(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 96204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* reexport safe */ _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__.Ib; },
/* harmony export */   "VD": function() { return /* binding */ BuilderComponent; },
/* harmony export */   "Wp": function() { return /* binding */ BuilderBlocks; },
/* harmony export */   "fl": function() { return /* reexport safe */ _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__.fl; },
/* harmony export */   "u7": function() { return /* binding */ withChildren; }
/* harmony export */ });
/* unused harmony exports BuilderAsyncRequestsContext, BuilderBlock, BuilderBlockComponent, BuilderContent, BuilderMetaContext, BuilderPage, BuilderStoreContext, Button, Columns, CustomCode, Dropzone, Embed, Form, FormInput, FormSelect, FormSubmitButton, Fragment, Image, Img, Label, Mutation, RawText, RenderContent, Router, Section, StateProvider, Symbol, Text, TextArea, Video, getSrcSet, noWrap, onChange, stringToFunction, updateMetadata, useIsPreviewing, withBuilder */
/* harmony import */ var _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26149);
/* harmony import */ var _emotion_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39503);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28316);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37525);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hash_sum__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(34406);
var version="2.0.17",_a;"undefined"!=typeof window&&(null===(_a=window.parent)||void 0===_a||_a.postMessage({type:"builder.isReactSdk",data:{value:!0,supportsPatchUpdates:"v4",supportsCustomBreakpoints:!0,priorVersion:version}},"*"));var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])})(e,t)};function __extends(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e}extendStatics(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var __assign=function(){return(__assign=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};function __decorate(e,t,n,i){var r,o=arguments.length,a=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,i);else for(var s=e.length-1;s>=0;s--)(r=e[s])&&(a=(o<3?r(a):o>3?r(t,n,a):r(t,n))||a);return o>3&&a&&Object.defineProperty(t,n,a),a}function __metadata(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function __awaiter(e,t,n,i){return new(n||(n=Promise))((function(r,o){function a(e){try{l(i.next(e))}catch(e){o(e)}}function s(e){try{l(i.throw(e))}catch(e){o(e)}}function l(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}l((i=i.apply(e,t||[])).next())}))}function __generator(e,t){var n,i,r,o,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(s){return function(l){return function(s){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,s[0]&&(a=0)),a;)try{if(n=1,i&&(r=2&s[0]?i.return:s[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,s[1])).done)return r;switch(i=0,r&&(s=[2&s[0],r.value]),s[0]){case 0:case 1:r=s;break;case 4:return a.label++,{value:s[1],done:!1};case 5:a.label++,i=s[1],s=[0];continue;case 7:s=a.ops.pop(),a.trys.pop();continue;default:if(!(r=a.trys,(r=r.length>0&&r[r.length-1])||6!==s[0]&&2!==s[0])){a=0;continue}if(3===s[0]&&(!r||s[1]>r[0]&&s[1]<r[3])){a.label=s[1];break}if(6===s[0]&&a.label<r[1]){a.label=r[1],r=s;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(s);break}r[2]&&a.ops.pop(),a.trys.pop();continue}s=t.call(e,a)}catch(e){s=[6,e],i=0}finally{n=r=0}if(5&s[0])throw s[1];return{value:s[0]?s[1]:void 0,done:!0}}([s,l])}}}function __spreadArray(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))}var fastClone=function(e){return JSON.parse(JSON.stringify(e))},sizeNames=["xsmall","small","medium","large"],sizes={xsmall:{min:0,default:0,max:0},small:{min:320,default:321,max:640},medium:{min:641,default:642,max:991},large:{min:990,default:991,max:1200},getWidthForSize:function(e){return this[e].default},getSizeForWidth:function(e){for(var t=0,n=sizeNames;t<n.length;t++){var i=n[t];if(e<=this[i].max)return i}return"large"}},getSizesForBreakpoints=function(e){var t=e.small,n=e.medium,i=__assign(__assign({},sizes),fastClone(sizes));if(!t||!n)return i;var r=Math.floor(t/2);i.small={max:t,min:r,default:r+1};var o=i.small.max+1;i.medium={max:n,min:o,default:o+1};var a=i.medium.max+1;return i.large={max:2e3,min:a,default:a+1},i},set=function(e,t,n){if(Object(e)!==e)return e;var i=Array.isArray(t)?t:t.toString().match(/[^.[\]]+/g);return i.slice(0,-1).reduce((function(e,t,n){return Object(e[t])===e[t]?e[t]:e[t]=Math.abs(Number(i[n+1]))>>0==+i[n+1]?[]:{}}),e)[i[i.length-1]]=n,e},noop=function(){return null},safeDynamicRequire;if("function"==typeof(null===globalThis||void 0===globalThis?void 0:globalThis.require)||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer&&"function"=="function")try{safeDynamicRequire=eval("require")}catch(e){safeDynamicRequire=(null===globalThis||void 0===globalThis?void 0:globalThis.require)?globalThis.require:noop}null!=safeDynamicRequire||(safeDynamicRequire=noop);var fnCache={},api=function(e){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl};function stringToFunction(e,t,n,i){if(void 0===t&&(t=!0),!e||!e.trim())return function(){};var r=e+":"+t;if(fnCache[r])return fnCache[r];var o=t&&!(e.includes(";")||e.includes(" return ")||e.trim().startsWith("return "))||e.trim().startsWith("builder.run"),a=function(){};try{_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(a=new Function("state","event","block","builder","Device","update","Builder","context","\n          var names = [\n            'state',\n            'event',\n            'block',\n            'builder',\n            'Device',\n            'update',\n            'Builder',\n            'context'\n          ];\n          var rootState = state;\n          if (typeof Proxy !== 'undefined') {\n            rootState = new Proxy(rootState, {\n              set: function () {\n                return false;\n              },\n              get: function (target, key) {\n                if (names.includes(key)) {\n                  return undefined;\n                }\n                return target[key];\n              }\n            });\n          }\n          /* Alias */\n          var ctx = context;\n          with (rootState) {\n            ".concat(o?"return (".concat(e,");"):e,";\n          }\n        ")))}catch(t){n&&n.push(t);var s=t&&t.message;s&&"string"==typeof s&&i&&-1===i.indexOf(s)&&i.push(s),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&console.warn("Function compile error in ".concat(e),t)}var l=function(){for(var t,i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];try{if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)return a.apply(void 0,i);var o=safeDynamicRequire("vm2").VM,s=i[0],l=i[1],u=(i[2],i[3],i[4],i[5],i[6],i[7]);return new o({timeout:100,sandbox:__assign(__assign(__assign(__assign(__assign({},s),{state:s}),{context:u}),{builder:api}),{event:l})}).run(e.replace(/(^|;)return /,"$1"))}catch(i){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",i.message||i,"in",e,i.stack||i):(null===(t=null===process||void 0===process?void 0:process.env)||void 0===t?void 0:t.DEBUG)&&console.debug("Builder custom code error:",i.message||i,"in",e,i.stack||i),n&&n.push(i),null}};return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(fnCache[r]=l),l}var isPromise=function(e){return"function"==typeof e.then},isRequestInfo=function(e){return!isPromise(e)},BuilderAsyncRequestsContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({requests:[],errors:[],logs:[]}),BuilderStoreContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({state:{},rootState:{},content:{},context:{},update:function(e){return null}}),applyPatchWithMinimalMutationChain=function(e,t,n){if(void 0===n&&(n=!1),Object(e)!==e)return e;var i=t.path,r=t.op,o=t.value,a=i.split(/\//);""===a[0]&&a.shift();for(var s=n?e:__assign({},e),l=s,u=0;u<a.length;u++){var d=u===a.length-1,c=a[u];if(d){if("replace"===r)l[c]=o;else if("add"===r){var p=Number(c);Array.isArray(l)?"-"===c?l.push(o):l.splice(p,0,o):l[c]=o}else if("remove"===r){p=Number(c);Array.isArray(l)?l.splice(p,1):delete l[c]}}else{var f=a[u+1],m=Object(l[c])===l[c]?l[c]:String(Number(f))===f?[]:{};l=l[c]=Array.isArray(m)?__spreadArray([],m,!0):__assign({},m)}}return s},htmlEscape=function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},blockToHtmlString=function(e){var t;return"<".concat(htmlEscape(e.tagName||"div"),' \n    class="builder-block ').concat(e.id," ").concat(e.class||"",'"\n    builder-id="').concat(e.id,'"\n  ').concat(Object.keys(e.properties||{}).map((function(t){return"".concat(htmlEscape(t),'="').concat(htmlEscape(e.properties[t]),'"')})).join(" "),"\n  >").concat("Text"===(null===(t=null==e?void 0:e.component)||void 0===t?void 0:t.name)?e.component.options.text:e.children?e.children.map((function(e){return blockToHtmlString(e)})).join(""):"","</").concat(e.tagName||"div",">").replace(/\s+/g," ")},Link=function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Consumer,null,(function(t){return t.renderLink?t.renderLink(e):react__WEBPACK_IMPORTED_MODULE_2__.createElement("a",__assign({},e))}))},camelCaseToKebabCase=function(e){return e?e.replace(/([A-Z])/g,(function(e){return"-".concat(e[0].toLowerCase())})):""},kebabCaseToCamelCase=function(e){return void 0===e&&(e=""),e.replace(/-([a-z])/g,(function(e){return e[1].toUpperCase()}))},Device={desktop:0,tablet:1,mobile:2},voidElements=new Set(["area","base","br","col","embed","hr","img","input","link","meta","param","source","track","wbr","textarea"]),last=function(e){return e[e.length-1]};function omit$1(e,t){for(var n=Object.assign({},e),i=0,r=t;i<r.length;i++){delete n[r[i]]}return n}var cssCase=function(e){if(!e)return e;var t=camelCaseToKebabCase(e);return e[0]===e[0].toUpperCase()&&(t="-"+t),t};function capitalize(e){if(e)return e[0].toUpperCase()+e.slice(1)}var BuilderBlock$1=function(_super){function BuilderBlock(){var _this=null!==_super&&_super.apply(this,arguments)||this;return _this.state={hasError:!1,updates:0},_this.privateState={state:{},rootState:{},context:{},update:function(){}},_this.onWindowMessage=function(event){var message=event.data;if(message)switch(message.type){case"builder.selectionChange":var data=message.data;if(!data)break;var selection=data.selection,id=_this.block&&_this.block.id;id&&Array.isArray(selection)&&selection.indexOf(id)>-1&&setTimeout((function(){window.$block=_this,window.$blocks||(window.$blocks=[]),window.$blocks.push(_this)}));break;case"builder.patchUpdates":var data=message.data;if(!data||!data.data)break;var patches=data.data[_this.block.id];if(!patches)return;location.href.includes("builder.debug=true")&&eval("debugger");for(var _i=0,patches_1=patches;_i<patches_1.length;_i++){var patch=patches_1[_i];applyPatchWithMinimalMutationChain(_this.props.block,patch,!0)}_this.setState({updates:_this.state.updates+1})}},_this}return __extends(BuilderBlock,_super),Object.defineProperty(BuilderBlock.prototype,"store",{get:function(){return this.privateState},enumerable:!1,configurable:!0}),BuilderBlock.getDerivedStateFromError=function(e){return{hasError:!0}},BuilderBlock.prototype.componentDidCatch=function(e,t){console.error("Builder block error:",e,t)},BuilderBlock.prototype.stringToFunction=function(e,t){return void 0===t&&(t=!0),stringToFunction(e,t,this._errors,this._logs)},Object.defineProperty(BuilderBlock.prototype,"block",{get:function(){return this.props.block},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderBlock.prototype,"emotionCss",{get:function(){var e,t,n,i,r,o=this.block;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer){var a=o.animations&&o.animations[0];if(a&&"hover"!==a.trigger){var s=a&&a.steps&&a.steps[0],l=s&&s.styles;l&&(r=l)}}var u=sizeNames.slice().reverse(),d=this.block,c={};if(d.responsiveStyles)for(var p=0,f=u;p<f.length;p++){var m=f[p];if("large"===m)this.props.emailMode||(c["&.builder-block"]=Object.assign({},d.responsiveStyles[m],r));else{var h=getSizesForBreakpoints((null===(t=null===(e=this.privateState.context.builderContent)||void 0===e?void 0:e.meta)||void 0===t?void 0:t.breakpoints)||{});c["@media only screen and (max-width: ".concat(h[m].max,"px)")]={"&.builder-block":d.responsiveStyles[m]}}}var g=o.animations&&o.animations.find((function(e){return"hover"===e.trigger}));return g&&(c[":hover"]=(null===(i=null===(n=g.steps)||void 0===n?void 0:n[1])||void 0===i?void 0:i.styles)||{},c.transition="all ".concat(g.duration,"s ").concat(camelCaseToKebabCase(g.easing)),g.delay&&(c.transitionDelay=g.delay+"s")),c},enumerable:!1,configurable:!0}),BuilderBlock.prototype.eval=function(e){return this.stringToFunction(e)(this.privateState.state,void 0,this.block,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,Device,this.privateState.update,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context)},BuilderBlock.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&removeEventListener("message",this.onWindowMessage)},BuilderBlock.prototype.componentDidMount=function(){var e,t=this,n=this.block,i=n&&n.animations;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&addEventListener("message",this.onWindowMessage),i){var r={animations:fastClone(i)};if(n.bindings)for(var o in n.bindings)if((null===(e=o.trim)||void 0===e?void 0:e.call(o))&&o.startsWith("animations.")){var a=this.stringToFunction(n.bindings[o]);void 0!==a&&set(r,o,a(this.privateState.state,null,n,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,null,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context))}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.animator.bindAnimations */ .Ib.animator.bindAnimations(r.animations.filter((function(e){return"hover"!==e.trigger})).map((function(e){return __assign(__assign({},e),{elementId:t.block.id})})))}},BuilderBlock.prototype.getElement=function(e,t){var n,i,r,o,a,s=this;void 0===e&&(e=0),void 0===t&&(t=this.privateState.state);var l=this.props;l.child,l.fieldName;var u,d=this.block,c=(d.tagName||"div").toLowerCase();if("template"===c){var p=d.children?d.children.map((function(e){return blockToHtmlString(e)})).join(" "):"";return console.debug("template html",p),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("template",__assign({},d.properties,{dangerouslySetInnerHTML:{__html:p}}))}var f=d.component&&(d.component.name||d.component.component),m=null;d.component&&!d.component.class&&(d.component&&d.component.tag?u=d.component.tag:(m=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.find */ .Ib.components.find((function(e){return e.name===f}))||null)&&m.class?u=m.class:m&&m.tag?u=m.tag:(null==f?void 0:f.startsWith("Builder:"))?console.warn("Missing @builder.io/widgets installation, please install and import @builder.io/widgets to use ".concat(f.split(":")[1]," in your content, more info here: https://github.com/BuilderIO/builder/tree/main/packages/widgets")):f&&console.warn("Missing registration for ".concat(f,", have you included the registration in your bundle?")));var h=__assign(__assign({},d.properties),{style:{}});if(h=__assign(__assign({},h.properties),h),d.component&&(h.component=fastClone(d.component)),d.bindings)for(var g in d.bindings)if(null===(i=g.trim)||void 0===i?void 0:i.call(g)){var v=this.stringToFunction(d.bindings[g]);set(h,g,v(t,null,d,api(),Device,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context))}if(h.hide)return null;if(delete h.hide,("show"in h||d.bindings&&d.bindings.show)&&!h.show)return null;if(delete h.show,d.actions){var b=function(e){if(!(null===(r=e.trim)||void 0===r?void 0:r.call(e)))return"continue";var n=d.actions[e];h["on"+capitalize(e)]=function(e){var i=t;return"undefined"!=typeof Proxy&&(i=new Proxy(t,{set:function(e,t,n){return e[t]=n,s.privateState.rootState[t]=n,!0}})),s.stringToFunction(n,!1)(i,e,s.block,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,Device,s.privateState.update,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,s.privateState.context)}};for(var g in d.actions)b(g)}var y=(h.component||h.options)&&__assign(__assign({},h.options),h.component.options||h.component.data),_=voidElements.has(c),x=m&&(m.fragment||m.noWrap),S=(null===(o=h.attr)||void 0===o?void 0:o.style)||("string"==typeof h.style?h.style:"")||"";if("string"==typeof S){"object"!=typeof h.style&&(h.style={});for(var B=0,k=S.split(";");B<k.length;B++){var w=k[B].split(":");if(!w.length)return;g=w[0],v=w[1];g&&(w.length>2&&(v=w.slice(1).join(":")),h.style[kebabCaseToCamelCase(g)]=v)}}var C=__assign(__assign(__assign({},omit$1(h,["class","component","attr"])),((n={})["string"!=typeof c||c.includes("-")?"class":"className"]="builder-block ".concat(this.id).concat(d.class?" ".concat(d.class):"").concat(!d.component||["Image","Video","Banner"].indexOf(f)>-1?"":" builder-has-component")+(h.class?" "+h.class:"")+(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(null===(a=this.privateState.state._spacer)||void 0===a?void 0:a.parent)===d.id?" builder-spacer-parent":""),n.key=this.id+e,n["builder-id"]=this.id,n)),0!==e&&{"builder-index":e});_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(C["builder-inline-styles"]=h.attr&&h.attr.style?Object.keys(h.style).reduce((function(e,t){return(e?"".concat(e,";"):"")+"".concat(cssCase(t),":").concat(h.style[t],";")}),""):""),(C.properties&&C.properties.href||C.href)&&"div"===c&&(c="a"),"a"===c&&(c=Link);var R=d.children||C.children||[];return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .ClassNames */ .ms,null,(function(e){var t=e.css;if(e.cx,!s.props.emailMode){var n=" "+t(s.emotionCss);C.class&&(C.class+=n),C.className&&(C.className+=n)}return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderAsyncRequestsContext.Consumer,null,(function(e){return s._asyncRequests=e&&e.requests,s._errors=e&&e.errors,s._logs=e&&e.logs,_?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(c,__assign({},C)):u&&(x||s.props.emailMode)?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(u,__assign({},y,{attributes:C,builderBlock:d,builderState:s.privateState})):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(c,__assign({},C),u&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(u,__assign({builderState:s.privateState,builderBlock:d},y)),d.text||h.text?h.text:!u&&R&&Array.isArray(R)&&R.length?R.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock,{key:(s.id||"")+t,block:e,index:t,size:s.props.size,fieldName:s.props.fieldName,child:s.props.child,emailMode:s.props.emailMode})})):null)}))})))},Object.defineProperty(BuilderBlock.prototype,"id",{get:function(){var e=this.block;return e.id.startsWith("builder")?e.id:"builder-"+e.id},enumerable:!1,configurable:!0}),BuilderBlock.prototype.contents=function(e){var t=this,n=this.block;if(this.privateState=e,n.repeat&&n.repeat.collection){var i=n.repeat.collection,r=last((i||"").trim().split("(")[0].trim().split(".")),o=n.repeat.itemName||(r?r+"Item":"item"),a=this.stringToFunction(i)(e.state,null,n,api(),Device,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context);return Array.isArray(a)?a.map((function(n,i){var r,a=__assign(__assign({},e.state),((r={$index:i,$item:n})[o]=n,r["$".concat(o,"Index")]=i,r));return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{key:i,value:__assign(__assign({},e),{state:a})},t.getElement(i,a))})):null}return this.getElement()},BuilderBlock.prototype.render=function(){var e=this;return this.state.hasError?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",{css:{display:"inline-block",padding:5,color:"#999",fontSize:11,fontStyle:"italic"}},"Builder block error :( Check console for details"):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(t){return e.contents(t)}))},BuilderBlock}(react__WEBPACK_IMPORTED_MODULE_2__.Component),BuilderBlocks=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onClickEmptyBlocks=function(){var e;_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&t.noBlocks&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.clickEmptyBlocks",data:{parentElementId:t.parentId,dataPath:t.path}},"*"))},t.onHoverEmptyBlocks=function(){var e;_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&t.noBlocks&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.hoverEmptyBlocks",data:{parentElementId:t.parentId,dataPath:t.path}},"*"))},t}return __extends(t,e),Object.defineProperty(t.prototype,"isRoot",{get:function(){return!this.props.child},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"noBlocks",{get:function(){var e=this.props.blocks;return!(e&&e.length)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"path",{get:function(){var e=this.props.dataPath||"";return e.trim()&&(e.startsWith("this.")?e=e.replace("this.",""):e.startsWith("component.options.")||(e="component.options."+e)),e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"parentId",{get:function(){return this.props.parentElementId?this.props.parentElementId:this.props.parent&&this.props.parent.id},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this,t=this.props.blocks,n=this.props.emailMode?"span":"div";return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(n,__assign({className:"builder-blocks"+(this.noBlocks?" no-blocks":"")+(this.props.child?" builder-blocks-child":"")+(this.props.className?" "+this.props.className:""),"builder-type":"blocks","builder-path":_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe?this.path:void 0,"builder-parent-id":this.parentId,css:__assign(__assign({},!this.props.emailMode&&{display:"flex",flexDirection:"column",alignItems:"stretch"}),this.props.style),onClick:function(){e.noBlocks&&e.onClickEmptyBlocks()}},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&{onMouseEnter:function(){return e.onHoverEmptyBlocks()}}),t&&Array.isArray(t)&&t.map((function(t,n){return t&&"@builder.io/sdk:Element"===t["@type"]?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:t.id,block:t,index:n,fieldName:e.props.fieldName,child:e.props.child,emailMode:e.props.emailMode}):t}))||t)},t.renderInto=function(e,n,i){if(void 0===n&&(n={}),e){var r=null;return"string"==typeof e?r=document.querySelector(e):e instanceof Element&&(r=e),react_dom__WEBPACK_IMPORTED_MODULE_3__.render((0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{value:i},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(t,__assign({},n))),r)}},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),NoWrap=function(e){return e.children};function getData(e){if(void 0!==(null==e?void 0:e.data)){var t=e.data,n=t.blocks,i=t.blocksString,r=Array.isArray(n)||"string"==typeof i,o=__assign(__assign({},e.data),r&&{blocks:n||JSON.parse(i)});return delete o.blocksString,o}}var variantsScript=function(e,t){return"\n(function() {\n  if (window.builderNoTrack || !navigator.cookieEnabled) {\n    return;\n  }\n\n  var variants = ".concat(e,";\n  function removeVariants() {\n    variants.forEach(function (template) {\n      document.querySelector('template[data-template-variant-id=\"' + template.id + '\"]').remove();\n    });\n    document.getElementById('variants-script-").concat(t,'\').remove();\n  }\n\n  if (typeof document.createElement("template").content === \'undefined\') {\n    removeVariants();\n    return ;\n  }\n\n  function setCookie(name,value,days) {\n    var expires = "";\n    if (days) {\n        var date = new Date();\n        date.setTime(date.getTime() + (days*24*60*60*1000));\n        expires = "; expires=" + date.toUTCString();\n    }\n    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + "; Secure; SameSite=None";\n  }\n\n  function getCookie(name) {\n    var nameEQ = name + "=";\n    var ca = document.cookie.split(\';\');\n    for(var i=0;i < ca.length;i++) {\n        var c = ca[i];\n        while (c.charAt(0)==\' \') c = c.substring(1,c.length);\n        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);\n    }\n    return null;\n  }\n  var cookieName = \'builder.tests.').concat(t,"';\n  var variantInCookie = getCookie(cookieName);\n  var availableIDs = variants.map(function(vr) { return vr.id }).concat('").concat(t,"');\n  var variantId;\n  if (availableIDs.indexOf(variantInCookie) > -1) {\n    variantId = variantInCookie;\n  }\n  if (!variantId) {\n    var n = 0;\n    var random = Math.random();\n    for (var i = 0; i < variants.length; i++) {\n      var variant = variants[i];\n      var testRatio = variant.testRatio;\n      n += testRatio;\n      if (random < n) {\n        setCookie(cookieName, variant.id);\n        variantId = variant.id;\n        break;\n      }\n    }\n    if (!variantId) {\n      variantId = \"").concat(t,'";\n      setCookie(cookieName, "').concat(t,'");\n    }\n  }\n  if (variantId && variantId !== "').concat(t,"\") {\n    var winningTemplate = document.querySelector('template[data-template-variant-id=\"' + variantId + '\"]');\n    if (winningTemplate) {\n      var parentNode = winningTemplate.parentNode;\n      var newParent = parentNode.cloneNode(false);\n      newParent.appendChild(winningTemplate.content.firstChild);\n      parentNode.parentNode.replaceChild(newParent, parentNode);\n    }\n  } else if (variants.length > 0) {\n    removeVariants();\n  }\n})()").replace(/\s+/g," ")},VariantsProvider=function(e){var t=e.initialContent,n=e.children;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.canTrack */ .fl.canTrack)return n([t]);if(!Boolean(Object.keys((null==t?void 0:t.variations)||{}).length))return n([t]);var i=Object.keys(t.variations).map((function(e){return __assign(__assign({id:e},t.variations[e]),{data:getData(t.variations[e])})})),r=__spreadArray(__spreadArray([],i,!0),[t],!1);if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer){var o=JSON.stringify(Object.keys(t.variations||{}).map((function(e){return{id:e,testRatio:t.variations[e].testRatio}})));return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,n(r,(function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("script",{id:"variants-script-".concat(t.id),dangerouslySetInnerHTML:{__html:variantsScript(o,t.id)}})})))}var a="builder.tests.".concat(t.id),s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getCookie */ .fl.getCookie(a);if(!s&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)for(var l=0,u=Math.random(),d=0;d<i.length;d++){var c=i[d];if(u<(l+=c.testRatio)){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.setCookie */ .fl.setCookie(a,c.id),s=c.id;break}}return s||(s=t.id,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.setCookie */ .fl.setCookie(a,s)),n([r.find((function(e){return e.id===s}))])},BuilderContent=function(_super){function BuilderContent(){var _this=null!==_super&&_super.apply(this,arguments)||this;return _this.ref=null,_this.state={loading:!_this.props.content,data:getContentWithInfo(_this.props.content),updates:1},_this.onWindowMessage=function(event){var _a,_b,message=event.data;if(message)switch(message.type){case"builder.patchUpdates":if(null===(_a=_this.props.options)||void 0===_a?void 0:_a.noEditorUpdates)return;var data=message.data;if(!data||!data.data)break;var patches=data.data[null===(_b=_this.state.data)||void 0===_b?void 0:_b.id];if(!patches||!patches.length)return;location.href.includes("builder.debug=true")&&eval("debugger");for(var newData=_this.state.data,_i=0,patches_1=patches;_i<patches_1.length;_i++){var patch=patches_1[_i];newData=applyPatchWithMinimalMutationChain(newData,patch,!1)}_this.setState({updates:_this.state.updates+1,data:newData}),_this.props.contentLoaded&&_this.props.contentLoaded(newData.data,newData)}},_this.subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0,_this.firstLoad=!0,_this.clicked=!1,_this.trackedImpression=!1,_this.intersectionObserver=null,_this.onClick=function(e){var t=e.nativeEvent,n=_this.data;n&&(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.autoTrack */ .fl.autoTrack&&_this.builder.trackInteraction(n.id,_this.renderedVariantId,_this.clicked,t,{content:n}),_this.clicked||(_this.clicked=!0))},_this}return __extends(BuilderContent,_super),Object.defineProperty(BuilderContent.prototype,"builder",{get:function(){return this.props.builder||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"name",{get:function(){var e=this.props;return"model"in e?e.model:e.modelName},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"renderedVariantId",{get:function(){var e,t,n=this.props.isStatic?this.builder.getCookie("builder.tests.".concat(null===(e=this.data)||void 0===e?void 0:e.id)):null===(t=this.data)||void 0===t?void 0:t.variationId;if(null!==n)return n},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"options",{get:function(){var e,t,n=__assign({},this.props.options||{});return n.key||!(null===(e=this.props.content)||void 0===e?void 0:e.id)||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing||(n.key=this.props.content.id),!this.props.content||(null===(t=n.initialContent)||void 0===t?void 0:t.length)||!this.props.inline&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing||(n.initialContent=[this.props.content]),n},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"data",{get:function(){var e=(this.props.inline||!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||this.firstLoad)&&this.options.initialContent&&this.options.initialContent[0]||this.state.data;return getContentWithInfo(e)},enumerable:!1,configurable:!0}),BuilderContent.prototype.componentDidMount=function(){var e,t;if(!this.props.inline||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)this.subscribeToContent();else if(this.props.inline&&(null===(t=null===(e=this.options)||void 0===e?void 0:e.initialContent)||void 0===t?void 0:t.length)){var n=this.options.initialContent[0];(null==n?void 0:n.id)&&this.builder.trackImpression(n.id,this.renderedVariantId,void 0,{content:n})}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&addEventListener("message",this.onWindowMessage)},BuilderContent.prototype.subscribeToContent=function(){var e=this;"_inline"!==this.name&&this.subscriptions.add(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.queueGetContent */ .fl.queueGetContent(this.name,this.options).subscribe((function(t){var n=t&&t[0];e.setState({data:n,loading:!1});var i=(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.editingModel */ .fl.editingModel||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.previewingModel */ .fl.previewingModel)===e.name;if(!e.props.inline&&e.props.content&&e.firstLoad&&i&&(e.firstLoad=!1,e.subscriptions.unsubscribe(),e.subscribeToContent()),n&&e.firstLoad&&(e.firstLoad=!1,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.autoTrack */ .fl.autoTrack&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing)){var r=!1;if("function"==typeof IntersectionObserver&&e.ref)try{(e.intersectionObserver=new IntersectionObserver((function(t,i){t.forEach((function(t){t.intersectionRatio>0&&!e.trackedImpression&&(e.builder.trackImpression(n.id,e.renderedVariantId,void 0,{content:e.data}),e.data,e.trackedImpression=!0,e.ref&&i.unobserve(e.ref))}))}))).observe(e.ref),r=!0}catch(e){console.warn("Could not bind intersection observer")}r||(e.trackedImpression=!0,e.builder.trackImpression(n.id,e.renderedVariantId,void 0,{content:n}))}e.props.contentLoaded&&e.props.contentLoaded(n&&n.data,n)}),(function(t){e.props.contentError&&(e.props.contentError(t),e.setState({loading:!1}))})))},BuilderContent.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&removeEventListener("message",this.onWindowMessage),this.subscriptions.unsubscribe(),this.intersectionObserver&&this.ref&&this.intersectionObserver.unobserve(this.ref)},BuilderContent.prototype.render=function(){var e=this;if(this.props.dataOnly)return null;var t=this.state.loading,n=this.data,i=this.props.dataOnly?NoWrap:"div";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(VariantsProvider,{initialContent:n},(function(r,o){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,r.map((function(a,s){var l=s===r.length-1?react__WEBPACK_IMPORTED_MODULE_2__.Fragment:"template";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,{key:String((null==a?void 0:a.id)+s)},"template"!==l&&(null==o?void 0:o()),react__WEBPACK_IMPORTED_MODULE_2__.createElement(l,__assign({key:String((null==a?void 0:a.id)+s)},"template"===l&&{"data-template-variant-id":null==a?void 0:a.id}),react__WEBPACK_IMPORTED_MODULE_2__.createElement(i,__assign({},0===s&&!e.props.dataOnly&&{ref:function(t){return e.ref=t}},{className:"builder-content",onClick:e.onClick,"builder-content-id":null==a?void 0:a.id,"builder-model":e.name}),e.props.children(null==a?void 0:a.data,!e.props.inline&&t,n))))})))}))},BuilderContent}(react__WEBPACK_IMPORTED_MODULE_2__.Component),getContentWithInfo=function(e){var t;if(e){var n=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getCookie */ .fl.getCookie("builder.tests.".concat(e.id)),i=n===e.id?e:null===(t=e.variations)||void 0===t?void 0:t[n],r=(null==i?void 0:i.name)||((null==i?void 0:i.id)===e.id?"Default variation":"");return __assign(__assign({},e),{variationId:n,testVariationId:n,testVariationName:r})}return null};function unwrapExports(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var onChange_1=createCommonjsModule((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var n=Symbol("target"),i=Symbol("unsubscribe"),r=function(e,t){return t&&t.toString&&(e&&(e+="."),e+=t.toString()),e},o=function(e){return Array.isArray(e)?e.slice():Object.assign({},e)},a=function(e,t,a){if("undefined"==typeof Proxy)return e;void 0===a&&(a={});var s,l,u=Symbol("ProxyTarget"),d=!1,c=!1,p=!1,f=a.equals||Object.is,m=new WeakMap,h=new WeakMap,g=new WeakMap,v=function(e,n,i,a){if(!p)if(d){if(d&&l&&void 0!==i&&void 0!==a&&"length"!==n){var u=l;e!==s&&function(e,t){for(var n;e;)-1===(n=e.indexOf("."))&&(n=e.length),t(e.slice(0,n)),e=e.slice(n+1)}(e=e.replace(s,"").slice(1),(function(e){u[e]=o(u[e]),u=u[e]})),u[n]=i}c=!0}else t(r(e,n),a,i)},b=function(e,t){var n=m?m.get(e):void 0;n&&n.delete(t)},y=function(e,t){if(p)return e;h.set(e,t);var n=g.get(e);return void 0===n&&(n=new Proxy(e,x),g.set(e,n)),n},_=function(e){return p||!0===a.ignoreSymbols&&"symbol"==typeof e},x={get:function(e,t,o){if(t===u||t===n)return e;if(t===i&&""===h.get(e))return function(e){return p=!0,m=null,h=null,g=null,e}(e);var s=Reflect.get(e,t,o);if(function(e){return null===e||"object"!=typeof e&&"function"!=typeof e}(s)||function(e){return e instanceof RegExp||e instanceof Number}(s)||"constructor"===t||!0===a.isShallow)return s;var l=function(e,t){var n=m?m.get(e):void 0;if(n)return n;n=new Map,m.set(e,n);var i=n.get(t);return i||(i=Reflect.getOwnPropertyDescriptor(e,t),n.set(t,i)),i}(e,t);if(l&&!l.configurable){if(l.set&&!l.get)return;if(!1===l.writable)return s}return y(s,r(h.get(e),t))},set:function(e,t,n,i){n&&void 0!==n[u]&&(n=n[u]);var r=_(t),o=r?null:Reflect.get(e,t,i),a=Reflect.set(e[u]||e,t,n);return r||f(o,n)||v(h.get(e),t,o,n),a},defineProperty:function(e,t,n){var i=Reflect.defineProperty(e,t,n);return _(t)||(b(e,t),v(h.get(e),t,void 0,n.value)),i},deleteProperty:function(e,t){if(!Reflect.has(e,t))return!0;var n=_(t),i=n?null:Reflect.get(e,t),r=Reflect.deleteProperty(e,t);return n||(b(e,t),v(h.get(e),t,i)),r},apply:function(e,t,n){var i=t instanceof Date;if(i&&(t=t[u]),!d){d=!0,i&&(l=t.valueOf()),(Array.isArray(t)||"[object Object]"===toString.call(t))&&(l=o(t[u])),s=(s=h.get(e)).slice(0,Math.max(s.lastIndexOf("."),0));var r=Reflect.apply(e,t,n);return d=!1,(c||i&&!f(l,t.valueOf()))&&(v(s,"",l,t[u]||t),l=null,c=!1),r}return Reflect.apply(e,t,n)}},S=y(e,"");return t=t.bind(S),S};a.target=function(e){return e[n]||e},a.unsubscribe=function(e){return e[i]||e},e.exports=a,t.default=a})),onChange=unwrapExports(onChange_1),nextTick=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick;function debounceNextTick(e,t,n){return void 0===t&&"function"==typeof e?debounceNextTickImpl(e):{configurable:!0,enumerable:n.enumerable,get:function(){return Object.defineProperty(this,t,{configurable:!0,enumerable:n.enumerable,value:debounceNextTickImpl(n.value)}),this[t]}}}function debounceNextTickImpl(e){var t=null,n=null;return function(){var e=t;if(t=[].slice.call(arguments),n=this,null!==e)return;nextTick(i)};function i(){e.apply(n,t),t=null,n=null}}function throttle(e,t,n){var i,r,o;void 0===n&&(n={});var a=null,s=0,l=function(){s=!1===n.leading?0:Date.now(),a=null,o=e.apply(i,r),a||(i=r=null)};return function(){var u=Date.now();s||!1!==n.leading||(s=u);var d=t-(u-s);return i=this,r=arguments,d<=0||d>t?(a&&(clearTimeout(a),a=null),s=u,o=e.apply(i,r),a||(i=r=null)):a||!1===n.trailing||(a=setTimeout(l,d)),o}}var BuilderMetaContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({emailMode:!1,ampMode:!1,isServer:!1}),tryEval=function(e,t,n){var i;void 0===t&&(t={});var r=e;if("string"==typeof r&&r.trim()){var o=!(r.includes(";")||r.includes(" return ")),a=function(){};try{_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(a=new Function("state","var rootState = state;\n        if (typeof Proxy !== 'undefined') {\n          rootState = new Proxy(rootState, {\n            set: function () {\n              return false;\n            },\n            get: function (target, key) {\n              if (key === 'state') {\n                return state;\n              }\n              return target[key]\n            }\n          });\n        }\n        with (rootState) {\n          ".concat(o?"return (".concat(e,");"):e,";\n        }")))}catch(e){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&console.warn("Could not compile javascript",e)}try{return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?a(t||{}):new(0,safeDynamicRequire("vm2").VM)({sandbox:__assign(__assign({},t),{state:t})}).run(r.replace(/(^|;)return /,"$1"))}catch(t){n&&n.push(t),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",t.message,"in",e,t.stack):(null===(i=null===process||void 0===process?void 0:process.env)||void 0===i?void 0:i.DEBUG)&&console.debug("Builder custom code error:",t.message,"in",e,t.stack)}}};function toError(e){return e instanceof Error?e:new Error(String(e))}function getBuilderPixel(e){return{id:"builder-pixel-"+Math.random().toString(36).split(".")[1],"@type":"@builder.io/sdk:Element",tagName:"img",properties:{role:"presentation","aria-hidden":"true",src:"https://cdn.builder.io/api/v1/pixel?apiKey=".concat(e)},responsiveStyles:{large:{height:"0",width:"0",display:"inline-block",opacity:"0",overflow:"hidden",pointerEvents:"none"}}}}function pick(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var i={};return t.forEach((function(t){i[t]=e[t]})),i}function omit(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var i=__assign({},e);return t.forEach((function(e){delete i[e]})),i}var wrapComponent=function(e){return function(t){var n,i=t.builderTag||"div",r=["children"].concat((null===(n=e.inputs)||void 0===n?void 0:n.map((function(e){return e.name})))||[]),o=omit.apply(void 0,__spreadArray(__spreadArray([t],r,!1),["attributes"],!1)),a=t;return e.noWrap?react__WEBPACK_IMPORTED_MODULE_2__.createElement(e.class,__assign({attributes:o},a)):react__WEBPACK_IMPORTED_MODULE_2__.createElement(i,__assign({},o),react__WEBPACK_IMPORTED_MODULE_2__.createElement(e.class,__assign({},a)))}},size$1=function(e){return Object.keys(e).length};function debounce(e,t,n){var i;return void 0===n&&(n=!1),function(){var r=this,o=arguments;clearTimeout(i),i=setTimeout((function(){i=null,n||e.apply(r,o)}),t),n&&!i&&e.apply(r,o)}}var fontsLoaded=new Set,fetch$1;globalThis.fetch&&(fetch$1=globalThis.fetch),null!=fetch$1||(fetch$1=__webpack_require__(34911));var sizeMap={desktop:"large",tablet:"medium",mobile:"small"},fetchCache={};function searchToObject$1(e){var t=(e.search||"").substring(1).split("&"),n={};for(var i in t)if(t[i]&&"string"==typeof t[i]){var r=t[i].split("=");n[decodeURIComponent(r[0])]=decodeURIComponent(r[1])}return n}var BuilderComponent=function(e){function t(t){var n,i=this;(i=e.call(this,t)||this).subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0,i.onStateChange=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .Xe(null),i.asServer=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer,i.contentRef=null,i.styleRef=null,i.rootState=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer?{}:onChange({},(function(){return i.updateState()})),i.lastJsCode="",i.lastHttpRequests={},i.httpSubscriptionPerKey={},i.firstLoad=!0,i.ref=null,i.messageListener=function(e){var t,n=e.data;switch(n.type){case"builder.configureSdk":var r=n.data;if(!r.contentId||r.contentId!==(null===(t=i.useContent)||void 0===t?void 0:t.id))return;i.sizes=getSizesForBreakpoints(r.breakpoints||{}),i.setState({state:Object.assign(i.rootState,{deviceSize:i.deviceSizeState,device:i.device}),updates:(i.state&&i.state.updates||0)+1,breakpoints:r.breakpoints});break;case"builder.updateSpacer":var o=n.data;i.rootState._spacer,i.updateState((function(e){e._spacer=o}));break;case"builder.resetState":var a=n.data,s=a.state;if(a.model===i.name){for(var l in i.rootState)"function"!=typeof i.rootState[l]&&delete i.rootState[l];Object.assign(i.rootState,s),i.setState(__assign(__assign({},i.state),{state:i.rootState,updates:(i.state&&i.state.updates||0)+1}))}break;case"builder.resetSymbolState":var u=n.data.state,d=(s=u.state,u.model,u.id);if(i.props.builderBlock&&i.props.builderBlock===d){for(var l in i.rootState)delete i.rootState[l];Object.assign(i.rootState,s),i.setState(__assign(__assign({},i.state),{state:i.rootState,updates:(i.state&&i.state.updates||0)+1}))}}},i.resizeFn=function(){var e=i.deviceSizeState;e!==i.state.state.deviceSize&&i.setState(__assign(__assign({},i.state),{updates:(i.state&&i.state.updates||0)+1,state:Object.assign(i.rootState,__assign(__assign({},i.state.state),{deviceSize:e}))}))},i.resizeListener=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?throttle(i.resizeFn,200):debounce(i.resizeFn,400),i.mounted=!1,i.updateState=function(e){var t=i.rootState;e&&e(t),i.mounted?i.setState({update:i.updateState,state:t,updates:(i.state&&i.state.updates||0)+1}):i.state=__assign(__assign({},i.state),{update:i.updateState,state:t,updates:(i.state&&i.state.updates||0)+1}),i.notifyStateChange()},i.onContentLoaded=function(e,t){var n;if("page"===i.name&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&e){var r=e.title,o=e.pageTitle,a=e.description,s=e.pageDescription;if((r||o)&&(document.title=r||o),a||s){var l=document.querySelector('meta[name="description"]');l||((l=document.createElement("meta")).setAttribute("name","description"),document.head.appendChild(l)),l.setAttribute("content",a||s)}}if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i.notifyStateChange(),i.props.contentLoaded&&i.props.contentLoaded(e,t),e&&e.inputs&&Array.isArray(e.inputs)&&e.inputs.length&&(e.state||(e.state={}),e.inputs.forEach((function(t){t&&t.name&&void 0!==t.defaultValue&&void 0===e.state[t.name]&&(e.state[t.name]=t.defaultValue)}))),e&&e.state){var u=__assign(__assign({},i.state),{updates:(i.state&&i.state.updates||0)+1,state:Object.assign(i.rootState,__assign(__assign(__assign(__assign({},i.state.state),{location:i.locationState,deviceSize:i.deviceSizeState,device:i.device}),e.state),i.externalState))});i.mounted?i.setState(u):i.state=u}if(e&&e.jsCode&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&!i.options.codegen){var d=!1;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(i.lastJsCode===e.jsCode?d=!0:i.lastJsCode=e.jsCode),!d){var c=i.state.state;try{new Function("data","ref","state","update","element","Builder","builder","context",e.jsCode)(e,i,c,i.state.update,i.ref,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,i.state.context)}catch(t){var p=toError(t);_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",p.message,"in",e.jsCode,p.stack):(null===(n=null===process||void 0===process?void 0:process.env)||void 0===n?void 0:n.DEBUG)&&console.debug("Builder custom code error:",p.message,"in",e.jsCode,p.stack)}}}if(e&&e.httpRequests&&!i.props.noAsync&&!(d=!1)){var f=function(t){var n=e.httpRequests[t];if(n&&(!i.data[t]||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing))if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var r=i.evalExpression(n);if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i.lastHttpRequests[t]===r)return"continue";i.lastHttpRequests[t]=r;var o=n.match(/builder\.io\/api\/v2\/([^\/\?]+)/i);o&&o[1],i.handleRequest(t,r);var a=i.httpSubscriptionPerKey[t];a&&a.unsubscribe();var s=i.httpSubscriptionPerKey[t]=i.onStateChange.subscribe((function(){var e=i.evalExpression(n);e!==r&&(i.handleRequest(t,e),i.lastHttpRequests[t]=e)}));i.subscriptions.add(s)}else i.handleRequest(t,i.evalExpression(n))};for(var m in e.httpRequests)f(m)}};var r=i.inlinedContent;if(r&&r.content&&(r=r.content),i.sizes=getSizesForBreakpoints((null===(n=null==r?void 0:r.meta)||void 0===n?void 0:n.breakpoints)||{}),i.state={context:__assign(__assign({},t.context),{apiKey:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.apiKey */ .fl.apiKey||i.props.apiKey}),state:Object.assign(i.rootState,__assign(__assign(__assign(__assign({},i.inlinedContent&&i.inlinedContent.data&&i.inlinedContent.data.state),{isBrowser:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser,isServer:!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser,_hydrate:t.hydrate,location:i.locationState,deviceSize:i.deviceSizeState,device:i.device}),i.getHtmlData()),t.data)),updates:0,key:0,update:i.updateState},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var o=i.props.apiKey;if(o&&o!==i.builder.apiKey&&(i.builder.apiKey=o),i.inlinedContent){var a=i.inlinedContent.content||i.inlinedContent;i.onContentLoaded(null==a?void 0:a.data,getContentWithInfo(a))}}return i}return __extends(t,e),Object.defineProperty(t.prototype,"options",{get:function(){return __assign(__assign({},t.defaults),this.props)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"name",{get:function(){return this.props.model||this.props.modelName||this.props.name},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.ref},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"inlinedContent",{get:function(){if(!this.isPreviewing||this.props.inlineContent)return this.props.content},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"builder",{get:function(){return this.props.builder||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl},enumerable:!1,configurable:!0}),t.prototype.getHtmlData=function(){var e=this.inlinedContent&&this.inlinedContent.id||this.props.entry,t=e&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&document.querySelector('script[data-builder-json="'.concat(e,'"],script[data-builder-state="').concat(e,'"]'));if(t)try{return JSON.parse(t.innerText)}catch(e){console.warn("Could not parse Builder.io HTML data transfer",e,t.innerText)}return{}},Object.defineProperty(t.prototype,"device",{get:function(){return this.builder.getUserAttributes().device||"desktop"},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"locationState",{get:function(){return __assign(__assign({},pick(this.location,"pathname","hostname","search","host")),{path:this.location.pathname&&this.location.pathname.split("/").slice(1)||"",query:searchToObject$1(this.location)})},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"deviceSizeState",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?this.sizes.getSizeForWidth(window.innerWidth):sizeMap[this.device]||"large"},enumerable:!1,configurable:!0}),t.renderInto=function(e,n,i,r){if(void 0===n&&(n={}),void 0===i&&(i=!0),void 0===r&&(r=!1),console.debug("BuilderPage.renderInto",e,n,i,this),e){var o=null;if("string"==typeof e?o=document.querySelector(e):e instanceof Element&&(o=e),o){var a=o.classList.contains("builder-hydrated");if(!a||r){o.classList.add("builder-hydrated");var s=i&&o.innerHTML.includes("builder-block");if(!o.classList.contains("builder-component")){var l=o.querySelector(".builder-api-styles")||(o.previousElementSibling&&o.previousElementSibling.matches(".builder-api-styles")?o.previousElementSibling:null),u="";if(l)l.innerHTML.replace(/\/\*start:([^\*]+?)\*\/([\s\S]*?)\/\*end:([^\*]+?)\*\//g,(function(e,t,n){var i=null;try{i=document.querySelector('[data-emotion-css="'.concat(t,'"]'))}catch(e){console.warn(e)}return i?i.innerHTML=n:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||(u+=e),e})),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){l.innerHTML=u}));var d=o.querySelector(".builder-component");d?o=d:s=!1}location.search.includes("builder.debug=true")&&console.debug("hydrate",s,o);var c=o;if(!a){var p=document.createElement("div");o.insertAdjacentElement("beforebegin",p),p.appendChild(o),c=p}if((_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&location.search.includes("builder.preview="))&&(s=!1),s&&o){var f=react_dom__WEBPACK_IMPORTED_MODULE_3__.render(react__WEBPACK_IMPORTED_MODULE_2__.createElement(t,__assign({},n)),c,c.builderRootRef);return c.builderRootRef=f,f}var m=react_dom__WEBPACK_IMPORTED_MODULE_3__.render(react__WEBPACK_IMPORTED_MODULE_2__.createElement(t,__assign({},n)),c,c.builderRootRef);return c.builderRootRef=m,m}console.debug("Tried to hydrate multiple times")}}},t.prototype.componentDidMount=function(){var e,t=this;this.mounted=!0,this.asServer&&(this.asServer=!1,this.updateState((function(e){e.isBrowser=!0,e.isServer=!1}))),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.sdkInjected",data:{modelName:this.name}},"*")),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(window.addEventListener("resize",this.resizeListener),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&window.addEventListener("message",this.messageListener),(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){t.firstLoad=!1,t.reload()})),setTimeout((function(){window.dispatchEvent(new CustomEvent("builder:component:load",{detail:{ref:t}}))})))},Object.defineProperty(t.prototype,"isPreviewing",{get:function(){return(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing&&!this.firstLoad)&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.previewingModel */ .fl.previewingModel===this.name},enumerable:!1,configurable:!0}),t.prototype.notifyStateChange=function(){if(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer&&this&&this.state){var e=this.state.state;this.props.onStateChange&&this.props.onStateChange(e),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&window.dispatchEvent(new CustomEvent("builder:component:stateChange",{detail:{state:e,ref:this}})),this.onStateChange.next(e)}},t.prototype.processStateFromApi=function(e){return e},Object.defineProperty(t.prototype,"location",{get:function(){return this.props.location||(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?location:{})},enumerable:!1,configurable:!0}),t.prototype.getCssFromFont=function(e,t){var n=e.family+(e.kind&&!e.kind.includes("#")?", "+e.kind:""),i=n.split(",")[0],r=e.fileUrl?e.fileUrl:e.files&&e.files.regular,o="";if(r&&n&&i&&(o+='\n@font-face {\n  font-family: "'.concat(n,'";\n  src: local("').concat(i,"\"), url('").concat(r,"') format('woff2');\n  font-display: fallback;\n  font-weight: 400;\n}\n        ").trim()),e.files)for(var a in e.files){if(String(Number(a))===a){var s=e.files[a];s&&s!==r&&(o+='\n@font-face {\n  font-family: "'.concat(n,"\";\n  src: url('").concat(s,"') format('woff2');\n  font-display: fallback;\n  font-weight: ").concat(a,";\n}\n          ").trim())}}return o},t.prototype.componentWillUnmount=function(){this.unsubscribe(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(window.removeEventListener("resize",this.resizeListener),window.removeEventListener("message",this.messageListener))},t.prototype.getFontCss=function(e){var t=this;return this.builder.allowCustomFonts&&(null==e?void 0:e.customFonts)&&e.customFonts.length&&e.customFonts.map((function(n){return t.getCssFromFont(n,e)})).join(" ")||""},t.prototype.ensureFontsLoaded=function(e){if(this.builder.allowCustomFonts&&(null==e?void 0:e.customFonts)&&Array.isArray(e.customFonts))for(var t=0,n=e.customFonts;t<n.length;t++){var i=n[t],r=i.fileUrl?i.fileUrl:i.files&&i.files.regular;if(!fontsLoaded.has(r)){var o=this.getCssFromFont(i,e);if(fontsLoaded.add(r),!o)continue;var a=document.createElement("style");a.className="builder-custom-font",a.setAttribute("data-builder-custom-font",r),a.innerHTML=o,document.head.appendChild(a)}}},t.prototype.getCss=function(e){var t,n=null===(t=this.useContent)||void 0===t?void 0:t.id,i=(null==e?void 0:e.cssCode)||"";return n&&(i=i.replace(/&/g,".builder-component-".concat(n))),i+this.getFontCss(e)},Object.defineProperty(t.prototype,"data",{get:function(){var e,t=__assign(__assign(__assign({},this.inlinedContent&&(null===(e=this.inlinedContent.data)||void 0===e?void 0:e.state)),this.externalState),this.state.state);return Object.assign(this.rootState,t),t},enumerable:!1,configurable:!0}),t.prototype.componentDidUpdate=function(e){var t=this;this.props.data&&e.data!==this.props.data&&this.state.update((function(e){Object.assign(e,t.externalState)})),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.inlinedContent&&e.content!==this.inlinedContent&&this.onContentLoaded(this.inlinedContent.data,this.inlinedContent)},t.prototype.checkStyles=function(e){if(this.styleRef){var t=this.getCss(e);this.styleRef.innerHTML!==t&&(this.styleRef.innerHTML=t)}},t.prototype.reload=function(){this.setState({key:this.state.key+1})},Object.defineProperty(t.prototype,"content",{get:function(){var e=this.inlinedContent;return e&&e.content&&(e=__assign(__assign({},e),{data:e.content})),e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"externalState",{get:function(){return __assign(__assign({},this.props.data),this.props.locale?{locale:this.props.locale}:{})},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"useContent",{get:function(){return this.content||this.state.context.builderContent},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e,t=this,n=this.content,i=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.externalState&&size$1(this.externalState)&&hash_sum__WEBPACK_IMPORTED_MODULE_4___default()(this.externalState),r=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?this.name:this.props.entry;r&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i&&i.length<300&&(r+=":"+i);var o=this.props.dataOnly?react__WEBPACK_IMPORTED_MODULE_2__.Fragment:"div",a=null===(e=this.useContent)||void 0===e?void 0:e.id;return react__WEBPACK_IMPORTED_MODULE_2__.createElement(o,{onClick:function(e){!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||t.props.isChild||t.props.stopClickPropagationWhenEditing||e.stopPropagation()},className:"builder-component ".concat(a?"builder-component-".concat(a):""),"data-name":this.name,"data-source":"Rendered by Builder.io",key:this.state.key,ref:function(e){return t.ref=e}},react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderMetaContext.Consumer,null,(function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderMetaContext.Provider,{value:"boolean"==typeof t.props.ampMode?__assign(__assign({},e),{ampMode:t.props.ampMode}):e},react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderAsyncRequestsContext.Consumer,null,(function(e){var i;return t._asyncRequests=e&&e.requests,t._errors=e&&e.errors,t._logs=e&&e.logs,react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderContent,{isStatic:t.props.isStatic||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isStatic */ .Ib.isStatic,key:(null===(i=t.inlinedContent)||void 0===i?void 0:i.id)||("content"in t.props&&!t.isPreviewing?"null-content-prop":"no-content-prop"),builder:t.builder,ref:function(e){return t.contentRef=e},contentLoaded:function(e,n){return t.onContentLoaded(e,n)},options:__assign(__assign(__assign(__assign(__assign(__assign({key:r,entry:t.props.entry},n&&{initialContent:[n]}),!n&&"content"in t.props&&!t.isPreviewing&&{initialContent:[]}),t.props.url&&{url:t.props.url}),t.props.options),t.props.locale?{locale:t.props.locale}:{}),t.options.codegen&&{format:"react"}),inline:t.props.inlineContent||!t.isPreviewing&&"content"in t.props,contentError:t.props.contentError,modelName:t.name||"page"},(function(e,n,i){var r;if(t.props.dataOnly)return null;i&&i.id&&(t.state.breakpoints&&(i.meta=i.meta||{},i.meta.breakpoints=t.state.breakpoints),t.state.context.builderContent=i),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){t.checkStyles(e)}));var o=t.options.codegen;if(o&&!t.Component&&(null==e?void 0:e.blocksJs)){var a=Array.from(new Set(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.map */ .Ib.components.map((function(e){return e.name})))),s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.slice */ .Ib.components.slice().reverse(),l=a.map((function(e){return s.find((function(t){return t.class&&t.name===e}))})),u=a.map((function(e){return(e||"").replace(/[^\w]+/gi,"")})),d=l.map((function(e){return wrapComponent(e)}));t.Component=(new(Function.bind.apply(Function,__spreadArray(__spreadArray([void 0,"jsx","_css","Builder","builder","React","useBuilderState"],u,!1),[e.blocksJs],!1)))).apply(void 0,__spreadArray([_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,react__WEBPACK_IMPORTED_MODULE_2__,function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.useState(0)[1];return react__WEBPACK_IMPORTED_MODULE_2__.useState((function(){return onChange(e,(function(){t((function(e){return e+1}))}))}))[0]}],d,!1))}var c=(null==e?void 0:e.blocks)||[],p=c.find((function(e){var t;return null===(t=e.id)||void 0===t?void 0:t.startsWith("builder-pixel")}));return e&&!p&&c.length>0&&c.push(getBuilderPixel(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.apiKey */ .fl.apiKey)),e?react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",__assign({"data-builder-component":t.name,"data-builder-content-id":i.id},t.isPreviewing?{"data-builder-variation-id":i.testVariationId||i.variationId||i.id}:{}),!o&&t.getCss(e)&&react__WEBPACK_IMPORTED_MODULE_2__.createElement("style",{ref:function(e){return t.styleRef=e},className:"builder-custom-styles",dangerouslySetInnerHTML:{__html:t.getCss(e)}}),react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Provider,{value:__assign(__assign({},t.state),{rootState:t.rootState,state:t.data,content:i,renderLink:t.props.renderLink})},o&&t.Component?react__WEBPACK_IMPORTED_MODULE_2__.createElement(t.Component,{data:t.data,context:t.state.context}):react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlocks,{key:String(!!(null===(r=null==e?void 0:e.blocks)||void 0===r?void 0:r.length)),emailMode:t.props.emailMode,fieldName:"blocks",blocks:c}))):n?react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{"data-builder-component":t.name,className:"builder-loading"},t.props.children):react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{"data-builder-component":t.name,className:"builder-no-content"})}))})))})))},t.prototype.evalExpression=function(e){var t=this,n=this.data;return String(e).replace(/{{([^}]+)}}/g,(function(e,i){return tryEval(i,n,t._errors)}))},t.prototype.handleRequest=function(e,t){return __awaiter(this,void 0,void 0,(function(){var n,i,r,o,a=this;return __generator(this,(function(s){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&fetchCache[t]?(this.updateState((function(n){n[e]=fetchCache[t]})),[2,fetchCache[t]]):(n=function(){return __awaiter(a,void 0,void 0,(function(){var n,i,r,o;return __generator(this,(function(a){switch(a.label){case 0:n=Date.now(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||console.time("Fetch "+t),a.label=1;case 1:return a.trys.push([1,4,5,6]),[4,fetch$1(t)];case 2:return[4,a.sent().json()];case 3:return i=a.sent(),[3,6];case 4:return r=a.sent(),o=toError(r),this._errors&&this._errors.push(o),this._logs&&this._logs.push("Fetch to ".concat(t," errored in ").concat(Date.now()-n,"ms")),[2];case 5:return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||(console.timeEnd("Fetch "+t),this._logs&&this._logs.push("Fetched ".concat(t," in ").concat(Date.now()-n,"ms"))),[7];case 6:return i&&(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&(fetchCache[t]=i),this.updateState((function(t){t[e]=i}))),[2,i]}}))}))},(i=this._asyncRequests&&this._asyncRequests.find((function(e){return isRequestInfo(e)&&e.url===t})))?((r=i.promise).then((function(t){t&&a.updateState((function(n){n[e]=t}))})),[2,r]):(o=n(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){a._asyncRequests&&a._asyncRequests.push(o)})),[2,o]))}))}))},t.prototype.unsubscribe=function(){this.subscriptions&&(this.subscriptions.unsubscribe(),this.subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0)},t.prototype.handleBuilderRequest=function(e,t){var n=this,i=tryEval(t,this.data,this._errors);this.subscriptions&&this.unsubscribe(),i&&this.subscriptions.add(this.builder.queueGetContent(i.model,i).subscribe((function(t){t&&n.updateState((function(n){n[e]=t}))})))},t.defaults={codegen:Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&location.href.includes("builder.codegen=true"))},__decorate([debounceNextTick,__metadata("design:type",Function),__metadata("design:paramtypes",[]),__metadata("design:returntype",void 0)],t.prototype,"notifyStateChange",null),t}(react__WEBPACK_IMPORTED_MODULE_2__.Component);function BuilderBlock(e){return e.type="react",_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.Component */ .Ib.Component(e)}function updateMetadata(e,t){var n=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.find */ .Ib.components.find((function(t){return"string"==typeof e?t.name===e:t.class===t}))||null,i=t(n);n&&i?_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(i.class||n.class,i):n&&!i||!n&&i&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(i.class,i)}function withBuilder(e,t){return BuilderBlock(t)(e),e}var withChildren=function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((function(t,n){var i=t.children||t.builderBlock&&t.builderBlock.children&&t.builderBlock.children.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{key:e.id,block:e})}));return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({},t,{ref:n}),i)}));return t.builderOptions={canHaveChildren:!0},t},noWrap=function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((function(t,n){var i=__assign(__assign({},t),t.attributes);return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({},i,{ref:n}))}));return t.builderOptions={noWrap:!0},t},iconUrl="https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",TextComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.textRef=null,t}return __extends(t,e),t.prototype.componentDidUpdate=function(e){this.allowTextEdit&&(!this.textRef||"true"===this.textRef.contentEditable&&this.textRef===document.activeElement||this.props.text!==e.text&&(this.textRef.innerHTML=this.props.text))},t.prototype.componentDidMount=function(){this.textRef&&(this.textRef.innerHTML=this.props.text)},t.prototype.evalExpression=function(e,t){return String(e).replace(/{{([^}]+)}}/g,(function(e,n){return tryEval(n,t)}))},Object.defineProperty(t.prototype,"allowTextEdit",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&location.search.includes("builder.allowTextEdit=true")&&!(this.props.builderBlock&&this.props.builderBlock.bindings&&(this.props.builderBlock.bindings["component.options.text"]||this.props.builderBlock.bindings["options.text"]||this.props.builderBlock.bindings.text))},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this,t=this.allowTextEdit,n={outline:"none","& p:first-of-type, & .builder-paragraph:first-of-type":{margin:0},"& > p, & .builder-paragraph":{color:"inherit",lineHeight:"inherit",letterSpacing:"inherit",fontWeight:"inherit",fontSize:"inherit",textAlign:"inherit",fontFamily:"inherit"}};return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(i){var r;return(null===(r=i.content.meta)||void 0===r?void 0:r.rtlMode)&&(n.direction="rtl"),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",__assign({ref:function(t){e.textRef=t},contentEditable:t||void 0,onInput:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textEdited",data:{id:e.props.builderBlock&&e.props.builderBlock.id,value:n.currentTarget.innerHTML}},"*"))},onKeyDown:function(n){t&&e.textRef&&27===n.which&&document.activeElement===e.textRef&&e.textRef.blur()},onFocus:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textFocused",data:{id:e.props.builderBlock&&e.props.builderBlock.id}},"*"))},onBlur:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textBlurred",data:{id:e.props.builderBlock&&e.props.builderBlock.id}},"*"))},css:n,className:"builder-text"},!t&&{dangerouslySetInnerHTML:{__html:e.evalExpression(e.props.text||e.props.content||"",i.state)}})))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Text=withBuilder(TextComponent,{name:"Text",static:!0,image:iconUrl,inputs:[{name:"text",type:"html",required:!0,autoFocus:!0,bubble:!0,defaultValue:"Enter some text..."}],defaultStyles:{lineHeight:"normal",height:"auto",textAlign:"center"}});function Slot(e){var t=e.name,n=(0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(BuilderStoreContext),i=!n.context.symbolId;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",__assign({css:{pointerEvents:"auto"}},i&&{"builder-slot":t}),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{child:!0,parentElementId:n.context.symbolId,dataPath:"symbol.data.".concat(t),blocks:n.state[t]||[]}))}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(Slot,{name:"Slot",description:"Allow child blocks to be inserted into this content when used as a Symbol",docsLink:"https://www.builder.io/c/docs/symbols-with-blocks",image:"https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",inputs:[{name:"name",type:"string",required:!0,defaultValue:"children"}]});var FragmentComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e,t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{block:e,key:e.id,index:t})}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Fragment=withBuilder(FragmentComponent,{name:"Core:Fragment",canHaveChildren:!0,noWrap:!0,static:!0,hideFromInsertMenu:!0}),DEFAULT_ASPECT_RATIO$2=.7004048582995948,defaultBlocks=[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{display:"flex",flexDirection:"column",alignItems:"stretch",flexShrink:"0",position:"relative",marginTop:"30px",textAlign:"center",lineHeight:"normal",height:"auto",minHeight:"20px",minWidth:"20px",overflow:"hidden"}},component:{name:"Image",options:{image:"https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",backgroundPosition:"center",backgroundSize:"cover",aspectRatio:DEFAULT_ASPECT_RATIO$2}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{display:"flex",flexDirection:"column",alignItems:"stretch",flexShrink:"0",position:"relative",marginTop:"30px",textAlign:"center",lineHeight:"normal",height:"auto"}},component:{name:"Text",options:{text:"<p>Enter some text...</p>"}}}],ColumnsComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),Object.defineProperty(t.prototype,"columns",{get:function(){return this.props.columns||[]},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"gutterSize",{get:function(){return"number"==typeof this.props.space?this.props.space||0:20},enumerable:!1,configurable:!0}),t.prototype.getWidth=function(e){return this.columns[e]&&this.columns[e].width||100/this.columns.length},t.prototype.getColumnWidth=function(e){var t=this.columns,n=this.gutterSize*(t.length-1)/t.length;return"calc(".concat(this.getWidth(e),"% - ").concat(n,"px)")},t.prototype.render=function(){var e,t,n,i,r=this,o=this.columns,a=this.gutterSize,s=(null===(i=null===(n=null===(t=this.props.builderState)||void 0===t?void 0:t.context.builderContent)||void 0===n?void 0:n.meta)||void 0===i?void 0:i.breakpoints)||{},l=getSizesForBreakpoints(s);return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-columns",css:__assign({display:"flex"},"never"!==this.props.stackColumnsAt&&(e={},e["@media (max-width: ".concat("tablet"!==this.props.stackColumnsAt?l.small.max:l.medium.max,"px)")]={flexDirection:this.props.reverseColumnsWhenStacked?"column-reverse":"column",alignItems:"stretch"},e))},o.map((function(e,t){var n,i,o=e.link?Link:"div";return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,{key:t},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(o,__assign({className:"builder-column"},e.link?{href:e.link}:null,{css:__assign((n={display:"flex",flexDirection:"column",alignItems:"stretch",lineHeight:"normal"},n["& > .builder-blocks"]={flexGrow:1},n.width=r.getColumnWidth(t),n.marginLeft=0===t?0:a,n),"never"!==r.props.stackColumnsAt&&(i={},i["@media (max-width: ".concat("tablet"!==r.props.stackColumnsAt?l.small.max:l.medium.max,"px)")]={width:"100%",marginLeft:0},i))}),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{key:t,child:!0,parentElementId:r.props.builderBlock&&r.props.builderBlock.id,blocks:e.blocks,dataPath:"component.options.columns.".concat(t,".blocks")})))}))))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Columns=withBuilder(ColumnsComponent,{name:"Columns",static:!0,inputs:[{name:"columns",type:"array",broadcast:!0,subFields:[{name:"blocks",type:"array",hideFromUI:!0,defaultValue:defaultBlocks},{name:"width",type:"number",hideFromUI:!0,helperText:"Width %, e.g. set to 50 to fill half of the space"},{name:"link",type:"url",helperText:"Optionally set a url that clicking this column will link to"}],defaultValue:[{blocks:defaultBlocks},{blocks:defaultBlocks}],onChange:function(e){function t(){n.forEach((function(e){e.delete("width")}))}var n=e.get("columns");Array.isArray(n)&&(!n.find((function(e){return e.get("width")}))||(n.find((function(e){return!e.get("width")}))||100!==n.reduce((function(e,t){return e+t.get("width")}),0))&&t())}},{name:"space",type:"number",defaultValue:20,helperText:"Size of gap between columns",advanced:!0},{name:"stackColumnsAt",type:"string",defaultValue:"tablet",helperText:"Convert horizontal columns to vertical at what device size",enum:["tablet","mobile","never"],advanced:!0},{name:"reverseColumnsWhenStacked",type:"boolean",defaultValue:!1,helperText:"When stacking columns for mobile devices, reverse the ordering",advanced:!0}]}),EmbedComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.elementRef=null,t.scriptsInserted=new Set,t.scriptsRun=new Set,t}return __extends(t,e),t.prototype.componentDidUpdate=function(e){this.props.content!==e.content&&this.findAndRunScripts()},t.prototype.componentDidMount=function(){this.findAndRunScripts()},t.prototype.findAndRunScripts=function(){if(this.elementRef&&"undefined"!=typeof window)for(var e=this.elementRef.getElementsByTagName("script"),t=0;t<e.length;t++){var n=e[t];if(n.src){if(this.scriptsInserted.has(n.src))continue;this.scriptsInserted.add(n.src);var i=document.createElement("script");i.async=!0,i.src=n.src,document.head.appendChild(i)}else{if(this.scriptsRun.has(n.innerText))continue;this.scriptsRun.add(n.innerText);try{new Function(n.innerText)()}catch(e){console.warn("Builder custom code component error:",e)}}}},Object.defineProperty(t.prototype,"content",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer?(this.props.content||"").replace(/<script[\s\S]*?<\/script>/g,""):this.props.content},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{ref:function(t){return e.elementRef=t},className:"builder-embed",dangerouslySetInnerHTML:{__html:this.content}})},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Embed=withBuilder(EmbedComponent,{name:"Embed",static:!0,inputs:[{name:"url",type:"url",required:!0,defaultValue:"",helperText:"e.g. enter a youtube url, google map, etc",onChange:function(e){var t=e.get("url");if(t){e.set("content","Loading...");return fetch("https://iframe.ly/api/iframely?url=".concat(t,"&api_key=").concat("ae0e60e78201a3f2b0de4b")).then((function(e){return e.json()})).then((function(n){e.get("url")===t&&(n.html?e.set("content",n.html):e.set("content","Invalid url, please try another"))})).catch((function(t){e.set("content","There was an error embedding this URL, please try again or another URL")}))}e.delete("content")}},{name:"content",type:"html",defaultValue:'<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',hideFromUI:!0}]}),globalReplaceNodes={}||null,isShopify$1=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&"Shopify"in window;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&globalReplaceNodes){var customCodeQuerySelector_1=".builder-custom-code";try{var allCustomCodeElements_1=Array.from(document.querySelectorAll(customCodeQuerySelector_1)),builderTemplates=document.querySelectorAll("template[data-template-variant-id]");builderTemplates.length&&Array.from(builderTemplates).forEach((function(e){var t=e.content.querySelectorAll(customCodeQuerySelector_1);t.length&&(allCustomCodeElements_1=allCustomCodeElements_1.concat(Array.from(t)))})),allCustomCodeElements_1.forEach((function(e){var t=e.parentElement,n=t&&t.getAttribute("builder-id");n&&(globalReplaceNodes[n]=globalReplaceNodes[n]||[],globalReplaceNodes[n].push(isShopify$1?e:e.cloneNode(!0)))}))}catch(e){console.error("Builder replace nodes error:",e)}}var CustomCodeComponent=function(e){function t(t){var n,i=this;if((i=e.call(this,t)||this).elementRef=null,i.originalRef=null,i.scriptsInserted=new Set,i.scriptsRun=new Set,i.firstLoad=!0,i.replaceNodes=!1,i.state={hydrated:!1},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var r=null===(n=i.props.builderBlock)||void 0===n?void 0:n.id;if(i.replaceNodes=Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(t.replaceNodes||isShopify$1)&&r&&(null==globalReplaceNodes?void 0:globalReplaceNodes[r])),i.firstLoad&&i.props.builderBlock)if(r&&(null==globalReplaceNodes?void 0:globalReplaceNodes[r])){var o=globalReplaceNodes[r].shift()||null;i.originalRef=o,0===globalReplaceNodes[r].length&&delete globalReplaceNodes[r]}else if(i.replaceNodes){var a=document.querySelectorAll(".".concat(i.props.builderBlock.id," .builder-custom-code"));if(1===a.length){var s=a[0];i.originalRef=s,i.originalRef.remove()}}}return i}return __extends(t,e),Object.defineProperty(t.prototype,"noReactRender",{get:function(){var e;return Boolean(isShopify$1&&(null===(e=this.props.code)||void 0===e?void 0:e.match(/{[{%]/g)))},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isHydrating",{get:function(){return!isShopify$1&&this.originalRef},enumerable:!1,configurable:!0}),t.prototype.componentDidUpdate=function(e){this.props.code!==e.code&&this.findAndRunScripts()},t.prototype.componentDidMount=function(){var e=this;this.firstLoad=!1,this.replaceNodes||(this.isHydrating?(this.setState({hydrated:!0}),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){return e.findAndRunScripts()}))):this.findAndRunScripts()),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.replaceNodes&&this.originalRef&&this.elementRef&&this.elementRef.appendChild(this.originalRef)},t.prototype.findAndRunScripts=function(){if(this.elementRef&&"undefined"!=typeof window)for(var e=this.elementRef.getElementsByTagName("script"),t=0;t<e.length;t++){var n=e[t];if(n.src){if(this.scriptsInserted.has(n.src))continue;this.scriptsInserted.add(n.src);var i=document.createElement("script");i.async=!0,i.src=n.src,document.head.appendChild(i)}else if(!n.type||["text/javascript","application/javascript","application/ecmascript"].includes(n.type)){if(this.scriptsRun.has(n.innerText))continue;try{this.scriptsRun.add(n.innerText),new Function(n.innerText)()}catch(e){console.warn("Builder custom code component error:",e)}}}},Object.defineProperty(t.prototype,"code",{get:function(){return(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer||this.isHydrating&&this.firstLoad)&&this.props.scriptsClientOnly?(this.props.code||"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,""):this.props.code},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",__assign({ref:function(t){return e.elementRef=t},className:"builder-custom-code"},!this.replaceNodes&&!this.noReactRender&&{dangerouslySetInnerHTML:{__html:this.code}}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),CustomCode=withBuilder(CustomCodeComponent,{name:"Custom Code",static:!0,requiredPermissions:["editCode"],inputs:[{name:"code",type:"html",required:!0,defaultValue:"<p>Hello there, I am custom HTML code!</p>",code:!0},__assign({name:"replaceNodes",type:"boolean",helperText:"Preserve server rendered dom nodes",advanced:!0},isShopify$1&&{defaultValue:!0}),__assign({name:"scriptsClientOnly",type:"boolean",helperText:"Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",advanced:!0},!isShopify$1&&{defaultValue:!0})]});function removeProtocol(e){return e.replace(/http(s)?:/,"")}function isElementInViewport(e){var t=e.getBoundingClientRect();return t.top>=0&&t.left>=0&&t.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&t.right<=(window.innerWidth||document.documentElement.clientWidth)}function getShopifyImageUrl(e,t){if(!e||!(null==e?void 0:e.match(/cdn\.shopify\.com/))||!t)return e;if("master"===t)return removeProtocol(e);var n=e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);if(n){var i=e.split(n[0]),r=n[3],o=t.match("x")?t:"".concat(t,"x");return removeProtocol("".concat(i[0],"_").concat(o).concat(r))}return null}var DEFAULT_ASPECT_RATIO$1=.7041;function updateQueryParam(e,t,n){void 0===e&&(e="");var i=new RegExp("([?&])"+t+"=.*?(&|$)","i"),r=-1!==e.indexOf("?")?"&":"?";return e.match(i)?e.replace(i,"$1"+t+"="+encodeURIComponent(n)+"$2"):e+r+t+"="+encodeURIComponent(n)}function getSrcSet(e){if(!e)return e;var t=[100,200,400,800,1200,1600,2e3];if(e.match(/builder\.io/)){var n=e,i=Number(e.split("?width=")[1]);return isNaN(i)||(n="".concat(n," ").concat(i,"w")),t.filter((function(e){return e!==i})).map((function(t){return"".concat(updateQueryParam(e,"width",t)," ").concat(t,"w")})).concat([n]).join(", ")}return e.match(/cdn\.shopify\.com/)?t.map((function(t){return[getShopifyImageUrl(e,"".concat(t,"x").concat(t)),t]})).filter((function(e){return!!e[0]})).map((function(e){var t=e[0],n=e[1];return"".concat(t," ").concat(n,"w")})).concat([e]).join(", "):e}var getSizes=function(e,t,n){var i,r,o,a,s,l,u,d;void 0===n&&(n={});var c="";if(e){var p=e.split(","),f=p.length;c=p.map((function(e,t){return f===t+1?e.replace(/\([\s\S]*?\)/g,"").trim():e})).join(", ")}else if(t&&t.responsiveStyles){var m=[],h=!1,g=/^\d+/,v=getSizesForBreakpoints(n);if(null===(o=null===(r=null===(i=t.responsiveStyles)||void 0===i?void 0:i.small)||void 0===r?void 0:r.width)||void 0===o?void 0:o.match(g)){h=!0;var b="(max-width: ".concat(v.small.max,"px)"),y="".concat(b," ").concat(t.responsiveStyles.small.width.replace("%","vw"));m.push(y)}if(null===(l=null===(s=null===(a=t.responsiveStyles)||void 0===a?void 0:a.medium)||void 0===s?void 0:s.width)||void 0===l?void 0:l.match(g)){h=!0;b="(max-width: ".concat(v.medium.max,"px)"),y="".concat(b," ").concat(t.responsiveStyles.medium.width.replace("%","vw"));m.push(y)}if(null===(d=null===(u=t.responsiveStyles)||void 0===u?void 0:u.large)||void 0===d?void 0:d.width){var _=t.responsiveStyles.large.width.replace("%","vw");m.push(_)}else h&&m.push("100vw");m.length&&(c=m.join(", "))}return c},ImageComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={imageLoaded:!t.useLazyLoading,load:!t.useLazyLoading},t.pictureRef=null,t.scrollListener=null,t.intersectionObserver=null,t}return __extends(t,e),Object.defineProperty(t.prototype,"useLazyLoading",{get:function(){return(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||!location.search.includes("builder.lazyLoadImages=false"))&&(!(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||!location.href.includes("builder.lazyLoadImages=true"))||this.props.lazy)},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(this.scrollListener&&(window.removeEventListener("scroll",this.scrollListener),this.scrollListener=null),this.intersectionObserver&&this.pictureRef&&this.intersectionObserver.unobserve(this.pictureRef))},t.prototype.componentDidMount=function(){var e=this;if(this.props.lazy&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)if(this.pictureRef&&isElementInViewport(this.pictureRef))this.setState({load:!0});else if("function"==typeof IntersectionObserver&&this.pictureRef){(this.intersectionObserver=new IntersectionObserver((function(t,n){t.forEach((function(t){t.intersectionRatio>0&&(e.setState({load:!0}),e.pictureRef&&n.unobserve(e.pictureRef))}))}))).observe(this.pictureRef)}else{var t=throttle((function(n){if(e.pictureRef){var i=e.pictureRef.getBoundingClientRect(),r=window.innerHeight/2;i.top<window.innerHeight+r&&(e.setState(__assign(__assign({},e.state),{load:!0})),window.removeEventListener("scroll",t),e.scrollListener=null)}}),400,{leading:!1,trailing:!0});this.scrollListener=t,window.addEventListener("scroll",t,{capture:!0,passive:!0}),t()}},Object.defineProperty(t.prototype,"image",{get:function(){return this.props.image||this.props.src},enumerable:!1,configurable:!0}),t.prototype.getSrcSet=function(){var e=this.image;if(e&&(e.match(/builder\.io/)||e.match(/cdn\.shopify\.com/)))return getSrcSet(e)},t.prototype.render=function(){var e,t,n=this,i=this.props,r=i.aspectRatio,o=i.lazy,a=i.builderBlock,s=i.builderState,l=this.props.builderBlock&&this.props.builderBlock.children,u=this.props.srcset,d=getSizes(this.props.sizes,a,(null===(t=null===(e=null==s?void 0:s.context.builderContent)||void 0===e?void 0:e.meta)||void 0===t?void 0:t.breakpoints)||{}),c=this.image;u&&c&&c.includes("builder.io/api/v1/image")?u.includes(c.split("?")[0])||(console.debug("Removed given srcset"),u=this.getSrcSet()):c&&!u&&(u=this.getSrcSet());var p=null==a?void 0:a.id.startsWith("builder-pixel-"),f=this.props.fitContent;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderMetaContext.Consumer,null,(function(e){var t,i=e.ampMode,a=i?"amp-img":"img",s=(!o||n.state.load||i)&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(a,__assign({},i?{layout:"responsive",height:n.props.height||(r?Math.round(1e3*r):void 0),width:n.props.width||(r?Math.round(1e3/r):void 0)}:null,{alt:n.props.altText,key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&"string"==typeof n.image&&n.image.split("?")[0]||void 0,role:n.props.altText?void 0:"presentation",css:__assign(__assign({opacity:i?1:n.useLazyLoading&&!n.state.imageLoaded?0:1,transition:"opacity 0.2s ease-in-out",objectFit:n.props.backgroundSize||"cover",objectPosition:n.props.backgroundPosition||"center"},r&&!i&&{position:"absolute",height:"100%",width:"100%",left:0,top:0}),i&&(t={},t["& img"]={objectFit:n.props.backgroundSize,objectPosition:n.props.backgroundPosition},t)),loading:p?"eager":"lazy",className:"builder-image"+(n.props.className?" "+n.props.className:""),src:n.image},!i&&{onLoad:function(){return n.setState({imageLoaded:!0})}},{srcSet:u,sizes:!i&&d?d:void 0}));return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,i?s:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("picture",{ref:function(e){return n.pictureRef=e}},u&&u.match(/builder\.io/)&&!n.props.noWebp&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source",{srcSet:u.replace(/\?/g,"?format=webp&"),type:"image/webp"}),s),!r||i||f&&l&&l.length?null:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-image-sizer",css:{width:"100%",paddingTop:100*r+"%",pointerEvents:"none",fontSize:0}}," "),l&&l.length?f?l.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})})):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex",flexDirection:"column",alignItems:"stretch",position:"absolute",top:0,left:0,width:"100%",height:"100%"}},l.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})}))):null)}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Image=withBuilder(ImageComponent,{name:"Image",static:!0,image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",defaultStyles:{position:"relative",minHeight:"20px",minWidth:"20px",overflow:"hidden"},canHaveChildren:!0,inputs:[{name:"image",type:"file",bubble:!0,allowedFileTypes:["jpeg","jpg","png","svg"],required:!0,defaultValue:"https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",onChange:function(e){e.delete("srcset"),e.delete("noWebp");var t,n,i=e.get("image"),r=e.get("aspectRatio");if(fetch(i).then((function(e){return e.blob()})).then((function(t){t.type.includes("svg")&&e.set("noWebp",!0)})),i&&(!r||.7041===r))return(t=i,void 0===n&&(n=6e4),new Promise((function(e,i){var r=document.createElement("img"),o=!1;r.onload=function(){o=!0,e(r)},r.addEventListener("error",(function(e){console.warn("Image load failed",e.error),i(e.error)})),r.src=t,setTimeout((function(){o||i(new Error("Image load timed out"))}),n)}))).then((function(t){var n,r=e.get("aspectRatio");e.get("image")!==i||r&&.7041!==r||t.width&&t.height&&(e.set("aspectRatio",(n=t.height/t.width,Math.round(1e3*n)/1e3)),e.set("height",t.height),e.set("width",t.width))}))}},{name:"backgroundSize",type:"text",defaultValue:"cover",enum:[{label:"contain",value:"contain",helperText:"The image should never get cropped"},{label:"cover",value:"cover",helperText:"The image should fill its box, cropping when needed"}]},{name:"backgroundPosition",type:"text",defaultValue:"center",enum:["center","top","left","right","bottom","top left","top right","bottom left","bottom right"]},{name:"altText",type:"string",helperText:"Text to display when the user has images off"},{name:"height",type:"number",hideFromUI:!0},{name:"width",type:"number",hideFromUI:!0},{name:"sizes",type:"string",hideFromUI:!0},{name:"srcset",type:"string",hideFromUI:!0},{name:"lazy",type:"boolean",defaultValue:!0,hideFromUI:!0},{name:"fitContent",type:"boolean",helperText:"When child blocks are provided, fit to them instead of using the image's aspect ratio",defaultValue:!0},{name:"aspectRatio",type:"number",helperText:"This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",advanced:!0,defaultValue:DEFAULT_ASPECT_RATIO$1}]}),DEFAULT_ASPECT_RATIO=.7004048582995948,VideoComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.video=null,t.containerRef=null,t.scrollListener=null,t.state={load:!t.lazyLoad},t}return __extends(t,e),Object.defineProperty(t.prototype,"lazyLoad",{get:function(){return!1!==this.props.lazyLoad},enumerable:!1,configurable:!0}),t.prototype.updateVideo=function(){var e=this,t=this.video;if(t){["muted","playsInline","autoPlay"].forEach((function(n){var i=n.toLowerCase();e.props[n]?t.setAttribute(i,i):t.removeAttribute(i)}))}},t.prototype.componentDidUpdate=function(){this.updateVideo()},t.prototype.componentDidMount=function(){var e=this;if(this.updateVideo(),this.lazyLoad&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var t=throttle((function(n){if(e.containerRef){var i=e.containerRef.getBoundingClientRect(),r=window.innerHeight/2;i.top<window.innerHeight+r&&(e.setState((function(e){return __assign(__assign({},e),{load:!0})})),window.removeEventListener("scroll",t),e.scrollListener=null)}}),400,{leading:!1,trailing:!0});this.scrollListener=t,window.addEventListener("scroll",t,{capture:!0,passive:!0}),t()}},t.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.scrollListener&&(window.removeEventListener("scroll",this.scrollListener),this.scrollListener=null)},t.prototype.render=function(){var e=this,t=this.props,n=t.aspectRatio,i=t.children;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{ref:function(t){return e.containerRef=t},css:{position:"relative"}},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("video",{key:this.props.video||"no-src",poster:this.props.posterImage,ref:function(t){return e.video=t},autoPlay:this.props.autoPlay,muted:this.props.muted,controls:this.props.controls,loop:this.props.loop,className:"builder-video",css:__assign({width:"100%",height:"100%",objectFit:this.props.fit,objectPosition:this.props.position,zIndex:2,borderRadius:1},n?{position:"absolute"}:null)},(!this.lazyLoad||this.state.load)&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source",{type:"video/mp4",src:this.props.video})),!n||this.props.fitContent&&i?null:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{width:"100%",paddingTop:100*n+"%",pointerEvents:"none",fontSize:0}}),i&&this.props.fitContent?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex",flexDirection:"column",alignItems:"stretch"}},i):i?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{pointerEvents:"none",display:"flex",flexDirection:"column",alignItems:"stretch",position:"absolute",top:0,left:0,width:"100%",height:"100%"}},i):null)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Video=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(withChildren(VideoComponent),{name:"Video",canHaveChildren:!0,defaultStyles:{minHeight:"20px",minWidth:"20px"},image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",inputs:[{name:"video",type:"file",allowedFileTypes:["mp4"],bubble:!0,defaultValue:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",required:!0},{name:"posterImage",type:"file",allowedFileTypes:["jpeg","png"],helperText:"Image to show before the video plays"},{name:"autoPlay",type:"boolean",defaultValue:!0},{name:"controls",type:"boolean",defaultValue:!1},{name:"muted",type:"boolean",defaultValue:!0},{name:"loop",type:"boolean",defaultValue:!0},{name:"playsInline",type:"boolean",defaultValue:!0},{name:"fit",type:"text",defaultValue:"cover",enum:["contain","cover","fill","auto"]},{name:"fitContent",type:"boolean",helperText:"When child blocks are provided, fit to them instead of using the aspect ratio",defaultValue:!0,advanced:!0},{name:"position",type:"text",defaultValue:"center",enum:["center","top","left","right","bottom","top left","top right","bottom left","bottom right"]},{name:"height",type:"number",advanced:!0},{name:"width",type:"number",advanced:!0},{name:"aspectRatio",type:"number",advanced:!0,defaultValue:DEFAULT_ASPECT_RATIO},{name:"lazyLoad",type:"boolean",helperText:'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',defaultValue:!0,advanced:!0}]}),size=function(e){return Object.keys(e).length},isShopify=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&"Shopify"in window,refs={};if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)try{Array.from(document.querySelectorAll("[builder-static-symbol]")).forEach((function(e){var t=e.getAttribute("builder-static-symbol");t&&(refs[t]=e)}))}catch(e){console.error("Builder replace nodes error:",e)}var SymbolComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.staticRef=null,t}return __extends(t,e),Object.defineProperty(t.prototype,"placeholder",{get:function(){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{padding:10}},"Symbols let you reuse dynamic elements across your content. Please choose a model and entry for this symbol.")},enumerable:!1,configurable:!0}),t.prototype.componentDidMount=function(){var e,t,n;this.useStatic&&this.staticRef&&refs[null===(e=this.props.builderBlock)||void 0===e?void 0:e.id]&&(null===(t=this.staticRef.parentNode)||void 0===t||t.replaceChild(refs[null===(n=this.props.builderBlock)||void 0===n?void 0:n.id],this.staticRef))},Object.defineProperty(t.prototype,"useStatic",{get:function(){var e;return Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&refs[null===(e=this.props.builderBlock)||void 0===e?void 0:e.id]&&!(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing))},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e,t=this;if(this.useStatic)return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{ref:function(e){return t.staticRef=e}});var n=this.props.symbol,i=!1;n||(i=!0);var r=this.props.dataOnly?NoWrap:this.props.builderBlock&&this.props.builderBlock.tagName||"div",o=n||{},a=o.model,s=o.entry,l=o.data,u=o.content,d=o.inline,c=(null==n?void 0:n.dynamic)||this.props.dynamic;a&&(s||c)||(null===(e=null==u?void 0:u.data)||void 0===e?void 0:e.blocksJs)||d||(i=!0);var p=c?void 0:[a,s].join(":"),f=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?null:l&&size(l)&&hash_sum__WEBPACK_IMPORTED_MODULE_4___default()(l);p&&f&&f.length<300&&(p+=":"+f);var m=this.props.attributes||{};return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,{key:(a||"no model")+":"+(s||"no entry")},(function(e){var o,d,c,f,h,g,v,b,y,_;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(r,__assign({"data-model":a},m,{className:(m.class||m.className||"")+" builder-symbol"+((null==n?void 0:n.inline)?" builder-inline-symbol":"")+((null==n?void 0:n.dynamic)||t.props.dynamic?" builder-dynamic-symbol":"")}),i?t.placeholder:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderComponent,__assign({},(null===(o=e.state)||void 0===o?void 0:o.locale)&&{locale:e.state.locale},{isChild:!0,ref:function(e){return t.ref=e},context:__assign(__assign({},e.context),{symbolId:null===(d=t.props.builderBlock)||void 0===d?void 0:d.id}),modelName:a,entry:s,data:__assign(__assign(__assign({},l),!!t.props.inheritState&&e.state),null===(b=null===(v=null===(g=null===(h=null===(f=null===(c=t.props.builderBlock)||void 0===c?void 0:c.component)||void 0===f?void 0:f.options)||void 0===h?void 0:h.symbol)||void 0===g?void 0:g.content)||void 0===v?void 0:v.data)||void 0===b?void 0:b.state),renderLink:e.renderLink,inlineContent:null==n?void 0:n.inline},u&&{content:u},{options:{key:p,noEditorUpdates:!0},codegen:!!(null===(y=null==u?void 0:u.data)||void 0===y?void 0:y.blocksJs),hydrate:null===(_=e.state)||void 0===_?void 0:_._hydrate,builderBlock:t.props.builderBlock,dataOnly:t.props.dataOnly}),t.props.children))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Symbol$1=withBuilder(SymbolComponent,{name:"Symbol",noWrap:!0,static:!0,inputs:[{name:"symbol",type:"uiSymbol"},{name:"dataOnly",helperText:"Make this a data symbol that doesn't display any UI",type:"boolean",defaultValue:!1,advanced:!0,hideFromUI:!0},{name:"inheritState",helperText:"Inherit the parent component state and data",type:"boolean",defaultValue:isShopify,advanced:!0},{name:"renderToLiquid",helperText:"Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",type:"boolean",defaultValue:isShopify,advanced:!0,hideFromUI:!0},{name:"useChildren",hideFromUI:!0,type:"boolean"}]}),ButtonComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.link?Link:"span";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({role:"button",href:this.props.link,target:this.props.openLinkInNewTab?"_blank":void 0},this.props.attributes),this.props.text)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Button=withBuilder(ButtonComponent,{name:"Core:Button",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",defaultStyles:{appearance:"none",paddingTop:"15px",paddingBottom:"15px",paddingLeft:"25px",paddingRight:"25px",backgroundColor:"#000000",color:"white",borderRadius:"4px",textAlign:"center",cursor:"pointer"},inputs:[{name:"text",type:"text",defaultValue:"Click me!",bubble:!0},{name:"link",type:"url",bubble:!0},{name:"openLinkInNewTab",type:"boolean",defaultValue:!1,friendlyName:"Open link in new tab"}],static:!0,noWrap:!0}),SectionComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.unmountCallbacks=[],t.state={inView:!1},t}return __extends(t,e),Object.defineProperty(t.prototype,"renderContents",{get:function(){return!0!==this.props.lazyLoad||this.state.inView},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){this.unmountCallbacks.forEach((function(e){return e()}))},t.prototype.componentDidMount=function(){var e=this;if(this.props.lazyLoad)if("undefined"!=typeof IntersectionObserver&&this.ref){var t=new IntersectionObserver((function(t,n){t.forEach((function(t){t.intersectionRatio>0&&(e.setState({inView:!0}),e.ref&&n.unobserve(e.ref))}))}),{rootMargin:"10px"});t.observe(this.ref),this.unmountCallbacks.push((function(){e.ref&&t.unobserve(e.ref)}))}else this.setState({inView:!0})},t.prototype.render=function(){var e=this;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("section",{ref:function(t){return e.ref=t},css:__assign({width:"100%",alignSelf:"stretch",flexGrow:1,boxSizing:"border-box",maxWidth:this.props.maxWidth,display:"flex",flexDirection:"column",alignItems:"stretch",marginLeft:"auto",marginRight:"auto"},this.renderContents?null:this.props.lazyStyles)},this.renderContents?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,this.props.children,this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})}))):null)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Section=withBuilder(SectionComponent,{name:"Core:Section",static:!0,image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",inputs:[{name:"maxWidth",type:"number",defaultValue:1200},{name:"lazyLoad",type:"boolean",defaultValue:!1,advanced:!0,description:"Only render this section when in view"}],defaultStyles:{paddingLeft:"20px",paddingRight:"20px",paddingTop:"50px",paddingBottom:"50px",marginTop:"0px",width:"100vw",marginLeft:"calc(50% - 50vw)"},canHaveChildren:!0,defaultChildren:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{textAlign:"center"}},component:{name:"Text",options:{text:"<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"}}}]}),StateProviderComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Consumer,null,(function(t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Provider,{value:__assign(__assign({},t),{state:__assign(__assign({},t.state),e.props.state),context:__assign(__assign({},t.context),e.props.context)})},e.props.builderBlock&&e.props.builderBlock.children&&e.props.builderBlock.children.map((function(e,t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{block:e,key:e.id,index:t,child:!0})})),e.props.children)}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),StateProvider=withBuilder(StateProviderComponent,{name:"Builder:StateProvider",canHaveChildren:!0,static:!0,noWrap:!0,hideFromInsertMenu:!0}),prefetched=new Set;function searchToObject(e){var t=(e.search||"").substring(1).split("&"),n={};for(var i in t)if(t[i]&&"string"==typeof t[i]){var r=t[i].split("=");n[decodeURIComponent(r[0])]=decodeURIComponent(r[1])}return n}var RouterComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.builder=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,t.routed=!1,t.preloadQueue=0,t.onPopState=function(e){t.updateLocationState()},t.onMouseOverOrTouchStart=function(e){if(!(t.preloadQueue>4)&&!1!==t.props.preloadOnHover){var n=t.findHrefTarget(e);if(n){var i=n.getAttribute("href");if(i){if(!t.isRelative(i)){var r=t.convertToRelative(i);if(!r)return;i=r}if(!i.startsWith("#")&&!prefetched.has(i)){prefetched.add(i);var o=t.parseUrl(i);t.preloadQueue++;var a=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getUserAttributes */ .fl.getUserAttributes();a.urlPath=o.pathname,a.queryString=o.search;var s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.get */ .fl.get(t.model,{userAttributes:a,key:t.model+":"+o.pathname+o.search}).subscribe((function(){t.preloadQueue--,s.unsubscribe()}))}}}}},t.onClick=function(e){return __awaiter(t,void 0,void 0,(function(){var t,n,i,r;return __generator(this,(function(o){if(!1===this.props.handleRouting)return[2];if(0!==e.button||e.ctrlKey||e.defaultPrevented||e.metaKey)return[2];if(!(t=this.findHrefTarget(e)))return[2];if(t.target&&"_client"!==t.target)return[2];if(!(n=t.getAttribute("href")))return[2];if(this.props.onRoute&&(i={url:n,anchorNode:t,preventDefault:function(){this.defaultPrevented=!0},defaultPrevented:!1},this.props.onRoute(i),i.defaultPrevented))return[2];if(!this.isRelative(n)){if(!(r=this.convertToRelative(n)))return[2];n=r}return n.startsWith("#")||(e.preventDefault(),this.route(n)),[2]}))}))},t.privateState=null,t}return __extends(t,e),t.prototype.route=function(e){var t;return this.routed=!0,"function"==typeof(null===(t=window.history)||void 0===t?void 0:t.pushState)?(history.pushState(null,"",e),this.updateLocationState(),!0):(location.href=e,!1)},t.prototype.updateLocationState=function(){this.privateState&&this.privateState.update((function(e){e.location=__assign(__assign({},e.location),{pathname:location.pathname,search:location.search,path:location.pathname.split("/").slice(1),query:searchToObject(location)})}))},Object.defineProperty(t.prototype,"model",{get:function(){return this.props.model||"page"},enumerable:!1,configurable:!0}),t.prototype.componentDidMount=function(){"undefined"!=typeof document&&(document.addEventListener("click",this.onClick),window.addEventListener("popstate",this.onPopState),document.addEventListener("mouseover",this.onMouseOverOrTouchStart),document.addEventListener("touchstart",this.onMouseOverOrTouchStart))},t.prototype.componentWillUnmount=function(){"undefined"!=typeof document&&(document.removeEventListener("click",this.onClick),document.removeEventListener("mouseover",this.onMouseOverOrTouchStart),window.removeEventListener("popstate",this.onPopState),document.removeEventListener("touchstart",this.onMouseOverOrTouchStart))},t.prototype.render=function(){var e=this,t=this.model;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(n){e.privateState=n;var i=n.state&&n.state.location&&n.state.location.pathname+n.state.location.search;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-router","data-model":t},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("style",null,"\n                @keyframes builderLoadingSpinner {\n                  0% {\n                    transform: rotate(0deg);\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                  }\n                }\n                /* TODO: overridable tag */\n                .builder-page-loading {\n                  -webkit-animation: builderLoadingSpinner 1s infinite linear;\n                  animation: builderLoadingSpinner 1s infinite linear;\n                  -webkit-transform: translateZ(0);\n                  transform: translateZ(0);\n                  border-radius: 50%;\n                  width: 36px;\n                  height: 36px;\n                  margin: 6px auto;\n                  position: relative;\n                  border: 1px solid transparent;\n                  border-left: 1px solid #808284;\n                }\n              "),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderComponent,{key:i,data:e.props.data,content:e.routed?void 0:e.props.content,modelName:t,options:{key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?void 0:e.model+":"+i}},e.props.children||(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex"}},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{margin:"40vh auto"},className:"builder-page-loading"}))))}))},t.prototype.findHrefTarget=function(e){for(var t=e.target;t;){if(t instanceof HTMLAnchorElement&&t.getAttribute("href"))return t;if(t===e.currentTarget)break;t=t.parentElement}return null},t.prototype.isRelative=function(e){return!e.match(/^(\/\/|https?:\/\/)/i)},t.prototype.parseUrl=function(e){var t=document.createElement("a");return t.href=e,t},t.prototype.convertToRelative=function(e){var t=this.parseUrl(location.href),n=this.parseUrl(e);if(t.host===n.host){var i=n.pathname+(n.search?n.search:"");return i.startsWith("#")?null:i||"/"}return null},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Router=withBuilder(RouterComponent,{name:"Core:Router",hideFromInsertMenu:!0,inputs:[{name:"model",type:"string",defaultValue:"page",advanced:!0},{name:"handleRouting",type:"boolean",defaultValue:!0,advanced:!0},{name:"preloadOnHover",type:"boolean",defaultValue:!0,advanced:!0},{name:"onRoute",type:"function",advanced:!0}]});function Mutation(e){var t,n,i=react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);useWaitForSelector(e.selector,(function(t){"afterEnd"!==e.type&&(t.innerHTML=""),t.appendChild(i.current.firstElementChild)}));var r=null===(t=e.builderBlock)||void 0===t?void 0:t.children;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",{style:{display:"none"},ref:i},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{style:{display:"inline"},child:!0,parentElementId:null===(n=e.builderBlock)||void 0===n?void 0:n.id,dataPath:"this.children",blocks:r}))}function useWaitForSelector(e,t){react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect((function(){try{var n=document.querySelector(e);if(n)return void t(n)}catch(e){console.warn(e)}var i=new MutationObserver((function(){try{var n=document.querySelector(e);n&&(i.disconnect(),t(n))}catch(e){console.warn(e)}}));return i.observe(document.body,{attributes:!0,subtree:!0,characterData:!0}),function(){i.disconnect()}}),[e])}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(Mutation,{name:"Builder:Mutation",canHaveChildren:!0,noWrap:!0,hideFromInsertMenu:!0,inputs:[{name:"type",type:"string",defaultValue:"replace",enum:[{label:"Replace",value:"replace",helperText:"Replace the contents of this site region with content from Builder"},{label:"Append",value:"afterEnd",helperText:"Append Builder content after the chosen site region"}]},{name:"selector",type:"builder:domSelector"}]});var get=function(e,t,n){var i=String.prototype.split.call(t,/[,[\].]+?/).filter(Boolean).reduce((function(e,t){return null!=e?e[t]:e}),e);return void 0===i||i===e?n:i},MULTIPART_CONTENT_TYPE="multipart/form-data",JSON_CONTENT_TYPE="application/json",ENCODED_CONTENT_TYPE="application/x-www-form-urlencoded",FormComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.state={state:"unsubmitted",responseData:null,formErrorMessage:""},t}return __extends(t,e),Object.defineProperty(t.prototype,"submissionState",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.previewState||this.state.state},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{value:__assign(__assign({},t),{state:__assign(__assign({},t.state),{formErrorMessage:e.state.formErrorMessage})})},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("form",__assign({validate:e.props.validate,ref:function(t){return e.ref=t},action:!e.props.sendWithJs&&e.props.action,method:e.props.method,name:e.props.name,onSubmit:function(t){var n,i=e.props.sendWithJs||"email"===e.props.sendSubmissionsTo;if("zapier"===e.props.sendSubmissionsTo)t.preventDefault();else if(i){if(!e.props.action&&"email"!==e.props.sendSubmissionsTo)return void t.preventDefault();t.preventDefault();var r=t.currentTarget,o=e.props.customHeaders||{},a=void 0,s=new FormData(r),l=Array.from(t.currentTarget.querySelectorAll("input,select,textarea")).filter((function(e){return!!e.name})).map((function(e){var t,n=e.name;if(e instanceof HTMLInputElement)if("radio"===e.type){if(e.checked)return{key:n,value:t=e.name}}else if("checkbox"===e.type)t=e.checked;else if("number"===e.type||"range"===e.type){var i=e.valueAsNumber;isNaN(i)||(t=i)}else t="file"===e.type?e.files:e.value;else t=e.value;return{key:n,value:t}})),u=e.props.contentType;if("email"===e.props.sendSubmissionsTo&&(u=MULTIPART_CONTENT_TYPE),Array.from(l).forEach((function(e){var t=e.value;(t instanceof File||Array.isArray(t)&&t[0]instanceof File||t instanceof FileList)&&(u=MULTIPART_CONTENT_TYPE)})),u===MULTIPART_CONTENT_TYPE)a=s;else if(u===JSON_CONTENT_TYPE){var d={};Array.from(l).forEach((function(e){var t=e.value,n=e.key;set(d,n,t)})),a=JSON.stringify(d)}else{if(u!==ENCODED_CONTENT_TYPE)return void console.error("Unsupported content type: ",u);a=Array.from(l).map((function(e){var t=e.value,n=e.key;return encodeURIComponent(n)+"="+encodeURIComponent(t)})).join("&")}u&&u!==MULTIPART_CONTENT_TYPE&&(i&&(null===(n=e.props.action)||void 0===n?void 0:n.includes("zapier.com"))||(o["content-type"]=u));var c=new CustomEvent("presubmit",{detail:{body:a}});if(e.ref&&(e.ref.dispatchEvent(c),c.defaultPrevented))return;e.setState(__assign(__assign({},e.state),{state:"sending"}));var p="".concat("dev"===_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.env */ .fl.env?"http://localhost:5000":"https://builder.io","/api/v1/form-submit?apiKey=").concat(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.apiKey */ .fl.apiKey,"&to=").concat(btoa(e.props.sendSubmissionsToEmail||""),"&name=").concat(encodeURIComponent(e.props.name||""));fetch("email"===e.props.sendSubmissionsTo?p:e.props.action,{body:a,headers:o,method:e.props.method||"post"}).then((function(t){return __awaiter(e,void 0,void 0,(function(){var e,n,i,r,o;return __generator(this,(function(a){switch(a.label){case 0:return(n=t.headers.get("content-type"))&&-1!==n.indexOf(JSON_CONTENT_TYPE)?[4,t.json()]:[3,2];case 1:return e=a.sent(),[3,4];case 2:return[4,t.text()];case 3:e=a.sent(),a.label=4;case 4:if(!t.ok&&this.props.errorMessagePath&&(i=get(e,this.props.errorMessagePath))&&("string"!=typeof i&&(i=JSON.stringify(i)),this.setState(__assign(__assign({},this.state),{formErrorMessage:i}))),this.setState(__assign(__assign({},this.state),{responseData:e,state:t.ok?"success":"error"})),t.ok){if(r=new CustomEvent("submit:success",{detail:{res:t,body:e}}),this.ref){if(this.ref.dispatchEvent(r),r.defaultPrevented)return[2];!1!==this.props.resetFormOnSubmit&&this.ref.reset()}this.props.successUrl&&(this.ref?(o=new CustomEvent("route",{detail:{url:this.props.successUrl}}),this.ref.dispatchEvent(o),o.defaultPrevented||(location.href=this.props.successUrl)):location.href=this.props.successUrl)}return[2]}}))}))}),(function(t){var n=new CustomEvent("submit:error",{detail:{error:t}});e.ref&&(e.ref.dispatchEvent(n),n.defaultPrevented)||e.setState(__assign(__assign({},e.state),{responseData:t,state:"error"}))}))}}},e.props.attributes),e.props.builderBlock&&e.props.builderBlock.children&&e.props.builderBlock.children.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})})),"error"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"errorMessage",blocks:e.props.errorMessage}),"sending"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"sendingMessage",blocks:e.props.sendingMessage}),"error"===e.submissionState&&e.state.responseData&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("pre",{className:"builder-form-error-text",css:{padding:10,color:"red",textAlign:"center"}},JSON.stringify(e.state.responseData,null,2)),"success"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"successMessage",blocks:e.props.successMessage})))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Form=withBuilder(FormComponent,{name:"Form:Form",defaults:{responsiveStyles:{large:{marginTop:"15px",paddingBottom:"15px"}}},image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",inputs:[{name:"sendSubmissionsTo",type:"string",enum:[{label:"Send to email",value:"email",helperText:"Send form submissions to the email address of your choosing"},{label:"Custom",value:"custom",helperText:"Handle where the form requests go manually with a little code, e.g. to your own custom backend"}],defaultValue:"email"},{name:"sendSubmissionsToEmail",type:"string",required:!0,defaultValue:"your@email.com",showIf:'options.get("sendSubmissionsTo") === "email"'},{name:"sendWithJs",type:"boolean",helperText:"Set to false to use basic html form action",defaultValue:!0,showIf:'options.get("sendSubmissionsTo") === "custom"'},{name:"name",type:"string",defaultValue:"My form"},{name:"action",type:"string",helperText:"URL to send the form data to",showIf:'options.get("sendSubmissionsTo") === "custom"'},{name:"contentType",type:"string",defaultValue:JSON_CONTENT_TYPE,advanced:!0,enum:[JSON_CONTENT_TYPE,MULTIPART_CONTENT_TYPE,ENCODED_CONTENT_TYPE],showIf:'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'},{name:"method",type:"string",showIf:'options.get("sendSubmissionsTo") === "custom"',defaultValue:"POST",advanced:!0},{name:"previewState",type:"string",enum:["unsubmitted","sending","success","error"],defaultValue:"unsubmitted",helperText:'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',showIf:'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'},{name:"successUrl",type:"url",helperText:"Optional URL to redirect the user to on form submission success",showIf:'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'},{name:"resetFormOnSubmit",type:"boolean",showIf:function(e){return"custom"===e.get("sendSubmissionsTo")&&!0===e.get("sendWithJs")},advanced:!0},{name:"successMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Thanks!</span>"}}}]},{name:"validate",type:"boolean",defaultValue:!0,advanced:!0},{name:"errorMessagePath",type:"text",advanced:!0,helperText:'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'},{name:"errorMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},bindings:{"component.options.text":"state.formErrorMessage || block.component.options.text"},component:{name:"Text",options:{text:"<span>Form submission error :( Please check your answers and try again</span>"}}}]},{name:"sendingMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Sending...</span>"}}}]},__assign(__assign({name:"customHeaders",type:"map"},{valueType:{type:"string"}}),{advanced:!0,showIf:'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'})],noWrap:!0,canHaveChildren:!0,defaultChildren:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Enter your name</span>"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:Input",options:{name:"name",placeholder:"Jane Doe"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Enter your email</span>"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:Input",options:{name:"email",placeholder:"jane@doe.com"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:SubmitButton",options:{text:"Submit"}}}]}),FormInputComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("input",__assign({key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.defaultValue?this.props.defaultValue:"default-key",placeholder:this.props.placeholder,type:this.props.type,name:this.props.name,value:this.props.value,defaultValue:this.props.defaultValue,required:this.props.required},this.props.attributes))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormInput=withBuilder(FormInputComponent,{name:"Form:Input",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",inputs:[{name:"type",type:"text",enum:["text","number","email","url","checkbox","radio","range","date","datetime-local","search","tel","time","file","month","week","password","color","hidden"],defaultValue:"text"},{name:"name",type:"string",required:!0,helperText:'Every input in a form needs a unique name describing what it takes, e.g. "email"'},{name:"placeholder",type:"string",defaultValue:"Hello there",helperText:"Text to display when there is no value"},{name:"defaultValue",type:"string"},{name:"value",type:"string",advanced:!0},{name:"required",type:"boolean",helperText:"Is this input required to be filled out to submit a form",defaultValue:!1}],noWrap:!0,static:!0,defaultStyles:{paddingTop:"10px",paddingBottom:"10px",paddingLeft:"10px",paddingRight:"10px",borderRadius:"3px",borderWidth:"1px",borderStyle:"solid",borderColor:"#ccc"}}),FormSubmitButtonComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("button",__assign({type:"submit"},this.props.attributes),this.props.text)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormSubmitButton=withBuilder(FormSubmitButtonComponent,{name:"Form:SubmitButton",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",defaultStyles:{appearance:"none",paddingTop:"15px",paddingBottom:"15px",paddingLeft:"25px",paddingRight:"25px",backgroundColor:"#3898EC",color:"white",borderRadius:"4px",cursor:"pointer"},inputs:[{name:"text",type:"text",defaultValue:"Click me"}],static:!0,noWrap:!0}),LabelComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("label",__assign({htmlFor:this.props.for},this.props.attributes),this.props.text&&react__WEBPACK_IMPORTED_MODULE_2__.createElement("span",{className:"builder-label-text",dangerouslySetInnerHTML:{__html:this.props.text}}),this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{key:e.id,block:e})})))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Label=withBuilder(LabelComponent,{name:"Form:Label",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F9322342f04b545fb9a8091cd801dfb5b",inputs:[{name:"text",type:"html",richText:!0,defaultValue:"Label"},{name:"for",type:"text",helperText:"The name of the input this label is for",advanced:!0}],noWrap:!0,static:!0,canHaveChildren:!0}),FormSelectComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.options;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("select",__assign({value:this.props.value,key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.defaultValue?this.props.defaultValue:"default-key",defaultValue:this.props.defaultValue,name:this.props.name},this.props.attributes),e&&e.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("option",{value:e.value},e.name||e.value)})))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormSelect=withBuilder(FormSelectComponent,{name:"Form:Select",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",defaultStyles:{alignSelf:"flex-start"},inputs:[{name:"options",type:"list",required:!0,subFields:[{name:"value",type:"text",required:!0},{name:"name",type:"text"}],defaultValue:[{value:"option 1"},{value:"option 2"}]},{name:"name",type:"string",required:!0,helperText:'Every select in a form needs a unique name describing what it gets, e.g. "email"'},{name:"defaultValue",type:"string"},{name:"value",type:"string",advanced:!0},{name:"required",type:"boolean",defaultValue:!1}],static:!0,noWrap:!0}),TextAreaComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("textarea",__assign({placeholder:this.props.placeholder,name:this.props.name,value:this.props.value,defaultValue:this.props.defaultValue},this.props.attributes))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),TextArea=withBuilder(TextAreaComponent,{name:"Form:TextArea",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",inputs:[{advanced:!0,name:"value",type:"string"},{name:"name",type:"string",required:!0,helperText:'Every input in a form needs a unique name describing what it gets, e.g. "email"'},{name:"defaultValue",type:"string"},{name:"placeholder",type:"string",defaultValue:"Hello there"},{name:"required",type:"boolean",defaultValue:!1}],defaultStyles:{paddingTop:"10px",paddingBottom:"10px",paddingLeft:"10px",paddingRight:"10px",borderRadius:"3px",borderWidth:"1px",borderStyle:"solid",borderColor:"#ccc"},static:!0,noWrap:!0}),ImgComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.attributes||{};return react__WEBPACK_IMPORTED_MODULE_2__.createElement("img",__assign({},this.props.attributes,{src:this.props.image||e.src}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Img=withBuilder(ImgComponent,{name:"Raw:Img",hideFromInsertMenu:!0,image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",inputs:[{name:"image",bubble:!0,type:"file",allowedFileTypes:["jpeg","jpg","png","svg"],required:!0}],noWrap:!0,static:!0}),RawText=function(e){var t=e.attributes||{};return react__WEBPACK_IMPORTED_MODULE_2__.createElement("span",{className:(null==t?void 0:t.class)||(null==t?void 0:t.className),dangerouslySetInnerHTML:{__html:e.text||""}})};function useIsPreviewing(){var e=(0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!1),t=e[0],n=e[1];return (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)((function(){(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)&&n(!0)}),[]),t}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(RawText,{name:"Builder:RawText",hideFromInsertMenu:!0,inputs:[{name:"text",bubble:!0,type:"longText",required:!0}]}),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isReact */ .Ib.isReact=!0;
//# sourceMappingURL=builder-react.es5.js.map


/***/ }),

/***/ 26149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* binding */ Builder; },
/* harmony export */   "Xe": function() { return /* binding */ BehaviorSubject; },
/* harmony export */   "fl": function() { return /* binding */ builder; },
/* harmony export */   "w0": function() { return /* binding */ Subscription; }
/* harmony export */ });
/* unused harmony exports BuilderComponent, isBrowser */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74859);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37525);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hash_sum__WEBPACK_IMPORTED_MODULE_0__);



(function () {
  if (typeof window === 'undefined' || typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

var isSafari = typeof window !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
// TODO: queue all of these in a debounceNextTick
function nextTick(fn) {
    // React native
    if (typeof setImmediate === 'function' && typeof window === 'undefined') {
        return setImmediate(fn);
    }
    // TODO: should this be setImmediate instead? Forgot if that is micro or macro task
    // TODO: detect specifically if is server
    // if (typeof process !== 'undefined' && process.nextTick) {
    //   console.log('process.nextTick?');
    //   process.nextTick(fn);
    //   return;
    // }
    // FIXME: fix the real safari issue of this randomly not working
    if (isSafari || typeof MutationObserver === 'undefined') {
        setTimeout(fn);
        return;
    }
    var called = 0;
    var observer = new MutationObserver(function () { return fn(); });
    var element = document.createTextNode('');
    observer.observe(element, {
        characterData: true,
    });
    // tslint:disable-next-line
    element.data = String((called = ++called));
}

var PROPERTY_NAME_DENY_LIST = Object.freeze(['__proto__', 'prototype', 'constructor']);
// TODO: unit tests
var QueryString = /** @class */ (function () {
    function QueryString() {
    }
    QueryString.parseDeep = function (queryString) {
        var obj = this.parse(queryString);
        return this.deepen(obj);
    };
    QueryString.stringifyDeep = function (obj) {
        var map = this.flatten(obj);
        return this.stringify(map);
    };
    QueryString.parse = function (queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            // TODO: node support?
            try {
                query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
            }
            catch (error) {
                // Ignore malformed URI components
            }
        }
        return query;
    };
    QueryString.stringify = function (map) {
        var str = '';
        for (var key in map) {
            if (map.hasOwnProperty(key)) {
                var value = map[key];
                if (str) {
                    str += '&';
                }
                str += encodeURIComponent(key) + '=' + encodeURIComponent(value);
            }
        }
        return str;
    };
    QueryString.deepen = function (map) {
        // FIXME; Should be type Tree = Record<string, string | Tree>
        // requires a typescript upgrade.
        var output = {};
        for (var k in map) {
            var t = output;
            var parts = k.split('.');
            var key = parts.pop();
            for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                var part = parts_1[_i];
                assertAllowedPropertyName(part);
                t = t[part] = t[part] || {};
            }
            t[key] = map[k];
        }
        return output;
    };
    QueryString.flatten = function (obj, _current, _res) {
        if (_res === void 0) { _res = {}; }
        for (var key in obj) {
            var value = obj[key];
            var newKey = _current ? _current + '.' + key : key;
            if (value && typeof value === 'object') {
                this.flatten(value, newKey, _res);
            }
            else {
                _res[newKey] = value;
            }
        }
        return _res;
    };
    return QueryString;
}());
function assertAllowedPropertyName(name) {
    if (PROPERTY_NAME_DENY_LIST.indexOf(name) >= 0)
        throw new Error("Property name \"".concat(name, "\" is not allowed"));
}

var version = "1.1.35";

var Subscription = /** @class */ (function () {
    function Subscription(listeners, listener) {
        this.listeners = listeners;
        this.listener = listener;
        this.unsubscribed = false;
        this.otherSubscriptions = [];
    }
    Object.defineProperty(Subscription.prototype, "closed", {
        get: function () {
            return this.unsubscribed;
        },
        enumerable: false,
        configurable: true
    });
    Subscription.prototype.add = function (subscription) {
        this.otherSubscriptions.push(subscription);
    };
    Subscription.prototype.unsubscribe = function () {
        if (this.unsubscribed) {
            return;
        }
        if (this.listener && this.listeners) {
            var index = this.listeners.indexOf(this.listener);
            if (index > -1) {
                this.listeners.splice(index, 1);
            }
        }
        this.otherSubscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.unsubscribed = true;
    };
    return Subscription;
}());
// TODO: follow minimal basic spec: https://github.com/tc39/proposal-observable
var BehaviorSubject = /** @class */ (function () {
    function BehaviorSubject(value) {
        this.value = value;
        this.listeners = [];
        this.errorListeners = [];
    }
    BehaviorSubject.prototype.next = function (value) {
        this.value = value;
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(value);
        }
    };
    // TODO: implement this as PIPE instead
    BehaviorSubject.prototype.map = function (fn) {
        var newSubject = new BehaviorSubject(fn(this.value));
        // TODO: on destroy delete these
        this.subscribe(function (val) {
            newSubject.next(fn(val));
        });
        this.catch(function (err) {
            newSubject.error(err);
        });
        return newSubject;
    };
    BehaviorSubject.prototype.catch = function (errorListener) {
        this.errorListeners.push(errorListener);
        return new Subscription(this.errorListeners, errorListener);
    };
    BehaviorSubject.prototype.error = function (error) {
        for (var _i = 0, _a = this.errorListeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(error);
        }
    };
    BehaviorSubject.prototype.subscribe = function (listener, errorListener) {
        this.listeners.push(listener);
        if (errorListener) {
            this.errorListeners.push(errorListener);
        }
        return new Subscription(this.listeners, listener);
    };
    BehaviorSubject.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var subscription = _this.subscribe(function (value) {
                resolve(value);
                subscription.unsubscribe();
            }, function (err) {
                reject(err);
                subscription.unsubscribe();
            });
        });
    };
    BehaviorSubject.prototype.promise = function () {
        return this.toPromise();
    };
    return BehaviorSubject;
}());

var State = {
    Pending: 'Pending',
    Fulfilled: 'Fulfilled',
    Rejected: 'Rejected',
};
function isFunction(val) {
    return val && typeof val === 'function';
}
function isObject(val) {
    return val && typeof val === 'object';
}
var TinyPromise = /** @class */ (function () {
    function TinyPromise(executor) {
        this._state = State.Pending;
        this._handlers = [];
        this._value = null;
        executor(this._resolve.bind(this), this._reject.bind(this));
    }
    TinyPromise.prototype._resolve = function (x) {
        var _this = this;
        if (x instanceof TinyPromise) {
            x.then(this._resolve.bind(this), this._reject.bind(this));
        }
        else if (isObject(x) || isFunction(x)) {
            var called_1 = false;
            try {
                var thenable = x.then;
                if (isFunction(thenable)) {
                    thenable.call(x, function (result) {
                        if (!called_1)
                            _this._resolve(result);
                        called_1 = true;
                        return undefined;
                    }, function (error) {
                        if (!called_1)
                            _this._reject(error);
                        called_1 = true;
                        return undefined;
                    });
                }
                else {
                    this._fulfill(x);
                }
            }
            catch (ex) {
                if (!called_1) {
                    this._reject(ex);
                }
            }
        }
        else {
            this._fulfill(x);
        }
    };
    TinyPromise.prototype._fulfill = function (result) {
        var _this = this;
        this._state = State.Fulfilled;
        this._value = result;
        this._handlers.forEach(function (handler) { return _this._callHandler(handler); });
    };
    TinyPromise.prototype._reject = function (error) {
        var _this = this;
        this._state = State.Rejected;
        this._value = error;
        this._handlers.forEach(function (handler) { return _this._callHandler(handler); });
    };
    TinyPromise.prototype._isPending = function () {
        return this._state === State.Pending;
    };
    TinyPromise.prototype._isFulfilled = function () {
        return this._state === State.Fulfilled;
    };
    TinyPromise.prototype._isRejected = function () {
        return this._state === State.Rejected;
    };
    TinyPromise.prototype._addHandler = function (onFulfilled, onRejected) {
        this._handlers.push({
            onFulfilled: onFulfilled,
            onRejected: onRejected,
        });
    };
    TinyPromise.prototype._callHandler = function (handler) {
        if (this._isFulfilled() && isFunction(handler.onFulfilled)) {
            handler.onFulfilled(this._value);
        }
        else if (this._isRejected() && isFunction(handler.onRejected)) {
            handler.onRejected(this._value);
        }
    };
    TinyPromise.prototype.then = function (onFulfilled, onRejected) {
        var _this = this;
        switch (this._state) {
            case State.Pending: {
                return new TinyPromise(function (resolve, reject) {
                    _this._addHandler(function (value) {
                        nextTick(function () {
                            try {
                                if (isFunction(onFulfilled)) {
                                    resolve(onFulfilled(value));
                                }
                                else {
                                    resolve(value);
                                }
                            }
                            catch (ex) {
                                reject(ex);
                            }
                        });
                    }, function (error) {
                        nextTick(function () {
                            try {
                                if (isFunction(onRejected)) {
                                    resolve(onRejected(error));
                                }
                                else {
                                    reject(error);
                                }
                            }
                            catch (ex) {
                                reject(ex);
                            }
                        });
                    });
                });
            }
            case State.Fulfilled: {
                return new TinyPromise(function (resolve, reject) {
                    nextTick(function () {
                        try {
                            if (isFunction(onFulfilled)) {
                                resolve(onFulfilled(_this._value));
                            }
                            else {
                                resolve(_this._value);
                            }
                        }
                        catch (ex) {
                            reject(ex);
                        }
                    });
                });
            }
            case State.Rejected: {
                return new TinyPromise(function (resolve, reject) {
                    nextTick(function () {
                        try {
                            if (isFunction(onRejected)) {
                                resolve(onRejected(_this._value));
                            }
                            else {
                                reject(_this._value);
                            }
                        }
                        catch (ex) {
                            reject(ex);
                        }
                    });
                });
            }
        }
    };
    return TinyPromise;
}());
var Promise$1 = (typeof Promise !== 'undefined' ? Promise : TinyPromise);

// Webpack workaround to conditionally require certain external modules
// only on the server and not bundle them on the client
var serverOnlyRequire;
try {
    // tslint:disable-next-line:no-eval
    serverOnlyRequire = eval('require');
}
catch (err) {
    // all good
    serverOnlyRequire = (function () { return null; });
}
var serverOnlyRequire$1 = serverOnlyRequire;

function promiseResolve(value) {
    return new Promise$1(function (resolve) { return resolve(value); });
}
// Adapted from https://raw.githubusercontent.com/developit/unfetch/master/src/index.mjs
function tinyFetch(url, options) {
    if (options === void 0) { options = {}; }
    return new Promise$1(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open(options.method || 'get', url, true);
        if (options.headers) {
            for (var i in options.headers) {
                request.setRequestHeader(i, options.headers[i]);
            }
        }
        request.withCredentials = options.credentials === 'include';
        request.onload = function () {
            resolve(response());
        };
        request.onerror = reject;
        request.send(options.body);
        function response() {
            var keys = [];
            var all = [];
            var headers = {};
            var header = undefined;
            request
                .getAllResponseHeaders()
                .replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (_match, _key, value) {
                var key = _key;
                keys.push((key = key.toLowerCase()));
                all.push([key, value]);
                header = headers[key];
                headers[key] = header ? "".concat(header, ",").concat(value) : value;
                return '';
            });
            return {
                ok: ((request.status / 100) | 0) === 2,
                status: request.status,
                statusText: request.statusText,
                url: request.responseURL,
                clone: response,
                text: function () { return promiseResolve(request.responseText); },
                json: function () { return promiseResolve(request.responseText).then(JSON.parse); },
                blob: function () { return promiseResolve(new Blob([request.response])); },
                headers: {
                    keys: function () { return keys; },
                    entries: function () { return all; },
                    get: function (n) { return headers[n.toLowerCase()]; },
                    has: function (n) { return n.toLowerCase() in headers; },
                },
            };
        }
    });
}
function getFetch() {
    // If fetch is defined, in the browser, via polyfill, or in a Cloudflare worker, use it.
    var _fetch = undefined;
    if (globalThis.fetch) {
        _fetch !== null && _fetch !== void 0 ? _fetch : (_fetch = globalThis.fetch);
    }
    else if (typeof window === 'undefined') {
        // If fetch is not defined, in a Node.js environment, use node-fetch.
        try {
            // node-fetch@^3 is ESM only, and will throw error on require.
            _fetch !== null && _fetch !== void 0 ? _fetch : (_fetch = serverOnlyRequire$1('node-fetch'));
        }
        catch (e) {
            // If node-fetch is not installed, use tiny-fetch.
            console.warn('node-fetch is not installed. consider polyfilling fetch or installing node-fetch.');
            console.warn(e);
        }
    }
    // Otherwise, use tiny-fetch.
    return _fetch !== null && _fetch !== void 0 ? _fetch : tinyFetch;
}

function assign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var to = Object(target);
    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}

function throttle(func, wait, options) {
    if (options === void 0) { options = {}; }
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout)
            context = args = null;
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false)
            previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout)
                context = args = null;
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

var camelCaseToKebabCase = function (str) {
    return str ? str.replace(/([A-Z])/g, function (g) { return "-".concat(g[0].toLowerCase()); }) : '';
};
var Animator = /** @class */ (function () {
    function Animator() {
    }
    Animator.prototype.bindAnimations = function (animations) {
        for (var _i = 0, animations_1 = animations; _i < animations_1.length; _i++) {
            var animation = animations_1[_i];
            switch (animation.trigger) {
                case 'pageLoad':
                    this.triggerAnimation(animation);
                    break;
                case 'hover':
                    this.bindHoverAnimation(animation);
                    break;
                case 'scrollInView':
                    this.bindScrollInViewAnimation(animation);
                    break;
            }
        }
    };
    Animator.prototype.warnElementNotPresent = function (id) {
        console.warn("Cannot animate element: element with ID ".concat(id, " not found!"));
    };
    Animator.prototype.augmentAnimation = function (animation, element) {
        var stylesUsed = this.getAllStylesUsed(animation);
        var computedStyle = getComputedStyle(element);
        // const computedStyle = getComputedStyle(element);
        // // FIXME: this will break if original load is in one reponsive size then resize to another hmmm
        // Need to use transform instead of left since left can change on screen sizes
        var firstStyles = animation.steps[0].styles;
        var lastStyles = animation.steps[animation.steps.length - 1].styles;
        var bothStyles = [firstStyles, lastStyles];
        // FIXME: this won't work as expected for augmented animations - may need the editor itself to manage this
        for (var _i = 0, bothStyles_1 = bothStyles; _i < bothStyles_1.length; _i++) {
            var styles = bothStyles_1[_i];
            for (var _a = 0, stylesUsed_1 = stylesUsed; _a < stylesUsed_1.length; _a++) {
                var style = stylesUsed_1[_a];
                if (!(style in styles)) {
                    styles[style] = computedStyle[style];
                }
            }
        }
    };
    Animator.prototype.getAllStylesUsed = function (animation) {
        var properties = [];
        for (var _i = 0, _a = animation.steps; _i < _a.length; _i++) {
            var step = _a[_i];
            for (var key in step.styles) {
                if (properties.indexOf(key) === -1) {
                    properties.push(key);
                }
            }
        }
        return properties;
    };
    Animator.prototype.triggerAnimation = function (animation) {
        var _this = this;
        // TODO: do for ALL elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            // TODO: do this properly, may have other animations of different properties
            // TODO: only override the properties
            // TODO: if there is an entrance and hover animation, the transition duration will get effed
            // element.setAttribute('style', '');
            // const styledUsed = this.getAllStylesUsed(animation);
            element.style.transition = 'none';
            element.style.transitionDelay = '0';
            assign(element.style, animation.steps[0].styles);
            // TODO: queue/batch these timeouts
            // TODO: only include properties explicitly set in the animation
            // using Object.keys(styles)
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
                assign(element.style, animation.steps[1].styles);
                // TODO: maybe remove/reset transitoin property after animation duration
                // TODO: queue timers
                setTimeout(function () {
                    // TODO: what if has other transition (reset back to what it was)
                    element.style.transition = '';
                    element.style.transitionDelay = '';
                }, (animation.delay || 0) * 1000 + animation.duration * 1000 + 100);
            });
        });
    };
    Animator.prototype.bindHoverAnimation = function (animation) {
        var _this = this;
        // TODO: is it multiple binding when editing...?
        // TODO: unbind on element remove
        // TODO: apply to ALL elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            var defaultState = animation.steps[0].styles;
            var hoverState = animation.steps[1].styles;
            function attachDefaultState() {
                assign(element.style, defaultState);
            }
            function attachHoverState() {
                assign(element.style, hoverState);
            }
            attachDefaultState();
            element.addEventListener('mouseenter', attachHoverState);
            element.addEventListener('mouseleave', attachDefaultState);
            // TODO: queue/batch these timeouts
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
            });
        });
    };
    // TODO: unbind on element remove
    Animator.prototype.bindScrollInViewAnimation = function (animation) {
        var _this = this;
        // TODO: apply to ALL matching elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        // TODO: if server side rendered and scrolled into view don't animate...
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            var triggered = false;
            var pendingAnimation = false;
            function immediateOnScroll() {
                if (!triggered && isScrolledIntoView(element)) {
                    triggered = true;
                    pendingAnimation = true;
                    setTimeout(function () {
                        assign(element.style, animation.steps[1].styles);
                        if (!animation.repeat) {
                            document.removeEventListener('scroll', onScroll);
                        }
                        setTimeout(function () {
                            pendingAnimation = false;
                            if (!animation.repeat) {
                                element.style.transition = '';
                                element.style.transitionDelay = '';
                            }
                        }, (animation.duration + (animation.delay || 0)) * 1000 + 100);
                    });
                }
                else if (animation.repeat &&
                    triggered &&
                    !pendingAnimation &&
                    !isScrolledIntoView(element)) {
                    // we want to repeat the animation every time the the element is out of view and back again
                    triggered = false;
                    assign(element.style, animation.steps[0].styles);
                }
            }
            // TODO: roll all of these in one for more efficiency of checking all the rects
            var onScroll = throttle(immediateOnScroll, 200, { leading: false });
            // TODO: fully in view or partially
            function isScrolledIntoView(elem) {
                var rect = elem.getBoundingClientRect();
                var windowHeight = window.innerHeight;
                var thresholdPercent = (animation.thresholdPercent || 0) / 100;
                var threshold = thresholdPercent * windowHeight;
                // TODO: partial in view? or what if element is larger than screen itself
                return (rect.bottom > threshold && rect.top < windowHeight - threshold // Element is peeking top or bottom
                // (rect.top > 0 && rect.bottom < window.innerHeight) || // element fits within the screen and is fully on screen (not hanging off at all)
                // (rect.top < 0 && rect.bottom > window.innerHeight) // element is larger than the screen and hangs over the top and bottom
                );
            }
            var defaultState = animation.steps[0].styles;
            function attachDefaultState() {
                assign(element.style, defaultState);
            }
            attachDefaultState();
            // TODO: queue/batch these timeouts!
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
            });
            // TODO: one listener for everything
            document.addEventListener('scroll', onScroll, { capture: true, passive: true });
            // Do an initial check
            immediateOnScroll();
        });
    };
    return Animator;
}());

/**
 * Only gets one level up from hostname
 * wwww.example.com -> example.com
 * www.example.co.uk -> example.co.uk
 */
function getTopLevelDomain(host) {
    var parts = host.split('.');
    if (parts.length > 2) {
        return parts.slice(1).join('.');
    }
    return host;
}

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var Cookies = /** @class */ (function () {
    function Cookies(request, response) {
        this.request = request;
        this.response = response;
    }
    Cookies.prototype.get = function (name) {
        var header = this.request.headers['cookie'];
        if (!header) {
            return;
        }
        var match = header.match(getPattern(name));
        if (!match) {
            return;
        }
        var value = match[1];
        return value;
    };
    Cookies.prototype.set = function (name, value, opts) {
        var res = this.response;
        var req = this.request;
        var headers = res.getHeader('Set-Cookie') || [];
        // TODO: just make this always true
        var secure = this.secure !== undefined
            ? !!this.secure
            : req.protocol === 'https' || req.connection.encrypted;
        var cookie = new Cookie(name, value, opts);
        if (typeof headers === 'string') {
            headers = [headers];
        }
        if (!secure && opts && opts.secure) {
            throw new Error('Cannot send secure cookie over unencrypted connection');
        }
        cookie.secure = secure;
        if (opts && 'secure' in opts) {
            cookie.secure = !!opts.secure;
        }
        cookie.domain = req.headers.host && getTopLevelDomain(req.headers.host);
        pushCookie(headers, cookie);
        var setHeader = res.setHeader;
        setHeader.call(res, 'Set-Cookie', headers);
        return this;
    };
    return Cookies;
}());
var Cookie = /** @class */ (function () {
    function Cookie(name, value, attrs) {
        this.path = '/';
        this.domain = undefined;
        this.httpOnly = true;
        this.sameSite = false;
        this.secure = false;
        this.overwrite = false;
        this.name = '';
        this.value = '';
        if (!fieldContentRegExp.test(name)) {
            throw new TypeError('argument name is invalid');
        }
        if (value && !fieldContentRegExp.test(value)) {
            throw new TypeError('argument value is invalid');
        }
        if (!value) {
            this.expires = new Date(0);
        }
        this.name = name;
        this.value = value || '';
        if (attrs.expires) {
            this.expires = attrs.expires;
        }
        if (attrs.secure) {
            this.secure = attrs.secure;
        }
    }
    Cookie.prototype.toString = function () {
        return "".concat(this.name, "=").concat(this.value);
    };
    Cookie.prototype.toHeader = function () {
        var header = this.toString();
        if (this.maxAge) {
            this.expires = new Date(Date.now() + this.maxAge);
        }
        if (this.path) {
            header += "; path=".concat(this.path);
        }
        if (this.expires) {
            header += "; expires=".concat(this.expires.toUTCString());
        }
        if (this.domain) {
            header += "; domain=".concat(this.domain);
        }
        // TODO: samesite=none by default (?)
        header += "; SameSite=".concat(this.sameSite === true ? 'strict' : 'None');
        // TODO: On by default
        if (this.secure) {
            header += '; secure';
        }
        if (this.httpOnly) {
            header += '; httponly';
        }
        return header;
    };
    return Cookie;
}());
function getPattern(name) {
    return new RegExp("(?:^|;) *".concat(name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "=([^;]*)"));
}
function pushCookie(headers, cookie) {
    if (cookie.overwrite) {
        for (var i = headers.length - 1; i >= 0; i--) {
            if (headers[i].indexOf("".concat(cookie.name, "=")) === 0) {
                headers.splice(i, 1);
            }
        }
    }
    headers.push(cookie.toHeader());
}

function omit(obj) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var newObject = Object.assign({}, obj);
    for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
        var key = values_1[_a];
        delete newObject[key];
    }
    return newObject;
}

/**
 * @credit https://stackoverflow.com/a/2117523
 */
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Slightly cleaner and smaller UUIDs
 */
function uuid() {
    return uuidv4().replace(/-/g, '');
}

function emptyUrl() {
    return {
        query: null,
        port: null,
        auth: null,
        hash: null,
        host: null,
        hostname: null,
        href: null,
        path: null,
        pathname: null,
        protocol: null,
        search: null,
        slashes: null,
    };
}
// Replacement for `url.parse` using `URL` global object that works with relative paths.
// Assumptions: this function operates in a NodeJS environment.
function parse(url) {
    var out = emptyUrl();
    var u;
    var pathOnly = url === '' || url[0] === '/';
    if (pathOnly) {
        u = new URL(url, 'http://0.0.0.0/');
        out.href = u.href;
        out.href = out.href.slice(14); // remove 'http://0.0.0.0/'
    }
    else {
        u = new URL(url);
        out.href = u.href;
        out.port = u.port === '' ? null : u.port;
        out.hash = u.hash === '' ? null : u.hash;
        out.host = u.host;
        out.hostname = u.hostname;
        out.href = u.href;
        out.pathname = u.pathname;
        out.protocol = u.protocol;
        out.slashes = url[u.protocol.length] === '/'; // check if the mimetype is proceeded by a slash
    }
    out.search = u.search;
    out.query = u.search.slice(1); // remove '?'
    out.path = "".concat(u.pathname).concat(u.search);
    out.pathname = u.pathname;
    return out;
}

/**
 * Safe conversion to error type. Intended to be used in catch blocks where the
 *  value is not guaranteed to be an error.
 *
 *  @example
 *  try {
 *    throw new Error('Something went wrong')
 *  }
 *  catch (err: unknown) {
 *    const error: Error = toError(err)
 *  }
 */
function toError(err) {
    if (err instanceof Error)
        return err;
    return new Error(String(err));
}

var DEFAULT_API_VERSION = 'v3';

function datePlusMinutes(minutes) {
    if (minutes === void 0) { minutes = 30; }
    return new Date(Date.now() + minutes * 60000);
}
var isPositiveNumber = function (thing) {
    return typeof thing === 'number' && !isNaN(thing) && thing >= 0;
};
var isReactNative = typeof navigator === 'object' && navigator.product === 'ReactNative';
var validEnvList = [
    'production',
    'qa',
    'test',
    'development',
    'dev',
    'cdn-qa',
    'cloud',
    'fast',
    'cdn2',
    'cdn-prod',
];
function getQueryParam(url, variable) {
    var query = url.split('?')[1] || '';
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
var urlParser = {
    parse: function (url) {
        var el = document.createElement('a');
        el.href = url;
        var out = {};
        var props = [
            'username',
            'password',
            'host',
            'hostname',
            'port',
            'protocol',
            'origin',
            'pathname',
            'search',
            'hash',
        ];
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            out[prop] = el[prop];
        }
        // IE 11 pathname handling workaround
        // (IE omits preceeding '/', unlike other browsers)
        if ((out.pathname || out.pathname === '') &&
            typeof out.pathname === 'string' &&
            out.pathname.indexOf('/') !== 0) {
            out.pathname = '/' + out.pathname;
        }
        return out;
    },
};
var parse$1 = isReactNative
    ? function () { return emptyUrl(); }
    : typeof window === 'object'
        ? urlParser.parse
        : parse;
function setCookie(name$$1, value, expires) {
    try {
        var expiresString = '';
        // TODO: need to know if secure server side
        if (expires) {
            expiresString = '; expires=' + expires.toUTCString();
        }
        var secure = isBrowser ? location.protocol === 'https:' : true;
        document.cookie =
            name$$1 +
                '=' +
                (value || '') +
                expiresString +
                '; path=/' +
                "; domain=".concat(getTopLevelDomain(location.hostname)) +
                (secure ? ';secure ; SameSite=None' : '');
    }
    catch (err) {
        console.warn('Could not set cookie', err);
    }
}
function getCookie(name$$1) {
    try {
        return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
            encodeURIComponent(name$$1).replace(/[\-\.\+\*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
    }
    catch (err) {
        console.warn('Could not get cookie', err);
    }
}
function size(object) {
    return Object.keys(object).length;
}
function find(target, callback) {
    var list = target;
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if (callback.call(thisArg, element, i, list)) {
            return element;
        }
    }
}
var sessionStorageKey = 'builderSessionId';
var localStorageKey = 'builderVisitorId';
var isBrowser = typeof window !== 'undefined' && !isReactNative;
var isIframe = isBrowser && window.top !== window.self;
function BuilderComponent(info) {
    if (info === void 0) { info = {}; }
    return Builder.Component(info);
}
var Builder = /** @class */ (function () {
    function Builder(apiKey, request, response, forceNewInstance, authToken, apiVersion) {
        if (apiKey === void 0) { apiKey = null; }
        if (forceNewInstance === void 0) { forceNewInstance = false; }
        if (authToken === void 0) { authToken = null; }
        var _this = this;
        this.request = request;
        this.response = response;
        this.eventsQueue = [];
        this.throttledClearEventsQueue = throttle(function () {
            _this.processEventsQueue();
            // Extend the session cookie
            _this.setCookie(sessionStorageKey, _this.sessionId, datePlusMinutes(30));
        }, 5);
        this.env = 'production';
        this.sessionId = this.getSessionId();
        this.targetContent = true;
        this.contentPerRequest = 1;
        // TODO: make array or function
        this.allowCustomFonts = true;
        this.cookies = null;
        // TODO: api options object
        this.cachebust = false;
        this.overrideParams = '';
        this.noCache = false;
        this.preview = false;
        this.apiVersion$ = new BehaviorSubject(undefined);
        this.canTrack$ = new BehaviorSubject(!this.browserTrackingDisabled);
        this.apiKey$ = new BehaviorSubject(null);
        this.authToken$ = new BehaviorSubject(null);
        this.userAttributesChanged = new BehaviorSubject(null);
        this.editingMode$ = new BehaviorSubject(isIframe);
        // TODO: decorator to do this stuff with the get/set (how do with typing too? compiler?)
        this.editingModel$ = new BehaviorSubject(null);
        this.userAgent = (typeof navigator === 'object' && navigator.userAgent) || '';
        this.trackingHooks = [];
        // Set this to control the userId
        // TODO: allow changing it mid session and updating existing data to be associated
        // e.g. for when a user navigates and then logs in
        this.visitorId = this.getVisitorId();
        this.autoTrack = !Builder.isBrowser
            ? false
            : !this.isDevelopmentEnv &&
                !(Builder.isBrowser && location.search.indexOf('builder.preview=') !== -1);
        this.trackingUserAttributes = {};
        this.blockContentLoading = '';
        this.observersByKey = {};
        this.noEditorUpdates = {};
        this.overrides = {};
        this.queryOptions = {};
        this.getContentQueue = null;
        this.priorContentQueue = null;
        this.testCookiePrefix = 'builder.tests';
        this.cookieQueue = [];
        // TODO: use a window variable for this perhaps, e.g. bc webcomponents may be loading builder twice
        // with it's and react (use rollup build to fix)
        if (Builder.isBrowser && !forceNewInstance && Builder.singletonInstance) {
            return Builder.singletonInstance;
        }
        if (this.request && this.response) {
            this.setUserAgent(this.request.headers['user-agent'] || '');
            this.cookies = new Cookies(this.request, this.response);
        }
        if (apiKey) {
            this.apiKey = apiKey;
        }
        if (apiVersion) {
            this.apiVersion = apiVersion;
        }
        if (authToken) {
            this.authToken = authToken;
        }
        if (isBrowser) {
            this.bindMessageListeners();
            if (Builder.isEditing) {
                parent.postMessage({
                    type: 'builder.animatorOptions',
                    data: {
                        options: {
                            version: 2,
                        },
                    },
                }, '*');
            }
            // TODO: postmessage to parent the builder info for every package
            // type: 'builder.sdk', data: { name: '@builder.io/react', version: '0.1.23' }
            // (window as any).BUILDER_VERSION = Builder.VERSION;
            // Ensure always one Builder global singleton
            // TODO: some people won't want this, e.g. rakuten
            // Maybe hide this behind symbol or on document, etc
            // if ((window as any).Builder) {
            //   Builder.components = (window as any).Builder.components;
            // } else {
            //   (window as any).Builder = Builder;
            // }
        }
        if (isIframe) {
            this.messageFrameLoaded();
        }
        // TODO: on destroy clear subscription
        this.canTrack$.subscribe(function (value) {
            if (value) {
                if (typeof sessionStorage !== 'undefined') {
                    try {
                        if (!sessionStorage.getItem(sessionStorageKey)) {
                            sessionStorage.setItem(sessionStorageKey, _this.sessionId);
                        }
                    }
                    catch (err) {
                        console.debug('Session storage error', err);
                    }
                }
                if (_this.eventsQueue.length) {
                    _this.throttledClearEventsQueue();
                }
                if (_this.cookieQueue.length) {
                    _this.cookieQueue.forEach(function (item) {
                        _this.setCookie(item[0], item[1]);
                    });
                    _this.cookieQueue.length = 0;
                }
            }
        });
        if (isBrowser) {
            // TODO: defer so subclass constructor runs and injects location service
            this.setTestsFromUrl();
            // TODO: do this on every request send?
            this.getOverridesFromQueryString();
        }
    }
    Builder.register = function (type, info) {
        // TODO: all must have name and can't conflict?
        var typeList = this.registry[type];
        if (!typeList) {
            typeList = this.registry[type] = [];
        }
        typeList.push(info);
        if (Builder.isBrowser) {
            var message = {
                type: 'builder.register',
                data: {
                    type: type,
                    info: info,
                },
            };
            try {
                parent.postMessage(message, '*');
                if (parent !== window) {
                    window.postMessage(message, '*');
                }
            }
            catch (err) {
                console.debug('Could not postmessage', err);
            }
        }
        this.registryChange.next(this.registry);
    };
    Builder.registerEditor = function (info) {
        if (Builder.isBrowser) {
            window.postMessage({
                type: 'builder.registerEditor',
                data: omit(info, 'component'),
            }, '*');
            var hostname = location.hostname;
            if (!Builder.isTrustedHost(hostname)) {
                console.error('Builder.registerEditor() called in the wrong environment! You cannot load custom editors from your app, they must be loaded through the Builder.io app itself. Follow the readme here for more details: https://github.com/builderio/builder/tree/master/plugins/cloudinary or contact chat us in our Spectrum community for help: https://spectrum.chat/builder');
            }
        }
        this.editors.push(info);
    };
    Builder.registerPlugin = function (info) {
        this.plugins.push(info);
    };
    Builder.registerAction = function (action) {
        this.actions.push(action);
    };
    Builder.registerTrustedHost = function (host) {
        this.trustedHosts.push(host);
    };
    Builder.isTrustedHost = function (hostname) {
        return (this.trustedHosts.findIndex(function (trustedHost) { return trustedHost === hostname || hostname.endsWith(".".concat(trustedHost)); }) > -1);
    };
    Builder.runAction = function (action) {
        // TODO
        var actionObject = typeof action === 'string' ? find(this.actions, function (item) { return item.name === action; }) : action;
        if (!actionObject) {
            throw new Error("Action not found: ".concat(action));
        }
    };
    Builder.fields = function (name$$1, fields) {
        var _a;
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'builder.fields',
            data: { name: name$$1, fields: fields },
        }, '*');
    };
    /**
     * @deprecated
     * @hidden
     *
     * Use Builder.register('editor.settings', {}) instead.
     */
    Builder.set = function (settings) {
        Builder.register('editor.settings', settings);
    };
    Builder.import = function (packageName) {
        if (!Builder.isBrowser) {
            // TODO: server side support *maybe*
            console.warn('Builder.import used on the server - this should only be used in the browser');
            return;
        }
        var System = window.System;
        if (!System) {
            console.warn('System.js not available. Please include System.js when using Builder.import');
            return;
        }
        return System.import("https://cdn.builder.io/systemjs/".concat(packageName));
    };
    Object.defineProperty(Builder, "editingPage", {
        // useCdnApi = false;
        get: function () {
            return this._editingPage;
        },
        set: function (editingPage) {
            this._editingPage = editingPage;
            if (isBrowser && isIframe) {
                if (editingPage) {
                    document.body.classList.add('builder-editing-page');
                }
                else {
                    document.body.classList.remove('builder-editing-page');
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prepareComponentSpecToSend = function (spec) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, spec), (spec.inputs && {
            inputs: spec.inputs.map(function (input) {
                var _a;
                // TODO: do for nexted fields too
                // TODO: probably just convert all functions, not just
                // TODO: put this in input hooks: { onChange: ..., showIf: ... }
                var keysToConvertFnToString = ['onChange', 'showIf'];
                for (var _i = 0, keysToConvertFnToString_1 = keysToConvertFnToString; _i < keysToConvertFnToString_1.length; _i++) {
                    var key = keysToConvertFnToString_1[_i];
                    if (input[key] && typeof input[key] === 'function') {
                        var fn = input[key];
                        input = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, input), (_a = {}, _a[key] = "return (".concat(fn.toString(), ").apply(this, arguments)"), _a));
                    }
                }
                return input;
            }),
        })), { hooks: Object.keys(spec.hooks || {}).reduce(function (memo, key) {
                var value = spec.hooks && spec.hooks[key];
                if (!value) {
                    return memo;
                }
                if (typeof value === 'string') {
                    memo[key] = value;
                }
                else {
                    memo[key] = "return (".concat(value.toString(), ").apply(this, arguments)");
                }
                return memo;
            }, {}), class: undefined });
    };
    Builder.registerBlock = function (component, options) {
        this.registerComponent(component, options);
    };
    Builder.registerComponent = function (component, options) {
        var _a;
        var spec = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ class: component }, component.builderOptions), options);
        this.addComponent(spec);
        var editable = options.models && this.singletonInstance.editingModel
            ? isBrowser && options.models.includes(this.singletonInstance.editingModel)
            : isBrowser;
        if (editable) {
            var sendSpec = this.prepareComponentSpecToSend(spec);
            (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                type: 'builder.registerComponent',
                data: sendSpec,
            }, '*');
        }
    };
    Builder.addComponent = function (component) {
        var current = find(this.components, function (item) { return item.name === component.name; });
        if (current) {
            // FIXME: why does sometimes we get an extra post without class - probably
            // from postMessage handler wrong in some place
            if (current.class && !component.class) {
                return;
            }
            this.components.splice(this.components.indexOf(current), 1, component);
        }
        else {
            this.components.push(component);
        }
    };
    // TODO: style guide, etc off this system as well?
    Builder.component = function (info) {
        var _this = this;
        if (info === void 0) { info = {}; }
        return function (component) {
            var _a;
            var spec = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, info), { class: component });
            if (!spec.name) {
                spec.name = component.name;
            }
            _this.addComponent(spec);
            var sendSpec = _this.prepareComponentSpecToSend(spec);
            // TODO: serialize component name and inputs
            if (isBrowser) {
                (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                    type: 'builder.registerComponent',
                    data: sendSpec,
                }, '*');
            }
            return component;
        };
    };
    Object.defineProperty(Builder, "Component", {
        get: function () {
            return this.component;
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.processEventsQueue = function () {
        if (!this.eventsQueue.length) {
            return;
        }
        var events = this.eventsQueue;
        this.eventsQueue = [];
        var fullUserAttributes = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, Builder.overrideUserAttributes), this.trackingUserAttributes);
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            if (!event_1.data.metadata) {
                event_1.data.metadata = {};
            }
            if (!event_1.data.metadata.user) {
                event_1.data.metadata.user = {};
            }
            Object.assign(event_1.data.metadata.user, fullUserAttributes, event_1.data.metadata.user);
        }
        var host = this.host;
        getFetch()("".concat(host, "/api/v1/track"), {
            method: 'POST',
            body: JSON.stringify({ events: events }),
            headers: {
                'content-type': 'application/json',
            },
            mode: 'cors',
        }).catch(function () {
            // Not the end of the world
        });
    };
    Object.defineProperty(Builder.prototype, "browserTrackingDisabled", {
        get: function () {
            return Builder.isBrowser && Boolean(window.builderNoTrack || !navigator.cookieEnabled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "canTrack", {
        get: function () {
            return this.canTrack$.value;
        },
        set: function (canTrack) {
            if (this.canTrack !== canTrack) {
                this.canTrack$.next(canTrack);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "apiVersion", {
        get: function () {
            return this.apiVersion$.value;
        },
        set: function (apiVersion) {
            if (this.apiVersion !== apiVersion) {
                this.apiVersion$.next(apiVersion);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "editingMode", {
        get: function () {
            return this.editingMode$.value;
        },
        set: function (value) {
            if (value !== this.editingMode) {
                this.editingMode$.next(value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "editingModel", {
        get: function () {
            return this.editingModel$.value;
        },
        set: function (value) {
            if (value !== this.editingModel) {
                this.editingModel$.next(value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.findParentElement = function (target, callback, checkElement) {
        if (checkElement === void 0) { checkElement = true; }
        if (!(target instanceof HTMLElement)) {
            return null;
        }
        var parent = checkElement ? target : target.parentElement;
        do {
            if (!parent) {
                return null;
            }
            var matches = callback(parent);
            if (matches) {
                return parent;
            }
        } while ((parent = parent.parentElement));
        return null;
    };
    Builder.prototype.findBuilderParent = function (target) {
        return this.findParentElement(target, function (el) {
            var id = el.getAttribute('builder-id') || el.id;
            return Boolean(id && id.indexOf('builder-') === 0);
        });
    };
    Builder.prototype.setUserAgent = function (userAgent) {
        this.userAgent = userAgent || '';
    };
    /**
     * Set a hook to modify events being tracked from builder, such as impressions and clicks
     *
     * For example, to track the model ID of each event associated with content for querying
     * by mode, you can do
     *
     *    builder.setTrackingHook((event, context) => {
     *      if (context.content) {
     *        event.data.metadata.modelId = context.content.modelId
     *      }
     *    })
     */
    Builder.prototype.setTrackingHook = function (hook) {
        this.trackingHooks.push(hook);
    };
    Builder.prototype.track = function (eventName, properties, context) {
        if (properties === void 0) { properties = {}; }
        // TODO: queue up track requests and fire them off when canTrack set to true - otherwise may get lots of clicks with no impressions
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var apiKey = this.apiKey;
        if (!apiKey) {
            console.error('Builder integration error: Looks like the Builder SDK has not been initialized properly (your API key has not been set). Make sure you are calling `builder.init("«YOUR-API-KEY»");` as early as possible in your application\'s code.');
            return;
        }
        var eventData = JSON.parse(JSON.stringify({
            type: eventName,
            data: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, omit(properties, 'meta')), { metadata: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ sdkVersion: Builder.VERSION, url: location.href }, properties.meta), properties.metadata), ownerId: apiKey, userAttributes: this.getUserAttributes(), sessionId: this.sessionId, visitorId: this.visitorId }),
        }));
        for (var _i = 0, _a = this.trackingHooks; _i < _a.length; _i++) {
            var hook = _a[_i];
            var returnValue = hook(eventData, context || {});
            if (returnValue) {
                eventData = returnValue;
            }
        }
        // batch events
        this.eventsQueue.push(eventData);
        if (this.canTrack) {
            this.throttledClearEventsQueue();
        }
    };
    Builder.prototype.getSessionId = function () {
        var _this = this;
        var sessionId = null;
        try {
            if (Builder.isBrowser && typeof sessionStorage !== 'undefined') {
                sessionId = this.getCookie(sessionStorageKey);
            }
        }
        catch (err) {
            console.debug('Session storage error', err);
            // It's ok
        }
        if (!sessionId) {
            sessionId = uuid();
        }
        // Give the app a second to start up and set canTrack to false if needed
        if (Builder.isBrowser) {
            setTimeout(function () {
                try {
                    if (_this.canTrack) {
                        _this.setCookie(sessionStorageKey, sessionId, datePlusMinutes(30));
                    }
                }
                catch (err) {
                    console.debug('Cookie setting error', err);
                }
            });
        }
        return sessionId;
    };
    Builder.prototype.getVisitorId = function () {
        var _this = this;
        if (this.visitorId) {
            return this.visitorId;
        }
        var visitorId = null;
        try {
            if (Builder.isBrowser && typeof localStorage !== 'undefined') {
                // TODO: cookie instead?
                visitorId = localStorage.getItem(localStorageKey);
            }
        }
        catch (err) {
            console.debug('Local storage error', err);
            // It's ok
        }
        if (!visitorId) {
            visitorId = uuid();
        }
        this.visitorId = visitorId;
        // Give the app a second to start up and set canTrack to false if needed
        if (Builder.isBrowser) {
            setTimeout(function () {
                try {
                    if (_this.canTrack && typeof localStorage !== 'undefined' && visitorId) {
                        localStorage.setItem(localStorageKey, visitorId);
                    }
                }
                catch (err) {
                    console.debug('Session storage error', err);
                }
            });
        }
        return visitorId;
    };
    Builder.prototype.trackImpression = function (contentId, variationId, properties, context) {
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        // TODO: use this.track method
        this.track('impression', {
            contentId: contentId,
            variationId: variationId !== contentId ? variationId : undefined,
            metadata: properties,
        }, context);
    };
    Builder.prototype.trackConversion = function (amount, contentId, variationId, customProperties, context) {
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var meta = typeof contentId === 'object' ? contentId : customProperties;
        var useContentId = typeof contentId === 'string' ? contentId : undefined;
        this.track('conversion', { amount: amount, variationId: variationId, meta: meta, contentId: useContentId }, context);
    };
    Object.defineProperty(Builder.prototype, "isDevelopmentEnv", {
        // TODO: set this for QA
        get: function () {
            // Automatic determining of development environment
            return (Builder.isIframe ||
                (Builder.isBrowser && (location.hostname === 'localhost' || location.port !== '')) ||
                this.env !== 'production');
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.trackInteraction = function (contentId, variationId, alreadyTrackedOne, event, context) {
        if (alreadyTrackedOne === void 0) { alreadyTrackedOne = false; }
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var target = event && event.target;
        var targetBuilderElement = target && this.findBuilderParent(target);
        function round(num) {
            return Math.round(num * 1000) / 1000;
        }
        var metadata = {};
        if (event) {
            var clientX = event.clientX, clientY = event.clientY;
            if (target) {
                var targetRect = target.getBoundingClientRect();
                var xOffset = clientX - targetRect.left;
                var yOffset = clientY - targetRect.top;
                var xRatio = round(xOffset / targetRect.width);
                var yRatio = round(yOffset / targetRect.height);
                metadata.targetOffset = {
                    x: xRatio,
                    y: yRatio,
                };
            }
            if (targetBuilderElement) {
                var targetRect = targetBuilderElement.getBoundingClientRect();
                var xOffset = clientX - targetRect.left;
                var yOffset = clientY - targetRect.top;
                var xRatio = round(xOffset / targetRect.width);
                var yRatio = round(yOffset / targetRect.height);
                metadata.builderTargetOffset = {
                    x: xRatio,
                    y: yRatio,
                };
            }
        }
        var builderId = targetBuilderElement &&
            (targetBuilderElement.getAttribute('builder-id') || targetBuilderElement.id);
        if (builderId && targetBuilderElement) {
            metadata.builderElementIndex = [].slice
                .call(document.getElementsByClassName(builderId))
                .indexOf(targetBuilderElement);
        }
        this.track('click', {
            contentId: contentId,
            metadata: metadata,
            variationId: variationId !== contentId ? variationId : undefined,
            unique: !alreadyTrackedOne,
            targetBuilderElement: builderId || undefined,
        }, context);
    };
    Builder.prototype.component = function (info) {
        if (info === void 0) { info = {}; }
        return Builder.component(info);
    };
    Object.defineProperty(Builder.prototype, "apiKey", {
        get: function () {
            return this.apiKey$.value;
        },
        set: function (key) {
            this.apiKey$.next(key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "authToken", {
        get: function () {
            return this.authToken$.value;
        },
        set: function (token) {
            this.authToken$.next(token);
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.modifySearch = function (search) {
        return search.replace(/(^|&|\?)(builder_.*?)=/gi, function (_match, group1, group2) { return group1 + group2.replace(/_/g, '.') + '='; });
    };
    Builder.prototype.setTestsFromUrl = function () {
        var search = this.getLocation().search;
        var params = QueryString.parseDeep(this.modifySearch(search || '').substr(1));
        var tests = params.builder && params.builder.tests;
        if (tests && typeof tests === 'object') {
            for (var key in tests) {
                if (tests.hasOwnProperty(key)) {
                    this.setTestCookie(key, tests[key]);
                }
            }
        }
    };
    Builder.prototype.resetOverrides = function () {
        // Ugly - pass down instances per request instead using react context
        // or use builder.get('foo', { req, res }) in react...........
        Builder.overrideUserAttributes = {};
        this.cachebust = false;
        this.noCache = false;
        this.preview = false;
        this.editingModel = null;
        this.overrides = {};
        this.env = 'production';
        this.userAgent = '';
        this.request = undefined;
        this.response = undefined;
    };
    Builder.prototype.getOverridesFromQueryString = function () {
        var location = this.getLocation();
        var params = QueryString.parseDeep(this.modifySearch(location.search || '').substr(1));
        var builder = params.builder;
        if (builder) {
            var userAttributes = builder.userAttributes, overrides = builder.overrides, env = builder.env, host = builder.host, api = builder.api, cachebust = builder.cachebust, noCache = builder.noCache, preview = builder.preview, editing = builder.editing, frameEditing = builder.frameEditing, options = builder.options, overrideParams = builder.params;
            if (userAttributes) {
                this.setUserAttributes(userAttributes);
            }
            if (options) {
                // picking only locale and includeRefs
                this.queryOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (options.locale && { locale: options.locale })), (options.includeRefs && { includeRefs: options.includeRefs }));
            }
            if (overrides) {
                this.overrides = overrides;
            }
            if (validEnvList.indexOf(env || api) > -1) {
                this.env = env || api;
            }
            if (Builder.isEditing) {
                var editingModel = frameEditing || editing || preview;
                if (editingModel && editingModel !== 'true') {
                    this.editingModel = editingModel;
                }
            }
            if (cachebust) {
                this.cachebust = true;
            }
            if (noCache) {
                this.noCache = true;
            }
            if (preview) {
                this.preview = true;
            }
            if (params) {
                this.overrideParams = overrideParams;
            }
        }
    };
    Builder.prototype.messageFrameLoaded = function () {
        var _a;
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'builder.loaded',
            data: {
                value: true,
            },
        }, '*');
    };
    Builder.prototype.bindMessageListeners = function () {
        var _this = this;
        if (isBrowser) {
            addEventListener('message', function (event) {
                var _a, _b, _c, _d, _e;
                var url = parse$1(event.origin);
                var isRestricted = ['builder.register', 'builder.registerComponent'].indexOf((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === -1;
                var isTrusted = url.hostname && Builder.isTrustedHost(url.hostname);
                if (isRestricted && !isTrusted) {
                    return;
                }
                var data = event.data;
                if (data) {
                    switch (data.type) {
                        case 'builder.ping': {
                            (_b = window.parent) === null || _b === void 0 ? void 0 : _b.postMessage({
                                type: 'builder.pong',
                                data: {},
                            }, '*');
                            break;
                        }
                        case 'builder.register': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var options = data.data;
                            if (!options) {
                                break;
                            }
                            var type = options.type, info = options.info;
                            // TODO: all must have name and can't conflict?
                            var typeList = Builder.registry[type];
                            if (!typeList) {
                                typeList = Builder.registry[type] = [];
                            }
                            typeList.push(info);
                            Builder.registryChange.next(Builder.registry);
                            break;
                        }
                        case 'builder.settingsChange': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var settings = data.data;
                            if (!settings) {
                                break;
                            }
                            Object.assign(Builder.settings, settings);
                            Builder.settingsChange.next(Builder.settings);
                            break;
                        }
                        case 'builder.registerEditor': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var info_1 = data.data;
                            if (!info_1) {
                                break;
                            }
                            var hasComponent_1 = !!info_1.component;
                            Builder.editors.every(function (thisInfo, index) {
                                if (info_1.name === thisInfo.name) {
                                    if (thisInfo.component && !hasComponent_1) {
                                        return false;
                                    }
                                    else {
                                        Builder.editors[index] = thisInfo;
                                    }
                                    return false;
                                }
                                return true;
                            });
                            break;
                        }
                        case 'builder.triggerAnimation': {
                            Builder.animator.triggerAnimation(data.data);
                            break;
                        }
                        case 'builder.contentUpdate':
                            var key = data.data.key || data.data.alias || data.data.entry || data.data.modelName;
                            var contentData = data.data.data; // hmmm...
                            var observer = _this.observersByKey[key];
                            if (observer && !_this.noEditorUpdates[key]) {
                                observer.next([contentData]);
                            }
                            break;
                        case 'builder.getComponents':
                            (_c = window.parent) === null || _c === void 0 ? void 0 : _c.postMessage({
                                type: 'builder.components',
                                data: Builder.components.map(function (item) { return Builder.prepareComponentSpecToSend(item); }),
                            }, '*');
                            break;
                        case 'builder.editingModel':
                            _this.editingModel = data.data.model;
                            break;
                        case 'builder.registerComponent':
                            var componentData = data.data;
                            Builder.addComponent(componentData);
                            break;
                        case 'builder.blockContentLoading':
                            if (typeof data.data.model === 'string') {
                                _this.blockContentLoading = data.data.model;
                            }
                            break;
                        case 'builder.editingMode':
                            var editingMode = data.data;
                            if (editingMode) {
                                _this.editingMode = true;
                                document.body.classList.add('builder-editing');
                            }
                            else {
                                _this.editingMode = false;
                                document.body.classList.remove('builder-editing');
                            }
                            break;
                        case 'builder.editingPageMode':
                            var editingPageMode = data.data;
                            Builder.editingPage = editingPageMode;
                            break;
                        case 'builder.overrideUserAttributes':
                            var userAttributes = data.data;
                            assign(Builder.overrideUserAttributes, userAttributes);
                            _this.flushGetContentQueue(true);
                            // TODO: refetch too
                            break;
                        case 'builder.overrideTestGroup':
                            var _f = data.data, variationId = _f.variationId, contentId = _f.contentId;
                            if (variationId && contentId) {
                                _this.setTestCookie(contentId, variationId);
                                _this.flushGetContentQueue(true);
                            }
                            break;
                        case 'builder.evaluate': {
                            var text = data.data.text;
                            var args = data.data.arguments || [];
                            var id_1 = data.data.id;
                            // tslint:disable-next-line:no-function-constructor-with-string-args
                            var fn = new Function(text);
                            var result = void 0;
                            var error = null;
                            try {
                                result = fn.apply(_this, args);
                            }
                            catch (err) {
                                error = toError(err);
                            }
                            if (error) {
                                (_d = window.parent) === null || _d === void 0 ? void 0 : _d.postMessage({
                                    type: 'builder.evaluateError',
                                    data: { id: id_1, error: error.message },
                                }, '*');
                            }
                            else {
                                if (result && typeof result.then === 'function') {
                                    result
                                        .then(function (finalResult) {
                                        var _a;
                                        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                                            type: 'builder.evaluateResult',
                                            data: { id: id_1, result: finalResult },
                                        }, '*');
                                    })
                                        .catch(console.error);
                                }
                                else {
                                    (_e = window.parent) === null || _e === void 0 ? void 0 : _e.postMessage({
                                        type: 'builder.evaluateResult',
                                        data: { result: result, id: id_1 },
                                    }, '*');
                                }
                            }
                            break;
                        }
                    }
                }
            });
        }
    };
    Object.defineProperty(Builder.prototype, "defaultCanTrack", {
        get: function () {
            return Boolean(Builder.isBrowser &&
                navigator.userAgent.trim() &&
                !navigator.userAgent.match(/bot|crawler|spider|robot|crawling|prerender|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex|phantom|headless|selenium|puppeteer/i) &&
                !this.browserTrackingDisabled);
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.init = function (apiKey, canTrack, req, res, authToken, apiVersion) {
        if (canTrack === void 0) { canTrack = this.defaultCanTrack; }
        if (req) {
            this.request = req;
        }
        if (res) {
            this.response = res;
        }
        this.canTrack = canTrack;
        this.apiKey = apiKey;
        if (authToken) {
            this.authToken = authToken;
        }
        if (apiVersion) {
            this.apiVersion = apiVersion;
        }
        return this;
    };
    Object.defineProperty(Builder.prototype, "previewingModel", {
        get: function () {
            var search = this.getLocation().search;
            var params = QueryString.parse((search || '').substr(1));
            return params['builder.preview'];
        },
        enumerable: false,
        configurable: true
    });
    // TODO: allow adding location object as property and/or in constructor
    Builder.prototype.getLocation = function () {
        var _a;
        var parsedLocation = {};
        // in ssr mode
        if (this.request) {
            parsedLocation = parse$1((_a = this.request.url) !== null && _a !== void 0 ? _a : '');
        }
        else if (typeof location === 'object') {
            // in the browser
            parsedLocation = parse$1(location.href);
        }
        // IE11 bug with parsed path being empty string
        // causes issues with our user targeting
        if (parsedLocation.pathname === '') {
            parsedLocation.pathname = '/';
        }
        return parsedLocation;
    };
    Builder.prototype.getUserAttributes = function (userAgent) {
        if (userAgent === void 0) { userAgent = this.userAgent || ''; }
        var isMobile = {
            Android: function () {
                return userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return userAgent.match(/iPhone|iPod/i);
            },
            Opera: function () {
                return userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
            },
            any: function () {
                return (isMobile.Android() ||
                    isMobile.BlackBerry() ||
                    isMobile.iOS() ||
                    isMobile.Opera() ||
                    isMobile.Windows());
            },
        };
        var isTablet = userAgent.match(/Tablet|iPad/i);
        var url = this.getLocation();
        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ urlPath: url.pathname, host: url.host || url.hostname, 
            // TODO: maybe an option to choose to target off of mobile/tablet/desktop or just mobile/desktop
            device: isTablet ? 'tablet' : isMobile.any() ? 'mobile' : 'desktop' }, Builder.overrideUserAttributes);
    };
    Builder.prototype.setUserAttributes = function (options) {
        assign(Builder.overrideUserAttributes, options);
        this.userAttributesChanged.next(options);
    };
    /**
     * Set user attributes just for tracking purposes.
     *
     * Do this so properties exist on event objects for querying insights, but
     * won't affect targeting
     *
     * Use this when you want to track properties but don't need to target off
     * of them to optimize cache efficiency
     */
    Builder.prototype.setTrackingUserAttributes = function (attributes) {
        assign(this.trackingUserAttributes, attributes);
    };
    Builder.prototype.get = function (modelName, options) {
        if (options === void 0) { options = {}; }
        var instance = this;
        if (!Builder.isBrowser) {
            instance = new Builder(options.apiKey || this.apiKey, options.req, options.res, undefined, options.authToken || this.authToken, options.apiVersion || this.apiVersion);
            instance.setUserAttributes(this.getUserAttributes());
        }
        else {
            // NOTE: All these are when .init is not called and the customer
            // directly calls .get on the singleton instance of Builder
            if (options.apiKey && !this.apiKey) {
                this.apiKey = options.apiKey;
            }
            if (options.authToken && !this.authToken) {
                this.authToken = options.authToken;
            }
            if (options.apiVersion && !this.apiVersion) {
                this.apiVersion = options.apiVersion;
            }
        }
        return instance.queueGetContent(modelName, options).map(
        /* map( */ function (matches) {
            var match = matches && matches[0];
            if (Builder.isStatic) {
                return match;
            }
            var matchData = match && match.data;
            if (!matchData) {
                return null;
            }
            if (typeof matchData.blocksString !== 'undefined') {
                matchData.blocks = JSON.parse(matchData.blocksString);
                delete matchData.blocksString;
            }
            return {
                // TODO: add ab test info here and other high level stuff
                data: matchData,
                id: match.id,
                variationId: match.testVariationId || match.variationId || null,
                testVariationId: match.testVariationId || match.variationId || null,
                testVariationName: match.testVariationName || null,
                lastUpdated: match.lastUpdated || null,
            };
        });
        // );
    };
    // TODO: entry id in options
    Builder.prototype.queueGetContent = function (modelName, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        // TODO: if query do modelName + query
        var key = options.key ||
            options.alias ||
            // TODO: SDKs only pass entry key when given to them, and never when editing...
            // options.entry ||
            // TODO: this is ugly - instead of multiple of same model with different options are sent
            // say requires key/alias. Or if not perhaps make a reliable hash of the options and use that.
            // TODO: store last user state on last request and if user attributes different now
            // give a warning that need to use keys to request new contente
            // (options &&
            //   Object.keys(options).filter(key => key !== 'model').length &&
            //   JSON.stringify({ model: modelName, ...options, initialContent: undefined })) ||
            modelName;
        var isEditingThisModel = this.editingModel === modelName;
        // TODO: include params in this key........
        var currentObservable = this.observersByKey[key];
        // if (options.query && options.query._id) {
        //   this.flushGetContentQueue([options])
        // }
        if (this.apiKey === 'DEMO' && !this.overrides[key] && !options.initialContent) {
            options.initialContent = [];
        }
        var initialContent = options.initialContent;
        // TODO: refresh option in options
        if (currentObservable && (!currentObservable.value || options.cache)) {
            // TODO: test if this ran, otherwise on 404 some observers may never be called...
            if (currentObservable.value) {
                nextTick(function () {
                    // TODO: return a new observable and only that one fires subscribers, don't refire for existing ones
                    currentObservable.next(currentObservable.value);
                });
            }
            return currentObservable;
        }
        if (isEditingThisModel) {
            if (Builder.isBrowser) {
                parent.postMessage({ type: 'builder.updateContent', data: { options: options } }, '*');
            }
        }
        if (!initialContent /* || isEditingThisModel */) {
            if (!this.getContentQueue) {
                this.getContentQueue = [];
            }
            this.getContentQueue.push((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, options), { model: modelName, key: key }));
            if (this.getContentQueue && this.getContentQueue.length >= this.contentPerRequest) {
                var queue_1 = this.getContentQueue.slice();
                this.getContentQueue = [];
                nextTick(function () {
                    _this.flushGetContentQueue(false, queue_1);
                });
            }
            else {
                nextTick(function () {
                    _this.flushGetContentQueue();
                });
            }
        }
        var observable = new BehaviorSubject(null);
        this.observersByKey[key] = observable;
        if (options.noEditorUpdates) {
            this.noEditorUpdates[key] = true;
        }
        if (initialContent) {
            nextTick(function () {
                // TODO: need to testModify this I think...?
                observable.next(initialContent);
            });
        }
        return observable;
    };
    // this is needed to satisfy the Angular SDK, which used to rely on the more complex version of `requestUrl`.
    // even though we only use `fetch()` now, we prefer to keep the old behavior and use the `fetch` that comes from
    // the core SDK for consistency
    Builder.prototype.requestUrl = function (url, options) {
        return getFetch()(url, options).then(function (res) { return res.json(); });
    };
    Object.defineProperty(Builder.prototype, "host", {
        get: function () {
            switch (this.env) {
                case 'qa':
                    return 'https://qa.builder.io';
                case 'test':
                    return 'https://builder-io-test.web.app';
                case 'fast':
                    return 'https://fast.builder.io';
                case 'cloud':
                    return 'https://cloud.builder.io';
                case 'cdn2':
                    return 'https://cdn2.builder.io';
                case 'cdn-qa':
                    return 'https://cdn-qa.builder.io';
                case 'development':
                case 'dev':
                    return 'http://localhost:5000';
                case 'cdn-prod':
                    return 'https://cdn.builder.io';
                default:
                    return Builder.overrideHost || 'https://cdn.builder.io';
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.flushGetContentQueue = function (usePastQueue, useQueue) {
        var _this = this;
        if (usePastQueue === void 0) { usePastQueue = false; }
        if (!this.apiKey) {
            throw new Error("Fetching content failed, expected apiKey to be defined instead got: ".concat(this.apiKey));
        }
        if (this.apiVersion) {
            if (!['v1', 'v3'].includes(this.apiVersion)) {
                throw new Error("Invalid apiVersion: expected 'v1' or 'v3', received '".concat(this.apiVersion, "'"));
            }
        }
        else {
            this.apiVersion = DEFAULT_API_VERSION;
        }
        if (!usePastQueue && !this.getContentQueue) {
            return;
        }
        var queue = useQueue || (usePastQueue ? this.priorContentQueue : this.getContentQueue) || [];
        // TODO: do this on every request send?
        this.getOverridesFromQueryString();
        var queryParams = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ 
            // TODO: way to force a request to be in a separate queue. or just lower queue limit to be 1 by default
            omit: queue[0].omit || 'meta.componentsUsed', apiKey: this.apiKey }, queue[0].options), this.queryOptions);
        if (queue[0].fields) {
            queryParams.fields = queue[0].fields;
        }
        if (queue[0].format) {
            queryParams.format = queue[0].format;
        }
        var pageQueryParams = typeof location !== 'undefined'
            ? QueryString.parseDeep(location.search.substr(1))
            :  false || {};
        var userAttributes = 
        // FIXME: HACK: only checks first in queue for user attributes overrides, should check all
        // TODO: merge user attributes provided here with defaults and current user attiributes (?)
        queue && queue[0].userAttributes
            ? queue[0].userAttributes
            : this.targetContent
                ? this.getUserAttributes()
                : {
                    urlPath: this.getLocation().pathname,
                };
        var fullUrlQueueItem = queue.find(function (item) { return !!item.includeUrl; });
        if (fullUrlQueueItem) {
            var location_1 = this.getLocation();
            if (location_1.origin) {
                queryParams.url = "".concat(location_1.origin).concat(location_1.pathname).concat(location_1.search);
            }
        }
        var urlQueueItem = useQueue === null || useQueue === void 0 ? void 0 : useQueue.find(function (item) { return item.url; });
        if (urlQueueItem === null || urlQueueItem === void 0 ? void 0 : urlQueueItem.url) {
            userAttributes.urlPath = urlQueueItem.url.split('?')[0];
        }
        // TODO: merge in the attribute from query string ones
        // TODO: make this an option per component/request
        queryParams.userAttributes = userAttributes;
        if (!usePastQueue && !useQueue) {
            this.priorContentQueue = queue;
            this.getContentQueue = null;
        }
        var cachebust = this.cachebust ||
            isIframe ||
            pageQueryParams.cachebust ||
            pageQueryParams['builder.cachebust'];
        if (cachebust || this.env !== 'production') {
            queryParams.cachebust = true;
        }
        if (Builder.isEditing) {
            queryParams.isEditing = true;
        }
        if (this.noCache || this.env !== 'production') {
            queryParams.noCache = true;
        }
        if (size(this.overrides)) {
            for (var key in this.overrides) {
                if (this.overrides.hasOwnProperty(key)) {
                    queryParams["overrides.".concat(key)] = this.overrides[key];
                }
            }
        }
        if (!Builder.isReact) {
            // TODO: remove me once v1 page editors converted to v2
            // queryParams.extractCss = true;
            queryParams.prerender = true;
        }
        for (var _i = 0, queue_2 = queue; _i < queue_2.length; _i++) {
            var options = queue_2[_i];
            if (options.format) {
                queryParams.format = options.format;
            }
            // TODO: remove me and make permodel
            if (options.static) {
                queryParams.static = options.static;
            }
            if (options.cachebust) {
                queryParams.cachebust = options.cachebust;
            }
            if (isPositiveNumber(options.cacheSeconds)) {
                queryParams.cacheSeconds = options.cacheSeconds;
            }
            if (isPositiveNumber(options.staleCacheSeconds)) {
                queryParams.staleCacheSeconds = options.staleCacheSeconds;
            }
            var properties = [
                'prerender',
                'extractCss',
                'limit',
                'offset',
                'query',
                'preview',
                'model',
                'entry',
                'rev',
                'static',
            ];
            for (var _a = 0, properties_1 = properties; _a < properties_1.length; _a++) {
                var key = properties_1[_a];
                var value = options[key];
                if (value !== undefined) {
                    queryParams.options = queryParams.options || {};
                    queryParams.options[options.key] = queryParams.options[options.key] || {};
                    queryParams.options[options.key][key] = JSON.stringify(value);
                }
            }
        }
        if (this.preview) {
            queryParams.preview = 'true';
        }
        var hasParams = Object.keys(queryParams).length > 0;
        // TODO: option to force dev or qa api here
        var host = this.host;
        var keyNames = queue.map(function (item) { return encodeURIComponent(item.key); }).join(',');
        if (this.overrideParams) {
            var params = omit(QueryString.parse(this.overrideParams), 'apiKey');
            assign(queryParams, params);
        }
        var queryStr = QueryString.stringifyDeep(queryParams);
        var format = queryParams.format;
        var requestOptions = { headers: {} };
        if (this.authToken) {
            requestOptions.headers = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, requestOptions.headers), { Authorization: "Bearer ".concat(this.authToken) });
        }
        var fn = format === 'solid' || format === 'react' ? 'codegen' : 'query';
        // NOTE: this is a hack to get around the fact that the codegen endpoint is not yet available in v3
        var apiVersionBasedOnFn = fn === 'query' ? this.apiVersion : 'v1';
        var url = "".concat(host, "/api/").concat(apiVersionBasedOnFn, "/").concat(fn, "/").concat(this.apiKey, "/").concat(keyNames) +
            (queryParams && hasParams ? "?".concat(queryStr) : '');
        var promise = getFetch()(url, requestOptions)
            .then(function (res) { return res.json(); })
            .then(function (result) {
            for (var _i = 0, queue_3 = queue; _i < queue_3.length; _i++) {
                var options = queue_3[_i];
                var keyName = options.key;
                if (options.model === _this.blockContentLoading && !options.noEditorUpdates) {
                    continue;
                }
                var isEditingThisModel = _this.editingModel === options.model;
                if (isEditingThisModel && Builder.isEditing) {
                    parent.postMessage({ type: 'builder.updateContent', data: { options: options } }, '*');
                    // return;
                }
                var observer = _this.observersByKey[keyName];
                if (!observer) {
                    return;
                }
                var data = result[keyName];
                var sorted = data; // sortBy(data, item => item.priority);
                if (data) {
                    var testModifiedResults = Builder.isServer
                        ? sorted
                        : _this.processResultsForTests(sorted);
                    observer.next(testModifiedResults);
                }
                else {
                    var search = _this.getLocation().search;
                    if ((search || '').includes('builder.preview=' + options.model)) {
                        var previewData = {
                            id: 'preview',
                            name: 'Preview',
                            data: {},
                        };
                        observer.next([previewData]);
                    }
                    observer.next([]);
                }
            }
        }, function (err) {
            for (var _i = 0, queue_4 = queue; _i < queue_4.length; _i++) {
                var options = queue_4[_i];
                var observer = _this.observersByKey[options.key];
                if (!observer) {
                    return;
                }
                observer.error(err);
            }
        });
        return promise;
    };
    Builder.prototype.processResultsForTests = function (results) {
        var _this = this;
        var _a;
        var mappedResults = results.map(function (item) {
            if (!item.variations) {
                return item;
            }
            var cookieValue = _this.getTestCookie(item.id);
            var cookieVariation = cookieValue === item.id ? item : item.variations[cookieValue];
            if (cookieVariation) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { data: cookieVariation.data, variationId: cookieValue, testVariationId: cookieValue, testVariationName: cookieVariation.name });
            }
            if (_this.canTrack && item.variations && size(item.variations)) {
                var n = 0;
                var random = Math.random();
                for (var id in item.variations) {
                    var variation = item.variations[id];
                    var testRatio = variation.testRatio;
                    n += testRatio;
                    if (random < n) {
                        _this.setTestCookie(item.id, variation.id);
                        var variationName = variation.name || (variation.id === item.id ? 'Default variation' : '');
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { data: variation.data, variationId: variation.id, testVariationId: variation.id, variationName: variationName, testVariationName: variationName });
                    }
                }
                _this.setTestCookie(item.id, item.id);
            }
            return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { variationId: item.id }), (item.variations &&
                size(item.variations) && {
                testVariationId: item.id,
                testVariationName: 'Default variation',
            }));
        });
        if (isIframe) {
            (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'builder.contentResults', data: { results: mappedResults } }, '*');
        }
        return mappedResults;
    };
    Builder.prototype.getTestCookie = function (contentId) {
        return this.getCookie("".concat(this.testCookiePrefix, ".").concat(contentId));
    };
    Builder.prototype.setTestCookie = function (contentId, variationId) {
        if (!this.canTrack) {
            this.cookieQueue.push([contentId, variationId]);
            return;
        }
        // 30 days from now
        var future = new Date();
        future.setDate(future.getDate() + 30);
        return this.setCookie("".concat(this.testCookiePrefix, ".").concat(contentId), variationId, future);
    };
    Builder.prototype.getCookie = function (name$$1) {
        if (this.cookies) {
            return this.cookies.get(name$$1);
        }
        return Builder.isBrowser && getCookie(name$$1);
    };
    Builder.prototype.setCookie = function (name$$1, value, expires) {
        if (this.cookies && !(Builder.isServer && Builder.isStatic)) {
            return this.cookies.set(name$$1, value, {
                expires: expires,
                secure: this.getLocation().protocol === 'https:',
            });
        }
        return Builder.isBrowser && setCookie(name$$1, value, expires);
    };
    Builder.prototype.getContent = function (modelName, options) {
        if (options === void 0) { options = {}; }
        if (!this.apiKey) {
            throw new Error("Fetching content from model ".concat(modelName, " failed, expected apiKey to be defined instead got: ").concat(this.apiKey));
        }
        return this.queueGetContent(modelName, options);
    };
    Builder.prototype.getAll = function (modelName, options) {
        if (options === void 0) { options = {}; }
        var instance = this;
        if (!Builder.isBrowser) {
            instance = new Builder(options.apiKey || this.apiKey, options.req, options.res, false, null, options.apiVersion);
            instance.setUserAttributes(this.getUserAttributes());
        }
        else {
            // NOTE: All these are when .init is not called and the customer
            // directly calls .get on the singleton instance of Builder
            if (options.apiKey && !this.apiKey) {
                this.apiKey = options.apiKey;
            }
            if (options.apiVersion && !this.apiVersion) {
                this.apiVersion = options.apiVersion;
            }
        }
        return instance
            .getContent(modelName, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ limit: 30 }, options), { key: options.key ||
                // Make the key include all options, so we don't reuse cache for the same content fetched
                // with different options
                Builder.isBrowser
                ? "".concat(modelName, ":").concat(hash_sum__WEBPACK_IMPORTED_MODULE_0___default()(omit(options, 'initialContent', 'req', 'res')))
                : undefined }))
            .promise();
    };
    /**
     * @hidden
     * @deprecated. This is buggy, and always behind by a version.
     */
    Builder.VERSION = version;
    Builder.components = [];
    /**
     * Makes it so that a/b tests generate code like {@link
     * https://www.builder.io/blog/high-performance-no-code#__next:~:text=Static%20generated%20A%2FB%20testing}
     * instead of the old way where we render only one test group at a time on the
     * server. This is the preferred/better way not and we should ultimately make it
     * the default
     */
    Builder.isStatic = true;
    Builder.animator = new Animator();
    Builder.nextTick = nextTick;
    Builder.throttle = throttle;
    Builder.editors = [];
    Builder.trustedHosts = ['builder.io', 'localhost'];
    Builder.plugins = [];
    Builder.actions = [];
    Builder.registry = {};
    Builder.registryChange = new BehaviorSubject({});
    Builder._editingPage = false;
    Builder.isIframe = isIframe;
    Builder.isBrowser = isBrowser;
    Builder.isReactNative = isReactNative;
    Builder.isServer = !isBrowser && !isReactNative;
    Builder.previewingModel = Builder.isBrowser && getQueryParam(location.href, 'builder.preview');
    Builder.settings = {};
    Builder.settingsChange = new BehaviorSubject({});
    // TODO: this is quick and dirty, do better implementation later. Also can be unreliable
    // if page 301s etc. Use a query param instead? also could have issues with redirects. Injecting var could
    // work but is async...
    Builder.isEditing = Boolean(isIframe &&
        ((document.referrer && document.referrer.match(/builder\.io|localhost:1234/)) ||
            location.search.indexOf('builder.frameEditing=') !== -1));
    Builder.isPreviewing = Boolean(isBrowser &&
        (location.search.indexOf('builder.preview=') !== -1 ||
            location.search.indexOf('builder.frameEditing=') !== -1));
    Builder.isReact = false;
    Builder.overrideUserAttributes = {};
    return Builder;
}());

var builder = new Builder(null, undefined, undefined, true);
Builder.singletonInstance = builder;


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 74859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __extends, __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 98917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 39503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ms": function() { return /* binding */ ClassNames; },
  "xB": function() { return /* binding */ Global; },
  "iv": function() { return /* reexport */ css_browser_esm; },
  "tZ": function() { return /* binding */ jsx; }
});

// UNUSED EXPORTS: CacheProvider, ThemeContext, createElement, keyframes, withEmotionCache

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(32222);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/core/node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ../../node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(3369);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = (0,memoize_browser_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/emotion-element-57a3a7a3.browser.esm.js






var emotion_element_57a3a7a3_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ../../node_modules/@emotion/css/dist/css.browser.esm.js


function css_browser_esm_css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css_browser_esm_css);

;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),

/***/ 3369:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 66330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Emotion; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwnProperty; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports C, _, a, b, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98917);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81060);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40161);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82668);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  var rules = (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, newProps));
});

if (false) {}




/***/ }),

/***/ 28165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98917);
/* harmony import */ var _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66330);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81060);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40161);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82668);












var pkg = {
	name: "@emotion/react",
	version: "11.10.5",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.5",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.5",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.5",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)([styles], undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 40161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 81060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 47925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_styled_browser_esm; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(3369);
;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js
var emotion_element_6a883da9_browser_esm = __webpack_require__(66330);
;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/serialize/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = emotion_is_prop_valid_browser_esm;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var emotion_styled_base_browser_esm_ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_6a883da9_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_6a883da9_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/(0,react.createElement)(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js








var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);


/***/ }),

/***/ 82668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 92642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureEvent, captureMessage, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 66465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90063);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4266);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51877);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48364);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (event.type !== 'transaction') {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 51877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97946);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90063);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48364);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts = { ...this._contexts, [key]: context };
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 48364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21995);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 78900:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(66465);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(58536);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(4266);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(64005);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(92517);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(40564);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(18235);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 40564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ DEFAULT_HEARTBEAT_INTERVAL; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28207);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18235);




const DEFAULT_IDLE_TIMEOUT = 1000;
const DEFAULT_FINAL_TIMEOUT = 30000;
const DEFAULT_HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
      _heartbeatInterval = DEFAULT_HEARTBEAT_INTERVAL,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter += 1;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 28207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12885);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21995);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 18235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12885);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66465);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21995);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28207);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);;

    this._hub = hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
      changes: [],
      propagations: 0,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    // `source` could change without the name changing if we discover that an unparameterized route is actually
    // parameterized by virtue of having no parameters in its path
    if (name !== this.name || source !== this.metadata.source) {
      this.metadata.changes.push({
        // log previous source
        source: this.metadata.source,
        timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)(),
        propagations: this.metadata.propagations,
      });
    }

    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      const client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
          changes: metadata.changes,
          propagations: metadata.propagations,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      environment,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 92517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 54194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const MAX_OUTPUT_LEN = 80;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;

    // eslint-disable-next-line no-plusplus
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 12885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 64005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81757);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58536);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21995);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69038);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49798);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);







// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in WINDOW)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in WINDOW.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  const oldOnPopState = WINDOW.onpopstate;
  WINDOW.onpopstate = function ( ...args) {
    const to = WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount += 1;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount -= 1;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = WINDOW.onerror;

  WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW.onunhandledrejection;

  WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 81757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 58536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21995);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  const lineno = frame.lineno || 0;
  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 4266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34406);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 21995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54194);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39660);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 69038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];

    for (const line of stack.split('\n').slice(skipFirst)) {
      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        // eslint-disable-next-line no-plusplus
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 39660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if (typeof pattern === 'string') {
    return value.indexOf(pattern) !== -1;
  }
  return false;
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 49798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58536);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 97946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 7790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 90063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 38229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
/* unused harmony export default */
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}


//# sourceMappingURL=equality.esm.js.map


/***/ }),

/***/ 22193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var useCurrentAccountId_1 = __webpack_require__(32456);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useCurrentAccountId_1.useCurrentAccountId; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useCurrentAccountId_1.CurrentAccountIdProvider; } });
var useSessionStorage_1 = __webpack_require__(21910);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useSessionStorage_1.useSessionStorage; } });
var useLocalStorage_1 = __webpack_require__(32559);
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return useLocalStorage_1.useLocalStorage; } }));
var usePrevious_1 = __webpack_require__(99375);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return usePrevious_1.usePrevious; } });
var useFirstEvent_1 = __webpack_require__(10841);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useFirstEvent_1.useFirstEvent; } });
var useLink_1 = __webpack_require__(76209);
Object.defineProperty(exports, "nB", ({ enumerable: true, get: function () { return useLink_1.useLink; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useLink_1.LinkProvider; } });
var useTrackPropChanges_1 = __webpack_require__(55453);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useTrackPropChanges_1.useTrackPropChanges; } });


/***/ }),

/***/ 32456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useCurrentAccountId_1 = __webpack_require__(98671);
Object.defineProperty(exports, "useCurrentAccountId", ({ enumerable: true, get: function () { return useCurrentAccountId_1.useCurrentAccountId; } }));
Object.defineProperty(exports, "CurrentAccountIdProvider", ({ enumerable: true, get: function () { return useCurrentAccountId_1.CurrentAccountIdProvider; } }));


/***/ }),

/***/ 98671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CurrentAccountIdProvider = exports.useCurrentAccountId = void 0;
const react_1 = __importStar(__webpack_require__(2784));
const useLocalStorage_1 = __webpack_require__(32559);
const CurrentAccountIdContext = react_1.createContext(undefined);
exports.useCurrentAccountId = () => react_1.useContext(CurrentAccountIdContext);
exports.CurrentAccountIdProvider = (props) => {
    const [currentAccountId, setCurrentAccountId] = useLocalStorage_1.useLocalStorage('currentAccountId');
    react_1.useEffect(() => {
        if (props.currentAccountId && currentAccountId !== props.currentAccountId) {
            setCurrentAccountId(props.currentAccountId);
        }
    }, [props.currentAccountId, currentAccountId, setCurrentAccountId]);
    return (react_1.default.createElement(CurrentAccountIdContext.Provider, { value: currentAccountId }, props.children));
};


/***/ }),

/***/ 10841:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useFirstEvent_1 = __webpack_require__(21865);
Object.defineProperty(exports, "useFirstEvent", ({ enumerable: true, get: function () { return useFirstEvent_1.default; } }));


/***/ }),

/***/ 21865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(2784);
// Given an array of event names, fires the callback the first time that
// any of the events are called on the ref'd element.
// After the callback has been called once, it will never be called again
// for the lifetime of the component.
const useFirstEvent = (events, onFirstEvent) => {
    const [wasFired, setWasFired] = react_1.useState(false);
    const [element, setElement] = react_1.useState(null);
    // A callback ref is used instead of a useRef hook so that
    // setElement() can be called when the ref changes.
    // This allows the useEffect cleanup function to be called
    // to remove event listeners for an element that may no longer exist.
    const callbackRef = react_1.useCallback(el => setElement(el), []);
    // If a ref'd element exists, attach listeners for each event.
    // Remove those listeners if the events, callback, or element change.
    react_1.useEffect(() => {
        if (element && !wasFired) {
            let onEvent = () => { }; // required by typescript
            const removeListeners = () => 
            // @ts-ignore despite the truthy conditional, typescript still thinks `element` can be null
            events.forEach(event => element.removeEventListener(event, onEvent));
            onEvent = () => {
                if (!wasFired) {
                    setWasFired(true);
                    onFirstEvent();
                    removeListeners();
                }
            };
            // @ts-ignore despite the truthy conditional, typescript still thinks `element` can be null
            events.forEach(event => element.addEventListener(event, onEvent));
            return removeListeners;
        }
        return () => { }; // required by linter
    }, [element, events, onFirstEvent, wasFired]);
    // Return the callback ref so that it may be set as the `ref` prop on an element.
    return callbackRef;
};
exports["default"] = useFirstEvent;


/***/ }),

/***/ 76209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useLink_1 = __webpack_require__(28649);
Object.defineProperty(exports, "LinkProvider", ({ enumerable: true, get: function () { return useLink_1.LinkProvider; } }));
Object.defineProperty(exports, "useLink", ({ enumerable: true, get: function () { return useLink_1.useLink; } }));


/***/ }),

/***/ 28649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkProvider = exports.useLink = void 0;
const react_1 = __importDefault(__webpack_require__(2784));
const defaultContext = {
    routeTo: null,
};
const LinkContext = react_1.default.createContext(defaultContext);
exports.useLink = () => react_1.default.useContext(LinkContext);
/**
 * React context that provides the `routeTo` function to `Link`
 * components to be able to do client side routing when needed
 */
exports.LinkProvider = ({ children, routeTo }) => {
    return children ? (react_1.default.createElement(LinkContext.Provider, { value: { routeTo } }, react_1.default.Children.only(children))) : null;
};


/***/ }),

/***/ 32559:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useLocalStorage_1 = __webpack_require__(48984);
Object.defineProperty(exports, "useLocalStorage", ({ enumerable: true, get: function () { return useLocalStorage_1.default; } }));


/***/ }),

/***/ 48984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const lodash_1 = __webpack_require__(76635);
const react_1 = __webpack_require__(2784);
const utils_1 = __webpack_require__(96570);
const parseReadValue = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        console.warn(`Could not parse value read from localStorage.`);
    }
    return value;
};
const readValue = (key) => {
    if (utils_1.isBrowser()) {
        try {
            return window.localStorage.getItem(key);
        }
        catch (e) {
            console.warn(`Could not read "${key}" from localStorage.`);
        }
    }
    return undefined;
};
const stringifyWriteValue = (value) => {
    try {
        return value && lodash_1.isObject(value) ? JSON.stringify(value) : value;
    }
    catch (e) {
        console.warn(`Could not stringify value before writing it to localStorage.`);
    }
    return value;
};
const writeValue = (key, value) => {
    if (utils_1.isBrowser()) {
        try {
            window.localStorage.setItem(key, value);
        }
        catch (e) {
            console.warn(`Could not write "${key}" to localStorage.`);
        }
    }
};
const useLocalStorage = (key) => {
    // Use `useState` to prevent `localStorage` from being
    // accessed on every rerun of this hook.
    const [value, setValue] = react_1.useState(() => {
        const rawValue = readValue(key);
        return rawValue ? parseReadValue(rawValue) : rawValue;
    });
    react_1.useEffect(() => {
        const rawValue = readValue(key);
        setValue(rawValue ? parseReadValue(rawValue) : rawValue);
    }, [key]);
    react_1.useEffect(() => {
        const stringifiedValue = stringifyWriteValue(value);
        writeValue(key, stringifiedValue);
    }, [key, value]);
    return [value, setValue];
};
exports["default"] = useLocalStorage;


/***/ }),

/***/ 99375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var usePrevious_1 = __webpack_require__(29871);
Object.defineProperty(exports, "usePrevious", ({ enumerable: true, get: function () { return usePrevious_1.default; } }));


/***/ }),

/***/ 29871:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(2784);
const usePrevious = (value) => {
    const ref = react_1.useRef();
    react_1.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};
exports["default"] = usePrevious;


/***/ }),

/***/ 21910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useSessionStorage_1 = __webpack_require__(54526);
Object.defineProperty(exports, "useSessionStorage", ({ enumerable: true, get: function () { return useSessionStorage_1.default; } }));


/***/ }),

/***/ 54526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const lodash_1 = __webpack_require__(76635);
const react_1 = __webpack_require__(2784);
const utils_1 = __webpack_require__(96570);
const parseReadValue = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        console.warn(`Could not parse value read from sessionStorage.`, e);
    }
    return value;
};
const readValue = (key) => {
    if (utils_1.isBrowser()) {
        try {
            return window.sessionStorage.getItem(key);
        }
        catch (e) {
            console.warn(`Could not read "${key}" from sessionStorage.`, e);
        }
    }
    return undefined;
};
const stringifyWriteValue = (value) => {
    try {
        return value && lodash_1.isObject(value) ? JSON.stringify(value) : value;
    }
    catch (e) {
        console.warn(`Could not stringify value before writing it to sessionStorage.`, e);
    }
    return value;
};
const writeValue = (key, value) => {
    if (utils_1.isBrowser()) {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (e) {
            console.warn(`Could not write "${key}" to sessionStorage.`, e);
        }
    }
};
const useSessionStorage = (key) => {
    // Use `useState` to prevent `sessionStorage` from being
    // accessed on every rerun of this hook.
    const [value, setValue] = react_1.useState(() => {
        const rawValue = readValue(key);
        return rawValue ? parseReadValue(rawValue) : rawValue;
    });
    react_1.useEffect(() => {
        const rawValue = readValue(key);
        setValue(rawValue ? parseReadValue(rawValue) : rawValue);
    }, [key]);
    react_1.useEffect(() => {
        const stringifiedValue = stringifyWriteValue(value);
        writeValue(key, stringifiedValue);
    }, [key, value]);
    return [value, setValue];
};
exports["default"] = useSessionStorage;


/***/ }),

/***/ 55453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var useTrackPropChanges_1 = __webpack_require__(48736);
Object.defineProperty(exports, "useTrackPropChanges", ({ enumerable: true, get: function () { return useTrackPropChanges_1.default; } }));


/***/ }),

/***/ 48736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(2784);
const lodash_1 = __webpack_require__(76635);
function getInitialChangesValue(propsToTrack) {
    return lodash_1.reduce(propsToTrack, (result, value, key) => {
        result[key] = {
            initialValue: value,
            currentValue: value,
            wasChanged: false,
        };
        return result;
    }, {});
}
/**
  Tracks changes made to props passed to a component. When the component unmounts
  (or when you change the `onTrackChanges` callback), the `onTrackChanges` callback
  will be called with a set of changes objects describing what changed:

  ```
    {
      firstName: {
        initialValue: 'mary',
        currentValue: 'sally',
        wasChanged: true,
      },
      lastName: {
        initialValue: 'smith',
        currentValue: 'smith',
        wasChanged: smith,
      }
    }
  ```

  The `wasChanged` prop helps distinguish when a prop was changed but then changed
  back to its original value. In that case `initialValue` and `currentValue` will be
  the same, but `wasChanged` will be `true`.
*/
function useTrackPropChanges({ onTrackChanges, propsToTrack, }) {
    const changesRef = react_1.useRef(getInitialChangesValue(propsToTrack));
    react_1.useEffect(() => {
        lodash_1.each(propsToTrack, (value, key) => {
            const change = changesRef.current[key];
            if (change.currentValue !== value) {
                changesRef.current[key] = {
                    initialValue: change.initialValue,
                    currentValue: value,
                    wasChanged: true,
                };
            }
        });
    }, [propsToTrack]);
    react_1.useEffect(() => () => onTrackChanges(changesRef.current), [onTrackChanges]);
}
exports["default"] = useTrackPropChanges;


/***/ }),

/***/ 96570:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isBrowser = void 0;
exports.isBrowser = () => typeof window !== 'undefined';


/***/ }),

/***/ 3269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ readCookieCategories; },
/* harmony export */   "Lx": function() { return /* binding */ canWriteCookieCategory; }
/* harmony export */ });
/* unused harmony export getActiveCategoryCodes */
/* harmony import */ var _readCookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59251);

const categoryCodes = ['C0001', 'C0002', 'C0004'];
const categoryNameToCodeMap = {
    essential: 'C0001',
    analytics: 'C0002',
    marketing: 'C0004',
};
const categoryCodeToNameMap = Object.entries(categoryNameToCodeMap).reduce((accum, entry) => {
    const name = entry[0];
    const code = entry[1];
    accum[code] = name;
    return accum;
}, {});
const readCookieCategoriesFromCookie = () => {
    const optanonConsent = (0,_readCookie__WEBPACK_IMPORTED_MODULE_0__/* .readCookie */ .v)('OptanonConsent');
    const groups = new URLSearchParams(optanonConsent).get('groups') || '';
    const activeCodes = groups
        .split(',')
        .map((group) => group.split(':'))
        .filter(([groupCode]) => !!groupCode)
        .filter(([, isConsented]) => isConsented === '1')
        .map(([groupCode]) => groupCode);
    return activeCodes;
};
const getActiveCategoryCodes = () => {
    const activeGroups = (typeof window !== 'undefined' ? window.OnetrustActiveGroups : '') || '';
    const liveActiveCodes = activeGroups.split(/\s*,\s*/).filter(Boolean);
    const activeCodes = liveActiveCodes.length > 0
        ? liveActiveCodes
        : readCookieCategoriesFromCookie();
    return [...new Set(['C0001', ...activeCodes])].sort();
};
const readCookieCategories = () => {
    const activeCodes = getActiveCategoryCodes();
    const byCode = categoryCodes.reduce((accum, catCode) => {
        accum[catCode] = activeCodes.includes(catCode);
        return accum;
    }, {});
    const byName = Object.entries(byCode).reduce((accum, [categoryCode, isActive]) => {
        const categoryName = categoryCodeToNameMap[categoryCode];
        accum[categoryName] = isActive;
        return accum;
    }, {});
    return { byCode, byName };
};
const canWriteCookieCategory = (category) => {
    if (category === 'essential') {
        return true;
    }
    const cookieCategories = readCookieCategories();
    return !!cookieCategories.byName[category];
};
//# sourceMappingURL=categories.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)


/***/ }),

/***/ 65334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "canWriteCookieCategory": function() { return /* reexport */ categories/* canWriteCookieCategory */.Lx; },
  "readCookie": function() { return /* reexport */ readCookie/* readCookie */.v; },
  "readCookieCategories": function() { return /* reexport */ categories/* readCookieCategories */.DN; },
  "readCookies": function() { return /* reexport */ readCookie/* readCookies */.n; },
  "useCookie": function() { return /* reexport */ useCookie; },
  "useCookieConsent": function() { return /* reexport */ useCookieConsent/* useCookieConsent */.Y; },
  "writeCookie": function() { return /* reexport */ writeCookie/* writeCookie */.w; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/readCookie.js
var readCookie = __webpack_require__(59251);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/writeCookie.js
var writeCookie = __webpack_require__(26791);
;// CONCATENATED MODULE: ../../node_modules/@zapier/cookies/esm/useCookie.js



const useCookie = (name) => {
    const [value, setValue] = (0,react.useState)(() => {
        return (0,readCookie/* readCookie */.v)(name);
    });
    const setCookie = (newValue, options) => {
        const didWrite = (0,writeCookie/* writeCookie */.w)(name, newValue, options);
        if (didWrite !== false) {
            setValue(newValue);
        }
    };
    (0,react.useEffect)(() => {
        setValue((0,readCookie/* readCookie */.v)(name));
    }, [name]);
    return [value, setCookie];
};
//# sourceMappingURL=useCookie.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)

// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/useCookieConsent.js
var useCookieConsent = __webpack_require__(7727);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/categories.js
var categories = __webpack_require__(3269);
;// CONCATENATED MODULE: ../../node_modules/@zapier/cookies/esm/index.js





//# sourceMappingURL=index.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)


/***/ }),

/***/ 59251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ readCookies; },
/* harmony export */   "v": function() { return /* binding */ readCookie; }
/* harmony export */ });
const readCookies = () => {
    if (typeof document === 'undefined') {
        return {};
    }
    try {
        return (document.cookie || '')
            .split(/;[\s]*/)
            .reduce((accum, cookie) => {
            const indexOfFirstEq = cookie.indexOf('=');
            const cName = cookie.slice(0, indexOfFirstEq);
            const cValue = cookie.slice(indexOfFirstEq + 1);
            accum[decodeURIComponent(cName)] = decodeURIComponent(cValue);
            return accum;
        }, {});
    }
    catch (e) {
        console.error(`readCookie :: Could not read cookies.`, e);
    }
    return {};
};
const readCookie = (name) => {
    return readCookies()[name];
};
//# sourceMappingURL=readCookie.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)


/***/ }),

/***/ 7727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useCookieConsent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _categories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3269);


const useCookieConsent = () => {
    const [categories, setCategories] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
        return (0,_categories__WEBPACK_IMPORTED_MODULE_1__/* .readCookieCategories */ .DN)();
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const eventName = 'zapier.cookie-consent';
        const onConsentChanged = () => {
            setCategories((0,_categories__WEBPACK_IMPORTED_MODULE_1__/* .readCookieCategories */ .DN)());
        };
        window.addEventListener(eventName, onConsentChanged);
        return () => {
            window.removeEventListener(eventName, onConsentChanged);
        };
    });
    return categories;
};
//# sourceMappingURL=useCookieConsent.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)


/***/ }),

/***/ 26791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ writeCookie; }
/* harmony export */ });
/* harmony import */ var _categories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3269);

const optionNamesMap = {
    category: null,
    domain: 'domain',
    expires: 'expires',
    maxAge: 'max-age',
    path: 'path',
    sameSite: 'samesite',
    secure: 'secure',
};
const formatCookieOptionName = (name) => {
    return optionNamesMap[name] || name;
};
const optionValuesMap = {
    category: null,
    domain: undefined,
    expires: (date) => new Date(date).toUTCString(),
    maxAge: undefined,
    path: undefined,
    sameSite: undefined,
    secure: (_isSecure) => undefined,
};
const formatCookieOptionValue = (name, value) => {
    if (optionValuesMap[name]) {
        return optionValuesMap[name](value);
    }
    return value;
};
const stringifyOptions = (options) => {
    return Object.entries(options)
        .filter(([name, value]) => {
        return name !== 'category' && value !== false;
    })
        .map(([name, value]) => {
        const formattedName = formatCookieOptionName(name);
        const formattedValue = formatCookieOptionValue(name, value);
        return formattedValue === undefined
            ? `; ${formattedName}`
            : `; ${formattedName}=${formattedValue}`;
    }, [])
        .join('')
        .trim();
};
const writeCookie = (name, value, options) => {
    if (typeof document === 'undefined') {
        return false;
    }
    try {
        const encodedName = encodeURIComponent(name);
        const encodedValue = encodeURIComponent(value);
        const stringifiedOptions = stringifyOptions(options);
        if ((0,_categories__WEBPACK_IMPORTED_MODULE_0__/* .canWriteCookieCategory */ .Lx)(options.category)) {
            document.cookie = `${encodedName}=${encodedValue}${stringifiedOptions}`.trim();
            return true;
        }
        console.warn(`writeCookie :: Could not write cookie ${name} in unconsented category ${options.category}.`);
        return false;
    }
    catch (e) {
        console.error(`writeCookie :: Could not write cookie ${name}.`, e);
    }
    return false;
};
//# sourceMappingURL=writeCookie.js.map
// @zapier/cookies@1.1.3 (39d1b5f07)


/***/ }),

/***/ 43540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDate = exports.DateContext = void 0;
const react_1 = __importDefault(__webpack_require__(2784));
exports.DateContext = react_1.default.createContext({});
/** Use entire Date Context */
exports.useDate = () => react_1.default.useContext(exports.DateContext);


/***/ }),

/***/ 76010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(2784));
const DateContext_1 = __webpack_require__(43540);
/**
 * A provider of common Date info to the app that needs to be directly
 * shared to components
 *
 * When components use the DateProvider they will be able to work inside
 * or outside of the provider since wrapping the component in a provider
 * is just overriding the defaultContext.
 *
 * For Example `DateTime`:
 *
 * This works outside of the DateProvider and falls back to browser timezone
 * ```
 * <DateTime />
 * ```
 *
 * However to get the correct user profile timezone we must wrap it
 * inside of an DateProvider
 *
 * ```
 * <DateProvider timezone="EST">
 *  <DateTime />
 * </DateProvider>
 * ```
 *
 * This is useful because we can:
 *
 * 1. Create / test the components independent of the data source here.
 *
 * 2. Connect them to data sources based on the environment of the app.
 * <br />- `web` will connect DateProvider to the redux store
 * <br />- `web-ssr` will use graphql queries in the DateProvider
 */
const DateProvider = (props) => {
    const { children } = props, innerDate = __rest(props, ["children"]);
    const outerDate = DateContext_1.useDate();
    const app = Object.assign(Object.assign({}, outerDate), innerDate);
    return children ? (react_1.default.createElement(DateContext_1.DateContext.Provider, { value: app }, react_1.default.Children.only(children))) : null;
};
exports["default"] = DateProvider;


/***/ }),

/***/ 2035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var DateProvider_1 = __webpack_require__(76010);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return DateProvider_1.default; } }));
var DateContext_1 = __webpack_require__(43540);
Object.defineProperty(exports, "useDate", ({ enumerable: true, get: function () { return DateContext_1.useDate; } }));


/***/ }),

/***/ 30499:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(2784));
const DateProvider_1 = __webpack_require__(2035);
const getClientTimeZone_1 = __importDefault(__webpack_require__(60731));
const formatDateTime_1 = __importDefault(__webpack_require__(16166));
const DateTime = (props) => {
    const { date, format } = props;
    // Get timezone from AppProvider (if exists)
    const { timezone } = DateProvider_1.useDate();
    // fallback to client timezone then to UTC if that fails
    const clientTimezone = (props.ignoreProfileTimezone ? null : timezone) ||
        getClientTimeZone_1.default() ||
        'UTC';
    const formattedDate = formatDateTime_1.default(date, format || 'default', clientTimezone);
    const formattedISODate = formatDateTime_1.default(date, 'dateString', clientTimezone);
    return (react_1.default.createElement("time", { dateTime: formattedISODate, title: formattedDate }, formattedDate));
};
exports["default"] = DateTime;


/***/ }),

/***/ 89989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var DateTime_1 = __webpack_require__(30499);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return DateTime_1.default; } }));


/***/ }),

/***/ 11741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(2784));
const DateProvider_1 = __webpack_require__(2035);
const formatDateTime_1 = __importDefault(__webpack_require__(16166));
const formatTimeSpan_1 = __importDefault(__webpack_require__(84752));
const getClientTimeZone_1 = __importDefault(__webpack_require__(60731));
const RelativeTime = (props) => {
    const { date, formatter = formatTimeSpan_1.default, hasSuffix } = props;
    // Get timezone from AppProvider (if exists)
    const { timezone } = DateProvider_1.useDate();
    // fallback to client timezone then to UTC if that fails
    const clientTimezone = timezone || getClientTimeZone_1.default() || 'UTC';
    const formattedISODate = formatDateTime_1.default(date, 'dateString', clientTimezone);
    return (react_1.default.createElement("time", { dateTime: formattedISODate, title: formattedISODate }, formatter(Date.now(), date, hasSuffix !== false)));
};
exports["default"] = RelativeTime;


/***/ }),

/***/ 34267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var RelativeTime_1 = __webpack_require__(11741);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return RelativeTime_1.default; } }));


/***/ }),

/***/ 68516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// Components
var DateProvider_1 = __webpack_require__(2035);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return DateProvider_1.default; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return DateProvider_1.useDate; } });
var DateTime_1 = __webpack_require__(89989);
Object.defineProperty(exports, "ou", ({ enumerable: true, get: function () { return DateTime_1.default; } }));
var RelativeTime_1 = __webpack_require__(34267);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return RelativeTime_1.default; } });
// Utils
var daysBetween_1 = __webpack_require__(34245);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return daysBetween_1.default; } });
var daysFromNow_1 = __webpack_require__(63210);
Object.defineProperty(exports, "Cp", ({ enumerable: true, get: function () { return daysFromNow_1.default; } }));
var ensureDate_1 = __webpack_require__(94537);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return ensureDate_1.default; } });
var formatDateTime_1 = __webpack_require__(16166);
Object.defineProperty(exports, "o0", ({ enumerable: true, get: function () { return formatDateTime_1.default; } }));
var formatTimeSpan_1 = __webpack_require__(84752);
Object.defineProperty(exports, "lF", ({ enumerable: true, get: function () { return formatTimeSpan_1.default; } }));
var formatTimeSpanAbbreviated_1 = __webpack_require__(19349);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return formatTimeSpanAbbreviated_1.default; } });
var getClientTimeZone_1 = __webpack_require__(60731);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return getClientTimeZone_1.default; } });
var withMonotonicTimestamp_1 = __webpack_require__(45531);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return withMonotonicTimestamp_1.default; } });
var getUTCDate_1 = __webpack_require__(10907);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return getUTCDate_1.default; } });
var parseDateTime_1 = __webpack_require__(40890);
Object.defineProperty(exports, "wG", ({ enumerable: true, get: function () { return parseDateTime_1.default; } }));


/***/ }),

/***/ 34245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const date_fns_1 = __webpack_require__(25155);
const daysBetween = (endDate, startDate) => date_fns_1.differenceInDays(endDate, startDate);
exports["default"] = daysBetween;


/***/ }),

/***/ 63210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.daysFromNow = void 0;
const daysBetween_1 = __importDefault(__webpack_require__(34245));
exports.daysFromNow = (dateTime) => Math.abs(daysBetween_1.default(Date.now(), dateTime));
exports["default"] = exports.daysFromNow;


/***/ }),

/***/ 94537:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Make sure the given `Dateable` is a `Date`.
 *
 * @param {Dateable} date
 */
const ensureDate = (date) => {
    // The server sends us UNIX timestamps in seconds, make sure we use JS timestamp in milliseconds
    if (typeof date === 'number' && date < 10e9) {
        date *= 1000;
    }
    return new Date(date);
};
exports["default"] = ensureDate;


/***/ }),

/***/ 16166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const intl_dateformat_1 = __importDefault(__webpack_require__(82067));
const ensureDate_1 = __importDefault(__webpack_require__(94537));
const PREDEFINED_FORMATS = {
    dateString: 'YYYY-MM-DD',
    default: 'MMMM DD, YYYY',
    exhaustive: 'YYYY-MM-DD HH:mm:ss',
    iso: 'YYYY-MM-DDTHH:mm:ssZ',
    short: 'MMM DD, YYYY',
};
const formatDateTime = (dateTime, format, timeZone) => {
    const parsedDate = ensureDate_1.default(dateTime);
    if (format === 'iso')
        return parsedDate.toISOString();
    try {
        return intl_dateformat_1.default(parsedDate, PREDEFINED_FORMATS[format] || format, timeZone ? { timezone: timeZone } : undefined);
    }
    catch (err) {
        // `intl-dateformat` uses `Intl.DateTimeFormat` under the hood.
        // In order to still support legacy browsers, we fallback on `Date#toLocalDateString`.
        try {
            return parsedDate.toLocaleDateString('en-US', timeZone ? { timeZone } : undefined);
        }
        catch (err2) {
            // In some edge-cases the backend can send non-IANA timezones.
            // If so we can still try to format the date correctly with no timezone.
            return formatDateTime(dateTime, format);
        }
    }
};
exports["default"] = formatDateTime;


/***/ }),

/***/ 84752:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const date_fns_1 = __webpack_require__(25155);
const pluralize_1 = __importDefault(__webpack_require__(19928));
const formatTimeSpan = (endDate, startDate, addSuffix = true) => {
    // `distanceInWords` does not support weeks resolution
    const fullWeeks = Math.abs(date_fns_1.differenceInWeeks(endDate, startDate));
    if (fullWeeks > 0 && fullWeeks < 4) {
        const remainderDays = Math.abs(date_fns_1.differenceInDays(endDate, startDate)) % 7;
        const weeks = remainderDays < 4 ? fullWeeks : fullWeeks + 1;
        const isEndAfter = date_fns_1.isAfter(startDate, endDate);
        const prefix = addSuffix && isEndAfter ? 'in ' : '';
        const suffix = addSuffix && !isEndAfter ? ' ago' : '';
        return `${prefix}${weeks} ${pluralize_1.default('week', weeks)}${suffix}`;
    }
    return date_fns_1.distanceInWordsStrict(endDate, startDate, { addSuffix });
};
exports["default"] = formatTimeSpan;


/***/ }),

/***/ 19349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const formatTimeSpan_1 = __importDefault(__webpack_require__(84752));
const formatTimeSpanAbbreviated = (endDate, startDate, addSuffix) => {
    return formatTimeSpan_1.default(endDate, startDate, addSuffix)
        .replace('year', 'yr')
        .replace('month', 'mo')
        .replace('week', 'wk')
        .replace('hour', 'hr')
        .replace('minute', 'min')
        .replace('second', 'sec');
};
exports["default"] = formatTimeSpanAbbreviated;


/***/ }),

/***/ 60731:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const getClientTimeZone = () => {
    try {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) {
        return null;
    }
};
exports["default"] = getClientTimeZone;


/***/ }),

/***/ 10907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const parseDateTime_1 = __importDefault(__webpack_require__(40890));
// Takes a Date or string to convert to one
// Dates are always localized
// Returned Date is as well, but acts like it's UTC
const getUTCDate = (dateTime) => {
    const parsedDate = parseDateTime_1.default(dateTime);
    const utcDate = new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), parsedDate.getUTCHours(), parsedDate.getUTCMinutes(), parsedDate.getUTCSeconds(), parsedDate.getUTCMilliseconds());
    return utcDate;
};
exports["default"] = getUTCDate;


/***/ }),

/***/ 40890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const date_fns_1 = __webpack_require__(25155);
function isNumber(number) {
    return typeof number === 'number' && !isNaN(number);
}
const parseDateTime = (dateTime) => {
    if (isNumber(dateTime) && dateTime < 10e9) {
        return date_fns_1.parse(dateTime * 1000);
    }
    return date_fns_1.parse(dateTime);
};
exports["default"] = parseDateTime;


/***/ }),

/***/ 45531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
// @ts-ignore
const monotonic_timestamp_1 = __importDefault(__webpack_require__(17969));
const withMonotonicTimestamp = (fn) => {
    return fn(monotonic_timestamp_1.default());
};
exports["default"] = withMonotonicTimestamp;


/***/ }),

/***/ 20271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77293);
/* harmony import */ var _display_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28067);
/* harmony import */ var _display_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46688);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70776);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3000);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10391);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98628);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






const typeConfigs = {
    info: {
        backgroundColor: 'blue',
        color: 'neutral100',
        icon: 'alertInfoFill',
        iconColor: 'blue',
    },
    success: {
        backgroundColor: 'success400',
        color: 'neutral700',
        icon: 'formCheckCircle',
        iconColor: 'success400',
    },
    warning: {
        backgroundColor: 'warning400',
        color: 'neutral700',
        icon: 'alertTriangleFill',
        iconColor: 'neutral700',
    },
    error: {
        backgroundColor: 'error400',
        color: 'neutral100',
        icon: 'formXCircle',
        iconColor: 'error400',
    },
};
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .labelStyles */ .B)('Alert', {
    root: (_a) => {
        var { miniBackgroundColor = 'blue' } = _a, props = __rest(_a, ["miniBackgroundColor"]);
        return [
            props.layout === 'box' && [
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -box;
        position: relative;
        display: grid;
        grid-template-columns: max-content 1fr max-content;
        align-items: start;
        gap: 10px;
        padding: 10px 10px 10px 20px;
        border: 1px solid ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral300 */ .w.neutral300};
        border-radius: 5px;
        background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100 */ .w.neutral100};
        ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Typography.paragraph3 */ .ZT.paragraph3};
        color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral700 */ .w.neutral700};

        // Colored stripe that renders on the left of the box.
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          border-top-left-radius: inherit;
          border-bottom-left-radius: inherit;
          width: 10px;
        }
      `,
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -${props.type};
        &::before {
          background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[typeConfigs[props.type].backgroundColor]};
        }
      `,
            ],
            props.layout === 'banner' && [
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -banner;
        position: relative;
        display: grid;
        align-items: center;
        ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Typography.paragraph3 */ .ZT.paragraph3};
        padding: 10px 44px;
        text-align: center;
      `,
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -${props.type};
        color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[typeConfigs[props.type].color]};
        background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[typeConfigs[props.type].backgroundColor]};

        // Rare tag selection to ensure that links are accessible
        // and consumers don't need to worry about it.
        a[class] {
          color: inherit;
          text-decoration: underline;
          &:hover,
          &:focus {
            color: rgba(${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100rgb */ .w.neutral100rgb}, 0.75);
          }
          &:focus {
            outline: 1px solid rgba(${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100rgb */ .w.neutral100rgb}, 0.75);
          }
        }
      `,
            ],
            props.layout === 'banner-inverse' && [
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -banner;
        position: relative;
        display: grid;
        align-items: center;
        ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Typography.paragraph3 */ .ZT.paragraph3};
        padding: 10px 44px;
        text-align: center;
      `,
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -${props.type};
        color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral700 */ .w.neutral700};
        background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100 */ .w.neutral100};
      `,
            ],
            props.layout === 'mini' && [
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -mini;
        position: relative;
        display: grid;
        align-items: center;
        ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium};
        text-align: center;
        padding: 8px 44px;
      `,
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -${props.type};
        background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[miniBackgroundColor]};
        color: ${miniBackgroundColor === 'neutral100'
                    ? _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral800 */ .w.neutral800
                    : _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100 */ .w.neutral100};

        a[class] {
          color: inherit;
          text-decoration: underline;
          &:hover,
          &:focus {
            color: ${miniBackgroundColor === 'neutral100'
                    ? _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.blue */ .w.blue
                    : `rgba(${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100rgb */ .w.neutral100rgb}, 0.75)`};
          }
          &:focus {
            outline: 1px solid
              ${miniBackgroundColor === 'neutral100'
                    ? _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.blue */ .w.blue
                    : `rgba(${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100rgb */ .w.neutral100rgb}, 0.75)`};
          }
        }
      `,
            ],
            props.layout === 'modal' && [
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -modal;
        position: relative;
        max-width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral100 */ .w.neutral100};
        padding: 15px;
        border: 1px solid ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral300 */ .w.neutral300};
        text-align: center;
        border-radius: 10px;
      `,
            ],
            props.hasShadow &&
                _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        label: -shadowed;
        box-shadow: ${_theme__WEBPACK_IMPORTED_MODULE_5__/* .Shadows.elevation5 */ .f.elevation5};
      `,
        ];
    },
    typeIcon: (props) => [
        _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
      color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[typeConfigs[props.type].iconColor]};
    `,
        props.layout === 'modal' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        margin-bottom: 8px;
      `,
        (props.layout === 'banner' || props.layout === 'banner-inverse') &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: ${props.layout === 'banner'
                ? 'currentColor'
                : _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[typeConfigs[props.type].iconColor]};
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        position: relative;
        top: -2px;
      `,
    ],
    titleInner: (props) => [
        _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
      display: block;
      ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Typography.paragraph3Bold */ .ZT.paragraph3Bold};
      color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral800 */ .w.neutral800};
    `,
        props.layout === 'banner' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: inherit;
      `,
        props.layout === 'mini' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: inherit;
      `,
    ],
    closeButton: (props) => [
        props.layout !== 'banner' &&
            props.layout !== 'mini' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral600 */ .w.neutral600};
        transition: ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Animation.transitionValue */ .f.transitionValue};

        &:hover,
        &:focus {
          color: ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral600 */ .w.neutral600};
        }
      `,
        props.layout === 'banner' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: inherit;
      `,
        props.layout === 'mini' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        color: ${props.miniBackgroundColor === 'neutral100'
                ? _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors.neutral600 */ .w.neutral600
                : 'inherit'};
      `,
        (props.layout === 'banner' || props.layout === 'banner-inverse') &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        position: absolute;
        right: 15px;
        top: 22px;
        transform: translateY(-50%);
      `,
        props.layout === 'mini' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        position: absolute;
        right: 15px;
        top: 20px;
        transform: translateY(-50%);
      `,
        props.layout === 'modal' &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        position: absolute;
        top: 15px;
        right: 15px;
      `,
    ],
});
const defaultProps = {
    hasShadow: true,
    type: 'info',
    layout: 'box',
};
const Alert = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const config = typeConfigs[props.type];
    const isBanner = props.layout === 'banner' || props.layout === 'banner-inverse';
    const isMini = props.layout === 'mini';
    const icon = ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("div", { css: Styles.typeIcon(props) },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)(_display_Icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, { ariaLabel: props.type, isBlock: true, name: config.icon, size: 24 })));
    const closeButton = props.onDismiss && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("button", { type: "button", "aria-label": "Dismiss", css: Styles.closeButton(props), onClick: props.onDismiss },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)(_display_Icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, { isBlock: true, name: "formX", size: 24 })));
    const bannerIcon = isBanner && !isMini && icon && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        icon,
        "\u00A0"));
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("article", { "aria-live": props.ariaLive, css: Styles.root(props), role: props.role },
        !isBanner && !isMini && icon,
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("div", { css: Styles.content },
            props.title && !isMini && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)(_display_Heading__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X, { css: Styles.title },
                (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("span", { css: Styles.titleInner(props) },
                    bannerIcon,
                    props.title))),
            props.children),
        closeButton));
};
//# sourceMappingURL=Alert.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 41273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _display_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77509);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3000);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70776);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98628);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77293);





const getNameInitials = (name) => {
    const initials = (name || '')
        .trim()
        .split(/\s+/)
        .map((s) => s[0]);
    const firstLetter = initials[0];
    const lastLetter = initials[initials.length - 1];
    if (!firstLetter) {
        return '';
    }
    return initials.length === 1
        ? String(firstLetter)
        : `${firstLetter}${lastLetter}`;
};
const mapV4ColortoV5Color = (color) => {
    let transformedColor;
    switch (color) {
        case 'lava':
            transformedColor = 'primary';
            break;
        case 'ocean':
            transformedColor = 'secondary';
            break;
        case 'sun':
            transformedColor = 'tertiary';
            break;
        default:
            transformedColor = color;
    }
    return transformedColor;
};
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .labelStyles */ .B)('Avatar', {
    root: (hasError, props) => [
        _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
      ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Typography.base */ .ZT.base};
      font-weight: 700;
      line-height: 1;
      user-select: none;
      align-items: center;
      border-radius: 50%;
      display: inline-flex;
      justify-content: center;
      overflow: hidden;
      position: relative;
      border: 1px solid ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
      transition: ${_theme__WEBPACK_IMPORTED_MODULE_5__/* .Animation.transitionValue */ .f.transitionValue};

      &[data-block] {
        display: flex;
      }

      &[data-interactive] {
        &:hover,
        &:focus {
          border-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral300 */ .w.neutral300};
        }
      }

      &[data-selected][data-selected] {
        border-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.blue */ .w.blue};
      }
    `,
        !props.url || (props.url && hasError)
            ? _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
          &:nth-of-type(1n),
          &[data-color='lava'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral800 */ .w.neutral800};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }
          &:nth-of-type(1n),
          &[data-color='primary'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral800 */ .w.neutral800};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }

          &:nth-of-type(2n),
          &[data-color='ocean'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.night */ .w.night};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }
          &:nth-of-type(2n),
          &[data-color='secondary'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.night */ .w.night};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }

          &:nth-of-type(3n),
          &[data-color='sun'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.moss */ .w.moss};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }
          &:nth-of-type(3n),
          &[data-color='tertiary'][data-color] {
            background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.moss */ .w.moss};
            color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};
          }
        `
            : null,
        _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
      label: -${props.size}x ${props.size};
      height: ${props.size}px;
      width: ${props.size}px;
      font-size: ${Math.floor(props.size * (props.size > 25 ? 0.35 : 0.45))}px;
    `,
        props.size >= 40 &&
            _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
        border-width: 2px;
      `,
    ],
    img: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
});
const Avatar = (props) => {
    const [hasError, setHasError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { name, url, size } = props;
    const initials = name ? getNameInitials(name) : null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (hasError) {
            setHasError(false);
        }
    }, [props.url]);
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { "aria-hidden": props.ariaHidden, "aria-label": name, css: Styles.root(hasError, props), "data-block": props.isBlock ? 'true' : undefined, "data-color": mapV4ColortoV5Color(props.color), "data-interactive": props.isInteractive ? 'true' : undefined, "data-selected": props.isSelected ? 'true' : undefined, "data-size": props.size, "data-testid": "Avatar", role: "img" }, url && !hasError ? ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)(_display_Img__WEBPACK_IMPORTED_MODULE_7__/* .Img */ .E, { css: Styles.img, alt: name, ariaHidden: true, height: size, onError: () => setHasError(true), src: url, width: size, loading: props.shouldLazilyLoad ? 'lazy' : 'eager' })) : ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("span", null, initials))));
};
Avatar.defaultProps = {
    shouldLazilyLoad: true,
    size: 25,
};
//# sourceMappingURL=Avatar.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 15504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FloatingBox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98628);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91604);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10391);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70776);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77293);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69480);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37168);





const menuOpenAnimation = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)({
    '0%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '30%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '100%': {
        transform: 'translateY(0)',
        opacity: 1,
    },
});
const DISTANCE = 'calc(100% + 5px)';
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .labelStyles */ .B)('FloatingBox', {
    root: (props, derivedState) => [
        (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
            animation: `${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Animation.transitionDuration */ .f.transitionDuration} ease-out ${menuOpenAnimation}`,
            maxWidth: props.maxWidth,
            position: 'absolute',
            minWidth: props.minWidth,
            zIndex: _theme__WEBPACK_IMPORTED_MODULE_4__/* .Zindexes.dropdownMenu */ .C.dropdownMenu,
        }),
        props.align === 'left' &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .withModifier */ .Q)(props.align, {
                left: 0,
            }),
        props.align === 'right' &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .withModifier */ .Q)(props.align, {
                right: 0,
            }),
        props.align === 'stretch' &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .withModifier */ .Q)(props.align, {
                left: 0,
                right: 0,
            }),
        derivedState.position === 'south' &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .withModifier */ .Q)(derivedState.position, {
                top: DISTANCE,
            }),
        derivedState.position === 'north' &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .withModifier */ .Q)(derivedState.position, {
                bottom: DISTANCE,
            }),
    ],
    box: (backgroundColor, borderRadius, borderColor) => (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
        backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius,
        boxShadow: _theme__WEBPACK_IMPORTED_MODULE_6__/* .Shadows.elevation20 */ .f.elevation20,
    }),
});
function getBorderRadius(borderRadius) {
    return borderRadius || 3;
}
function getBorderColor(borderColor) {
    return borderColor || _theme__WEBPACK_IMPORTED_MODULE_7__/* .Colors.neutral400 */ .w.neutral400;
}
function getBackgroundColor(hasWhiteBackground = false) {
    return hasWhiteBackground ? _theme__WEBPACK_IMPORTED_MODULE_7__/* .Colors.white */ .w.white : _theme__WEBPACK_IMPORTED_MODULE_7__/* .Colors.neutral100 */ .w.neutral100;
}
const FloatingBox = (props) => {
    const threshold = 0.9;
    const node = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [setIntersectNode, { isBottomIntersecting, isTopIntersecting },] = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useIntersect */ .U)({
        heightOverride: props.intersectHeight,
        once: true,
        threshold,
    });
    const borderRadius = getBorderRadius(props.borderRadius);
    const borderColor = getBorderColor(props.borderColor);
    const backgroundColor = getBackgroundColor(props.hasWhiteBackground);
    const onClickOutside = props.onClickOutside || (() => { });
    const [setClickOutsideNode] = (0,_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useClickOutside */ .O)({
        onClickOutside,
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setIntersectNode(node.current);
        setClickOutsideNode(node.current);
    }, [setClickOutsideNode, setIntersectNode]);
    const derivedState = {
        position: props.position ||
            (isTopIntersecting || !isBottomIntersecting ? 'south' : 'north'),
    };
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_10__/* .isolateComponent */ .U)("div", { css: Styles.root(props, derivedState), ref: node, "data-testid": "floating-box" },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_10__/* .isolateComponent */ .U)("div", { css: Styles.box(backgroundColor, borderRadius, borderColor) }, props.children)));
};
FloatingBox.defaultProps = {
    align: 'left',
};
//# sourceMappingURL=FloatingBox.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 28067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77293);
/* harmony import */ var _zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30826);
/* harmony import */ var _zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_clamp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37260);




const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('Heading', {
    root: _emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv `
    display: block;
  `,
});
const Heading = (props) => {
    const { level } = (0,_zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_2__.useHeadingLevel)();
    const headingLevel = (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_3__/* .clamp */ .u)(level, 1, 6);
    const Tag = `h${headingLevel}`;
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .isolateComponent */ .U)(Tag, { css: Styles.root, className: props.className }, props.children));
};
//# sourceMappingURL=Heading.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 78062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ HeadingLevel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_clamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37260);
/* harmony import */ var _zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30826);
/* harmony import */ var _zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_1__);



const HeadingLevel = ({ children }) => {
    const { level } = (0,_zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_1__.useHeadingLevel)();
    const nextLevel = (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_2__/* .clamp */ .u)(level + 1, 1, 6);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_zapier_heading_level_context__WEBPACK_IMPORTED_MODULE_1__.HeadingLevelProvider, { level: nextLevel }, children));
};
//# sourceMappingURL=HeadingLevel.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 46688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Icon; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/withModifier.js
var withModifier = __webpack_require__(52676);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/asyncImportSVG.js
const asyncImportSVG = async (name) => await __webpack_require__(72363)(`./${name}.js`);
//# sourceMappingURL=asyncImportSVG.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js




const sanitizeClassName = (size) => {
    return `${size}`.replace(/[^a-z0-9]/gi, '-');
};
const Styles = (0,labelStyles/* labelStyles */.B)('Icon', {
    root: (props) => [
        {
            label: `-${props.name}`,
            display: 'inline-block',
            fill: 'currentColor',
            transitionProperty: 'fill',
            transitionTimingFunction: Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction,
            transitionDuration: Animation/* Animation.transitionDuration */.f.transitionDuration,
            '> svg': {
                display: 'block',
                height: 'inherit',
                width: 'inherit',
            },
            '*': {
                fill: 'inherit',
            },
        },
        !props.canAcceptPointerEvents &&
            (0,withModifier/* withModifier */.Q)('disable-pointer-events', {
                pointerEvents: 'none',
            }),
        props.isBlock &&
            (0,withModifier/* withModifier */.Q)('block', {
                display: 'block',
            }),
        (0,withModifier/* withModifier */.Q)(sanitizeClassName(`${props.size}x${props.size}`), {
            height: props.size,
            width: props.size,
        }),
        props.color &&
            (0,withModifier/* withModifier */.Q)(props.color, {
                fill: Colors/* Colors */.w[props.color],
            }),
    ],
});
const LoadingIcon = () => ((0,isolateComponent/* isolateComponent */.U)("svg", { "aria-label": "Loading icon", "data-is-loading-icon": "true", viewBox: "0 0 24 24" }));
const MissingIcon = () => ((0,isolateComponent/* isolateComponent */.U)("svg", { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24" },
    (0,isolateComponent/* isolateComponent */.U)("rect", { height: "24", width: "24", x: "0", y: "0" })));
class IconErrorBoundary extends react.Component {
    constructor() {
        super(...arguments);
        this.state = {
            didFailToLoad: false,
        };
    }
    static getDerivedStateFromError() {
        return {
            didFailToLoad: true,
        };
    }
    render() {
        return this.state.didFailToLoad ? (0,isolateComponent/* isolateComponent */.U)(MissingIcon, null) : this.props.children;
    }
}
const iconsCache = {};
const loadSvgAsComponent = async (name) => {
    if (iconsCache[name]) {
        return iconsCache[name];
    }
    if (false) {}
    try {
        const svg = await asyncImportSVG(name);
        const Svg = svg.default;
        const props = typeof Svg === 'string'
            ? {
                dangerouslySetInnerHTML: { __html: Svg },
            }
            : {
                children: (0,isolateComponent/* isolateComponent */.U)(Svg, null),
            };
        iconsCache[name] = () => (0,isolateComponent/* isolateComponent */.U)(react.Fragment, Object.assign({}, props));
        return iconsCache[name];
    }
    catch (error) {
        const message = `Could not load Icon with name of ${name}`;
        throw new Error(message);
    }
};
const Icon = (props) => {
    const [IconSvg, setIconSvg] = (0,react.useState)(() => LoadingIcon);
    (0,react.useEffect)(() => {
        let isMounted = true;
        loadSvgAsComponent(props.name)
            .then((SvgComponent) => {
            if (isMounted) {
                setIconSvg(() => SvgComponent);
            }
        })
            .catch(() => { });
        return () => {
            isMounted = false;
        };
    }, [props.name]);
    return ((0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": props.ariaHidden ? 'true' : undefined, "aria-label": props.ariaLabel, css: Styles.root(props), "data-testid": "iconContainer" },
        (0,isolateComponent/* isolateComponent */.U)(IconErrorBoundary, null,
            (0,isolateComponent/* isolateComponent */.U)(IconSvg, null))));
};
Icon.defaultProps = {
    canAcceptPointerEvents: true,
    size: 30,
    ariaHidden: true,
};
//# sourceMappingURL=Icon.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 50672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iconNames": function() { return /* binding */ iconNames; },
/* harmony export */   "iconsMap": function() { return /* binding */ iconsMap; }
/* harmony export */ });
const iconNames = {
    actionAttachment: true,
    actionAutoRenew: true,
    actionBookmark: true,
    actionBookmarkFill: true,
    actionBug: true,
    actionBugFill: true,
    actionBuild: true,
    actionCalendar: true,
    actionCalendarFill: true,
    actionCamera: true,
    actionCameraFill: true,
    actionCheckConnection: true,
    actionCheckConnectionFill: true,
    actionCopy: true,
    actionCopyFill: true,
    actionDownload: true,
    actionDrag: true,
    actionEdit: true,
    actionEditCircle: true,
    actionEditCircleFill: true,
    actionEditFill: true,
    actionEmail: true,
    actionEmailFill: true,
    actionExplore: true,
    actionExploreFill: true,
    actionFilter: true,
    actionFlag: true,
    actionFlagFill: true,
    actionInsert: true,
    actionLink: true,
    actionLock: true,
    actionLockFill: true,
    actionMoveToFolder: true,
    actionMoveToFolderFill: true,
    actionPhoto: true,
    actionPhotoFill: true,
    actionPin: true,
    actionPinFill: true,
    actionPlay: true,
    actionPlayFill: true,
    actionRename: true,
    actionRenameFill: true,
    actionResend: true,
    actionResendFill: true,
    actionSend: true,
    actionSendFill: true,
    actionShare: true,
    actionShareFill: true,
    actionSwitchAccount: true,
    actionSwitchAccountFill: true,
    actionTrash: true,
    actionTrashFill: true,
    actionZapDetails: true,
    actionZapDetailsFill: true,
    alertCircle: true,
    alertCircleFill: true,
    alertInfo: true,
    alertInfoFill: true,
    alertTriangle: true,
    alertTriangleFill: true,
    arrowBigDown: true,
    arrowBigLeft: true,
    arrowBigRight: true,
    arrowBigUp: true,
    arrowBranch: true,
    arrowCode: true,
    arrowCodeDots: true,
    arrowConnect: true,
    arrowDropdown: true,
    arrowDropdownCircle: true,
    arrowExit: true,
    arrowLineLeft: true,
    arrowLineRight: true,
    arrowOffsite: true,
    arrowRedo: true,
    arrowRefresh: true,
    arrowSmallDown: true,
    arrowSmallLeft: true,
    arrowSmallRight: true,
    arrowSmallUp: true,
    arrowUndo: true,
    arrowZoom: true,
    commentAdd: true,
    commentAddFill: true,
    commentBlank: true,
    commentBlankFill: true,
    commentConvo: true,
    commentConvoFill: true,
    commentFilled: true,
    commentFilledFill: true,
    commentWaiting: true,
    commentWaitingFill: true,
    fileAdd: true,
    fileAddFill: true,
    fileFile: true,
    fileFileFill: true,
    fileFilled: true,
    fileFilledFill: true,
    fileGuide: true,
    fileGuideFill: true,
    formAdd: true,
    formAddCircle: true,
    formAddCircleOutlined: true,
    formAddSquare: true,
    formAddSquareOutlined: true,
    formBlank: true,
    formCheck: true,
    formCheckCircle: true,
    formCheckCircleOutlined: true,
    formCheckSquare: true,
    formCheckSquareOutlined: true,
    formDash: true,
    formDashCircle: true,
    formDashCircleOutlined: true,
    formDashSquare: true,
    formDashSquareOutlined: true,
    formRadioCheck: true,
    formRadioDot: true,
    formRadioUnchecked: true,
    formText: true,
    formTextLong: true,
    formTextAlignCenter: true,
    formTextAlignLeft: true,
    formTextAlignRight: true,
    formToggle: true,
    formX: true,
    formXCircle: true,
    formXCircleOutlined: true,
    magnifyingGlass: true,
    miscBolt: true,
    miscBoltAlt: true,
    miscBoltAltFill: true,
    miscBoltFill: true,
    miscBoltOutlined: true,
    miscClock: true,
    miscClockFill: true,
    miscCloud: true,
    miscCloudCheck: true,
    miscCloudCheckFill: true,
    miscCloudFill: true,
    miscColor: true,
    miscColorFill: true,
    miscCookie: true,
    miscCookieFill: true,
    miscCreditCard: true,
    miscCreditCardFill: true,
    miscDollar: true,
    miscEye: true,
    miscEyeClosed: true,
    miscEyeFill: true,
    miscFingerprint: true,
    miscFire: true,
    miscFireFill: true,
    miscGraph: true,
    miscGraphBox: true,
    miscGraphBoxFill: true,
    miscHand: true,
    miscHandFill: true,
    miscHeadset: true,
    miscHeadsetFill: true,
    miscLearn: true,
    miscLearnFill: true,
    miscList: true,
    miscMic: true,
    miscMicFill: true,
    miscPie: true,
    miscPieFill: true,
    miscPin: true,
    miscPinFill: true,
    miscSecurity: true,
    miscSecurityFill: true,
    miscSteps: true,
    miscSteps1: true,
    miscSteps2: true,
    miscSteps3: true,
    miscStepsAlt: true,
    miscStepsFill: true,
    miscTimelapse: true,
    miscUptime: true,
    miscUptimeFill: true,
    miscWallet: true,
    miscWalletFill: true,
    miscWorld: true,
    miscWorldFill: true,
    navApps: true,
    navAppsFill: true,
    navBell: true,
    navBellFill: true,
    navBlog: true,
    navBlogFill: true,
    navBriefcase: true,
    navBriefcaseFill: true,
    navCog: true,
    navCogFill: true,
    navDashboard: true,
    navDashboardFill: true,
    navExplore: true,
    navExploreFill: true,
    navFolder: true,
    navFolderFill: true,
    navHelp: true,
    navHelpFill: true,
    navHome: true,
    navHomeFill: true,
    navIntegrations: true,
    navIntegrationsFill: true,
    navInterfaces: true,
    navInterfacesFill: true,
    navMenu: true,
    navMenuAlt: true,
    navMoreHoriz: true,
    navMoreVert: true,
    navSearch: true,
    navSearchFill: true,
    navTable: true,
    navTableFill: true,
    navVersions: true,
    navVersionsFill: true,
    partnerDashboard: true,
    partnerEmbed: true,
    personAccount: true,
    personAdd: true,
    personAddFill: true,
    personCircle: true,
    personCircleFill: true,
    personGroup: true,
    personGroupFill: true,
    personOne: true,
    personOneFill: true,
    ratingCool: true,
    ratingHappy: true,
    ratingHappyAlt: true,
    ratingHeart: true,
    ratingHeartFill: true,
    ratingNeutral: true,
    ratingNeutralAlt: true,
    ratingSad: true,
    ratingSadAlt: true,
    ratingStar: true,
    ratingStarFill: true,
    ratingThumbsBoth: true,
    ratingThumbsBothFill: true,
    ratingThumbsDown: true,
    ratingThumbsDownFill: true,
    ratingThumbsUp: true,
    ratingThumbsUpFill: true,
    ratingVeryHappy: true,
    ratingVeryHappyAlt: true,
    ratingVerySad: true,
    ratingVerySadAlt: true,
    ratingWink: true,
    ratingWinkAlt: true,
    statusFilter: true,
    statusFilterFill: true,
    statusPaused: true,
    statusPlaying: true,
    statusPlayingFill: true,
    team: true,
    teamFill: true,
    upAndDownArrows: true,
    x: true,
    zapierLogo: true,
    zapDetails: true,
};
const iconsMap = Object.keys(iconNames).reduce((icons, iconName) => {
    icons[iconName] = `./${iconName}.svg`;
    return icons;
}, {});
//# sourceMappingURL=index.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 72363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./actionAttachment.js": [
		62677,
		2677
	],
	"./actionAutoRenew.js": [
		57842,
		7842
	],
	"./actionBookmark.js": [
		7594,
		7594
	],
	"./actionBookmarkFill.js": [
		34598,
		4598
	],
	"./actionBug.js": [
		15362,
		5362
	],
	"./actionBugFill.js": [
		94991,
		4991
	],
	"./actionBuild.js": [
		26289,
		6289
	],
	"./actionCalendar.js": [
		15819,
		5819
	],
	"./actionCalendarFill.js": [
		70843,
		843
	],
	"./actionCamera.js": [
		20142,
		142
	],
	"./actionCameraFill.js": [
		97778,
		7778
	],
	"./actionCheckConnection.js": [
		72809,
		1451
	],
	"./actionCheckConnectionFill.js": [
		94607,
		4607
	],
	"./actionCopy.js": [
		15404,
		5404
	],
	"./actionCopyFill.js": [
		85883,
		5883
	],
	"./actionDownload.js": [
		97196,
		7196
	],
	"./actionDrag.js": [
		15894,
		5894
	],
	"./actionEdit.js": [
		17734,
		7734
	],
	"./actionEditCircle.js": [
		98876,
		8876
	],
	"./actionEditCircleFill.js": [
		23045,
		3045
	],
	"./actionEditFill.js": [
		41618,
		1618
	],
	"./actionEmail.js": [
		58242,
		8242
	],
	"./actionEmailFill.js": [
		44694,
		4694
	],
	"./actionExplore.js": [
		78136,
		8136
	],
	"./actionExploreFill.js": [
		14355,
		4355
	],
	"./actionFilter.js": [
		20045,
		45
	],
	"./actionFlag.js": [
		60427,
		427
	],
	"./actionFlagFill.js": [
		44321,
		4321
	],
	"./actionInsert.js": [
		48716,
		8716
	],
	"./actionLink.js": [
		2809,
		2809
	],
	"./actionLock.js": [
		86505,
		6505
	],
	"./actionLockFill.js": [
		65843,
		5843
	],
	"./actionMoveToFolder.js": [
		13636,
		3636
	],
	"./actionMoveToFolderFill.js": [
		28100,
		8100
	],
	"./actionPhoto.js": [
		67051,
		7051
	],
	"./actionPhotoFill.js": [
		72264,
		2264
	],
	"./actionPin.js": [
		78631,
		8631
	],
	"./actionPinFill.js": [
		70540,
		540
	],
	"./actionPlay.js": [
		91070,
		1070
	],
	"./actionPlayFill.js": [
		55191,
		5191
	],
	"./actionRename.js": [
		22123,
		2123
	],
	"./actionRenameFill.js": [
		71641,
		1641
	],
	"./actionResend.js": [
		54660,
		4660
	],
	"./actionResendFill.js": [
		33663,
		9179
	],
	"./actionSend.js": [
		75325,
		5325
	],
	"./actionSendFill.js": [
		78200,
		8200
	],
	"./actionShare.js": [
		98834,
		8834
	],
	"./actionShareFill.js": [
		66839,
		6839
	],
	"./actionSwitchAccount.js": [
		13358,
		3358
	],
	"./actionSwitchAccountFill.js": [
		37040,
		7040
	],
	"./actionTrash.js": [
		96588,
		6588
	],
	"./actionTrashFill.js": [
		36576,
		6576
	],
	"./actionZapDetails.js": [
		16492,
		6492
	],
	"./actionZapDetailsFill.js": [
		45970,
		5970
	],
	"./alertCircle.js": [
		44127,
		4127
	],
	"./alertCircleFill.js": [
		49824,
		9824
	],
	"./alertInfo.js": [
		80476,
		476
	],
	"./alertInfoFill.js": [
		14202,
		4202
	],
	"./alertTriangle.js": [
		54656,
		4656
	],
	"./alertTriangleFill.js": [
		46821,
		6821
	],
	"./arrowBigDown.js": [
		39494,
		9494
	],
	"./arrowBigLeft.js": [
		12860,
		2860
	],
	"./arrowBigRight.js": [
		47316,
		7316
	],
	"./arrowBigUp.js": [
		83025,
		3025
	],
	"./arrowBranch.js": [
		9062,
		9062
	],
	"./arrowCode.js": [
		76826,
		6826
	],
	"./arrowCodeDots.js": [
		8617,
		8617
	],
	"./arrowConnect.js": [
		52743,
		2743
	],
	"./arrowDropdown.js": [
		75058,
		5058
	],
	"./arrowDropdownCircle.js": [
		64093,
		4093
	],
	"./arrowExit.js": [
		75735,
		5735
	],
	"./arrowLineLeft.js": [
		50659,
		659
	],
	"./arrowLineRight.js": [
		36657,
		6657
	],
	"./arrowOffsite.js": [
		5946,
		6209
	],
	"./arrowRedo.js": [
		47158,
		7158
	],
	"./arrowRefresh.js": [
		67657,
		7657
	],
	"./arrowSmallDown.js": [
		81548,
		1548
	],
	"./arrowSmallLeft.js": [
		62153,
		2153
	],
	"./arrowSmallRight.js": [
		92806,
		2806
	],
	"./arrowSmallUp.js": [
		68009,
		1
	],
	"./arrowUndo.js": [
		32862,
		2862
	],
	"./arrowZoom.js": [
		70151,
		151
	],
	"./commentAdd.js": [
		56481,
		6481
	],
	"./commentAddFill.js": [
		30692,
		692
	],
	"./commentBlank.js": [
		40552,
		552
	],
	"./commentBlankFill.js": [
		82206,
		2206
	],
	"./commentConvo.js": [
		17564,
		7564
	],
	"./commentConvoFill.js": [
		48950,
		8950
	],
	"./commentFilled.js": [
		89731,
		9731
	],
	"./commentFilledFill.js": [
		31691,
		1155
	],
	"./commentWaiting.js": [
		66309,
		6309
	],
	"./commentWaitingFill.js": [
		67930,
		7930
	],
	"./fileAdd.js": [
		33856,
		3856
	],
	"./fileAddFill.js": [
		429,
		429
	],
	"./fileFile.js": [
		67224,
		7224
	],
	"./fileFileFill.js": [
		19882,
		9882
	],
	"./fileFilled.js": [
		53956,
		3956
	],
	"./fileFilledFill.js": [
		21391,
		1391
	],
	"./fileGuide.js": [
		96948,
		6948
	],
	"./fileGuideFill.js": [
		89940,
		9940
	],
	"./formAdd.js": [
		83232,
		3232
	],
	"./formAddCircle.js": [
		67977,
		7977
	],
	"./formAddCircleOutlined.js": [
		34373,
		4373
	],
	"./formAddSquare.js": [
		31630,
		1630
	],
	"./formAddSquareOutlined.js": [
		36626,
		6626
	],
	"./formBlank.js": [
		20701,
		701
	],
	"./formCheck.js": [
		71822,
		1822
	],
	"./formCheckCircle.js": [
		63305,
		3305
	],
	"./formCheckCircleOutlined.js": [
		23663,
		3663
	],
	"./formCheckSquare.js": [
		63940,
		3940
	],
	"./formCheckSquareOutlined.js": [
		90580,
		580
	],
	"./formDash.js": [
		24142,
		4142
	],
	"./formDashCircle.js": [
		18462,
		8462
	],
	"./formDashCircleOutlined.js": [
		76407,
		6407
	],
	"./formDashSquare.js": [
		40968,
		968
	],
	"./formDashSquareOutlined.js": [
		98802,
		8802
	],
	"./formRadioCheck.js": [
		28361,
		8361
	],
	"./formRadioDot.js": [
		79406,
		9406
	],
	"./formRadioUnchecked.js": [
		68027,
		8027
	],
	"./formText.js": [
		90010,
		10
	],
	"./formTextAlignCenter.js": [
		24179,
		4179
	],
	"./formTextAlignLeft.js": [
		74370,
		4370
	],
	"./formTextAlignRight.js": [
		13896,
		3896
	],
	"./formTextLong.js": [
		1781,
		1781
	],
	"./formToggle.js": [
		3257,
		3257
	],
	"./formX.js": [
		24295,
		4295
	],
	"./formXCircle.js": [
		92179,
		2179
	],
	"./formXCircleOutlined.js": [
		92819,
		2819
	],
	"./index.js": [
		50672
	],
	"./magnifyingGlass.js": [
		76796,
		6796
	],
	"./miscBolt.js": [
		91102,
		1102
	],
	"./miscBoltAlt.js": [
		64181,
		4181
	],
	"./miscBoltAltFill.js": [
		47133,
		7133
	],
	"./miscBoltFill.js": [
		47654,
		7654
	],
	"./miscBoltOutlined.js": [
		11172,
		1172
	],
	"./miscClock.js": [
		98710,
		8710
	],
	"./miscClockFill.js": [
		62818,
		2818
	],
	"./miscCloud.js": [
		86951,
		6951
	],
	"./miscCloudCheck.js": [
		64517,
		4517
	],
	"./miscCloudCheckFill.js": [
		1833,
		1833
	],
	"./miscCloudFill.js": [
		69399,
		9399
	],
	"./miscColor.js": [
		1270,
		3205
	],
	"./miscColorFill.js": [
		37998,
		7998
	],
	"./miscCookie.js": [
		86090,
		6090
	],
	"./miscCookieFill.js": [
		89115,
		9115
	],
	"./miscCreditCard.js": [
		66121,
		6121
	],
	"./miscCreditCardFill.js": [
		65019,
		5019
	],
	"./miscDollar.js": [
		85002,
		5002
	],
	"./miscEye.js": [
		89266,
		9266
	],
	"./miscEyeClosed.js": [
		54776,
		4776
	],
	"./miscEyeFill.js": [
		81338,
		1338
	],
	"./miscFingerprint.js": [
		34628,
		4628
	],
	"./miscFire.js": [
		70810,
		810
	],
	"./miscFireFill.js": [
		27376,
		7376
	],
	"./miscGraph.js": [
		44966,
		4966
	],
	"./miscGraphBox.js": [
		33450,
		3450
	],
	"./miscGraphBoxFill.js": [
		40590,
		590
	],
	"./miscHand.js": [
		58148,
		8148
	],
	"./miscHandFill.js": [
		95391,
		5391
	],
	"./miscHeadset.js": [
		75432,
		5432
	],
	"./miscHeadsetFill.js": [
		41909,
		1909
	],
	"./miscLearn.js": [
		31211,
		1211
	],
	"./miscLearnFill.js": [
		19840,
		9840
	],
	"./miscList.js": [
		7486,
		7486
	],
	"./miscMic.js": [
		89928,
		9928
	],
	"./miscMicFill.js": [
		27841,
		7841
	],
	"./miscPie.js": [
		81040,
		1040
	],
	"./miscPieFill.js": [
		54030,
		4030
	],
	"./miscPin.js": [
		21039,
		1039
	],
	"./miscPinFill.js": [
		55534,
		5534
	],
	"./miscSecurity.js": [
		73297,
		3297
	],
	"./miscSecurityFill.js": [
		36064,
		6064
	],
	"./miscSteps.js": [
		29178,
		9178
	],
	"./miscSteps1.js": [
		15112,
		5112
	],
	"./miscSteps2.js": [
		62681,
		2681
	],
	"./miscSteps3.js": [
		43187,
		3187
	],
	"./miscStepsAlt.js": [
		92231,
		2231
	],
	"./miscStepsFill.js": [
		62266,
		2266
	],
	"./miscTimelapse.js": [
		40566,
		566
	],
	"./miscUptime.js": [
		40616,
		616
	],
	"./miscUptimeFill.js": [
		71468,
		1468
	],
	"./miscWallet.js": [
		98385,
		8385
	],
	"./miscWalletFill.js": [
		70987,
		987
	],
	"./miscWorld.js": [
		50530,
		530
	],
	"./miscWorldFill.js": [
		85928,
		5928
	],
	"./navApps.js": [
		27150,
		7150
	],
	"./navAppsFill.js": [
		36669,
		6669
	],
	"./navBell.js": [
		98743,
		8743
	],
	"./navBellFill.js": [
		33361,
		3361
	],
	"./navBlog.js": [
		66093,
		6093
	],
	"./navBlogFill.js": [
		47730,
		7730
	],
	"./navBriefcase.js": [
		91050,
		1050
	],
	"./navBriefcaseFill.js": [
		21266,
		1266
	],
	"./navCog.js": [
		55649,
		5649
	],
	"./navCogFill.js": [
		84735,
		4735
	],
	"./navDashboard.js": [
		88104,
		8104
	],
	"./navDashboardFill.js": [
		44836,
		4836
	],
	"./navExplore.js": [
		42349,
		2349
	],
	"./navExploreFill.js": [
		37739,
		7739
	],
	"./navFolder.js": [
		81049,
		1049
	],
	"./navFolderFill.js": [
		8517,
		8517
	],
	"./navHelp.js": [
		43325,
		3325
	],
	"./navHelpFill.js": [
		80704,
		704
	],
	"./navHome.js": [
		96201,
		6201
	],
	"./navHomeFill.js": [
		82598,
		2598
	],
	"./navIntegrations.js": [
		25437,
		5437
	],
	"./navIntegrationsFill.js": [
		9862,
		9862
	],
	"./navInterfaces.js": [
		23242,
		3242
	],
	"./navInterfacesFill.js": [
		95930,
		5930
	],
	"./navMenu.js": [
		14774,
		4774
	],
	"./navMenuAlt.js": [
		92428,
		2428
	],
	"./navMoreHoriz.js": [
		32188,
		2188
	],
	"./navMoreVert.js": [
		90953,
		953
	],
	"./navSearch.js": [
		81216,
		1216
	],
	"./navSearchFill.js": [
		24242,
		4242
	],
	"./navTable.js": [
		72375,
		2375
	],
	"./navTableFill.js": [
		40494,
		494
	],
	"./navVersions.js": [
		70095,
		95
	],
	"./navVersionsFill.js": [
		4131,
		4131
	],
	"./partnerDashboard.js": [
		89468,
		9468
	],
	"./partnerEmbed.js": [
		78050,
		8050
	],
	"./personAccount.js": [
		7661,
		7661
	],
	"./personAdd.js": [
		50750,
		750
	],
	"./personAddFill.js": [
		73738,
		3738
	],
	"./personCircle.js": [
		58658,
		8658
	],
	"./personCircleFill.js": [
		26605,
		6605
	],
	"./personGroup.js": [
		12458,
		2458
	],
	"./personGroupFill.js": [
		59124,
		9124
	],
	"./personOne.js": [
		73345,
		3345
	],
	"./personOneFill.js": [
		19944,
		9944
	],
	"./ratingCool.js": [
		25284,
		5284
	],
	"./ratingHappy.js": [
		88462,
		926
	],
	"./ratingHappyAlt.js": [
		89117,
		9117
	],
	"./ratingHeart.js": [
		70547,
		547
	],
	"./ratingHeartFill.js": [
		68819,
		8819
	],
	"./ratingNeutral.js": [
		31139,
		1139
	],
	"./ratingNeutralAlt.js": [
		2293,
		2293
	],
	"./ratingSad.js": [
		22505,
		2505
	],
	"./ratingSadAlt.js": [
		92000,
		2000
	],
	"./ratingStar.js": [
		35809,
		5809
	],
	"./ratingStarFill.js": [
		8790,
		8790
	],
	"./ratingThumbsBoth.js": [
		25413,
		5413
	],
	"./ratingThumbsBothFill.js": [
		77056,
		7056
	],
	"./ratingThumbsDown.js": [
		5940,
		5940
	],
	"./ratingThumbsDownFill.js": [
		12623,
		2623
	],
	"./ratingThumbsUp.js": [
		10154,
		154
	],
	"./ratingThumbsUpFill.js": [
		58261,
		8261
	],
	"./ratingVeryHappy.js": [
		85344,
		5344
	],
	"./ratingVeryHappyAlt.js": [
		5600,
		5600
	],
	"./ratingVerySad.js": [
		83582,
		3582
	],
	"./ratingVerySadAlt.js": [
		41820,
		1820
	],
	"./ratingWink.js": [
		77285,
		7285
	],
	"./ratingWinkAlt.js": [
		90779,
		779
	],
	"./statusFilter.js": [
		43335,
		3335
	],
	"./statusFilterFill.js": [
		33061,
		3061
	],
	"./statusPaused.js": [
		38484,
		8484
	],
	"./statusPlaying.js": [
		39906,
		9906
	],
	"./statusPlayingFill.js": [
		8602,
		8602
	],
	"./team.js": [
		30623,
		623
	],
	"./teamFill.js": [
		25803,
		5803
	],
	"./upAndDownArrows.js": [
		50366,
		366
	],
	"./x.js": [
		53762,
		3762
	],
	"./zapDetails.js": [
		14782,
		4782
	],
	"./zapierLogo.js": [
		56369,
		6369
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 72363;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 77509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Img; }
});

;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/array-findindex.js
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, "findIndex", {
    value: function value(predicate) {
      "use strict";

      if (this == null) {
        throw new TypeError("Array.prototype.findIndex called on null or undefined");
      }

      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];

        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }

      return -1;
    },
    enumerable: false,
    configurable: false,
    writable: false
  });
}

/* harmony default export */ var array_findindex = (true);
//# sourceMappingURL=array-findindex.js.map
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/targetWidths.js
function targetWidths() {
  var resolutions = [];
  var prev = 100;
  var INCREMENT_PERCENTAGE = 8;
  var MAX_SIZE = 8192;

  var ensureEven = function ensureEven(n) {
    return 2 * Math.round(n / 2);
  };

  while (prev <= MAX_SIZE) {
    resolutions.push(ensureEven(prev));
    prev *= 1 + INCREMENT_PERCENTAGE / 100 * 2;
  }

  resolutions.push(MAX_SIZE);
  return resolutions;
}

/* harmony default export */ var es_targetWidths = (targetWidths());
//# sourceMappingURL=targetWidths.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/constructUrl.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright © 2015 by Coursera
Licensed under the Apache License 2.0, seen https://github.com/coursera/react-imgix/blob/master/LICENSE

Minor syntax modifications have been made
*/
var Base64 = (__webpack_require__(95978).Base64);

var PACKAGE_VERSION = "9.0.3";
 // @see https://www.imgix.com/docs/reference

var PARAM_EXPANSION = Object.freeze({
  // Adjustment
  brightness: "bri",
  contrast: "con",
  exposure: "exp",
  gamma: "gam",
  highlights: "high",
  hue: "hue",
  invert: "invert",
  saturation: "sat",
  shaddows: "shad",
  sharpness: "sharp",
  "unsharp-mask": "usm",
  "unsharp-radius": "usmrad",
  vibrance: "vib",
  // Automatic
  "auto-features": "auto",
  // Background
  "background-color": "bg",
  // Blend
  blend: "blend",
  "blend-mode": "bm",
  "blend-align": "ba",
  "blend-alpha": "balph",
  "blend-padding": "bp",
  "blend-width": "bw",
  "blend-height": "bh",
  "blend-fit": "bf",
  "blend-crop": "bc",
  "blend-size": "bs",
  "blend-x": "bx",
  "blend-y": "by",
  // Border & Padding
  border: "border",
  padding: "pad",
  // Face Detection
  "face-index": "faceindex",
  "face-padding": "facepad",
  faces: "faces",
  // Format
  "chroma-subsampling": "chromasub",
  "color-quantization": "colorquant",
  download: "dl",
  DPI: "dpi",
  format: "fm",
  "lossless-compression": "lossless",
  quality: "q",
  // Mask
  "mask-image": "mask",
  // Mask
  "noise-blur": "nr",
  "noise-sharpen": "nrs",
  // Palette n/a
  // PDF n/a
  // Pixel Density n/a
  // Rotation
  "flip-direction": "flip",
  orientation: "or",
  "rotation-angle": "rot",
  // Size
  "crop-mode": "crop",
  "fit-mode": "fit",
  "image-height": "h",
  "image-width": "w",
  // Stylize
  blurring: "blur",
  halftone: "htn",
  monotone: "mono",
  pixelate: "px",
  "sepia-tone": "sepia",
  // Trim TODO
  // Watermark TODO
  // Extra
  height: "h",
  width: "w"
});
var DEFAULT_OPTIONS = Object.freeze({
  auto: "format" // http://www.imgix.com/docs/reference/automatic#param-auto

});
/**
 * Construct a URL for an image with an Imgix proxy, expanding image options
 * per the [API reference docs](https://www.imgix.com/docs/reference).
 * @param  {String} src         src of raw image
 * @param  {Object} longOptions map of image API options, in long or short form per expansion rules
 * @return {String}             URL of image src transformed by Imgix
 */

function constructUrl(src, longOptions) {
  if (!src) {
    return "";
  }

  var keys = Object.keys(longOptions);
  var keysLength = keys.length;
  var url = src + "?";

  for (var i = 0; i < keysLength; i++) {
    var key = keys[i];
    var val = longOptions[key];

    if (PARAM_EXPANSION[key]) {
      key = PARAM_EXPANSION[key];
    } else {
      key = encodeURIComponent(key);
    }

    if (key.substr(-2) === "64") {
      val = Base64.encodeURI(val);
    }

    url += key + "=" + encodeURIComponent(val) + "&";
  }

  return url.slice(0, -1);
}

function buildURLPublic(src) {
  var imgixParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var disableLibraryParam = options.disableLibraryParam;

  var _extractQueryParams = extractQueryParams(src),
      _extractQueryParams2 = _slicedToArray(_extractQueryParams, 2),
      rawSrc = _extractQueryParams2[0],
      params = _extractQueryParams2[1];

  return constructUrl(rawSrc, _extends({}, params, imgixParams, disableLibraryParam ? {} : {
    ixlib: "react-".concat(PACKAGE_VERSION)
  }));
}

/* harmony default export */ var es_constructUrl = (constructUrl);

//# sourceMappingURL=constructUrl.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/extractQueryParams.js
function extractQueryParams_extractQueryParams(src) {
  var splitSrc = src.split("?");
  var url = splitSrc[0];
  var query = splitSrc[1];

  if (!query) {
    return [url, {}];
  }

  var paramsPairs = query.split("&");
  var params = {};
  var len = paramsPairs.length;

  for (var i = 0; i < len; i++) {
    var param = paramsPairs[i];
    var splitParam = param.split("=");
    var key = splitParam[0];
    var val = splitParam[1];
    params[key] = decodeURIComponent(val);
  }

  return [url, params];
}
//# sourceMappingURL=extractQueryParams.js.map
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/config.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var config = {
  warnings: {
    fallbackImage: true,
    sizesAttribute: true,
    invalidARFormat: true
  }
};

var _setWarning = function _setWarning(name, value) {
  if (!name || !(name in config.warnings)) {
    return;
  }

  config.warnings[name] = value;
};

var PublicConfigAPI = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PublicConfigAPI() {
    _classCallCheck(this, PublicConfigAPI);
  }

  _createClass(PublicConfigAPI, null, [{
    key: "disableWarning",
    value: function disableWarning(name) {
      _setWarning(name, false);
    }
  }, {
    key: "enableWarning",
    value: function enableWarning(name) {
      _setWarning(name, true);
    }
  }]);

  return PublicConfigAPI;
}()));

/* harmony default export */ var es_config = (config);

//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/common.js


 // Taken from https://github.com/reduxjs/redux/blob/v4.0.0/src/compose.js

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/HOCs/shouldComponentUpdateHOC.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function shouldComponentUpdateHOC_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function shouldComponentUpdateHOC_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function shouldComponentUpdateHOC_createClass(Constructor, protoProps, staticProps) { if (protoProps) shouldComponentUpdateHOC_defineProperties(Constructor.prototype, protoProps); if (staticProps) shouldComponentUpdateHOC_defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ShouldComponentUpdateHOC = function ShouldComponentUpdateHOC(WrappedComponent) {
  var ShouldComponentUpdateHOC = /*#__PURE__*/function (_Component) {
    _inherits(ShouldComponentUpdateHOC, _Component);

    var _super = _createSuper(ShouldComponentUpdateHOC);

    function ShouldComponentUpdateHOC() {
      var _this;

      shouldComponentUpdateHOC_classCallCheck(this, ShouldComponentUpdateHOC);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps) {
        var props = _this.props;
        warning_default()(nextProps.onMounted == _this.props.onMounted, "props.onMounted() is changing between renders. This is probably not intended. Ensure that a class method is being passed to Imgix rather than a function that is created every render. If this is intended, ignore this warning.");

        var customizer = function customizer(oldProp, newProp, key) {
          if (key === "children") {
            return shallowequal_default()(oldProp, newProp);
          }

          if (key === "imgixParams") {
            return shallowequal_default()(oldProp, newProp, function (a, b) {
              if (Array.isArray(a)) {
                return shallowequal_default()(a, b);
              }

              return undefined;
            });
          }

          if (key === "htmlAttributes") {
            return shallowequal_default()(oldProp, newProp);
          }

          if (key === "attributeConfig") {
            return shallowequal_default()(oldProp, newProp);
          }

          return undefined; // handled by shallowEqual
        };

        var propsAreEqual = shallowequal_default()(props, nextProps, customizer);
        return !propsAreEqual;
      });

      return _this;
    }

    shouldComponentUpdateHOC_createClass(ShouldComponentUpdateHOC, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      }
    }]);

    return ShouldComponentUpdateHOC;
  }(react.Component);

  ShouldComponentUpdateHOC.displayName = "ShouldComponentUpdateHOC(".concat(WrappedComponent.displayName, ")");
  return ShouldComponentUpdateHOC;
};


//# sourceMappingURL=shouldComponentUpdateHOC.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/HOCs/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/constants.js
function _objectValues(obj) {
  var values = [];
  var keys = Object.keys(obj);

  for (var k = 0; k < keys.length; k++) values.push(obj[keys[k]]);

  return values;
}

var DPR_QUALITY = {
  q_dpr1: 75,
  q_dpr2: 50,
  q_dpr3: 35,
  q_dpr4: 23,
  q_dpr5: 20
};
var DPR_QUALITY_VALUES = _objectValues(DPR_QUALITY);
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/react-imgix.js
function react_imgix_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { react_imgix_typeof = function _typeof(obj) { return typeof obj; }; } else { react_imgix_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return react_imgix_typeof(obj); }

function react_imgix_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function react_imgix_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function react_imgix_createClass(Constructor, protoProps, staticProps) { if (protoProps) react_imgix_defineProperties(Constructor.prototype, protoProps); if (staticProps) react_imgix_defineProperties(Constructor, staticProps); return Constructor; }

function react_imgix_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) react_imgix_setPrototypeOf(subClass, superClass); }

function react_imgix_setPrototypeOf(o, p) { react_imgix_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return react_imgix_setPrototypeOf(o, p); }

function react_imgix_createSuper(Derived) { var hasNativeReflectConstruct = react_imgix_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = react_imgix_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = react_imgix_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return react_imgix_possibleConstructorReturn(this, result); }; }

function react_imgix_possibleConstructorReturn(self, call) { if (call && (react_imgix_typeof(call) === "object" || typeof call === "function")) { return call; } return react_imgix_assertThisInitialized(self); }

function react_imgix_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function react_imgix_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function react_imgix_getPrototypeOf(o) { react_imgix_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return react_imgix_getPrototypeOf(o); }

function react_imgix_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function react_imgix_slicedToArray(arr, i) { return react_imgix_arrayWithHoles(arr) || react_imgix_iterableToArrayLimit(arr, i) || react_imgix_unsupportedIterableToArray(arr, i) || react_imgix_nonIterableRest(); }

function react_imgix_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function react_imgix_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return react_imgix_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return react_imgix_arrayLikeToArray(o, minLen); }

function react_imgix_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function react_imgix_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function react_imgix_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function react_imgix_extends() { react_imgix_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_imgix_extends.apply(this, arguments); }










var react_imgix_PACKAGE_VERSION = "9.0.3";
var NODE_ENV = "production";

var buildKey = function buildKey(idx) {
  return "react-imgix-".concat(idx);
};

var defaultImgixParams = {
  auto: ["format"]
};
var defaultAttributeMap = {
  src: "src",
  srcSet: "srcSet",
  sizes: "sizes"
};

var noop = function noop() {};

var COMMON_PROP_TYPES = {
  className: (prop_types_default()).string,
  onMounted: (prop_types_default()).func,
  htmlAttributes: (prop_types_default()).object
};

var SHARED_IMGIX_AND_SOURCE_PROP_TYPES = react_imgix_extends({}, COMMON_PROP_TYPES, {
  disableQualityByDPR: (prop_types_default()).bool,
  disableSrcSet: (prop_types_default()).bool,
  disableLibraryParam: (prop_types_default()).bool,
  imgixParams: (prop_types_default()).object,
  sizes: (prop_types_default()).string,
  width: (prop_types_default()).number,
  height: (prop_types_default()).number,
  src: (prop_types_default()).string.isRequired
});
/**
 * Validates that an aspect ratio is in the format w:h. If false is returned, the aspect ratio is in the wrong format.
 */


function aspectRatioIsValid(aspectRatio) {
  if (typeof aspectRatio !== "string") {
    return false;
  }

  return /^\d+(\.\d+)?:\d+(\.\d+)?$/.test(aspectRatio);
}

var setParentRef = function setParentRef(parentRef, el) {
  if (!parentRef) {
    return;
  } // assign ref based on if it's a callback vs object


  if (typeof parentRef === "function") {
    parentRef(el);
  } else {
    parentRef.current = el;
  }
};

var buildSrcSetPairWithFixedHeight = function buildSrcSetPairWithFixedHeight(url, targetWidth, fixedHeight, _) {
  return url + "&h=" + fixedHeight + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildSrcSetPairWithTargetWidth = function buildSrcSetPairWithTargetWidth(url, targetWidth, _1, _2) {
  return url + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildDprSrcWithQuality = function buildDprSrcWithQuality(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithoutQuality = function buildDprSrcWithoutQuality(url, _, dpr) {
  return url + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithQualityByDpr = function buildDprSrcWithQualityByDpr(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};
/**
 * Build a imgix source url with parameters from a raw url
 */


function buildSrc(_ref) {
  var inputSrc = _ref.src,
      width = _ref.width,
      height = _ref.height,
      disableLibraryParam = _ref.disableLibraryParam,
      disableSrcSet = _ref.disableSrcSet,
      imgixParams = _ref.imgixParams,
      disableQualityByDPR = _ref.disableQualityByDPR;
  var fixedSize = width != null || height != null;

  var _extractQueryParams = extractQueryParams_extractQueryParams(inputSrc),
      _extractQueryParams2 = react_imgix_slicedToArray(_extractQueryParams, 2),
      rawSrc = _extractQueryParams2[0],
      params = _extractQueryParams2[1];

  var srcOptions = react_imgix_extends({}, params, imgixParams, disableLibraryParam ? {} : {
    ixlib: "react-".concat(react_imgix_PACKAGE_VERSION)
  }, fixedSize && height ? {
    height: height
  } : {}, fixedSize && width ? {
    width: width
  } : {});

  var src = es_constructUrl(rawSrc, srcOptions);
  var srcSet;

  if (disableSrcSet) {
    srcSet = src;
  } else {
    if (fixedSize) {
      var q = srcOptions.q,
          urlParams = _objectWithoutProperties(srcOptions, ["q"]);

      var constructedUrl = es_constructUrl(rawSrc, urlParams);
      var srcFn = buildDprSrcWithQualityByDpr;

      if (q) {
        srcFn = buildDprSrcWithQuality;
      } else if (disableQualityByDPR) {
        srcFn = buildDprSrcWithoutQuality;
      }

      srcSet = "";
      var len = DPR_QUALITY_VALUES.length;

      for (var i = 0; i < len; i++) {
        var quality = DPR_QUALITY_VALUES[i];
        srcSet += srcFn(constructedUrl, q || quality, i + 1) + ", ";
      }

      srcSet = srcSet.slice(0, -2);
    } else {
      var _width = srcOptions.width,
          w = srcOptions.w,
          _height = srcOptions.height,
          _urlParams = _objectWithoutProperties(srcOptions, ["width", "w", "height"]);

      var _constructedUrl = es_constructUrl(rawSrc, _urlParams);

      var aspectRatio = imgixParams.ar;
      var showARWarning = aspectRatio != null && aspectRatioIsValid(aspectRatio) === false;
      var _srcFn = buildSrcSetPairWithTargetWidth;

      if (_height) {
        _srcFn = buildSrcSetPairWithFixedHeight;
      }

      srcSet = "";
      var _len = es_targetWidths.length;

      for (var _i2 = 0; _i2 < _len; _i2++) {
        var targetWidth = es_targetWidths[_i2];
        srcSet += _srcFn(_constructedUrl, targetWidth, _height) + ", ";
      }

      srcSet = srcSet.slice(0, -2);

      if (NODE_ENV !== "production" && showARWarning && es_config.warnings.invalidARFormat) {
        console.warn("[Imgix] The aspect ratio passed (\"".concat(aspectRatio, "\") is not in the correct format. The correct format is \"W:H\"."));
      }
    }
  }

  return {
    src: src,
    srcSet: srcSet
  };
}
/**
 * Combines default imgix params with custom imgix params to make a imgix params config object
 */


function imgixParams(props) {
  var params = react_imgix_extends({}, defaultImgixParams, props.imgixParams);

  return react_imgix_extends({}, params);
}
/**
 * React component used to render <img> elements with Imgix
 */


var ReactImgix = /*#__PURE__*/function (_Component) {
  react_imgix_inherits(ReactImgix, _Component);

  var _super = react_imgix_createSuper(ReactImgix);

  function ReactImgix(props) {
    var _this;

    react_imgix_classCallCheck(this, ReactImgix);

    _this = _super.call(this, props);
    _this.imgRef = null;
    return _this;
  }

  react_imgix_createClass(ReactImgix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.imgRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _extends2;

      var _this$props = this.props,
          disableSrcSet = _this$props.disableSrcSet,
          type = _this$props.type,
          width = _this$props.width,
          height = _this$props.height; // Pre-render checks

      if (NODE_ENV !== "production" && es_config.warnings.sizesAttribute) {
        if (this.props.width == null && this.props.height == null && this.props.sizes == null && !this.props._inPicture) {
          console.warn("If width and height are not set, a sizes attribute should be passed.");
        }
      }

      var _buildSrc = buildSrc(react_imgix_extends({}, this.props, {
        type: "img",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc.src,
          srcSet = _buildSrc.srcSet;

      var attributeConfig = react_imgix_extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = react_imgix_extends({}, this.props.htmlAttributes, (_extends2 = {}, react_imgix_defineProperty(_extends2, attributeConfig.sizes, this.props.sizes), react_imgix_defineProperty(_extends2, "className", this.props.className), react_imgix_defineProperty(_extends2, "width", width <= 1 ? null : width), react_imgix_defineProperty(_extends2, "height", height <= 1 ? null : height), react_imgix_defineProperty(_extends2, attributeConfig.src, src), react_imgix_defineProperty(_extends2, "ref", function ref(el) {
        _this2.imgRef = el;

        if (_this2.props.htmlAttributes !== undefined && "ref" in _this2.props.htmlAttributes) {
          setParentRef(_this2.props.htmlAttributes.ref, _this2.imgRef);
        }
      }), _extends2));

      if (!disableSrcSet) {
        childProps[attributeConfig.srcSet] = srcSet;
      }

      return /*#__PURE__*/react.createElement("img", childProps);
    }
  }]);

  return ReactImgix;
}(react.Component);

react_imgix_defineProperty(ReactImgix, "propTypes", react_imgix_extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

react_imgix_defineProperty(ReactImgix, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

ReactImgix.displayName = "ReactImgix";
/**
 * React component used to render <picture> elements with Imgix
 */

var PictureImpl = /*#__PURE__*/function (_Component2) {
  react_imgix_inherits(PictureImpl, _Component2);

  var _super2 = react_imgix_createSuper(PictureImpl);

  function PictureImpl(props) {
    var _this3;

    react_imgix_classCallCheck(this, PictureImpl);

    _this3 = _super2.call(this, props);
    _this3.pictureRef = null;
    return _this3;
  }

  react_imgix_createClass(PictureImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.pictureRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children; // make sure all of our children have key set, otherwise we get react warnings

      var _children = react.Children.map(children, function (child, idx) {
        return /*#__PURE__*/react.cloneElement(child, {
          key: buildKey(idx),
          _inPicture: true
        });
      }) || [];
      /*
      We need to make sure an <img /> or <Imgix /> is the last child so we look for one in children
        a. if we find one, move it to the last entry if it's not already there
        b. if we don't find one, warn the user as they probably want to pass one.
      */
      // look for an <img> or <ReactImgix type='img'> - at the bare minimum we have to have a single <img> element or else it will not work.


      var imgIdx = _children.findIndex(function (c) {
        return c.type === "img" || c.type === ReactImgix || c.type === ReactImgixWrapped;
      });

      if (imgIdx === -1 && es_config.warnings.fallbackImage) {
        console.warn("No fallback <img /> or <Imgix /> found in the children of a <picture> component. A fallback image should be passed to ensure the image renders correctly at all dimensions.");
      } else if (imgIdx !== _children.length - 1) {
        // found one, need to move it to the end
        _children.push(_children.splice(imgIdx, 1)[0]);
      }

      return /*#__PURE__*/react.createElement("picture", {
        ref: function ref(el) {
          return _this4.pictureRef = el;
        },
        children: _children
      });
    }
  }]);

  return PictureImpl;
}(react.Component);

react_imgix_defineProperty(PictureImpl, "propTypes", react_imgix_extends({}, COMMON_PROP_TYPES, {
  children: (prop_types_default()).any
}));

react_imgix_defineProperty(PictureImpl, "defaultProps", {
  onMounted: noop
});

PictureImpl.displayName = "ReactImgixPicture";
/**
 * React component used to render <source> elements with Imgix
 */

var SourceImpl = /*#__PURE__*/function (_Component3) {
  react_imgix_inherits(SourceImpl, _Component3);

  var _super3 = react_imgix_createSuper(SourceImpl);

  function SourceImpl(props) {
    var _this5;

    react_imgix_classCallCheck(this, SourceImpl);

    _this5 = _super3.call(this, props);
    _this5.sourceRef = null;
    return _this5;
  }

  react_imgix_createClass(SourceImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.sourceRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
          _extends3;

      var _this$props2 = this.props,
          disableSrcSet = _this$props2.disableSrcSet,
          width = _this$props2.width,
          height = _this$props2.height;

      var _buildSrc2 = buildSrc(react_imgix_extends({}, this.props, {
        type: "source",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc2.src,
          srcSet = _buildSrc2.srcSet;

      var attributeConfig = react_imgix_extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = react_imgix_extends({}, this.props.htmlAttributes, (_extends3 = {}, react_imgix_defineProperty(_extends3, attributeConfig.sizes, this.props.sizes), react_imgix_defineProperty(_extends3, "className", this.props.className), react_imgix_defineProperty(_extends3, "width", width <= 1 ? null : width), react_imgix_defineProperty(_extends3, "height", height <= 1 ? null : height), react_imgix_defineProperty(_extends3, "ref", function ref(el) {
        _this6.sourceRef = el;

        if (_this6.props.htmlAttributes !== undefined && "ref" in _this6.props.htmlAttributes) {
          setParentRef(_this6.props.htmlAttributes.ref, _this6.sourceRef);
        }
      }), _extends3)); // inside of a <picture> element a <source> element ignores its src
      // attribute in favor of srcSet so we set that with either an actual
      // srcSet or a single src


      if (disableSrcSet) {
        childProps[attributeConfig.srcSet] = src;
      } else {
        childProps[attributeConfig.srcSet] = "".concat(srcSet);
      } // for now we'll take media from htmlAttributes which isn't ideal because
      //   a) this isn't an <img>
      //   b) passing objects as props means that react will always rerender
      //      since objects dont respond correctly to ===


      return /*#__PURE__*/react.createElement("source", childProps);
    }
  }]);

  return SourceImpl;
}(react.Component);

react_imgix_defineProperty(SourceImpl, "propTypes", react_imgix_extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

react_imgix_defineProperty(SourceImpl, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

SourceImpl.displayName = "ReactImgixSource";
var ReactImgixWrapped = compose(ShouldComponentUpdateHOC)(ReactImgix);
var Picture = compose(ShouldComponentUpdateHOC)(PictureImpl);
var Source = compose(ShouldComponentUpdateHOC)(SourceImpl);
/* harmony default export */ var react_imgix = (ReactImgixWrapped);

//# sourceMappingURL=react-imgix.js.map
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(32222);
;// CONCATENATED MODULE: ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ var ResizeObserver_es = (index);

;// CONCATENATED MODULE: ../../node_modules/react-measure/dist/index.esm.js







var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}

function index_esm_getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }

  return calculations;
}

/**
 * Returns the global window object associated with provided element.
 */
function index_esm_getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
  // provided element.

  return ownerGlobal || window;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      (0,inheritsLoose/* default */.Z)(WithContentRect, _Component);

      function WithContentRect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;
        _this._window = null;

        _this.measure = function (entries) {
          var contentRect = index_esm_getContentRect(_this._node, types || getTypes(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });

              if (typeof _this.props.onResize === 'function') {
                _this.props.onResize(contentRect);
              }
            }
          });
        };

        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.unobserve(_this._node);
          }

          _this._node = node;
          _this._window = index_esm_getWindowOf(_this._node);
          var innerRef = _this.props.innerRef;

          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(_this._node);
            } else {
              innerRef.current = _this._node;
            }
          }

          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.observe(_this._node);
          }
        };

        return _this;
      }

      var _proto = WithContentRect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new ResizeObserver_es(this.measure);

        if (this._node !== null) {
          this._resizeObserver.observe(this._node);

          if (typeof this.props.onResize === 'function') {
            this.props.onResize(index_esm_getContentRect(this._node, types || getTypes(this.props)));
          }
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._window !== null) {
          this._window.cancelAnimationFrame(this._animationFrameID);
        }

        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();

          this._resizeObserver = null;
        }
      };

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            onResize = _this$props.onResize,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["innerRef", "onResize"]);

        return (0,react.createElement)(WrappedComponent, (0,esm_extends/* default */.Z)({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };

      return WithContentRect;
    }(react.Component), _class.propTypes = {
      client: (prop_types_default()).bool,
      offset: (prop_types_default()).bool,
      scroll: (prop_types_default()).bool,
      bounds: (prop_types_default()).bool,
      margin: (prop_types_default()).bool,
      innerRef: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).func]),
      onResize: (prop_types_default()).func
    }, _temp;
  };
}

var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = (prop_types_default()).func;

/* harmony default export */ var index_esm = ((/* unused pure expression or super */ null && (Measure)));


;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/findClosest.js
/**
 * Finds the closest value in the search array to the value provided using a binary search
 * If the value is in the middle of two candidate values, it chooses the higher value
 */
function findClosest(searchValue, arr) {
  if (searchValue < arr[0]) {
    return arr[0];
  }

  if (searchValue > arr[arr.length - 1]) {
    return arr[arr.length - 1];
  }

  var mid;
  var lo = 0;
  var hi = arr.length - 1;

  while (hi - lo > 1) {
    mid = Math.floor((lo + hi) / 2);

    if (arr[mid] < searchValue) {
      lo = mid;
    } else {
      hi = mid;
    }
  }

  if (searchValue - arr[lo] < arr[hi] - searchValue) {
    return arr[lo];
  }

  return arr[hi];
}
//# sourceMappingURL=findClosest.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/react-imgix-bg.js
function react_imgix_bg_slicedToArray(arr, i) { return react_imgix_bg_arrayWithHoles(arr) || react_imgix_bg_iterableToArrayLimit(arr, i) || react_imgix_bg_unsupportedIterableToArray(arr, i) || react_imgix_bg_nonIterableRest(); }

function react_imgix_bg_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function react_imgix_bg_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return react_imgix_bg_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return react_imgix_bg_arrayLikeToArray(o, minLen); }

function react_imgix_bg_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function react_imgix_bg_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function react_imgix_bg_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function react_imgix_bg_extends() { react_imgix_bg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return react_imgix_bg_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { react_imgix_bg_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function react_imgix_bg_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var react_imgix_bg_PACKAGE_VERSION = "9.0.3";

var react_imgix_bg_noop = function noop() {};

var findNearestWidth = function findNearestWidth(actualWidth) {
  return findClosest(actualWidth, es_targetWidths);
};

var toFixed = function toFixed(dp, value) {
  return +value.toFixed(dp);
};

var BackgroundImpl = function BackgroundImpl(props) {
  var measureRef = props.measureRef,
      measure = props.measure,
      contentRect = props.contentRect,
      _props$imgixParams = props.imgixParams,
      imgixParams = _props$imgixParams === void 0 ? {} : _props$imgixParams,
      onLoad = props.onLoad,
      disableLibraryParam = props.disableLibraryParam,
      src = props.src,
      children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className;
  var forcedWidth = imgixParams.w,
      forcedHeight = imgixParams.h;
  var hasDOMDimensions = contentRect.bounds.width != null && contentRect.bounds.height != null;
  var htmlAttributes = props.htmlAttributes || {};
  var dpr = toFixed(2, imgixParams.dpr || __webpack_require__.g.devicePixelRatio || 1);
  var ref = htmlAttributes.ref;

  var onRef = function onRef(el) {
    measureRef(el);

    if (typeof ref === "function") {
      ref(el);
    }
  };

  var _ref = function () {
    var bothWidthAndHeightPassed = forcedWidth != null && forcedHeight != null;

    if (bothWidthAndHeightPassed) {
      return {
        width: forcedWidth,
        height: forcedHeight
      };
    }

    if (!hasDOMDimensions) {
      return {
        width: undefined,
        height: undefined
      };
    }

    var ar = contentRect.bounds.width / contentRect.bounds.height;
    var neitherWidthNorHeightPassed = forcedWidth == null && forcedHeight == null;

    if (neitherWidthNorHeightPassed) {
      var _width = findNearestWidth(contentRect.bounds.width);

      var _height = Math.ceil(_width / ar);

      return {
        width: _width,
        height: _height
      };
    }

    if (forcedWidth != null) {
      var _height2 = Math.ceil(forcedWidth / ar);

      return {
        width: forcedWidth,
        height: _height2
      };
    } else if (forcedHeight != null) {
      var _width2 = Math.ceil(forcedHeight * ar);

      return {
        width: _width2,
        height: forcedHeight
      };
    }
  }(),
      width = _ref.width,
      height = _ref.height;

  var isReady = width != null && height != null;

  var commonProps = _objectSpread({}, htmlAttributes);

  if (!isReady) {
    return /*#__PURE__*/react.createElement("div", react_imgix_bg_extends({}, commonProps, {
      className: "react-imgix-bg-loading ".concat(className),
      ref: onRef
    }), children);
  }

  var renderedSrc = function () {
    var _extractQueryParams = extractQueryParams_extractQueryParams(src),
        _extractQueryParams2 = react_imgix_bg_slicedToArray(_extractQueryParams, 2),
        rawSrc = _extractQueryParams2[0],
        params = _extractQueryParams2[1];

    var srcOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, params), {}, {
      fit: "crop"
    }, imgixParams), disableLibraryParam ? {} : {
      ixlib: "react-".concat(react_imgix_bg_PACKAGE_VERSION)
    }), {}, {
      width: width,
      height: height,
      dpr: dpr
    });

    return es_constructUrl(rawSrc, srcOptions);
  }();

  var style = _objectSpread(_objectSpread({}, htmlAttributes.style), {}, {
    backgroundImage: "url(".concat(renderedSrc, ")"),
    backgroundSize: (htmlAttributes.style || {}).backgroundSize !== undefined ? htmlAttributes.style.backgroundSize : "cover"
  });

  return /*#__PURE__*/react.createElement("div", react_imgix_bg_extends({}, commonProps, {
    className: className,
    ref: onRef,
    style: style
  }), children);
};

var Background = withContentRect("bounds")(BackgroundImpl);

//# sourceMappingURL=react-imgix-bg.js.map
;// CONCATENATED MODULE: ../../node_modules/react-imgix/es/index.js




/* harmony default export */ var es = (react_imgix);


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Shadows.js
var Shadows = __webpack_require__(10391);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Img/Img.js




const Styles = (0,labelStyles/* labelStyles */.B)('Img', {
    root: emotion_react_browser_esm/* css */.iv `
    all: unset;
    box-sizing: border-box;
    transition: box-shadow ${Animation/* Animation.transitionDuration */.f.transitionDuration}
      ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};
    max-width: 100%;
  `,
});
const defaultProps = {
    borderRadius: 5,
    loading: 'lazy',
};
const Img = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const sharedProps = {
        className: props.className,
        css: props.className ? undefined : Styles.root,
        height: props.height,
        alt: props.alt || '',
        'aria-hidden': props.ariaHidden,
        'data-testid': 'img',
        loading: props.loading,
        onError: props.onError,
        onLoad: props.onLoad,
        sizes: props.sizes,
        src: props.src,
        width: props.width,
        style: !props.className
            ? {
                display: props.isBlock ? 'block' : undefined,
                width: props.isFullWidth ? '100%' : props.width,
                height: props.height,
                borderRadius: props.borderRadius,
                boxShadow: props.shadow && Shadows/* Shadows */.f[props.shadow],
                objectFit: props.objectFit,
                objectPosition: props.objectPosition,
            }
            : undefined,
    };
    if (!props.src.includes('imgix.net')) {
        return ((0,isolateComponent/* isolateComponent */.U)("img", Object.assign({}, sharedProps)));
    }
    return ((0,isolateComponent/* isolateComponent */.U)(es, { className: sharedProps.className, css: sharedProps.css, height: sharedProps.height, htmlAttributes: {
            alt: sharedProps.alt,
            'aria-hidden': sharedProps['aria-hidden'],
            'data-testid': sharedProps['data-testid'],
            loading: sharedProps.loading,
            onError: sharedProps.onError,
            onLoad: sharedProps.onLoad,
            style: sharedProps.style,
        }, imgixParams: {
            ar: props.aspectRatio,
            fit: props.aspectRatio || props.width || props.height || props.sizes
                ? 'crop'
                : undefined,
        }, sizes: sharedProps.sizes, src: sharedProps.src, width: sharedProps.width }));
};
//# sourceMappingURL=Img.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 52819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70776);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98628);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77293);
/* harmony import */ var _utils_clamp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37260);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('ProgressBar', {
    root: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
        position: 'relative',
        height: 5,
        borderRadius: 2.5,
        backgroundColor: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.neutral300 */ .w.neutral300,
    }),
    progress: (color) => [
        (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
            height: 'inherit',
            borderRadius: 'inherit',
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            transition: `all ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Animation.transitionDuration */ .f.transitionDuration} ease-in-out`,
            backgroundColor: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors */ .w[color],
        }),
    ],
});
const ProgressBar = (_a) => {
    var { max = 1, min = 0, color = 'blue' } = _a, props = __rest(_a, ["max", "min", "color"]);
    const value = (0,_utils_clamp__WEBPACK_IMPORTED_MODULE_4__/* .clamp */ .u)(props.value, min, max);
    const range = max - min;
    const decimal = (value - min) / range;
    const width = `${decimal * 100}%`;
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("div", { css: Styles.root },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("div", { css: Styles.progress(color), "data-testid": "progress", style: {
                width,
            } })));
};
//# sourceMappingURL=ProgressBar.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 22211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77293);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70776);
/* harmony import */ var _VisuallyHidden__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18672);




const defaultProps = {
    ariaLabel: 'Loading',
    color: 'black',
    size: 'small',
};
const spin = _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4 `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const sizes = {
    small: {
        diameter: 20,
        thickness: 4,
    },
    medium: {
        diameter: 30,
        thickness: 6,
    },
    large: {
        diameter: 60,
        thickness: 10,
    },
};
const mapPropToColorValue = (color) => {
    let returnedColor;
    switch (color) {
        case 'black':
            returnedColor = _theme__WEBPACK_IMPORTED_MODULE_1__/* .Colors.neutral800 */ .w.neutral800;
            break;
        case 'white':
            returnedColor = _theme__WEBPACK_IMPORTED_MODULE_1__/* .Colors.neutral100 */ .w.neutral100;
            break;
        case 'light':
            returnedColor = _theme__WEBPACK_IMPORTED_MODULE_1__/* .Colors.neutral100 */ .w.neutral100;
            break;
        case 'dark':
            returnedColor = _theme__WEBPACK_IMPORTED_MODULE_1__/* .Colors.neutral800 */ .w.neutral800;
    }
    return returnedColor;
};
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .labelStyles */ .B)('Spinner', {
    root: (props) => [
        {
            animation: `${spin} 0.75s linear infinite`,
            borderStyle: 'solid',
            borderRightColor: 'transparent',
            borderRadius: '50%',
            opacity: 0.7,
        },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .withModifier */ .Q)(props.size, {
            height: sizes[props.size].diameter,
            width: sizes[props.size].diameter,
            borderWidth: `${sizes[props.size].thickness}px`,
        }),
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .withModifier */ .Q)(props.color, {
            borderColor: mapPropToColorValue(props.color),
            borderRightColor: 'transparent',
        }),
    ],
});
const Spinner = (props) => {
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .isolateComponent */ .U)("div", { css: Styles.root(props), "data-testid": "spinner", role: "status" },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .isolateComponent */ .U)(_VisuallyHidden__WEBPACK_IMPORTED_MODULE_5__/* .VisuallyHidden */ .T, null, props.ariaLabel)));
};
Spinner.defaultProps = defaultProps;
//# sourceMappingURL=Spinner.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 55414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3000);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70776);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77293);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const defaultProps = {
    color: 'neutral800',
    tag: 'span',
    textAlign: 'inherit',
    type: 'paragraph3',
    hasTransition: true,
};
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('Text', {
    root: (props) => [
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .withModifier */ .Q)(props.type, _theme__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT[props.type]),
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .withModifier */ .Q)(props.color, { color: _theme__WEBPACK_IMPORTED_MODULE_3__/* .Colors */ .w[props.color] }),
        props.fontWeight &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .withModifier */ .Q)(`fontWeight-${props.fontWeight}`, {
                fontWeight: props.fontWeight,
            }),
        {
            margin: props.margin,
            maxWidth: '100%',
            textAlign: props.textAlign,
        },
        props.hasTransition && {
            transition: 'color 0.2s ease-in-out',
        },
    ],
});
const Text = (_a) => {
    var { color, hasTransition = true, tag = 'span', textAlign = 'inherit', type = 'paragraph3' } = _a, props = __rest(_a, ["color", "hasTransition", "tag", "textAlign", "type"]);
    const interpolatedProps = Object.assign({ color: color !== null && color !== void 0 ? color : 'neutral800', hasTransition,
        tag,
        textAlign,
        type }, props);
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .isolateComponent */ .U)(interpolatedProps.tag, { css: Styles.root(interpolatedProps) }, interpolatedProps.children));
};
//# sourceMappingURL=Text.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 29476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; },
  "S": function() { return /* binding */ positionStyles; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useDimensions.js

const defaultDOMRect = {
    height: 0,
    width: 0,
    x: 0,
    y: 0,
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    toJSON: () => { },
};
const useDimensions = () => {
    const ref = (0,react.useRef)(null);
    const [dimensions, setDimensions] = (0,react.useState)(defaultDOMRect);
    (0,react.useEffect)(() => {
        const rect = ref && ref.current
            ? ref.current.getBoundingClientRect()
            : defaultDOMRect;
        setDimensions(rect);
    }, []);
    return [ref, dimensions];
};
//# sourceMappingURL=useDimensions.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Shadows.js
var Shadows = __webpack_require__(10391);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Tooltip/Tooltip.js




const distance = '5px';
const tooltipOpenAnimation = (0,emotion_react_browser_esm/* keyframes */.F4)({
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
const positionStyles = {
    northwest: emotion_react_browser_esm/* css */.iv `
    bottom: calc(100% + ${distance});
    left: 0;
  `,
    north: emotion_react_browser_esm/* css */.iv `
    bottom: calc(100% + ${distance});
    left: 50%;
    transform: translateX(-50%);
  `,
    northeast: emotion_react_browser_esm/* css */.iv `
    bottom: calc(100% + ${distance});
    right: 0;
  `,
    east: emotion_react_browser_esm/* css */.iv `
    left: calc(100% + ${distance});
    top: 50%;
    transform: translateY(-50%);
  `,
    southeast: emotion_react_browser_esm/* css */.iv `
    top: calc(100% + ${distance});
    right: 0;
  `,
    south: emotion_react_browser_esm/* css */.iv `
    top: calc(100% + ${distance});
    left: 50%;
    transform: translateX(-50%);
  `,
    southwest: emotion_react_browser_esm/* css */.iv `
    top: calc(100% + ${distance});
    left: 0;
  `,
    west: emotion_react_browser_esm/* css */.iv `
    right: calc(100% + ${distance});
    top: 50%;
    transform: translateY(-50%);
  `,
};
const singleLineHeightPlusPadding = 28;
const defaultPosition = 'south';
const Styles = (0,labelStyles/* labelStyles */.B)('Tooltip', {
    root: ({ position = defaultPosition, allowMultiline, isInteractive }, isMultiline) => [
        emotion_react_browser_esm/* css */.iv `
      display: block;
      color: ${Colors/* Colors.neutral100 */.w.neutral100};
      text-align: center;
      border-radius: 100px;
      position: relative;
      z-index: 2;
      box-shadow: ${Shadows/* Shadows.elevation30 */.f.elevation30};
      background-color: ${Colors/* Colors.neutral800 */.w.neutral800};
      width: max-content;
      max-width: 300px;
      animation: ${Animation/* Animation.transitionDuration */.f.transitionDuration}
        ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction} ${tooltipOpenAnimation};
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
      padding: 2px 11px;
      */

      // Increase mouse area so tooltip doesn't disappear when
      // mousing over a gap between its toggle and the tooltip itself.
      &::before {
        content: '';
        position: absolute;
        top: -${distance};
        right: -${distance};
        bottom: -${distance};
        left: -${distance};
        z-index: -1;
      }
    `,
        position &&
            emotion_react_browser_esm/* css */.iv `
        label: -${position};
        position: absolute;
        ${positionStyles[position]};
      `,
        isMultiline &&
            emotion_react_browser_esm/* css */.iv `
        label: -multiline;
        border-radius: 10px;
        padding: 16px 14px;
        text-align: left;
      `,
        !allowMultiline &&
            emotion_react_browser_esm/* css */.iv `
        label: -single-line;
        height: ${singleLineHeightPlusPadding}px;
        padding: 2px 11px;
      `,
        !isInteractive &&
            emotion_react_browser_esm/* css */.iv `
        label: -non-interactive;
        pointer-events: none;
      `,
    ],
    content: (props) => [
        emotion_react_browser_esm/* css */.iv `
      display: block;
    `,
        !props.allowMultiline &&
            emotion_react_browser_esm/* css */.iv `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      `,
    ],
});
const Tooltip = (props) => {
    const [ref, { height }] = useDimensions();
    const isMultiline = height > singleLineHeightPlusPadding;
    return ((0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": props.ariaHidden, css: Styles.root(props, isMultiline), "data-testid": `tooltip-${props.position}`, id: props.id, ref: ref, role: "tooltip" },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.content(props) }, props.children)));
};
Tooltip.defaultProps = {
    allowMultiline: false,
    position: defaultPosition,
};
//# sourceMappingURL=Tooltip.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 87593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ TooltipWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/hashString.js
var hashString = __webpack_require__(49015);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/utils/createUniqueClassName.js

const createUniqueClassName = (block, elementName) => {
    const hash = (0,hashString/* hashString */.W)('design-system' + block + elementName);
    return `${block}__${elementName}-${hash}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(29476);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useIntersect.js
var useIntersect = __webpack_require__(69480);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/uniqueId.js
var uniqueId = __webpack_require__(61814);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/TooltipWrapper/TooltipWrapper.js








const contentNodeClassName = createUniqueClassName('TooltipWrapper', 'content');
const contentNodeSelector = `.${contentNodeClassName}` + '[class]'.repeat(5);
const Styles = (0,labelStyles/* labelStyles */.B)('TooltipWrapper', {
    root: (props, correctedPosition) => [
        emotion_react_browser_esm/* css */.iv `
      position: relative;
      display: inline-block;

      ${contentNodeSelector} {
        position: absolute;
        z-index: 1;
        ${correctedPosition ? Tooltip/* positionStyles */.S[correctedPosition] : null};
        opacity: 0;
        transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
        pointer-events: none;
      }

      // Edge doesnt understand ':focus-within' and will therefore
      // ignore the styles if theyre comboed like '&:hover, &:focus-within'.
      // As a workaround, separate the duplicated styles.
      &:hover ${contentNodeSelector} {
        opacity: 1;
        pointer-events: auto;
      }

      &:focus-within ${contentNodeSelector} {
        opacity: 1;
        pointer-events: auto;
      }
    `,
        !props.isTooltipInteractive &&
            emotion_react_browser_esm/* css */.iv `
        ${contentNodeSelector}[class] {
          label: -non-interactive;
          pointer-events: none;
        }
      `,
        !props.showTooltipOnTouchDevices &&
            emotion_react_browser_esm/* css */.iv `
        @media (hover: none) {
          ${contentNodeSelector}[class] {
            label: -hide-tooltip-on-touch-devices;
            opacity: 0;
          }
        }
      `,
        props.isBlock &&
            emotion_react_browser_esm/* css */.iv `
        label: -block;
        display: block;
      `,
    ],
});
const correctPosition = (position, result) => {
    const { isTopIntersecting, isBottomIntersecting, isLeftIntersecting, isRightIntersecting, } = result;
    if (isBottomIntersecting && position.includes('south')) {
        return position.replace('south', 'north');
    }
    else if (isTopIntersecting && position.includes('north')) {
        return position.replace('north', 'south');
    }
    else if (isLeftIntersecting && position.includes('west')) {
        return position.replace('west', 'east');
    }
    else if (isRightIntersecting && position.includes('east')) {
        return position.replace('east', 'west');
    }
    return position;
};
const defaultProps = {
    position: 'south',
    shouldCorrectPosition: true,
    showTooltipOnTouchDevices: true,
    tooltipAriaHidden: true,
};
const TooltipWrapper = (props) => {
    const { children, content, position } = Object.assign(Object.assign({}, defaultProps), props);
    const [tooltipId] = (0,react.useState)(props.tooltipId || (0,uniqueId/* uniqueId */.E)('tooltip-'));
    const shouldRenderTooltip = !!content;
    const childProps = {
        ariaDescribedBy: shouldRenderTooltip ? tooltipId : undefined,
    };
    const threshold = 0.9;
    const rootMargin = `-25px`;
    const [setNode, result] = (0,useIntersect/* useIntersect */.U)({
        threshold,
        rootMargin,
    });
    const correctedPosition = props.shouldCorrectPosition && result && Object.keys(result).length > 0
        ? correctPosition(position, result)
        : position;
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Styles.root(props, correctedPosition), ref: setNode },
        children({
            childProps,
            tooltipId,
        }),
        shouldRenderTooltip && ((0,isolateComponent/* isolateComponent */.U)("div", { className: contentNodeClassName, "data-testid": `TooltipWrapper__content--${correctedPosition}` },
            (0,isolateComponent/* isolateComponent */.U)(Tooltip/* Tooltip */.u, { allowMultiline: props.allowMultilineTooltip, ariaHidden: props.tooltipAriaHidden, id: tooltipId, isInteractive: true, position: null }, content)))));
};
TooltipWrapper.defaultProps = {
    position: 'south',
    shouldCorrectPosition: true,
    showTooltipOnTouchDevices: true,
    tooltipAriaHidden: true,
};
//# sourceMappingURL=TooltipWrapper.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 18672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ VisuallyHidden; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77293);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const noop = () => { };
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .labelStyles */ .B)('VisuallyHidden', {
    root: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  `,
});
const VisuallyHidden = (props) => {
    const [forceShow, setForceShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (false) {}
        else {
            return noop;
        }
    }, []);
    if (forceShow) {
        return (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .isolateComponent */ .U)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.children);
    }
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .isolateComponent */ .U)("span", { css: Styles.root, "data-testid": "visually-hidden" }, props.children));
};
//# sourceMappingURL=VisuallyHidden.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 45246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ LabeledBooleanInput; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/createUniqueCustomProperty.js
var createUniqueCustomProperty = __webpack_require__(38137);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/FormLabel/FormLabel.js + 1 modules
var FormLabel = __webpack_require__(61446);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/withModifier.js
var withModifier = __webpack_require__(52676);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(46688);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/BooleanInput/BooleanInput.js




const borderWidth = 2;
const Styles = (0,labelStyles/* labelStyles */.B)('BooleanInput', {
    root: () => [
        (0,emotion_react_browser_esm/* css */.iv)({
            position: 'relative',
            display: 'inline-block',
        }),
    ],
    inner: (props) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            display: 'block',
            position: 'relative',
            zIndex: 1,
            border: `${borderWidth}px solid ${Colors/* Colors.neutral600 */.w.neutral600}`,
            backgroundColor: 'transparent',
            cursor: 'pointer',
            transition: `all ${Animation/* Animation.transitionDuration */.f.transitionDuration} ease-in-out`,
        }),
        props.type === 'checkbox' && [
            (0,withModifier/* withModifier */.Q)('checkbox', (0,emotion_react_browser_esm/* css */.iv)({
                width: 18,
                height: 18,
                borderRadius: 3,
                color: Colors/* Colors.neutral100 */.w.neutral100,
            })),
            props.checked &&
                (0,withModifier/* withModifier */.Q)('checked', (0,emotion_react_browser_esm/* css */.iv)({
                    backgroundColor: Colors/* Colors.blue */.w.blue,
                    borderColor: 'transparent',
                })),
            props.isErrored &&
                (0,withModifier/* withModifier */.Q)('errored', (0,emotion_react_browser_esm/* css */.iv)({
                    backgroundColor: props.checked ? Colors/* Colors.error */.w.error : 'transparent',
                    borderColor: Colors/* Colors.error */.w.error,
                })),
            props.disabled &&
                (0,withModifier/* withModifier */.Q)('disabled', (0,emotion_react_browser_esm/* css */.iv)({
                    backgroundColor: props.checked ? Colors/* Colors.neutral500 */.w.neutral500 : 'transparent',
                    borderColor: Colors/* Colors.neutral500 */.w.neutral500,
                    cursor: 'not-allowed',
                })),
        ],
        props.type === 'radio' && [
            (0,withModifier/* withModifier */.Q)('radio', (0,emotion_react_browser_esm/* css */.iv)({
                color: 'transparent',
                width: 20,
                height: 20,
                borderRadius: 20,
            })),
            props.checked &&
                (0,withModifier/* withModifier */.Q)('checked', (0,emotion_react_browser_esm/* css */.iv)({
                    borderColor: Colors/* Colors.blue */.w.blue,
                    color: Colors/* Colors.blue */.w.blue,
                })),
            props.isErrored &&
                (0,withModifier/* withModifier */.Q)('errored', (0,emotion_react_browser_esm/* css */.iv)({
                    borderColor: Colors/* Colors.error */.w.error,
                    color: Colors/* Colors.error */.w.error,
                })),
            props.disabled &&
                (0,withModifier/* withModifier */.Q)('disabled', (0,emotion_react_browser_esm/* css */.iv)({
                    borderColor: Colors/* Colors.neutral500 */.w.neutral500,
                    color: Colors/* Colors.neutral500 */.w.neutral500,
                    cursor: 'not-allowed',
                })),
        ],
    ],
    layer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: -borderWidth,
        left: -borderWidth,
        width: `calc(100% + ${2 * borderWidth}px)`,
        height: `calc(100% + ${2 * borderWidth}px)`,
    }),
});
const BooleanInput = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.root() },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.inner(props) },
            (0,isolateComponent/* isolateComponent */.U)("input", { "aria-label": props.ariaLabel, checked: props.checked, css: Styles.layer, disabled: props.disabled, id: props.id, name: props.name, onChange: props.onChange, required: props.isRequired, tabIndex: props.tabIndex, type: props.type, value: props.value }),
            props.checked && ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.layer },
                (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: {
                        checkbox: 'formCheck',
                        radio: 'formRadioDot',
                    }[props.type], size: 18 }))))));
};
BooleanInput.defaultProps = {
    checked: false,
    onChange: () => { },
    tabIndex: 0,
};
//# sourceMappingURL=BooleanInput.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/BooleanInput/LabeledBooleanInput.js






const Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('LabeledBooleanInput', [
    'outlineColor',
]);
const LabeledBooleanInput_Styles = (0,labelStyles/* labelStyles */.B)('LabeledBooleanInput', {
    root: emotion_react_browser_esm/* css */.iv `
    ${Vars.outlineColor}: transparent;
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px;
    align-items: center;
    padding: 10px 8px;
    min-height: 0;

    // This is the outline that renders around the label when
    // it's focused. It's a pseudo element to preserve transparency
    // between the edge of the label and the edge of the outline.
    // It's defined here vs only in ':focus-with' so that it can transition
    // between states.
    &::before {
      content: '';
      position: absolute;
      pointer-events: none;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 2px solid var(${Vars.outlineColor});
      border-radius: 3px;
      transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
    }

    &:focus-within {
      ${Vars.outlineColor}: ${Colors/* Colors.blue */.w.blue};

      &[data-errored] {
        ${Vars.outlineColor}: ${Colors/* Colors.error */.w.error};
      }
    }
  `,
});
const LabeledBooleanInput = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)(FormLabel/* FormLabel */.l, { isDisabled: props.isDisabled, isErrored: props.isErrored, isRequired: props.isRequired, isSelected: props.checked, justifyContent: "stretch" },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: LabeledBooleanInput_Styles.root, "data-errored": props.isErrored ? '' : undefined },
            (0,isolateComponent/* isolateComponent */.U)(BooleanInput, { ariaLabel: props.ariaLabel, checked: props.checked, disabled: props.isDisabled, id: props.id, isErrored: props.isErrored, name: props.name, onChange: props.onChange, tabIndex: props.tabIndex, type: props.type, value: props.value }),
            props.children)));
};
LabeledBooleanInput.defaultProps = {
    checked: false,
    onChange: () => { },
    tabIndex: 0,
};
//# sourceMappingURL=LabeledBooleanInput.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 17688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Field; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77293);
/* harmony import */ var _display_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46688);
/* harmony import */ var _forms_FormLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61446);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3000);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70776);
/* harmony import */ var _hooks_useOverflow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60196);
/* harmony import */ var _utils_uniqueId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61814);








const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .labelStyles */ .B)('Field', {
    root: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    display: grid;
    grid-gap: 5px;
  `,
    helpTextWrapper: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    ${_theme__WEBPACK_IMPORTED_MODULE_3__/* .Typography.smallPrint1 */ .ZT.smallPrint1}
  `,
    helpText: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    align-items: start;
    color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral700 */ .w.neutral700};
  `,
    helpTextInner: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    padding-top: 1px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    // Without this truncation won't properly occur.
    * {
      display: inline;
      margin: 0;
    }
  `,
    helpTextToggle: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    cursor: pointer;
    text-decoration: underline;
    text-transform: lowercase;
    // Prevent help text toggle size from changing.
    width: 33px;
    &:hover,
    &:focus {
      outline: 1px solid ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.blue */ .w.blue};
      outline-offset: 1px;
      color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.blue */ .w.blue};
    }
  `,
    error: _emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv `
    display: inline;
    color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.error400 */ .w.error400};
  `,
});
const HelpText = ({ children, helpTextLineClamp }) => {
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [isOverflowing, setOverflowingNode] = (0,_hooks_useOverflow__WEBPACK_IMPORTED_MODULE_5__/* .useOverflow */ .I)();
    const toggle = isOverflowing && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("button", { "aria-hidden": "true", css: Styles.helpTextToggle, onClick: () => setIsOpen(!isOpen), type: "button" }, isOpen ? 'Less' : 'More'));
    const style = {
        WebkitLineClamp: isOpen ? undefined : helpTextLineClamp,
    };
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { css: Styles.helpText },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { css: Styles.helpTextInner, ref: (node) => setOverflowingNode(node), style: style },
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", null, children)),
        toggle));
};
const defaultProps = {
    helpTextLineClamp: 1,
};
const Field = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const [id] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(props.inputId || (0,_utils_uniqueId__WEBPACK_IMPORTED_MODULE_7__/* .uniqueId */ .E)('Field-'));
    const describedById = `${id}-description`;
    const helpText = props.renderHelpText && props.renderHelpText();
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { css: Styles.root },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", null, props.renderLabel ? (props.renderLabel({
            htmlFor: id,
            isDisabled: props.isDisabled,
            isErrored: !!props.error,
            isRequired: props.isRequired,
            label: props.label,
            requiredText: props.requiredText,
        })) : ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)(_forms_FormLabel__WEBPACK_IMPORTED_MODULE_8__/* .FormLabel */ .l, { alignItems: "start", htmlFor: id, isDisabled: props.isDisabled, isErrored: !!props.error, isRequired: props.isRequired, requiredText: props.requiredText, size: "small" },
            props.error && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)(_display_Icon__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .J, { color: "error400", isBlock: true, name: "formXCircle", size: 18 })),
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("span", null, props.label)))),
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", null, props.renderInput({
            ariaDescribedBy: helpText || props.error ? describedById : undefined,
            id,
            isDisabled: !!props.isDisabled,
            isErrored: !!props.error,
            isRequired: !!props.isRequired,
        })),
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { "aria-live": props.error ? 'polite' : 'off', css: Styles.helpTextWrapper, id: describedById }, (helpText || props.error) && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)(HelpText, { helpTextLineClamp: props.helpTextLineClamp },
            props.error && (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_6__/* .isolateComponent */ .U)("div", { css: Styles.error },
                props.error,
                " "),
            helpText)))));
};
//# sourceMappingURL=Field.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 35080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FloatingMenu; }
/* harmony export */ });
/* harmony import */ var _display_FloatingBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15504);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3000);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70776);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77293);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28165);




const MENU_ITEM_HEIGHT = 40;
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('FloatingMenu', {
    list: ({ visibleItems }) => [
        {
            maxHeight: ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10,
            overflow: 'auto',
            padding: 10,
        },
    ],
    menuItem: ({ isDisabled, isHighlighted, }) => [
        Object.assign(Object.assign({}, _theme__WEBPACK_IMPORTED_MODULE_1__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium), { alignItems: 'center', borderRadius: 3, cursor: 'pointer', display: 'flex', height: MENU_ITEM_HEIGHT, padding: '0 10px', color: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.neutral700 */ .w.neutral700 }),
        isDisabled &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .withModifier */ .Q)('disabled', Object.assign(Object.assign({}, _theme__WEBPACK_IMPORTED_MODULE_1__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium), { color: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.neutral500 */ .w.neutral500 })),
        isHighlighted &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .withModifier */ .Q)('enabled-highlighted', Object.assign(Object.assign({}, _theme__WEBPACK_IMPORTED_MODULE_1__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium), { backgroundColor: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.blue10 */ .w.blue10, color: _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.blue */ .w.blue })),
    ],
    menuItemIcon: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
    }),
    menuItemText: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }),
});
const FloatingMenu = (_props) => {
    const props = Object.assign({ align: 'stretch', visibleItems: 4 }, _props);
    const { align, ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth, } = props;
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)(_display_FloatingBox__WEBPACK_IMPORTED_MODULE_6__/* .FloatingBox */ .f, { align: align, maxWidth: maxWidth, minWidth: minWidth },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("ul", Object.assign({ css: Styles.list(props) }, getMenuProps({ 'aria-label': ariaLabel })), items.map((item, index) => ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("li", Object.assign({}, getItemProps({ item, disabled: item.disabled }), { css: Styles.menuItem({
                isDisabled: item.disabled,
                isHighlighted: highlightedIndex === index,
            }), key: getKeyForItem ? getKeyForItem(item) : index }),
            props.renderIcon && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("span", { css: Styles.menuItemIcon }, props.renderIcon(item, props.getLabelForItem))),
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_5__/* .isolateComponent */ .U)("span", { css: Styles.menuItemText }, getLabelForItem(item))))))));
};
//# sourceMappingURL=FloatingMenu.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 61446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ FormLabel; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/FormLabel/FormLabelRequiredText.js


const Styles = (0,labelStyles/* labelStyles */.B)('FormLabelRequiredText', {
    root: Object.assign(Object.assign({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), { color: Colors/* Colors.neutral700 */.w.neutral700, textTransform: 'lowercase', '&::before': {
            content: '"("',
        }, '&::after': {
            content: '")"',
        }, '&[data-state="disabled"]': {
            color: Colors/* Colors.neutral500 */.w.neutral500,
        } }),
});
const defaultProps = {
    children: 'Required',
    isDisabled: false,
};
const FormLabelRequiredText = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return ((0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": "true", css: Styles.root, "data-state": (props.isDisabled && 'disabled') || undefined }, props.children));
};
//# sourceMappingURL=FormLabelRequiredText.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/FormLabel/FormLabel.js




const FormLabel_Styles = (0,labelStyles/* labelStyles */.B)('FormLabel', {
    root: emotion_react_browser_esm/* css */.iv `
    display: grid;
    justify-content: start;
    grid-gap: 5px;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    cursor: pointer;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    &[data-align-items='center'] {
      align-items: center;
    }

    &[data-align-items='start'] {
      align-items: start;
    }

    &[data-justify-content='start'] {
      justify-content: start;
    }

    &[data-justify-content='stretch'] {
      justify-content: stretch;
    }

    &[data-state~='selected'] {
      color: ${Colors/* Colors.blue */.w.blue};
    }

    &[data-state~='errored'] {
      color: ${Colors/* Colors.error400 */.w.error400};
    }

    &[data-state~='disabled'] {
      cursor: not-allowed;
    }

    &[data-state~='disabled'] {
      color: ${Colors/* Colors.neutral500 */.w.neutral500};
    }

    &[data-size='small'] {
      ${Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold};
    }

    &[data-size='medium'] {
      ${Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium};
    }

    &[data-size='medium'][data-state='selected'] {
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold}
    }
  `,
});
const FormLabel_defaultProps = {
    alignItems: 'center',
    justifyContent: 'start',
    size: 'medium',
};
const FormLabel = (_props) => {
    const props = Object.assign(Object.assign({}, FormLabel_defaultProps), _props);
    return ((0,isolateComponent/* isolateComponent */.U)("label", { css: FormLabel_Styles.root, "data-align-items": props.alignItems, "data-justify-content": props.justifyContent, "data-size": props.size, "data-state": [
            props.isSelected && 'selected',
            props.isErrored && 'errored',
            props.isDisabled && 'disabled',
        ]
            .filter(Boolean)
            .join(' ') || undefined, htmlFor: props.htmlFor },
        props.isRequired && '*',
        props.children,
        props.isRequired ? (props.requiredText ? ((0,isolateComponent/* isolateComponent */.U)(FormLabelRequiredText, { isDisabled: props.isDisabled }, props.requiredText)) : ((0,isolateComponent/* isolateComponent */.U)(FormLabelRequiredText, { isDisabled: props.isDisabled }))) : null));
};
//# sourceMappingURL=FormLabel.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 13030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28165);
/* harmony import */ var _display_Tooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29476);
/* harmony import */ var _utils_createUniqueCustomProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38137);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70776);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98628);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3000);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77293);
/* harmony import */ var _utils_uniqueId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61814);







const Vars = (0,_utils_createUniqueCustomProperty__WEBPACK_IMPORTED_MODULE_1__/* .createUniqueCustomProperties */ .F)('Input', [
    'borderRadius',
    'iconColor',
    'inputValueColor',
    'inputHeight',
    'inputPaddingLeft',
    'inputPaddingRight',
    'inputPaddingTop',
    'inputPaddingBottom',
    'prependPaddingLeft',
    'appendPaddingRight',
    'outlineColor',
    'placeholderColor',
    'prependAppendColor',
    'tooltipOpacity',
]);
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .labelStyles */ .B)('Input', {
    root: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    ${Vars.borderRadius}: 3px;
    ${Vars.iconColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral600 */ .w.neutral600};
    // Input is 44px height including border
    ${Vars.inputHeight}: 42px;
    ${Vars.inputPaddingLeft}: 15px;
    ${Vars.inputPaddingRight}: 15px;
    ${Vars.inputPaddingTop}: 9px;
    ${Vars.inputPaddingBottom}: 9px;
    ${Vars.placeholderColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral600 */ .w.neutral600};
    ${Vars.inputValueColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral800 */ .w.neutral800};
    ${Vars.prependPaddingLeft}: 15px;
    ${Vars.appendPaddingRight}: 15px;
    ${Vars.outlineColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral600 */ .w.neutral600};
    ${Vars.prependAppendColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral800 */ .w.neutral800};
    ${Vars.tooltipOpacity}: 0;

    border: 1px solid var(${Vars.outlineColor});
    // Box-shadow only for focus state
    box-shadow: none;
    // For Tooltip positioning
    position: relative;
    border-radius: var(${Vars.borderRadius});
    background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral100 */ .w.neutral100};

    // Only transition specific properties because some,
    // like 'padding', will change but shouldn't transition.
    transition-duration: ${_theme__WEBPACK_IMPORTED_MODULE_5__/* .Animation.transitionDuration */ .f.transitionDuration};
    transition-property: background-color, color, box-shadow;
    transition-timing-function: ease;

    &[data-errored] {
      ${Vars.outlineColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.error400 */ .w.error400};
    }

    &:not([data-disabled]):hover {
      ${Vars.outlineColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.blue */ .w.blue};
    }

    &:not([data-disabled]):focus-within {
      ${Vars.outlineColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.blue */ .w.blue};
      box-shadow: 0 0 0 1px var(${Vars.outlineColor});
    }

    &[data-disabled] {
      ${Vars.prependAppendColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
      ${Vars.outlineColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral400 */ .w.neutral400};
      ${Vars.iconColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral400 */ .w.neutral400};
      ${Vars.inputValueColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
      ${Vars.placeholderColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
      cursor: not-allowed;
      background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral200 */ .w.neutral200};
    }

    &[data-readonly]:hover,
    &[data-disabled]:hover {
      ${Vars.tooltipOpacity}: 1;
    }

    &[data-full-width] {
      width: 100%;
      max-width: 100%;
    }

    &[data-icon-before] {
      ${Vars.prependPaddingLeft}: 0;
      ${Vars.inputPaddingLeft}: 0;
    }

    &[data-prepend][data-layout='inline'] {
      ${Vars.inputPaddingLeft}: 0;
    }

    &[data-icon-after] {
      ${Vars.appendPaddingRight}: 0;
      ${Vars.inputPaddingRight}: 0;
    }

    &[data-append][data-layout='inline'] {
      ${Vars.inputPaddingRight}: 0;
    }
  `,
    inputLayout: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  `,
    prependAppend: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    color: var(${Vars.prependAppendColor});

    &[data-layout='inline'] {
      ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium};

      &[data-type='prepend'] {
        margin-left: var(${Vars.prependPaddingLeft});
        margin-right: 10px;
      }

      &[data-type='append'] {
        margin-left: 10px;
        margin-right: var(${Vars.appendPaddingRight});
      }
    }

    &[data-layout='block'] {
      ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Typography.smallPrint1 */ .ZT.smallPrint1};
      background-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral300 */ .w.neutral300};
      display: flex;
      align-items: center;
      width: 100%;
      height: 30px;
      padding: 0 var(${Vars.inputPaddingLeft});

      &[data-type='prepend'] {
        // Ensure prepend renders before icon.
        order: -1;
        border-top-left-radius: var(${Vars.borderRadius});
        border-top-right-radius: var(${Vars.borderRadius});
      }

      &[data-type='append'] {
        // Ensure append renders after icon.
        // The value is a contrived number that needs to be
        // greater than the number of siblings it has.
        order: 10;
        border-bottom-left-radius: var(${Vars.borderRadius});
        border-bottom-right-radius: var(${Vars.borderRadius});
      }
    }
  `,
    input: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    flex: 1;
    ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Typography.paragraph3Medium */ .ZT.paragraph3Medium};
    color: var(${Vars.inputValueColor});
    height: 100%;
    padding-top: var(${Vars.inputPaddingTop});
    padding-bottom: var(${Vars.inputPaddingBottom});
    padding-left: var(${Vars.inputPaddingLeft});
    padding-right: var(${Vars.inputPaddingRight});

    &:not(textarea) {
      height: var(${Vars.inputHeight});
    }

    // Style placeholder. Selectors cannot be combined,
    // so keep 'em separated.
    &::placeholder {
      color: var(${Vars.placeholderColor});
      // Necessary for Safari.
      -webkit-text-fill-color: var(${Vars.placeholderColor});
    }
    &::-moz-placeholder {
      color: var(${Vars.placeholderColor});
      // Firefox has <1 'opacity' on its placeholders,
      // so it has to be overridden.
      opacity: 1;
    }

    // Bump font size for devices that don't support hovering
    // to prevent mobile browsers from zooming in on inputs
    // when they're focused. 16px is defined at the OS level
    // of these devices, specifically iOS.
    @media (hover: none) {
      font-size: 16px;
    }

    // Hide "clear selection" X icon in Edge.
    // https://zappy.zapier.com/F693DF53-79B7-4857-AADE-73E9BF3011DB.png
    &::-ms-clear {
      display: none;
    }
    // Hide "clear selection" X icon in Safari.
    &::-webkit-search-cancel-button {
      display: none;
    }

    // Hide selection when '[readonly]' since the text can't
    // be edited, but the selection makes it look like it can be.
    &[readonly]::selection {
      background-color: transparent;
    }

    &[disabled] {
      cursor: not-allowed;
      color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
      -webkit-text-fill-color: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
      white-space: pre-wrap;
      ${Vars.placeholderColor}: ${_theme__WEBPACK_IMPORTED_MODULE_4__/* .Colors.neutral500 */ .w.neutral500};
    }
  `,
    icon: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(${Vars.iconColor});
    position: relative;
    z-index: 1;
    pointer-events: none;
    margin: 0 8px;
    height: var(${Vars.inputHeight});

    &[data-interactive] {
      pointer-events: auto;
    }
  `,
    tooltip: _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
    opacity: var(${Vars.tooltipOpacity});
    transition: ${_theme__WEBPACK_IMPORTED_MODULE_5__/* .Animation.transitionValue */ .f.transitionValue};
    position: absolute;
    left: 50%;
    transform: translate(0, -15px);
    z-index: 2;
  `,
});
const Input = (props) => {
    const [isFocused, setIsFocused] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [isHovered, setIsHovered] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [tooltipId] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(props.id ? `${props.id}-tooltip` : (0,_utils_uniqueId__WEBPACK_IMPORTED_MODULE_7__/* .uniqueId */ .E)(`Input__tooltip-`));
    const shouldRenderTooltip = (props.isDisabled && !!props.disabledText) ||
        (props.isReadonly && !!props.readOnlyText);
    const renderIconProps = {
        iconSize: 24,
        isFocused,
        isHovered,
    };
    const iconBefore = props.renderIconBefore && props.renderIconBefore(renderIconProps);
    const iconAfter = props.renderIconAfter && props.renderIconAfter(renderIconProps);
    const derivedState = {
        hasIconBefore: !!iconBefore,
        hasIconAfter: !!iconAfter,
        isFocused,
        isHovered,
    };
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.root, "data-append": props.appendContent ? '' : undefined, "data-disabled": props.isDisabled ? '' : undefined, "data-readonly": props.isReadonly ? '' : undefined, "data-errored": props.isErrored ? '' : undefined, "data-full-width": props.isFullWidth ? '' : undefined, "data-icon-after": iconAfter ? '' : undefined, "data-icon-before": iconBefore ? '' : undefined, "data-layout": props.layout, "data-prepend": props.prependContent ? '' : undefined, "data-size": props.size, onBlur: () => setIsFocused(false), onClick: props.onClick, onFocus: () => setIsFocused(true), onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), role: "presentation" },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.inputLayout },
            iconBefore && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.icon, "data-interactive": props.canClickIconBefore ? '' : undefined, "data-size": props.size }, iconBefore)),
            props.prependContent && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.prependAppend, "data-layout": props.layout, "data-size": props.size, "data-type": "prepend" }, props.prependContent)),
            props.children({
                'aria-activedescendant': props.ariaActiveDescendant,
                'aria-controls': props.ariaControls,
                'aria-describedby': shouldRenderTooltip
                    ? tooltipId
                    : props.ariaDescribedBy,
                'aria-errormessage': props.isErrored
                    ? props.ariaDescribedBy
                    : undefined,
                'aria-hidden': props.ariaHidden,
                'aria-invalid': props.isErrored,
                'aria-label': props.ariaLabel,
                'aria-labelledby': props.ariaLabelledBy,
                'aria-required': props.ariaRequired,
                'data-size': props.size,
                autoComplete: props.autoComplete,
                autoFocus: props.autoFocus,
                css: Styles.input,
                tabIndex: props.isFocusable ? undefined : -1,
                disabled: props.isDisabled,
                id: props.id,
                maxLength: props.maxLength,
                name: props.name,
                onBlur: props.onBlur,
                onChange: props.onChange,
                onFocus: props.onFocus,
                onKeyDown: props.onKeyDown,
                placeholder: props.placeholder,
                readOnly: props.isReadonly,
                required: props.isRequired,
                role: props.role,
                value: props.value,
            }, derivedState),
            props.appendContent && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.prependAppend, "data-layout": props.layout, "data-type": "append", "data-size": props.size }, props.appendContent)),
            iconAfter && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.icon, "data-interactive": props.canClickIconAfter ? '' : undefined, "data-size": props.size }, iconAfter))),
        shouldRenderTooltip && ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)("div", { css: Styles.tooltip },
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_8__/* .isolateComponent */ .U)(_display_Tooltip__WEBPACK_IMPORTED_MODULE_9__/* .Tooltip */ .u, { id: tooltipId, position: "south" }, props.isReadonly ? props.readOnlyText : props.disabledText)))));
};
Input.defaultProps = {
    canClickIconBefore: true,
    canClickIconAfter: true,
    disabledText: 'Disabled',
    readOnlyText: 'Read-Only',
    isFocusable: true,
    layout: 'inline',
    isFullWidth: false,
    size: 'small',
};
//# sourceMappingURL=Input.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 42126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _forms_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13030);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77293);



const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .labelStyles */ .B)('TextInput', {
    input: (props) => [
        { minWidth: 1 },
        props.isMultiline &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .withModifier */ .Q)('multiline', {
                height: 'auto',
            }),
        props.isFullWidth &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .withModifier */ .Q)('fullwidth', {
                width: '100%',
            }),
        props.resize &&
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .withModifier */ .Q)(`resize-${props.resize}`, {
                resize: props.resize,
            }),
    ],
});
const TextInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
    const Tag = props.isMultiline ? 'textarea' : 'input';
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .isolateComponent */ .U)(_forms_Input__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I, Object.assign({}, props, { renderIconAfter: props.isMultiline ? undefined : props.renderIconAfter, renderIconBefore: props.isMultiline ? undefined : props.renderIconBefore }), (inputProps) => ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_3__/* .isolateComponent */ .U)(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, css: [inputProps.css, Styles.input(props)], inputMode: props.inputMode, ref: ref, rows: props.isMultiline ? props.rows : undefined, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : undefined, value: inputProps.value, onChange: inputProps.onChange })))));
});
TextInput.defaultProps = {
    isMultiline: false,
    type: 'text',
    isFullWidth: false,
    size: 'small',
};
//# sourceMappingURL=TextInput.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 56119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Grid; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77293);


const isNumber = (value) => typeof value === 'number';
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('Grid', {
    root: (props) => (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
        display: 'grid',
        alignItems: props.alignItems,
        gap: props.gap,
        gridTemplateColumns: isNumber(props.columns)
            ? `repeat(${props.columns}, 1fr)`
            : props.columns,
    }),
});
const Grid = (props) => {
    return (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_2__/* .isolateComponent */ .U)("div", { css: Styles.root(props) }, props.children);
};
//# sourceMappingURL=Grid.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 53939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77293);

const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('Spacer', {
    root: (props) => [
        {
            label: `${props.width || 0}-by-${props.height || 0}`,
            width: props.width,
            height: props.height,
        },
    ],
});
const Spacer = (props) => {
    return (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .isolateComponent */ .U)("div", { css: Styles.root(props) });
};
Spacer.defaultProps = {
    width: 0,
    height: 0,
};
//# sourceMappingURL=Spacer.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 37510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BrandButton; }
/* harmony export */ });
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77293);
/* harmony import */ var _navigation_Button_BaseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36897);
/* harmony import */ var _display_VisuallyHidden__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18672);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function BrandButton(_a) {
    var { color = 'brand', size = 'small' } = _a, props = __rest(_a, ["color", "size"]);
    return color === 'brand-nav' ? ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .isolateComponent */ .U)(_navigation_Button_BaseButton__WEBPACK_IMPORTED_MODULE_1__/* .BaseButton */ .Y, { color: "brand-nav", iconBefore: props.iconBefore || 'formAdd', size: "medium" },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .isolateComponent */ .U)(_display_VisuallyHidden__WEBPACK_IMPORTED_MODULE_2__/* .VisuallyHidden */ .T, null, props.children || 'Create a Zap'))) : ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .isolateComponent */ .U)(_navigation_Button_BaseButton__WEBPACK_IMPORTED_MODULE_1__/* .BaseButton */ .Y, Object.assign({ color: color, size: size }, props)));
}
//# sourceMappingURL=BrandButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 36897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ BaseButton; }
});

// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(46688);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Link/Link.js + 1 modules
var Link = __webpack_require__(36394);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Shadows.js
var Shadows = __webpack_require__(10391);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/createUniqueCustomProperty.js
var createUniqueCustomProperty = __webpack_require__(38137);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/Styles.js




const Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('Button', [
    'baseBackgroundColor',
    'baseBorderColor',
    'baseColor',
    'disabledBackgroundColor',
    'disabledBorderColor',
    'disabledColor',
    'disabledOutlineColor',
    'hoverBackgroundColor',
    'hoverBorderColor',
    'hoverColor',
    'hoverOutlineColor',
    'iconMargin',
    'focusBackgroundColor',
    'focusBorderColor',
    'focusColor',
    'focusOutlineColor',
    'selectedBackgroundColor',
    'selectedBorderColor',
    'selectedColor',
    'selectedOutlineColor',
    'buttonContentPadding',
]);
const Styles = (0,labelStyles/* labelStyles */.B)('BaseButton', {
    root: emotion_react_browser_esm/* css */.iv `
    // All of the CSS Custom Properties that are used by this
    // component, ensured to be unique. Most are color related
    // and are set below via '[data-color]' selectors.
    ${Vars.baseBackgroundColor}: transparent;
    ${Vars.baseBorderColor}: transparent;
    ${Vars.baseColor}: #000;
    ${Vars.disabledBackgroundColor}: ${Colors/* Colors.neutral200 */.w.neutral200};
    ${Vars.disabledBorderColor}: ${Colors/* Colors.neutral400 */.w.neutral400};
    ${Vars.disabledColor}: ${Colors/* Colors.neutral500 */.w.neutral500};
    ${Vars.disabledOutlineColor}: transparent;
    ${Vars.hoverBackgroundColor}: var(${Vars.baseBackgroundColor});
    ${Vars.hoverBorderColor}: var(${Vars.baseBorderColor});
    ${Vars.hoverColor}: var(${Vars.baseColor});
    ${Vars.hoverOutlineColor}: transparent;
    ${Vars.iconMargin}: 6px;
    ${Vars.focusBackgroundColor}: var(${Vars.baseBackgroundColor});
    ${Vars.focusBorderColor}: transparent;
    ${Vars.focusColor}: var(${Vars.baseColor});
    ${Vars.focusOutlineColor}: var(${Vars.focusBackgroundColor});
    ${Vars.selectedBackgroundColor}: var(${Vars.baseBackgroundColor});
    ${Vars.selectedBorderColor}: transparent;
    ${Vars.selectedColor}: var(${Vars.baseColor});
    ${Vars.selectedOutlineColor}: transparent;
    ${Vars.buttonContentPadding}: 0 10px;

    background-color: var(${Vars.baseBackgroundColor});
    border-color: var(${Vars.baseBorderColor});
    color: var(${Vars.baseColor});

    align-items: center;
    appearance: none;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    // Safari applies 2px margin to buttons this clears it
    margin: 0;
    min-width: 0;
    opacity: 1;
    text-align: center;
    text-decoration: none;
    text-transform: none;
    transition: all 200ms ease-in-out;
    vertical-align: middle;
    white-space: nowrap;

    &::-moz-focus-inner {
      padding: 0;
      border: 0;
    }

    // This is the outline that renders around the button when
    // its focused. Its a pseudo element to preserve transparency;
    // between the edge of the button and the edge of the outline.
    // Its defined here vs only in ':focus' so that it can transition
    // between states.
    &::before {
      content: '';
      position: absolute;
      pointer-events: none;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 2px solid transparent;
      border-radius: 5px;
      transition-property: all;
      transition-timing-function: ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};
      transition-duration: 200ms;
    }

    &:hover:not([disabled]),
    a:hover & {
      background-color: var(${Vars.hoverBackgroundColor});
      border-color: var(${Vars.hoverBorderColor});
      box-shadow: ${Shadows/* Shadows.elevation6 */.f.elevation6};
      color: var(${Vars.hoverColor});
    }

    &:focus:not([disabled]),
    a:focus & {
      background-color: var(${Vars.focusBackgroundColor});
      border-color: var(${Vars.focusBorderColor});
      color: var(${Vars.focusColor});
      outline: none;
      &::before {
        border-color: var(${Vars.focusOutlineColor});
        top: -5px;
        right: -5px;
        bottom: -5px;
        left: -5px;
      }
    }

    &[data-selected]:not([data-color='button-nav']) {
      background-color: var(${Vars.selectedBackgroundColor});
      border-color: var(${Vars.selectedBorderColor});
      color: var(${Vars.selectedColor});
      // Hide :focus outline on selected buttons
      &::before {
        content: none;
      }
    }

    &[data-color='primary'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.baseColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.night */.w.night};
    }

    &[data-color='primary-alt'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Vars.baseColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
    }

    &[data-color='danger'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.error400 */.w.error400};
      ${Vars.baseColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.error500 */.w.error500};
      ${Vars.hoverColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.focusColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.error400 */.w.error400};
    }

    &[data-color='secondary'] {
      ${Vars.baseBackgroundColor}: transparent;
      ${Vars.baseColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
      ${Vars.hoverColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.focusBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
      ${Vars.focusColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.baseBorderColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blue */.w.blue};
    }

    &[data-color='icon-primary'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.baseBorderColor}: ${Colors/* Colors.neutral600 */.w.neutral600};
      ${Vars.baseColor}: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Vars.hoverColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusBorderColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};

      &[disabled] {
        background-color: var(${Vars.disabledBackgroundColor});
        border-color: ${Colors/* Colors.neutral400 */.w.neutral400};
        color: ${Colors/* Colors.neutral500 */.w.neutral500};
        outline-color: var(${Vars.disabledOutlineColor});
      }
    }

    &[data-color='icon-alt'] {
      &[data-color='icon-alt'] {
        ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
        ${Vars.baseBorderColor}: ${Colors/* Colors.blue */.w.blue};
        ${Vars.baseColor}: ${Colors/* Colors.blue */.w.blue};
        ${Vars.hoverColor}: ${Colors/* Colors.blue */.w.blue};
        ${Vars.hoverBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
        ${Vars.focusBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
        ${Vars.focusBorderColor}: ${Colors/* Colors.blue */.w.blue};
        ${Vars.focusColor}: ${Colors/* Colors.blue */.w.blue};
        ${Vars.focusOutlineColor}: ${Colors/* Colors.blue */.w.blue};

        &[disabled] {
          background-color: var(${Vars.disabledBackgroundColor});
          border-color: ${Colors/* Colors.neutral400 */.w.neutral400};
          color: ${Colors/* Colors.neutral500 */.w.neutral500};
          outline-color: var(${Vars.disabledOutlineColor});
        }
      }
    }

    &[data-color='icon-secondary'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.baseBorderColor}: ${Colors/* Colors.neutral600 */.w.neutral600};
      ${Vars.baseColor}: ${Colors/* Colors.neutral600 */.w.neutral600};
      ${Vars.hoverColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
      ${Vars.focusBorderColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};

      &[disabled] {
        background-color: var(${Vars.disabledBackgroundColor});
        border-color: ${Colors/* Colors.neutral400 */.w.neutral400};
        color: ${Colors/* Colors.neutral500 */.w.neutral500};
        outline-color: var(${Vars.disabledOutlineColor});
      }
    }
    &[data-color='number'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.baseBorderColor}: ${Colors/* Colors.neutral600 */.w.neutral600};
      ${Vars.baseColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.hoverBorderColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.hoverColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.focusBorderColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blueJeans */.w.blueJeans};

      &[disabled] {
        background-color: var(${Vars.disabledBackgroundColor});
        border-color: ${Colors/* Colors.neutral400 */.w.neutral400};
        color: ${Colors/* Colors.neutral500 */.w.neutral500};
        outline-color: var(${Vars.disabledOutlineColor});
      }
    }
    &[data-color='primary-dark'],
    &[data-color='icon-primary-dark'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.baseColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.hoverColor}: ${Colors/* Colors.night */.w.night};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.focusColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
    }
    &[data-color='secondary-dark'],
    &[data-color='icon-secondary-dark'] {
      ${Vars.baseBackgroundColor}: transparent;
      ${Vars.baseColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.baseBorderColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.hoverColor}: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
      ${Vars.hoverBorderColor}: ${Colors/* Colors.blue10 */.w.blue10};
      ${Vars.focusColor}: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blue10 */.w.blue10};
      ${Vars.focusBackgroundColor}: ${Colors/* Colors.blue10 */.w.blue10};
    }
    &[data-color='button-nav'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral200 */.w.neutral200};
      ${Vars.baseColor}: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Vars.baseBorderColor}: ${Colors/* Colors.neutral600 */.w.neutral600};
      ${Vars.hoverColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.hoverBorderColor}: ${Colors/* Colors.blue */.w.blue};
      ${Vars.focusBackgroundColor}: ${Colors/* Colors.neutral200 */.w.neutral200};
      ${Vars.focusBorderColor}: ${Colors/* Colors.neutral200 */.w.neutral200};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.blue */.w.blue};
      border-radius: 30px;
      &::before {
        border-radius: 30px;
      }
      &[data-selected] {
        ${Vars.baseBackgroundColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.baseColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
        ${Vars.baseBorderColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.hoverBackgroundColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.hoverBorderColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.focusBorderColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.focusBackgroundColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
        ${Vars.focusOutlineColor}: ${Colors/* Colors.neutral700 */.w.neutral700};
      }
    }
    &[data-color='brand'],
    &[data-color='brand-nav'] {
      ${Vars.baseBackgroundColor}: ${Colors/* Colors.zapier */.w.zapier};
      ${Vars.baseColor}: ${Colors/* Colors.cream */.w.cream};
      ${Vars.baseBorderColor}: transparent;
      ${Vars.hoverColor}: ${Colors/* Colors.cream */.w.cream};
      ${Vars.hoverBackgroundColor}: ${Colors/* Colors.zapier */.w.zapier};
      ${Vars.focusColor}: ${Colors/* Colors.cream */.w.cream};
      ${Vars.focusOutlineColor}: ${Colors/* Colors.zapier */.w.zapier};
      ${Vars.focusBackgroundColor}: ${Colors/* Colors.zapier */.w.zapier};
      ${Vars.focusBorderColor}: transparent;
    }
    &[data-color='brand'] {
      &[data-size='small'] {
        ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
        border-radius: 18px;
        &::before {
          border-radius: 20px;
        }
      }
      &[data-size='medium'] {
        ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
        border-radius: 18px;
        &::before {
          border-radius: 20px;
        }
      }
      &[data-size='large'] {
        ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
        border-radius: 24px;
        &::before {
          border-radius: 26px;
        }
      }
    }
    &[data-color='brand-nav'] {
      ${Vars.iconMargin}: 0;
      &[data-size='medium'] {
        ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
        border-radius: 18px;
        &::before {
          border-radius: 22px;
        }
      }
    }

    &[disabled] {
      cursor: not-allowed;
      background-color: var(${Vars.disabledBackgroundColor});
      border-color: var(${Vars.disabledBorderColor});
      color: var(${Vars.disabledColor});
      outline-color: var(${Vars.disabledOutlineColor});
    }

    &[data-full-width] {
      width: 100%;
    }

    &[data-shadowed] {
      box-shadow: ${Shadows/* Shadows.elevation5 */.f.elevation5};
    }

    &[data-size='xsmall'] {
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
      ${Vars.buttonContentPadding}: 0 15px;
      height: 30px;
      border-radius: 3px;

      &[data-icon] {
        ${Vars.buttonContentPadding}: 0 8px 0 3px;
      }

      &[data-square] {
        width: 30px;
      }
    }

    &[data-size='small'] {
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
      ${Vars.buttonContentPadding}: 0 20px;
      height: 44px;

      &[data-icon] {
        ${Vars.buttonContentPadding}: 0 10px;
      }

      &[data-square] {
        width: 44px;
      }
      &[data-color='button-nav'] {
        ${Vars.buttonContentPadding}: 0 20px;
      }
    }

    &[data-size='medium'] {
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
      ${Vars.buttonContentPadding}: 0 20px;
      height: 50px;

      &[data-icon] {
        ${Vars.buttonContentPadding}: 0 17px;
        &[data-color='brand-nav'] {
          ${Vars.buttonContentPadding}: 0 12px;
        }
      }

      &[data-square] {
        width: 50px;
      }
    }

    &[data-size='large'] {
      ${Typography/* Typography.paragraph1ShortSemibold */.ZT.paragraph1ShortSemibold};
      ${Vars.buttonContentPadding}: 0 20px;
      height: 60px;

      &[data-icon] {
        ${Vars.buttonContentPadding}: 0 17px;
      }

      &[data-square] {
        width: 60px;
      }
    }

    &[data-unpadded],
    &[data-square] {
      ${Vars.buttonContentPadding}: 0 !important;
    }

    &[data-pill] {
      border-radius: 100px !important;

      &::before {
        border-radius: 100px !important;
      }
    }
  `,
    buttonContent: emotion_react_browser_esm/* css */.iv `
    display: flex;
    align-items: center;
    min-width: 0;
    padding: var(${Vars.buttonContentPadding});
  `,
    buttonText: emotion_react_browser_esm/* css */.iv `
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  `,
    buttonIcon: (hasSibling) => emotion_react_browser_esm/* css */.iv `
    display: block;
    flex: none;
    ${hasSibling && `margin-right: var(${Vars.iconMargin});`}
  `,
});
//# sourceMappingURL=Styles.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/BaseButton.js




const ButtonIcon = (props) => ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.buttonIcon(props.hasSibling) },
    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { canAcceptPointerEvents: false, isBlock: true, name: props.iconName, size: props.size })));
const ButtonText = (props) => ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.buttonText }, props.children));
const ButtonContent = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.buttonContent },
        props.iconBefore && ((0,isolateComponent/* isolateComponent */.U)(ButtonIcon, { hasSibling: !!props.children, iconName: props.iconBefore, size: 24 })),
        (0,isolateComponent/* isolateComponent */.U)(ButtonText, null, props.children)));
};
const getTag = (props) => {
    if (props.presentationOnly) {
        return 'span';
    }
    if (props.htmlFor && !props.disabled) {
        return 'label';
    }
    if (props.href && !props.disabled) {
        return Link/* Link */.r;
    }
    return 'button';
};
const defaultProps = {
    disabled: false,
    isFullWidth: false,
    isPill: false,
};
function BaseButton(_props) {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    const ButtonTag = getTag(props);
    const isLink = ButtonTag === Link/* Link */.r;
    const ariaProps = {
        [`${isLink ? 'ariaLabel' : 'aria-label'}`]: props.ariaLabel,
    };
    return ((0,isolateComponent/* isolateComponent */.U)(ButtonTag, Object.assign({ "aria-controls": props.ariaControls, "aria-describedby": props.ariaDescribedBy, "aria-disabled": props.disabled, "aria-expanded": props.ariaExpanded, "aria-haspopup": props.ariaHaspopup, "aria-hidden": props.ariaHidden }, ariaProps, { color: isLink ? null : undefined, css: Styles.root, "data-color": props.color, "data-icon": props.iconBefore ? 'before' : undefined, "data-full-width": props.isFullWidth ? '' : undefined, "data-pill": props.isPill ? '' : undefined, "data-selected": props.isSelected ? '' : undefined, "data-shadowed": props.hasShadow ? '' : undefined, "data-size": props.size, "data-square": props.isSquare ? '' : undefined, disabled: props.disabled, htmlFor: props.htmlFor, href: isLink ? props.href : undefined, id: props.id, onClick: props.onClick, onKeyDown: props.onKeyDown, rel: isLink ? props.rel : undefined, role: !isLink ? 'button' : undefined, tabIndex: props.tabIndex, target: isLink ? props.target : undefined, type: ButtonTag === 'button' ? props.type : undefined }),
        (0,isolateComponent/* isolateComponent */.U)(ButtonContent, Object.assign({}, props))));
}
//# sourceMappingURL=BaseButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 20110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77293);
/* harmony import */ var _BaseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36897);


function Button(props) {
    return (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .isolateComponent */ .U)(_BaseButton__WEBPACK_IMPORTED_MODULE_1__/* .BaseButton */ .Y, Object.assign({}, props));
}
Button.defaultProps = {
    color: 'primary',
    size: 'medium',
};
//# sourceMappingURL=Button.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 36394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system-context/esm/components/DesignSystemProvider/DesignSystemProvider.js

const defaultContext = {
    LinkComponent: 'a',
};
const DesignSystemContext = react.createContext(defaultContext);
const useDesignSystem = () => react.useContext(DesignSystemContext);
const DesignSystemProvider = ({ children, LinkComponent, }) => {
    return children ? (React.createElement(DesignSystemContext.Provider, { value: {
            LinkComponent,
        } }, React.Children.only(children))) : null;
};
//# sourceMappingURL=DesignSystemProvider.js.map
// @zapier/design-system-context@1.2.0 (e31aef2e9)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/fromEntries.js
var fromEntries = __webpack_require__(93594);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Link/Link.js






const Styles = (0,labelStyles/* labelStyles */.B)('Link', {
    root: () => [
        emotion_react_browser_esm/* css */.iv `
      // Need to manually unset here since these styles may
      // be passed to a component and not directly to an 'a'.
      all: unset;
      box-sizing: border-box;
      text-decoration: underline;
      cursor: pointer;
      transition: all ${Animation/* Animation.transitionDuration */.f.transitionDuration} ease-in-out;
      outline-offset: 1px;
      // Fix Safari 13 issue with 'color' and 'all: unset'
      // (https://bugs.webkit.org/show_bug.cgi?id=158782).
      -webkit-text-fill-color: currentColor;

      outline: 1px solid transparent;

      &[data-color='ocean'] {
        color: ${Colors/* Colors.blue */.w.blue};

        &:hover {
          color: ${Colors/* Colors.night */.w.night};
        }

        &:focus {
          color: ${Colors/* Colors.blue */.w.blue};
          outline-color: ${Colors/* Colors.blue */.w.blue};
        }
      }

      &[data-color='white'] {
        color: ${Colors/* Colors.neutral100 */.w.neutral100};

        &:hover {
          color: ${Colors/* Colors.neutral500 */.w.neutral500};
        }

        &:focus {
          color: ${Colors/* Colors.neutral100 */.w.neutral100};
          outline-color: ${Colors/* Colors.neutral100 */.w.neutral100};
        }
      }

      &[data-color='primary'] {
        color: ${Colors/* Colors.blue */.w.blue};

        &:hover {
          color: ${Colors/* Colors.night */.w.night};
        }

        &:focus {
          color: ${Colors/* Colors.blue */.w.blue};
          outline-color: ${Colors/* Colors.blue */.w.blue};
        }
      }

      &[data-color='secondary'] {
        color: ${Colors/* Colors.neutral100 */.w.neutral100};

        &:hover {
          color: ${Colors/* Colors.neutral500 */.w.neutral500};
        }

        &:focus {
          color: ${Colors/* Colors.neutral100 */.w.neutral100};
          outline-color: ${Colors/* Colors.neutral100 */.w.neutral100};
        }
      }

      &[data-weight='inherit'] {
        font-weight: inherit;
      }

      &[data-weight='normal'] {
        font-weight: 400;
      }

      &[data-weight='bold'] {
        font-weight: 700;
      }
    `,
    ],
});
const DOMAIN_WHITELIST = ['zapier.com', 'zapier-staging.com', 'localhost'];
const isLinkExternal = (href) => {
    if (!href || href.length === 0) {
        return false;
    }
    const matcher = /(^[?#/]|http)|^[^.]+(\/)/;
    let hrefWithProtocol = href;
    if (!matcher.test(href)) {
        hrefWithProtocol = `https://${href}`;
    }
    const baseUrl = 'https://zapier.com';
    let url;
    try {
        url = new URL(hrefWithProtocol, baseUrl);
    }
    catch (_) {
        return true;
    }
    const [topLevelDomain, secondLevelDomain] = url.host
        .split(':')[0]
        .split('.')
        .reverse();
    const domain = secondLevelDomain
        ? `${secondLevelDomain}.${topLevelDomain}`
        : topLevelDomain;
    return !DOMAIN_WHITELIST.includes(domain);
};
const buildRel = (rel, isExternal, noReferrer) => {
    const externalLinkRel = [];
    if (isExternal) {
        externalLinkRel.push('noopener');
    }
    if (isExternal && noReferrer) {
        externalLinkRel.push('noreferrer');
    }
    const propsRel = (rel && rel.split(/\s+/)) || [];
    return [...new Set([...propsRel, ...externalLinkRel])].join(' ') || undefined;
};
const Link = (0,react.forwardRef)(function Link(props, ref) {
    const { color = 'primary', component: Component, noReferrer = true, weight = 'inherit', } = props;
    const colorMaybeNull = color === 'inherit' ? null : color;
    const trimmedHref = props.href ? props.href.trim() : props.href;
    const { LinkComponent: ContextLink } = useDesignSystem();
    const LinkComponent = Component || ContextLink;
    const dataAttributes = (0,fromEntries/* fromEntries */.s)(Object.entries(props).filter(([key]) => {
        return key.startsWith('data-');
    }));
    return ((0,isolateComponent/* isolateComponent */.U)(LinkComponent, Object.assign({ "aria-current": props.ariaCurrent, "aria-label": props.ariaLabel, className: props.className, css: props.className ? undefined : Styles.root(), "data-color": props.className ? undefined : colorMaybeNull, "data-weight": props.className ? undefined : weight, href: trimmedHref, id: props.id, name: props.name, onBlur: props.onBlur, onClick: props.onClick, onFocus: props.onFocus, onKeyDown: props.onKeyDown, onMouseDown: props.onMouseDown, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onMouseUp: props.onMouseUp, ref: ref, rel: buildRel(props.rel, isLinkExternal(props.href), noReferrer), role: props.role, style: props.style, tabIndex: props.tabIndex, target: props.target, referrerPolicy: props.referrerPolicy, title: props.title }, dataAttributes), props.children));
});
//# sourceMappingURL=Link.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 64476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ServiceIcon; }
/* harmony export */ });
/* harmony import */ var _ServiceIconShell__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35788);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77293);
/* harmony import */ var _display_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77509);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41717);




const getPropsWithDefaults = (props) => (Object.assign({ ariaHidden: false, hasBorder: true }, props));
const ServiceIcon = (props) => {
    const { ariaHidden, serviceName, hasBorder, hasShadow, size, src, alt, hasWhiteBackground, } = getPropsWithDefaults(props);
    const { iconSize } = _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceIconConfig */ .G[size];
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .isolateComponent */ .U)(_ServiceIconShell__WEBPACK_IMPORTED_MODULE_2__/* .ServiceIconShell */ .e, { size: size, hasBorder: hasBorder, hasShadow: hasShadow, hasWhiteBackground: hasWhiteBackground },
        (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_1__/* .isolateComponent */ .U)(_display_Img__WEBPACK_IMPORTED_MODULE_3__/* .Img */ .E, { alt: alt || `${serviceName} logo`, ariaHidden: ariaHidden, borderRadius: 0, height: iconSize, objectFit: "contain", src: src, width: iconSize })));
};
//# sourceMappingURL=ServiceIcon.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 41717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ServiceIconConfig; }
/* harmony export */ });
const ServiceIconConfig = {
    20: {
        borderRadius: 3,
        iconSize: 14,
        spacing: 5,
    },
    30: {
        borderRadius: 3,
        iconSize: 20,
        spacing: 5,
    },
    40: {
        borderRadius: 5,
        iconSize: 30,
        spacing: 5,
    },
    60: {
        borderRadius: 8,
        iconSize: 40,
        spacing: 10,
    },
    80: {
        borderRadius: 10,
        iconSize: 60,
        spacing: 20,
    },
    120: {
        borderRadius: 15,
        iconSize: 90,
        spacing: 30,
    },
    150: {
        borderRadius: 18,
        iconSize: 110,
        spacing: 40,
    },
};
//# sourceMappingURL=constants.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 35788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ServiceIconShell; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28165);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70776);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10391);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98628);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39479);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52676);
/* harmony import */ var _zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77293);
/* harmony import */ var _ServiceIcon_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41717);




const getPropsWithDefaults = (props) => (Object.assign({ isEmpty: false, hasBorder: true }, props));
const Styles = (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_0__/* .labelStyles */ .B)('ServiceIconShell', {
    root: (_props) => {
        const props = getPropsWithDefaults(_props);
        const { borderRadius } = _ServiceIcon_constants__WEBPACK_IMPORTED_MODULE_1__/* .ServiceIconConfig */ .G[props.size];
        const border = props.hasBorder ? `1px solid ${_theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.neutral300 */ .w.neutral300}` : `none`;
        const background = props.hasWhiteBackground
            ? _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .w.white
            : _theme__WEBPACK_IMPORTED_MODULE_2__/* .Colors.neutral100 */ .w.neutral100;
        return [
            _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${background};
        border: ${border};
        border-radius: ${borderRadius}px;
      `,
            (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .withModifier */ .Q)(`size`, _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
          height: ${props.size}px;
          width: ${props.size}px;
        `),
            props.hasShadow &&
                (0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_4__/* .withModifier */ .Q)('shadowed', _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv `
            box-shadow: ${_theme__WEBPACK_IMPORTED_MODULE_5__/* .Shadows.elevation5 */ .f.elevation5};
            transition-duration: ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Animation.transitionDuration */ .f.transitionDuration};
            transition-property: box-shadow;
            transition-timing-function: ${_theme__WEBPACK_IMPORTED_MODULE_6__/* .Animation.transitionTimingFunction */ .f.transitionTimingFunction};
          `),
        ];
    },
});
const ServiceIconShell = (props) => {
    return ((0,_zapier_style_encapsulation__WEBPACK_IMPORTED_MODULE_7__/* .isolateComponent */ .U)("span", { css: Styles.root(props), "data-testid": "ServiceIconShell" }, props.children));
};
//# sourceMappingURL=ServiceIconShell.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 37168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const useClickOutside = ({ onClickOutside, }) => {
    const [node, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const onClick = (event) => {
            if (onClickOutside && node && !node.contains(event.target)) {
                onClickOutside(event);
            }
        };
        const body = document && document.body;
        if (body) {
            body.addEventListener('click', onClick, { capture: true });
            body.addEventListener('touchend', onClick, { capture: true });
            return () => {
                body.removeEventListener('click', onClick, { capture: true });
                body.removeEventListener('touchend', onClick, { capture: true });
            };
        }
        return () => { };
    }, [node, onClickOutside]);
    return [setNode];
};
//# sourceMappingURL=useClickOutside.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 69480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useIntersect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const useIntersect = ({ heightOverride, once = false, root, rootMargin = '0px', threshold = 1, } = {}) => {
    const [entry, updateEntry] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [meta, updateMeta] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [node, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const disconnect = () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
        disconnect();
        const getMetadata = ({ intersectionRatio, intersectionRect, rootBounds, }) => {
            const isIntersecting = !!intersectionRect && !!rootBounds && intersectionRatio < threshold;
            const height = heightOverride !== null && heightOverride !== void 0 ? heightOverride : intersectionRect.height;
            const bottom = intersectionRect.top + height;
            const top = intersectionRect.top - height;
            return {
                isTopIntersecting: isIntersecting &&
                    (top <= rootBounds.top ||
                        intersectionRect.height > rootBounds.height),
                isBottomIntersecting: isIntersecting && bottom >= rootBounds.bottom,
                isLeftIntersecting: isIntersecting && intersectionRect.left <= rootBounds.left,
                isRightIntersecting: isIntersecting && intersectionRect.right >= rootBounds.right,
            };
        };
        const callback = ([updatedEntry]) => {
            updateEntry(updatedEntry);
            updateMeta(getMetadata(updatedEntry));
            if (once) {
                disconnect();
            }
        };
        const options = {
            root,
            rootMargin,
            threshold: Array.isArray(threshold) ? threshold : [threshold],
        };
        if (window.IntersectionObserver) {
            observer.current = new window.IntersectionObserver(callback, options);
        }
        if (node && observer.current) {
            observer.current.observe(node);
        }
        return disconnect;
    }, [once, node, root, rootMargin, threshold, heightOverride]);
    return [setNode, Object.assign({ entry }, meta)];
};
//# sourceMappingURL=useIntersect.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 60196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useOverflow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const useOverflow = () => {
    const [isOverflowing, setIsOverflowing] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [node, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (node) {
            const offsetHeight = node.offsetHeight;
            const scrollHeight = node.scrollHeight;
            if (scrollHeight - offsetHeight > 2) {
                setIsOverflowing(true);
            }
        }
    }, [node]);
    return [isOverflowing, setNode];
};
//# sourceMappingURL=useOverflow.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 98628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Animation; }
/* harmony export */ });
const transitionTimingFunction = 'ease-in-out';
const transitionDuration = '300ms';
const transitionValue = `all ${transitionDuration} ${transitionTimingFunction}`;
const Animation = {
    transitionTimingFunction,
    transitionDuration,
    transitionValue,
};
//# sourceMappingURL=Animation.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 70776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ Colors; }
});

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-tokens/dist/index.mjs
var p=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var y=Object.getOwnPropertyNames;var c=Object.getPrototypeOf,h=Object.prototype.hasOwnProperty;var g=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports);var f=(t,e,s,o)=>{if(e&&typeof e=="object"||typeof e=="function")for(let r of y(e))!h.call(t,r)&&r!==s&&a(t,r,{get:()=>e[r],enumerable:!(o=l(e,r))||o.enumerable});return t};var S=(t,e,s)=>(s=t!=null?p(c(t)):{},f(e||!t||!t.__esModule?a(s,"default",{value:t,enumerable:!0}):s,t));var u=g((v,i)=>{"use strict";i.exports={border:{},color:{brand:{orange:{value:"#ff4f00",type:"color",comment:`#FF4F00

Primary brand color`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ff4f00ff",type:"color",comment:`#FF4F00

Primary brand color`},name:"ColorBrandOrange",attributes:{category:"color",type:"brand",item:"orange"},path:["color","brand","orange"]},earth:{value:"#201515",type:"color",comment:"#201515",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#201515ff",type:"color",comment:"#201515"},name:"ColorBrandEarth",attributes:{category:"color",type:"brand",item:"earth"},path:["color","brand","earth"]},peach:{value:"#ffbf6e",type:"color",comment:"#FFBF6E",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ffbf6eff",type:"color",comment:"#FFBF6E"},name:"ColorBrandPeach",attributes:{category:"color",type:"brand",item:"peach"},path:["color","brand","peach"]},cream:{value:"#fff3e6",type:"color",comment:"#FFF3E6",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fff3e6ff",type:"color",comment:"#FFF3E6"},name:"ColorBrandCream",attributes:{category:"color",type:"brand",item:"cream"},path:["color","brand","cream"]},moss:{value:"#1f3121",type:"color",comment:"#1F3121",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#1f3121ff",type:"color",comment:"#1F3121"},name:"ColorBrandMoss",attributes:{category:"color",type:"brand",item:"moss"},path:["color","brand","moss"]},bolt:{value:"#f6ffdb",type:"color",comment:"#F6FFDB",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#f6ffdbff",type:"color",comment:"#F6FFDB"},name:"ColorBrandBolt",attributes:{category:"color",type:"brand",item:"bolt"},path:["color","brand","bolt"]},night:{value:"#2b2358",type:"color",comment:"#2B2358",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#2b2358ff",type:"color",comment:"#2B2358"},name:"ColorBrandNight",attributes:{category:"color",type:"brand",item:"night"},path:["color","brand","night"]},sky:{value:"#cde4e1",type:"color",comment:"#CDE4E1",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#cde4e1ff",type:"color",comment:"#CDE4E1"},name:"ColorBrandSky",attributes:{category:"color",type:"brand",item:"sky"},path:["color","brand","sky"]},lavender:{value:"#c1b7ff",type:"color",comment:"#C1B7FF",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#c1b7ffff",type:"color",comment:"#C1B7FF"},name:"ColorBrandLavender",attributes:{category:"color",type:"brand",item:"lavender"},path:["color","brand","lavender"]}},neutrals:{neutral800:{value:"#2d2e2e",type:"color",comment:`#2D2E2E \u2022 Almost black

Uses: Headlines/other text, Primary Icons`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#2d2e2eff",type:"color",comment:`#2D2E2E \u2022 Almost black

Uses: Headlines/other text, Primary Icons`},name:"ColorNeutralsNeutral800",attributes:{category:"color",type:"neutrals",item:"neutral800"},path:["color","neutrals","neutral800"]},neutral700:{value:"#403f3e",type:"color",comment:`#403F3E

Uses: Secondary headlines, Body text`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#403f3eff",type:"color",comment:`#403F3E

Uses: Secondary headlines, Body text`},name:"ColorNeutralsNeutral700",attributes:{category:"color",type:"neutrals",item:"neutral700"},path:["color","neutrals","neutral700"]},neutral600:{value:"#95928e",type:"color",comment:`#95928E

Uses: Secondary Icons`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#95928eff",type:"color",comment:`#95928E

Uses: Secondary Icons`},name:"ColorNeutralsNeutral600",attributes:{category:"color",type:"neutrals",item:"neutral600"},path:["color","neutrals","neutral600"]},neutral500:{value:"#a8a5a0",type:"color",comment:`#A8A5A0

Uses: Inactive Text (buttons, inputs)`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#a8a5a0ff",type:"color",comment:`#A8A5A0

Uses: Inactive Text (buttons, inputs)`},name:"ColorNeutralsNeutral500",attributes:{category:"color",type:"neutrals",item:"neutral500"},path:["color","neutrals","neutral500"]},neutral400:{value:"#d7d5d2",type:"color",comment:`#D7D5D2

Uses: Strong Borders`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#d7d5d2ff",type:"color",comment:`#D7D5D2

Uses: Strong Borders`},name:"ColorNeutralsNeutral400",attributes:{category:"color",type:"neutrals",item:"neutral400"},path:["color","neutrals","neutral400"]},neutral300:{value:"#e8e7e4",type:"color",comment:`#E8E7E4

Uses: Soft borders`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#e8e7e4ff",type:"color",comment:`#E8E7E4

Uses: Soft borders`},name:"ColorNeutralsNeutral300",attributes:{category:"color",type:"neutrals",item:"neutral300"},path:["color","neutrals","neutral300"]},neutral200:{value:"#f7f5f2",type:"color",comment:`#F7F5F2

Uses: Inactive Input Background`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#f7f5f2ff",type:"color",comment:`#F7F5F2

Uses: Inactive Input Background`},name:"ColorNeutralsNeutral200",attributes:{category:"color",type:"neutrals",item:"neutral200"},path:["color","neutrals","neutral200"]},neutral100:{value:"#fffdf9",type:"color",comment:`#FFFDF9 \u2022 Almost white

Uses: Page and component backgrounds, light text`,filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fffdf9ff",type:"color",comment:`#FFFDF9 \u2022 Almost white

Uses: Page and component backgrounds, light text`},name:"ColorNeutralsNeutral100",attributes:{category:"color",type:"neutrals",item:"neutral100"},path:["color","neutrals","neutral100"]}},ui:{action:{blue100:{value:"#f0f1fa",type:"color",comment:"#F0F1FA \u2022 Used for expressing state",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#f0f1faff",type:"color",comment:"#F0F1FA \u2022 Used for expressing state"},name:"ColorUiActionBlue100",attributes:{category:"color",type:"ui",item:"action",subitem:"blue100"},path:["color","ui","action","blue100"]},blue600:{value:"#3d4592",type:"color",comment:"#3D4592 \u2022 Used for primary actions",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#3d4592ff",type:"color",comment:"#3D4592 \u2022 Used for primary actions"},name:"ColorUiActionBlue600",attributes:{category:"color",type:"ui",item:"action",subitem:"blue600"},path:["color","ui","action","blue600"]},blue200:{value:"#d2d8f3",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#d2d8f3ff",type:"color"},name:"ColorUiActionBlue200",attributes:{category:"color",type:"ui",item:"action",subitem:"blue200"},path:["color","ui","action","blue200"]},blue300:{value:"#b2bce9",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#b2bce9ff",type:"color"},name:"ColorUiActionBlue300",attributes:{category:"color",type:"ui",item:"action",subitem:"blue300"},path:["color","ui","action","blue300"]},blue400:{value:"#90a1ed",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#90a1edff",type:"color"},name:"ColorUiActionBlue400",attributes:{category:"color",type:"ui",item:"action",subitem:"blue400"},path:["color","ui","action","blue400"]},blue500:{value:"#5e71c7",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#5e71c7ff",type:"color"},name:"ColorUiActionBlue500",attributes:{category:"color",type:"ui",item:"action",subitem:"blue500"},path:["color","ui","action","blue500"]}},feedback:{success100:{value:"#def3e9",type:"color",comment:"#DEF3E9",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#def3e9ff",type:"color",comment:"#DEF3E9"},name:"ColorUiFeedbackSuccess100",attributes:{category:"color",type:"ui",item:"feedback",subitem:"success100"},path:["color","ui","feedback","success100"]},success400:{value:"#0f884e",type:"color",comment:"#0F884E",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#0f884eff",type:"color",comment:"#0F884E"},name:"ColorUiFeedbackSuccess400",attributes:{category:"color",type:"ui",item:"feedback",subitem:"success400"},path:["color","ui","feedback","success400"]},success500:{value:"#086f3d",type:"color",comment:"High contrast success backgrounds",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#086f3dff",type:"color",comment:"High contrast success backgrounds"},name:"ColorUiFeedbackSuccess500",attributes:{category:"color",type:"ui",item:"feedback",subitem:"success500"},path:["color","ui","feedback","success500"]},warning100:{value:"#fff4bc",type:"color",comment:"#FFF4BC",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fff4bcff",type:"color",comment:"#FFF4BC"},name:"ColorUiFeedbackWarning100",attributes:{category:"color",type:"ui",item:"feedback",subitem:"warning100"},path:["color","ui","feedback","warning100"]},warning200:{value:"#fcea93",type:"color",comment:"#FCEA93",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fcea93ff",type:"color",comment:"#FCEA93"},name:"ColorUiFeedbackWarning200",attributes:{category:"color",type:"ui",item:"feedback",subitem:"warning200"},path:["color","ui","feedback","warning200"]},warning400:{value:"#ffd300",type:"color",comment:"#FFD300",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ffd300ff",type:"color",comment:"#FFD300"},name:"ColorUiFeedbackWarning400",attributes:{category:"color",type:"ui",item:"feedback",subitem:"warning400"},path:["color","ui","feedback","warning400"]},warning500:{value:"#eec913",type:"color",comment:"#EEC913",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#eec913ff",type:"color",comment:"#EEC913"},name:"ColorUiFeedbackWarning500",attributes:{category:"color",type:"ui",item:"feedback",subitem:"warning500"},path:["color","ui","feedback","warning500"]},error100:{value:"#fadfd9",type:"color",comment:"#FADFD9",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fadfd9ff",type:"color",comment:"#FADFD9"},name:"ColorUiFeedbackError100",attributes:{category:"color",type:"ui",item:"feedback",subitem:"error100"},path:["color","ui","feedback","error100"]},error400:{value:"#ce482d",type:"color",comment:"#CE482D",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ce482dff",type:"color",comment:"#CE482D"},name:"ColorUiFeedbackError400",attributes:{category:"color",type:"ui",item:"feedback",subitem:"error400"},path:["color","ui","feedback","error400"]},error500:{value:"#b83519",type:"color",comment:"#B83519",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#b83519ff",type:"color",comment:"#B83519"},name:"ColorUiFeedbackError500",attributes:{category:"color",type:"ui",item:"feedback",subitem:"error500"},path:["color","ui","feedback","error500"]},success200:{value:"#ade2c8",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ade2c8ff",type:"color"},name:"ColorUiFeedbackSuccess200",attributes:{category:"color",type:"ui",item:"feedback",subitem:"success200"},path:["color","ui","feedback","success200"]},success300:{value:"#36a770",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#36a770ff",type:"color"},name:"ColorUiFeedbackSuccess300",attributes:{category:"color",type:"ui",item:"feedback",subitem:"success300"},path:["color","ui","feedback","success300"]},warning300:{value:"#f8df68",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#f8df68ff",type:"color"},name:"ColorUiFeedbackWarning300",attributes:{category:"color",type:"ui",item:"feedback",subitem:"warning300"},path:["color","ui","feedback","warning300"]},error200:{value:"#feb7a8",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#feb7a8ff",type:"color"},name:"ColorUiFeedbackError200",attributes:{category:"color",type:"ui",item:"feedback",subitem:"error200"},path:["color","ui","feedback","error200"]},error300:{value:"#e87057",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#e87057ff",type:"color"},name:"ColorUiFeedbackError300",attributes:{category:"color",type:"ui",item:"feedback",subitem:"error300"},path:["color","ui","feedback","error300"]}},accent:{pink:{value:"#fad9ef",type:"color",comment:"#FAD9EF",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fad9efff",type:"color",comment:"#FAD9EF"},name:"ColorUiAccentPink",attributes:{category:"color",type:"ui",item:"accent",subitem:"pink"},path:["color","ui","accent","pink"]},purple:{value:"#ebd9fa",type:"color",comment:"#EBD9FA",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ebd9faff",type:"color",comment:"#EBD9FA"},name:"ColorUiAccentPurple",attributes:{category:"color",type:"ui",item:"accent",subitem:"purple"},path:["color","ui","accent","purple"]},mint:{value:"#d6fcf5",type:"color",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#d6fcf5ff",type:"color"},name:"ColorUiAccentMint",attributes:{category:"color",type:"ui",item:"accent",subitem:"mint"},path:["color","ui","accent","mint"]}},semantic:{action:{"bg-primary":{value:"#3d4592",type:"color",comment:"Primary UI action color for backgrounds.",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#3d4592ff",type:"color",comment:"Primary UI action color for backgrounds."},name:"ColorUiSemanticActionBgPrimary",attributes:{category:"color",type:"ui",item:"semantic",subitem:"action",state:"bg-primary"},path:["color","ui","semantic","action","bg-primary"]},"bg-primary-hover":{value:"#2b2358",type:"color",comment:"Complementary Brand background color used for UI hover states.",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#2b2358ff",type:"color",comment:"Complementary Brand background color used for UI hover states."},name:"ColorUiSemanticActionBgPrimaryHover",attributes:{category:"color",type:"ui",item:"semantic",subitem:"action",state:"bg-primary-hover"},path:["color","ui","semantic","action","bg-primary-hover"]},"bg-selected":{value:"#f0f1fa",type:"color",comment:"Soft highlight background color used behind text in menus and navigation elements",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#f0f1faff",type:"color",comment:"Soft highlight background color used behind text in menus and navigation elements"},name:"ColorUiSemanticActionBgSelected",attributes:{category:"color",type:"ui",item:"semantic",subitem:"action",state:"bg-selected"},path:["color","ui","semantic","action","bg-selected"]}},feedback:{"bg-success":{value:"#def3e9",type:"color",comment:"Soft Success color used for backgrounds like Tag Label",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#def3e9ff",type:"color",comment:"Soft Success color used for backgrounds like Tag Label"},name:"ColorUiSemanticFeedbackBgSuccess",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"bg-success"},path:["color","ui","semantic","feedback","bg-success"]},"fg-success":{value:"#0f884e",type:"color",comment:"Primary Success foreground color for icons, alerts, and badges",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#0f884eff",type:"color",comment:"Primary Success foreground color for icons, alerts, and badges"},name:"ColorUiSemanticFeedbackFgSuccess",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"fg-success"},path:["color","ui","semantic","feedback","fg-success"]},"bg-warning":{value:"#fff4bc",type:"color",comment:"Soft Warning color used for backgrounds like Tag Label",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fff4bcff",type:"color",comment:"Soft Warning color used for backgrounds like Tag Label"},name:"ColorUiSemanticFeedbackBgWarning",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"bg-warning"},path:["color","ui","semantic","feedback","bg-warning"]},"fg-warning":{value:"#ffd300",type:"color",comment:"Primary Warning foreground color for icons, alerts, and badges",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ffd300ff",type:"color",comment:"Primary Warning foreground color for icons, alerts, and badges"},name:"ColorUiSemanticFeedbackFgWarning",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"fg-warning"},path:["color","ui","semantic","feedback","fg-warning"]},"bg-error":{value:"#fadfd9",type:"color",comment:"Soft Error color used for backgrounds like Tag Label",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fadfd9ff",type:"color",comment:"Soft Error color used for backgrounds like Tag Label"},name:"ColorUiSemanticFeedbackBgError",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"bg-error"},path:["color","ui","semantic","feedback","bg-error"]},"fg-error":{value:"#ce482d",type:"color",comment:"Primary Error foreground color for icons, alerts, and badges",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#ce482dff",type:"color",comment:"Primary Error foreground color for icons, alerts, and badges"},name:"ColorUiSemanticFeedbackFgError",attributes:{category:"color",type:"ui",item:"semantic",subitem:"feedback",state:"fg-error"},path:["color","ui","semantic","feedback","fg-error"]}},surface:{"bg-primary":{value:"#fffdf9",type:"color",comment:"Page and component backgrounds, light text",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#fffdf9ff",type:"color",comment:"Page and component backgrounds, light text"},name:"ColorUiSemanticSurfaceBgPrimary",attributes:{category:"color",type:"ui",item:"semantic",subitem:"surface",state:"bg-primary"},path:["color","ui","semantic","surface","bg-primary"]},"border-subtle":{value:"#e8e7e4",type:"color",comment:"Soft borders",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#e8e7e4ff",type:"color",comment:"Soft borders"},name:"ColorUiSemanticSurfaceBorderSubtle",attributes:{category:"color",type:"ui",item:"semantic",subitem:"surface",state:"border-subtle"},path:["color","ui","semantic","surface","border-subtle"]},"border-strong":{value:"#d7d5d2",type:"color",comment:"Strong borders",filePath:"src/tokens/colors.json",isSource:!0,original:{value:"#d7d5d2ff",type:"color",comment:"Strong borders"},name:"ColorUiSemanticSurfaceBorderStrong",attributes:{category:"color",type:"ui",item:"semantic",subitem:"surface",state:"border-strong"},path:["color","ui","semantic","surface","border-strong"]}}}}},font:{},gradient:{gradients:{"carousel-fade":{value:{to:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:.9999999999999999,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf900",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:.9999999999999999,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf900",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientGradientsCarouselFade",attributes:{category:"gradient",type:"gradients",item:"carousel-fade"},path:["gradient","gradients","carousel-fade"]},"modal-fade":{value:{to:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:.9999999999999999,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf980",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:.9999999999999999,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf980",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientGradientsModalFade",attributes:{category:"gradient",type:"gradients",item:"modal-fade"},path:["gradient","gradients","modal-fade"]}},hero:{"default-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.4999999690944974,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996909449784,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5685111880302429,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.568611204624176,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.4999999690944974,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996909449784,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5685111880302429,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.568611204624176,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroDefaultColorblock",attributes:{category:"gradient",type:"hero",item:"default-colorblock"},path:["gradient","hero","default-colorblock"]},"zapier-orange-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.49999996833709015,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996833708993,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#ff4f00ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.515625,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#ff4f00ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5157250165939331,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.49999996833709015,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996833708993,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#ff4f00ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.515625,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#ff4f00ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5157250165939331,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroZapierOrangeColorblock",attributes:{category:"gradient",type:"hero",item:"zapier-orange-colorblock"},path:["gradient","hero","zapier-orange-colorblock"]},"night-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.5000000312512753,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000312512753,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5208333134651184,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5209333300590515,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.5000000312512753,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000312512753,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5208333134651184,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5209333300590515,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroNightColorblock",attributes:{category:"gradient",type:"hero",item:"night-colorblock"},path:["gradient","hero","night-colorblock"]},"almost-black-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.4999999690944974,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996909449784,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2d2e2eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5260416865348816,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2d2e2eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5261417031288147,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.4999999690944974,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996909449784,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2d2e2eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5260416865348816,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2d2e2eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5261417031288147,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroAlmostBlackColorblock",attributes:{category:"gradient",type:"hero",item:"almost-black-colorblock"},path:["gradient","hero","almost-black-colorblock"]},"moss-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.49999996833709015,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996833708993,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#1f3121ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.515625,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#1f3121ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5157250165939331,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.49999996833709015,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.49999996833708993,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#1f3121ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.515625,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#1f3121ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5157250165939331,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroMossColorblock",attributes:{category:"gradient",type:"hero",item:"moss-colorblock"},path:["gradient","hero","moss-colorblock"]}},"hero-mobile":{"default-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.4999999903236202,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000000000001,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:790556014267821e-31,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5790279507637024,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5791279673576355,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.4999999903236202,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000000000001,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:790556014267821e-31,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5790279507637024,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#403f3eff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5791279673576355,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroMobileDefaultColorblock",attributes:{category:"gradient",type:"hero-mobile",item:"default-colorblock"},path:["gradient","hero-mobile","default-colorblock"]},"night-colorblock":{value:{to:{type:"point",value:{x:{type:"size",value:.4999999903236202,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000000000001,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:790556014267821e-31,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5260416865348816,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5261417031288147,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient",filePath:"src/tokens/gradients.json",isSource:!0,original:{value:{to:{type:"point",value:{x:{type:"size",value:.4999999903236202,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:1,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},from:{type:"point",value:{x:{type:"size",value:.5000000000000001,filePath:"src/tokens/gradients.json",isSource:!0},y:{type:"size",value:790556014267821e-31,filePath:"src/tokens/gradients.json",isSource:!0}},filePath:"src/tokens/gradients.json",isSource:!0},type:{type:"string",value:"Linear",filePath:"src/tokens/gradients.json",isSource:!0},aspectRatio:{type:"size"},stops:{0:{type:"gradientStop",position:{type:"size",value:0,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},1:{type:"gradientStop",position:{type:"size",value:.5260416865348816,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#2b2358ff",filePath:"src/tokens/gradients.json",isSource:!0}},2:{type:"gradientStop",position:{type:"size",value:.5261417031288147,filePath:"src/tokens/gradients.json",isSource:!0},color:{type:"color",value:"#fffdf9ff",filePath:"src/tokens/gradients.json",isSource:!0}}}},type:"gradient"},name:"GradientHeroMobileNightColorblock",attributes:{category:"gradient",type:"hero-mobile",item:"night-colorblock"},path:["gradient","hero-mobile","night-colorblock"]}}},measure:{},radius:{},shadow:{button:{value:{color:{type:"color",value:"#00000033",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#00000033",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowButton",attributes:{category:"shadow",type:"button"},path:["shadow","button"]},selected:{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowSelected",attributes:{category:"shadow",type:"selected"},path:["shadow","selected"]},hover:{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowHover",attributes:{category:"shadow",type:"hover"},path:["shadow","hover"]},dropdown:{value:{color:{type:"color",value:"#00000033",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#00000033",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowDropdown",attributes:{category:"shadow",type:"dropdown"},path:["shadow","dropdown"]},"service-icon":{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#0000001a",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:5,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowServiceIcon",attributes:{category:"shadow",type:"service-icon"},path:["shadow","service-icon"]},tooltip:{value:{color:{type:"color",value:"#0000004d",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow",filePath:"src/tokens/shadows.json",isSource:!0,original:{value:{color:{type:"color",value:"#0000004d",filePath:"src/tokens/shadows.json",isSource:!0},x:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},y:{type:"measure",value:{measure:{type:"size",value:10,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},radius:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},spread:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/shadows.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/shadows.json",isSource:!0}},filePath:"src/tokens/shadows.json",isSource:!0},opacity:{type:"size",value:1,filePath:"src/tokens/shadows.json",isSource:!0}},type:"shadow"},name:"ShadowTooltip",attributes:{category:"shadow",type:"tooltip"},path:["shadow","tooltip"]}},text:{},typography:{headers:{"page-header-1":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:82,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:84,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:82,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:84,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader1",attributes:{category:"typography",type:"headers",item:"page-header-1"},path:["typography","headers","page-header-1"]},"page-header-3":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:62,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.61,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:66,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:62,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.61,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:66,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader3",attributes:{category:"typography",type:"headers",item:"page-header-3"},path:["typography","headers","page-header-3"]},"page-header-4":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:52,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.92,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:60,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular Display",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:52,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:1.92,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:60,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader4",attributes:{category:"typography",type:"headers",item:"page-header-4"},path:["typography","headers","page-header-4"]},"page-header-5":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:42,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:50,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:42,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:50,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader5",attributes:{category:"typography",type:"headers",item:"page-header-5"},path:["typography","headers","page-header-5"]},"page-header-7":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:34,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:40,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:34,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:40,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader7",attributes:{category:"typography",type:"headers",item:"page-header-7"},path:["typography","headers","page-header-7"]},"page-header-9":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyHeadersPageHeader9",attributes:{category:"typography",type:"headers",item:"page-header-9"},path:["typography","headers","page-header-9"]}},sections:{"section-header-1-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:35,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:35,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSectionHeader1Medium",attributes:{category:"typography",type:"sections",item:"section-header-1-medium-"},path:["typography","sections","section-header-1-medium-"]},"section-header-1-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:35,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:32,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:35,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSectionHeader1Bold",attributes:{category:"typography",type:"sections",item:"section-header-1-bold-"},path:["typography","sections","section-header-1-bold-"]},"section-header-3-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSectionHeader3SemiBold",attributes:{category:"typography",type:"sections",item:"section-header-3-semi-bold-"},path:["typography","sections","section-header-3-semi-bold-"]},"section-header-3-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSectionHeader3Bold",attributes:{category:"typography",type:"sections",item:"section-header-3-bold-"},path:["typography","sections","section-header-3-bold-"]},"subheader-1":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader1",attributes:{category:"typography",type:"sections",item:"subheader-1"},path:["typography","sections","subheader-1"]},"subheader-1-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader1SemiBold",attributes:{category:"typography",type:"sections",item:"subheader-1-semi-bold-"},path:["typography","sections","subheader-1-semi-bold-"]},"subheader-1-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:30,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader1Bold",attributes:{category:"typography",type:"sections",item:"subheader-1-bold-"},path:["typography","sections","subheader-1-bold-"]},"subheader-3-deprecated-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader3Deprecated",attributes:{category:"typography",type:"sections",item:"subheader-3-deprecated-"},path:["typography","sections","subheader-3-deprecated-"]},"subheader-3-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader3Medium",attributes:{category:"typography",type:"sections",item:"subheader-3-medium-"},path:["typography","sections","subheader-3-medium-"]},"subheader-3-semibold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:22,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:28,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader3Semibold",attributes:{category:"typography",type:"sections",item:"subheader-3-semibold-"},path:["typography","sections","subheader-3-semibold-"]},"subheader-5-deprecated-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader5Deprecated",attributes:{category:"typography",type:"sections",item:"subheader-5-deprecated-"},path:["typography","sections","subheader-5-deprecated-"]},"subheader-5-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader5Medium",attributes:{category:"typography",type:"sections",item:"subheader-5-medium-"},path:["typography","sections","subheader-5-medium-"]},"subheader-5-semibold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Degular",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Semibold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:26,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographySectionsSubheader5Semibold",attributes:{category:"typography",type:"sections",item:"subheader-5-semibold-"},path:["typography","sections","subheader-5-semibold-"]}},body:{"paragraph-1":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1",attributes:{category:"typography",type:"body",item:"paragraph-1"},path:["typography","body","paragraph-1"]},"paragraph-1-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1Medium",attributes:{category:"typography",type:"body",item:"paragraph-1-medium-"},path:["typography","body","paragraph-1-medium-"]},"paragraph-1-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1SemiBold",attributes:{category:"typography",type:"body",item:"paragraph-1-semi-bold-"},path:["typography","body","paragraph-1-semi-bold-"]},"paragraph-1-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:31,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1Bold",attributes:{category:"typography",type:"body",item:"paragraph-1-bold-"},path:["typography","body","paragraph-1-bold-"]},"paragraph-1-short-regular-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1ShortRegular",attributes:{category:"typography",type:"body",item:"paragraph-1-short-regular-"},path:["typography","body","paragraph-1-short-regular-"]},"paragraph-1-short-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1ShortMedium",attributes:{category:"typography",type:"body",item:"paragraph-1-short-medium-"},path:["typography","body","paragraph-1-short-medium-"]},"paragraph-1-short-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1ShortSemiBold",attributes:{category:"typography",type:"body",item:"paragraph-1-short-semi-bold-"},path:["typography","body","paragraph-1-short-semi-bold-"]},"paragraph-1-short-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:18,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph1ShortBold",attributes:{category:"typography",type:"body",item:"paragraph-1-short-bold-"},path:["typography","body","paragraph-1-short-bold-"]},"paragraph-3":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph3",attributes:{category:"typography",type:"body",item:"paragraph-3"},path:["typography","body","paragraph-3"]},"paragraph-3-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph3Medium",attributes:{category:"typography",type:"body",item:"paragraph-3-medium-"},path:["typography","body","paragraph-3-medium-"]},"paragraph-3-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph3SemiBold",attributes:{category:"typography",type:"body",item:"paragraph-3-semi-bold-"},path:["typography","body","paragraph-3-semi-bold-"]},"paragraph-3-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:16,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:24,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodyParagraph3Bold",attributes:{category:"typography",type:"body",item:"paragraph-3-bold-"},path:["typography","body","paragraph-3-bold-"]},"small-print":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Regular",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodySmallPrint",attributes:{category:"typography",type:"body",item:"small-print"},path:["typography","body","small-print"]},"small-print-medium-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Medium",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodySmallPrintMedium",attributes:{category:"typography",type:"body",item:"small-print-medium-"},path:["typography","body","small-print-medium-"]},"small-print-semi-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"SemiBold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodySmallPrintSemiBold",attributes:{category:"typography",type:"body",item:"small-print-semi-bold-"},path:["typography","body","small-print-semi-bold-"]},"small-print-bold-":{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography",filePath:"src/tokens/typography.json",isSource:!0,original:{value:{font:{type:"font",value:{family:{type:"string",value:"Inter",filePath:"src/tokens/typography.json",isSource:!0},subfamily:{type:"string",value:"Bold",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},fontSize:{type:"measure",value:{measure:{type:"size",value:14,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},textDecoration:"None",textCase:"Original",letterSpacing:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"percent",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},paragraphIndent:{type:"measure",value:{measure:{type:"size",value:0,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0},lineHeight:{type:"measure",value:{measure:{type:"size",value:20,filePath:"src/tokens/typography.json",isSource:!0},unit:{type:"string",value:"pixels",filePath:"src/tokens/typography.json",isSource:!0}},filePath:"src/tokens/typography.json",isSource:!0}},type:"typography"},name:"TypographyBodySmallPrintBold",attributes:{category:"typography",type:"body",item:"small-print-bold-"},path:["typography","body","small-print-bold-"]}}}}});var n=S(u()),P=n.default;
//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js

const BaseColors = {
    zapier: P.color.brand.orange.value,
    earth: P.color.brand.earth.value,
    moss: P.color.brand.moss.value,
    night: P.color.brand.night.value,
    lavender: P.color.brand.lavender.value,
    peach: P.color.brand.peach.value,
    bolt: P.color.brand.bolt.value,
    sky: P.color.brand.sky.value,
    cream: P.color.brand.cream.value,
    blue: P.color.ui.action.blue600.value,
    blue80: P.color.ui.action.blue500.value,
    blue60: P.color.ui.action.blue400.value,
    blue40: P.color.ui.action.blue300.value,
    blue20: P.color.ui.action.blue200.value,
    blue10: P.color.ui.action.blue100.value,
    blue600: P.color.ui.action.blue600.value,
    blue500: P.color.ui.action.blue500.value,
    blue400: P.color.ui.action.blue400.value,
    blue300: P.color.ui.action.blue300.value,
    blue200: P.color.ui.action.blue200.value,
    blue100: P.color.ui.action.blue100.value,
    error: '#e02d00',
    error10: '#ffe1d5',
    error120: '#b92602',
    error500: P.color.ui.feedback.error500.value,
    error400: P.color.ui.feedback.error400.value,
    error300: P.color.ui.feedback.error300.value,
    error200: P.color.ui.feedback.error200.value,
    error100: P.color.ui.feedback.error100.value,
    warning: '#ffc43e',
    warning10: '#ffe7b2',
    warning500: P.color.ui.feedback.warning500.value,
    warning400: P.color.ui.feedback.warning400.value,
    warning300: P.color.ui.feedback.warning300.value,
    warning200: P.color.ui.feedback.warning200.value,
    warning100: P.color.ui.feedback.warning100.value,
    success: '#62d493',
    success10: '#daf5e6',
    success500: P.color.ui.feedback.success500.value,
    success400: P.color.ui.feedback.success400.value,
    success300: P.color.ui.feedback.success300.value,
    success200: P.color.ui.feedback.success200.value,
    success100: P.color.ui.feedback.success100.value,
    neutral800: P.color.neutrals.neutral800.value,
    neutral700: P.color.neutrals.neutral700.value,
    neutral600: P.color.neutrals.neutral600.value,
    neutral500: P.color.neutrals.neutral500.value,
    neutral400: P.color.neutrals.neutral400.value,
    neutral300: P.color.neutrals.neutral300.value,
    neutral200: P.color.neutrals.neutral200.value,
    neutral100: P.color.neutrals.neutral100.value,
    neutral100rgb: '255, 253, 249',
    black: '#000000',
    white: '#ffffff',
    transparent: 'transparent',
    inherit: 'inherit',
    currentColor: 'currentColor',
    pink: P.color.ui.accent.pink.value,
    purple: P.color.ui.accent.purple.value,
    lava: '#ff4a00',
    lava120: '#d93f00',
    lava80: '#ff6e33',
    lava60: '#ff9266',
    lava40: '#ffb799',
    lava20: '#ffdbcc',
    lava10: '#ffede6',
    lava5: '#fff6f2',
    ocean: '#136bf5',
    ocean120: '#2655bd',
    ocean80: '#4289f7',
    ocean60: '#71a6f9',
    ocean40: '#a1c4fb',
    ocean20: '#d0e1fd',
    ocean10: '#e7f0fe',
    ocean5: '#f3f8ff',
    sun: '#ffc43e',
    sun120: '#e6b038',
    sun80: '#ffd065',
    sun60: '#ffdc8b',
    sun40: '#ffe7b2',
    sun20: '#fff3d8',
    sun10: '#fff9ec',
    sun5: '#fffcf5',
    gray: '#333333',
    gray80: '#424242',
    gray60: '#757575',
    gray40: '#cccccc',
    gray20: '#e6e6e6',
    gray10: '#f2f2f2',
    gray5: '#fafafa',
};
const ColorAliases = {
    brand: BaseColors.lava,
    blueJeans: BaseColors.blue600,
    bluebell: BaseColors.blue500,
    periwinkle: BaseColors.blue400,
    lilac: BaseColors.blue300,
    hydrangea: BaseColors.blue200,
    acidWash: BaseColors.blue100,
};
const Colors = Object.assign(Object.assign({}, BaseColors), ColorAliases);
//# sourceMappingURL=Colors.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 10391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Shadows; }
/* harmony export */ });
var Shadows;
(function (Shadows) {
    Shadows["elevation5"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.1)";
    Shadows["elevation6"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.2)";
    Shadows["elevation10"] = "0px 20px 30px 0px rgba(0, 0, 0, 0.1)";
    Shadows["elevation20"] = "0px 10px 30px 0px rgba(0, 0, 0, 0.2)";
    Shadows["elevation30"] = "0px 10px 20px 0px rgba(0, 0, 0, 0.3)";
})(Shadows || (Shadows = {}));
//# sourceMappingURL=Shadows.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 3000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony exports TypographyNameV5, TypographyName */
const defaultFont = 'var(--zds-typography-base, "Inter", Helvetica, arial, sans-serif)';
const headingFont = 'var(--zds-typography-heading, "Degular", Helvetica, arial, sans-serif)';
const displayFont = 'var(--zds-typography-heading-display, "Degular Display", Helvetica, arial, sans-serif)';
const Typography = {
    base: {
        fontFamily: defaultFont,
    },
    heading: {
        fontFamily: headingFont,
    },
    pageHeader1: {
        fontFamily: displayFont,
        fontSize: 'var(--zds-typography-pageheader1-fontsize, 82px)',
        lineHeight: 'var(--zds-typography-pageheader1-lineheight, 84px)',
        fontWeight: 'var(--zds-typography-pageheader-weight, 700)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    pageHeader3: {
        fontFamily: displayFont,
        fontSize: 'var(--zds-typography-pageheader3-fontsize, 62px)',
        lineHeight: 'var(--zds-typography-pageheader3-lineheight, 66px)',
        fontWeight: 'var(--zds-typography-pageheader-weight, 700)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    pageHeader4: {
        fontFamily: displayFont,
        fontSize: 'var(--zds-typography-pageheader4-fontsize, 52px)',
        lineHeight: 'var(--zds-typography-pageheader4-lineheight, 60px)',
        fontWeight: 'var(--zds-typography-pageheader-weight, 700)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    pageHeader5: {
        fontFamily: headingFont,
        fontSize: 'var(--zds-typography-pageheader5-fontsize, 42px)',
        lineHeight: 'var(--zds-typography-pageheader5-lineheight, 50px)',
        fontWeight: 'var(--zds-typography-semibold-weight, var(--zds-typography-pageheader-weight, 600))',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    pageHeader7: {
        fontFamily: headingFont,
        fontSize: 'var(--zds-typography-pageheader7-fontsize, 34px)',
        lineHeight: 'var(--zds-typography-pageheader7-lineheight, 40px)',
        fontWeight: 'var(--zds-typography-semibold-weight, 600)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    pageHeader9: {
        fontFamily: headingFont,
        fontSize: 'var(--zds-typography-pageheader9-fontsize, 26px)',
        lineHeight: 'var(--zds-typography-pageheader9-lineheight, 32px)',
        fontWeight: 'var(--zds-typography-semibold-weight, 600)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    sectionHeader1: {
        fontFamily: defaultFont,
        fontSize: 32,
        lineHeight: '35px',
        fontWeight: 700,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader1Extrabold: {
        fontFamily: defaultFont,
        fontSize: 32,
        lineHeight: '35px',
        fontWeight: 800,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader1Medium: {
        fontFamily: defaultFont,
        fontSize: 32,
        lineHeight: '35px',
        fontWeight: 500,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader1Bold: {
        fontFamily: defaultFont,
        fontSize: 32,
        lineHeight: '35px',
        fontWeight: 700,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader3: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 700,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader3Extrabold: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 800,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader3Semibold: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 600,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    sectionHeader3Bold: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 700,
        letterSpacing: 'var(--zds-typography-small-letter-spacing, normal)',
    },
    subHeader1: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 400,
    },
    subHeader1Semibold: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 600,
    },
    subHeader1Bold: {
        fontFamily: defaultFont,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 700,
    },
    subHeader3: {
        fontFamily: defaultFont,
        fontSize: 22,
        lineHeight: '28px',
        fontWeight: 400,
    },
    subHeader3Medium: {
        fontFamily: headingFont,
        fontSize: 22,
        lineHeight: '28px',
        fontWeight: 500,
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    subHeader3Bold: {
        fontFamily: headingFont,
        fontSize: 22,
        lineHeight: '28px',
        fontWeight: 'var(--zds-typography-semibold-weight, 600)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    subHeader5: {
        fontFamily: defaultFont,
        fontSize: 20,
        lineHeight: '26px',
        fontWeight: 400,
    },
    subHeader5Medium: {
        fontFamily: headingFont,
        fontSize: 20,
        lineHeight: '26px',
        fontWeight: 500,
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    subHeader5Bold: {
        fontFamily: headingFont,
        fontSize: 20,
        lineHeight: '26px',
        fontWeight: 'var(--zds-typography-semibold-weight, 600)',
        letterSpacing: 'var(--zds-typography-large-letter-spacing, 1px)',
    },
    superTitle1: {
        fontFamily: defaultFont,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 700,
        textTransform: 'uppercase',
    },
    superTitle3: {
        fontFamily: defaultFont,
        fontSize: 12,
        lineHeight: '15px',
        fontWeight: 700,
        textTransform: 'uppercase',
    },
    superTitle5: {
        fontFamily: defaultFont,
        fontSize: 10,
        lineHeight: '15px',
        fontWeight: 700,
        textTransform: 'uppercase',
    },
    paragraph1: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: '31px',
        fontWeight: 400,
    },
    paragraph1Medium: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: '31px',
        fontWeight: 500,
    },
    paragraph1Semibold: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: '31px',
        fontWeight: 600,
    },
    paragraph1Bold: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: '31px',
        fontWeight: 700,
    },
    paragraph1Short: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: 'var(--zds-typography-paragraph1short-lineheight, 24px)',
        fontWeight: 400,
    },
    paragraph1ShortMedium: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: 'var(--zds-typography-paragraph1short-lineheight, 24px)',
        fontWeight: 500,
    },
    paragraph1ShortSemibold: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: 'var(--zds-typography-paragraph1short-lineheight, 24px)',
        fontWeight: 600,
    },
    paragraph1ShortBold: {
        fontFamily: defaultFont,
        fontSize: 18,
        lineHeight: 'var(--zds-typography-paragraph1short-lineheight, 24px)',
        fontWeight: 700,
    },
    paragraph3: {
        fontFamily: defaultFont,
        fontSize: 16,
        lineHeight: 'var(--zds-typography-paragraph3-lineheight, 24px)',
        fontWeight: 400,
    },
    paragraph3Medium: {
        fontFamily: defaultFont,
        fontSize: 16,
        lineHeight: 'var(--zds-typography-paragraph3-lineheight, 24px)',
        fontWeight: 500,
    },
    paragraph3Semibold: {
        fontFamily: defaultFont,
        fontSize: 16,
        lineHeight: 'var(--zds-typography-paragraph3-lineheight, 24px)',
        fontWeight: 600,
    },
    paragraph3Bold: {
        fontFamily: defaultFont,
        fontSize: 16,
        lineHeight: 'var(--zds-typography-paragraph3-lineheight, 24px)',
        fontWeight: 700,
    },
    smallPrint1: {
        fontFamily: defaultFont,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 400,
    },
    smallPrint1Medium: {
        fontFamily: defaultFont,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 500,
    },
    smallPrint1Semibold: {
        fontFamily: defaultFont,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
    },
    smallPrint1Bold: {
        fontFamily: defaultFont,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 700,
    },
    smallPrint3: {
        fontFamily: defaultFont,
        fontSize: 12,
        lineHeight: '15px',
        fontWeight: 400,
    },
    smallPrint3Semibold: {
        fontFamily: defaultFont,
        fontSize: 12,
        lineHeight: '15px',
        fontWeight: 600,
    },
    smallPrint3Bold: {
        fontFamily: defaultFont,
        fontSize: 12,
        lineHeight: '15px',
        fontWeight: 700,
    },
};
const TypographyNameV5 = (/* unused pure expression or super */ null && ([
    'base',
    'heading',
    'pageHeader1',
    'pageHeader3',
    'pageHeader4',
    'pageHeader5',
    'pageHeader7',
    'pageHeader9',
    'sectionHeader1Medium',
    'sectionHeader1Bold',
    'sectionHeader3Semibold',
    'sectionHeader3Bold',
    'subHeader1',
    'subHeader3',
    'subHeader5',
    'subHeader1Semibold',
    'subHeader1Bold',
    'subHeader3Medium',
    'subHeader3Bold',
    'subHeader5Medium',
    'subHeader5Bold',
    'paragraph1',
    'paragraph1Medium',
    'paragraph1Semibold',
    'paragraph1Bold',
    'paragraph1Short',
    'paragraph1ShortMedium',
    'paragraph1ShortSemibold',
    'paragraph1ShortBold',
    'paragraph3',
    'paragraph3Medium',
    'paragraph3Semibold',
    'paragraph3Bold',
    'smallPrint1',
    'smallPrint1Medium',
    'smallPrint1Semibold',
    'smallPrint1Bold',
]));
const TypographyName = (/* unused pure expression or super */ null && ([
    'base',
    'heading',
    'pageHeader1',
    'pageHeader3',
    'pageHeader4',
    'pageHeader5',
    'pageHeader7',
    'pageHeader9',
    'sectionHeader1Medium',
    'sectionHeader1Bold',
    'sectionHeader3Semibold',
    'sectionHeader3Bold',
    'subHeader1',
    'subHeader1Semibold',
    'subHeader1Bold',
    'subHeader3Medium',
    'subHeader3Bold',
    'subHeader5Medium',
    'subHeader5Bold',
    'paragraph1',
    'paragraph1Medium',
    'paragraph1Semibold',
    'paragraph1Bold',
    'paragraph1Short',
    'paragraph1ShortMedium',
    'paragraph1ShortSemibold',
    'paragraph1ShortBold',
    'paragraph3',
    'paragraph3Medium',
    'paragraph3Semibold',
    'paragraph3Bold',
    'smallPrint1',
    'smallPrint1Medium',
    'smallPrint1Semibold',
    'smallPrint1Bold',
]));
//# sourceMappingURL=Typography.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 91604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Zindexes; }
/* harmony export */ });
const Zindexes = {
    supportButtons: 12,
    npsSurvey: 99,
    stickyHeader: 99,
    dropdownMenu: 900,
    blogDialogContainer: 901,
    asyncOverlay: 901,
    signUp: 949,
    universalNav: 950,
    universalTopbarMegaDropdown: 960,
    popover: 1002,
    editorErrorList: 1002,
    modalOverlay: 2000,
    headerFixedPosition: 10000,
    pageNotification: 10100,
    perfReport: 1000000,
    fixedSurvey: 1000201,
};
//# sourceMappingURL=Zindexes.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 37260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
const clamp = (val, min, max) => {
    return Math.max(min, Math.min(val, max));
};
//# sourceMappingURL=clamp.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 38137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createUniqueCustomProperties; }
/* harmony export */ });
/* unused harmony export createUniqueCustomProperty */
/* harmony import */ var _hashString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49015);

const createUniqueCustomProperty = (block, propertyName) => {
    const hash = (0,_hashString__WEBPACK_IMPORTED_MODULE_0__/* .hashString */ .W)('design-system' + block + propertyName);
    return `--${block}-${propertyName}-${hash}`;
};
const createUniqueCustomProperties = (block, propertyNames) => {
    return propertyNames.reduce((accum, propertyName) => {
        accum[propertyName] = createUniqueCustomProperty(block, propertyName);
        return accum;
    }, {});
};
//# sourceMappingURL=createUniqueCustomProperty.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 95945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ camelCaseAriaAttrs; },
/* harmony export */   "v": function() { return /* binding */ kebabCaseAriaAttrs; }
/* harmony export */ });
/* harmony import */ var _fromEntries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93594);

const allAriaAttrs = {
    'aria-activedescendant': 'ariaActiveDescendant',
    'aria-atomic': 'ariaAtomic',
    'aria-autocomplete': 'ariaAutoComplete',
    'aria-busy': 'ariaBusy',
    'aria-checked': 'ariaChecked',
    'aria-colcount': 'ariaColCount',
    'aria-colindex': 'ariaColIndex',
    'aria-colspan': 'ariaColSpan',
    'aria-controls': 'ariaControls',
    'aria-current': 'ariaCurrent',
    'aria-describedby': 'ariaDescribedBy',
    'aria-details': 'ariaDetails',
    'aria-disabled': 'ariaDisabled',
    'aria-dropeffect': 'ariaDropEffect',
    'aria-errormessage': 'ariaErrorMessage',
    'aria-expanded': 'ariaExpanded',
    'aria-flowto': 'ariaFlowTo',
    'aria-grabbed': 'ariaGrabbed',
    'aria-haspopup': 'ariaHasPopup',
    'aria-hidden': 'ariaHidden',
    'aria-invalid': 'ariaInvalid',
    'aria-keyshortcuts': 'ariaKeyShortcuts',
    'aria-label': 'ariaLabel',
    'aria-labelledby': 'ariaLabelledBy',
    'aria-level': 'ariaLevel',
    'aria-live': 'ariaLive',
    'aria-modal': 'ariaModal',
    'aria-multiline': 'ariaMultiline',
    'aria-multiselectable': 'ariaMultiselectable',
    'aria-orientation': 'ariaOrientation',
    'aria-owns': 'ariaOwns',
    'aria-placeholder': 'ariaPlaceholder',
    'aria-posinset': 'ariaPosInset',
    'aria-pressed': 'ariaPressed',
    'aria-readonly': 'ariaReadOnly',
    'aria-relevant': 'ariaRelevant',
    'aria-required': 'ariaRequired',
    'aria-roledescription': 'ariaRoleDescription',
    'aria-rowcount': 'ariaRowCount',
    'aria-rowindex': 'ariaRowIndex',
    'aria-rowspan': 'ariaRowSpan',
    'aria-selected': 'ariaSelected',
    'aria-setsize': 'ariaSetSize',
    'aria-sort': 'ariaSort',
    'aria-valuemax': 'ariaValueMax',
    'aria-valuemin': 'ariaValueMin',
    'aria-valuenow': 'ariaValueNow',
    'aria-valuetext': 'ariaValueText',
};
const invertedAriaAttrs = (0,_fromEntries__WEBPACK_IMPORTED_MODULE_0__/* .fromEntries */ .s)(Object.entries(allAriaAttrs).map(([key, value]) => [value, key]));
const camelCaseAriaAttrs = (kebabCasedAttrs) => {
    return (0,_fromEntries__WEBPACK_IMPORTED_MODULE_0__/* .fromEntries */ .s)(Object.entries(kebabCasedAttrs).map(([key, val]) => {
        return [allAriaAttrs[key] || key, val];
    }));
};
const kebabCaseAriaAttrs = (camelCasedAttrs) => {
    return (0,_fromEntries__WEBPACK_IMPORTED_MODULE_0__/* .fromEntries */ .s)(Object.entries(camelCasedAttrs).map(([key, val]) => {
        return [
            invertedAriaAttrs[key] || key,
            val,
        ];
    }));
};
//# sourceMappingURL=formatAriaAttrKeys.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 93594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ fromEntries; }
/* harmony export */ });
const fromEntries = (entries) => {
    return entries.reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
    }, {});
};
//# sourceMappingURL=fromEntries.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 49015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ hashString; }
/* harmony export */ });
const hashString = (str) => {
    let hash = 0;
    let i = 0;
    let chr = null;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return Math.abs(hash).toString(16);
};
//# sourceMappingURL=hashString.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 61814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ uniqueId; }
/* harmony export */ });
const counters = {};
const uniqueId = (prefix) => {
    counters[prefix] = (counters[prefix] || 0) + 1;
    return `${prefix}${counters[prefix]}`;
};
//# sourceMappingURL=uniqueId.js.map
// @zapier/design-system@5.32.5 (2004a9d50)


/***/ }),

/***/ 78464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.emit = void 0;
const EventsToolkitSettings_1 = __webpack_require__(91530);
const EventsToolkitUtilities_1 = __webpack_require__(52578);
const _1 = __webpack_require__(8736);
const VisitorTracking_1 = __webpack_require__(43189);
const VisitorTracking_2 = __webpack_require__(43189);
const version_1 = __webpack_require__(90625);
const PREVIOUS_LOCATION_KEY = _1.visitorId + "-previous-location";
const NEXT_PAGE_VIEW_REFERRER_KEY = _1.visitorId + "-next-page-view-referrer";
const PageViewEvent = "web_analytics.tracking.page_view.PageViewEvent";
const UserInteractionEvent = "web_analytics.tracking.user_interaction.UserInteractionEvent";
function setPreviousLocation(locationHref) {
    // we use session storage here to ensure this goes away when a browser window/tab is closed
    // but that it's also persisted if a browser session is restored.
    typeof window !== 'undefined' && window.sessionStorage.setItem(PREVIOUS_LOCATION_KEY, locationHref);
}
function getPreviousLocation() {
    // we use "referer" to record where folks came from when they arrive in an app.
    // we also use it to record their previous location as they navigate around within
    // an app.   To ensure this works properly for Single Page Apps, we keep track
    // of this in session storage.
    return ((typeof window !== 'undefined' && window.sessionStorage.getItem(PREVIOUS_LOCATION_KEY)) || document.referrer);
}
function removePreviousLocation() {
    return (typeof window !== 'undefined' && window.sessionStorage.removeItem(PREVIOUS_LOCATION_KEY));
}
function removeNextPageViewReferrer() {
    return (typeof window !== 'undefined' && window.sessionStorage.removeItem(NEXT_PAGE_VIEW_REFERRER_KEY));
}
function setNextPageViewReferrer(locationHref) {
    typeof window !== 'undefined' && window.sessionStorage.setItem(NEXT_PAGE_VIEW_REFERRER_KEY, locationHref);
}
function getNextPageViewReferrer() {
    return ((typeof window !== 'undefined' && window.sessionStorage.getItem(NEXT_PAGE_VIEW_REFERRER_KEY)) ||
        document.referrer);
}
function applyDataGovernanceDefaults(eventData, eventType) {
    let page_path = null;
    let screen_size = null;
    let iframe_flag = null;
    let popup_flag = null;
    let user_agent = null;
    let url_address = null;
    let query_string = null;
    let fully_qualified_domain_name = null;
    let utm_campaign = null;
    let utm_content = null;
    let utm_medium = null;
    let utm_source = null;
    let visitor_id = null;
    let session_id = null;
    let page_view_id = null;
    let referer = null;
    let events_library_version = version_1.LIB_VERSION;
    let event_action = null;
    let interaction_name = null;
    let interaction_raw_text = null;
    if (EventsToolkitUtilities_1.isBrowser()) {
        fully_qualified_domain_name = window.location.hostname;
        url_address = window.location.href;
        page_path = window.location.pathname;
        query_string = window.location.search;
        user_agent = window.navigator.userAgent;
        var queryStringObject = EventsToolkitUtilities_1.querystringToObj(query_string);
        utm_campaign = queryStringObject.utm_campaign;
        utm_content = queryStringObject.utm_content;
        utm_medium = queryStringObject.utm_medium;
        utm_source = queryStringObject.utm_source;
        const width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        screen_size = `${width}x${height}`;
        iframe_flag = EventsToolkitUtilities_1.isInIframe();
        popup_flag = EventsToolkitUtilities_1.isInPopup();
        visitor_id = _1.visitorId;
        session_id = VisitorTracking_1.getSessionId();
        page_view_id = VisitorTracking_2.getPageViewId();
        if (eventType == UserInteractionEvent) {
            event_action = eventData.event_action || null;
            interaction_name = eventData.interaction_name || null;
            interaction_raw_text = eventData.interaction_raw_text || null;
        }
        if (eventType == PageViewEvent) {
            // We'll save the current url_address value for the PageViewEvent
            // as the "next PageViewEvent referrer"   This value will be used as
            // the next PageViewEvent's referer value to ensure this is consistently
            // tracked for Single Page Applications.
            // As we move to different pages, we'll keep track of our history
            // so we can use this as the "referrer" in Single Page Applications.
            // We don't immediately make the "next PageViewEvent referrer value" the
            // "previous location" as that can cause issues for referrer tracking
            // on other events like the UserInteractionEvent.
            setPreviousLocation(getNextPageViewReferrer());
            referer = getPreviousLocation();
            setNextPageViewReferrer(url_address);
        }
        else {
            referer = getPreviousLocation();
        }
    }
    return Object.assign({ fully_qualified_domain_name,
        url_address,
        query_string,
        page_path,
        screen_size,
        iframe_flag,
        popup_flag,
        user_agent,
        utm_content,
        utm_medium,
        utm_source,
        utm_campaign,
        visitor_id,
        page_view_id,
        referer,
        session_id,
        events_library_version,
        interaction_name,
        interaction_raw_text,
        event_action }, eventData);
}
function writeToDataLayer(eventType, eventData) {
    if (EventsToolkitUtilities_1.isBrowser() && EventsToolkitSettings_1.settings.write_to_data_layer === "true") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "analyticsEvent",
            eventLabel: eventType,
            eventAction: eventData.event_action,
            interactionName: eventData.interaction_name,
            interactionRawText: eventData.interaction_raw_text,
            pagePath: eventData.page_path,
            visitorId: _1.visitorId,
        });
    }
}
if (typeof window !== 'undefined') {
    window.addEventListener("beforeunload", () => {
        removePreviousLocation();
        removeNextPageViewReferrer();
    });
}
function emit(eventData, eventType) {
    return __awaiter(this, void 0, void 0, function* () {
        var emitStatus = true;
        var eventRequestData = undefined;
        try {
            eventRequestData = applyDataGovernanceDefaults(eventData, eventType);
            var headers = {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            };
            const response = yield fetch(EventsToolkitSettings_1.settings.emit_api, {
                body: JSON.stringify({
                    properties: eventRequestData,
                    subject: eventType,
                }),
                credentials: "include",
                headers: headers,
                method: "POST",
            });
            if (response.status !== 200) {
                console.warn("Unable to emit event:", response);
                emitStatus = false;
            }
            else {
                writeToDataLayer(eventType, eventRequestData);
            }
        }
        catch (error) {
            console.warn("Unable to emit event:", error);
            emitStatus = false;
        }
        return [emitStatus, eventRequestData];
    });
}
exports.emit = emit;


/***/ }),

/***/ 91530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settings = void 0;
function getEventsToolkitEmitAPI() {
    if (true) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return "https://zapier-staging.com/api/v4/tracking/event/";
    }
    else {}
}
function getWriteToDataLayer() {
    if (true) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return "true";
    }
    else {}
}
exports.settings = {
    streaming_service: process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        ? process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        : "api",
    emit_api: getEventsToolkitEmitAPI(),
    domain: new URL(getEventsToolkitEmitAPI()).hostname,
    write_to_data_layer: getWriteToDataLayer(),
};


/***/ }),

/***/ 52578:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.querystringToObj = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isInIframe = () => {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInIframe = isInIframe;
const isInPopup = () => {
    return exports.isBrowser() && !!window.opener;
};
exports.isInPopup = isInPopup;
const querystringToObj = (query) => {
    var _a, _b;
    let qs = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : "";
    if (qs.startsWith("?")) {
        qs = qs.substr(1);
    }
    qs = decodeURIComponent(qs);
    var chunks = qs.split("&"), obj = {};
    for (var c = 0; c < chunks.length; c++) {
        var split = chunks[c].split("=", 2);
        obj[split[0]] = split[1];
    }
    return obj;
};
exports.querystringToObj = querystringToObj;


/***/ }),

/***/ 43189:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPageViewId = exports.getSessionId = exports.getVisitorId = void 0;
const EventsToolkitSettings_1 = __webpack_require__(91530);
const EventsToolkitUtilities_1 = __webpack_require__(52578);
const sessionIdCookieName = "session_id";
const visitorIdCookieName = "visitor_id";
const pageViewIdSessionStorageName = "page_view_id";
function getCookie(name) {
    var _a;
    let matches = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.match(new RegExp("(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
// this routine is based on various approaches that have been posted and discussed
// at https://gist.github.com/jed/982883
// we prefer to do "inline" uuid generation here instead of including a separate library.
const getUuid = (a = "") => {
    var _a;
    return a
        ? /* eslint-disable no-bitwise */
            (Number(a) ^
                (((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint8Array(1))[0]) &
                    (15 >> (Number(a) / 4)))).toString(16)
        : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, getUuid);
};
function getVisitorId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var visitorId = getCookie(visitorIdCookieName);
        if (!visitorId) {
            visitorId = getUuid();
            document.cookie =
                visitorIdCookieName +
                    "=" +
                    visitorId +
                    ";domain=" +
                    EventsToolkitSettings_1.settings.domain +
                    ";path=/;max-age=5897232000";
        }
        return visitorId;
    }
    else {
        return undefined;
    }
}
exports.getVisitorId = getVisitorId;
function getSessionId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var sessionId = getCookie(sessionIdCookieName);
        if (!sessionId) {
            sessionId = getUuid();
        }
        // session id values should be regenerated after 60 minutes (3600 seconds) of inactivity
        document.cookie =
            sessionIdCookieName +
                "=" +
                sessionId +
                ";domain=" +
                EventsToolkitSettings_1.settings.domain +
                ";path=/;max-age=3600";
        return sessionId;
    }
    else {
        return undefined;
    }
}
exports.getSessionId = getSessionId;
function getPageViewId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var pageViewIdSession = sessionStorage.getItem(pageViewIdSessionStorageName);
        var pageViewIdJson;
        var pageViewId;
        if (pageViewIdSession) {
            pageViewIdJson = JSON.parse(pageViewIdSession);
        }
        if (pageViewIdJson && pageViewIdJson.length == 2 && pageViewIdJson[0] == window.location.pathname) {
            pageViewId = pageViewIdJson[1];
        }
        else {
            pageViewId = getUuid();
            pageViewIdSession = JSON.stringify([location.pathname, pageViewId]);
            sessionStorage.setItem(pageViewIdSessionStorageName, pageViewIdSession);
        }
        return pageViewId;
    }
    else {
        return undefined;
    }
}
exports.getPageViewId = getPageViewId;


/***/ }),

/***/ 8736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.emit = exports.visitorId = void 0;
const VisitorTracking_1 = __webpack_require__(43189);
exports.visitorId = VisitorTracking_1.getVisitorId();
var EventsToolkit_1 = __webpack_require__(78464);
Object.defineProperty(exports, "emit", ({ enumerable: true, get: function () { return EventsToolkit_1.emit; } }));


/***/ }),

/***/ 90625:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LIB_VERSION = void 0;
exports.LIB_VERSION = "1.1.7";


/***/ }),

/***/ 18801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeadingLevelProvider = exports.useHeadingLevel = void 0;
var react_1 = __importDefault(__webpack_require__(2784));
// Components within `common-components` and `design-system` both need
// a reference to this exact context object. However there are circular
// dependency issues between those packages, so this context object exists
// in its own package.
var HeadingLevelContext = react_1.default.createContext({
    level: 1,
});
exports.useHeadingLevel = function () { return react_1.default.useContext(HeadingLevelContext); };
exports.HeadingLevelProvider = function (_a) {
    var _b = _a.level, level = _b === void 0 ? 1 : _b, children = _a.children;
    return (react_1.default.createElement(HeadingLevelContext.Provider, { value: {
            level: level,
        } }, children));
};


/***/ }),

/***/ 30826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(18801), exports);


/***/ }),

/***/ 38716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L5": function() { return /* binding */ buildAccountSwitcherUrl; },
/* harmony export */   "No": function() { return /* binding */ CurrentAccountIdProvider; },
/* harmony export */   "X8": function() { return /* binding */ useCurrentAccountId; }
/* harmony export */ });
/* unused harmony export ACCOUNT_COOKIE_NAME */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _zapier_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59251);



function buildAccountSwitcherUrl(accountId) {
  return "/switch-account?account=".concat(accountId, "&next=").concat(window.location.pathname);
}

const ACCOUNT_COOKIE_NAME = 'currentAccountId';
const ACCOUNT_LOCAL_STORAGE_NAME = 'currentAccountId';

const CurrentAccountIdContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const useCurrentAccountId = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(CurrentAccountIdContext);

function getAccountIdFromCookie() {
  if (typeof document === 'undefined') {
    return undefined;
  } // check if the currentAccountId cookie has been set more than once with differing values
  // if so, we need to expire all of them and force a reauth
  // https://zapierorg.atlassian.net/browse/TA-44


  const cookies = document.cookie.split(';');
  const currentAccountIdCookies = cookies.filter(cookie => cookie.includes(ACCOUNT_COOKIE_NAME));
  const allCookiesAreTheSame = currentAccountIdCookies.every(cookie => cookie.trim() === currentAccountIdCookies[0].trim());

  if (currentAccountIdCookies.length > 1 && !allCookiesAreTheSame) {
    document.cookie = "".concat(ACCOUNT_COOKIE_NAME, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"); // handles `zapier.com` domain

    document.cookie = "".concat(ACCOUNT_COOKIE_NAME, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.").concat(window.location.hostname); // handles `*.zapier.com` domains

    window.location.href = '/app/login?reauth=true';
    return undefined;
  }

  return parseInt((0,_zapier_cookies__WEBPACK_IMPORTED_MODULE_1__/* .readCookie */ .v)(ACCOUNT_COOKIE_NAME), 10);
}

function setLocalStorage(accountId) {
  try {
    localStorage.setItem(ACCOUNT_LOCAL_STORAGE_NAME, accountId);
  } catch (e) {// This is only used for backwards compatibility reasons, so if we cannot store it in LocalStorage for whatever reason, we can just ignore it.
  }
}

function CurrentAccountIdProvider(props) {
  const [currentAccountId, setCurrentAccountId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(getAccountIdFromCookie());
  /** Watch current account id cookie for changes */

  async function watchCookie() {
    const idFromCookie = getAccountIdFromCookie(); // Only take action if this is a real change

    if (idFromCookie && idFromCookie !== currentAccountId) {
      // Account id has changed
      setCurrentAccountId(idFromCookie); // Ensure that localStorage is the same as the current cookie value
      // for backwards compatibility

      setLocalStorage(idFromCookie);
    }
  }

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Read cookie value on a set interval to watch for changes
    const timer = setInterval(watchCookie, 1000); // Ensure that localStorage is the same as the current cookie value
    // for backwards compatibility

    setLocalStorage(currentAccountId);
    /** Remove cookie watcher when we dismount */

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  });
  /** Create provider */

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CurrentAccountIdContext.Provider, {
    value: currentAccountId
  }, props.children);
}




/***/ }),

/***/ 70591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserAgentContext = void 0;
var react_1 = __importDefault(__webpack_require__(2784));
var isBrowser = function () { return typeof window !== 'undefined'; };
var userAgent = isBrowser() ? navigator.userAgent : '';
exports.UserAgentContext = react_1.default.createContext(userAgent);


/***/ }),

/***/ 82174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var UserAgentContext_1 = __webpack_require__(70591);
Object.defineProperty(exports, "UserAgentContext", ({ enumerable: true, get: function () { return UserAgentContext_1.UserAgentContext; } }));


/***/ }),

/***/ 87865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var responsiveStyles_1 = __webpack_require__(4134);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return responsiveStyles_1.responsiveStyles; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return responsiveStyles_1.responsiveStylesFn; } });
var useMediaProps_1 = __webpack_require__(66350);
Object.defineProperty(exports, "Oh", ({ enumerable: true, get: function () { return useMediaProps_1.useMediaProps; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useMediaProps_1.findMatchingQueries; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return useMediaProps_1.guessUserAgentInfo; } });
var UserAgentContext_1 = __webpack_require__(82174);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return UserAgentContext_1.UserAgentContext; } });


/***/ }),

/***/ 4134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(19363), exports);


/***/ }),

/***/ 19363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.responsiveStylesFn = exports.responsiveStyles = void 0;
var sizes = ['small', 'medium', 'large', 'xlarge'];
/**
 * Combine appropriate "per breakpoint" styles, cascading responsively upwards.
 */
function responsiveStyles(size, styles) {
    var relevantStyles = sizes
        .filter(function (currentSize) {
        return styles.hasOwnProperty(currentSize) &&
            // Only include styles for equal or greater than breakpoints
            sizes.indexOf(size) >= sizes.indexOf(currentSize);
    })
        .map(function (currentSize) { return styles[currentSize]; });
    return relevantStyles.length > 0 ? __spread(relevantStyles, [{ label: size }]) : [];
}
exports.responsiveStyles = responsiveStyles;
function responsiveStylesFn(styles) {
    return function (size) { return responsiveStyles(size, styles); };
}
exports.responsiveStylesFn = responsiveStylesFn;


/***/ }),

/***/ 32366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findMatchingQueries = exports.parseQuery = void 0;
var lodash_1 = __webpack_require__(76635);
exports.parseQuery = function (query) {
    // Only works for `and` queries for now.
    var parts = query
        .split('and')
        .map(function (part) { return part.trim(); })
        // Remove parentheses
        .map(function (part) { return part.replace(/[()]/g, ''); });
    return parts.reduce(function (accum, part) {
        var _a = __read(part.split(':'), 2), _b = _a[0], key = _b === void 0 ? '' : _b, _c = _a[1], val = _c === void 0 ? '' : _c;
        accum[key.trim()] = parseInt(val, 10);
        return accum;
    }, {});
};
var doesQueryMatch = function (queryables, query) {
    return [
        queryables.width >= (query['min-width'] || 0),
        queryables.width <= (query['max-width'] || Infinity),
    ].every(Boolean);
};
exports.findMatchingQueries = function (queryables, queries) {
    return lodash_1.reduce(queries, function (accum, queryToCheck) {
        var mediaQuery = queryToCheck;
        var parsedQuery = exports.parseQuery(mediaQuery);
        accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
        return accum;
    }, {});
};
exports["default"] = exports.findMatchingQueries;


/***/ }),

/***/ 29233:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// This file must synced with `@zapier/toolbox-frontend-app`'s `guessUserAgentInfo`.
// If you change this code, please change there, too.
Object.defineProperty(exports, "__esModule", ({ value: true }));
var DEVICE_TYPES = {
    phone: 'phone',
    phablet: 'phablet',
    tablet: 'tablet',
    desktop: 'desktop',
};
var containsAnyUa = function (substrings) { return function (ua) {
    // Load testing tools such as ab and autocannon, and Datadog Synthetics
    // (simulated user requests), do not send a user agent string.
    if (typeof ua !== 'string') {
        return false;
    }
    var normalizedUa = ua.toLowerCase();
    return substrings
        .map(function (substring) { return substring.toLowerCase(); })
        .some(function (substring) { return normalizedUa.includes(substring); });
}; };
var isTablet = containsAnyUa(['ipad', 'kfapwi']);
var isPhablet = containsAnyUa(['nexus']);
var isMobile = containsAnyUa(['iphone', 'mobile']);
var guessUserAgentInfo = function (userAgent) {
    // Order is important since subsequent conditions are more generic.
    // Specifically, guessing a tablet looks for specific devices,
    // as does phablet, and then mobile looks for devices or a `mobile`
    // string in the UA. Desktop is the fallback.
    if (isTablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.tablet, width: 660 };
    }
    if (isPhablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.phablet, width: 420 };
    }
    if (isMobile(userAgent)) {
        return { deviceType: DEVICE_TYPES.phone, width: 320 };
    }
    return { deviceType: DEVICE_TYPES.desktop, width: 1024 };
};
exports["default"] = guessUserAgentInfo;


/***/ }),

/***/ 66350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var findMatchingQueries_1 = __webpack_require__(32366);
Object.defineProperty(exports, "findMatchingQueries", ({ enumerable: true, get: function () { return findMatchingQueries_1.default; } }));
var guessUserAgentInfo_1 = __webpack_require__(29233);
Object.defineProperty(exports, "guessUserAgentInfo", ({ enumerable: true, get: function () { return guessUserAgentInfo_1.default; } }));
var useMediaProps_1 = __webpack_require__(76902);
Object.defineProperty(exports, "useMediaProps", ({ enumerable: true, get: function () { return useMediaProps_1.default; } }));


/***/ }),

/***/ 76902:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var react_1 = __webpack_require__(2784);
var UserAgentContext_1 = __webpack_require__(82174);
var findMatchingQueries_1 = __importDefault(__webpack_require__(32366));
var guessUserAgentInfo_1 = __importDefault(__webpack_require__(29233));
var mergeProps = function (propsArray) {
    // `reverse` because this is `defaultsDeep`, so earlier
    // items in the array take precedence, but we want later
    // items to take precedence.
    return lodash_1.defaultsDeep.apply(void 0, __spread([{}], propsArray.reverse()));
};
var computeInitialPropsFromUserAgent = function (userAgent, mediaQueriesToProps) {
    var userAgentInfo = guessUserAgentInfo_1.default(userAgent);
    var mediaQueries = Object.keys(mediaQueriesToProps);
    var matchingQueries = findMatchingQueries_1.default(userAgentInfo, mediaQueries);
    var matchingProps = mediaQueries
        .filter(function (query) { return matchingQueries[query]; })
        .map(function (query) { return mediaQueriesToProps[query]; });
    return mergeProps(matchingProps);
};
var mergeMatchingProps = function (queryObjs) {
    var matchingProps = queryObjs
        .filter(function (queryObj) { var _a; return (_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.matches; })
        .map(function (queryObj) { return queryObj.props; });
    return mergeProps(matchingProps);
};
// Hook that takes a `mediaQueriesToProps` which is an object whose
// keys are media queries and whose values are objects
// representing props of one or more components. Returns
// a deeply merged object of all props matching the media
// queries defined in `mediaQueriesToProps`.
var useMediaProps = function (mediaQueriesToProps) {
    var userAgent = react_1.useContext(UserAgentContext_1.UserAgentContext);
    var initialProps = computeInitialPropsFromUserAgent(userAgent, mediaQueriesToProps);
    var _a = __read(react_1.useState(initialProps), 2), props = _a[0], setProps = _a[1];
    react_1.useEffect(function () {
        var mediaQueries = Object.keys(mediaQueriesToProps);
        // Hold onto `query`, `mediaQueryList`, and `props` since `matchMedia`
        // may change how `query` is structured and we need a way
        // to easily reaccess the `props` defined for that query.
        var queryObjs = mediaQueries.map(function (query) {
            return {
                query: query,
                mediaQueryList: window === null || window === void 0 ? void 0 : window.matchMedia(query),
                props: mediaQueriesToProps[query],
            };
        });
        // Merge all the props for matching media queries together
        // and then set them as the new props.
        var computeProps = function () {
            var newProps = mergeMatchingProps(queryObjs);
            // Perf enhancement / infinite loop prevention.
            if (!lodash_1.isEqual(newProps, props)) {
                setProps(newProps);
            }
        };
        // Listen to changes for each of the media queries.
        // These events only fire when a media query matches,
        // unlike `onresize`.
        queryObjs.forEach(function (queryObj) {
            var _a;
            if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.addListener) {
                queryObj.mediaQueryList.addListener(computeProps);
            }
        });
        // Initial call to compute the props. Without this
        // the props would never be computed unless the user
        // resized their browser to match a media query.
        computeProps();
        // Return the teardown function.
        return function () {
            queryObjs.forEach(function (queryObj) {
                var _a;
                if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.removeListener) {
                    queryObj.mediaQueryList.removeListener(computeProps);
                }
            });
        };
    }, [mediaQueriesToProps, props]);
    return props;
};
exports["default"] = useMediaProps;


/***/ }),

/***/ 77293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ isolateComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../node_modules/@zapier/style-encapsulation/esm/buildResetStyles.js

const isHtmlNode = (type) => {
    return typeof type === 'string';
};
const blockNodes = new Set([
    'address',
    'article',
    'aside',
    'blockquote',
    'details',
    'dialog',
    'dd',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'hr',
    'li',
    'main',
    'nav',
    'ol',
    'p',
    'pre',
    'section',
    'table',
    'ul',
]);
const isBlockNode = (type) => {
    return blockNodes.has(type);
};
const svgNodes = new Set([
    'path',
    'rect',
    'ellipse',
    'circle',
    'g',
    'defs',
    'clipPath',
    'linearGradient',
    'stop',
    'animate',
]);
const isSvgNode = (type) => {
    return svgNodes.has(type);
};
const clickableNodes = new Set(['a', 'label', 'button']);
const isClickableNode = (type) => {
    return clickableNodes.has(type);
};
const buildResetStyles = (nodeType) => {
    return emotion_react_browser_esm/* css */.iv `
    all: unset;
    box-sizing: border-box;
    /* Fix Safari 13 issue with 'color' and 'all: unset'
     * (https://bugs.webkit.org/show_bug.cgi?id=158782).
     */
    -webkit-text-fill-color: currentColor;
    /* Fix Firefox textarea issue with 'all: unset' */
    ${nodeType === 'textarea' ? 'white-space: pre-wrap;' : ''}
    ${nodeType === 'strong' ? 'font-weight: bold;' : ''}
    ${nodeType === 'em' ? 'font-style: italic;' : ''}
    ${isBlockNode(nodeType) ? 'display: block;' : ''}
    ${isClickableNode(nodeType) ? 'cursor: pointer;' : ''}
  `;
};
//# sourceMappingURL=buildResetStyles.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)

;// CONCATENATED MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js


const isComponent = (type) => {
    var _a;
    return (typeof type === 'function' ||
        !!((_a = type === null || type === void 0 ? void 0 : type.$$typeof) === null || _a === void 0 ? void 0 : _a.toString().includes('forward')));
};
const componentSelector = '&' + '[class]'.repeat(5);
const isolateCss = (nodeType, styles) => {
    return {
        [componentSelector]: [
            !isComponent(nodeType) && buildResetStyles(nodeType),
            styles.map((stylesItem) => ({
                '&': stylesItem,
            })),
        ],
    };
};
const flatten = (arr) => {
    return arr.reduce((acc, item) => {
        return acc.concat(Array.isArray(item) ? flatten(item) : item);
    }, []);
};
const isolateComponent = (type, props, ...children) => {
    props = props || {};
    if (!type || isSvgNode(type)) {
        return (0,emotion_react_browser_esm/* jsx */.tZ)(type, props, ...children);
    }
    if (props.css || isHtmlNode(type)) {
        props.css = isolateCss(type, flatten([props.css]).filter(Boolean));
    }
    return (0,emotion_react_browser_esm/* jsx */.tZ)(type, props, ...children);
};
//# sourceMappingURL=isolateComponent.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)


/***/ }),

/***/ 39479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ labelStyles; }
/* harmony export */ });
const addLabelToStyles = (label, styles) => {
    if (typeof styles === 'function') {
        return (...args) => {
            return [{ label }, styles(...args)];
        };
    }
    return [{ label }, styles];
};
const labelStyles = (block, allStyles) => {
    return (Object.entries(allStyles)
        .map(([name, styles]) => {
        const label = name.startsWith('root') ? block : `${block}__${name}`;
        return [name, addLabelToStyles(label, styles)];
    })
        .reduce((mapped, [name, styles]) => {
        mapped[name] = styles;
        return mapped;
    }, {}));
};
//# sourceMappingURL=labelStyles.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)


/***/ }),

/***/ 52676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withModifier; }
/* harmony export */ });
const withModifier = (name, styles) => ({
    '&[class]': Object.assign({ label: name && `-${name}` }, styles),
});
//# sourceMappingURL=withModifier.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)


/***/ }),

/***/ 77409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    // `errorDetails` can be an error instance, a fetch response, or a plain object. Good luck!
    function NetworkError(errorDetails) {
        var _this = _super.call(this, errorDetails.message) || this;
        _this.name = 'NetworkError';
        // Legacy redux-framework code relies on the presence of this property to check whether an error is a network error.
        _this.networkErrorMessage = errorDetails.message;
        _this.message = "We're having some trouble connecting. You might try reloading the page or checking your internet connection. " + _this.networkErrorMessage;
        // Legacy redux-framework code checks this flag to decide if it should show an error modal to the user.
        _this.shouldGlobalizeError =
            errorDetails.shouldGlobalizeError !== false &&
                !NetworkError.isFirefoxFetchError(errorDetails);
        return _this;
    }
    // Catches a very specific Firefox error that occurs when a fetch
    // request is interrupted while inflight. This error causes the global
    // error modal to appear if a user is quickly navigating to a page
    // that requires a refresh while there are inflight fetch requests.
    NetworkError.isFirefoxFetchError = function (errorDetails) {
        return Boolean(errorDetails &&
            errorDetails.name === 'TypeError' &&
            errorDetails.message ===
                'NetworkError when attempting to fetch resource.');
    };
    // Preserve backwards compatibility with legacy redux-framework code that relies on this static method existing,
    // such as the `ErrorModal` and `ErrorSummary` components.
    NetworkError.summary = function (errorInstance) {
        return errorInstance.message;
    };
    return NetworkError;
}(Error));
exports["default"] = NetworkError;


/***/ }),

/***/ 25287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getJsonWithAccountId = exports.isJsonResponse = exports.sendFormData = exports.postJsonWithAccountId = exports.putJson = exports.postJson = exports.patchJson = exports.getJson = exports.deleteJson = exports.fetchJson = exports.onFetchComplete = exports.csrfTokenReady = void 0;
var lodash_1 = __importDefault(__webpack_require__(76635));
var url_utils_1 = __webpack_require__(17712);
var cookies_1 = __webpack_require__(65334);
var NetworkError_1 = __importDefault(__webpack_require__(77409));
var fetchSuccess = function (response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    return response.text().then(function (body) {
        // Hack to make legacy z.useful.errors work for now.
        response.responseText = body;
        throw response;
    });
};
// If the client doesn't already have a CSRF token, then retrieve one
var retrieveCsrfToken = function (crossOrigin) {
    if (crossOrigin) {
        return (fetch(process.env.ZAPIER_API_BASE_URL + "/api/v3/csrf", {
            credentials: 'include',
            mode: 'cors',
        })
            .then(fetchSuccess)
            // The `fetch` call can reject with a `TypeError` or `AbortError`, but `fetchSuccess`
            // can reject with the actual response instead of an error (*flips table*). It's too
            // late to change this because of all the downstream dependencies on this behavior, so
            // we're going to have to live with it.
            .catch(function (errorOrResponse) {
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: 'Unable to retrieve CSRF token.' }));
        }));
    }
    return cookies_1.readCookie('csrftoken')
        ? Promise.resolve()
        : fetch('/api/v3/csrf', { credentials: 'same-origin' })
            .then(fetchSuccess)
            // The `fetch` call can reject with a `TypeError` or `AbortError`, but `fetchSuccess`
            // can reject with the actual response instead of an error (*flips table*). It's too
            // late to change this because of all the downstream dependencies on this behavior, so
            // we're going to have to live with it.
            .catch(function (errorOrResponse) {
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: 'Unable to retrieve CSRF token.' }));
        });
};
/**
 * The CSRF token needs to be the first thing retrieved before any CSRF-protected
 * request can take place (e.g. POST requests), so all requests should wait until
 * that resolves before proceeding.
 * To improve performance, we cache the promise from the first call to `csrfTokenReady`.
 */
var _retrieveCsrfTokenPromise = null;
function csrfTokenReady(crossOrigin) {
    if (_retrieveCsrfTokenPromise) {
        return _retrieveCsrfTokenPromise;
    }
    _retrieveCsrfTokenPromise = retrieveCsrfToken(crossOrigin);
    return _retrieveCsrfTokenPromise;
}
exports.csrfTokenReady = csrfTokenReady;
/**
 * Retry trying to get `document.location` if it's not available immediately.
 * We do that because, weirdly, we're seeing some errors in Sentry where `document.location` is `null`.
 * After some initial investigation, it looks like Firefox has a bug where `document.location`
 * is not being properly set until a couple of seconds after the page is loaded.
 */
var waitForLocation = function (totalTimeWaited) {
    if (totalTimeWaited === void 0) { totalTimeWaited = 0; }
    if (document.location) {
        return Promise.resolve(document.location);
    }
    if (totalTimeWaited > 2000) {
        return Promise.reject("Couldn't find document.location after 2 seconds.");
    }
    return new Promise(function (resolve) {
        setTimeout(function () {
            waitForLocation(totalTimeWaited + 100).then(resolve);
        }, 100);
    });
};
/**
 * Test that the base of the request url matches the Zapier API Base URL.
 */
var urlMatchesZapierApiBaseUrl = function (url) {
    if (!process.env.ZAPIER_API_BASE_URL) {
        return false;
    }
    var parsedBaseUrl = new URL(process.env.ZAPIER_API_BASE_URL);
    try {
        var parsedUrl = new URL(url);
        return parsedUrl.origin === parsedBaseUrl.origin;
    }
    catch (err) {
        // the url could have been protocol-relative or relative
        return false;
    }
};
/**
 * Test that a given url is a same-origin URL.
 * url could be relative or scheme relative or absolute host + port.
 */
var sameOrigin = function (url) {
    return waitForLocation().then(function (location) {
        var host = location.host;
        var protocol = location.protocol;
        var sr_origin = '//' + host;
        var origin = protocol + sr_origin;
        /* Allow absolute or scheme relative URLs to same origin
         * or any other URL that isn't scheme relative or absolute i.e relative.
         */
        return (url === origin ||
            url.slice(0, origin.length + 1) === origin + '/' ||
            url === sr_origin ||
            url.slice(0, sr_origin.length + 1) === sr_origin + '/' ||
            !/^(\/\/|http:|https:).*/.test(url));
    });
};
function isRelative(path) {
    return (path.indexOf('//') !== 0 &&
        path.indexOf('https://') !== 0 &&
        path.indexOf('http://') !== 0);
}
/**
 * Checks if the request about to be fired needs an CSRF token.
 * If it does, fetch the token and set it as a request header.
 */
function setCsrfHeaderIfNeeded(url, info) {
    return __awaiter(this, void 0, void 0, function () {
        var method, isCsrfSafeMethod, isSameOrigin, isSafeCrossOrigin, resp, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = info.method || '';
                    isCsrfSafeMethod = /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
                    // CSRF-safe methods don't need the CSRF header.
                    if (isCsrfSafeMethod) {
                        return [2 /*return*/, info];
                    }
                    // We currently don't support CSRF for non-browser environments.
                    if (typeof window === 'undefined') {
                        return [2 /*return*/, info];
                    }
                    return [4 /*yield*/, sameOrigin(url)];
                case 1:
                    isSameOrigin = _a.sent();
                    isSafeCrossOrigin = urlMatchesZapierApiBaseUrl(url);
                    if (!isSameOrigin && !isSafeCrossOrigin) {
                        return [2 /*return*/, info];
                    }
                    return [4 /*yield*/, csrfTokenReady(isSafeCrossOrigin)];
                case 2:
                    resp = _a.sent();
                    token = isSafeCrossOrigin
                        ? resp.headers.get('x-upstreamcsrftoken')
                        : cookies_1.readCookie('csrftoken');
                    if (token) {
                        info.headers = new Headers(info.headers || {});
                        info.headers.set('X-CSRFToken', token);
                    }
                    return [2 /*return*/, info];
            }
        });
    });
}
var onFetchCompleteListener = function (_response) { };
// Allow consumers to listen to completed fetch requests.
// This is nasty, but needed to preserve backwards-compatibility with the fetchMiddleware from `@zapier/toolbox-redux-framework`.
function onFetchComplete(fn) {
    onFetchCompleteListener = fn;
}
exports.onFetchComplete = onFetchComplete;
// Note that we don't support passing in `url` `Request` objects, only strings.
var wrappedFetch = function (url, info) {
    if (info === void 0) { info = {}; }
    info = __assign({}, info);
    info.headers = new Headers(info.headers || {});
    info.headers.set('X-Requested-With', 'XMLHttpRequest'); // help django's request.is_ajax()
    info.credentials = 'include';
    // For relative URLs, we let the downstream consumer of the library customize the base URL to prepend
    // via the ZAPIER_API_BASE_URL environment variable.
    var apiUrl = isRelative(url)
        ? "" + (process.env.ZAPIER_API_BASE_URL || '') + url
        : url;
    return setCsrfHeaderIfNeeded(apiUrl, info).then(function (newInfo) {
        return (fetch(apiUrl, newInfo)
            .then(function (response) {
            onFetchCompleteListener(response);
            return response;
        })
            // Our `fetch` call can reject with a `TypeError` or `AbortError`, but `setCsrfHeaderIfNeeded`
            // can reject with the actual response instead of an error (*flips table*). It's too late to
            // change this because of all the downstream dependencies on this behavior, so we're going to
            // have to live with it.
            .catch(function (errorOrResponse) {
            // Sentry captures this error:
            //
            // > We're having some trouble connecting. You might try reloading the page
            // > or checking your internet connection. Only absolute URLs are supported
            //
            // Let's try to include the URL so we can better understand the issue
            var originalMessage = errorOrResponse.message || '';
            var newMessage = originalMessage + " url='" + apiUrl + "'";
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: newMessage }));
        }));
    });
};
wrappedFetch.success = fetchSuccess;
wrappedFetch.json = function (response) {
    return response
        .json()
        .then(function (data) {
        return data;
    })
        .catch(function (err) {
        // Empty content is expected with a 204 and is valid,
        // though parsing it as JSON would fail.
        if (response.status === 204) {
            return null;
        }
        // Throw the error if it was a problem parsing.
        if (response.status >= 200 && response.status < 300) {
            throw err;
        }
        // Otherwise, maybe this was an error status and JSON wasn't expected.
        throw response;
    });
};
// FIXME: This should be a named export instead.
wrappedFetch.url = function (url, params) {
    if (!params) {
        return url;
    }
    var queryString = Object.keys(params).reduce(function (prevQueryString, paramKey) {
        var value = params[paramKey];
        var nextQueryString = prevQueryString;
        if (typeof value !== 'undefined' && value !== null) {
            if (nextQueryString) {
                nextQueryString += '&';
            }
            nextQueryString += encodeURIComponent(paramKey) + "=" + encodeURIComponent(value);
        }
        return nextQueryString;
    }, '');
    return url + (queryString ? '?' : '') + queryString;
};
exports.fetchJson = function (uri, info) {
    info = info ? lodash_1.default.extend({}, info) : {};
    info.headers = new Headers(info.headers || {});
    // It is incorrect to send this with no body and some frameworks,
    // like Aperture's Fastify refuse to process it if we do.
    if (info.body) {
        info.headers.set('Content-Type', 'application/json');
    }
    info.headers.set('Accept', 'application/json');
    return wrappedFetch(uri, info)
        .then(wrappedFetch.success)
        .then(wrappedFetch.json);
};
// `fetchJson` via `method`, passing along a stringified
// `body` if it exists.
var fetchJsonWithMethod = function (method, url, body) {
    return exports.fetchJson(url, __assign(__assign({}, (method !== 'GET' ? { body: body && JSON.stringify(body) } : {})), { method: method }));
};
exports.deleteJson = lodash_1.default.partial(fetchJsonWithMethod, 'DELETE');
exports.getJson = lodash_1.default.partial(fetchJsonWithMethod, 'GET');
exports.patchJson = lodash_1.default.partial(fetchJsonWithMethod, 'PATCH');
exports.postJson = lodash_1.default.partial(fetchJsonWithMethod, 'POST');
exports.putJson = lodash_1.default.partial(fetchJsonWithMethod, 'PUT');
exports.postJsonWithAccountId = function (accountId, url, body) {
    if (body === void 0) { body = {}; }
    return exports.postJson(url, __assign(__assign({}, body), { account_id: accountId }));
};
exports.sendFormData = function (url, formData, opts) {
    if (opts === void 0) { opts = {}; }
    if (opts.headers) {
        opts.headers = new Headers(opts.headers || {});
        opts.headers.set('Accept', 'application/json');
    }
    var options = __assign(__assign({ method: 'POST' }, opts), { body: formData });
    return wrappedFetch(url, options)
        .then(wrappedFetch.success)
        .then(wrappedFetch.json);
};
var isResponseOfType = function (type, response) {
    return lodash_1.default.isFunction(lodash_1.default.get(response, ['headers', 'get'])) &&
        response.headers.get('content-type').indexOf(type) > -1;
};
exports.isJsonResponse = lodash_1.default.partial(isResponseOfType, 'application/json');
exports.getJsonWithAccountId = function (accountId, url) {
    return exports.getJson(url_utils_1.addTruthyParamsToUrl(url, { account_id: accountId }));
};
exports["default"] = wrappedFetch;


/***/ }),

/***/ 9197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// import-sort-ignore
Object.defineProperty(exports, "__esModule", ({ value: true }));
var fetch_1 = __webpack_require__(25287);
Object.defineProperty(exports, "fetch", ({ enumerable: true, get: function () { return fetch_1.default; } }));
Object.defineProperty(exports, "onFetchComplete", ({ enumerable: true, get: function () { return fetch_1.onFetchComplete; } }));
Object.defineProperty(exports, "isJsonResponse", ({ enumerable: true, get: function () { return fetch_1.isJsonResponse; } }));
Object.defineProperty(exports, "getJsonWithAccountId", ({ enumerable: true, get: function () { return fetch_1.getJsonWithAccountId; } }));
Object.defineProperty(exports, "postJsonWithAccountId", ({ enumerable: true, get: function () { return fetch_1.postJsonWithAccountId; } }));
Object.defineProperty(exports, "sendFormData", ({ enumerable: true, get: function () { return fetch_1.sendFormData; } }));
Object.defineProperty(exports, "csrfTokenReady", ({ enumerable: true, get: function () { return fetch_1.csrfTokenReady; } }));
Object.defineProperty(exports, "getJson", ({ enumerable: true, get: function () { return fetch_1.getJson; } }));
Object.defineProperty(exports, "deleteJson", ({ enumerable: true, get: function () { return fetch_1.deleteJson; } }));
Object.defineProperty(exports, "fetchJson", ({ enumerable: true, get: function () { return fetch_1.fetchJson; } }));
Object.defineProperty(exports, "patchJson", ({ enumerable: true, get: function () { return fetch_1.patchJson; } }));
Object.defineProperty(exports, "postJson", ({ enumerable: true, get: function () { return fetch_1.postJson; } }));
Object.defineProperty(exports, "putJson", ({ enumerable: true, get: function () { return fetch_1.putJson; } }));
var NetworkError_1 = __webpack_require__(77409);
Object.defineProperty(exports, "NetworkError", ({ enumerable: true, get: function () { return NetworkError_1.default; } }));


/***/ }),

/***/ 15390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(2784));
var utils_1 = __webpack_require__(81354);
var TrackEntry = /** @class */ (function (_super) {
    __extends(TrackEntry, _super);
    function TrackEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackEntry.prototype.componentDidMount = function () {
        var _a = this.props, track = _a.track, trackingMessage = _a.trackingMessage, _b = _a.trackingProps, trackingProps = _b === void 0 ? {} : _b;
        if (utils_1.isBrowser()) {
            var message = trackingMessage || 'track entry';
            track(message, __assign({}, trackingProps));
        }
    };
    TrackEntry.prototype.render = function () {
        return this.props.children;
    };
    return TrackEntry;
}(react_1.default.Component));
exports["default"] = TrackEntry;


/***/ }),

/***/ 61819:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var TrackOnChange = function (_a) {
    var track = _a.track, trackingMessage = _a.trackingMessage, _b = _a.trackingProps, trackingProps = _b === void 0 ? {} : _b, children = _a.children;
    react_1.useEffect(function () {
        track(trackingMessage, trackingProps);
    }, [track, trackingMessage, trackingProps]);
    return children;
};
exports["default"] = TrackOnChange;


/***/ }),

/***/ 57822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(2784));
var lodash_1 = __webpack_require__(76635);
var utils_1 = __webpack_require__(81354);
var getVisibilityChangeProps = function () {
    if (typeof document.hidden !== 'undefined') {
        // This covers most cases
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }
    // @ts-ignore
    else if (typeof document.msHidden !== 'undefined') {
        // Internet Explorer and Microsoft Edge
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        // Older versions of webkit browsers (Chrome, Safari, newer versions of Opera, almost all iOS browsers (including Firefox for iOS))
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }
    return undefined;
};
var TrackTime = /** @class */ (function (_super) {
    __extends(TrackTime, _super);
    function TrackTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hidden: '',
            visibilityChange: '',
            totalActiveMillis: 0,
            totalAbsentMillis: 0,
            lastEventTime: Date.now(),
            // sets the user state active,
            // which requires a previous event of userInactive to kick things off.
            lastEvent: 'userInactive',
            userState: 'active',
        };
        _this.getTimeDelta = function () {
            var now = Date.now();
            return {
                now: now,
                elapsed: now - _this.state.lastEventTime,
            };
        };
        _this.onChangeUserStatus = function (statusType) {
            var _a = _this.state, totalAbsentMillis = _a.totalAbsentMillis, totalActiveMillis = _a.totalActiveMillis, userState = _a.userState;
            var _b = _this.getTimeDelta(), elapsed = _b.elapsed, now = _b.now;
            // we're switching from 'inactive' to 'active', so the event will be 'userActive'
            // and the current userState will be 'inactive'
            // since we have a few events handling a visibility change (mouseleave, mousenter, and the
            // events triggered by the visibility change api) we need to double-check that we're not already // counting active/inactive time before we change the user status.
            if (statusType === 'userActive' && userState === 'inactive') {
                _this.setState({
                    totalAbsentMillis: totalAbsentMillis + elapsed,
                    lastEvent: 'userActive',
                    lastEventTime: now,
                    userState: 'active',
                });
            }
            else if (statusType === 'userInactive' && userState === 'active') {
                _this.setState({
                    totalActiveMillis: totalActiveMillis + elapsed,
                    lastEvent: 'userInactive',
                    lastEventTime: now,
                    userState: 'inactive',
                });
            }
        };
        _this.onUserActive = lodash_1.partial(_this.onChangeUserStatus, 'userActive');
        _this.onUserInactive = lodash_1.partial(_this.onChangeUserStatus, 'userInactive');
        _this.beginEventListening = function () {
            document.addEventListener(_this.state.visibilityChange, _this.handleVisibilityChange);
            window.addEventListener('beforeunload', _this.onClosePage);
            document.addEventListener('mouseleave', _this.onUserInactive);
            document.addEventListener('mouseenter', _this.onUserActive);
            _this.onUserActive();
        };
        _this.onClosePage = function () {
            var _a = _this.state, totalActiveMillis = _a.totalActiveMillis, totalAbsentMillis = _a.totalAbsentMillis, userState = _a.userState;
            var trackingProps = _this.props.trackingProps || {};
            var elapsed = _this.getTimeDelta().elapsed;
            var message = _this.props.trackingMessage || 'track time';
            _this.props.track(message, __assign(__assign({}, trackingProps), { totalActiveTime: totalActiveMillis + (userState === 'active' ? elapsed : 0), totalAbsentTime: totalAbsentMillis + (userState === 'inactive' ? elapsed : 0) }));
            document.removeEventListener('mouseleave', _this.onUserInactive);
            window.removeEventListener('beforeunload', _this.onClosePage);
            document.removeEventListener('mouseenter', _this.onUserActive);
        };
        _this.handleVisibilityChange = function () {
            if (lodash_1.get(document, [_this.state.hidden])) {
                _this.onUserInactive();
            }
            else {
                _this.onUserActive();
            }
        };
        return _this;
    }
    TrackTime.prototype.componentWillUnmount = function () {
        if (utils_1.isBrowser()) {
            this.onClosePage();
        }
    };
    TrackTime.prototype.componentDidMount = function () {
        if (utils_1.isBrowser()) {
            var visibilityChangeProps = getVisibilityChangeProps();
            if (visibilityChangeProps) {
                this.setState(visibilityChangeProps, this.beginEventListening);
            }
        }
    };
    TrackTime.prototype.render = function () {
        return this.props.children;
    };
    return TrackTime;
}(react_1.default.Component));
exports["default"] = TrackTime;


/***/ }),

/***/ 99278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TrackingProvider = exports.useTrackingContext = exports.TrackingContext = void 0;
var react_1 = __importDefault(__webpack_require__(2784));
var createTrackingFunctions_1 = __importDefault(__webpack_require__(13903));
/** Placeholder trackEvent to feed into defaultContext. This should never be used. */
var defaultTrackEvent = function ( /* eventName, metaData */) { return Promise.resolve(); };
var defaultContext = createTrackingFunctions_1.default(defaultTrackEvent);
exports.TrackingContext = react_1.default.createContext(defaultContext);
exports.useTrackingContext = function () {
    return react_1.default.useContext(exports.TrackingContext);
};
exports.TrackingProvider = function (_a) {
    var children = _a.children, propsTrackingFunctions = _a.trackingFunctions, metadata = _a.metadata;
    var trackingFunctions = exports.useTrackingContext();
    // Context TrackingFunctions may be overridden by props.trackingFunctions
    if (propsTrackingFunctions) {
        // @ts-ignore these two types are not exactly the same because
        // trackEvent is the only required prop.
        trackingFunctions = propsTrackingFunctions;
    }
    /*
     * If metadata is provided, enhance TrackingFunctions with it.
     * Metadata is enhanced for descendants within context boundaries.
     * TrackingProvider may live within boundaries of other TrackingProvider
     * to allow for progressive enhancement of metadata down the component hierarchy.
     */
    if (metadata) {
        var trackEvent_1 = trackingFunctions.trackEvent;
        trackingFunctions = createTrackingFunctions_1.default(function (eventName, eventData) {
            return trackEvent_1(eventName, __assign(__assign({}, metadata), eventData));
        });
    }
    return (react_1.default.createElement(exports.TrackingContext.Provider, { value: trackingFunctions }, children));
};


/***/ }),

/***/ 63176:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var url_utils_1 = __webpack_require__(17712);
var cookies_1 = __webpack_require__(65334);
var constants_1 = __importStar(__webpack_require__(62958));
var utils_1 = __webpack_require__(81354);
var TrackingCookies = {
    /* Returns the cookie name based on the ID, e.g. __fbclid */
    getClickIdCookieName: function (id) {
        return "__" + id;
    },
    /* Retrieves a cookie for a single click ID query parameter, e.g. fbclid, gclid, msclkid */
    retrieveClickId: function (id) {
        var cookie = cookies_1.readCookie(this.getClickIdCookieName(id));
        if (cookie) {
            try {
                return atob(cookie);
            }
            catch (e) {
                console.error("Error retrieving " + id + ": " + e);
            }
        }
        return null;
    },
    /* Stores a cookie for a single click ID query parameter, e.g. fbclid, gclid, msclkid */
    storeClickId: function (id, href) {
        if (href === void 0) { href = window.location.href; }
        if (utils_1.isBrowser()) {
            var params = url_utils_1.extractParams(href);
            var param = params[id];
            if (param) {
                cookies_1.writeCookie(this.getClickIdCookieName(id), btoa(param), {
                    category: 'marketing',
                    maxAge: constants_1.default.CLICK_ID_COOKIE_EXPIRATION,
                });
            }
        }
    },
    /* Iterates through all ClickIds values and fetches cookies for each, e.g. fbclid, gclid, msclkid */
    retrieveAllClickIds: function () {
        var _this = this;
        Object.values(constants_1.ClickIds).forEach(function (id) {
            _this.retrieveClickId(id);
        });
    },
    /* Iterates through all ClickIds values and stores cookies for each, e.g. fbclid, gclid, msclkid */
    storeAllClickIds: function () {
        var _this = this;
        Object.values(constants_1.ClickIds).forEach(function (id) {
            _this.storeClickId(id);
        });
    },
    retrieveUtms: function () {
        if (utils_1.isBrowser()) {
            var utmCookie = cookies_1.readCookie(constants_1.default.UTM_COOKIE_NAME);
            if (utmCookie) {
                try {
                    return JSON.parse(utmCookie);
                }
                catch (e) {
                    // If we fail to parse the cookie, then we will resolve everything
                    // as `undefined`.
                }
            }
        }
        return {
            utm_campaign: undefined,
            utm_source: undefined,
            utm_content: undefined,
            utm_medium: undefined,
            utm_term: undefined,
        };
    },
    storeUtms: function (url) {
        if (utils_1.isBrowser()) {
            try {
                var href = url || window.location.href;
                var params = url_utils_1.extractParams(href);
                var utmParams = lodash_1.pick(params, constants_1.default.UTM_PARAM_NAMES);
                if (lodash_1.keys(utmParams).length > 0) {
                    cookies_1.writeCookie(constants_1.default.UTM_COOKIE_NAME, JSON.stringify(utmParams), {
                        category: 'marketing',
                        maxAge: constants_1.default.UTM_COOKIE_EXPIRATION,
                    });
                }
                return undefined;
            }
            catch (e) {
                // If we fail to set the cookie, then we will resolve `undefined`.
            }
        }
        return undefined;
    },
};
exports["default"] = TrackingCookies;


/***/ }),

/***/ 62958:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SIGNUP_PRE_INTENT_EVENT = exports.SIGNUP_CONVERSION_EVENT = exports.TRIGGER_SCROLL_TRACKING = exports.SIGNUP_INTENT_EVENT = exports.ClickIds = void 0;
var ClickIds;
(function (ClickIds) {
    ClickIds["Facebook"] = "fbclid";
    ClickIds["Google"] = "gclid";
    ClickIds["Bing"] = "msclkid";
})(ClickIds = exports.ClickIds || (exports.ClickIds = {}));
var TrackingConstants = {
    CLICK_ID_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
    UTM_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
    UTM_COOKIE_NAME: '__utm_params',
    UTM_PARAM_NAMES: [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ],
}; // Triggered when the user attempts to sign-up. May fire more than once as the user interacts with the form(s).
exports.SIGNUP_INTENT_EVENT = 'auth: signup_intent'; // Triggered when the user successfully completes the sign up process.
exports.TRIGGER_SCROLL_TRACKING = 'ScrollDistance'; // Triggers scroll tracking via GTM tag
exports.SIGNUP_CONVERSION_EVENT = 'auth: signup'; // Triggered when a user clicks the `Sign Up` button in the header
exports.SIGNUP_PRE_INTENT_EVENT = 'auth: signup_pre_intent';
exports["default"] = TrackingConstants;


/***/ }),

/***/ 42078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var attachAttributionParams_1 = __importDefault(__webpack_require__(45343));
var attachWindowParams_1 = __importDefault(__webpack_require__(25271));
var createMaybeAddUserAndIdentityId_1 = __importDefault(__webpack_require__(8606));
var createTrackingFunctions_1 = __importDefault(__webpack_require__(13903));
var environmentParams_1 = __importDefault(__webpack_require__(17713));
var eventDebugger_1 = __importDefault(__webpack_require__(95898));
var sendToBackend_1 = __importDefault(__webpack_require__(34482));
var sendToGA_1 = __importDefault(__webpack_require__(58898));
var utmParams_1 = __importDefault(__webpack_require__(21277));
var trackingScope_1 = __webpack_require__(3678);
var utils_1 = __webpack_require__(81354);
var createEventTracker = function (customMiddleware) {
    if (customMiddleware === void 0) { customMiddleware = []; }
    var middleware = (utils_1.isProduction()
        ? __spread([
            attachWindowParams_1.default,
            attachAttributionParams_1.default,
            utmParams_1.default,
            createMaybeAddUserAndIdentityId_1.default
        ], customMiddleware, [
            environmentParams_1.default,
            sendToBackend_1.default,
            sendToGA_1.default,
        ]) : __spread([
        attachWindowParams_1.default,
        attachAttributionParams_1.default,
        utmParams_1.default,
        createMaybeAddUserAndIdentityId_1.default
    ], customMiddleware, [
        environmentParams_1.default,
        eventDebugger_1.default,
    ])).map(function (ware) { return ware(trackingScope_1.trackingScopeApi); });
    console.warn('This package has been deprecated. We strongly encourage if you are ' +
        'planning to use it for the first time, please use the new library ' +
        'Events-Toolkit-Browser: https://github.com/zapier/events-toolkit-js');
    return createTrackingFunctions_1.default(function (eventName, metaData) { return __awaiter(void 0, void 0, void 0, function () {
        var context, isCancelled, setIsCancelled, applyContext, _deprecatedPropertiesInRoot, _deprecatedSetProprtiesInRoot, _deprecatedBuildProprtiesInRoot, buildEventApi, middleware_1, middleware_1_1, promise, event_1, e_1_1, e_2;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    context = {};
                    isCancelled = false;
                    setIsCancelled = function () {
                        isCancelled = true;
                    };
                    applyContext = function (newCtx) {
                        context = __assign(__assign({}, context), newCtx);
                    };
                    _deprecatedPropertiesInRoot = new Set();
                    _deprecatedSetProprtiesInRoot = function (properties) {
                        properties.forEach(function (property) {
                            _deprecatedPropertiesInRoot.add(property);
                        });
                    };
                    _deprecatedBuildProprtiesInRoot = function () {
                        var rootContext = {};
                        _deprecatedPropertiesInRoot.forEach(function (key) {
                            rootContext[key] = context[key];
                        });
                        return rootContext;
                    };
                    buildEventApi = function () { return ({
                        name: eventName,
                        data: __assign({}, metaData),
                        context: __assign({}, context),
                        apply: applyContext,
                        cancel: setIsCancelled,
                        _deprecatedSetProprtiesInRoot: _deprecatedSetProprtiesInRoot,
                        _deprecatedBuildProprtiesInRoot: _deprecatedBuildProprtiesInRoot,
                    }); };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 10, , 11]);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 7, 8, 9]);
                    middleware_1 = __values(middleware), middleware_1_1 = middleware_1.next();
                    _b.label = 3;
                case 3:
                    if (!!middleware_1_1.done) return [3 /*break*/, 6];
                    promise = middleware_1_1.value;
                    event_1 = buildEventApi();
                    return [4 /*yield*/, promise(event_1)];
                case 4:
                    _b.sent();
                    if (isCancelled) {
                        return [3 /*break*/, 6];
                    }
                    _b.label = 5;
                case 5:
                    middleware_1_1 = middleware_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (middleware_1_1 && !middleware_1_1.done && (_a = middleware_1.return)) _a.call(middleware_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_2 = _b.sent();
                    if (utils_1.isProduction()) {
                        console.warn(JSON.stringify({
                            message: 'Unable to track event: ',
                            eventName: eventName,
                            data: metaData,
                            context: context,
                        }), e_2);
                    }
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); });
};
exports["default"] = createEventTracker;


/***/ }),

/***/ 13903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var constants_1 = __webpack_require__(62958);
/**
 * Creates a collection of essential functions to be used across Zapier
 *
 * Takes a TrackingFunction as an argument and returns additional functions
 * built on top of that function.
 *
 * Example usage:
 *
 * const trackingFunction = (eventType, metaData) => { ... }
 *
 * export const { trackSignupConversion } = createTrackingFunctions(trackingFunction);
 *
 * trackSignupConversion(SignupType.oneTap)
 */
var createTrackingFunctions = function (trackEvent) {
    var trackSignupConversion = function (signupType, metaData) {
        return trackEvent(constants_1.SIGNUP_CONVERSION_EVENT, __assign(__assign({}, metaData), { eventCategory: 'account', eventAction: 'created', eventValue: 1, signupType: signupType }));
    };
    var trackSignupIntent = lodash_1.once(function (signupType, metaData) {
        return trackEvent(constants_1.SIGNUP_INTENT_EVENT, __assign(__assign({}, metaData), { eventCategory: 'account', eventAction: 'created', eventValue: 1, signupType: signupType }));
    });
    var trackBirthEvent = lodash_1.once(function (test, lane, extraEventData) {
        var metaData = __assign(__assign({}, extraEventData), { lane: lane,
            test: test });
        return trackEvent("test: " + test + "_birth", metaData);
    });
    var trackOnce = lodash_1.once(trackEvent);
    return {
        trackEvent: trackEvent,
        trackSignupIntent: trackSignupIntent,
        trackSignupConversion: trackSignupConversion,
        trackBirthEvent: trackBirthEvent,
        trackOnce: trackOnce,
    };
};
exports["default"] = createTrackingFunctions;


/***/ }),

/***/ 18101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(91174), exports);
__exportStar(__webpack_require__(87338), exports);


/***/ }),

/***/ 87338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMaybeSendFullStoryEvent = void 0;
var react_1 = __webpack_require__(2784);
var utils_1 = __webpack_require__(3144);
exports.useMaybeSendFullStoryEvent = function (shouldSendEvent, eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    react_1.useEffect(function () {
        if (shouldSendEvent) {
            utils_1.sendFullStoryEvent(eventName, eventProperties);
        }
        /**
         * Can't just pass `eventProperties` into the dependency array here because
         * it's a new object each time (even if the values are the same), so this hook
         * will get called on every re-render.
         *
         * A deep compare of `eventProperties` is an option, but Dan Abramov says that
         * deep compares are generally a bad idea here, which is why `useEffect` doesn't
         * just do that itself. He suggests using `JSON.stringify` instead, as long as the
         * object is only a couple layers deep.
         *
         * https://twitter.com/dan_abramov/status/1104414272753487872
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldSendEvent, eventName, JSON.stringify(eventProperties)]);
};


/***/ }),

/***/ 91174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSendFullStoryEvent = void 0;
var react_1 = __webpack_require__(2784);
var utils_1 = __webpack_require__(3144);
exports.useSendFullStoryEvent = function (eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    react_1.useEffect(function () {
        utils_1.sendFullStoryEvent(eventName, eventProperties);
        /**
         * Can't just pass `eventProperties` into the dependency array here because
         * it's a new object each time (even if the values are the same), so this hook
         * will get called on every re-render.
         *
         * A deep compare of `eventProperties` is an option, but Dan Abramov says that
         * deep compares are generally a bad idea here, which is why `useEffect` doesn't
         * just do that itself. He suggests using `JSON.stringify` instead, as long as the
         * object is only a couple layers deep.
         *
         * https://twitter.com/dan_abramov/status/1104414272753487872
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventName, JSON.stringify(eventProperties)]);
};


/***/ }),

/***/ 90978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(18101), exports);
__exportStar(__webpack_require__(3144), exports);


/***/ }),

/***/ 10638:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFullStory = void 0;
exports.getFullStory = function () { return window.FS; };


/***/ }),

/***/ 41671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.identifyToFullStory = void 0;
var _1 = __webpack_require__(3144);
exports.identifyToFullStory = function (id, userVars) {
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().identify(id, userVars);
};


/***/ }),

/***/ 3144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(10638), exports);
__exportStar(__webpack_require__(41671), exports);
__exportStar(__webpack_require__(70356), exports);
__exportStar(__webpack_require__(81086), exports);
__exportStar(__webpack_require__(32233), exports);


/***/ }),

/***/ 70356:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isFullStoryInstalled = void 0;
var lodash_1 = __webpack_require__(76635);
var utils_1 = __webpack_require__(81354);
var _1 = __webpack_require__(3144);
// See fullstory.html for details about when FS gets installed for a user.
exports.isFullStoryInstalled = function () {
    return utils_1.isBrowser() && !!window.FS && lodash_1.isFunction(_1.getFullStory().identify);
};


/***/ }),

/***/ 81086:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendFullStoryEvent = void 0;
var _1 = __webpack_require__(3144);
// Note that both 'eventName' and 'eventProperties' here must conform to FullStory's requirements,
// otherwise your event will be silently rejected! The requirements are discussed here:
// https://help.fullstory.com/hc/en-us/articles/360020623274#Limitations%20&%20Guidelines
exports.sendFullStoryEvent = function (eventName, eventProperties) {
    var _a;
    if (eventProperties === void 0) { eventProperties = {}; }
    if ((_a = window) === null || _a === void 0 ? void 0 : _a.DEBUG) {
        console.info("\u2139\uFE0F Would have sent FullStory event \"" + eventName + "\"", eventProperties);
        return;
    }
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().event(eventName, eventProperties);
};


/***/ }),

/***/ 32233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setFullStoryUserVars = void 0;
var _1 = __webpack_require__(3144);
// Note that custom vars need to be type-suffixed (e.g. _str for strings).
// See "Custom fields" section of this doc for more info: https://help.fullstory.com/develop-js/setuservars
exports.setFullStoryUserVars = function (userVars) {
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().setUserVars(userVars);
};


/***/ }),

/***/ 67579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var utils_1 = __webpack_require__(81354);
function useCountClicks(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    var clicksRef = react_1.useRef(0);
    function incrementClicks() {
        clicksRef.current += 1;
    }
    function onComponentUnmount() {
        var message = trackingMessage || 'track click';
        track(message, __assign(__assign({}, (trackingProps || {})), { number_of_clicks_on_refresh_close_or_navigate_away: clicksRef.current }));
        window.removeEventListener('click', incrementClicks);
        window.removeEventListener('beforeunload', onComponentUnmount);
    }
    var onComponentUnmountCallback = react_1.useCallback(onComponentUnmount, []);
    react_1.useEffect(function () {
        if (utils_1.isBrowser()) {
            window.addEventListener('click', incrementClicks);
            window.addEventListener('beforeunload', onComponentUnmountCallback);
        }
        // will be called on component unmount
        return function () {
            if (utils_1.isBrowser()) {
                onComponentUnmountCallback();
            }
        };
    }, [onComponentUnmountCallback]);
}
exports["default"] = useCountClicks;


/***/ }),

/***/ 83533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var TrackingContext_1 = __webpack_require__(99278);
var useMaybeTrackEvent = function (shouldSendEvent, eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    var trackEvent = TrackingContext_1.useTrackingContext().trackEvent;
    react_1.useEffect(function () {
        if (shouldSendEvent) {
            trackEvent(eventName, eventProperties);
        }
        /**
         * Can't just pass `eventProperties` into the dependency array here because
         * it's a new object each time (even if the values are the same), so this hook
         * will get called on every re-render.
         *
         * A deep compare of `eventProperties` is an option, but Dan Abramov says that
         * deep compares are generally a bad idea here, which is why `useEffect` doesn't
         * just do that itself. He suggests using `JSON.stringify` instead, as long as the
         * object is only a couple layers deep.
         *
         * https://twitter.com/dan_abramov/status/1104414272753487872
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldSendEvent, eventName, JSON.stringify(eventProperties)]);
};
exports["default"] = useMaybeTrackEvent;


/***/ }),

/***/ 75814:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var utils_1 = __webpack_require__(81354);
function useTrackEntry(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    function trackEntry() {
        if (utils_1.isBrowser()) {
            var message = trackingMessage || 'track entry';
            track(message, __assign({}, trackingProps));
        }
    }
    var trackEntryCallback = react_1.useCallback(trackEntry, []);
    react_1.useEffect(trackEntryCallback, [trackEntryCallback]);
}
exports["default"] = useTrackEntry;


/***/ }),

/***/ 15363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var TrackingContext_1 = __webpack_require__(99278);
var useTrackEvent = function (eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    var trackEvent = TrackingContext_1.useTrackingContext().trackEvent;
    react_1.useEffect(function () {
        trackEvent(eventName, eventProperties);
        /**
         * Can't just pass `eventProperties` into the dependency array here because
         * it's a new object each time (even if the values are the same), so this hook
         * will get called on every re-render.
         *
         * A deep compare of `eventProperties` is an option, but Dan Abramov says that
         * deep compares are generally a bad idea here, which is why `useEffect` doesn't
         * just do that itself. He suggests using `JSON.stringify` instead, as long as the
         * object is only a couple layers deep.
         *
         * https://twitter.com/dan_abramov/status/1104414272753487872
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventName, JSON.stringify(eventProperties)]);
};
exports["default"] = useTrackEvent;


/***/ }),

/***/ 36207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(2784);
var lodash_1 = __webpack_require__(76635);
var utils_1 = __webpack_require__(81354);
var getVisibilityChangeProps = function () {
    if (typeof document.hidden !== 'undefined') {
        // This covers most cases
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }
    else if (typeof document.msHidden !== 'undefined') {
        // Internet Explorer and Microsoft Edge
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        // Older versions of webkit browsers (Chrome, Safari, newer versions of Opera, almost all iOS browsers (including Firefox for iOS))
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }
    return undefined;
};
var initialValue = {
    hidden: '',
    visibilityChange: '',
    totalActiveMillis: 0,
    totalAbsentMillis: 0,
    lastEventTime: Date.now(),
    userState: 'active',
};
function useTrackTime(_a) {
    var _b = _a === void 0 ? {
        track: function () { },
    } : _a, track = _b.track, trackingMessage = _b.trackingMessage, trackingProps = _b.trackingProps;
    var timeRef = react_1.useRef(initialValue);
    function getTimeDelta() {
        var lastEventTime = timeRef.current.lastEventTime;
        var now = Date.now();
        return {
            now: now,
            elapsed: now - lastEventTime,
        };
    }
    function setUserActive() {
        var _a = getTimeDelta(), elapsed = _a.elapsed, now = _a.now;
        var _b = timeRef.current, totalAbsentMillis = _b.totalAbsentMillis, userState = _b.userState;
        if (userState === 'inactive') {
            timeRef.current = __assign(__assign({}, timeRef.current), { totalAbsentMillis: totalAbsentMillis + elapsed, lastEventTime: now, userState: 'active' });
        }
    }
    function setUserInactive() {
        var _a = getTimeDelta(), elapsed = _a.elapsed, now = _a.now;
        var _b = timeRef.current, totalActiveMillis = _b.totalActiveMillis, userState = _b.userState;
        if (userState === 'active') {
            timeRef.current = __assign(__assign({}, timeRef.current), { totalActiveMillis: totalActiveMillis + elapsed, lastEventTime: now, userState: 'inactive' });
        }
    }
    function onComponentUnmount() {
        var elapsed = getTimeDelta().elapsed;
        var message = trackingMessage || 'track time';
        var _a = timeRef.current, totalActiveMillis = _a.totalActiveMillis, totalAbsentMillis = _a.totalAbsentMillis, userState = _a.userState;
        track(message, __assign(__assign({}, (trackingProps || {})), { totalActiveTime: totalActiveMillis + (userState === 'active' ? elapsed : 0), totalAbsentTime: totalAbsentMillis + (userState === 'inactive' ? elapsed : 0) }));
        window.removeEventListener('beforeunload', onComponentUnmount);
        document.removeEventListener('mouseenter', setUserActive);
        document.removeEventListener('mouseleave', setUserInactive);
    }
    var onComponentUnmountCallback = react_1.useCallback(onComponentUnmount, []);
    function handleVisibilityChange() {
        var hidden = timeRef.current.hidden;
        if (lodash_1.get(document, [hidden])) {
            setUserInactive();
        }
        else {
            setUserActive();
        }
    }
    function beginEventListening() {
        var visibilityChange = timeRef.current.visibilityChange;
        document.addEventListener(visibilityChange, handleVisibilityChange);
        window.addEventListener('beforeunload', onComponentUnmount);
        document.addEventListener('mouseenter', setUserActive);
        document.addEventListener('mouseleave', setUserInactive);
        setUserActive();
    }
    var beginEventListeningCallback = react_1.useCallback(beginEventListening, []);
    react_1.useEffect(function () {
        if (utils_1.isBrowser()) {
            var visibilityChangeProps = getVisibilityChangeProps();
            if (visibilityChangeProps) {
                timeRef.current = __assign(__assign({}, timeRef.current), visibilityChangeProps);
                beginEventListeningCallback();
            }
        }
        // will be called on component unmount
        return function () {
            if (utils_1.isBrowser()) {
                onComponentUnmountCallback();
            }
        };
        // We only want to run this effect after component mounts, not when beginEventListening or onComponentUnmount changes
    }, [beginEventListeningCallback, onComponentUnmountCallback]);
}
exports["default"] = useTrackTime;


/***/ }),

/***/ 24645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", ({ value: true }));
var TrackEntry_1 = __webpack_require__(15390);
Object.defineProperty(exports, "TrackEntry", ({ enumerable: true, get: function () { return TrackEntry_1.default; } }));
var useMaybeTrackEvent_1 = __webpack_require__(83533);
Object.defineProperty(exports, "useMaybeTrackEvent", ({ enumerable: true, get: function () { return useMaybeTrackEvent_1.default; } }));
var useTrackEntry_1 = __webpack_require__(75814);
Object.defineProperty(exports, "useTrackEntry", ({ enumerable: true, get: function () { return useTrackEntry_1.default; } }));
var useTrackEvent_1 = __webpack_require__(15363);
Object.defineProperty(exports, "useTrackEvent", ({ enumerable: true, get: function () { return useTrackEvent_1.default; } }));
var useTrackTime_1 = __webpack_require__(36207);
Object.defineProperty(exports, "useTrackTime", ({ enumerable: true, get: function () { return useTrackTime_1.default; } }));
var useCountClicks_1 = __webpack_require__(67579);
Object.defineProperty(exports, "useCountClicks", ({ enumerable: true, get: function () { return useCountClicks_1.default; } }));
var TrackOnChange_1 = __webpack_require__(61819);
Object.defineProperty(exports, "TrackOnChange", ({ enumerable: true, get: function () { return TrackOnChange_1.default; } }));
var TrackTime_1 = __webpack_require__(57822);
Object.defineProperty(exports, "TrackTime", ({ enumerable: true, get: function () { return TrackTime_1.default; } }));
var TrackingCookies_1 = __webpack_require__(63176);
Object.defineProperty(exports, "TrackingCookies", ({ enumerable: true, get: function () { return TrackingCookies_1.default; } }));
var createEventTracker_1 = __webpack_require__(42078);
Object.defineProperty(exports, "createEventTracker", ({ enumerable: true, get: function () { return createEventTracker_1.default; } }));
__exportStar(__webpack_require__(90978), exports);
var TrackingContext_1 = __webpack_require__(99278);
Object.defineProperty(exports, "TrackingContext", ({ enumerable: true, get: function () { return TrackingContext_1.TrackingContext; } }));
Object.defineProperty(exports, "useTrackingContext", ({ enumerable: true, get: function () { return TrackingContext_1.useTrackingContext; } }));
Object.defineProperty(exports, "TrackingProvider", ({ enumerable: true, get: function () { return TrackingContext_1.TrackingProvider; } }));
var constants_1 = __webpack_require__(62958);
Object.defineProperty(exports, "SIGNUP_PRE_INTENT_EVENT", ({ enumerable: true, get: function () { return constants_1.SIGNUP_PRE_INTENT_EVENT; } }));
Object.defineProperty(exports, "TRIGGER_SCROLL_TRACKING", ({ enumerable: true, get: function () { return constants_1.TRIGGER_SCROLL_TRACKING; } }));
Object.defineProperty(exports, "ClickIds", ({ enumerable: true, get: function () { return constants_1.ClickIds; } }));
__exportStar(__webpack_require__(3678), exports); // Middleware
var eventDebugger_1 = __webpack_require__(95898);
Object.defineProperty(exports, "eventDebugger", ({ enumerable: true, get: function () { return eventDebugger_1.default; } }));


/***/ }),

/***/ 45343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var url_utils_1 = __webpack_require__(17712);
var constants_1 = __webpack_require__(62958);
var TrackingCookies_1 = __importDefault(__webpack_require__(63176));
var attachAttributionParams = function () { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var qs, clickIdParams, conditionalParams;
    return __generator(this, function (_a) {
        qs = url_utils_1.querystringToObj();
        clickIdParams = {};
        Object.values(constants_1.ClickIds).forEach(function (id) {
            var val = qs[id] || TrackingCookies_1.default.retrieveClickId(id);
            if (val) {
                clickIdParams[id] = val;
            }
        });
        conditionalParams = __assign(__assign(__assign({}, clickIdParams), { embedded_referrer: qs.embedded_referrer, template: qs.template, utm_campaign: qs.utm_campaign, utm_content: qs.utm_content, utm_medium: qs.utm_medium, utm_source: qs.utm_source }), (!lodash_1.isEmpty(document.referrer) // Remove `referrer` only once Data has deprecated it
            ? {
                referrer: document.referrer,
                http_referer: document.referrer,
            }
            : {}));
        event.apply(conditionalParams);
        event._deprecatedSetProprtiesInRoot(__spread(Object.values(constants_1.ClickIds), [
            'embedded_referrer',
            'template',
            'utm_campaign',
            'utm_content',
            'utm_medium',
            'utm_source',
            'referrer',
        ]));
        return [2 /*return*/];
    });
}); }; };
exports["default"] = attachAttributionParams;


/***/ }),

/***/ 25271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(81354);
var attachWindowParams = function () { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (utils_1.isBrowser()) {
            event.apply({
                absolute_uri: window.location.href,
                path: window.location.pathname,
                querystring: window.location.search,
                userAgent: window.navigator.userAgent,
            });
            event._deprecatedSetProprtiesInRoot(['path']);
        }
        return [2 /*return*/];
    });
}); }; };
exports["default"] = attachWindowParams;


/***/ }),

/***/ 8606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clearCurrentProfileCache = void 0;
var lodash_1 = __webpack_require__(76635);
var toolbox_browser_fetch_1 = __webpack_require__(9197);
var utils_1 = __webpack_require__(81354);
// Memoize this so that we don't fetch more than once
// (unless the baseUrl is different, which probably won't ever happen)
var getCurrentProfile = lodash_1.memoize(function (baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var url, cachedCurrentProfile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = baseUrl + "/api/v3/profiles";
                return [4 /*yield*/, toolbox_browser_fetch_1.getJson(url)];
            case 1:
                cachedCurrentProfile = _a.sent();
                return [2 /*return*/, cachedCurrentProfile];
        }
    });
}); });
// Only exposed for testing purposes
exports.clearCurrentProfileCache = function () {
    return getCurrentProfile.cache.clear && getCurrentProfile.cache.clear();
};
var createMaybeAddUserAndIdentityId = function (config) {
    return function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, identity_id, _a, baseUrl, cachedCurrentProfile, active_id, objects, e_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // We don't want to be calling `/api/v3/profiles` from the server.
                    if (!utils_1.isBrowser()) {
                        return [2 /*return*/];
                    }
                    userId = (_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.userId;
                    identity_id = (_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.identity_id;
                    if (!(!userId || !identity_id)) return [3 /*break*/, 4];
                    _a = config.get(['service', 'baseUrl']).baseUrl, baseUrl = _a === void 0 ? '' : _a;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCurrentProfile(baseUrl)];
                case 2:
                    cachedCurrentProfile = _d.sent();
                    active_id = cachedCurrentProfile.active_id, objects = cachedCurrentProfile.objects;
                    if (!userId) {
                        userId = active_id;
                    }
                    if (!identity_id) {
                        identity_id = objects[0].identity;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    return [3 /*break*/, 4];
                case 4:
                    event.apply({
                        userId: userId,
                        identity_id: identity_id,
                    });
                    event._deprecatedSetProprtiesInRoot(['userId', 'identity_id']);
                    return [2 /*return*/];
            }
        });
    }); };
};
exports["default"] = createMaybeAddUserAndIdentityId;


/***/ }),

/***/ 17713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(81354);
var environmentParams = function (config) { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var conditionalParams, release;
    return __generator(this, function (_a) {
        conditionalParams = utils_1.isBrowser()
            ? {
                in_iframe: utils_1.isInIframe(),
                in_popup: utils_1.isInPopup(),
            }
            : {};
        release = config.get(['release']).release;
        event.apply(__assign(__assign({}, conditionalParams), { release: release, timestamp: Date.now() }));
        return [2 /*return*/];
    });
}); }; };
exports["default"] = environmentParams;


/***/ }),

/***/ 95898:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var eventDebugger = function () { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (false) {}
        console.info("\uD83E\uDDED Would have tracked event \"" + event.name + "\"", {
            name: event.name,
            _data: event.data,
            _context: event.context,
        });
        event.apply({
            __debugMode: true,
        });
        return [2 /*return*/];
    });
}); }; };
exports["default"] = eventDebugger;


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var toolbox_browser_fetch_1 = __webpack_require__(9197);
var utils_1 = __webpack_require__(81354);
var CONTEXT_ENV = utils_1.isBrowser() ? 'client' : 'server';
var sendToBackend = function (config) { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, service, _b, baseUrl, schemaName, url, _c, identity_id, utm_campaign, utm_content, utm_medium, utm_source, page_path, screen_size, iframe_flag, popup_flag, user_agent, url_address, query_string, fully_qualified_domain_name, width, height, url;
    var _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = config.get(['service', 'baseUrl']), service = _a.service, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
                if (!event.name.startsWith('schema:')) return [3 /*break*/, 2];
                schemaName = event.name.split(':')[1];
                url = baseUrl + "/api/v4/tracking/event/";
                _c = event.context, identity_id = _c.identity_id, utm_campaign = _c.utm_campaign, utm_content = _c.utm_content, utm_medium = _c.utm_medium, utm_source = _c.utm_source;
                page_path = null;
                screen_size = null;
                iframe_flag = null;
                popup_flag = null;
                user_agent = null;
                url_address = null;
                query_string = null;
                fully_qualified_domain_name = null;
                if (utils_1.isBrowser()) {
                    // for browser based events, like PageViewEvent, we want to collect common Avro event
                    // properties here prior to making the v4 Events API request to emit the event
                    fully_qualified_domain_name = window.location.hostname;
                    url_address = window.location.href;
                    page_path = window.location.pathname;
                    query_string = window.location.search;
                    user_agent = window.navigator.userAgent;
                    width = window.innerWidth ||
                        document.documentElement.clientWidth ||
                        document.body.clientWidth;
                    height = window.innerHeight ||
                        document.documentElement.clientHeight ||
                        document.body.clientHeight;
                    screen_size = width + "x" + height;
                    iframe_flag = utils_1.isInIframe();
                    popup_flag = utils_1.isInPopup();
                }
                return [4 /*yield*/, toolbox_browser_fetch_1.postJson(url, {
                        subject: schemaName,
                        properties: __assign(__assign({}, event.data), { identity_id: identity_id,
                            fully_qualified_domain_name: fully_qualified_domain_name,
                            url_address: url_address,
                            query_string: query_string,
                            page_path: page_path,
                            screen_size: screen_size,
                            iframe_flag: iframe_flag,
                            popup_flag: popup_flag,
                            user_agent: user_agent,
                            utm_content: utm_content,
                            utm_medium: utm_medium,
                            utm_source: utm_source,
                            utm_campaign: utm_campaign, 
                            // When all Avro events have adopted the latest data governance guidance for events,
                            // we can remove this nested `context` as top level fields are now preferred.
                            context: (_d = {},
                                _d[(service || '') + "__" + CONTEXT_ENV] = event.context,
                                _d) }),
                    })];
            case 1:
                _f.sent();
                return [3 /*break*/, 4];
            case 2:
                url = baseUrl + "/api/v3/events";
                return [4 /*yield*/, toolbox_browser_fetch_1.postJson(url, {
                        message: event.name,
                        data: __assign(__assign(__assign({}, event._deprecatedBuildProprtiesInRoot()), event.data), { _data: event.data, _context: (_e = {},
                                _e[(service || '') + "__" + CONTEXT_ENV] = event.context,
                                _e) }),
                    })];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports["default"] = sendToBackend;


/***/ }),

/***/ 58898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(81354);
var pushToDataLayer = function (data) {
    if (utils_1.isBrowser()) {
        // Provide empty array to push into to avoid errors in development
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }
};
var sendToGA = function () { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        pushToDataLayer(__assign(__assign(__assign({}, event.data), event._deprecatedBuildProprtiesInRoot()), { _data: event.data, _context: event.context, event: 'analyticsEvent', eventLabel: event.name }));
        return [2 /*return*/];
    });
}); }; };
exports["default"] = sendToGA;


/***/ }),

/***/ 21277:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var TrackingCookies_1 = __importDefault(__webpack_require__(63176));
var utmParamsMiddleware = function () { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var utmTrackParams;
    return __generator(this, function (_a) {
        utmTrackParams = TrackingCookies_1.default.retrieveUtms();
        if (lodash_1.isEmpty(lodash_1.filter(lodash_1.values(utmTrackParams)))) {
            return [2 /*return*/];
        }
        event.apply({
            utmTrackParams: {
                campaignName: utmTrackParams.utm_campaign,
                campaignSource: utmTrackParams.utm_source,
                campaignContent: utmTrackParams.utm_content,
                campaignMedium: utmTrackParams.utm_medium,
            },
        });
        event._deprecatedSetProprtiesInRoot(['utmTrackParams']);
        return [2 /*return*/];
    });
}); }; };
exports["default"] = utmParamsMiddleware;


/***/ }),

/***/ 3678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTrackingScope = exports.configureTracking = exports.trackingScopeApi = exports.TrackingScopeApi = void 0;
var DEFAULT_CONFIG = {
    required: false,
    default: '',
};
var TrackingScopeApi = /** @class */ (function () {
    function TrackingScopeApi() {
        this._trackingScopeParams = new Map();
    }
    TrackingScopeApi.prototype.add = function (key, config) {
        this._trackingScopeParams.set(key, __assign(__assign({}, DEFAULT_CONFIG), config));
        return this;
    };
    TrackingScopeApi.prototype.get = function (keys) {
        var _this = this;
        if (!keys) {
            keys = Array.from(this._trackingScopeParams.keys());
        }
        if (!Array.isArray(keys)) {
            keys = [keys];
        }
        return keys.reduce(function (prev, cur) {
            var _a;
            var config = _this._trackingScopeParams.get(cur);
            var value = config ? config.value || config.default : undefined;
            if (!value && config && config.required) {
                throw new Error("Tracking Scope param `" + cur + "` is required.");
            }
            return __assign(__assign({}, prev), (_a = {}, _a[cur] = value, _a));
        }, {});
    };
    TrackingScopeApi.prototype.set = function (definitions) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(definitions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (typeof value !== 'string') {
                    throw new Error("Tracking scope param `" + key + "` must be a string.");
                }
                var config = this._trackingScopeParams.get(key);
                // If the params hasn't been added or the value is falsy when required
                // bail out of setting it.
                if (!config)
                    continue;
                if (config.required && !config.default && !value) {
                    throw new Error("Tracking scope param `" + key + "` is required.");
                }
                this._trackingScopeParams.set(key, __assign(__assign({}, config), { value: value }));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    return TrackingScopeApi;
}());
exports.TrackingScopeApi = TrackingScopeApi;
// Setup our global scope values
exports.trackingScopeApi = new TrackingScopeApi();
exports.trackingScopeApi
    .add('service', { required: true })
    .add('release', {
    required: true,
    default: '<unknown>',
})
    .add('baseUrl', { required: false });
exports.configureTracking = function (definitions) {
    exports.trackingScopeApi.set(definitions);
};
exports.getTrackingScope = function (keys) { return exports.trackingScopeApi.get(keys); };


/***/ }),

/***/ 81354:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isInPopup = exports.isInIframe = exports.isBrowser = exports.isProduction = void 0;
// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
exports.isProduction = function () { return "production" === 'production'; };
exports.isBrowser = function () { return typeof window !== 'undefined'; };
exports.isInIframe = function () {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInPopup = function () {
    return exports.isBrowser() && !!window.opener;
};


/***/ }),

/***/ 84649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH; },
/* harmony export */   "Eg": function() { return /* binding */ UNIVERSAL_TOPBAR_CONDENSED_HEIGHT; },
/* harmony export */   "Qv": function() { return /* binding */ loginPath; },
/* harmony export */   "Z": function() { return /* binding */ UNIVERSAL_SIDEBAR_WIDTH; },
/* harmony export */   "au": function() { return /* binding */ signupPath; },
/* harmony export */   "fe": function() { return /* binding */ skipLinkHref; },
/* harmony export */   "ii": function() { return /* binding */ UNIVERSAL_NAV_ZINDEX; },
/* harmony export */   "w5": function() { return /* binding */ UNIVERSAL_TOPBAR_HEIGHT; }
/* harmony export */ });
/* unused harmony export UNIVERSAL_NAV_SUBMENU_ZINDEX */

const signupPath = '/sign-up/';
const loginPath = '/app/login';
const skipLinkHref = '#mainContent';
const UNIVERSAL_NAV_ZINDEX = 950;
const UNIVERSAL_NAV_SUBMENU_ZINDEX = UNIVERSAL_NAV_ZINDEX + 1;
const UNIVERSAL_TOPBAR_HEIGHT = 70;
const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 60;
const UNIVERSAL_SIDEBAR_WIDTH = 300;
const UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH = 70;
//# sourceMappingURL=index.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)


/***/ }),

/***/ 9992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var addParamsToUrl_1 = __importDefault(__webpack_require__(6961));
var removeFromUrl_1 = __importDefault(__webpack_require__(14112));
/**
 * Add the from url to a `from_url` parameter and tack it onto an href. That
 * way, if you navigate to that page, you can keep track of where you came from.
 * Currently used by the support form to send the problem url.
 *
 * @example
 *  addFromUrl('/app/dashboard', '/app/settings')
 *  > '/app/dashboard?from_url=/app/settings'
 */
var addFromUrl = function (targetHref, currentHref) {
    if (!currentHref || !targetHref)
        return targetHref !== null && targetHref !== void 0 ? targetHref : '';
    var currentUrl = removeFromUrl_1.default(String(currentHref));
    return addParamsToUrl_1.default(targetHref, { from_url: currentUrl });
};
exports["default"] = addFromUrl;


/***/ }),

/***/ 86213:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var normalizePathname_1 = __webpack_require__(68184);
/**
 * Adds location origin to a path to create a full URL
 *
 * @example
 *  addLocationOriginToUrl('/some/url/', 'https://www.zapier.ninja/')
 *  > 'https://www.zapier.ninja/some/url/'
 */
var addLocationOriginToUrl = function (url, origin) {
    // defaulting the argument would break imports on server-side
    if (typeof origin === 'undefined' && typeof window !== 'undefined') {
        origin = window.location.origin;
    }
    var httpProtocolMatch = url.match(/https?:\/\//);
    if (httpProtocolMatch && httpProtocolMatch.index === 0) {
        return url;
    }
    return "" + normalizePathname_1.stripTrailingSlash(origin) + url;
};
exports["default"] = addLocationOriginToUrl;


/***/ }),

/***/ 87368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var makeQueryString_1 = __importDefault(__webpack_require__(29938));
var addParamsToHash = function (url, params) {
    if (params === void 0) { params = {}; }
    var queryString = makeQueryString_1.default(params);
    return url + "#" + queryString;
};
exports["default"] = addParamsToHash;


/***/ }),

/***/ 6961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var adjustUrlParams_1 = __importDefault(__webpack_require__(63423));
var isEmptyString_1 = __importDefault(__webpack_require__(86877));
var sanitize = function (params, onlyTruthyParams) {
    return onlyTruthyParams ? lodash_1.omitBy(params, isEmptyString_1.default) : params;
};
/**
 * Takes an object and adds it as a query string to the given URL.
 * If there is already a query string with the URL, append the given
 * params to the query string.
 *
 * Optionally, filters out falsy params with `onlyTruthParams`
 */
var addParamsToUrl = function (url, params, onlyTruthyParams) {
    if (url === void 0) { url = ''; }
    if (params === void 0) { params = {}; }
    if (onlyTruthyParams === void 0) { onlyTruthyParams = false; }
    return adjustUrlParams_1.default(function (currentParams) { return (__assign(__assign({}, currentParams), sanitize(params, onlyTruthyParams))); }, url);
};
exports["default"] = addParamsToUrl;


/***/ }),

/***/ 50927:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var adjustUrlParams_1 = __importDefault(__webpack_require__(63423));
var isEmptyString_1 = __importDefault(__webpack_require__(86877));
var addTruthyParamsToUrl = function (url, params) {
    if (params === void 0) { params = {}; }
    var activeFields = lodash_1.omitBy(params, isEmptyString_1.default);
    return adjustUrlParams_1.default(function (currentParams) { return (__assign(__assign({}, currentParams), activeFields)); }, url);
};
exports["default"] = addTruthyParamsToUrl;


/***/ }),

/***/ 63423:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var extractParams_1 = __importDefault(__webpack_require__(2793));
var makeQueryString_1 = __importDefault(__webpack_require__(29938));
var splitUrl_1 = __importDefault(__webpack_require__(79849));
/**
 * Takes an `adjust` function that defines how to handle params from a URL's
 * querystring and returns the transformed URL.
 *
 * Ensures we remove the `?` if there are no query params in the adjusted URL.
 */
var adjustUrlParams = function (adjust, url) {
    var parts = splitUrl_1.default(url);
    var newParams = adjust(extractParams_1.default(url)) || {};
    var newUrl = parts.baseHref + "?" + makeQueryString_1.default(newParams);
    // Strip trailing `?` if there are no params
    return newUrl.replace(/\?$/, '');
};
exports["default"] = adjustUrlParams;


/***/ }),

/***/ 76233:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Removes extraneous slashes in a URL path.
 *
 * @example
 *  deduplicateSlashes('/app///path/to//stuff')
 *  > '/app/path/to/stuff'
 */
var deduplicateSlashes = function (url) { return url.replace(/\/{2,}/g, '/'); };
exports["default"] = deduplicateSlashes;


/***/ }),

/***/ 50214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var normalizePathname_1 = __webpack_require__(68184);
/**
 * Ensures that the given url ends with a trailing slash
 */
var ensureTrailingSlash = function (url) { return normalizePathname_1.stripTrailingSlash(url) + "/"; };
exports["default"] = ensureTrailingSlash;


/***/ }),

/***/ 2793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var querystring_1 = __importDefault(__webpack_require__(56642));
var lodash_1 = __webpack_require__(76635);
var splitUrl_1 = __importDefault(__webpack_require__(79849));
var filterEmptyKeys = function (obj) { return lodash_1.pickBy(obj, function (_, key) { return !!key; }); };
/**
 * Extracts query params from a URL and returns them as an object.
 *
 * Filters out empty params so the returned object has defined values.
 */
var extractParams = function (url) {
    if (url === void 0) { url = ''; }
    var params = querystring_1.default.parse(splitUrl_1.default(url).queryString);
    // Handles a params object that was extracted from an URL with a trailing `&`,
    // which would result in an empty key/value pair.
    return filterEmptyKeys(params);
};
exports["default"] = extractParams;


/***/ }),

/***/ 24402:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var querystring_1 = __importDefault(__webpack_require__(56642));
var lodash_1 = __webpack_require__(76635);
var splitHashParams_1 = __importDefault(__webpack_require__(79668));
var filterEmptyKeys = function (obj) { return lodash_1.pickBy(obj, function (_, key) { return !!key; }); };
var extractParamsFromHash = function (url) {
    if (url === void 0) { url = ''; }
    var params = querystring_1.default.parse(splitHashParams_1.default(url).queryString);
    // Handles a params object that was extracted from an URL with a trailing `&`,
    // which would result in an empty key/value pair.
    return filterEmptyKeys(params);
};
exports["default"] = extractParamsFromHash;


/***/ }),

/***/ 17712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var addFromUrl_1 = __webpack_require__(9992);
Object.defineProperty(exports, "addFromUrl", ({ enumerable: true, get: function () { return addFromUrl_1.default; } }));
var addParamsToUrl_1 = __webpack_require__(6961);
Object.defineProperty(exports, "addParamsToUrl", ({ enumerable: true, get: function () { return addParamsToUrl_1.default; } }));
var addParamsToHash_1 = __webpack_require__(87368);
Object.defineProperty(exports, "addParamsToHash", ({ enumerable: true, get: function () { return addParamsToHash_1.default; } }));
var addTruthyParamsToUrl_1 = __webpack_require__(50927);
Object.defineProperty(exports, "addTruthyParamsToUrl", ({ enumerable: true, get: function () { return addTruthyParamsToUrl_1.default; } }));
var extractParams_1 = __webpack_require__(2793);
Object.defineProperty(exports, "extractParams", ({ enumerable: true, get: function () { return extractParams_1.default; } }));
var extractParamsFromHash_1 = __webpack_require__(24402);
Object.defineProperty(exports, "extractParamsFromHash", ({ enumerable: true, get: function () { return extractParamsFromHash_1.default; } }));
var makeQueryString_1 = __webpack_require__(29938);
Object.defineProperty(exports, "makeQueryString", ({ enumerable: true, get: function () { return makeQueryString_1.default; } }));
var removeFromUrl_1 = __webpack_require__(14112);
Object.defineProperty(exports, "removeFromUrl", ({ enumerable: true, get: function () { return removeFromUrl_1.default; } }));
var removeParamsFromUrl_1 = __webpack_require__(45530);
Object.defineProperty(exports, "removeParamsFromUrl", ({ enumerable: true, get: function () { return removeParamsFromUrl_1.default; } }));
var splitUrl_1 = __webpack_require__(79849);
Object.defineProperty(exports, "splitUrl", ({ enumerable: true, get: function () { return splitUrl_1.default; } }));
var normalizePathname_1 = __webpack_require__(68184);
Object.defineProperty(exports, "stripLeadingSlash", ({ enumerable: true, get: function () { return normalizePathname_1.stripLeadingSlash; } }));
Object.defineProperty(exports, "stripTrailingSlash", ({ enumerable: true, get: function () { return normalizePathname_1.stripTrailingSlash; } }));
Object.defineProperty(exports, "normalizePathname", ({ enumerable: true, get: function () { return normalizePathname_1.default; } }));
var splitHashParams_1 = __webpack_require__(79668);
Object.defineProperty(exports, "splitHashParams", ({ enumerable: true, get: function () { return splitHashParams_1.default; } }));
var ensureTrailingSlash_1 = __webpack_require__(50214);
Object.defineProperty(exports, "ensureTrailingSlash", ({ enumerable: true, get: function () { return ensureTrailingSlash_1.default; } }));
var deduplicateSlashes_1 = __webpack_require__(76233);
Object.defineProperty(exports, "deduplicateSlashes", ({ enumerable: true, get: function () { return deduplicateSlashes_1.default; } }));
var isSubUrlOf_1 = __webpack_require__(14847);
Object.defineProperty(exports, "isSubUrlOf", ({ enumerable: true, get: function () { return isSubUrlOf_1.default; } }));
var isUrlDenylisted_1 = __webpack_require__(13333);
Object.defineProperty(exports, "isUrlDenylisted", ({ enumerable: true, get: function () { return isUrlDenylisted_1.default; } }));
var isUrlDenylisted_2 = __webpack_require__(13333);
Object.defineProperty(exports, "isUrlBlacklisted", ({ enumerable: true, get: function () { return isUrlDenylisted_2.default; } }));
var urlWithNext_1 = __webpack_require__(99694);
Object.defineProperty(exports, "urlWithNext", ({ enumerable: true, get: function () { return urlWithNext_1.default; } }));
var querystringToObj_1 = __webpack_require__(87539);
Object.defineProperty(exports, "querystringToObj", ({ enumerable: true, get: function () { return querystringToObj_1.default; } }));
var addLocationOriginToUrl_1 = __webpack_require__(86213);
Object.defineProperty(exports, "addLocationOriginToUrl", ({ enumerable: true, get: function () { return addLocationOriginToUrl_1.default; } }));


/***/ }),

/***/ 14847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var normalizePathname_1 = __importDefault(__webpack_require__(68184));
var isSubUrlOf = function (url, maybeSubUrl) {
    var cleanUrl = normalizePathname_1.default(url || '');
    var cleanSubUrl = normalizePathname_1.default(maybeSubUrl || '');
    return cleanUrl.indexOf(cleanSubUrl) > -1;
};
exports["default"] = isSubUrlOf;


/***/ }),

/***/ 13333:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var isSubUrlOf_1 = __importDefault(__webpack_require__(14847));
/**
 * Expects an array of paths that are denylisted.
 *
 * @example
 *  isUrlDenylisted('/developer/builder', ['/developer/']);
 *  > true
 */
var isUrlDenylisted = function (url, denylistedRoutePrefixes) {
    return denylistedRoutePrefixes.some(function (path) { return isSubUrlOf_1.default(url, path); });
};
exports["default"] = isUrlDenylisted;


/***/ }),

/***/ 29938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var querystring_1 = __importDefault(__webpack_require__(56642));
var lodash_1 = __webpack_require__(76635);
var makeQueryString = function (oldParams, mergeParams) {
    var newParams = lodash_1.extend({}, oldParams, mergeParams);
    return querystring_1.default.stringify(newParams);
};
exports["default"] = makeQueryString;


/***/ }),

/***/ 68184:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stripTrailingSlash = exports.stripLeadingSlash = void 0;
var lodash_1 = __webpack_require__(76635);
var splitHashParams_1 = __importDefault(__webpack_require__(79668));
var splitUrl_1 = __importDefault(__webpack_require__(79849));
var stripFromString = function (regexOrString, string) {
    if (string === void 0) { string = ''; }
    return string.replace(regexOrString, '');
};
exports.stripLeadingSlash = lodash_1.partial(stripFromString, /^\/+/);
exports.stripTrailingSlash = lodash_1.partial(stripFromString, /\/+$/);
var stripTerminalSlashes = lodash_1.flow(exports.stripLeadingSlash, exports.stripTrailingSlash);
/**
 * Strips possible leading and trailing slashes and
 * then adds them back to ensure they're always there
 * and not doubled up. It's important to have the slashes
 * to prevent something like `/dashboard` from matching
 * `/dashboard-items` which is likely a completely
 * different route.
 *
 * If the `retainHashOrQuery` argument is passed as truthy, then it
 * will retain the hash or query string attached to the original `pathname`.
 */
var normalizePathname = function (pathname, retainHashOrQuery) {
    if (retainHashOrQuery === void 0) { retainHashOrQuery = false; }
    var query = splitUrl_1.default(pathname);
    var hash = splitHashParams_1.default(query.baseHref);
    var cleanPath = "/" + stripTerminalSlashes(hash.baseHref) + "/";
    if (retainHashOrQuery) {
        var hashStr = lodash_1.isEmpty(hash.queryString) ? '' : "#" + hash.queryString;
        var queryStr = lodash_1.isEmpty(query.queryString) ? '' : "?" + query.queryString;
        return "" + cleanPath + queryStr + hashStr;
    }
    return cleanPath;
};
exports["default"] = normalizePathname;


/***/ }),

/***/ 87539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var querystring_1 = __importDefault(__webpack_require__(56642));
var querystringToObj = function (query) {
    var _a, _b;
    var qs = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '';
    if (qs.startsWith('?')) {
        qs = qs.substr(1);
    }
    return querystring_1.default.parse(qs);
};
exports["default"] = querystringToObj;


/***/ }),

/***/ 14112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var splitUrl_1 = __importDefault(__webpack_require__(79849));
/**
 * Remove the `from_url` query parameter from a url.
 *
 * Useful if you're adding `from_url` so it doesn't keep appending.
 */
var removeFromUrl = function (href) {
    if (!href || href.indexOf('?') < 0) {
        return href;
    }
    var _a = splitUrl_1.default(href), baseHref = _a.baseHref, queryString = _a.queryString;
    var queryStringParts = queryString.split('&');
    var cleanQueryStringParts = queryStringParts.filter(function (part) { return !part.startsWith('from_url='); });
    var cleanQueryString = cleanQueryStringParts.join('&');
    if (cleanQueryString === '') {
        return baseHref;
    }
    return baseHref + "?" + cleanQueryString;
};
exports["default"] = removeFromUrl;


/***/ }),

/***/ 45530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lodash_1 = __webpack_require__(76635);
var adjustUrlParams_1 = __importDefault(__webpack_require__(63423));
var removeParamsFromUrl = function (url, paramsToRemove) {
    return adjustUrlParams_1.default(function (currentParams) { return lodash_1.omit(currentParams, paramsToRemove !== null && paramsToRemove !== void 0 ? paramsToRemove : []); }, url);
};
exports["default"] = removeParamsFromUrl;


/***/ }),

/***/ 79668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var splitUrlPiece_1 = __importDefault(__webpack_require__(66338));
/**
 * Splits a URL in half by a `#`
 */
var splitHashParams = splitUrlPiece_1.default.bind(null, '#');
exports["default"] = splitHashParams;


/***/ }),

/***/ 79849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var splitUrlPiece_1 = __importDefault(__webpack_require__(66338));
/**
 * Splits a URL in half by querystring '?'
 */
var splitUrl = splitUrlPiece_1.default.bind(null, '?');
exports["default"] = splitUrl;


/***/ }),

/***/ 66338:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var splitUrlPiece = function (splitter, url) {
    if (url === void 0) { url = ''; }
    if (url.indexOf(splitter) < 0) {
        url = "" + url + splitter;
    }
    var splitterIndex = url.indexOf(splitter);
    return {
        baseHref: url.substring(0, splitterIndex),
        queryString: url.substring(splitterIndex + 1),
    };
};
exports["default"] = splitUrlPiece;


/***/ }),

/***/ 99694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var addTruthyParamsToUrl_1 = __importDefault(__webpack_require__(50927));
/** Append `next` query parameter to a URL, if provided. */
var urlWithNext = function (url, next) {
    return addTruthyParamsToUrl_1.default(url, { next: next });
};
exports["default"] = urlWithNext;


/***/ }),

/***/ 86877:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var isEmptyString = function (string) { return !string || /^\s*$/.test(string); };
exports["default"] = isEmptyString;


/***/ }),

/***/ 5792:
/***/ (function(module) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ 96279:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 19562:
/***/ (function(module) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ 4261:
/***/ (function(module) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),

/***/ 90071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),

/***/ 23210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(75683)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),

/***/ 96399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getISOYear = __webpack_require__(93242)
var setISOYear = __webpack_require__(92155)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),

/***/ 75683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),

/***/ 63063:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(75683)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),

/***/ 51822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var getDaysInMonth = __webpack_require__(70119)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),

/***/ 22995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMonths = __webpack_require__(51822)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),

/***/ 74681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(75683)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),

/***/ 70495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addDays = __webpack_require__(90071)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),

/***/ 35661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMonths = __webpack_require__(51822)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),

/***/ 40848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),

/***/ 76278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),

/***/ 32721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),

/***/ 6294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),

/***/ 53014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),

/***/ 6144:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),

/***/ 89378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(86891)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),

/***/ 70089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getISOYear = __webpack_require__(93242)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),

/***/ 64441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),

/***/ 5251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getQuarter = __webpack_require__(70790)
var parse = __webpack_require__(18838)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),

/***/ 71959:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfWeek = __webpack_require__(70351)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),

/***/ 33356:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),

/***/ 61189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var differenceInCalendarDays = __webpack_require__(6144)
var compareAsc = __webpack_require__(6294)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),

/***/ 25855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(84698)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),

/***/ 593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var differenceInCalendarISOYears = __webpack_require__(70089)
var compareAsc = __webpack_require__(6294)
var subISOYears = __webpack_require__(1567)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),

/***/ 84698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),

/***/ 81429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(84698)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),

/***/ 81262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var differenceInCalendarMonths = __webpack_require__(64441)
var compareAsc = __webpack_require__(6294)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),

/***/ 23499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(81262)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),

/***/ 93747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(84698)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),

/***/ 49851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var differenceInDays = __webpack_require__(61189)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),

/***/ 34331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var differenceInCalendarYears = __webpack_require__(33356)
var compareAsc = __webpack_require__(6294)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),

/***/ 16320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareDesc = __webpack_require__(53014)
var parse = __webpack_require__(18838)
var differenceInSeconds = __webpack_require__(93747)
var differenceInMonths = __webpack_require__(81262)
var enLocale = __webpack_require__(15665)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),

/***/ 14163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareDesc = __webpack_require__(53014)
var parse = __webpack_require__(18838)
var differenceInSeconds = __webpack_require__(93747)
var enLocale = __webpack_require__(15665)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),

/***/ 51607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var distanceInWords = __webpack_require__(16320)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),

/***/ 99752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),

/***/ 9297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),

/***/ 98318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),

/***/ 47578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var endOfWeek = __webpack_require__(81762)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),

/***/ 14340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getISOYear = __webpack_require__(93242)
var startOfISOWeek = __webpack_require__(86891)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),

/***/ 1572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),

/***/ 63472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),

/***/ 12902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),

/***/ 60102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),

/***/ 57060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var endOfDay = __webpack_require__(9297)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),

/***/ 82593:
/***/ (function(module) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),

/***/ 81762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),

/***/ 39272:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),

/***/ 63994:
/***/ (function(module) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),

/***/ 55695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(93264)
var getISOWeek = __webpack_require__(49709)
var getISOYear = __webpack_require__(93242)
var parse = __webpack_require__(18838)
var isValid = __webpack_require__(7708)
var enLocale = __webpack_require__(15665)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),

/***/ 99821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),

/***/ 446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),

/***/ 93264:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var startOfYear = __webpack_require__(67172)
var differenceInCalendarDays = __webpack_require__(6144)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),

/***/ 70119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),

/***/ 8949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isLeapYear = __webpack_require__(42740)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),

/***/ 29595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),

/***/ 37695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),

/***/ 49709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var startOfISOWeek = __webpack_require__(86891)
var startOfISOYear = __webpack_require__(63717)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),

/***/ 48801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(63717)
var addWeeks = __webpack_require__(70495)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),

/***/ 93242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var startOfISOWeek = __webpack_require__(86891)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),

/***/ 27712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),

/***/ 89396:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),

/***/ 53622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),

/***/ 49070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),

/***/ 70790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),

/***/ 67762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),

/***/ 15931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),

/***/ 81706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),

/***/ 25155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(90071),
  addHours: __webpack_require__(23210),
  addISOYears: __webpack_require__(96399),
  addMilliseconds: __webpack_require__(75683),
  addMinutes: __webpack_require__(63063),
  addMonths: __webpack_require__(51822),
  addQuarters: __webpack_require__(22995),
  addSeconds: __webpack_require__(74681),
  addWeeks: __webpack_require__(70495),
  addYears: __webpack_require__(35661),
  areRangesOverlapping: __webpack_require__(40848),
  closestIndexTo: __webpack_require__(76278),
  closestTo: __webpack_require__(32721),
  compareAsc: __webpack_require__(6294),
  compareDesc: __webpack_require__(53014),
  differenceInCalendarDays: __webpack_require__(6144),
  differenceInCalendarISOWeeks: __webpack_require__(89378),
  differenceInCalendarISOYears: __webpack_require__(70089),
  differenceInCalendarMonths: __webpack_require__(64441),
  differenceInCalendarQuarters: __webpack_require__(5251),
  differenceInCalendarWeeks: __webpack_require__(71959),
  differenceInCalendarYears: __webpack_require__(33356),
  differenceInDays: __webpack_require__(61189),
  differenceInHours: __webpack_require__(25855),
  differenceInISOYears: __webpack_require__(593),
  differenceInMilliseconds: __webpack_require__(84698),
  differenceInMinutes: __webpack_require__(81429),
  differenceInMonths: __webpack_require__(81262),
  differenceInQuarters: __webpack_require__(23499),
  differenceInSeconds: __webpack_require__(93747),
  differenceInWeeks: __webpack_require__(49851),
  differenceInYears: __webpack_require__(34331),
  distanceInWords: __webpack_require__(16320),
  distanceInWordsStrict: __webpack_require__(14163),
  distanceInWordsToNow: __webpack_require__(51607),
  eachDay: __webpack_require__(99752),
  endOfDay: __webpack_require__(9297),
  endOfHour: __webpack_require__(98318),
  endOfISOWeek: __webpack_require__(47578),
  endOfISOYear: __webpack_require__(14340),
  endOfMinute: __webpack_require__(1572),
  endOfMonth: __webpack_require__(63472),
  endOfQuarter: __webpack_require__(12902),
  endOfSecond: __webpack_require__(60102),
  endOfToday: __webpack_require__(57060),
  endOfTomorrow: __webpack_require__(82593),
  endOfWeek: __webpack_require__(81762),
  endOfYear: __webpack_require__(39272),
  endOfYesterday: __webpack_require__(63994),
  format: __webpack_require__(55695),
  getDate: __webpack_require__(99821),
  getDay: __webpack_require__(446),
  getDayOfYear: __webpack_require__(93264),
  getDaysInMonth: __webpack_require__(70119),
  getDaysInYear: __webpack_require__(8949),
  getHours: __webpack_require__(29595),
  getISODay: __webpack_require__(37695),
  getISOWeek: __webpack_require__(49709),
  getISOWeeksInYear: __webpack_require__(48801),
  getISOYear: __webpack_require__(93242),
  getMilliseconds: __webpack_require__(27712),
  getMinutes: __webpack_require__(89396),
  getMonth: __webpack_require__(53622),
  getOverlappingDaysInRanges: __webpack_require__(49070),
  getQuarter: __webpack_require__(70790),
  getSeconds: __webpack_require__(67762),
  getTime: __webpack_require__(15931),
  getYear: __webpack_require__(81706),
  isAfter: __webpack_require__(15219),
  isBefore: __webpack_require__(44207),
  isDate: __webpack_require__(85990),
  isEqual: __webpack_require__(16506),
  isFirstDayOfMonth: __webpack_require__(61648),
  isFriday: __webpack_require__(7614),
  isFuture: __webpack_require__(84684),
  isLastDayOfMonth: __webpack_require__(90021),
  isLeapYear: __webpack_require__(42740),
  isMonday: __webpack_require__(88850),
  isPast: __webpack_require__(60634),
  isSameDay: __webpack_require__(19831),
  isSameHour: __webpack_require__(5457),
  isSameISOWeek: __webpack_require__(60018),
  isSameISOYear: __webpack_require__(59870),
  isSameMinute: __webpack_require__(6808),
  isSameMonth: __webpack_require__(35641),
  isSameQuarter: __webpack_require__(36167),
  isSameSecond: __webpack_require__(73253),
  isSameWeek: __webpack_require__(10127),
  isSameYear: __webpack_require__(97585),
  isSaturday: __webpack_require__(42220),
  isSunday: __webpack_require__(31607),
  isThisHour: __webpack_require__(84282),
  isThisISOWeek: __webpack_require__(77023),
  isThisISOYear: __webpack_require__(58449),
  isThisMinute: __webpack_require__(52418),
  isThisMonth: __webpack_require__(10178),
  isThisQuarter: __webpack_require__(13474),
  isThisSecond: __webpack_require__(3062),
  isThisWeek: __webpack_require__(52731),
  isThisYear: __webpack_require__(69534),
  isThursday: __webpack_require__(19649),
  isToday: __webpack_require__(63592),
  isTomorrow: __webpack_require__(56317),
  isTuesday: __webpack_require__(73626),
  isValid: __webpack_require__(7708),
  isWednesday: __webpack_require__(85166),
  isWeekend: __webpack_require__(69562),
  isWithinRange: __webpack_require__(4108),
  isYesterday: __webpack_require__(44407),
  lastDayOfISOWeek: __webpack_require__(58026),
  lastDayOfISOYear: __webpack_require__(82888),
  lastDayOfMonth: __webpack_require__(96208),
  lastDayOfQuarter: __webpack_require__(25399),
  lastDayOfWeek: __webpack_require__(37508),
  lastDayOfYear: __webpack_require__(86205),
  max: __webpack_require__(20476),
  min: __webpack_require__(35103),
  parse: __webpack_require__(18838),
  setDate: __webpack_require__(17430),
  setDay: __webpack_require__(38377),
  setDayOfYear: __webpack_require__(90431),
  setHours: __webpack_require__(10057),
  setISODay: __webpack_require__(40381),
  setISOWeek: __webpack_require__(16829),
  setISOYear: __webpack_require__(92155),
  setMilliseconds: __webpack_require__(61155),
  setMinutes: __webpack_require__(28609),
  setMonth: __webpack_require__(39621),
  setQuarter: __webpack_require__(89197),
  setSeconds: __webpack_require__(57869),
  setYear: __webpack_require__(43773),
  startOfDay: __webpack_require__(22635),
  startOfHour: __webpack_require__(86411),
  startOfISOWeek: __webpack_require__(86891),
  startOfISOYear: __webpack_require__(63717),
  startOfMinute: __webpack_require__(96079),
  startOfMonth: __webpack_require__(6027),
  startOfQuarter: __webpack_require__(33805),
  startOfSecond: __webpack_require__(64429),
  startOfToday: __webpack_require__(11114),
  startOfTomorrow: __webpack_require__(60056),
  startOfWeek: __webpack_require__(70351),
  startOfYear: __webpack_require__(67172),
  startOfYesterday: __webpack_require__(13761),
  subDays: __webpack_require__(36254),
  subHours: __webpack_require__(56333),
  subISOYears: __webpack_require__(1567),
  subMilliseconds: __webpack_require__(73073),
  subMinutes: __webpack_require__(63401),
  subMonths: __webpack_require__(90590),
  subQuarters: __webpack_require__(5151),
  subSeconds: __webpack_require__(77982),
  subWeeks: __webpack_require__(75997),
  subYears: __webpack_require__(58888)
}


/***/ }),

/***/ 15219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),

/***/ 44207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),

/***/ 85990:
/***/ (function(module) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),

/***/ 16506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),

/***/ 61648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),

/***/ 7614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),

/***/ 84684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),

/***/ 90021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var endOfDay = __webpack_require__(9297)
var endOfMonth = __webpack_require__(63472)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),

/***/ 42740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),

/***/ 88850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),

/***/ 60634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),

/***/ 19831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),

/***/ 5457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfHour = __webpack_require__(86411)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),

/***/ 60018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameWeek = __webpack_require__(10127)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),

/***/ 59870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(63717)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),

/***/ 6808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfMinute = __webpack_require__(96079)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),

/***/ 35641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),

/***/ 36167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(33805)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),

/***/ 73253:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfSecond = __webpack_require__(64429)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),

/***/ 10127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfWeek = __webpack_require__(70351)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),

/***/ 97585:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),

/***/ 42220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),

/***/ 31607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),

/***/ 84282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameHour = __webpack_require__(5457)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),

/***/ 77023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(60018)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),

/***/ 58449:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(59870)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),

/***/ 52418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameMinute = __webpack_require__(6808)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),

/***/ 10178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameMonth = __webpack_require__(35641)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),

/***/ 13474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(36167)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),

/***/ 3062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameSecond = __webpack_require__(73253)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),

/***/ 52731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameWeek = __webpack_require__(10127)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),

/***/ 69534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSameYear = __webpack_require__(97585)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),

/***/ 19649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),

/***/ 63592:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),

/***/ 56317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),

/***/ 73626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),

/***/ 7708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isDate = __webpack_require__(85990)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),

/***/ 85166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),

/***/ 69562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),

/***/ 4108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),

/***/ 44407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),

/***/ 58026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(37508)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),

/***/ 82888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getISOYear = __webpack_require__(93242)
var startOfISOWeek = __webpack_require__(86891)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),

/***/ 96208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),

/***/ 25399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),

/***/ 37508:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),

/***/ 86205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),

/***/ 80088:
/***/ (function(module) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),

/***/ 55433:
/***/ (function(module) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),

/***/ 81146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(80088)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),

/***/ 15665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(55433)
var buildFormatLocale = __webpack_require__(81146)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),

/***/ 20476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),

/***/ 35103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),

/***/ 18838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(4261)
var isDate = __webpack_require__(85990)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),

/***/ 17430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),

/***/ 38377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var addDays = __webpack_require__(90071)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),

/***/ 90431:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),

/***/ 10057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),

/***/ 40381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var addDays = __webpack_require__(90071)
var getISODay = __webpack_require__(37695)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),

/***/ 16829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var getISOWeek = __webpack_require__(49709)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),

/***/ 92155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var startOfISOYear = __webpack_require__(63717)
var differenceInCalendarDays = __webpack_require__(6144)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),

/***/ 61155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),

/***/ 28609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),

/***/ 39621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var getDaysInMonth = __webpack_require__(70119)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),

/***/ 89197:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)
var setMonth = __webpack_require__(39621)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),

/***/ 57869:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),

/***/ 43773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),

/***/ 22635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),

/***/ 86411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),

/***/ 86891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfWeek = __webpack_require__(70351)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),

/***/ 63717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getISOYear = __webpack_require__(93242)
var startOfISOWeek = __webpack_require__(86891)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),

/***/ 96079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),

/***/ 6027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),

/***/ 33805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),

/***/ 64429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),

/***/ 11114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var startOfDay = __webpack_require__(22635)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),

/***/ 60056:
/***/ (function(module) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),

/***/ 70351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),

/***/ 67172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18838)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),

/***/ 13761:
/***/ (function(module) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),

/***/ 36254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addDays = __webpack_require__(90071)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),

/***/ 56333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addHours = __webpack_require__(23210)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),

/***/ 1567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addISOYears = __webpack_require__(96399)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),

/***/ 73073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(75683)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),

/***/ 63401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMinutes = __webpack_require__(63063)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),

/***/ 90590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addMonths = __webpack_require__(51822)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),

/***/ 5151:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addQuarters = __webpack_require__(22995)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),

/***/ 77982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addSeconds = __webpack_require__(74681)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),

/***/ 75997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addWeeks = __webpack_require__(70495)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),

/***/ 58888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var addYears = __webpack_require__(35661)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),

/***/ 57490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ downshift_esm; }
});

// UNUSED EXPORTS: resetIdCounter, useSelect

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(32222);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
;// CONCATENATED MODULE: ../../node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ function index_module(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../../node_modules/downshift/dist/downshift.esm.js









var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (node === null) {
    return;
  }

  var actions = index_module(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */


function resetIdCounter() {
  idCounter = 0;
}
/**
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage(_ref2) {
  var isOpen = _ref2.isOpen,
      selectedItem = _ref2.selectedItem,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount,
      itemToString = _ref2.itemToString;

  if (!isOpen) {
    return selectedItem ? itemToString(selectedItem) : '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {
  // then we assume this is react
  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {
  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount) {
  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = itemsLastIndex;
  } else if (newIndex > itemsLastIndex) {
    newIndex = 0;
  }

  return newIndex;
}

var cleanupStatus = debounce(function () {
  getStatusDiv().textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus();
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown =  false ? 0 : 0;
var mouseUp =  false ? 0 : 1;
var itemMouseEnter =  false ? 0 : 2;
var keyDownArrowUp =  false ? 0 : 3;
var keyDownArrowDown =  false ? 0 : 4;
var keyDownEscape =  false ? 0 : 5;
var keyDownEnter =  false ? 0 : 6;
var keyDownHome =  false ? 0 : 7;
var keyDownEnd =  false ? 0 : 8;
var clickItem =  false ? 0 : 9;
var blurInput =  false ? 0 : 10;
var changeInput =  false ? 0 : 11;
var keyDownSpaceButton =  false ? 0 : 12;
var clickButton =  false ? 0 : 13;
var blurButton =  false ? 0 : 14;
var controlledPropUpdatedSelectedItem =  false ? 0 : 15;
var touchEnd =  false ? 0 : 16;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var Downshift =
/*#__PURE__*/
function () {
  var Downshift =
  /*#__PURE__*/
  function (_Component) {
    (0,inheritsLoose/* default */.Z)(Downshift, _Component);

    function Downshift(_props) {
      var _this = _Component.call(this, _props) || this;

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState((0,esm_extends/* default */.Z)({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState((0,esm_extends/* default */.Z)({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, (0,esm_extends/* default */.Z)({}, _this.getStateAndHelpers(), {}, stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed

          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!_this.isControlledProp(key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, (0,esm_extends/* default */.Z)({}, _this.getStateAndHelpers(), {}, newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["refKey", "ref"]);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                _this2.setHighlightedIndex(getNextWrappingIndex(1, _this2.getState().highlightedIndex, itemCount), {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                _this3.setHighlightedIndex(getNextWrappingIndex(-1, _this3.getState().highlightedIndex, itemCount), {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset({
            type: keyDownEscape,
            selectedItem: null,
            inputValue: ''
          });
        }
      };
      _this.buttonKeyDownHandlers = (0,esm_extends/* default */.Z)({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = (0,esm_extends/* default */.Z)({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          this.highlightFirstOrLastIndex(event, true, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          this.highlightFirstOrLastIndex(event, false, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick,
            onPress = _ref3.onPress,
            onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);

        var _this$getState3 = _this.getState(),
            isOpen = _this$getState3.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return (0,esm_extends/* default */.Z)({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, {}, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if ( _this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (false) {} else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
              _this.reset({
                type: blurButton
              });
            }
        });
      };

      _this.getLabelProps = function (props) {
        return (0,esm_extends/* default */.Z)({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput,
            onChangeText = _ref4.onChangeText,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        onChangeKey = 'onChange';

        var _this$getState4 = _this.getState(),
            inputValue = _this$getState4.inputValue,
            isOpen = _this$getState4.isOpen,
            highlightedIndex = _this$getState4.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        /* istanbul ignore if (react-native) */


        return (0,esm_extends/* default */.Z)({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, {}, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref5, ["refKey", "ref"]);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick,
            onPress = _ref7.onPress,
            index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ?  true ?
        /* istanbul ignore next */
        undefined : 0 : _ref7$item,
            rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return (0,esm_extends/* default */.Z)({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, {}, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return (0,esm_extends/* default */.Z)({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return (0,esm_extends/* default */.Z)({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, {}, otherStateToSet);
        }, function () {
          var _this$getState5 = _this.getState(),
              isOpen = _this$getState5.isOpen,
              highlightedIndex = _this$getState5.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage((0,esm_extends/* default */.Z)({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;

    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * This will perform a shallow merge of the given state object
     * with the state coming from props
     * (for the controlled component scenario)
     * This is used in state updater functions so they're referencing
     * the right state regardless of where it comes from.
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState(stateToMerge) {
      var _this4 = this;

      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return Object.keys(stateToMerge).reduce(function (state, key) {
        state[key] = _this4.isControlledProp(key) ? _this4.props[key] : stateToMerge[key];
        return state;
      }, {});
    }
    /**
     * This determines whether a prop is a "controlled prop" meaning it is
     * state which is controlled by the outside of this component rather
     * than within this component.
     * @param {String} key the key to check
     * @return {Boolean} whether it is a controlled controlled prop
     */
    ;

    _proto.isControlledProp = function isControlledProp(key) {
      return this.props[key] !== undefined;
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var itemCount = this.getItemCount();

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, this.getState().highlightedIndex, itemCount);
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.highlightFirstOrLastIndex = function highlightFirstOrLastIndex(event, first, otherStateToSet) {
      var itemsLastIndex = this.getItemCount() - 1;

      if (itemsLastIndex < 0 || !this.getState().isOpen) {
        return;
      }

      event.preventDefault();
      this.setHighlightedIndex(first ? 0 : itemsLastIndex, otherStateToSet);
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState6 = this.getState(),
          highlightedIndex = _this$getState6.highlightedIndex,
          inputValue = _this$getState6.inputValue,
          selectedItem = _this$getState6.selectedItem,
          isOpen = _this$getState6.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this5 = this;

      /* istanbul ignore if (react-native) */
      if (false) {}
      /* istanbul ignore if (react-native) */


      {
        var targetWithinDownshift = function (target, checkActiveElement) {
          if (checkActiveElement === void 0) {
            checkActiveElement = true;
          }

          var document = _this5.props.environment.document;
          return [_this5._rootNode, _this5._menuNode].some(function (contextNode) {
            return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document.activeElement));
          });
        }; // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.


        var onMouseDown = function () {
          _this5.isMouseDown = true;
        };

        var onMouseUp = function (event) {
          _this5.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target);

          if (!contextWithinDownshift && _this5.getState().isOpen) {
            _this5.reset({
              type: mouseUp
            }, function () {
              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function () {
          _this5.isTouchMove = false;
        };

        var onTouchMove = function () {
          _this5.isTouchMove = true;
        };

        var onTouchEnd = function (event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, false);

          if (!_this5.isTouchMove && !contextWithinDownshift && _this5.getState().isOpen) {
            _this5.reset({
              type: touchEnd
            }, function () {
              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this5.internalClearTimeouts();

          _this5.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      return scrollWhenOpen || currentHighlightedIndex !== prevHighlightedIndex;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      this.updateStatus();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (false) {}

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return (0,react.cloneElement)(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (false) {}
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(react.Component);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (false) {}

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === 'undefined'
    /* istanbul ignore next (ssr) */
    ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes;
  return Downshift;
}();

 false ? 0 : void 0;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

function validateControlledUnchanged(prevProps, nextProps) {
  var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  ['selectedItem', 'isOpen', 'inputValue', 'highlightedIndex'].forEach(function (propKey) {
    if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
    } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
    }
  });
}

function getElementIds(generateDefaultId, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      id = _ref.id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId;

  var uniqueId = id === undefined ? "downshift-" + generateDefaultId() : id;
  return {
    labelId: labelId || uniqueId + "-label",
    menuId: menuId || uniqueId + "-menu",
    getItemId: getItemId || function (index) {
      return uniqueId + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || uniqueId + "-toggle-button"
  };
}

function getNextWrappingIndex$1(moveAmount, baseIndex, itemsLength, circular) {
  if (baseIndex === -1) {
    return moveAmount > 0 ? 0 : itemsLength - 1;
  }

  var nextIndex = baseIndex + moveAmount;

  if (nextIndex < 0) {
    return circular ? itemsLength - 1 : 0;
  }

  if (nextIndex >= itemsLength) {
    return circular ? 0 : itemsLength - 1;
  }

  return nextIndex;
}

function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToStringParam) {
  var newHighlightedIndex = -1;
  var itemStrings = items.map(function (item) {
    return itemToStringParam(item).toLowerCase();
  });
  var startPosition = highlightedIndex + 1;
  newHighlightedIndex = itemStrings.slice(startPosition).findIndex(function (itemString) {
    return itemString.startsWith(keysSoFar);
  });

  if (newHighlightedIndex > -1) {
    return newHighlightedIndex + startPosition;
  } else {
    return itemStrings.slice(0, startPosition).findIndex(function (itemString) {
      return itemString.startsWith(keysSoFar);
    });
  }
}

function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    // eslint-disable-next-line no-param-reassign
    prevState[key] = key in props ? props[key] : state[key];
    return prevState;
  }, {});
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function getPropTypesValidator(caller, propTypes) {
  // istanbul ignore next
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    Object.entries(propTypes).forEach(function (_ref2) {
      var key = _ref2[0];
      PropTypes.checkPropTypes(propTypes, options, key, caller.name);
    });
  };
}

function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function invokeOnChangeHandler(propKey, props, state, changes) {
  var handler = "on" + capitalizeString(propKey) + "Change";

  if (props[handler] && changes[propKey] !== undefined && changes[propKey] !== state[propKey]) {
    props[handler](changes);
  }
}

function callOnChangeProps(props, state, changes) {
  Object.keys(state).forEach(function (stateKey) {
    invokeOnChangeHandler(stateKey, props, state, changes);
  });

  if (props.onStateChange && changes !== undefined) {
    props.onStateChange(changes);
  }
}

function useEnhancedReducer(reducer, initialState, props) {
  var enhancedReducer = (0,react.useCallback)(function (state, action) {
    state = getState(state, action.props);
    var stateReducer = action.props.stateReducer;
    var changes = reducer(state, action);
    var newState = stateReducer(state, (0,esm_extends/* default */.Z)({}, action, {
      changes: changes
    }));
    callOnChangeProps(action.props, state, newState);
    return newState;
  }, [reducer]);

  var _useReducer = (0,react.useReducer)(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return [getState(state, props), dispatch];
}

var lastId = 0; // istanbul ignore next

var genId = function () {
  return ++lastId;
};
/**
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 * Taken from @reach/auto-id
 * @see https://github.com/reach/reach-ui/blob/6e9dbcf716d5c9a3420e062e5bac1ac4671d01cb/packages/auto-id/src/index.js
 */
// istanbul ignore next


function useId() {
  var _useState = (0,react.useState)(null),
      id = _useState[0],
      setId = _useState[1];

  (0,react.useEffect)(function () {
    return setId(genId());
  }, []);
  return id;
}
/**
 * Checks if nextElement receives focus after the blur event.
 *
 * @param {FocusEvent} event The blur event.
 * @param {Element} nextElement The element to check that receive focus next.
 * @returns {boolean} If the focus lands on nextElement.
 */


function focusLandsOnElement(event, nextElement) {
  return event.relatedTarget === nextElement || // https://github.com/downshift-js/downshift/issues/832 - workaround for Firefox.
  event.nativeEvent && (nextElement === event.nativeEvent.explicitOriginalTarget || nextElement.contains(event.nativeEvent.explicitOriginalTarget));
}

var defaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null
};

function getA11yStatusMessage$1(_ref) {
  var isOpen = _ref.isOpen,
      items = _ref.items;

  if (!items) {
    return '';
  }

  var resultCount = items.length;

  if (isOpen) {
    if (resultCount === 0) {
      return 'No results are available';
    }

    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}

function getA11ySelectionMessage(_ref2) {
  var selectedItem = _ref2.selectedItem,
      itemToString = _ref2.itemToString;
  return itemToString(selectedItem) + " has been selected.";
}

function getHighlightedIndexOnOpen(props, state, offset) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex; // initialHighlightedIndex will give value to highlightedIndex on initial state only.

  if (initialHighlightedIndex !== undefined && highlightedIndex > -1) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex$1(offset, items.indexOf(selectedItem), items.length, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}

function getDefaultValue(props, propKey) {
  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}

function getInitialValue(props, propKey) {
  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue(props, propKey);
}

function getInitialState(props) {
  var selectedItem = getInitialValue(props, 'selectedItem');
  var highlightedIndex = getInitialValue(props, 'highlightedIndex');
  var isOpen = getInitialValue(props, 'isOpen');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    keysSoFar: ''
  };
}

var propTypes = {
  items: (prop_types_default()).array.isRequired,
  itemToString: (prop_types_default()).func,
  getA11yStatusMessage: (prop_types_default()).func,
  getA11ySelectionMessage: (prop_types_default()).func,
  circularNavigation: (prop_types_default()).bool,
  highlightedIndex: (prop_types_default()).number,
  defaultHighlightedIndex: (prop_types_default()).number,
  initialHighlightedIndex: (prop_types_default()).number,
  isOpen: (prop_types_default()).bool,
  defaultIsOpen: (prop_types_default()).bool,
  initialIsOpen: (prop_types_default()).bool,
  selectedItem: (prop_types_default()).any,
  initialSelectedItem: (prop_types_default()).any,
  defaultSelectedItem: (prop_types_default()).any,
  id: (prop_types_default()).string,
  labelId: (prop_types_default()).string,
  menuId: (prop_types_default()).string,
  getItemId: (prop_types_default()).func,
  toggleButtonId: (prop_types_default()).string,
  stateReducer: (prop_types_default()).func,
  onSelectedItemChange: (prop_types_default()).func,
  onHighlightedIndexChange: (prop_types_default()).func,
  onStateChange: (prop_types_default()).func,
  onIsOpenChange: (prop_types_default()).func,
  environment: prop_types_default().shape({
    addEventListener: (prop_types_default()).func,
    removeEventListener: (prop_types_default()).func,
    document: prop_types_default().shape({
      getElementById: (prop_types_default()).func,
      activeElement: (prop_types_default()).any,
      body: (prop_types_default()).any
    })
  })
};

var MenuKeyDownArrowDown =  false ? 0 : 0;
var MenuKeyDownArrowUp =  false ? 0 : 1;
var MenuKeyDownEscape =  false ? 0 : 2;
var MenuKeyDownHome =  false ? 0 : 3;
var MenuKeyDownEnd =  false ? 0 : 4;
var MenuKeyDownEnter =  false ? 0 : 5;
var MenuKeyDownCharacter =  false ? 0 : 6;
var MenuBlur =  false ? 0 : 7;
var MenuMouseLeave =  false ? 0 : 8;
var ItemMouseMove =  false ? 0 : 9;
var ItemClick =  false ? 0 : 10;
var ToggleButtonKeyDownCharacter =  false ? 0 : 11;
var ToggleButtonKeyDownArrowDown =  false ? 0 : 12;
var ToggleButtonKeyDownArrowUp =  false ? 0 : 13;
var ToggleButtonClick =  false ? 0 : 14;
var FunctionToggleMenu =  false ? 0 : 15;
var FunctionOpenMenu =  false ? 0 : 16;
var FunctionCloseMenu =  false ? 0 : 17;
var FunctionSetHighlightedIndex =  false ? 0 : 18;
var FunctionSelectItem =  false ? 0 : 19;
var FunctionClearKeysSoFar =  false ? 0 : 20;
var FunctionReset =  false ? 0 : 21;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionClearKeysSoFar: FunctionClearKeysSoFar,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick:
      changes = {
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex$1(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex$1(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, props.circularNavigation)
      };
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: 0
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: props.items.length - 1
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownEnter:
      changes = (0,esm_extends/* default */.Z)({
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var keysSoFar = "" + state.keysSoFar + lowercasedKey;
        var highlightedIndex = getItemIndexByCharacterKey(keysSoFar, state.highlightedIndex, props.items, props.itemToString);
        changes = (0,esm_extends/* default */.Z)({
          keysSoFar: keysSoFar
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _keysSoFar = "" + state.keysSoFar + _lowercasedKey;

        var itemIndex = getItemIndexByCharacterKey(_keysSoFar, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString);
        changes = (0,esm_extends/* default */.Z)({
          keysSoFar: _keysSoFar
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      {
        changes = {
          isOpen: true,
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1)
        };
        break;
      }

    case ToggleButtonKeyDownArrowUp:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1)
      };
      break;

    case ToggleButtonClick:
    case FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    case FunctionClearKeysSoFar:
      changes = {
        keysSoFar: ''
      };
      break;

    case FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        isOpen: getDefaultValue(props, 'isOpen'),
        selectedItem: getDefaultValue(props, 'selectedItem')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return (0,esm_extends/* default */.Z)({}, state, {}, changes);
}
/* eslint-enable complexity */

var validatePropTypes =  true ?
/* istanbul ignore next */
null : 0;
var defaultProps = {
  itemToString: itemToString,
  stateReducer: function stateReducer(s, a) {
    return a.changes;
  },
  getA11yStatusMessage: getA11yStatusMessage$1,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  environment: typeof window === 'undefined'
  /* istanbul ignore next (ssr) */
  ? {} : window
};
useSelect.stateChangeTypes = stateChangeTypes$1;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (false) {} // Props defaults and destructuring.


  var props = (0,esm_extends/* default */.Z)({}, defaultProps, {}, userProps);

  var items = props.items,
      itemToString = props.itemToString,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment; // Initial state depending on controlled props.

  var initialState = getInitialState(props); // Reducer init.

  var _useEnhancedReducer = useEnhancedReducer(downshiftSelectReducer, initialState, props),
      _useEnhancedReducer$ = _useEnhancedReducer[0],
      isOpen = _useEnhancedReducer$.isOpen,
      highlightedIndex = _useEnhancedReducer$.highlightedIndex,
      selectedItem = _useEnhancedReducer$.selectedItem,
      keysSoFar = _useEnhancedReducer$.keysSoFar,
      dispatchWithoutProps = _useEnhancedReducer[1];

  var dispatch = function (action) {
    return dispatchWithoutProps((0,esm_extends/* default */.Z)({
      props: props
    }, action));
  }; // IDs generation.


  var _getElementIds = getElementIds(useId, props),
      labelId = _getElementIds.labelId,
      getItemId = _getElementIds.getItemId,
      menuId = _getElementIds.menuId,
      toggleButtonId = _getElementIds.toggleButtonId;
  /* Refs */


  var toggleButtonRef = (0,react.useRef)(null);
  var menuRef = (0,react.useRef)(null);
  var itemRefs = (0,react.useRef)();
  itemRefs.current = [];
  var isInitialMount = (0,react.useRef)(true);
  var shouldScroll = (0,react.useRef)(true);
  var clearTimeout = (0,react.useRef)(null);
  /* Effects */

  /* Sets a11y status message on changes in isOpen. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11yStatusMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  /* Sets a11y status message on changes in selectedItem. */

  (0,react.useEffect)(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11ySelectionMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  /* Sets cleanup for the keysSoFar after 500ms. */

  (0,react.useEffect)(function () {
    // init the clean function here as we need access to dispatch.
    if (isInitialMount.current) {
      clearTimeout.current = debounce(function () {
        dispatch({
          type: FunctionClearKeysSoFar
        });
      }, 500);
    }

    if (!keysSoFar) {
      return;
    }

    clearTimeout.current(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keysSoFar]);
  /* Controls the focus on the menu or the toggle button. */

  (0,react.useEffect)(function () {
    // Don't focus menu on first render.
    if (isInitialMount.current) {
      // Unless it was initialised as open.
      if (initialIsOpen || defaultIsOpen || isOpen) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.
    // istanbul ignore next


    if (isOpen) {
      menuRef.current.focus(); // Focus toggleButton on close.
    } else if (environment.document.activeElement === menuRef.current) {
      toggleButtonRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  /* Scroll on highlighted item if change comes from keyboard. */

  (0,react.useEffect)(function () {
    if (highlightedIndex < 0 || !isOpen || !itemRefs.current.length) {
      return;
    }

    if (shouldScroll.current === false) {
      shouldScroll.current = true;
    } else {
      scrollIntoView(itemRefs.current[highlightedIndex], menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  /* Make initial ref false. */

  (0,react.useEffect)(function () {
    isInitialMount.current = false;
  }, []);
  /* Event handler functions */

  var menuKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowDown,
        shiftKey: event.shiftKey
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowUp,
        shiftKey: event.shiftKey
      });
    },
    Home: function Home(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownHome
      });
    },
    End: function End(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnd
      });
    },
    Escape: function Escape() {
      dispatch({
        type: MenuKeyDownEscape
      });
    },
    Enter: function Enter(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnter
      });
    },
    Tab: function Tab(event) {
      // The exception that calls MenuBlur.
      // istanbul ignore next
      if (event.shiftKey) {
        dispatch({
          type: MenuBlur
        });
      }
    }
  };
  var toggleButtonKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowDown
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowUp
      });
    }
  }; // Event handlers.

  var menuHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && menuKeyDownHandlers[key]) {
      menuKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: MenuKeyDownCharacter,
        key: key
      });
    }
  }; // Focus going back to the toggleButton is something we control (Escape, Enter, Click).
  // We are toggleing special actions for these cases in reducer, not MenuBlur.
  // Since Shift-Tab also lands focus on toggleButton, we will handle it as exception and call MenuBlur.


  var menuHandleBlur = function (event) {
    if (!focusLandsOnElement(event, toggleButtonRef.current)) {
      dispatch({
        type: MenuBlur
      });
    }
  };

  var menuHandleMouseLeave = function () {
    dispatch({
      type: MenuMouseLeave
    });
  };

  var toggleButtonHandleClick = function () {
    dispatch({
      type: ToggleButtonClick
    });
  };

  var toggleButtonHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && toggleButtonKeyDownHandlers[key]) {
      toggleButtonKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: ToggleButtonKeyDownCharacter,
        key: key
      });
    }
  };

  var itemHandleMouseMove = function (index) {
    if (index === highlightedIndex) {
      return;
    }

    shouldScroll.current = false;
    dispatch({
      type: ItemMouseMove,
      index: index
    });
  };

  var itemHandleClick = function (index) {
    dispatch({
      type: ItemClick,
      index: index
    });
  }; // returns


  return {
    // prop getters.
    getToggleButtonProps: function getToggleButtonProps(_temp2) {
      var _extends3;

      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          onClick = _ref2.onClick,
          onKeyDown = _ref2.onKeyDown,
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          ref = _ref2.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["onClick", "onKeyDown", "refKey", "ref"]);

      var toggleProps = (0,esm_extends/* default */.Z)((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
        toggleButtonRef.current = toggleButtonNode;
      }), _extends3.id = toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = isOpen, _extends3['aria-labelledby'] = labelId + " " + toggleButtonId, _extends3), rest);

      if (!rest.disabled) {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }

      return toggleProps;
    },
    getLabelProps: function getLabelProps(labelProps) {
      return (0,esm_extends/* default */.Z)({
        id: labelId,
        htmlFor: toggleButtonId
      }, labelProps);
    },
    getMenuProps: function getMenuProps(_temp) {
      var _extends2;

      var _ref = _temp === void 0 ? {} : _temp,
          onKeyDown = _ref.onKeyDown,
          onBlur = _ref.onBlur,
          onMouseLeave = _ref.onMouseLeave,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onKeyDown", "onBlur", "onMouseLeave", "refKey", "ref"]);

      return (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = labelId, _extends2.tabIndex = -1, _extends2), highlightedIndex > -1 && {
        'aria-activedescendant': getItemId(highlightedIndex)
      }, {
        onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
        onBlur: callAllEventHandlers(onBlur, menuHandleBlur),
        onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave)
      }, rest);
    },
    getItemProps: function getItemProps(_temp3) {
      var _extends4;

      var _ref3 = _temp3 === void 0 ? {} : _temp3,
          item = _ref3.item,
          index = _ref3.index,
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          ref = _ref3.ref,
          onMouseMove = _ref3.onMouseMove,
          onClick = _ref3.onClick,
          rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick"]);

      var itemIndex = getItemIndex(index, item, items);

      if (itemIndex < 0) {
        throw new Error('Pass either item or item index in getItemProps!');
      }

      var itemProps = (0,esm_extends/* default */.Z)((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (itemNode) {
        if (itemNode) {
          itemRefs.current.push(itemNode);
        }
      }), _extends4.role = 'option', _extends4), itemIndex === highlightedIndex && {
        'aria-selected': true
      }, {
        id: getItemId(itemIndex)
      }, rest);

      if (!rest.disabled) {
        itemProps.onMouseMove = callAllEventHandlers(onMouseMove, function () {
          return itemHandleMouseMove(itemIndex);
        });
        itemProps.onClick = callAllEventHandlers(onClick, function () {
          return itemHandleClick(itemIndex);
        });
      }

      return itemProps;
    },
    // actions.
    toggleMenu: function toggleMenu() {
      dispatch({
        type: FunctionToggleMenu
      });
    },
    openMenu: function openMenu() {
      dispatch({
        type: FunctionOpenMenu
      });
    },
    closeMenu: function closeMenu() {
      dispatch({
        type: FunctionCloseMenu
      });
    },
    setHighlightedIndex: function setHighlightedIndex(newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex,
        highlightedIndex: newHighlightedIndex
      });
    },
    selectItem: function selectItem(newSelectedItem) {
      dispatch({
        type: FunctionSelectItem,
        selectedItem: newSelectedItem
      });
    },
    reset: function reset() {
      dispatch({
        type: FunctionReset
      });
    },
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem
  };
}

/* harmony default export */ var downshift_esm = (Downshift);



/***/ }),

/***/ 73356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; }
});

// UNUSED EXPORTS: disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, gql, resetCaches

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(92277);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(88660);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(46182);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/defineToJSON.mjs

/**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */

function defineToJSON(classObject) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
  classObject.prototype.toJSON = fn;
  classObject.prototype.inspect = fn;

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var sublineIndex = Math.floor(columnNum / 80);
    var sublineColumnNum = columnNum % 80;
    var sublines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      sublines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function (subline) {
      return ['', subline];
    }), [[' ', whitespace(sublineColumnNum - 1) + '^'], ['', sublines[sublineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/GraphQLError.mjs



/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return getLocation(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(getLocation(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions;

  if (_extensions == null && originalError != null) {
    var originalExtensions = originalError.extensions;

    if (isObjectLike(originalExtensions)) {
      _extensions = originalExtensions;
    }
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}
GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return printError(this);
    }
  }
});
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
// EXTERNAL MODULE: ../../node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(8162);
// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

;// CONCATENATED MODULE: ../../node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

function createLexer(source, options) {
  var startOfFileToken = new Tok(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== tokenKind_TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === tokenKind_TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


// @internal
function isPunctuatorToken(token) {
  var kind = token.kind;
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Tok, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = body.charCodeAt(pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(tokenKind_TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(tokenKind_TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(tokenKind_TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(tokenKind_TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(tokenKind_TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
        return new Tok(tokenKind_TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(tokenKind_TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(tokenKind_TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(tokenKind_TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(tokenKind_TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(tokenKind_TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(tokenKind_TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev, lexer);
      }

      return readString(source, pos, line, col, prev);
  }

  throw syntaxError(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = body.charCodeAt(position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or e


  if (code === 46 || code === 69 || code === 101) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Tok(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

;// CONCATENATED MODULE: ../../node_modules/graphql/language/parser.mjs










/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}

var Parser =
/*#__PURE__*/
function () {
  function Parser(source, options) {
    var sourceObj = typeof source === 'string' ? new language_source/* Source */.H(source) : source;
    sourceObj instanceof language_source/* Source */.H || (0,devAssert/* default */.Z)(0, "Must provide Source. Received: ".concat((0,inspect/* default */.Z)(sourceObj)));
    this._lexer = createLexer(sourceObj);
    this._options = options || {};
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.experimentalFragmentVariables) {
      return {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        if (token.value === 'true' || token.value === 'false') {
          this._lexer.advance();

          return {
            kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
            value: token.value === 'true',
            loc: this.loc(token)
          };
        } else if (token.value === 'null') {
          this._lexer.advance();

          return {
            kind: kinds/* Kind.NULL */.h.NULL,
            loc: this.loc(token)
          };
        }

        this._lexer.advance();

        return {
          kind: kinds/* Kind.ENUM */.h.ENUM,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var types = [];

    if (this.expectOptionalKeyword('implements')) {
      // Optional leading ampersand
      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || // Legacy support for the SDL?
      this._options.allowLegacySDLImplementsInterfaces && this.peek(tokenKind_TokenKind.NAME));
    }

    return types;
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    // Legacy support for the SDL?
    if (this._options.allowLegacySDLEmptyFields && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    var types = [];

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      // Optional leading pipe
      this.expectOptionalToken(tokenKind_TokenKind.PIPE);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));
    }

    return types;
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *   - extend interface Name Directives[Const]? FieldsDefinition
   *   - extend interface Name Directives[Const]
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    // Optional leading pipe
    this.expectOptionalToken(tokenKind_TokenKind.PIPE);
    var locations = [];

    do {
      locations.push(this.parseDirectiveLocation());
    } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));

    return locations;
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    if (!this._options.noLocation) {
      return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token)));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken || this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  };

  return Parser;
}();

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Loc, function () {
  return {
    start: this.start,
    end: this.end
  };
});
/**
 * A helper function to describe a token as a string for debugging
 */

function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

;// CONCATENATED MODULE: ../../node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 37525:
/***/ (function(module) {

"use strict";


function pad (hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }
  return hash;
}

function fold (hash, text) {
  var i;
  var chr;
  var len;
  if (text.length === 0) {
    return hash;
  }
  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? hash * -2 : hash;
}

function foldObject (hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);
  function foldKey (hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue (input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
  if (value === null) {
    return fold(hash, 'null');
  }
  if (value === undefined) {
    return fold(hash, 'undefined');
  }
  if (typeof value === 'object' || typeof value === 'function') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }
    seen.push(value);

    var objHash = foldObject(hash, value, seen)

    if (!('valueOf' in value) || typeof value.valueOf !== 'function') {
      return objHash;
    }

    try {
      return fold(objHash, String(value.valueOf()))
    } catch (err) {
      return fold(objHash, '[valueOf exception]' + (err.stack || err.message))
    }
  }
  return fold(hash, value.toString());
}

function toString (o) {
  return Object.prototype.toString.call(o);
}

function sum (o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = sum;


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(48570);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 13335:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ 95978:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */
;(function (global, factory) {
     true
        ? module.exports = factory(global)
        : 0
}((
    typeof self !== 'undefined' ? self
        : typeof window !== 'undefined' ? window
        : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g
: this
), function(global) {
    'use strict';
    // existing version for noConflict()
    global = global || {};
    var _Base64 = global.Base64;
    var version = "2.6.4";
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa && typeof global.btoa == 'function'
        ? function(b){ return global.btoa(b) } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError(
            'The string contains invalid characters.'
        );
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function (b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) { return encode(u, true) };
    var fromUint8Array;
    if (global.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for (var i = 0, l = a.length; i < l; i += 3) {
            var a0 = a[i], a1 = a[i+1], a2 = a[i+2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 +=    b64chars.charAt( ord >>> 18)
                +     b64chars.charAt((ord >>> 12) & 63)
                + ( typeof a1 != 'undefined'
                    ? b64chars.charAt((ord >>>  6) & 63) : '=')
                + ( typeof a2 != 'undefined'
                    ? b64chars.charAt( ord         & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var _atob = global.atob && typeof global.atob == 'function'
        ? function(a){ return global.atob(a) } : function(a){
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) { return btou(_atob(a)) };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/'
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a){
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global['Meteor']) { // Meteor.js
        Base64 = global.Base64;
    }
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if ( true && module.exports) {
        module.exports.Base64 = global.Base64;
    }
    else if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){ return global.Base64 }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    // that's it!
    return {Base64: global.Base64}
}));


/***/ }),

/***/ 39515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 89612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(52118),
    hashDelete = __webpack_require__(96909),
    hashGet = __webpack_require__(98138),
    hashHas = __webpack_require__(4174),
    hashSet = __webpack_require__(7942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 80235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3945),
    listCacheDelete = __webpack_require__(21846),
    listCacheGet = __webpack_require__(88028),
    listCacheHas = __webpack_require__(72344),
    listCacheSet = __webpack_require__(94769);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 10326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 96738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(92411),
    mapCacheDelete = __webpack_require__(36417),
    mapCacheGet = __webpack_require__(86928),
    mapCacheHas = __webpack_require__(79493),
    mapCacheSet = __webpack_require__(24150);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 52760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 45386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738),
    setCacheAdd = __webpack_require__(52842),
    setCacheHas = __webpack_require__(52482);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 86571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    stackClear = __webpack_require__(15243),
    stackDelete = __webpack_require__(72858),
    stackGet = __webpack_require__(4417),
    stackHas = __webpack_require__(8605),
    stackSet = __webpack_require__(71418);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 50857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 79162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 93215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 49432:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 67552:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 1634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(36473),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isIndex = __webpack_require__(39045),
    isTypedArray = __webpack_require__(77598);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 50343:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 65067:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 87064:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 60091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 22218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 13940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(83043);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 62034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isFlattenable = __webpack_require__(95882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 13324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 1897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 53366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    getRawTag = __webpack_require__(62107),
    objectToString = __webpack_require__(37157);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 20187:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 15183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 88746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(51952),
    isObjectLike = __webpack_require__(15125);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 51952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    equalArrays = __webpack_require__(74871),
    equalByTag = __webpack_require__(11491),
    equalObjects = __webpack_require__(17416),
    getTag = __webpack_require__(70940),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isTypedArray = __webpack_require__(77598);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isMasked = __webpack_require__(47394),
    isObject = __webpack_require__(29259),
    toSource = __webpack_require__(87035);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 35522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isLength = __webpack_require__(61158),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 1184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(16001),
    nativeKeys = __webpack_require__(54248);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 92602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePickBy = __webpack_require__(93759),
    hasIn = __webpack_require__(95041);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 93759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(13324),
    baseSet = __webpack_require__(82857),
    castPath = __webpack_require__(17297);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 82857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(60091),
    castPath = __webpack_require__(17297),
    isIndex = __webpack_require__(39045),
    isObject = __webpack_require__(29259),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 86532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(86874),
    defineProperty = __webpack_require__(83043),
    identity = __webpack_require__(23059);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 36473:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 1054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    arrayMap = __webpack_require__(50343),
    isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 47826:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 59950:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 17297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isKey = __webpack_require__(21401),
    stringToPath = __webpack_require__(54452),
    toString = __webpack_require__(66188);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 24019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 83043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 74871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(45386),
    arraySome = __webpack_require__(87064),
    cacheHas = __webpack_require__(59950);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 11491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    Uint8Array = __webpack_require__(79162),
    eq = __webpack_require__(41225),
    equalArrays = __webpack_require__(74871),
    mapToArray = __webpack_require__(75179),
    setToArray = __webpack_require__(16909);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 17416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(13483);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 29097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(35676),
    overRest = __webpack_require__(43114),
    setToString = __webpack_require__(75251);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 51242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 13483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1897),
    getSymbols = __webpack_require__(80633),
    keys = __webpack_require__(90249);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 27937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(98304);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 38761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(6840),
    getValue = __webpack_require__(98109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 62107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 80633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(67552),
    stubArray = __webpack_require__(30981);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 70940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(39515),
    Map = __webpack_require__(10326),
    Promise = __webpack_require__(52760),
    Set = __webpack_require__(2143),
    WeakMap = __webpack_require__(93215),
    baseGetTag = __webpack_require__(53366),
    toSource = __webpack_require__(87035);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 98109:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 1369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isIndex = __webpack_require__(39045),
    isLength = __webpack_require__(61158),
    toKey = __webpack_require__(33812);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 52118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 96909:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 98138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 4174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 39045:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 21401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 98304:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(24019);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 16001:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 3945:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 21846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 88028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 72344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 94769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 92411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(89612),
    ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 36417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 86928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 79493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 24150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 75179:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 77777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(30733);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 99191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 54248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(60241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(51242);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 37157:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 60241:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 43114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(49432);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 37772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(51242);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 52842:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 52482:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 16909:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 75251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(86532),
    shortOut = __webpack_require__(97787);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 97787:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 15243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 72858:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 4417:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 8605:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 71418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326),
    MapCache = __webpack_require__(96738);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 54452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(77777);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 33812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 87035:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 86874:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 41225:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 35676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(62034);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 95041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(20187),
    hasPath = __webpack_require__(1369);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 23059:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 79631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(15183),
    isObjectLike = __webpack_require__(15125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 86152:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 67878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isLength = __webpack_require__(61158);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 73226:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772),
    stubFalse = __webpack_require__(79207);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 18149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(88746);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 61049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObject = __webpack_require__(29259);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 61158:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 29259:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 15125:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 4795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 77598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(35522),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 90249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeys = __webpack_require__(1184),
    isArrayLike = __webpack_require__(67878);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 76635:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 30733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 13888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePick = __webpack_require__(92602),
    flatRest = __webpack_require__(29097);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 30981:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 79207:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 66188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(1054);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 12039:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return factory(root);
        }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}((window || {}), function(window) {
	/* global locationHref:writable, animationManager, subframeEnabled:writable, defaultCurveSegments:writable, roundValues,
expressionsPlugin:writable, PropertyFactory, ShapePropertyFactory, Matrix, idPrefix:writable, _useWebWorker:writable */
/* exported locationHref, subframeEnabled, expressionsPlugin, idPrefix, _useWebWorker */

'use strict';

/* exported svgNS, locationHref, initialDefaultFrame, _useWebWorker */

var svgNS = 'http://www.w3.org/2000/svg';

var locationHref = '';

var initialDefaultFrame = -999999;

var _useWebWorker = false;

/* global createSizedArray */
/* exported subframeEnabled, expressionsPlugin, isSafari, cachedColors, bmPow, bmSqrt, bmFloor, bmMax, bmMin, ProjectInterface,
defaultCurveSegments, degToRads, roundCorner, bmRnd, styleDiv, BMEnterFrameEvent, BMCompleteEvent, BMCompleteLoopEvent,
BMSegmentStartEvent, BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, BMAnimationConfigErrorEvent, createElementID,
addSaturationToRGB, addBrightnessToRGB, addHueToRGB, rgbToHex */

var subframeEnabled = true;
var idPrefix = '';
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bmRnd;
var bmPow = Math.pow;
var bmSqrt = Math.sqrt;
var bmFloor = Math.floor;
var bmMax = Math.max;
var bmMin = Math.min;

var BMMath = {};
(function () {
  var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
  var i;
  var len = propertyNames.length;
  for (i = 0; i < len; i += 1) {
    BMMath[propertyNames[i]] = Math[propertyNames[i]];
  }
}());

function ProjectInterface() { return {}; }

BMMath.random = Math.random;
BMMath.abs = function (val) {
  var tOfVal = typeof val;
  if (tOfVal === 'object' && val.length) {
    var absArr = createSizedArray(val.length);
    var i;
    var len = val.length;
    for (i = 0; i < len; i += 1) {
      absArr[i] = Math.abs(val[i]);
    }
    return absArr;
  }
  return Math.abs(val);
};
var defaultCurveSegments = 150;
var degToRads = Math.PI / 180;
var roundCorner = 0.5519;

function roundValues(flag) {
  if (flag) {
    bmRnd = Math.round;
  } else {
    bmRnd = function (val) {
      return val;
    };
  }
}
roundValues(false);

function styleDiv(element) {
  element.style.position = 'absolute';
  element.style.top = 0;
  element.style.left = 0;
  element.style.display = 'block';
  element.style.transformOrigin = '0 0';
  element.style.webkitTransformOrigin = '0 0';
  element.style.backfaceVisibility = 'visible';
  element.style.webkitBackfaceVisibility = 'visible';
  element.style.transformStyle = 'preserve-3d';
  element.style.webkitTransformStyle = 'preserve-3d';
  element.style.mozTransformStyle = 'preserve-3d';
}

function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
  this.type = type;
  this.currentTime = currentTime;
  this.totalTime = totalTime;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteEvent(type, frameMultiplier) {
  this.type = type;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
  this.type = type;
  this.currentLoop = currentLoop;
  this.totalLoops = totalLoops;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMSegmentStartEvent(type, firstFrame, totalFrames) {
  this.type = type;
  this.firstFrame = firstFrame;
  this.totalFrames = totalFrames;
}

function BMDestroyEvent(type, target) {
  this.type = type;
  this.target = target;
}

function BMRenderFrameErrorEvent(nativeError, currentTime) {
  this.type = 'renderFrameError';
  this.nativeError = nativeError;
  this.currentTime = currentTime;
}

function BMConfigErrorEvent(nativeError) {
  this.type = 'configError';
  this.nativeError = nativeError;
}

function BMAnimationConfigErrorEvent(type, nativeError) {
  this.type = type;
  this.nativeError = nativeError;
}

var createElementID = (function () {
  var _count = 0;
  return function createID() {
    _count += 1;
    return idPrefix + '__lottie_element_' + _count;
  };
}());

function HSVtoRGB(h, s, v) {
  var r;
  var g;
  var b;
  var i;
  var f;
  var p;
  var q;
  var t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
    default: break;
  }
  return [r,
    g,
    b];
}

function RGBtoHSV(r, g, b) {
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var d = max - min;
  var h;
  var s = (max === 0 ? 0 : d / max);
  var v = max / 255;

  switch (max) {
    case min: h = 0; break;
    case r: h = (g - b) + d * (g < b ? 6 : 0); h /= 6 * d; break;
    case g: h = (b - r) + d * 2; h /= 6 * d; break;
    case b: h = (r - g) + d * 4; h /= 6 * d; break;
    default: break;
  }

  return [
    h,
    s,
    v,
  ];
}

function addSaturationToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[1] += offset;
  if (hsv[1] > 1) {
    hsv[1] = 1;
  } else if (hsv[1] <= 0) {
    hsv[1] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addBrightnessToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[2] += offset;
  if (hsv[2] > 1) {
    hsv[2] = 1;
  } else if (hsv[2] < 0) {
    hsv[2] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addHueToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[0] += offset / 360;
  if (hsv[0] > 1) {
    hsv[0] -= 1;
  } else if (hsv[0] < 0) {
    hsv[0] += 1;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

var rgbToHex = (function () {
  var colorMap = [];
  var i;
  var hex;
  for (i = 0; i < 256; i += 1) {
    hex = i.toString(16);
    colorMap[i] = hex.length === 1 ? '0' + hex : hex;
  }

  return function (r, g, b) {
    if (r < 0) {
      r = 0;
    }
    if (g < 0) {
      g = 0;
    }
    if (b < 0) {
      b = 0;
    }
    return '#' + colorMap[r] + colorMap[g] + colorMap[b];
  };
}());

function BaseEvent() {}
BaseEvent.prototype = {
  triggerEvent: function (eventName, args) {
    if (this._cbs[eventName]) {
      var callbacks = this._cbs[eventName];
      for (var i = 0; i < callbacks.length; i += 1) {
        callbacks[i](args);
      }
    }
  },
  addEventListener: function (eventName, callback) {
    if (!this._cbs[eventName]) {
      this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

    return function () {
      this.removeEventListener(eventName, callback);
    }.bind(this);
  },
  removeEventListener: function (eventName, callback) {
    if (!callback) {
      this._cbs[eventName] = null;
    } else if (this._cbs[eventName]) {
      var i = 0;
      var len = this._cbs[eventName].length;
      while (i < len) {
        if (this._cbs[eventName][i] === callback) {
          this._cbs[eventName].splice(i, 1);
          i -= 1;
          len -= 1;
        }
        i += 1;
      }
      if (!this._cbs[eventName].length) {
        this._cbs[eventName] = null;
      }
    }
  },
};

/* exported createTypedArray, createSizedArray */

var createTypedArray = (function () {
  function createRegularArray(type, len) {
    var i = 0;
    var arr = [];
    var value;
    switch (type) {
      case 'int16':
      case 'uint8c':
        value = 1;
        break;
      default:
        value = 1.1;
        break;
    }
    for (i = 0; i < len; i += 1) {
      arr.push(value);
    }
    return arr;
  }
  function createTypedArrayFactory(type, len) {
    if (type === 'float32') {
      return new Float32Array(len);
    } if (type === 'int16') {
      return new Int16Array(len);
    } if (type === 'uint8c') {
      return new Uint8ClampedArray(len);
    }
    return createRegularArray(type, len);
  }
  if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
    return createTypedArrayFactory;
  }
  return createRegularArray;
}());

function createSizedArray(len) {
  return Array.apply(null, { length: len });
}

/* global svgNS */
/* exported createNS */

function createNS(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElementNS(svgNS, type);
}

/* exported createTag */

function createTag(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElement(type);
}

function DynamicPropertyContainer() {}
DynamicPropertyContainer.prototype = {
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
      this.container.addDynamicProperty(this);
      this._isAnimated = true;
    }
  },
  iterateDynamicProperties: function () {
    this._mdf = false;
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
      if (this.dynamicProperties[i]._mdf) {
        this._mdf = true;
      }
    }
  },
  initDynamicPropertyContainer: function (container) {
    this.container = container;
    this.dynamicProperties = [];
    this._mdf = false;
    this._isAnimated = false;
  },
};

/* exported getBlendMode */

var getBlendMode = (function () {
  var blendModeEnums = {
    0: 'source-over',
    1: 'multiply',
    2: 'screen',
    3: 'overlay',
    4: 'darken',
    5: 'lighten',
    6: 'color-dodge',
    7: 'color-burn',
    8: 'hard-light',
    9: 'soft-light',
    10: 'difference',
    11: 'exclusion',
    12: 'hue',
    13: 'saturation',
    14: 'color',
    15: 'luminosity',
  };

  return function (mode) {
    return blendModeEnums[mode] || '';
  };
}());

/* exported lineCapEnum, lineJoinEnum */

var lineCapEnum = {
  1: 'butt',
  2: 'round',
  3: 'square',
};

var lineJoinEnum = {
  1: 'miter',
  2: 'round',
  3: 'bevel',
};

/* global createTypedArray */

/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function () {
  var _cos = Math.cos;
  var _sin = Math.sin;
  var _tan = Math.tan;
  var _rnd = Math.round;

  function reset() {
    this.props[0] = 1;
    this.props[1] = 0;
    this.props[2] = 0;
    this.props[3] = 0;
    this.props[4] = 0;
    this.props[5] = 1;
    this.props[6] = 0;
    this.props[7] = 0;
    this.props[8] = 0;
    this.props[9] = 0;
    this.props[10] = 1;
    this.props[11] = 0;
    this.props[12] = 0;
    this.props[13] = 0;
    this.props[14] = 0;
    this.props[15] = 1;
    return this;
  }

  function rotate(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function rotateX(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
  }

  function rotateY(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
  }

  function rotateZ(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function shear(sx, sy) {
    return this._t(1, sy, sx, 1, 0, 0);
  }

  function skew(ax, ay) {
    return this.shear(_tan(ax), _tan(ay));
  }

  function skewFromAxis(ax, angle) {
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
  }

  function scale(sx, sy, sz) {
    if (!sz && sz !== 0) {
      sz = 1;
    }
    if (sx === 1 && sy === 1 && sz === 1) {
      return this;
    }
    return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
  }

  function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
    this.props[0] = a;
    this.props[1] = b;
    this.props[2] = c;
    this.props[3] = d;
    this.props[4] = e;
    this.props[5] = f;
    this.props[6] = g;
    this.props[7] = h;
    this.props[8] = i;
    this.props[9] = j;
    this.props[10] = k;
    this.props[11] = l;
    this.props[12] = m;
    this.props[13] = n;
    this.props[14] = o;
    this.props[15] = p;
    return this;
  }

  function translate(tx, ty, tz) {
    tz = tz || 0;
    if (tx !== 0 || ty !== 0 || tz !== 0) {
      return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
    }
    return this;
  }

  function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
    var _p = this.props;

    if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
      // NOTE: commenting this condition because TurboFan deoptimizes code when present
      // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
      _p[12] = _p[12] * a2 + _p[15] * m2;
      _p[13] = _p[13] * f2 + _p[15] * n2;
      _p[14] = _p[14] * k2 + _p[15] * o2;
      _p[15] *= p2;
      // }
      this._identityCalculated = false;
      return this;
    }

    var a1 = _p[0];
    var b1 = _p[1];
    var c1 = _p[2];
    var d1 = _p[3];
    var e1 = _p[4];
    var f1 = _p[5];
    var g1 = _p[6];
    var h1 = _p[7];
    var i1 = _p[8];
    var j1 = _p[9];
    var k1 = _p[10];
    var l1 = _p[11];
    var m1 = _p[12];
    var n1 = _p[13];
    var o1 = _p[14];
    var p1 = _p[15];

    /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
    _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
    _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
    _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
    _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;

    _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
    _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
    _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
    _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;

    _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
    _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
    _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
    _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;

    _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
    _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
    _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
    _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;

    this._identityCalculated = false;
    return this;
  }

  function isIdentity() {
    if (!this._identityCalculated) {
      this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
      this._identityCalculated = true;
    }
    return this._identity;
  }

  function equals(matr) {
    var i = 0;
    while (i < 16) {
      if (matr.props[i] !== this.props[i]) {
        return false;
      }
      i += 1;
    }
    return true;
  }

  function clone(matr) {
    var i;
    for (i = 0; i < 16; i += 1) {
      matr.props[i] = this.props[i];
    }
    return matr;
  }

  function cloneFromProps(props) {
    var i;
    for (i = 0; i < 16; i += 1) {
      this.props[i] = props[i];
    }
  }

  function applyToPoint(x, y, z) {
    return {
      x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
      y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
      z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
    };
    /* return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         }; */
  }
  function applyToX(x, y, z) {
    return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
  }
  function applyToY(x, y, z) {
    return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
  }
  function applyToZ(x, y, z) {
    return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
  }

  function getInverseMatrix() {
    var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
    var a = this.props[5] / determinant;
    var b = -this.props[1] / determinant;
    var c = -this.props[4] / determinant;
    var d = this.props[0] / determinant;
    var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
    var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
    var inverseMatrix = new Matrix();
    inverseMatrix.props[0] = a;
    inverseMatrix.props[1] = b;
    inverseMatrix.props[4] = c;
    inverseMatrix.props[5] = d;
    inverseMatrix.props[12] = e;
    inverseMatrix.props[13] = f;
    return inverseMatrix;
  }

  function inversePoint(pt) {
    var inverseMatrix = this.getInverseMatrix();
    return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
  }

  function inversePoints(pts) {
    var i;
    var len = pts.length;
    var retPts = [];
    for (i = 0; i < len; i += 1) {
      retPts[i] = inversePoint(pts[i]);
    }
    return retPts;
  }

  function applyToTriplePoints(pt1, pt2, pt3) {
    var arr = createTypedArray('float32', 6);
    if (this.isIdentity()) {
      arr[0] = pt1[0];
      arr[1] = pt1[1];
      arr[2] = pt2[0];
      arr[3] = pt2[1];
      arr[4] = pt3[0];
      arr[5] = pt3[1];
    } else {
      var p0 = this.props[0];
      var p1 = this.props[1];
      var p4 = this.props[4];
      var p5 = this.props[5];
      var p12 = this.props[12];
      var p13 = this.props[13];
      arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
      arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
      arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
      arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
      arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
      arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
    }
    return arr;
  }

  function applyToPointArray(x, y, z) {
    var arr;
    if (this.isIdentity()) {
      arr = [x, y, z];
    } else {
      arr = [
        x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
      ];
    }
    return arr;
  }

  function applyToPointStringified(x, y) {
    if (this.isIdentity()) {
      return x + ',' + y;
    }
    var _p = this.props;
    return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
  }

  function toCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var i = 0;
    var props = this.props;
    var cssValue = 'matrix3d(';
    var v = 10000;
    while (i < 16) {
      cssValue += _rnd(props[i] * v) / v;
      cssValue += i === 15 ? ')' : ',';
      i += 1;
    }
    return cssValue;
  }

  function roundMatrixProperty(val) {
    var v = 10000;
    if ((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
      return _rnd(val * v) / v;
    }
    return val;
  }

  function to2dCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var props = this.props;
    var _a = roundMatrixProperty(props[0]);
    var _b = roundMatrixProperty(props[1]);
    var _c = roundMatrixProperty(props[4]);
    var _d = roundMatrixProperty(props[5]);
    var _e = roundMatrixProperty(props[12]);
    var _f = roundMatrixProperty(props[13]);
    return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
  }

  return function () {
    this.reset = reset;
    this.rotate = rotate;
    this.rotateX = rotateX;
    this.rotateY = rotateY;
    this.rotateZ = rotateZ;
    this.skew = skew;
    this.skewFromAxis = skewFromAxis;
    this.shear = shear;
    this.scale = scale;
    this.setTransform = setTransform;
    this.translate = translate;
    this.transform = transform;
    this.applyToPoint = applyToPoint;
    this.applyToX = applyToX;
    this.applyToY = applyToY;
    this.applyToZ = applyToZ;
    this.applyToPointArray = applyToPointArray;
    this.applyToTriplePoints = applyToTriplePoints;
    this.applyToPointStringified = applyToPointStringified;
    this.toCSS = toCSS;
    this.to2dCSS = to2dCSS;
    this.clone = clone;
    this.cloneFromProps = cloneFromProps;
    this.equals = equals;
    this.inversePoints = inversePoints;
    this.inversePoint = inversePoint;
    this.getInverseMatrix = getInverseMatrix;
    this._t = this.transform;
    this.isIdentity = isIdentity;
    this._identity = true;
    this._identityCalculated = false;

    this.props = createTypedArray('float32', 16);
    this.reset();
  };
}());

/* eslint-disable */
/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options === true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed === null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; };
        prng.quick = function() { return arc4.g(4) / 0x100000000; };
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); };
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        };
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date(), global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
/* eslint-disable */
var BezierFactory = (function () {
  /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

  var ob = {};
  ob.getBezierEasing = getBezierEasing;
  var beziers = {};

  function getBezierEasing(a, b, c, d, nm) {
    var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
    if (beziers[str]) {
      return beziers[str];
    }
    var bezEasing = new BezierEasing([a, b, c, d]);
    beziers[str] = bezEasing;
    return bezEasing;
  }

  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
  function C(aA1) { return 3.0 * aA1; }

  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }

  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
      currentT,
      i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) return aGuessT;
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
  function BezierEasing(points) {
    this._p = points;
    this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    this._precomputed = false;

    this.get = this.get.bind(this);
  }

  BezierEasing.prototype = {

    get: function (x) {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      if (!this._precomputed) this._precompute();
      if (mX1 === mY1 && mX2 === mY2) return x; // linear
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) return 0;
      if (x === 1) return 1;
      return calcBezier(this._getTForX(x), mY1, mY2);
    },

    // Private part

    _precompute: function () {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      this._precomputed = true;
      if (mX1 !== mY1 || mX2 !== mY2) { this._calcSampleValues(); }
    },

    _calcSampleValues: function () {
      var mX1 = this._p[0],
        mX2 = this._p[2];
      for (var i = 0; i < kSplineTableSize; ++i) {
        this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    },

    /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
    _getTForX: function (aX) {
      var mX1 = this._p[0],
        mX2 = this._p[2],
        mSampleValues = this._mSampleValues;

      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;

      // Interpolate to provide an initial guess for t
      var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;

      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } if (initialSlope === 0.0) {
        return guessForT;
      }
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    },
  };

  return ob;
}());

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) { // eslint-disable-line no-plusplus
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = setTimeout(function () {
        callback(currTime + timeToCall);
      },
      timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());

/* exported extendPrototype, getDescriptor, createProxyFunction */

function extendPrototype(sources, destination) {
  var i;
  var len = sources.length;
  var sourcePrototype;
  for (i = 0; i < len; i += 1) {
    sourcePrototype = sources[i].prototype;
    for (var attr in sourcePrototype) {
      if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
    }
  }
}

function getDescriptor(object, prop) {
  return Object.getOwnPropertyDescriptor(object, prop);
}

function createProxyFunction(prototype) {
  function ProxyFunction() {}
  ProxyFunction.prototype = prototype;
  return ProxyFunction;
}

/* global segmentsLengthPool, defaultCurveSegments, createSizedArray, bmPow, bmSqrt, bmFloor, createTypedArray, bezierLengthPool */
/* exported bez */

function bezFunction() {
  var math = Math;

  function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
    var det1 = (x1 * y2) + (y1 * x3) + (x2 * y3) - (x3 * y2) - (y3 * x1) - (x2 * y1);
    return det1 > -0.001 && det1 < 0.001;
  }

  function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
    if (z1 === 0 && z2 === 0 && z3 === 0) {
      return pointOnLine2D(x1, y1, x2, y2, x3, y3);
    }
    var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
    var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
    var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
    var diffDist;
    if (dist1 > dist2) {
      if (dist1 > dist3) {
        diffDist = dist1 - dist2 - dist3;
      } else {
        diffDist = dist3 - dist2 - dist1;
      }
    } else if (dist3 > dist2) {
      diffDist = dist3 - dist2 - dist1;
    } else {
      diffDist = dist2 - dist1 - dist3;
    }
    return diffDist > -0.0001 && diffDist < 0.0001;
  }

  var getBezierLength = (function () {
    return function (pt1, pt2, pt3, pt4) {
      var curveSegments = defaultCurveSegments;
      var k;
      var i;
      var len;
      var ptCoord;
      var perc;
      var addedLength = 0;
      var ptDistance;
      var point = [];
      var lastPoint = [];
      var lengthData = bezierLengthPool.newElement();
      len = pt3.length;
      for (k = 0; k < curveSegments; k += 1) {
        perc = k / (curveSegments - 1);
        ptDistance = 0;
        for (i = 0; i < len; i += 1) {
          ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
          point[i] = ptCoord;
          if (lastPoint[i] !== null) {
            ptDistance += bmPow(point[i] - lastPoint[i], 2);
          }
          lastPoint[i] = point[i];
        }
        if (ptDistance) {
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
        }
        lengthData.percents[k] = perc;
        lengthData.lengths[k] = addedLength;
      }
      lengthData.addedLength = addedLength;
      return lengthData;
    };
  }());

  function getSegmentsLength(shapeData) {
    var segmentsLength = segmentsLengthPool.newElement();
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i;
    var len = shapeData._length;
    var lengths = segmentsLength.lengths;
    var totalLength = 0;
    for (i = 0; i < len - 1; i += 1) {
      lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
      totalLength += lengths[i].addedLength;
    }
    if (closed && len) {
      lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
      totalLength += lengths[i].addedLength;
    }
    segmentsLength.totalLength = totalLength;
    return segmentsLength;
  }

  function BezierData(length) {
    this.segmentLength = 0;
    this.points = new Array(length);
  }

  function PointData(partial, point) {
    this.partialLength = partial;
    this.point = point;
  }

  var buildBezierData = (function () {
    var storedData = {};

    return function (pt1, pt2, pt3, pt4) {
      var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
      if (!storedData[bezierName]) {
        var curveSegments = defaultCurveSegments;
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point;
        var lastPoint = null;
        if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
          curveSegments = 2;
        }
        var bezierData = new BezierData(curveSegments);
        len = pt3.length;
        for (k = 0; k < curveSegments; k += 1) {
          point = createSizedArray(len);
          perc = k / (curveSegments - 1);
          ptDistance = 0;
          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;
            if (lastPoint !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }
          }
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
          bezierData.points[k] = new PointData(ptDistance, point);
          lastPoint = point;
        }
        bezierData.segmentLength = addedLength;
        storedData[bezierName] = bezierData;
      }
      return storedData[bezierName];
    };
  }());

  function getDistancePerc(perc, bezierData) {
    var percents = bezierData.percents;
    var lengths = bezierData.lengths;
    var len = percents.length;
    var initPos = bmFloor((len - 1) * perc);
    var lengthPos = perc * bezierData.addedLength;
    var lPerc = 0;
    if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
      return percents[initPos];
    }
    var dir = lengths[initPos] > lengthPos ? -1 : 1;
    var flag = true;
    while (flag) {
      if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
        lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
        flag = false;
      } else {
        initPos += dir;
      }
      if (initPos < 0 || initPos >= len - 1) {
        // FIX for TypedArrays that don't store floating point values with enough accuracy
        if (initPos === len - 1) {
          return percents[initPos];
        }
        flag = false;
      }
    }
    return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
  }

  function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
    var t1 = getDistancePerc(percent, bezierData);
    var u1 = 1 - t1;
    var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
    var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
    return [ptX, ptY];
  }

  var bezierSegmentPoints = createTypedArray('float32', 8);

  function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
    if (startPerc < 0) {
      startPerc = 0;
    } else if (startPerc > 1) {
      startPerc = 1;
    }
    var t0 = getDistancePerc(startPerc, bezierData);
    endPerc = endPerc > 1 ? 1 : endPerc;
    var t1 = getDistancePerc(endPerc, bezierData);
    var i;
    var len = pt1.length;
    var u0 = 1 - t0;
    var u1 = 1 - t1;
    var u0u0u0 = u0 * u0 * u0;
    var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0t0 = t0 * t0 * t0;
    //
    var u0u0u1 = u0 * u0 * u1;
    var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0t1 = t0 * t0 * t1;
    //
    var u0u1u1 = u0 * u1 * u1;
    var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1t1 = t0 * t1 * t1;
    //
    var u1u1u1 = u1 * u1 * u1;
    var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1t1 = t1 * t1 * t1;
    for (i = 0; i < len; i += 1) {
      bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
    }

    return bezierSegmentPoints;
  }

  return {
    getSegmentsLength: getSegmentsLength,
    getNewSegment: getNewSegment,
    getPointInSegment: getPointInSegment,
    buildBezierData: buildBezierData,
    pointOnLine2D: pointOnLine2D,
    pointOnLine3D: pointOnLine3D,
  };
}

var bez = bezFunction();

/* global _useWebWorker */

var dataManager = (function () {
  var _counterId = 1;
  var processes = [];
  var workerFn;
  var workerInstance;
  var workerProxy = {
    onmessage: function () {

    },
    postMessage: function (path) {
      workerFn({
        data: path,
      });
    },
  };
  var _workerSelf = {
    postMessage: function (data) {
      workerProxy.onmessage({
        data: data,
      });
    },
  };
  function createWorker(fn) {
    if (window.Worker && window.Blob && _useWebWorker) {
      var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], { type: 'text/javascript' });
      // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
      var url = URL.createObjectURL(blob);
      return new Worker(url);
    }
    workerFn = fn;
    return workerProxy;
  }

  function setupWorker() {
    if (!workerInstance) {
      workerInstance = createWorker(function workerStart(e) {
        /* exported dataManager */

        function dataFunctionManager() {
          // var tCanvasHelper = createTag('canvas').getContext('2d');

          function completeLayers(layers, comps) {
            var layerData;
            var i;
            var len = layers.length;
            var j;
            var jLen;
            var k;
            var kLen;
            for (i = 0; i < len; i += 1) {
              layerData = layers[i];
              if (('ks' in layerData) && !layerData.completed) {
                layerData.completed = true;
                if (layerData.tt) {
                  layers[i - 1].td = layerData.tt;
                }
                if (layerData.hasMask) {
                  var maskProps = layerData.masksProperties;
                  jLen = maskProps.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (maskProps[j].pt.k.i) {
                      convertPathsToAbsoluteValues(maskProps[j].pt.k);
                    } else {
                      kLen = maskProps[j].pt.k.length;
                      for (k = 0; k < kLen; k += 1) {
                        if (maskProps[j].pt.k[k].s) {
                          convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                        }
                        if (maskProps[j].pt.k[k].e) {
                          convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                        }
                      }
                    }
                  }
                }
                if (layerData.ty === 0) {
                  layerData.layers = findCompLayers(layerData.refId, comps);
                  completeLayers(layerData.layers, comps);
                } else if (layerData.ty === 4) {
                  completeShapes(layerData.shapes);
                } else if (layerData.ty === 5) {
                  completeText(layerData);
                }
              }
            }
          }

          function findCompLayers(id, comps) {
            var i = 0;
            var len = comps.length;
            while (i < len) {
              if (comps[i].id === id) {
                if (!comps[i].layers.__used) {
                  comps[i].layers.__used = true;
                  return comps[i].layers;
                }
                return JSON.parse(JSON.stringify(comps[i].layers));
              }
              i += 1;
            }
            return null;
          }

          function completeShapes(arr) {
            var i;
            var len = arr.length;
            var j;
            var jLen;
            for (i = len - 1; i >= 0; i -= 1) {
              if (arr[i].ty === 'sh') {
                if (arr[i].ks.k.i) {
                  convertPathsToAbsoluteValues(arr[i].ks.k);
                } else {
                  jLen = arr[i].ks.k.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (arr[i].ks.k[j].s) {
                      convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                    }
                    if (arr[i].ks.k[j].e) {
                      convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                    }
                  }
                }
              } else if (arr[i].ty === 'gr') {
                completeShapes(arr[i].it);
              }
            }
          }

          function convertPathsToAbsoluteValues(path) {
            var i;
            var len = path.i.length;
            for (i = 0; i < len; i += 1) {
              path.i[i][0] += path.v[i][0];
              path.i[i][1] += path.v[i][1];
              path.o[i][0] += path.v[i][0];
              path.o[i][1] += path.v[i][1];
            }
          }

          function checkVersion(minimum, animVersionString) {
            var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
            if (minimum[0] > animVersion[0]) {
              return true;
            } if (animVersion[0] > minimum[0]) {
              return false;
            }
            if (minimum[1] > animVersion[1]) {
              return true;
            } if (animVersion[1] > minimum[1]) {
              return false;
            }
            if (minimum[2] > animVersion[2]) {
              return true;
            } if (animVersion[2] > minimum[2]) {
              return false;
            }
            return null;
          }

          var checkText = (function () {
            var minimumVersion = [4, 4, 14];

            function updateTextLayer(textLayer) {
              var documentData = textLayer.t.d;
              textLayer.t.d = {
                k: [
                  {
                    s: documentData,
                    t: 0,
                  },
                ],
              };
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 5) {
                  updateTextLayer(layers[i]);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkChars = (function () {
            var minimumVersion = [4, 7, 99];
            return function (animationData) {
              if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                var i;
                var len = animationData.chars.length;
                var j;
                var jLen;
                var pathData;
                var paths;
                for (i = 0; i < len; i += 1) {
                  if (animationData.chars[i].data && animationData.chars[i].data.shapes) {
                    paths = animationData.chars[i].data.shapes[0].it;
                    jLen = paths.length;

                    for (j = 0; j < jLen; j += 1) {
                      pathData = paths[j].ks.k;
                      if (!pathData.__converted) {
                        convertPathsToAbsoluteValues(paths[j].ks.k);
                        pathData.__converted = true;
                      }
                    }
                  }
                }
              }
            };
          }());

          var checkPathProperties = (function () {
            var minimumVersion = [5, 7, 15];

            function updateTextLayer(textLayer) {
              var pathData = textLayer.t.p;
              if (typeof pathData.a === 'number') {
                pathData.a = {
                  a: 0,
                  k: pathData.a,
                };
              }
              if (typeof pathData.p === 'number') {
                pathData.p = {
                  a: 0,
                  k: pathData.p,
                };
              }
              if (typeof pathData.r === 'number') {
                pathData.r = {
                  a: 0,
                  k: pathData.r,
                };
              }
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 5) {
                  updateTextLayer(layers[i]);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkColors = (function () {
            var minimumVersion = [4, 1, 9];

            function iterateShapes(shapes) {
              var i;
              var len = shapes.length;
              var j;
              var jLen;
              for (i = 0; i < len; i += 1) {
                if (shapes[i].ty === 'gr') {
                  iterateShapes(shapes[i].it);
                } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                  if (shapes[i].c.k && shapes[i].c.k[0].i) {
                    jLen = shapes[i].c.k.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (shapes[i].c.k[j].s) {
                        shapes[i].c.k[j].s[0] /= 255;
                        shapes[i].c.k[j].s[1] /= 255;
                        shapes[i].c.k[j].s[2] /= 255;
                        shapes[i].c.k[j].s[3] /= 255;
                      }
                      if (shapes[i].c.k[j].e) {
                        shapes[i].c.k[j].e[0] /= 255;
                        shapes[i].c.k[j].e[1] /= 255;
                        shapes[i].c.k[j].e[2] /= 255;
                        shapes[i].c.k[j].e[3] /= 255;
                      }
                    }
                  } else {
                    shapes[i].c.k[0] /= 255;
                    shapes[i].c.k[1] /= 255;
                    shapes[i].c.k[2] /= 255;
                    shapes[i].c.k[3] /= 255;
                  }
                }
              }
            }

            function iterateLayers(layers) {
              var i;
              var len = layers.length;
              for (i = 0; i < len; i += 1) {
                if (layers[i].ty === 4) {
                  iterateShapes(layers[i].shapes);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          var checkShapes = (function () {
            var minimumVersion = [4, 4, 18];

            function completeClosingShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;
              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    arr[i].ks.k.c = arr[i].closed;
                  } else {
                    jLen = arr[i].ks.k.length;
                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        arr[i].ks.k[j].s[0].c = arr[i].closed;
                      }
                      if (arr[i].ks.k[j].e) {
                        arr[i].ks.k[j].e[0].c = arr[i].closed;
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeClosingShapes(arr[i].it);
                }
              }
            }

            function iterateLayers(layers) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;
              for (i = 0; i < len; i += 1) {
                layerData = layers[i];
                if (layerData.hasMask) {
                  var maskProps = layerData.masksProperties;
                  jLen = maskProps.length;
                  for (j = 0; j < jLen; j += 1) {
                    if (maskProps[j].pt.k.i) {
                      maskProps[j].pt.k.c = maskProps[j].cl;
                    } else {
                      kLen = maskProps[j].pt.k.length;
                      for (k = 0; k < kLen; k += 1) {
                        if (maskProps[j].pt.k[k].s) {
                          maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                        }
                        if (maskProps[j].pt.k[k].e) {
                          maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                        }
                      }
                    }
                  }
                }
                if (layerData.ty === 4) {
                  completeClosingShapes(layerData.shapes);
                }
              }
            }

            return function (animationData) {
              if (checkVersion(minimumVersion, animationData.v)) {
                iterateLayers(animationData.layers);
                if (animationData.assets) {
                  var i;
                  var len = animationData.assets.length;
                  for (i = 0; i < len; i += 1) {
                    if (animationData.assets[i].layers) {
                      iterateLayers(animationData.assets[i].layers);
                    }
                  }
                }
              }
            };
          }());

          function completeData(animationData) {
            if (animationData.__complete) {
              return;
            }
            checkColors(animationData);
            checkText(animationData);
            checkChars(animationData);
            checkPathProperties(animationData);
            checkShapes(animationData);
            completeLayers(animationData.layers, animationData.assets);
            animationData.__complete = true;
          }

          function completeText(data) {
            if (data.t.a.length === 0 && !('m' in data.t.p)) {
              data.singleShape = true;
            }
          }

          var moduleOb = {};
          moduleOb.completeData = completeData;
          moduleOb.checkColors = checkColors;
          moduleOb.checkChars = checkChars;
          moduleOb.checkPathProperties = checkPathProperties;
          moduleOb.checkShapes = checkShapes;
          moduleOb.completeLayers = completeLayers;

          return moduleOb;
        }
        if (!_workerSelf.dataManager) {
          _workerSelf.dataManager = dataFunctionManager();
        }

        /* exported assetLoader */
        if (!_workerSelf.assetLoader) {
          _workerSelf.assetLoader = (function () {
            function formatResponse(xhr) {
              // using typeof doubles the time of execution of this method,
              // so if available, it's better to use the header to validate the type
              var contentTypeHeader = xhr.getResponseHeader('content-type');
              if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                return xhr.response;
              }
              if (xhr.response && typeof xhr.response === 'object') {
                return xhr.response;
              } if (xhr.response && typeof xhr.response === 'string') {
                return JSON.parse(xhr.response);
              } if (xhr.responseText) {
                return JSON.parse(xhr.responseText);
              }
              return null;
            }

            function loadAsset(path, fullPath, callback, errorCallback) {
              var response;
              var xhr = new XMLHttpRequest();
              // set responseType after calling open or IE will break.
              try {
                // This crashes on Android WebView prior to KitKat
                xhr.responseType = 'json';
              } catch (err) {} // eslint-disable-line no-empty
              xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                  if (xhr.status === 200) {
                    response = formatResponse(xhr);
                    callback(response);
                  } else {
                    try {
                      response = formatResponse(xhr);
                      callback(response);
                    } catch (err) {
                      if (errorCallback) {
                        errorCallback(err);
                      }
                    }
                  }
                }
              };
              try {
                xhr.open('GET', path, true);
              } catch (error) {
                xhr.open('GET', fullPath + '/' + path, true);
              }
              xhr.send();
            }
            return {
              load: loadAsset,
            };
          }());
        }

        if (e.data.type === 'loadAnimation') {
          _workerSelf.assetLoader.load(
            e.data.path,
            e.data.fullPath,
            function (data) {
              _workerSelf.dataManager.completeData(data);
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success',
              });
            },
            function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error',
              });
            }
          );
        } else if (e.data.type === 'complete') {
          var animation = e.data.animation;
          _workerSelf.dataManager.completeData(animation);
          _workerSelf.postMessage({
            id: e.data.id,
            payload: animation,
            status: 'success',
          });
        } else if (e.data.type === 'loadData') {
          _workerSelf.assetLoader.load(
            e.data.path,
            e.data.fullPath,
            function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success',
              });
            },
            function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error',
              });
            }
          );
        }
      });

      workerInstance.onmessage = function (event) {
        var data = event.data;
        var id = data.id;
        var process = processes[id];
        processes[id] = null;
        if (data.status === 'success') {
          process.onComplete(data.payload);
        } else if (process.onError) {
          process.onError();
        }
      };
    }
  }

  function createProcess(onComplete, onError) {
    _counterId += 1;
    var id = 'processId_' + _counterId;
    processes[id] = {
      onComplete: onComplete,
      onError: onError,
    };
    return id;
  }

  function loadAnimation(path, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'loadAnimation',
      path: path,
      fullPath: window.location.origin + window.location.pathname,
      id: processId,
    });
  }

  function loadData(path, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'loadData',
      path: path,
      fullPath: window.location.origin + window.location.pathname,
      id: processId,
    });
  }

  function completeAnimation(anim, onComplete, onError) {
    setupWorker();
    var processId = createProcess(onComplete, onError);
    workerInstance.postMessage({
      type: 'complete',
      animation: anim,
      id: processId,
    });
  }

  return {
    loadAnimation: loadAnimation,
    loadData: loadData,
    completeAnimation: completeAnimation,
  };
}());

/* exported getFontProperties */

function getFontProperties(fontData) {
  var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];

  var fWeight = 'normal'; var
    fStyle = 'normal';
  var len = styles.length;
  var styleName;
  for (var i = 0; i < len; i += 1) {
    styleName = styles[i].toLowerCase();
    switch (styleName) {
      case 'italic':
        fStyle = 'italic';
        break;
      case 'bold':
        fWeight = '700';
        break;
      case 'black':
        fWeight = '900';
        break;
      case 'medium':
        fWeight = '500';
        break;
      case 'regular':
      case 'normal':
        fWeight = '400';
        break;
      case 'light':
      case 'thin':
        fWeight = '200';
        break;
      default:
        break;
    }
  }

  return {
    style: fStyle,
    weight: fontData.fWeight || fWeight,
  };
}

/* global createNS, createTag, getFontProperties */
/* exported FontManager */

var FontManager = (function () {
  var maxWaitingTime = 5000;
  var emptyChar = {
    w: 0,
    size: 0,
    shapes: [],
  };
  var combinedCharacters = [];
  // Hindi characters
  combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366,
    2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379,
    2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);

  var surrogateModifiers = [
    'd83cdffb',
    'd83cdffc',
    'd83cdffd',
    'd83cdffe',
    'd83cdfff',
  ];

  var zeroWidthJoiner = [65039, 8205];

  function trimFontOptions(font) {
    var familyArray = font.split(',');
    var i;
    var len = familyArray.length;
    var enabledFamilies = [];
    for (i = 0; i < len; i += 1) {
      if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
        enabledFamilies.push(familyArray[i]);
      }
    }
    return enabledFamilies.join(',');
  }

  function setUpNode(font, family) {
    var parentNode = createTag('span');
    // Node is invisible to screen readers.
    parentNode.setAttribute('aria-hidden', true);
    parentNode.style.fontFamily = family;
    var node = createTag('span');
    // Characters that vary significantly among different fonts
    node.innerText = 'giItT1WQy@!-/#';
    // Visible - so we can measure it - but not on the screen
    parentNode.style.position = 'absolute';
    parentNode.style.left = '-10000px';
    parentNode.style.top = '-10000px';
    // Large font size makes even subtle changes obvious
    parentNode.style.fontSize = '300px';
    // Reset any font properties
    parentNode.style.fontVariant = 'normal';
    parentNode.style.fontStyle = 'normal';
    parentNode.style.fontWeight = 'normal';
    parentNode.style.letterSpacing = '0';
    parentNode.appendChild(node);
    document.body.appendChild(parentNode);

    // Remember width with no applied web font
    var width = node.offsetWidth;
    node.style.fontFamily = trimFontOptions(font) + ', ' + family;
    return { node: node, w: width, parent: parentNode };
  }

  function checkLoadedFonts() {
    var i;
    var len = this.fonts.length;
    var node;
    var w;
    var loadedCount = len;
    for (i = 0; i < len; i += 1) {
      if (this.fonts[i].loaded) {
        loadedCount -= 1;
      } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
        this.fonts[i].loaded = true;
      } else {
        node = this.fonts[i].monoCase.node;
        w = this.fonts[i].monoCase.w;
        if (node.offsetWidth !== w) {
          loadedCount -= 1;
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].sansCase.node;
          w = this.fonts[i].sansCase.w;
          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          }
        }
        if (this.fonts[i].loaded) {
          this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
          this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
        }
      }
    }

    if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
      setTimeout(this.checkLoadedFontsBinded, 20);
    } else {
      setTimeout(this.setIsLoadedBinded, 10);
    }
  }

  function createHelper(def, fontData) {
    var tHelper = createNS('text');
    tHelper.style.fontSize = '100px';
    // tHelper.style.fontFamily = fontData.fFamily;

    var fontProps = getFontProperties(fontData);
    tHelper.setAttribute('font-family', fontData.fFamily);
    tHelper.setAttribute('font-style', fontProps.style);
    tHelper.setAttribute('font-weight', fontProps.weight);
    tHelper.textContent = '1';
    if (fontData.fClass) {
      tHelper.style.fontFamily = 'inherit';
      tHelper.setAttribute('class', fontData.fClass);
    } else {
      tHelper.style.fontFamily = fontData.fFamily;
    }
    def.appendChild(tHelper);
    var tCanvasHelper = createTag('canvas').getContext('2d');
    tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px ' + fontData.fFamily;
    // tCanvasHelper.font = ' 100px '+ fontData.fFamily;
    return tHelper;
  }

  function addFonts(fontData, defs) {
    if (!fontData) {
      this.isLoaded = true;
      return;
    }
    if (this.chars) {
      this.isLoaded = true;
      this.fonts = fontData.list;
      return;
    }

    var fontArr = fontData.list;
    var i;
    var len = fontArr.length;
    var _pendingFonts = len;
    for (i = 0; i < len; i += 1) {
      var shouldLoadFont = true;
      var loadedSelector;
      var j;
      fontArr[i].loaded = false;
      fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
      fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
      if (!fontArr[i].fPath) {
        fontArr[i].loaded = true;
        _pendingFonts -= 1;
      } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
        loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

        if (loadedSelector.length > 0) {
          shouldLoadFont = false;
        }

        if (shouldLoadFont) {
          var s = createTag('style');
          s.setAttribute('f-forigin', fontArr[i].fOrigin);
          s.setAttribute('f-origin', fontArr[i].origin);
          s.setAttribute('f-family', fontArr[i].fFamily);
          s.type = 'text/css';
          s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
          defs.appendChild(s);
        }
      } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
        loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var l = createTag('link');
          l.setAttribute('f-forigin', fontArr[i].fOrigin);
          l.setAttribute('f-origin', fontArr[i].origin);
          l.type = 'text/css';
          l.rel = 'stylesheet';
          l.href = fontArr[i].fPath;
          document.body.appendChild(l);
        }
      } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
        loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (fontArr[i].fPath === loadedSelector[j].src) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var sc = createTag('link');
          sc.setAttribute('f-forigin', fontArr[i].fOrigin);
          sc.setAttribute('f-origin', fontArr[i].origin);
          sc.setAttribute('rel', 'stylesheet');
          sc.setAttribute('href', fontArr[i].fPath);
          defs.appendChild(sc);
        }
      }
      fontArr[i].helper = createHelper(defs, fontArr[i]);
      fontArr[i].cache = {};
      this.fonts.push(fontArr[i]);
    }
    if (_pendingFonts === 0) {
      this.isLoaded = true;
    } else {
      // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
      // Adding this timeout seems to fix it
      setTimeout(this.checkLoadedFonts.bind(this), 100);
    }
  }

  function addChars(chars) {
    if (!chars) {
      return;
    }
    if (!this.chars) {
      this.chars = [];
    }
    var i;
    var len = chars.length;
    var j;
    var jLen = this.chars.length;
    var found;
    for (i = 0; i < len; i += 1) {
      j = 0;
      found = false;
      while (j < jLen) {
        if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
          found = true;
        }
        j += 1;
      }
      if (!found) {
        this.chars.push(chars[i]);
        jLen += 1;
      }
    }
  }

  function getCharData(char, style, font) {
    var i = 0;
    var len = this.chars.length;
    while (i < len) {
      if (this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font) {
        return this.chars[i];
      }
      i += 1;
    }
    if (((typeof char === 'string' && char.charCodeAt(0) !== 13) || !char)
            && console
            && console.warn // eslint-disable-line no-console
            && !this._warned
    ) {
      this._warned = true;
      console.warn('Missing character from exported characters list: ', char, style, font); // eslint-disable-line no-console
    }
    return emptyChar;
  }

  function measureText(char, fontName, size) {
    var fontData = this.getFontByName(fontName);
    var index = char.charCodeAt(0);
    if (!fontData.cache[index + 1]) {
      var tHelper = fontData.helper;
      // Canvas version
      // fontData.cache[index] = tHelper.measureText(char).width / 100;
      // SVG version
      // console.log(tHelper.getBBox().width)
      if (char === ' ') {
        tHelper.textContent = '|' + char + '|';
        var doubleSize = tHelper.getComputedTextLength();
        tHelper.textContent = '||';
        var singleSize = tHelper.getComputedTextLength();
        fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
      } else {
        tHelper.textContent = char;
        fontData.cache[index + 1] = (tHelper.getComputedTextLength()) / 100;
      }
    }
    return fontData.cache[index + 1] * size;
  }

  function getFontByName(name) {
    var i = 0;
    var len = this.fonts.length;
    while (i < len) {
      if (this.fonts[i].fName === name) {
        return this.fonts[i];
      }
      i += 1;
    }
    return this.fonts[0];
  }

  function isModifier(firstCharCode, secondCharCode) {
    var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
    return surrogateModifiers.indexOf(sum) !== -1;
  }

  function isZeroWidthJoiner(firstCharCode, secondCharCode) {
    if (!secondCharCode) {
      return firstCharCode === zeroWidthJoiner[1];
    }
    return firstCharCode === zeroWidthJoiner[0] && secondCharCode === zeroWidthJoiner[1];
  }

  function isCombinedCharacter(char) {
    return combinedCharacters.indexOf(char) !== -1;
  }

  function setIsLoaded() {
    this.isLoaded = true;
  }

  var Font = function () {
    this.fonts = [];
    this.chars = null;
    this.typekitLoaded = 0;
    this.isLoaded = false;
    this._warned = false;
    this.initTime = Date.now();
    this.setIsLoadedBinded = this.setIsLoaded.bind(this);
    this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
  };
  Font.isModifier = isModifier;
  Font.isZeroWidthJoiner = isZeroWidthJoiner;
  Font.isCombinedCharacter = isCombinedCharacter;

  var fontPrototype = {
    addChars: addChars,
    addFonts: addFonts,
    getCharData: getCharData,
    getFontByName: getFontByName,
    measureText: measureText,
    checkLoadedFonts: checkLoadedFonts,
    setIsLoaded: setIsLoaded,
  };

  Font.prototype = fontPrototype;

  return Font;
}());

/* global initialDefaultFrame, BezierFactory, degToRads, bez, createTypedArray */
/* exported PropertyFactory */

var PropertyFactory = (function () {
  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];
      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }
        iterationIndex = 0;
        break;
      }
      if ((nextKeyData.t - offsetTime) > frameNum) {
        iterationIndex = i;
        break;
      }
      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }
    keyframeMetadata = this.keyframesMetadata[i] || {};

    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
      if (!keyframeMetadata.bezierData) {
        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }
      var bezierData = keyframeMetadata.bezierData;
      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;
        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        }
        // caching._lastKeyframeIndex = -1;
      } else {
        if (keyframeMetadata.__fnct) {
          fnc = keyframeMetadata.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyframeMetadata.__fnct = fnc;
        }
        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;

        var segmentPerc;
        var addedLength = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastAddedLength : 0;
        j = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;
        while (flag) {
          addedLength += bezierData.points[j].partialLength;
          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }
            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }
            break;
          }
          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }
        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;
      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyframeMetadata.__fnct) {
                  keyframeMetadata.__fnct = [];
                }
                if (!keyframeMetadata.__fnct[i]) {
                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyframeMetadata.__fnct[i] = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct[i];
                }
              } else if (!keyframeMetadata.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.keyframeMetadata = fnc;
              } else {
                fnc = keyframeMetadata.__fnct;
              }
              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
  }

  // based on @Toji's https://github.com/toji/gl-matrix/
  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];

    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;

    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }
    if ((1.0 - cosom) > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;

    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;

    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;
      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;
      while (i < len) {
        multipliedValue = val[i] * this.mult;
        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }
        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1,
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if ((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2]))) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);
    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }
    this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray('float32', arrLen) };
    this.addEffect = addEffect;
  }

  function getProp(elem, data, type, mult, container) {
    var p;
    if (!data.k.length) {
      p = new ValueProperty(elem, data, mult, container);
    } else if (typeof (data.k[0]) === 'number') {
      p = new MultiDimensionalProperty(elem, data, mult, container);
    } else {
      switch (type) {
        case 0:
          p = new KeyframedValueProperty(elem, data, mult, container);
          break;
        case 1:
          p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
          break;
        default:
          break;
      }
    }
    if (p.effectsSequence.length) {
      container.addDynamicProperty(p);
    }
    return p;
  }

  var ob = {
    getProp: getProp,
  };
  return ob;
}());

/* global Matrix, degToRads, PropertyFactory, extendPrototype, DynamicPropertyContainer */
/* exported TransformPropertyFactory */

var TransformPropertyFactory = (function () {
  var defaultVector = [0, 0];

  function applyToMatrix(mat) {
    var _mdf = this._mdf;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || _mdf;
    if (this.a) {
      mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
    }
    if (this.s) {
      mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
    }
    if (this.sk) {
      mat.skewFromAxis(-this.sk.v, this.sa.v);
    }
    if (this.r) {
      mat.rotate(-this.r.v);
    } else {
      mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
    }
    if (this.data.p.s) {
      if (this.data.p.z) {
        mat.translate(this.px.v, this.py.v, -this.pz.v);
      } else {
        mat.translate(this.px.v, this.py.v, 0);
      }
    } else {
      mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
    }
  }
  function processKeys(forceRender) {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }
    if (this._isDirty) {
      this.precalculateMatrix();
      this._isDirty = false;
    }

    this.iterateDynamicProperties();

    if (this._mdf || forceRender) {
      var frameRate;
      this.v.cloneFromProps(this.pre.props);
      if (this.appliedTransformations < 1) {
        this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }
      if (this.appliedTransformations < 2) {
        this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }
      if (this.sk && this.appliedTransformations < 3) {
        this.v.skewFromAxis(-this.sk.v, this.sa.v);
      }
      if (this.r && this.appliedTransformations < 4) {
        this.v.rotate(-this.r.v);
      } else if (!this.r && this.appliedTransformations < 4) {
        this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
          .rotateY(this.or.v[1])
          .rotateX(this.or.v[0]);
      }
      if (this.autoOriented) {
        var v1;
        var v2;
        frameRate = this.elem.globalData.frameRate;
        if (this.p && this.p.keyframes && this.p.getValueAtTime) {
          if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
          } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
          } else {
            v1 = this.p.pv;
            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
          }
        } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
          v1 = [];
          v2 = [];
          var px = this.px;
          var py = this.py;
          if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
            v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate, 0);
          } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
            v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate), 0);
            v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate), 0);
            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
          } else {
            v1 = [px.pv, py.pv];
            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
          }
        } else {
          v2 = defaultVector;
          v1 = v2;
        }
        this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
      }
      if (this.data.p && this.data.p.s) {
        if (this.data.p.z) {
          this.v.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          this.v.translate(this.px.v, this.py.v, 0);
        }
      } else {
        this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }
    this.frameId = this.elem.globalData.frameId;
  }

  function precalculateMatrix() {
    if (!this.a.k) {
      this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      this.appliedTransformations = 1;
    } else {
      return;
    }
    if (!this.s.effectsSequence.length) {
      this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      this.appliedTransformations = 2;
    } else {
      return;
    }
    if (this.sk) {
      if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
        this.pre.skewFromAxis(-this.sk.v, this.sa.v);
        this.appliedTransformations = 3;
      } else {
        return;
      }
    }
    if (this.r) {
      if (!this.r.effectsSequence.length) {
        this.pre.rotate(-this.r.v);
        this.appliedTransformations = 4;
      }
    } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
      this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
      this.appliedTransformations = 4;
    }
  }

  function autoOrient() {
    //
    // var prevP = this.getValueAtTime();
  }

  function addDynamicProperty(prop) {
    this._addDynamicProperty(prop);
    this.elem.addDynamicProperty(prop);
    this._isDirty = true;
  }

  function TransformProperty(elem, data, container) {
    this.elem = elem;
    this.frameId = -1;
    this.propType = 'transform';
    this.data = data;
    this.v = new Matrix();
    // Precalculated matrix with non animated properties
    this.pre = new Matrix();
    this.appliedTransformations = 0;
    this.initDynamicPropertyContainer(container || elem);
    if (data.p && data.p.s) {
      this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
      this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
      if (data.p.z) {
        this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
      }
    } else {
      this.p = PropertyFactory.getProp(elem, data.p || { k: [0, 0, 0] }, 1, 0, this);
    }
    if (data.rx) {
      this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
      this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
      this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
      if (data.or.k[0].ti) {
        var i;
        var len = data.or.k.length;
        for (i = 0; i < len; i += 1) {
          data.or.k[i].to = null;
          data.or.k[i].ti = null;
        }
      }
      this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
      // sh Indicates it needs to be capped between -180 and 180
      this.or.sh = true;
    } else {
      this.r = PropertyFactory.getProp(elem, data.r || { k: 0 }, 0, degToRads, this);
    }
    if (data.sk) {
      this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
      this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
    }
    this.a = PropertyFactory.getProp(elem, data.a || { k: [0, 0, 0] }, 1, 0, this);
    this.s = PropertyFactory.getProp(elem, data.s || { k: [100, 100, 100] }, 1, 0.01, this);
    // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
    if (data.o) {
      this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
    } else {
      this.o = { _mdf: false, v: 1 };
    }
    this._isDirty = true;
    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }
  }

  TransformProperty.prototype = {
    applyToMatrix: applyToMatrix,
    getValue: processKeys,
    precalculateMatrix: precalculateMatrix,
    autoOrient: autoOrient,
  };

  extendPrototype([DynamicPropertyContainer], TransformProperty);
  TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
  TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

  function getTransformProperty(elem, data, container) {
    return new TransformProperty(elem, data, container);
  }

  return {
    getTransformProperty: getTransformProperty,
  };
}());

/* global createSizedArray, createSizedArray, pointPool */

function ShapePath() {
  this.c = false;
  this._length = 0;
  this._maxLength = 8;
  this.v = createSizedArray(this._maxLength);
  this.o = createSizedArray(this._maxLength);
  this.i = createSizedArray(this._maxLength);
}

ShapePath.prototype.setPathData = function (closed, len) {
  this.c = closed;
  this.setLength(len);
  var i = 0;
  while (i < len) {
    this.v[i] = pointPool.newElement();
    this.o[i] = pointPool.newElement();
    this.i[i] = pointPool.newElement();
    i += 1;
  }
};

ShapePath.prototype.setLength = function (len) {
  while (this._maxLength < len) {
    this.doubleArrayLength();
  }
  this._length = len;
};

ShapePath.prototype.doubleArrayLength = function () {
  this.v = this.v.concat(createSizedArray(this._maxLength));
  this.i = this.i.concat(createSizedArray(this._maxLength));
  this.o = this.o.concat(createSizedArray(this._maxLength));
  this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
  var arr;
  this._length = Math.max(this._length, pos + 1);
  if (this._length >= this._maxLength) {
    this.doubleArrayLength();
  }
  switch (type) {
    case 'v':
      arr = this.v;
      break;
    case 'i':
      arr = this.i;
      break;
    case 'o':
      arr = this.o;
      break;
    default:
      arr = [];
      break;
  }
  if (!arr[pos] || (arr[pos] && !replace)) {
    arr[pos] = pointPool.newElement();
  }
  arr[pos][0] = x;
  arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
  this.setXYAt(vX, vY, 'v', pos, replace);
  this.setXYAt(oX, oY, 'o', pos, replace);
  this.setXYAt(iX, iY, 'i', pos, replace);
};

ShapePath.prototype.reverse = function () {
  var newPath = new ShapePath();
  newPath.setPathData(this.c, this._length);
  var vertices = this.v;
  var outPoints = this.o;
  var inPoints = this.i;
  var init = 0;
  if (this.c) {
    newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
    init = 1;
  }
  var cnt = this._length - 1;
  var len = this._length;

  var i;
  for (i = init; i < len; i += 1) {
    newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
    cnt -= 1;
  }
  return newPath;
};

/* global extendPrototype, roundCorner, BezierFactory, shapePool, degToRads,
  shapeCollectionPool, PropertyFactory, bmMin, DynamicPropertyContainer */
/* exported ShapePropertyFactory */

var ShapePropertyFactory = (function () {
  var initFrame = -999999;

  function interpolateShape(frameNum, previousValue, caching) {
    var iterationIndex = caching.lastIndex;
    var keyPropS;
    var keyPropE;
    var isHold;
    var j;
    var k;
    var jLen;
    var kLen;
    var perc;
    var vertexValue;
    var kf = this.keyframes;
    if (frameNum < kf[0].t - this.offsetTime) {
      keyPropS = kf[0].s[0];
      isHold = true;
      iterationIndex = 0;
    } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
      keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
      /* if(kf[kf.length - 1].s){
                keyPropS = kf[kf.length - 1].s[0];
            }else{
                keyPropS = kf[kf.length - 2].e[0];
            } */
      isHold = true;
    } else {
      var i = iterationIndex;
      var len = kf.length - 1;
      var flag = true;
      var keyData;
      var nextKeyData;
      var keyframeMetadata;
      while (flag) {
        keyData = kf[i];
        nextKeyData = kf[i + 1];
        if ((nextKeyData.t - this.offsetTime) > frameNum) {
          break;
        }
        if (i < len - 1) {
          i += 1;
        } else {
          flag = false;
        }
      }
      keyframeMetadata = this.keyframesMetadata[i] || {};
      isHold = keyData.h === 1;
      iterationIndex = i;
      if (!isHold) {
        if (frameNum >= nextKeyData.t - this.offsetTime) {
          perc = 1;
        } else if (frameNum < keyData.t - this.offsetTime) {
          perc = 0;
        } else {
          var fnc;
          if (keyframeMetadata.__fnct) {
            fnc = keyframeMetadata.__fnct;
          } else {
            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
            keyframeMetadata.__fnct = fnc;
          }
          perc = fnc((frameNum - (keyData.t - this.offsetTime)) / ((nextKeyData.t - this.offsetTime) - (keyData.t - this.offsetTime)));
        }
        keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
      }
      keyPropS = keyData.s[0];
    }
    jLen = previousValue._length;
    kLen = keyPropS.i[0].length;
    caching.lastIndex = iterationIndex;

    for (j = 0; j < jLen; j += 1) {
      for (k = 0; k < kLen; k += 1) {
        vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
        previousValue.i[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
        previousValue.o[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
        previousValue.v[j][k] = vertexValue;
      }
    }
  }

  function interpolateShapeCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    var lastFrame = this._caching.lastFrame;
    if (!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))) {
      /// /
      this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
      this.interpolateShape(frameNum, this.pv, this._caching);
      /// /
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function resetShape() {
    this.paths = this.localShapeCollection;
  }

  function shapesEqual(shape1, shape2) {
    if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
      return false;
    }
    var i;
    var len = shape1._length;
    for (i = 0; i < len; i += 1) {
      if (shape1.v[i][0] !== shape2.v[i][0]
            || shape1.v[i][1] !== shape2.v[i][1]
            || shape1.o[i][0] !== shape2.o[i][0]
            || shape1.o[i][1] !== shape2.o[i][1]
            || shape1.i[i][0] !== shape2.i[i][0]
            || shape1.i[i][1] !== shape2.i[i][1]) {
        return false;
      }
    }
    return true;
  }

  function setVValue(newPath) {
    if (!shapesEqual(this.v, newPath)) {
      this.v = shapePool.clone(newPath);
      this.localShapeCollection.releaseShapes();
      this.localShapeCollection.addShape(this.v);
      this._mdf = true;
      this.paths = this.localShapeCollection;
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    } if (!this.effectsSequence.length) {
      this._mdf = false;
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = false;
    var finalValue;
    if (this.kf) {
      finalValue = this.pv;
    } else if (this.data.ks) {
      finalValue = this.data.ks.k;
    } else {
      finalValue = this.data.pt.k;
    }
    var i;
    var len = this.effectsSequence.length;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function ShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.container = elem;
    this.elem = elem;
    this.data = data;
    this.k = false;
    this.kf = false;
    this._mdf = false;
    var pathData = type === 3 ? data.pt.k : data.ks.k;
    this.v = shapePool.clone(pathData);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.reset = resetShape;
    this.effectsSequence = [];
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  ShapeProperty.prototype.interpolateShape = interpolateShape;
  ShapeProperty.prototype.getValue = processEffectsSequence;
  ShapeProperty.prototype.setVValue = setVValue;
  ShapeProperty.prototype.addEffect = addEffect;

  function KeyframedShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.elem = elem;
    this.container = elem;
    this.offsetTime = elem.data.st;
    this.keyframes = type === 3 ? data.pt.k : data.ks.k;
    this.keyframesMetadata = [];
    this.k = true;
    this.kf = true;
    var len = this.keyframes[0].s[0].i.length;
    this.v = shapePool.newElement();
    this.v.setPathData(this.keyframes[0].s[0].c, len);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.lastFrame = initFrame;
    this.reset = resetShape;
    this._caching = { lastFrame: initFrame, lastIndex: 0 };
    this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
  }
  KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
  KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
  KeyframedShapeProperty.prototype.setVValue = setVValue;
  KeyframedShapeProperty.prototype.addEffect = addEffect;

  var EllShapeProperty = (function () {
    var cPoint = roundCorner;

    function EllShapePropertyFactory(elem, data) {
      /* this.v = {
                v: createSizedArray(4),
                i: createSizedArray(4),
                o: createSizedArray(4),
                c: true
            }; */
      this.v = shapePool.newElement();
      this.v.setPathData(true, 4);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.localShapeCollection.addShape(this.v);
      this.d = data.d;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertEllToPath();
      }
    }

    EllShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();

        if (this._mdf) {
          this.convertEllToPath();
        }
      },
      convertEllToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var s0 = this.s.v[0] / 2;
        var s1 = this.s.v[1] / 2;
        var _cw = this.d !== 3;
        var _v = this.v;
        _v.v[0][0] = p0;
        _v.v[0][1] = p1 - s1;
        _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.v[1][1] = p1;
        _v.v[2][0] = p0;
        _v.v[2][1] = p1 + s1;
        _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.v[3][1] = p1;
        _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.i[0][1] = p1 - s1;
        _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.i[1][1] = p1 - s1 * cPoint;
        _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.i[2][1] = p1 + s1;
        _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.i[3][1] = p1 + s1 * cPoint;
        _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.o[0][1] = p1 - s1;
        _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.o[1][1] = p1 + s1 * cPoint;
        _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.o[2][1] = p1 + s1;
        _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.o[3][1] = p1 - s1 * cPoint;
      },
    };

    extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);

    return EllShapePropertyFactory;
  }());

  var StarShapeProperty = (function () {
    function StarShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.setPathData(true, 0);
      this.elem = elem;
      this.comp = elem.comp;
      this.data = data;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      if (data.sy === 1) {
        this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
        this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
        this.convertToPath = this.convertStarToPath;
      } else {
        this.convertToPath = this.convertPolygonToPath;
      }
      this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
      this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
      this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertToPath();
      }
    }

    StarShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertToPath();
        }
      },
      convertStarToPath: function () {
        var numPts = Math.floor(this.pt.v) * 2;
        var angle = (Math.PI * 2) / numPts;
        /* this.v.v.length = numPts;
                this.v.i.length = numPts;
                this.v.o.length = numPts; */
        var longFlag = true;
        var longRad = this.or.v;
        var shortRad = this.ir.v;
        var longRound = this.os.v;
        var shortRound = this.is.v;
        var longPerimSegment = (2 * Math.PI * longRad) / (numPts * 2);
        var shortPerimSegment = (2 * Math.PI * shortRad) / (numPts * 2);
        var i;
        var rad;
        var roundness;
        var perimSegment;
        var currentAng = -Math.PI / 2;
        currentAng += this.r.v;
        var dir = this.data.d === 3 ? -1 : 1;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          rad = longFlag ? longRad : shortRad;
          roundness = longFlag ? longRound : shortRound;
          perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);

          /* this.v.v[i] = [x,y];
                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                    this.v._length = numPts; */
          longFlag = !longFlag;
          currentAng += angle * dir;
        }
      },
      convertPolygonToPath: function () {
        var numPts = Math.floor(this.pt.v);
        var angle = (Math.PI * 2) / numPts;
        var rad = this.or.v;
        var roundness = this.os.v;
        var perimSegment = (2 * Math.PI * rad) / (numPts * 4);
        var i;
        var currentAng = -Math.PI * 0.5;
        var dir = this.data.d === 3 ? -1 : 1;
        currentAng += this.r.v;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
          currentAng += angle * dir;
        }
        this.paths.length = 0;
        this.paths[0] = this.v;
      },

    };
    extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);

    return StarShapePropertyFactory;
  }());

  var RectShapeProperty = (function () {
    function RectShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.c = true;
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertRectToPath();
      }
    }

    RectShapePropertyFactory.prototype = {
      convertRectToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var v0 = this.s.v[0] / 2;
        var v1 = this.s.v[1] / 2;
        var round = bmMin(v0, v1, this.r.v);
        var cPoint = round * (1 - roundCorner);
        this.v._length = 0;

        if (this.d === 2 || this.d === 1) {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
          this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
          }
        } else {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
          }
        }
      },
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertRectToPath();
        }
      },
      reset: resetShape,
    };
    extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);

    return RectShapePropertyFactory;
  }());

  function getShapeProp(elem, data, type) {
    var prop;
    if (type === 3 || type === 4) {
      var dataProp = type === 3 ? data.pt : data.ks;
      var keys = dataProp.k;
      if (keys.length) {
        prop = new KeyframedShapeProperty(elem, data, type);
      } else {
        prop = new ShapeProperty(elem, data, type);
      }
    } else if (type === 5) {
      prop = new RectShapeProperty(elem, data);
    } else if (type === 6) {
      prop = new EllShapeProperty(elem, data);
    } else if (type === 7) {
      prop = new StarShapeProperty(elem, data);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  }

  function getConstructorFunction() {
    return ShapeProperty;
  }

  function getKeyframedConstructorFunction() {
    return KeyframedShapeProperty;
  }

  var ob = {};
  ob.getShapeProp = getShapeProp;
  ob.getConstructorFunction = getConstructorFunction;
  ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
  return ob;
}());

/* global shapeCollectionPool, initialDefaultFrame, extendPrototype, DynamicPropertyContainer */
/* exported ShapeModifiers */

var ShapeModifiers = (function () {
  var ob = {};
  var modifiers = {};
  ob.registerModifier = registerModifier;
  ob.getModifier = getModifier;

  function registerModifier(nm, factory) {
    if (!modifiers[nm]) {
      modifiers[nm] = factory;
    }
  }

  function getModifier(nm, elem, data) {
    return new modifiers[nm](elem, data);
  }

  return ob;
}());

function ShapeModifier() {}
ShapeModifier.prototype.initModifierProperties = function () {};
ShapeModifier.prototype.addShapeToModifier = function () {};
ShapeModifier.prototype.addShape = function (data) {
  if (!this.closed) {
    // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
    data.sh.container.addDynamicProperty(data.sh);
    var shapeData = { shape: data.sh, data: data, localShapeCollection: shapeCollectionPool.newShapeCollection() };
    this.shapes.push(shapeData);
    this.addShapeToModifier(shapeData);
    if (this._isAnimated) {
      data.setAsAnimated();
    }
  }
};
ShapeModifier.prototype.init = function (elem, data) {
  this.shapes = [];
  this.elem = elem;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, data);
  this.frameId = initialDefaultFrame;
  this.closed = false;
  this.k = false;
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};
ShapeModifier.prototype.processKeys = function () {
  if (this.elem.globalData.frameId === this.frameId) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
};

extendPrototype([DynamicPropertyContainer], ShapeModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, segmentsLengthPool, bez, shapePool, ShapeModifiers */

function TrimModifier() {
}
extendPrototype([ShapeModifier], TrimModifier);
TrimModifier.prototype.initModifierProperties = function (elem, data) {
  this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
  this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
  this.sValue = 0;
  this.eValue = 0;
  this.getValue = this.processKeys;
  this.m = data.m;
  this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};

TrimModifier.prototype.addShapeToModifier = function (shapeData) {
  shapeData.pathsData = [];
};

TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
  var segments = [];
  if (e <= 1) {
    segments.push({
      s: s,
      e: e,
    });
  } else if (s >= 1) {
    segments.push({
      s: s - 1,
      e: e - 1,
    });
  } else {
    segments.push({
      s: s,
      e: 1,
    });
    segments.push({
      s: 0,
      e: e - 1,
    });
  }
  var shapeSegments = [];
  var i;
  var len = segments.length;
  var segmentOb;
  for (i = 0; i < len; i += 1) {
    segmentOb = segments[i];
    if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
      var shapeS;
      var shapeE;
      if (segmentOb.s * totalModifierLength <= addedLength) {
        shapeS = 0;
      } else {
        shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
      }
      if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
        shapeE = 1;
      } else {
        shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
      }
      shapeSegments.push([shapeS, shapeE]);
    }
  }
  if (!shapeSegments.length) {
    shapeSegments.push([0, 0]);
  }
  return shapeSegments;
};

TrimModifier.prototype.releasePathsData = function (pathsData) {
  var i;
  var len = pathsData.length;
  for (i = 0; i < len; i += 1) {
    segmentsLengthPool.release(pathsData[i]);
  }
  pathsData.length = 0;
  return pathsData;
};

TrimModifier.prototype.processShapes = function (_isFirstFrame) {
  var s;
  var e;
  if (this._mdf || _isFirstFrame) {
    var o = (this.o.v % 360) / 360;
    if (o < 0) {
      o += 1;
    }
    if (this.s.v > 1) {
      s = 1 + o;
    } else if (this.s.v < 0) {
      s = 0 + o;
    } else {
      s = this.s.v + o;
    }
    if (this.e.v > 1) {
      e = 1 + o;
    } else if (this.e.v < 0) {
      e = 0 + o;
    } else {
      e = this.e.v + o;
    }

    if (s > e) {
      var _s = s;
      s = e;
      e = _s;
    }
    s = Math.round(s * 10000) * 0.0001;
    e = Math.round(e * 10000) * 0.0001;
    this.sValue = s;
    this.eValue = e;
  } else {
    s = this.sValue;
    e = this.eValue;
  }
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var pathsData;
  var pathData;
  var totalShapeLength;
  var totalModifierLength = 0;

  if (e === s) {
    for (i = 0; i < len; i += 1) {
      this.shapes[i].localShapeCollection.releaseShapes();
      this.shapes[i].shape._mdf = true;
      this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
      if (this._mdf) {
        this.shapes[i].pathsData.length = 0;
      }
    }
  } else if (!((e === 1 && s === 0) || (e === 0 && s === 1))) {
    var segments = [];
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
      if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
        shapeData.shape.paths = shapeData.localShapeCollection;
      } else {
        shapePaths = shapeData.shape.paths;
        jLen = shapePaths._length;
        totalShapeLength = 0;
        if (!shapeData.shape._mdf && shapeData.pathsData.length) {
          totalShapeLength = shapeData.totalShapeLength;
        } else {
          pathsData = this.releasePathsData(shapeData.pathsData);
          for (j = 0; j < jLen; j += 1) {
            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
            pathsData.push(pathData);
            totalShapeLength += pathData.totalLength;
          }
          shapeData.totalShapeLength = totalShapeLength;
          shapeData.pathsData = pathsData;
        }

        totalModifierLength += totalShapeLength;
        shapeData.shape._mdf = true;
      }
    }
    var shapeS = s;
    var shapeE = e;
    var addedLength = 0;
    var edges;
    for (i = len - 1; i >= 0; i -= 1) {
      shapeData = this.shapes[i];
      if (shapeData.shape._mdf) {
        localShapeCollection = shapeData.localShapeCollection;
        localShapeCollection.releaseShapes();
        // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
        if (this.m === 2 && len > 1) {
          edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
          addedLength += shapeData.totalShapeLength;
        } else {
          edges = [[shapeS, shapeE]];
        }
        jLen = edges.length;
        for (j = 0; j < jLen; j += 1) {
          shapeS = edges[j][0];
          shapeE = edges[j][1];
          segments.length = 0;
          if (shapeE <= 1) {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength * shapeE,
            });
          } else if (shapeS >= 1) {
            segments.push({
              s: shapeData.totalShapeLength * (shapeS - 1),
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          } else {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength,
            });
            segments.push({
              s: 0,
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          }
          var newShapesData = this.addShapes(shapeData, segments[0]);
          if (segments[0].s !== segments[0].e) {
            if (segments.length > 1) {
              var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
              if (lastShapeInCollection.c) {
                var lastShape = newShapesData.pop();
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
              } else {
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1]);
              }
            }
            this.addPaths(newShapesData, localShapeCollection);
          }
        }
        shapeData.shape.paths = localShapeCollection;
      }
    }
  } else if (this._mdf) {
    for (i = 0; i < len; i += 1) {
      // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
      // Don't remove this even if it's losing cached info.
      this.shapes[i].pathsData.length = 0;
      this.shapes[i].shape._mdf = true;
    }
  }
};

TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
  var i;
  var len = newPaths.length;
  for (i = 0; i < len; i += 1) {
    localShapeCollection.addShape(newPaths[i]);
  }
};

TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
  shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
  shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
  }
  shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
};

TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
  shapePath.setXYAt(points[1], points[5], 'o', pos);
  shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(points[0], points[4], 'v', pos);
  }
  shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
};

TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
  var pathsData = shapeData.pathsData;
  var shapePaths = shapeData.shape.paths.shapes;
  var i;
  var len = shapeData.shape.paths._length;
  var j;
  var jLen;
  var addedLength = 0;
  var currentLengthData;
  var segmentCount;
  var lengths;
  var segment;
  var shapes = [];
  var initPos;
  var newShape = true;
  if (!shapePath) {
    shapePath = shapePool.newElement();
    segmentCount = 0;
    initPos = 0;
  } else {
    segmentCount = shapePath._length;
    initPos = shapePath._length;
  }
  shapes.push(shapePath);
  for (i = 0; i < len; i += 1) {
    lengths = pathsData[i].lengths;
    shapePath.c = shapePaths[i].c;
    jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
    for (j = 1; j < jLen; j += 1) {
      currentLengthData = lengths[j - 1];
      if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
        addedLength += currentLengthData.addedLength;
        shapePath.c = false;
      } else if (addedLength > shapeSegment.e) {
        shapePath.c = false;
        break;
      } else {
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }
    }
    if (shapePaths[i].c && lengths.length) {
      currentLengthData = lengths[j - 1];
      if (addedLength <= shapeSegment.e) {
        var segmentLength = lengths[j - 1].addedLength;
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
      } else {
        shapePath.c = false;
      }
      addedLength += currentLengthData.addedLength;
      segmentCount += 1;
    }
    if (shapePath._length) {
      shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
      shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
    }
    if (addedLength > shapeSegment.e) {
      break;
    }
    if (i < len - 1) {
      shapePath = shapePool.newElement();
      newShape = true;
      shapes.push(shapePath);
      segmentCount = 0;
    }
  }
  return shapes;
};

ShapeModifiers.registerModifier('tm', TrimModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, roundCorner, ShapeModifiers */

function RoundCornersModifier() {}
extendPrototype([ShapeModifier], RoundCornersModifier);
RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
  this._isAnimated = !!this.rd.effectsSequence.length;
};

RoundCornersModifier.prototype.processPath = function (path, round) {
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var i;
  var len = path._length;
  var currentV;
  var currentI;
  var currentO;
  var closerV;
  var distance;
  var newPosPerc;
  var index = 0;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < len; i += 1) {
    currentV = path.v[i];
    currentO = path.o[i];
    currentI = path.i[i];
    if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
      if ((i === 0 || i === len - 1) && !path.c) {
        clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
        /* clonedPath.v[index] = currentV;
                clonedPath.o[index] = currentO;
                clonedPath.i[index] = currentI; */
        index += 1;
      } else {
        if (i === 0) {
          closerV = path.v[len - 1];
        } else {
          closerV = path.v[i - 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = iX;
        iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
        vY = iY;
        oX = vX - (vX - currentV[0]) * roundCorner;
        oY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;

        if (i === len - 1) {
          closerV = path.v[0];
        } else {
          closerV = path.v[i + 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = oX;
        oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
        vY = oY;
        iX = vX - (vX - currentV[0]) * roundCorner;
        iY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;
      }
    } else {
      clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
      index += 1;
    }
  }
  return clonedPath;
};

RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var rd = this.rd.v;

  if (rd !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};

ShapeModifiers.registerModifier('rd', RoundCornersModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, ShapeModifiers */

function PuckerAndBloatModifier() {}
extendPrototype([ShapeModifier], PuckerAndBloatModifier);
PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
  this._isAnimated = !!this.amount.effectsSequence.length;
};

PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
  var percent = amount / 100;
  var centerPoint = [0, 0];
  var pathLength = path._length;
  var i = 0;
  for (i = 0; i < pathLength; i += 1) {
    centerPoint[0] += path.v[i][0];
    centerPoint[1] += path.v[i][1];
  }
  centerPoint[0] /= pathLength;
  centerPoint[1] /= pathLength;
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < pathLength; i += 1) {
    vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
    vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
    oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
    oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
    iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
    iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
  }
  return clonedPath;
};

PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var amount = this.amount.v;

  if (amount !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};
ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);

/* global extendPrototype, ShapeModifier, TransformPropertyFactory, PropertyFactory, Matrix, ShapeModifiers */

function RepeaterModifier() {}
extendPrototype([ShapeModifier], RepeaterModifier);

RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
  this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
  this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
  this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
  this.data = data;
  if (!this.dynamicProperties.length) {
    this.getValue(true);
  }
  this._isAnimated = !!this.dynamicProperties.length;
  this.pMatrix = new Matrix();
  this.rMatrix = new Matrix();
  this.sMatrix = new Matrix();
  this.tMatrix = new Matrix();
  this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
  var dir = inv ? -1 : 1;
  var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
  var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
  pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
  rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  rMatrix.rotate(-transform.r.v * dir * perc);
  rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
  sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
};

RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
  this.elem = elem;
  this.arr = arr;
  this.pos = pos;
  this.elemsData = elemsData;
  this._currentCopies = 0;
  this._elements = [];
  this._groups = [];
  this.frameId = -1;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, arr[pos]);
  while (pos > 0) {
    pos -= 1;
    // this._elements.unshift(arr.splice(pos,1)[0]);
    this._elements.unshift(arr[pos]);
  }
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};

RepeaterModifier.prototype.resetElements = function (elements) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._processed = false;
    if (elements[i].ty === 'gr') {
      this.resetElements(elements[i].it);
    }
  }
};

RepeaterModifier.prototype.cloneElements = function (elements) {
  var newElements = JSON.parse(JSON.stringify(elements));
  this.resetElements(newElements);
  return newElements;
};

RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._render = renderFlag;
    if (elements[i].ty === 'gr') {
      this.changeGroupRender(elements[i].it, renderFlag);
    }
  }
};

RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
  var items;
  var itemsTransform;
  var i;
  var dir;
  var cont;
  var hasReloaded = false;
  if (this._mdf || _isFirstFrame) {
    var copies = Math.ceil(this.c.v);
    if (this._groups.length < copies) {
      while (this._groups.length < copies) {
        var group = {
          it: this.cloneElements(this._elements),
          ty: 'gr',
        };
        group.it.push({
          a: { a: 0, ix: 1, k: [0, 0] }, nm: 'Transform', o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: 'tr',
        });

        this.arr.splice(0, 0, group);
        this._groups.splice(0, 0, group);
        this._currentCopies += 1;
      }
      this.elem.reloadShapes();
      hasReloaded = true;
    }
    cont = 0;
    var renderFlag;
    for (i = 0; i <= this._groups.length - 1; i += 1) {
      renderFlag = cont < copies;
      this._groups[i]._render = renderFlag;
      this.changeGroupRender(this._groups[i].it, renderFlag);
      if (!renderFlag) {
        var elems = this.elemsData[i].it;
        var transformData = elems[elems.length - 1];
        if (transformData.transform.op.v !== 0) {
          transformData.transform.op._mdf = true;
          transformData.transform.op.v = 0;
        } else {
          transformData.transform.op._mdf = false;
        }
      }
      cont += 1;
    }

    this._currentCopies = copies;
    /// /

    var offset = this.o.v;
    var offsetModulo = offset % 1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    this.pMatrix.reset();
    this.rMatrix.reset();
    this.sMatrix.reset();
    this.tMatrix.reset();
    this.matrix.reset();
    var iteration = 0;

    if (offset > 0) {
      while (iteration < roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        iteration += 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
        iteration += offsetModulo;
      }
    } else if (offset < 0) {
      while (iteration > roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
        iteration -= 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
        iteration -= offsetModulo;
      }
    }
    i = this.data.m === 1 ? 0 : this._currentCopies - 1;
    dir = this.data.m === 1 ? 1 : -1;
    cont = this._currentCopies;
    var j;
    var jLen;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      jLen = itemsTransform.length;
      items[items.length - 1].transform.mProps._mdf = true;
      items[items.length - 1].transform.op._mdf = true;
      items[items.length - 1].transform.op.v = this._currentCopies === 1
        ? this.so.v
        : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

      if (iteration !== 0) {
        if ((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        }
        this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
        this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
        this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
        this.matrix.reset();
      } else {
        this.matrix.reset();
        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
      }
      iteration += 1;
      cont -= 1;
      i += dir;
    }
  } else {
    cont = this._currentCopies;
    i = 0;
    dir = 1;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      items[items.length - 1].transform.mProps._mdf = false;
      items[items.length - 1].transform.op._mdf = false;
      cont -= 1;
      i += dir;
    }
  }
  return hasReloaded;
};

RepeaterModifier.prototype.addShape = function () {};

ShapeModifiers.registerModifier('rp', RepeaterModifier);

/* global createSizedArray, shapePool */

function ShapeCollection() {
  this._length = 0;
  this._maxLength = 4;
  this.shapes = createSizedArray(this._maxLength);
}

ShapeCollection.prototype.addShape = function (shapeData) {
  if (this._length === this._maxLength) {
    this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  }
  this.shapes[this._length] = shapeData;
  this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function () {
  var i;
  for (i = 0; i < this._length; i += 1) {
    shapePool.release(this.shapes[i]);
  }
  this._length = 0;
};

/* global createSizedArray, createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function DashProperty(elem, data, renderer, container) {
  this.elem = elem;
  this.frameId = -1;
  this.dataProps = createSizedArray(data.length);
  this.renderer = renderer;
  this.k = false;
  this.dashStr = '';
  this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
  this.dashoffset = createTypedArray('float32', 1);
  this.initDynamicPropertyContainer(container);
  var i;
  var len = data.length || 0;
  var prop;
  for (i = 0; i < len; i += 1) {
    prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
    this.k = prop.k || this.k;
    this.dataProps[i] = { n: data[i].n, p: prop };
  }
  if (!this.k) {
    this.getValue(true);
  }
  this._isAnimated = this.k;
}

DashProperty.prototype.getValue = function (forceRender) {
  if (this.elem.globalData.frameId === this.frameId && !forceRender) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
  this._mdf = this._mdf || forceRender;
  if (this._mdf) {
    var i = 0;
    var len = this.dataProps.length;
    if (this.renderer === 'svg') {
      this.dashStr = '';
    }
    for (i = 0; i < len; i += 1) {
      if (this.dataProps[i].n !== 'o') {
        if (this.renderer === 'svg') {
          this.dashStr += ' ' + this.dataProps[i].p.v;
        } else {
          this.dashArray[i] = this.dataProps[i].p.v;
        }
      } else {
        this.dashoffset[0] = this.dataProps[i].p.v;
      }
    }
  }
};
extendPrototype([DynamicPropertyContainer], DashProperty);

/* global createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */
function GradientProperty(elem, data, container) {
  this.data = data;
  this.c = createTypedArray('uint8c', data.p * 4);
  var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p * 4) : data.k.k.length - data.p * 4;
  this.o = createTypedArray('float32', cLength);
  this._cmdf = false;
  this._omdf = false;
  this._collapsable = this.checkCollapsable();
  this._hasOpacity = cLength;
  this.initDynamicPropertyContainer(container);
  this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
  this.k = this.prop.k;
  this.getValue(true);
}

GradientProperty.prototype.comparePoints = function (values, points) {
  var i = 0;
  var len = this.o.length / 2;
  var diff;
  while (i < len) {
    diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
    if (diff > 0.01) {
      return false;
    }
    i += 1;
  }
  return true;
};

GradientProperty.prototype.checkCollapsable = function () {
  if (this.o.length / 2 !== this.c.length / 4) {
    return false;
  }
  if (this.data.k.k[0].s) {
    var i = 0;
    var len = this.data.k.k.length;
    while (i < len) {
      if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
        return false;
      }
      i += 1;
    }
  } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
    return false;
  }
  return true;
};

GradientProperty.prototype.getValue = function (forceRender) {
  this.prop.getValue();
  this._mdf = false;
  this._cmdf = false;
  this._omdf = false;
  if (this.prop._mdf || forceRender) {
    var i;
    var len = this.data.p * 4;
    var mult;
    var val;
    for (i = 0; i < len; i += 1) {
      mult = i % 4 === 0 ? 100 : 255;
      val = Math.round(this.prop.v[i] * mult);
      if (this.c[i] !== val) {
        this.c[i] = val;
        this._cmdf = !forceRender;
      }
    }
    if (this.o.length) {
      len = this.prop.v.length;
      for (i = this.data.p * 4; i < len; i += 1) {
        mult = i % 2 === 0 ? 100 : 1;
        val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
        if (this.o[i - this.data.p * 4] !== val) {
          this.o[i - this.data.p * 4] = val;
          this._omdf = !forceRender;
        }
      }
    }
    this._mdf = !forceRender;
  }
};

extendPrototype([DynamicPropertyContainer], GradientProperty);

/* exported buildShapeString */

var buildShapeString = function (pathNodes, length, closed, mat) {
  if (length === 0) {
    return '';
  }
  var _o = pathNodes.o;
  var _i = pathNodes.i;
  var _v = pathNodes.v;
  var i;
  var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
  for (i = 1; i < length; i += 1) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
  }
  if (closed && length) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    shapeString += 'z';
  }
  return shapeString;
};

/* global Howl */
/* exported audioControllerFactory */

var audioControllerFactory = (function () {
  function AudioController(audioFactory) {
    this.audios = [];
    this.audioFactory = audioFactory;
    this._volume = 1;
    this._isMuted = false;
  }

  AudioController.prototype = {
    addAudio: function (audio) {
      this.audios.push(audio);
    },
    pause: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].pause();
      }
    },
    resume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].resume();
      }
    },
    setRate: function (rateValue) {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].setRate(rateValue);
      }
    },
    createAudio: function (assetPath) {
      if (this.audioFactory) {
        return this.audioFactory(assetPath);
      } if (Howl) {
        return new Howl({
          src: [assetPath],
        });
      }
      return {
        isPlaying: false,
        play: function () { this.isPlaying = true; },
        seek: function () { this.isPlaying = false; },
        playing: function () {},
        rate: function () {},
        setVolume: function () {},
      };
    },
    setAudioFactory: function (audioFactory) {
      this.audioFactory = audioFactory;
    },
    setVolume: function (value) {
      this._volume = value;
      this._updateVolume();
    },
    mute: function () {
      this._isMuted = true;
      this._updateVolume();
    },
    unmute: function () {
      this._isMuted = false;
      this._updateVolume();
    },
    getVolume: function () {
      return this._volume;
    },
    _updateVolume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
      }
    },
  };

  return function () {
    return new AudioController();
  };
}());

/* global createTag, createNS, isSafari, dataManager */
/* exported ImagePreloader */

var ImagePreloader = (function () {
  var proxyImage = (function () {
    var canvas = createTag('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return canvas;
  }());

  function imageLoaded() {
    this.loadedAssets += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }
  function footageLoaded() {
    this.loadedFootagesCount += 1;
    if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }

  function getAssetsPath(assetData, assetsPath, originalPath) {
    var path = '';
    if (assetData.e) {
      path = assetData.p;
    } else if (assetsPath) {
      var imagePath = assetData.p;
      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }
      path = assetsPath + imagePath;
    } else {
      path = originalPath;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }
    return path;
  }

  function testImageLoaded(img) {
    var _count = 0;
    var intervalId = setInterval(function () {
      var box = img.getBBox();
      if (box.width || _count > 500) {
        this._imageLoaded();
        clearInterval(intervalId);
      }
      _count += 1;
    }.bind(this), 50);
  }

  function createImageData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createNS('image');
    if (isSafari) {
      this.testImageLoaded(img);
    } else {
      img.addEventListener('load', this._imageLoaded, false);
    }
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
    if (this._elementHelper.append) {
      this._elementHelper.append(img);
    } else {
      this._elementHelper.appendChild(img);
    }
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createImgData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createTag('img');
    img.crossOrigin = 'anonymous';
    img.addEventListener('load', this._imageLoaded, false);
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.src = path;
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createFootageData(data) {
    var ob = {
      assetData: data,
    };
    var path = getAssetsPath(data, this.assetsPath, this.path);
    dataManager.loadData(path, function (footageData) {
      ob.img = footageData;
      this._footageLoaded();
    }.bind(this), function () {
      ob.img = {};
      this._footageLoaded();
    }.bind(this));
    return ob;
  }

  function loadAssets(assets, cb) {
    this.imagesLoadedCb = cb;
    var i;
    var len = assets.length;
    for (i = 0; i < len; i += 1) {
      if (!assets[i].layers) {
        if (!assets[i].t || assets[i].t === 'seq') {
          this.totalImages += 1;
          this.images.push(this._createImageData(assets[i]));
        } else if (assets[i].t === 3) {
          this.totalFootages += 1;
          this.images.push(this.createFootageData(assets[i]));
        }
      }
    }
  }

  function setPath(path) {
    this.path = path || '';
  }

  function setAssetsPath(path) {
    this.assetsPath = path || '';
  }

  function getAsset(assetData) {
    var i = 0;
    var len = this.images.length;
    while (i < len) {
      if (this.images[i].assetData === assetData) {
        return this.images[i].img;
      }
      i += 1;
    }
    return null;
  }

  function destroy() {
    this.imagesLoadedCb = null;
    this.images.length = 0;
  }

  function loadedImages() {
    return this.totalImages === this.loadedAssets;
  }

  function loadedFootages() {
    return this.totalFootages === this.loadedFootagesCount;
  }

  function setCacheType(type, elementHelper) {
    if (type === 'svg') {
      this._elementHelper = elementHelper;
      this._createImageData = this.createImageData.bind(this);
    } else {
      this._createImageData = this.createImgData.bind(this);
    }
  }

  function ImagePreloaderFactory() {
    this._imageLoaded = imageLoaded.bind(this);
    this._footageLoaded = footageLoaded.bind(this);
    this.testImageLoaded = testImageLoaded.bind(this);
    this.createFootageData = createFootageData.bind(this);
    this.assetsPath = '';
    this.path = '';
    this.totalImages = 0;
    this.totalFootages = 0;
    this.loadedAssets = 0;
    this.loadedFootagesCount = 0;
    this.imagesLoadedCb = null;
    this.images = [];
  }

  ImagePreloaderFactory.prototype = {
    loadAssets: loadAssets,
    setAssetsPath: setAssetsPath,
    setPath: setPath,
    loadedImages: loadedImages,
    loadedFootages: loadedFootages,
    destroy: destroy,
    getAsset: getAsset,
    createImgData: createImgData,
    createImageData: createImageData,
    imageLoaded: imageLoaded,
    footageLoaded: footageLoaded,
    setCacheType: setCacheType,
  };

  return ImagePreloaderFactory;
}());

/* exported featureSupport */

var featureSupport = (function () {
  var ob = {
    maskType: true,
  };
  if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
    ob.maskType = false;
  }
  return ob;
}());

/* global createNS */
/* exported filtersFactory */

var filtersFactory = (function () {
  var ob = {};
  ob.createFilter = createFilter;
  ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

  function createFilter(filId, skipCoordinates) {
    var fil = createNS('filter');
    fil.setAttribute('id', filId);
    if (skipCoordinates !== true) {
      fil.setAttribute('filterUnits', 'objectBoundingBox');
      fil.setAttribute('x', '0%');
      fil.setAttribute('y', '0%');
      fil.setAttribute('width', '100%');
      fil.setAttribute('height', '100%');
    }
    return fil;
  }

  function createAlphaToLuminanceFilter() {
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
    return feColorMatrix;
  }

  return ob;
}());

/* global createSizedArray, PropertyFactory, TextAnimatorDataProperty, bez, addHueToRGB,
  addSaturationToRGB, addBrightnessToRGB, LetterProps, Matrix, extendPrototype, DynamicPropertyContainer */

function TextAnimatorProperty(textData, renderType, elem) {
  this._isFirstFrame = true;
  this._hasMaskedPath = false;
  this._frameId = -1;
  this._textData = textData;
  this._renderType = renderType;
  this._elem = elem;
  this._animatorsData = createSizedArray(this._textData.a.length);
  this._pathData = {};
  this._moreOptions = {
    alignment: {},
  };
  this.renderedLetters = [];
  this.lettersChangedFlag = false;
  this.initDynamicPropertyContainer(elem);
}

TextAnimatorProperty.prototype.searchProperties = function () {
  var i;
  var len = this._textData.a.length;
  var animatorProps;
  var getProp = PropertyFactory.getProp;
  for (i = 0; i < len; i += 1) {
    animatorProps = this._textData.a[i];
    this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
  }
  if (this._textData.p && 'm' in this._textData.p) {
    this._pathData = {
      a: getProp(this._elem, this._textData.p.a, 0, 0, this),
      f: getProp(this._elem, this._textData.p.f, 0, 0, this),
      l: getProp(this._elem, this._textData.p.l, 0, 0, this),
      r: getProp(this._elem, this._textData.p.r, 0, 0, this),
      p: getProp(this._elem, this._textData.p.p, 0, 0, this),
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
    };
    this._hasMaskedPath = true;
  } else {
    this._hasMaskedPath = false;
  }
  this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
};

TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
  this.lettersChangedFlag = lettersChangedFlag;
  if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
    return;
  }
  this._isFirstFrame = false;
  var alignment = this._moreOptions.alignment.v;
  var animators = this._animatorsData;
  var textData = this._textData;
  var matrixHelper = this.mHelper;
  var renderType = this._renderType;
  var renderedLettersCount = this.renderedLetters.length;
  var xPos;
  var yPos;
  var i;
  var len;
  var letters = documentData.l;
  var pathInfo;
  var currentLength;
  var currentPoint;
  var segmentLength;
  var flag;
  var pointInd;
  var segmentInd;
  var prevPoint;
  var points;
  var segments;
  var partialLength;
  var totalLength;
  var perc;
  var tanAngle;
  var mask;
  if (this._hasMaskedPath) {
    mask = this._pathData.m;
    if (!this._pathData.n || this._pathData._mdf) {
      var paths = mask.v;
      if (this._pathData.r.v) {
        paths = paths.reverse();
      }
      // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
      pathInfo = {
        tLength: 0,
        segments: [],
      };
      len = paths._length - 1;
      var bezierData;
      totalLength = 0;
      for (i = 0; i < len; i += 1) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[i + 1],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      i = len;
      if (mask.v.c) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[0],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      this._pathData.pi = pathInfo;
    }
    pathInfo = this._pathData.pi;

    currentLength = this._pathData.f.v;
    segmentInd = 0;
    pointInd = 1;
    segmentLength = 0;
    flag = true;
    segments = pathInfo.segments;
    if (currentLength < 0 && mask.v.c) {
      if (pathInfo.tLength < Math.abs(currentLength)) {
        currentLength = -Math.abs(currentLength) % pathInfo.tLength;
      }
      segmentInd = segments.length - 1;
      points = segments[segmentInd].points;
      pointInd = points.length - 1;
      while (currentLength < 0) {
        currentLength += points[pointInd].partialLength;
        pointInd -= 1;
        if (pointInd < 0) {
          segmentInd -= 1;
          points = segments[segmentInd].points;
          pointInd = points.length - 1;
        }
      }
    }
    points = segments[segmentInd].points;
    prevPoint = points[pointInd - 1];
    currentPoint = points[pointInd];
    partialLength = currentPoint.partialLength;
  }

  len = letters.length;
  xPos = 0;
  yPos = 0;
  var yOff = documentData.finalSize * 1.2 * 0.714;
  var firstLine = true;
  var animatorProps;
  var animatorSelector;
  var j;
  var jLen;
  var letterValue;

  jLen = animators.length;

  var mult;
  var ind = -1;
  var offf;
  var xPathPos;
  var yPathPos;
  var initPathPos = currentLength;
  var initSegmentInd = segmentInd;
  var initPointInd = pointInd;
  var currentLine = -1;
  var elemOpacity;
  var sc;
  var sw;
  var fc;
  var k;
  var letterSw;
  var letterSc;
  var letterFc;
  var letterM = '';
  var letterP = this.defaultPropsArray;
  var letterO;

  //
  if (documentData.j === 2 || documentData.j === 1) {
    var animatorJustifyOffset = 0;
    var animatorFirstCharOffset = 0;
    var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
    var lastIndex = 0;
    var isNewLine = true;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        if (animatorJustifyOffset) {
          animatorJustifyOffset += animatorFirstCharOffset;
        }
        while (lastIndex < i) {
          letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
          lastIndex += 1;
        }
        animatorJustifyOffset = 0;
        isNewLine = true;
      } else {
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.t.propType) {
            if (isNewLine && documentData.j === 2) {
              animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
            }
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
            } else {
              animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
            }
          }
        }
        isNewLine = false;
      }
    }
    if (animatorJustifyOffset) {
      animatorJustifyOffset += animatorFirstCharOffset;
    }
    while (lastIndex < i) {
      letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
      lastIndex += 1;
    }
  }
  //

  for (i = 0; i < len; i += 1) {
    matrixHelper.reset();
    elemOpacity = 1;
    if (letters[i].n) {
      xPos = 0;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      currentLength = initPathPos;
      firstLine = false;
      if (this._hasMaskedPath) {
        segmentInd = initSegmentInd;
        pointInd = initPointInd;
        points = segments[segmentInd].points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        partialLength = currentPoint.partialLength;
        segmentLength = 0;
      }
      letterM = '';
      letterFc = '';
      letterSw = '';
      letterO = '';
      letterP = this.defaultPropsArray;
    } else {
      if (this._hasMaskedPath) {
        if (currentLine !== letters[i].line) {
          switch (documentData.j) {
            case 1:
              currentLength += totalLength - documentData.lineWidths[letters[i].line];
              break;
            case 2:
              currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
              break;
            default:
              break;
          }
          currentLine = letters[i].line;
        }
        if (ind !== letters[i].ind) {
          if (letters[ind]) {
            currentLength += letters[ind].extra;
          }
          currentLength += letters[i].an / 2;
          ind = letters[i].ind;
        }
        currentLength += (alignment[0] * letters[i].an) * 0.005;
        var animatorOffset = 0;
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.p.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.p.v[0] * mult;
            }
          }
          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.a.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.a.v[0] * mult;
            }
          }
        }
        flag = true;
        // Force alignment only works with a single line for now
        if (this._pathData.a.v) {
          currentLength = letters[0].an * 0.5 + ((totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind) / (len - 1);
          currentLength += this._pathData.f.v;
        }
        while (flag) {
          if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
            matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, -(alignment[1] * yOff) * 0.01);
            flag = false;
          } else if (points) {
            segmentLength += currentPoint.partialLength;
            pointInd += 1;
            if (pointInd >= points.length) {
              pointInd = 0;
              segmentInd += 1;
              if (!segments[segmentInd]) {
                if (mask.v.c) {
                  pointInd = 0;
                  segmentInd = 0;
                  points = segments[segmentInd].points;
                } else {
                  segmentLength -= currentPoint.partialLength;
                  points = null;
                }
              } else {
                points = segments[segmentInd].points;
              }
            }
            if (points) {
              prevPoint = currentPoint;
              currentPoint = points[pointInd];
              partialLength = currentPoint.partialLength;
            }
          }
        }
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);
      } else {
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);

        // Grouping alignment
        matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, (-alignment[1] * yOff) * 0.01, 0);
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.t.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
          if (xPos !== 0 || documentData.j !== 0) {
            if (this._hasMaskedPath) {
              if (mult.length) {
                currentLength += animatorProps.t.v * mult[0];
              } else {
                currentLength += animatorProps.t.v * mult;
              }
            } else if (mult.length) {
              xPos += animatorProps.t.v * mult[0];
            } else {
              xPos += animatorProps.t.v * mult;
            }
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        sw = documentData.sw || 0;
      }
      if (documentData.strokeColorAnim) {
        if (documentData.sc) {
          sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
        } else {
          sc = [0, 0, 0];
        }
      }
      if (documentData.fillColorAnim && documentData.fc) {
        fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.a.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (mult.length) {
            matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
          } else {
            matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.s.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (mult.length) {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult[0]), 1 + ((animatorProps.s.v[1] - 1) * mult[1]), 1);
          } else {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult), 1 + ((animatorProps.s.v[1] - 1) * mult), 1);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        animatorSelector = animators[j].s;
        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
        if (animatorProps.sk.propType) {
          if (mult.length) {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
          } else {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
          }
        }
        if (animatorProps.r.propType) {
          if (mult.length) {
            matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
          } else {
            matrixHelper.rotateZ(-animatorProps.r.v * mult);
          }
        }
        if (animatorProps.ry.propType) {
          if (mult.length) {
            matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
          } else {
            matrixHelper.rotateY(animatorProps.ry.v * mult);
          }
        }
        if (animatorProps.rx.propType) {
          if (mult.length) {
            matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
          } else {
            matrixHelper.rotateX(animatorProps.rx.v * mult);
          }
        }
        if (animatorProps.o.propType) {
          if (mult.length) {
            elemOpacity += ((animatorProps.o.v) * mult[0] - elemOpacity) * mult[0];
          } else {
            elemOpacity += ((animatorProps.o.v) * mult - elemOpacity) * mult;
          }
        }
        if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
          if (mult.length) {
            sw += animatorProps.sw.v * mult[0];
          } else {
            sw += animatorProps.sw.v * mult;
          }
        }
        if (documentData.strokeColorAnim && animatorProps.sc.propType) {
          for (k = 0; k < 3; k += 1) {
            if (mult.length) {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
            } else {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
            }
          }
        }
        if (documentData.fillColorAnim && documentData.fc) {
          if (animatorProps.fc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
              } else {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
              }
            }
          }
          if (animatorProps.fh.propType) {
            if (mult.length) {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
            } else {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult);
            }
          }
          if (animatorProps.fs.propType) {
            if (mult.length) {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
            } else {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
            }
          }
          if (animatorProps.fb.propType) {
            if (mult.length) {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
            } else {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
            }
          }
        }
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;

        if (animatorProps.p.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (this._hasMaskedPath) {
            if (mult.length) {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
            } else {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          } else if (mult.length) {
            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
          } else {
            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        letterSw = sw < 0 ? 0 : sw;
      }
      if (documentData.strokeColorAnim) {
        letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
      }
      if (documentData.fillColorAnim && documentData.fc) {
        letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
      }

      if (this._hasMaskedPath) {
        matrixHelper.translate(0, -documentData.ls);

        matrixHelper.translate(0, (alignment[1] * yOff) * 0.01 + yPos, 0);
        if (this._pathData.p.v) {
          tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
          var rot = (Math.atan(tanAngle) * 180) / Math.PI;
          if (currentPoint.point[0] < prevPoint.point[0]) {
            rot += 180;
          }
          matrixHelper.rotate((-rot * Math.PI) / 180);
        }
        matrixHelper.translate(xPathPos, yPathPos, 0);
        currentLength -= (alignment[0] * letters[i].an) * 0.005;
        if (letters[i + 1] && ind !== letters[i + 1].ind) {
          currentLength += letters[i].an / 2;
          currentLength += (documentData.tr * 0.001) * documentData.finalSize;
        }
      } else {
        matrixHelper.translate(xPos, yPos, 0);

        if (documentData.ps) {
          // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
          matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        }
        switch (documentData.j) {
          case 1:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
            break;
          case 2:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
            break;
          default:
            break;
        }
        matrixHelper.translate(0, -documentData.ls);
        matrixHelper.translate(offf, 0, 0);
        matrixHelper.translate((alignment[0] * letters[i].an) * 0.005, (alignment[1] * yOff) * 0.01, 0);
        xPos += letters[i].l + (documentData.tr * 0.001) * documentData.finalSize;
      }
      if (renderType === 'html') {
        letterM = matrixHelper.toCSS();
      } else if (renderType === 'svg') {
        letterM = matrixHelper.to2dCSS();
      } else {
        letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
      }
      letterO = elemOpacity;
    }

    if (renderedLettersCount <= i) {
      letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
      this.renderedLetters.push(letterValue);
      renderedLettersCount += 1;
      this.lettersChangedFlag = true;
    } else {
      letterValue = this.renderedLetters[i];
      this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
    }
  }
};

TextAnimatorProperty.prototype.getValue = function () {
  if (this._elem.globalData.frameId === this._frameId) {
    return;
  }
  this._frameId = this._elem.globalData.frameId;
  this.iterateDynamicProperties();
};

TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

/* global PropertyFactory, degToRads, TextSelectorProp */
/* exported TextAnimatorDataProperty */

function TextAnimatorDataProperty(elem, animatorProps, container) {
  var defaultData = { propType: false };
  var getProp = PropertyFactory.getProp;
  var textAnimatorAnimatables = animatorProps.a;
  this.a = {
    r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
    rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
    ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
    sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
    sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
    s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
    a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
    o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
    p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
    sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
    sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
    fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
    fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
    fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
    fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
    t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData,
  };

  this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
  this.s.t = animatorProps.s.t;
}

function LetterProps(o, sw, sc, fc, m, p) {
  this.o = o;
  this.sw = sw;
  this.sc = sc;
  this.fc = fc;
  this.m = m;
  this.p = p;
  this._mdf = {
    o: true,
    sw: !!sw,
    sc: !!sc,
    fc: !!fc,
    m: true,
    p: true,
  };
}

LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
  this._mdf.o = false;
  this._mdf.sw = false;
  this._mdf.sc = false;
  this._mdf.fc = false;
  this._mdf.m = false;
  this._mdf.p = false;
  var updated = false;

  if (this.o !== o) {
    this.o = o;
    this._mdf.o = true;
    updated = true;
  }
  if (this.sw !== sw) {
    this.sw = sw;
    this._mdf.sw = true;
    updated = true;
  }
  if (this.sc !== sc) {
    this.sc = sc;
    this._mdf.sc = true;
    updated = true;
  }
  if (this.fc !== fc) {
    this.fc = fc;
    this._mdf.fc = true;
    updated = true;
  }
  if (this.m !== m) {
    this.m = m;
    this._mdf.m = true;
    updated = true;
  }
  if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
    this.p = p;
    this._mdf.p = true;
    updated = true;
  }
  return updated;
};

/* global FontManager, initialDefaultFrame, getFontProperties */
/* exported TextProperty */

function TextProperty(elem, data) {
  this._frameId = initialDefaultFrame;
  this.pv = '';
  this.v = '';
  this.kf = false;
  this._isFirstFrame = true;
  this._mdf = false;
  this.data = data;
  this.elem = elem;
  this.comp = this.elem.comp;
  this.keysIndex = 0;
  this.canResize = false;
  this.minimumFontSize = 1;
  this.effectsSequence = [];
  this.currentData = {
    ascent: 0,
    boxWidth: this.defaultBoxWidth,
    f: '',
    fStyle: '',
    fWeight: '',
    fc: '',
    j: '',
    justifyOffset: '',
    l: [],
    lh: 0,
    lineWidths: [],
    ls: '',
    of: '',
    s: '',
    sc: '',
    sw: 0,
    t: 0,
    tr: 0,
    sz: 0,
    ps: null,
    fillColorAnim: false,
    strokeColorAnim: false,
    strokeWidthAnim: false,
    yOffset: 0,
    finalSize: 0,
    finalText: [],
    finalLineHeight: 0,
    __complete: false,

  };
  this.copyData(this.currentData, this.data.d.k[0].s);

  if (!this.searchProperty()) {
    this.completeTextData(this.currentData);
  }
}

TextProperty.prototype.defaultBoxWidth = [0, 0];

TextProperty.prototype.copyData = function (obj, data) {
  for (var s in data) {
    if (Object.prototype.hasOwnProperty.call(data, s)) {
      obj[s] = data[s];
    }
  }
  return obj;
};

TextProperty.prototype.setCurrentData = function (data) {
  if (!data.__complete) {
    this.completeTextData(data);
  }
  this.currentData = data;
  this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
  this._mdf = true;
};

TextProperty.prototype.searchProperty = function () {
  return this.searchKeyframes();
};

TextProperty.prototype.searchKeyframes = function () {
  this.kf = this.data.d.k.length > 1;
  if (this.kf) {
    this.addEffect(this.getKeyframeValue.bind(this));
  }
  return this.kf;
};

TextProperty.prototype.addEffect = function (effectFunction) {
  this.effectsSequence.push(effectFunction);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.getValue = function (_finalValue) {
  if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
    return;
  }
  this.currentData.t = this.data.d.k[this.keysIndex].s.t;
  var currentValue = this.currentData;
  var currentIndex = this.keysIndex;
  if (this.lock) {
    this.setCurrentData(this.currentData);
    return;
  }
  this.lock = true;
  this._mdf = false;
  var i; var
    len = this.effectsSequence.length;
  var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
  for (i = 0; i < len; i += 1) {
    // Checking if index changed to prevent creating a new object every time the expression updates.
    if (currentIndex !== this.keysIndex) {
      finalValue = this.effectsSequence[i](finalValue, finalValue.t);
    } else {
      finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
    }
  }
  if (currentValue !== finalValue) {
    this.setCurrentData(finalValue);
  }
  this.v = this.currentData;
  this.pv = this.v;
  this.lock = false;
  this.frameId = this.elem.globalData.frameId;
};

TextProperty.prototype.getKeyframeValue = function () {
  var textKeys = this.data.d.k;
  var frameNum = this.elem.comp.renderedFrame;
  var i = 0; var
    len = textKeys.length;
  while (i <= len - 1) {
    if (i === len - 1 || textKeys[i + 1].t > frameNum) {
      break;
    }
    i += 1;
  }
  if (this.keysIndex !== i) {
    this.keysIndex = i;
  }
  return this.data.d.k[this.keysIndex].s;
};

TextProperty.prototype.buildFinalText = function (text) {
  var charactersArray = [];
  var i = 0;
  var len = text.length;
  var charCode;
  var secondCharCode;
  var shouldCombine = false;
  while (i < len) {
    charCode = text.charCodeAt(i);
    if (FontManager.isCombinedCharacter(charCode)) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
    } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      secondCharCode = text.charCodeAt(i + 1);
      if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
        if (shouldCombine || FontManager.isModifier(charCode, secondCharCode)) {
          charactersArray[charactersArray.length - 1] += text.substr(i, 2);
          shouldCombine = false;
        } else {
          charactersArray.push(text.substr(i, 2));
        }
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else if (charCode > 0xDBFF) {
      secondCharCode = text.charCodeAt(i + 1);
      if (FontManager.isZeroWidthJoiner(charCode, secondCharCode)) {
        shouldCombine = true;
        charactersArray[charactersArray.length - 1] += text.substr(i, 2);
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else if (FontManager.isZeroWidthJoiner(charCode)) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
      shouldCombine = true;
    } else {
      charactersArray.push(text.charAt(i));
    }
    i += 1;
  }
  return charactersArray;
};

TextProperty.prototype.completeTextData = function (documentData) {
  documentData.__complete = true;
  var fontManager = this.elem.globalData.fontManager;
  var data = this.data;
  var letters = [];
  var i; var
    len;
  var newLineFlag; var index = 0; var
    val;
  var anchorGrouping = data.m.g;
  var currentSize = 0; var currentPos = 0; var currentLine = 0; var
    lineWidths = [];
  var lineWidth = 0;
  var maxLineWidth = 0;
  var j; var
    jLen;
  var fontData = fontManager.getFontByName(documentData.f);
  var charData; var
    cLength = 0;

  var fontProps = getFontProperties(fontData);
  documentData.fWeight = fontProps.weight;
  documentData.fStyle = fontProps.style;
  documentData.finalSize = documentData.s;
  documentData.finalText = this.buildFinalText(documentData.t);
  len = documentData.finalText.length;
  documentData.finalLineHeight = documentData.lh;
  var trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
  var charCode;
  if (documentData.sz) {
    var flag = true;
    var boxWidth = documentData.sz[0];
    var boxHeight = documentData.sz[1];
    var currentHeight; var
      finalText;
    while (flag) {
      finalText = this.buildFinalText(documentData.t);
      currentHeight = 0;
      lineWidth = 0;
      len = finalText.length;
      trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
      var lastSpaceIndex = -1;
      for (i = 0; i < len; i += 1) {
        charCode = finalText[i].charCodeAt(0);
        newLineFlag = false;
        if (finalText[i] === ' ') {
          lastSpaceIndex = i;
        } else if (charCode === 13 || charCode === 3) {
          lineWidth = 0;
          newLineFlag = true;
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
        }
        if (fontManager.chars) {
          charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
          cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
        } else {
          // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
          cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
        }
        if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
          if (lastSpaceIndex === -1) {
            len += 1;
          } else {
            i = lastSpaceIndex;
          }
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
          // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
          lastSpaceIndex = -1;
          lineWidth = 0;
        } else {
          lineWidth += cLength;
          lineWidth += trackingOffset;
        }
      }
      currentHeight += (fontData.ascent * documentData.finalSize) / 100;
      if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
        documentData.finalSize -= 1;
        documentData.finalLineHeight = (documentData.finalSize * documentData.lh) / documentData.s;
      } else {
        documentData.finalText = finalText;
        len = documentData.finalText.length;
        flag = false;
      }
    }
  }
  lineWidth = -trackingOffset;
  cLength = 0;
  var uncollapsedSpaces = 0;
  var currentChar;
  for (i = 0; i < len; i += 1) {
    newLineFlag = false;
    currentChar = documentData.finalText[i];
    charCode = currentChar.charCodeAt(0);
    if (charCode === 13 || charCode === 3) {
      uncollapsedSpaces = 0;
      lineWidths.push(lineWidth);
      maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
      lineWidth = -2 * trackingOffset;
      val = '';
      newLineFlag = true;
      currentLine += 1;
    } else {
      val = currentChar;
    }
    if (fontManager.chars) {
      charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
      cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
    } else {
      // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
      // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
      cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
    }

    //
    if (currentChar === ' ') {
      uncollapsedSpaces += cLength + trackingOffset;
    } else {
      lineWidth += cLength + trackingOffset + uncollapsedSpaces;
      uncollapsedSpaces = 0;
    }
    letters.push({
      l: cLength, an: cLength, add: currentSize, n: newLineFlag, anIndexes: [], val: val, line: currentLine, animatorJustifyOffset: 0,
    });
    if (anchorGrouping == 2) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || val === ' ' || i === len - 1) {
        if (val === '' || val === ' ') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        index += 1;
        currentSize = 0;
      }
    } else if (anchorGrouping == 3) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || i === len - 1) {
        if (val === '') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        currentSize = 0;
        index += 1;
      }
    } else {
      letters[index].ind = index;
      letters[index].extra = 0;
      index += 1;
    }
  }
  documentData.l = letters;
  maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
  lineWidths.push(lineWidth);
  if (documentData.sz) {
    documentData.boxWidth = documentData.sz[0];
    documentData.justifyOffset = 0;
  } else {
    documentData.boxWidth = maxLineWidth;
    switch (documentData.j) {
      case 1:
        documentData.justifyOffset = -documentData.boxWidth;
        break;
      case 2:
        documentData.justifyOffset = -documentData.boxWidth / 2;
        break;
      default:
        documentData.justifyOffset = 0;
    }
  }
  documentData.lineWidths = lineWidths;

  var animators = data.a; var animatorData; var
    letterData;
  jLen = animators.length;
  var based; var ind; var
    indexes = [];
  for (j = 0; j < jLen; j += 1) {
    animatorData = animators[j];
    if (animatorData.a.sc) {
      documentData.strokeColorAnim = true;
    }
    if (animatorData.a.sw) {
      documentData.strokeWidthAnim = true;
    }
    if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
      documentData.fillColorAnim = true;
    }
    ind = 0;
    based = animatorData.s.b;
    for (i = 0; i < len; i += 1) {
      letterData = letters[i];
      letterData.anIndexes[j] = ind;
      if ((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== ' ') || (based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))) { // eslint-disable-line eqeqeq
        if (animatorData.s.rn === 1) {
          indexes.push(ind);
        }
        ind += 1;
      }
    }
    data.a[j].s.totalChars = ind;
    var currentInd = -1; var
      newInd;
    if (animatorData.s.rn === 1) {
      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        if (currentInd != letterData.anIndexes[j]) { // eslint-disable-line eqeqeq
          currentInd = letterData.anIndexes[j];
          newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
        }
        letterData.anIndexes[j] = newInd;
      }
    }
  }
  documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
  documentData.ls = documentData.ls || 0;
  documentData.ascent = (fontData.ascent * documentData.finalSize) / 100;
};

TextProperty.prototype.updateDocumentData = function (newData, index) {
  index = index === undefined ? this.keysIndex : index;
  var dData = this.copyData({}, this.data.d.k[index].s);
  dData = this.copyData(dData, newData);
  this.data.d.k[index].s = dData;
  this.recalculate(index);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.recalculate = function (index) {
  var dData = this.data.d.k[index].s;
  dData.__complete = false;
  this.keysIndex = 0;
  this._isFirstFrame = true;
  this.getValue(dData);
};

TextProperty.prototype.canResizeFont = function (_canResize) {
  this.canResize = _canResize;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
  this.minimumFontSize = Math.floor(_fontValue) || 1;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

/* global extendPrototype, BezierFactory, PropertyFactory, DynamicPropertyContainer */
/* exported TextSelectorProp */

var TextSelectorProp = (function () {
  var max = Math.max;
  var min = Math.min;
  var floor = Math.floor;

  function TextSelectorPropFactory(elem, data) {
    this._currentTextLength = -1;
    this.k = false;
    this.data = data;
    this.elem = elem;
    this.comp = elem.comp;
    this.finalS = 0;
    this.finalE = 0;
    this.initDynamicPropertyContainer(elem);
    this.s = PropertyFactory.getProp(elem, data.s || { k: 0 }, 0, 0, this);
    if ('e' in data) {
      this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
    } else {
      this.e = { v: 100 };
    }
    this.o = PropertyFactory.getProp(elem, data.o || { k: 0 }, 0, 0, this);
    this.xe = PropertyFactory.getProp(elem, data.xe || { k: 0 }, 0, 0, this);
    this.ne = PropertyFactory.getProp(elem, data.ne || { k: 0 }, 0, 0, this);
    this.sm = PropertyFactory.getProp(elem, data.sm || { k: 100 }, 0, 0, this);
    this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
    if (!this.dynamicProperties.length) {
      this.getValue();
    }
  }

  TextSelectorPropFactory.prototype = {
    getMult: function (ind) {
      if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
        this.getValue();
      }
      // var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
      var x1 = 0;
      var y1 = 0;
      var x2 = 1;
      var y2 = 1;
      if (this.ne.v > 0) {
        x1 = this.ne.v / 100.0;
      } else {
        y1 = -this.ne.v / 100.0;
      }
      if (this.xe.v > 0) {
        x2 = 1.0 - this.xe.v / 100.0;
      } else {
        y2 = 1.0 + this.xe.v / 100.0;
      }
      var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;

      var mult = 0;
      var s = this.finalS;
      var e = this.finalE;
      var type = this.data.sh;
      if (type === 2) {
        if (e === s) {
          mult = ind >= e ? 1 : 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }
        mult = easer(mult);
      } else if (type === 3) {
        if (e === s) {
          mult = ind >= e ? 0 : 1;
        } else {
          mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }

        mult = easer(mult);
      } else if (type === 4) {
        if (e === s) {
          mult = 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          if (mult < 0.5) {
            mult *= 2;
          } else {
            mult = 1 - 2 * (mult - 0.5);
          }
        }
        mult = easer(mult);
      } else if (type === 5) {
        if (e === s) {
          mult = 0;
        } else {
          var tot = e - s;
          /* ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
          ind = min(max(0, ind + 0.5 - s), e - s);
          var x = -tot / 2 + ind;
          var a = tot / 2;
          mult = Math.sqrt(1 - (x * x) / (a * a));
        }
        mult = easer(mult);
      } else if (type === 6) {
        if (e === s) {
          mult = 0;
        } else {
          ind = min(max(0, ind + 0.5 - s), e - s);
          mult = (1 + (Math.cos((Math.PI + Math.PI * 2 * (ind) / (e - s))))) / 2; // eslint-disable-line
        }
        mult = easer(mult);
      } else {
        if (ind >= floor(s)) {
          if (ind - s < 0) {
            mult = max(0, min(min(e, 1) - (s - ind), 1));
          } else {
            mult = max(0, min(e - ind, 1));
          }
        }
        mult = easer(mult);
      }
      // Smoothness implementation.
      // The smoothness represents a reduced range of the original [0; 1] range.
      // if smoothness is 25%, the new range will be [0.375; 0.625]
      // Steps are:
      // - find the lower value of the new range (threshold)
      // - if multiplier is smaller than that value, floor it to 0
      // - if it is larger,
      //     - subtract the threshold
      //     - divide it by the smoothness (this will return the range to [0; 1])
      // Note: If it doesn't work on some scenarios, consider applying it before the easer.
      if (this.sm.v !== 100) {
        var smoothness = this.sm.v * 0.01;
        if (smoothness === 0) {
          smoothness = 0.00000001;
        }
        var threshold = 0.5 - smoothness * 0.5;
        if (mult < threshold) {
          mult = 0;
        } else {
          mult = (mult - threshold) / smoothness;
          if (mult > 1) {
            mult = 1;
          }
        }
      }
      return mult * this.a.v;
    },
    getValue: function (newCharsFlag) {
      this.iterateDynamicProperties();
      this._mdf = newCharsFlag || this._mdf;
      this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
      if (newCharsFlag && this.data.r === 2) {
        this.e.v = this._currentTextLength;
      }
      var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
      var o = this.o.v / divisor;
      var s = this.s.v / divisor + o;
      var e = (this.e.v / divisor) + o;
      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }
      this.finalS = s;
      this.finalE = e;
    },
  };
  extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

  function getTextSelectorProp(elem, data, arr) {
    return new TextSelectorPropFactory(elem, data, arr);
  }

  return {
    getTextSelectorProp: getTextSelectorProp,
  };
}());

/* global createSizedArray, pooling */
/* exported poolFactory */

var poolFactory = (function () {
  return function (initialLength, _create, _release) {
    var _length = 0;
    var _maxLength = initialLength;
    var pool = createSizedArray(_maxLength);

    var ob = {
      newElement: newElement,
      release: release,
    };

    function newElement() {
      var element;
      if (_length) {
        _length -= 1;
        element = pool[_length];
      } else {
        element = _create();
      }
      return element;
    }

    function release(element) {
      if (_length === _maxLength) {
        pool = pooling.double(pool);
        _maxLength *= 2;
      }
      if (_release) {
        _release(element);
      }
      pool[_length] = element;
      _length += 1;
    }

    return ob;
  };
}());

/* global createSizedArray */
/* exported pooling */

var pooling = (function () {
  function double(arr) {
    return arr.concat(createSizedArray(arr.length));
  }

  return {
    double: double,
  };
}());

/* global createTypedArray, poolFactory */
/* exported pointPool */

var pointPool = (function () {
  function create() {
    return createTypedArray('float32', 2);
  }
  return poolFactory(8, create);
}());

/* global ShapePath, pointPool, poolFactory */
/* exported shapePool */

var shapePool = (function () {
  function create() {
    return new ShapePath();
  }

  function release(shapePath) {
    var len = shapePath._length;
    var i;
    for (i = 0; i < len; i += 1) {
      pointPool.release(shapePath.v[i]);
      pointPool.release(shapePath.i[i]);
      pointPool.release(shapePath.o[i]);
      shapePath.v[i] = null;
      shapePath.i[i] = null;
      shapePath.o[i] = null;
    }
    shapePath._length = 0;
    shapePath.c = false;
  }

  function clone(shape) {
    var cloned = factory.newElement();
    var i;
    var len = shape._length === undefined ? shape.v.length : shape._length;
    cloned.setLength(len);
    cloned.c = shape.c;

    for (i = 0; i < len; i += 1) {
      cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
    }
    return cloned;
  }

  var factory = poolFactory(4, create, release);
  factory.clone = clone;

  return factory;
}());

/* global createSizedArray, ShapeCollection, shapePool, pooling */
/* exported shapeCollectionPool */

var shapeCollectionPool = (function () {
  var ob = {
    newShapeCollection: newShapeCollection,
    release: release,
  };

  var _length = 0;
  var _maxLength = 4;
  var pool = createSizedArray(_maxLength);

  function newShapeCollection() {
    var shapeCollection;
    if (_length) {
      _length -= 1;
      shapeCollection = pool[_length];
    } else {
      shapeCollection = new ShapeCollection();
    }
    return shapeCollection;
  }

  function release(shapeCollection) {
    var i;
    var len = shapeCollection._length;
    for (i = 0; i < len; i += 1) {
      shapePool.release(shapeCollection.shapes[i]);
    }
    shapeCollection._length = 0;

    if (_length === _maxLength) {
      pool = pooling.double(pool);
      _maxLength *= 2;
    }
    pool[_length] = shapeCollection;
    _length += 1;
  }

  return ob;
}());

/* global poolFactory, bezierLengthPool */
/* exported segmentsLengthPool */

var segmentsLengthPool = (function () {
  function create() {
    return {
      lengths: [],
      totalLength: 0,
    };
  }

  function release(element) {
    var i;
    var len = element.lengths.length;
    for (i = 0; i < len; i += 1) {
      bezierLengthPool.release(element.lengths[i]);
    }
    element.lengths.length = 0;
  }

  return poolFactory(8, create, release);
}());

/* global createTypedArray, defaultCurveSegments, poolFactory */
/* exported bezierLengthPool */

var bezierLengthPool = (function () {
  function create() {
    return {
      addedLength: 0,
      percents: createTypedArray('float32', defaultCurveSegments),
      lengths: createTypedArray('float32', defaultCurveSegments),
    };
  }
  return poolFactory(8, create);
}());

/* exported markerParser */

var markerParser = (

  function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;
      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');
        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }
      if (keysCount === 0) {
        throw new Error();
      }
      return keys;
    }

    return function (_markers) {
      var markers = [];
      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr,
        };
        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i],
            };
          }
        }
        markers.push(markerData);
      }
      return markers;
    };
  }());

/* global AudioElement, FootageElement, FontManager */

function BaseRenderer() {}
BaseRenderer.prototype.checkLayers = function (num) {
  var i;
  var len = this.layers.length;
  var data;
  this.completeLayers = true;
  for (i = len - 1; i >= 0; i -= 1) {
    if (!this.elements[i]) {
      data = this.layers[i];
      if (data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st)) {
        this.buildItem(i);
      }
    }
    this.completeLayers = this.elements[i] ? this.completeLayers : false;
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function (layer) {
  switch (layer.ty) {
    case 2:
      return this.createImage(layer);
    case 0:
      return this.createComp(layer);
    case 1:
      return this.createSolid(layer);
    case 3:
      return this.createNull(layer);
    case 4:
      return this.createShape(layer);
    case 5:
      return this.createText(layer);
    case 6:
      return this.createAudio(layer);
    case 13:
      return this.createCamera(layer);
    case 15:
      return this.createFootage(layer);
    default:
      return this.createNull(layer);
  }
};

BaseRenderer.prototype.createCamera = function () {
  throw new Error('You\'re using a 3d camera. Try the html renderer.');
};

BaseRenderer.prototype.createAudio = function (data) {
  return new AudioElement(data, this.globalData, this);
};

BaseRenderer.prototype.createFootage = function (data) {
  return new FootageElement(data, this.globalData, this);
};

BaseRenderer.prototype.buildAllItems = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    this.buildItem(i);
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function (newLayers) {
  this.completeLayers = false;
  var i;
  var len = newLayers.length;
  var j;
  var jLen = this.layers.length;
  for (i = 0; i < len; i += 1) {
    j = 0;
    while (j < jLen) {
      if (this.layers[j].id === newLayers[i].id) {
        this.layers[j] = newLayers[i];
        break;
      }
      j += 1;
    }
  }
};

BaseRenderer.prototype.setProjectInterface = function (pInterface) {
  this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function () {
  if (!this.globalData.progressiveLoad) {
    this.buildAllItems();
  }
};
BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
  var elements = this.elements;
  var layers = this.layers;
  var i = 0;
  var len = layers.length;
  while (i < len) {
    if (layers[i].ind == parentName) { // eslint-disable-line eqeqeq
      if (!elements[i] || elements[i] === true) {
        this.buildItem(i);
        this.addPendingElement(element);
      } else {
        hierarchy.push(elements[i]);
        elements[i].setAsParent();
        if (layers[i].parent !== undefined) {
          this.buildElementParenting(element, layers[i].parent, hierarchy);
        } else {
          element.setHierarchy(hierarchy);
        }
      }
    }
    i += 1;
  }
};

BaseRenderer.prototype.addPendingElement = function (element) {
  this.pendingElements.push(element);
};

BaseRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i]);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
  this.globalData.fontManager = new FontManager();
  this.globalData.fontManager.addChars(animData.chars);
  this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
  this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
  this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
  this.globalData.imageLoader = this.animationItem.imagePreloader;
  this.globalData.audioController = this.animationItem.audioController;
  this.globalData.frameId = 0;
  this.globalData.frameRate = animData.fr;
  this.globalData.nm = animData.nm;
  this.globalData.compSize = {
    w: animData.w,
    h: animData.h,
  };
};

/* global createElementID, extendPrototype, BaseRenderer, NullElement, SVGShapeElement, SVGTextLottieElement,
IImageElement, SVGCompElement, ISolidElement, createNS, locationHref, createSizedArray, expressionsPlugin */

function SVGRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.svgElement = createNS('svg');
  var ariaLabel = '';
  if (config && config.title) {
    var titleElement = createNS('title');
    var titleId = createElementID();
    titleElement.setAttribute('id', titleId);
    titleElement.textContent = config.title;
    this.svgElement.appendChild(titleElement);
    ariaLabel += titleId;
  }
  if (config && config.description) {
    var descElement = createNS('desc');
    var descId = createElementID();
    descElement.setAttribute('id', descId);
    descElement.textContent = config.description;
    this.svgElement.appendChild(descElement);
    ariaLabel += ' ' + descId;
  }
  if (ariaLabel) {
    this.svgElement.setAttribute('aria-labelledby', ariaLabel);
  }
  var defs = createNS('defs');
  this.svgElement.appendChild(defs);
  var maskElement = createNS('g');
  this.svgElement.appendChild(maskElement);
  this.layerElement = maskElement;
  this.renderConfig = {
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    contentVisibility: (config && config.contentVisibility) || 'visible',
    progressiveLoad: (config && config.progressiveLoad) || false,
    hideOnTransparent: !((config && config.hideOnTransparent === false)),
    viewBoxOnly: (config && config.viewBoxOnly) || false,
    viewBoxSize: (config && config.viewBoxSize) || false,
    className: (config && config.className) || '',
    id: (config && config.id) || '',
    focusable: config && config.focusable,
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '100%',
      height: (config && config.filterSize && config.filterSize.height) || '100%',
      x: (config && config.filterSize && config.filterSize.x) || '0%',
      y: (config && config.filterSize && config.filterSize.y) || '0%',
    },
  };

  this.globalData = {
    _mdf: false,
    frameNum: -1,
    defs: defs,
    renderConfig: this.renderConfig,
  };
  this.elements = [];
  this.pendingElements = [];
  this.destroyed = false;
  this.rendererType = 'svg';
}

extendPrototype([BaseRenderer], SVGRenderer);

SVGRenderer.prototype.createNull = function (data) {
  return new NullElement(data, this.globalData, this);
};

SVGRenderer.prototype.createShape = function (data) {
  return new SVGShapeElement(data, this.globalData, this);
};

SVGRenderer.prototype.createText = function (data) {
  return new SVGTextLottieElement(data, this.globalData, this);
};

SVGRenderer.prototype.createImage = function (data) {
  return new IImageElement(data, this.globalData, this);
};

SVGRenderer.prototype.createComp = function (data) {
  return new SVGCompElement(data, this.globalData, this);
};

SVGRenderer.prototype.createSolid = function (data) {
  return new ISolidElement(data, this.globalData, this);
};

SVGRenderer.prototype.configAnimation = function (animData) {
  this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  if (this.renderConfig.viewBoxSize) {
    this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
  } else {
    this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
  }

  if (!this.renderConfig.viewBoxOnly) {
    this.svgElement.setAttribute('width', animData.w);
    this.svgElement.setAttribute('height', animData.h);
    this.svgElement.style.width = '100%';
    this.svgElement.style.height = '100%';
    this.svgElement.style.transform = 'translate3d(0,0,0)';
    this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
  }
  if (this.renderConfig.className) {
    this.svgElement.setAttribute('class', this.renderConfig.className);
  }
  if (this.renderConfig.id) {
    this.svgElement.setAttribute('id', this.renderConfig.id);
  }
  if (this.renderConfig.focusable !== undefined) {
    this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
  }
  this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
  // this.layerElement.style.transform = 'translate3d(0,0,0)';
  // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
  this.animationItem.wrapper.appendChild(this.svgElement);
  // Mask animation
  var defs = this.globalData.defs;

  this.setupGlobalData(animData, defs);
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.data = animData;

  var maskElement = createNS('clipPath');
  var rect = createNS('rect');
  rect.setAttribute('width', animData.w);
  rect.setAttribute('height', animData.h);
  rect.setAttribute('x', 0);
  rect.setAttribute('y', 0);
  var maskId = createElementID();
  maskElement.setAttribute('id', maskId);
  maskElement.appendChild(rect);
  this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + maskId + ')');

  defs.appendChild(maskElement);
  this.layers = animData.layers;
  this.elements = createSizedArray(animData.layers.length);
};

SVGRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.layerElement = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  elements[pos] = true;
  var element = this.createItem(this.layers[pos]);

  elements[pos] = element;
  if (expressionsPlugin) {
    if (this.layers[pos].ty === 0) {
      this.globalData.projectInterface.registerComposition(element);
    }
    element.initExpressions();
  }
  this.appendElementInPos(element, pos);
  if (this.layers[pos].tt) {
    if (!this.elements[pos - 1] || this.elements[pos - 1] === true) {
      this.buildItem(pos - 1);
      this.addPendingElement(element);
    } else {
      element.setMatte(elements[pos - 1].layerId);
    }
  }
};

SVGRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
    if (element.data.tt) {
      var i = 0;
      var len = this.elements.length;
      while (i < len) {
        if (this.elements[i] === element) {
          element.setMatte(this.elements[i - 1].layerId);
          break;
        }
        i += 1;
      }
    }
  }
};

SVGRenderer.prototype.renderFrame = function (num) {
  if (this.renderedFrame === num || this.destroyed) {
    return;
  }
  if (num === null) {
    num = this.renderedFrame;
  } else {
    this.renderedFrame = num;
  }
  // console.log('-------');
  // console.log('FRAME ',num);
  this.globalData.frameNum = num;
  this.globalData.frameId += 1;
  this.globalData.projectInterface.currentFrame = num;
  this.globalData._mdf = false;
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  }
};

SVGRenderer.prototype.appendElementInPos = function (element, pos) {
  var newElement = element.getBaseElement();
  if (!newElement) {
    return;
  }
  var i = 0;
  var nextElement;
  while (i < pos) {
    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
      nextElement = this.elements[i].getBaseElement();
    }
    i += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(newElement, nextElement);
  } else {
    this.layerElement.appendChild(newElement);
  }
};

SVGRenderer.prototype.hide = function () {
  this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function () {
  this.layerElement.style.display = 'block';
};

/* global CVContextData, Matrix, extendPrototype, BaseRenderer, CVShapeElement, CVTextElement,
CVImageElement, CVCompElement, CVSolidElement, SVGRenderer, createTag, createSizedArray */

function CanvasRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.renderConfig = {
    clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
    context: (config && config.context) || null,
    progressiveLoad: (config && config.progressiveLoad) || false,
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    contentVisibility: (config && config.contentVisibility) || 'visible',
    className: (config && config.className) || '',
    id: (config && config.id) || '',
  };
  this.renderConfig.dpr = (config && config.dpr) || 1;
  if (this.animationItem.wrapper) {
    this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
  }
  this.renderedFrame = -1;
  this.globalData = {
    frameNum: -1,
    _mdf: false,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1,
  };
  this.contextData = new CVContextData();
  this.elements = [];
  this.pendingElements = [];
  this.transformMat = new Matrix();
  this.completeLayers = false;
  this.rendererType = 'canvas';
}
extendPrototype([BaseRenderer], CanvasRenderer);

CanvasRenderer.prototype.createShape = function (data) {
  return new CVShapeElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createText = function (data) {
  return new CVTextElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createImage = function (data) {
  return new CVImageElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createComp = function (data) {
  return new CVCompElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createSolid = function (data) {
  return new CVSolidElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

CanvasRenderer.prototype.ctxTransform = function (props) {
  if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
    return;
  }
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    return;
  }
  this.transformMat.cloneFromProps(props);
  var cProps = this.contextData.cTr.props;
  this.transformMat.transform(cProps[0], cProps[1], cProps[2], cProps[3], cProps[4], cProps[5], cProps[6], cProps[7], cProps[8], cProps[9], cProps[10], cProps[11], cProps[12], cProps[13], cProps[14], cProps[15]);
  // this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
  this.contextData.cTr.cloneFromProps(this.transformMat.props);
  var trProps = this.contextData.cTr.props;
  this.canvasContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function (op) {
  /* if(op === 1){
        return;
    } */
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
    return;
  }
  this.contextData.cO *= op < 0 ? 0 : op;
  if (this.globalData.currentGlobalAlpha !== this.contextData.cO) {
    this.canvasContext.globalAlpha = this.contextData.cO;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
  }
};

CanvasRenderer.prototype.reset = function () {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  this.contextData.reset();
};

CanvasRenderer.prototype.save = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.save();
    return;
  }
  if (actionFlag) {
    this.canvasContext.save();
  }
  var props = this.contextData.cTr.props;
  if (this.contextData._length <= this.contextData.cArrPos) {
    this.contextData.duplicate();
  }
  var i;
  var arr = this.contextData.saved[this.contextData.cArrPos];
  for (i = 0; i < 16; i += 1) {
    arr[i] = props[i];
  }
  this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
  this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  if (actionFlag) {
    this.canvasContext.restore();
    this.globalData.blendMode = 'source-over';
  }
  this.contextData.cArrPos -= 1;
  var popped = this.contextData.saved[this.contextData.cArrPos];
  var i;
  var arr = this.contextData.cTr.props;
  for (i = 0; i < 16; i += 1) {
    arr[i] = popped[i];
  }
  this.canvasContext.setTransform(popped[0], popped[1], popped[4], popped[5], popped[12], popped[13]);
  popped = this.contextData.savedOp[this.contextData.cArrPos];
  this.contextData.cO = popped;
  if (this.globalData.currentGlobalAlpha !== popped) {
    this.canvasContext.globalAlpha = popped;
    this.globalData.currentGlobalAlpha = popped;
  }
};

CanvasRenderer.prototype.configAnimation = function (animData) {
  if (this.animationItem.wrapper) {
    this.animationItem.container = createTag('canvas');
    var containerStyle = this.animationItem.container.style;
    containerStyle.width = '100%';
    containerStyle.height = '100%';
    var origin = '0px 0px 0px';
    containerStyle.transformOrigin = origin;
    containerStyle.mozTransformOrigin = origin;
    containerStyle.webkitTransformOrigin = origin;
    containerStyle['-webkit-transform'] = origin;
    containerStyle.contentVisibility = this.renderConfig.contentVisibility;
    this.animationItem.wrapper.appendChild(this.animationItem.container);
    this.canvasContext = this.animationItem.container.getContext('2d');
    if (this.renderConfig.className) {
      this.animationItem.container.setAttribute('class', this.renderConfig.className);
    }
    if (this.renderConfig.id) {
      this.animationItem.container.setAttribute('id', this.renderConfig.id);
    }
  } else {
    this.canvasContext = this.renderConfig.context;
  }
  this.data = animData;
  this.layers = animData.layers;
  this.transformCanvas = {
    w: animData.w,
    h: animData.h,
    sx: 0,
    sy: 0,
    tx: 0,
    ty: 0,
  };
  this.setupGlobalData(animData, document.body);
  this.globalData.canvasContext = this.canvasContext;
  this.globalData.renderer = this;
  this.globalData.isDashed = false;
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.globalData.transformCanvas = this.transformCanvas;
  this.elements = createSizedArray(animData.layers.length);

  this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
  this.reset();
  var elementWidth;
  var elementHeight;
  if (this.animationItem.wrapper && this.animationItem.container) {
    elementWidth = this.animationItem.wrapper.offsetWidth;
    elementHeight = this.animationItem.wrapper.offsetHeight;
    this.animationItem.container.setAttribute('width', elementWidth * this.renderConfig.dpr);
    this.animationItem.container.setAttribute('height', elementHeight * this.renderConfig.dpr);
  } else {
    elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
    elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
  }
  var elementRel;
  var animationRel;
  if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
    var par = this.renderConfig.preserveAspectRatio.split(' ');
    var fillType = par[1] || 'meet';
    var pos = par[0] || 'xMidYMid';
    var xPos = pos.substr(0, 4);
    var yPos = pos.substr(4);
    elementRel = elementWidth / elementHeight;
    animationRel = this.transformCanvas.w / this.transformCanvas.h;
    if ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice')) {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    } else {
      this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    }

    if (xPos === 'xMid' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = ((elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2) * this.renderConfig.dpr;
    } else if (xPos === 'xMax' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.tx = 0;
    }
    if (yPos === 'YMid' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2) * this.renderConfig.dpr;
    } else if (yPos === 'YMax' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w))) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.ty = 0;
    }
  } else if (this.renderConfig.preserveAspectRatio === 'none') {
    this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  } else {
    this.transformCanvas.sx = this.renderConfig.dpr;
    this.transformCanvas.sy = this.renderConfig.dpr;
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  }
  this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
  /* var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    } */
  this.ctxTransform(this.transformCanvas.props);
  this.canvasContext.beginPath();
  this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
  this.canvasContext.closePath();
  this.canvasContext.clip();

  this.renderFrame(this.renderedFrame, true);
};

CanvasRenderer.prototype.destroy = function () {
  if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.globalData.canvasContext = null;
  this.animationItem.container = null;
  this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function (num, forceRender) {
  if ((this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender) || this.destroyed || num === -1) {
    return;
  }
  this.renderedFrame = num;
  this.globalData.frameNum = num - this.animationItem._isFirstFrame;
  this.globalData.frameId += 1;
  this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
  this.globalData.projectInterface.currentFrame = num;

  // console.log('--------');
  // console.log('NEW: ',num);
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }

  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    if (this.renderConfig.clearCanvas === true) {
      this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    } else {
      this.save();
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
    if (this.renderConfig.clearCanvas !== true) {
      this.restore();
    }
  }
};

CanvasRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  var element = this.createItem(this.layers[pos], this, this.globalData);
  elements[pos] = element;
  element.initExpressions();
  /* if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    } */
};

CanvasRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

CanvasRenderer.prototype.hide = function () {
  this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function () {
  this.animationItem.container.style.display = 'block';
};

/* global extendPrototype, BaseRenderer, SVGRenderer, SVGShapeElement, HShapeElement, SVGTextLottieElement,
HTextElement, HCameraElement, IImageElement, HImageElement, SVGCompElement, HCompElement, ISolidElement,
HSolidElement, styleDiv, createTag, createNS */

function HybridRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.renderConfig = {
    className: (config && config.className) || '',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    hideOnTransparent: !(config && config.hideOnTransparent === false),
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '400%',
      height: (config && config.filterSize && config.filterSize.height) || '400%',
      x: (config && config.filterSize && config.filterSize.x) || '-100%',
      y: (config && config.filterSize && config.filterSize.y) || '-100%',
    },
  };
  this.globalData = {
    _mdf: false,
    frameNum: -1,
    renderConfig: this.renderConfig,
  };
  this.pendingElements = [];
  this.elements = [];
  this.threeDElements = [];
  this.destroyed = false;
  this.camera = null;
  this.supports3d = true;
  this.rendererType = 'html';
}

extendPrototype([BaseRenderer], HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

HybridRenderer.prototype.appendElementInPos = function (element, pos) {
  var newDOMElement = element.getBaseElement();
  if (!newDOMElement) {
    return;
  }
  var layer = this.layers[pos];
  if (!layer.ddd || !this.supports3d) {
    if (this.threeDElements) {
      this.addTo3dContainer(newDOMElement, pos);
    } else {
      var i = 0;
      var nextDOMElement;
      var nextLayer;
      var tmpDOMElement;
      while (i < pos) {
        if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
          nextLayer = this.elements[i];
          tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
          nextDOMElement = tmpDOMElement || nextDOMElement;
        }
        i += 1;
      }
      if (nextDOMElement) {
        if (!layer.ddd || !this.supports3d) {
          this.layerElement.insertBefore(newDOMElement, nextDOMElement);
        }
      } else if (!layer.ddd || !this.supports3d) {
        this.layerElement.appendChild(newDOMElement);
      }
    }
  } else {
    this.addTo3dContainer(newDOMElement, pos);
  }
};

HybridRenderer.prototype.createShape = function (data) {
  if (!this.supports3d) {
    return new SVGShapeElement(data, this.globalData, this);
  }
  return new HShapeElement(data, this.globalData, this);
};

HybridRenderer.prototype.createText = function (data) {
  if (!this.supports3d) {
    return new SVGTextLottieElement(data, this.globalData, this);
  }
  return new HTextElement(data, this.globalData, this);
};

HybridRenderer.prototype.createCamera = function (data) {
  this.camera = new HCameraElement(data, this.globalData, this);
  return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
  if (!this.supports3d) {
    return new IImageElement(data, this.globalData, this);
  }
  return new HImageElement(data, this.globalData, this);
};

HybridRenderer.prototype.createComp = function (data) {
  if (!this.supports3d) {
    return new SVGCompElement(data, this.globalData, this);
  }
  return new HCompElement(data, this.globalData, this);
};

HybridRenderer.prototype.createSolid = function (data) {
  if (!this.supports3d) {
    return new ISolidElement(data, this.globalData, this);
  }
  return new HSolidElement(data, this.globalData, this);
};

HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

HybridRenderer.prototype.getThreeDContainerByPos = function (pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
      return this.threeDElements[i].perspectiveElem;
    }
    i += 1;
  }
  return null;
};

HybridRenderer.prototype.createThreeDContainer = function (pos, type) {
  var perspectiveElem = createTag('div');
  var style;
  var containerStyle;
  styleDiv(perspectiveElem);
  var container = createTag('div');
  styleDiv(container);
  if (type === '3d') {
    style = perspectiveElem.style;
    style.width = this.globalData.compSize.w + 'px';
    style.height = this.globalData.compSize.h + 'px';
    var center = '50% 50%';
    style.webkitTransformOrigin = center;
    style.mozTransformOrigin = center;
    style.transformOrigin = center;
    containerStyle = container.style;
    var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    containerStyle.transform = matrix;
    containerStyle.webkitTransform = matrix;
  }

  perspectiveElem.appendChild(container);
  // this.resizerElem.appendChild(perspectiveElem);
  var threeDContainerData = {
    container: container,
    perspectiveElem: perspectiveElem,
    startPos: pos,
    endPos: pos,
    type: type,
  };
  this.threeDElements.push(threeDContainerData);
  return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function () {
  var i;
  var len = this.layers.length;
  var lastThreeDContainerData;
  var currentContainer = '';
  for (i = 0; i < len; i += 1) {
    if (this.layers[i].ddd && this.layers[i].ty !== 3) {
      if (currentContainer !== '3d') {
        currentContainer = '3d';
        lastThreeDContainerData = this.createThreeDContainer(i, '3d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    } else {
      if (currentContainer !== '2d') {
        currentContainer = '2d';
        lastThreeDContainerData = this.createThreeDContainer(i, '2d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    }
  }
  len = this.threeDElements.length;
  for (i = len - 1; i >= 0; i -= 1) {
    this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
  }
};

HybridRenderer.prototype.addTo3dContainer = function (elem, pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (pos <= this.threeDElements[i].endPos) {
      var j = this.threeDElements[i].startPos;
      var nextElement;
      while (j < pos) {
        if (this.elements[j] && this.elements[j].getBaseElement) {
          nextElement = this.elements[j].getBaseElement();
        }
        j += 1;
      }
      if (nextElement) {
        this.threeDElements[i].container.insertBefore(elem, nextElement);
      } else {
        this.threeDElements[i].container.appendChild(elem);
      }
      break;
    }
    i += 1;
  }
};

HybridRenderer.prototype.configAnimation = function (animData) {
  var resizerElem = createTag('div');
  var wrapper = this.animationItem.wrapper;
  var style = resizerElem.style;
  style.width = animData.w + 'px';
  style.height = animData.h + 'px';
  this.resizerElem = resizerElem;
  styleDiv(resizerElem);
  style.transformStyle = 'flat';
  style.mozTransformStyle = 'flat';
  style.webkitTransformStyle = 'flat';
  if (this.renderConfig.className) {
    resizerElem.setAttribute('class', this.renderConfig.className);
  }
  wrapper.appendChild(resizerElem);

  style.overflow = 'hidden';
  var svg = createNS('svg');
  svg.setAttribute('width', '1');
  svg.setAttribute('height', '1');
  styleDiv(svg);
  this.resizerElem.appendChild(svg);
  var defs = createNS('defs');
  svg.appendChild(defs);
  this.data = animData;
  // Mask animation
  this.setupGlobalData(animData, svg);
  this.globalData.defs = defs;
  this.layers = animData.layers;
  this.layerElement = this.resizerElem;
  this.build3dContainers();
  this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.animationItem.container = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    this.elements[i].destroy();
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
  var elementWidth = this.animationItem.wrapper.offsetWidth;
  var elementHeight = this.animationItem.wrapper.offsetHeight;
  var elementRel = elementWidth / elementHeight;
  var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
  var sx;
  var sy;
  var tx;
  var ty;
  if (animationRel > elementRel) {
    sx = elementWidth / (this.globalData.compSize.w);
    sy = elementWidth / (this.globalData.compSize.w);
    tx = 0;
    ty = ((elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2);
  } else {
    sx = elementHeight / (this.globalData.compSize.h);
    sy = elementHeight / (this.globalData.compSize.h);
    tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
    ty = 0;
  }
  var style = this.resizerElem.style;
  style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
  style.transform = style.webkitTransform;
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function () {
  this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function () {
  this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function () {
  this.buildAllItems();
  if (this.camera) {
    this.camera.setup();
  } else {
    var cWidth = this.globalData.compSize.w;
    var cHeight = this.globalData.compSize.h;
    var i;
    var len = this.threeDElements.length;
    for (i = 0; i < len; i += 1) {
      var style = this.threeDElements[i].perspectiveElem.style;
      style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
      style.perspective = style.webkitPerspective;
    }
  }
};

HybridRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  var floatingContainer = createTag('div');
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

/* global createSizedArray, createElementID, PropertyFactory, ShapePropertyFactory, createNS, locationHref */

function MaskElement(data, element, globalData) {
  this.data = data;
  this.element = element;
  this.globalData = globalData;
  this.storedData = [];
  this.masksProperties = this.data.masksProperties || [];
  this.maskElement = null;
  var defs = this.globalData.defs;
  var i;
  var len = this.masksProperties ? this.masksProperties.length : 0;
  this.viewData = createSizedArray(len);
  this.solidPath = '';

  var path;
  var properties = this.masksProperties;
  var count = 0;
  var currentMasks = [];
  var j;
  var jLen;
  var layerId = createElementID();
  var rect;
  var expansor;
  var feMorph;
  var x;
  var maskType = 'clipPath';
  var maskRef = 'clip-path';
  for (i = 0; i < len; i += 1) {
    if ((properties[i].mode !== 'a' && properties[i].mode !== 'n') || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
      maskType = 'mask';
      maskRef = 'mask';
    }

    if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
      rect = createNS('rect');
      rect.setAttribute('fill', '#ffffff');
      rect.setAttribute('width', this.element.comp.data.w || 0);
      rect.setAttribute('height', this.element.comp.data.h || 0);
      currentMasks.push(rect);
    } else {
      rect = null;
    }

    path = createNS('path');
    if (properties[i].mode === 'n') {
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        elem: path,
        lastPath: '',
      };
      defs.appendChild(path);
    } else {
      count += 1;

      path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
      path.setAttribute('clip-rule', 'nonzero');
      var filterID;

      if (properties[i].x.k !== 0) {
        maskType = 'mask';
        maskRef = 'mask';
        x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
        filterID = createElementID();
        expansor = createNS('filter');
        expansor.setAttribute('id', filterID);
        feMorph = createNS('feMorphology');
        feMorph.setAttribute('operator', 'erode');
        feMorph.setAttribute('in', 'SourceGraphic');
        feMorph.setAttribute('radius', '0');
        expansor.appendChild(feMorph);
        defs.appendChild(expansor);
        path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
      } else {
        feMorph = null;
        x = null;
      }

      // TODO move this to a factory or to a constructor
      this.storedData[i] = {
        elem: path,
        x: x,
        expan: feMorph,
        lastPath: '',
        lastOperator: '',
        filterId: filterID,
        lastRadius: 0,
      };
      if (properties[i].mode === 'i') {
        jLen = currentMasks.length;
        var g = createNS('g');
        for (j = 0; j < jLen; j += 1) {
          g.appendChild(currentMasks[j]);
        }
        var mask = createNS('mask');
        mask.setAttribute('mask-type', 'alpha');
        mask.setAttribute('id', layerId + '_' + count);
        mask.appendChild(path);
        defs.appendChild(mask);
        g.setAttribute('mask', 'url(' + locationHref + '#' + layerId + '_' + count + ')');

        currentMasks.length = 0;
        currentMasks.push(g);
      } else {
        currentMasks.push(path);
      }
      if (properties[i].inv && !this.solidPath) {
        this.solidPath = this.createLayerSolidPath();
      }
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        elem: path,
        lastPath: '',
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        invRect: rect,
      };
      if (!this.viewData[i].prop.k) {
        this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
      }
    }
  }

  this.maskElement = createNS(maskType);

  len = currentMasks.length;
  for (i = 0; i < len; i += 1) {
    this.maskElement.appendChild(currentMasks[i]);
  }

  if (count > 0) {
    this.maskElement.setAttribute('id', layerId);
    this.element.maskedElement.setAttribute(maskRef, 'url(' + locationHref + '#' + layerId + ')');
    defs.appendChild(this.maskElement);
  }
  if (this.viewData.length) {
    this.element.addRenderableComponent(this);
  }
}

MaskElement.prototype.getMaskProperty = function (pos) {
  return this.viewData[pos].prop;
};

MaskElement.prototype.renderFrame = function (isFirstFrame) {
  var finalMat = this.element.finalTransform.mat;
  var i;
  var len = this.masksProperties.length;
  for (i = 0; i < len; i += 1) {
    if (this.viewData[i].prop._mdf || isFirstFrame) {
      this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
    }
    if (this.viewData[i].op._mdf || isFirstFrame) {
      this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
    }
    if (this.masksProperties[i].mode !== 'n') {
      if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
        this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
      }
      if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
        var feMorph = this.storedData[i].expan;
        if (this.storedData[i].x.v < 0) {
          if (this.storedData[i].lastOperator !== 'erode') {
            this.storedData[i].lastOperator = 'erode';
            this.storedData[i].elem.setAttribute('filter', 'url(' + locationHref + '#' + this.storedData[i].filterId + ')');
          }
          feMorph.setAttribute('radius', -this.storedData[i].x.v);
        } else {
          if (this.storedData[i].lastOperator !== 'dilate') {
            this.storedData[i].lastOperator = 'dilate';
            this.storedData[i].elem.setAttribute('filter', null);
          }
          this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
        }
      }
    }
  }
};

MaskElement.prototype.getMaskelement = function () {
  return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function () {
  var path = 'M0,0 ';
  path += ' h' + this.globalData.compSize.w;
  path += ' v' + this.globalData.compSize.h;
  path += ' h-' + this.globalData.compSize.w;
  path += ' v-' + this.globalData.compSize.h + ' ';
  return path;
};

MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
  var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  var i;
  var len;
  len = pathNodes._length;
  for (i = 1; i < len; i += 1) {
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
  }
  // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
  if (pathNodes.c && len > 1) {
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  }
  // pathNodes.__renderedString = pathString;

  if (viewData.lastPath !== pathString) {
    var pathShapeValue = '';
    if (viewData.elem) {
      if (pathNodes.c) {
        pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
      }
      viewData.elem.setAttribute('d', pathShapeValue);
    }
    viewData.lastPath = pathString;
  }
};

MaskElement.prototype.destroy = function () {
  this.element = null;
  this.globalData = null;
  this.maskElement = null;
  this.data = null;
  this.masksProperties = null;
};

/**
 * @file
 * Handles AE's layer parenting property.
 *
 */

function HierarchyElement() {}

HierarchyElement.prototype = {
  /**
     * @function
     * Initializes hierarchy properties
     *
     */
  initHierarchy: function () {
    // element's parent list
    this.hierarchy = [];
    // if element is parent of another layer _isParent will be true
    this._isParent = false;
    this.checkParenting();
  },
  /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */
  setHierarchy: function (hierarchy) {
    this.hierarchy = hierarchy;
  },
  /**
     * @function
     * Sets layer as parent.
     *
     */
  setAsParent: function () {
    this._isParent = true;
  },
  /**
     * @function
     * Searches layer's parenting chain
     *
     */
  checkParenting: function () {
    if (this.data.parent !== undefined) {
      this.comp.buildElementParenting(this, this.data.parent, []);
    }
  },
};

/**
 * @file
 * Handles element's layer frame update.
 * Checks layer in point and out point
 *
 */

function FrameElement() {}

FrameElement.prototype = {
  /**
     * @function
     * Initializes frame related properties.
     *
     */
  initFrame: function () {
    // set to true when inpoint is rendered
    this._isFirstFrame = false;
    // list of animated properties
    this.dynamicProperties = [];
    // If layer has been modified in current tick this will be true
    this._mdf = false;
  },
  /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */
  prepareProperties: function (num, isVisible) {
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
        this.dynamicProperties[i].getValue();
        if (this.dynamicProperties[i]._mdf) {
          this.globalData._mdf = true;
          this._mdf = true;
        }
      }
    }
  },
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
    }
  },
};

/* global TransformPropertyFactory, Matrix */

function TransformElement() {}

TransformElement.prototype = {
  initTransform: function () {
    this.finalTransform = {
      mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 },
      _matMdf: false,
      _opMdf: false,
      mat: new Matrix(),
    };
    if (this.data.ao) {
      this.finalTransform.mProp.autoOriented = true;
    }

    // TODO: check TYPE 11: Guided elements
    if (this.data.ty !== 11) {
      // this.createElements();
    }
  },
  renderTransform: function () {
    this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
    this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

    if (this.hierarchy) {
      var mat;
      var finalMat = this.finalTransform.mat;
      var i = 0;
      var len = this.hierarchy.length;
      // Checking if any of the transformation matrices in the hierarchy chain has changed.
      if (!this.finalTransform._matMdf) {
        while (i < len) {
          if (this.hierarchy[i].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = true;
            break;
          }
          i += 1;
        }
      }

      if (this.finalTransform._matMdf) {
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for (i = 0; i < len; i += 1) {
          mat = this.hierarchy[i].finalTransform.mProp.v.props;
          finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
        }
      }
    }
  },
  globalToLocal: function (pt) {
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while (flag) {
      if (comp.finalTransform) {
        if (comp.data.hasMask) {
          transforms.splice(0, 0, comp.finalTransform);
        }
        comp = comp.comp;
      } else {
        flag = false;
      }
    }
    var i;
    var len = transforms.length;
    var ptNew;
    for (i = 0; i < len; i += 1) {
      ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
      // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
      pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
    }
    return pt;
  },
  mHelper: new Matrix(),
};

function RenderableElement() {

}

RenderableElement.prototype = {
  initRenderable: function () {
    // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
    this.isInRange = false;
    // layer's display state
    this.hidden = false;
    // If layer's transparency equals 0, it can be hidden
    this.isTransparent = false;
    // list of animated components
    this.renderableComponents = [];
  },
  addRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) === -1) {
      this.renderableComponents.push(component);
    }
  },
  removeRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) !== -1) {
      this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
    }
  },
  prepareRenderableFrame: function (num) {
    this.checkLayerLimits(num);
  },
  checkTransparency: function () {
    if (this.finalTransform.mProp.o.v <= 0) {
      if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
        this.isTransparent = true;
        this.hide();
      }
    } else if (this.isTransparent) {
      this.isTransparent = false;
      this.show();
    }
  },
  /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */
  checkLayerLimits: function (num) {
    if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
      if (this.isInRange !== true) {
        this.globalData._mdf = true;
        this._mdf = true;
        this.isInRange = true;
        this.show();
      }
    } else if (this.isInRange !== false) {
      this.globalData._mdf = true;
      this.isInRange = false;
      this.hide();
    }
  },
  renderRenderable: function () {
    var i;
    var len = this.renderableComponents.length;
    for (i = 0; i < len; i += 1) {
      this.renderableComponents[i].renderFrame(this._isFirstFrame);
    }
    /* this.maskManager.renderFrame(this.finalTransform.mat);
        this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
  },
  sourceRectAtTime: function () {
    return {
      top: 0,
      left: 0,
      width: 100,
      height: 100,
    };
  },
  getLayerSize: function () {
    if (this.data.ty === 5) {
      return { w: this.data.textData.width, h: this.data.textData.height };
    }
    return { w: this.data.width, h: this.data.height };
  },
};

/* global extendPrototype, RenderableElement, createProxyFunction */

function RenderableDOMElement() {}

(function () {
  var _prototype = {
    initElement: function (data, globalData, comp) {
      this.initFrame();
      this.initBaseData(data, globalData, comp);
      this.initTransform(data, globalData, comp);
      this.initHierarchy();
      this.initRenderable();
      this.initRendererElement();
      this.createContainerElements();
      this.createRenderableComponents();
      this.createContent();
      this.hide();
    },
    hide: function () {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        var elem = this.baseElement || this.layerElement;
        elem.style.display = 'none';
        this.hidden = true;
      }
    },
    show: function () {
      if (this.isInRange && !this.isTransparent) {
        if (!this.data.hd) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'block';
        }
        this.hidden = false;
        this._isFirstFrame = true;
      }
    },
    renderFrame: function () {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    renderInnerContent: function () {},
    prepareFrame: function (num) {
      this._mdf = false;
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
      this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null;
      this.destroyBaseElement();
    },
  };
  extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
}());

/* exported ProcessedElement */

function ProcessedElement(element, position) {
  this.elem = element;
  this.pos = position;
}

/* global createNS */

function SVGStyleData(data, level) {
  this.data = data;
  this.type = data.ty;
  this.d = '';
  this.lvl = level;
  this._mdf = false;
  this.closed = data.hd === true;
  this.pElem = createNS('path');
  this.msElem = null;
}

SVGStyleData.prototype.reset = function () {
  this.d = '';
  this._mdf = false;
};

function SVGShapeData(transformers, level, shape) {
  this.caches = [];
  this.styles = [];
  this.transformers = transformers;
  this.lStr = '';
  this.sh = shape;
  this.lvl = level;
  // TODO find if there are some cases where _isAnimated can be false.
  // For now, since shapes add up with other shapes. They have to be calculated every time.
  // One way of finding out is checking if all styles associated to this shape depend only of this shape
  this._isAnimated = !!shape.k;
  // TODO: commenting this for now since all shapes are animated
  var i = 0;
  var len = transformers.length;
  while (i < len) {
    if (transformers[i].mProps.dynamicProperties.length) {
      this._isAnimated = true;
      break;
    }
    i += 1;
  }
}

SVGShapeData.prototype.setAsAnimated = function () {
  this._isAnimated = true;
};

/* exported SVGTransformData */

function SVGTransformData(mProps, op, container) {
  this.transform = {
    mProps: mProps,
    op: op,
    container: container,
  };
  this.elements = [];
  this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}

/* global DashProperty, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

/* global PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
}

extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

/* global PropertyFactory, degToRads, GradientProperty, createElementID, createNS, locationHref,
extendPrototype, DynamicPropertyContainer, lineCapEnum, lineJoinEnum */

function SVGGradientFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.initGradientData(elem, data, styleOb);
}

SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
  this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
  this.h = PropertyFactory.getProp(elem, data.h || { k: 0 }, 0, 0.01, this);
  this.a = PropertyFactory.getProp(elem, data.a || { k: 0 }, 0, degToRads, this);
  this.g = new GradientProperty(elem, data.g, this);
  this.style = styleOb;
  this.stops = [];
  this.setGradientData(styleOb.pElem, data);
  this.setGradientOpacity(data, styleOb);
  this._isAnimated = !!this._isAnimated;
};

SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
  var gradientId = createElementID();
  var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
  gfill.setAttribute('id', gradientId);
  gfill.setAttribute('spreadMethod', 'pad');
  gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
  var stops = [];
  var stop;
  var j;
  var jLen;
  jLen = data.g.p * 4;
  for (j = 0; j < jLen; j += 4) {
    stop = createNS('stop');
    gfill.appendChild(stop);
    stops.push(stop);
  }
  pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + gradientId + ')');
  this.gf = gfill;
  this.cst = stops;
};

SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
  if (this.g._hasOpacity && !this.g._collapsable) {
    var stop;
    var j;
    var jLen;
    var mask = createNS('mask');
    var maskElement = createNS('path');
    mask.appendChild(maskElement);
    var opacityId = createElementID();
    var maskId = createElementID();
    mask.setAttribute('id', maskId);
    var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    opFill.setAttribute('id', opacityId);
    opFill.setAttribute('spreadMethod', 'pad');
    opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
    jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
    var stops = this.stops;
    for (j = data.g.p * 4; j < jLen; j += 2) {
      stop = createNS('stop');
      stop.setAttribute('stop-color', 'rgb(255,255,255)');
      opFill.appendChild(stop);
      stops.push(stop);
    }
    maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + opacityId + ')');
    if (data.ty === 'gs') {
      maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      if (data.lj === 1) {
        maskElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }
    this.of = opFill;
    this.ms = mask;
    this.ost = stops;
    this.maskId = maskId;
    styleOb.msElem = maskElement;
  }
};

extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

/* global PropertyFactory, DashProperty, extendPrototype, SVGGradientFillStyleData, DynamicPropertyContainer */

function SVGGradientStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.initGradientData(elem, data, styleOb);
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

/* global createNS */
/* exported ShapeGroupData */

function ShapeGroupData() {
  this.it = [];
  this.prevViewData = [];
  this.gr = createNS('g');
}

/* global Matrix, buildShapeString, bmFloor */
/* exported SVGElementsRenderer */

var SVGElementsRenderer = (function () {
  var _identityMatrix = new Matrix();
  var _matrixHelper = new Matrix();

  var ob = {
    createRenderFunction: createRenderFunction,
  };

  function createRenderFunction(data) {
    switch (data.ty) {
      case 'fl':
        return renderFill;
      case 'gf':
        return renderGradient;
      case 'gs':
        return renderGradientStroke;
      case 'st':
        return renderStroke;
      case 'sh':
      case 'el':
      case 'rc':
      case 'sr':
        return renderPath;
      case 'tr':
        return renderContentTransform;
      default:
        return null;
    }
  }

  function renderContentTransform(styleData, itemData, isFirstFrame) {
    if (isFirstFrame || itemData.transform.op._mdf) {
      itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
    }
    if (isFirstFrame || itemData.transform.mProps._mdf) {
      itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
    }
  }

  function renderPath(styleData, itemData, isFirstFrame) {
    var j;
    var jLen;
    var pathStringTransformed;
    var redraw;
    var pathNodes;
    var l;
    var lLen = itemData.styles.length;
    var lvl = itemData.lvl;
    var paths;
    var mat;
    var props;
    var iterations;
    var k;
    for (l = 0; l < lLen; l += 1) {
      redraw = itemData.sh._mdf || isFirstFrame;
      if (itemData.styles[l].lvl < lvl) {
        mat = _matrixHelper.reset();
        iterations = lvl - itemData.styles[l].lvl;
        k = itemData.transformers.length - 1;
        while (!redraw && iterations > 0) {
          redraw = itemData.transformers[k].mProps._mdf || redraw;
          iterations -= 1;
          k -= 1;
        }
        if (redraw) {
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;
          while (iterations > 0) {
            props = itemData.transformers[k].mProps.v.props;
            mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
            iterations -= 1;
            k -= 1;
          }
        }
      } else {
        mat = _identityMatrix;
      }
      paths = itemData.sh.paths;
      jLen = paths._length;
      if (redraw) {
        pathStringTransformed = '';
        for (j = 0; j < jLen; j += 1) {
          pathNodes = paths.shapes[j];
          if (pathNodes && pathNodes._length) {
            pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
          }
        }
        itemData.caches[l] = pathStringTransformed;
      } else {
        pathStringTransformed = itemData.caches[l];
      }
      itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
      itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
    }
  }

  function renderFill(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
    }
  }

  function renderGradientStroke(styleData, itemData, isFirstFrame) {
    renderGradient(styleData, itemData, isFirstFrame);
    renderStroke(styleData, itemData, isFirstFrame);
  }

  function renderGradient(styleData, itemData, isFirstFrame) {
    var gfill = itemData.gf;
    var hasOpacity = itemData.g._hasOpacity;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;

    if (itemData.o._mdf || isFirstFrame) {
      var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
      itemData.style.pElem.setAttribute(attr, itemData.o.v);
    }
    if (itemData.s._mdf || isFirstFrame) {
      var attr1 = styleData.t === 1 ? 'x1' : 'cx';
      var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
      gfill.setAttribute(attr1, pt1[0]);
      gfill.setAttribute(attr2, pt1[1]);
      if (hasOpacity && !itemData.g._collapsable) {
        itemData.of.setAttribute(attr1, pt1[0]);
        itemData.of.setAttribute(attr2, pt1[1]);
      }
    }
    var stops;
    var i;
    var len;
    var stop;
    if (itemData.g._cmdf || isFirstFrame) {
      stops = itemData.cst;
      var cValues = itemData.g.c;
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        stop.setAttribute('offset', cValues[i * 4] + '%');
        stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
      }
    }
    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
      var oValues = itemData.g.o;
      if (itemData.g._collapsable) {
        stops = itemData.cst;
      } else {
        stops = itemData.ost;
      }
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        if (!itemData.g._collapsable) {
          stop.setAttribute('offset', oValues[i * 2] + '%');
        }
        stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
      }
    }
    if (styleData.t === 1) {
      if (itemData.e._mdf || isFirstFrame) {
        gfill.setAttribute('x2', pt2[0]);
        gfill.setAttribute('y2', pt2[1]);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('x2', pt2[0]);
          itemData.of.setAttribute('y2', pt2[1]);
        }
      }
    } else {
      var rad;
      if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
        rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        gfill.setAttribute('r', rad);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('r', rad);
        }
      }
      if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
        if (!rad) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        }
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

        var percent = itemData.h.v;
        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }
        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        gfill.setAttribute('fx', x);
        gfill.setAttribute('fy', y);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('fx', x);
          itemData.of.setAttribute('fy', y);
        }
      }
      // gfill.setAttribute('fy','200');
    }
  }

  function renderStroke(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;
    var d = itemData.d;
    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
      styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
      styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
    }
    if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
      styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
    }
    if (itemData.w._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
      if (styleElem.msElem) {
        styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
      }
    }
  }

  return ob;
}());

/* global Matrix */

function ShapeTransformManager() {
  this.sequences = {};
  this.sequenceList = [];
  this.transform_key_count = 0;
}

ShapeTransformManager.prototype = {
  addTransformSequence: function (transforms) {
    var i;
    var len = transforms.length;
    var key = '_';
    for (i = 0; i < len; i += 1) {
      key += transforms[i].transform.key + '_';
    }
    var sequence = this.sequences[key];
    if (!sequence) {
      sequence = {
        transforms: [].concat(transforms),
        finalTransform: new Matrix(),
        _mdf: false,
      };
      this.sequences[key] = sequence;
      this.sequenceList.push(sequence);
    }
    return sequence;
  },
  processSequence: function (sequence, isFirstFrame) {
    var i = 0;
    var len = sequence.transforms.length;
    var _mdf = isFirstFrame;
    while (i < len && !isFirstFrame) {
      if (sequence.transforms[i].transform.mProps._mdf) {
        _mdf = true;
        break;
      }
      i += 1;
    }
    if (_mdf) {
      var props;
      sequence.finalTransform.reset();
      for (i = len - 1; i >= 0; i -= 1) {
        props = sequence.transforms[i].transform.mProps.v.props;
        sequence.finalTransform.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
      }
    }
    sequence._mdf = _mdf;
  },
  processSequences: function (isFirstFrame) {
    var i;
    var len = this.sequenceList.length;
    for (i = 0; i < len; i += 1) {
      this.processSequence(this.sequenceList[i], isFirstFrame);
    }
  },
  getNewKey: function () {
    this.transform_key_count += 1;
    return '_' + this.transform_key_count;
  },
};

/* global ShapePropertyFactory, SVGShapeData */

function CVShapeData(element, data, styles, transformsManager) {
  this.styledShapes = [];
  this.tr = [0, 0, 0, 0, 0, 0];
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
  var i;
  var len = styles.length;
  var styledShape;
  for (i = 0; i < len; i += 1) {
    if (!styles[i].closed) {
      styledShape = {
        transforms: transformsManager.addTransformSequence(styles[i].transforms),
        trNodes: [],
      };
      this.styledShapes.push(styledShape);
      styles[i].elements.push(styledShape);
    }
  }
}

CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

/* global LayerExpressionInterface, EffectsExpressionInterface, CompExpressionInterface, ShapeExpressionInterface,
TextExpressionInterface, getBlendMode,createElementID, EffectsManager */

function BaseElement() {
}

BaseElement.prototype = {
  checkMasks: function () {
    if (!this.data.hasMask) {
      return false;
    }
    var i = 0;
    var len = this.data.masksProperties.length;
    while (i < len) {
      if ((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  initExpressions: function () {
    this.layerInterface = LayerExpressionInterface(this);
    if (this.data.hasMask && this.maskManager) {
      this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if (this.data.ty === 0 || this.data.xt) {
      this.compInterface = CompExpressionInterface(this);
    } else if (this.data.ty === 4) {
      this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
      this.layerInterface.content = this.layerInterface.shapeInterface;
    } else if (this.data.ty === 5) {
      this.layerInterface.textInterface = TextExpressionInterface(this);
      this.layerInterface.text = this.layerInterface.textInterface;
    }
  },
  setBlendMode: function () {
    var blendModeValue = getBlendMode(this.data.bm);
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
  },
  initBaseData: function (data, globalData, comp) {
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.layerId = createElementID();

    // Stretch factor for old animations missing this property.
    if (!this.data.sr) {
      this.data.sr = 1;
    }
    // effects manager
    this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
  },
  getType: function () {
    return this.type;
  },
  sourceRectAtTime: function () {},
};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement */

function NullElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initFrame();
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
}

NullElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

NullElement.prototype.renderFrame = function () {
};

NullElement.prototype.getBaseElement = function () {
  return null;
};

NullElement.prototype.destroy = function () {
};

NullElement.prototype.sourceRectAtTime = function () {
};

NullElement.prototype.hide = function () {
};

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

/* global filtersFactory, featureSupport, filtersFactory, createElementID, createNS, MaskElement, SVGEffects, locationHref */

function SVGBaseElement() {
}

SVGBaseElement.prototype = {
  initRendererElement: function () {
    this.layerElement = createNS('g');
  },
  createContainerElements: function () {
    this.matteElement = createNS('g');
    this.transformedElement = this.layerElement;
    this.maskedElement = this.layerElement;
    this._sizeChanged = false;
    var layerElementParent = null;
    // If this layer acts as a mask for the following layer
    var filId;
    var fil;
    var gg;
    if (this.data.td) {
      if (this.data.td == 3 || this.data.td == 1) { // eslint-disable-line eqeqeq
        var masker = createNS('mask');
        masker.setAttribute('id', this.layerId);
        masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha'); // eslint-disable-line eqeqeq
        masker.appendChild(this.layerElement);
        layerElementParent = masker;
        this.globalData.defs.appendChild(masker);
        // This is only for IE and Edge when mask if of type alpha
        if (!featureSupport.maskType && this.data.td == 1) { // eslint-disable-line eqeqeq
          masker.setAttribute('mask-type', 'luminance');
          filId = createElementID();
          fil = filtersFactory.createFilter(filId);
          this.globalData.defs.appendChild(fil);
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          masker.appendChild(gg);
          gg.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        }
      } else if (this.data.td == 2) { // eslint-disable-line eqeqeq
        var maskGroup = createNS('mask');
        maskGroup.setAttribute('id', this.layerId);
        maskGroup.setAttribute('mask-type', 'alpha');
        var maskGrouper = createNS('g');
        maskGroup.appendChild(maskGrouper);
        filId = createElementID();
        fil = filtersFactory.createFilter(filId);
        /// /

        // This solution doesn't work on Android when meta tag with viewport attribute is set
        /* var feColorMatrix = createNS('feColorMatrix');
                feColorMatrix.setAttribute('type', 'matrix');
                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
                fil.appendChild(feColorMatrix); */
        /// /
        var feCTr = createNS('feComponentTransfer');
        feCTr.setAttribute('in', 'SourceGraphic');
        fil.appendChild(feCTr);
        var feFunc = createNS('feFuncA');
        feFunc.setAttribute('type', 'table');
        feFunc.setAttribute('tableValues', '1.0 0.0');
        feCTr.appendChild(feFunc);
        /// /
        this.globalData.defs.appendChild(fil);
        var alphaRect = createNS('rect');
        alphaRect.setAttribute('width', this.comp.data.w);
        alphaRect.setAttribute('height', this.comp.data.h);
        alphaRect.setAttribute('x', '0');
        alphaRect.setAttribute('y', '0');
        alphaRect.setAttribute('fill', '#ffffff');
        alphaRect.setAttribute('opacity', '0');
        maskGrouper.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        maskGrouper.appendChild(alphaRect);
        maskGrouper.appendChild(this.layerElement);
        layerElementParent = maskGrouper;
        if (!featureSupport.maskType) {
          maskGroup.setAttribute('mask-type', 'luminance');
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          maskGrouper.appendChild(alphaRect);
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          maskGrouper.appendChild(gg);
        }
        this.globalData.defs.appendChild(maskGroup);
      }
    } else if (this.data.tt) {
      this.matteElement.appendChild(this.layerElement);
      layerElementParent = this.matteElement;
      this.baseElement = this.matteElement;
    } else {
      this.baseElement = this.layerElement;
    }
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
    if (this.data.ty === 0 && !this.data.hd) {
      var cp = createNS('clipPath');
      var pt = createNS('path');
      pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
      var clipId = createElementID();
      cp.setAttribute('id', clipId);
      cp.appendChild(pt);
      this.globalData.defs.appendChild(cp);

      if (this.checkMasks()) {
        var cpGroup = createNS('g');
        cpGroup.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
        cpGroup.appendChild(this.layerElement);
        this.transformedElement = cpGroup;
        if (layerElementParent) {
          layerElementParent.appendChild(this.transformedElement);
        } else {
          this.baseElement = this.transformedElement;
        }
      } else {
        this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
      }
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    if (this.finalTransform._matMdf) {
      this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
    }
    if (this.finalTransform._opMdf) {
      this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
    }
  },
  destroyBaseElement: function () {
    this.layerElement = null;
    this.matteElement = null;
    this.maskManager.destroy();
  },
  getBaseElement: function () {
    if (this.data.hd) {
      return null;
    }
    return this.baseElement;
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
    this.renderableEffectsManager = new SVGEffects(this);
  },
  setMatte: function (id) {
    if (!this.matteElement) {
      return;
    }
    this.matteElement.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
  },
};

/* global ProcessedElement */

function IShapeElement() {
}

IShapeElement.prototype = {
  addShapeToModifiers: function (data) {
    var i;
    var len = this.shapeModifiers.length;
    for (i = 0; i < len; i += 1) {
      this.shapeModifiers[i].addShape(data);
    }
  },
  isShapeInAnimatedModifiers: function (data) {
    var i = 0;
    var len = this.shapeModifiers.length;
    while (i < len) {
      if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
        return true;
      }
    }
    return false;
  },
  renderModifiers: function () {
    if (!this.shapeModifiers.length) {
      return;
    }
    var i;
    var len = this.shapes.length;
    for (i = 0; i < len; i += 1) {
      this.shapes[i].sh.reset();
    }

    len = this.shapeModifiers.length;
    var shouldBreakProcess;
    for (i = len - 1; i >= 0; i -= 1) {
      shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
      // workaround to fix cases where a repeater resets the shape so the following processes get called twice
      // TODO: find a better solution for this
      if (shouldBreakProcess) {
        break;
      }
    }
  },

  searchProcessedElement: function (elem) {
    var elements = this.processedElements;
    var i = 0;
    var len = elements.length;
    while (i < len) {
      if (elements[i].elem === elem) {
        return elements[i].pos;
      }
      i += 1;
    }
    return 0;
  },
  addProcessedElement: function (elem, pos) {
    var elements = this.processedElements;
    var i = elements.length;
    while (i) {
      i -= 1;
      if (elements[i].elem === elem) {
        elements[i].pos = pos;
        return;
      }
    }
    elements.push(new ProcessedElement(elem, pos));
  },
  prepareFrame: function (num) {
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  },
};

/* global TextProperty, TextAnimatorProperty, buildShapeString, LetterProps */

function ITextElement() {
}

ITextElement.prototype.initElement = function (data, globalData, comp) {
  this.lettersChangedFlag = true;
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
  this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
  this.initRenderable();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  this.createContent();
  this.hide();
  this.textAnimator.searchProperties(this.dynamicProperties);
};

ITextElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
    this.buildNewText();
    this.textProperty._isFirstFrame = false;
    this.textProperty._mdf = false;
  }
};

ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
  var j;
  var jLen = shapes.length;
  var pathNodes;
  var shapeStr = '';
  for (j = 0; j < jLen; j += 1) {
    pathNodes = shapes[j].ks.k;
    shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
  }
  return shapeStr;
};

ITextElement.prototype.updateDocumentData = function (newData, index) {
  this.textProperty.updateDocumentData(newData, index);
};

ITextElement.prototype.canResizeFont = function (_canResize) {
  this.textProperty.canResizeFont(_canResize);
};

ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
  this.textProperty.setMinimumFontSize(_fontSize);
};

ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
  if (documentData.ps) {
    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
  }
  matrixHelper.translate(0, -documentData.ls, 0);
  switch (documentData.j) {
    case 1:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
      break;
    case 2:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
      break;
    default:
      break;
  }
  matrixHelper.translate(xPos, yPos, 0);
};

ITextElement.prototype.buildColor = function (colorData) {
  return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
};

ITextElement.prototype.emptyProp = new LetterProps();

ITextElement.prototype.destroy = function () {

};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement */

function ICompElement() {}

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

ICompElement.prototype.initElement = function (data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initTransform(data, globalData, comp);
  this.initRenderable();
  this.initHierarchy();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  if (this.data.xt || !globalData.progressiveLoad) {
    this.buildAllItems();
  }
  this.hide();
};

/* ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this.hideElement();
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
}; */

ICompElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (!this.isInRange && !this.data.xt) {
    return;
  }

  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    if (timeRemapped === this.data.op) {
      timeRemapped = this.data.op - 1;
    }
    this.renderedFrame = timeRemapped;
  } else {
    this.renderedFrame = num / this.data.sr;
  }
  var i;
  var len = this.elements.length;
  if (!this.completeLayers) {
    this.checkLayers(this.renderedFrame);
  }
  // This iteration needs to be backwards because of how expressions connect between each other
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
      if (this.elements[i]._mdf) {
        this._mdf = true;
      }
    }
  }
};

ICompElement.prototype.renderInnerContent = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

ICompElement.prototype.setElements = function (elems) {
  this.elements = elems;
};

ICompElement.prototype.getElements = function () {
  return this.elements;
};

ICompElement.prototype.destroyElements = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
};

ICompElement.prototype.destroy = function () {
  this.destroyElements();
  this.destroyBaseElement();
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, createNS */

function IImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
  this.sourceRect = {
    top: 0, left: 0, width: this.assetData.w, height: this.assetData.h,
  };
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

IImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);

  this.innerElem = createNS('image');
  this.innerElem.setAttribute('width', this.assetData.w + 'px');
  this.innerElem.setAttribute('height', this.assetData.h + 'px');
  this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
  this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);

  this.layerElement.appendChild(this.innerElem);
};

IImageElement.prototype.sourceRectAtTime = function () {
  return this.sourceRect;
};

/* global extendPrototype, IImageElement, createNS */

function ISolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([IImageElement], ISolidElement);

ISolidElement.prototype.createContent = function () {
  var rect = createNS('rect');
  /// /rect.style.width = this.data.sw;
  /// /rect.style.height = this.data.sh;
  /// /rect.style.fill = this.data.sc;
  rect.setAttribute('width', this.data.sw);
  rect.setAttribute('height', this.data.sh);
  rect.setAttribute('fill', this.data.sc);
  this.layerElement.appendChild(rect);
};

/* global PropertyFactory, extendPrototype, RenderableElement, BaseElement, FrameElement */

function AudioElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.initBaseData(data, globalData, comp);
  this._isPlaying = false;
  this._canPlay = false;
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  this.audio = this.globalData.audioController.createAudio(assetPath);
  this._currentTime = 0;
  this.globalData.audioController.addAudio(this);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

AudioElement.prototype.prepareFrame = function (num) {
  this.prepareRenderableFrame(num, true);
  this.prepareProperties(num, true);
  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    this._currentTime = timeRemapped;
  } else {
    this._currentTime = num / this.data.sr;
  }
};

extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

AudioElement.prototype.renderFrame = function () {
  if (this.isInRange && this._canPlay) {
    if (!this._isPlaying) {
      this.audio.play();
      this.audio.seek(this._currentTime / this.globalData.frameRate);
      this._isPlaying = true;
    } else if (!this.audio.playing()
      || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1
    ) {
      this.audio.seek(this._currentTime / this.globalData.frameRate);
    }
  }
};

AudioElement.prototype.show = function () {
  // this.audio.play()
};

AudioElement.prototype.hide = function () {
  this.audio.pause();
  this._isPlaying = false;
};

AudioElement.prototype.pause = function () {
  this.audio.pause();
  this._isPlaying = false;
  this._canPlay = false;
};

AudioElement.prototype.resume = function () {
  this._canPlay = true;
};

AudioElement.prototype.setRate = function (rateValue) {
  this.audio.rate(rateValue);
};

AudioElement.prototype.volume = function (volumeValue) {
  this.audio.volume(volumeValue);
};

AudioElement.prototype.getBaseElement = function () {
  return null;
};

AudioElement.prototype.destroy = function () {
};

AudioElement.prototype.sourceRectAtTime = function () {
};

AudioElement.prototype.initExpressions = function () {
};

/* global extendPrototype, RenderableElement, BaseElement, FrameElement, FootageInterface */

function FootageElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.footageData = globalData.imageLoader.getAsset(this.assetData);
  this.initBaseData(data, globalData, comp);
}

FootageElement.prototype.prepareFrame = function () {
};

extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

FootageElement.prototype.getBaseElement = function () {
  return null;
};

FootageElement.prototype.renderFrame = function () {
};

FootageElement.prototype.destroy = function () {
};

FootageElement.prototype.initExpressions = function () {
  this.layerInterface = FootageInterface(this);
};

FootageElement.prototype.getFootageData = function () {
  return this.footageData;
};

/* global createSizedArray, PropertyFactory, extendPrototype, SVGRenderer, ICompElement, SVGBaseElement */

function SVGCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = true;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  // this.layerElement = createNS('g');
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createNS */

function SVGTextLottieElement(data, globalData, comp) {
  this.textSpans = [];
  this.renderType = 'svg';
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

SVGTextLottieElement.prototype.createContent = function () {
  if (this.data.singleShape && !this.globalData.fontManager.chars) {
    this.textContainer = createNS('text');
  }
};

SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
  var i = 0;
  var len = textArray.length;
  var textContents = [];
  var currentTextContent = '';
  while (i < len) {
    if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
      textContents.push(currentTextContent);
      currentTextContent = '';
    } else {
      currentTextContent += textArray[i];
    }
    i += 1;
  }
  textContents.push(currentTextContent);
  return textContents;
};

SVGTextLottieElement.prototype.buildNewText = function () {
  var i;
  var len;

  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
  if (documentData.fc) {
    this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
  } else {
    this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
  }
  if (documentData.sc) {
    this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
    this.layerElement.setAttribute('stroke-width', documentData.sw);
  }
  this.layerElement.setAttribute('font-size', documentData.finalSize);
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (fontData.fClass) {
    this.layerElement.setAttribute('class', fontData.fClass);
  } else {
    this.layerElement.setAttribute('font-family', fontData.fFamily);
    var fWeight = documentData.fWeight;
    var fStyle = documentData.fStyle;
    this.layerElement.setAttribute('font-style', fStyle);
    this.layerElement.setAttribute('font-weight', fWeight);
  }
  this.layerElement.setAttribute('aria-label', documentData.t);

  var letters = documentData.l || [];
  var usesGlyphs = !!this.globalData.fontManager.chars;
  len = letters.length;

  var tSpan;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var singleShape = this.data.singleShape;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  if (singleShape && !usesGlyphs && !documentData.sz) {
    var tElement = this.textContainer;
    var justify = 'start';
    switch (documentData.j) {
      case 1:
        justify = 'end';
        break;
      case 2:
        justify = 'middle';
        break;
      default:
        justify = 'start';
        break;
    }
    tElement.setAttribute('text-anchor', justify);
    tElement.setAttribute('letter-spacing', trackingOffset);
    var textContent = this.buildTextContents(documentData.finalText);
    len = textContent.length;
    yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
    for (i = 0; i < len; i += 1) {
      tSpan = this.textSpans[i] || createNS('tspan');
      tSpan.textContent = textContent[i];
      tSpan.setAttribute('x', 0);
      tSpan.setAttribute('y', yPos);
      tSpan.style.display = 'inherit';
      tElement.appendChild(tSpan);
      this.textSpans[i] = tSpan;
      yPos += documentData.finalLineHeight;
    }

    this.layerElement.appendChild(tElement);
  } else {
    var cachedSpansLength = this.textSpans.length;
    var shapeData;
    var charData;
    for (i = 0; i < len; i += 1) {
      if (!usesGlyphs || !singleShape || i === 0) {
        tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs ? 'path' : 'text');
        if (cachedSpansLength <= i) {
          tSpan.setAttribute('stroke-linecap', 'butt');
          tSpan.setAttribute('stroke-linejoin', 'round');
          tSpan.setAttribute('stroke-miterlimit', '4');
          this.textSpans[i] = tSpan;
          this.layerElement.appendChild(tSpan);
        }
        tSpan.style.display = 'inherit';
      }

      matrixHelper.reset();
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
      if (singleShape) {
        if (letters[i].n) {
          xPos = -trackingOffset;
          yPos += documentData.yOffset;
          yPos += firstLine ? 1 : 0;
          firstLine = false;
        }
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
        xPos += letters[i].l || 0;
        // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
        xPos += trackingOffset;
      }
      if (usesGlyphs) {
        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        shapeData = (charData && charData.data) || {};
        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
        if (!singleShape) {
          tSpan.setAttribute('d', this.createPathShape(matrixHelper, shapes));
        } else {
          shapeStr += this.createPathShape(matrixHelper, shapes);
        }
      } else {
        if (singleShape) {
          tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
        }
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      }
      //
    }
    if (singleShape && tSpan) {
      tSpan.setAttribute('d', shapeStr);
    }
  }
  while (i < this.textSpans.length) {
    this.textSpans[i].style.display = 'none';
    i += 1;
  }

  this._sizeChanged = true;
};

SVGTextLottieElement.prototype.sourceRectAtTime = function () {
  this.prepareFrame(this.comp.renderedFrame - this.data.st);
  this.renderInnerContent();
  if (this._sizeChanged) {
    this._sizeChanged = false;
    var textBox = this.layerElement.getBBox();
    this.bbox = {
      top: textBox.y,
      left: textBox.x,
      width: textBox.width,
      height: textBox.height,
    };
  }
  return this.bbox;
};

SVGTextLottieElement.prototype.renderInnerContent = function () {
  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
      this._sizeChanged = true;
      var i;
      var len;
      var renderedLetters = this.textAnimator.renderedLetters;

      var letters = this.textProperty.currentData.l;

      len = letters.length;
      var renderedLetter;
      var textSpan;
      for (i = 0; i < len; i += 1) {
        if (!letters[i].n) {
          renderedLetter = renderedLetters[i];
          textSpan = this.textSpans[i];
          if (renderedLetter._mdf.m) {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
          if (renderedLetter._mdf.o) {
            textSpan.setAttribute('opacity', renderedLetter.o);
          }
          if (renderedLetter._mdf.sw) {
            textSpan.setAttribute('stroke-width', renderedLetter.sw);
          }
          if (renderedLetter._mdf.sc) {
            textSpan.setAttribute('stroke', renderedLetter.sc);
          }
          if (renderedLetter._mdf.fc) {
            textSpan.setAttribute('fill', renderedLetter.fc);
          }
        }
      }
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement,
FrameElement, RenderableDOMElement, Matrix, SVGStyleData, SVGStrokeStyleData, SVGFillStyleData,
SVGGradientFillStyleData, SVGGradientStrokeStyleData, locationHref, getBlendMode, ShapeGroupData,
TransformPropertyFactory, SVGTransformData, ShapePropertyFactory, SVGShapeData, SVGElementsRenderer, ShapeModifiers,
lineCapEnum, lineJoinEnum */

function SVGShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

SVGShapeElement.prototype.initSecondaryElement = function () {
};

SVGShapeElement.prototype.identityMatrix = new Matrix();

SVGShapeElement.prototype.buildExpressionInterface = function () {};

SVGShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
};

/*
This method searches for multiple shapes that affect a single element and one of them is animated
*/
SVGShapeElement.prototype.filterUniqueShapes = function () {
  var i;
  var len = this.shapes.length;
  var shape;
  var j;
  var jLen = this.stylesList.length;
  var style;
  var tempShapes = [];
  var areAnimated = false;
  for (j = 0; j < jLen; j += 1) {
    style = this.stylesList[j];
    areAnimated = false;
    tempShapes.length = 0;
    for (i = 0; i < len; i += 1) {
      shape = this.shapes[i];
      if (shape.styles.indexOf(style) !== -1) {
        tempShapes.push(shape);
        areAnimated = shape._isAnimated || areAnimated;
      }
    }
    if (tempShapes.length > 1 && areAnimated) {
      this.setShapesAsAnimated(tempShapes);
    }
  }
};

SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
  var i;
  var len = shapes.length;
  for (i = 0; i < len; i += 1) {
    shapes[i].setAsAnimated();
  }
};

SVGShapeElement.prototype.createStyleElement = function (data, level) {
  // TODO: prevent drawing of hidden styles
  var elementData;
  var styleOb = new SVGStyleData(data, level);

  var pathElement = styleOb.pElem;
  if (data.ty === 'st') {
    elementData = new SVGStrokeStyleData(this, data, styleOb);
  } else if (data.ty === 'fl') {
    elementData = new SVGFillStyleData(this, data, styleOb);
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
    elementData = new GradientConstructor(this, data, styleOb);
    this.globalData.defs.appendChild(elementData.gf);
    if (elementData.maskId) {
      this.globalData.defs.appendChild(elementData.ms);
      this.globalData.defs.appendChild(elementData.of);
      pathElement.setAttribute('mask', 'url(' + locationHref + '#' + elementData.maskId + ')');
    }
  }

  if (data.ty === 'st' || data.ty === 'gs') {
    pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
    pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
    pathElement.setAttribute('fill-opacity', '0');
    if (data.lj === 1) {
      pathElement.setAttribute('stroke-miterlimit', data.ml);
    }
  }

  if (data.r === 2) {
    pathElement.setAttribute('fill-rule', 'evenodd');
  }

  if (data.ln) {
    pathElement.setAttribute('id', data.ln);
  }
  if (data.cl) {
    pathElement.setAttribute('class', data.cl);
  }
  if (data.bm) {
    pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  this.stylesList.push(styleOb);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createGroupElement = function (data) {
  var elementData = new ShapeGroupData();
  if (data.ln) {
    elementData.gr.setAttribute('id', data.ln);
  }
  if (data.cl) {
    elementData.gr.setAttribute('class', data.cl);
  }
  if (data.bm) {
    elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  return elementData;
};

SVGShapeElement.prototype.createTransformElement = function (data, container) {
  var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
  var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
  var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
  var i = 0;
  var len = this.animatedContents.length;
  while (i < len) {
    if (this.animatedContents[i].element === element) {
      return;
    }
    i += 1;
  }
  this.animatedContents.push({
    fn: SVGElementsRenderer.createRenderFunction(data),
    element: element,
    data: data,
  });
};

SVGShapeElement.prototype.setElementStyles = function (elementData) {
  var arr = elementData.styles;
  var j;
  var jLen = this.stylesList.length;
  for (j = 0; j < jLen; j += 1) {
    if (!this.stylesList[j].closed) {
      arr.push(this.stylesList[j]);
    }
  }
};

SVGShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
};

SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
  var ownTransformers = [].concat(transformers);
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var currentTransform;
  var modifier;
  var processedPos;
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._render = render;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], level);
      } else {
        itemsData[i].style.closed = false;
      }
      if (arr[i]._render) {
        if (itemsData[i].style.pElem.parentNode !== container) {
          container.appendChild(itemsData[i].style.pElem);
        }
      }
      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
      if (arr[i]._render) {
        if (itemsData[i].gr.parentNode !== container) {
          container.appendChild(itemsData[i].gr);
        }
      }
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        itemsData[i] = this.createTransformElement(arr[i], container);
      }
      currentTransform = itemsData[i].transform;
      ownTransformers.push(currentTransform);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
      }
      this.setElementStyles(itemsData[i]);
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        render = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  len = ownStyles.length;
  for (i = 0; i < len; i += 1) {
    ownStyles[i].closed = true;
  }
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

SVGShapeElement.prototype.renderInnerContent = function () {
  this.renderModifiers();
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    this.stylesList[i].reset();
  }
  this.renderShape();

  for (i = 0; i < len; i += 1) {
    if (this.stylesList[i]._mdf || this._isFirstFrame) {
      if (this.stylesList[i].msElem) {
        this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
        // Adding M0 0 fixes same mask bug on all browsers
        this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
      }
      this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
    }
  }
};

SVGShapeElement.prototype.renderShape = function () {
  var i;
  var len = this.animatedContents.length;
  var animatedContent;
  for (i = 0; i < len; i += 1) {
    animatedContent = this.animatedContents[i];
    if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
      animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
    }
  }
};

SVGShapeElement.prototype.destroy = function () {
  this.destroyBaseElement();
  this.shapesData = null;
  this.itemsData = null;
};

/* global createNS */

function SVGTintFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f2');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
  if (filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k) {
    var feMerge = createNS('feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'SourceGraphic');
    feMerge.appendChild(feMergeNode);
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'f2');
    feMerge.appendChild(feMergeNode);
  }
}

SVGTintFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var colorBlack = this.filterManager.effectElements[0].p.v;
    var colorWhite = this.filterManager.effectElements[1].p.v;
    var opacity = this.filterManager.effectElements[2].p.v / 100;
    this.matrixFilter.setAttribute('values', (colorWhite[0] - colorBlack[0]) + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGFillFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color = this.filterManager.effectElements[2].p.v;
    var opacity = this.filterManager.effectElements[6].p.v;
    this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGGaussianBlurEffect(filter, filterManager) {
  // Outset the filter region by 100% on all sides to accommodate blur expansion.
  filter.setAttribute('x', '-100%');
  filter.setAttribute('y', '-100%');
  filter.setAttribute('width', '300%');
  filter.setAttribute('height', '300%');

  this.filterManager = filterManager;
  var feGaussianBlur = createNS('feGaussianBlur');
  filter.appendChild(feGaussianBlur);
  this.feGaussianBlur = feGaussianBlur;
}

SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    // Empirical value, matching AE's blur appearance.
    var kBlurrinessToSigma = 0.3;
    var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

    // Dimensions mapping:
    //
    //   1 -> horizontal & vertical
    //   2 -> horizontal only
    //   3 -> vertical only
    //
    var dimensions = this.filterManager.effectElements[1].p.v;
    var sigmaX = (dimensions == 3) ? 0 : sigma; // eslint-disable-line eqeqeq
    var sigmaY = (dimensions == 2) ? 0 : sigma; // eslint-disable-line eqeqeq

    this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);

    // Repeat edges mapping:
    //
    //   0 -> off -> duplicate
    //   1 -> on  -> wrap
    var edgeMode = (this.filterManager.effectElements[2].p.v == 1) ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
    this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
  }
};

/* global createNS, createElementID, locationHref, bmFloor */

function SVGStrokeEffect(elem, filterManager) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.elem = elem;
  this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function () {
  var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
  var path;
  var groupPath;
  var i;
  var len;
  if (this.filterManager.effectElements[1].p.v === 1) {
    len = this.elem.maskManager.masksProperties.length;
    i = 0;
  } else {
    i = this.filterManager.effectElements[0].p.v - 1;
    len = i + 1;
  }
  groupPath = createNS('g');
  groupPath.setAttribute('fill', 'none');
  groupPath.setAttribute('stroke-linecap', 'round');
  groupPath.setAttribute('stroke-dashoffset', 1);
  for (i; i < len; i += 1) {
    path = createNS('path');
    groupPath.appendChild(path);
    this.paths.push({ p: path, m: i });
  }
  if (this.filterManager.effectElements[10].p.v === 3) {
    var mask = createNS('mask');
    var id = createElementID();
    mask.setAttribute('id', id);
    mask.setAttribute('mask-type', 'alpha');
    mask.appendChild(groupPath);
    this.elem.globalData.defs.appendChild(mask);
    var g = createNS('g');
    g.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
    while (elemChildren[0]) {
      g.appendChild(elemChildren[0]);
    }
    this.elem.layerElement.appendChild(g);
    this.masker = mask;
    groupPath.setAttribute('stroke', '#fff');
  } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (this.filterManager.effectElements[10].p.v === 2) {
      elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      while (elemChildren.length) {
        this.elem.layerElement.removeChild(elemChildren[0]);
      }
    }
    this.elem.layerElement.appendChild(groupPath);
    this.elem.layerElement.removeAttribute('mask');
    groupPath.setAttribute('stroke', '#fff');
  }
  this.initialized = true;
  this.pathMasker = groupPath;
};

SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
  if (!this.initialized) {
    this.initialize();
  }
  var i;
  var len = this.paths.length;
  var mask;
  var path;
  for (i = 0; i < len; i += 1) {
    if (this.paths[i].m !== -1) {
      mask = this.elem.maskManager.viewData[this.paths[i].m];
      path = this.paths[i].p;
      if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
        path.setAttribute('d', mask.lastPath);
      }
      if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
        var dasharrayValue;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var l = path.getTotalLength();
          dasharrayValue = '0 0 0 ' + l * s + ' ';
          var lineLength = l * (e - s);
          var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          var units = Math.floor(lineLength / segment);
          var j;
          for (j = 0; j < units; j += 1) {
            dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
          }
          dasharrayValue += '0 ' + l * 10 + ' 0 0';
        } else {
          dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
        }
        path.setAttribute('stroke-dasharray', dasharrayValue);
      }
    }
  }
  if (forceRender || this.filterManager.effectElements[4].p._mdf) {
    this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
  }

  if (forceRender || this.filterManager.effectElements[6].p._mdf) {
    this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
  }
  if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (forceRender || this.filterManager.effectElements[3].p._mdf) {
      var color = this.filterManager.effectElements[3].p.v;
      this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
    }
  }
};

/* global createNS */

function SVGTritoneFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  var feComponentTransfer = createNS('feComponentTransfer');
  feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
  filter.appendChild(feComponentTransfer);
  this.matrixFilter = feComponentTransfer;
  var feFuncR = createNS('feFuncR');
  feFuncR.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncR);
  this.feFuncR = feFuncR;
  var feFuncG = createNS('feFuncG');
  feFuncG.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncG);
  this.feFuncG = feFuncG;
  var feFuncB = createNS('feFuncB');
  feFuncB.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncB);
  this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color1 = this.filterManager.effectElements[0].p.v;
    var color2 = this.filterManager.effectElements[1].p.v;
    var color3 = this.filterManager.effectElements[2].p.v;
    var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
    var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
    var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
    this.feFuncR.setAttribute('tableValues', tableR);
    this.feFuncG.setAttribute('tableValues', tableG);
    this.feFuncB.setAttribute('tableValues', tableB);
    // var opacity = this.filterManager.effectElements[2].p.v/100;
    // this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGProLevelsFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var effectElements = this.filterManager.effectElements;
  var feComponentTransfer = createNS('feComponentTransfer');

  if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
    this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
  }
  if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
    this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
  }
  if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
    this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
  }
  if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
    this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
  }

  if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    feComponentTransfer = createNS('feComponentTransfer');
  }

  if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
    this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
    this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
  }
}

SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
  var feFunc = createNS(type);
  feFunc.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFunc);
  return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
  var cnt = 0;
  var segments = 256;
  var perc;
  var min = Math.min(inputBlack, inputWhite);
  var max = Math.max(inputBlack, inputWhite);
  var table = Array.call(null, { length: segments });
  var colorValue;
  var pos = 0;
  var outputDelta = outputWhite - outputBlack;
  var inputDelta = inputWhite - inputBlack;
  while (cnt <= 256) {
    perc = cnt / 256;
    if (perc <= min) {
      colorValue = inputDelta < 0 ? outputWhite : outputBlack;
    } else if (perc >= max) {
      colorValue = inputDelta < 0 ? outputBlack : outputWhite;
    } else {
      colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
    }
    table[pos] = colorValue;
    pos += 1;
    cnt += 256 / (segments - 1);
  }
  return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var val;
    var effectElements = this.filterManager.effectElements;
    if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
      val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
      this.feFuncRComposed.setAttribute('tableValues', val);
      this.feFuncGComposed.setAttribute('tableValues', val);
      this.feFuncBComposed.setAttribute('tableValues', val);
    }

    if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
      val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
      this.feFuncR.setAttribute('tableValues', val);
    }

    if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
      val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
      this.feFuncG.setAttribute('tableValues', val);
    }

    if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
      val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
      this.feFuncB.setAttribute('tableValues', val);
    }

    if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
      val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
      this.feFuncA.setAttribute('tableValues', val);
    }
  }
};

/* global createNS, rgbToHex, degToRads */

function SVGDropShadowEffect(filter, filterManager) {
  var filterSize = filterManager.container.globalData.renderConfig.filterSize;
  filter.setAttribute('x', filterSize.x);
  filter.setAttribute('y', filterSize.y);
  filter.setAttribute('width', filterSize.width);
  filter.setAttribute('height', filterSize.height);
  this.filterManager = filterManager;

  var feGaussianBlur = createNS('feGaussianBlur');
  feGaussianBlur.setAttribute('in', 'SourceAlpha');
  feGaussianBlur.setAttribute('result', 'drop_shadow_1');
  feGaussianBlur.setAttribute('stdDeviation', '0');
  this.feGaussianBlur = feGaussianBlur;
  filter.appendChild(feGaussianBlur);

  var feOffset = createNS('feOffset');
  feOffset.setAttribute('dx', '25');
  feOffset.setAttribute('dy', '0');
  feOffset.setAttribute('in', 'drop_shadow_1');
  feOffset.setAttribute('result', 'drop_shadow_2');
  this.feOffset = feOffset;
  filter.appendChild(feOffset);
  var feFlood = createNS('feFlood');
  feFlood.setAttribute('flood-color', '#00ff00');
  feFlood.setAttribute('flood-opacity', '1');
  feFlood.setAttribute('result', 'drop_shadow_3');
  this.feFlood = feFlood;
  filter.appendChild(feFlood);

  var feComposite = createNS('feComposite');
  feComposite.setAttribute('in', 'drop_shadow_3');
  feComposite.setAttribute('in2', 'drop_shadow_2');
  feComposite.setAttribute('operator', 'in');
  feComposite.setAttribute('result', 'drop_shadow_4');
  filter.appendChild(feComposite);

  var feMerge = createNS('feMerge');
  filter.appendChild(feMerge);
  var feMergeNode;
  feMergeNode = createNS('feMergeNode');
  feMerge.appendChild(feMergeNode);
  feMergeNode = createNS('feMergeNode');
  feMergeNode.setAttribute('in', 'SourceGraphic');
  this.feMergeNode = feMergeNode;
  this.feMerge = feMerge;
  this.originalNodeAdded = false;
  feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
    }
    if (forceRender || this.filterManager.effectElements[0].p._mdf) {
      var col = this.filterManager.effectElements[0].p.v;
      this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
    }
    if (forceRender || this.filterManager.effectElements[1].p._mdf) {
      this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
    }
    if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
      var distance = this.filterManager.effectElements[3].p.v;
      var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
      var x = distance * Math.cos(angle);
      var y = distance * Math.sin(angle);
      this.feOffset.setAttribute('dx', x);
      this.feOffset.setAttribute('dy', y);
    }
    /* if(forceRender || this.filterManager.effectElements[5].p._mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        } */
  }
};

/* global createElementID, createNS */

var _svgMatteSymbols = [];

function SVGMatte3Effect(filterElem, filterManager, elem) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.filterElem = filterElem;
  this.elem = elem;
  elem.matteElement = createNS('g');
  elem.matteElement.appendChild(elem.layerElement);
  elem.matteElement.appendChild(elem.transformedElement);
  elem.baseElement = elem.matteElement;
}

SVGMatte3Effect.prototype.findSymbol = function (mask) {
  var i = 0;
  var len = _svgMatteSymbols.length;
  while (i < len) {
    if (_svgMatteSymbols[i] === mask) {
      return _svgMatteSymbols[i];
    }
    i += 1;
  }
  return null;
};

SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
  var parentNode = mask.layerElement.parentNode;
  if (!parentNode) {
    return;
  }
  var children = parentNode.children;
  var i = 0;
  var len = children.length;
  while (i < len) {
    if (children[i] === mask.layerElement) {
      break;
    }
    i += 1;
  }
  var nextChild;
  if (i <= len - 2) {
    nextChild = children[i + 1];
  }
  var useElem = createNS('use');
  useElem.setAttribute('href', '#' + symbolId);
  if (nextChild) {
    parentNode.insertBefore(useElem, nextChild);
  } else {
    parentNode.appendChild(useElem);
  }
};

SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
  if (!this.findSymbol(mask)) {
    var symbolId = createElementID();
    var masker = createNS('mask');
    masker.setAttribute('id', mask.layerId);
    masker.setAttribute('mask-type', 'alpha');
    _svgMatteSymbols.push(mask);
    var defs = elem.globalData.defs;
    defs.appendChild(masker);
    var symbol = createNS('symbol');
    symbol.setAttribute('id', symbolId);
    this.replaceInParent(mask, symbolId);
    symbol.appendChild(mask.layerElement);
    defs.appendChild(symbol);
    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);
    masker.appendChild(useElem);
    mask.data.hd = false;
    mask.show();
  }
  elem.setMatte(mask.layerId);
};

SVGMatte3Effect.prototype.initialize = function () {
  var ind = this.filterManager.effectElements[0].p.v;
  var elements = this.elem.comp.elements;
  var i = 0;
  var len = elements.length;
  while (i < len) {
    if (elements[i] && elements[i].data.ind === ind) {
      this.setElementAsMask(this.elem, elements[i]);
    }
    i += 1;
  }
  this.initialized = true;
};

SVGMatte3Effect.prototype.renderFrame = function () {
  if (!this.initialized) {
    this.initialize();
  }
};

/* global createElementID, filtersFactory, SVGTintFilter, SVGFillFilter, SVGStrokeEffect, SVGTritoneFilter,
SVGProLevelsFilter, SVGDropShadowEffect, SVGMatte3Effect, SVGGaussianBlurEffect, locationHref */

function SVGEffects(elem) {
  var i;
  var len = elem.data.ef ? elem.data.ef.length : 0;
  var filId = createElementID();
  var fil = filtersFactory.createFilter(filId, true);
  var count = 0;
  this.filters = [];
  var filterManager;
  for (i = 0; i < len; i += 1) {
    filterManager = null;
    if (elem.data.ef[i].ty === 20) {
      count += 1;
      filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 21) {
      count += 1;
      filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 22) {
      filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 23) {
      count += 1;
      filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 24) {
      count += 1;
      filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 25) {
      count += 1;
      filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 28) {
      // count += 1;
      filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
    } else if (elem.data.ef[i].ty === 29) {
      count += 1;
      filterManager = new SVGGaussianBlurEffect(fil, elem.effectsManager.effectElements[i]);
    }
    if (filterManager) {
      this.filters.push(filterManager);
    }
  }
  if (count) {
    elem.globalData.defs.appendChild(fil);
    elem.layerElement.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
  }
  if (this.filters.length) {
    elem.addRenderableComponent(this);
  }
}

SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
  var i;
  var len = this.filters.length;
  for (i = 0; i < len; i += 1) {
    this.filters[i].renderFrame(_isFirstFrame);
  }
};

/* global Matrix, createTypedArray */

function CVContextData() {
  this.saved = [];
  this.cArrPos = 0;
  this.cTr = new Matrix();
  this.cO = 1;
  var i;
  var len = 15;
  this.savedOp = createTypedArray('float32', len);
  for (i = 0; i < len; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = len;
}

CVContextData.prototype.duplicate = function () {
  var newLength = this._length * 2;
  var currentSavedOp = this.savedOp;
  this.savedOp = createTypedArray('float32', newLength);
  this.savedOp.set(currentSavedOp);
  var i = 0;
  for (i = this._length; i < newLength; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = newLength;
};

CVContextData.prototype.reset = function () {
  this.cArrPos = 0;
  this.cTr.reset();
  this.cO = 1;
};

/* global CVEffects, getBlendMode, CVMaskElement, Matrix */

function CVBaseElement() {
}

CVBaseElement.prototype = {
  createElements: function () {},
  initRendererElement: function () {},
  createContainerElements: function () {
    this.canvasContext = this.globalData.canvasContext;
    this.renderableEffectsManager = new CVEffects(this);
  },
  createContent: function () {},
  setBlendMode: function () {
    var globalData = this.globalData;
    if (globalData.blendMode !== this.data.bm) {
      globalData.blendMode = this.data.bm;
      var blendModeValue = getBlendMode(this.data.bm);
      globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new CVMaskElement(this.data, this);
  },
  hideElement: function () {
    if (!this.hidden && (!this.isInRange || this.isTransparent)) {
      this.hidden = true;
    }
  },
  showElement: function () {
    if (this.isInRange && !this.isTransparent) {
      this.hidden = false;
      this._isFirstFrame = true;
      this.maskManager._isFirstFrame = true;
    }
  },
  renderFrame: function () {
    if (this.hidden || this.data.hd) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.setBlendMode();
    var forceRealStack = this.data.ty === 0;
    this.globalData.renderer.save(forceRealStack);
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
    this.renderInnerContent();
    this.globalData.renderer.restore(forceRealStack);
    if (this.maskManager.hasMasks) {
      this.globalData.renderer.restore(true);
    }
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    this.maskManager.destroy();
  },
  mHelper: new Matrix(),
};
CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement,HierarchyElement, FrameElement,
RenderableElement, SVGShapeElement, IImageElement, createTag */

function CVImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.img = globalData.imageLoader.getAsset(this.assetData);
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);

CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVImageElement.prototype.createContent = function () {
  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
    var canvas = createTag('canvas');
    canvas.width = this.assetData.w;
    canvas.height = this.assetData.h;
    var ctx = canvas.getContext('2d');

    var imgW = this.img.width;
    var imgH = this.img.height;
    var imgRel = imgW / imgH;
    var canvasRel = this.assetData.w / this.assetData.h;
    var widthCrop;
    var heightCrop;
    var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
    if ((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
      heightCrop = imgH;
      widthCrop = heightCrop * canvasRel;
    } else {
      widthCrop = imgW;
      heightCrop = widthCrop / canvasRel;
    }
    ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
    this.img = canvas;
  }
};

CVImageElement.prototype.renderInnerContent = function () {
  this.canvasContext.drawImage(this.img, 0, 0);
};

CVImageElement.prototype.destroy = function () {
  this.img = null;
};

/* global createSizedArray, PropertyFactory, extendPrototype, CanvasRenderer, ICompElement, CVBaseElement */

function CVCompElement(data, globalData, comp) {
  this.completeLayers = false;
  this.layers = data.layers;
  this.pendingElements = [];
  this.elements = createSizedArray(this.layers.length);
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);

CVCompElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(this.data.w, 0);
  ctx.lineTo(this.data.w, this.data.h);
  ctx.lineTo(0, this.data.h);
  ctx.lineTo(0, 0);
  ctx.clip();
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

CVCompElement.prototype.destroy = function () {
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.layers = null;
  this.elements = null;
};

/* global createSizedArray, ShapePropertyFactory, MaskElement */

function CVMaskElement(data, element) {
  this.data = data;
  this.element = element;
  this.masksProperties = this.data.masksProperties || [];
  this.viewData = createSizedArray(this.masksProperties.length);
  var i;
  var len = this.masksProperties.length;
  var hasMasks = false;
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      hasMasks = true;
    }
    this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
  }
  this.hasMasks = hasMasks;
  if (hasMasks) {
    this.element.addRenderableComponent(this);
  }
}

CVMaskElement.prototype.renderFrame = function () {
  if (!this.hasMasks) {
    return;
  }
  var transform = this.element.finalTransform.mat;
  var ctx = this.element.canvasContext;
  var i;
  var len = this.masksProperties.length;
  var pt;
  var pts;
  var data;
  ctx.beginPath();
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      if (this.masksProperties[i].inv) {
        ctx.moveTo(0, 0);
        ctx.lineTo(this.element.globalData.compSize.w, 0);
        ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
        ctx.lineTo(0, this.element.globalData.compSize.h);
        ctx.lineTo(0, 0);
      }
      data = this.viewData[i].v;
      pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
      ctx.moveTo(pt[0], pt[1]);
      var j;
      var jLen = data._length;
      for (j = 1; j < jLen; j += 1) {
        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
      pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
      ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
    }
  }
  this.element.globalData.renderer.save(true);
  ctx.clip();
};

CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

CVMaskElement.prototype.destroy = function () {
  this.element = null;
};

/* global ShapeTransformManager, extendPrototype, BaseElement, TransformElement, CVBaseElement, IShapeElement,
HierarchyElement, FrameElement, RenderableElement, RenderableDOMElement, PropertyFactory, degToRads, GradientProperty,
DashProperty, TransformPropertyFactory, CVShapeData, ShapeModifiers, bmFloor, lineCapEnum, lineJoinEnum */

function CVShapeElement(data, globalData, comp) {
  this.shapes = [];
  this.shapesData = data.shapes;
  this.stylesList = [];
  this.itemsData = [];
  this.prevViewData = [];
  this.shapeModifiers = [];
  this.processedElements = [];
  this.transformsManager = new ShapeTransformManager();
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);

CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;

CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: false };

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
};

CVShapeElement.prototype.createStyleElement = function (data, transforms) {
  var styleElem = {
    data: data,
    type: data.ty,
    preTransforms: this.transformsManager.addTransformSequence(transforms),
    transforms: [],
    elements: [],
    closed: data.hd === true,
  };
  var elementData = {};
  if (data.ty === 'fl' || data.ty === 'st') {
    elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
    if (!elementData.c.k) {
      styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
    }
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
    elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
    elementData.h = PropertyFactory.getProp(this, data.h || { k: 0 }, 0, 0.01, this);
    elementData.a = PropertyFactory.getProp(this, data.a || { k: 0 }, 0, degToRads, this);
    elementData.g = new GradientProperty(this, data.g, this);
  }
  elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
  if (data.ty === 'st' || data.ty === 'gs') {
    styleElem.lc = lineCapEnum[data.lc || 2];
    styleElem.lj = lineJoinEnum[data.lj || 2];
    if (data.lj == 1) { // eslint-disable-line eqeqeq
      styleElem.ml = data.ml;
    }
    elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
    if (!elementData.w.k) {
      styleElem.wi = elementData.w.v;
    }
    if (data.d) {
      var d = new DashProperty(this, data.d, 'canvas', this);
      elementData.d = d;
      if (!elementData.d.k) {
        styleElem.da = elementData.d.dashArray;
        styleElem.do = elementData.d.dashoffset[0];
      }
    }
  } else {
    styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
  }
  this.stylesList.push(styleElem);
  elementData.style = styleElem;
  return elementData;
};

CVShapeElement.prototype.createGroupElement = function () {
  var elementData = {
    it: [],
    prevViewData: [],
  };
  return elementData;
};

CVShapeElement.prototype.createTransformElement = function (data) {
  var elementData = {
    transform: {
      opacity: 1,
      _opMdf: false,
      key: this.transformsManager.getNewKey(),
      op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
      mProps: TransformPropertyFactory.getTransformProperty(this, data, this),
    },
  };
  return elementData;
};

CVShapeElement.prototype.createShapeElement = function (data) {
  var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);

  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  return elementData;
};

CVShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
};

CVShapeElement.prototype.addTransformToStyleList = function (transform) {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.push(transform);
    }
  }
};

CVShapeElement.prototype.removeTransformFromStyleList = function () {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.pop();
    }
  }
};

CVShapeElement.prototype.closeStyles = function (styles) {
  var i;
  var len = styles.length;
  for (i = 0; i < len; i += 1) {
    styles[i].closed = true;
  }
};

CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var processedPos;
  var modifier;
  var currentTransform;
  var ownTransforms = [].concat(transforms);
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._shouldRender = shouldRender;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
      } else {
        itemsData[i].style.closed = false;
      }

      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        currentTransform = this.createTransformElement(arr[i]);
        itemsData[i] = currentTransform;
      }
      ownTransforms.push(itemsData[i]);
      this.addTransformToStyleList(itemsData[i]);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i]);
      }
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        shouldRender = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  this.removeTransformFromStyleList();
  this.closeStyles(ownStyles);
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

CVShapeElement.prototype.renderInnerContent = function () {
  this.transformHelper.opacity = 1;
  this.transformHelper._opMdf = false;
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
  this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
};

CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
  if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
    groupTransform.opacity = parentTransform.opacity;
    groupTransform.opacity *= groupTransform.op.v;
    groupTransform._opMdf = true;
  }
};

CVShapeElement.prototype.drawLayer = function () {
  var i;
  var len = this.stylesList.length;
  var j;
  var jLen;
  var k;
  var kLen;
  var elems;
  var nodes;
  var renderer = this.globalData.renderer;
  var ctx = this.globalData.canvasContext;
  var type;
  var currentStyle;
  for (i = 0; i < len; i += 1) {
    currentStyle = this.stylesList[i];
    type = currentStyle.type;

    // Skipping style when
    // Stroke width equals 0
    // style should not be rendered (extra unused repeaters)
    // current opacity equals 0
    // global opacity equals 0
    if (!(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
      renderer.save();
      elems = currentStyle.elements;
      if (type === 'st' || type === 'gs') {
        ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
        ctx.lineWidth = currentStyle.wi;
        ctx.lineCap = currentStyle.lc;
        ctx.lineJoin = currentStyle.lj;
        ctx.miterLimit = currentStyle.ml || 0;
      } else {
        ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
      }
      renderer.ctxOpacity(currentStyle.coOp);
      if (type !== 'st' && type !== 'gs') {
        ctx.beginPath();
      }
      renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
      jLen = elems.length;
      for (j = 0; j < jLen; j += 1) {
        if (type === 'st' || type === 'gs') {
          ctx.beginPath();
          if (currentStyle.da) {
            ctx.setLineDash(currentStyle.da);
            ctx.lineDashOffset = currentStyle.do;
          }
        }
        nodes = elems[j].trNodes;
        kLen = nodes.length;

        for (k = 0; k < kLen; k += 1) {
          if (nodes[k].t === 'm') {
            ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
          } else if (nodes[k].t === 'c') {
            ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
          } else {
            ctx.closePath();
          }
        }
        if (type === 'st' || type === 'gs') {
          ctx.stroke();
          if (currentStyle.da) {
            ctx.setLineDash(this.dashResetter);
          }
        }
      }
      if (type !== 'st' && type !== 'gs') {
        ctx.fill(currentStyle.r);
      }
      renderer.restore();
    }
  }
};

CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
  var i;
  var len = items.length - 1;
  var groupTransform;
  groupTransform = parentTransform;
  for (i = len; i >= 0; i -= 1) {
    if (items[i].ty === 'tr') {
      groupTransform = data[i].transform;
      this.renderShapeTransform(parentTransform, groupTransform);
    } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
      this.renderPath(items[i], data[i]);
    } else if (items[i].ty === 'fl') {
      this.renderFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'st') {
      this.renderStroke(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
      this.renderGradientFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gr') {
      this.renderShape(groupTransform, items[i].it, data[i].it);
    } else if (items[i].ty === 'tm') {
      //
    }
  }
  if (isMain) {
    this.drawLayer();
  }
};

CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
  if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
    var shapeNodes = styledShape.trNodes;
    var paths = shape.paths;
    var i;
    var len;
    var j;
    var jLen = paths._length;
    shapeNodes.length = 0;
    var groupTransformMat = styledShape.transforms.finalTransform;
    for (j = 0; j < jLen; j += 1) {
      var pathNodes = paths.shapes[j];
      if (pathNodes && pathNodes.v) {
        len = pathNodes._length;
        for (i = 1; i < len; i += 1) {
          if (i === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
            });
          }
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i]),
          });
        }
        if (len === 1) {
          shapeNodes.push({
            t: 'm',
            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
          });
        }
        if (pathNodes.c && len) {
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0]),
          });
          shapeNodes.push({
            t: 'z',
          });
        }
      }
    }
    styledShape.trNodes = shapeNodes;
  }
};

CVShapeElement.prototype.renderPath = function (pathData, itemData) {
  if (pathData.hd !== true && pathData._shouldRender) {
    var i;
    var len = itemData.styledShapes.length;
    for (i = 0; i < len; i += 1) {
      this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
    }
  }
};

CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;

  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb('
        + bmFloor(itemData.c.v[0]) + ','
        + bmFloor(itemData.c.v[1]) + ','
        + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
};

CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var grd;
  if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
    var ctx = this.globalData.canvasContext;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;
    if (styleData.t === 1) {
      grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
    } else {
      var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
      var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

      var percent = itemData.h.v;
      if (percent >= 1) {
        percent = 0.99;
      } else if (percent <= -1) {
        percent = -0.99;
      }
      var dist = rad * percent;
      var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
      var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
      grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
    }

    var i;
    var len = styleData.g.p;
    var cValues = itemData.g.c;
    var opacity = 1;

    for (i = 0; i < len; i += 1) {
      if (itemData.g._hasOpacity && itemData.g._collapsable) {
        opacity = itemData.g.o[i * 2 + 1];
      }
      grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
    }
    styleElem.grd = grd;
  }
  styleElem.coOp = itemData.o.v * groupTransform.opacity;
};

CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var d = itemData.d;
  if (d && (d._mdf || this._isFirstFrame)) {
    styleElem.da = d.dashArray;
    styleElem.do = d.dashoffset[0];
  }
  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
  if (itemData.w._mdf || this._isFirstFrame) {
    styleElem.wi = itemData.w.v;
  }
};

CVShapeElement.prototype.destroy = function () {
  this.shapesData = null;
  this.globalData = null;
  this.canvasContext = null;
  this.stylesList.length = 0;
  this.itemsData.length = 0;
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement,
SVGShapeElement, IImageElement */

function CVSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);

CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVSolidElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.fillStyle = this.data.sc;
  ctx.fillRect(0, 0, this.data.sw, this.data.sh);
  //
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement,
RenderableElement, ITextElement, createTag, createSizedArray */

function CVTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.yOffset = 0;
  this.fillColorAnim = false;
  this.strokeColorAnim = false;
  this.strokeWidthAnim = false;
  this.stroke = false;
  this.fill = false;
  this.justifyOffset = 0;
  this.currentRender = null;
  this.renderType = 'canvas';
  this.values = {
    fill: 'rgba(0,0,0,0)',
    stroke: 'rgba(0,0,0,0)',
    sWidth: 0,
    fValue: '',
  };
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);

CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

CVTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);

  var hasFill = false;
  if (documentData.fc) {
    hasFill = true;
    this.values.fill = this.buildColor(documentData.fc);
  } else {
    this.values.fill = 'rgba(0,0,0,0)';
  }
  this.fill = hasFill;
  var hasStroke = false;
  if (documentData.sc) {
    hasStroke = true;
    this.values.stroke = this.buildColor(documentData.sc);
    this.values.sWidth = documentData.sw;
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  var i;
  var len;
  var letters = documentData.l;
  var matrixHelper = this.mHelper;
  this.stroke = hasStroke;
  this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
  len = documentData.finalText.length;
  // this.tHelper.font = this.values.fValue;
  var charData;
  var shapeData;
  var k;
  var kLen;
  var shapes;
  var j;
  var jLen;
  var pathNodes;
  var commands;
  var pathArr;
  var singleShape = this.data.singleShape;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
    shapeData = (charData && charData.data) || {};
    matrixHelper.reset();
    if (singleShape && letters[i].n) {
      xPos = -trackingOffset;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      firstLine = false;
    }

    shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
    jLen = shapes.length;
    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
    if (singleShape) {
      this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
    }
    commands = createSizedArray(jLen);
    for (j = 0; j < jLen; j += 1) {
      kLen = shapes[j].ks.k.i.length;
      pathNodes = shapes[j].ks.k;
      pathArr = [];
      for (k = 1; k < kLen; k += 1) {
        if (k === 1) {
          pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
        }
        pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
      }
      pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
      commands[j] = pathArr;
    }
    if (singleShape) {
      xPos += letters[i].l;
      xPos += trackingOffset;
    }
    if (this.textSpans[cnt]) {
      this.textSpans[cnt].elem = commands;
    } else {
      this.textSpans[cnt] = { elem: commands };
    }
    cnt += 1;
  }
};

CVTextElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.font = this.values.fValue;
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;

  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  }

  var i;
  var len;
  var j;
  var jLen;
  var k;
  var kLen;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var lastFill = null;
  var lastStroke = null;
  var lastStrokeW = null;
  var commands;
  var pathArr;
  for (i = 0; i < len; i += 1) {
    if (!letters[i].n) {
      renderedLetter = renderedLetters[i];
      if (renderedLetter) {
        this.globalData.renderer.save();
        this.globalData.renderer.ctxTransform(renderedLetter.p);
        this.globalData.renderer.ctxOpacity(renderedLetter.o);
      }
      if (this.fill) {
        if (renderedLetter && renderedLetter.fc) {
          if (lastFill !== renderedLetter.fc) {
            lastFill = renderedLetter.fc;
            ctx.fillStyle = renderedLetter.fc;
          }
        } else if (lastFill !== this.values.fill) {
          lastFill = this.values.fill;
          ctx.fillStyle = this.values.fill;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.fill();
        /// ctx.fillText(this.textSpans[i].val,0,0);
      }
      if (this.stroke) {
        if (renderedLetter && renderedLetter.sw) {
          if (lastStrokeW !== renderedLetter.sw) {
            lastStrokeW = renderedLetter.sw;
            ctx.lineWidth = renderedLetter.sw;
          }
        } else if (lastStrokeW !== this.values.sWidth) {
          lastStrokeW = this.values.sWidth;
          ctx.lineWidth = this.values.sWidth;
        }
        if (renderedLetter && renderedLetter.sc) {
          if (lastStroke !== renderedLetter.sc) {
            lastStroke = renderedLetter.sc;
            ctx.strokeStyle = renderedLetter.sc;
          }
        } else if (lastStroke !== this.values.stroke) {
          lastStroke = this.values.stroke;
          ctx.strokeStyle = this.values.stroke;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.stroke();
        /// ctx.strokeText(letters[i].val,0,0);
      }
      if (renderedLetter) {
        this.globalData.renderer.restore();
      }
    }
  }
};

function CVEffects() {

}
CVEffects.prototype.renderFrame = function () {};

/* global createTag, createNS, styleDiv, CVEffects, MaskElement, SVGBaseElement, HybridRenderer */

function HBaseElement() {}
HBaseElement.prototype = {
  checkBlendMode: function () {},
  initRendererElement: function () {
    this.baseElement = createTag(this.data.tg || 'div');
    if (this.data.hasMask) {
      this.svgElement = createNS('svg');
      this.layerElement = createNS('g');
      this.maskedElement = this.layerElement;
      this.svgElement.appendChild(this.layerElement);
      this.baseElement.appendChild(this.svgElement);
    } else {
      this.layerElement = this.baseElement;
    }
    styleDiv(this.baseElement);
  },
  createContainerElements: function () {
    this.renderableEffectsManager = new CVEffects(this);
    this.transformedElement = this.baseElement;
    this.maskedElement = this.layerElement;
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
    if (this.finalTransform._matMdf) {
      var matrixValue = this.finalTransform.mat.toCSS();
      transformedElementStyle.transform = matrixValue;
      transformedElementStyle.webkitTransform = matrixValue;
    }
    if (this.finalTransform._opMdf) {
      transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
    }
  },
  renderFrame: function () {
    // If it is exported as hidden (data.hd === true) no need to render
    // If it is not visible no need to render
    if (this.data.hd || this.hidden) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.renderElement();
    this.renderInnerContent();
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.layerElement = null;
    this.transformedElement = null;
    if (this.matteElement) {
      this.matteElement = null;
    }
    if (this.maskManager) {
      this.maskManager.destroy();
      this.maskManager = null;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
  },
  addEffects: function () {
  },
  setMatte: function () {},
};
HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, createNS, createTag */

function HSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

HSolidElement.prototype.createContent = function () {
  var rect;
  if (this.data.hasMask) {
    rect = createNS('rect');
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.svgElement.setAttribute('width', this.data.sw);
    this.svgElement.setAttribute('height', this.data.sh);
  } else {
    rect = createTag('div');
    rect.style.width = this.data.sw + 'px';
    rect.style.height = this.data.sh + 'px';
    rect.style.backgroundColor = this.data.sc;
  }
  this.layerElement.appendChild(rect);
};

/* global createSizedArray, PropertyFactory, extendPrototype, HybridRenderer, ICompElement, HBaseElement */

function HCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = !data.hasMask;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

HCompElement.prototype.createContainerElements = function () {
  this._createBaseContainerElements();
  // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
  if (this.data.hasMask) {
    this.svgElement.setAttribute('width', this.data.w);
    this.svgElement.setAttribute('height', this.data.h);
    this.transformedElement = this.baseElement;
  } else {
    this.transformedElement = this.layerElement;
  }
};

HCompElement.prototype.addTo3dContainer = function (elem, pos) {
  var j = 0;
  var nextElement;
  while (j < pos) {
    if (this.elements[j] && this.elements[j].getBaseElement) {
      nextElement = this.elements[j].getBaseElement();
    }
    j += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(elem, nextElement);
  } else {
    this.layerElement.appendChild(elem);
  }
};

/* global createNS, extendPrototype, BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement,
HierarchyElement, FrameElement, RenderableElement, createNS, bmMin, bmSqrt, bmMin, bmMax, bmPow */

function HShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.shapesContainer = createNS('g');
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
}
extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

HShapeElement.prototype.createContent = function () {
  var cont;
  this.baseElement.style.fontSize = 0;
  if (this.data.hasMask) {
    this.layerElement.appendChild(this.shapesContainer);
    cont = this.svgElement;
  } else {
    cont = createNS('svg');
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width', size.w);
    cont.setAttribute('height', size.h);
    cont.appendChild(this.shapesContainer);
    this.layerElement.appendChild(cont);
  }

  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
  this.filterUniqueShapes();
  this.shapeCont = cont;
};

HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
  var i;
  var len = transformers.length;
  for (i = 0; i < len; i += 1) {
    point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
  }
  return point;
};

HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
  var shape = item.sh.v;
  var transformers = item.transformers;
  var i;
  var len = shape._length;
  var vPoint;
  var oPoint;
  var nextIPoint;
  var nextVPoint;
  if (len <= 1) {
    return;
  }
  for (i = 0; i < len - 1; i += 1) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
  if (shape.c) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
};

HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
  this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
  var bounds = this.shapeBoundingBox;
  boundingBox.x = bmMin(bounds.left, boundingBox.x);
  boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
  boundingBox.y = bmMin(bounds.top, boundingBox.y);
  boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
};

HShapeElement.prototype.shapeBoundingBox = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

HShapeElement.prototype.tempBoundingBox = {
  x: 0,
  xMax: 0,
  y: 0,
  yMax: 0,
  width: 0,
  height: 0,
};

HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
  var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

  for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) { // eslint-disable-line no-plusplus
    b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
    a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
    c = 3 * p1[i] - 3 * p0[i];

    b |= 0; // eslint-disable-line no-bitwise
    a |= 0; // eslint-disable-line no-bitwise
    c |= 0; // eslint-disable-line no-bitwise

    if (a === 0 && b === 0) {
      //
    } else if (a === 0) {
      t = -c / b;

      if (t > 0 && t < 1) {
        bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
      }
    } else {
      b2ac = b * b - 4 * c * a;

      if (b2ac >= 0) {
        t1 = (-b + bmSqrt(b2ac)) / (2 * a);
        if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
        t2 = (-b - bmSqrt(b2ac)) / (2 * a);
        if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
      }
    }
  }

  this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
  this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
  this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
  this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
};

HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
  return bmPow(1 - t, 3) * p0[i]
        + 3 * bmPow(1 - t, 2) * t * p1[i]
        + 3 * (1 - t) * bmPow(t, 2) * p2[i]
        + bmPow(t, 3) * p3[i];
};

HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
  var i;
  var len = itemsData.length;
  for (i = 0; i < len; i += 1) {
    if (itemsData[i] && itemsData[i].sh) {
      this.calculateShapeBoundingBox(itemsData[i], boundingBox);
    } else if (itemsData[i] && itemsData[i].it) {
      this.calculateBoundingBox(itemsData[i].it, boundingBox);
    }
  }
};

HShapeElement.prototype.currentBoxContains = function (box) {
  return this.currentBBox.x <= box.x
    && this.currentBBox.y <= box.y
    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
};

HShapeElement.prototype.renderInnerContent = function () {
  this._renderShapeFrame();

  if (!this.hidden && (this._isFirstFrame || this._mdf)) {
    var tempBoundingBox = this.tempBoundingBox;
    var max = 999999;
    tempBoundingBox.x = max;
    tempBoundingBox.xMax = -max;
    tempBoundingBox.y = max;
    tempBoundingBox.yMax = -max;
    this.calculateBoundingBox(this.itemsData, tempBoundingBox);
    tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
    tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
    // var tempBoundingBox = this.shapeCont.getBBox();
    if (this.currentBoxContains(tempBoundingBox)) {
      return;
    }
    var changed = false;
    if (this.currentBBox.w !== tempBoundingBox.width) {
      this.currentBBox.w = tempBoundingBox.width;
      this.shapeCont.setAttribute('width', tempBoundingBox.width);
      changed = true;
    }
    if (this.currentBBox.h !== tempBoundingBox.height) {
      this.currentBBox.h = tempBoundingBox.height;
      this.shapeCont.setAttribute('height', tempBoundingBox.height);
      changed = true;
    }
    if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
      this.currentBBox.w = tempBoundingBox.width;
      this.currentBBox.h = tempBoundingBox.height;
      this.currentBBox.x = tempBoundingBox.x;
      this.currentBBox.y = tempBoundingBox.y;

      this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      var shapeStyle = this.shapeCont.style;
      var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      shapeStyle.transform = shapeTransform;
      shapeStyle.webkitTransform = shapeTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createTag, styleDiv, createNS, lineJoinEnum, lineCapEnum */

function HTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.textPaths = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
  this.renderType = 'svg';
  this.isMasked = false;
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

HTextElement.prototype.createContent = function () {
  this.isMasked = this.checkMasks();
  if (this.isMasked) {
    this.renderType = 'svg';
    this.compW = this.comp.data.w;
    this.compH = this.comp.data.h;
    this.svgElement.setAttribute('width', this.compW);
    this.svgElement.setAttribute('height', this.compH);
    var g = createNS('g');
    this.maskedElement.appendChild(g);
    this.innerElem = g;
  } else {
    this.renderType = 'html';
    this.innerElem = this.layerElement;
  }

  this.checkParenting();
};

HTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
  var innerElemStyle = this.innerElem.style;
  var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
  innerElemStyle.fill = textColor;
  innerElemStyle.color = textColor;
  if (documentData.sc) {
    innerElemStyle.stroke = this.buildColor(documentData.sc);
    innerElemStyle.strokeWidth = documentData.sw + 'px';
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (!this.globalData.fontManager.chars) {
    innerElemStyle.fontSize = documentData.finalSize + 'px';
    innerElemStyle.lineHeight = documentData.finalSize + 'px';
    if (fontData.fClass) {
      this.innerElem.className = fontData.fClass;
    } else {
      innerElemStyle.fontFamily = fontData.fFamily;
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      innerElemStyle.fontStyle = fStyle;
      innerElemStyle.fontWeight = fWeight;
    }
  }
  var i;
  var len;

  var letters = documentData.l;
  len = letters.length;
  var tSpan;
  var tParent;
  var tCont;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    if (this.globalData.fontManager.chars) {
      if (!this.textPaths[cnt]) {
        tSpan = createNS('path');
        tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
        tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
        tSpan.setAttribute('stroke-miterlimit', '4');
      } else {
        tSpan = this.textPaths[cnt];
      }
      if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tCont = tParent.children[0];
        } else {
          tParent = createTag('div');
          tParent.style.lineHeight = 0;
          tCont = createNS('svg');
          tCont.appendChild(tSpan);
          styleDiv(tParent);
        }
      }
    } else if (!this.isMasked) {
      if (this.textSpans[cnt]) {
        tParent = this.textSpans[cnt];
        tSpan = this.textPaths[cnt];
      } else {
        tParent = createTag('span');
        styleDiv(tParent);
        tSpan = createTag('span');
        styleDiv(tSpan);
        tParent.appendChild(tSpan);
      }
    } else {
      tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
    }
    // tSpan.setAttribute('visibility', 'hidden');
    if (this.globalData.fontManager.chars) {
      var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      var shapeData;
      if (charData) {
        shapeData = charData.data;
      } else {
        shapeData = null;
      }
      matrixHelper.reset();
      if (shapeData && shapeData.shapes) {
        shapes = shapeData.shapes[0].it;
        matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
        shapeStr = this.createPathShape(matrixHelper, shapes);
        tSpan.setAttribute('d', shapeStr);
      }
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        if (shapeData && shapeData.shapes) {
          // document.body.appendChild is needed to get exact measure of shape
          document.body.appendChild(tCont);
          var boundingBox = tCont.getBBox();
          tCont.setAttribute('width', boundingBox.width + 2);
          tCont.setAttribute('height', boundingBox.height + 2);
          tCont.setAttribute('viewBox', (boundingBox.x - 1) + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
          var tContStyle = tCont.style;
          var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
          tContStyle.transform = tContTranslation;
          tContStyle.webkitTransform = tContTranslation;

          letters[i].yOffset = boundingBox.y - 1;
        } else {
          tCont.setAttribute('width', 1);
          tCont.setAttribute('height', 1);
        }
        tParent.appendChild(tCont);
      } else {
        this.innerElem.appendChild(tSpan);
      }
    } else {
      tSpan.textContent = letters[i].val;
      tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        //
        var tStyle = tSpan.style;
        var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
        tStyle.transform = tSpanTranslation;
        tStyle.webkitTransform = tSpanTranslation;
      } else {
        this.innerElem.appendChild(tSpan);
      }
    }
    //
    if (!this.isMasked) {
      this.textSpans[cnt] = tParent;
    } else {
      this.textSpans[cnt] = tSpan;
    }
    this.textSpans[cnt].style.display = 'block';
    this.textPaths[cnt] = tSpan;
    cnt += 1;
  }
  while (cnt < this.textSpans.length) {
    this.textSpans[cnt].style.display = 'none';
    cnt += 1;
  }
};

HTextElement.prototype.renderInnerContent = function () {
  var svgStyle;
  if (this.data.singleShape) {
    if (!this._isFirstFrame && !this.lettersChangedFlag) {
      return;
    } if (this.isMasked && this.finalTransform._matMdf) {
      // Todo Benchmark if using this is better than getBBox
      this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
      svgStyle = this.svgElement.style;
      var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
      svgStyle.transform = translation;
      svgStyle.webkitTransform = translation;
    }
  }

  this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
    return;
  }
  var i;
  var len;
  var count = 0;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var textSpan;
  var textPath;
  for (i = 0; i < len; i += 1) {
    if (letters[i].n) {
      count += 1;
    } else {
      textSpan = this.textSpans[i];
      textPath = this.textPaths[i];
      renderedLetter = renderedLetters[count];
      count += 1;
      if (renderedLetter._mdf.m) {
        if (!this.isMasked) {
          textSpan.style.webkitTransform = renderedLetter.m;
          textSpan.style.transform = renderedLetter.m;
        } else {
          textSpan.setAttribute('transform', renderedLetter.m);
        }
      }
      /// /textSpan.setAttribute('opacity',renderedLetter.o);
      textSpan.style.opacity = renderedLetter.o;
      if (renderedLetter.sw && renderedLetter._mdf.sw) {
        textPath.setAttribute('stroke-width', renderedLetter.sw);
      }
      if (renderedLetter.sc && renderedLetter._mdf.sc) {
        textPath.setAttribute('stroke', renderedLetter.sc);
      }
      if (renderedLetter.fc && renderedLetter._mdf.fc) {
        textPath.setAttribute('fill', renderedLetter.fc);
        textPath.style.color = renderedLetter.fc;
      }
    }
  }

  if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
    var boundingBox = this.innerElem.getBBox();

    if (this.currentBBox.w !== boundingBox.width) {
      this.currentBBox.w = boundingBox.width;
      this.svgElement.setAttribute('width', boundingBox.width);
    }
    if (this.currentBBox.h !== boundingBox.height) {
      this.currentBBox.h = boundingBox.height;
      this.svgElement.setAttribute('height', boundingBox.height);
    }

    var margin = 1;
    if (this.currentBBox.w !== (boundingBox.width + margin * 2) || this.currentBBox.h !== (boundingBox.height + margin * 2) || this.currentBBox.x !== (boundingBox.x - margin) || this.currentBBox.y !== (boundingBox.y - margin)) {
      this.currentBBox.w = boundingBox.width + margin * 2;
      this.currentBBox.h = boundingBox.height + margin * 2;
      this.currentBBox.x = boundingBox.x - margin;
      this.currentBBox.y = boundingBox.y - margin;

      this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      svgStyle = this.svgElement.style;
      var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      svgStyle.transform = svgTransform;
      svgStyle.webkitTransform = svgTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement,
FrameElement, RenderableElement, createNS */

function HImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

HImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  var img = new Image();

  if (this.data.hasMask) {
    this.imageElem = createNS('image');
    this.imageElem.setAttribute('width', this.assetData.w + 'px');
    this.imageElem.setAttribute('height', this.assetData.h + 'px');
    this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.imageElem);
    this.baseElement.setAttribute('width', this.assetData.w);
    this.baseElement.setAttribute('height', this.assetData.h);
  } else {
    this.layerElement.appendChild(img);
  }
  img.crossOrigin = 'anonymous';
  img.src = assetPath;
  if (this.data.ln) {
    this.baseElement.setAttribute('id', this.data.ln);
  }
};

/* global PropertyFactory, degToRads, Matrix, extendPrototype, BaseElement, FrameElement, HierarchyElement */

function HCameraElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initHierarchy();
  var getProp = PropertyFactory.getProp;
  this.pe = getProp(this, data.pe, 0, 0, this);
  if (data.ks.p.s) {
    this.px = getProp(this, data.ks.p.x, 1, 0, this);
    this.py = getProp(this, data.ks.p.y, 1, 0, this);
    this.pz = getProp(this, data.ks.p.z, 1, 0, this);
  } else {
    this.p = getProp(this, data.ks.p, 1, 0, this);
  }
  if (data.ks.a) {
    this.a = getProp(this, data.ks.a, 1, 0, this);
  }
  if (data.ks.or.k.length && data.ks.or.k[0].to) {
    var i;
    var len = data.ks.or.k.length;
    for (i = 0; i < len; i += 1) {
      data.ks.or.k[i].to = null;
      data.ks.or.k[i].ti = null;
    }
  }
  this.or = getProp(this, data.ks.or, 1, degToRads, this);
  this.or.sh = true;
  this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
  this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
  this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
  this.mat = new Matrix();
  this._prevMat = new Matrix();
  this._isFirstFrame = true;

  // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
  this.finalTransform = {
    mProp: this,
  };
}
extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

HCameraElement.prototype.setup = function () {
  var i;
  var len = this.comp.threeDElements.length;
  var comp;
  var perspectiveStyle;
  var containerStyle;
  for (i = 0; i < len; i += 1) {
    // [perspectiveElem,container]
    comp = this.comp.threeDElements[i];
    if (comp.type === '3d') {
      perspectiveStyle = comp.perspectiveElem.style;
      containerStyle = comp.container.style;
      var perspective = this.pe.v + 'px';
      var origin = '0px 0px 0px';
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      perspectiveStyle.perspective = perspective;
      perspectiveStyle.webkitPerspective = perspective;
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      perspectiveStyle.transform = matrix;
      perspectiveStyle.webkitTransform = matrix;
    }
  }
};

HCameraElement.prototype.createElements = function () {
};

HCameraElement.prototype.hide = function () {
};

HCameraElement.prototype.renderFrame = function () {
  var _mdf = this._isFirstFrame;
  var i;
  var len;
  if (this.hierarchy) {
    len = this.hierarchy.length;
    for (i = 0; i < len; i += 1) {
      _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
    }
  }
  if (_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
    this.mat.reset();

    if (this.hierarchy) {
      len = this.hierarchy.length - 1;
      for (i = len; i >= 0; i -= 1) {
        var mTransf = this.hierarchy[i].finalTransform.mProp;
        this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
        this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
        this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
        this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
        this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
      }
    }
    if (this.p) {
      this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
    } else {
      this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
    }
    if (this.a) {
      var diffVector;
      if (this.p) {
        diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
      } else {
        diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
      }
      var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
      // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
      var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
      var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
      var mRotationX = (Math.atan2(lookDir[1], lookLengthOnXZ));
      var mRotationY = (Math.atan2(lookDir[0], -lookDir[2]));
      this.mat.rotateY(mRotationY).rotateX(-mRotationX);
    }
    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
    this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
    this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
    this.mat.translate(0, 0, this.pe.v);

    var hasMatrixChanged = !this._prevMat.equals(this.mat);
    if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
      len = this.comp.threeDElements.length;
      var comp;
      var perspectiveStyle;
      var containerStyle;
      for (i = 0; i < len; i += 1) {
        comp = this.comp.threeDElements[i];
        if (comp.type === '3d') {
          if (hasMatrixChanged) {
            var matValue = this.mat.toCSS();
            containerStyle = comp.container.style;
            containerStyle.transform = matValue;
            containerStyle.webkitTransform = matValue;
          }
          if (this.pe._mdf) {
            perspectiveStyle = comp.perspectiveElem.style;
            perspectiveStyle.perspective = this.pe.v + 'px';
            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
          }
        }
      }
      this.mat.clone(this._prevMat);
    }
  }
  this._isFirstFrame = false;
};

HCameraElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

HCameraElement.prototype.destroy = function () {
};
HCameraElement.prototype.getBaseElement = function () { return null; };

function HEffects() {
}
HEffects.prototype.renderFrame = function () {};

/* global createTag, AnimationItem */
/* exported animationManager */

var animationManager = (function () {
  var moduleOb = {};
  var registeredAnimations = [];
  var initTime = 0;
  var len = 0;
  var playingAnimationsNum = 0;
  var _stopped = true;
  var _isFrozen = false;

  function removeElement(ev) {
    var i = 0;
    var animItem = ev.target;
    while (i < len) {
      if (registeredAnimations[i].animation === animItem) {
        registeredAnimations.splice(i, 1);
        i -= 1;
        len -= 1;
        if (!animItem.isPaused) {
          subtractPlayingCount();
        }
      }
      i += 1;
    }
  }

  function registerAnimation(element, animationData) {
    if (!element) {
      return null;
    }
    var i = 0;
    while (i < len) {
      if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
        return registeredAnimations[i].animation;
      }
      i += 1;
    }
    var animItem = new AnimationItem();
    setupAnimation(animItem, element);
    animItem.setData(element, animationData);
    return animItem;
  }

  function getRegisteredAnimations() {
    var i;
    var lenAnims = registeredAnimations.length;
    var animations = [];
    for (i = 0; i < lenAnims; i += 1) {
      animations.push(registeredAnimations[i].animation);
    }
    return animations;
  }

  function addPlayingCount() {
    playingAnimationsNum += 1;
    activate();
  }

  function subtractPlayingCount() {
    playingAnimationsNum -= 1;
  }

  function setupAnimation(animItem, element) {
    animItem.addEventListener('destroy', removeElement);
    animItem.addEventListener('_active', addPlayingCount);
    animItem.addEventListener('_idle', subtractPlayingCount);
    registeredAnimations.push({ elem: element, animation: animItem });
    len += 1;
  }

  function loadAnimation(params) {
    var animItem = new AnimationItem();
    setupAnimation(animItem, null);
    animItem.setParams(params);
    return animItem;
  }

  function setSpeed(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setSpeed(val, animation);
    }
  }

  function setDirection(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setDirection(val, animation);
    }
  }

  function play(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.play(animation);
    }
  }
  function resume(nowTime) {
    var elapsedTime = nowTime - initTime;
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.advanceTime(elapsedTime);
    }
    initTime = nowTime;
    if (playingAnimationsNum && !_isFrozen) {
      window.requestAnimationFrame(resume);
    } else {
      _stopped = true;
    }
  }

  function first(nowTime) {
    initTime = nowTime;
    window.requestAnimationFrame(resume);
  }

  function pause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.pause(animation);
    }
  }

  function goToAndStop(value, isFrame, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
    }
  }

  function stop(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.stop(animation);
    }
  }

  function togglePause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.togglePause(animation);
    }
  }

  function destroy(animation) {
    var i;
    for (i = (len - 1); i >= 0; i -= 1) {
      registeredAnimations[i].animation.destroy(animation);
    }
  }

  function searchAnimations(animationData, standalone, renderer) {
    var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
      [].slice.call(document.getElementsByClassName('bodymovin')));
    var i;
    var lenAnims = animElements.length;
    for (i = 0; i < lenAnims; i += 1) {
      if (renderer) {
        animElements[i].setAttribute('data-bm-type', renderer);
      }
      registerAnimation(animElements[i], animationData);
    }
    if (standalone && lenAnims === 0) {
      if (!renderer) {
        renderer = 'svg';
      }
      var body = document.getElementsByTagName('body')[0];
      body.innerText = '';
      var div = createTag('div');
      div.style.width = '100%';
      div.style.height = '100%';
      div.setAttribute('data-bm-type', renderer);
      body.appendChild(div);
      registerAnimation(div, animationData);
    }
  }

  function resize() {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.resize();
    }
  }

  function activate() {
    if (!_isFrozen && playingAnimationsNum) {
      if (_stopped) {
        window.requestAnimationFrame(first);
        _stopped = false;
      }
    }
  }

  function freeze() {
    _isFrozen = true;
  }

  function unfreeze() {
    _isFrozen = false;
    activate();
  }

  function setVolume(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setVolume(val, animation);
    }
  }

  function mute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.mute(animation);
    }
  }

  function unmute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.unmute(animation);
    }
  }

  moduleOb.registerAnimation = registerAnimation;
  moduleOb.loadAnimation = loadAnimation;
  moduleOb.setSpeed = setSpeed;
  moduleOb.setDirection = setDirection;
  moduleOb.play = play;
  moduleOb.pause = pause;
  moduleOb.stop = stop;
  moduleOb.togglePause = togglePause;
  moduleOb.searchAnimations = searchAnimations;
  moduleOb.resize = resize;
  // moduleOb.start = start;
  moduleOb.goToAndStop = goToAndStop;
  moduleOb.destroy = destroy;
  moduleOb.freeze = freeze;
  moduleOb.unfreeze = unfreeze;
  moduleOb.setVolume = setVolume;
  moduleOb.mute = mute;
  moduleOb.unmute = unmute;
  moduleOb.getRegisteredAnimations = getRegisteredAnimations;
  return moduleOb;
}());

/* global createElementID, subframeEnabled, ProjectInterface, ImagePreloader, audioControllerFactory, extendPrototype, BaseEvent,
CanvasRenderer, SVGRenderer, HybridRenderer, dataManager, expressionsPlugin, BMEnterFrameEvent, BMCompleteLoopEvent,
BMCompleteEvent, BMSegmentStartEvent, BMDestroyEvent, BMEnterFrameEvent, BMCompleteLoopEvent, BMCompleteEvent, BMSegmentStartEvent,
BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, markerParser */

var AnimationItem = function () {
  this._cbs = [];
  this.name = '';
  this.path = '';
  this.isLoaded = false;
  this.currentFrame = 0;
  this.currentRawFrame = 0;
  this.firstFrame = 0;
  this.totalFrames = 0;
  this.frameRate = 0;
  this.frameMult = 0;
  this.playSpeed = 1;
  this.playDirection = 1;
  this.playCount = 0;
  this.animationData = {};
  this.assets = [];
  this.isPaused = true;
  this.autoplay = false;
  this.loop = true;
  this.renderer = null;
  this.animationID = createElementID();
  this.assetsPath = '';
  this.timeCompleted = 0;
  this.segmentPos = 0;
  this.isSubframeEnabled = subframeEnabled;
  this.segments = [];
  this._idle = true;
  this._completedLoop = false;
  this.projectInterface = ProjectInterface();
  this.imagePreloader = new ImagePreloader();
  this.audioController = audioControllerFactory();
  this.markers = [];
  this.configAnimation = this.configAnimation.bind(this);
  this.onSetupError = this.onSetupError.bind(this);
  this.onSegmentComplete = this.onSegmentComplete.bind(this);
};

extendPrototype([BaseEvent], AnimationItem);

AnimationItem.prototype.setParams = function (params) {
  if (params.wrapper || params.container) {
    this.wrapper = params.wrapper || params.container;
  }
  var animType = 'svg';
  if (params.animType) {
    animType = params.animType;
  } else if (params.renderer) {
    animType = params.renderer;
  }
  switch (animType) {
    case 'canvas':
      this.renderer = new CanvasRenderer(this, params.rendererSettings);
      break;
    case 'svg':
      this.renderer = new SVGRenderer(this, params.rendererSettings);
      break;
    default:
      this.renderer = new HybridRenderer(this, params.rendererSettings);
      break;
  }
  this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
  this.renderer.setProjectInterface(this.projectInterface);
  this.animType = animType;
  if (params.loop === ''
        || params.loop === null
        || params.loop === undefined
        || params.loop === true) {
    this.loop = true;
  } else if (params.loop === false) {
    this.loop = false;
  } else {
    this.loop = parseInt(params.loop, 10);
  }
  this.autoplay = 'autoplay' in params ? params.autoplay : true;
  this.name = params.name ? params.name : '';
  this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
  this.assetsPath = params.assetsPath;
  this.initialSegment = params.initialSegment;
  if (params.audioFactory) {
    this.audioController.setAudioFactory(params.audioFactory);
  }
  if (params.animationData) {
    this.setupAnimation(params.animationData);
  } else if (params.path) {
    if (params.path.lastIndexOf('\\') !== -1) {
      this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
    } else {
      this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
    }
    this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
    this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
    dataManager.loadAnimation(
      params.path,
      this.configAnimation,
      this.onSetupError
    );
  }
};

AnimationItem.prototype.onSetupError = function () {
  this.trigger('data_failed');
};

AnimationItem.prototype.setupAnimation = function (data) {
  dataManager.completeAnimation(
    data,
    this.configAnimation
  );
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
  if (animationData) {
    if (typeof animationData !== 'object') {
      animationData = JSON.parse(animationData);
    }
  }
  var params = {
    wrapper: wrapper,
    animationData: animationData,
  };
  var wrapperAttributes = wrapper.attributes;

  params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value
    : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-path').value
      : wrapperAttributes.getNamedItem('bm-path')
        ? wrapperAttributes.getNamedItem('bm-path').value
        : '';
  params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value
    : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-type').value
      : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
        ? wrapperAttributes.getNamedItem('bm-type').value
        : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
          ? wrapperAttributes.getNamedItem('data-bm-renderer').value
          : wrapperAttributes.getNamedItem('bm-renderer')
            ? wrapperAttributes.getNamedItem('bm-renderer').value
            : 'canvas';

  var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value
    : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-loop').value
      : wrapperAttributes.getNamedItem('bm-loop')
        ? wrapperAttributes.getNamedItem('bm-loop').value
        : '';
  if (loop === 'false') {
    params.loop = false;
  } else if (loop === 'true') {
    params.loop = true;
  } else if (loop !== '') {
    params.loop = parseInt(loop, 10);
  }
  var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value
    : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-autoplay').value
      : wrapperAttributes.getNamedItem('bm-autoplay')
        ? wrapperAttributes.getNamedItem('bm-autoplay').value
        : true;
  params.autoplay = autoplay !== 'false';

  params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value
    : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-name').value
      : wrapperAttributes.getNamedItem('bm-name')
        ? wrapperAttributes.getNamedItem('bm-name').value
        : '';
  var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value
    : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-prerender').value
      : wrapperAttributes.getNamedItem('bm-prerender')
        ? wrapperAttributes.getNamedItem('bm-prerender').value
        : '';

  if (prerender === 'false') {
    params.prerender = false;
  }
  this.setParams(params);
};

AnimationItem.prototype.includeLayers = function (data) {
  if (data.op > this.animationData.op) {
    this.animationData.op = data.op;
    this.totalFrames = Math.floor(data.op - this.animationData.ip);
  }
  var layers = this.animationData.layers;
  var i;
  var len = layers.length;
  var newLayers = data.layers;
  var j;
  var jLen = newLayers.length;
  for (j = 0; j < jLen; j += 1) {
    i = 0;
    while (i < len) {
      if (layers[i].id === newLayers[j].id) {
        layers[i] = newLayers[j];
        break;
      }
      i += 1;
    }
  }
  if (data.chars || data.fonts) {
    this.renderer.globalData.fontManager.addChars(data.chars);
    this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
  }
  if (data.assets) {
    len = data.assets.length;
    for (i = 0; i < len; i += 1) {
      this.animationData.assets.push(data.assets[i]);
    }
  }
  this.animationData.__complete = false;
  dataManager.completeAnimation(
    this.animationData,
    this.onSegmentComplete
  );
};

AnimationItem.prototype.onSegmentComplete = function (data) {
  this.animationData = data;
  if (expressionsPlugin) {
    expressionsPlugin.initExpressions(this);
  }
  this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function () {
  var segments = this.animationData.segments;
  if (!segments || segments.length === 0 || !this.autoloadSegments) {
    this.trigger('data_ready');
    this.timeCompleted = this.totalFrames;
    return;
  }
  var segment = segments.shift();
  this.timeCompleted = segment.time * this.frameRate;
  var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
  this.segmentPos += 1;
  dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
    this.trigger('data_failed');
  }.bind(this));
};

AnimationItem.prototype.loadSegments = function () {
  var segments = this.animationData.segments;
  if (!segments) {
    this.timeCompleted = this.totalFrames;
  }
  this.loadNextSegment();
};

AnimationItem.prototype.imagesLoaded = function () {
  this.trigger('loaded_images');
  this.checkLoaded();
};

AnimationItem.prototype.preloadImages = function () {
  this.imagePreloader.setAssetsPath(this.assetsPath);
  this.imagePreloader.setPath(this.path);
  this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};

AnimationItem.prototype.configAnimation = function (animData) {
  if (!this.renderer) {
    return;
  }
  try {
    this.animationData = animData;
    if (this.initialSegment) {
      this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
      this.firstFrame = Math.round(this.initialSegment[0]);
    } else {
      this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
      this.firstFrame = Math.round(this.animationData.ip);
    }
    this.renderer.configAnimation(animData);
    if (!animData.assets) {
      animData.assets = [];
    }

    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.frameMult = this.animationData.fr / 1000;
    this.renderer.searchExtraCompositions(animData.assets);
    this.markers = markerParser(animData.markers || []);
    this.trigger('config_ready');
    this.preloadImages();
    this.loadSegments();
    this.updaFrameModifier();
    this.waitForFontsLoaded();
    if (this.isPaused) {
      this.audioController.pause();
    }
  } catch (error) {
    this.triggerConfigError(error);
  }
};

AnimationItem.prototype.waitForFontsLoaded = function () {
  if (!this.renderer) {
    return;
  }
  if (this.renderer.globalData.fontManager.isLoaded) {
    this.checkLoaded();
  } else {
    setTimeout(this.waitForFontsLoaded.bind(this), 20);
  }
};

AnimationItem.prototype.checkLoaded = function () {
  if (!this.isLoaded
        && this.renderer.globalData.fontManager.isLoaded
        && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas')
        && (this.imagePreloader.loadedFootages())
  ) {
    this.isLoaded = true;
    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }
    this.renderer.initItems();
    setTimeout(function () {
      this.trigger('DOMLoaded');
    }.bind(this), 0);
    this.gotoFrame();
    if (this.autoplay) {
      this.play();
    }
  }
};

AnimationItem.prototype.resize = function () {
  this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function (flag) {
  this.isSubframeEnabled = !!flag;
};

AnimationItem.prototype.gotoFrame = function () {
  this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

  if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
    this.currentFrame = this.timeCompleted;
  }
  this.trigger('enterFrame');
  this.renderFrame();
  this.trigger('drawnFrame');
};

AnimationItem.prototype.renderFrame = function () {
  if (this.isLoaded === false || !this.renderer) {
    return;
  }
  try {
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
  } catch (error) {
    this.triggerRenderFrameError(error);
  }
};

AnimationItem.prototype.play = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.isPaused = false;
    this.audioController.resume();
    if (this._idle) {
      this._idle = false;
      this.trigger('_active');
    }
  }
};

AnimationItem.prototype.pause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === false) {
    this.isPaused = true;
    this._idle = true;
    this.trigger('_idle');
    this.audioController.pause();
  }
};

AnimationItem.prototype.togglePause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.play();
  } else {
    this.pause();
  }
};

AnimationItem.prototype.stop = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.pause();
  this.playCount = 0;
  this._completedLoop = false;
  this.setCurrentRawFrameValue(0);
};

AnimationItem.prototype.getMarkerData = function (markerName) {
  var marker;
  for (var i = 0; i < this.markers.length; i += 1) {
    marker = this.markers[i];
    if (marker.payload && marker.payload.name === markerName) {
      return marker;
    }
  }
  return null;
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      this.goToAndStop(marker.time, true);
    }
  } else if (isFrame) {
    this.setCurrentRawFrameValue(value);
  } else {
    this.setCurrentRawFrameValue(value * this.frameModifier);
  }
  this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  var numValue = Number(value);
  if (isNaN(numValue)) {
    var marker = this.getMarkerData(value);
    if (marker) {
      if (!marker.duration) {
        this.goToAndStop(marker.time, true);
      } else {
        this.playSegments([marker.time, marker.time + marker.duration], true);
      }
    }
  } else {
    this.goToAndStop(numValue, isFrame, name);
  }
  this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
  if (this.isPaused === true || this.isLoaded === false) {
    return;
  }
  var nextValue = this.currentRawFrame + value * this.frameModifier;
  var _isComplete = false;
  // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
  // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
  if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
    if (!this.loop || this.playCount === this.loop) {
      if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
        _isComplete = true;
        nextValue = this.totalFrames - 1;
      }
    } else if (nextValue >= this.totalFrames) {
      this.playCount += 1;
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        this.setCurrentRawFrameValue(nextValue % this.totalFrames);
        this._completedLoop = true;
        this.trigger('loopComplete');
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }
  } else if (nextValue < 0) {
    if (!this.checkSegments(nextValue % this.totalFrames)) {
      if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) { // eslint-disable-line no-plusplus
        this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
        if (!this._completedLoop) {
          this._completedLoop = true;
        } else {
          this.trigger('loopComplete');
        }
      } else {
        _isComplete = true;
        nextValue = 0;
      }
    }
  } else {
    this.setCurrentRawFrameValue(nextValue);
  }
  if (_isComplete) {
    this.setCurrentRawFrameValue(nextValue);
    this.pause();
    this.trigger('complete');
  }
};

AnimationItem.prototype.adjustSegment = function (arr, offset) {
  this.playCount = 0;
  if (arr[1] < arr[0]) {
    if (this.frameModifier > 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(-1);
      }
    }
    this.totalFrames = arr[0] - arr[1];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[1];
    this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
  } else if (arr[1] > arr[0]) {
    if (this.frameModifier < 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(1);
      }
    }
    this.totalFrames = arr[1] - arr[0];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[0];
    this.setCurrentRawFrameValue(0.001 + offset);
  }
  this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init, end) {
  var pendingFrame = -1;
  if (this.isPaused) {
    if (this.currentRawFrame + this.firstFrame < init) {
      pendingFrame = init;
    } else if (this.currentRawFrame + this.firstFrame > end) {
      pendingFrame = end - init;
    }
  }

  this.firstFrame = init;
  this.totalFrames = end - init;
  this.timeCompleted = this.totalFrames;
  if (pendingFrame !== -1) {
    this.goToAndStop(pendingFrame, true);
  }
};

AnimationItem.prototype.playSegments = function (arr, forceFlag) {
  if (forceFlag) {
    this.segments.length = 0;
  }
  if (typeof arr[0] === 'object') {
    var i;
    var len = arr.length;
    for (i = 0; i < len; i += 1) {
      this.segments.push(arr[i]);
    }
  } else {
    this.segments.push(arr);
  }
  if (this.segments.length && forceFlag) {
    this.adjustSegment(this.segments.shift(), 0);
  }
  if (this.isPaused) {
    this.play();
  }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
  this.segments.length = 0;
  this.segments.push([this.animationData.ip, this.animationData.op]);
  if (forceFlag) {
    this.checkSegments(0);
  }
};
AnimationItem.prototype.checkSegments = function (offset) {
  if (this.segments.length) {
    this.adjustSegment(this.segments.shift(), offset);
    return true;
  }
  return false;
};

AnimationItem.prototype.destroy = function (name) {
  if ((name && this.name !== name) || !this.renderer) {
    return;
  }
  this.renderer.destroy();
  this.imagePreloader.destroy();
  this.trigger('destroy');
  this._cbs = null;
  this.onEnterFrame = null;
  this.onLoopComplete = null;
  this.onComplete = null;
  this.onSegmentStart = null;
  this.onDestroy = null;
  this.renderer = null;
  this.renderer = null;
  this.imagePreloader = null;
  this.projectInterface = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
  this.currentRawFrame = value;
  this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
  this.playSpeed = val;
  this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
  this.playDirection = val < 0 ? -1 : 1;
  this.updaFrameModifier();
};

AnimationItem.prototype.setVolume = function (val, name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.setVolume(val);
};

AnimationItem.prototype.getVolume = function () {
  return this.audioController.getVolume();
};

AnimationItem.prototype.mute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.mute();
};

AnimationItem.prototype.unmute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.unmute();
};

AnimationItem.prototype.updaFrameModifier = function () {
  this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
  this.audioController.setRate(this.playSpeed * this.playDirection);
};

AnimationItem.prototype.getPath = function () {
  return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
  var path = '';
  if (assetData.e) {
    path = assetData.p;
  } else if (this.assetsPath) {
    var imagePath = assetData.p;
    if (imagePath.indexOf('images/') !== -1) {
      imagePath = imagePath.split('/')[1];
    }
    path = this.assetsPath + imagePath;
  } else {
    path = this.path;
    path += assetData.u ? assetData.u : '';
    path += assetData.p;
  }
  return path;
};

AnimationItem.prototype.getAssetData = function (id) {
  var i = 0;
  var len = this.assets.length;
  while (i < len) {
    if (id === this.assets[i].id) {
      return this.assets[i];
    }
    i += 1;
  }
  return null;
};

AnimationItem.prototype.hide = function () {
  this.renderer.hide();
};

AnimationItem.prototype.show = function () {
  this.renderer.show();
};

AnimationItem.prototype.getDuration = function (isFrame) {
  return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
};

AnimationItem.prototype.trigger = function (name) {
  if (this._cbs && this._cbs[name]) {
    switch (name) {
      case 'enterFrame':
      case 'drawnFrame':
        this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
        break;
      case 'loopComplete':
        this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        break;
      case 'complete':
        this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
        break;
      case 'segmentStart':
        this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        break;
      case 'destroy':
        this.triggerEvent(name, new BMDestroyEvent(name, this));
        break;
      default:
        this.triggerEvent(name);
    }
  }
  if (name === 'enterFrame' && this.onEnterFrame) {
    this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
  }
  if (name === 'loopComplete' && this.onLoopComplete) {
    this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
  }
  if (name === 'complete' && this.onComplete) {
    this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
  }
  if (name === 'segmentStart' && this.onSegmentStart) {
    this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
  }
  if (name === 'destroy' && this.onDestroy) {
    this.onDestroy.call(this, new BMDestroyEvent(name, this));
  }
};

AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
  var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

AnimationItem.prototype.triggerConfigError = function (nativeError) {
  var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

/* global CompExpressionInterface, expressionsPlugin: writable */
/* exported expressionsPlugin */

var Expressions = (function () {
  var ob = {};
  ob.initExpressions = initExpressions;

  function initExpressions(animation) {
    var stackCount = 0;
    var registers = [];

    function pushExpression() {
      stackCount += 1;
    }

    function popExpression() {
      stackCount -= 1;
      if (stackCount === 0) {
        releaseInstances();
      }
    }

    function registerExpressionProperty(expression) {
      if (registers.indexOf(expression) === -1) {
        registers.push(expression);
      }
    }

    function releaseInstances() {
      var i;
      var len = registers.length;
      for (i = 0; i < len; i += 1) {
        registers[i].release();
      }
      registers.length = 0;
    }

    animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
    animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    animation.renderer.globalData.pushExpression = pushExpression;
    animation.renderer.globalData.popExpression = popExpression;
    animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
  }
  return ob;
}());

expressionsPlugin = Expressions;

/* eslint-disable camelcase, no-unused-vars */
/* global BMMath, BezierFactory, createTypedArray, degToRads, shapePool */

var ExpressionManager = (function () {
  'use strict';

  var ob = {};
  var Math = BMMath;
  var window = null;
  var document = null;
  var XMLHttpRequest = null;
  var fetch = null;
  var frames = null;

  function $bm_isInstanceOfArray(arr) {
    return arr.constructor === Array || arr.constructor === Float32Array;
  }

  function isNumerable(tOfV, v) {
    return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
  }

  function $bm_neg(a) {
    var tOfA = typeof a;
    if (tOfA === 'number' || tOfA === 'boolean' || a instanceof Number) {
      return -a;
    }
    if ($bm_isInstanceOfArray(a)) {
      var i;
      var lenA = a.length;
      var retArr = [];
      for (i = 0; i < lenA; i += 1) {
        retArr[i] = -a[i];
      }
      return retArr;
    }
    if (a.propType) {
      return a.v;
    }
    return -a;
  }

  var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
  var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
  var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

  function sum(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (tOfA === 'string' || tOfB === 'string') {
      return a + b;
    }
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a + b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] += b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a + b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] + b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }
  var add = sum;

  function sub(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      if (tOfA === 'string') {
        a = parseInt(a, 10);
      }
      if (tOfB === 'string') {
        b = parseInt(b, 10);
      }
      return a - b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] -= b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a - b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] - b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }

  function mul(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a * b;
    }

    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] * b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a * b[i];
      }
      return arr;
    }
    return 0;
  }

  function div(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a / b;
    }
    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] / b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a / b[i];
      }
      return arr;
    }
    return 0;
  }
  function mod(a, b) {
    if (typeof a === 'string') {
      a = parseInt(a, 10);
    }
    if (typeof b === 'string') {
      b = parseInt(b, 10);
    }
    return a % b;
  }
  var $bm_sum = sum;
  var $bm_sub = sub;
  var $bm_mul = mul;
  var $bm_div = div;
  var $bm_mod = mod;

  function clamp(num, min, max) {
    if (min > max) {
      var mm = max;
      max = min;
      min = mm;
    }
    return Math.min(Math.max(num, min), max);
  }

  function radiansToDegrees(val) {
    return val / degToRads;
  }
  var radians_to_degrees = radiansToDegrees;

  function degreesToRadians(val) {
    return val * degToRads;
  }
  var degrees_to_radians = radiansToDegrees;

  var helperLengthArray = [0, 0, 0, 0, 0, 0];

  function length(arr1, arr2) {
    if (typeof arr1 === 'number' || arr1 instanceof Number) {
      arr2 = arr2 || 0;
      return Math.abs(arr1 - arr2);
    }
    if (!arr2) {
      arr2 = helperLengthArray;
    }
    var i;
    var len = Math.min(arr1.length, arr2.length);
    var addedLength = 0;
    for (i = 0; i < len; i += 1) {
      addedLength += Math.pow(arr2[i] - arr1[i], 2);
    }
    return Math.sqrt(addedLength);
  }

  function normalize(vec) {
    return div(vec, length(vec));
  }

  function rgbToHsl(val) {
    var r = val[0]; var g = val[1]; var b = val[2];
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;

    if (max === min) {
      h = 0; // achromatic
      s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: break;
      }
      h /= 6;
    }

    return [h, s, l, val[3]];
  }

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function hslToRgb(val) {
    var h = val[0];
    var s = val[1];
    var l = val[2];

    var r;
    var g;
    var b;

    if (s === 0) {
      r = l; // achromatic
      b = l; // achromatic
      g = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [r, g, b, val[3]];
  }

  function linear(t, tMin, tMax, value1, value2) {
    if (value1 === undefined || value2 === undefined) {
      value1 = tMin;
      value2 = tMax;
      tMin = 0;
      tMax = 1;
    }
    if (tMax < tMin) {
      var _tMin = tMax;
      tMax = tMin;
      tMin = _tMin;
    }
    if (t <= tMin) {
      return value1;
    } if (t >= tMax) {
      return value2;
    }
    var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
    if (!value1.length) {
      return value1 + (value2 - value1) * perc;
    }
    var i;
    var len = value1.length;
    var arr = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
    }
    return arr;
  }
  function random(min, max) {
    if (max === undefined) {
      if (min === undefined) {
        min = 0;
        max = 1;
      } else {
        max = min;
        min = undefined;
      }
    }
    if (max.length) {
      var i;
      var len = max.length;
      if (!min) {
        min = createTypedArray('float32', len);
      }
      var arr = createTypedArray('float32', len);
      var rnd = BMMath.random();
      for (i = 0; i < len; i += 1) {
        arr[i] = min[i] + rnd * (max[i] - min[i]);
      }
      return arr;
    }
    if (min === undefined) {
      min = 0;
    }
    var rndm = BMMath.random();
    return min + rndm * (max - min);
  }

  function createPath(points, inTangents, outTangents, closed) {
    var i;
    var len = points.length;
    var path = shapePool.newElement();
    path.setPathData(!!closed, len);
    var arrPlaceholder = [0, 0];
    var inVertexPoint;
    var outVertexPoint;
    for (i = 0; i < len; i += 1) {
      inVertexPoint = (inTangents && inTangents[i]) ? inTangents[i] : arrPlaceholder;
      outVertexPoint = (outTangents && outTangents[i]) ? outTangents[i] : arrPlaceholder;
      path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
    }
    return path;
  }

  function initiateExpression(elem, data, property) {
    var val = data.x;
    var needsVelocity = /velocity(?![\w\d])/.test(val);
    var _needsRandom = val.indexOf('random') !== -1;
    var elemType = elem.data.ty;
    var transform;
    var $bm_transform;
    var content;
    var effect;
    var thisProperty = property;
    thisProperty.valueAtTime = thisProperty.getValueAtTime;
    Object.defineProperty(thisProperty, 'value', {
      get: function () {
        return thisProperty.v;
      },
    });
    elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
    elem.comp.displayStartTime = 0;
    var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    var outPoint = elem.data.op / elem.comp.globalData.frameRate;
    var width = elem.data.sw ? elem.data.sw : 0;
    var height = elem.data.sh ? elem.data.sh : 0;
    var name = elem.data.nm;
    var loopIn;
    var loop_in;
    var loopOut;
    var loop_out;
    var smooth;
    var toWorld;
    var fromWorld;
    var fromComp;
    var toComp;
    var fromCompToSurface;
    var position;
    var rotation;
    var anchorPoint;
    var scale;
    var thisLayer;
    var thisComp;
    var mask;
    var valueAtTime;
    var velocityAtTime;

    var scoped_bm_rt;
    // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
    var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
    var numKeys = property.kf ? data.k.length : 0;

    var active = !this.data || this.data.hd !== true;

    var wiggle = function wiggle(freq, amp) {
      var iWiggle;
      var j;
      var lenWiggle = this.pv.length ? this.pv.length : 1;
      var addedAmps = createTypedArray('float32', lenWiggle);
      freq = 5;
      var iterations = Math.floor(time * freq);
      iWiggle = 0;
      j = 0;
      while (iWiggle < iterations) {
        // var rnd = BMMath.random();
        for (j = 0; j < lenWiggle; j += 1) {
          addedAmps[j] += -amp + amp * 2 * BMMath.random();
          // addedAmps[j] += -amp + amp*2*rnd;
        }
        iWiggle += 1;
      }
      // var rnd2 = BMMath.random();
      var periods = time * freq;
      var perc = periods - Math.floor(periods);
      var arr = createTypedArray('float32', lenWiggle);
      if (lenWiggle > 1) {
        for (j = 0; j < lenWiggle; j += 1) {
          arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
          // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
          // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
        }
        return arr;
      }
      return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
    }.bind(this);

    if (thisProperty.loopIn) {
      loopIn = thisProperty.loopIn.bind(thisProperty);
      loop_in = loopIn;
    }

    if (thisProperty.loopOut) {
      loopOut = thisProperty.loopOut.bind(thisProperty);
      loop_out = loopOut;
    }

    if (thisProperty.smooth) {
      smooth = thisProperty.smooth.bind(thisProperty);
    }

    function loopInDuration(type, duration) {
      return loopIn(type, duration, true);
    }

    function loopOutDuration(type, duration) {
      return loopOut(type, duration, true);
    }

    if (this.getValueAtTime) {
      valueAtTime = this.getValueAtTime.bind(this);
    }

    if (this.getVelocityAtTime) {
      velocityAtTime = this.getVelocityAtTime.bind(this);
    }

    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

    function lookAt(elem1, elem2) {
      var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
      var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
      var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
      return [yaw, pitch, 0];
    }

    function easeOut(t, tMin, tMax, val1, val2) {
      return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
    }

    function easeIn(t, tMin, tMax, val1, val2) {
      return applyEase(easeInBez, t, tMin, tMax, val1, val2);
    }

    function ease(t, tMin, tMax, val1, val2) {
      return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
    }

    function applyEase(fn, t, tMin, tMax, val1, val2) {
      if (val1 === undefined) {
        val1 = tMin;
        val2 = tMax;
      } else {
        t = (t - tMin) / (tMax - tMin);
      }
      if (t > 1) {
        t = 1;
      } else if (t < 0) {
        t = 0;
      }
      var mult = fn(t);
      if ($bm_isInstanceOfArray(val1)) {
        var iKey;
        var lenKey = val1.length;
        var arr = createTypedArray('float32', lenKey);
        for (iKey = 0; iKey < lenKey; iKey += 1) {
          arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
        }
        return arr;
      }
      return (val2 - val1) * mult + val1;
    }

    function nearestKey(time) {
      var iKey;
      var lenKey = data.k.length;
      var index;
      var keyTime;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        index = 0;
        keyTime = 0;
      } else {
        index = -1;
        time *= elem.comp.globalData.frameRate;
        if (time < data.k[0].t) {
          index = 1;
          keyTime = data.k[0].t;
        } else {
          for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
            if (time === data.k[iKey].t) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
              break;
            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
              if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                index = iKey + 2;
                keyTime = data.k[iKey + 1].t;
              } else {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
              }
              break;
            }
          }
          if (index === -1) {
            index = iKey + 1;
            keyTime = data.k[iKey].t;
          }
        }
      }
      var obKey = {};
      obKey.index = index;
      obKey.time = keyTime / elem.comp.globalData.frameRate;
      return obKey;
    }

    function key(ind) {
      var obKey;
      var iKey;
      var lenKey;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        throw new Error('The property has no keyframe at index ' + ind);
      }
      ind -= 1;
      obKey = {
        time: data.k[ind].t / elem.comp.globalData.frameRate,
        value: [],
      };
      var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;

      lenKey = arr.length;
      for (iKey = 0; iKey < lenKey; iKey += 1) {
        obKey[iKey] = arr[iKey];
        obKey.value[iKey] = arr[iKey];
      }
      return obKey;
    }

    function framesToTime(fr, fps) {
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return fr / fps;
    }

    function timeToFrames(t, fps) {
      if (!t && t !== 0) {
        t = time;
      }
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return t * fps;
    }

    function seedRandom(seed) {
      BMMath.seedrandom(randSeed + seed);
    }

    function sourceRectAtTime() {
      return elem.sourceRectAtTime();
    }

    function substring(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substring(init);
        }
        return value.substring(init, end);
      }
      return '';
    }

    function substr(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substr(init);
        }
        return value.substr(init, end);
      }
      return '';
    }

    function posterizeTime(framesPerSecond) {
      time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
      value = valueAtTime(time);
    }

    var time;
    var velocity;
    var value;
    var text;
    var textIndex;
    var textTotal;
    var selectorValue;
    var index = elem.data.ind;
    var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
    var parent;
    var randSeed = Math.floor(Math.random() * 1000000);
    var globalData = elem.globalData;
    function executeExpression(_value) {
      // globalData.pushExpression();
      value = _value;
      if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
        return value;
      }
      if (this.propType === 'textSelector') {
        textIndex = this.textIndex;
        textTotal = this.textTotal;
        selectorValue = this.selectorValue;
      }
      if (!thisLayer) {
        text = elem.layerInterface.text;
        thisLayer = elem.layerInterface;
        thisComp = elem.comp.compInterface;
        toWorld = thisLayer.toWorld.bind(thisLayer);
        fromWorld = thisLayer.fromWorld.bind(thisLayer);
        fromComp = thisLayer.fromComp.bind(thisLayer);
        toComp = thisLayer.toComp.bind(thisLayer);
        mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
        fromCompToSurface = fromComp;
      }
      if (!transform) {
        transform = elem.layerInterface('ADBE Transform Group');
        $bm_transform = transform;
        if (transform) {
          anchorPoint = transform.anchorPoint;
          /* position = transform.position;
                    rotation = transform.rotation;
                    scale = transform.scale; */
        }
      }

      if (elemType === 4 && !content) {
        content = thisLayer('ADBE Root Vectors Group');
      }
      if (!effect) {
        effect = thisLayer(4);
      }
      hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      if (hasParent && !parent) {
        parent = elem.hierarchy[0].layerInterface;
      }
      time = this.comp.renderedFrame / this.comp.globalData.frameRate;
      if (_needsRandom) {
        seedRandom(randSeed + time);
      }
      if (needsVelocity) {
        velocity = velocityAtTime(time);
      }
      expression_function();
      this.frameExpressionId = elem.globalData.frameId;

      // TODO: Check if it's possible to return on ShapeInterface the .v value
      if (scoped_bm_rt.propType === 'shape') {
        scoped_bm_rt = scoped_bm_rt.v;
      }
      // globalData.popExpression();
      return scoped_bm_rt;
    }
    return executeExpression;
  }

  ob.initiateExpression = initiateExpression;
  return ob;
}());

/* global ExpressionManager, createTypedArray */
/* exported expressionHelpers */

var expressionHelpers = (function () {
  function searchExpressions(elem, data, prop) {
    if (data.x) {
      prop.k = true;
      prop.x = true;
      prop.initiateExpression = ExpressionManager.initiateExpression;
      prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
    }
  }

  function getValueAtTime(frameNum) {
    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastFrame) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
      this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
      this._cachingAtTime.lastFrame = frameNum;
    }
    return this._cachingAtTime.value;
  }

  function getSpeedAtTime(frameNum) {
    var delta = -0.01;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var speed = 0;
    if (v1.length) {
      var i;
      for (i = 0; i < v1.length; i += 1) {
        speed += Math.pow(v2[i] - v1[i], 2);
      }
      speed = Math.sqrt(speed) * 100;
    } else {
      speed = 0;
    }
    return speed;
  }

  function getVelocityAtTime(frameNum) {
    if (this.vel !== undefined) {
      return this.vel;
    }
    var delta = -0.001;
    // frameNum += this.elem.data.st;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var velocity;
    if (v1.length) {
      velocity = createTypedArray('float32', v1.length);
      var i;
      for (i = 0; i < v1.length; i += 1) {
        // removing frameRate
        // if needed, don't add it here
        // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
        velocity[i] = (v2[i] - v1[i]) / delta;
      }
    } else {
      velocity = (v2 - v1) / delta;
    }
    return velocity;
  }

  function getStaticValueAtTime() {
    return this.pv;
  }

  function setGroupProperty(propertyGroup) {
    this.propertyGroup = propertyGroup;
  }

  return {
    searchExpressions: searchExpressions,
    getSpeedAtTime: getSpeedAtTime,
    getVelocityAtTime: getVelocityAtTime,
    getValueAtTime: getValueAtTime,
    getStaticValueAtTime: getStaticValueAtTime,
    setGroupProperty: setGroupProperty,
  };
}());

/* global createTypedArray, Matrix, TransformPropertyFactory, expressionHelpers, PropertyFactory, expressionHelpers,
initialDefaultFrame, shapePool, ShapePropertyFactory, bez, extendPrototype, ExpressionManager, createSizedArray */

(function addPropertyDecorator() {
  function loopOut(type, duration, durationFlag) {
    if (!this.k || !this.keyframes) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var lastKeyFrame = keyframes[keyframes.length - 1].t;
    if (currentFrame <= lastKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var firstKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
      } else {
        cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
      }
      firstKeyFrame = lastKeyFrame - cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (iterations % 2 !== 0) {
          return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = (endV[i] - initV[i]) * repeats + current[i];
        }
        return ret;
      }
      return (endV - initV) * repeats + current;
    } else if (type === 'continue') {
      var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(lastValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
        }
        return ret;
      }
      return lastValue + (lastValue - nextLastValue) * (((currentFrame - lastKeyFrame)) / 0.001);
    }
      return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function loopIn(type, duration, durationFlag) {
    if (!this.k) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var firstKeyFrame = keyframes[0].t;
    if (currentFrame >= firstKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var lastKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      lastKeyFrame = keyframes[duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
      } else {
        cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
      }
      lastKeyFrame = firstKeyFrame + cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
      if (iterations % 2 === 0) {
          return this.getValueAtTime((((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var current = this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration) + firstKeyFrame) / this.comp.globalData.frameRate, 0);
      var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
        }
        return ret;
      }
      return current - (endV - initV) * repeats;
    } else if (type === 'continue') {
      var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(firstValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = firstValue[i] + ((firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame)) / 0.001;
        }
        return ret;
      }
      return firstValue + ((firstValue - nextFirstValue) * (firstKeyFrame - currentFrame)) / 0.001;
    }
      return this.getValueAtTime(((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame))) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function smooth(width, samples) {
    if (!this.k) {
      return this.pv;
    }
    width = (width || 0.4) * 0.5;
    samples = Math.floor(samples || 5);
    if (samples <= 1) {
      return this.pv;
    }
    var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
    var initFrame = currentTime - width;
    var endFrame = currentTime + width;
    var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
    var i = 0;
    var j = 0;
    var value;
    if (this.pv.length) {
      value = createTypedArray('float32', this.pv.length);
    } else {
      value = 0;
    }
    var sampleValue;
    while (i < samples) {
      sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] += sampleValue[j];
        }
      } else {
        value += sampleValue;
      }
      i += 1;
    }
    if (this.pv.length) {
      for (j = 0; j < this.pv.length; j += 1) {
        value[j] /= samples;
      }
    } else {
      value /= samples;
    }
    return value;
  }

  function getTransformValueAtTime(time) {
    if (!this._transformCachingAtTime) {
      this._transformCachingAtTime = {
        v: new Matrix(),
      };
    }
    /// /
    var matrix = this._transformCachingAtTime.v;
    matrix.cloneFromProps(this.pre.props);
    if (this.appliedTransformations < 1) {
      var anchor = this.a.getValueAtTime(time);
      matrix.translate(
        -anchor[0] * this.a.mult,
        -anchor[1] * this.a.mult,
        anchor[2] * this.a.mult
      );
    }
    if (this.appliedTransformations < 2) {
      var scale = this.s.getValueAtTime(time);
      matrix.scale(
        scale[0] * this.s.mult,
        scale[1] * this.s.mult,
        scale[2] * this.s.mult
      );
    }
    if (this.sk && this.appliedTransformations < 3) {
      var skew = this.sk.getValueAtTime(time);
      var skewAxis = this.sa.getValueAtTime(time);
      matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
    }
    if (this.r && this.appliedTransformations < 4) {
      var rotation = this.r.getValueAtTime(time);
      matrix.rotate(-rotation * this.r.mult);
    } else if (!this.r && this.appliedTransformations < 4) {
      var rotationZ = this.rz.getValueAtTime(time);
      var rotationY = this.ry.getValueAtTime(time);
      var rotationX = this.rx.getValueAtTime(time);
      var orientation = this.or.getValueAtTime(time);
      matrix.rotateZ(-rotationZ * this.rz.mult)
        .rotateY(rotationY * this.ry.mult)
        .rotateX(rotationX * this.rx.mult)
        .rotateZ(-orientation[2] * this.or.mult)
        .rotateY(orientation[1] * this.or.mult)
        .rotateX(orientation[0] * this.or.mult);
    }
    if (this.data.p && this.data.p.s) {
      var positionX = this.px.getValueAtTime(time);
      var positionY = this.py.getValueAtTime(time);
      if (this.data.p.z) {
        var positionZ = this.pz.getValueAtTime(time);
        matrix.translate(
          positionX * this.px.mult,
          positionY * this.py.mult,
          -positionZ * this.pz.mult
        );
      } else {
        matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
      }
    } else {
      var position = this.p.getValueAtTime(time);
      matrix.translate(
        position[0] * this.p.mult,
        position[1] * this.p.mult,
        -position[2] * this.p.mult
      );
    }
    return matrix;
    /// /
  }

  function getTransformStaticValueAtTime() {
    return this.v.clone(new Matrix());
  }

  var getTransformProperty = TransformPropertyFactory.getTransformProperty;
  TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
    var prop = getTransformProperty(elem, data, container);
    if (prop.dynamicProperties.length) {
      prop.getValueAtTime = getTransformValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    return prop;
  };

  var propertyGetProp = PropertyFactory.getProp;
  PropertyFactory.getProp = function (elem, data, type, mult, container) {
    var prop = propertyGetProp(elem, data, type, mult, container);
    // prop.getVelocityAtTime = getVelocityAtTime;
    // prop.loopOut = loopOut;
    // prop.loopIn = loopIn;
    if (prop.kf) {
      prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    prop.loopOut = loopOut;
    prop.loopIn = loopIn;
    prop.smooth = smooth;
    prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
    prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
    prop.numKeys = data.a === 1 ? data.k.length : 0;
    prop.propertyIndex = data.ix;
    var value = 0;
    if (type !== 0) {
      value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
    }
    prop._cachingAtTime = {
      lastFrame: initialDefaultFrame,
      lastIndex: 0,
      value: value,
    };
    expressionHelpers.searchExpressions(elem, data, prop);
    if (prop.k) {
      container.addDynamicProperty(prop);
    }

    return prop;
  };

  function getShapeValueAtTime(frameNum) {
    // For now this caching object is created only when needed instead of creating it when the shape is initialized.
    if (!this._cachingAtTime) {
      this._cachingAtTime = {
        shapeValue: shapePool.clone(this.pv),
        lastIndex: 0,
        lastTime: initialDefaultFrame,
      };
    }

    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastTime) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
      this._cachingAtTime.lastTime = frameNum;
      this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
    }
    return this._cachingAtTime.shapeValue;
  }

  var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
  var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

  function ShapeExpressions() {}
  ShapeExpressions.prototype = {
    vertices: function (prop, time) {
      if (this.k) {
        this.getValue();
      }
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      var i;
      var len = shapePath._length;
      var vertices = shapePath[prop];
      var points = shapePath.v;
      var arr = createSizedArray(len);
      for (i = 0; i < len; i += 1) {
        if (prop === 'i' || prop === 'o') {
          arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
        } else {
          arr[i] = [vertices[i][0], vertices[i][1]];
        }
      }
      return arr;
    },
    points: function (time) {
      return this.vertices('v', time);
    },
    inTangents: function (time) {
      return this.vertices('i', time);
    },
    outTangents: function (time) {
      return this.vertices('o', time);
    },
    isClosed: function () {
      return this.v.c;
    },
    pointOnPath: function (perc, time) {
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      if (!this._segmentsLength) {
        this._segmentsLength = bez.getSegmentsLength(shapePath);
      }

      var segmentsLength = this._segmentsLength;
      var lengths = segmentsLength.lengths;
      var lengthPos = segmentsLength.totalLength * perc;
      var i = 0;
      var len = lengths.length;
      var accumulatedLength = 0;
      var pt;
      while (i < len) {
        if (accumulatedLength + lengths[i].addedLength > lengthPos) {
          var initIndex = i;
          var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
          var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
          pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
          break;
        } else {
          accumulatedLength += lengths[i].addedLength;
        }
        i += 1;
      }
      if (!pt) {
        pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
      }
      return pt;
    },
    vectorOnPath: function (perc, time, vectorType) {
      // perc doesn't use triple equality because it can be a Number object as well as a primitive.
      if (perc == 1) { // eslint-disable-line eqeqeq
        perc = this.v.c;
      } else if (perc == 0) { // eslint-disable-line eqeqeq
        perc = 0.999;
      }
      var pt1 = this.pointOnPath(perc, time);
      var pt2 = this.pointOnPath(perc + 0.001, time);
      var xLength = pt2[0] - pt1[0];
      var yLength = pt2[1] - pt1[1];
      var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
      if (magnitude === 0) {
        return [0, 0];
      }
      var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
      return unitVector;
    },
    tangentOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'tangent');
    },
    normalOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'normal');
    },
    setGroupProperty: expressionHelpers.setGroupProperty,
    getValueAtTime: expressionHelpers.getStaticValueAtTime,
  };
  extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
  extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
  KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
  KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;

  var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
  ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
    var prop = propertyGetShapeProp(elem, data, type, arr, trims);
    prop.propertyIndex = data.ix;
    prop.lock = false;
    if (type === 3) {
      expressionHelpers.searchExpressions(elem, data.pt, prop);
    } else if (type === 4) {
      expressionHelpers.searchExpressions(elem, data.ks, prop);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  };
}());

/* global ExpressionManager, TextProperty */

(function addDecorator() {
  function searchExpressions() {
    if (this.data.d.x) {
      this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
      this.addEffect(this.getExpressionValue.bind(this));
      return true;
    }
    return null;
  }

  TextProperty.prototype.getExpressionValue = function (currentValue, text) {
    var newValue = this.calculateExpression(text);
    if (currentValue.t !== newValue) {
      var newData = {};
      this.copyData(newData, currentValue);
      newData.t = newValue.toString();
      newData.__complete = false;
      return newData;
    }
    return currentValue;
  };

  TextProperty.prototype.searchProperty = function () {
    var isKeyframed = this.searchKeyframes();
    var hasExpressions = this.searchExpressions();
    this.kf = isKeyframed || hasExpressions;
    return this.kf;
  };

  TextProperty.prototype.searchExpressions = searchExpressions;
}());

/* global propertyGroupFactory, PropertyInterface */
/* exported ShapePathInterface */

var ShapePathInterface = (

  function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }
        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        shape: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        _name: { value: shape.nm },
        ix: { value: shape.ix },
        propertyIndex: { value: shape.ix },
        mn: { value: shape.mn },
        propertyGroup: { value: propertyGroup },
      });
      return interfaceFunction;
    };
  }()
);

/* exported propertyGroupFactory */

var propertyGroupFactory = (function () {
  return function (interfaceFunction, parentPropertyGroup) {
    return function (val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return parentPropertyGroup(val - 1);
    };
  };
}());

/* exported PropertyInterface */

var PropertyInterface = (function () {
  return function (propertyName, propertyGroup) {
    var interfaceFunction = {
      _name: propertyName,
    };

    function _propertyGroup(val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return propertyGroup(val - 1);
    }

    return _propertyGroup;
  };
}());

/* global ExpressionPropertyInterface, PropertyInterface, propertyGroupFactory, ShapePathInterface */
/* exported ShapeExpressionInterface */

var ShapeExpressionInterface = (function () {
  function iterateElements(shapes, view, propertyGroup) {
    var arr = [];
    var i;
    var len = shapes ? shapes.length : 0;
    for (i = 0; i < len; i += 1) {
      if (shapes[i].ty === 'gr') {
        arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'fl') {
        arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'st') {
        arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tm') {
        arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tr') {
        // arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
      } else if (shapes[i].ty === 'el') {
        arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sr') {
        arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sh') {
        arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rc') {
        arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rd') {
        arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rp') {
        arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'gf') {
        arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else {
        arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
      }
    }
    return arr;
  }

  function contentsInterfaceFactory(shape, view, propertyGroup) {
    var interfaces;
    var interfaceFunction = function _interfaceFunction(value) {
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
          return interfaces[i];
        }
        i += 1;
      }
      if (typeof value === 'number') {
        return interfaces[value - 1];
      }
      return null;
    };

    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
    interfaceFunction.numProperties = interfaces.length;
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.transform = transformInterface;
    interfaceFunction.propertyIndex = shape.cix;
    interfaceFunction._name = shape.nm;

    return interfaceFunction;
  }

  function groupInterfaceFactory(shape, view, propertyGroup) {
    var interfaceFunction = function _interfaceFunction(value) {
      switch (value) {
        case 'ADBE Vectors Group':
        case 'Contents':
        case 2:
          return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:
        default:
          return interfaceFunction.transform;
      }
    };
    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.content = content;
    interfaceFunction.transform = transformInterface;
    Object.defineProperty(interfaceFunction, '_name', {
      get: function () {
        return shape.nm;
      },
    });
    // interfaceFunction.content = interfaceFunction;
    interfaceFunction.numProperties = shape.np;
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.nm = shape.nm;
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function fillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }

  function gradientFillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Start Point' || val === 'start point') {
        return interfaceFunction.startPoint;
      }
      if (val === 'End Point' || val === 'end point') {
        return interfaceFunction.endPoint;
      }
      if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      startPoint: {
        get: ExpressionPropertyInterface(view.s),
      },
      endPoint: {
        get: ExpressionPropertyInterface(view.e),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      type: {
        get: function () {
          return 'a';
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }
  function defaultInterfaceFactory() {
    function interfaceFunction() {
      return null;
    }
    return interfaceFunction;
  }

  function strokeInterfaceFactory(shape, view, propertyGroup) {
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
    function addPropertyToDashOb(i) {
      Object.defineProperty(dashOb, shape.d[i].nm, {
        get: ExpressionPropertyInterface(view.d.dataProps[i].p),
      });
    }
    var i;
    var len = shape.d ? shape.d.length : 0;
    var dashOb = {};
    for (i = 0; i < len; i += 1) {
      addPropertyToDashOb(i);
      view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
    }

    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      } if (val === 'Stroke Width' || val === 'stroke width') {
        return interfaceFunction.strokeWidth;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      strokeWidth: {
        get: ExpressionPropertyInterface(view.w),
      },
      dash: {
        get: function () {
          return dashOb;
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
    return interfaceFunction;
  }

  function trimInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === shape.e.ix || val === 'End' || val === 'end') {
        return interfaceFunction.end;
      }
      if (val === shape.s.ix) {
        return interfaceFunction.start;
      }
      if (val === shape.o.ix) {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;

    view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.propertyGroup = propertyGroup;

    Object.defineProperties(interfaceFunction, {
      start: {
        get: ExpressionPropertyInterface(view.s),
      },
      end: {
        get: ExpressionPropertyInterface(view.e),
      },
      offset: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function transformInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.a.ix === value || value === 'Anchor Point') {
        return interfaceFunction.anchorPoint;
      }
      if (shape.o.ix === value || value === 'Opacity') {
        return interfaceFunction.opacity;
      }
      if (shape.p.ix === value || value === 'Position') {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
        return interfaceFunction.rotation;
      }
      if (shape.s.ix === value || value === 'Scale') {
        return interfaceFunction.scale;
      }
      if ((shape.sk && shape.sk.ix === value) || value === 'Skew') {
        return interfaceFunction.skew;
      }
      if ((shape.sa && shape.sa.ix === value) || value === 'Skew Axis') {
        return interfaceFunction.skewAxis;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
    view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
    view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (view.transform.mProps.sk) {
      view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
      view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
    }
    view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      opacity: {
        get: ExpressionPropertyInterface(view.transform.mProps.o),
      },
      position: {
        get: ExpressionPropertyInterface(view.transform.mProps.p),
      },
      anchorPoint: {
        get: ExpressionPropertyInterface(view.transform.mProps.a),
      },
      scale: {
        get: ExpressionPropertyInterface(view.transform.mProps.s),
      },
      rotation: {
        get: ExpressionPropertyInterface(view.transform.mProps.r),
      },
      skew: {
        get: ExpressionPropertyInterface(view.transform.mProps.sk),
      },
      skewAxis: {
        get: ExpressionPropertyInterface(view.transform.mProps.sa),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.ty = 'tr';
    interfaceFunction.mn = shape.mn;
    interfaceFunction.propertyGroup = propertyGroup;
    return interfaceFunction;
  }

  function ellipseInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.s.ix === value) {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function starInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.rotation;
      }
      if (shape.pt.ix === value) {
        return interfaceFunction.points;
      }
      if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
        return interfaceFunction.outerRadius;
      }
      if (shape.os.ix === value) {
        return interfaceFunction.outerRoundness;
      }
      if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
        return interfaceFunction.innerRadius;
      }
      if (shape.is && shape.is.ix === value) {
        return interfaceFunction.innerRoundness;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
    prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
    prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (shape.ir) {
      prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
      prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
    }

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      rotation: {
        get: ExpressionPropertyInterface(prop.r),
      },
      points: {
        get: ExpressionPropertyInterface(prop.pt),
      },
      outerRadius: {
        get: ExpressionPropertyInterface(prop.or),
      },
      outerRoundness: {
        get: ExpressionPropertyInterface(prop.os),
      },
      innerRadius: {
        get: ExpressionPropertyInterface(prop.ir),
      },
      innerRoundness: {
        get: ExpressionPropertyInterface(prop.is),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function rectInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.roundness;
      }
      if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      roundness: {
        get: ExpressionPropertyInterface(prop.r),
      },
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function roundedInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.r.ix === value || value === 'Round Corners 1') {
        return interfaceFunction.radius;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      radius: {
        get: ExpressionPropertyInterface(prop.rd),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function repeaterInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.c.ix === value || value === 'Copies') {
        return interfaceFunction.copies;
      } if (shape.o.ix === value || value === 'Offset') {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
    prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      copies: {
        get: ExpressionPropertyInterface(prop.c),
      },
      offset: {
        get: ExpressionPropertyInterface(prop.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  return function (shapes, view, propertyGroup) {
    var interfaces;
    function _interfaceFunction(value) {
      if (typeof value === 'number') {
        value = value === undefined ? 1 : value;
        if (value === 0) {
          return propertyGroup;
        }
        return interfaces[value - 1];
      }
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value) {
          return interfaces[i];
        }
        i += 1;
      }
      return null;
    }
    function parentGroupWrapper() {
      return propertyGroup;
    }
    _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
    interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
    _interfaceFunction.numProperties = interfaces.length;
    _interfaceFunction._name = 'Contents';
    return _interfaceFunction;
  };
}());

/* exported TextExpressionInterface */

var TextExpressionInterface = (function () {
  return function (elem) {
    var _prevValue;
    var _sourceText;
    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Text Document':
          return _thisLayerFunction.sourceText;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisLayerFunction, 'sourceText', {
      get: function () {
        elem.textProperty.getValue();
        var stringValue = elem.textProperty.currentData.t;
        if (stringValue !== _prevValue) {
          elem.textProperty.currentData.t = _prevValue;
          _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
          // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
          _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
        }
        return _sourceText;
      },
    });
    return _thisLayerFunction;
  };
}());

/* global Matrix, MaskManagerInterface, TransformExpressionInterface, getDescriptor */
/* exported LayerExpressionInterface */

var LayerExpressionInterface = (function () {
  function getMatrix(time) {
    var toWorldMat = new Matrix();
    if (time !== undefined) {
      var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
      propMatrix.clone(toWorldMat);
    } else {
      var transformMat = this._elem.finalTransform.mProp;
      transformMat.applyToMatrix(toWorldMat);
    }
    return toWorldMat;
  }

  function toWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.applyPoint(toWorldMat, arr);
  }

  function toWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.applyPoint(toWorldMat, arr);
  }

  function fromWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.invertPoint(toWorldMat, arr);
  }

  function fromWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.invertPoint(toWorldMat, arr);
  }

  function applyPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
  }

  function invertPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.inversePoint(arr);
  }

  function fromComp(arr) {
    var toWorldMat = new Matrix();
    toWorldMat.reset();
    this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
      }
      return toWorldMat.inversePoint(arr);
    }
    return toWorldMat.inversePoint(arr);
  }

  function sampleImage() {
    return [1, 1, 1, 1];
  }

  return function (elem) {
    var transformInterface;

    function _registerMaskInterface(maskManager) {
      _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
    }
    function _registerEffectsInterface(effects) {
      _thisLayerFunction.effect = effects;
    }

    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Root Vectors Group':
        case 'Contents':
        case 2:
          return _thisLayerFunction.shapeInterface;
        case 1:
        case 6:
        case 'Transform':
        case 'transform':
        case 'ADBE Transform Group':
          return transformInterface;
        case 4:
        case 'ADBE Effect Parade':
        case 'effects':
        case 'Effects':
          return _thisLayerFunction.effect;
        case 'ADBE Text Properties':
          return _thisLayerFunction.textInterface;
        default:
          return null;
      }
    }
    _thisLayerFunction.getMatrix = getMatrix;
    _thisLayerFunction.invertPoint = invertPoint;
    _thisLayerFunction.applyPoint = applyPoint;
    _thisLayerFunction.toWorld = toWorld;
    _thisLayerFunction.toWorldVec = toWorldVec;
    _thisLayerFunction.fromWorld = fromWorld;
    _thisLayerFunction.fromWorldVec = fromWorldVec;
    _thisLayerFunction.toComp = toWorld;
    _thisLayerFunction.fromComp = fromComp;
    _thisLayerFunction.sampleImage = sampleImage;
    _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
    _thisLayerFunction._elem = elem;
    transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
    var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
    Object.defineProperties(_thisLayerFunction, {
      hasParent: {
        get: function () {
          return elem.hierarchy.length;
        },
      },
      parent: {
        get: function () {
          return elem.hierarchy[0].layerInterface;
        },
      },
      rotation: getDescriptor(transformInterface, 'rotation'),
      scale: getDescriptor(transformInterface, 'scale'),
      position: getDescriptor(transformInterface, 'position'),
      opacity: getDescriptor(transformInterface, 'opacity'),
      anchorPoint: anchorPointDescriptor,
      anchor_point: anchorPointDescriptor,
      transform: {
        get: function () {
          return transformInterface;
        },
      },
      active: {
        get: function () {
          return elem.isInRange;
        },
      },
    });

    _thisLayerFunction.startTime = elem.data.st;
    _thisLayerFunction.index = elem.data.ind;
    _thisLayerFunction.source = elem.data.refId;
    _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
    _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
    _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
    _thisLayerFunction._name = elem.data.nm;

    _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
    _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
    return _thisLayerFunction;
  };
}());

/* global */
/* exported FootageInterface */

var FootageInterface = (function () {
  var outlineInterfaceFactory = (function (elem) {
    var currentPropertyName = '';
    var currentProperty = elem.getFootageData();
    function init() {
      currentPropertyName = '';
      currentProperty = elem.getFootageData();
      return searchProperty;
    }
    function searchProperty(value) {
      if (currentProperty[value]) {
        currentPropertyName = value;
        currentProperty = currentProperty[value];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      var propertyNameIndex = value.indexOf(currentPropertyName);
      if (propertyNameIndex !== -1) {
        var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
        currentProperty = currentProperty[index];
        if (typeof currentProperty === 'object') {
          return searchProperty;
        }
        return currentProperty;
      }
      return '';
    }
    return init;
  });

  var dataInterfaceFactory = function (elem) {
    function interfaceFunction(value) {
      if (value === 'Outline') {
        return interfaceFunction.outlineInterface();
      }
      return null;
    }

    interfaceFunction._name = 'Outline';
    interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
    return interfaceFunction;
  };

  return function (elem) {
    function _interfaceFunction(value) {
      if (value === 'Data') {
        return _interfaceFunction.dataInterface;
      }
      return null;
    }

    _interfaceFunction._name = 'Data';
    _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
    return _interfaceFunction;
  };
}());

/* exported CompExpressionInterface */

var CompExpressionInterface = (function () {
  return function (comp) {
    function _thisLayerFunction(name) {
      var i = 0;
      var len = comp.layers.length;
      while (i < len) {
        if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
          return comp.elements[i].layerInterface;
        }
        i += 1;
      }
      return null;
      // return {active:false};
    }
    Object.defineProperty(_thisLayerFunction, '_name', { value: comp.data.nm });
    _thisLayerFunction.layer = _thisLayerFunction;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
    _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
    _thisLayerFunction.displayStartTime = 0;
    _thisLayerFunction.numLayers = comp.layers.length;
    return _thisLayerFunction;
  };
}());

/* global ExpressionPropertyInterface */
/* exported TransformExpressionInterface */

var TransformExpressionInterface = (function () {
  return function (transform) {
    function _thisFunction(name) {
      switch (name) {
        case 'scale':
        case 'Scale':
        case 'ADBE Scale':
        case 6:
          return _thisFunction.scale;
        case 'rotation':
        case 'Rotation':
        case 'ADBE Rotation':
        case 'ADBE Rotate Z':
        case 10:
          return _thisFunction.rotation;
        case 'ADBE Rotate X':
          return _thisFunction.xRotation;
        case 'ADBE Rotate Y':
          return _thisFunction.yRotation;
        case 'position':
        case 'Position':
        case 'ADBE Position':
        case 2:
          return _thisFunction.position;
        case 'ADBE Position_0':
          return _thisFunction.xPosition;
        case 'ADBE Position_1':
          return _thisFunction.yPosition;
        case 'ADBE Position_2':
          return _thisFunction.zPosition;
        case 'anchorPoint':
        case 'AnchorPoint':
        case 'Anchor Point':
        case 'ADBE AnchorPoint':
        case 1:
          return _thisFunction.anchorPoint;
        case 'opacity':
        case 'Opacity':
        case 11:
          return _thisFunction.opacity;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisFunction, 'rotation', {
      get: ExpressionPropertyInterface(transform.r || transform.rz),
    });

    Object.defineProperty(_thisFunction, 'zRotation', {
      get: ExpressionPropertyInterface(transform.rz || transform.r),
    });

    Object.defineProperty(_thisFunction, 'xRotation', {
      get: ExpressionPropertyInterface(transform.rx),
    });

    Object.defineProperty(_thisFunction, 'yRotation', {
      get: ExpressionPropertyInterface(transform.ry),
    });
    Object.defineProperty(_thisFunction, 'scale', {
      get: ExpressionPropertyInterface(transform.s),
    });
    var _px;
    var _py;
    var _pz;
    var _transformFactory;
    if (transform.p) {
      _transformFactory = ExpressionPropertyInterface(transform.p);
    } else {
      _px = ExpressionPropertyInterface(transform.px);
      _py = ExpressionPropertyInterface(transform.py);
      if (transform.pz) {
        _pz = ExpressionPropertyInterface(transform.pz);
      }
    }
    Object.defineProperty(_thisFunction, 'position', {
      get: function () {
        if (transform.p) {
          return _transformFactory();
        }
        return [
          _px(),
          _py(),
          _pz ? _pz() : 0];
      },
    });

    Object.defineProperty(_thisFunction, 'xPosition', {
      get: ExpressionPropertyInterface(transform.px),
    });

    Object.defineProperty(_thisFunction, 'yPosition', {
      get: ExpressionPropertyInterface(transform.py),
    });

    Object.defineProperty(_thisFunction, 'zPosition', {
      get: ExpressionPropertyInterface(transform.pz),
    });

    Object.defineProperty(_thisFunction, 'anchorPoint', {
      get: ExpressionPropertyInterface(transform.a),
    });

    Object.defineProperty(_thisFunction, 'opacity', {
      get: ExpressionPropertyInterface(transform.o),
    });

    Object.defineProperty(_thisFunction, 'skew', {
      get: ExpressionPropertyInterface(transform.sk),
    });

    Object.defineProperty(_thisFunction, 'skewAxis', {
      get: ExpressionPropertyInterface(transform.sa),
    });

    Object.defineProperty(_thisFunction, 'orientation', {
      get: ExpressionPropertyInterface(transform.or),
    });

    return _thisFunction;
  };
}());

/* exported ProjectInterface */

var ProjectInterface = (function () {
  function registerComposition(comp) {
    this.compositions.push(comp);
  }

  return function () {
    function _thisProjectFunction(name) {
      var i = 0;
      var len = this.compositions.length;
      while (i < len) {
        if (this.compositions[i].data && this.compositions[i].data.nm === name) {
          if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
            this.compositions[i].prepareFrame(this.currentFrame);
          }
          return this.compositions[i].compInterface;
        }
        i += 1;
      }
      return null;
    }

    _thisProjectFunction.compositions = [];
    _thisProjectFunction.currentFrame = 0;

    _thisProjectFunction.registerComposition = registerComposition;

    return _thisProjectFunction;
  };
}());

/* global propertyGroupFactory, ExpressionPropertyInterface, PropertyInterface */
/* exported EffectsExpressionInterface */

var EffectsExpressionInterface = (function () {
  var ob = {
    createEffectsInterface: createEffectsInterface,
  };

  function createEffectsInterface(elem, propertyGroup) {
    if (elem.effectsManager) {
      var effectElements = [];
      var effectsData = elem.data.ef;
      var i;
      var len = elem.effectsManager.effectElements.length;
      for (i = 0; i < len; i += 1) {
        effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
      }

      var effects = elem.data.ef || [];
      var groupInterface = function (name) {
        i = 0;
        len = effects.length;
        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            return effectElements[i];
          }
          i += 1;
        }
        return null;
      };
      Object.defineProperty(groupInterface, 'numProperties', {
        get: function () {
          return effects.length;
        },
      });
      return groupInterface;
    }
    return null;
  }

  function createGroupInterface(data, elements, propertyGroup, elem) {
    function groupInterface(name) {
      var effects = data.ef;
      var i = 0;
      var len = effects.length;
      while (i < len) {
        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
          if (effects[i].ty === 5) {
            return effectElements[i];
          }
          return effectElements[i]();
        }
        i += 1;
      }
      throw new Error();
    }
    var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

    var effectElements = [];
    var i;
    var len = data.ef.length;
    for (i = 0; i < len; i += 1) {
      if (data.ef[i].ty === 5) {
        effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
      } else {
        effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
      }
    }

    if (data.mn === 'ADBE Color Control') {
      Object.defineProperty(groupInterface, 'color', {
        get: function () {
          return effectElements[0]();
        },
      });
    }
    Object.defineProperties(groupInterface, {
      numProperties: {
        get: function () {
          return data.np;
        },
      },
      _name: { value: data.nm },
      propertyGroup: { value: _propertyGroup },
    });
    groupInterface.enabled = data.en !== 0;
    groupInterface.active = groupInterface.enabled;
    return groupInterface;
  }

  function createValueInterface(element, type, elem, propertyGroup) {
    var expressionProperty = ExpressionPropertyInterface(element.p);
    function interfaceFunction() {
      if (type === 10) {
        return elem.comp.compInterface(element.p.v);
      }
      return expressionProperty();
    }

    if (element.p.setGroupProperty) {
      element.p.setGroupProperty(PropertyInterface('', propertyGroup));
    }

    return interfaceFunction;
  }

  return ob;
}());

/* global createSizedArray */
/* exported MaskManagerInterface */

var MaskManagerInterface = (function () {
  function MaskInterface(mask, data) {
    this._mask = mask;
    this._data = data;
  }
  Object.defineProperty(MaskInterface.prototype, 'maskPath', {
    get: function () {
      if (this._mask.prop.k) {
        this._mask.prop.getValue();
      }
      return this._mask.prop;
    },
  });
  Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
    get: function () {
      if (this._mask.op.k) {
        this._mask.op.getValue();
      }
      return this._mask.op.v * 100;
    },
  });

  var MaskManager = function (maskManager) {
    var _masksInterfaces = createSizedArray(maskManager.viewData.length);
    var i;
    var len = maskManager.viewData.length;
    for (i = 0; i < len; i += 1) {
      _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
    }

    var maskFunction = function (name) {
      i = 0;
      while (i < len) {
        if (maskManager.masksProperties[i].nm === name) {
          return _masksInterfaces[i];
        }
        i += 1;
      }
      return null;
    };
    return maskFunction;
  };
  return MaskManager;
}());

/* global createTypedArray */
/* exported ExpressionPropertyInterface */

var ExpressionPropertyInterface = (function () {
  var defaultUnidimensionalValue = { pv: 0, v: 0, mult: 1 };
  var defaultMultidimensionalValue = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };

  function completeProperty(expressionValue, property, type) {
    Object.defineProperty(expressionValue, 'velocity', {
      get: function () {
        return property.getVelocityAtTime(property.comp.currentFrame);
      },
    });
    expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
    expressionValue.key = function (pos) {
      if (!expressionValue.numKeys) {
        return 0;
      }
      var value = '';
      if ('s' in property.keyframes[pos - 1]) {
        value = property.keyframes[pos - 1].s;
      } else if ('e' in property.keyframes[pos - 2]) {
        value = property.keyframes[pos - 2].e;
      } else {
        value = property.keyframes[pos - 2].s;
      }
      var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
      valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
      valueProp.value = type === 'unidimensional' ? value[0] : value;
      return valueProp;
    };
    expressionValue.valueAtTime = property.getValueAtTime;
    expressionValue.speedAtTime = property.getSpeedAtTime;
    expressionValue.velocityAtTime = property.getVelocityAtTime;
    expressionValue.propertyGroup = property.propertyGroup;
  }

  function UnidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultUnidimensionalValue;
    }
    var mult = 1 / property.mult;
    var val = property.pv * mult;
    var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
    expressionValue.value = val;
    completeProperty(expressionValue, property, 'unidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      val = property.v * mult;
      if (expressionValue.value !== val) {
        expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
        expressionValue.value = val;
        completeProperty(expressionValue, property, 'unidimensional');
      }
      return expressionValue;
    };
  }

  function MultidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultMultidimensionalValue;
    }
    var mult = 1 / property.mult;
    var len = (property.data && property.data.l) || property.pv.length;
    var expressionValue = createTypedArray('float32', len);
    var arrValue = createTypedArray('float32', len);
    expressionValue.value = arrValue;
    completeProperty(expressionValue, property, 'multidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      for (var i = 0; i < len; i += 1) {
        arrValue[i] = property.v[i] * mult;
        expressionValue[i] = arrValue[i];
      }
      return expressionValue;
    };
  }

  // TODO: try to avoid using this getter
  function defaultGetter() {
    return defaultUnidimensionalValue;
  }

  return function (property) {
    if (!property) {
      return defaultGetter;
    } if (property.propType === 'unidimensional') {
      return UnidimensionalPropertyInterface(property);
    }
    return MultidimensionalPropertyInterface(property);
  };
}());

/* global expressionHelpers, TextSelectorProp, ExpressionManager */
/* exported TextExpressionSelectorPropFactory */

var TextExpressionSelectorPropFactory = (function () { // eslint-disable-line no-unused-vars
  function getValueProxy(index, total) {
    this.textIndex = index + 1;
    this.textTotal = total;
    this.v = this.getValue() * this.mult;
    return this.v;
  }

  return function (elem, data) {
    this.pv = 1;
    this.comp = elem.comp;
    this.elem = elem;
    this.mult = 0.01;
    this.propType = 'textSelector';
    this.textTotal = data.totalChars;
    this.selectorValue = 100;
    this.lastValue = [1, 1, 1];
    this.k = true;
    this.x = true;
    this.getValue = ExpressionManager.initiateExpression.bind(this)(elem, data, this);
    this.getMult = getValueProxy;
    this.getVelocityAtTime = expressionHelpers.getVelocityAtTime;
    if (this.kf) {
      this.getValueAtTime = expressionHelpers.getValueAtTime.bind(this);
    } else {
      this.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(this);
    }
    this.setGroupProperty = expressionHelpers.setGroupProperty;
  };
}());

var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
TextSelectorProp.getTextSelectorProp = function (elem, data, arr) {
  if (data.t === 1) {
    return new TextExpressionSelectorPropFactory(elem, data, arr); // eslint-disable-line no-undef
  }
  return propertyGetTextProp(elem, data, arr);
};

/* global PropertyFactory */
/* exported SliderEffect, AngleEffect, ColorEffect, PointEffect, LayerIndexEffect, MaskIndexEffect, CheckboxEffect, NoValueEffect */

function SliderEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function AngleEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function ColorEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function PointEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function LayerIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function MaskIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function CheckboxEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function NoValueEffect() {
  this.p = {};
}

/* global extendPrototype, SliderEffect, AngleEffect, ColorEffect, PointEffect, CheckboxEffect, LayerIndexEffect,
MaskIndexEffect, NoValueEffect, DynamicPropertyContainer */

function EffectsManager(data, element) {
  var effects = data.ef || [];
  this.effectElements = [];
  var i;
  var len = effects.length;
  var effectItem;
  for (i = 0; i < len; i += 1) {
    effectItem = new GroupEffect(effects[i], element);
    this.effectElements.push(effectItem);
  }
}

function GroupEffect(data, element) {
  this.init(data, element);
}

extendPrototype([DynamicPropertyContainer], GroupEffect);

GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

GroupEffect.prototype.init = function (data, element) {
  this.data = data;
  this.effectElements = [];
  this.initDynamicPropertyContainer(element);
  var i;
  var len = this.data.ef.length;
  var eff;
  var effects = this.data.ef;
  for (i = 0; i < len; i += 1) {
    eff = null;
    switch (effects[i].ty) {
      case 0:
        eff = new SliderEffect(effects[i], element, this);
        break;
      case 1:
        eff = new AngleEffect(effects[i], element, this);
        break;
      case 2:
        eff = new ColorEffect(effects[i], element, this);
        break;
      case 3:
        eff = new PointEffect(effects[i], element, this);
        break;
      case 4:
      case 7:
        eff = new CheckboxEffect(effects[i], element, this);
        break;
      case 10:
        eff = new LayerIndexEffect(effects[i], element, this);
        break;
      case 11:
        eff = new MaskIndexEffect(effects[i], element, this);
        break;
      case 5:
        eff = new EffectsManager(effects[i], element, this);
        break;
        // case 6:
      default:
        eff = new NoValueEffect(effects[i], element, this);
        break;
    }
    if (eff) {
      this.effectElements.push(eff);
    }
  }
};


var lottie = {};

function setLocationHref(href) {
  locationHref = href;
}

function searchAnimations() {
  if (standalone === true) {
    animationManager.searchAnimations(animationData, standalone, renderer);
  } else {
    animationManager.searchAnimations();
  }
}

function setSubframeRendering(flag) {
  subframeEnabled = flag;
}

function setIDPrefix(prefix) {
  idPrefix = prefix;
}

function loadAnimation(params) {
  if (standalone === true) {
    params.animationData = JSON.parse(animationData);
  }
  return animationManager.loadAnimation(params);
}

function setQuality(value) {
  if (typeof value === 'string') {
    switch (value) {
      case 'high':
        defaultCurveSegments = 200;
        break;
      default:
      case 'medium':
        defaultCurveSegments = 50;
        break;
      case 'low':
        defaultCurveSegments = 10;
        break;
    }
  } else if (!isNaN(value) && value > 1) {
    defaultCurveSegments = value;
  }
  if (defaultCurveSegments >= 50) {
    roundValues(false);
  } else {
    roundValues(true);
  }
}

function inBrowser() {
  return typeof navigator !== 'undefined';
}

function installPlugin(type, plugin) {
  if (type === 'expressions') {
    expressionsPlugin = plugin;
  }
}

function getFactory(name) {
  switch (name) {
    case 'propertyFactory':
      return PropertyFactory;
    case 'shapePropertyFactory':
      return ShapePropertyFactory;
    case 'matrix':
      return Matrix;
    default:
      return null;
  }
}

lottie.play = animationManager.play;
lottie.pause = animationManager.pause;
lottie.setLocationHref = setLocationHref;
lottie.togglePause = animationManager.togglePause;
lottie.setSpeed = animationManager.setSpeed;
lottie.setDirection = animationManager.setDirection;
lottie.stop = animationManager.stop;
lottie.searchAnimations = searchAnimations;
lottie.registerAnimation = animationManager.registerAnimation;
lottie.loadAnimation = loadAnimation;
lottie.setSubframeRendering = setSubframeRendering;
lottie.resize = animationManager.resize;
// lottie.start = start;
lottie.goToAndStop = animationManager.goToAndStop;
lottie.destroy = animationManager.destroy;
lottie.setQuality = setQuality;
lottie.inBrowser = inBrowser;
lottie.installPlugin = installPlugin;
lottie.freeze = animationManager.freeze;
lottie.unfreeze = animationManager.unfreeze;
lottie.setVolume = animationManager.setVolume;
lottie.mute = animationManager.mute;
lottie.unmute = animationManager.unmute;
lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
lottie.useWebWorker = function (flag) {
  _useWebWorker = flag;
};
lottie.setIDPrefix = setIDPrefix;
lottie.__getFactory = getFactory;
lottie.version = '5.8.1';

function checkReady() {
  if (document.readyState === 'complete') {
    clearInterval(readyStateCheckInterval);
    searchAnimations();
  }
}

function getQueryVariable(variable) {
  var vars = queryString.split('&');
  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) { // eslint-disable-line eqeqeq
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
var standalone = '__[STANDALONE]__';
var animationData = '__[ANIMATIONDATA]__';
var renderer = '';
var queryString;
if (standalone) {
  var scripts = document.getElementsByTagName('script');
  var index = scripts.length - 1;
  var myScript = scripts[index] || {
    src: '',
  };
  queryString = myScript.src.replace(/^[^\?]+\??/, ''); // eslint-disable-line no-useless-escape
  renderer = getQueryVariable('renderer');
}
var readyStateCheckInterval = setInterval(checkReady, 100);

return lottie;
}));

/***/ }),

/***/ 68762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(19562),
      utf8 = (__webpack_require__(5792).utf8),
      isBuffer = __webpack_require__(13335),
      bin = (__webpack_require__(5792).bin),

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ 17969:
/***/ (function(module) {

// If `Date.now()` is invoked twice quickly, it's possible to get two
// identical time stamps. To avoid generation duplications, subsequent
// calls are manually ordered to force uniqueness.

var _last = 0
var _count = 1
var adjusted = 0
var _adjusted = 0

module.exports =
function timestamp() {
  /**
  Returns NOT an accurate representation of the current time.
  Since js only measures time as ms, if you call `Date.now()`
  twice quickly, it's possible to get two identical time stamps.
  This function guarantees unique but maybe inaccurate results
  on each call.
  **/
  //uncomment this wen
  var time = Date.now()
  //time = ~~ (time / 1000) 
  //^^^uncomment when testing...

  /**
  If time returned is same as in last call, adjust it by
  adding a number based on the counter. 
  Counter is incremented so that next call get's adjusted properly.
  Because floats have restricted precision, 
  may need to step past some values...
  **/
  if (_last === time)  {
    do {
      adjusted = time + ((_count++) / (_count + 999))
    } while (adjusted === _adjusted)
    _adjusted = adjusted
  }
  // If last time was different reset timer back to `1`.
  else {
    _count = 1
    adjusted = time
  }
  _adjusted = adjusted
  _last = time
  return adjusted
}


/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(73548);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7298:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.18.0';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(58536);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(63699);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(39660);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message =>
    ignoreErrors.some(pattern => (0,string/* isMatchingPattern */.zC)(message, pattern)),
  );
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : denyUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : allowUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(21995);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(66465);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(51877);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(69038);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(49798);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(64005);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(97946);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded += 1;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/envelope.js



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    const envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(7790);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/envelope.js


/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }
  const { name, version } = metadata.sdk;
  return { name, version };
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const eventType = event.type || 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(48364);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category) {
    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    const prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    if (finalScope) {
      // Collect attachments from the hint and scope
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    const normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    const options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    const request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    const integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = event.type === 'transaction';
    const beforeSendProcessorName = isTransaction ? 'beforeSendTransaction' : 'beforeSend';
    const beforeSendProcessor = options[beforeSendProcessorName];

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error');
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', event.type || 'error');
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException || !beforeSendProcessor) {
          return prepared;
        }

        const beforeSendResult = beforeSendProcessor(prepared, hint);
        return _validateBeforeSendResult(beforeSendResult, beforeSendProcessorName);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error');
          throw new SentryError(`\`${beforeSendProcessorName}\` returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
            changes: [
              ...transactionInfo.changes,
              {
                source,
                // use the same timestamp as the processed event.
                timestamp: processedEvent.timestamp ,
                propagations: transactionInfo.propagations,
              },
            ],
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing += 1;
    void promise.then(
      value => {
        this._numProcessing -= 1;
        return value;
      },
      reason => {
        this._numProcessing -= 1;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendProcessorName,
) {
  const invalidValueError = `\`${beforeSendProcessorName}\` must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`\`${beforeSendProcessorName}\` rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(90063);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError += 1;
  setTimeout(() => {
    ignoreOnError -= 1;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(54194);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.Rt)(handlerData.event.target , keyAttrs)
        : (0,browser/* htmlTreeAsString */.Rt)(handlerData.event , keyAttrs);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/client.js






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    if (
      breadcrumbIntegration &&
      // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options &&
      breadcrumbIntegration.options.sentry
    ) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          // eslint-disable-next-line no-plusplus
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (_, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/sdk.js
















const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(78900);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(40564);
// EXTERNAL MODULE: ../../node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(92517);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(12885);
;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport, opts = {}) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric, opts.reportAllChanges);

    onHidden(() => {
      handleEntries(po.takeRecords() );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport, opts = {}) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric, opts.reportAllChanges);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */
const onLCP = (onReport, opts = {}) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric, opts.reportAllChanges);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/metrics/index.js











function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals(reportAllChanges = false) {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP(reportAllChanges);
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = (0,utils/* msToSec */.XL)((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = (0,utils/* msToSec */.XL)(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP(reportAllChanges) {
  onLCP(
    metric => {
      const entry = metric.entries.pop();
      if (!entry) {
        return;
      }

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
      _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
      _lcpEntry = entry ;
    },
    { reportAllChanges },
  );
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    const duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/request.js



// TODO (v8): Remove `tracingOrigins`
const DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  tracingOrigins: DEFAULT_TRACING_ORIGINS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const { traceFetch, traceXHR, tracingOrigins, tracePropagationTargets, shouldCreateSpanForRequest } = {
    ...defaultRequestInstrumentationOptions,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  const shouldAttachHeaders = (url) =>
    tracingOrigins.some(origin => (0,string/* isMatchingPattern */.zC)(url, origin)) ||
    tracePropagationTargets.some(origin => (0,string/* isMatchingPattern */.zC)(url, origin));

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans);
    });
  }
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );

      activeTransaction.metadata.propagations += 1;
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }

        activeTransaction.metadata.propagations += 1;
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/browser/browsertracing.js











const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  heartbeatInterval: idletransaction/* DEFAULT_HEARTBEAT_INTERVAL */.hd,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  _experiments: { enableLongTask: true },
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    let tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
    // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
    if (_options) {
      if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins)) {
        tracingOrigins = _options.tracingOrigins;
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (this._emitOptionsWarning = true);
      }
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
      tracingOrigins,
    };

    const { _metricOptions } = this.options;
    startTrackingWebVitals(_metricOptions && _metricOptions._reportAllChanges);
    if (_optionalChain([this, 'access', _2 => _2.options, 'access', _3 => _3._experiments, 'optionalAccess', _4 => _4.enableLongTask])) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    if (this._emitOptionsWarning) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          '[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.',
        );
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `[Tracing] We added a reasonable default for you: ${defaultRequestInstrumentationOptions.tracingOrigins}`,
        );
    }

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracingOrigins,
      shouldCreateSpanForRequest,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    instrumentOutgoingRequests({ traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
      transaction.setTag(
        'sentry_reportAllChanges',
        Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges),
      );
    });

    return idleTransaction ;
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/performance/client.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/utils/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/index.client.js











// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";

  let integrations = options.integrations;

  // Guard below evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false"
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    if (options.tracesSampleRate !== undefined || options.tracesSampler !== undefined) {
      integrations = createClientIntegrations(options.integrations);
    }
  }

  sdk_init({
    ...options,
    integrations,
  });

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function createClientIntegrations(userIntegrations = []) {
  const defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    routingInstrumentation: nextRouterInstrumentation,
  });

  return addOrUpdateIntegration(defaultBrowserTracingIntegration, userIntegrations, {
    'options.routingInstrumentation': nextRouterInstrumentation,
  });
}


//# sourceMappingURL=index.client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/extraerrordata.js


/** JSDoc */

/** Patch toString calls to return proper name for wrapped functions */
class ExtraErrorData  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'ExtraErrorData';}

  /**
   * @inheritDoc
   */
   __init() {this.name = ExtraErrorData.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {;ExtraErrorData.prototype.__init.call(this);
    this._options = {
      depth: 3,
      ...options,
    };
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor((event, hint) => {
      const self = getCurrentHub().getIntegration(ExtraErrorData);
      if (!self) {
        return event;
      }
      return self.enhanceEventWithErrorData(event, hint);
    });
  }

  /**
   * Attaches extracted information from the Error object to extra field in the Event
   */
   enhanceEventWithErrorData(event, hint = {}) {
    if (!hint.originalException || !(0,is/* isError */.VZ)(hint.originalException)) {
      return event;
    }
    const exceptionName = (hint.originalException ).name || hint.originalException.constructor.name;

    const errorData = this._extractErrorData(hint.originalException );

    if (errorData) {
      const contexts = {
        ...event.contexts,
      };

      const normalizedErrorData = normalize(errorData, this._options.depth);

      if ((0,is/* isPlainObject */.PO)(normalizedErrorData)) {
        // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
        // potentially truncate the data we just already normalized, with a certain depth setting.
        (0,object/* addNonEnumerableProperty */.xp)(normalizedErrorData, '__sentry_skip_normalization__', true);
        contexts[exceptionName] = normalizedErrorData;
      }

      return {
        ...event,
        contexts,
      };
    }

    return event;
  }

  /**
   * Extract extra information from the Error object
   */
   _extractErrorData(error) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
      const nativeKeys = [
        'name',
        'message',
        'stack',
        'line',
        'column',
        'fileName',
        'lineNumber',
        'columnNumber',
        'toJSON',
      ];

      const extraErrorInfo = {};

      // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
      for (const key of Object.keys(error)) {
        if (nativeKeys.indexOf(key) !== -1) {
          continue;
        }
        const value = error[key];
        extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
      }

      // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
      if (typeof error.toJSON === 'function') {
        const serializedError = error.toJSON() ;

        for (const key of Object.keys(serializedError)) {
          const value = serializedError[key];
          extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
        }
      }

      return extraErrorInfo;
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Unable to extract extra data from the Error object:', oO);
    }

    return null;
  }
} ExtraErrorData.__initStatic();


//# sourceMappingURL=extraerrordata.js.map

;// CONCATENATED MODULE: ./src/observability/sentry.ts
/* provided dependency */ var process = __webpack_require__(34406);

var keys = [
    /password/i,
    /secret/i,
    /token/i,
    /credentials/i
];
function scrub(event) {
    var _loop = function(eventKey) {
        var isSensitiveKey = keys.some(function(key) {
            return key.test(eventKey);
        });
        if (isSensitiveKey) {
            delete event[eventKey];
        } else if (typeof event[eventKey] === "object") {
            scrub(event[eventKey]);
        }
    };
    if (typeof event !== "object") return;
    if (Array.isArray(event)) return event.forEach(function(element) {
        return scrub(element);
    });
    for(var eventKey in event)_loop(eventKey);
}
var removeSensitiveData = function(event) {
    if (event.transaction && keys.some(function(key) {
        return key.test(event.transaction);
    })) event.transaction = "redacted";
    scrub(event.breadcrumbs);
    scrub(event.request);
    scrub(event.contexts);
    scrub(event.transaction_info);
    scrub(event.user);
};
var CLIENT_EXCEPTIONS_TO_IGNORE = [
    // Ignore http://bit.ly/2hk42Ap, resulting from what
    // appears to be a Chrome bug http://bit.ly/2gVbncS
    /__gCrWeb\.autofill\.extractForms/,
    // Ignore http://bit.ly/2hk71Zv, resulting from
    // some really strange issue in Safari 9. Experienced
    // by Mozilla team, too http://bit.ly/2hk9vHq
    /docs-homescreen-gb-container/,
    // Ignore http://bit.ly/2mVGcgX. It's a weird react error.
    // Google says it _might_ be a logging error? http://bit.ly/2lEB3ZW
    /e\.getHostNode/,
    // Ignore http://bit.ly/2lyZSao, resulting from
    // some Chrome plugin presumably.
    /ahk_main/,
    // Some weird firefox errors that seem to happen only on firefox for iOS.
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1394296
    /__firefox__\./,
    /*
    This error occurs when a ResizeObserver event handler makes a size change
    to the element being observed, which causes the event handler to be
    triggered again, creating a loop. This error is thrown to prevent this
    potential loop.

    There is typically no noticeable effect to the user and
    most browsers don't even log this error to the console.

    The error message can differ per browser.
  */ /ResizeObserver loop limit exceeded/,
    /ResizeObserver loop completed with undelivered notifications\./,
    /*
    This error occurs when an unfinished `fetch` request is cancelled, most
    often by navigating to a new page.

    The error message can differ per browser.
  */ /TypeError: Load failed/,
    /TypeError: cancelled/, 
];
var SERVER_EXCEPTIONS_TO_IGNORE = (/* unused pure expression or super */ null && ([
    // Error emitted by Builder.io during build-time that can safely be ignored
    /Missing registration for/,
    // Error emitted until we remove v3 tracking package
    /This package has been deprecated. We strongly encourage if you are planning to use it for the first time, please use the new library Events-Toolkit-Browser: https:\/\/github.com\/zapier\/events-toolkit-js/,
    /Do not use the cta disclaimer with the zapier background/, 
]));
// Base configurations used by both client and server
var BASE_CONFIG = {
    dsn: process.env.SENTRY_DSN || "https://e3d608100dcb43dea96b971c58431ee7@o23399.ingest.sentry.io/5720276",
    // tracesSampleRate is the sampling of transactions sent to Sentry
    tracesSampleRate: 0.2,
    // sampleRate is the sampling rate of errors sent to Sentry
    sampleRate: 1.0,
    environment: "staging",
    release: process.env.SENTRY_RELEASE,
    integrations: [
        // Extracts all non-native attributes from the Error object and attaches
        // them to the event as the `extra` data.
        // https://docs.sentry.io/platforms/javascript/#extraerrordata
        new ExtraErrorData(), 
    ]
};

;// CONCATENATED MODULE: ./sentry.client.config.js
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/




index_client_init((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, BASE_CONFIG), {
    ignoreErrors: CLIENT_EXCEPTIONS_TO_IGNORE,
    beforeSend: function beforeSend(event) {
        if (event.environment === "development") {
            var ref;
            console.log("Would have sent the following exception to Sentry: ", JSON.stringify((ref = event.exception) === null || ref === void 0 ? void 0 : ref.values));
            return null;
        }
        removeSensitiveData(event);
        return event;
    }
}));


/***/ }),

/***/ 15593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ../../node_modules/@builder.io/sdk/dist/index.esm.js
var index_esm = __webpack_require__(26149);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/colord/index.mjs
var r={grad:.9,turn:360,rad:360/(2*Math.PI)},t=function(r){return"string"==typeof r?r.length>0:"number"==typeof r},n=function(r,t,n){return void 0===t&&(t=0),void 0===n&&(n=Math.pow(10,t)),Math.round(n*r)/n+0},e=function(r,t,n){return void 0===t&&(t=0),void 0===n&&(n=1),r>n?n:r>t?r:t},u=function(r){return(r=isFinite(r)?r%360:0)>0?r:r+360},a=function(r){return{r:e(r.r,0,255),g:e(r.g,0,255),b:e(r.b,0,255),a:e(r.a)}},o=function(r){return{r:n(r.r),g:n(r.g),b:n(r.b),a:n(r.a,3)}},colord_i=/^#([0-9a-f]{3,8})$/i,s=function(r){var t=r.toString(16);return t.length<2?"0"+t:t},h=function(r){var t=r.r,n=r.g,e=r.b,u=r.a,a=Math.max(t,n,e),o=a-Math.min(t,n,e),i=o?a===t?(n-e)/o:a===n?2+(e-t)/o:4+(t-n)/o:0;return{h:60*(i<0?i+6:i),s:a?o/a*100:0,v:a/255*100,a:u}},b=function(r){var t=r.h,n=r.s,e=r.v,u=r.a;t=t/360*6,n/=100,e/=100;var a=Math.floor(t),o=e*(1-n),i=e*(1-(t-a)*n),s=e*(1-(1-t+a)*n),h=a%6;return{r:255*[e,i,o,o,s,e][h],g:255*[s,e,e,i,o,o][h],b:255*[o,o,s,e,e,i][h],a:u}},g=function(r){return{h:u(r.h),s:e(r.s,0,100),l:e(r.l,0,100),a:e(r.a)}},d=function(r){return{h:n(r.h),s:n(r.s),l:n(r.l),a:n(r.a,3)}},f=function(r){return b((n=(t=r).s,{h:t.h,s:(n*=((e=t.l)<50?e:100-e)/100)>0?2*n/(e+n)*100:0,v:e+n,a:t.a}));var t,n,e},c=function(r){return{h:(t=h(r)).h,s:(u=(200-(n=t.s))*(e=t.v)/100)>0&&u<200?n*e/100/(u<=100?u:200-u)*100:0,l:u/2,a:t.a};var t,n,e,u},l=/^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,p=/^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,v=/^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,m=/^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,y={string:[[function(r){var t=colord_i.exec(r);return t?(r=t[1]).length<=4?{r:parseInt(r[0]+r[0],16),g:parseInt(r[1]+r[1],16),b:parseInt(r[2]+r[2],16),a:4===r.length?n(parseInt(r[3]+r[3],16)/255,2):1}:6===r.length||8===r.length?{r:parseInt(r.substr(0,2),16),g:parseInt(r.substr(2,2),16),b:parseInt(r.substr(4,2),16),a:8===r.length?n(parseInt(r.substr(6,2),16)/255,2):1}:null:null},"hex"],[function(r){var t=v.exec(r)||m.exec(r);return t?t[2]!==t[4]||t[4]!==t[6]?null:a({r:Number(t[1])/(t[2]?100/255:1),g:Number(t[3])/(t[4]?100/255:1),b:Number(t[5])/(t[6]?100/255:1),a:void 0===t[7]?1:Number(t[7])/(t[8]?100:1)}):null},"rgb"],[function(t){var n=l.exec(t)||p.exec(t);if(!n)return null;var e,u,a=g({h:(e=n[1],u=n[2],void 0===u&&(u="deg"),Number(e)*(r[u]||1)),s:Number(n[3]),l:Number(n[4]),a:void 0===n[5]?1:Number(n[5])/(n[6]?100:1)});return f(a)},"hsl"]],object:[[function(r){var n=r.r,e=r.g,u=r.b,o=r.a,i=void 0===o?1:o;return t(n)&&t(e)&&t(u)?a({r:Number(n),g:Number(e),b:Number(u),a:Number(i)}):null},"rgb"],[function(r){var n=r.h,e=r.s,u=r.l,a=r.a,o=void 0===a?1:a;if(!t(n)||!t(e)||!t(u))return null;var i=g({h:Number(n),s:Number(e),l:Number(u),a:Number(o)});return f(i)},"hsl"],[function(r){var n=r.h,a=r.s,o=r.v,i=r.a,s=void 0===i?1:i;if(!t(n)||!t(a)||!t(o))return null;var h=function(r){return{h:u(r.h),s:e(r.s,0,100),v:e(r.v,0,100),a:e(r.a)}}({h:Number(n),s:Number(a),v:Number(o),a:Number(s)});return b(h)},"hsv"]]},N=function(r,t){for(var n=0;n<t.length;n++){var e=t[n][0](r);if(e)return[e,t[n][1]]}return[null,void 0]},x=function(r){return"string"==typeof r?N(r.trim(),y.string):"object"==typeof r&&null!==r?N(r,y.object):[null,void 0]},I=function(r){return x(r)[1]},M=function(r,t){var n=c(r);return{h:n.h,s:e(n.s+100*t,0,100),l:n.l,a:n.a}},H=function(r){return(299*r.r+587*r.g+114*r.b)/1e3/255},$=function(r,t){var n=c(r);return{h:n.h,s:n.s,l:e(n.l+100*t,0,100),a:n.a}},j=function(){function r(r){this.parsed=x(r)[0],this.rgba=this.parsed||{r:0,g:0,b:0,a:1}}return r.prototype.isValid=function(){return null!==this.parsed},r.prototype.brightness=function(){return n(H(this.rgba),2)},r.prototype.isDark=function(){return H(this.rgba)<.5},r.prototype.isLight=function(){return H(this.rgba)>=.5},r.prototype.toHex=function(){return r=o(this.rgba),t=r.r,e=r.g,u=r.b,i=(a=r.a)<1?s(n(255*a)):"","#"+s(t)+s(e)+s(u)+i;var r,t,e,u,a,i},r.prototype.toRgb=function(){return o(this.rgba)},r.prototype.toRgbString=function(){return r=o(this.rgba),t=r.r,n=r.g,e=r.b,(u=r.a)<1?"rgba("+t+", "+n+", "+e+", "+u+")":"rgb("+t+", "+n+", "+e+")";var r,t,n,e,u},r.prototype.toHsl=function(){return d(c(this.rgba))},r.prototype.toHslString=function(){return r=d(c(this.rgba)),t=r.h,n=r.s,e=r.l,(u=r.a)<1?"hsla("+t+", "+n+"%, "+e+"%, "+u+")":"hsl("+t+", "+n+"%, "+e+"%)";var r,t,n,e,u},r.prototype.toHsv=function(){return r=h(this.rgba),{h:n(r.h),s:n(r.s),v:n(r.v),a:n(r.a,3)};var r},r.prototype.invert=function(){return w({r:255-(r=this.rgba).r,g:255-r.g,b:255-r.b,a:r.a});var r},r.prototype.saturate=function(r){return void 0===r&&(r=.1),w(M(this.rgba,r))},r.prototype.desaturate=function(r){return void 0===r&&(r=.1),w(M(this.rgba,-r))},r.prototype.grayscale=function(){return w(M(this.rgba,-1))},r.prototype.lighten=function(r){return void 0===r&&(r=.1),w($(this.rgba,r))},r.prototype.darken=function(r){return void 0===r&&(r=.1),w($(this.rgba,-r))},r.prototype.rotate=function(r){return void 0===r&&(r=15),this.hue(this.hue()+r)},r.prototype.alpha=function(r){return"number"==typeof r?w({r:(t=this.rgba).r,g:t.g,b:t.b,a:r}):n(this.rgba.a,3);var t},r.prototype.hue=function(r){var t=c(this.rgba);return"number"==typeof r?w({h:r,s:t.s,l:t.l,a:t.a}):n(t.h)},r.prototype.isEqual=function(r){return this.toHex()===w(r).toHex()},r}(),w=function(r){return r instanceof j?r:new j(r)},S=[],k=function(r){r.forEach(function(r){S.indexOf(r)<0&&(r(j,y),S.push(r))})},E=function(){return new j({r:255*Math.random(),g:255*Math.random(),b:255*Math.random()})};

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/colord/plugins/lch.mjs
var lch_r={grad:.9,turn:360,rad:360/(2*Math.PI)},lch_t=function(r){return"string"==typeof r?r.length>0:"number"==typeof r},lch_a=function(r,t,a){return void 0===t&&(t=0),void 0===a&&(a=Math.pow(10,t)),Math.round(a*r)/a+0},lch_n=function(r,t,a){return void 0===t&&(t=0),void 0===a&&(a=1),r>a?a:r>t?r:t},lch_u=function(r){var t=r/255;return t<.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)},lch_h=function(r){return 255*(r>.0031308?1.055*Math.pow(r,1/2.4)-.055:12.92*r)},lch_o=96.422,lch_e=100,lch_c=82.521,lch_i=function(r){var t,a,u={x:.9555766*(t=r).x+-.0230393*t.y+.0631636*t.z,y:-.0282895*t.x+1.0099416*t.y+.0210077*t.z,z:.0122982*t.x+-.020483*t.y+1.3299098*t.z};return a={r:lch_h(.032404542*u.x-.015371385*u.y-.004985314*u.z),g:lch_h(-.00969266*u.x+.018760108*u.y+41556e-8*u.z),b:lch_h(556434e-9*u.x-.002040259*u.y+.010572252*u.z),a:r.a},{r:lch_n(a.r,0,255),g:lch_n(a.g,0,255),b:lch_n(a.b,0,255),a:lch_n(a.a)}},lch_l=function(r){var t=lch_u(r.r),a=lch_u(r.g),h=lch_u(r.b);return function(r){return{x:lch_n(r.x,0,lch_o),y:lch_n(r.y,0,lch_e),z:lch_n(r.z,0,lch_c),a:lch_n(r.a)}}(function(r){return{x:1.0478112*r.x+.0228866*r.y+-.050127*r.z,y:.0295424*r.x+.9904844*r.y+-.0170491*r.z,z:-.0092345*r.x+.0150436*r.y+.7521316*r.z,a:r.a}}({x:100*(.4124564*t+.3575761*a+.1804375*h),y:100*(.2126729*t+.7151522*a+.072175*h),z:100*(.0193339*t+.119192*a+.9503041*h),a:r.a}))},lch_f=216/24389,lch_b=24389/27,lch_d=function(r){return{l:lch_n(r.l,0,100),c:r.c,h:(t=r.h,(t=isFinite(t)?t%360:0)>0?t:t+360),a:r.a};var t},lch_p=function(r){return{l:lch_a(r.l,2),c:lch_a(r.c,2),h:lch_a(r.h,2),a:lch_a(r.a,3)}},lch_v=function(r){var a=r.l,n=r.c,u=r.h,h=r.a,o=void 0===h?1:h;if(!lch_t(a)||!lch_t(n)||!lch_t(u))return null;var e=lch_d({l:Number(a),c:Number(n),h:Number(u),a:Number(o)});return lch_M(e)},lch_y=function(r){var t=function(r){var t=lch_l(r),a=t.x/lch_o,n=t.y/lch_e,u=t.z/lch_c;return a=a>lch_f?Math.cbrt(a):(lch_b*a+16)/116,{l:116*(n=n>lch_f?Math.cbrt(n):(lch_b*n+16)/116)-16,a:500*(a-n),b:200*(n-(u=u>lch_f?Math.cbrt(u):(lch_b*u+16)/116)),alpha:t.a}}(r),n=lch_a(t.a,3),u=lch_a(t.b,3),h=Math.atan2(u,n)/Math.PI*180;return{l:t.l,c:Math.sqrt(n*n+u*u),h:h<0?h+360:h,a:t.alpha}},lch_M=function(r){return t={l:r.l,a:r.c*Math.cos(r.h*Math.PI/180),b:r.c*Math.sin(r.h*Math.PI/180),alpha:r.a},n=t.a/500+(a=(t.l+16)/116),u=a-t.b/200,lch_i({x:(Math.pow(n,3)>lch_f?Math.pow(n,3):(116*n-16)/lch_b)*lch_o,y:(t.l>8?Math.pow((t.l+16)/116,3):t.l/lch_b)*lch_e,z:(Math.pow(u,3)>lch_f?Math.pow(u,3):(116*u-16)/lch_b)*lch_c,a:t.alpha});var t,a,n,u},lch_x=/^lch\(\s*([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)\s+([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,lch_s=function(t){var a=lch_x.exec(t);if(!a)return null;var n,u,h=lch_d({l:Number(a[1]),c:Number(a[2]),h:(n=a[3],u=a[4],void 0===u&&(u="deg"),Number(n)*(lch_r[u]||1)),a:void 0===a[5]?1:Number(a[5])/(a[6]?100:1)});return lch_M(h)};/* harmony default export */ function lch(r,t){r.prototype.toLch=function(){return lch_p(lch_y(this.rgba))},r.prototype.toLchString=function(){return r=lch_p(lch_y(this.rgba)),t=r.l,a=r.c,n=r.h,(u=r.a)<1?"lch("+t+"% "+a+" "+n+" / "+u+")":"lch("+t+"% "+a+" "+n+")";var r,t,a,n,u},t.string.push([lch_s,"lch"]),t.object.push([lch_v,"lch"])}

// EXTERNAL MODULE: ../../node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__(98621);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapCard/utils/darkenColor.js



k([lch]);
function darkenColor(baseColor, { contrast = 4.5, minimumLightnessDistance = 0, } = {}) {
    const colorToTransform = baseColor.startsWith('#')
        ? baseColor
        : `#${baseColor}`;
    const color = w(colorToTransform).toLch();
    const l = color.l;
    if (Number.isNaN(l)) {
        throw new Error(`couldn't parse color "${color}"`);
    }
    while (color.l > 0 && getContrast(w(color).toHex()) < contrast) {
        color.l -= 1;
    }
    if (l - color.l < minimumLightnessDistance) {
        color.l = l - minimumLightnessDistance;
    }
    return w(color).toHex();
}
function getContrast(color) {
    const contrastColor = '#fffdf9';
    return (0,tinycolor.readability)(color, contrastColor);
}
//# sourceMappingURL=darkenColor.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Shadows.js
var Shadows = __webpack_require__(10391);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Heading/Heading.js
var Heading = __webpack_require__(28067);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Avatar/Avatar.js
var Avatar = __webpack_require__(41273);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(46688);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Link/Link.js + 1 modules
var Link = __webpack_require__(36394);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/withModifier.js
var withModifier = __webpack_require__(52676);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Menu/MenuItem.js



const Styles = (0,labelStyles/* labelStyles */.B)('MenuItem', {
    content: (props) => [
        Object.assign(Object.assign({}, Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium), { alignItems: 'center', borderRadius: 3, color: Colors/* Colors.neutral700 */.w.neutral700, display: 'flex', height: 44, lineHeight: '44px', padding: '0 10px', textDecoration: 'none', outline: 'none', width: '100%', '&:not([disabled]):hover, &:not([disabled]):focus': {
                backgroundColor: Colors/* Colors.blue10 */.w.blue10,
                color: Colors/* Colors.blue */.w.blue,
                fontWeight: props.isSelected ? 600 : 500,
            }, '&[disabled]': {
                color: Colors/* Colors.neutral500 */.w.neutral500,
                cursor: 'not-allowed',
            } }),
        props.isSelected &&
            (0,withModifier/* withModifier */.Q)('selected', {
                backgroundColor: Colors/* Colors.neutral200 */.w.neutral200,
                fontWeight: 600,
            }),
    ],
    text: {
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
const MenuItem = (props) => {
    const Tag = props.href && !props.disabled ? Link/* Link */.r : 'button';
    const isLink = Tag === Link/* Link */.r;
    const ariaLabel = props.isSelected
        ? `${props.ariaLabel || props.children}, selected`
        : props.ariaLabel;
    const conditionalProps = isLink
        ? {
            ariaLabel,
            href: props.href,
        }
        : {
            'aria-label': ariaLabel,
            type: 'button',
            disabled: props.disabled,
        };
    const liRole = props.role ? { role: 'none' } : null;
    return ((0,isolateComponent/* isolateComponent */.U)("li", Object.assign({}, liRole),
        (0,isolateComponent/* isolateComponent */.U)(Tag, Object.assign({}, conditionalProps, { component: isLink ? props.component : undefined, color: isLink ? null : undefined, css: Styles.content(props), href: props.href, onClick: props.onClick, role: props.role }),
            (0,isolateComponent/* isolateComponent */.U)("span", { css: Styles.text }, props.children))));
};
//# sourceMappingURL=MenuItem.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/formatAriaAttrKeys.js
var formatAriaAttrKeys = __webpack_require__(95945);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Menu/Menu.js


const Menu_Styles = (0,labelStyles/* labelStyles */.B)('Menu', {
    root: {
        overflow: 'auto',
    },
});
const Menu = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("ul", Object.assign({ css: Menu_Styles.root, role: props.role }, (0,formatAriaAttrKeys/* kebabCaseAriaAttrs */.v)(props)), props.children));
};
//# sourceMappingURL=Menu.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/TagLabel/Styles.js



const Styles_Styles = (0,labelStyles/* labelStyles */.B)('TagLabel', {
    root: emotion_react_browser_esm/* css */.iv `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 30px;
    ${Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold};

    &[data-size='small'] {
      height: auto;
      padding: 0 8px;
    }

    &[data-size='medium'] {
      height: auto;
      padding: 3px 8px;
    }

    &[data-color='gray'] {
      background-color: ${Colors/* Colors.neutral700 */.w.neutral700};
      color: ${Colors/* Colors.neutral100 */.w.neutral100};
    }

    &[data-color='white'] {
      background-color: ${Colors/* Colors.neutral100 */.w.neutral100};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='info'] {
      background-color: ${Colors/* Colors.blue10 */.w.blue10};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='success'] {
      background-color: ${Colors/* Colors.success100 */.w.success100};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='warning'] {
      background-color: ${Colors/* Colors.warning100 */.w.warning100};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='error'] {
      background-color: ${Colors/* Colors.error100 */.w.error100};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='peach'] {
      background-color: ${Colors/* Colors.peach */.w.peach};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='neutral300'] {
      background-color: ${Colors/* Colors.neutral300 */.w.neutral300};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='bolt'] {
      background-color: ${Colors/* Colors.bolt */.w.bolt};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='cream'] {
      background-color: ${Colors/* Colors.cream */.w.cream};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }

    &[data-color='success500'] {
      background-color: ${Colors/* Colors.success500 */.w.success500};
      color: ${Colors/* Colors.neutral100 */.w.neutral100};
    }
  `,
});
//# sourceMappingURL=Styles.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/TagLabel/TagLabel.js


const defaultProps = {
    color: 'gray',
    size: 'medium',
};
const TagLabel = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Styles_Styles.root, "data-color": props.color, "data-size": props.size }, props.children));
};
//# sourceMappingURL=TagLabel.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useZdsColor.js

const isCustomProperty = (color) => {
    return color === null || color === void 0 ? void 0 : color.startsWith('var(');
};
const getCustomPropertyValue = (color) => {
    const maybeColorArray = color.split(/[\s, (\s )]+/);
    const maybeColor = Array.isArray(maybeColorArray)
        ? maybeColorArray[1]
        : color;
    const computedStyle = getComputedStyle(document.documentElement).getPropertyValue(maybeColor);
    const fallbackColor = maybeColorArray.length === 4 ? maybeColorArray[2] : '#ffffff';
    return computedStyle.length > 0 ? computedStyle : fallbackColor;
};
const getColor = (color) => {
    return color && isCustomProperty(color)
        ? getCustomPropertyValue(color)
        : color;
};
const useZdsColor = (color) => {
    const [transformedColor, setTransformedColor] = (0,react.useState)(color);
    (0,react.useEffect)(() => {
        setTransformedColor(getColor(color));
    }, [color]);
    return transformedColor;
};
//# sourceMappingURL=useZdsColor.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useClickOutside.js
var useClickOutside = __webpack_require__(37168);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/TooltipWrapper/TooltipWrapper.js + 1 modules
var TooltipWrapper = __webpack_require__(87593);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIcon/ServiceIcon.js
var ServiceIcon = __webpack_require__(64476);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIcon/constants.js
var constants = __webpack_require__(41717);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIconShell/ServiceIconShell.js
var ServiceIconShell = __webpack_require__(35788);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIcons/ServiceIconNumeric.js



const fontSizeMapping = (size, text) => {
    switch (size) {
        case 20:
            return 10;
        case 30:
            return text > 9 ? 12 : 16;
        case 40:
            return text > 9 ? 16 : 18;
        case 60:
            return text > 9 ? 18 : 24;
        case 80:
            return 32;
        case 120:
            return 48;
        case 150:
            return 60;
        default:
            return 16;
    }
};
const typography = {
    30: Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold,
    40: Typography/* Typography.paragraph1Bold */.ZT.paragraph1Bold,
    60: Typography/* Typography.subHeader1Bold */.ZT.subHeader1Bold,
};
const ServiceIconNumeric_Styles = (0,labelStyles/* labelStyles */.B)('ServiceIconNumeric', {
    number: (fontSize, iconSize) => (Object.assign(Object.assign({}, typography[iconSize]), { fontSize, color: Colors/* Colors.neutral800 */.w.neutral800, textIndent: -2 })),
});
const ServiceIconNumeric = (props) => {
    const { size, hasBorder = true, hasWhiteBackground } = props;
    const label = `Plus ${props.number} more apps.`;
    const fontSize = fontSizeMapping(size, props.number);
    const text = props.number > 99 ? `99+` : `+${props.number}`;
    return ((0,isolateComponent/* isolateComponent */.U)(ServiceIconShell/* ServiceIconShell */.e, { size: size, hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground },
        (0,isolateComponent/* isolateComponent */.U)("span", { "aria-label": label, css: ServiceIconNumeric_Styles.number(fontSize, size), role: "img" },
            (0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": "true" }, text))));
};
//# sourceMappingURL=ServiceIconNumeric.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIcons/ServiceIcons.js





const ServiceIcons_Styles = (0,labelStyles/* labelStyles */.B)('ServiceIcons', {
    root: (iconSpacing) => emotion_react_browser_esm/* css */.iv `
    display: inline-grid;
    user-select: none;
    grid-gap: ${iconSpacing}px;
    grid-auto-flow: column;
  `,
});
const ServiceIcons = (props) => {
    const { maxServices, services, size, renderServiceIcon, hasBorder = true, hasWhiteBackground = false, } = props;
    const { spacing } = constants/* ServiceIconConfig */.G[size];
    const label = props.ariaLabel || `${services.length} apps mentioned`;
    const hasExtraServices = services.length > maxServices;
    const numServicesHidden = hasExtraServices
        ? services.length - maxServices + 1
        : 0;
    const numServicesShown = hasExtraServices ? maxServices - 1 : services.length;
    let visibleServices = [];
    if (numServicesShown === 1) {
        visibleServices = [services[0]];
    }
    else if (numServicesShown >= 2) {
        visibleServices = [
            ...services.slice(0, numServicesShown - 1),
            services[services.length - 1],
        ];
    }
    const icons = visibleServices.map((service, idx) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: idx }, renderServiceIcon(service, props))));
    if (hasExtraServices) {
        const hiddenServicesCountIcon = ((0,isolateComponent/* isolateComponent */.U)("li", { key: `remainder-${numServicesHidden}` },
            (0,isolateComponent/* isolateComponent */.U)(ServiceIconNumeric, { size: size, number: numServicesHidden, hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground })));
        if (maxServices > 2)
            icons.splice(-1, 0, hiddenServicesCountIcon);
        else
            icons.push(hiddenServicesCountIcon);
    }
    return ((0,isolateComponent/* isolateComponent */.U)("ul", { "aria-label": label, css: ServiceIcons_Styles.root(spacing) }, icons));
};
function defaultRenderServiceIcon({ name, src }, { size, hasBorder, hasWhiteBackground }) {
    return ((0,isolateComponent/* isolateComponent */.U)(ServiceIcon/* ServiceIcon */.A, { serviceName: name, size: size, src: src, hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground }));
}
ServiceIcons.defaultProps = {
    hasBorder: true,
    maxServices: 6,
    renderServiceIcon: defaultRenderServiceIcon,
    size: 40,
};
//# sourceMappingURL=ServiceIcons.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapCard/useResizeObserver.js

const useResizeObserver = () => {
    const ref = (0,react.useRef)(null);
    const [width, setWidth] = (0,react.useState)(0);
    const [height, setHeight] = (0,react.useState)(0);
    (0,react.useEffect)(() => {
        const node = ref.current;
        let observer;
        try {
            observer = new ResizeObserver((entries) => {
                const lastEntry = entries.pop();
                if (lastEntry) {
                    const contentRect = Array.isArray(lastEntry.contentRect)
                        ? lastEntry.contentRect[0]
                        : lastEntry.contentRect;
                    setWidth(contentRect.width);
                    setHeight(contentRect.height);
                }
            });
            observer.observe(node);
        }
        catch (e) { }
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    });
    return {
        ref,
        width,
        height,
    };
};
//# sourceMappingURL=useResizeObserver.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/Button.js
var Button = __webpack_require__(20110);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapCard/ZapCardCTA.js






const ZapCardCTA = (props) => {
    const { computedState, ariaHidden, href, isLink, target } = props;
    const ctaBody = isLink ? ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: ZapCard_Styles.ctaLink(computedState), href: href, target: target, tabIndex: ariaHidden ? -1 : undefined },
            "Try it",
            (0,isolateComponent/* isolateComponent */.U)("span", { css: ZapCard_Styles.ctaIcon(computedState) },
                (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: "arrowBigRight", size: 24 }))))) : ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { href: props.href, target: target, tabIndex: ariaHidden ? -1 : undefined, size: "small" }, "Try it"));
    return ((0,isolateComponent/* isolateComponent */.U)("div", { "aria-hidden": ariaHidden, css: ZapCard_Styles.ctaArea(computedState, props) }, ctaBody));
};
//# sourceMappingURL=ZapCardCTA.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapCard/ZapCard.js
















const DEFAULT_COLOR = '#fffdf9';
const isDefaultColor = (color) => {
    return color === DEFAULT_COLOR;
};
const getDefaultComputedColors = () => ({
    backgroundColor: DEFAULT_COLOR,
    backgroundColorDark: 'rgb(0, 0, 0, 0.25)',
});
const getComputedColors = (color) => {
    if (isDefaultColor(color) || !color) {
        return getDefaultComputedColors();
    }
    try {
        return {
            backgroundColor: darkenColor(color, { contrast: 3 }),
            backgroundColorDark: darkenColor(color, {
                contrast: 4.5,
                minimumLightnessDistance: 10,
            }),
        };
    }
    catch (err) {
        return getDefaultComputedColors();
    }
};
const hasMenu = (props) => {
    return (props.menuItems || []).length > 0;
};
const CARD_MAX_WIDTH = 375;
const SMALL_LINE_MAX_WIDTH = 770;
const MEDIUM_LINE_MAX_WIDTH = 615;
const ANIMATION_TRANSITION_VALUE = 'all 150ms ease-in-out';
const isCardLayout = (computedState) => {
    return computedState.layout === 'card';
};
const isLineLayout = (computedState) => {
    return computedState.layout === 'line';
};
const isMegaLayout = (computedState) => {
    return computedState.layout === 'mega';
};
const isCardLayoutWidth = (computedState) => {
    return computedState.width <= CARD_MAX_WIDTH;
};
const isWideLayoutWidth = (computedState) => computedState.width > SMALL_LINE_MAX_WIDTH;
const isMediumLineLayoutWidth = (computedState) => {
    return (computedState.width > CARD_MAX_WIDTH &&
        computedState.width <= MEDIUM_LINE_MAX_WIDTH);
};
const isLargeLineLayoutWidth = (computedState) => {
    return computedState.width > MEDIUM_LINE_MAX_WIDTH;
};
const computeLineLayoutGrid = (computedState, props) => {
    if (isLargeLineLayoutWidth(computedState)) {
        return emotion_react_browser_esm/* css */.iv `
      grid-template-columns: max-content max-content 1fr max-content max-content max-content;
      grid-template-areas:
        'services title title title label cta menu'
        '.        ${props.authorName
            ? 'author'
            : 'meta'}  meta  meta   meta     .   .';
    `;
    }
    return emotion_react_browser_esm/* css */.iv `
    grid-template-columns: max-content 1fr max-content;
    grid-template-areas: 'services title cta';
  `;
};
const isCardOrMegaLayout = (computedState) => {
    return isCardLayout(computedState) || isMegaLayout(computedState);
};
const shouldBeColored = (computedState) => {
    return (isCardOrMegaLayout(computedState) &&
        !isDefaultColor(computedState.backgroundColor));
};
const StyleVars = {
    cardPadding: '20px',
    cardHeaderHeight: '40px',
    cardFooterHeight: '55px',
    megaPaddingLeft: '30px',
    megaPaddingTop: '38px',
    servicesHeight: '40px',
    servicesHeightMegaCard: '60px',
};
const centerLineCardStyles = emotion_react_browser_esm/* css */.iv `
  display: flex;
  align-items: center;
  min-height: ${StyleVars.servicesHeight};
`;
const ZapCard_Styles = (0,labelStyles/* labelStyles */.B)('ZapCard', {
    root: (props, computedState) => [
        emotion_react_browser_esm/* css */.iv `
      min-width: 270px;
    `,
        (isCardOrMegaLayout(computedState) ||
            (isLineLayout(computedState) &&
                isMediumLineLayoutWidth(computedState))) &&
            (hasMenu(props) || props.authorName) &&
            emotion_react_browser_esm/* css */.iv `
        padding-top: ${StyleVars.cardHeaderHeight};
      `,
    ],
    inner: (computedState, props) => [
        !shouldBeColored(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        border: 1px solid ${Colors/* Colors.neutral300 */.w.neutral300};
      `,
        emotion_react_browser_esm/* css */.iv `
      position: relative;
      box-shadow: none;
      transition: box-shadow 150ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};
      border-radius: 5px;
      background-color: ${DEFAULT_COLOR};
      // Default to undefined.
      --ZapCard-text-color: ${Colors/* Colors.neutral800 */.w.neutral800};

      // This is the overlay and footer background color. A pseudo
      // element is used to facilitate using CSS Grid for the disparate
      // values for the 'layout' prop.
      &::before {
        pointer-events: none;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        transition: ${ANIMATION_TRANSITION_VALUE};
      }

      &::after {
        opacity: 0;
        content: '';
        position: absolute;
        inset: -1px;
        border-radius: 4px;
        transition: opacity 150ms ease-in-out;
      }
      @media (hover: hover) {
        &:hover,
        &:focus-within {
          box-shadow: ${Shadows/* Shadows.elevation5 */.f.elevation5};
        }
      }
    `,
        props.shouldOverlayLink &&
            emotion_react_browser_esm/* css */.iv `
        &:after {
          border: 2px solid ${Colors/* Colors.blue */.w.blue};
        }
      `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        --ZapCard-cta-color: ${Colors/* Colors.neutral600 */.w.neutral600};
        --ZapCard-cta-opacity: 0;
        @media (hover: hover) {
          &:hover,
          &:focus-within {
            --ZapCard-cta-color: ${Colors/* Colors.blue */.w.blue};
            --ZapCard-cta-opacity: 1;
          }
        }

        &::before {
          height: ${StyleVars.cardFooterHeight};
          border-radius: 0 0 4px 4px;
          background-color: ${Colors/* Colors.neutral200 */.w.neutral200};
        }

        @media (hover: hover) {
          &:hover::before,
          &:focus-within::before {
            background-color: ${Colors/* Colors.blue10 */.w.blue10};
          }
          &:focus-within::after {
            opacity: 1;
          }
        }
      `,
        shouldBeColored(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        --ZapCard-cta-color: ${Colors/* Colors.neutral100 */.w.neutral100};
        --ZapCard-text-color: ${Colors/* Colors.neutral100 */.w.neutral100};
        background-color: ${computedState.backgroundColor};

        &::before {
          background-color: ${computedState.backgroundColorDark};
        }

        @media (hover: hover) {
          &:hover,
          &:focus-within {
            --ZapCard-cta-color: ${Colors/* Colors.neutral100 */.w.neutral100};
          }

          &:hover,
          &:focus-within {
            box-shadow: ${Shadows/* Shadows.elevation10 */.f.elevation10};
          }

          &:hover::before,
          &:focus-within::before {
            background-color: ${computedState.backgroundColorDark};
          }
          &:focus-within::after {
            border: 2px solid ${computedState.backgroundColorDark};
          }
        }
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        &::before {
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          border-radius: inherit;
        }
        @media (hover: hover) {
          &:hover::before,
          &:focus-within::before {
            background-color: ${Colors/* Colors.blue10 */.w.blue10};
          }
        }
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        div div div span[data-color] {
          transition: ${ANIMATION_TRANSITION_VALUE};
        }

        @media (hover: hover) {
          &:hover,
          &:focus-within {
            div div div span[data-color] {
              background-color: ${Colors/* Colors.neutral100 */.w.neutral100};
            }
          }
          &:focus-within::after {
            opacity: 1;
          }
        }
      `,
        isLineLayout(computedState) &&
            computedState.isExpanded &&
            emotion_react_browser_esm/* css */.iv `
        &::before {
          content: '';
          display: none;
        }
      `,
    ],
    layout: (computedState, props) => [
        emotion_react_browser_esm/* css */.iv `
      display: grid;
      position: relative;
    `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -card;
        min-height: 219px;
        grid-template-columns: 1fr max-content;
        grid-template-rows: ${StyleVars.servicesHeight} 1fr ${StyleVars.cardFooterHeight};
        gap: 10px;
        align-items: center;
        grid-template-areas:
          'services label'
          'title title'
          'meta cta';
        padding: ${StyleVars.cardPadding} ${StyleVars.cardPadding} 0;
      `,
        isMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -mega;
        min-height: 345px;
        padding: ${StyleVars.megaPaddingTop} ${StyleVars.cardPadding} 0
          ${StyleVars.megaPaddingLeft};
        grid-template-rows: ${StyleVars.servicesHeightMegaCard} 1fr ${StyleVars.cardFooterHeight};
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -line;
        ${computeLineLayoutGrid(computedState, props)}
        gap: 2px 20px;
        align-items: center;
        min-height: 80px;
        padding: ${StyleVars.cardPadding};
      `,
    ],
    titleArea: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      grid-area: title;
    `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${centerLineCardStyles}
        align-items: inherit;
      `,
    ],
    title: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      ${Typography/* Typography.subHeader3Bold */.ZT.subHeader3Bold};
      color: var(--ZapCard-text-color, ${Colors/* Colors.neutral800 */.w.neutral800});
      // All of the properties below this are necessary
      // for line clamping to work. Even though the properties
      // have 'webkit' in them, they work cross-browser.
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      resize: none;
    `,
        isMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        -webkit-line-clamp: 5;
      `,
        isMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${isWideLayoutWidth(computedState)
                ? Typography/* Typography.pageHeader7 */.ZT.pageHeader7
                : Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold}
      `,
    ],
    link: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
    display: block;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
  `,
    ctaArea: (computedState, props) => [
        emotion_react_browser_esm/* css */.iv `
      grid-area: cta;
      color: var(--ZapCard-text-color, var(--ZapCard-cta-color));
      position: relative;
      z-index: 3;
    `,
        isCardOrMegaLayout(computedState) && [
            emotion_react_browser_esm/* css */.iv `
        display: grid;
        grid-template-columns: max-content max-content;
        justify-content: end;
        align-items: center;
        transition: ${ANIMATION_TRANSITION_VALUE};
      `,
            props.shouldOverlayLink &&
                emotion_react_browser_esm/* css */.iv `
          // Entire card is clickable; let these events "bleed through."
          pointer-events: none;
        `,
        ],
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${centerLineCardStyles};
      `,
    ],
    ctaLink: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      display: flex;
      align-items: center;
      ${Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold};
      color: var(--ZapCard-cta-color);
      transition: ${ANIMATION_TRANSITION_VALUE};
      text-decoration: none;
      outline: 1px solid transparent;
      gap: 10px;
      transition: all 150ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};

      // Balances out CTA right arrow icon, which
      // has 3px padding-right built in to the SVG
      padding-left: 3px;

      &:focus {
        transition: all 300ms ease-in-out;
        outline-color: ${Colors/* Colors.blueJeans */.w.blueJeans};
      }

      &:focus,
      &:hover {
        color: ${Colors/* Colors.night */.w.night};
      }
    `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        color: var(--ZapCard-cta-color);
      `,
        isMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold};
      `,
    ],
    ctaIcon: (computedState) => [
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        display: none;
      `,
    ],
    menuArea: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      position: relative;
      z-index: 4;
    `,
        computedState.isMenuOpen &&
            emotion_react_browser_esm/* css */.iv `
        z-index: 5;
      `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -card;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 100%;
        right: 0px;
        height: ${StyleVars.cardHeaderHeight};
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -line;
        grid-area: menu;
        // Tighten gutter
        margin-left: -10px;
        ${centerLineCardStyles};
      `,
        isLineLayout(computedState) &&
            isMediumLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 100%;
        right: 0px;
        height: ${StyleVars.cardHeaderHeight};
      `,
    ],
    menuToggle: emotion_react_browser_esm/* css */.iv `
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors/* Colors.neutral600 */.w.neutral600};
    &:hover,
    &:focus,
    &[aria-expanded='true'] {
      color: ${Colors/* Colors.blue */.w.blue};
    }
  `,
    menu: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      position: absolute;
      width: 270px;
      background: ${Colors/* Colors.neutral100 */.w.neutral100};
      border: 1px solid ${Colors/* Colors.neutral400 */.w.neutral400};
      border-radius: 3px;
      box-shadow: ${Shadows/* Shadows.elevation20 */.f.elevation20};
      // Subtract a pixel to ensure card coverage.
      top: calc(100% - 1px);
      right: -1px;
    `,
        isLineLayout(computedState) &&
            isLargeLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        top: 100%;
        right: calc(-${StyleVars.cardPadding} - 1px);
      `,
    ],
    menuInner: emotion_react_browser_esm/* css */.iv `
    padding: 10px;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
  `,
    menuItemInner: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 8px;
    align-items: center;
  `,
    menuItemText: emotion_react_browser_esm/* css */.iv `
    overflow: hidden;
    text-overflow: ellipsis;
  `,
    labelArea: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      display: flex;
      grid-area: label;
      position: relative;
      z-index: 3;
      gap: 10px;
      align-items: center;
    `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        text-align: right;
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        ${centerLineCardStyles};
        gap: 20px;
      `,
        isLineLayout(computedState) &&
            isMediumLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        display: none;
      `,
    ],
    servicesArea: [
        emotion_react_browser_esm/* css */.iv `
      grid-area: services;
      position: relative;
      z-index: 3;
      align-self: baseline;
    `,
    ],
    metaInfoArea: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      grid-area: meta;
      ${Typography/* Typography.smallPrint3Bold */.ZT.smallPrint3Bold};
      font-size: 14px;
      line-height: 20px;
      color: var(--ZapCard-text-color, ${Colors/* Colors.neutral800 */.w.neutral800});
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `,
        isMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        font-size: 16px;
        line-height: 22px;
      `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        pointer-events: none;
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        line-height: 20px;
      `,
        isLineLayout(computedState) &&
            isMediumLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        display: none;
      `,
    ],
    authorArea: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1};
      gap: 10px;
    `,
        isCardOrMegaLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -card;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 100%;
        left: 0px;
        height: ${StyleVars.cardHeaderHeight};
      `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        label: -line;
        grid-area: author;
        ${centerLineCardStyles};
      `,
        isLineLayout(computedState) &&
            isLargeLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        gap: 5px;
        font-size: 14px;
        min-height: auto;
        position: relative;

        // Simple but somewhat magical way to add middot.
        // Gets the job done, but might refactor if more
        // of these middot separators are needed later.
        &:not(:empty)::after {
          content: '•';
          position: absolute;
          font-size: 16px;
          right: -14px;
          bottom: 2px;
          opacity: 0.4;
        }
      `,
        isLineLayout(computedState) &&
            isMediumLineLayoutWidth(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 100%;
        left: 0px;
        height: ${StyleVars.cardHeaderHeight};
      `,
    ],
    authorContent: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      display: grid;
      grid-template-columns: min-content 1fr;
      gap: inherit;
      align-items: center;
      color: ${Colors/* Colors.neutral700 */.w.neutral700};
    `,
        emotion_react_browser_esm/* css */.iv `
      position: relative;
      z-index: ${isLineLayout(computedState) &&
            !isMediumLineLayoutWidth(computedState)
            ? 3
            : 4};
    `,
    ],
    authorByline: (computedState) => [
        emotion_react_browser_esm/* css */.iv `
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 22ch;
    `,
        isLineLayout(computedState) &&
            emotion_react_browser_esm/* css */.iv `
        max-width: 15ch;
      `,
    ],
    authorName: emotion_react_browser_esm/* css */.iv `
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    font-weight: 700;
  `,
    summary: emotion_react_browser_esm/* css */.iv `
    display: block;
    cursor: pointer;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
  `,
    detailsContent: emotion_react_browser_esm/* css */.iv `
    position: relative;
    z-index: 3;
    padding: 0 20px 20px;
  `,
    detailsHref: emotion_react_browser_esm/* css */.iv `
    z-index: 3;
  `,
});
const ZapCard_defaultProps = {
    hrefTarget: '_self',
    layout: 'auto',
    menuItems: [],
    renderAuthor: (props, computedState) => {
        if (!props.authorName) {
            return null;
        }
        const [first, ...rest] = props.authorName.split(/\s+/);
        const last = rest.pop();
        const lastInitial = last ? `${last[0]}.` : '';
        const name = `${first} ${lastInitial}`.trim();
        const author = ((0,isolateComponent/* isolateComponent */.U)("p", { "aria-hidden": true, css: ZapCard_Styles.authorByline(computedState) },
            "by ",
            (0,isolateComponent/* isolateComponent */.U)("span", { css: ZapCard_Styles.authorName }, name)));
        return ((0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": `by ${props.authorName}`, css: ZapCard_Styles.authorContent(computedState) },
            (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { ariaHidden: true, isBlock: true, name: props.authorName, size: isLineLayout(computedState) && isLargeLineLayoutWidth(computedState)
                    ? 18
                    : 25, url: props.authorAvatarUrl }),
            (0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: props.authorName, position: "southwest", shouldCorrectPosition: false }, () => author)));
    },
    renderLabel: (props, computedState) => {
        const color = shouldBeColored(computedState) ? 'white' : 'info';
        return (props.label && ((0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: props.labelTooltip, position: "southeast", shouldCorrectPosition: false }, () => (0,isolateComponent/* isolateComponent */.U)(TagLabel, { color: color }, props.label))));
    },
    renderMenu: (props, computedState, { closeMenu }) => {
        var _a, _b;
        const hasDetailsMenuItem = props.detailsLink &&
            isLineLayout(computedState) &&
            isMediumLineLayoutWidth(computedState);
        if (!hasDetailsMenuItem && !hasMenu(props)) {
            return null;
        }
        const renderMenuItem = (item) => {
            const onClick = (e) => {
                item.onClick && item.onClick(e, item);
                closeMenu();
            };
            const icon = item.icon && (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: item.icon, size: 24 });
            return ((0,isolateComponent/* isolateComponent */.U)(MenuItem, { href: item.href, key: item.text, onClick: onClick },
                (0,isolateComponent/* isolateComponent */.U)("span", { css: ZapCard_Styles.menuItemInner },
                    icon,
                    (0,isolateComponent/* isolateComponent */.U)("span", { css: ZapCard_Styles.menuItemText }, item.text))));
        };
        const items = ((_a = props.menuItems) !== null && _a !== void 0 ? _a : []).map(renderMenuItem);
        return ((0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.menu(computedState) },
            (0,isolateComponent/* isolateComponent */.U)(Menu, { ariaLabel: "Zap options" },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.menuInner },
                    items,
                    hasDetailsMenuItem &&
                        renderMenuItem({
                            text: 'See Zap details',
                            icon: 'miscList',
                            href: (_b = props.detailsLink) === null || _b === void 0 ? void 0 : _b.href,
                            onClick: (e) => { var _a; return (_a = props.detailsLink) === null || _a === void 0 ? void 0 : _a.onClick(e, computedState); },
                        })))));
    },
    renderMetaInfo: (props, computedState) => {
        if (props.metaInfo) {
            return props.metaInfo;
        }
        const truncatedServices = computedState.uniqueServices.slice(0, 3);
        const countDiff = computedState.uniqueServices.length - truncatedServices.length;
        return [...truncatedServices, countDiff > 0 && `${countDiff} more`]
            .filter(Boolean)
            .join(' + ');
    },
    shouldOverlayLink: true,
};
const ZapCard = (_props) => {
    const colorValue = useZdsColor(_props.color || DEFAULT_COLOR);
    const props = Object.assign(Object.assign(Object.assign({}, ZapCard_defaultProps), _props), { color: colorValue });
    const [isMenuOpen, setIsMenuOpen] = (0,react.useState)(false);
    const closeMenu = () => setIsMenuOpen(false);
    const [setMenuOutsideClickNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: closeMenu,
    });
    let menuNode = null;
    const setMenuNode = (node) => {
        menuNode = node;
        setMenuOutsideClickNode(node);
    };
    const onClick = (e) => {
        if (!menuNode || !menuNode.contains(e.target)) {
            props.onClick && props.onClick(e, computedState);
        }
    };
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const [setExpansionOutsideClickNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: () => {
            if (props.canClickOutsideToClose) {
                setIsExpanded(false);
            }
        },
    });
    const { ref, width } = useResizeObserver();
    const uniqueServices = [
        ...new Set(props.services.map((service) => {
            return service.name;
        })),
    ];
    const computedState = Object.assign(Object.assign({ isExpanded,
        isMenuOpen, layout: props.layout }, getComputedColors(colorValue)), { width,
        uniqueServices });
    computedState.layout =
        props.layout !== 'auto'
            ? props.layout
            : isCardLayoutWidth(computedState)
                ? 'card'
                : 'line';
    const canExpand = props.children && isLineLayout(computedState);
    const renderedMenu = props.renderMenu(props, computedState, { closeMenu });
    const renderedLabel = props.renderLabel(props, computedState);
    const renderedAuthor = props.renderAuthor(props, computedState);
    const renderedMetaInfo = props.renderMetaInfo(props, computedState);
    const detailsLink = props.detailsLink && ((0,isolateComponent/* isolateComponent */.U)("span", { css: ZapCard_Styles.detailsHref },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: props.detailsLink.href, onClick: (e) => { var _a; return (_a = props.detailsLink) === null || _a === void 0 ? void 0 : _a.onClick(e, computedState); } }, "Details")));
    const link = props.shouldOverlayLink &&
        (isCardLayout(computedState) || !props.children) && ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: ZapCard_Styles.link, href: props.href, target: props.hrefTarget }, props.title));
    const details = canExpand && ((0,isolateComponent/* isolateComponent */.U)("details", { css: ZapCard_Styles.details, "data-testid": "ZapCard__details", open: isExpanded },
        (0,isolateComponent/* isolateComponent */.U)("summary", { css: ZapCard_Styles.summary, onClick: (e) => {
                e.preventDefault();
                setIsExpanded(!isExpanded);
            } }, "More details"),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.detailsContent }, props.children)));
    const cta = isCardOrMegaLayout(computedState) ? ((0,isolateComponent/* isolateComponent */.U)(ZapCardCTA, { computedState: computedState, ariaHidden: !!link, href: props.href, isLink: true, shouldOverlayLink: props.shouldOverlayLink, target: props.hrefTarget })) : isLineLayout(computedState) ? ((0,isolateComponent/* isolateComponent */.U)(ZapCardCTA, { computedState: computedState, ariaHidden: !!link, href: props.href, isLink: false, shouldOverlayLink: props.shouldOverlayLink, target: props.hrefTarget })) : null;
    const serviceIconSize = isMegaLayout(computedState) ? 60 : 40;
    return ((0,isolateComponent/* isolateComponent */.U)("article", { css: ZapCard_Styles.root(props, computedState), ref: ref },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.inner(computedState, props), "data-testid": "ZapCard__inner", onClick: onClick, ref: setExpansionOutsideClickNode },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.layout(computedState, props) },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.titleArea(computedState) },
                    (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: ZapCard_Styles.title(computedState) }, props.title)),
                renderedAuthor && ((0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.authorArea(computedState) }, renderedAuthor)),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.labelArea(computedState) },
                    renderedLabel,
                    detailsLink),
                link,
                cta,
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.menuArea(computedState), ref: setMenuNode },
                    renderedMenu && ((0,isolateComponent/* isolateComponent */.U)("button", { "aria-expanded": isMenuOpen, "aria-label": "More options", css: ZapCard_Styles.menuToggle, onClick: () => setIsMenuOpen(!isMenuOpen), type: "button" },
                        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: "navMoreHoriz", size: 32 }))),
                    isMenuOpen && renderedMenu),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.servicesArea },
                    (0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { allowMultilineTooltip: true, content: uniqueServices.join(', '), position: "southwest", shouldCorrectPosition: false, tooltipId: "tooltip-zap-card" }, () => ((0,isolateComponent/* isolateComponent */.U)(ServiceIcons, { ariaLabel: `Zap uses ${uniqueServices.join(', ')}`, maxServices: 3, services: props.services, size: serviceIconSize, hasBorder: !shouldBeColored(computedState) })))),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCard_Styles.metaInfoArea(computedState) }, renderedMetaInfo)),
            details)));
};
//# sourceMappingURL=ZapCard.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapCardSection/ZapCardSection.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const ZapCardSection_Styles = (0,labelStyles/* labelStyles */.B)('ZapCardSection', {
    root: emotion_react_browser_esm/* css */.iv `
    padding: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 20px 30px;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 40px;
    }
  `,
    container: (layout) => emotion_react_browser_esm/* css */.iv `
    display: grid;
    gap: 30px;
    grid-template-columns: ${layout === 'auto'
        ? '1fr'
        : 'repeat(auto-fit, minmax(235px, 1fr))'};
    margin: 0 auto;
    max-width: 1170px;
  `,
});
const ZapCardSection = ({ items, layout = 'card' }) => {
    var _a;
    if (items.length > 3) {
        console.error('Max 3 items are allowed in ZapCardSection component');
    }
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCardSection_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ZapCardSection_Styles.container(layout) }, (_a = items === null || items === void 0 ? void 0 : items.slice(0, 3)) === null || _a === void 0 ? void 0 : _a.map((_a) => {
            var { color = Colors/* Colors.neutral100 */.w.neutral100, href } = _a, rest = __rest(_a, ["color", "href"]);
            return ((0,isolateComponent/* isolateComponent */.U)(ZapCard, Object.assign({}, rest, { color: color, href: href, layout: layout })));
        }))));
};
//# sourceMappingURL=ZapCardSection.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(47925);
// EXTERNAL MODULE: ./src/constants/responsive.ts
var responsive = __webpack_require__(95964);
// EXTERNAL MODULE: ./src/constants/colors.ts
var colors = __webpack_require__(27423);
;// CONCATENATED MODULE: ./src/components/Section/background.ts
var backgroundColors = {
    lava120: "lava120",
    lava80: "lava80",
    lava60: "lava60",
    lava40: "lava40",
    lava20: "lava20",
    lava10: "lava10",
    lava5: "lava5",
    lava: "lava",
    ocean120: "ocean120",
    ocean80: "ocean80",
    ocean60: "ocean60",
    ocean40: "ocean40",
    ocean20: "ocean20",
    ocean10: "ocean10",
    ocean5: "ocean5",
    ocean: "ocean",
    sun120: "sun120",
    sun80: "sun80",
    sun60: "sun60",
    sun40: "sun40",
    sun20: "sun20",
    sun10: "sun10",
    sun5: "sun5",
    sun: "sun",
    white: "white",
    transparent: "transparent"
};
var backgroundImages = {
    BlockyRetro: "blockyRetro.png",
    Lava20Cropped: "lava20Cropped.png",
    Sun40Cropped: "sun40Cropped.png"
};
function isBackgroundStyle(background) {
    return background === "Lava40Dotty" || background === "Sun60Dotty";
}
function mapBackgroundStyleToColor(background) {
    var backgroundStyleNames = [
        "Dotty"
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = backgroundStyleNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var color = background.split(name)[0].toLowerCase();
            if (color in backgroundColors) {
                return color;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "transparent";
}
/**
 * Narrow type predicate. Determines if is BackgroundImage
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ function isBackgroundImage(background) {
    return background in backgroundImages;
}
function getBackgroundImage(background) {
    return backgroundImages[background];
}

// EXTERNAL MODULE: ./src/components/InViewTracking/InViewTracking.tsx + 1 modules
var InViewTracking = __webpack_require__(79205);
;// CONCATENATED MODULE: ./src/components/Section/Section.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                margin-top: 10px;\n                ",
        " {\n                  ",
        ";\n                  margin-top: 20px;\n                }\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-image: url('/l/images/",
        "');\n        background-size: cover;\n        background-position: center center;\n        background-repeat: no-repeat;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        label: contentWidth-padded;\n        padding: 40px 20px;\n        ",
        " {\n          padding: 60px 30px;\n        }\n        ",
        " {\n          padding: 65px 100px;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        label: contentWidth-fullWidth;\n        padding: 50px 20px;\n        ",
        " {\n          padding: 70px 30px;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        label: contentWidth-overflow;\n\n        padding: 60px 0 60px 20px;\n        ",
        " {\n          padding: 65px 0 65px 30px;\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        label: contentWidth-custom;\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      position: absolute;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      max-width: 1350px;\n      pointer-events: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-image: url('/l/images/dotty.png');\n      background-size: cover;\n      background-position: center center;\n      background-repeat: no-repeat;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n  margin: 0 auto 0 auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  text-align: center;\n\n  ",
        " {\n    margin-bottom: 60px;\n  }\n\n  ",
        " {\n    margin-bottom: 70px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







function Section(param) {
    var _background = param.background, background = _background === void 0 ? "transparent" : _background, children = param.children, _contentWidth = param.contentWidth, contentWidth = _contentWidth === void 0 ? "padded" : _contentWidth, heading = param.heading, headingSize = param.headingSize, layerName = param.layerName, sectionToTrack = param.sectionToTrack, _style = param.style, style = _style === void 0 ? {} : _style, subheading = param.subheading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Outer, {
        as: "section",
        background: background,
        contentWidth: contentWidth,
        layerName: layerName,
        sectionName: sectionToTrack,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundLayer, {
                background: background
            }),
            heading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingsWrapper, {
                children: [
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section_Heading, {
                        background: background,
                        headingSize: headingSize,
                        children: heading
                    }),
                    subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Subheading, {
                        headingSize: headingSize,
                        background: background,
                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), responsive/* mediaQueries.tablet */.w5.tablet, Typography/* Typography.paragraph1 */.ZT.paragraph1),
                        children: subheading
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: children
            })
        ]
    });
}
var Outer = (0,emotion_styled_browser_esm/* default */.Z)(InViewTracking.InViewTracking, {
    shouldForwardProp: function(prop) {
        return prop === "as" || prop === "sectionName" || prop === "children";
    }
})(function(param) {
    var background = param.background, contentWidth = param.contentWidth;
    return [
        isBackgroundStyle(background) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), Colors/* Colors */.w[mapBackgroundStyleToColor(background)]),
        isBackgroundImage(background) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), getBackgroundImage(background)),
        !isBackgroundStyle(background) && !isBackgroundImage(background) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), Colors/* Colors */.w[background]),
        contentWidth === "padded" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject4(), responsive/* mediaQueries.tablet */.w5.tablet, responsive/* mediaQueries.desktop */.w5.desktop),
        contentWidth === "fullWidth" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject5(), responsive/* mediaQueries.tablet */.w5.tablet),
        contentWidth === "overflow" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject6(), responsive/* mediaQueries.desktop */.w5.desktop),
        contentWidth === "custom" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject7()), 
    ];
}, function(param) {
    var style = param.style;
    return (0,src_object_spread/* default */.Z)({}, style);
});
var BackgroundLayer = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var background = param.background;
    return [
        isBackgroundStyle(background) && (0,emotion_react_browser_esm/* css */.iv)(_templateObject8()),
        (background === "Lava40Dotty" || background === "Sun60Dotty") && (0,emotion_react_browser_esm/* css */.iv)(_templateObject9()), 
    ];
});
var Content = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject10());
/**
 * margin-bottom represents the spacing between the Heading(s) and Content
 */ var HeadingsWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject11(), responsive/* mediaQueries.tablet */.w5.tablet, responsive/* mediaQueries.desktop */.w5.desktop);
var Section_Heading = emotion_styled_browser_esm/* default.h2 */.Z.h2(function(param) {
    var background = param.background, headingSize = param.headingSize;
    var _obj;
    return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        maxWidth: "800px",
        margin: "0 auto"
    }, headingSize ? Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].mobile] : Typography/* Typography.sectionHeader1 */.ZT.sectionHeader1), (_obj = {
        color: background === colors/* COLOR_KEYS.zapier */.US.zapier || background === colors/* COLOR_KEYS.night */.US.night || background === colors/* COLOR_KEYS.moss */.US.moss || background === colors/* COLOR_KEYS.neutral800 */.US.neutral800 || background === colors/* COLOR_KEYS.earth */.US.earth ? Colors/* Colors.neutral100 */.w.neutral100 : Colors/* Colors.neutral800 */.w.neutral800,
        textAlign: "center",
        "&:not(:last-child)": {
            marginBottom: "0.25em"
        }
    }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, headingSize ? Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].tablet] : Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, headingSize ? Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].desktop] : Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), _obj)));
});
/**
 * margin-top represents the spacing between Heading and Subheading
 */ var Subheading = emotion_styled_browser_esm/* default.p */.Z.p(function(param) {
    var background = param.background, headingSize = param.headingSize;
    var _obj;
    return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        maxWidth: "800px",
        margin: "0 auto"
    }, headingSize ? Typography/* Typography */.ZT[responsive/* SUB_HEADING_SIZE_MAP */.Ux[headingSize].mobile] : Typography/* Typography.smallPrint1 */.ZT.smallPrint1), (_obj = {
        color: background === colors/* COLOR_KEYS.zapier */.US.zapier || background === colors/* COLOR_KEYS.night */.US.night || background === colors/* COLOR_KEYS.moss */.US.moss || background === colors/* COLOR_KEYS.neutral800 */.US.neutral800 || background === colors/* COLOR_KEYS.earth */.US.earth ? Colors/* Colors.neutral100 */.w.neutral100 : Colors/* Colors.neutral800 */.w.neutral800
    }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, headingSize ? Typography/* Typography */.ZT[responsive/* SUB_HEADING_SIZE_MAP */.Ux[headingSize].tablet] : Typography/* Typography.paragraph1 */.ZT.paragraph1)), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, headingSize ? Typography/* Typography */.ZT[responsive/* SUB_HEADING_SIZE_MAP */.Ux[headingSize].desktop] : Typography/* Typography.paragraph1 */.ZT.paragraph1)), _obj)));
});

// EXTERNAL MODULE: ./src/observability/tracking/events.ts
var events = __webpack_require__(65088);
// EXTERNAL MODULE: ./src/observability/tracking/useTrackEvent.ts + 1 modules
var useTrackEvent = __webpack_require__(22506);
// EXTERNAL MODULE: ./src/observability/tracking/avro.ts
var avro = __webpack_require__(90073);
// EXTERNAL MODULE: ./src/components/sections/ZapCardSection/ZapCardSection.transformer.ts + 2 modules
var ZapCardSection_transformer = __webpack_require__(28257);
;// CONCATENATED MODULE: ./src/components/sections/ZapCardSection/ZapCardSection.tsx








function ZapCardSection_ZapCardSection(props) {
    var ref;
    var items = (0,ZapCardSection_transformer/* useUnregisteredProps */.gs)(props).items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        background: props.background,
        contentWidth: "custom",
        layerName: (ref = props.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
        sectionToTrack: events/* SectionName.ZapCardSection */.jz.ZapCardSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCards, {
            items: items || [],
            layout: props.layout
        })
    });
}
// Have to create an inner component in order for useTrackEvent to be invoked in TrackingProvider
function ZapCards(param) {
    var items = param.items, layout = param.layout;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var zapCardItems = items.map(function(item, index) {
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
            services: item.services || [],
            color: item.color ? w(item.color).toHex() : Colors/* Colors.white */.w.white,
            key: "zap_card_".concat(index),
            onClick: function() {
                emitCTAClickEvent({
                    text: item.title,
                    href: item.href,
                    section: events/* SectionName.ZapCardSection */.jz.ZapCardSection,
                    type: avro/* CTAType.zap_card_link */.g8.zap_card_link
                });
                trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
                    path: window.location.pathname,
                    from_path: document.referrer,
                    cta_name: item.ctaName,
                    cta_goal: item.ctaGoal,
                    cta_raw_text: item.title,
                    link_destination: item.href
                });
            }
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCardSection, {
        items: zapCardItems,
        layout: layout
    });
}

;// CONCATENATED MODULE: ./src/migrations/migrateZapCardsSection.tsx


var migrateZapCardsSection = function() {
    return builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(ZapCardSection_ZapCardSection, {
        name: "ZapCardsSection",
        hideFromInsertMenu: true
    });
};
/* harmony default export */ var migrations_migrateZapCardsSection = (migrateZapCardsSection);

;// CONCATENATED MODULE: ./src/migrations/index.ts

/* harmony default export */ var migrations = ([
    migrations_migrateZapCardsSection
]);

;// CONCATENATED MODULE: ./src/builder/builder-module.ts
/**
 * Builder module factory
 *
 * This helper exists to centralize the creation of BuilderModules.
 * Each SomeComponent.builder.ts module should export a config using this.
 */ function createBuilderModule(Component, config) {
    return {
        Component: Component,
        config: config
    };
}

// EXTERNAL MODULE: ./src/components/ABTest/ABTest.tsx
var ABTest = __webpack_require__(75571);
;// CONCATENATED MODULE: ./src/components/ABTest/ABTest.builder.ts



/* harmony default export */ var ABTest_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(ABTest/* ABTest */.h), {
    name: "ABTest",
    image: "https://cdn.zappy.app/0aa56417d6b262b93417a0b1340b95b6.png",
    inputs: [
        {
            name: "experimentName",
            type: "string",
            required: true,
            helperText: "The name of experiment"
        },
        {
            name: "variants",
            type: "list",
            subFields: [
                {
                    name: "name",
                    helperText: "Each variant must have a unique name.",
                    required: true,
                    type: "string"
                },
                {
                    name: "percent",
                    required: true,
                    type: "number",
                    helperText: "Percentage of users that should see this variant. Percents of all variants must add up to 100."
                },
                {
                    name: "control",
                    type: "boolean",
                    defaultValue: false
                }, 
            ],
            required: true
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/hooks/usePrevious.ts

// Taken from https://usehooks.com/usePrevious/
function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    var ref = (0,react.useRef)();
    // Store current value in ref
    (0,react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}

;// CONCATENATED MODULE: ./src/components/ABVariant/ABVariant.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 




function ABVariant(param) {
    var children = param.children, preview = param.preview, variantName = param.variantName;
    var ref = (0,ABTest/* useABTestContext */.I)(), activeVariant = ref.activeVariant, registerVariant = ref.registerVariant, deregisterVariant = ref.deregisterVariant;
    var previousVariantName = usePrevious(variantName);
    var isPreviewMode = builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing;
    (0,react.useEffect)(function() {
        if (isPreviewMode) {
            return;
        }
        if (variantName) {
            registerVariant(variantName);
        }
        if (previousVariantName && previousVariantName !== variantName) {
            deregisterVariant(previousVariantName);
        }
        return function() {
            deregisterVariant(variantName);
        };
    }, [
        variantName,
        registerVariant,
        deregisterVariant,
        isPreviewMode,
        previousVariantName, 
    ]);
    var shouldShowVariant = function() {
        if (isPreviewMode) return preview;
        return variantName === (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name);
    };
    if (!shouldShowVariant()) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, children);
}

;// CONCATENATED MODULE: ./src/components/ABVariant/ABVariant.builder.ts



/* harmony default export */ var ABVariant_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(ABVariant), {
    name: "ABVariant",
    image: "https://cdn.zappy.app/f8cf0c0326588be441590818d2dc6dd3.png",
    inputs: [
        {
            name: "variantName",
            type: "string",
            required: true,
            helperText: "The name of the corresponding variant in Split.io"
        },
        {
            name: "preview",
            type: "boolean",
            helperText: "Would you like to see it when in preview/edit mode? Only if this is true, will the child block show while either editing or viewing current draft"
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/observability/tracking/withTracking.tsx



var withTracking_InViewTracking = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79205)).then(function(mod) {
        return mod.InViewTracking;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79205)
            ];
        }
    }
});
var withTracking = function(Component, config) {
    return function(props) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(withTracking_InViewTracking, {
            as: config === null || config === void 0 ? void 0 : config.as,
            className: config.className,
            sectionName: config.sectionName,
            layerName: (ref = props.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,src_object_spread/* default */.Z)({}, props))
        });
    };
};

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Heading/HeadingLevel.js
var HeadingLevel = __webpack_require__(78062);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Accordion/Accordion.js






const Accordion_Styles = (0,labelStyles/* labelStyles */.B)('Accordion', {
    root: (derivedState) => [
        emotion_react_browser_esm/* css */.iv `
      position: relative;
      background-color: ${Colors/* Colors.neutral200 */.w.neutral200};
      border: 1px solid ${Colors/* Colors.neutral200 */.w.neutral200};
      border-radius: 10px;
      transition-property: box-shadow, border-color, background-color;
      transition-timing-function: ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};
      transition-duration: ${Animation/* Animation.transitionDuration */.f.transitionDuration};
    `,
        (derivedState.isFocused || derivedState.isHovered || derivedState.isOpen) &&
            (0,withModifier/* withModifier */.Q)('highlighted', emotion_react_browser_esm/* css */.iv `
          background-color: ${Colors/* Colors.neutral100 */.w.neutral100};
          border-color: ${Colors/* Colors.neutral400 */.w.neutral400};
          border-radius: 10px;
          box-shadow: ${Shadows/* Shadows.elevation5 */.f.elevation5};
        `),
        derivedState.isHovered &&
            (0,withModifier/* withModifier */.Q)('hovered', emotion_react_browser_esm/* css */.iv `
          box-shadow: ${Shadows/* Shadows.elevation10 */.f.elevation10};
        `),
    ],
    summary: (derivedState) => [
        emotion_react_browser_esm/* css */.iv `
      ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold};
      display: block;
      color: ${Colors/* Colors.neutral700 */.w.neutral700};
      cursor: pointer;
      list-style: none;
      padding: 20px;
      padding-${derivedState.toggleSide}: 55px;

      &::-webkit-details-marker {
        display: none;
      }

      // Remove marker from browser / polyfills
      &::before {
        content: '';
      }
    `,
        derivedState.isOpen &&
            (0,withModifier/* withModifier */.Q)('open', emotion_react_browser_esm/* css */.iv `
          // swapping padding for bottom so that when closed, you can tap anywhere
          // to open, after which the margin absorbs any (smaller) content margins
          padding-bottom: 0;
          margin-bottom: 20px;
          color: ${Colors/* Colors.neutral800 */.w.neutral800};
        `),
        (derivedState.isFocused || derivedState.isHovered) &&
            (0,withModifier/* withModifier */.Q)('highlighted', emotion_react_browser_esm/* css */.iv `
          color: ${Colors/* Colors.blue */.w.blue};
        `),
    ],
    content: (derivedState) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph1 */.ZT.paragraph1};
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin: 20px;
    margin-${derivedState.toggleSide}: 55px;
`,
    arrow: (derivedState) => emotion_react_browser_esm/* css */.iv `
      position: absolute;
      top: 20px;
      ${derivedState.toggleSide}: 15px;
    `,
    fullPageButton: emotion_react_browser_esm/* css */.iv `
    margin: 20px;
  `,
});
const FullPageButton = (props) => {
    const iconName = 'arrowOffsite';
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Accordion_Styles.fullPageButton },
        (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "secondary", href: props.href, iconBefore: iconName, isFullWidth: true, size: "small", target: "_blank" }, "Open full page")));
};
const Accordion = (props) => {
    const { children, href, isInitiallyOpen, title, onToggle = () => { }, toggleSide = 'left', } = props;
    const [isFocused, setIsFocused] = (0,react.useState)(false);
    const [isHovered, setIsHovered] = (0,react.useState)(false);
    const [isOpen, setIsOpen] = (0,react.useState)(!!isInitiallyOpen);
    const derivedState = {
        isFocused,
        isHovered,
        isOpen,
        toggleSide,
    };
    const iconColor = !isFocused && !isHovered ? 'neutral600' : 'currentColor';
    (0,react.useEffect)(() => {
        if (props.isOpen !== undefined) {
            setIsOpen(props.isOpen);
        }
    }, [props.isOpen]);
    const handleClick = (e) => {
        e.preventDefault();
        onToggle({ isOpen: !isOpen });
        if (props.isOpen === undefined) {
            setIsOpen(!isOpen);
        }
    };
    return ((0,isolateComponent/* isolateComponent */.U)("details", { css: Accordion_Styles.root(derivedState), open: isOpen },
        (0,isolateComponent/* isolateComponent */.U)("summary", { css: Accordion_Styles.summary(derivedState), onBlur: () => setIsFocused(false), onClick: handleClick, onFocus: () => setIsFocused(true), onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), tabIndex: 0, role: "button", "aria-expanded": isOpen },
            (0,isolateComponent/* isolateComponent */.U)("span", { css: Accordion_Styles.arrow(derivedState) },
                (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { canAcceptPointerEvents: false, color: iconColor, name: isOpen ? 'arrowSmallUp' : 'arrowSmallDown', size: 24 })),
            title),
        isOpen && (0,isolateComponent/* isolateComponent */.U)("div", { css: Accordion_Styles.content(derivedState) }, children),
        isOpen && href && (0,isolateComponent/* isolateComponent */.U)(FullPageButton, Object.assign({}, props))));
};
//# sourceMappingURL=Accordion.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/FAQ/FAQ.js



const FAQ_Styles = (0,labelStyles/* labelStyles */.B)('FAQ', {
    root: emotion_react_browser_esm/* css */.iv `
    padding: 30px 20px;

    @media screen and (min-width: 650px) {
      padding: 50px 30px;
    }
  `,
    faqContent: emotion_react_browser_esm/* css */.iv `
    max-width: 1170px;
    margin: 0 auto;
  `,
    heading: emotion_react_browser_esm/* css */.iv `
    text-align: center;
    margin-bottom: 30px;
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    ${Typography/* Typography.pageHeader5 */.ZT.pageHeader5}
  `,
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    text-align: center;
    margin-top: 30px;

    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 650px) {
      margin-top: 30px;
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
    grid: emotion_react_browser_esm/* css */.iv `
    display: grid;
    gap: 20px;

    @media screen and (min-width: 650px) {
      gap: 15px;
    }
  `,
});
const FAQ = ({ heading = 'Frequently Asked Questions', items, children, ctaText, ctaHref, onCtaClick, }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: FAQ_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: FAQ_Styles.faqContent },
            (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: FAQ_Styles.heading }, heading)),
            items && items.length > 0 ? ((0,isolateComponent/* isolateComponent */.U)("div", { css: FAQ_Styles.grid }, items.map((item) => ((0,isolateComponent/* isolateComponent */.U)(Accordion, { key: item.title, title: item.title, href: item.href, isInitiallyOpen: item.isInitiallyOpen, isOpen: item.isOpen, onToggle: item.onToggle }, item.content))))) : (children),
            ctaText && (ctaHref || onCtaClick) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: FAQ_Styles.ctaContainer },
                (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { href: ctaHref, size: "small", onClick: onCtaClick }, ctaText))))));
};
//# sourceMappingURL=FAQ.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ./src/components/RichTextHtml/RichTextHtml.tsx
var RichTextHtml = __webpack_require__(8841);
;// CONCATENATED MODULE: ./src/components/sections/AccordionSection/AccordionSection.tsx





/**
 * This needs to be a seperated component so it properly consumes
 * the context provided by TrackingWrapper.
 */ function AccordionSection(props) {
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var ref = (0,avro/* useAvroTracking */.B2)(), emitAccordionToggleEvent = ref.emitAccordionToggleEvent, emitCTAClickEvent = ref.emitCTAClickEvent;
    var items = props.items.map(function(item) {
        return {
            title: item.title,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
                html: item.content
            }),
            href: item.href,
            isInitiallyOpen: item.isInitiallyOpen,
            onToggle: function(param) {
                var isOpen = param.isOpen;
                emitAccordionToggleEvent({
                    option_selected: isOpen ? "opening" : "closing",
                    section: events/* SectionName.AccordionSection */.jz.AccordionSection,
                    title: item.title
                });
                trackEvent(isOpen ? events/* EventName.FAQ_ACCORDION_OPEN */.B_.FAQ_ACCORDION_OPEN : events/* EventName.FAQ_ACCORDION_CLOSE */.B_.FAQ_ACCORDION_CLOSE, {
                    title: item.title
                });
            }
        };
    });
    var handleCtaClick = function() {
        emitCTAClickEvent({
            href: props.seeMoreHref,
            type: avro/* CTAType.cta_button */.g8.cta_button,
            text: props.seeMoreText,
            section: events/* SectionName.AccordionSection */.jz.AccordionSection
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: events/* CtaName.moreArticles */.XE.moreArticles,
            cta_raw_text: props.seeMoreText,
            cta_goal: events/* CtaGoal.getMoreInformation */.LK.getMoreInformation
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {
        ctaHref: props.seeMoreHref,
        ctaText: props.seeMoreText,
        heading: props.heading,
        items: items,
        onCtaClick: handleCtaClick
    });
}

;// CONCATENATED MODULE: ./src/components/sections/AccordionSection/AccordionSection.builder.ts






var defaultItem = {
    title: "Example Item",
    content: "<p>Example content. Edit me!</p>",
    isInitiallyOpen: false
};
/* harmony default export */ var AccordionSection_builder = (createBuilderModule(withTracking(AccordionSection, {
    as: "section",
    sectionName: events/* SectionName.AccordionSection */.jz.AccordionSection
}), {
    name: "AccordionSection",
    image: "https://cdn.zappy.app/6382a6105475561a2f092b12a8806891.png",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Section Heading"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    defaultValue: "Item Title"
                },
                {
                    name: "content",
                    type: "richText",
                    defaultValue: "<p>Example content. Edit me!</p>"
                },
                {
                    name: "href",
                    type: "string",
                    helperText: "Optional link, visible as icon next to/under (depends on viewport) the content when open."
                },
                {
                    name: "isInitiallyOpen",
                    type: "boolean",
                    defaultValue: false,
                    helperText: 'Begin the accordion item as "open" (default to "closed until opened")'
                }, 
            ],
            defaultValue: [
                defaultItem,
                (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, defaultItem), {
                    title: "Another Example Item"
                }), 
            ]
        },
        {
            name: "seeMoreHref",
            type: "string",
            helperText: 'Optional link to "more entries". Adds button below Accordion entries.'
        },
        {
            name: "seeMoreText",
            type: "string",
            helperText: 'Text to display in the button linking to "more entries".'
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/Anchor/Anchor.tsx

function Anchor(param) {
    var anchorID = param.anchorID;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: anchorID
    });
}

;// CONCATENATED MODULE: ./src/components/Anchor/Anchor.builder.ts


/* harmony default export */ var Anchor_builder = (createBuilderModule(Anchor, {
    name: "Anchor",
    image: "https://cdn.zappy.app/c8e9252849d606dd84861bc9212b5a58.png",
    inputs: [
        {
            name: "anchorID",
            type: "string",
            required: true
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Context/actions.ts
var SUB_NAV_HEIGHT_UPDATE = "SUB_NAV_HEIGHT_UPDATE";
var SECTION_INDEX_UPDATE = "SECTION_INDEX_UPDATE";
var updateSubNavHeight = function(payload) {
    return {
        type: SUB_NAV_HEIGHT_UPDATE,
        payload: payload
    };
};
var updateSectionIndex = function(payload) {
    return {
        type: SECTION_INDEX_UPDATE,
        payload: payload
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        updateSubNavHeight: function(arg) {
            return dispatch(updateSubNavHeight(arg));
        },
        updateSectionIndex: function(arg) {
            return dispatch(updateSectionIndex(arg));
        }
    };
};

// EXTERNAL MODULE: ./src/hooks/useViewportSize.tsx
var useViewportSize = __webpack_require__(36287);
;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Context/selectors.ts
var getSectionIndex = function(state) {
    return state.sectionIndex;
};
var getPrevSectionIndex = function(state) {
    return state.prevSectionIndex;
};
var getSubNavHeight = function(state) {
    return state.subNavHeight;
};
var getWidth = function(state) {
    return state.width;
};
var getHeight = function(state) {
    return state.height;
};
var getIsShort = function(state) {
    var height = getHeight(state);
    return height === "short";
};
/**
 * We don't want to render the animations until the viewport size is known to avoid rendering
 * and then immediately unmounting a set of animations if getIsAnimationScrollable
 * returns false due to width being undefined.
 * */ var getIsViewportSizeKnown = function(state) {
    var width = getWidth(state);
    return width !== undefined;
};
var getIsAnimationScrollable = function(state) {
    var width = getWidth(state);
    return width === "small" || width === "medium" || width === "extraSmall";
};
var getUniversalNavHeight = function(state) {
    var width = getWidth(state);
    return width === "extraSmall" ? 60 : 70;
};
var getTextRootMargin = function(state) {
    var isShort = getIsShort(state);
    var isAnimationScrollable = getIsAnimationScrollable(state);
    var subNavHeight = getSubNavHeight(state);
    var universalNavHeight = getUniversalNavHeight(state);
    var topMargin = isShort || isAnimationScrollable ? -100 : -subNavHeight - universalNavHeight - 10;
    return "".concat(topMargin, "px 0px -125px 0px ");
};
var getAnimationRootMargin = function(state) {
    var isShort = getIsShort(state);
    var subNavHeight = getSubNavHeight(state);
    var topMargin = isShort ? -10 : -subNavHeight;
    var bottomMargin = isShort ? -10 : -100;
    return "".concat(topMargin, "px 0px ").concat(bottomMargin, "px 0px ");
};
var mapStateToProps = function(state) {
    return {
        animationRootMargin: getAnimationRootMargin(state),
        isViewportSizeKnown: getIsViewportSizeKnown(state),
        height: getHeight(state),
        isAnimationScrollable: getIsAnimationScrollable(state),
        prevSectionIndex: getPrevSectionIndex(state),
        sectionIndex: getSectionIndex(state),
        subNavHeight: getSubNavHeight(state),
        textRootMargin: getTextRootMargin(state),
        universalNavHeight: getUniversalNavHeight(state),
        width: getWidth(state)
    };
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Context/reducer.ts






var initialState = {
    sectionIndex: 0,
    prevSectionIndex: null,
    subNavHeight: 0
};
function reducer(state, param) {
    var payload = param.payload, type = param.type;
    switch(type){
        case SUB_NAV_HEIGHT_UPDATE:
            {
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    subNavHeight: payload
                });
            }
        case SECTION_INDEX_UPDATE:
            {
                if (payload === state.sectionIndex) return state;
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    sectionIndex: payload,
                    prevSectionIndex: state.sectionIndex
                });
            }
        default:
            {
                return state;
            }
    }
}
function useAnimationsSectionReducer() {
    var ref = (0,react.useReducer)(reducer, initialState), reducerState = ref[0], dispatch = ref[1];
    var viewPortState = (0,useViewportSize/* useViewportSize */.n)();
    var state = mapStateToProps((0,src_object_spread/* default */.Z)({}, reducerState, viewPortState));
    return [
        state,
        dispatch
    ];
}

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Context/Context.tsx






var initialContext = {
    animationRefs: {
        current: []
    },
    animationRootMargin: "",
    isAnimationScrollable: null,
    isViewportSizeKnown: false,
    prevSectionIndex: null,
    scrollToSection: function() {},
    sectionIndex: 0,
    sectionRefs: {
        current: []
    },
    subNavHeight: 0,
    subNavRef: {
        current: null
    },
    textRootMargin: "",
    universalNavHeight: 0,
    updateSectionIndex: function() {}
};
var Context = /*#__PURE__*/ (0,react.createContext)(initialContext);
var Provider = function(param) {
    var children = param.children;
    var sectionRefs = (0,react.useRef)([]);
    var subNavRef = (0,react.useRef)(null);
    var animationRefs = (0,react.useRef)([]);
    var ref = (0,_sliced_to_array/* default */.Z)(useAnimationsSectionReducer(), 2), state = ref[0], dispatch = ref[1];
    var sectionIndex = state.sectionIndex, prevSectionIndex = state.prevSectionIndex;
    var getActions = (0,react.useCallback)(function() {
        return mapDispatchToProps(dispatch);
    }, [
        dispatch
    ]);
    (0,react.useLayoutEffect)(function() {
        var ref, ref1;
        getActions().updateSubNavHeight(((ref1 = (ref = subNavRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.height) || 0);
    }, [
        getActions
    ]);
    (0,react.useEffect)(function() {
        if (typeof prevSectionIndex !== "number") return;
        var animation = animationRefs.current[prevSectionIndex];
        if (animation) {
            animation.stop();
        }
    }, [
        prevSectionIndex
    ]);
    (0,react.useEffect)(function() {
        var animation = animationRefs.current[sectionIndex];
        if (animation) {
            animation.play();
        }
        return function() {
            if (animation) animation.stop();
        };
    }, [
        sectionIndex
    ]);
    var scrollToSection = function(index) {
        sectionRefs.current[index].scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };
    var actions = getActions();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: (0,src_object_spread/* default */.Z)({
            animationRefs: animationRefs,
            scrollToSection: scrollToSection,
            sectionRefs: sectionRefs,
            subNavRef: subNavRef
        }, actions, state),
        children: children
    });
};
var useAnimationsSectionContext = function() {
    return (0,react.useContext)(Context);
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/SubNav.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 









var _obj;
var SubNav_Styles = (0,labelStyles/* labelStyles */.B)("SubNav", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
            zIndex: 1,
            top: "0px",
            backgroundImage: "linear-gradient(90deg, ".concat(Colors/* Colors */.w[backgroundColor], " 50%, rgba(0,0,0,0) 50%)"),
            position: "sticky",
            boxShadow: "-50px 50px 30px ".concat(Colors/* Colors.neutral100 */.w.neutral100)
        }, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
            position: "relative",
            boxShadow: "none"
        }));
    },
    linksContainer: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        zIndex: 1,
        width: "fit-content",
        top: "0px",
        display: "flex",
        height: "31px"
    }, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        display: "none"
    })),
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), (_obj = {
        color: Colors/* Colors.earth */.w.earth,
        paddingBottom: "26px",
        paddingTop: "87px"
    }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.medium */.Eb.medium, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), {
        paddingTop: "38px"
    })), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), {
        paddingTop: "48px"
    })), _obj))),
    link: function(isActive) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            marginRight: "18px"
        }, Typography/* Typography.paragraph3 */.ZT.paragraph3), {
            color: "currentColor",
            "&:focus": {
                color: Colors/* Colors.blue */.w.blue
            },
            "&:focus-visible": {
                color: Colors/* Colors.blue */.w.blue
            },
            "&:focus:not(:focus-visible)": {
                color: Colors/* Colors.neutral800 */.w.neutral800
            },
            textDecoration: "none",
            outline: "0",
            paddingTop: "6px",
            borderTop: "3px solid ".concat(isActive ? Colors/* Colors.zapier */.w.zapier : "transparent")
        }));
    }
});
function SubNav(param) {
    var backgroundColor = param.backgroundColor, title = param.title, links = param.links;
    var ref = useAnimationsSectionContext(), scrollToSection = ref.scrollToSection, sectionIndex = ref.sectionIndex, subNavRef = ref.subNavRef;
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SubNav_Styles.root(backgroundColor),
        "data-testid": "sub-nav",
        ref: subNavRef
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SubNav_Styles.title
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Heading/* Heading */.X, null, title)), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("nav", {
        css: SubNav_Styles.linksContainer
    }, links.map(function(param, index) {
        var text = param.text;
        var isActive = sectionIndex === index;
        var href = "#".concat(text.toLowerCase().replace(" ", "-"));
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
            css: SubNav_Styles.link(isActive),
            href: href,
            key: "".concat(text, "-").concat(index),
            onClick: function(e) {
                e.preventDefault();
                // TO_DO - replace this JS scrolling with native <a /> scroll behavior using CSS scroll-behavior: smooth; to retain the smooth scroll effect.
                scrollToSection(index);
                emitUserInteractionEvent({
                    event_action: avro/* EventAction.click */.AO.click,
                    interaction_name: avro/* InteractionName.navigation */.AI.navigation,
                    interaction_raw_text: text,
                    option_selected: "nav_link",
                    destination_href: href,
                    custom_tracking_fields: {
                        section_name: events/* SectionName.AnimationsSection */.jz.AnimationsSection
                    }
                });
            }
        }, text);
    }))));
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
;// CONCATENATED MODULE: ./src/components/RichTextHeading/RichTextHeading.tsx



var RichTextHeading = function(_param) {
    var html = _param.html, tag = _param.tag, rest = _objectWithoutProperties(_param, [
        "html",
        "tag"
    ]);
    var Tag = tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,src_object_spread/* default */.Z)({
        dangerouslySetInnerHTML: {
            __html: html.replace(/<\/?(p|h[1-6])>/g, "")
        }
    }, rest));
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/ScrollFade.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 



var ScrollFade = function(param) {
    var children = param.children, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0px" : _rootMargin, onVisible = param.onVisible;
    var width = useAnimationsSectionContext().width;
    var elementRef = (0,react.useRef)(null);
    var prevWidth = (0,react.useRef)();
    var prevRootMargin = (0,react.useRef)("");
    var ref = (0,react.useState)(1), opacity = ref[0], setOpacity = ref[1];
    (0,react.useEffect)(function() {
        var ref = elementRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), ref1 = _param[0], isIntersecting = ref1.isIntersecting, intersectionRatio = ref1.intersectionRatio;
            if (ref && (width !== prevWidth.current || rootMargin !== prevRootMargin.current)) observer.unobserve(ref);
            if (isIntersecting && intersectionRatio >= 0.75) {
                setOpacity(1);
                if (onVisible) onVisible();
            } else if (isIntersecting) {
                setOpacity(intersectionRatio);
            } else if (intersectionRatio <= 0.2) {
                setOpacity(0);
            }
        }, {
            threshold: Array.from({
                length: 5
            }).map(function(_, index) {
                return index / 4;
            }),
            rootMargin: rootMargin
        });
        prevWidth.current = width;
        prevRootMargin.current = rootMargin;
        if (ref) {
            observer.observe(ref);
        }
        return function() {
            if (ref) {
                observer.unobserve(ref);
            }
        };
    }, [
        width,
        rootMargin,
        onVisible
    ]);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: (0,emotion_react_browser_esm/* css */.iv)({
            opacity: opacity,
            transition: "opacity 0.25s ease, transform 0.25s ease",
            "@keyframes wipe-enter": {
                "0%": {
                    transform: "scale(0, .025)"
                },
                "50%": {
                    transform: "scale(1, .025)"
                }
            }
        }),
        ref: elementRef
    }, children);
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Text.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 










var Text_obj;
var Text_Styles = (0,labelStyles/* labelStyles */.B)("Text", {
    root: (0,emotion_react_browser_esm/* css */.iv)((Text_obj = {
        display: "flex",
        alignItems: "center",
        width: "100%"
    }, (0,_define_property/* default */.Z)(Text_obj, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        margin: "0 0 50px 0"
    }), (0,_define_property/* default */.Z)(Text_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
        margin: "40px 0 40px 0"
    }), (0,_define_property/* default */.Z)(Text_obj, "".concat(responsive/* MEDIA_MIN_WIDTH.small */.l0.small, " and ").concat(responsive/* MAX_WIDTH.large */.d.large), {
        width: "50%"
    }), Text_obj)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader3 */.ZT.pageHeader3), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.earth */.w.earth
    }, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7)))),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3), (0,_define_property/* default */.Z)({
        paddingTop: "22px"
    }, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3), {
        paddingTop: "5px"
    }))))
});
function Text(param) {
    var heading = param.heading, index = param.index, description = param.description;
    var ref = useAnimationsSectionContext(), textRootMargin = ref.textRootMargin, updateSectionIndex = ref.updateSectionIndex, isAnimationScrollable = ref.isAnimationScrollable;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Text_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ScrollFade, {
        onVisible: function() {
            if (!isAnimationScrollable) updateSectionIndex(index);
        },
        rootMargin: textRootMargin
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHeading, {
        css: Text_Styles.heading,
        html: heading,
        tag: "h2"
    })), description && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Text_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ScrollFade, {
        rootMargin: textRootMargin
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: description
    })))));
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(12039);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
;// CONCATENATED MODULE: ./src/components/LottieAnimation/LottieAnimation.tsx





var LottieAnimation = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref = (0,react.useState)(), animationData = _$ref[0], setAnimationData = _$ref[1];
    var _$ref1 = (0,react.useState)(false), isLoaded = _$ref1[0], setIsLoaded = _$ref1[1];
    var animationRef = (0,react.useRef)();
    var containerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            play: function play() {
                if (animationRef.current) {
                    animationRef.current.play();
                }
            },
            pause: function pause() {
                if (animationRef.current) {
                    animationRef.current.pause();
                }
            },
            stop: function stop() {
                if (animationRef.current) {
                    animationRef.current.stop();
                }
            }
        };
    });
    var fetchAnimationData = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(signal) {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(props.animationDataUrl, {
                            method: "GET",
                            signal: signal
                        });
                    case 2:
                        response = _ctx.sent;
                        _ctx.next = 5;
                        return response.json();
                    case 5:
                        data = _ctx.sent;
                        setAnimationData(data);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props.animationDataUrl
    ]);
    (0,react.useEffect)(function() {
        // AbortController is used to abort the fetch request if the component is unmounted to avoid a memory leak
        var controller = new AbortController();
        fetchAnimationData(controller.signal);
        return function() {
            controller.abort();
        };
    }, [
        fetchAnimationData
    ]);
    (0,react.useEffect)(function() {
        if (!containerRef.current) {
            return undefined;
        }
        var _autoplay, _loop;
        animationRef.current = lottie_default().loadAnimation({
            animationData: animationData,
            assetsPath: props.animationAssetsUrl,
            autoplay: (_autoplay = props.autoplay) !== null && _autoplay !== void 0 ? _autoplay : false,
            container: containerRef.current,
            loop: (_loop = props.loop) !== null && _loop !== void 0 ? _loop : false,
            renderer: "svg",
            rendererSettings: {
                viewBoxOnly: true
            }
        });
        setIsLoaded(animationRef.current.isLoaded);
        return function() {
            if (animationRef.current) {
                animationRef.current.destroy();
            }
        };
    }, [
        animationData,
        props.animationAssetsUrl,
        props.autoplay,
        props.loop
    ]);
    (0,react.useEffect)(function() {
        if (typeof props.speed === "number" && isLoaded && animationRef.current) {
            animationRef.current.setSpeed(props.speed);
        }
    }, [
        props.speed,
        isLoaded
    ]);
    (0,react.useEffect)(function() {
        if (!props.onDOMLoaded || !isLoaded || !animationRef.current) {
            return undefined;
        }
        animationRef.current.addEventListener("DOMLoaded", props.onDOMLoaded);
        return function() {
            if (animationRef.current) {
                try {
                    animationRef.current.removeEventListener("DOMLoaded", props.onDOMLoaded);
                } catch (error) {
                    console.error(error);
                }
            }
        };
    }, [
        props.onDOMLoaded,
        isLoaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "aria-label": props.ariaLabel,
        className: props.className,
        ref: containerRef
    });
});

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/Animation.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 






var Animation_Styles = (0,labelStyles/* labelStyles */.B)("Animation", {
    root: function(isVisible) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            opacity: isVisible ? 1 : 0,
            visibility: isVisible ? "visible" : "hidden",
            transition: "visibility 0.5s, opacity 0.5s linear",
            margin: "auto",
            position: "relative",
            width: "70vw"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            width: "40vw"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, {
            width: "35vw"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            width: "30vw",
            position: "absolute"
        }), _obj));
    }
});
var Animation_Animation = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var ariaLabel = param.ariaLabel, animationAssetsUrl = param.animationAssetsUrl, animationDataUrl = param.animationDataUrl, animationSpeed = param.animationSpeed, autoPlay = param.autoPlay, isVisible = param.isVisible;
    var isViewportSizeKnown = useAnimationsSectionContext().isViewportSizeKnown;
    return isViewportSizeKnown ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Animation_Styles.root(isVisible)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(LottieAnimation, {
        animationAssetsUrl: animationAssetsUrl,
        animationDataUrl: animationDataUrl,
        ariaLabel: ariaLabel,
        autoplay: autoPlay,
        loop: false,
        ref: ref,
        speed: animationSpeed
    })) : null;
});

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/ScrollableSections.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var ScrollableSections_Styles = (0,labelStyles/* labelStyles */.B)("AnimationsSection", {
    root: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        width: "100%"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        width: "45%"
    })),
    scrollable: function(param) {
        var subNavHeight = param.subNavHeight, universalNavHeight = param.universalNavHeight;
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            minHeight: "75vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "45vh"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            minHeight: "calc(100vh - ".concat(subNavHeight + universalNavHeight, "px)"),
            paddingBottom: "".concat(universalNavHeight, "px"),
            "&:first-of-type": {
                marginTop: "".concat(-universalNavHeight, "px"),
                paddingBottom: "0px"
            },
            "&:last-of-type": {
                minHeight: "100vh",
                marginTop: "".concat(-subNavHeight, "px"),
                paddingBottom: "0px"
            }
        }), _obj));
    }
});
function ScrollableSections(param) {
    var sections = param.sections;
    var ref = useAnimationsSectionContext(), animationRefs = ref.animationRefs, animationRootMargin = ref.animationRootMargin, isAnimationScrollable = ref.isAnimationScrollable, sectionRefs = ref.sectionRefs, subNavHeight = ref.subNavHeight, universalNavHeight = ref.universalNavHeight, updateSectionIndex = ref.updateSectionIndex;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ScrollableSections_Styles.root
    }, sections.map(function(param, index) {
        var animationAssetsUrl = param.animationAssetsUrl, animationDataUrl = param.animationDataUrl, animationSpeed = param.animationSpeed, description = param.description, heading = param.heading, mediaAltText = param.mediaAltText, navLinkText = param.navLinkText;
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: ScrollableSections_Styles.scrollable({
                universalNavHeight: universalNavHeight,
                subNavHeight: subNavHeight
            }),
            id: navLinkText.toLocaleLowerCase().replace(" ", "-"),
            key: "".concat(animationDataUrl, "-").concat(navLinkText, "-").concat(index),
            ref: function(ref) {
                if (ref) {
                    sectionRefs.current[index] = ref;
                }
            }
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text, {
            description: description,
            heading: heading,
            index: index
        }), isAnimationScrollable && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ScrollFade, {
            onVisible: function() {
                return updateSectionIndex(index);
            },
            rootMargin: animationRootMargin
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Animation_Animation, {
            animationAssetsUrl: animationAssetsUrl,
            animationDataUrl: animationDataUrl,
            animationSpeed: animationSpeed,
            ariaLabel: mediaAltText,
            autoPlay: index === 0,
            isVisible: true,
            ref: function(ref) {
                if (ref) animationRefs.current[index] = ref;
            }
        })));
    }));
}

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/StickySections.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 



var StickySections_Styles = (0,labelStyles/* labelStyles */.B)("AnimationsSection", {
    root: function(subNavHeight) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            zIndex: 1,
            top: "0px",
            height: "100vh",
            marginTop: "".concat(-subNavHeight, "px"),
            width: "45%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "sticky"
        });
    }
});
function StickySections(param) {
    var sections = param.sections;
    var ref = useAnimationsSectionContext(), isAnimationScrollable = ref.isAnimationScrollable, subNavHeight = ref.subNavHeight, animationRefs = ref.animationRefs, sectionIndex = ref.sectionIndex;
    return !isAnimationScrollable ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: StickySections_Styles.root(subNavHeight)
    }, sections.map(function(param, index) {
        var animationAssetsUrl = param.animationAssetsUrl, animationDataUrl = param.animationDataUrl, animationSpeed = param.animationSpeed, mediaAltText = param.mediaAltText;
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Animation_Animation, {
            animationAssetsUrl: animationAssetsUrl,
            animationDataUrl: animationDataUrl,
            animationSpeed: animationSpeed,
            ariaLabel: mediaAltText,
            autoPlay: index === 0,
            isVisible: sectionIndex === index,
            key: "".concat(animationDataUrl, "-").concat(index),
            ref: function(ref) {
                if (ref) animationRefs.current[index] = ref;
            }
        });
    })) : null;
}

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/AnimationsSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 








var AnimationsSection_Styles = (0,labelStyles/* labelStyles */.B)("AnimationsSection", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            width: "100%",
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        });
    },
    container: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: "1170px",
        margin: "auto",
        padding: "0 20px"
    }),
    section: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column"
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        justifyContent: "space-between",
        flexDirection: "row"
    }))
});
function AnimationsSectionUnwrapped(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? colors/* COLOR_KEYS.cream */.US.cream : _backgroundColor, sections = param.sections, title = param.title;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AnimationsSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AnimationsSection_Styles.container
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SubNav, {
        backgroundColor: backgroundColor,
        links: sections.map(function(param) {
            var navLinkText = param.navLinkText;
            return {
                text: navLinkText
            };
        }),
        title: title
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
        css: AnimationsSection_Styles.section
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ScrollableSections, {
        sections: sections
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(StickySections, {
        sections: sections
    }))));
}
var AnimationsSection = function(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Provider, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(AnimationsSectionUnwrapped, Object.assign({}, props)));
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/fixtures.ts


var SECTIONS = [
    {
        navLinkText: "Section 1",
        heading: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>'),
        description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
        animationDataUrl: "https://assets3.lottiefiles.com/private_files/lf30_pbxec3cw.json"
    },
    {
        navLinkText: "Section 2",
        heading: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>'),
        description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
        animationDataUrl: "https://assets3.lottiefiles.com/packages/lf20_2r60fbgn.json"
    },
    {
        navLinkText: "Section 3",
        heading: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>'),
        description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
        animationDataUrl: "https://assets7.lottiefiles.com/packages/lf20_wvgjjcbq.json"
    },
    {
        navLinkText: "Section 4",
        heading: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>'),
        description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
        animationDataUrl: "https://assets3.lottiefiles.com/packages/lf20_2cyedfbj.json"
    },
    {
        navLinkText: "Section 5",
        heading: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>'),
        description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
        animationDataUrl: "https://assets10.lottiefiles.com/packages/lf20_hcae8wxn.json"
    }, 
];
var DEFAULT_VALUES = {
    title: "Animation party",
    backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
    sections: [
        {
            navLinkText: "Time",
            heading: '<p>It\'s <span style="color: var(--zds-colors-zapier, #ff4f00);">5 o\'clock </span><span style="color: rgb(0, 0, 0);">somewhere!</span></p>',
            description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
            animationDataUrl: "https://assets3.lottiefiles.com/private_files/lf30_pbxec3cw.json",
            mediaAltText: "Time passing on a clock"
        },
        {
            navLinkText: "Bunny",
            heading: '<p>This <span style="color: var(--zds-colors-zapier, #ff4f00);">little bunny </span><span style="color: rgb(0, 0, 0);">needs a drink</span></p>',
            description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
            animationDataUrl: "https://assets3.lottiefiles.com/packages/lf20_2r60fbgn.json",
            mediaAltText: "A bunny rabbit drinking a bottle of rainbow colored liquid in a drunken fashion"
        },
        {
            navLinkText: "Too much?",
            heading: '<p>Oh no! Too much <span style="color: rgb(255, 79, 0);">rainbow juice</span>?</p>',
            description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
            animationDataUrl: "https://assets7.lottiefiles.com/packages/lf20_wvgjjcbq.json",
            mediaAltText: "Pink pony looking worried"
        },
        {
            navLinkText: "Nah!",
            heading: '<p>No such thing as <span style="color: rgb(255, 79, 0);">too much </span><span style="color: rgb(0, 0, 0);">rainbow</span><span style="color: rgb(255, 79, 0);"> </span><span style="color: rgb(0, 0, 0);">juice</span></p>',
            description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
            animationDataUrl: "https://assets3.lottiefiles.com/packages/lf20_2cyedfbj.json",
            mediaAltText: "Non-chalant beer bottle"
        },
        {
            navLinkText: "Goodbye",
            heading: '<p>Owl <span style="color: rgb(255, 79, 0);">see you</span> later!</p>',
            description: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>",
            animationDataUrl: "https://assets5.lottiefiles.com/packages/lf20_fhMCjY.json",
            mediaAltText: "Owl drinking wine and then keeling over"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/sections/AnimationsSection/AnimationsSection.builder.ts







/* harmony default export */ var AnimationsSection_builder = (createBuilderModule(withTracking(AnimationsSection, {
    as: "section",
    sectionName: events/* SectionName.AnimationsSection */.jz.AnimationsSection
}), {
    name: "AnimationsSection",
    image: "https://cdn.zappy.app/8df6a921d924e95ea2ef57b043358b2f.png",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: DEFAULT_VALUES.title,
            helperText: "The title of the entire section to be displayed in the sticky nav"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            defaultValue: DEFAULT_VALUES.backgroundColor
        },
        {
            name: "sections",
            type: "list",
            subFields: [
                {
                    name: "heading",
                    type: "richText",
                    defaultValue: 'Connect your apps, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">automate your work</span>')
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: "<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>"
                },
                {
                    name: "navLinkText",
                    type: "string",
                    required: true
                },
                {
                    name: "animationDataUrl",
                    type: "string",
                    required: true
                },
                {
                    name: "animationAssetsUrl",
                    type: "string"
                },
                {
                    name: "animationSpeed",
                    type: "number"
                },
                {
                    name: "mediaAltText",
                    type: "string",
                    required: true,
                    helperText: "Text that describes the animation for accessibility purposes"
                }, 
            ],
            defaultValue: [
                DEFAULT_VALUES.sections[0]
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/CustomButton/CustomButton.tsx
/** @jsxRuntime classic */ /** @jsx isolateComponent */ 







var CustomButton_Styles = (0,labelStyles/* labelStyles */.B)("CustomButton", {
    root: function(color) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            "& > a, & > button": {
                backgroundColor: {
                    primary: Colors/* Colors.neutral800 */.w.neutral800,
                    secondary: Colors/* Colors.neutral100 */.w.neutral100,
                    "secondary-alt": Colors/* Colors.peach */.w.peach,
                    outline: Colors/* Colors.neutral100 */.w.neutral100
                }[color],
                color: color === "primary" ? Colors/* Colors.neutral100 */.w.neutral100 : Colors/* Colors.neutral800 */.w.neutral800,
                border: color === "outline" ? "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800) : "none",
                '&[data-size="large"]': (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (0,_define_property/* default */.Z)({
                    fontWeight: 500,
                    fontSize: "16px",
                    height: "50px"
                }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3Medium */.ZT.subHeader3Medium), {
                    height: "70px"
                }))),
                "&:hover:not([disabled])": {
                    backgroundColor: {
                        primary: Colors/* Colors.night */.w.night,
                        secondary: Colors/* Colors.blue20 */.w.blue20,
                        "secondary-alt": Colors/* Colors.neutral100 */.w.neutral100,
                        outline: Colors/* Colors.night */.w.night
                    }[color],
                    boxShadow: "none",
                    color: color === "primary" || color === "outline" ? Colors/* Colors.neutral100 */.w.neutral100 : Colors/* Colors.neutral800 */.w.neutral800,
                    borderColor: Colors/* Colors.night */.w.night
                }
            }
        });
    }
});
function CustomButton(_param) {
    var _color = _param.color, color = _color === void 0 ? "primary" : _color, props = _objectWithoutProperties(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("div", {
        css: CustomButton_Styles.root(color)
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, props, {
        color: color === "primary" ? "primary-alt" : "secondary",
        size: "large"
    })));
}

;// CONCATENATED MODULE: ./src/components/sections/AppsSection/AppsSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 











var appFocusStyles = (0,emotion_react_browser_esm/* css */.iv)({
    content: '""',
    position: "absolute",
    border: "2px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
    borderRadius: "10px",
    inset: "-1px"
});
var AppsSection_obj, _obj1, _obj2, _obj3;
var AppsSection_Styles = (0,labelStyles/* labelStyles */.B)("AppsSection", {
    root: (0,emotion_react_browser_esm/* css */.iv)((AppsSection_obj = {
        overflow: "hidden",
        padding: "48px 0"
    }, (0,_define_property/* default */.Z)(AppsSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        padding: "96px 20px"
    }), (0,_define_property/* default */.Z)(AppsSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "128px 20px"
    }), AppsSection_obj)),
    container: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        maxWidth: "1170px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: "center"
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        flexDirection: "row"
    })),
    content: (0,emotion_react_browser_esm/* css */.iv)((_obj1 = {
        flexShrink: 0,
        padding: "0 20px"
    }, (0,_define_property/* default */.Z)(_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "288px",
        padding: 0
    }), (0,_define_property/* default */.Z)(_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "370px"
    }), _obj1)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (_obj2 = {
        color: Colors/* Colors.earth */.w.earth,
        marginBottom: "16px"
    }, (0,_define_property/* default */.Z)(_obj2, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        marginBottom: "64px"
    }), (0,_define_property/* default */.Z)(_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        marginBottom: "144px"
    })), _obj2))),
    body: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (0,_define_property/* default */.Z)({
        fontSize: "16px",
        lineHeight: "22px",
        color: Colors/* Colors.neutral800 */.w.neutral800,
        marginBottom: "20px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3), {
        marginBottom: "24px"
    })))),
    grid: (0,emotion_react_browser_esm/* css */.iv)((_obj3 = {
        display: "grid",
        gridTemplateRows: "repeat(4, 1fr)",
        gridAutoFlow: "column",
        gap: "20px 16px",
        flexShrink: 0,
        padding: "0 20px 40px",
        overflowX: "hidden"
    }, (0,_define_property/* default */.Z)(_obj3, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        marginLeft: "80px",
        padding: "16px"
    }), (0,_define_property/* default */.Z)(_obj3, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        gap: "40px 24px",
        marginLeft: "224px"
    }), _obj3)),
    app: (0,emotion_react_browser_esm/* css */.iv)({
        position: "relative",
        outline: "none",
        "&:focus::before": appFocusStyles,
        "&:focus-visible::before": appFocusStyles,
        "&:focus:not(:focus-visible)::before": {
            display: "none"
        }
    })
});
function AppsSection(props) {
    var ref = (0,react.useState)(0), viewportWidth = ref[0], setViewportWidth = ref[1];
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    (0,react.useEffect)(function() {
        setViewportWidth(window.innerWidth);
        var handleResize = function() {
            return setViewportWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    // Returns only apps that will fit in the viewport
    var getApps = function() {
        var rows = 4;
        var overflowColumns = viewportWidth < responsive/* BREAKPOINTS.small */.j$.small ? 0 : 1;
        var appWidth = viewportWidth < responsive/* BREAKPOINTS.large */.j$.large ? 60 : 80;
        var gridGap = viewportWidth < responsive/* BREAKPOINTS.large */.j$.large ? 16 : 24;
        var gridWidth = viewportWidth;
        if (viewportWidth >= responsive/* BREAKPOINTS.small */.j$.small && viewportWidth < responsive/* BREAKPOINTS.large */.j$.large) {
            gridWidth = viewportWidth - 404;
        } else if (viewportWidth >= responsive/* BREAKPOINTS.large */.j$.large) {
            gridWidth = viewportWidth - Math.max((viewportWidth - 1170) / 2, 20) - 610;
        }
        return props.apps.slice(0, (Math.floor(gridWidth / (appWidth + gridGap)) + overflowColumns) * rows);
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AppsSection_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AppsSection_Styles.container
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AppsSection_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHeading, {
        css: AppsSection_Styles.heading,
        html: props.heading,
        tag: "h2"
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AppsSection_Styles.body
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: props.body
    })), props.ctaText && props.ctaUrl && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        href: props.ctaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: props.ctaText,
                href: props.ctaUrl,
                section: events/* SectionName.AppsSection */.jz.AppsSection
            });
        }
    }, props.ctaText))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AppsSection_Styles.grid
    }, getApps().map(function(app) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
            css: AppsSection_Styles.app,
            href: app.appProfileUrl,
            key: app.appProfileUrl
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ServiceIcon/* ServiceIcon */.A, {
            hasShadow: true,
            serviceName: app.name,
            size: viewportWidth < responsive/* BREAKPOINTS.large */.j$.large ? 60 : 80,
            src: app.iconUrl
        }));
    }))));
}

;// CONCATENATED MODULE: ./src/components/sections/AppsSection/fixtures.ts

var fixtures_DEFAULT_VALUES = {
    apps: [
        {
            appProfileUrl: "/apps/gmail/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/54f0bd6f9c31b757ab20d4c7058dc7c0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Gmail"
        },
        {
            appProfileUrl: "/apps/shopify/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/4da9d3e3f93cd522f85e1b0695341f89.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Shopify"
        },
        {
            appProfileUrl: "/apps/slack/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Slack"
        },
        {
            appProfileUrl: "/apps/google-calendar/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/62c82a7958c6c29736f17d0495b6635c.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Google Calendar"
        },
        {
            appProfileUrl: "/apps/mailchimp/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/221770b81f376004aee4a712ef4353be.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Mailchimp"
        },
        {
            appProfileUrl: "/apps/trello/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/da3ff465abd3a3e1b687c52ff803af74.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Trello"
        },
        {
            appProfileUrl: "/apps/asana/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/986718c45d823ca0a4173ec68912416e.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Asana"
        },
        {
            appProfileUrl: "/apps/hubspot/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "HubSpot"
        },
        {
            appProfileUrl: "/apps/zoom/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/472b2b8aba2dc38d4ef605c955341739_6.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Zoom"
        },
        {
            appProfileUrl: "/apps/stripe/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/27f5433f521806493e2c38a304e1786e.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Stripe"
        },
        {
            appProfileUrl: "/apps/marketo/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/bec09826ed23eb439c1d9f47d2f5fab7.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Marketo"
        },
        {
            appProfileUrl: "/apps/facebook-pages/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/f407c31b217aac6e0cd4171092d53a8c.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Facebook Pages"
        },
        {
            appProfileUrl: "/apps/google-drive/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/bb735e567f1a1e9e3b8b7241497c2d43.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Google Drive"
        },
        {
            appProfileUrl: "/apps/salesforce/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/1a4435539b4764e6ded3d368cabab387.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Salesforce"
        },
        {
            appProfileUrl: "/apps/zendesk/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/45e89018e756b043d806701f17dc2632.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Zendesk"
        },
        {
            appProfileUrl: "/apps/airtable/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/c6c8c5e300ef0da0e47b3084e5522f20.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Airtable"
        },
        {
            appProfileUrl: "/apps/microsoft-teams/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/22d6681f64c79dd71a34066afe1c54e2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Microsoft Teams"
        },
        {
            appProfileUrl: "/apps/calendly/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/33464c48a26a29dd29977ffb16bcca53.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Calendly"
        },
        {
            appProfileUrl: "/apps/jira/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/ea4a5ee38c7a088e243745dd0b851784.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Jira Software Server"
        },
        {
            appProfileUrl: "/apps/docusign/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/8b4a1cdb476943811b60b1adaf85fb4d.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "DocuSign"
        },
        {
            appProfileUrl: "/apps/google-sheets/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Google Sheets"
        },
        {
            appProfileUrl: "/apps/notion/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/0de44c7d5f0046873886168b9b498f66_3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Notion"
        },
        {
            appProfileUrl: "/apps/microsoft-outlook/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/17b8fae71a30cf910b73ed0eda8b1443.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Microsoft Outlook"
        },
        {
            appProfileUrl: "/apps/twitter/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/580b3c79622bbff634f0d764e9f813a3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Twitter"
        },
        {
            appProfileUrl: "/apps/discord/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/ca03beabe94d8f97ba6fbf75cbb695c4.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Discord"
        },
        {
            appProfileUrl: "/apps/clickup/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/services/000c15b838d86d80869cff5938fa76f3.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "ClickUp"
        },
        {
            appProfileUrl: "/apps/webflow/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/dba91ada3f465bc866a1c4431236d9f2_2.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Webflow"
        },
        {
            appProfileUrl: "/apps/pipedrive/integrations",
            iconUrl: "https://zapier-images.imgix.net/storage/developer/a70589f8db6a514b6820267b506409f0.png?auto=format%2Ccompress&ixlib=python-3.0.0&q=50",
            name: "Pipedrive"
        }, 
    ],
    body: "<p>Zapier supports more apps than any other platform, so you can connect the tools you use today—and tomorrow.</p>",
    ctaText: "Explore by app",
    ctaUrl: "#",
    heading: '<span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">4,000+ apps,</span> infinite possibilities')
};

;// CONCATENATED MODULE: ./src/components/sections/AppsSection/AppsSection.builder.ts




/* harmony default export */ var AppsSection_builder = (createBuilderModule(withTracking(AppsSection, {
    as: "section",
    sectionName: events/* SectionName.AppsSection */.jz.AppsSection
}), {
    name: "AppsSection",
    image: "https://cdn.zappy.app/17572733d9a5c08c7a4862e4ee712358.png",
    inputs: [
        {
            name: "heading",
            type: "richText",
            required: true,
            defaultValue: fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "body",
            type: "richText",
            required: true,
            defaultValue: fixtures_DEFAULT_VALUES.body
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: fixtures_DEFAULT_VALUES.ctaText
        },
        {
            name: "ctaUrl",
            type: "string",
            defaultValue: fixtures_DEFAULT_VALUES.ctaUrl
        },
        {
            name: "apps",
            type: "list",
            required: true,
            defaultValue: fixtures_DEFAULT_VALUES.apps,
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "iconUrl",
                    type: "cloudinaryImage",
                    required: true
                },
                {
                    name: "appProfileUrl",
                    type: "string",
                    required: true
                }, 
            ]
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/icons/index.js
var icons = __webpack_require__(50672);
;// CONCATENATED MODULE: ./src/constants/icons.ts




var ICON_NAMES = Object.keys(icons.iconNames).reduce(function(acc, key) {
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, key));
}, {});

// EXTERNAL MODULE: ../../node_modules/@zapier/date/dist/index.js
var dist = __webpack_require__(68516);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/createUniqueCustomProperty.js
var createUniqueCustomProperty = __webpack_require__(38137);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Avatar/AvatarsWithText.js





const Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('AvatarsWithText', [
    'textDisplay',
    'textFontSizeLight',
    'textLineHeightLight',
    'textFontSizeHeavy',
    'textLineHeightHeavy',
]);
const AvatarsWithText_Styles = (0,labelStyles/* labelStyles */.B)('AvatarsWithText', {
    root: (shouldRenderGap) => emotion_react_browser_esm/* css */.iv `
    ${Vars.textDisplay}: inline-block;
    ${Vars.textFontSizeLight}: 12px;
    ${Vars.textLineHeightLight}: 15px;
    ${Vars.textFontSizeHeavy}: 12px;
    ${Vars.textLineHeightHeavy}: 15px;

    display: grid;
    grid-template-columns: auto 1fr;
    gap: ${shouldRenderGap ? '0px' : '5px'};
    align-items: center;

    &[data-multiline] {
      ${Vars.textDisplay}: block;
    }

    &[data-size='18'] {
      ${Vars.textFontSizeLight}: ${Typography/* Typography.smallPrint3.fontSize */.ZT.smallPrint3.fontSize};
      ${Vars.textLineHeightLight}: ${Typography/* Typography.smallPrint3.lineHeight */.ZT.smallPrint3.lineHeight};
      ${Vars.textFontSizeHeavy}: ${Typography/* Typography.smallPrint3Bold.fontSize */.ZT.smallPrint3Bold.fontSize};
      ${Vars.textLineHeightHeavy}: ${Typography/* Typography.smallPrint3Bold.lineHeight */.ZT.smallPrint3Bold.lineHeight};
    }
    &[data-size='18'] > *:last-of-type {
      top: -1px;
    }

    &[data-size='25']:not([data-multiline]),
    &[data-size='40']:not([data-multiline]) {
      ${Vars.textFontSizeLight}: ${Typography/* Typography.smallPrint1.fontSize */.ZT.smallPrint1.fontSize};
      ${Vars.textLineHeightLight}: ${Typography/* Typography.smallPrint1.lineHeight */.ZT.smallPrint1.lineHeight};
      ${Vars.textFontSizeHeavy}: ${Typography/* Typography.smallPrint1Bold.fontSize */.ZT.smallPrint1Bold.fontSize};
      ${Vars.textLineHeightHeavy}: ${Typography/* Typography.smallPrint1Bold.lineHeight */.ZT.smallPrint1Bold.lineHeight};
    }

    &[data-size='25'][data-multiline] {
      align-items: start;
      ${Vars.textFontSizeLight}: ${Typography/* Typography.smallPrint1.fontSize */.ZT.smallPrint1.fontSize};
      ${Vars.textLineHeightLight}: 17px;
      ${Vars.textFontSizeHeavy}: ${Typography/* Typography.smallPrint1Bold.fontSize */.ZT.smallPrint1Bold.fontSize};
      ${Vars.textLineHeightHeavy}: ${Typography/* Typography.smallPrint1Bold.lineHeight */.ZT.smallPrint1Bold.lineHeight};
    }

    &[data-size='40'][data-multiline] {
      ${Vars.textFontSizeLight}: ${Typography/* Typography.smallPrint1.fontSize */.ZT.smallPrint1.fontSize};
      ${Vars.textLineHeightLight}: ${Typography/* Typography.smallPrint1.lineHeight */.ZT.smallPrint1.lineHeight};
      ${Vars.textFontSizeHeavy}: ${Typography/* Typography.paragraph3Bold.fontSize */.ZT.paragraph3Bold.fontSize};
      ${Vars.textLineHeightHeavy}: ${Typography/* Typography.paragraph3Bold.lineHeight */.ZT.paragraph3Bold.lineHeight};
    }
    &[data-size='40'] {
      gap: ${shouldRenderGap ? '0px' : '10px'};
    }
  `,
    avatars: emotion_react_browser_esm/* css */.iv `
    display: block;
  `,
    content: emotion_react_browser_esm/* css */.iv `
    display: block;
    position: relative;
    line-height: max(
      var(${Vars.textLineHeightLight}),
      var(${Vars.textLineHeightHeavy})
    );
  `,
    text: emotion_react_browser_esm/* css */.iv `
    display: var(${Vars.textDisplay});
    &[data-kind='light'] {
      color: ${Colors/* Colors.neutral700 */.w.neutral700};
      font-weight: 400;
      font-size: calc(1px * var(${Vars.textFontSizeLight}));
      line-height: var(${Vars.textLineHeightLight});
    }
    &[data-kind='heavy'] {
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      font-weight: 700;
      font-size: calc(1px * var(${Vars.textFontSizeHeavy}));
      line-height: var(${Vars.textLineHeightHeavy});
    }
  `,
});
const AvatarText = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("span", { "aria-label": props.ariaLabel, css: AvatarsWithText_Styles.text, "data-kind": props.kind, role: "text" }, props.children));
};
const AvatarsWithText = (props) => {
    var _a, _b;
    const childArray = react.Children.toArray(props.avatars);
    const childCount = (0,react.isValidElement)(childArray[0])
        ? (_b = (_a = childArray[0].props) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length
        : 0;
    const shouldRenderGap = childCount > 3 && props.size !== 40;
    return ((0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": props.ariaLabel, css: AvatarsWithText_Styles.root(shouldRenderGap), "data-multiline": props.multiline ? '' : undefined, "data-size": props.size },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: AvatarsWithText_Styles.avatars }, props.avatars),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: AvatarsWithText_Styles.content }, props.children)));
};
//# sourceMappingURL=AvatarsWithText.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Img/Img.js + 15 modules
var Img = __webpack_require__(77509);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Article/Article.js











const labelBackgroundColorConfig = {
    primary: 'blue10',
    secondary: 'peach',
    neutral: 'neutral300',
};
const Article_Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('Article', [
    'imageMarginBottom',
    'titleMargin',
    'labelBackgroundColor',
]);
const Article_Styles = (0,labelStyles/* labelStyles */.B)('Article', {
    root: emotion_react_browser_esm/* css */.iv `
    display: flex;
    position: relative;
    background: ${Colors/* Colors.neutral100 */.w.neutral100};
    border: 1px solid ${Colors/* Colors.neutral400 */.w.neutral400};
    transition-property: box-shadow;
    transition-timing-function: ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction};
    transition-duration: ${Animation/* Animation.transitionDuration */.f.transitionDuration};
    border-radius: 3px;
    &:hover,
    &:focus,
    &:focus-within {
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      box-shadow: ${Shadows/* Shadows.elevation10 */.f.elevation10};
    }

    &[data-layout='card'] {
      flex-direction: column;
    }

    &[data-layout='row'] {
      flex-direction: row;
      align-items: center;
      padding: 30px 0;
    }

    &[data-size='medium'] {
      ${Article_Vars.imageMarginBottom}: 25px;
      ${Article_Vars.titleMargin}: 20px;
      height: max-content;
    }
  `,
    image: emotion_react_browser_esm/* css */.iv `
    position: relative;
    overflow: hidden;
    border-radius: 3px 3px 0 0;

    &[data-layout='card'] {
      margin-bottom: var(${Article_Vars.imageMarginBottom});
      padding-bottom: 50%; // 2:1 ratio
    }

    &[data-layout='row'] {
      border-radius: 3px;
      margin-left: 30px;
      margin-right: 30px;
      width: 370px;
      height: 185px; // 2:1 ratio
    }
  `,
    imageInner: emotion_react_browser_esm/* css */.iv `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
  `,
    content: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: column;
    border-radius: 0 0 3px 3px;
    padding: 0 20px 30px;
    flex: unset;

    &[data-showimg='false'] {
      padding: 30px 20px;
    }

    &[data-layout='row'] {
      padding: 0;
      border-radius: 0;
      flex: 1;
    }

    /* if the card is in row layout with no image we need to apply horizontal padding to the content */
    &[data-rownoimg='true'] {
      padding: 0 30px;
    }
  `,
    title: emotion_react_browser_esm/* css */.iv `
    &[class] {
      order: 2;
      ${Typography/* Typography.sectionHeader3Semibold */.ZT.sectionHeader3Semibold};
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      margin-bottom: var(${Article_Vars.titleMargin});
      transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
      text-decoration: none;
      &:hover,
      &:focus {
        color: ${Colors/* Colors.neutral800 */.w.neutral800};
      }

      // This pseudo element stretches over the entire Article
      // to make the entire Article clickable while preserving
      // accessibilty by not nesting <a /> tags.
      &::before {
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      &[data-lastelement='true'] {
        margin-bottom: 0;
      }
    }
  `,
    metaInfo: emotion_react_browser_esm/* css */.iv `
    // Ensure meta info renders above rest of clickable Article
    // in case any of the meta info is interactive.
    position: relative;
    z-index: 2;
    order: 4;
    display: flex;
    align-items: center;
    color: ${Colors/* Colors.gray60 */.w.gray60};
    ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1};
  `,
    meta: emotion_react_browser_esm/* css */.iv `
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  `,
    metaItem: emotion_react_browser_esm/* css */.iv `
    display: flex;
    align-items: center;
    &:not(:last-child) {
      &::after {
        content: '•';
        margin: 0 5px;
      }
    }
  `,
    description: emotion_react_browser_esm/* css */.iv `
    order: 3;
    margin-bottom: 20px;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    &[data-size='medium'] {
      ${Typography/* Typography.paragraph3 */.ZT.paragraph3};
    }

    &[data-layout='row'] {
      ${Typography/* Typography.paragraph1Short */.ZT.paragraph1Short};
    }

    &[data-lastelement='true'] {
      margin-bottom: 0;
    }
  `,
    category: emotion_react_browser_esm/* css */.iv `
    order: 1;
    position: relative;
    // Ensure clickable category renders above rest of clickable Article
    z-index: 2;
    ${Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold};
    margin-bottom: 10px;
  `,
    label: (labelVariant = 'neutral') => emotion_react_browser_esm/* css */.iv `
    order: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    text-align: center;
    ${Article_Vars.labelBackgroundColor}: ${Colors/* Colors */.w[labelBackgroundColorConfig[labelVariant]]};
    background-color: var(${Article_Vars.labelBackgroundColor});
    border-radius: 100px;
    ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    padding: 4px 8px;
    margin-bottom: 10px;
    width: max-content;
  `,
});
const ArticleTag = ({ label, labelIcon = 'fileFilled', labelVariant = 'neutral', }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Article_Styles.label(labelVariant) },
        labelIcon && (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: labelIcon, size: 18 }),
        (0,isolateComponent/* isolateComponent */.U)("span", null, label)));
};
const Article = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("article", { css: Article_Styles.root, "data-layout": props.layout, "data-size": "medium" },
        props.imageUrl && ((0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.image, "data-layout": props.layout },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.imageInner },
                (0,isolateComponent/* isolateComponent */.U)(Img/* Img */.E, { alt: "", ariaHidden: true, aspectRatio: "2:1", borderRadius: 0, isBlock: true, loading: "lazy", objectFit: "cover", sizes: "100vw", src: props.imageUrl })))),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.content, "data-layout": props.layout, "data-showimg": !!props.imageUrl, "data-rownoimg": props.layout === 'row' && !props.imageUrl },
            (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: Article_Styles.title, color: null, href: props.url, "data-lastelement": !props.author && !props.description },
                    (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, null, props.title))),
            props.description && ((0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.description, "data-size": "medium", "data-layout": props.layout, "data-lastelement": !props.author }, props.description)),
            props.author && ((0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.metaInfo },
                (0,isolateComponent/* isolateComponent */.U)(AvatarsWithText, { avatars: (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { ariaHidden: true, isBlock: true, name: props.author.name, size: 40, url: props.author.imageUrl }), multiline: true, size: 40 },
                    (0,isolateComponent/* isolateComponent */.U)(AvatarText, { ariaLabel: `by ${props.author.name}`, kind: "heavy" }, props.author.name),
                    props.meta))),
            props.label && ((0,isolateComponent/* isolateComponent */.U)(ArticleTag, { label: props.label, labelIcon: props.labelIcon, labelVariant: props.labelVariant })),
            props.category && props.categoryUrl && !props.label && ((0,isolateComponent/* isolateComponent */.U)("div", { css: Article_Styles.category },
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { ariaLabel: `Categorized under ${props.category}`, href: props.categoryUrl }, props.category))))));
};
const ArticleMeta = (props) => {
    const children = react.Children.toArray(props.children)
        .filter(Boolean)
        .map((child, i) => {
        return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Article_Styles.metaItem, key: i }, child));
    });
    return ((0,isolateComponent/* isolateComponent */.U)(AvatarText, { kind: "light" },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: Article_Styles.meta }, children)));
};
const ArticleReadTime = (props) => {
    return (0,isolateComponent/* isolateComponent */.U)("div", null,
        props.minutes,
        " min read");
};
const ArticleDate = (props) => {
    return (0,isolateComponent/* isolateComponent */.U)(dist/* DateTime */.ou, { date: props.date });
};
//# sourceMappingURL=Article.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/md5/md5.js
var md5 = __webpack_require__(68762);
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);
;// CONCATENATED MODULE: ./src/components/Article/Article.tsx





function Article_Article(props) {
    var getGravatarUrl = function() {
        return props.authorEmail && "https://www.gravatar.com/avatar/" + md5_default()(props.authorEmail) + "?d=https://secure.gravatar.com/avatar/b9fa8353122853002d8dcffc2c775182";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
        author: {
            name: props.authorName,
            imageUrl: props.authorImageUrl || getGravatarUrl()
        },
        category: props.category,
        categoryUrl: props.categoryUrl,
        description: props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
            html: props.description
        }),
        imageUrl: props.imageUrl,
        label: props.label,
        labelIcon: props.labelIcon,
        labelVariant: props.labelVariant,
        layout: props.layout,
        meta: (props.metaDate || props.metaReadTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleMeta, {
            children: [
                props.metaDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleDate, {
                    date: props.metaDate
                }),
                props.metaReadTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleReadTime, {
                    minutes: props.metaReadTime
                })
            ]
        }),
        size: "medium",
        title: props.title,
        url: props.url
    });
}

;// CONCATENATED MODULE: ./src/components/Article/fixtures.ts
var Article_fixtures_DEFAULT_VALUES = {
    authorImageUrl: "https://cdn.zappy.app/8f151269c2bb9ba9e1b06a65fcd6f65c.png",
    authorName: "Bryan Helmig",
    description: "<p>An automation mindset can help you use automation across your entire business, getting more done in less time</p>",
    imageUrl: "https://cdn.zappy.app/f06d6d51b2788f4972912671fde3b6d2.jpeg",
    layout: "card",
    title: "Thinking with an automation mindset",
    url: "/blog/thinking-with-an-automation-mindset/"
};

;// CONCATENATED MODULE: ./src/components/Article/Article.builder.ts




/* harmony default export */ var Article_builder = (createBuilderModule(Article_Article, {
    name: "Article",
    image: "https://cdn.zappy.app/1a634bb631bc562d9e341eb75fa9ee5e.svg",
    inputs: [
        {
            name: "layout",
            type: "string",
            enum: [
                "card",
                "row"
            ],
            required: true,
            defaultValue: Article_fixtures_DEFAULT_VALUES.layout
        },
        {
            name: "url",
            type: "string",
            required: true,
            defaultValue: Article_fixtures_DEFAULT_VALUES.url
        },
        {
            name: "imageUrl",
            type: "cloudinaryImage",
            required: true,
            defaultValue: Article_fixtures_DEFAULT_VALUES.imageUrl
        },
        {
            name: "title",
            type: "string",
            required: true,
            defaultValue: Article_fixtures_DEFAULT_VALUES.title
        },
        {
            name: "description",
            type: "richText",
            defaultValue: Article_fixtures_DEFAULT_VALUES.description
        },
        {
            name: "authorName",
            type: "string",
            required: true,
            defaultValue: Article_fixtures_DEFAULT_VALUES.authorName
        },
        {
            name: "authorImageUrl",
            type: "cloudinaryImage",
            defaultValue: Article_fixtures_DEFAULT_VALUES.authorImageUrl
        },
        {
            name: "authorEmail",
            type: "string",
            helperText: "Used for Gravatar if author image URL isn't provided"
        },
        {
            name: "category",
            type: "string"
        },
        {
            name: "categoryUrl",
            type: "string"
        },
        {
            name: "label",
            type: "string"
        },
        {
            name: "labelIcon",
            type: "string",
            enum: Object.values(ICON_NAMES)
        },
        {
            name: "labelVariant",
            type: "string",
            enum: [
                "primary",
                "secondary",
                "neutral"
            ]
        },
        {
            name: "metaDate",
            type: "date"
        },
        {
            name: "metaReadTime",
            type: "number"
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/global/types.ts

var ContentStyle;
(function(ContentStyle) {
    ContentStyle["paragraph1"] = "paragraph1";
    ContentStyle["paragraph1Bold"] = "paragraph1Bold";
    ContentStyle["paragraph1Short"] = "paragraph1Short";
    ContentStyle["paragraph1ShortBold"] = "paragraph1ShortBold";
    ContentStyle["paragraph3"] = "paragraph3";
    ContentStyle["paragraph3Bold"] = "paragraph3Bold";
})(ContentStyle || (ContentStyle = {}));
var CtaStyle;
(function(CtaStyle) {
    CtaStyle["primary"] = "primary";
    CtaStyle["primary-alt"] = "primary-alt";
    CtaStyle["secondary"] = "secondary";
    CtaStyle["tertiary"] = "tertiary";
})(CtaStyle || (CtaStyle = {}));
var TextPlacement;
(function(TextPlacement) {
    TextPlacement["left"] = "left";
    TextPlacement["right"] = "right";
})(TextPlacement || (TextPlacement = {}));
var MobileTextPlacement;
(function(MobileTextPlacement) {
    MobileTextPlacement["top"] = "top";
    MobileTextPlacement["bottom"] = "bottom";
})(MobileTextPlacement || (MobileTextPlacement = {}));
var HeadingStyle;
(function(HeadingStyle) {
    HeadingStyle["pageHeader3"] = "pageHeader3";
    HeadingStyle["pageHeader5"] = "pageHeader5";
    HeadingStyle["sectionHeader3"] = "sectionHeader3";
    HeadingStyle["paragraph1Bold"] = "paragraph1Bold";
})(HeadingStyle || (HeadingStyle = {}));
var CTASectionVariant;
(function(CTASectionVariant) {
    CTASectionVariant["standard"] = "standard";
    CTASectionVariant["filled"] = "filled";
    CTASectionVariant["centered"] = "centered";
})(CTASectionVariant || (CTASectionVariant = {}));

var HeroVariant;
(function(HeroVariant) {
    HeroVariant["standard"] = "Standard";
    HeroVariant["colorBlock"] = "Color Block";
    HeroVariant["features"] = "Features";
})(HeroVariant || (HeroVariant = {}));

;// CONCATENATED MODULE: ./src/builder/element-factories.ts


/**
 * BuilderElement factory. API inspired by React.createElement
 * @see createElement
 * @example
 *  builderElement('SomeComponent', {title: 'A title'})
 *  builderElement('SomeComponent', {title: 'A title'}, childElement)
 */ function builderElement(name, options) {
    for(var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        children[_key - 2] = arguments[_key];
    }
    return {
        "@type": "@builder.io/sdk:Element",
        component: {
            name: name,
            options: options
        },
        children: children
    };
}
/**
 * Img Factory
 * @param options
 */ function imgElement(options) {
    return builderElement("img", (0,src_object_spread/* default */.Z)({
        alt: "This is alt text"
    }, options));
}
/**
 * Block factory
 */ function blockElement(_param) {
    var mediaSrc = _param.mediaSrc, options = _objectWithoutProperties(_param, [
        "mediaSrc"
    ]);
    var blockDefaults = {
        align: "left",
        content: "Default content",
        contentStyle: "paragraph1",
        headingStyle: "sectionHeader3",
        isPageWidth: true,
        textPlacement: "left",
        mobileTextPlacement: "bottom"
    };
    return builderElement("Block", (0,src_object_spread/* default */.Z)({}, blockDefaults, options), imgElement({
        src: mediaSrc
    }));
}

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/ContentSection/ContentSection.js

const ContentSection_Styles = (0,labelStyles/* labelStyles */.B)('ContentSection', {
    root: (props) => [
        {
            maxWidth: 1280,
            margin: '0 auto',
        },
        (0,withModifier/* withModifier */.Q)(props.size, {
            small: { padding: '0 10px' },
            medium: { padding: '0 20px' },
            large: { padding: '0 40px' },
        }[props.size]),
    ],
});
const ContentSection = (props) => ((0,isolateComponent/* isolateComponent */.U)("div", { css: ContentSection_Styles.root(props) }, props.children));
ContentSection.defaultProps = {
    size: 'small',
};
//# sourceMappingURL=ContentSection.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Text/Text.js
var Text_Text = __webpack_require__(55414);
// EXTERNAL MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js + 9 modules
var core_browser_esm = __webpack_require__(39503);
;// CONCATENATED MODULE: ./src/utils/getResponsiveStyles.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 



// Avoid applying a `max-width` so that we can allow a cascading effect to
// happen, e.g. tablet styles will apply if desktop styles are not provided.
var mediaQueries = {
    mobile: "@media (min-width: 0)",
    tablet: "@media (min-width: 660px)",
    desktop: "@media (min-width: 1024px)"
};
var getResponsiveStyles = function(styles) {
    return [
        (0,_define_property/* default */.Z)({}, mediaQueries.mobile, (0,core_browser_esm/* css */.iv)(styles.mobile) || {}),
        (0,_define_property/* default */.Z)({}, mediaQueries.tablet, (0,core_browser_esm/* css */.iv)(styles.tablet) || {}),
        (0,_define_property/* default */.Z)({}, mediaQueries.desktop, (0,core_browser_esm/* css */.iv)(styles.desktop) || {}), 
    ];
};
// returns the responsive styles as a single object instead of an array
// useful for nested styles such as pseudo-elements like ::before
var getResponsiveStylesObject = function(styles) {
    return getResponsiveStyles(styles).reduce(function(acc, style) {
        return _object_spread({}, acc, style);
    }, {});
};
var visibleOnlyOnMobile = getResponsiveStyles({
    mobile: {
        display: "inherit",
        visibility: "visible"
    },
    tablet: {
        display: "none",
        visibility: "hidden"
    },
    desktop: {
        display: "none",
        visibility: "hidden"
    }
});
var visibleOnlyOnTablet = getResponsiveStyles({
    mobile: {
        display: "none",
        visibility: "hidden"
    },
    tablet: {
        display: "inherit",
        visibility: "visible"
    },
    desktop: {
        display: "none",
        visibility: "hidden"
    }
});
var visibleOnlyOnDesktop = getResponsiveStyles({
    mobile: {
        display: "none",
        visibility: "hidden"
    },
    tablet: {
        display: "none",
        visibility: "hidden"
    },
    desktop: {
        display: "inherit",
        visibility: "visible"
    }
});
var hiddenOnMobile = getResponsiveStyles({
    mobile: {
        display: "none",
        visibility: "hidden"
    },
    tablet: {
        display: "inherit",
        visibility: "visible"
    },
    desktop: {
        display: "inherit",
        visibility: "visible"
    }
});
var hiddenOnTabletAndMobile = getResponsiveStyles({
    mobile: {
        display: "none",
        visibility: "hidden"
    },
    tablet: {
        display: "none",
        visibility: "hidden"
    },
    desktop: {
        display: "inherit",
        visibility: "visible"
    }
});
var hiddenOnDesktop = getResponsiveStyles({
    mobile: {
        display: "inherit",
        visibility: "visible"
    },
    tablet: {
        display: "inherit",
        visibility: "visible"
    },
    desktop: {
        display: "none",
        visibility: "hidden"
    }
});
var VisibleOnlyOnMobile = function(param) {
    var children = param.children;
    if (false) {}
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: visibleOnlyOnMobile
    }, children);
};

;// CONCATENATED MODULE: ./src/components/Block/Link.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 




var Link_Link = function(_param) {
    var href = _param.href, ctaText = _param.ctaText, ctaGoal = _param.ctaGoal, ctaName = _param.ctaName, children = _param.children, restProps = _objectWithoutProperties(_param, [
        "href",
        "ctaText",
        "ctaGoal",
        "ctaName",
        "children"
    ]);
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var handleClick = function() {
        emitCTAClickEvent({
            type: avro/* CTAType.cta_link */.g8.cta_link,
            text: ctaText,
            section: "Block",
            href: href
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: ctaName,
            cta_raw_text: ctaText,
            cta_goal: ctaGoal,
            link_destination: href
        });
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link/* Link */.r, Object.assign({}, restProps, {
        href: href,
        onClick: handleClick
    }), children);
};

;// CONCATENATED MODULE: ./src/components/Block/CTA.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 





var CTA = function(param) {
    var ctaGoal = param.ctaGoal, ctaName = param.ctaName, ctaHref = param.ctaHref, _ctaStyle = param.ctaStyle, ctaStyle = _ctaStyle === void 0 ? "primary" : _ctaStyle, ctaText = param.ctaText;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var ctaProps = {
        color: ctaStyle,
        href: ctaHref,
        isFullWidth: false
    };
    var handleClick = function() {
        emitCTAClickEvent({
            text: ctaText,
            href: ctaHref,
            section: "Block",
            type: isTertiary ? avro/* CTAType.cta_link */.g8.cta_link : avro/* CTAType.cta_button */.g8.cta_button
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: ctaName,
            cta_raw_text: ctaText,
            cta_goal: ctaGoal,
            link_destination: ctaHref
        });
    };
    var isTertiary = ctaStyle === CtaStyle.tertiary;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, isTertiary ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        "data-testid": "cta-block",
        href: ctaHref,
        onClick: handleClick,
        weight: "bold"
    }, ctaText) : /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: hiddenOnMobile
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* Button */.z, Object.assign({
        "data-testid": "cta-block",
        onClick: handleClick
    }, ctaProps), ctaText)), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisibleOnlyOnMobile, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* Button */.z, Object.assign({
        "data-testid": "cta-block",
        onClick: handleClick,
        size: "small"
    }, ctaProps), ctaText))));
};

;// CONCATENATED MODULE: ./src/components/Block/blockContext.tsx


var BlockContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var useBlockContext = function() {
    return useContext(BlockContext);
};
function BlockContextProvider(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isHover = ref[0], setHover = ref[1];
    var ref1 = (0,react.useState)(false), isActive = ref1[0], setActive = ref1[1];
    var handleMouseEnter = function() {
        return setHover(true);
    };
    var handleMouseDown = function() {
        return setActive(true);
    };
    var handleMouseLeave = function() {
        setHover(false);
        setActive(false);
    };
    var context = (0,react.useMemo)(function() {
        return {
            isHover: isHover,
            isActive: isActive
        };
    }, [
        isHover,
        isActive
    ]);
    var handlers = {
        onMouseEnter: handleMouseEnter,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContext.Provider, {
        value: context,
        children: children(handlers)
    });
}

;// CONCATENATED MODULE: ./src/components/Block/useBlockContext.tsx


var useBlockContext_useBlockContext = function() {
    return (0,react.useContext)(BlockContext);
};
/* harmony default export */ var Block_useBlockContext = (useBlockContext_useBlockContext);

;// CONCATENATED MODULE: ./src/components/Block/Block.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 


function Block_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    Block_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Block_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: ",
        ";\n    display: flex;\n    flex-direction: column;\n    text-align: ",
        ";\n  "
    ]);
    Block_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Block_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n      flex-direction: ",
        ";\n\n      ",
        " {\n        align-items: center;\n        flex-direction: ",
        ";\n      }\n    "
    ]);
    Block_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Block_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: ",
        ";\n    display: flex;\n    flex-direction: column;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  "
    ]);
    Block_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Block_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      text-align: ",
        ";\n\n      ",
        " {\n        align-items: flex-start;\n        justify-content: center;\n        margin-right: ",
        "px;\n        margin-left: ",
        "px;\n        text-align: left;\n        width: 50%;\n      }\n    "
    ]);
    Block_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Block_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    Block_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Block_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        width: 50%;\n      }\n    "
    ]);
    Block_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Block_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    Block_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}











var BlockHeadingTag;
(function(BlockHeadingTag) {
    BlockHeadingTag["h1"] = "h1";
    BlockHeadingTag["h2"] = "h2";
    BlockHeadingTag["h3"] = "h3";
})(BlockHeadingTag || (BlockHeadingTag = {}));
/**
 * @deprecated
 * This component has been deprecated. `BlockGridItem` should be used instead.
 */ function Block(_param) {
    var _isLink = _param.isLink, isLink = _isLink === void 0 ? false : _isLink, content = _param.content, ctaHref = _param.ctaHref, ctaGoal = _param.ctaGoal, ctaName = _param.ctaName, restProps = _objectWithoutProperties(_param, [
        "isLink",
        "content",
        "ctaHref",
        "ctaGoal",
        "ctaName"
    ]);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSection, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(BlockContextProvider, null, function(param) {
        var onMouseEnter = param.onMouseEnter, onMouseDown = param.onMouseDown, onMouseLeave = param.onMouseLeave;
        return isLink ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link_Link, {
            ctaGoal: ctaGoal,
            ctaName: ctaName,
            ctaText: content,
            href: ctaHref,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(BlockContent, Object.assign({}, restProps, {
            content: content,
            isLink: true
        }))) : /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(BlockContent, Object.assign({}, restProps, {
            content: content,
            ctaGoal: ctaGoal,
            ctaHref: ctaHref,
            ctaName: ctaName
        }));
    }));
}
var BlockContent = function(_param) /*#__PURE__*/ {
    var content = _param.content, _align = _param.align, align = _align === void 0 ? "left" : _align, _textPlacement = _param.textPlacement, textPlacement = _textPlacement === void 0 ? TextPlacement.right : _textPlacement, _mobileTextPlacement = _param.mobileTextPlacement, mobileTextPlacement = _mobileTextPlacement === void 0 ? MobileTextPlacement.bottom : _mobileTextPlacement, _isLink = _param.isLink, isLink = _isLink === void 0 ? false : _isLink, ctaHref = _param.ctaHref, ctaGoal = _param.ctaGoal, ctaName = _param.ctaName, media = _param.media, _isPageWidth = _param.isPageWidth, isPageWidth = _isPageWidth === void 0 ? false : _isPageWidth, icon = _param.icon, restProps = _objectWithoutProperties(_param, [
        "content",
        "align",
        "textPlacement",
        "mobileTextPlacement",
        "isLink",
        "ctaHref",
        "ctaGoal",
        "ctaName",
        "media",
        "isPageWidth",
        "icon"
    ]);
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
        align: align,
        isPageWidth: isPageWidth,
        mobileTextPlacement: mobileTextPlacement,
        textPlacement: textPlacement
    }, icon && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        color: "blue",
        name: icon,
        size: 50
    })), media && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(MediaContainer, {
        isPageWidth: isPageWidth
    }, media), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(BlockText, Object.assign({}, restProps, {
        align: align,
        content: content,
        ctaGoal: ctaGoal,
        ctaHref: ctaHref,
        ctaName: ctaName,
        isLink: isLink,
        isPageWidth: isPageWidth,
        mobileTextPlacement: mobileTextPlacement,
        textPlacement: textPlacement
    })));
};
function BlockText(param) {
    var _align = param.align, align = _align === void 0 ? "left" : _align, _textPlacement = param.textPlacement, textPlacement = _textPlacement === void 0 ? TextPlacement.right : _textPlacement, _mobileTextPlacement = param.mobileTextPlacement, mobileTextPlacement = _mobileTextPlacement === void 0 ? MobileTextPlacement.bottom : _mobileTextPlacement, content = param.content, _contentStyle = param.contentStyle, contentStyle = _contentStyle === void 0 ? ContentStyle.paragraph1Short : _contentStyle, _isLink = param.isLink, isLink = _isLink === void 0 ? false : _isLink, ctaText = param.ctaText, ctaHref = param.ctaHref, ctaGoal = param.ctaGoal, ctaName = param.ctaName, ctaStyle = param.ctaStyle, secondaryCtaText = param.secondaryCtaText, secondaryCtaHref = param.secondaryCtaHref, secondaryCtaGoal = param.secondaryCtaGoal, secondaryCtaName = param.secondaryCtaName, secondaryCtaStyle = param.secondaryCtaStyle, heading = param.heading, _headingStyle = param.headingStyle, headingStyle = _headingStyle === void 0 ? HeadingStyle.pageHeader5 : _headingStyle, _headingTag = param.// Assume within a Section and / or under appropriate h2
    headingTag, headingTag = _headingTag === void 0 ? BlockHeadingTag.h3 : _headingTag, _isPageWidth = param.isPageWidth, isPageWidth = _isPageWidth === void 0 ? false : _isPageWidth, smallText = param.smallText, superTitle = param.superTitle;
    if (!content.length) {
        throw new Error("Block content is required");
    }
    var withHoverColor = function(color) {
        var isHover = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return isHover ? "inherit" : color;
    };
    var _obj;
    var responsiveContentStyleMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph1, ContentStyle.paragraph3), (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph1Bold, ContentStyle.paragraph3Bold), (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph1Short, ContentStyle.paragraph3), (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph1ShortBold, ContentStyle.paragraph3Bold), (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph3, ContentStyle.paragraph3), (0,_define_property/* default */.Z)(_obj, ContentStyle.paragraph3Bold, ContentStyle.paragraph3Bold), _obj);
    var isPrimaryCta = Boolean(ctaText && ctaHref && ctaGoal && ctaName);
    var isSecondaryCta = Boolean(secondaryCtaText && secondaryCtaHref && secondaryCtaGoal && secondaryCtaName);
    var context = Block_useBlockContext();
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(TextContainer, {
        align: align,
        isPageWidth: isPageWidth,
        mobileTextPlacement: mobileTextPlacement,
        textPlacement: textPlacement
    }, superTitle && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray60", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 5px 0",
        tag: "p",
        type: "superTitle1"
    }, superTitle), heading && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 10px 0",
        tag: headingTag,
        type: HeadingStyle[headingStyle]
    }, heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: hiddenOnMobile
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray80", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 10px 0",
        tag: "div",
        type: ContentStyle[contentStyle]
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: content
    }))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisibleOnlyOnMobile, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray80", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 10px 0",
        tag: "div",
        type: responsiveContentStyleMap[contentStyle]
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: content
    }))), smallText && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: hiddenOnMobile
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray80", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 10px 0",
        tag: "p",
        type: "paragraph3"
    }, smallText)), smallText && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisibleOnlyOnMobile, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Text_Text/* Text */.x, {
        color: withHoverColor("gray80", context === null || context === void 0 ? void 0 : context.isHover),
        hasTransition: false,
        margin: "0 0 10px 0",
        tag: "p",
        type: "smallPrint1"
    }, smallText)), isPrimaryCta && !isLink && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CTA, {
        ctaGoal: ctaGoal,
        ctaHref: ctaHref,
        ctaName: ctaName,
        ctaStyle: ctaStyle,
        ctaText: ctaText
    }), isSecondaryCta && !isLink && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SecondaryCtaContainer, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CTA, {
        ctaGoal: secondaryCtaGoal,
        ctaHref: secondaryCtaHref,
        ctaName: secondaryCtaName,
        ctaStyle: secondaryCtaStyle,
        ctaText: secondaryCtaText
    })));
}
var alignItems = {
    left: "flex-start",
    right: "flex-end",
    center: "center"
};
var IconContainer = emotion_styled_browser_esm/* default.div */.Z.div(Block_templateObject());
var Container = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var align = param.align, textPlacement = param.textPlacement, mobileTextPlacement = param.mobileTextPlacement, isPageWidth = param.isPageWidth;
    return [
        (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject1(), alignItems[align], align),
        isPageWidth && (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject2(), mobileTextPlacement === MobileTextPlacement.top ? "column-reverse" : "column", responsive/* mediaQueries.desktop */.w5.desktop, textPlacement === TextPlacement.left ? "row-reverse" : "row"), 
    ];
});
var TextContainer = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var align = param.align, textPlacement = param.textPlacement, mobileTextPlacement = param.mobileTextPlacement, isPageWidth = param.isPageWidth;
    return [
        (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject3(), alignItems[align], mobileTextPlacement === MobileTextPlacement.bottom ? "20px" : "0", mobileTextPlacement === MobileTextPlacement.top ? "20px" : "0", responsive/* mediaQueries.desktop */.w5.desktop),
        isPageWidth && (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject4(), align, responsive/* mediaQueries.desktop */.w5.desktop, textPlacement === TextPlacement.left ? 60 : 0, textPlacement === TextPlacement.left ? 0 : 60), 
    ];
});
var MediaContainer = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var isPageWidth = param.isPageWidth;
    return [
        (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject5()),
        isPageWidth && (0,emotion_react_browser_esm/* css */.iv)(Block_templateObject6(), responsive/* mediaQueries.desktop */.w5.desktop), 
    ];
});
var SecondaryCtaContainer = emotion_styled_browser_esm/* default.div */.Z.div(Block_templateObject7());

;// CONCATENATED MODULE: ./src/components/Block/Block.builder.tsx











/**
 * Pass Builder's children in as BlockSection.props.media
 *  Note: Favoring withChildren() where possible over custom uiBlocks implementation.
 */ function BlockBuilder(_param) {
    var children = _param.children, otherProps = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, otherProps), {
        media: children
    }));
}
var defaultValues = {
    isPageWidth: false,
    content: "<p>This is default content. Please edit me!</p>",
    contentStyle: ContentStyle.paragraph1Short,
    ctaGoal: events/* CtaGoal.fakeCtaGoal */.LK.fakeCtaGoal,
    ctaHref: "https://zapier.com",
    ctaName: events/* CtaName.fakeCtaName */.XE.fakeCtaName,
    ctaText: "Sign Up",
    heading: "Default heading (edit me)",
    headingStyle: HeadingStyle.sectionHeader3,
    icon: "miscCloud",
    secondaryCtaGoal: events/* CtaGoal.fakeCtaGoal */.LK.fakeCtaGoal,
    secondaryCtaHref: "https://zapier.com",
    secondaryCtaName: events/* CtaName.fakeCtaName */.XE.fakeCtaName,
    secondaryCtaStyle: "tertiary",
    secondaryCtaText: "Learn more",
    smallText: "Default small text (edit me)",
    textPlacement: "left",
    mobileTextPlacement: "bottom"
};
/**
 * @deprecated
 * This component has been deprecated. `BlockGridItem` should be used instead.
 */ /* harmony default export */ var Block_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(BlockBuilder), {
    name: "Block",
    hideFromInsertMenu: true,
    image: "https://cdn.zappy.app/213f0a68702998508b364f372a5f2f5f.png",
    defaultChildren: [
        imgElement({
            src: "https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png"
        }), 
    ],
    inputs: [
        {
            name: "isPageWidth",
            type: "boolean",
            defaultValue: defaultValues.isPageWidth
        },
        {
            name: "textPlacement",
            type: "string",
            enum: Object.keys(TextPlacement),
            defaultValue: defaultValues.textPlacement
        },
        {
            name: "mobileTextPlacement",
            type: "string",
            enum: Object.keys(MobileTextPlacement),
            defaultValue: defaultValues.mobileTextPlacement
        },
        // Heading
        {
            name: "heading",
            type: "string",
            defaultValue: defaultValues.heading
        },
        {
            name: "headingStyle",
            type: "string",
            enum: Object.keys(HeadingStyle),
            defaultValue: defaultValues.headingStyle
        },
        {
            name: "headingTag",
            helperText: 'HTML heading level for heading. Note: Use h1 if using Block as "Hero".',
            type: "string",
            enum: Object.keys(BlockHeadingTag),
            // Assume within a Section and / or under appropriate h2
            defaultValue: BlockHeadingTag.h3
        },
        // Content
        {
            name: "content",
            type: "richText",
            defaultValue: defaultValues.content
        },
        {
            name: "contentStyle",
            type: "string",
            enum: Object.keys(ContentStyle),
            defaultValue: defaultValues.contentStyle
        },
        {
            name: "align",
            type: "string",
            enum: [
                "center",
                "left",
                "right"
            ],
            defaultValue: defaultValues.align
        },
        // CTA
        {
            name: "isLink",
            type: "boolean",
            defaultValue: defaultValues.isLink
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: defaultValues.ctaText
        },
        {
            name: "ctaHref",
            type: "string",
            defaultValue: defaultValues.ctaHref
        },
        {
            name: "ctaStyle",
            type: "string",
            enum: Object.keys(CtaStyle),
            defaultValue: defaultValues.ctaStyle
        },
        {
            name: "ctaName",
            type: "string",
            enum: Object.keys(events/* CtaName */.XE),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.ctaName,
            required: true
        },
        {
            name: "ctaGoal",
            type: "string",
            enum: Object.keys(events/* CtaGoal */.LK),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.ctaGoal,
            required: true
        },
        // Secondary CTA
        {
            name: "secondaryCtaText",
            type: "string",
            defaultValue: defaultValues.secondaryCtaText
        },
        {
            name: "secondaryCtaHref",
            type: "string",
            defaultValue: defaultValues.secondaryCtaHref
        },
        {
            name: "secondaryCtaStyle",
            type: "string",
            enum: Object.keys(CtaStyle),
            defaultValue: defaultValues.secondaryCtaStyle
        },
        {
            name: "secondaryCtaName",
            type: "string",
            enum: Object.keys(events/* CtaName */.XE),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.secondaryCtaName,
            required: true
        },
        {
            name: "secondaryCtaGoal",
            type: "string",
            enum: Object.keys(events/* CtaGoal */.LK),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.secondaryCtaGoal,
            required: true
        },
        // Optional texts
        {
            name: "smallText",
            type: "string",
            defaultValue: defaultValues.smallText
        },
        {
            name: "superTitle",
            type: "string"
        },
        // Optional icon
        {
            name: "icon",
            type: "string",
            enum: [
                ""
            ].concat((0,_to_consumable_array/* default */.Z)(Object.keys(icons.iconNames))),
            defaultValue: defaultValues.icon
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/BlockGrid/BlockGrid.js



const BlockGrid_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const BlockGrid_Styles = (0,labelStyles/* labelStyles */.B)('BlockGrid', {
    root: ({ childrenLength, maxColumns, maxWidth, }) => emotion_react_browser_esm/* css */.iv `
      display: grid;
      align-items: flex-start;
      gap: 50px 30px;
      max-width: ${maxWidth}px;
      margin: auto;
      grid-template-columns: repeat(${childrenLength}, 1fr);

      // Two columns if tablet and two children, otherwise one column.
      @media screen and (max-width: ${BlockGrid_breakpoints.desktop}px) {
        grid-template-columns: repeat(
          ${childrenLength === 2 || maxColumns === 2 ? 2 : 1},
          1fr
        );
      }

      // One column if mobile
      @media screen and (max-width: ${BlockGrid_breakpoints.tablet}px) {
        grid-template-columns: repeat(1, 1fr);
      }
    `,
});
const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }) => {
    const childrenLength = maxColumns || react.Children.toArray(children).length;
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: BlockGrid_Styles.root({ childrenLength, maxColumns, maxWidth }) }, children));
};
//# sourceMappingURL=BlockGrid.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/BlockGrid/BlockGrid.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 






var BlockGrid_BlockGrid_Styles = (0,labelStyles/* labelStyles */.B)("BlockGrid", {
    footer: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        justifyContent: "center",
        paddingTop: "90px"
    })
});
function BlockGrid_BlockGrid(param) {
    var children = param.children, _ctaColor = param.ctaColor, ctaColor = _ctaColor === void 0 ? colors/* SEMANTIC_COLORS.primaryAlt */.kg.primaryAlt : _ctaColor, ctaText = param.ctaText, ctaHref = param.ctaHref, maxColumns = param.maxColumns, sectionHeading = param.sectionHeading, sectionSubheading = param.sectionSubheading, backgroundColor = param.backgroundColor, sectionHeadingSize = param.sectionHeadingSize, builderBlock = param.builderBlock;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var shouldDisplayFooter = !!ctaHref && !!ctaText;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Section, {
        background: backgroundColor,
        contentWidth: "fullWidth",
        heading: sectionHeading,
        headingSize: sectionHeadingSize,
        layerName: builderBlock === null || builderBlock === void 0 ? void 0 : builderBlock.layerName,
        sectionToTrack: events/* SectionName.BlockGrid */.jz.BlockGrid,
        subheading: sectionSubheading
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(BlockGrid, {
        maxColumns: maxColumns
    }, children), shouldDisplayFooter && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: BlockGrid_BlockGrid_Styles.footer
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        color: ctaColor,
        href: ctaHref,
        onClick: function() {
            emitCTAClickEvent({
                text: ctaText,
                href: ctaHref,
                section: "BlockGrid",
                type: avro/* CTAType.cta_link */.g8.cta_link
            });
        }
    }, ctaText)));
}

;// CONCATENATED MODULE: ./src/components/sections/BlockGrid/BlockGrid.builder.ts





/* harmony default export */ var BlockGrid_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(BlockGrid_BlockGrid), {
    name: "BlockGrid",
    image: "https://cdn.zappy.app/71a7c8c0547ac245aebdc925fa5eb32f.png",
    inputs: [
        {
            name: "maxColumns",
            type: "number"
        },
        {
            name: "sectionHeading",
            type: "string"
        },
        {
            name: "sectionHeadingSize",
            type: "string",
            enum: [
                "small",
                "medium",
                "large"
            ]
        },
        {
            name: "sectionSubheading",
            type: "string"
        },
        {
            name: "ctaText",
            type: "string"
        },
        {
            name: "ctaHref",
            type: "string"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: colors/* LIGHT_BACKGROUND_COLORS */.Z5
        },
        {
            name: "ctaColor",
            type: "string",
            enum: colors/* SEMANTIC_COLORS_LIST */.kw
        }, 
    ],
    defaultChildren: Array(3).fill(builderElement("BlockGridItem", {
        heading: "Example heading",
        description: "<p>Example content...</p>"
    }))
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Block/Block.js




const Block_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const ContentStyles = {
    iconContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 15px;
  `,
    mediaContainer: emotion_react_browser_esm/* css */.iv `
    width: 100%;
    margin-bottom: 20px;
  `,
    heading: [
        emotion_react_browser_esm/* css */.iv `
      margin-bottom: 10px;
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    `,
    ],
    description: [
        emotion_react_browser_esm/* css */.iv `
      margin-bottom: 10px;
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      ${Typography/* Typography.paragraph3 */.ZT.paragraph3}

      @media screen and (min-width: ${Block_breakpoints.tablet}px) {
        ${Typography/* Typography.paragraph1Short */.ZT.paragraph1Short}
      }
    `,
    ],
    smallText: [
        emotion_react_browser_esm/* css */.iv `
      margin-bottom: 10px;
      color: ${Colors/* Colors.neutral700 */.w.neutral700};
      ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1}

      @media screen and (min-width: ${Block_breakpoints.tablet}px) {
        ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
      }
    `,
    ],
};
const PrimaryCTAStyles = {
    primaryCtaContainer: emotion_react_browser_esm/* css */.iv `
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: ${Block_breakpoints.tablet}px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
};
const SecondaryCTAStyles = {
    secondaryCtaContainer: emotion_react_browser_esm/* css */.iv `
    margin-top: 10px;

    & > a {
      display: inline-flex;
      align-items: center;
    }
  `,
    secondaryCtaText: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold}
  `,
    secondaryCtaIconContainer: emotion_react_browser_esm/* css */.iv `
    margin-left: 6px;
    height: 24px;
  `,
};
const Block_Styles = (0,labelStyles/* labelStyles */.B)('Block', Object.assign(Object.assign(Object.assign({ container: (isCentered) => [
        emotion_react_browser_esm/* css */.iv `
      background-color: transparent;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      align-items: ${isCentered ? 'center' : 'flex-start'};
      text-align: ${isCentered ? 'center' : 'left'};
    `,
    ], link: emotion_react_browser_esm/* css */.iv `
    &:hover img {
      box-shadow: ${Shadows/* Shadows.elevation20 */.f.elevation20};
    }
  ` }, ContentStyles), PrimaryCTAStyles), SecondaryCTAStyles));
const Block_Content = ({ iconName, iconColor, media, heading, description, smallText, }) => {
    return ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        iconName && ((0,isolateComponent/* isolateComponent */.U)("div", { "data-testid": "icon", css: Block_Styles.iconContainer },
            (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { color: iconColor, name: iconName, size: 50 }))),
        media && (0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.mediaContainer }, media),
        heading && ((0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: Block_Styles.heading }, heading))),
        description && (0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.description }, description),
        smallText && (0,isolateComponent/* isolateComponent */.U)("p", { css: Block_Styles.smallText }, smallText)));
};
const PrimaryCTA = ({ ctaHref, onCtaClick, onCtaKeyDown, ctaText, }) => ((0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.primaryCtaContainer },
    (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "primary", href: ctaHref, onClick: onCtaClick, onKeyDown: onCtaKeyDown, "data-testid": "cta-button" }, ctaText)));
const SecondaryCTA = ({ secondaryCtaHref, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaText, }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.secondaryCtaContainer },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { "data-testid": "cta-secondary-button", href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.secondaryCtaText }, secondaryCtaText))));
};
function Block_Block({ isLink = false, isCentered = false, description, iconName, iconColor = 'blue', media, ctaText, ctaHref, secondaryCtaText, secondaryCtaHref, heading, smallText, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, }) {
    const hasPrimaryCta = Boolean(ctaText && (ctaHref || onCtaClick));
    const hasSecondaryCta = Boolean(secondaryCtaText && (secondaryCtaHref || onSecondaryCtaClick));
    const contentProps = {
        iconName,
        iconColor,
        media,
        heading,
        description,
        smallText,
    };
    const primaryCTAProps = {
        ctaHref,
        onCtaClick,
        onCtaKeyDown,
        ctaText,
    };
    const secondaryCTAProps = {
        secondaryCtaHref,
        onSecondaryCtaClick,
        onSecondaryCtaKeyDown,
        secondaryCtaText,
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Block_Styles.container(isCentered) }, isLink ? ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: ctaHref, "data-testid": "link-wrapper", onClick: onCtaClick, onKeyDown: onCtaKeyDown, css: Block_Styles.link },
        (0,isolateComponent/* isolateComponent */.U)(Block_Content, Object.assign({}, contentProps)))) : ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        (0,isolateComponent/* isolateComponent */.U)(Block_Content, Object.assign({}, contentProps)),
        hasPrimaryCta && (0,isolateComponent/* isolateComponent */.U)(PrimaryCTA, Object.assign({}, primaryCTAProps)),
        hasSecondaryCta && (0,isolateComponent/* isolateComponent */.U)(SecondaryCTA, Object.assign({}, secondaryCTAProps))))));
}
//# sourceMappingURL=Block.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/Video/Video.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 










var Video_obj;
var Video_Styles = (0,labelStyles/* labelStyles */.B)("Video", {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        maxWidth: "100%",
        maxHeight: "100%",
        margin: "0 auto",
        height: "100%"
    }),
    overlay: (0,emotion_react_browser_esm/* css */.iv)({
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        cursor: "pointer",
        border: "none"
    }),
    playIcon: (0,emotion_react_browser_esm/* css */.iv)((Video_obj = {
        width: "64px",
        height: "64px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 253, 249, 0.8)",
        color: Colors/* Colors.neutral700 */.w.neutral700,
        borderRadius: "50%",
        transition: "all 250ms"
    }, (0,_define_property/* default */.Z)(Video_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        width: "96px",
        height: "96px"
    }), (0,_define_property/* default */.Z)(Video_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        width: "128px",
        height: "128px"
    }), (0,_define_property/* default */.Z)(Video_obj, "button:hover &", {
        backgroundColor: "rgba(255, 253, 249, 1)",
        transform: "scale(0.95)",
        color: Colors/* Colors.neutral800 */.w.neutral800
    }), (0,_define_property/* default */.Z)(Video_obj, "& > svg", (0,emotion_react_browser_esm/* css */.iv)({
        width: "50%",
        marginLeft: "7.5%"
    })), Video_obj)),
    video: function(fullHeight) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({
            display: "block",
            maxWidth: "100%",
            maxHeight: "100%"
        }, fullHeight && {
            height: "100%"
        }));
    }
});
function Video(props) {
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), hasBeenStarted = ref[0], setHasBeenStarted = ref[1];
    var ref1 = (0,react.useState)([]), textTracks = ref1[0], setTextTracks = ref1[1];
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    (0,react.useEffect)(function() {
        if (props.textTracks) {
            Promise.all(props.textTracks.map(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(track) {
                    var response, blob;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return fetch(track.textTrackUrl);
                            case 2:
                                response = _ctx.sent;
                                if (response.ok) {
                                    _ctx.next = 5;
                                    break;
                                }
                                return _ctx.abrupt("return", track);
                            case 5:
                                _ctx.next = 7;
                                return response.blob();
                            case 7:
                                blob = _ctx.sent;
                                return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, track), {
                                    textTrackUrl: URL.createObjectURL(blob)
                                }));
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(track) {
                    return _ref.apply(this, arguments);
                };
            }())).then(function(tracks) {
                setTextTracks(tracks);
            });
        }
    }, [
        props.textTracks
    ]);
    (0,react.useEffect)(function() {
        if (videoRef.current && props.playbackRate && props.playbackRate >= 0 && props.playbackRate !== videoRef.current.playbackRate) {
            videoRef.current.playbackRate = props.playbackRate;
        }
    }, [
        props.playbackRate
    ]);
    var play = function() {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };
    var handlePlayEvent = function(event) {
        if (props.onPlay) props.onPlay();
        setHasBeenStarted(true);
        // Only emit a play event when triggered by a user, not by auto play
        if (!props.hideControls && (!props.autoPlay || event.currentTarget.currentTime > 0)) {
            emitUserInteractionEvent({
                event_action: avro/* EventAction.click */.AO.click,
                interaction_name: avro/* InteractionName.video */.AI.video,
                option_selected: "play",
                custom_tracking_fields: {
                    current_time: event.currentTarget.currentTime.toString()
                }
            });
        }
    };
    var handlePauseEvent = function(event) {
        // Only emit a pause event when triggered by a user, not by the video ending
        if (event.currentTarget.currentTime < event.currentTarget.duration) {
            emitUserInteractionEvent({
                event_action: avro/* EventAction.click */.AO.click,
                interaction_name: avro/* InteractionName.video */.AI.video,
                option_selected: "pause",
                custom_tracking_fields: {
                    current_time: event.currentTarget.currentTime.toString()
                }
            });
        }
    };
    var handleSeekedEvent = function(event) {
        // Only emit a seek event when triggered by a user, not by the video looping
        if (!props.loop || props.loop && event.currentTarget.currentTime > 0.01) {
            emitUserInteractionEvent({
                event_action: avro/* EventAction.click */.AO.click,
                interaction_name: avro/* InteractionName.video */.AI.video,
                option_selected: "seek",
                custom_tracking_fields: {
                    current_time: event.currentTarget.currentTime.toString()
                }
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Video_Styles.root
    }, !props.autoPlay && !hasBeenStarted && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
        css: Video_Styles.overlay,
        "data-testid": "video-overlay",
        onClick: play
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Video_Styles.playIcon
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M19.5 12L5 3.63V20.37L19.5 12Z"
    })))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("video", Object.assign({
        autoPlay: props.autoPlay,
        controls: hasBeenStarted && !props.hideControls,
        controlsList: "nodownload noplaybackrate",
        css: Video_Styles.video(props.fullHeight),
        "data-testid": "video",
        disablePictureInPicture: true,
        disableRemotePlayback: true,
        loop: props.loop,
        muted: props.autoPlay,
        onLoadedData: props.onLoadedData,
        onPlay: handlePlayEvent,
        playsInline: props.autoPlay,
        poster: props.posterImageUrl,
        preload: props.autoPlay ? "auto" : "metadata",
        ref: videoRef,
        src: props.videoUrl,
        title: props.title
    }, !props.hideControls && {
        onSeeked: handleSeekedEvent,
        onPause: handlePauseEvent
    }), textTracks.map(function(track, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("track", {
            default: track.default,
            key: index,
            kind: track.type,
            label: track.label,
            src: track.textTrackUrl,
            srcLang: track.language
        });
    })));
}

;// CONCATENATED MODULE: ./src/components/BlockGridItem/BlockGridItem.tsx







function BlockGridItem(_param) {
    var ctaHref = _param.ctaHref, ctaText = _param.ctaText, description = _param.description, imageAltText = _param.imageAltText, imageUrl = _param.imageUrl, isCentered = _param.isCentered, isLink = _param.isLink, secondaryCtaHref = _param.secondaryCtaHref, secondaryCtaText = _param.secondaryCtaText, video = _param.video, restProps = _objectWithoutProperties(_param, [
        "ctaHref",
        "ctaText",
        "description",
        "imageAltText",
        "imageUrl",
        "isCentered",
        "isLink",
        "secondaryCtaHref",
        "secondaryCtaText",
        "video"
    ]);
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var trackCtaEvent = function() {
        if (ctaText && ctaHref) {
            emitCTAClickEvent({
                text: ctaText,
                href: ctaHref,
                section: events/* SectionName.BlockGrid */.jz.BlockGrid
            });
        }
    };
    var handleCtaClick = function() {
        trackCtaEvent();
    };
    var handleCtaKeyDown = function(e) {
        if (e.key === "Enter") {
            trackCtaEvent();
        }
    };
    var trackSecondaryCtaEvent = function() {
        if (secondaryCtaText && secondaryCtaHref) {
            emitCTAClickEvent({
                text: secondaryCtaText,
                href: secondaryCtaHref,
                section: events/* SectionName.BlockGrid */.jz.BlockGrid,
                type: avro/* CTAType.block_grid_item_link */.g8.block_grid_item_link
            });
        }
    };
    var handleSecondaryCtaClick = function() {
        trackSecondaryCtaEvent();
    };
    var handleSecondaryCtaKeyDown = function(e) {
        if (e.key === "Enter") {
            trackSecondaryCtaEvent();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_Block, (0,src_object_spread/* default */.Z)({
        ctaHref: ctaHref,
        ctaText: ctaText,
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            html: description
        }),
        isCentered: isCentered,
        isLink: isLink,
        media: imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
            alt: imageAltText || "",
            src: imageUrl
        }) || (video === null || video === void 0 ? void 0 : video.videoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, (0,src_object_spread/* default */.Z)({}, video)),
        onCtaClick: handleCtaClick,
        onCtaKeyDown: handleCtaKeyDown,
        onSecondaryCtaClick: handleSecondaryCtaClick,
        onSecondaryCtaKeyDown: handleSecondaryCtaKeyDown,
        secondaryCtaHref: secondaryCtaHref,
        secondaryCtaText: secondaryCtaText
    }, restProps));
}

;// CONCATENATED MODULE: ./src/components/Video/Video.builder.ts


var videoInputs = [
    {
        name: "videoUrl",
        type: "cloudinaryMediaLibrary",
        required: true
    },
    {
        name: "title",
        type: "string",
        required: true,
        helperText: "This is what a screen reader will use to describe the video."
    },
    {
        name: "posterImageUrl",
        type: "cloudinaryMediaLibrary"
    },
    {
        name: "textTracks",
        type: "list",
        subFields: [
            {
                name: "textTrackUrl",
                type: "cloudinaryMediaLibrary"
            },
            {
                name: "type",
                type: "string",
                enum: [
                    "subtitles",
                    "captions"
                ]
            },
            {
                name: "label",
                type: "string"
            },
            {
                name: "language",
                type: "string",
                helperText: 'This must be a valid langauage tag like "en-US". Values can be validated with this tool: https://r12a.github.io/app-subtags/'
            },
            {
                name: "default",
                type: "boolean"
            }, 
        ]
    },
    {
        name: "autoPlay",
        type: "boolean",
        helperText: "Note: Enabling auto play also mutes the video in order for it to be allowed by browsers"
    },
    {
        name: "loop",
        type: "boolean"
    },
    {
        name: "hideControls",
        type: "boolean"
    },
    {
        name: "playbackRate",
        type: "number"
    }, 
];
/* harmony default export */ var Video_builder = (createBuilderModule(Video, {
    name: "Video",
    image: "",
    inputs: videoInputs
}));

;// CONCATENATED MODULE: ./src/components/BlockGridItem/BlockGridItem.builder.tsx






/* harmony default export */ var BlockGridItem_builder = (createBuilderModule(BlockGridItem, {
    name: "BlockGridItem",
    image: "https://cdn.zappy.app/213f0a68702998508b364f372a5f2f5f.png",
    inputs: [
        // Icon
        {
            name: "iconName",
            type: "string",
            enum: [
                ""
            ].concat((0,_to_consumable_array/* default */.Z)(Object.keys(icons.iconNames)))
        },
        {
            name: "iconColor",
            type: "string",
            enum: colors/* COLOR_KEYS_LIST */.ji,
            showIf: function(options) {
                return !!options.get("iconName");
            }
        },
        // Media
        {
            name: "imageUrl",
            type: "cloudinaryImage"
        },
        {
            name: "imageAltText",
            type: "string"
        },
        {
            name: "video",
            type: "object",
            subFields: videoInputs
        },
        // Heading
        {
            name: "heading",
            type: "string",
            defaultValue: "Example heading"
        },
        // Description
        {
            name: "description",
            type: "richText",
            defaultValue: "<p>Example content...</p>"
        },
        // Small text
        {
            name: "smallText",
            type: "string"
        },
        // Primary CTA
        {
            name: "ctaText",
            type: "string"
        },
        {
            name: "ctaHref",
            type: "string"
        },
        // Secondary CTA
        {
            name: "secondaryCtaText",
            type: "string"
        },
        {
            name: "secondaryCtaHref",
            type: "string"
        },
        // Toggles
        {
            name: "isLink",
            friendlyName: "Make entire block clickable",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "isCentered",
            friendlyName: "Center align content",
            type: "boolean",
            defaultValue: false
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/constants/stories.ts
var HOW_ZAPIER_WORKS_VIDEO = "fau466af4f";

;// CONCATENATED MODULE: ./src/components/sections/BlockSection/BlockSection.tsx








function BlockSection(_param) {
    var sectionHeading = _param.sectionHeading, sectionSubheading = _param.sectionSubheading, media = _param.media, _background = _param.background, background = _background === void 0 ? colors/* COLOR_KEYS.transparent */.US.transparent : _background, builderBlock = _param.builderBlock, otherProps = _objectWithoutProperties(_param, [
        "sectionHeading",
        "sectionSubheading",
        "media",
        "background",
        "builderBlock"
    ]);
    var getBackground = function() {
        var colorMap = {
            ocean10: colors/* COLOR_KEYS.blue10 */.US.blue10,
            sun10: colors/* COLOR_KEYS.neutral200 */.US.neutral200,
            sun20: colors/* COLOR_KEYS.neutral200 */.US.neutral200,
            lava10: colors/* COLOR_KEYS.cream */.US.cream
        };
        return Object.prototype.hasOwnProperty.call(colorMap, background) ? colorMap[background] : background;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        background: getBackground(),
        contentWidth: "padded",
        heading: sectionHeading,
        layerName: builderBlock === null || builderBlock === void 0 ? void 0 : builderBlock.layerName,
        sectionToTrack: events/* SectionName.BlockSection */.jz.BlockSection,
        subheading: sectionSubheading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, otherProps), {
            isPageWidth: true,
            media: media
        }))
    });
}

;// CONCATENATED MODULE: ./src/components/sections/BlockSection/BlockSection.builder.tsx














/**
 * Pass Builder's children in as BlockSection.props.media
 *  Note: Favoring withChildren() where possible over custom uiBlocks implementation.
 */ function BlockSectionBuilder(_param) {
    var children = _param.children, otherProps = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockSection, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, otherProps), {
        media: children
    }));
}
var inputsToReset = [
    "ctaText",
    "ctaHref",
    "ctaStyle",
    "ctaName",
    "ctaGoal",
    "secondaryCtaText",
    "secondaryCtaHref",
    "secondaryCtaStyle",
    "secondaryCtaName",
    "secondaryCtaGoal",
    "smallText",
    "icon", 
];
var sharedBlockInputs = Block_builder.config.inputs.filter(function(input) {
    return input.name !== "isPageWidth";
}).map(function(input) {
    return inputsToReset.includes(input.name) ? (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, input), {
        defaultValue: undefined
    }) : input;
});
/* harmony default export */ var BlockSection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(BlockSectionBuilder), {
    name: "BlockSection",
    image: "https://cdn.zappy.app/96cd6e766d7dcf818b77a403301fe306.png",
    defaultChildren: [
        builderElement("WistiaVideo", {
            wistiaId: HOW_ZAPIER_WORKS_VIDEO
        }), 
    ],
    /**
   * Block and BlockSection have nearly identical inputs
   */ inputs: [
        {
            name: "background",
            type: "string",
            enum: Object.values(backgroundColors),
            defaultValue: colors/* COLOR_KEYS.transparent */.US.transparent,
            required: true
        },
        // Section Props, optional section heading(s)
        {
            name: "sectionHeading",
            type: "string"
        },
        {
            name: "sectionSubheading",
            type: "string"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(sharedBlockInputs), [
        {
            name: "headingStyle",
            type: "string",
            enum: Object.keys(HeadingStyle),
            defaultValue: HeadingStyle.pageHeader5
        },
        {
            name: "contentStyle",
            type: "string",
            enum: Object.keys(ContentStyle),
            defaultValue: ContentStyle.paragraph1
        }, 
    ])
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Breadcrumbs/Breadcrumbs.js





const Breadcrumbs_Styles = (0,labelStyles/* labelStyles */.B)('Breadcrumbs', {
    root: emotion_react_browser_esm/* css */.iv `
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    &[data-size='large'] {
      ${Typography/* Typography.paragraph1ShortSemibold */.ZT.paragraph1ShortSemibold};
    }
    &[data-size='small'] {
      ${Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold};
    }
  `,
    list: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px 0px;
  `,
    item: emotion_react_browser_esm/* css */.iv `
    display: flex;
    align-items: inherit;
    gap: inherit;
  `,
});
const Breadcrumbs_defaultProps = {
    size: 'large',
};
const Breadcrumbs = (_props) => {
    const props = Object.assign(Object.assign({}, Breadcrumbs_defaultProps), _props);
    const iconSize = {
        small: 20,
        large: 24,
    }[props.size];
    const items = react.Children.toArray(props.children)
        .filter(Boolean)
        .map((link, i, links) => {
        const icon = i !== links.length - 1 && ((0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": "true" },
            (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { css: Breadcrumbs_Styles.icon, isBlock: true, color: "neutral400", name: "arrowSmallRight", size: iconSize })));
        return ((0,isolateComponent/* isolateComponent */.U)("li", { css: Breadcrumbs_Styles.item, key: i },
            link,
            icon));
    });
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Breadcrumbs_Styles.root, "data-size": props.size },
        (0,isolateComponent/* isolateComponent */.U)("ol", { css: Breadcrumbs_Styles.list }, items)));
};
//# sourceMappingURL=Breadcrumbs.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 



var Breadcrumbs_Breadcrumbs_Styles = (0,labelStyles/* labelStyles */.B)("Breadcrumbs", {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        margin: "0 auto",
        maxWidth: "1170px",
        padding: "20px"
    })
});
function Breadcrumbs_Breadcrumbs(props) {
    var ref;
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Breadcrumbs_Breadcrumbs_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Breadcrumbs, {
        size: props.size
    }, (ref = props.links) === null || ref === void 0 ? void 0 : ref.map(function(link) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            href: link.href,
            key: link.href,
            onClick: function() {
                emitUserInteractionEvent({
                    event_action: avro/* EventAction.click */.AO.click,
                    interaction_name: avro/* InteractionName.navigation */.AI.navigation,
                    interaction_raw_text: link.text,
                    option_selected: "breadcrumb_link",
                    destination_href: link.href
                });
            }
        }, link.text);
    }), props.currentPage && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, props.currentPage)));
}

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.builder.ts


/* harmony default export */ var Breadcrumbs_builder = (createBuilderModule(Breadcrumbs_Breadcrumbs, {
    name: "Breadcrumbs",
    image: "https://globalsymbols.com/uploads/production/image/imagefile/3364/13_3364_30369cc3-b4cd-42ce-9385-2aa9f7bf489c.svg",
    inputs: [
        {
            name: "currentPage",
            type: "string"
        },
        {
            name: "size",
            type: "string",
            enum: [
                "small",
                "large"
            ]
        },
        {
            name: "links",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "string",
                    required: true
                },
                {
                    name: "href",
                    type: "string",
                    required: true
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/Card/Card.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var Card_Styles = (0,labelStyles/* labelStyles */.B)("Card", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            padding: "40px 20px",
            backgroundColor: backgroundColor,
            border: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
            borderRadius: "5px",
            boxShadow: "6px 6px 0 ".concat(Colors/* Colors.neutral800 */.w.neutral800)
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "40px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "44px"
        }), _obj));
    },
    heading: function(color) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), (_obj = {
            color: color,
            marginBottom: "8px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7)), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), _obj)));
    },
    subHeading: function(color) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader5Bold */.ZT.subHeader5Bold), (_obj = {
            fontWeight: 600,
            color: color,
            marginBottom: "20px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3Bold */.ZT.subHeader3Bold)), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({
            marginBottom: "40px"
        }, Typography/* Typography.subHeader1Bold */.ZT.subHeader1Bold)), _obj)));
    },
    description: function(color) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            color: color
        }, Typography/* Typography.paragraph3 */.ZT.paragraph3), (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({
            minHeight: "84px"
        }, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short))));
    }
});
function Card(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? colors/* COLOR_KEYS.neutral100 */.US.neutral100 : _backgroundColor, children = param.children, description = param.description, heading = param.heading, subHeading = param.subHeading;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Card_Styles.root(Colors/* Colors */.w[backgroundColor])
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: Card_Styles.heading(colors/* BACKGROUND_TO_FONT_COLORS */.H7[backgroundColor])
    }, heading), subHeading && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h4", {
        css: Card_Styles.subHeading(backgroundColor === colors/* COLOR_KEYS.zapier */.US.zapier ? colors/* BACKGROUND_TO_FONT_COLORS.zapier */.H7.zapier : Colors/* Colors.zapier */.w.zapier)
    }, subHeading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Card_Styles.description(colors/* BACKGROUND_TO_FONT_COLORS */.H7[backgroundColor])
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: description,
        backgroundColor: backgroundColor
    })), children);
}

;// CONCATENATED MODULE: ./src/components/Card/Card.builder.ts




/* harmony default export */ var Card_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(Card), {
    name: "Card",
    image: "https://cdn.zappy.app/d87fedcef4c62762a559c5dd83614817.png",
    inputs: [
        {
            name: "heading",
            type: "string"
        },
        {
            name: "subHeading",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: colors/* BACKGROUND_COLOR_KEYS */.gh
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/BaseButton.js + 1 modules
var BaseButton = __webpack_require__(36897);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/uniqueId.js
var uniqueId = __webpack_require__(61814);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Indicator/Indicator.js




const colorVariations = {
    gray: {
        base: {
            borderColor: Colors/* Colors.gray60 */.w.gray60,
        },
        check: {
            borderColor: Colors/* Colors.ocean */.w.ocean,
        },
        hover: {
            borderColor: Colors/* Colors.ocean */.w.ocean,
        },
        focus: {
            backgroundColor: Colors/* Colors.ocean */.w.ocean,
            borderColor: Colors/* Colors.ocean */.w.ocean,
        },
    },
    white: {
        base: {
            borderColor: Colors/* Colors.white */.w.white,
        },
        check: {
            borderColor: Colors/* Colors.white */.w.white,
        },
        hover: {
            borderColor: Colors/* Colors.white */.w.white,
        },
        focus: {
            backgroundColor: Colors/* Colors.white */.w.white,
            borderColor: Colors/* Colors.white */.w.white,
        },
    },
};
const Indicator_Styles = (0,labelStyles/* labelStyles */.B)('Indicator', {
    input: (props) => [
        {
            position: 'relative',
            appearance: 'none',
            display: 'inline-block',
            borderStyle: 'solid',
            borderWidth: 2,
            borderRadius: '50%',
            width: 10,
            height: 10,
            cursor: 'pointer',
            transitionDuration: Animation/* Animation.transitionDuration */.f.transitionDuration,
            transitionProperty: 'border-width, border-color',
            transitionTimingFunction: Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction,
            '&::before': {
                position: 'absolute',
                height: 16,
                width: 16,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                content: '""',
                opacity: 0,
                transitionDuration: Animation/* Animation.transitionDuration */.f.transitionDuration,
                transitionProperty: 'opacity',
                transitionTimingFunction: Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction,
            },
            '&:checked': {
                borderWidth: 5,
            },
            '&:focus': {
                '&::before': {
                    opacity: 0.25,
                },
            },
            '&:hover': {
                borderWidth: 5,
            },
        },
        (0,withModifier/* withModifier */.Q)(props.color, {
            borderColor: colorVariations[props.color].base.borderColor,
            '&::before': {
                backgroundColor: colorVariations[props.color].focus.backgroundColor,
            },
            '&:checked': {
                borderColor: colorVariations[props.color].check.borderColor,
            },
            '&:focus': {
                borderColor: colorVariations[props.color].focus.borderColor,
            },
            '&:hover': {
                borderColor: colorVariations[props.color].hover.borderColor,
            },
        }),
    ],
    root: (props) => [
        {
            display: 'grid',
            gap: 6,
            gridTemplateColumns: `repeat(${props.count}, 10px)`,
        },
    ],
});
const Indicator = (props) => {
    const { count, selectedIndex, onChangeIndex, ariaLabel, noun } = props;
    const [name] = (0,react.useState)((0,uniqueId/* uniqueId */.E)('Indicator-'));
    const handleOnChange = ({ target }) => {
        const { value } = target;
        const index = parseInt(value, 10);
        onChangeIndex(index);
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": ariaLabel, css: Indicator_Styles.root(props), role: "radiogroup" }, Array.from({ length: count }).map((_, i) => ((0,isolateComponent/* isolateComponent */.U)("input", { "aria-label": `${noun} ${i + 1}`, checked: i === selectedIndex, css: Indicator_Styles.input(props), key: `bubble-${i}`, name: name, onChange: handleOnChange, type: "radio", value: i })))));
};
Indicator.defaultProps = {
    noun: 'page',
};
//# sourceMappingURL=Indicator.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/IconButton/BaseIconButton.js
var BaseIconButton_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIconButton(_a) {
    var { icon, iconSize, isCircle, label, shouldCorrectTooltipPosition, tooltipId, tooltipPosition } = _a, buttonProps = BaseIconButton_rest(_a, ["icon", "iconSize", "isCircle", "label", "shouldCorrectTooltipPosition", "tooltipId", "tooltipPosition"]);
    return ((0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false, tooltipId: tooltipId }, ({ childProps }) => ((0,isolateComponent/* isolateComponent */.U)(BaseButton/* BaseButton */.Y, Object.assign({ ariaLabel: label }, buttonProps, childProps, { isPill: isCircle, isSquare: true }),
        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { canAcceptPointerEvents: false, isBlock: true, name: icon, size: 24 })))));
}
//# sourceMappingURL=BaseIconButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/IconButton/IconButton.js
var IconButton_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


function IconButton(_a) {
    var { color = 'icon-primary', size = 'small', tooltipPosition = 'south' } = _a, props = IconButton_rest(_a, ["color", "size", "tooltipPosition"]);
    return ((0,isolateComponent/* isolateComponent */.U)(BaseIconButton, Object.assign({ color: color, size: size, tooltipPosition: tooltipPosition }, props)));
}
//# sourceMappingURL=IconButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/clamp.js
var clamp = __webpack_require__(37260);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/NumberButton/NumberButton.js
var NumberButton_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


function NumberButton(_a) {
    var { selected, value } = _a, buttonProps = NumberButton_rest(_a, ["selected", "value"]);
    return ((0,isolateComponent/* isolateComponent */.U)(BaseButton/* BaseButton */.Y, Object.assign({}, buttonProps, { color: selected ? 'primary-alt' : 'number', isSquare: true, size: "small" }), value));
}
//# sourceMappingURL=NumberButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Paginator/Paginator.js






const Paginator_Styles = (0,labelStyles/* labelStyles */.B)('Paginator', {
    root: (derivedState, props) => [
        {
            display: 'grid',
            gap: 10,
            gridTemplateColumns: `repeat(${derivedState.numberOfButtons}, 40px)`,
            alignItems: 'center',
        },
        derivedState.isCondensed &&
            (0,withModifier/* withModifier */.Q)('condensed', {
                gridTemplateColumns: '44px 44px min-content 44px 44px',
            }),
        props.isCentered &&
            (0,withModifier/* withModifier */.Q)('isCentered', {
                justifyContent: 'center',
            }),
    ],
    text: [
        (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.base */.ZT.base), { fontSize: 16, lineHeight: '22px', fontWeight: 600, textAlign: 'center', whiteSpace: 'nowrap', color: Colors/* Colors.neutral800 */.w.neutral800 })),
        emotion_react_browser_esm/* css */.iv `
      padding-left: 20px;
      padding-right: 20px;
    `,
    ],
});
const PaginatorText = (props) => {
    const maxChars = `${props.numberOfPages}`.length * 2 + 3;
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Paginator_Styles.text, style: {
            minWidth: `${maxChars}ch`,
        } }, `${props.currentPageIndex + 1} of ${props.numberOfPages}`));
};
const Paginator_defaultProps = {
    condenseAt: 6,
    offset: 0,
};
const Paginator = (_props) => {
    const props = Object.assign(Object.assign({}, Paginator_defaultProps), _props);
    const { currentPageIndex, pageUrls, condenseAt, offset, firstPageUrl, lastPageUrl, } = props;
    const numberOfPages = pageUrls.length;
    const maxPageIndex = numberOfPages - 1;
    const safeCurrentPageIndex = (0,clamp/* clamp */.u)(currentPageIndex, 0, maxPageIndex);
    const prevIndex = Math.max(0, safeCurrentPageIndex - 1);
    const nextIndex = Math.min(maxPageIndex, safeCurrentPageIndex + 1);
    const isCondensed = numberOfPages >= condenseAt;
    const derivedState = {
        numberOfPages,
        isCondensed,
        numberOfButtons: numberOfPages + 2 + [firstPageUrl, lastPageUrl].filter(Boolean).length,
    };
    const createOnPaginateFn = (buttonType, pageIndex, pageUrl) => {
        return (event) => {
            if (props.onPaginate) {
                props.onPaginate({
                    buttonType,
                    pageIndex,
                    pageUrl,
                }, event);
            }
        };
    };
    const content = isCondensed ? ((0,isolateComponent/* isolateComponent */.U)(PaginatorText, { currentPageIndex: safeCurrentPageIndex, numberOfPages: numberOfPages })) : (pageUrls.map((pageUrl, pageIndex) => {
        const isSelected = pageIndex === safeCurrentPageIndex;
        const pageNumber = offset + pageIndex + 1;
        return ((0,isolateComponent/* isolateComponent */.U)(NumberButton, { ariaLabel: isSelected ? `Current page (${pageNumber})` : `${pageNumber}`, href: pageUrl, key: pageUrl || pageNumber, onClick: createOnPaginateFn('number', pageIndex, pageUrl), value: pageNumber, selected: isSelected, hasShadow: isSelected }));
    }));
    const firstPageButtonUrl = firstPageUrl || (isCondensed ? pageUrls[0] : undefined);
    const firstPageButton = (firstPageButtonUrl || isCondensed) && ((0,isolateComponent/* isolateComponent */.U)(IconButton, { ariaLabel: "First page", color: "icon-secondary", disabled: currentPageIndex <= 0, href: firstPageButtonUrl, icon: "arrowLineLeft", onClick: createOnPaginateFn('first', 0, firstPageButtonUrl), tooltipPosition: "southwest" }));
    const lastPageButtonUrl = lastPageUrl || (isCondensed ? pageUrls[maxPageIndex] : undefined);
    const lastPageButton = (lastPageButtonUrl || isCondensed) && ((0,isolateComponent/* isolateComponent */.U)(IconButton, { ariaLabel: "Last page", color: "icon-secondary", disabled: safeCurrentPageIndex >= maxPageIndex, href: lastPageButtonUrl, icon: "arrowLineRight", onClick: createOnPaginateFn('last', maxPageIndex, lastPageButtonUrl), tooltipPosition: "southeast" }));
    return ((0,isolateComponent/* isolateComponent */.U)("nav", { "aria-label": props.ariaLabel, css: [Paginator_Styles.root(derivedState, props)] },
        firstPageButton,
        (0,isolateComponent/* isolateComponent */.U)(IconButton, { ariaLabel: `Previous page (${prevIndex + 1})`, color: "icon-secondary", disabled: safeCurrentPageIndex <= 0, href: pageUrls[prevIndex], icon: "arrowSmallLeft", onClick: createOnPaginateFn('previous', prevIndex, pageUrls[prevIndex]), tooltipPosition: "southwest" }),
        content,
        (0,isolateComponent/* isolateComponent */.U)(IconButton, { ariaLabel: `Next page (${nextIndex + 1})`, color: "icon-secondary", disabled: safeCurrentPageIndex >= maxPageIndex, href: pageUrls[nextIndex], icon: "arrowSmallRight", onClick: createOnPaginateFn('next', nextIndex, pageUrls[nextIndex]), tooltipPosition: "southeast" }),
        lastPageButton));
};
//# sourceMappingURL=Paginator.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/utils/debounce.js
const debounce = (fn, timeoutMs) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            fn(...args);
        }, timeoutMs);
    };
};
//# sourceMappingURL=debounce.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/utils/ensureArray.js
const ensureArray = (value) => Array.isArray(value) ? value : [value];
//# sourceMappingURL=ensureArray.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Carousel/ScrollSnap/ScrollSnap.js






const ScrollSnap_defaultProps = {
    pageIndex: 0,
    scrollSnapAlign: 'start',
    gap: 0,
    alignment: 'left',
};
const ScrollSnap_Styles = (0,labelStyles/* labelStyles */.B)('ScrollSnap', {
    root: () => [
        (0,emotion_react_browser_esm/* css */.iv)({
            width: '100%',
            overflow: 'hidden',
        }),
    ],
    scrollableArea: () => [
        (0,emotion_react_browser_esm/* css */.iv)({
            overflowX: 'auto',
            overscrollBehaviorX: 'none',
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch',
            scrollBehavior: 'smooth',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            scrollbarWidth: 'none',
            '&:focus-visible': {
                outline: `2px solid ${Colors/* Colors.blue */.w.blue}`,
                outlineOffset: '-2px',
            },
        }),
    ],
    scrollingSurface: (props, pageCount, alignment) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: pageCount * props.itemWidth + props.gap * Math.max(pageCount - 1, 0),
        }),
        alignment === 'center' &&
            (0,withModifier/* withModifier */.Q)('centerAligned', {
                margin: '0 auto',
            }),
    ],
    snappable: (props) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            scrollSnapAlign: props.scrollSnapAlign,
            width: props.itemWidth,
        }),
    ],
});
const getSnapPoints = (opts) => {
    const { itemWidth, pageCount, scrollSnapAlign, gap } = opts;
    const snapPointGetter = {
        start: (_v, i) => (itemWidth + gap) * i,
        center: (_v, i) => itemWidth / 2 + i * (itemWidth + gap / 2),
        end: (_v, i) => itemWidth + i * (itemWidth + gap),
    }[scrollSnapAlign];
    return Array.from({ length: pageCount }).map(snapPointGetter);
};
const getSnapThresholds = (opts) => {
    const { itemWidth, scrollSnapAlign, pageCount, gap, clientWidth } = opts;
    const snappingPoints = getSnapPoints(opts);
    const width = itemWidth + gap;
    const stoppingPoint = width * pageCount - clientWidth;
    const snapThresholdGetter = {
        start: (acc, _v, i, src) => {
            let point;
            if (i === 0) {
                point = 0;
            }
            else if (i === 1) {
                point = width / 2;
            }
            else if (i === src.length - 1) {
                point = width * src.length - (clientWidth - width);
            }
            else {
                point = acc[i - 1] + width;
            }
            if (point >= stoppingPoint) {
                const offset = Math.max((stoppingPoint - snappingPoints[i - 1]) / 2, 1);
                point = stoppingPoint - offset;
            }
            acc[i] = point;
            return acc;
        },
        center: (acc, _v, i, src) => {
            if (i === 0) {
                acc[i] = 0;
            }
            else if (i === 1) {
                acc[i] = width + width / 4;
            }
            else if (i === src.length - 1) {
                acc[i] = width * src.length - width * 1.25;
            }
            else {
                acc[i] = width * i;
            }
            return acc;
        },
        end: (acc, _v, i) => {
            if (i === 0) {
                acc[i] = 0;
            }
            else if (i === 1) {
                acc[i] = width * 1.75;
            }
            else {
                acc[i] = i * width + width / 2;
            }
            return acc;
        },
    }[scrollSnapAlign];
    return Array.from({ length: pageCount }).reduce(snapThresholdGetter, []);
};
const DEBOUNCE_MS = 50;
const ScrollSnap = (_props) => {
    var _a;
    const props = Object.assign(Object.assign({}, ScrollSnap_defaultProps), _props);
    const { children, itemWidth, pageIndex, scrollSnapAlign, gap, alignment, } = props;
    const childArray = ensureArray(children);
    const pageCount = childArray.length;
    const rootRef = (0,react.useRef)(null);
    const clientWidth = ((_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || itemWidth;
    const scrollableAreaRef = (0,react.useRef)(null);
    const [currentPageIndex, setCurrentPageIndex] = (0,react.useState)(pageIndex);
    const snapThresholds = getSnapThresholds({
        pageCount,
        itemWidth,
        scrollSnapAlign,
        gap,
        clientWidth,
    });
    const updateScrollableAreaDebounced = (0,react.useCallback)(debounce((opts) => {
        var _a, _b;
        if (!opts || !opts.scrollableAreaRef.current || !opts.rootRef.current) {
            return;
        }
        const scrollLeftOffset = {
            start: 0,
            center: (((_a = opts.rootRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / 2,
            end: ((_b = opts.rootRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0,
        }[opts.scrollSnapAlign];
        const snapPoints = getSnapPoints({
            pageCount: opts.pageCount,
            itemWidth: opts.itemWidth,
            scrollSnapAlign: opts.scrollSnapAlign,
            gap,
        });
        if (opts.scrollableAreaRef.current) {
            opts.scrollableAreaRef.current.scrollLeft =
                snapPoints[opts.pageIndex] - scrollLeftOffset;
        }
    }, DEBOUNCE_MS), []);
    (0,react.useEffect)(() => {
        return updateScrollableAreaDebounced({
            itemWidth,
            pageCount,
            pageIndex,
            rootRef,
            scrollableAreaRef,
            scrollSnapAlign,
        });
    }, [
        updateScrollableAreaDebounced,
        itemWidth,
        pageCount,
        pageIndex,
        rootRef,
        scrollableAreaRef,
        scrollSnapAlign,
    ]);
    const onScroll = () => {
        const { current } = scrollableAreaRef;
        const scrollLeft = (current === null || current === void 0 ? void 0 : current.scrollLeft) || 0;
        const cursor = {
            start: scrollLeft,
            center: scrollLeft + clientWidth / 2,
            end: scrollLeft + clientWidth,
        }[scrollSnapAlign];
        const closestPoint = snapThresholds.reduce((acc, point) => (cursor > point ? point : acc), 0);
        const closestPageIndex = snapThresholds.indexOf(closestPoint);
        updateScrollableAreaDebounced();
        if (props.onScroll && currentPageIndex !== closestPageIndex) {
            props.onScroll(closestPageIndex);
        }
        setCurrentPageIndex(closestPageIndex);
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: ScrollSnap_Styles.root(), ref: rootRef },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ScrollSnap_Styles.scrollableArea(), onScroll: onScroll, ref: scrollableAreaRef, tabIndex: 0 },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: ScrollSnap_Styles.scrollingSurface(props, pageCount, alignment) }, childArray.map((child, i) => {
                return ((0,isolateComponent/* isolateComponent */.U)("span", { css: ScrollSnap_Styles.snappable(props), key: `${i}-snappable` }, child));
            })))));
};

//# sourceMappingURL=ScrollSnap.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Carousel/Carousel.js











const Carousel_Styles = (0,labelStyles/* labelStyles */.B)('Carousel', {
    carousel: (props, { isFirstPage, isLastPage }) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            position: 'relative',
        }),
        (props.edgeColor || props.showArrows) &&
            (0,withModifier/* withModifier */.Q)('fadeEdges', {
                '&::before, &::after': {
                    content: '""',
                    position: 'absolute',
                    zIndex: 1,
                    top: 0,
                    bottom: 0,
                    width: 100,
                    pointerEvents: 'none',
                    transition: Animation/* Animation.transitionValue */.f.transitionValue,
                },
                '&::before': {
                    opacity: isFirstPage ? 0 : 1,
                    left: 0,
                    right: 'auto',
                    background: `linear-gradient(to right, ${props.edgeColor || Colors/* Colors.white */.w.white}, #fff0)`,
                },
                '&::after': {
                    opacity: isLastPage ? 0 : 1,
                    left: 'auto',
                    right: 0,
                    background: `linear-gradient(to left, ${props.edgeColor || Colors/* Colors.white */.w.white}, #fff0)`,
                },
            }),
    ],
    paginator: () => [
        (0,emotion_react_browser_esm/* css */.iv)({
            marginTop: 30,
            gridTemplateRows: 'auto auto',
            gridTemplateColumns: '100%',
            justifyItems: 'center',
            display: 'grid',
        }),
    ],
    arrowButton: (props) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            transition: Animation/* Animation.transitionValue */.f.transitionValue,
            position: 'absolute',
            zIndex: 3,
            top: props.yOffset,
            transform: 'translateY(-50%)',
            display: 'none',
            '&:hover > button': {
                boxShadow: 'none !important',
            },
            '@media (min-width: 1230px)': {
                display: 'block',
            },
        }),
        (0,withModifier/* withModifier */.Q)(props.direction, {
            prev: {
                left: '20px',
            },
            next: {
                right: '20px',
            },
        }[props.direction]),
        props.isDisabled &&
            (0,withModifier/* withModifier */.Q)('disabled', {
                pointerEvents: 'none',
                '& > button': {
                    color: `${Colors/* Colors.neutral100 */.w.neutral100} !important`,
                    border: 0,
                    backgroundColor: `${Colors/* Colors.neutral500 */.w.neutral500} !important`,
                },
            }),
    ],
    scrollSnapChild: ({ fadeInactive }, isActiveSlide) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            transition: 'opacity 0.5s',
            height: '100%',
        }),
        fadeInactive &&
            !isActiveSlide &&
            (0,withModifier/* withModifier */.Q)('faded', {
                opacity: 0.3,
            }),
    ],
});
const ArrowButton = (props) => {
    const icon = {
        prev: 'arrowSmallLeft',
        next: 'arrowSmallRight',
    }[props.direction];
    return ((0,isolateComponent/* isolateComponent */.U)("span", { css: Carousel_Styles.arrowButton(props) },
        (0,isolateComponent/* isolateComponent */.U)(BaseButton/* BaseButton */.Y, { ariaLabel: `${props.direction} image`, color: "primary-alt", disabled: props.isDisabled, isPill: true, isSquare: true, onClick: props.onClick, size: "large" },
            (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: icon, size: 30 }))));
};
const Carousel_defaultProps = {
    gap: 10,
    children: [],
    arrowOffset: '50%',
    showPaginator: false,
};
const Carousel = (_props) => {
    const props = Object.assign(Object.assign({}, Carousel_defaultProps), _props);
    const [pageIndex, setPageIndex] = (0,react.useState)(0);
    const isFirstPage = pageIndex === 0;
    const isLastPage = pageIndex === props.children.length - 1;
    const gap = 20;
    const changePageIndex = (nextIndex, source) => {
        setPageIndex(nextIndex);
        if (props.onActiveSlideChange && pageIndex !== nextIndex) {
            props.onActiveSlideChange(nextIndex, pageIndex, { source });
        }
    };
    const paginatorAriaLabel = props.id
        ? `${props.id} carousel paginator`
        : (0,uniqueId/* uniqueId */.E)('carousel paginator ');
    let paginator = props.paginatorStyle &&
        {
            paginator: ((0,isolateComponent/* isolateComponent */.U)(Paginator, { ariaLabel: paginatorAriaLabel, currentPageIndex: pageIndex, onPaginate: ({ pageIndex: index }) => changePageIndex(index, 'paginator'), pageUrls: Array.from({ length: props.children.length }) })),
            indicator: ((0,isolateComponent/* isolateComponent */.U)(Indicator, { ariaLabel: "List of images", color: "gray", count: props.children.length, noun: "image", onChangeIndex: (index) => changePageIndex(index, 'indicator'), selectedIndex: pageIndex })),
        }[props.paginatorStyle];
    if (props.showPaginator || props.paginatorStyle) {
        paginator = ((0,isolateComponent/* isolateComponent */.U)(Paginator, { ariaLabel: paginatorAriaLabel, currentPageIndex: pageIndex, onPaginate: ({ pageIndex: index }) => changePageIndex(index, 'paginator'), pageUrls: Array.from({ length: props.children.length }) }));
    }
    return ((0,isolateComponent/* isolateComponent */.U)("div", { id: props.id },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: Carousel_Styles.carousel(props, { isFirstPage, isLastPage }) },
            props.showArrows && ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                (0,isolateComponent/* isolateComponent */.U)(ArrowButton, { direction: "prev", isDisabled: isFirstPage, yOffset: props.arrowOffset, onClick: () => {
                        changePageIndex(pageIndex - 1, 'previous');
                    } }),
                (0,isolateComponent/* isolateComponent */.U)(ArrowButton, { direction: "next", isDisabled: isLastPage, yOffset: props.arrowOffset, onClick: () => {
                        changePageIndex(pageIndex + 1, 'next');
                    } }))),
            (0,isolateComponent/* isolateComponent */.U)(ScrollSnap, { gap: gap, itemWidth: props.slideWidth, onScroll: (index) => {
                    changePageIndex(index, 'scroll');
                }, pageIndex: pageIndex, scrollSnapAlign: "center" }, react.Children.map(props.children, (child, i) => ((0,isolateComponent/* isolateComponent */.U)("div", { css: Carousel_Styles.scrollSnapChild(props, pageIndex === i), key: i }, child))))),
        paginator && (0,isolateComponent/* isolateComponent */.U)("div", { css: Carousel_Styles.paginator() }, paginator)));
};
//# sourceMappingURL=Carousel.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.tsx

function Carousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    Carousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Carousel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 423px;\n    background: linear-gradient(\n      90deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 1) 100%\n    );\n  }\n"
    ]);
    Carousel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Carousel_Carousel = function(param) {
    var children = param.children, onActiveSlideChange = param.onActiveSlideChange;
    var width = (0,useViewportSize/* useViewportSize */.n)().width;
    var isMobile = width === "extraSmall" || width === "small";
    var slideWidth = isMobile ? 300 : 650;
    var ref = (0,react.useState)("50%"), arrowOffset = ref[0], setArrowOffset = ref[1];
    var ref1 = (0,react.useState)(false), showArrows = ref1[0], setShowArrows = ref1[1];
    var containerRef = function(node) {
        if (!node) return;
        var image = node.querySelector("img");
        if (!image) {
            setShowArrows(!isMobile);
            return;
        }
        var handleLoad = function() {
            if (image.clientHeight === 0) return;
            setArrowOffset("".concat(image.clientHeight / 2, "px"));
            setShowArrows(!isMobile);
        };
        image.onload = handleLoad;
        image.onerror = function() {
            setShowArrows(!isMobile);
        };
        /** handleLoad is sometimes attached after `onLoad` has already fired.
     *  So, we want to fire it again here and use the early return when image.clientHeight is 0
     *  to avoid the arrows it sliding in from the top.
     */ handleLoad();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselContainer, {
        "data-testid": "carousel",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                arrowOffset: arrowOffset,
                onActiveSlideChange: onActiveSlideChange,
                paginatorStyle: "indicator",
                showArrows: showArrows,
                slideWidth: slideWidth,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselOverlay, {})
        ]
    });
};
var CarouselContainer = emotion_styled_browser_esm/* default.div */.Z.div(Carousel_templateObject());
var CarouselOverlay = emotion_styled_browser_esm/* default.div */.Z.div(Carousel_templateObject1(), responsive/* mediaQueries.desktop */.w5.desktop);

;// CONCATENATED MODULE: ./src/components/sections/CarouselSection/CarouselSection.tsx




function CarouselSection(props) {
    var ref;
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var handleActiveSlideChange = function(currentSlide, previousSlide) {
        emitUserInteractionEvent({
            event_action: avro/* EventAction.click */.AO.click,
            interaction_name: avro/* InteractionName.carousel_button_click */.AI.carousel_button_click,
            option_selected: currentSlide > previousSlide ? "next" : "previous",
            custom_tracking_fields: {
                section_name: events/* SectionName.CarouselSection */.jz.CarouselSection
            }
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: events/* CtaName.moreArticles */.XE.moreArticles,
            cta_raw_text: "click_arrow",
            cta_goal: events/* CtaGoal.getMoreInformation */.LK.getMoreInformation
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        contentWidth: "overflow",
        heading: props.heading,
        layerName: (ref = props.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
        sectionToTrack: events/* SectionName.CarouselSection */.jz.CarouselSection,
        subheading: props.subheading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_Carousel, {
            onActiveSlideChange: handleActiveSlideChange,
            children: props.children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/sections/CarouselSection/CarouselSection.builder.ts




/* harmony default export */ var CarouselSection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(CarouselSection), {
    name: "CarouselSection",
    image: "https://cdn.zappy.app/70bef4e8e2b54f2a55972f5c147e48c6.png",
    inputs: [
        {
            name: "subheading",
            type: "string",
            defaultValue: "Section Subheading"
        },
        {
            name: "heading",
            type: "string",
            defaultValue: "Section Heading"
        }, 
    ],
    defaultChildren: Array(3).fill(builderElement("BlockGridItem", {
        heading: "Example heading",
        description: "<p>Example content...</p>",
        imageUrl: "https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1656512382/Blog/Generic/abstract-zaps_qpodgh.png"
    }))
}));

;// CONCATENATED MODULE: ./src/components/sections/ColumnsGridSection/ColumnsGridSection.tsx

function ColumnsGridSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-items: start;\n  gap: 30px;\n  grid-template-columns: repeat(1, 1fr);\n\n  ",
        " {\n    grid-template-columns: ",
        ";\n  }\n\n  ",
        " {\n    grid-template-columns: ",
        ";\n  }\n"
    ]);
    ColumnsGridSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */ function ColumnsGridSection(param) {
    var children = param.children, heading = param.heading, builderBlock = param.builderBlock;
    var childrenLength = react.Children.toArray(children).length;
    if (childrenLength > 4) {
        throw new Error("Max 4 columns are allowed");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        contentWidth: "fullWidth",
        heading: heading,
        layerName: builderBlock === null || builderBlock === void 0 ? void 0 : builderBlock.layerName,
        sectionToTrack: events/* SectionName.ColumnsGridSection */.jz.ColumnsGridSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
            columns: childrenLength,
            children: children
        })
    });
}
var Grid = emotion_styled_browser_esm/* default.div */.Z.div(ColumnsGridSection_templateObject(), responsive/* mediaQueries.tablet */.w5.tablet, function(param) {
    var columns = param.columns;
    return "repeat(".concat(columns === 2 ? 2 : 1, ", 1fr)");
}, responsive/* mediaQueries.desktop */.w5.desktop, function(param) {
    var columns = param.columns;
    return "repeat(".concat(columns, ", 1fr)");
});

;// CONCATENATED MODULE: ./src/components/sections/ColumnsGridSection/ColumnGridSections.builder.ts







var twoColBlockDefaults = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, defaultValues), {
    mediaSrc: "https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png"
});
/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */ /* harmony default export */ var ColumnGridSections_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(ColumnsGridSection), {
    name: "ColumnsSection",
    hideFromInsertMenu: true,
    image: "https://cdn.zappy.app/95912730bbbb5c8e0cf46127cc12ca67.png",
    inputs: [
        {
            name: "heading",
            type: "string"
        }, 
    ],
    defaultChildren: [
        blockElement((0,src_object_spread/* default */.Z)({}, twoColBlockDefaults)),
        blockElement((0,src_object_spread/* default */.Z)({}, twoColBlockDefaults)), 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/CompactCTASection/fixtures.ts

var CompactCTASection_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.zapier */.US.zapier,
    ctaText: "Sign up for free",
    ctaUrl: "https://zapier.com/sign-up/",
    heading: "See what automation can do for you",
    isFullWidth: true
};

;// CONCATENATED MODULE: ./src/components/sections/CompactCTASection/CompactCTASection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 








var CompactCTASection_Styles = (0,labelStyles/* labelStyles */.B)("CompactCTASection", {
    root: function(props) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({
            backgroundColor: props.isFullWidth ? Colors/* Colors */.w[props.backgroundColor] : Colors/* Colors.neutral100 */.w.neutral100
        }, props.isFullWidth ? {
            padding: "0 20px"
        } : (_obj = {
            padding: "20px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "64px 20px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "120px 20px"
        }), _obj)));
    },
    content: function(props) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({
            maxWidth: "1170px",
            margin: "0 auto",
            textAlign: "center"
        }, props.isFullWidth ? (_obj = {
            padding: "48px 0"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "60px 0"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "120px 0",
            textAlign: "left"
        }), _obj) : (0,_define_property/* default */.Z)({
            padding: "48px 20px",
            backgroundColor: Colors/* Colors */.w[props.backgroundColor],
            borderRadius: "5px"
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "60px 20px"
        })));
    },
    heading: function(props) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), (0,_define_property/* default */.Z)({
            maxWidth: "448px",
            margin: "0 auto 32px",
            color: props.backgroundColor === colors/* COLOR_KEYS.cream */.US.cream ? Colors/* Colors.zapier */.w.zapier : Colors/* Colors.cream */.w.cream
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader4 */.ZT.pageHeader4), {
            maxWidth: "none",
            margin: props.isFullWidth ? "0 48px 0 0" : ""
        }))));
    },
    cta: (0,emotion_react_browser_esm/* css */.iv)({
        width: "288px",
        minWidth: "fit-content",
        maxWidth: "100%",
        margin: "0 auto"
    }),
    ctaText: (0,emotion_react_browser_esm/* css */.iv)({
        display: "inline-flex",
        alignItems: "center",
        gap: "8px"
    })
});
function CompactCTASection(props) {
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: CompactCTASection_Styles.root(props)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: CompactCTASection_Styles.content(props)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: CompactCTASection_Styles.heading(props)
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: CompactCTASection_Styles.cta
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        color: props.backgroundColor === colors/* COLOR_KEYS.cream */.US.cream ? "primary" : "secondary-alt",
        href: props.ctaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: props.ctaText,
                href: props.ctaUrl,
                section: events/* SectionName.CompactCTASection */.jz.CompactCTASection
            });
        }
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
        css: CompactCTASection_Styles.ctaText
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, props.ctaText), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: ICON_NAMES.arrowBigRight,
        size: 24
    }))))));
}

;// CONCATENATED MODULE: ./src/components/sections/CompactCTASection/CompactCTASection.builder.tsx






/* harmony default export */ var CompactCTASection_builder = (createBuilderModule(withTracking(CompactCTASection, {
    sectionName: events/* SectionName.CompactCTASection */.jz.CompactCTASection
}), {
    name: "CompactCTASection",
    image: "https://cdn.zappy.app/26523527dbfc73189300e09db2be9552.svg",
    inputs: [
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: CompactCTASection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "ctaText",
            type: "string",
            required: true,
            defaultValue: CompactCTASection_fixtures_DEFAULT_VALUES.ctaText
        },
        {
            name: "ctaUrl",
            type: "string",
            required: true,
            defaultValue: CompactCTASection_fixtures_DEFAULT_VALUES.ctaUrl
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.zapier */.US.zapier
            ],
            required: true,
            defaultValue: CompactCTASection_fixtures_DEFAULT_VALUES.backgroundColor
        },
        {
            name: "isFullWidth",
            type: "boolean",
            required: true,
            defaultValue: CompactCTASection_fixtures_DEFAULT_VALUES.isFullWidth
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(18770);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(93520);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/utils/isNullOrUndefined.ts
function isNullOrUndefined(value) {
    return typeof value === "undefined" || value === null;
}

// EXTERNAL MODULE: ./src/rest/zapier/accounts/data.ts + 2 modules
var accounts_data = __webpack_require__(59606);
// EXTERNAL MODULE: ./src/rest/zapier/session/data.ts + 1 modules
var session_data = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/rest/zapier/recommendations/user_profile/data.ts + 1 modules
var user_profile_data = __webpack_require__(56675);
;// CONCATENATED MODULE: ./src/components/Conditional/Conditional.tsx











var DATASET_LABELS;
(function(DATASET_LABELS) {
    DATASET_LABELS["allAccounts"] = "All Accounts";
    DATASET_LABELS["currentAccount"] = "Current Account";
    DATASET_LABELS["global"] = "Global";
    DATASET_LABELS["queryParameters"] = "Query Parameters";
    DATASET_LABELS["session"] = "User";
    DATASET_LABELS["userProfile"] = "User Profile";
})(DATASET_LABELS || (DATASET_LABELS = {}));
var COMPARISONS;
(function(COMPARISONS) {
    COMPARISONS["isTrue"] = "is true";
    COMPARISONS["isFalse"] = "is false";
    COMPARISONS["equals"] = "equals";
    COMPARISONS["doesNotEqual"] = "does not equal";
    COMPARISONS["contains"] = "contains";
    COMPARISONS["doesNotContain"] = "does not contain";
    COMPARISONS["startsWith"] = "starts with";
    COMPARISONS["doesNotStartWith"] = "does not start with";
    COMPARISONS["endsWith"] = "ends with";
    COMPARISONS["doesNotEndWith"] = "does not end with";
})(COMPARISONS || (COMPARISONS = {}));
function someConditionUsesDataset(datasetLabel, conditions) {
    return conditions.some(function(condition) {
        var ref;
        return ((ref = condition.property) === null || ref === void 0 ? void 0 : ref.startsWith("".concat(datasetLabel, " - "))) || condition.and && someConditionUsesDataset(datasetLabel, condition.and);
    });
}
/** Gets a value in a nested object using the provided array of keys */ function getValue(obj, keys) {
    var _keys = _toArray(keys), firstKey = _keys[0], remainingKeys = _keys.slice(1);
    if (!Object.hasOwn(obj !== null && obj !== void 0 ? obj : {}, firstKey)) {
        return null;
    }
    var value = obj[firstKey];
    if (remainingKeys.length === 0) {
        return value;
    }
    return getValue(value, remainingKeys);
}
function Conditional(param) {
    var _conditions = param.conditions, conditions = _conditions === void 0 ? [] : _conditions, preview = param.preview, children = param.children;
    var router = (0,next_router.useRouter)();
    var shouldFetch = {
        allAccounts: someConditionUsesDataset(DATASET_LABELS.allAccounts, conditions),
        currentAccount: someConditionUsesDataset(DATASET_LABELS.currentAccount, conditions),
        session: someConditionUsesDataset(DATASET_LABELS.session, conditions),
        userProfile: someConditionUsesDataset(DATASET_LABELS.userProfile, conditions)
    };
    var allAccounts = (0,accounts_data/* useAccounts */.xe)(shouldFetch.allAccounts);
    var currentAccount = (0,accounts_data/* useCurrentAccount */.t)(shouldFetch.currentAccount);
    var session = (0,session_data/* useSession */.k)(shouldFetch.session);
    var userProfile = (0,user_profile_data/* useUserProfile */.G)(shouldFetch.userProfile);
    var data = {
        global: {
            is_loading: allAccounts.isLoading || currentAccount.isLoading || session.isLoading || userProfile.isLoading
        },
        allAccounts: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, allAccounts.data && {
            plan_info: {
                ids: allAccounts.data.map(function(account) {
                    return account.plan_info.id;
                }),
                names: allAccounts.data.map(function(account) {
                    return account.plan_info.name;
                })
            }
        }), {
            is_loading: allAccounts.isLoading
        }),
        currentAccount: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, currentAccount.data), {
            is_loading: currentAccount.isLoading
        }),
        session: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, session.data), {
            is_loading: session.isLoading
        }),
        userProfile: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userProfile.data), {
            is_loading: userProfile.isLoading
        }),
        queryParameters: router.query
    };
    var conditionIsSatisfied = function(condition) {
        if (!condition.property || !condition.comparison) {
            return false;
        }
        var ref = _toArray(condition.property.split(" - ")), datasetLabel = ref[0], keys = ref.slice(1);
        var _obj;
        var datasetKey = (_obj = {}, (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.allAccounts, "allAccounts"), (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.currentAccount, "currentAccount"), (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.session, "session"), (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.userProfile, "userProfile"), (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.queryParameters, "queryParameters"), (0,_define_property/* default */.Z)(_obj, DATASET_LABELS.global, "global"), _obj)[datasetLabel];
        if (!datasetKey) {
            return false;
        }
        var actualValue = getValue(data, [
            datasetKey
        ].concat((0,_to_consumable_array/* default */.Z)(keys)));
        var expectedValue = "".concat(condition.value);
        switch(condition.comparison){
            case COMPARISONS.isTrue:
                return !!actualValue;
            case COMPARISONS.isFalse:
                return !actualValue;
            case COMPARISONS.equals:
                return !isNullOrUndefined(actualValue) && "".concat(actualValue) === expectedValue;
            case COMPARISONS.doesNotEqual:
                return isNullOrUndefined(actualValue) || "".concat(actualValue) !== expectedValue;
            case COMPARISONS.contains:
                return !isNullOrUndefined(actualValue) && Array.isArray(actualValue) ? actualValue.includes(expectedValue) : "".concat(actualValue).includes(expectedValue);
            case COMPARISONS.doesNotContain:
                return isNullOrUndefined(actualValue) || !(Array.isArray(actualValue) ? actualValue.includes(expectedValue) : "".concat(actualValue).includes(expectedValue));
            case COMPARISONS.startsWith:
                return !isNullOrUndefined(actualValue) && "".concat(actualValue).startsWith(expectedValue);
            case COMPARISONS.doesNotStartWith:
                return isNullOrUndefined(actualValue) || !"".concat(actualValue).startsWith(expectedValue);
            case COMPARISONS.endsWith:
                return !isNullOrUndefined(actualValue) && "".concat(actualValue).endsWith(expectedValue);
            case COMPARISONS.doesNotEndWith:
                return isNullOrUndefined(actualValue) || !"".concat(actualValue).endsWith(expectedValue);
            default:
                return false;
        }
    };
    var someConditionIsSatisfied = conditions === null || conditions === void 0 ? void 0 : conditions.some(function(condition) {
        return conditionIsSatisfied(condition) && (condition.and || []).every(function(andCondition) {
            return conditionIsSatisfied(andCondition);
        });
    });
    /**
   * Render nothing if there are no children, the page is being
   * previewed/edited and `preview` is disabled, or the page is not being
   * previewed/edited and no conditions are satisfied
   * */ if (!children || (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing ? !preview : !someConditionIsSatisfied)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/Conditional/properties.ts



var PROPERTY_TYPES;
(function(PROPERTY_TYPES) {
    PROPERTY_TYPES["array"] = "List";
    PROPERTY_TYPES["boolean"] = "True/False";
    PROPERTY_TYPES["number"] = "Number";
    PROPERTY_TYPES["string"] = "Text";
})(PROPERTY_TYPES || (PROPERTY_TYPES = {}));
var globalProperties = {
    is_loading: PROPERTY_TYPES.boolean
};
var allAccountsProperties = {
    plan_info: {
        names: PROPERTY_TYPES.array,
        ids: PROPERTY_TYPES.array
    }
};
var currentAccountProperties = {
    companies_trial_auto_upgrade: PROPERTY_TYPES.boolean,
    companies_trial_end_date: PROPERTY_TYPES.string,
    companies_trial_start_date: PROPERTY_TYPES.string,
    company_account_end_date: PROPERTY_TYPES.string,
    company_address: PROPERTY_TYPES.string,
    company_initial_engagement: PROPERTY_TYPES.boolean,
    created_at: PROPERTY_TYPES.string,
    currency: PROPERTY_TYPES.string,
    first_known_upgrade_date: PROPERTY_TYPES.string,
    has_been_in_companies_trial: PROPERTY_TYPES.boolean,
    has_modern_pricing_plan: PROPERTY_TYPES.boolean,
    id: PROPERTY_TYPES.number,
    is_chat_eligible: PROPERTY_TYPES.boolean,
    is_company_account: PROPERTY_TYPES.boolean,
    is_in_experts_mvp: PROPERTY_TYPES.boolean,
    is_premier_chat_eligible: PROPERTY_TYPES.boolean,
    is_team_account: PROPERTY_TYPES.boolean,
    is_trialing_companies: PROPERTY_TYPES.boolean,
    is_trialing_teams: PROPERTY_TYPES.boolean,
    is_trialing: PROPERTY_TYPES.boolean,
    is_unlimited: PROPERTY_TYPES.boolean,
    last_plan_change_at: PROPERTY_TYPES.string,
    logo_url: PROPERTY_TYPES.string,
    name: PROPERTY_TYPES.string,
    offer_returning_trial_extension: PROPERTY_TYPES.boolean,
    owner: {
        id: PROPERTY_TYPES.number,
        name: PROPERTY_TYPES.string,
        email: PROPERTY_TYPES.string
    },
    paying: PROPERTY_TYPES.boolean,
    pays_manually: PROPERTY_TYPES.boolean,
    period_end: PROPERTY_TYPES.string,
    period_start: PROPERTY_TYPES.string,
    plan_group_id: PROPERTY_TYPES.number,
    plan_info: {
        id: PROPERTY_TYPES.number,
        name: PROPERTY_TYPES.string,
        metered_task_pricing: PROPERTY_TYPES.boolean,
        interval: PROPERTY_TYPES.string,
        allow_companies: PROPERTY_TYPES.boolean,
        allow_teams: PROPERTY_TYPES.boolean,
        allow_import_export: PROPERTY_TYPES.boolean
    },
    surveys_submitted: {
        company_trial_onboarding: PROPERTY_TYPES.boolean,
        company_trial_exit: PROPERTY_TYPES.boolean
    },
    team_account_end_date: PROPERTY_TYPES.string,
    teams_trial_auto_upgrade: PROPERTY_TYPES.boolean,
    teams_trial_end_date: PROPERTY_TYPES.string,
    trial_auto_upgrade: PROPERTY_TYPES.boolean,
    trial_end_date: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean
};
var queryParameterProperties = {
    demo_source: PROPERTY_TYPES.string,
    utm_campaign: PROPERTY_TYPES.string,
    utm_medium: PROPERTY_TYPES.string,
    utm_source: PROPERTY_TYPES.string
};
var userProperties = {
    banner_message: PROPERTY_TYPES.string,
    current_account_id: PROPERTY_TYPES.number,
    current_account_role: PROPERTY_TYPES.string,
    email: PROPERTY_TYPES.string,
    first_name: PROPERTY_TYPES.string,
    has_activated: PROPERTY_TYPES.boolean,
    has_active_zaps: PROPERTY_TYPES.boolean,
    has_signed_up: PROPERTY_TYPES.boolean,
    id: PROPERTY_TYPES.number,
    identity: PROPERTY_TYPES.number,
    is_developer: PROPERTY_TYPES.boolean,
    is_expert: PROPERTY_TYPES.boolean,
    is_high_value: PROPERTY_TYPES.boolean,
    is_logged_in: PROPERTY_TYPES.boolean,
    is_staff: PROPERTY_TYPES.boolean,
    is_temporary: PROPERTY_TYPES.boolean,
    last_login: PROPERTY_TYPES.string,
    last_name: PROPERTY_TYPES.string,
    organizations: PROPERTY_TYPES.array,
    photo_url: PROPERTY_TYPES.string,
    primary_organization: PROPERTY_TYPES.number,
    signup: PROPERTY_TYPES.string,
    since_signup: PROPERTY_TYPES.string,
    timezone: PROPERTY_TYPES.string,
    user_id: PROPERTY_TYPES.number,
    username: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean
};
var userProfileProperties = {
    role_id: PROPERTY_TYPES.number,
    role_name: PROPERTY_TYPES.string,
    company_size_id: PROPERTY_TYPES.number,
    company_size_display_range: PROPERTY_TYPES.string,
    organization_name: PROPERTY_TYPES.string,
    inferred_organization_name: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean
};
function getProperties(prefix, obj) {
    return Object.entries(obj).reduce(function(properties, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (value !== null && value.constructor.name === "Object") {
            return (0,_to_consumable_array/* default */.Z)(properties).concat((0,_to_consumable_array/* default */.Z)(getProperties("".concat(prefix, " - ").concat(key), value)));
        }
        var dashSeparatedKeys = "".concat(prefix, " - ").concat(key);
        return (0,_to_consumable_array/* default */.Z)(properties).concat([
            {
                label: dashSeparatedKeys,
                value: dashSeparatedKeys,
                helperText: value
            }, 
        ]);
    }, []);
}
var properties = (0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.global, globalProperties)).concat((0,_to_consumable_array/* default */.Z)((0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.allAccounts, allAccountsProperties)).concat((0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.currentAccount, currentAccountProperties)), (0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.queryParameters, queryParameterProperties)), (0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.session, userProperties)), (0,_to_consumable_array/* default */.Z)(getProperties(DATASET_LABELS.userProfile, userProfileProperties))).sort()));

;// CONCATENATED MODULE: ./src/components/Conditional/Conditional.builder.ts





var conditionalInputs = [
    {
        name: "property",
        type: "string",
        enum: properties
    },
    {
        name: "comparison",
        type: "string",
        enum: [
            {
                label: COMPARISONS.isTrue,
                value: COMPARISONS.isTrue,
                helperText: PROPERTY_TYPES.boolean
            },
            {
                label: COMPARISONS.isFalse,
                value: COMPARISONS.isFalse,
                helperText: PROPERTY_TYPES.boolean
            },
            {
                label: COMPARISONS.equals,
                value: COMPARISONS.equals,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            },
            {
                label: COMPARISONS.doesNotEqual,
                value: COMPARISONS.doesNotEqual,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            },
            {
                label: COMPARISONS.contains,
                value: COMPARISONS.contains,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number, ", ").concat(PROPERTY_TYPES.array)
            },
            {
                label: COMPARISONS.doesNotContain,
                value: COMPARISONS.doesNotContain,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number, ", ").concat(PROPERTY_TYPES.array)
            },
            {
                label: COMPARISONS.startsWith,
                value: COMPARISONS.startsWith,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            },
            {
                label: COMPARISONS.doesNotStartWith,
                value: COMPARISONS.doesNotStartWith,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            },
            {
                label: COMPARISONS.endsWith,
                value: COMPARISONS.endsWith,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            },
            {
                label: COMPARISONS.doesNotEndWith,
                value: COMPARISONS.doesNotEndWith,
                helperText: "".concat(PROPERTY_TYPES.string, ", ").concat(PROPERTY_TYPES.number)
            }, 
        ]
    },
    {
        name: "value",
        type: "string"
    }, 
];
/* harmony default export */ var Conditional_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(Conditional), {
    name: "Conditional",
    image: "https://cdn.zappy.app/e9c121e6bf62dd6ff449979889283b46.png",
    inputs: [
        {
            name: "conditions",
            helperText: "If ANY condition is true, then the child block will be shown.",
            type: "list",
            subFields: (0,_to_consumable_array/* default */.Z)(conditionalInputs).concat([
                {
                    name: "and",
                    type: "list",
                    subFields: (0,_to_consumable_array/* default */.Z)(conditionalInputs)
                }, 
            ])
        },
        {
            name: "preview",
            type: "boolean"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/CTAClickTracking/CTAClickTracking.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 

function CTAClickTracking(props) {
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var handleClick = function(event) {
        var target = event.target;
        if (target.tagName !== "A") {
            return;
        }
        emitCTAClickEvent({
            text: target.innerText,
            href: target.getAttribute("href") || "",
            section: props.sectionName
        });
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        role: "none",
        css: {
            display: "flex",
            flexDirection: "column"
        },
        onClick: handleClick
    }, props.children);
}

;// CONCATENATED MODULE: ./src/components/CTAClickTracking/CTAClickTracking.builder.ts



/* harmony default export */ var CTAClickTracking_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(CTAClickTracking), {
    name: "CTAClickTracking",
    image: "https://cdn.zappy.app/d686bf40f1aa0706d104ed34eedb946b.png",
    inputs: [
        {
            name: "sectionName",
            type: "string"
        }, 
    ],
    childRequirements: {
        message: "Children of the Click Tracking component must be a built-in component from the Basics section",
        query: {
            "component.name": {
                $in: [
                    "Core:Button",
                    "Core:Text",
                    "Core:Image",
                    "Core:Columns",
                    "Core:Box",
                    "Core:Section", 
                ]
            }
        }
    }
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/BrandButton/BrandButton.js
var BrandButton = __webpack_require__(37510);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/DarkBackgroundButton/DarkBackgroundButton.js
var DarkBackgroundButton_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const colorMappings = {
    primary: 'primary-dark',
    secondary: 'secondary-dark',
};
function DarkBackgroundButton(_a) {
    var { size = 'small', color = 'primary' } = _a, props = DarkBackgroundButton_rest(_a, ["size", "color"]);
    return (0,isolateComponent/* isolateComponent */.U)(BaseButton/* BaseButton */.Y, Object.assign({ color: colorMappings[color], size: size }, props));
}
//# sourceMappingURL=DarkBackgroundButton.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/constants.js
const BgColors = (/* unused pure expression or super */ null && ([
    'zapier',
    'night',
    'moss',
    'neutral800',
    'neutral100',
    'earth',
]));
const BgColorMap = {
    lava60: 'zapier',
    ocean40: 'night',
    sun60: 'moss',
    white: 'neutral100',
};
const TextColorMap = {
    zapier: 'cream',
    neutral100: 'neutral800',
    night: 'neutral100',
    moss: 'neutral100',
    neutral800: 'neutral100',
    earth: 'neutral100',
};
//# sourceMappingURL=constants.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/utils.js

const getBgColor = (backgroundColor) => {
    return BgColorMap[backgroundColor] || backgroundColor;
};
const getCtaBtnColor = (bgColor, ctaBtnColor) => {
    const background = getBgColor(bgColor);
    const allowedButtonTypes = {
        neutral100: ['primary', 'primary-alt', 'brand'],
        zapier: ['primary-alt'],
        night: ['primary-dark', 'brand'],
        moss: ['primary-dark', 'brand'],
        neutral800: ['primary-dark', 'brand'],
        earth: ['primary-dark', 'brand'],
    };
    if (ctaBtnColor && allowedButtonTypes[background].includes(ctaBtnColor)) {
        return ctaBtnColor;
    }
    return allowedButtonTypes[background][0];
};
//# sourceMappingURL=utils.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/CTATextContent.js










const CTATextContent_Styles = (0,labelStyles/* labelStyles */.B)('CTATextContent', {
    root: (alignment = 'left') => emotion_react_browser_esm/* css */.iv `
    text-align: ${alignment};
    @media screen and (min-width: 768px) {
      max-width: ${alignment === 'center' ? '100%' : '450px'};
    }
  `,
    heading: (alignment, textColor) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader4 */.ZT.pageHeader4}
    color: ${Colors/* Colors */.w[textColor]};
    @media screen and (min-width: 768px) {
      ${Typography/* Typography.pageHeader3 */.ZT.pageHeader3}
    }
    margin-bottom: ${alignment === 'center' ? '10px' : '20px'};
  `,
    subHeading: (textColor) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    color: ${Colors/* Colors */.w[textColor]};
    margin-bottom: 20px;
  `,
    description: (alignment, textColor) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph1ShortBold */.ZT.paragraph1ShortBold}
    color: ${Colors/* Colors */.w[textColor]};
    margin-bottom: ${alignment === 'center' ? '30px' : '20px'};
  `,
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 768px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
});
const getTextColor = (bgColor) => {
    return TextColorMap[bgColor];
};
const getButton = (props) => {
    const btnProps = {
        children: props.ctaText,
        href: props.ctaHref,
        onClick: props.onCtaClick,
        onKeyDown: props.onCtaKeyDown,
        target: props.ctaTarget,
        'data-testid': 'cta-button',
    };
    const btnColor = getCtaBtnColor(props.bgColor, props.ctaBtnColor);
    if (btnColor === 'primary-dark')
        return (0,isolateComponent/* isolateComponent */.U)(DarkBackgroundButton, Object.assign({}, btnProps));
    else if (btnColor === 'brand')
        return (0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, btnProps));
    else {
        return (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, btnProps, { color: btnColor, size: "small" }));
    }
};
const CTATextContent = (props) => {
    const textColor = getTextColor(props.bgColor);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTATextContent_Styles.root(props.alignment) },
        (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: CTATextContent_Styles.heading(props.alignment, textColor) }, props.heading),
            props.subHeading && ((0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: CTATextContent_Styles.subHeading(textColor) }, props.subHeading)))),
        props.description && ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTATextContent_Styles.description(props.alignment, textColor) }, props.description)),
        props.ctaText && (props.ctaHref || props.onCtaClick) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTATextContent_Styles.ctaContainer }, getButton(props)))));
};
//# sourceMappingURL=CTATextContent.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/CTAStandard/CTAStandard.js





const CTAStandard_Styles = (0,labelStyles/* labelStyles */.B)('CTAStandard', {
    root: (backgroundColor) => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[backgroundColor]};
    padding: 40px 20px;
    @media screen and (min-width: 768px) {
      padding: 60px 30px;
    }

    @media screen and (min-width: 1230px) {
      padding: 80px 20px;
    }
  `,
    content: (maxWidth) => emotion_react_browser_esm/* css */.iv `
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    @media screen and (min-width: 768px) {
      gap: 90px;
      grid-template-columns: repeat(2, 1fr);
    }
  `,
    mediaContent: emotion_react_browser_esm/* css */.iv `
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `,
});
const CTAStandard = ({ backgroundColor = 'white', heading, subHeading, ctaText, ctaHref, ctaBtnColor, description, onCtaClick, onCtaKeyDown, children, maxWidth = 1170, ctaTarget, }) => {
    const bgColor = getBgColor(backgroundColor);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTAStandard_Styles.root(bgColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: CTAStandard_Styles.content(maxWidth) },
            (0,isolateComponent/* isolateComponent */.U)(CTATextContent, { heading: heading, subHeading: subHeading, description: description, ctaText: ctaText, ctaHref: ctaHref, ctaBtnColor: ctaBtnColor, onCtaClick: onCtaClick, onCtaKeyDown: onCtaKeyDown, bgColor: bgColor, ctaTarget: ctaTarget }),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: CTAStandard_Styles.mediaContent, "data-testid": "media-content" }, children))));
};
//# sourceMappingURL=CTAStandard.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/CTAFilled/CTAFilled.js





const CTAFilled_Styles = (0,labelStyles/* labelStyles */.B)('CTAFilled', {
    root: (backgroundColor, maxWidth = 1170) => emotion_react_browser_esm/* css */.iv `
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 20px;
    padding: 40px 30px;
    border-radius: 10px;
    background-color: ${Colors/* Colors */.w[backgroundColor]};

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      margin: 40px 30px;
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      margin: 40px auto;
      padding: 40px 70px;
    }
  `,
    mediaContent: emotion_react_browser_esm/* css */.iv `
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `,
});
const CTAFilled = ({ backgroundColor = 'neutral100', children, ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth, onCtaClick, onCtaKeyDown, subHeading, ctaTarget, }) => {
    const bgColor = getBgColor(backgroundColor);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTAFilled_Styles.root(bgColor, maxWidth) },
        (0,isolateComponent/* isolateComponent */.U)(CTATextContent, { heading: heading, subHeading: subHeading, description: description, ctaText: ctaText, ctaHref: ctaHref, ctaBtnColor: ctaBtnColor, onCtaClick: onCtaClick, onCtaKeyDown: onCtaKeyDown, bgColor: bgColor, ctaTarget: ctaTarget }),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: CTAFilled_Styles.mediaContent, "data-testid": "media-content" }, children)));
};
//# sourceMappingURL=CTAFilled.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/TextInput/TextInput.js
var TextInput = __webpack_require__(42126);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/SubscriptionForm/SubscriptionForm.js
var SubscriptionForm_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





const SubscriptionForm_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const SubscriptionForm_Styles = (0,labelStyles/* labelStyles */.B)('SubscriptionForm', {
    root: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0 auto;
    @media screen and (min-width: ${SubscriptionForm_breakpoints.tablet}px) {
      margin: 0;
      flex-direction: row;
    }
  `,
    inputField: (fluidInput) => emotion_react_browser_esm/* css */.iv `
    display: flex;
    text-align: left;
    ${fluidInput &&
        (0,withModifier/* withModifier */.Q)('fluid', emotion_react_browser_esm/* css */.iv `
        flex: 1 100%;
        @media screen and (min-width: ${SubscriptionForm_breakpoints.tablet}px) {
          flex: 2;
        }
      `)}
  `,
});
const SubscriptionForm = (_a) => {
    var { inputIsFullWidth = true, fluidInput = false } = _a, props = SubscriptionForm_rest(_a, ["inputIsFullWidth", "fluidInput"]);
    const [id] = (0,react.useState)(props.inputId || (0,uniqueId/* uniqueId */.E)('SubscriptionForm-'));
    const [subscribedValue, setSubscribedValue] = (0,react.useState)('');
    const inputSize = 'small';
    const inputProps = {
        id,
        isDisabled: props.inputIsDisabled,
        isErrored: !!props.inputError,
        isRequired: props.inputIsRequired,
        isFullWidth: inputIsFullWidth,
        placeholder: props.placeholderText,
        ariaLabel: props.placeholderText,
        size: inputSize,
        onChange: (event) => setSubscribedValue(event.target.value),
    };
    return ((0,isolateComponent/* isolateComponent */.U)("form", { onSubmit: () => { var _a; return (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, subscribedValue); }, "data-testid": "subscription-form" },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: SubscriptionForm_Styles.root },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: SubscriptionForm_Styles.inputField(fluidInput) }, props.renderInput ? (props.renderInput(inputProps)) : ((0,isolateComponent/* isolateComponent */.U)(TextInput/* TextInput */.o, Object.assign({}, inputProps)))),
            props.renderButton({ size: 'small' }))));
};
//# sourceMappingURL=SubscriptionForm.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/SubscriptionForm/DisclaimerText.js



const DisclaimerText_Styles = {
    ctaDisclaimer: emotion_react_browser_esm/* css */.iv `
    margin: 10px 0;
  `,
};
const DisclaimerText = ({ color = 'primary', termsLink = 'https://zapier.com/tos', textType = 'paragraph3', privacyLink = 'https://zapier.com/privacy', }) => {
    const textColor = color === 'primary' ? 'neutral700' : 'neutral100';
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: DisclaimerText_Styles.ctaDisclaimer },
        (0,isolateComponent/* isolateComponent */.U)(Text_Text/* Text */.x, { tag: "p", type: textType, color: textColor },
            "By signing up, you agree to Zapier\u2019s",
            ' ',
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: termsLink, color: color }, "Terms of Service"),
            ' ',
            "and",
            ' ',
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: privacyLink, color: color }, "Privacy Policy"),
            ".")));
};
//# sourceMappingURL=DisclaimerText.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/SubscriptionForm/SubscriptionFormWithDisclaimer.js
var SubscriptionFormWithDisclaimer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const SubscriptionFormWithDisclaimer_Styles = {
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  `,
};
const SubscriptionFormWithDisclaimer = (_a) => {
    var { disclaimerTextColor = 'primary', disclaimerTextType } = _a, restProps = SubscriptionFormWithDisclaimer_rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: SubscriptionFormWithDisclaimer_Styles.ctaContainer },
        (0,isolateComponent/* isolateComponent */.U)(SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })),
        (0,isolateComponent/* isolateComponent */.U)(DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })));
};
//# sourceMappingURL=SubscriptionFormWithDisclaimer.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/CTA/CTACentered/CTACentered.js






const CTACentered_Styles = (0,labelStyles/* labelStyles */.B)('CTACentered', {
    root: (backgroundColor) => emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    background-color: ${Colors/* Colors */.w[backgroundColor]};

    @media screen and (min-width: 768px) {
      padding: 40px;
    }

    @media screen and (min-width: 1230px) {
      padding: 70px 200px;
    }
  `,
    mediaContent: (maxWidth) => emotion_react_browser_esm/* css */.iv `
    max-width: ${maxWidth}px;
    @media screen and (min-width: 768px) {
      margin: 0 auto;
    }
  `,
});
const getSubscriptionFormButton = (bgColor, ctaBtnColor) => {
    const btnColor = getCtaBtnColor(bgColor, ctaBtnColor);
    const btnProps = {
        children: 'Submit',
        type: 'submit',
    };
    if (btnColor === 'primary-dark')
        return (0,isolateComponent/* isolateComponent */.U)(DarkBackgroundButton, Object.assign({}, btnProps));
    else if (btnColor === 'brand')
        return (0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, btnProps));
    else {
        return (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, btnProps, { color: btnColor, size: "small" }));
    }
};
const CTACentered = ({ backgroundColor = 'neutral100', ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth = 570, onCtaClick, onCtaKeyDown, subHeading, isSubscriptionForm, subscriptionPlaceholder, onSubscriptionFormSubmit, ctaTarget, }) => {
    const bgColor = getBgColor(backgroundColor);
    const isZapierOrange = bgColor === 'zapier';
    if (isZapierOrange && isSubscriptionForm) {
        console.error('Do not use the subscription form with the zapier background. The disclaimer text accessibility ' +
            'is poor on the zapier background.');
    }
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: CTACentered_Styles.root(bgColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: CTACentered_Styles.mediaContent(maxWidth) },
            (0,isolateComponent/* isolateComponent */.U)(CTATextContent, { heading: heading, subHeading: subHeading, description: description, ctaText: !isSubscriptionForm ? ctaText : undefined, ctaHref: !isSubscriptionForm ? ctaHref : undefined, ctaBtnColor: ctaBtnColor, onCtaClick: !isSubscriptionForm ? onCtaClick : undefined, onCtaKeyDown: onCtaKeyDown, bgColor: bgColor, alignment: "center", ctaTarget: ctaTarget })),
        isSubscriptionForm ? ((0,isolateComponent/* isolateComponent */.U)(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder || '', renderButton: () => getSubscriptionFormButton(backgroundColor, ctaBtnColor), onSubmit: onSubscriptionFormSubmit, disclaimerTextColor: bgColor === 'neutral100' ? 'primary' : 'secondary', disclaimerTextType: "paragraph3" })) : null));
};
//# sourceMappingURL=CTACentered.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/utils/innerText.ts
/**
 * Taken from react-innertext package
 * Code can be found here: https://github.com/CharlesStover/react-innertext/blob/master/src/index.ts
 * MIT license can be found here: https://github.com/CharlesStover/react-innertext/blob/master/LICENSE
 */ var hasProps = function(jsx) {
    return Object.prototype.hasOwnProperty.call(jsx, "props");
};
var reduceJsxToString = function(previous, current) {
    return previous + innerText(current);
};
var innerText = function(jsx) {
    // Empty
    if (jsx === null || typeof jsx === "boolean" || typeof jsx === "undefined") {
        return "";
    }
    // Numeric children.
    if (typeof jsx === "number") {
        return jsx.toString();
    }
    // String literals.
    if (typeof jsx === "string") {
        return jsx;
    }
    // Array of JSX.
    if (Array.isArray(jsx)) {
        return jsx.reduce(reduceJsxToString, "");
    }
    // Children prop.
    if (hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, "children")) {
        return innerText(jsx.props.children);
    }
    // Default
    return "";
};
innerText.default = innerText;

;// CONCATENATED MODULE: ./src/components/sections/CTASection/CTASection.tsx










function CTASection(param) {
    var _variant = param.variant, variant = _variant === void 0 ? CTASectionVariant.standard : _variant, heading = param.heading, subHeading = param.subHeading, description = param.description, background = param.background, ctaText = param.ctaText, ctaHref = param.ctaHref, ctaName = param.ctaName, ctaGoal = param.ctaGoal, ctaBtnColor = param.ctaBtnColor, children = param.children, maxWidth = param.maxWidth, openInNewTab = param.openInNewTab;
    var ref;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var pascalCasedVariant = ((ref = variant === null || variant === void 0 ? void 0 : variant.charAt(0)) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (variant === null || variant === void 0 ? void 0 : variant.slice(1));
    var trackCtaEvent = function() {
        emitCTAClickEvent({
            text: innerText(ctaText),
            href: ctaHref,
            section: "CTA".concat(pascalCasedVariant)
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: ctaName,
            cta_raw_text: ctaText,
            cta_goal: ctaGoal
        });
    };
    var handleCtaClick = function() {
        trackCtaEvent();
    };
    var ctaCommonProps = {
        backgroundColor: background,
        heading: heading,
        subHeading: subHeading,
        description: description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: background,
            html: description
        }),
        ctaHref: ctaHref,
        ctaText: ctaText,
        ctaBtnColor: ctaBtnColor,
        onCtaClick: handleCtaClick,
        maxWidth: maxWidth,
        ctaTarget: openInNewTab ? "_blank" : "_self"
    };
    var _obj;
    var ctaFactory = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CTASectionVariant.standard, /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAStandard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ctaCommonProps), {
        children: children
    }))), (0,_define_property/* default */.Z)(_obj, CTASectionVariant.filled, /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAFilled, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ctaCommonProps), {
        children: children
    }))), (0,_define_property/* default */.Z)(_obj, CTASectionVariant.centered, /*#__PURE__*/ (0,jsx_runtime.jsx)(CTACentered, (0,src_object_spread/* default */.Z)({}, ctaCommonProps))), _obj);
    return ctaFactory[variant];
}

;// CONCATENATED MODULE: ./src/components/sections/CTASection/CTASection.builder.tsx









/* harmony default export */ var CTASection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(withTracking(CTASection, {
    as: "section",
    sectionName: events/* SectionName.CTASection */.jz.CTASection
})), {
    name: "CtaSection",
    image: "https://cdn.zapier.com/storage/photos/e5f1d03939df5f074b24b06198cfcbaa.png",
    inputs: [
        {
            name: "variant",
            type: "string",
            enum: [
                CTASectionVariant.standard,
                CTASectionVariant.filled,
                CTASectionVariant.centered, 
            ],
            defaultValue: CTASectionVariant.standard
        },
        {
            name: "background",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier, 
            ],
            defaultValue: colors/* COLOR_KEYS.neutral100 */.US.neutral100
        },
        {
            name: "heading",
            type: "string",
            defaultValue: defaultValues.heading,
            required: true
        },
        {
            name: "subHeading",
            type: "string",
            defaultValue: "Default sub heading (edit me)"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: defaultValues.ctaText
        },
        {
            name: "ctaHref",
            type: "string",
            defaultValue: defaultValues.ctaHref
        },
        {
            name: "ctaName",
            type: "string",
            enum: Object.values(events/* CtaName */.XE),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.ctaName,
            required: true
        },
        {
            name: "ctaGoal",
            type: "string",
            enum: Object.values(events/* CtaGoal */.LK),
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
            defaultValue: defaultValues.ctaGoal,
            required: true
        },
        {
            name: "ctaBtnColor",
            friendlyName: "CTA button color",
            type: "string",
            enum: [
                "primary",
                "primary-alt",
                "primary-dark",
                "brand"
            ]
        },
        {
            name: "maxWidth",
            type: "number"
        },
        {
            name: "openInNewTab",
            helperText: "Controls whether or not the CTA link opens in a new tab",
            type: "boolean"
        }, 
    ],
    defaultChildren: [
        imgElement({
            src: "https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png"
        }), 
    ],
    childRequirements: {
        message: "You can only use Img Block",
        query: {
            "component.name": {
                $in: [
                    "img"
                ]
            }
        }
    }
}));

;// CONCATENATED MODULE: ./src/utils/unsecureID.ts
/**
 * Generates non-secure IDs that should only be used in instances where security
 * and collision probability are not a concern (e.g HTML `id` attributes)
 */ function unsecureID() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8;
    var characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var id = prefix;
    for(var i = 0; i < size; i++){
        id += characters[Math.floor(Math.random() * characters.length)];
    }
    return id;
}

;// CONCATENATED MODULE: ./src/components/sections/EventAgendaSection/EventAgendaSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 










var EventAgendaSection_Styles = (0,labelStyles/* labelStyles */.B)("EventAgendaSection", {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: "1170px",
        margin: "40px auto",
        padding: "0 20px"
    }),
    heading: function() {
        var headingSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "medium", headingAlignment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "left";
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].mobile]), (_obj = {
            color: Colors/* Colors.neutral800 */.w.neutral800,
            margin: "0 auto 0.75em",
            textAlign: headingAlignment
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].tablet])), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[headingSize].desktop])), _obj)));
    },
    embedContainer: (0,emotion_react_browser_esm/* css */.iv)({
        height: "1200px",
        borderRadius: "10px",
        overflow: "hidden"
    })
});
function EventAgendaSection(props) {
    var ref;
    var embedContainerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var embedContainer = embedContainerRef.current;
        if (embedContainer) {
            var script = document.createElement("script");
            script.setAttribute("src", "https://www.accelevents.com/e/js/embedScript-vti76d0k3j5ne6j7j8k3n4.min.js");
            script.setAttribute("event-data", props.eventID);
            script.setAttribute("embedType", "agenda");
            script.setAttribute("embed", "https://www.accelevents.com/u/embedScript/agenda");
            script.setAttribute("widgetFor", "EVENT");
            script.setAttribute("id", unsecureID());
            embedContainer.appendChild(script);
            return function() {
                embedContainer.removeChild(script);
            };
        }
    }, [
        props.eventID
    ]);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(InViewTracking.InViewTracking, {
        css: EventAgendaSection_Styles.root,
        layerName: (ref = props.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
        sectionName: events/* SectionName.EventAgendaSection */.jz.EventAgendaSection
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: EventAgendaSection_Styles.heading(props.headingSize, props.headingAlignment)
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: EventAgendaSection_Styles.embedContainer,
        ref: embedContainerRef
    }));
}

;// CONCATENATED MODULE: ./src/components/sections/EventAgendaSection/EventAgendaSection.builder.ts


/* harmony default export */ var EventAgendaSection_builder = (createBuilderModule(EventAgendaSection, {
    name: "EventAgendaSection",
    image: "",
    inputs: [
        {
            name: "eventID",
            type: "string",
            required: true,
            helperText: 'The value of the "event-data" attribute found in the Accelevents embed snippet'
        },
        {
            name: "heading",
            type: "string",
            required: false
        },
        {
            name: "headingSize",
            type: "string",
            enum: [
                "small",
                "medium",
                "large"
            ],
            required: false
        },
        {
            name: "headingAlignment",
            type: "string",
            enum: [
                "left",
                "center"
            ],
            required: false
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/FAQSection/Drawer.tsx
/** @jsxRuntime classic */ /** @jsx isolateComponent */ 








var Drawer_Styles = (0,labelStyles/* labelStyles */.B)("Drawer", {
    summary: (0,core_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (0,_define_property/* default */.Z)({
        margin: "20px 5px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        listStyle: "none",
        "&::-webkit-details-marker": {
            display: "none"
        },
        // Remove marker from browser / polyfills
        "&::before": {
            content: '""'
        }
    }, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9)))),
    expandCollapseIcon: (0,core_browser_esm/* css */.iv)({
        height: "40px",
        width: "40px",
        fill: "none",
        flexShrink: 0,
        marginRight: "24px",
        top: "20px"
    }),
    content: (0,core_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), {
        margin: "20px 0px 20px 65px",
        "@media screen and (min-width: 768px)": {
            margin: "20px 65px"
        }
    })),
    link: (0,core_browser_esm/* css */.iv)({
        alignItems: "center",
        color: Colors/* Colors.zapier */.w.zapier,
        display: "flex",
        fontWeight: 600,
        height: "100%",
        margin: "20px 0",
        textDecoration: "none",
        width: "max-content",
        "& > p": {
            borderBottom: "1.5px solid ".concat(Colors/* Colors.transparent */.w.transparent)
        },
        "& > span": {
            display: "flex",
            opacity: 0,
            visibility: "hidden"
        },
        "&:hover": {
            "& > p": {
                borderBottom: "1.5px solid ".concat(Colors/* Colors.zapier */.w.zapier),
                transition: "250ms"
            },
            "& > span": {
                opacity: 1,
                transition: "250ms",
                visibility: "visible"
            }
        }
    })
});
var SquirclePlusIcon = function(param) {
    var open = param.open;
    return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("span", {
        css: Drawer_Styles.expandCollapseIcon
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("svg", {
        fill: "none",
        height: "40",
        viewBox: "0 0 40 40",
        width: "40",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("title", null, open ? "plus icon" : "minus icon"), /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("rect", {
        height: "36",
        rx: "15",
        stroke: Colors/* Colors.zapier */.w.zapier,
        strokeWidth: "3",
        width: "36",
        x: "2",
        y: "2"
    }), !open && /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("path", {
        d: "M20 9V31.5",
        stroke: Colors/* Colors.zapier */.w.zapier,
        strokeWidth: "3"
    }), /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("path", {
        d: "M32 20L9.5 20",
        stroke: Colors/* Colors.zapier */.w.zapier,
        strokeWidth: "3"
    })));
};
var Drawer = function(props) {
    var children = props.children, title = props.title, onToggle = props.onToggle, href = props.href, _linkText = props.linkText, linkText = _linkText === void 0 ? "Learn more" : _linkText;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var isControlled = props.isOpen !== undefined;
    var open = isControlled ? props.isOpen : isOpen;
    var handleClick = function(e) {
        e.preventDefault();
        if (onToggle) onToggle({
            isOpen: open
        });
        if (!isControlled) {
            setIsOpen(function(prevState) {
                return !prevState;
            });
        }
    };
    return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("details", {
        open: open
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("summary", {
        css: Drawer_Styles.summary,
        onClick: handleClick,
        tabIndex: 0
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(SquirclePlusIcon, {
        open: open
    }), title), /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("div", {
        css: Drawer_Styles.content
    }, children, linkText && href && /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, {
        css: Drawer_Styles.link,
        href: href,
        onClick: function() {
            emitCTAClickEvent({
                href: href,
                section: events/* SectionName.FAQSection */.jz.FAQSection,
                text: linkText,
                type: avro/* CTAType.cta_link */.g8.cta_link
            });
        }
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("p", null, linkText), " ", /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("span", null, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, {
        name: "arrowBigRight",
        size: 18
    })))));
};

;// CONCATENATED MODULE: ./src/components/sections/FAQSection/Accordion.tsx
/** @jsxRuntime classic */ /** @jsx isolateComponent */ 






var drawerBorder = "1.577px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800, ";");
var FAQSection_Accordion_Styles = (0,labelStyles/* labelStyles */.B)("Accordion", {
    root: (0,core_browser_esm/* css */.iv)({
        display: "block",
        margin: "auto",
        maxWidth: "768px"
    }),
    drawer: (0,core_browser_esm/* css */.iv)({
        borderBottom: drawerBorder,
        "&:first-of-type": {
            borderTop: drawerBorder
        }
    })
});
function Accordion_Accordion(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, autoClose = param.autoClose;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var ref = (0,react.useState)(-1), openIndex = ref[0], setOpenIndex = ref[1];
    var emitAccordionToggleEvent = (0,avro/* useAvroTracking */.B2)().emitAccordionToggleEvent;
    var handleToggle = function(param) {
        var index = param.index, isOpen = param.isOpen, title = param.title;
        emitAccordionToggleEvent({
            option_selected: isOpen ? "closing" : "opening",
            section: events/* SectionName.FAQSection */.jz.FAQSection,
            title: title
        });
        trackEvent(isOpen ? events/* EventName.FAQ_SECTION_CLOSE */.B_.FAQ_SECTION_CLOSE : events/* EventName.FAQ_SECTION_OPEN */.B_.FAQ_SECTION_OPEN, {
            title: title
        });
        if (autoClose) {
            setOpenIndex(function(prevState) {
                var wasOpen = prevState === index;
                return wasOpen ? -1 : index;
            });
        }
    };
    return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("div", {
        css: FAQSection_Accordion_Styles.root
    }, items.map(function(param, index) {
        var title = param.title, content = param.content, href = param.href, linkText = param.linkText;
        return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("div", {
            css: FAQSection_Accordion_Styles.drawer,
            key: title
        }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Drawer, {
            href: href,
            isOpen: autoClose ? openIndex === index : undefined,
            linkText: linkText,
            onToggle: function(param) {
                var isOpen = param.isOpen;
                return handleToggle({
                    index: index,
                    isOpen: isOpen,
                    title: title
                });
            },
            title: title
        }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(RichTextHtml/* RichTextHtml */.CW, {
            html: content
        })));
    }));
}

;// CONCATENATED MODULE: ./src/components/sections/FAQSection/FAQSection.tsx
/** @jsxRuntime classic */ /** @jsx isolateComponent */ 







var FAQSection_Styles = (0,labelStyles/* labelStyles */.B)("FAQSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            padding: "67px 0px",
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.medium */.Eb.medium, {
            padding: "60px 50px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
            padding: "55px 19px"
        }), _obj));
    },
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader3 */.ZT.pageHeader3), {
        color: Colors/* Colors.earth */.w.earth,
        marginBottom: "60px",
        textAlign: "center"
    }))
});
function FAQSection(param) {
    var _autoClose = param.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? colors/* COLOR_KEYS.neutral100 */.US.neutral100 : _backgroundColor, _title = param.title, title = _title === void 0 ? "FAQ" : _title, _items = param.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)("div", {
        css: FAQSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null, /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, {
        css: FAQSection_Styles.title
    }, title)), /*#__PURE__*/ (0,isolateComponent/* isolateComponent */.U)(Accordion_Accordion, {
        autoClose: autoClose,
        items: items
    }));
}

;// CONCATENATED MODULE: ./src/components/sections/FAQSection/fixtures.ts
var ITEMS = [
    {
        title: "What is automation?",
        content: "Zapier automates your work by connecting your apps and then automatically moving information between them. Sed maximus in leomolestie sagittis. Mauris lobortis id metus sit amet volutpat. Utfacilisis sem ut elit sodales consequat. Proin pulvinar porta felis quis suscipit. Nunc accumsan consectetur sem, efficitur dapibus dolor lobortis et. Vestibulum ut sodales purus, sed mollis lorem. Vivamus quis dui risus. Nulla vulputate erat libero, ut vulputate dui faucibus sit amet. Donec dapibus at elit in posuere. In scelerisque eu felis sit amet dapibus. Donec suscipit leo tortor, quis sollicitudin leo molestie quis. Maecenas bibendum lectus id pretium aliquet. Nam a mollis tellus.",
        linkText: "Learn more",
        href: "#"
    },
    {
        title: "What is Zapier?",
        content: "Zapier automates your work by connecting your apps and then automatically moving information between them. Sed maximus in leomolestie sagittis. Mauris lobortis id metus sit amet volutpat. Utfacilisis sem ut elit sodales consequat. Proin pulvinar porta felis quis suscipit. Nunc accumsan consectetur sem, efficitur dapibus dolor lobortis et. Vestibulum ut sodales purus, sed mollis lorem. Vivamus quis dui risus. Nulla vulputate erat libero, ut vulputate dui faucibus sit amet. Donec dapibus at elit in posuere. In scelerisque eu felis sit amet dapibus. Donec suscipit leo tortor, quis sollicitudin leo molestie quis. Maecenas bibendum lectus id pretium aliquet. Nam a mollis tellus.",
        linkText: "Learn more",
        href: "#"
    },
    {
        title: "What apps can I connect with Zapier?",
        content: "Zapier automates your work by connecting your apps and then automatically moving information between them. Sed maximus in leomolestie sagittis. Mauris lobortis id metus sit amet volutpat. Utfacilisis sem ut elit sodales consequat. Proin pulvinar porta felis quis suscipit. Nunc accumsan consectetur sem, efficitur dapibus dolor lobortis et. Vestibulum ut sodales purus, sed mollis lorem. Vivamus quis dui risus. Nulla vulputate erat libero, ut vulputate dui faucibus sit amet. Donec dapibus at elit in posuere. In scelerisque eu felis sit amet dapibus. Donec suscipit leo tortor, quis sollicitudin leo molestie quis. Maecenas bibendum lectus id pretium aliquet. Nam a mollis tellus.",
        linkText: "Learn more",
        href: "#"
    },
    {
        title: "How does Zapier automate my work?",
        content: "Zapier automates your work by connecting your apps and then automatically moving information between them. Sed maximus in leomolestie sagittis. Mauris lobortis id metus sit amet volutpat. Utfacilisis sem ut elit sodales consequat. Proin pulvinar porta felis quis suscipit. Nunc accumsan consectetur sem, efficitur dapibus dolor lobortis et. Vestibulum ut sodales purus, sed mollis lorem. Vivamus quis dui risus. Nulla vulputate erat libero, ut vulputate dui faucibus sit amet. Donec dapibus at elit in posuere. In scelerisque eu felis sit amet dapibus. Donec suscipit leo tortor, quis sollicitudin leo molestie quis. Maecenas bibendum lectus id pretium aliquet. Nam a mollis tellus.",
        linkText: "Learn more",
        href: "#"
    },
    {
        title: "How do I choose a trigger and action?",
        content: "Zapier automates your work by connecting your apps and then automatically moving information between them. Sed maximus in leomolestie sagittis. Mauris lobortis id metus sit amet volutpat. Utfacilisis sem ut elit sodales consequat. Proin pulvinar porta felis quis suscipit. Nunc accumsan consectetur sem, efficitur dapibus dolor lobortis et. Vestibulum ut sodales purus, sed mollis lorem. Vivamus quis dui risus. Nulla vulputate erat libero, ut vulputate dui faucibus sit amet. Donec dapibus at elit in posuere. In scelerisque eu felis sit amet dapibus. Donec suscipit leo tortor, quis sollicitudin leo molestie quis. Maecenas bibendum lectus id pretium aliquet. Nam a mollis tellus.",
        linkText: "Learn more",
        href: "#"
    }, 
];

;// CONCATENATED MODULE: ./src/components/sections/FAQSection/FAQSection.builder.ts






/* harmony default export */ var FAQSection_builder = (createBuilderModule(withTracking(FAQSection, {
    as: "section",
    sectionName: events/* SectionName.FAQSection */.jz.FAQSection
}), {
    image: "https://cdn.zappy.app/7ef8f81d88de7e12ae874ffeb96c8452.png",
    inputs: [
        {
            defaultValue: "FAQ",
            name: "title",
            required: true,
            type: "string"
        },
        {
            defaultValue: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            name: "backgroundColor",
            type: "string"
        },
        {
            defaultValue: true,
            helperText: "Determines whether two accordion 'drawers' can be open at the same time or if opening one automatically closes any other open drawer.",
            name: "autoClose",
            type: "boolean"
        },
        {
            defaultValue: [
                ITEMS[0]
            ],
            name: "items",
            required: true,
            subFields: [
                {
                    name: "title",
                    required: true,
                    type: "string"
                },
                {
                    name: "content",
                    required: true,
                    type: "richText"
                },
                {
                    helperText: "Optional link, visible as icon next to/under (depends on viewport) the content when open.",
                    name: "href",
                    type: "string"
                },
                {
                    helperText: "Optional text to display for the link below the content.",
                    name: "linkText",
                    type: "string"
                }, 
            ],
            type: "list"
        }, 
    ],
    name: "FAQSection"
}));

;// CONCATENATED MODULE: ./src/components/sections/FeaturesSection/fixtures.ts

var fixtures_defaultValues = {
    backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
    heading: "Automation you can trust",
    description: "<p>Because what good is automation unless it’s secure and reliable?</p>",
    features: [
        {
            iconName: ICON_NAMES.miscSecurity,
            heading: "Security features",
            description: "<p>At Zapier, we take security and privacy seriously. Learn more about our security practices.</p>"
        },
        {
            iconName: ICON_NAMES.ratingThumbsUp,
            heading: "SOC  II compliant",
            description: "<p>Zapier meets all SOC 2 Type II requirements, so you can automate with confidence.</p>"
        },
        {
            iconName: ICON_NAMES.actionAutoRenew,
            heading: "Auto-replay",
            description: "<p>If a Zap fails or encounters an error, we’ll re-run it automatically so your work keeps happening.</p>"
        },
        {
            iconName: ICON_NAMES.navCog,
            heading: "Advanced controls",
            description: "<p>Need advanced administrative or security features? Check out Zapier for Companies.</p>"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/sections/FeaturesSection/FeaturesSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var FeaturesSection_obj;
var FeaturesSection_Styles = (0,labelStyles/* labelStyles */.B)("FeaturesSection", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            padding: "60px 20px",
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        });
    },
    content: (0,emotion_react_browser_esm/* css */.iv)((FeaturesSection_obj = {
        maxWidth: "1170px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "40px",
        textAlign: "center"
    }, (0,_define_property/* default */.Z)(FeaturesSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        gap: "75px"
    }), (0,_define_property/* default */.Z)(FeaturesSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        gridTemplateColumns: "1fr 1fr",
        gap: "30px",
        textAlign: "left"
    }), FeaturesSection_obj)),
    sectionHeading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.earth */.w.earth,
        marginBottom: "18px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "300px"
    }))),
    sectionDescription: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.neutral700 */.w.neutral700
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "360px"
    }))),
    features: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "60px"
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        gridTemplateColumns: "1fr 1fr",
        gap: "112px 30px"
    })),
    featureHeading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), {
        color: Colors/* Colors.neutral800 */.w.neutral800,
        margin: "12px 0 8px"
    })),
    featureDescription: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), {
        color: Colors/* Colors.neutral800 */.w.neutral800
    }))
});
function FeaturesSection(param) {
    var backgroundColor = param.backgroundColor, description = param.description, features = param.features, heading = param.heading;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: FeaturesSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: FeaturesSection_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: FeaturesSection_Styles.sectionHeading
    }, heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: FeaturesSection_Styles.sectionDescription
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: backgroundColor,
        html: description
    }))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: FeaturesSection_Styles.features
    }, features.map(function(feature, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            key: "".concat(feature, "-").concat(index)
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            color: "zapier",
            name: feature.iconName,
            size: 48
        }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
            css: FeaturesSection_Styles.featureHeading
        }, feature.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: FeaturesSection_Styles.featureDescription
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: backgroundColor,
            html: feature.description
        })));
    }))));
}

;// CONCATENATED MODULE: ./src/components/sections/FeaturesSection/FeaturesSection.builder.tsx





/* harmony default export */ var FeaturesSection_builder = (createBuilderModule(withTracking(FeaturesSection, {
    sectionName: events/* SectionName.FeaturesSection */.jz.FeaturesSection
}), {
    name: "FeaturesSection",
    image: "https://cdn.zappy.app/4687d1540f1a9cf3db47733741045378.svg",
    inputs: [
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            required: true,
            defaultValue: fixtures_defaultValues.backgroundColor
        },
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: fixtures_defaultValues.heading
        },
        {
            name: "description",
            type: "richText",
            required: true,
            defaultValue: fixtures_defaultValues.description
        },
        {
            name: "features",
            type: "list",
            subFields: [
                {
                    name: "iconName",
                    type: "string",
                    enum: Object.values(ICON_NAMES),
                    required: true
                },
                {
                    name: "heading",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    required: true
                }, 
            ],
            required: true,
            defaultValue: fixtures_defaultValues.features
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/Heading/fixtures.ts

var Heading_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
    color: colors/* COLOR_KEYS.earth */.US.earth,
    isCentered: true,
    maxWidth: "medium",
    size: "medium",
    spacing: "medium",
    tag: "h2",
    text: "Heading"
};

;// CONCATENATED MODULE: ./src/components/Heading/Heading.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 






var SIZE_MAP = {
    small: {
        mobile: "pageHeader9",
        tablet: "pageHeader7",
        desktop: "pageHeader5"
    },
    medium: {
        mobile: "pageHeader7",
        tablet: "pageHeader5",
        desktop: "pageHeader3"
    },
    large: {
        mobile: "pageHeader5",
        tablet: "pageHeader3",
        desktop: "pageHeader1"
    }
};
var SPACING_MAP = {
    small: "0.5em",
    medium: "1.25em",
    large: "2em"
};
var MAX_WIDTH_MAP = {
    small: "10ch",
    medium: "15ch",
    large: "20ch",
    none: "none"
};
var Heading_Styles = (0,labelStyles/* labelStyles */.B)("Heading", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        });
    },
    container: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: "1170px",
        margin: "0 auto",
        padding: "0 20px"
    }),
    heading: function(props) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[SIZE_MAP[props.size].mobile]), (_obj = {
            color: Colors/* Colors */.w[props.color],
            textAlign: props.isCentered ? "center" : "left",
            margin: props.isCentered ? "0 auto" : 0,
            padding: "".concat(SPACING_MAP[props.spacing], " 0"),
            maxWidth: MAX_WIDTH_MAP[props.maxWidth]
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[SIZE_MAP[props.size].tablet])), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[SIZE_MAP[props.size].desktop])), _obj)));
    }
});
function Heading_Heading(props) {
    var Tag = props.tag;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Heading_Styles.root(props.backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Heading_Styles.container
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Tag, {
        css: Heading_Styles.heading(props)
    }, props.text)));
}

;// CONCATENATED MODULE: ./src/components/Heading/Heading.builder.ts




/* harmony default export */ var Heading_builder = (createBuilderModule(Heading_Heading, {
    name: "Heading",
    image: "https://cdn.zappy.app/8bea639e04905dfa561777218501d1c4.svg",
    inputs: [
        {
            name: "text",
            type: "string",
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.text
        },
        {
            name: "tag",
            type: "string",
            enum: [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6"
            ],
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.tag
        },
        {
            name: "color",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.earth */.US.earth,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800
            ],
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.color
        },
        {
            name: "size",
            type: "string",
            enum: Object.keys(SIZE_MAP),
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.size
        },
        {
            name: "spacing",
            type: "string",
            enum: Object.keys(SPACING_MAP),
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.spacing
        },
        {
            name: "maxWidth",
            type: "string",
            enum: Object.keys(MAX_WIDTH_MAP),
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.maxWidth
        },
        {
            name: "isCentered",
            type: "boolean",
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.isCentered
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            required: true,
            defaultValue: Heading_fixtures_DEFAULT_VALUES.backgroundColor
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/HeadingLevel/HeadingLevel.tsx


function HeadingLevel_HeadingLevel(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingLevel/* HeadingLevel */.y, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/HeadingLevel/HeadingLevel.builder.tsx



/* harmony default export */ var HeadingLevel_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(HeadingLevel_HeadingLevel), {
    name: "HeadingLevel",
    image: "https://cdn.zappy.app/27e375dc0c0b465ac8b8b1bf5b63837d.png",
    inputs: []
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Grid/Grid.js
var Grid_Grid = __webpack_require__(56119);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Hero/constants.js
const constants_breakpoints = {
    mobile: 375,
    tablet: 768,
};
const backgroundColorMap = {
    ocean40: 'night',
    sun60: 'moss',
    lava60: 'zapier',
    white: 'neutral100',
    neutral100: 'neutral100',
    zapier: 'zapier',
    night: 'night',
    moss: 'moss',
    neutral800: 'neutral800',
};
//# sourceMappingURL=constants.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Hero/utils.js

const transformBackgroundColor = (backgroundColor) => {
    return backgroundColorMap[backgroundColor] || backgroundColor;
};
const mapBackgroundColorToV5HeadingColorName = (color) => {
    const colorMap = {
        neutral100: 'neutral700',
        zapier: 'cream',
    };
    return colorMap[color] || 'neutral100';
};
const mapBackgroundColorToV5TextColorName = (color) => {
    const colorMap = {
        neutral100: 'neutral800',
        zapier: 'cream',
    };
    return colorMap[color] || 'neutral100';
};
const validateZapierBackgroundAccessibility = (backgroundColor, isSubscriptionForm, isCtaDisclaimerEnabled) => {
    const isZapierOrange = backgroundColor === 'zapier';
    if (isZapierOrange && (isSubscriptionForm || isCtaDisclaimerEnabled)) {
        console.error(`Do not use the ${isSubscriptionForm ? 'subscription form' : 'cta disclaimer'} with the zapier background. ` +
            `The disclaimer text accessibility is poor on the zapier background.`);
    }
};
const getSupportedCTAColor = (ctaColor, backgroundColor) => {
    const supportedCTAColors = {
        neutral100: ['primary', 'primary-alt', 'brand'],
        zapier: ['primary-alt'],
        night: ['primary-dark', 'brand'],
        moss: ['primary-dark', 'brand'],
        neutral800: ['primary-dark', 'brand'],
    };
    if (supportedCTAColors[backgroundColor].includes(ctaColor)) {
        return ctaColor;
    }
    return supportedCTAColors[backgroundColor][0];
};
//# sourceMappingURL=utils.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Hero/HeroStandard/HeroStandard.js






const SubscriptionFormStyles = {
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      align-items: stretch;
      flex-direction: column;
    }

    // Button shouldn't take up full width when subscription form is enabled;
    button,
    a {
      width: auto;
    }
  `,
    ctaDisclaimer: emotion_react_browser_esm/* css */.iv `
    margin: 10px 0;
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      margin: 10px 0;
    }
    @media screen and (max-width: ${constants_breakpoints.mobile}px) {
      text-align: left;
    }
  `,
};
const HeroStandard_Styles = (0,labelStyles/* labelStyles */.B)('Hero', {
    root: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[backgroundColor]};
    padding: 20px;
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      padding: 40px;
    }
  `,
    content: (maxWidth) => emotion_react_browser_esm/* css */.iv `
    display: grid;
    align-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    max-width: ${maxWidth}px;
    margin: 0 auto;

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      grid-template-columns: repeat(2, 1fr);
    }
  `,
    labelContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 10px;
  `,
    heading: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader4 */.ZT.pageHeader4}
    color: ${Colors/* Colors */.w[mapBackgroundColorToV5TextColorName(backgroundColor)]};
    margin-bottom: 10px;

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      ${Typography/* Typography.pageHeader3 */.ZT.pageHeader3}
      margin-bottom: 20px;
    }
  `,
    description: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    color: ${Colors/* Colors */.w[mapBackgroundColorToV5HeadingColorName(backgroundColor)]};
  `,
    textContent: emotion_react_browser_esm/* css */.iv `
    max-width: 470px;
    text-align: center;
    margin: 0 auto;

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      margin: 0;
      text-align: left;
    }
  `,
    mediaContent: emotion_react_browser_esm/* css */.iv `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
    ctaContainer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin-top: 20px;
    text-align: center;

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      margin-top: 40px;
      display: flex;
      align-items: center;
      text-align: left;
    }
    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form', SubscriptionFormStyles.ctaContainer)}
  `,
    ctaDisclaimer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin: 10px auto 0 auto;
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      margin-top: 0;
      margin-left: 20px;
    }

    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form-disclaimer', SubscriptionFormStyles.ctaDisclaimer)}
  `,
});
const HeroStandard = ({ backgroundColor = 'neutral100', ctaColor = 'primary', isSubscriptionForm = false, subscriptionPlaceholder = 'Email address', heading, description, ctaText, ctaHref, ctaDisclaimer, onCtaClick, onCtaKeyDown, onSubscriptionFormSubmit, children, maxWidth = 1170, ctaTarget, label, labelIcon, labelColor, }) => {
    const mappedBackgroundColor = transformBackgroundColor(backgroundColor);
    validateZapierBackgroundAccessibility(mappedBackgroundColor, isSubscriptionForm, !!ctaDisclaimer);
    const getCtaComponent = () => {
        const sharedProps = {
            children: ctaText,
            href: !isSubscriptionForm ? ctaHref : undefined,
            onClick: onCtaClick,
            onKeyDown: onCtaKeyDown,
            isFullWidth: true,
            type: isSubscriptionForm ? 'submit' : 'button',
            target: ctaTarget,
        };
        const color = getSupportedCTAColor(ctaColor, mappedBackgroundColor);
        return color === 'brand' ? ((0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, sharedProps))) : color === 'primary-dark' ? ((0,isolateComponent/* isolateComponent */.U)(DarkBackgroundButton, Object.assign({}, sharedProps))) : ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, sharedProps, { color: color, size: "small" })));
    };
    const isDisclaimerElement = !!ctaDisclaimer && (0,react.isValidElement)(ctaDisclaimer);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.root(mappedBackgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.content(maxWidth) },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.textContent },
                label && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.labelContainer },
                    (0,isolateComponent/* isolateComponent */.U)(TagLabel, { color: labelColor }, labelIcon ? ((0,isolateComponent/* isolateComponent */.U)(Grid_Grid/* Grid */.r, { alignItems: "center", columns: "auto max-content", gap: 5 },
                        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: labelIcon, size: 20 }),
                        label)) : (label)))),
                (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: HeroStandard_Styles.heading(mappedBackgroundColor) }, heading),
                description && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.description(mappedBackgroundColor) }, description)),
                ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.ctaContainer(isSubscriptionForm) }, isSubscriptionForm ? ((0,isolateComponent/* isolateComponent */.U)(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: mappedBackgroundColor === 'neutral100'
                        ? 'primary'
                        : 'secondary' })) : ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                    (0,isolateComponent/* isolateComponent */.U)("div", null, getCtaComponent()),
                    ctaDisclaimer && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.ctaDisclaimer(isSubscriptionForm) }, isDisclaimerElement ? (ctaDisclaimer) : ((0,isolateComponent/* isolateComponent */.U)(Text_Text/* Text */.x, { tag: "p", type: "paragraph3", color: mapBackgroundColorToV5HeadingColorName(mappedBackgroundColor) }, ctaDisclaimer))))))))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroStandard_Styles.mediaContent }, children))));
};
//# sourceMappingURL=HeroStandard.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Hero/HeroColorBlock/HeroColorBlock.js







const HeroColorBlock_Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('HeroColorBlock', [
    'primaryBackgroundColorStop',
    'secondaryBackgroundColorStop',
]);
const HeroColorBlock_SubscriptionFormStyles = {
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    max-width: 470px;
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      align-items: stretch;
      flex-direction: column;
    }
  `,
    ctaDisclaimer: emotion_react_browser_esm/* css */.iv `
    margin: 10px 0;
    text-align: left;
  `,
};
const HeroColorBlock_Styles = (0,labelStyles/* labelStyles */.B)('HeroColorBlock', {
    root: (backgroundColor = 'zapier') => emotion_react_browser_esm/* css */.iv `
    padding: 20px 19.5px;
    ${HeroColorBlock_Vars.primaryBackgroundColorStop}: ${Colors/* Colors */.w[backgroundColor]};
    ${HeroColorBlock_Vars.secondaryBackgroundColorStop}: ${Colors/* Colors.neutral100 */.w.neutral100};
    background: linear-gradient(
      to bottom,
      var(${HeroColorBlock_Vars.primaryBackgroundColorStop}) 80%,
      var(${HeroColorBlock_Vars.secondaryBackgroundColorStop}) 20%
    );
    @media screen and (min-width: ${constants_breakpoints.mobile}px) {
      padding: 40px 31px;
      background: linear-gradient(
        to bottom,
        var(${HeroColorBlock_Vars.primaryBackgroundColorStop}) 75%,
        var(${HeroColorBlock_Vars.secondaryBackgroundColorStop}) 25%
      );
    }
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      padding: 60px 31px;
      background: linear-gradient(
        to bottom,
        var(${HeroColorBlock_Vars.primaryBackgroundColorStop}) 54.55%,
        var(${HeroColorBlock_Vars.secondaryBackgroundColorStop}) 45.45%
      );
    }
  `,
    content: emotion_react_browser_esm/* css */.iv `
    max-width: 770px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
    textContent: emotion_react_browser_esm/* css */.iv `
    margin: auto;
  `,
    labelContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 10px;
  `,
    heading: (backgroundColor) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader4 */.ZT.pageHeader4}
    color: ${Colors/* Colors */.w[backgroundColor === 'zapier' ? 'cream' : 'neutral100']};
    margin-bottom: 10px;
    text-align: center;

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      ${Typography/* Typography.pageHeader3 */.ZT.pageHeader3}
      margin-bottom: 20px;
    }
  `,
    description: (backgroundColor) => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    color: ${Colors/* Colors */.w[backgroundColor === 'zapier' ? 'cream' : 'neutral100']};
    text-align: center;
    margin: 0 auto;
    max-width: 570px;
  `,
    ctaContainer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin-top: 20px;
    text-align: center;
    width: 100%;
    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      margin-top: 40px;
    }
    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form', HeroColorBlock_SubscriptionFormStyles.ctaContainer)}
  `,
    ctaButtonWrapper: emotion_react_browser_esm/* css */.iv `
    margin: 0 auto;

    // Button should take up full width in mobile only;
    button,
    a {
      width: 100%;
    }

    @media screen and (min-width: ${constants_breakpoints.tablet}px) {
      button,
      a {
        width: auto;
      }
    }
  `,
    ctaDisclaimer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin: 10px 0 0 0;
    text-align: center;
    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form-disclaimer', HeroColorBlock_SubscriptionFormStyles.ctaDisclaimer)}
  `,
    mediaContent: emotion_react_browser_esm/* css */.iv `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
  `,
});
const HeroColorBlock = ({ ctaColor = 'primary-alt', isSubscriptionForm = false, subscriptionPlaceholder = 'Email address', backgroundColor = 'zapier', heading, description, ctaText, ctaHref, ctaDisclaimer, onCtaClick, onCtaKeyDown, children, onSubscriptionFormSubmit, ctaTarget, label, labelIcon, labelColor, }) => {
    const mappedBackgroundColor = transformBackgroundColor(backgroundColor);
    validateZapierBackgroundAccessibility(mappedBackgroundColor, isSubscriptionForm, !!ctaDisclaimer);
    const getCtaComponent = () => {
        const sharedProps = {
            children: ctaText,
            href: !isSubscriptionForm ? ctaHref : undefined,
            onClick: onCtaClick,
            onKeyDown: onCtaKeyDown,
            type: isSubscriptionForm
                ? 'submit'
                : 'button',
            'data-testid': 'color-block-hero-cta-button',
            target: ctaTarget,
        };
        const color = getSupportedCTAColor(ctaColor, mappedBackgroundColor);
        return color === 'brand' ? ((0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, sharedProps))) : color === 'primary-dark' ? ((0,isolateComponent/* isolateComponent */.U)(DarkBackgroundButton, Object.assign({}, sharedProps))) : ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, sharedProps, { color: color, size: "small" })));
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.root(mappedBackgroundColor), "data-background-color": mappedBackgroundColor },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.content },
            label && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.labelContainer },
                (0,isolateComponent/* isolateComponent */.U)(TagLabel, { color: labelColor }, labelIcon ? ((0,isolateComponent/* isolateComponent */.U)(Grid_Grid/* Grid */.r, { alignItems: "center", columns: "auto max-content", gap: 5 },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: labelIcon, size: 20 }),
                    label)) : (label)))),
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: HeroColorBlock_Styles.heading(mappedBackgroundColor) }, heading),
            description && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.description(mappedBackgroundColor) }, description)),
            ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.ctaContainer(isSubscriptionForm) }, isSubscriptionForm ? ((0,isolateComponent/* isolateComponent */.U)(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: mappedBackgroundColor === 'neutral100'
                    ? 'primary'
                    : 'secondary' })) : ((0,isolateComponent/* isolateComponent */.U)("div", null,
                (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.ctaButtonWrapper }, getCtaComponent()),
                ctaDisclaimer && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.ctaDisclaimer(isSubscriptionForm) },
                    (0,isolateComponent/* isolateComponent */.U)(Text_Text/* Text */.x, { tag: "div", type: "paragraph3", color: mappedBackgroundColor === 'zapier'
                            ? 'cream'
                            : 'neutral100' }, ctaDisclaimer))))))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroColorBlock_Styles.mediaContent }, children))));
};
//# sourceMappingURL=HeroColorBlock.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Hero/HeroFeatures/HeroFeatures.js





const HeroFeatures_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const HeroFeatures_SubscriptionFormStyles = {
    ctaContainer: emotion_react_browser_esm/* css */.iv `
    max-width: 350px;
    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      max-width: 470px;
      align-items: stretch;
      flex-direction: column;
    }
  `,
    ctaDisclaimer: emotion_react_browser_esm/* css */.iv `
    margin: 10px 0;
    text-align: left;
    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      margin: 10px 0;
    }
  `,
};
const HeroFeatures_Styles = (0,labelStyles/* labelStyles */.B)('HeroFeatures', {
    root: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${Colors/* Colors */.w[backgroundColor]};
  `,
    mediaContent: emotion_react_browser_esm/* css */.iv `
    width: 100%;
    img {
      min-height: 341px;
      object-fit: cover;
    }
  `,
    content: emotion_react_browser_esm/* css */.iv `
    margin: 0 auto;
    padding: 20px;
    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      padding: 80px 0;
    }
    @media screen and (min-width: ${HeroFeatures_breakpoints.desktop}px) {
      padding: 85px 0;
    }
    max-width: 770px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
    textContent: emotion_react_browser_esm/* css */.iv `
    margin: auto;
  `,
    labelContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 10px;
  `,
    heading: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader4 */.ZT.pageHeader4}
    color: ${Colors/* Colors */.w[mapBackgroundColorToV5TextColorName(backgroundColor)]};
    margin-bottom: 10px;
    text-align: center;

    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      ${Typography/* Typography.pageHeader3 */.ZT.pageHeader3}
    }
  `,
    description: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    color: ${Colors/* Colors */.w[mapBackgroundColorToV5HeadingColorName(backgroundColor)]};
    text-align: center;
    margin: 0 auto;
    max-width: 570px;
  `,
    ctaContainer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin-top: 30px;
    text-align: center;
    width: 100%;
    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      margin-top: 40px;
    }
    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form', HeroFeatures_SubscriptionFormStyles.ctaContainer)}
  `,
    ctaButtonWrapper: emotion_react_browser_esm/* css */.iv `
    margin: 0 auto;

    // Button should take up full width in mobile only;
    button,
    a {
      width: 100%;
    }

    @media screen and (min-width: ${HeroFeatures_breakpoints.tablet}px) {
      button,
      a {
        width: auto;
      }
    }
  `,
    ctaDisclaimer: (isSubscriptionForm = false) => emotion_react_browser_esm/* css */.iv `
    margin: 10px 0 0 0;
    text-align: center;
    ${isSubscriptionForm &&
        (0,withModifier/* withModifier */.Q)('subscription-form-disclaimer', HeroFeatures_SubscriptionFormStyles.ctaDisclaimer)}
  `,
});
const HeroFeatures = ({ backgroundColor = 'neutral100', ctaColor = 'primary', isSubscriptionForm = false, subscriptionPlaceholder = 'Email address', heading, description, ctaText, ctaHref, ctaDisclaimer, onCtaClick, onCtaKeyDown, children, onSubscriptionFormSubmit, ctaTarget, label, labelIcon, labelColor, }) => {
    validateZapierBackgroundAccessibility(backgroundColor, isSubscriptionForm, !!ctaDisclaimer);
    const getCtaComponent = () => {
        const sharedProps = {
            children: ctaText,
            href: !isSubscriptionForm ? ctaHref : undefined,
            onClick: onCtaClick,
            onKeyDown: onCtaKeyDown,
            type: isSubscriptionForm
                ? 'submit'
                : 'button',
            'data-testid': 'standard-hero-cta-button',
            target: ctaTarget,
        };
        const color = getSupportedCTAColor(ctaColor, backgroundColor);
        return color === 'brand' ? ((0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, sharedProps))) : color === 'primary-dark' ? ((0,isolateComponent/* isolateComponent */.U)(DarkBackgroundButton, Object.assign({}, sharedProps))) : ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, sharedProps, { color: color }, (isSubscriptionForm && { size: 'small' }))));
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.root(backgroundColor), "data-background-color": backgroundColor },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.mediaContent }, children),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.content },
            label && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.labelContainer },
                (0,isolateComponent/* isolateComponent */.U)(TagLabel, { color: labelColor }, labelIcon ? ((0,isolateComponent/* isolateComponent */.U)(Grid_Grid/* Grid */.r, { alignItems: "center", columns: "auto max-content", gap: 5 },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: labelIcon, size: 20 }),
                    label)) : (label)))),
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: HeroFeatures_Styles.heading(backgroundColor) }, heading),
            description && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.description(backgroundColor) }, description)),
            ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.ctaContainer(isSubscriptionForm) }, isSubscriptionForm ? ((0,isolateComponent/* isolateComponent */.U)(SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: backgroundColor === 'neutral100' ? 'primary' : 'secondary' })) : ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                (0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.ctaButtonWrapper }, getCtaComponent()),
                ctaDisclaimer && ((0,isolateComponent/* isolateComponent */.U)("div", { css: HeroFeatures_Styles.ctaDisclaimer(isSubscriptionForm) },
                    (0,isolateComponent/* isolateComponent */.U)(Text_Text/* Text */.x, { tag: "div", type: "paragraph3", color: mapBackgroundColorToV5HeadingColorName(backgroundColor) }, ctaDisclaimer))))))))));
};
//# sourceMappingURL=HeroFeatures.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/HeroSection/HeroSection.tsx




function HeroSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: calc(100vw - 40px);\n"
    ]);
    HeroSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function HeroSection(props) {
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var handleCtaClick = function() {
        emitCTAClickEvent({
            text: innerText(props.ctaText),
            section: "hero_section_".concat(props.variant),
            href: props.ctaHref
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: props.ctaName,
            cta_raw_text: props.ctaText,
            cta_goal: props.ctaGoal
        });
    };
    var getDefaultCtaColor = function() {
        if (props.backgroundColor === colors/* COLOR_KEYS.night */.US.night || props.backgroundColor === colors/* COLOR_KEYS.moss */.US.moss || props.backgroundColor === colors/* COLOR_KEYS.ocean40 */.US.ocean40 || props.backgroundColor === colors/* COLOR_KEYS.sun60 */.US.sun60 || props.backgroundColor === colors/* COLOR_KEYS.neutral800 */.US.neutral800) {
            return "primary-dark";
        }
        if (props.backgroundColor === colors/* COLOR_KEYS.zapier */.US.zapier || colors/* COLOR_KEYS.lava60 */.US.lava60) {
            return "primary-alt";
        }
        return "primary";
    };
    var heroProps = {
        heading: props.heading,
        ctaText: props.ctaText,
        ctaHref: props.ctaHref,
        ctaColor: props.ctaColor || getDefaultCtaColor(),
        ctaDisclaimer: props.ctaDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: props.backgroundColor,
            html: props.ctaDisclaimer
        }),
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: props.backgroundColor,
            html: props.description
        }),
        onCtaClick: handleCtaClick,
        ctaTarget: props.openInNewTab ? "_blank" : "_self",
        label: props.label,
        labelIcon: props.labelIcon,
        labelColor: props.labelColor
    };
    var _obj;
    var heroFactory = (_obj = {}, (0,_define_property/* default */.Z)(_obj, HeroVariant.standard, /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroStandard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, heroProps), {
        backgroundColor: props.backgroundColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaChildren, {
            children: props.children
        })
    }))), (0,_define_property/* default */.Z)(_obj, HeroVariant.colorBlock, /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroColorBlock, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, heroProps), {
        // @ts-ignore -`neutral100` is not a supported value for `HeroColorBlock`
        backgroundColor: props.backgroundColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaChildren, {
            children: props.children
        })
    }))), (0,_define_property/* default */.Z)(_obj, HeroVariant.features, /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroFeatures, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, heroProps), {
        // @ts-ignore - `HeroFeatures` only accepts V5 colors
        backgroundColor: props.backgroundColor,
        children: props.children
    }))), _obj);
    return heroFactory[props.variant] || null;
}
var MediaChildren = emotion_styled_browser_esm/* default.div */.Z.div(HeroSection_templateObject());

;// CONCATENATED MODULE: ./src/components/sections/HeroSection/HeroSection.builder.tsx








/* harmony default export */ var HeroSection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(withTracking(HeroSection, {
    sectionName: events/* SectionName.HeroSection */.jz.HeroSection
})), {
    name: "HeroSection",
    image: "https://cdn.zappy.app/b131ef7a291b8a1a46b47e432e98dd4b.png",
    defaultChildren: [
        imgElement({
            src: "https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png"
        }), 
    ],
    inputs: [
        {
            name: "variant",
            type: "string",
            defaultValue: HeroVariant.standard,
            enum: [
                HeroVariant.standard,
                HeroVariant.colorBlock,
                HeroVariant.features, 
            ]
        },
        {
            name: "heading",
            type: "string",
            defaultValue: "Example Heading",
            required: true
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier, 
            ],
            defaultValue: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
            required: true
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: "Sign up"
        },
        {
            name: "ctaName",
            type: "string",
            enum: Object.values(events/* CtaName */.XE),
            defaultValue: events/* CtaName.signup */.XE.signup,
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA."
        },
        {
            name: "ctaGoal",
            type: "string",
            enum: Object.values(events/* CtaGoal */.LK),
            defaultValue: events/* CtaGoal.signup */.LK.signup,
            helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA."
        },
        {
            name: "ctaHref",
            type: "string",
            defaultValue: "#"
        },
        {
            name: "ctaDisclaimer",
            type: "richText",
            defaultValue: 'By signing up, you agree to Zapier’s <a href="https://zapier.com/legal" target="_blank">Terms of Service</a> and <a href="https://zapier.com/privacy" target="_blank">Privacy Policy</a>'
        },
        {
            name: "openInNewTab",
            helperText: "Controls whether or not the CTA link opens in a new tab",
            type: "boolean"
        },
        {
            name: "ctaColor",
            type: "string",
            enum: [
                "primary",
                "primary-alt",
                "primary-dark",
                "brand"
            ]
        },
        {
            name: "label",
            type: "string"
        },
        {
            name: "labelIcon",
            type: "string",
            enum: Object.values(ICON_NAMES)
        },
        {
            name: "labelColor",
            type: "string",
            enum: [
                "info",
                "success",
                "error",
                "warning",
                "white",
                "gray",
                "peach",
                "neutral300",
                "bolt",
                "cream", 
            ]
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/readCookie.js
var readCookie = __webpack_require__(59251);
;// CONCATENATED MODULE: ./src/components/HubSpotForm/HubSpotForm.tsx

function HubSpotForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 570px;\n  margin: 0 auto;\n  padding: 35px 30px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  border: 1px solid ",
        ";\n  box-shadow: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    HubSpotForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HubSpotForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 200px;\n  display: flex;\n  align-items: center;\n"
    ]);
    HubSpotForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HubSpotForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  text-align: center;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    HubSpotForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HubSpotForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n  text-align: center;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    HubSpotForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









function HubSpotForm(param) {
    var description = param.description, hubspotFormId = param.hubspotFormId, hubspotPortalId = param.hubspotPortalId, interaction_raw_text = param.interaction_raw_text, prefilledFields = param.prefilledFields, title = param.title;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(unsecureID("hubspot-form-")), containerID = ref[0];
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    (0,react.useEffect)(function() {
        // https://legacydocs.hubspot.com/global-form-events
        var handleFormCallback = function(event) {
            if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormSubmit") {
                emitUserInteractionEvent({
                    event_action: avro/* EventAction.click */.AO.click,
                    interaction_name: avro/* InteractionName.call_to_action */.AI.call_to_action,
                    interaction_raw_text: interaction_raw_text || title,
                    option_selected: avro/* CTAType.cta_button */.g8.cta_button,
                    custom_tracking_fields: {
                        section_name: "HubSpotForm",
                        hubspot_form_id: hubspotFormId,
                        hubspot_portal_id: hubspotPortalId
                    }
                });
                trackEvent(events/* EventName.HUBSPOT_FORM_SUBMITTED */.B_.HUBSPOT_FORM_SUBMITTED, {
                    title: title,
                    hubspot_form_id: hubspotFormId,
                    hubspot_portal_id: hubspotPortalId,
                    path: window.location.pathname
                });
            }
        };
        window.addEventListener("message", handleFormCallback);
        return function() {
            window.removeEventListener("message", handleFormCallback);
        };
    // Including `trackEvent` as a dependency causes this effect to be run much more than needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hubspotFormId,
        hubspotPortalId,
        title
    ]);
    var mountForm = function() {
        var prefillFields = function prefillFields($form) {
            prefilledFields === null || prefilledFields === void 0 ? void 0 : prefilledFields.forEach(function(param) {
                var name = param.name, value = param.value, cookieToBind = param.cookieToBind;
                var input = $form[0].querySelector("input[name=".concat(name, "]"));
                input.value = cookieToBind && cookieToBind.trim() !== "" ? (0,readCookie/* readCookie */.v)(cookieToBind) : value;
                input.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
            });
        };
        if (typeof hbspt === "undefined" || !containerRef.current || containerRef.current.dataset.mounted === "true") {
            return;
        }
        hbspt.forms.create({
            formId: hubspotFormId,
            portalId: hubspotPortalId,
            target: "#".concat(containerRef.current.id),
            onFormReady: prefillFields
        });
        containerRef.current.dataset.mounted = "true";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://js.hsforms.net/forms/v2.js",
                onReady: mountForm
            }),
            !!(prefilledFields === null || prefilledFields === void 0 ? void 0 : prefilledFields.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HubSpotForm_Container, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
                            html: description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                        id: containerID,
                        ref: containerRef,
                        "data-mounted": "false"
                    })
                ]
            })
        ]
    });
}
var HubSpotForm_Container = emotion_styled_browser_esm/* default.div */.Z.div(HubSpotForm_templateObject(), Colors/* Colors.gray20 */.w.gray20, Shadows/* Shadows.elevation5 */.f.elevation5, Colors/* Colors.white */.w.white);
var Form = emotion_styled_browser_esm/* default.div */.Z.div(HubSpotForm_templateObject1());
var Title = emotion_styled_browser_esm/* default.h3 */.Z.h3(HubSpotForm_templateObject2(), Colors/* Colors.gray */.w.gray, Typography/* Typography.sectionHeader3Extrabold */.ZT.sectionHeader3Extrabold);
var Description = emotion_styled_browser_esm/* default.div */.Z.div(HubSpotForm_templateObject3(), Colors/* Colors.gray80 */.w.gray80, Typography/* Typography.smallPrint1 */.ZT.smallPrint1);

;// CONCATENATED MODULE: ./src/components/HubSpotForm/HubSpotForm.builder.tsx


/* harmony default export */ var HubSpotForm_builder = (createBuilderModule(HubSpotForm, {
    name: "HubSpotForm",
    image: "https://cdn.zappy.app/65aca327f8d8f58911a8564e9ab0500d.png",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Request a demo"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "<p>We get it: Buying essential software for your business is hard. " + "But we want to make it easier.</p>"
        },
        {
            name: "hubspotPortalId",
            type: "string",
            defaultValue: "7462085",
            required: true
        },
        {
            name: "hubspotFormId",
            type: "string",
            required: true
        },
        {
            name: "prefilledFields",
            helperText: "Use to have any fields prefilled when the form loads. This can also be used for hidden fields. https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options",
            type: "list",
            subFields: [
                {
                    friendlyName: "Field name / contact property",
                    helperText: 'The contact property in Hubspot, which is also the "name" property of the HTML input (https://cdn.zappy.app/203ef02c90c194e3c4c1ae36d7636a00.png)',
                    name: "name",
                    required: true,
                    type: "string"
                },
                {
                    friendlyName: "Field value",
                    helperText: "The value that you would like to pre-populate in the field",
                    name: "value",
                    type: "string"
                },
                {
                    name: "cookieToBind",
                    type: "string",
                    helperText: 'The name of the cookie to bind the prefilled value to (used in place of the "Field value" input above)'
                }, 
            ]
        },
        {
            name: "interaction_raw_text",
            type: "string",
            helperText: "The value that will be sent in tracking events as 'interaction_raw_text' when a user submits the form. If this is empty, then the form's title will be sent."
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Alert/Alert.js
var Alert = __webpack_require__(20271);
// EXTERNAL MODULE: ./src/hooks/useDeepCompareEffect.ts
var useDeepCompareEffect = __webpack_require__(52965);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/BooleanInput/LabeledBooleanInput.js + 1 modules
var LabeledBooleanInput = __webpack_require__(45246);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Field/Field.js
var Field = __webpack_require__(17688);
// EXTERNAL MODULE: ../../node_modules/downshift/dist/downshift.esm.js + 2 modules
var downshift_esm = __webpack_require__(57490);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/FloatingMenu/FloatingMenu.js
var FloatingMenu = __webpack_require__(35080);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Input/Input.js
var Input = __webpack_require__(13030);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/fromEntries.js
var fromEntries = __webpack_require__(93594);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/utils/omit.js

const omit = (obj, keys) => {
    return (0,fromEntries/* fromEntries */.s)(Object.entries(obj).filter(([key]) => !keys.includes(key)));
};
//# sourceMappingURL=omit.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Dropdown/Dropdown.js
var Dropdown_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};










const isDisabled = (props) => {
    return props.isDisabled || props.items.length === 0;
};
const Dropdown_Styles = (0,labelStyles/* labelStyles */.B)('Dropdown', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        position: 'relative',
    }),
    buttonWrap: (props) => ({
        cursor: isDisabled(props) ? 'default' : 'pointer',
    }),
    button: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: '100%',
        overflow: 'hidden',
    }),
    buttonText: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }),
    placeholder: (0,emotion_react_browser_esm/* css */.iv)({
        color: Colors/* Colors.neutral600 */.w.neutral600,
    }),
});
const buildAriaLabel = ({ label, value, placeholder, }) => {
    return [value, label, !value && placeholder].filter(Boolean).join(', ');
};
const Dropdown_defaultProps = {
    size: 'small',
    getLabelForItem: (item) => item.label,
    renderFloatingMenu: (props) => (0,isolateComponent/* isolateComponent */.U)(FloatingMenu/* FloatingMenu */.A, Object.assign({}, props)),
    menuAriaLabel: 'List of items',
};
function Dropdown(_props) {
    const props = Object.assign(Object.assign({}, Dropdown_defaultProps), _props);
    const parentRef = (0,react.useRef)(null);
    const itemToString = (item) => {
        return item ? props.getLabelForItem(item) : '';
    };
    const onChangeNoNull = (selection) => {
        var _a;
        if (selection) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, selection);
        }
    };
    const onSelectNoNull = (selection) => {
        var _a;
        if (selection) {
            (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, selection);
        }
    };
    const stateReducer = (_, changes) => {
        switch (changes.type) {
            case downshift_esm/* default.stateChangeTypes.keyDownEscape */.ZP.stateChangeTypes.keyDownEscape:
                return {
                    isOpen: false,
                };
            default:
                return changes;
        }
    };
    const renderButtonForItem = props.renderButtonForItem || props.getLabelForItem;
    return ((0,isolateComponent/* isolateComponent */.U)(downshift_esm/* default */.ZP, { initialSelectedItem: props.initialSelectedItem, inputId: props.inputId, itemCount: props.items.length, itemToString: itemToString, onChange: onChangeNoNull, onSelect: onSelectNoNull, stateReducer: stateReducer, selectedItem: props.selectedItem }, ({ clearSelection, closeMenu, getInputProps, getItemProps, getMenuProps, getRootProps, highlightedIndex, isOpen, openMenu, selectItem, selectedItem, setHighlightedIndex, }) => {
        const hasSelectedItem = !!selectedItem;
        const renderIcon = () => typeof props.renderIcon === 'function'
            ? props.renderIcon(selectedItem)
            : undefined;
        const rootProps = omit(getRootProps(), ['aria-labelledby']);
        const onBlur = (e) => {
            if (props.onBlur) {
                const meta = {
                    didBlurWithin: parentRef.current
                        ? parentRef.current.contains(e.relatedTarget)
                        : false,
                    closeMenu,
                };
                props.onBlur(e, meta);
            }
            else {
                closeMenu();
            }
        };
        const { onChange, onClick } = props, propsNoOnChangeOrOnClick = Dropdown_rest(props, ["onChange", "onClick"]);
        return ((0,isolateComponent/* isolateComponent */.U)("div", Object.assign({ "aria-label": props.menuAriaLabel, "aria-labelledby": props.inputId, css: Dropdown_Styles.root }, rootProps, { onBlur: onBlur, ref: parentRef }),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: Dropdown_Styles.buttonWrap(props) },
                (0,isolateComponent/* isolateComponent */.U)(Input/* Input */.I, Object.assign({ onClick: () => {
                        if (isOpen === true) {
                            closeMenu();
                        }
                        else if (!isDisabled(props)) {
                            openMenu();
                        }
                        if (props.onClick)
                            props.onClick();
                    } }, propsNoOnChangeOrOnClick, (0,formatAriaAttrKeys/* camelCaseAriaAttrs */.j)(getInputProps()), { canClickIconAfter: false, id: props.inputId, isDisabled: isDisabled(props), renderIconAfter: () => (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: "arrowDropdown", size: 24 }), renderIconBefore: renderIcon }), (inputProps) => ((0,isolateComponent/* isolateComponent */.U)("button", Object.assign({}, {
                    'aria-activedescendant': inputProps['aria-activedescendant'],
                    'aria-invalid': inputProps['aria-invalid'],
                }, { "aria-controls": inputProps['aria-controls'], "aria-expanded": isOpen ? 'true' : 'false', "aria-haspopup": "true", "aria-label": buildAriaLabel({
                        label: inputProps['aria-label'] || '',
                        placeholder: props.placeholder,
                        value: hasSelectedItem
                            ? props.getLabelForItem(selectedItem)
                            : undefined,
                    }), css: [inputProps.css, Dropdown_Styles.button], disabled: inputProps.disabled, id: inputProps.id, onBlur: onBlur, onFocus: props.onFocus, onKeyDown: inputProps.onKeyDown, type: "button" }), hasSelectedItem ? ((0,isolateComponent/* isolateComponent */.U)("span", { css: Dropdown_Styles.buttonText }, renderButtonForItem(selectedItem))) : ((0,isolateComponent/* isolateComponent */.U)("span", { css: [Dropdown_Styles.buttonText, Dropdown_Styles.placeholder] }, props.placeholder)))))),
            isOpen &&
                props.renderFloatingMenu({
                    ariaLabel: props.menuAriaLabel,
                    clearSelection,
                    closeMenu,
                    items: props.items,
                    highlightedIndex,
                    getKeyForItem: props.getKeyForItem,
                    getLabelForItem: props.getLabelForItem,
                    getItemProps,
                    getMenuProps,
                    getInputProps,
                    renderIcon: props.renderIcon,
                    selectItem,
                    selectedItem,
                    setHighlightedIndex,
                })));
    }));
}
Dropdown.defaultProps = Dropdown_defaultProps;
//# sourceMappingURL=Dropdown.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/Form/Field.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var Field_Styles = (0,labelStyles/* labelStyles */.B)("FormField", {
    fieldset: (0,emotion_react_browser_esm/* css */.iv)({
        border: "none"
    }),
    helpText: (0,emotion_react_browser_esm/* css */.iv)({
        fontSize: 12,
        color: Colors/* Colors.gray60 */.w.gray60
    }),
    checkboxLabel: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        alignItems: "center"
    }),
    checkboxLabelRequiredText: (0,emotion_react_browser_esm/* css */.iv)({
        fontSize: "14px",
        color: Colors/* Colors.neutral700 */.w.neutral700,
        fontWeight: 400,
        marginLeft: "5px"
    }),
    checkboxError: (0,emotion_react_browser_esm/* css */.iv)({
        fontSize: "14px",
        color: Colors/* Colors.error400 */.w.error400
    })
});
function Field_Field(props) {
    var ref = (0,react.useState)(true), isPristine = ref[0], setIsPristine = ref[1];
    var handleChange = function(value) {
        props.onChange(value, isPristine);
        setIsPristine(false);
    };
    var fieldProps = (0,src_object_spread/* default */.Z)({
        label: props.label,
        isRequired: props.isRequired,
        isDisabled: props.isDisabled,
        isHiddenIfPrefilled: props.isHiddenIfPrefilled,
        error: props.error
    }, props.helpText && {
        renderHelpText: function() {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
                css: Field_Styles.helpText
            }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
                html: props.helpText || "",
                backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100
            }));
        }
    });
    if (props.type === "checkbox") {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(LabeledBooleanInput/* LabeledBooleanInput */.G, {
            type: "checkbox",
            name: props.name,
            checked: props.value,
            isDisabled: props.isDisabled,
            isErrored: !!props.error,
            onChange: function(event) {
                handleChange(event.currentTarget.checked);
            }
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
            css: Field_Styles.checkboxLabel
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, props.label), props.isRequired && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
            css: Field_Styles.checkboxLabelRequiredText
        }, "(required)"))), props.error && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: Field_Styles.checkboxError
        }, props.error));
    }
    if (props.type === "checkbox-group" || props.type === "radio-group") {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Field/* Field */.g, Object.assign({}, fieldProps, {
            renderInput: function() {
                var ref;
                /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)("fieldset", {
                    css: Field_Styles.fieldset
                }, (ref = props.options) === null || ref === void 0 ? void 0 : ref.map(function(option) {
                    var ref;
                    /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)(LabeledBooleanInput/* LabeledBooleanInput */.G, {
                        type: props.type === "checkbox-group" ? "checkbox" : "radio",
                        key: option.value,
                        name: props.name,
                        value: option.value,
                        checked: (ref = props.value) === null || ref === void 0 ? void 0 : ref.includes(option.value),
                        isDisabled: props.isDisabled,
                        onChange: function(event) {
                            var value = option.value;
                            if (props.type === "checkbox-group") {
                                var previousValue = props.value || [];
                                value = event.currentTarget.checked ? (0,_to_consumable_array/* default */.Z)(previousValue).concat([
                                    value
                                ]) : previousValue.filter(function(v) {
                                    return v !== value;
                                });
                            }
                            handleChange(value);
                        }
                    }, option.label);
                }));
            }
        }));
    }
    if (props.type === "dropdown") {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Field/* Field */.g, Object.assign({}, fieldProps, {
            renderInput: function(inputProps) {
                var ref;
                /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)(Dropdown, Object.assign({}, inputProps, {
                    getLabelForItem: function(item) {
                        return item.label;
                    },
                    placeholder: props.placeholder,
                    items: props.options || [],
                    selectedItem: (ref = props.options) === null || ref === void 0 ? void 0 : ref.find(function(option) {
                        return option.value === props.value;
                    }),
                    onChange: function(event) {
                        return handleChange(event.value);
                    }
                }));
            }
        }));
    }
    var _value;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Field/* Field */.g, Object.assign({}, fieldProps, {
        renderInput: function(inputProps) {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, Object.assign({}, inputProps, {
                name: props.name,
                value: (_value = props.value) !== null && _value !== void 0 ? _value : "",
                placeholder: props.placeholder,
                isFullWidth: true,
                onChange: function(event) {
                    handleChange(event.target.value);
                }
            }, props.type === "textarea" && {
                isMultiline: true,
                rows: 4
            }));
        }
    }));
}

;// CONCATENATED MODULE: ./src/components/Form/Form.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 
















var Form_Styles = (0,labelStyles/* labelStyles */.B)("Form", {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: 640,
        margin: "12px auto",
        padding: "32px 24px",
        boxSizing: "border-box",
        borderRadius: 10,
        border: "1px solid ".concat(Colors/* Colors.gray20 */.w.gray20),
        boxShadow: Shadows/* Shadows.elevation5 */.f.elevation5,
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100
    }),
    header: (0,emotion_react_browser_esm/* css */.iv)({
        display: "grid",
        placeItems: "center",
        gap: "8px",
        marginBottom: "32px"
    }),
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), {
        color: Colors/* Colors.neutral800 */.w.neutral800,
        textAlign: "center"
    })),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), {
        maxWidth: "384px",
        color: Colors/* Colors.neutral700 */.w.neutral700,
        textAlign: "center"
    })),
    form: (0,emotion_react_browser_esm/* css */.iv)({
        display: "grid",
        gap: 20
    }),
    block: (0,emotion_react_browser_esm/* css */.iv)({
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: 20
    }),
    button: (0,emotion_react_browser_esm/* css */.iv)({
        width: "100%",
        marginTop: "12px"
    }),
    confirmation: (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({
        minHeight: "480px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        padding: "20px 20px 40px",
        boxSizing: "border-box",
        textAlign: "center"
    }, Typography/* Typography.subHeader3Medium */.ZT.subHeader3Medium)),
    hidden: (0,emotion_react_browser_esm/* css */.iv)({
        display: "none"
    })
});
function Form_Form(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var _defaultValues;
    var ref1 = (0,react.useState)((_defaultValues = props.defaultValues) !== null && _defaultValues !== void 0 ? _defaultValues : {}), values = ref1[0], setValues = ref1[1];
    var ref2 = (0,react.useState)({}), fieldErrors = ref2[0], setFieldErrors = ref2[1];
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    /**
   * defaultValues may change while editing/previewing or if they are bound to
   * dynamic data. If editing/previewing, we want to blindly update value.
   * Otherwise, we only want to update the value if a value hasn't already been
   * set.
   * */ (0,useDeepCompareEffect/* useDeepCompareEffect */.KW)(function() {
        if (props.defaultValues) {
            setValues(function(previousValues) {
                var _defaultValues;
                var defaultValues = (_defaultValues = props.defaultValues) !== null && _defaultValues !== void 0 ? _defaultValues : {};
                if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
                    return (0,src_object_spread/* default */.Z)({}, previousValues, defaultValues);
                }
                return Object.entries(defaultValues).reduce(function(updatedValues, param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                    return previousValues[key] ? updatedValues : (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updatedValues), (0,_define_property/* default */.Z)({}, key, value));
                }, previousValues);
            });
        }
    }, [
        props.defaultValues
    ]);
    // Prefills the fields from the query params
    (0,react.useEffect)(function() {
        var isSlugOnly = Object.entries(router.query).length === 1;
        if (isSlugOnly) return;
        var fieldTypesMap = getFieldTypesMap(props.blocks || []);
        setValues(function(prevState) {
            return Object.entries(router.query).reduce(function(acc, param) {
                var type = fieldTypesMap[param[0]];
                if (!type) {
                    return acc;
                }
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, param[0], transformStringifiedValue(type, param[1])));
            }, prevState);
        });
    }, [
        router.query,
        props.blocks
    ]);
    // Prefill fields from specified cookies
    (0,useDeepCompareEffect/* useDeepCompareEffect */.KW)(function() {
        if (!props.cookieBindings) return;
        var fieldTypesMap = getFieldTypesMap(props.blocks || []);
        setValues(function(prevState) {
            return Object.entries(props.cookieBindings || {}).reduce(function(acc, param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                var type = fieldTypesMap[key];
                if (!type || !value) return acc;
                return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, transformStringifiedValue(type, (0,readCookie/* readCookie */.v)(value))));
            }, prevState);
        });
    }, [
        props.blocks,
        props.cookieBindings
    ]);
    (0,react.useEffect)(function() {
        if (props.fieldErrors) {
            setFieldErrors(props.fieldErrors);
        }
    }, [
        props.fieldErrors
    ]);
    var handleFieldChange = function(name, value) {
        setValues(function(previousValues) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previousValues), (0,_define_property/* default */.Z)({}, name, value));
        });
        if (fieldErrors[name]) {
            setFieldErrors(function(previousFieldErrors) {
                delete previousFieldErrors[name];
                return previousFieldErrors;
            });
        }
    };
    var isValid = function(field) {
        if (!field.isRequired) {
            return true;
        }
        var value = values[field.name];
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value === "string") {
            return value.trim() !== "";
        }
        return !!value;
    };
    var handleSubmit = function(event) {
        var ref;
        event.preventDefault();
        if (props.isDisabled) {
            return;
        }
        var errors = (ref = props.blocks) === null || ref === void 0 ? void 0 : ref.flatMap(function(block) {
            return block.fields || [];
        }).reduce(function(errors, field) {
            if (isValid(field)) {
                return errors;
            }
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, errors), (0,_define_property/* default */.Z)({}, field.name, "Please complete this required field"));
        }, {});
        if (errors && Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            return;
        }
        if (props.onSubmit) {
            props.onSubmit(values);
        }
    };
    var _submitButtonText;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Form_Styles.root
    }, (props.title || props.description) && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Form_Styles.header
    }, props.title && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: Form_Styles.title
    }, props.title), props.description && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Form_Styles.description
    }, props.description)), props.confirmationMessage ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Form_Styles.confirmation
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: "formCheckCircle",
        color: colors/* COLOR_KEYS.success300 */.US.success300,
        size: 64
    }), props.confirmationMessage) : /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("form", {
        css: Form_Styles.form,
        onSubmit: handleSubmit,
        noValidate: true
    }, (ref = props.blocks) === null || ref === void 0 ? void 0 : ref.map(function(block, index) {
        var ref;
        /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            key: index,
            css: [
                Form_Styles.block,
                !block.richText && ((ref = block.fields) === null || ref === void 0 ? void 0 : ref.every(function(field) {
                    var ref;
                    return field.isHidden || field.isHiddenIfPrefilled && ((ref = props.defaultValues) === null || ref === void 0 ? void 0 : ref[field.name]);
                })) ? Form_Styles.hidden : null, 
            ]
        }, block.fields && block.fields.map(function(field) {
            var ref;
            /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
                key: field.name,
                css: field.isHidden || field.isHiddenIfPrefilled && ((ref = props.defaultValues) === null || ref === void 0 ? void 0 : ref[field.name]) ? Form_Styles.hidden : null
            }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Field_Field, Object.assign({}, field, {
                value: values[field.name],
                error: fieldErrors[field.name],
                isDisabled: props.isDisabled,
                onChange: function(value, isPristine) {
                    if (isPristine) {
                        emitUserInteractionEvent({
                            event_action: avro/* EventAction.edit */.AO.edit,
                            interaction_name: field.name,
                            interaction_raw_text: field.label,
                            option_selected: field.type,
                            custom_tracking_fields: {
                                form_title: props.title
                            }
                        });
                    }
                    handleFieldChange(field.name, value);
                }
            })));
        }), block.richText && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
            html: block.richText,
            backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100
        }));
    }), props.error && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Alert/* Alert */.b, {
        type: "error"
    }, props.error), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Form_Styles.button
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        type: "submit",
        isFullWidth: true,
        disabled: props.isDisabled
    }, (_submitButtonText = props.submitButtonText) !== null && _submitButtonText !== void 0 ? _submitButtonText : "Submit"))));
}

// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var core_dist = __webpack_require__(79381);
;// CONCATENATED MODULE: ./src/components/HubSpotFormV2/HubSpotFormV2.tsx
/* provided dependency */ var process = __webpack_require__(34406);














function HubSpotFormV2(props) {
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var ref = useAsyncProps(props), blocks = ref.blocks, asyncDefaultValues = ref.defaultValues, submitButtonText = ref.submitButtonText;
    var ref1 = getDefaults({
        blocks: blocks,
        defaultValues: asyncDefaultValues,
        prefilledFields: props.prefilledFields
    }), defaultValues = ref1.defaultValues, cookieBindings = ref1.cookieBindings;
    var ref2 = (0,react.useState)(), formError = ref2[0], setFormError = ref2[1];
    var ref3 = (0,react.useState)(), fieldErrors = ref3[0], setFieldErrors = ref3[1];
    var ref4 = (0,react.useState)(), confirmationMessage = ref4[0], setConfirmationMessage = ref4[1];
    var ref5 = (0,react.useState)(false), isDisabled = ref5[0], setIsDisabled = ref5[1];
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsDisabled(true);
                        _ctx.next = 3;
                        return fetch("/api/pagebuilder/form/".concat(props.account, "/").concat(props.formId), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(values)
                        });
                    case 3:
                        response = _ctx.sent;
                        _ctx.next = 6;
                        return response.json().catch(function(error) {
                            return console.error(error);
                        });
                    case 6:
                        data = _ctx.sent;
                        setIsDisabled(false);
                        setFormError(data === null || data === void 0 ? void 0 : data.formError);
                        setFieldErrors(data === null || data === void 0 ? void 0 : data.fieldErrors);
                        if (!(!response.ok || !(data === null || data === void 0 ? void 0 : data.confirmation))) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        emitUserInteractionEvent({
                            event_action: avro/* EventAction.click */.AO.click,
                            interaction_name: avro/* InteractionName.submit */.AI.submit,
                            interaction_raw_text: submitButtonText || "Submit",
                            option_selected: "submit",
                            custom_tracking_fields: {
                                form_title: props.title
                            }
                        });
                        trackEvent(events/* EventName.HUBSPOT_FORM_SUBMITTED */.B_.HUBSPOT_FORM_SUBMITTED, {
                            title: props.title,
                            hubspot_form_id: props.formId,
                            path: window.location.pathname
                        });
                        if (data.confirmation.type === "redirect") {
                            setIsDisabled(true);
                            window.location.assign(data.confirmation.value);
                        } else {
                            setConfirmationMessage(data.confirmation.value);
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Form, (0,src_object_spread/* default */.Z)({
        cookieBindings: cookieBindings,
        title: props.title,
        blocks: blocks,
        defaultValues: defaultValues,
        error: formError,
        fieldErrors: fieldErrors,
        submitButtonText: submitButtonText,
        isDisabled: isDisabled,
        onSubmit: handleSubmit
    }, props.description && {
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            html: props.description,
            backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100
        })
    }, confirmationMessage && {
        confirmationMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            html: confirmationMessage,
            backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100
        })
    }));
}
function transformStringifiedValue(type, value) {
    if (type === "checkbox") {
        return value === "true" || value === "1";
    }
    if (type === "checkbox-group" && typeof value === "string") {
        return value.split(",").map(function(s) {
            return s.trim();
        });
    }
    return value;
}
function getFieldTypesMap(blocks) {
    var ref;
    return ((ref = blocks === null || blocks === void 0 ? void 0 : blocks.flatMap(function(block) {
        return block.fields;
    })) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
        if (curr === null || curr === void 0 ? void 0 : curr.name) return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr === null || curr === void 0 ? void 0 : curr.name, curr.type));
        return acc;
    }, {})) || {};
}
var getDefaults = function(props) {
    var fieldTypesMap = getFieldTypesMap(props.blocks || []);
    var prefilledFields = (props.prefilledFields || []).reduce(function(acc, field) {
        if (!field.name) {
            return acc;
        }
        var type = fieldTypesMap[field.name];
        var value = typeof field.value === "string" ? transformStringifiedValue(type, field.value) : field.value;
        return {
            defaultValues: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc.defaultValues), (0,_define_property/* default */.Z)({}, field.name, value)),
            cookieBindings: (0,src_object_spread/* default */.Z)({}, acc.cookieBindings, field.cookieToBind ? (0,_define_property/* default */.Z)({}, field.name, field.cookieToBind) : {})
        };
    }, {
        defaultValues: {},
        cookieBindings: {}
    });
    return {
        defaultValues: (0,src_object_spread/* default */.Z)({}, props.defaultValues, prefilledFields.defaultValues),
        cookieBindings: prefilledFields.cookieBindings
    };
};
function fetchAsyncProps(props) {
    return _fetchAsyncProps.apply(this, arguments);
}
function _fetchAsyncProps() {
    _fetchAsyncProps = _async_to_generator(regeneratorRuntime.mark(function _callee(props) {
        var hubspotAccessTokenMap, hubspotAccessToken, ref, defaultValues, blocks, submitButtonText;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    hubspotAccessTokenMap = {
                        zapier: process.env.HUBSPOT_ACCESS_TOKEN_ZAPIER,
                        sandbox: process.env.HUBSPOT_ACCESS_TOKEN_SANDBOX
                    };
                    hubspotAccessToken = hubspotAccessTokenMap[props.account];
                    if (hubspotAccessToken) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Invalid HubSpot account or missing access token");
                case 4:
                    _ctx.next = 6;
                    return fetchFormDefinition(props.formId, hubspotAccessToken, props.prefilledFields);
                case 6:
                    ref = _ctx.sent;
                    defaultValues = ref.defaultValues;
                    blocks = ref.blocks;
                    submitButtonText = ref.submitButtonText;
                    return _ctx.abrupt("return", {
                        defaultValues: defaultValues,
                        blocks: blocks,
                        submitButtonText: submitButtonText
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAsyncProps.apply(this, arguments);
}
var useAsyncProps = function(props) {
    var data = (0,core_dist/* default */.ZP)("hubspot-form/".concat(props.formId), (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing)) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 3;
                    return fetch("/api/pagebuilder/form/".concat(props.account, "/").concat(props.formId));
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.json());
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))).data;
    return data || {
        blocks: props.blocks,
        defaultValues: props.defaultValues,
        submitButtonText: props.submitButtonText
    };
};

;// CONCATENATED MODULE: ./src/components/HubSpotFormV2/HubSpotFormV2.builder.ts


/* harmony default export */ var HubSpotFormV2_builder = (createBuilderModule(HubSpotFormV2, {
    name: "HubSpotFormV2",
    image: "https://cdn.zappy.app/65aca327f8d8f58911a8564e9ab0500d.png",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "account",
            type: "string",
            enum: [
                "zapier",
                "sandbox"
            ],
            required: true,
            defaultValue: "zapier"
        },
        {
            name: "formId",
            friendlyName: "Form ID",
            type: "string",
            required: true
        },
        {
            name: "prefilledFields",
            helperText: "Use to have any fields prefilled when the form loads. This can also be used for hidden fields. https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options",
            type: "list",
            subFields: [
                {
                    friendlyName: "Field name / contact property",
                    helperText: 'The contact property in Hubspot, which is also the "name" property of the HTML input (https://cdn.zappy.app/203ef02c90c194e3c4c1ae36d7636a00.png)',
                    name: "name",
                    required: true,
                    type: "string"
                },
                {
                    friendlyName: "Field value",
                    helperText: 'The value that you would like to pre-populate in the field; if the field type is a checkbox, then input either "true" or "false"; if the field type is a checkbox group, then provide the prefilled values as a comma-separated list',
                    name: "value",
                    type: "string"
                },
                {
                    name: "cookieToBind",
                    type: "string",
                    helperText: 'The name of the cookie to bind the prefilled value to (used in place of the "Field value" input above)'
                },
                {
                    friendlyName: "Hide if prefilled",
                    helperText: "The option to hide a field that has been prefilled",
                    name: "isHiddenIfPrefilled",
                    type: "boolean"
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/HubSpotMeeting/HubSpotMeeting.tsx





function HubSpotMeeting(_param) {
    var dataSource = _param.dataSource, rest = _objectWithoutProperties(_param, [
        "dataSource"
    ]);
    var ref;
    if (!dataSource) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InViewTracking.InViewTracking, {
        sectionName: events/* SectionName.HubSpotMeeting */.jz.HubSpotMeeting,
        layerName: rest === null || rest === void 0 ? void 0 : (ref = rest.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "meetings-iframe-container",
                "data-src": dataSource
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/HubSpotMeeting/HubSpotMeeting.builder.ts


/* harmony default export */ var HubSpotMeeting_builder = (createBuilderModule(HubSpotMeeting, {
    name: "HubSpotMeeting",
    image: "https://cdn.zappy.app/19296724b95dd418fac6abdcfce5c084.png",
    inputs: [
        {
            type: "string",
            name: "dataSource",
            helperText: "The 'data-src' property from the embed code taken from HubSpot. Details: https://knowledge.hubspot.com/meetings-tool/embed-the-meeting-widget-on-a-page",
            defaultValue: "https://meetings.hubspot.com/beth-rea2/product-advocate-meetings?embed=true"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/Img/useIsHover.tsx

var useIsHover = function() {
    // NOTE: there are chances that Img use not only block context in the future
    // as Img theoretically could be the child of other container which might be stateful
    // like CarouselSection
    var blockContext = Block_useBlockContext();
    if (!blockContext) {
        return false;
    }
    return blockContext.isHover;
};
/* harmony default export */ var Img_useIsHover = (useIsHover);

;// CONCATENATED MODULE: ./src/components/Img/useIsActive.tsx

var useIsActive = function() {
    // NOTE: there are chances that Img use not only block context in the future
    // as Img theoretically could be the child of other container which might be stateful
    // like CarouselSection
    var blockContext = Block_useBlockContext();
    if (!blockContext) {
        return false;
    }
    return blockContext.isActive;
};
/* harmony default export */ var Img_useIsActive = (useIsActive);

;// CONCATENATED MODULE: ./src/components/Img/Img.tsx







function Img_Img(_param) {
    var /**
   * We are intentionally not passing borderRadius to ImgZDS so that we can use the default design-system value.
   * This is because we previously specified 10px borderRadius as a defaultValue in Img.builder.ts, meaning that we have Builder.io
   * content that has a borderRadius of 10px, even though with the rebrand that default value changed.
   */ borderRadius = _param.borderRadius, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? true : _isFullWidth, shadow = _param.shadow, restProps = _objectWithoutProperties(_param, [
        "borderRadius",
        "isFullWidth",
        "shadow"
    ]);
    var isHover = Img_useIsHover();
    var isActive = Img_useIsActive();
    var hoverShadow = isActive ? "elevation5" : "elevation10";
    return restProps.src ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        isFullWidth: isFullWidth,
        shadow: isHover ? hoverShadow : shadow
    })) : null;
}

;// CONCATENATED MODULE: ./src/components/Img/Img.builder.ts



/* harmony default export */ var Img_builder = (createBuilderModule(Img_Img, {
    name: "img",
    image: "https://cdn.zappy.app/b39b3768fca22ab65885f9c661c2eb0a.png",
    inputs: [
        {
            name: "src",
            type: "cloudinaryImage",
            required: true,
            defaultValue: "https://cdn.pixabay.com/photo/2015/04/10/17/23/wood-716610_1280.jpg"
        },
        {
            name: "alt",
            type: "string",
            defaultValue: "This is alt text"
        },
        {
            name: "ariaHidden",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "loading",
            type: "string",
            enum: [
                "eager",
                "lazy"
            ]
        },
        {
            name: "height",
            type: "number"
        },
        {
            name: "width",
            type: "number"
        },
        {
            name: "objectFit",
            type: "string",
            enum: [
                "contain",
                "cover",
                "fill",
                "none",
                "scale-down"
            ]
        },
        {
            name: "objectPosition",
            type: "string"
        },
        {
            name: "aspectRatio",
            type: "string"
        },
        {
            name: "shadow",
            type: "string",
            enum: Object.keys(Shadows/* Shadows */.f)
        },
        {
            name: "sizes",
            type: "string"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/InViewTracking/InViewTracking.builder.ts



/* harmony default export */ var InViewTracking_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(InViewTracking.InViewTracking), {
    name: "InViewTracking",
    image: "https://cdn.zappy.app/a26168b9b480805722e50990a838c47c.png",
    inputs: [
        {
            name: "sectionName",
            type: "string",
            required: true
        }, 
    ],
    childRequirements: {
        message: "Children of the In View Tracking component must be a built-in component from the Basics section",
        query: {
            "component.name": {
                $in: [
                    "Core:Button",
                    "Core:Text",
                    "Core:Image",
                    "Core:Columns",
                    "Core:Box",
                    "Core:Section", 
                ]
            }
        }
    }
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/SkeletonLoader/SkeletonBlock/SkeletonBlock.js



const streakAnimation = (0,emotion_react_browser_esm/* keyframes */.F4)({
    '0%': {
        transform: 'translateX(-100%)',
    },
    '100%': {
        transform: 'translateX(100%)',
    },
});
const SkeletonBlock_Styles = (0,labelStyles/* labelStyles */.B)('SkeletonBlock', {
    root: [
        {
            backgroundColor: Colors/* Colors.neutral200 */.w.neutral200,
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
                animation: `${streakAnimation} 1s ease-in-out infinite`,
                content: '""',
                background: `linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))`,
                position: 'absolute',
                top: '0',
                right: '0',
                bottom: '0',
                left: '0',
            },
        },
    ],
});
const SkeletonBlock = (props) => {
    const style = {
        borderRadius: props.borderRadius,
        width: props.width,
        paddingTop: props.aspectRatio
            ? `calc(${props.width} / ${props.aspectRatio})`
            : props.height,
    };
    return (0,isolateComponent/* isolateComponent */.U)("div", { css: SkeletonBlock_Styles.root, "data-testid": "SkeletonBlock", style: style });
};
SkeletonBlock.defaultProps = {
    borderRadius: 5,
    width: '100%',
};
//# sourceMappingURL=SkeletonBlock.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/SkeletonLoader/SkeletonText/SkeletonText.js


const SkeletonText_Styles = (0,labelStyles/* labelStyles */.B)('SkeletonText', {
    root: (props) => [
        {
            display: 'grid',
            gridTemplateColumns: '100%',
            gap: 5,
        },
        (0,withModifier/* withModifier */.Q)(props.textAlign, {
            justifyItems: {
                left: 'start',
                right: 'end',
                center: 'center',
                justify: 'left',
            }[props.textAlign],
        }),
    ],
});
const getLineHeight = (props) => ({
    heading: 30,
    body: 15,
}[props.size]);
const getLineWidth = (props, idx) => {
    if (idx === 0 && props.lines === 1) {
        return '100%';
    }
    if (idx === props.lines - 1) {
        return '70%';
    }
    if (props.textAlign === 'justify') {
        return '100%';
    }
    return idx % 2 ? '100%' : '93%';
};
const SkeletonText = (props) => {
    const blocks = Array.from({ length: props.lines }).map((_, idx) => {
        return ((0,isolateComponent/* isolateComponent */.U)(SkeletonBlock, { height: getLineHeight(props), key: idx, width: getLineWidth(props, idx) }));
    });
    const style = {
        width: props.width,
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: SkeletonText_Styles.root(props), "data-testid": "SkeletonText", style: style }, blocks));
};
SkeletonText.defaultProps = {
    size: 'body',
    textAlign: 'left',
    width: '100%',
};
//# sourceMappingURL=SkeletonText.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/utils/slugify.ts
function slugify(text) {
    return text.trim().toLowerCase().replace(/\s+/g, "-") // Replace spaces with dashes
    .replace(/[^\w-]+/g, "") // Remove non-word characters
    .replace(/--+/g, "-"); // Remove back-to-back dashes
}

;// CONCATENATED MODULE: ./src/components/JobBoard/data.ts



var fetchDepartments = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(controller) {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("https://boards-api.greenhouse.io/v1/boards/zapier/departments?render_as=tree", {
                        method: "GET",
                        signal: controller.signal
                    });
                case 2:
                    response = _ctx.sent;
                    _ctx.next = 5;
                    return response.json();
                case 5:
                    data = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Failed to fetch departments: " + "[".concat(data.status || "unknown", "] ").concat(data.error || ""));
                case 8:
                    return _ctx.abrupt("return", data.departments || []);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchDepartments(controller) {
        return _ref.apply(this, arguments);
    };
}();
var useDepartments = function() {
    var ref = (0,react.useState)([]), departments = ref[0], setDepartments = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var doFetch = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(controller) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetchDepartments(controller);
                    case 3:
                        data = _ctx.sent;
                        setDepartments(data);
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        setHasError(true);
                    case 11:
                        _ctx.prev = 11;
                        setIsLoading(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    11,
                    14
                ]
            ]);
        }));
        return function doFetch(controller) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var controller = new AbortController();
        doFetch(controller);
        return function() {
            controller.abort();
        };
    }, []);
    return {
        departments: departments,
        hasError: hasError,
        isLoading: isLoading
    };
};

;// CONCATENATED MODULE: ./src/components/JobBoard/JobBoard.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 










var JobBoard_obj, JobBoard_obj1, JobBoard_obj2;
var JobBoard_Styles = (0,labelStyles/* labelStyles */.B)("JobBoard", {
    root: (0,emotion_react_browser_esm/* css */.iv)((JobBoard_obj = {
        maxWidth: "1170px",
        margin: "0 auto",
        padding: "20px"
    }, (0,_define_property/* default */.Z)(JobBoard_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        padding: "40px 20px"
    }), (0,_define_property/* default */.Z)(JobBoard_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "60px 20px"
    }), JobBoard_obj)),
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), (JobBoard_obj1 = {
        color: Colors/* Colors.neutral800 */.w.neutral800
    }, (0,_define_property/* default */.Z)(JobBoard_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7)), (0,_define_property/* default */.Z)(JobBoard_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), JobBoard_obj1))),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.neutral800 */.w.neutral800,
        maxWidth: "600px",
        marginTop: "12px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1 */.ZT.paragraph1), {
        marginTop: "20px"
    })))),
    departmentList: (0,emotion_react_browser_esm/* css */.iv)({
        margin: 0,
        listStyleType: "none"
    }),
    department: function() {
        var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return (0,emotion_react_browser_esm/* css */.iv)(level === 0 ? (0,_define_property/* default */.Z)({
            marginTop: "32px"
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            marginTop: "48px"
        }) : {
            paddingTop: "16px",
            paddingLeft: "".concat(level * 24, "px"),
            borderTop: "1px solid ".concat(Colors/* Colors.neutral300 */.w.neutral300)
        });
    },
    departmentHeading: function() {
        var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({
            color: Colors/* Colors.neutral800 */.w.neutral800
        }, level === 0 ? (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Bold */.ZT.paragraph1Bold), (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.sectionHeader3Bold */.ZT.sectionHeader3Bold))) : (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold), (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Bold */.ZT.paragraph1Bold), {
            fontSize: "20px"
        })))));
    },
    jobList: function() {
        var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            margin: "12px 0 0 0",
            listStyleType: "none"
        }, level === 0 && {
            borderBottom: "1px solid ".concat(Colors/* Colors.neutral300 */.w.neutral300)
        }), (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            marginTop: "16px"
        })));
    },
    job: (0,emotion_react_browser_esm/* css */.iv)({
        padding: "16px 0",
        borderTop: "1px solid ".concat(Colors/* Colors.neutral300 */.w.neutral300)
    }),
    jobLink: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3), (JobBoard_obj2 = {
        color: Colors/* Colors.blue */.w.blue,
        textDecoration: "underline"
    }, (0,_define_property/* default */.Z)(JobBoard_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1 */.ZT.paragraph1)), (0,_define_property/* default */.Z)(JobBoard_obj2, "&:hover", {
        color: Colors/* Colors.night */.w.night
    }), (0,_define_property/* default */.Z)(JobBoard_obj2, "&:focus", {
        outline: "1px solid ".concat(Colors/* Colors.blue */.w.blue),
        outlineOffset: "2px"
    }), JobBoard_obj2)))
});
function Department(props) {
    if (props.jobs.length === 0 && props.subDepartments.every(function(subDepartment) {
        return subDepartment.jobs.length === 0;
    })) {
        return null;
    }
    var Heading = "h".concat(Math.min(props.level + 3, 6));
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
        css: JobBoard_Styles.department(props.level)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Heading, {
        css: JobBoard_Styles.departmentHeading(props.level)
    }, props.name), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
        css: JobBoard_Styles.jobList(props.level)
    }, props.jobs.map(function(job) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
            css: JobBoard_Styles.job,
            key: job.id
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
            css: JobBoard_Styles.jobLink,
            href: "/jobs/".concat(job.id, "/").concat(slugify(job.title))
        }, job.title));
    }), props.subDepartments && props.subDepartments.length > 0 && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
        css: JobBoard_Styles.departmentList
    }, props.subDepartments.map(function(subDepartment) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Department, {
            key: subDepartment.id,
            level: props.level + 1,
            name: subDepartment.name,
            jobs: subDepartment.jobs,
            subDepartments: subDepartment.children
        });
    })))));
}
function JobListings() {
    var ref = useDepartments(), departments = ref.departments, isLoading = ref.isLoading, hasError = ref.hasError;
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, Array.from({
        length: 13
    }).map(function(_, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            key: index,
            css: JobBoard_Styles.department()
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SkeletonText, {
            size: "heading",
            lines: 1
        }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SkeletonText, {
            size: "body",
            lines: 3
        }));
    }));
    if (hasError) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: JobBoard_Styles.department()
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: JobBoard_Styles.departmentHeading()
    }, "Something went wrong. Please try again later."));
    if (departments.length === 0) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: JobBoard_Styles.department()
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: JobBoard_Styles.departmentHeading()
    }, "We don't currently have any open positions."), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
        css: JobBoard_Styles.description
    }, "However, we are always on the lookout for talented, passionate people who want to work with us, so", " ", /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        href: "mailto:jobs@zapier.com",
        title: "Email jobs@zapier.com"
    }, "get in touch"), " ", "with what your dream role would be at Zapier."));
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
        css: JobBoard_Styles.departmentList
    }, departments.map(function(department) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Department, {
            key: department.id,
            level: 0,
            name: department.name,
            jobs: department.jobs,
            subDepartments: department.children
        });
    }));
}
function JobBoard(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: JobBoard_Styles.root
    }, props.title && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: JobBoard_Styles.title
    }, props.title), props.description && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: JobBoard_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        html: props.description
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(JobListings, null));
}

;// CONCATENATED MODULE: ./src/components/JobBoard/JobBoard.builder.ts




/* harmony default export */ var JobBoard_builder = (createBuilderModule(withTracking(JobBoard, {
    as: "section",
    sectionName: events/* SectionName.JobBoard */.jz.JobBoard
}), {
    name: "JobBoard",
    image: "https://cdn.zappy.app/02334b8ec9c195061646f95f621e0d9c.png",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/LogoBar/LogoBar.tsx



function LogoBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  padding: 55px 25px 20px 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 1280px;\n"
    ]);
    LogoBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LogoBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    LogoBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LogoBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n\n  ",
        " {\n    margin-bottom: 35px;\n\n    &:not(:last-child) {\n      margin-right: 50px;\n    }\n  }\n\n  ",
        " {\n    &:not(:last-child) {\n      margin-right: 80px;\n    }\n  }\n"
    ]);
    LogoBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function LogoBar(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoBar_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* Text */.x, {
                color: "gray",
                margin: "0 0 35px 0",
                tag: "p",
                type: "paragraph3",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosContainer, {
                children: items.map(function(_param, i) /*#__PURE__*/ {
                    var logoUrl = _param.logoUrl, companyName = _param.companyName, restProps = _objectWithoutProperties(_param, [
                        "logoUrl",
                        "companyName"
                    ]);
                    return (0,jsx_runtime.jsx)(LogoContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, (0,src_object_spread/* default */.Z)({
                            alt: companyName,
                            borderRadius: 0,
                            src: logoUrl
                        }, restProps))
                    }, i + logoUrl);
                })
            })
        ]
    });
}
var LogoBar_Container = emotion_styled_browser_esm/* default.div */.Z.div(LogoBar_templateObject());
var LogosContainer = emotion_styled_browser_esm/* default.div */.Z.div(LogoBar_templateObject1(), responsive/* mediaQueries.tablet */.w5.tablet);
var LogoContainer = emotion_styled_browser_esm/* default.div */.Z.div(LogoBar_templateObject2(), responsive/* mediaQueries.tablet */.w5.tablet, responsive/* mediaQueries.desktop */.w5.desktop);

;// CONCATENATED MODULE: ./src/components/sections/LogoBar/LogoBar.builder.tsx




/* harmony default export */ var LogoBar_builder = (createBuilderModule(withTracking(LogoBar, {
    sectionName: events/* SectionName.LogoBar */.jz.LogoBar
}), {
    name: "LogoBar",
    image: "https://cdn.zapier.com/storage/photos/f9503143fb1b1eaf4dcd839a06ffc9aa.png",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Trusted at companies large and small",
            required: true
        },
        {
            name: "items",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "logoUrl",
                    type: "cloudinaryImage",
                    defaultValue: "https://cdn.zappy.app/dd2c451262bf37375ce17fedcbaa2d17.svg"
                },
                {
                    name: "companyName",
                    type: "string",
                    helperText: "Used for alt text for the company logo",
                    required: true
                },
                {
                    name: "height",
                    type: "number"
                },
                {
                    name: "width",
                    type: "number"
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Margin/Margin.js

const Margin_Styles = (0,labelStyles/* labelStyles */.B)('Margin', {
    root: (props) => ({
        margin: props.margin,
    }),
});
const Margin = (props) => ((0,isolateComponent/* isolateComponent */.U)("div", { css: Margin_Styles.root(props) }, props.children));
//# sourceMappingURL=Margin.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/Margin/Margin.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 

function Margin_Margin(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Margin, {
        margin: "\n      ".concat(props.marginTop || 0, "px \n      ").concat(props.marginRight || 0, "px \n      ").concat(props.marginBottom || 0, "px \n      ").concat(props.marginLeft || 0, "px\n      ")
    }, props.children);
}

;// CONCATENATED MODULE: ./src/components/Margin/Margin.builder.ts



/* harmony default export */ var Margin_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(Margin_Margin), {
    name: "Margin",
    image: "https://cdn.icon-icons.com/icons2/1369/PNG/512/-space-bar_90666.png",
    inputs: [
        {
            name: "marginTop",
            type: "number"
        },
        {
            name: "marginRight",
            type: "number"
        },
        {
            name: "marginBottom",
            type: "number"
        },
        {
            name: "marginLeft",
            type: "number"
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/OneColumnBlock/OneColumnBlock.js






const OneColumnBlock_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const mapV4ToV5Color = (color) => {
    const colorMap = {
        [Colors/* Colors.lava10 */.w.lava10]: Colors/* Colors.cream */.w.cream,
        [Colors/* Colors.ocean10 */.w.ocean10]: Colors/* Colors.acidWash */.w.acidWash,
        [Colors/* Colors.sun10 */.w.sun10]: Colors/* Colors.neutral200 */.w.neutral200,
        [Colors/* Colors.white */.w.white]: Colors/* Colors.neutral100 */.w.neutral100,
    };
    return colorMap[color] || color;
};
const OneColumnBlock_Styles = (0,labelStyles/* labelStyles */.B)('OneColumnBlock', {
    root: (backgroundColor = 'neutral100') => [
        emotion_react_browser_esm/* css */.iv `
      background-color: ${mapV4ToV5Color(Colors/* Colors */.w[backgroundColor])};
      padding: 20px;
      @media screen and (min-width: ${OneColumnBlock_breakpoints.tablet}px) {
        padding: 40px 30px;
      }
      @media screen and (min-width: ${OneColumnBlock_breakpoints.desktop}px) {
        padding: 50px 30px;
      }
    `,
    ],
    content: [
        emotion_react_browser_esm/* css */.iv `
      margin: 0 auto;
      text-align: center;
      max-width: 1170px;
    `,
    ],
    text: (textAlign) => emotion_react_browser_esm/* css */.iv `
      text-align: ${textAlign};
      max-width: 720px;
      margin-left: ${textAlign === 'center' || textAlign === 'right'
        ? 'auto'
        : 0};
      margin-right: ${textAlign === 'center' ? 'auto' : 0};
    `,
    headingContainer: [
        emotion_react_browser_esm/* css */.iv `
      ${Typography/* Typography.pageHeader5 */.ZT.pageHeader5}

      @media screen and (min-width: ${OneColumnBlock_breakpoints.desktop}px) {
        ${Typography/* Typography.pageHeader5 */.ZT.pageHeader5}
      }
    `,
    ],
    description: [
        emotion_react_browser_esm/* css */.iv `
      margin-top: 20px;
      ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1}
      color: ${Colors/* Colors.neutral700 */.w.neutral700};

      @media screen and (min-width: ${OneColumnBlock_breakpoints.tablet}px) {
        ${Typography/* Typography.paragraph1Short */.ZT.paragraph1Short}
      }
    `,
    ],
});
const OneColumnBlock = ({ backgroundColor, altText = '', headingTag = 'h3', heading, description, imageUrl, textAlign = 'center', }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: OneColumnBlock_Styles.root(backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: OneColumnBlock_Styles.content }, imageUrl ? ((0,isolateComponent/* isolateComponent */.U)(Img/* Img */.E, { borderRadius: 0, src: imageUrl, alt: altText })) : ((0,isolateComponent/* isolateComponent */.U)("div", { "data-testid": "Text", css: OneColumnBlock_Styles.text(textAlign) },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: OneColumnBlock_Styles.headingContainer },
                (0,isolateComponent/* isolateComponent */.U)(Text_Text/* Text */.x, { type: "heading", color: "neutral800", tag: headingTag }, heading)),
            description && (0,isolateComponent/* isolateComponent */.U)("div", { css: OneColumnBlock_Styles.description }, description))))));
};
//# sourceMappingURL=OneColumnBlock.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/OneColumnBlock/OneColumnBlock.tsx





function OneColumnBlock_OneColumnBlock(_param) {
    var background = _param.background, description = _param.description, restProps = _objectWithoutProperties(_param, [
        "background",
        "description"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OneColumnBlock, (0,src_object_spread/* default */.Z)({
        backgroundColor: background,
        description: description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: background,
            html: description
        })
    }, restProps));
}

;// CONCATENATED MODULE: ./src/components/sections/OneColumnBlock/OneColumnBlock.builder.tsx






/* harmony default export */ var OneColumnBlock_builder = (createBuilderModule(withTracking(OneColumnBlock_OneColumnBlock, {
    sectionName: events/* SectionName.OneColumnBlock */.jz.OneColumnBlock
}), {
    name: "OneColumnBlock",
    image: "https://cdn.zapier.com/storage/photos/90baf19765445a2c227021419c5dc925.png",
    inputs: [
        {
            name: "background",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.lava10 */.US.lava10,
                colors/* COLOR_KEYS.ocean10 */.US.ocean10,
                colors/* COLOR_KEYS.sun10 */.US.sun10,
                colors/* COLOR_KEYS.white */.US.white,
                // V5 Colors
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            defaultValue: "neutral100"
        },
        {
            name: "textAlign",
            type: "string",
            enum: [
                "left",
                "right",
                "center",
                "inherit"
            ],
            defaultValue: "center"
        },
        {
            name: "heading",
            type: "string",
            defaultValue: "This is a default heading (Edit me)"
        },
        {
            name: "headingTag",
            helperText: "HTML heading level for heading.",
            type: "string",
            enum: Object.keys(BlockHeadingTag),
            defaultValue: BlockHeadingTag.h3
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "imageUrl",
            type: "cloudinaryImage"
        },
        {
            name: "altText",
            type: "string"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/PlanComparison/Plan.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 









var flexStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
};
var Plan_obj, Plan_obj1, Plan_obj2, Plan_obj3;
var Plan_Styles = (0,labelStyles/* labelStyles */.B)("Plan", {
    root: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flexStyle), (Plan_obj = {
        height: "366px",
        padding: "40px 24px 29px 24px",
        color: Colors/* Colors.neutral800 */.w.neutral800,
        backgroundColor: Colors/* Colors.cream */.w.cream
    }, (0,_define_property/* default */.Z)(Plan_obj, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        padding: "24px",
        height: "215px"
    }), (0,_define_property/* default */.Z)(Plan_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
        height: "243px"
    }), Plan_obj))),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flexStyle), (Plan_obj1 = {
        height: "90px"
    }, (0,_define_property/* default */.Z)(Plan_obj1, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        alignItems: "center"
    }), (0,_define_property/* default */.Z)(Plan_obj1, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
        height: "80px"
    }), Plan_obj1))),
    body: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flexStyle), (Plan_obj2 = {
        minHeight: "190px"
    }, (0,_define_property/* default */.Z)(Plan_obj2, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        alignItems: "center",
        minHeight: "105px"
    }), (0,_define_property/* default */.Z)(Plan_obj2, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
        minHeight: "122px"
    }), Plan_obj2))),
    planTitle: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (Plan_obj3 = {}, (0,_define_property/* default */.Z)(Plan_obj3, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9)), (0,_define_property/* default */.Z)(Plan_obj3, "".concat(responsive/* MEDIA_MIN_WIDTH.large */.l0.large, " and ").concat(responsive/* MAX_WIDTH.extraLarge */.d.extraLarge), {
        fontSize: "29px"
    }), Plan_obj3))),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1 */.ZT.paragraph1), (0,_define_property/* default */.Z)({
        lineHeight: "28px",
        maxWidth: "436px",
        marginRight: "48px",
        marginLeft: "6px"
    }, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        margin: "0"
    }, Typography/* Typography.paragraph3 */.ZT.paragraph3), {
        lineHeight: "22px",
        textAlign: "center"
    })))),
    button: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        width: "100%"
    }, "".concat(responsive/* MEDIA_MIN_WIDTH.small */.l0.small, " and ").concat(responsive/* MAX_WIDTH.large */.d.large), {
        width: "250px"
    })),
    buttonContent: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        alignItems: "center"
    }),
    buttonIcon: (0,emotion_react_browser_esm/* css */.iv)({
        marginTop: "6px",
        marginLeft: "4px",
        span: (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
            height: "20px !important",
            width: "20px !important"
        }),
        svg: (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
            height: "20px !important",
            width: "20px !important"
        })
    })
});
function Plan(param) {
    var iconName = param.iconName, title = param.title, description = param.description, href = param.href, buttonText = param.buttonText;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var handleClick = function() {
        emitCTAClickEvent({
            href: href,
            section: events/* SectionName.PlanComparisonSection */.jz.PlanComparisonSection,
            text: buttonText
        });
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.heading
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: iconName,
        size: 40
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: Plan_Styles.planTitle
    }, title)), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.body
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
        css: Plan_Styles.description
    }, description), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.button
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        color: "primary",
        href: href,
        isFullWidth: true,
        onClick: handleClick
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.buttonContent
    }, buttonText, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Plan_Styles.buttonIcon
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: ICON_NAMES.arrowBigRight,
        size: 24
    })))))));
}

;// CONCATENATED MODULE: ./src/components/sections/PlanComparison/PlanComparisonSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var PlanComparisonSection_obj;
var PlanComparisonSection_Styles = (0,labelStyles/* labelStyles */.B)("PlanComparisonSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            backgroundColor: Colors/* Colors */.w[backgroundColor],
            padding: "87px 22px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
            padding: "60px 50px 48px 50px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
            padding: "73px 20px 83px 20px"
        }), _obj));
    },
    content: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: "1170px",
        margin: "auto"
    }),
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.cream */.w.cream,
        textAlign: "center",
        height: "100%"
    }, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7)))),
    plans: (0,emotion_react_browser_esm/* css */.iv)((PlanComparisonSection_obj = {
        display: "grid",
        marginTop: "83px",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridGap: "30px"
    }, (0,_define_property/* default */.Z)(PlanComparisonSection_obj, responsive/* MEDIA_MAX_WIDTH.large */.Eb.large, {
        gridTemplateColumns: "repeat(1, 1fr)",
        marginTop: "57px"
    }), (0,_define_property/* default */.Z)(PlanComparisonSection_obj, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
        gridGap: "20px",
        marginTop: "36px"
    }), PlanComparisonSection_obj))
});
function PlanComparisonSection(param) {
    var _plans = param.plans, plans = _plans === void 0 ? [] : _plans, title = param.title, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? colors/* COLOR_KEYS.zapier */.US.zapier : _backgroundColor;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PlanComparisonSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PlanComparisonSection_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: PlanComparisonSection_Styles.title
    }, title), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PlanComparisonSection_Styles.plans
    }, plans.map(function(plan, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Plan, Object.assign({
            key: "".concat(plan.title, "-").concat(index)
        }, plan));
    }))));
}

;// CONCATENATED MODULE: ./src/components/sections/PlanComparison/fixtures.ts


var PLANS = [
    {
        buttonText: "Try it free",
        description: "Copy about the plan. Likely no longer the two lines to get in details.",
        href: "#",
        iconName: ICON_NAMES.ratingVeryHappy,
        title: "Zapier Free",
        ctaName: events/* CtaName.signup */.XE.signup,
        ctaGoal: events/* CtaGoal.signup */.LK.signup
    },
    {
        buttonText: "Start 14 day free trial",
        description: "Copy about the plan. Likely no longer the two lines to get in details.",
        href: "#",
        iconName: ICON_NAMES.navBriefcase,
        title: "Zapier Pro",
        ctaName: events/* CtaName.signup */.XE.signup,
        ctaGoal: events/* CtaGoal.signup */.LK.signup
    },
    {
        buttonText: "Get a Demo",
        description: "Copy about the plan. Likely no longer the two lines to get in details.",
        href: "#",
        iconName: ICON_NAMES.navExplore,
        title: "Teams/Companies",
        ctaName: events/* CtaName.learnMore */.XE.learnMore,
        ctaGoal: events/* CtaGoal.getMoreInformation */.LK.getMoreInformation
    }, 
];

;// CONCATENATED MODULE: ./src/components/sections/PlanComparison/PlanComparisonSection.builder.ts






/* harmony default export */ var PlanComparisonSection_builder = (createBuilderModule(withTracking(PlanComparisonSection, {
    as: "section",
    sectionName: events/* SectionName.PlanComparisonSection */.jz.PlanComparisonSection
}), {
    name: "PlanComparison",
    image: "https://cdn.zappy.app/55d81bcc520563f6d24ab42ecfe75d87.png",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true,
            defaultValue: "A plan to fit your needs"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier, 
            ],
            required: true,
            defaultValue: colors/* COLOR_KEYS.zapier */.US.zapier
        },
        {
            name: "plans",
            type: "list",
            defaultValue: PLANS,
            subFields: [
                {
                    name: "title",
                    required: true,
                    type: "string"
                },
                {
                    name: "description",
                    required: true,
                    type: "string"
                },
                {
                    name: "href",
                    required: true,
                    type: "string",
                    helperText: "URL for CTA button"
                },
                {
                    name: "buttonText",
                    required: true,
                    type: "string"
                },
                {
                    name: "iconName",
                    type: "string",
                    enum: Object.values(ICON_NAMES),
                    required: true
                }, 
            ]
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(40794);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(73356);
;// CONCATENATED MODULE: ./src/graphql/queries/popularTemplates/popularTemplatesQuery.ts

function popularTemplatesQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PopularTemplates(\n    $roleCanonicalId: String\n    $personalizeBy: SuggestionPersonalization!\n    $limit: Int\n  ) {\n    suggestedZapTemplates(\n      roleCanonicalId: $roleCanonicalId\n      personalizeBy: $personalizeBy\n      limit: $limit\n    ) {\n      edges {\n        zapTemplate {\n          title\n          url\n          services {\n            image\n            name\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    popularTemplatesQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var popularTemplatesQuery = (0,lib/* default */.ZP)(popularTemplatesQuery_templateObject());

;// CONCATENATED MODULE: ./src/graphql/types.ts
var AccessPolicyLevel;
(function(AccessPolicyLevel) {
    AccessPolicyLevel["AutoJoin"] = "auto_join";
    AccessPolicyLevel["InviteOnly"] = "invite_only";
    AccessPolicyLevel["RequestAccess"] = "request_access";
})(AccessPolicyLevel || (AccessPolicyLevel = {}));
var ShareMemberType;
(function(ShareMemberType) {
    ShareMemberType["Member"] = "member";
    ShareMemberType["Team"] = "team";
})(ShareMemberType || (ShareMemberType = {}));
var PaymentSourceType;
(function(PaymentSourceType) {
    PaymentSourceType["Bank"] = "bank";
    PaymentSourceType["Card"] = "card";
    PaymentSourceType["Manual"] = "manual";
    PaymentSourceType["Paypal"] = "paypal";
})(PaymentSourceType || (PaymentSourceType = {}));
var PaymentSourceBackend;
(function(PaymentSourceBackend) {
    PaymentSourceBackend["Braintree"] = "braintree";
    PaymentSourceBackend["Stripe"] = "stripe";
})(PaymentSourceBackend || (PaymentSourceBackend = {}));
var MemberRole;
(function(MemberRole) {
    MemberRole["Admin"] = "admin";
    MemberRole["Member"] = "member";
    MemberRole["Owner"] = "owner";
})(MemberRole || (MemberRole = {}));
var BillingInterval;
(function(BillingInterval) {
    BillingInterval["Month"] = "month";
    BillingInterval["Year"] = "year";
})(BillingInterval || (BillingInterval = {}));
var MemberStatus;
(function(MemberStatus) {
    MemberStatus["Invitation"] = "invitation";
    MemberStatus["Member"] = "member";
    MemberStatus["Request"] = "request";
})(MemberStatus || (MemberStatus = {}));
var TaskHeldReason;
(function(TaskHeldReason) {
    TaskHeldReason["AccessBlacklistedApp"] = "access_blacklisted_app";
    TaskHeldReason["BlacklistedApp"] = "blacklisted_app";
    TaskHeldReason["DedupeChange"] = "dedupe_change";
    TaskHeldReason["PaymentIssue"] = "paymentIssue";
    TaskHeldReason["PlanLimit"] = "plan_limit";
    TaskHeldReason["StaleAuth"] = "stale_auth";
    TaskHeldReason["StepLimit"] = "step_limit";
    TaskHeldReason["TaskLimit"] = "task_limit";
    TaskHeldReason["Throttled"] = "throttled";
    TaskHeldReason["TooMany"] = "too_many";
    TaskHeldReason["Unknown"] = "unknown";
})(TaskHeldReason || (TaskHeldReason = {}));
var BankAccountType;
(function(BankAccountType) {
    BankAccountType["Checking"] = "checking";
    BankAccountType["Savings"] = "savings";
})(BankAccountType || (BankAccountType = {}));
var BankOwnershipType;
(function(BankOwnershipType) {
    BankOwnershipType["Business"] = "business";
    BankOwnershipType["Personal"] = "personal";
})(BankOwnershipType || (BankOwnershipType = {}));
var LineItemReason;
(function(LineItemReason) {
    LineItemReason["AnnualMetered"] = "annual_metered";
    LineItemReason["PeriodEnded"] = "period_ended";
    LineItemReason["UpgradeOrDowngrade"] = "upgrade_or_downgrade";
})(LineItemReason || (LineItemReason = {}));
var InvoiceStatus;
(function(InvoiceStatus) {
    InvoiceStatus["Error"] = "error";
    InvoiceStatus["Forgiven"] = "forgiven";
    InvoiceStatus["Overdue"] = "overdue";
    InvoiceStatus["Paid"] = "paid";
    InvoiceStatus["Pending"] = "pending";
    InvoiceStatus["Refunded"] = "refunded";
    InvoiceStatus["Scheduled"] = "scheduled";
})(InvoiceStatus || (InvoiceStatus = {}));
var ZapNodeType;
(function(ZapNodeType) {
    ZapNodeType["Filter"] = "filter";
    ZapNodeType["Read"] = "read";
    ZapNodeType["Search"] = "search";
    ZapNodeType["SearchOrWrite"] = "search_or_write";
    ZapNodeType["Write"] = "write";
})(ZapNodeType || (ZapNodeType = {}));
var TaskStatus;
(function(TaskStatus) {
    TaskStatus["Delayed"] = "delayed";
    TaskStatus["Delete"] = "delete";
    TaskStatus["Deleted"] = "deleted";
    TaskStatus["Error"] = "error";
    TaskStatus["Filtered"] = "filtered";
    TaskStatus["Halted"] = "halted";
    TaskStatus["Held"] = "held";
    TaskStatus["Pending"] = "pending";
    TaskStatus["Replay"] = "replay";
    TaskStatus["Scheduled"] = "scheduled";
    TaskStatus["Skipped"] = "skipped";
    TaskStatus["Success"] = "success";
    TaskStatus["Throttled"] = "throttled";
    TaskStatus["Unknown"] = "unknown";
})(TaskStatus || (TaskStatus = {}));
var TaskNodeType;
(function(TaskNodeType) {
    TaskNodeType["Node"] = "node";
    TaskNodeType["Path"] = "path";
    TaskNodeType["PathGroup"] = "pathGroup";
})(TaskNodeType || (TaskNodeType = {}));
var ZapEditMode;
(function(ZapEditMode) {
    ZapEditMode["Guided"] = "guided";
    ZapEditMode["Normal"] = "normal";
    ZapEditMode["Simple"] = "simple";
    ZapEditMode["Unknown"] = "unknown";
})(ZapEditMode || (ZapEditMode = {}));
var ZapShareVisibility;
(function(ZapShareVisibility) {
    ZapShareVisibility["Disabled"] = "disabled";
    ZapShareVisibility["Global"] = "global";
    ZapShareVisibility["Private"] = "private";
    ZapShareVisibility["Public"] = "public";
    ZapShareVisibility["Team"] = "team";
})(ZapShareVisibility || (ZapShareVisibility = {}));
var ZapState;
(function(ZapState) {
    ZapState["Draft"] = "draft";
    ZapState["Off"] = "off";
    ZapState["On"] = "on";
})(ZapState || (ZapState = {}));
var TaskAggregationInterval;
(function(TaskAggregationInterval) {
    TaskAggregationInterval["Daily"] = "daily";
    TaskAggregationInterval["Monthly"] = "monthly";
    TaskAggregationInterval["Yearly"] = "yearly";
})(TaskAggregationInterval || (TaskAggregationInterval = {}));
var TeamMembershipStatus;
(function(TeamMembershipStatus) {
    TeamMembershipStatus["Member"] = "member";
    TeamMembershipStatus["None"] = "none";
    TeamMembershipStatus["Owner"] = "owner";
    TeamMembershipStatus["RequestedAccess"] = "requestedAccess";
})(TeamMembershipStatus || (TeamMembershipStatus = {}));
var AppSortOrder;
(function(AppSortOrder) {
    AppSortOrder["Actionadded"] = "ACTIONADDED";
    AppSortOrder["Alphabetical"] = "ALPHABETICAL";
    AppSortOrder["Created"] = "CREATED";
    AppSortOrder["Popularity"] = "POPULARITY";
    AppSortOrder["Recent"] = "RECENT";
})(AppSortOrder || (AppSortOrder = {}));
var BlogPostStatus;
(function(BlogPostStatus) {
    BlogPostStatus[/** Draft blog posts are visible to everyone, but not indexed by Google */ "Draft"] = "draft";
    BlogPostStatus[/** Internal blog posts are only visible to the company */ "Internal"] = "internal";
    BlogPostStatus[/** Published blog posts are visible to everyone, and indexed by Google */ "Published"] = "published";
})(BlogPostStatus || (BlogPostStatus = {}));
var AppCategoryRole;
(function(AppCategoryRole) {
    AppCategoryRole[/** All categories, either parent or child. */ "All"] = "all";
    AppCategoryRole[/** A child category has a parent. */ "Child"] = "child";
    AppCategoryRole[/** A parent category has no children. */ "Parent"] = "parent";
})(AppCategoryRole || (AppCategoryRole = {}));
var CategoryType;
(function(CategoryType) {
    CategoryType["Auto"] = "auto";
    CategoryType["Curated"] = "curated";
    CategoryType["Other"] = "other";
})(CategoryType || (CategoryType = {}));
var MediaTypes;
(function(MediaTypes) {
    MediaTypes["Image"] = "IMAGE";
    MediaTypes["Video"] = "VIDEO";
})(MediaTypes || (MediaTypes = {}));
var PartnerTier;
(function(PartnerTier) {
    PartnerTier["Beta"] = "BETA";
    PartnerTier["Bronze"] = "BRONZE";
    PartnerTier["Gold"] = "GOLD";
    PartnerTier["Platinum"] = "PLATINUM";
    PartnerTier["Silver"] = "SILVER";
})(PartnerTier || (PartnerTier = {}));
var AlertTriggersAction;
(function(AlertTriggersAction) {
    AlertTriggersAction["Always"] = "always";
    AlertTriggersAction["Never"] = "never";
    AlertTriggersAction["OnlyTrigger"] = "only_trigger";
    AlertTriggersAction["Repeated"] = "repeated";
})(AlertTriggersAction || (AlertTriggersAction = {}));
var SummarySchedule;
(function(SummarySchedule) {
    SummarySchedule["Daily"] = "daily";
    SummarySchedule["Never"] = "never";
    SummarySchedule["Weekly"] = "weekly";
})(SummarySchedule || (SummarySchedule = {}));
var HttpMethod;
(function(HttpMethod) {
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Get"] = "GET";
    HttpMethod["Invalid"] = "INVALID";
    HttpMethod["Patch"] = "PATCH";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
var DomainRequestStatus;
(function(DomainRequestStatus) {
    DomainRequestStatus["E"] = "E";
    DomainRequestStatus["P"] = "P";
    DomainRequestStatus["V"] = "V";
})(DomainRequestStatus || (DomainRequestStatus = {}));
var DivergenceState;
(function(DivergenceState) {
    DivergenceState["Diverged"] = "diverged";
    DivergenceState["Synced"] = "synced";
})(DivergenceState || (DivergenceState = {}));
var SharingState;
(function(SharingState) {
    SharingState["Disabled"] = "disabled";
    SharingState["Global"] = "global";
    SharingState["Private"] = "private";
    SharingState["Public"] = "public";
})(SharingState || (SharingState = {}));
var HelpDocs_ContentType;
(function(HelpDocs_ContentType) {
    HelpDocs_ContentType["Faq"] = "faq";
    HelpDocs_ContentType["Generic"] = "generic";
    HelpDocs_ContentType["Reference"] = "reference";
    HelpDocs_ContentType["Troubleshooting"] = "troubleshooting";
    HelpDocs_ContentType["Tutorial"] = "tutorial";
})(HelpDocs_ContentType || (HelpDocs_ContentType = {}));
var HelpDocs_ActionType;
(function(HelpDocs_ActionType) {
    HelpDocs_ActionType["Action"] = "action";
    HelpDocs_ActionType["Search"] = "search";
    HelpDocs_ActionType["Trigger"] = "trigger";
})(HelpDocs_ActionType || (HelpDocs_ActionType = {}));
var HelpDocs_Namespace;
(function(HelpDocs_Namespace) {
    HelpDocs_Namespace["App"] = "app";
    HelpDocs_Namespace["Help"] = "help";
})(HelpDocs_Namespace || (HelpDocs_Namespace = {}));
var IntegrationReviewFeedbackItemType;
(function(IntegrationReviewFeedbackItemType) {
    IntegrationReviewFeedbackItemType["Bug"] = "BUG";
    IntegrationReviewFeedbackItemType["FeatureRequest"] = "FEATURE_REQUEST";
})(IntegrationReviewFeedbackItemType || (IntegrationReviewFeedbackItemType = {}));
var AuthenticationType;
(function(AuthenticationType) {
    AuthenticationType["Basic"] = "basic";
    AuthenticationType["Custom"] = "custom";
    AuthenticationType["Digest"] = "digest";
    AuthenticationType["Oauth2"] = "oauth2";
    AuthenticationType["Session"] = "session";
})(AuthenticationType || (AuthenticationType = {}));
var DeveloperIntention;
(function(DeveloperIntention) {
    DeveloperIntention["Global"] = "global";
    DeveloperIntention["Invite"] = "invite";
    DeveloperIntention["Private"] = "private";
})(DeveloperIntention || (DeveloperIntention = {}));
var IssueStreamType;
(function(IssueStreamType) {
    IssueStreamType["Comments"] = "comments";
    IssueStreamType["Events"] = "events";
})(IssueStreamType || (IssueStreamType = {}));
var IssueOrderBy;
(function(IssueOrderBy) {
    IssueOrderBy["CreatedAt"] = "created_at";
    IssueOrderBy["Priority"] = "priority";
})(IssueOrderBy || (IssueOrderBy = {}));
var IssueOrderDirection;
(function(IssueOrderDirection) {
    IssueOrderDirection["Asc"] = "ASC";
    IssueOrderDirection["Desc"] = "DESC";
})(IssueOrderDirection || (IssueOrderDirection = {}));
var PartnerApiPaymentType;
(function(PartnerApiPaymentType) {
    PartnerApiPaymentType["ApiCall"] = "api_call";
    PartnerApiPaymentType["FlatFee"] = "flat_fee";
    PartnerApiPaymentType["No"] = "no";
})(PartnerApiPaymentType || (PartnerApiPaymentType = {}));
var DeveloperRole;
(function(DeveloperRole) {
    DeveloperRole["Contractor"] = "contractor";
    DeveloperRole["Employee"] = "employee";
    DeveloperRole["User"] = "user";
})(DeveloperRole || (DeveloperRole = {}));
var IntegrationReviewStatus;
(function(IntegrationReviewStatus) {
    IntegrationReviewStatus["Approved"] = "APPROVED";
    IntegrationReviewStatus["InReview"] = "IN_REVIEW";
    IntegrationReviewStatus["IsResubmission"] = "IS_RESUBMISSION";
    IntegrationReviewStatus["NotSubmitted"] = "NOT_SUBMITTED";
    IntegrationReviewStatus["PushedBack"] = "PUSHED_BACK";
    IntegrationReviewStatus["Rejected"] = "REJECTED";
})(IntegrationReviewStatus || (IntegrationReviewStatus = {}));
var Internal_Plan_Interval;
(function(Internal_Plan_Interval) {
    Internal_Plan_Interval["Month"] = "month";
    Internal_Plan_Interval["Year"] = "year";
})(Internal_Plan_Interval || (Internal_Plan_Interval = {}));
var Internal_AccountMembership_Role;
(function(Internal_AccountMembership_Role) {
    Internal_AccountMembership_Role["Admin"] = "admin";
    Internal_AccountMembership_Role["Member"] = "member";
    Internal_AccountMembership_Role["Owner"] = "owner";
})(Internal_AccountMembership_Role || (Internal_AccountMembership_Role = {}));
var Internal_Implementation_Role;
(function(Internal_Implementation_Role) {
    Internal_Implementation_Role["Owner"] = "owner";
    Internal_Implementation_Role["User"] = "user";
})(Internal_Implementation_Role || (Internal_Implementation_Role = {}));
var Internal_Zaps_Role;
(function(Internal_Zaps_Role) {
    Internal_Zaps_Role["Owner"] = "owner";
    Internal_Zaps_Role["User"] = "user";
})(Internal_Zaps_Role || (Internal_Zaps_Role = {}));
var StreamType;
(function(StreamType) {
    StreamType["Comments"] = "comments";
    StreamType["Events"] = "events";
})(StreamType || (StreamType = {}));
var OnboardingIntent;
(function(OnboardingIntent) {
    OnboardingIntent[/** When users want to discover what Zapier can do for them */ "General"] = "general";
    OnboardingIntent[/** When users have some specific apps they want to connect */ "Specific"] = "specific";
    OnboardingIntent[/** When users want to do something else - when this option is selected, users will have the option to provide intentionDetails */ "Uncertain"] = "uncertain";
})(OnboardingIntent || (OnboardingIntent = {}));
var OnboardingStatus;
(function(OnboardingStatus) {
    OnboardingStatus[/** When a user clicks the submit button on the last page of onboarding */ "Complete"] = "complete";
    OnboardingStatus[/** When a user clicks the skip button on the last page of onboarding */ "Skipped"] = "skipped";
    OnboardingStatus[/** When a user is displayed the onboarding page (currently app/onboarding) */ "Started"] = "started";
})(OnboardingStatus || (OnboardingStatus = {}));
var PartnerHealth;
(function(PartnerHealth) {
    PartnerHealth["Exceptional"] = "EXCEPTIONAL";
    PartnerHealth["Healthy"] = "HEALTHY";
    PartnerHealth[/**
   * A health score may be NA, or not available, if the partner has recently been
   * promoted public.
   */ "Na"] = "NA";
    PartnerHealth["Poor"] = "POOR";
})(PartnerHealth || (PartnerHealth = {}));
var MembershipAppTypes;
(function(MembershipAppTypes) {
    MembershipAppTypes["Cli"] = "cli";
    MembershipAppTypes["Py"] = "py";
    MembershipAppTypes["Wb"] = "wb";
})(MembershipAppTypes || (MembershipAppTypes = {}));
var MembershipSubscriptionOptions;
(function(MembershipSubscriptionOptions) {
    MembershipSubscriptionOptions["Collaborator"] = "collaborator";
    MembershipSubscriptionOptions["Subscriber"] = "subscriber";
})(MembershipSubscriptionOptions || (MembershipSubscriptionOptions = {}));
var SubscriptionId;
(function(SubscriptionId) {
    SubscriptionId["All"] = "all";
    SubscriptionId["Iterableappupdatesrecommendations"] = "iterableappupdatesrecommendations";
    SubscriptionId["Iterablecommunity"] = "iterablecommunity";
    SubscriptionId["Iterabledeveloperblog"] = "iterabledeveloperblog";
    SubscriptionId["Iterablegettingstartedseries"] = "iterablegettingstartedseries";
    SubscriptionId["Iterablenewappsweekly"] = "iterablenewappsweekly";
    SubscriptionId["Iterablenewsspecialoffers"] = "iterablenewsspecialoffers";
    SubscriptionId["Iterablepartnercommunications"] = "iterablepartnercommunications";
    SubscriptionId["Iterablezapierblog"] = "iterablezapierblog";
    SubscriptionId["Iterablezapierfeedback"] = "iterablezapierfeedback";
    SubscriptionId["Iterablezapierproductupdates"] = "iterablezapierproductupdates";
})(SubscriptionId || (SubscriptionId = {}));
var SuggestionPersonalization;
(function(SuggestionPersonalization) {
    SuggestionPersonalization["Popularity"] = "popularity";
    SuggestionPersonalization["Role"] = "role";
})(SuggestionPersonalization || (SuggestionPersonalization = {}));
var JobStatus;
(function(JobStatus) {
    JobStatus["Completed"] = "completed";
    JobStatus["Failed"] = "failed";
    JobStatus["InProgress"] = "inProgress";
    JobStatus["None"] = "none";
})(JobStatus || (JobStatus = {}));
var KindType;
(function(KindType) {
    KindType["Transfer"] = "transfer";
    KindType["Workflow"] = "workflow";
})(KindType || (KindType = {}));
var Sort;
(function(Sort) {
    Sort["Asc"] = "asc";
    Sort["Desc"] = "desc";
})(Sort || (Sort = {}));
var ZapTemplatesOrderByOptions;
(function(ZapTemplatesOrderByOptions) {
    ZapTemplatesOrderByOptions[/** Filters and orders results based on our default recommendation algorithm. */ "Default"] = "DEFAULT";
    ZapTemplatesOrderByOptions[/**
   * Filters and orders results based on what our recommendation system believes are good beginner Zaps.
   * In practice this means Simple Zap Setup ZTs, ranked by how often they have been completed by users.
   */ "ForBeginners"] = "FOR_BEGINNERS";
    ZapTemplatesOrderByOptions[/** Order results ascending by the ZT's "rank" field. */ "Rank"] = "RANK";
})(ZapTemplatesOrderByOptions || (ZapTemplatesOrderByOptions = {}));
var GlobalFailureStatus;
(function(GlobalFailureStatus) {
    GlobalFailureStatus["MassReplayDown"] = "mass_replay_down";
    GlobalFailureStatus["PaymentIssue"] = "payment_issue";
    GlobalFailureStatus["PlanLimit"] = "plan_limit";
})(GlobalFailureStatus || (GlobalFailureStatus = {}));
var HelpDocs_DocumentType;
(function(HelpDocs_DocumentType) {
    HelpDocs_DocumentType["Faq"] = "faq";
    HelpDocs_DocumentType["Generic"] = "generic";
    HelpDocs_DocumentType["Reference"] = "reference";
    HelpDocs_DocumentType["Troubleshooting"] = "troubleshooting";
    HelpDocs_DocumentType["Tutorial"] = "tutorial";
})(HelpDocs_DocumentType || (HelpDocs_DocumentType = {}));
var OnboardingSurveyType;
(function(OnboardingSurveyType) {
    OnboardingSurveyType["Company"] = "Company";
    OnboardingSurveyType["Team"] = "Team";
})(OnboardingSurveyType || (OnboardingSurveyType = {}));
var ChangePlanType;
(function(ChangePlanType) {
    ChangePlanType["Change"] = "change";
    ChangePlanType["Downgrade"] = "downgrade";
    ChangePlanType["Upgrade"] = "upgrade";
})(ChangePlanType || (ChangePlanType = {}));

;// CONCATENATED MODULE: ./src/graphql/queries/popularTemplates/usePopularTemplates.ts





var getPopularTemplates = function(data) {
    var ref, ref1;
    return data === null || data === void 0 ? void 0 : (ref = data.suggestedZapTemplates) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
        var zapTemplate = param.zapTemplate;
        return zapTemplate && (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zapTemplate), {
            url: (zapTemplate === null || zapTemplate === void 0 ? void 0 : zapTemplate.url) && "https://zapier.com".concat(zapTemplate.url)
        });
    });
};
var usePopularTemplates = function(param) {
    var _variables = param.variables, roleCanonicalId = _variables.roleCanonicalId, limit = _variables.limit, personalizeBy = _variables.personalizeBy, skip = param.skip;
    var ref = (0,useQuery/* useQuery */.a)(popularTemplatesQuery, {
        variables: {
            roleCanonicalId: roleCanonicalId,
            limit: limit || 3,
            personalizeBy: personalizeBy || SuggestionPersonalization.Role
        },
        skip: skip
    }), data = ref.data, loading = ref.loading, error = ref.error;
    return {
        data: getPopularTemplates(data),
        loading: loading,
        error: error
    };
};

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/VisuallyHidden/VisuallyHidden.js
var VisuallyHidden = __webpack_require__(18672);
;// CONCATENATED MODULE: ./src/components/sections/PopularTemplatesSection/TemplateCard.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var TemplateCard_obj;
var TemplateCard_Styles = (0,labelStyles/* labelStyles */.B)("TemplateCard", {
    root: (0,emotion_react_browser_esm/* css */.iv)((TemplateCard_obj = {
        height: "345px",
        width: "100%",
        flexShrink: 0,
        position: "relative",
        padding: "32px 32px 16px",
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        border: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
        borderRadius: "5px",
        boxSizing: "border-box",
        transition: "box-shadow 250ms ease-in-out",
        "&:hover, &:focus-within": {
            boxShadow: "6px 6px 0 ".concat(Colors/* Colors.neutral800 */.w.neutral800)
        },
        "& + &": {
            marginTop: "20px"
        },
        "&.hidden-on-mobile": (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
            visibility: "hidden"
        })
    }, (0,_define_property/* default */.Z)(TemplateCard_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        flexShrink: 1,
        "&:nth-child(3)": {
            display: "none"
        },
        "& + &": {
            marginTop: 0,
            marginLeft: "30px"
        }
    }), (0,_define_property/* default */.Z)(TemplateCard_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "370px",
        "&:nth-child(3)": {
            display: "block"
        }
    }), TemplateCard_obj)),
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), {
        minHeight: "128px",
        margin: "24px 0 52px"
    })),
    cta: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold), {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: Colors/* Colors.zapier */.w.zapier,
        textDecoration: "none"
    })),
    hiddenLink: (0,emotion_react_browser_esm/* css */.iv)({
        outline: "none",
        position: "absolute",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0
    })
});
function TemplateCard(param) {
    var title = param.title, isHiddenOnMobile = param.isHiddenOnMobile, _services = param.services, services = _services === void 0 ? [] : _services, url = param.url;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        className: isHiddenOnMobile ? "hidden-on-mobile" : "",
        css: TemplateCard_Styles.root,
        "data-testid": "template-card"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(ServiceIcons, {
        maxServices: 3,
        services: services.map(function(service) {
            return {
                name: service.name || "",
                src: service.image || ""
            };
        }),
        size: 60
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: TemplateCard_Styles.title
    }, title), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        "aria-hidden": true,
        css: TemplateCard_Styles.cta
    }, "Try it now", /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: "arrowBigRight"
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        href: url,
        onClick: function() {
            return emitCTAClickEvent({
                href: url,
                section: events/* SectionName.PopularTemplatesSection */.jz.PopularTemplatesSection,
                text: "Try it now",
                type: avro/* CTAType.zap_card_link */.g8.zap_card_link
            });
        }
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TemplateCard_Styles.hiddenLink,
        "data-testid": "".concat(title === null || title === void 0 ? void 0 : title.replace(" ", "-"), "-link")
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisuallyHidden/* VisuallyHidden */.T, null, "Try it now"))));
}

;// CONCATENATED MODULE: ./src/components/sections/PopularTemplatesSection/PopularTemplatesSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 












var PopularTemplatesSection_obj, PopularTemplatesSection_obj1, PopularTemplatesSection_obj2;
var PopularTemplatesSection_Styles = (0,labelStyles/* labelStyles */.B)("PopularTemplatesSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            backgroundColor: Colors/* Colors */.w[backgroundColor],
            padding: "55px 20px 45px 20px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "55px 20px 50px 20px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "55px 35px 85px 35px"
        }), _obj));
    },
    title: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.earth */.w.earth,
        textAlign: "center",
        marginBottom: "24px"
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        marginBottom: "32px"
    })))),
    dropdown: (0,emotion_react_browser_esm/* css */.iv)((PopularTemplatesSection_obj = {
        width: "100%",
        margin: "0 auto 32px"
    }, (0,_define_property/* default */.Z)(PopularTemplatesSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "492px",
        marginBottom: "40px"
    }), (0,_define_property/* default */.Z)(PopularTemplatesSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "570px",
        marginBottom: "48px"
    }), PopularTemplatesSection_obj)),
    templates: function(isExpanded, expandedHeight) {
        var _obj;
        return [
            (0,emotion_react_browser_esm/* css */.iv)((_obj = {
                height: "345px",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: "32px",
                paddingBottom: "8px",
                overflow: "hidden",
                transition: "height 250ms ease-out"
            }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
                height: "auto",
                flexDirection: "row",
                justifyContent: "center",
                marginBottom: "40px",
                overflow: "visible"
            }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
                marginBottom: "48px"
            }), _obj)),
            isExpanded && (0,withModifier/* withModifier */.Q)("expanded", (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
                height: expandedHeight
            }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
                height: "auto"
            }))), 
        ];
    },
    loaderCard: (0,emotion_react_browser_esm/* css */.iv)((PopularTemplatesSection_obj1 = {
        width: "calc(100% - 2px)",
        flexShrink: 0,
        border: "1px solid ".concat(Colors/* Colors.neutral300 */.w.neutral300),
        "& + &": {
            marginTop: "20px"
        }
    }, (0,_define_property/* default */.Z)(PopularTemplatesSection_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        flexShrink: 1,
        "&:nth-child(3)": {
            display: "none"
        },
        "& + &": {
            marginTop: 0,
            marginLeft: "30px"
        }
    }), (0,_define_property/* default */.Z)(PopularTemplatesSection_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "370px",
        "&:nth-child(3)": {
            display: "block"
        }
    }), PopularTemplatesSection_obj1)),
    cta: (0,emotion_react_browser_esm/* css */.iv)((PopularTemplatesSection_obj2 = {
        width: "100%",
        margin: "0 auto"
    }, (0,_define_property/* default */.Z)(PopularTemplatesSection_obj2, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "216px",
        minWidth: "max-content"
    }), (0,_define_property/* default */.Z)(PopularTemplatesSection_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "372px"
    }), PopularTemplatesSection_obj2)),
    loadMoreButton: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        width: "100%",
        "& > button": {
            color: "".concat(Colors/* Colors.neutral800 */.w.neutral800, " !important"),
            border: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800, " !important")
        }
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        display: "none"
    })),
    exploreRolesButton: function(isExpanded) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
            width: "100%",
            display: isExpanded ? "inline-block" : "none"
        }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            display: "inline-block"
        }));
    }
});
function PopularTemplatesSection(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? colors/* COLOR_KEYS.cream */.US.cream : _backgroundColor, _ctaButtonText = param.ctaButtonText, ctaButtonText = _ctaButtonText === void 0 ? "Explore Roles page" : _ctaButtonText, defaultCtaHref = param.defaultCtaHref, defaultTemplates = param.defaultTemplates, title = param.title, roles = param.roles;
    var ref;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var ref1 = (0,react.useState)(), selectedRole = ref1[0], setSelectedRole = ref1[1];
    var ref2 = (0,react.useState)(false), isExpanded = ref2[0], setIsExpanded = ref2[1];
    var ref3 = (0,react.useState)(unsecureID("templates-")), templatesId = ref3[0];
    var ref4 = usePopularTemplates({
        variables: {
            roleCanonicalId: selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.canonicalId
        },
        skip: !!(selectedRole === null || selectedRole === void 0 ? void 0 : (ref = selectedRole.templates) === null || ref === void 0 ? void 0 : ref.length)
    }), data = ref4.data, loading = ref4.loading;
    var manuallyInputTemplates = selectedRole ? selectedRole.templates : defaultTemplates;
    var templates = (manuallyInputTemplates === null || manuallyInputTemplates === void 0 ? void 0 : manuallyInputTemplates.length) ? manuallyInputTemplates : data;
    var ctaHref = (selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.href) || defaultCtaHref;
    var expandedHeight = (templates === null || templates === void 0 ? void 0 : templates.length) > 0 ? templates.length * 345 + (templates.length - 1) * 20 : 345;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: PopularTemplatesSection_Styles.title
    }, title), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.dropdown
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Dropdown, {
        ariaLabel: "Role",
        getLabelForItem: function(role) {
            return role.name;
        },
        items: roles,
        menuAriaLabel: "List of available roles",
        onChange: setSelectedRole,
        placeholder: "Explore by role",
        renderFloatingMenu: function(props) {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(FloatingMenu/* FloatingMenu */.A, Object.assign({}, props, {
                visibleItems: roles.length
            }));
        }
    })), loading ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.templates(isExpanded, expandedHeight)
    }, Array.from({
        length: 3
    }).map(function(_, i) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: PopularTemplatesSection_Styles.loaderCard,
            key: "skeleton-card-".concat(i)
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SkeletonBlock, {
            height: 345,
            width: "100%"
        }));
    })) : /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.templates(isExpanded, expandedHeight),
        id: templatesId
    }, templates === null || templates === void 0 ? void 0 : templates.map(function(template, index) {
        return template && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(TemplateCard, {
            isHiddenOnMobile: index > 0 && !isExpanded,
            key: "".concat(template.title, "-").concat(index),
            services: template.services,
            title: template.title,
            url: template.url
        });
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.cta
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.loadMoreButton
    }, !isExpanded && (templates === null || templates === void 0 ? void 0 : templates.length) > 1 && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        ariaControls: templatesId,
        ariaExpanded: isExpanded,
        color: "secondary",
        isFullWidth: true,
        onClick: function() {
            return setIsExpanded(true);
        }
    }, "Load more")), ctaHref && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: PopularTemplatesSection_Styles.exploreRolesButton(isExpanded)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        href: ctaHref,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                href: ctaHref,
                section: events/* SectionName.PopularTemplatesSection */.jz.PopularTemplatesSection,
                text: ctaButtonText
            });
        }
    }, ctaButtonText))));
}

;// CONCATENATED MODULE: ./src/components/sections/PopularTemplatesSection/fixtures.ts

var PopularTemplatesSection_fixtures_DEFAULT_VALUES = {
    title: "Find your first Zap",
    backgroudColor: colors/* COLOR_KEYS.cream */.US.cream,
    defaultCtaHref: "https://zapier.com/roles",
    ctaButtonText: "Explore roles page",
    roles: [
        {
            name: "Marketing",
            canonicalId: "0a326fb9-7108-4e93-84bd-d8ddffbd8aa1",
            href: "https://zapier.com/roles/marketers"
        },
        {
            name: "Business Owner",
            canonicalId: "511feb25-82b6-4a9f-81d6-83629a888016",
            href: "https://zapier.com/roles/business-owners"
        },
        {
            name: "IT",
            canonicalId: "c97bc7dc-030f-44d5-9c23-61d4b77a25b0",
            href: "https://zapier.com/roles/information-technology"
        },
        {
            name: "Sales",
            canonicalId: "30a9520e-7e2c-4c86-9acc-4fd07d08c260",
            href: "https://zapier.com/roles/sales"
        },
        {
            name: "Support",
            canonicalId: "96f2f4e2-cbd6-40d5-a49e-322a714070bd",
            href: "https://zapier.com/roles/customer-service"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/sections/PopularTemplatesSection/PopularTemplatesSection.builder.ts






/* harmony default export */ var PopularTemplatesSection_builder = (createBuilderModule(withTracking(PopularTemplatesSection, {
    as: "section",
    sectionName: events/* SectionName.PopularTemplatesSection */.jz.PopularTemplatesSection
}), {
    name: "PopularTemplatesSection",
    image: "https://cdn.zappy.app/9428f7ba38c34640ffa27b9834437180.png",
    inputs: [
        {
            name: "title",
            helperText: "Section title",
            type: "string",
            defaultValue: PopularTemplatesSection_fixtures_DEFAULT_VALUES.title,
            required: true
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            required: true,
            defaultValue: PopularTemplatesSection_fixtures_DEFAULT_VALUES.backgroudColor
        },
        {
            name: "defaultCtaHref",
            helperText: "Destination link for CTA button/link when a role is not selected",
            type: "string",
            required: true,
            defaultValue: PopularTemplatesSection_fixtures_DEFAULT_VALUES.defaultCtaHref
        },
        {
            name: "ctaButtonText",
            helperText: "Text for the CTA button",
            type: "string",
            required: true,
            defaultValue: PopularTemplatesSection_fixtures_DEFAULT_VALUES.ctaButtonText
        },
        {
            name: "defaultTemplates",
            helperText: "Templates displayed when no role is selected. If none is input, an API call will return the most popular templates for all roles.",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true,
                    defaultValue: "Title"
                },
                {
                    name: "url",
                    type: "string",
                    required: true,
                    defaultValue: "#"
                },
                {
                    name: "services",
                    type: "list",
                    required: true,
                    subFields: [
                        {
                            name: "image",
                            type: "string",
                            required: true
                        },
                        {
                            name: "name",
                            type: "string",
                            required: true
                        }, 
                    ],
                    defaultValue: [
                        {
                            image: "https://cdn.zappy.app/9428f7ba38c34640ffa27b9834437180.png",
                            name: "Templates logo"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "roles",
            type: "list",
            defaultValue: PopularTemplatesSection_fixtures_DEFAULT_VALUES.roles,
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "href",
                    type: "string",
                    required: true,
                    helperText: "Destination href for individual job role"
                },
                {
                    name: "canonicalId",
                    helperText: "ID used to fetch the templates for the role from the Zapier API. If none is input, you must manually add templates for the role.",
                    type: "string"
                },
                {
                    name: "templates",
                    type: "list",
                    subFields: [
                        {
                            name: "title",
                            type: "string",
                            required: true
                        },
                        {
                            name: "url",
                            type: "string",
                            required: true
                        },
                        {
                            name: "services",
                            type: "list",
                            required: true,
                            subFields: [
                                {
                                    name: "image",
                                    type: "string",
                                    required: true
                                },
                                {
                                    name: "name",
                                    type: "string",
                                    required: true
                                }, 
                            ]
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/ResourcesSection/fixtures.ts

var ResourcesSection_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.cream */.US.cream,
    heading: "As much (or as little) help as you want",
    groups: [
        {
            heading: "Do it yourself",
            description: "<p>Whether you’re brand-new to automation or looking to grow your skills, we make DIY doable.</p>",
            links: [
                {
                    text: "Quick start guide",
                    url: "https://zapier.com/learn/zapier-quick-start-guide/"
                },
                {
                    text: "Zapier University",
                    url: "https://zapier.com/university"
                },
                {
                    text: "Community",
                    url: "https://community.zapier.com/"
                },
                {
                    text: "Support",
                    url: "https://zapier.com/help"
                }, 
            ]
        },
        {
            heading: "Hire an Expert",
            description: "<p>Choose a Zapier Certified Expert to help you think through and create automated workflows.</p>",
            links: [
                {
                    text: "Andy Wingrave",
                    url: "https://zapier.com/experts/andy-wingrave",
                    showRating: true
                },
                {
                    text: "MercOlogy",
                    url: "https://zapier.com/experts/mercology",
                    showRating: true
                },
                {
                    text: "GetUWired",
                    url: "https://zapier.com/experts/getuwired",
                    showRating: true
                },
                {
                    text: "See all Experts",
                    url: "https://zapier.com/experts"
                }, 
            ]
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/sections/ResourcesSection/Group.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 








var linkFocusStyles = (0,emotion_react_browser_esm/* css */.iv)({
    content: '""',
    position: "absolute",
    border: "2px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
    borderRadius: "3px",
    inset: "-2px -10px"
});
var Group_obj;
var Group_Styles = (0,labelStyles/* labelStyles */.B)("Group", {
    root: (0,emotion_react_browser_esm/* css */.iv)((Group_obj = {
        padding: "40px 20px",
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        border: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
        borderRadius: "5px",
        boxShadow: "6px 6px 0 ".concat(Colors/* Colors.neutral800 */.w.neutral800)
    }, (0,_define_property/* default */.Z)(Group_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        padding: "40px"
    }), (0,_define_property/* default */.Z)(Group_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "44px"
    }), Group_obj)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), {
        color: Colors/* Colors.earth */.w.earth,
        marginBottom: "8px"
    })),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (0,_define_property/* default */.Z)({
        fontSize: "16px",
        lineHeight: "22px",
        color: Colors/* Colors.neutral800 */.w.neutral800,
        marginBottom: "32px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3), {
        minHeight: "84px",
        marginBottom: "48px"
    })))),
    list: (0,emotion_react_browser_esm/* css */.iv)({
        listStyle: "none"
    }),
    listItem: (0,emotion_react_browser_esm/* css */.iv)({
        borderBottom: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800)
    }),
    link: function(showRating) {
        var _obj;
        return [
            (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader5Medium */.ZT.subHeader5Medium), (_obj = {
                fontSize: "16px",
                lineHeight: "24px",
                color: Colors/* Colors.neutral800 */.w.neutral800,
                textDecoration: "none",
                position: "relative",
                display: "flex",
                alignItems: "center",
                padding: "12px 48px 12px 0",
                outline: "none",
                transition: "color 250ms"
            }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3Medium */.ZT.subHeader3Medium), {
                padding: "16px 48px 16px 0"
            })), (0,_define_property/* default */.Z)(_obj, "&:hover", {
                color: "#7B7977"
            }), (0,_define_property/* default */.Z)(_obj, "&:focus::before", linkFocusStyles), (0,_define_property/* default */.Z)(_obj, "&:focus-visible::before", linkFocusStyles), (0,_define_property/* default */.Z)(_obj, "&:focus:not(:focus-visible)::before", {
                display: "none"
            }), _obj))),
            showRating && (0,withModifier/* withModifier */.Q)("hasRating", (0,emotion_react_browser_esm/* css */.iv)({
                paddingRight: "144px"
            })), 
        ];
    },
    arrow: (0,emotion_react_browser_esm/* css */.iv)({
        height: "24px",
        position: "absolute",
        right: 0,
        transition: "all 250ms",
        "a:hover &": {
            transform: "translateX(4px)"
        }
    }),
    rating: (0,emotion_react_browser_esm/* css */.iv)({
        height: "24px",
        position: "absolute",
        right: 0,
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        transition: "all 250ms",
        "a:hover &, a:focus &": {
            opacity: 0,
            transform: "translateX(4px)"
        }
    })
});
function Group(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Group_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: Group_Styles.heading
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Group_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
        html: props.description
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
        css: Group_Styles.list
    }, props.links.map(function(link) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
            css: Group_Styles.listItem,
            key: link.text
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
            css: Group_Styles.link(link.showRating),
            href: link.url
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, link.text), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
            css: Group_Styles.arrow
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            color: colors/* COLOR_KEYS.zapier */.US.zapier,
            name: "arrowBigRight",
            size: 24
        })), link.showRating && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
            css: Group_Styles.rating
        }, (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
                color: colors/* COLOR_KEYS.zapier */.US.zapier,
                key: index,
                name: "ratingStarFill",
                size: 24
            });
        }))));
    })));
}

;// CONCATENATED MODULE: ./src/components/sections/ResourcesSection/ResourcesSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var ResourcesSection_obj;
var ResourcesSection_Styles = (0,labelStyles/* labelStyles */.B)("ResourcesSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            padding: "64px 20px",
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "72px 20px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "108px 20px"
        }), _obj));
    },
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (ResourcesSection_obj = {
        color: Colors/* Colors.earth */.w.earth,
        textAlign: "center",
        marginBottom: "32px"
    }, (0,_define_property/* default */.Z)(ResourcesSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginBottom: "48px"
    }), (0,_define_property/* default */.Z)(ResourcesSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        marginBottom: "64px"
    })), ResourcesSection_obj))),
    groups: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        maxWidth: "1170px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "30px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        gridTemplateColumns: "1fr 1fr"
    }))
});
function ResourcesSection(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ResourcesSection_Styles.root(props.backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: ResourcesSection_Styles.heading
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ResourcesSection_Styles.groups
    }, props.groups.map(function(group) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Group, Object.assign({}, group, {
            key: group.heading
        }));
    })));
}

;// CONCATENATED MODULE: ./src/components/sections/ResourcesSection/ResourcesSection.builder.ts





/* harmony default export */ var ResourcesSection_builder = (createBuilderModule(withTracking(ResourcesSection, {
    as: "section",
    sectionName: events/* SectionName.ResourcesSection */.jz.ResourcesSection
}), {
    name: "ResourcesSection",
    image: "https://cdn.zappy.app/4facc3abf377333bfae6f9585e51e76c.png",
    inputs: [
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            required: true,
            defaultValue: ResourcesSection_fixtures_DEFAULT_VALUES.backgroundColor
        },
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: ResourcesSection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "groups",
            type: "list",
            required: true,
            defaultValue: ResourcesSection_fixtures_DEFAULT_VALUES.groups,
            subFields: [
                {
                    name: "heading",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    required: true
                },
                {
                    name: "links",
                    type: "list",
                    required: true,
                    subFields: [
                        {
                            name: "text",
                            type: "string",
                            required: true
                        },
                        {
                            name: "url",
                            type: "string",
                            required: true
                        },
                        {
                            name: "showRating",
                            type: "boolean"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/ScrollingTweetsSection/fixtures.ts

var ScrollingTweetsSection_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.bolt */.US.bolt,
    heading: "This is what automation feels like",
    tweets: [
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
            mediaUrl: "https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
            mediaUrl: "https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
            mediaUrl: "https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>",
            mediaUrl: "https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png"
        },
        {
            name: "John Smith",
            handle: "@johnsmith",
            body: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>"
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/sections/ScrollingTweetsSection/Tweet.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var Tweet_obj;
var Tweet_Styles = (0,labelStyles/* labelStyles */.B)("Tweet", {
    root: function(hasLink) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
            width: "320px",
            padding: "16px",
            marginBottom: "20px",
            position: "relative",
            boxSizing: "border-box",
            breakInside: "avoid-column",
            backgroundColor: Colors/* Colors.white */.w.white,
            border: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
            borderRadius: "5px",
            transition: "box-shadow 250ms"
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            width: "512px",
            padding: "24px"
        }), hasLink && {
            "&:hover, &:focus-within": {
                boxShadow: "6px 6px 0 ".concat(Colors/* Colors.neutral800 */.w.neutral800)
            }
        }));
    },
    header: (0,emotion_react_browser_esm/* css */.iv)((Tweet_obj = {
        display: "flex",
        alignItems: "center",
        marginBottom: "12px"
    }, (0,_define_property/* default */.Z)(Tweet_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginBottom: "16px"
    }), (0,_define_property/* default */.Z)(Tweet_obj, "& > :last-child", (0,_define_property/* default */.Z)({
        marginLeft: "8px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginLeft: "12px"
    })), Tweet_obj)),
    name: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1Medium */.ZT.smallPrint1Medium), {
        lineHeight: 1.25,
        color: Colors/* Colors.neutral800 */.w.neutral800
    })),
    handle: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), {
        lineHeight: 1.25,
        color: Colors/* Colors.neutral600 */.w.neutral600
    })),
    body: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short)))),
    media: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        marginTop: "12px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginTop: "16px"
    })),
    video: (0,emotion_react_browser_esm/* css */.iv)({
        width: "100%",
        borderRadius: "10px"
    }),
    link: (0,emotion_react_browser_esm/* css */.iv)({
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        outline: "none"
    })
});
function Tweet(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        "aria-hidden": props.ariaHidden,
        css: Tweet_Styles.root(!!props.url)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("header", {
        css: Tweet_Styles.header
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* Avatar */.q, {
        name: props.name,
        size: 40,
        url: props.avatarUrl
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Tweet_Styles.name
    }, props.name), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Tweet_Styles.handle
    }, props.handle))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Tweet_Styles.body
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: colors/* COLOR_KEYS.white */.US.white,
        html: props.body
    })), props.mediaUrl && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Tweet_Styles.media
    }, props.mediaUrl.toLowerCase().endsWith(".mp4") || props.mediaUrl.toLowerCase().endsWith(".mov") ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("video", {
        "aria-label": props.mediaAltText,
        autoPlay: true,
        controls: false,
        css: Tweet_Styles.video,
        disablePictureInPicture: true,
        loop: true,
        muted: true,
        playsInline: true,
        preload: "auto",
        src: props.mediaUrl
    }) : /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Img/* Img */.E, {
        alt: props.mediaAltText || "",
        isFullWidth: true,
        src: props.mediaUrl
    })), props.url && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
        css: Tweet_Styles.link,
        href: props.url,
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisuallyHidden/* VisuallyHidden */.T, null, "View tweet")));
}

;// CONCATENATED MODULE: ./src/components/sections/ScrollingTweetsSection/ScrollingTweetsSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 









var ScrollingTweetsSection_obj;
var ScrollingTweetsSection_Styles = (0,labelStyles/* labelStyles */.B)("ScrollingTweetsSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            backgroundColor: Colors/* Colors */.w[backgroundColor],
            padding: "64px 0 56px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "80px 0 72px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "96px 0 88px"
        }), _obj));
    },
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (ScrollingTweetsSection_obj = {
        color: Colors/* Colors.earth */.w.earth,
        textAlign: "center",
        maxWidth: "320px",
        margin: "0 auto 48px"
    }, (0,_define_property/* default */.Z)(ScrollingTweetsSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "640px",
        marginBottom: "64px"
    }), (0,_define_property/* default */.Z)(ScrollingTweetsSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        maxWidth: "768px",
        marginBottom: "80px"
    })), ScrollingTweetsSection_obj))),
    scroller: (0,emotion_react_browser_esm/* css */.iv)({
        padding: "0 20px",
        overflowX: "scroll",
        willChange: "scroll-position",
        // Hide scrollbar
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        }
    }),
    tweets: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        width: "fit-content"
    }),
    tweetStack: (0,emotion_react_browser_esm/* css */.iv)({
        "& + &": {
            marginLeft: "20px"
        }
    })
});
function ScrollingTweetsSection(props) {
    var rootRef = (0,react.useRef)(null);
    var scrollerRef = (0,react.useRef)(null);
    var tweetsRef = (0,react.useRef)(null);
    var previousTimestampRef = (0,react.useRef)(0);
    var animationFrameRef = (0,react.useRef)();
    var isIntersectingRef = (0,react.useRef)(false);
    var autoScroll = (0,react.useCallback)(function(timestamp) {
        if (scrollerRef.current && timestamp - previousTimestampRef.current > 25) {
            scrollerRef.current.scrollBy(1, 0);
            previousTimestampRef.current = timestamp;
        }
        animationFrameRef.current = requestAnimationFrame(autoScroll);
    }, []);
    var handleScroll = (0,react.useCallback)(function() {
        var scroller = scrollerRef.current;
        var tweets = tweetsRef.current;
        if (!tweets || !scroller) {
            return;
        }
        var resetPoint = tweets.clientWidth / 2 + 10;
        if (scroller.scrollLeft <= 0 || scroller.scrollLeft >= resetPoint) {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
            animationFrameRef.current = requestAnimationFrame(function() {
                /*
          To achieve the infinite looping effect, when the scroll position
          reaches the last non-duplicated stack of tweets (plus spacing), the
          scroll position should reset to the beginning. Similarly, when
          scrolling backwards and the scroll position reaches 0, the scroll
          position should jump to the end of the non-duplicated tweets.
        */ scroller.scrollTo(scroller.scrollLeft <= 0 ? resetPoint - 1 : 1, 0);
                if (isIntersectingRef.current && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                    animationFrameRef.current = requestAnimationFrame(autoScroll);
                }
            });
        }
    }, [
        autoScroll
    ]);
    (0,react.useEffect)(function() {
        var root = rootRef.current;
        if (!root || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), isIntersecting = _param[0].isIntersecting;
            isIntersectingRef.current = isIntersecting;
            if (isIntersecting) {
                animationFrameRef.current = requestAnimationFrame(autoScroll);
            } else {
                if (animationFrameRef.current) {
                    cancelAnimationFrame(animationFrameRef.current);
                }
            }
        }, {
            threshold: 0.1
        });
        observer.observe(root);
        return function() {
            observer.unobserve(root);
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, [
        autoScroll
    ]);
    var tweetStacks = (0,react.useMemo)(function() {
        return props.tweets.reduce(function(stacks, tweet, tweetIndex) {
            var stackIndex = Math.floor(tweetIndex / 2);
            if (!stacks[stackIndex]) {
                stacks[stackIndex] = [];
            }
            stacks[stackIndex].push(tweet);
            return stacks;
        }, []);
    }, [
        props.tweets
    ]);
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ScrollingTweetsSection_Styles.root(props.backgroundColor),
        ref: rootRef
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: ScrollingTweetsSection_Styles.heading
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ScrollingTweetsSection_Styles.scroller,
        onScroll: handleScroll,
        ref: scrollerRef
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: ScrollingTweetsSection_Styles.tweets,
        ref: tweetsRef
    }, [
        false,
        true
    ].map(function(ariaHidden, renderIndex) {
        return tweetStacks.map(function(stack, stackIndex) {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
                css: ScrollingTweetsSection_Styles.tweetStack,
                key: "".concat(renderIndex, "-").concat(stackIndex)
            }, stack.map(function(tweet, tweetIndex) {
                return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Tweet, Object.assign({}, tweet, {
                    ariaHidden: ariaHidden,
                    key: "".concat(renderIndex, "-").concat(stackIndex, "-").concat(tweetIndex, "-").concat(tweet.url)
                }));
            }));
        });
    }))));
}

;// CONCATENATED MODULE: ./src/components/sections/ScrollingTweetsSection/ScrollingTweetsSection.builder.ts





/* harmony default export */ var ScrollingTweetsSection_builder = (createBuilderModule(withTracking(ScrollingTweetsSection, {
    as: "section",
    sectionName: events/* SectionName.ScrollingTweetsSection */.jz.ScrollingTweetsSection
}), {
    name: "ScrollingTweetsSection",
    image: "https://cdn.zappy.app/9672290cb2a53fb77db379e85a96089f.svg",
    inputs: [
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: ScrollingTweetsSection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "tweets",
            type: "list",
            required: true,
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "handle",
                    type: "string",
                    required: true
                },
                {
                    name: "body",
                    type: "richText",
                    required: true
                },
                {
                    name: "avatarUrl",
                    type: "string"
                },
                {
                    name: "mediaUrl",
                    type: "cloudinaryImage"
                },
                {
                    name: "mediaAltText",
                    type: "string"
                },
                {
                    name: "url",
                    type: "string"
                }, 
            ],
            defaultValue: ScrollingTweetsSection_fixtures_DEFAULT_VALUES.tweets
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.bolt */.US.bolt,
                colors/* COLOR_KEYS.peach */.US.peach,
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100, 
            ],
            required: true,
            defaultValue: ScrollingTweetsSection_fixtures_DEFAULT_VALUES.backgroundColor
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/SignUpForm/SignUpForm.tsx

function SignUpForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 370px;\n  margin: 0 auto;\n  padding: 25px 20px;\n  border-radius: 20px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    SignUpForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SignUpForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 375px;\n  height: 455px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n"
    ]);
    SignUpForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ZapierSignUpForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1270), __webpack_require__.e(6488), __webpack_require__.e(5048), __webpack_require__.e(3201), __webpack_require__.e(8614)]).then(__webpack_require__.bind(__webpack_require__, 36021)).then(function(mod) {
        return mod.SignUpForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36021)
            ];
        }
    }
});
function SignUpForm(param) {
    var _hideFieldsUntilFocus = param.hideFieldsUntilFocus, hideFieldsUntilFocus = _hideFieldsUntilFocus === void 0 ? true : _hideFieldsUntilFocus, _facebookSSOEnabled = param.facebookSSOEnabled, facebookSSOEnabled = _facebookSSOEnabled === void 0 ? true : _facebookSSOEnabled, _googleSSOEnabled = param.googleSSOEnabled, googleSSOEnabled = _googleSSOEnabled === void 0 ? true : _googleSSOEnabled, _microsoftSSOEnabled = param.microsoftSSOEnabled, microsoftSSOEnabled = _microsoftSSOEnabled === void 0 ? true : _microsoftSSOEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormContainer, {
        children: builder_react_es5/* Builder.isEditing */.Ib.isEditing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormPlaceholder, {
            children: "Sign up form"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapierSignUpForm, {
            facebookSSOEnabled: facebookSSOEnabled,
            googleCaptchaSiteKey: "6Lda9zoUAAAAAOwhmrgGDo_l4zcHOYWujO9Q_qnS" || 0,
            googleClientId: "927538837578.apps.googleusercontent.com" || 0,
            googleSSOEnabled: googleSSOEnabled,
            hideFieldsUntilFocus: hideFieldsUntilFocus,
            microsoftSSOEnabled: microsoftSSOEnabled
        })
    });
}
var SignUpFormContainer = emotion_styled_browser_esm/* default.div */.Z.div(SignUpForm_templateObject(), Colors/* Colors.white */.w.white, Shadows/* Shadows.elevation5 */.f.elevation5);
var SignUpFormPlaceholder = emotion_styled_browser_esm/* default.div */.Z.div(SignUpForm_templateObject1(), Colors/* Colors.gray60 */.w.gray60);

;// CONCATENATED MODULE: ./src/components/sections/SignUpCtaSection/SignUpCtaSection.tsx

function SignUpCtaSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    SignUpCtaSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function SignUpCtaSection(param) {
    var background = param.background, _facebookSSOEnabled = param.facebookSSOEnabled, facebookSSOEnabled = _facebookSSOEnabled === void 0 ? true : _facebookSSOEnabled, _googleSSOEnabled = param.googleSSOEnabled, googleSSOEnabled = _googleSSOEnabled === void 0 ? true : _googleSSOEnabled, heading = param.heading, _hideFieldsUntilFocus = param.hideFieldsUntilFocus, hideFieldsUntilFocus = _hideFieldsUntilFocus === void 0 ? true : _hideFieldsUntilFocus, _microsoftSSOEnabled = param.microsoftSSOEnabled, microsoftSSOEnabled = _microsoftSSOEnabled === void 0 ? true : _microsoftSSOEnabled, subheading = param.subheading, builderBlock = param.builderBlock;
    var getBackground = function() {
        var colorMap = {
            Lava40Dotty: colors/* COLOR_KEYS.zapier */.US.zapier,
            lava60: colors/* COLOR_KEYS.zapier */.US.zapier,
            ocean10: colors/* COLOR_KEYS.night */.US.night,
            Sun60Dotty: colors/* COLOR_KEYS.moss */.US.moss
        };
        return Object.prototype.hasOwnProperty.call(colorMap, background) ? colorMap[background] : background;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        background: getBackground(),
        heading: heading,
        layerName: builderBlock === null || builderBlock === void 0 ? void 0 : builderBlock.layerName,
        sectionToTrack: events/* SectionName.SignUpSection */.jz.SignUpSection,
        subheading: subheading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpCtaSection_Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {
                facebookSSOEnabled: facebookSSOEnabled,
                googleSSOEnabled: googleSSOEnabled,
                hideFieldsUntilFocus: hideFieldsUntilFocus,
                microsoftSSOEnabled: microsoftSSOEnabled
            })
        })
    });
}
var SignUpCtaSection_Content = emotion_styled_browser_esm/* default.div */.Z.div(SignUpCtaSection_templateObject());

;// CONCATENATED MODULE: ./src/components/sections/SignUpCtaSection/SignUpCtaSection.builder.ts




/* harmony default export */ var SignUpCtaSection_builder = (createBuilderModule(SignUpCtaSection, {
    name: "SignUpCtaSection",
    image: "https://cdn.zappy.app/2d64dcac2ba7f01bbf4e2cbb38f0d652.png",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Get started for free"
        },
        {
            name: "subheading",
            type: "string",
            defaultValue: "You can’t add more hours to the day. Zapier is the next best thing."
        },
        {
            name: "background",
            type: "string",
            enum: [
                "Lava40Dotty",
                "Sun60Dotty"
            ].concat((0,_to_consumable_array/* default */.Z)(Object.values(backgroundColors))),
            defaultValue: "Lava40Dotty"
        },
        {
            name: "googleSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "facebookSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "microsoftSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "hideFieldsUntilFocus",
            type: "boolean",
            defaultValue: true
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/SignUpForm/SignUpForm.builder.ts


/* harmony default export */ var SignUpForm_builder = (createBuilderModule(SignUpForm, {
    name: "SignUpForm",
    image: "https://cdn.zappy.app/46ccf0301f53cb8425ad63d5f05d7486.png",
    inputs: [
        {
            name: "googleSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "facebookSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "microsoftSSOEnabled",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "hideFieldsUntilFocus",
            type: "boolean",
            defaultValue: true
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Spacer/Spacer.js
var Spacer = __webpack_require__(53939);
;// CONCATENATED MODULE: ./src/components/Spacer/Spacer.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 


var Spacer_Styles = (0,labelStyles/* labelStyles */.B)("Spacer", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)({
            backgroundColor: backgroundColor
        });
    }
});
function Spacer_Spacer(param) {
    var height = param.height, width = param.width, backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Spacer_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Spacer/* Spacer */.L, {
        height: height,
        width: width
    }));
}

;// CONCATENATED MODULE: ./src/components/Spacer/Spacer.builder.ts





var emptyBackgroundColorItem = {
    "": ""
};
/* harmony default export */ var Spacer_builder = (createBuilderModule(Spacer_Spacer, {
    name: "Spacer",
    image: "",
    inputs: [
        {
            name: "height",
            type: "number",
            required: false
        },
        {
            name: "width",
            type: "number",
            required: false
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.entries((0,src_object_spread/* default */.Z)({}, emptyBackgroundColorItem, Colors/* Colors */.w)).sort(function(param, param1) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), a = _param[0], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 1), b = _param1[0];
                return a.localeCompare(b);
            }).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                return {
                    label: key,
                    value: value
                };
            })
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/constants/index.js
var universal_nav_constants = __webpack_require__(84649);
// EXTERNAL MODULE: ./src/utils/isBrowser.ts
var isBrowser = __webpack_require__(82929);
;// CONCATENATED MODULE: ./src/components/sections/SplitColorAccordionSection/AccordionItem.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 












var AccordionItem_Styles = (0,labelStyles/* labelStyles */.B)("AccordionItem", {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        borderBottom: "1px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800)
    }),
    button: (0,emotion_react_browser_esm/* css */.iv)({
        all: "unset",
        width: "100%",
        height: "48px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        color: Colors/* Colors.neutral800 */.w.neutral800,
        transition: "all 250ms",
        "&:not(:disabled)": {
            cursor: "pointer"
        },
        "@media(hover:hover)": {
            "&:hover:not(:disabled)": {
                color: "#7B7977"
            }
        },
        "&:focus-visible:not(:disabled)": {
            "&::before": {
                content: '""',
                position: "absolute",
                border: "2px solid ".concat(Colors/* Colors.neutral800 */.w.neutral800),
                borderRadius: "3px",
                inset: "-2px -10px"
            }
        }
    }),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3, Typography/* Typography.heading */.ZT.heading), {
        fontWeight: 500
    })),
    content: (0,emotion_react_browser_esm/* css */.iv)({
        maxHeight: 0,
        overflowY: "hidden",
        transition: "max-height 250ms cubic-bezier(0.25, 1, 0.5, 1)"
    }),
    body: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3), (0,_define_property/* default */.Z)({
        paddingBottom: "20px",
        color: Colors/* Colors.neutral800 */.w.neutral800
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short)))),
    mediaContainer: function(mediaBackgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            padding: "32px 24px",
            backgroundColor: Colors/* Colors */.w[mediaBackgroundColor],
            marginBottom: "20px"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            height: "100%",
            width: "55%",
            position: "absolute",
            top: 0,
            right: 0,
            margin: 0,
            boxSizing: "border-box",
            backgroundColor: "transparent",
            transition: "opacity 500ms cubic-bezier(0.25, 1, 0.5, 1)",
            '[aria-expanded="false"] + div &': {
                opacity: 0
            }
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "80px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
            padding: "96px"
        }), _obj));
    },
    media: (0,emotion_react_browser_esm/* css */.iv)({
        width: "100%",
        height: "100%",
        minHeight: "100%",
        maxHeight: "calc(100vh - 192px - ".concat(universal_nav_constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5, "px)"),
        display: "grid",
        placeItems: "center",
        gridTemplateRows: "minmax(0, 1fr)",
        "& video": (0,_define_property/* default */.Z)({}, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
            height: "auto"
        }),
        "& > svg, & > img": {
            display: "block",
            maxHeight: "100%",
            maxWidth: "100%"
        }
    }),
    icon: (0,emotion_react_browser_esm/* css */.iv)({
        height: "30px",
        transition: "transform 250ms cubic-bezier(0.25, 1, 0.5, 1)",
        '[aria-expanded="true"] &': {
            transform: "rotate(180deg)"
        }
    })
});
function AccordionItem(props) {
    var ref = (0,react.useState)(0), expandedHeight = ref[0], setExpandedHeight = ref[1];
    var animationRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var calculateExpandedHeight = (0,react.useCallback)(function() {
        if (contentRef.current) {
            setExpandedHeight(contentRef.current.scrollHeight);
        }
    }, []);
    var startOrStopAnimation = (0,react.useCallback)(function() {
        if (animationRef.current) {
            if (props.sectionIsIntersecting && props.isActive) {
                animationRef.current.play();
            } else {
                animationRef.current.stop();
            }
        }
    }, [
        props.sectionIsIntersecting,
        props.isActive
    ]);
    (0,react.useEffect)(function() {
        calculateExpandedHeight();
        window.addEventListener("resize", calculateExpandedHeight);
        return function() {
            return window.removeEventListener("resize", calculateExpandedHeight);
        };
    }, [
        calculateExpandedHeight
    ]);
    (0,react.useEffect)(function() {
        startOrStopAnimation();
    }, [
        startOrStopAnimation
    ]);
    var renderMedia = function() {
        var ref;
        if ((ref = props.animationDataUrl) === null || ref === void 0 ? void 0 : ref.endsWith(".json")) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(LottieAnimation, {
            animationAssetsUrl: props.animationAssetsUrl,
            animationDataUrl: props.animationDataUrl,
            ariaLabel: props.mediaAltText,
            css: AccordionItem_Styles.media,
            loop: props.animationShouldLoop,
            onDOMLoaded: function() {
                calculateExpandedHeight();
                startOrStopAnimation();
            },
            ref: animationRef,
            speed: props.animationSpeed
        });
        if (props.animationDataUrl && props.isActive) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: AccordionItem_Styles.media
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Video, {
            autoPlay: true,
            fullHeight: true,
            hideControls: true,
            loop: props.animationShouldLoop,
            onLoadedData: calculateExpandedHeight,
            title: props.mediaAltText,
            videoUrl: props.animationDataUrl,
            playbackRate: props.animationSpeed
        }));
        if (props.imageUrl) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: AccordionItem_Styles.media
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
            alt: props.mediaAltText || "",
            onLoad: calculateExpandedHeight,
            src: props.imageUrl
        }));
        return null;
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AccordionItem_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
        "aria-controls": "".concat(props.id, "-content"),
        "aria-expanded": props.isActive,
        css: AccordionItem_Styles.button,
        disabled: props.isActive && (0,isBrowser/* isBrowser */.j)() && window.innerWidth >= responsive/* BREAKPOINTS.small */.j$.small,
        id: "".concat(props.id, "-button"),
        onClick: props.onClick
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
        css: AccordionItem_Styles.heading
    }, props.heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AccordionItem_Styles.icon
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        name: "arrowSmallDown"
    }))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        "aria-hidden": !props.isActive,
        "aria-labelledby": "".concat(props.id, "-button"),
        css: AccordionItem_Styles.content,
        id: "".concat(props.id, "-content"),
        ref: contentRef,
        role: "region",
        style: {
            maxHeight: props.isActive ? expandedHeight : 0
        }
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AccordionItem_Styles.body
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
        html: props.body
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: AccordionItem_Styles.mediaContainer(props.mediaBackgroundColor)
    }, renderMedia())));
}

;// CONCATENATED MODULE: ./src/components/sections/SplitColorAccordionSection/SplitColorAccordionSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 














var SplitColorAccordionSection_obj, SplitColorAccordionSection_obj1, SplitColorAccordionSection_obj2;
var SplitColorAccordionSection_Styles = (0,labelStyles/* labelStyles */.B)("SplitColorAccordionSection", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
            position: "relative",
            maxWidth: "2048px",
            margin: "0 auto"
        }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        }));
    },
    contentContainer: (0,emotion_react_browser_esm/* css */.iv)((SplitColorAccordionSection_obj = {
        padding: "60px 20px",
        boxSizing: "border-box",
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100
    }, (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        width: "45%",
        padding: "48px 20px"
    }), (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "96px 0 96px max(calc((min(2048px, 100vw) - 1170px) / 2), 20px)"
    }), (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
        minHeight: "calc(100vh - ".concat(universal_nav_constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5, "px)"),
        display: "flex",
        flexDirection: "column"
    }), SplitColorAccordionSection_obj)),
    content: (0,emotion_react_browser_esm/* css */.iv)((SplitColorAccordionSection_obj1 = {
        height: "100%"
    }, (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "320px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }), (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "370px"
    }), (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj1, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
        flex: 1
    }), SplitColorAccordionSection_obj1)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (SplitColorAccordionSection_obj2 = {
        color: Colors/* Colors.earth */.w.earth,
        marginBottom: "16px",
        flexShrink: 0
    }, (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj2, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        minHeight: "120px",
        marginBottom: "48px"
    }), (0,_define_property/* default */.Z)(SplitColorAccordionSection_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), SplitColorAccordionSection_obj2))),
    accordion: (0,emotion_react_browser_esm/* css */.iv)({
        marginBottom: "24px"
    })
});
function SplitColorAccordionSection(param) {
    var accordionItems = param.accordionItems, backgroundColor = param.backgroundColor, ctaText = param.ctaText, ctaUrl = param.ctaUrl, heading = param.heading;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var rootRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(unsecureID("section-")), sectionId = ref[0];
    var ref1 = (0,react.useState)(0), activeAccordionItem = ref1[0], setActiveAccordionItem = ref1[1];
    var ref2 = (0,react.useState)(false), isIntersecting = ref2[0], setIsIntersecting = ref2[1];
    (0,react.useEffect)(function() {
        var root = rootRef.current;
        if (!root) {
            return undefined;
        }
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            setIsIntersecting(entry.isIntersecting);
        }, {
            threshold: 0.25
        });
        observer.observe(root);
        return function() {
            return observer.unobserve(root);
        };
    }, []);
    /**
   * If all accordion items are closed on a mobile-sized viewport and then the
   * window is resized to a desktop-sized viewport, the first accordion should
   * be opened as a fallback to prevent a weird state where no media is shown.
   * */ (0,react.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth >= responsive/* BREAKPOINTS.small */.j$.small && activeAccordionItem === -1) {
                setActiveAccordionItem(0);
            }
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, [
        activeAccordionItem
    ]);
    var handleAccordionItemClick = function(index) {
        setActiveAccordionItem(index === activeAccordionItem && window.innerWidth < responsive/* BREAKPOINTS.small */.j$.small ? -1 : index);
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorAccordionSection_Styles.root(backgroundColor),
        ref: rootRef
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorAccordionSection_Styles.contentContainer
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorAccordionSection_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHeading, {
        css: SplitColorAccordionSection_Styles.heading,
        html: heading,
        tag: "h2"
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorAccordionSection_Styles.accordion
    }, accordionItems.map(function(item, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionItem, Object.assign({}, item, {
            id: "".concat(sectionId, "-accordion-item-").concat(index),
            isActive: activeAccordionItem === index,
            key: "".concat(sectionId, "-accordion-item-").concat(index),
            mediaBackgroundColor: backgroundColor,
            onClick: function() {
                return handleAccordionItemClick(index);
            },
            sectionIsIntersecting: isIntersecting
        }));
    })), ctaText && ctaUrl && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        href: ctaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: ctaText,
                href: ctaUrl,
                section: events/* SectionName.SplitColorAccordionSection */.jz.SplitColorAccordionSection
            });
        }
    }, ctaText)))));
}

;// CONCATENATED MODULE: ./src/components/sections/SplitColorAccordionSection/fixtures.ts


var SplitColorAccordionSection_fixtures_DEFAULT_VALUES = {
    accordionItems: [
        {
            heading: "Multi-step workflows",
            body: "<p>Create automated workflows that do more than just one thing—up to 100 steps, to be specific!</p>",
            animationDataUrl: "https://assets9.lottiefiles.com/packages/lf20_bigdx6cj.json",
            mediaAltText: "Animation of shapes moving"
        },
        {
            heading: "Conditional logic",
            body: "<p>Add customized if/then logic to your workflows so they work exactly how you would—but automatically.</p>",
            animationDataUrl: "https://assets4.lottiefiles.com/packages/lf20_8ttxp7rk.json",
            mediaAltText: "Animation of shapes moving"
        },
        {
            heading: "Data formatting",
            body: "<p>Transform data from one app into the right format before passing it on to another app. No data science degree required!</p>",
            animationDataUrl: "https://assets2.lottiefiles.com/packages/lf20_gjgicmzg.json",
            mediaAltText: "Animation of shapes moving"
        }, 
    ],
    backgroundColor: colors/* COLOR_KEYS.moss */.US.moss,
    ctaText: "Discover more features",
    ctaUrl: "#",
    heading: 'Start simple, <span style="color: '.concat(Colors/* Colors.zapier */.w.zapier, '">scale to sophistication</span>')
};

;// CONCATENATED MODULE: ./src/components/sections/SplitColorAccordionSection/SplitColorAccordionSection.builder.ts





/* harmony default export */ var SplitColorAccordionSection_builder = (createBuilderModule(withTracking(SplitColorAccordionSection, {
    as: "section",
    sectionName: events/* SectionName.SplitColorAccordionSection */.jz.SplitColorAccordionSection
}), {
    name: "SplitColorAccordionSection",
    image: "https://cdn.zappy.app/4d90d4065a92673542dc544b85272782.png",
    inputs: [
        {
            name: "heading",
            type: "richText",
            required: true,
            defaultValue: SplitColorAccordionSection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "ctaText",
            type: "string",
            required: false,
            defaultValue: SplitColorAccordionSection_fixtures_DEFAULT_VALUES.ctaText
        },
        {
            name: "ctaUrl",
            type: "string",
            required: false,
            defaultValue: SplitColorAccordionSection_fixtures_DEFAULT_VALUES.ctaUrl
        },
        {
            name: "accordionItems",
            type: "list",
            subFields: [
                {
                    name: "heading",
                    type: "string",
                    required: true
                },
                {
                    name: "body",
                    type: "richText",
                    required: true
                },
                {
                    name: "imageUrl",
                    type: "cloudinaryImage",
                    required: false
                },
                {
                    name: "animationDataUrl",
                    friendlyName: "Animation URL",
                    type: "cloudinaryMediaLibrary",
                    helperText: "URL for either a Lottie JSON or an MP4 video",
                    required: false
                },
                {
                    name: "animationAssetsUrl",
                    type: "string",
                    required: false,
                    helperText: "Path to the folder that contains image assets for Lottie animations"
                },
                {
                    name: "animationShouldLoop",
                    type: "boolean",
                    required: false
                },
                {
                    name: "animationSpeed",
                    type: "number"
                },
                {
                    name: "mediaAltText",
                    type: "string",
                    required: true
                }, 
            ],
            defaultValue: SplitColorAccordionSection_fixtures_DEFAULT_VALUES.accordionItems
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.bolt */.US.bolt,
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.peach */.US.peach,
                colors/* COLOR_KEYS.zapier */.US.zapier,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.lavender */.US.lavender,
                colors/* COLOR_KEYS.sky */.US.sky,
                colors/* COLOR_KEYS.earth */.US.earth, 
            ],
            required: true,
            defaultValue: SplitColorAccordionSection_fixtures_DEFAULT_VALUES.backgroundColor
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/SplitColorHero/fixtures.ts

var SplitColorHero_fixtures_DEFAULT_VALUES = {
    animationShouldLoop: false,
    backgroundColor: colors/* COLOR_KEYS.zapier */.US.zapier,
    ctaText: "Get started free",
    ctaUrl: "https://zapier.com/sign-up/",
    secondaryCtaText: "Contact Sales",
    secondaryCtaUrl: "https://zapier.com/contact-sales",
    headingStaticText: "Automate your",
    headingRotatingText: [
        {
            text: "busywork"
        },
        {
            text: "sales outreach"
        },
        {
            text: "side hustle"
        },
        {
            text: "lead flow"
        },
        {
            text: "to-do list"
        },
        {
            text: "team updates"
        },
        {
            text: "social posts"
        },
        {
            text: "copy/paste"
        },
        {
            text: "opportunities"
        },
        {
            text: "contracts"
        },
        {
            text: "data entry"
        },
        {
            text: "possibilities"
        },
        {
            text: "way forward"
        }, 
    ],
    mediaAltText: "Image of happy person",
    imageUrl: "https://cdn.zappy.app/3dd21d692fdcfe9f6de827aff28c162a.png",
    description: "<p>Zapier connects the apps you use for work automatically. When your work is on autopilot you can focus on bigger better things.</p>"
};

;// CONCATENATED MODULE: ./src/components/sections/SplitColorHero/AnimatedHeading.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 






var AnimatedHeading_obj;
var AnimatedHeading_Styles = (0,labelStyles/* labelStyles */.B)("AnimatedHeading", {
    root: (0,emotion_react_browser_esm/* css */.iv)((AnimatedHeading_obj = {
        width: "max-content",
        minWidth: "100%",
        height: "80px",
        position: "relative",
        overflow: "hidden"
    }, (0,_define_property/* default */.Z)(AnimatedHeading_obj, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, {
        height: "96px"
    }), (0,_define_property/* default */.Z)(AnimatedHeading_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        height: "128px"
    }), AnimatedHeading_obj)),
    staticText: (0,emotion_react_browser_esm/* css */.iv)({
        position: "relative",
        zIndex: 1,
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100
    }),
    rotatingText: (0,emotion_react_browser_esm/* css */.iv)({
        position: "absolute",
        top: "100%",
        left: 0,
        whiteSpace: "nowrap",
        color: Colors/* Colors.zapier */.w.zapier,
        animationDuration: "500ms",
        animationTimingFunction: "cubic-bezier(0.65, 0, 0.35, 1)",
        animationFillMode: "forwards",
        "&.animate-in": {
            animationName: (0,emotion_react_browser_esm/* keyframes */.F4)({
                from: {
                    transform: "translateY(0)"
                },
                to: {
                    transform: "translateY(-100%)"
                }
            })
        },
        "&.animate-out": {
            animationName: (0,emotion_react_browser_esm/* keyframes */.F4)({
                from: {
                    transform: "translateY(-100%)"
                },
                to: {
                    transform: "translateY(-200%)"
                }
            })
        }
    })
});
function AnimatedHeading(props) {
    var ref = (0,react.useState)({
        current: 0,
        previous: -1
    }), rotatingTextIndex = ref[0], setRotatingTextIndex = ref[1];
    (0,react.useEffect)(function() {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        var interval = setInterval(function() {
            setRotatingTextIndex(function(param) {
                var current = param.current;
                return {
                    current: current < props.rotatingText.length - 1 ? current + 1 : 0,
                    previous: current
                };
            });
        }, 1500);
        return function() {
            return clearInterval(interval);
        };
    }, [
        props.rotatingText
    ]);
    /*
    Returns the heading text with proper punctuation for more natural readout
    by screen readers
  */ var getAriaLabel = (0,react.useCallback)(function() {
        var list = props.rotatingText.map(function(param, index) {
            var text = param.text;
            return index < props.rotatingText.length - 1 ? text : "and ".concat(text);
        }).join(", ");
        return "".concat(props.staticText, ": ").concat(list, ".");
    }, [
        props.staticText,
        props.rotatingText
    ]);
    var getClassName = function(index) {
        if (index === rotatingTextIndex.current) return "animate-in";
        if (index === rotatingTextIndex.previous) return "animate-out";
        return "";
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h1", {
        "aria-label": getAriaLabel(),
        css: [
            sharedHeadingStyles,
            AnimatedHeading_Styles.root
        ],
        role: "marquee"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
        css: AnimatedHeading_Styles.staticText
    }, props.staticText), props.rotatingText.map(function(param, index) {
        var text = param.text;
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
            className: getClassName(index),
            css: AnimatedHeading_Styles.rotatingText,
            key: "".concat(text, "-").concat(index)
        }, text);
    })));
}

;// CONCATENATED MODULE: ./src/components/GoogleSSOButton/GoogleSSOButton.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var GOOGLE_SSO_URL = "/google-sso/start?scopes=basic";
var GoogleSSOButton_obj;
var GoogleSSOButton_Styles = (0,labelStyles/* labelStyles */.B)("GoogleSSOButton", {
    root: (0,emotion_react_browser_esm/* css */.iv)((GoogleSSOButton_obj = {
        backgroundColor: "rgb(66, 133, 244)",
        border: "none",
        minHeight: "50px",
        borderRadius: "5px"
    }, (0,_define_property/* default */.Z)(GoogleSSOButton_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        height: "70px"
    }), (0,_define_property/* default */.Z)(GoogleSSOButton_obj, "&:hover:not([disabled])", {
        backgroundColor: "rgb(51, 103, 214)",
        boxShadow: "none",
        color: Colors/* Colors.neutral100 */.w.neutral100,
        borderColor: Colors/* Colors.night */.w.night
    }), GoogleSSOButton_obj)),
    link: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (0,_define_property/* default */.Z)({
        height: "100%",
        padding: "0 12px",
        display: "grid",
        gridTemplateColumns: "32px 1fr 32px",
        alignItems: "center",
        gap: "8px",
        fontWeight: 500,
        fontSize: "16px",
        textDecoration: "none",
        textAlign: "center",
        color: Colors/* Colors.neutral100 */.w.neutral100
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3Medium */.ZT.subHeader3Medium), {
        padding: "0 20px"
    })))),
    logo: (0,emotion_react_browser_esm/* css */.iv)({
        height: "32px",
        display: "grid",
        placeItems: "center",
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        borderRadius: "5px"
    })
});
function GoogleLogo() {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
        height: "21",
        preserveAspectRatio: "xMidYMid",
        viewBox: "0 0 256 262",
        width: "21",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, "Google Logo"), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    }));
}
function GoogleSSOButton(param) {
    var _text = param.text, text = _text === void 0 ? "Start free with Google" : _text;
    var emitSignupUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitSignupUserInteractionEvent;
    var handleClick = function() {
        emitSignupUserInteractionEvent({
            absolute_url: GOOGLE_SSO_URL,
            signup_funnel: "signup_intent",
            signup_type: "google_sso"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: GoogleSSOButton_Styles.root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
        href: GOOGLE_SSO_URL,
        onClick: handleClick,
        css: GoogleSSOButton_Styles.link
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
        css: GoogleSSOButton_Styles.logo
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(GoogleLogo, null)), " ", text));
}

;// CONCATENATED MODULE: ./src/components/sections/SplitColorHero/SplitColorHero.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 














var SplitColorHero_obj;
var sharedHeadingStyles = (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (SplitColorHero_obj = {
    color: Colors/* Colors.earth */.w.earth
}, (0,_define_property/* default */.Z)(SplitColorHero_obj, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5)), (0,_define_property/* default */.Z)(SplitColorHero_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader3 */.ZT.pageHeader3)), SplitColorHero_obj)));
var SplitColorHero_obj1, SplitColorHero_obj2, SplitColorHero_obj3, _obj4, _obj5;
var SplitColorHero_Styles = (0,labelStyles/* labelStyles */.B)("SplitColorHero", {
    root: function(isReversedOnMobile) {
        var _obj;
        return [
            (0,emotion_react_browser_esm/* css */.iv)((_obj = {
                display: "flex",
                flexDirection: "column-reverse",
                maxWidth: "2048px",
                margin: "0 auto"
            }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
                display: "grid",
                gridTemplateColumns: "45% 55%"
            }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
                minHeight: "calc(100vh - 72px)"
            }), _obj)),
            isReversedOnMobile && (0,withModifier/* withModifier */.Q)("isReversedOnMobile", (0,emotion_react_browser_esm/* css */.iv)({
                flexDirection: "column"
            })), 
        ];
    },
    contentContainer: (0,emotion_react_browser_esm/* css */.iv)((SplitColorHero_obj1 = {
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        padding: "24px 20px"
    }, (0,_define_property/* default */.Z)(SplitColorHero_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        padding: "48px 20px"
    }), (0,_define_property/* default */.Z)(SplitColorHero_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "96px 0 96px max(calc((min(2048px, 100vw) - 1170px) / 2), 20px);"
    }), SplitColorHero_obj1)),
    content: (0,emotion_react_browser_esm/* css */.iv)((SplitColorHero_obj2 = {
        height: "100%"
    }, (0,_define_property/* default */.Z)(SplitColorHero_obj2, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "320px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }), (0,_define_property/* default */.Z)(SplitColorHero_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "370px"
    }), SplitColorHero_obj2)),
    eyebrow: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (SplitColorHero_obj3 = {
        color: Colors/* Colors.earth */.w.earth,
        fontWeight: 600,
        fontSize: "14px",
        marginBottom: "12px"
    }, (0,_define_property/* default */.Z)(SplitColorHero_obj3, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, {
        fontSize: "16px",
        marginBottom: "16px"
    }), (0,_define_property/* default */.Z)(SplitColorHero_obj3, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        fontSize: "18px",
        marginBottom: "20px"
    }), SplitColorHero_obj3))),
    headingContainer: (0,emotion_react_browser_esm/* css */.iv)((_obj4 = {
        marginBottom: "16px"
    }, (0,_define_property/* default */.Z)(_obj4, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, {
        marginBottom: "40px"
    }), (0,_define_property/* default */.Z)(_obj4, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginBottom: "80px"
    }), _obj4)),
    heading: sharedHeadingStyles,
    headingGraphic: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        display: "block",
        maxWidth: "80%"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "100%"
    })),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3, Typography/* Typography.heading */.ZT.heading), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.neutral800 */.w.neutral800,
        marginBottom: "24px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3)))),
    calloutText: (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1)),
    mediaContainer: function(backgroundColor, hasMediaLink, hasVideo) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            backgroundColor: Colors/* Colors */.w[backgroundColor],
            padding: "24px",
            position: "relative"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: hasMediaLink ? "24px 24px 58px" : "24px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: hasMediaLink ? "80px 80px ".concat(hasVideo ? 80 : 114, "px") : "80px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
            padding: hasMediaLink ? "96px 96px ".concat(hasVideo ? 96 : 130, "px") : "96px"
        }), _obj));
    },
    media: (0,emotion_react_browser_esm/* css */.iv)((_obj5 = {
        width: "100%",
        "& video": (0,_define_property/* default */.Z)({
            paddingBottom: "8px"
        }, responsive/* MEDIA_MAX_WIDTH.small */.Eb.small, {
            height: "auto"
        })
    }, (0,_define_property/* default */.Z)(_obj5, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        height: "100%",
        minHeight: "100%",
        maxHeight: "calc(100vh - 72px - 192px)",
        display: "grid",
        placeItems: "center",
        gridTemplateRows: "minmax(0, 1fr)"
    }), (0,_define_property/* default */.Z)(_obj5, "& > svg, & > img", {
        display: "block",
        maxHeight: "100%",
        maxWidth: "100%"
    }), _obj5)),
    mediaLink: function(hasVideo) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold), (_obj = {
            color: Colors/* Colors.neutral800 */.w.neutral800,
            maxWidth: "75%",
            margin: "0 ".concat(hasVideo ? 0 : "2vw", " 0 0"),
            display: "inline-flex",
            alignItems: "flex-start",
            float: "right",
            textAlign: "right",
            textDecoration: "none"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint3Bold */.ZT.smallPrint3Bold), {
            maxWidth: "none",
            marginRight: hasVideo ? "auto" : "1vw",
            position: "absolute",
            display: "flex",
            alignItems: "center",
            float: "none"
        })), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.medium */.l0.medium, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold)), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold)), (0,_define_property/* default */.Z)(_obj, "& > svg", (0,_define_property/* default */.Z)({
            width: "10px",
            height: "10px",
            marginTop: "2px",
            marginLeft: "8px",
            flexShrink: 0
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            width: "14px",
            height: "14px",
            marginTop: 0
        })), _obj)));
    },
    ctaContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: "grid",
        gap: "24px"
    })
});
function SplitColorHero_Heading(props) {
    var ref;
    if (props.headingRotatingText && props.headingRotatingText.length > 0 && props.headingStaticText) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(AnimatedHeading, {
            rotatingText: props.headingRotatingText,
            staticText: props.headingStaticText
        });
    }
    if (((ref = props.headingGraphic) === null || ref === void 0 ? void 0 : ref.url) && props.headingGraphic.hiddenText) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(VisuallyHidden/* VisuallyHidden */.T, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h1", null, props.headingGraphic.hiddenText)), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
            css: SplitColorHero_Styles.headingGraphic,
            src: props.headingGraphic.url,
            alt: props.headingGraphic.hiddenText,
            role: "presentation"
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h1", {
        css: SplitColorHero_Styles.heading
    }, props.headingStaticText);
}
function SplitColorHero(props) {
    var ref;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var mediaContainerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)({
        right: 0,
        bottom: 0,
        visibility: "hidden"
    }), mediaLinkStyles = ref1[0], setMediaLinkStyles = ref1[1];
    var hasVideo = !!props.animationDataUrl && !((ref = props.animationDataUrl) === null || ref === void 0 ? void 0 : ref.endsWith(".json"));
    var calculateMediaLinkStyles = (0,react.useCallback)(function() {
        if (!props.mediaLinkText || !props.mediaLinkUrl || !mediaContainerRef.current) {
            return;
        }
        if (window.innerWidth < responsive/* BREAKPOINTS.small */.j$.small) {
            setMediaLinkStyles({
                right: 0,
                bottom: 0,
                visibility: "visible"
            });
            return;
        }
        var mediaElement = mediaContainerRef.current.querySelector("img") || mediaContainerRef.current.querySelector(".lottie-animation > svg") || mediaContainerRef.current.querySelector("video");
        if (!mediaElement) {
            return;
        }
        var ref = mediaElement.getBoundingClientRect(), mediaWidth = ref.width, mediaElementBottom = ref.bottom;
        var ref1 = mediaContainerRef.current.getBoundingClientRect(), mediaContainerWidth = ref1.width, mediaContainerBottom = ref1.bottom;
        var mediaContainerPaddingBottom = mediaContainerBottom - mediaElementBottom;
        setMediaLinkStyles({
            right: (mediaContainerWidth - mediaWidth) / 2,
            bottom: mediaContainerPaddingBottom - 20,
            visibility: "visible"
        });
    }, [
        props.mediaLinkText,
        props.mediaLinkUrl
    ]);
    (0,react.useEffect)(function() {
        calculateMediaLinkStyles();
        window.addEventListener("resize", calculateMediaLinkStyles);
        return function() {
            window.removeEventListener("resize", calculateMediaLinkStyles);
        };
    }, [
        calculateMediaLinkStyles
    ]);
    var renderMedia = function() {
        var ref;
        if ((ref = props.animationDataUrl) === null || ref === void 0 ? void 0 : ref.endsWith(".json")) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(LottieAnimation, {
            animationAssetsUrl: props.animationAssetsUrl,
            animationDataUrl: props.animationDataUrl,
            ariaLabel: props.mediaAltText,
            autoplay: true,
            className: "lottie-animation",
            css: SplitColorHero_Styles.media,
            loop: props.animationShouldLoop,
            onDOMLoaded: calculateMediaLinkStyles,
            speed: props.animationSpeed
        });
        if (props.animationDataUrl) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: SplitColorHero_Styles.media
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Video, {
            autoPlay: true,
            fullHeight: false,
            hideControls: true,
            loop: props.animationShouldLoop,
            onPlay: calculateMediaLinkStyles,
            playbackRate: props.animationSpeed,
            title: props.mediaAltText,
            videoUrl: props.animationDataUrl
        }));
        if (props.imageUrl) return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: SplitColorHero_Styles.media
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
            alt: props.mediaAltText,
            onLoad: calculateMediaLinkStyles,
            src: props.imageUrl
        }));
        return null;
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
        css: SplitColorHero_Styles.root(props.isReversedOnMobile)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.contentContainer
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.headingContainer
    }, props.eyebrow && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.eyebrow
    }, props.eyebrow), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(SplitColorHero_Heading, {
        headingGraphic: props.headingGraphic,
        headingRotatingText: props.headingRotatingText,
        headingStaticText: props.headingStaticText
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
        html: props.description
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.ctaContainer
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        href: props.ctaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: props.ctaText,
                href: props.ctaUrl,
                section: events/* SectionName.SplitColorHero */.jz.SplitColorHero
            });
        }
    }, props.ctaText), props.hasGoogleSSO && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(GoogleSSOButton, {
        text: props.googleSSOText
    })), props.secondaryCtaText && props.secondaryCtaUrl && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        color: "outline",
        href: props.secondaryCtaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: props.secondaryCtaText,
                href: props.secondaryCtaUrl,
                section: events/* SectionName.SplitColorHero */.jz.SplitColorHero,
                type: avro/* CTAType.secondary_cta_button */.g8.secondary_cta_button
            });
        }
    }, props.secondaryCtaText), props.calloutText && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.calloutText
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
        html: props.calloutText
    })))))), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: SplitColorHero_Styles.mediaContainer(props.backgroundColor, props.mediaLinkText && props.mediaLinkUrl, hasVideo),
        ref: mediaContainerRef
    }, renderMedia(), props.mediaLinkText && props.mediaLinkUrl && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
        css: SplitColorHero_Styles.mediaLink(hasVideo),
        href: props.mediaLinkUrl,
        style: mediaLinkStyles
    }, props.mediaLinkText, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
        fill: "currentColor",
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
        d: "M10.586 2H1V0h13v13h-2V3.414L1.707 13.707.293 12.293 10.586 2Z"
    })))));
}

;// CONCATENATED MODULE: ./src/components/sections/SplitColorHero/SplitColorHero.builder.tsx





/* harmony default export */ var SplitColorHero_builder = (createBuilderModule(withTracking(SplitColorHero, {
    sectionName: events/* SectionName.SplitColorHero */.jz.SplitColorHero
}), {
    name: "SplitColorHero",
    image: "https://cdn.zappy.app/46111e0323ae9f5a6c5d40dccca0116e.png",
    inputs: [
        {
            name: "eyebrow",
            type: "string"
        },
        {
            name: "headingStaticText",
            type: "string",
            helperText: "Text to be used as a basic heading or the static text to be paired with rotating text",
            showIf: function(options) {
                var ref, ref1;
                return !((ref = options.get("headingGraphic")) === null || ref === void 0 ? void 0 : ref.get("url")) && !((ref1 = options.get("headingGraphic")) === null || ref1 === void 0 ? void 0 : ref1.get("hiddenText"));
            }
        },
        {
            name: "headingRotatingText",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "string",
                    required: true
                }
            ],
            helperText: "Text to be used in the rotating text animation",
            showIf: function(options) {
                var ref, ref1;
                return !!options.get("headingStaticText") && !((ref = options.get("headingGraphic")) === null || ref === void 0 ? void 0 : ref.get("url")) && !((ref1 = options.get("headingGraphic")) === null || ref1 === void 0 ? void 0 : ref1.get("hiddenText"));
            }
        },
        {
            name: "headingGraphic",
            type: "object",
            subFields: [
                {
                    name: "url",
                    type: "cloudinaryImage",
                    required: true
                },
                {
                    name: "hiddenText",
                    type: "string",
                    required: true,
                    helperText: "Visually hidden text used of screen readers and SEO"
                }, 
            ],
            helperText: "Graphic to be used in place of heading text",
            showIf: function(options) {
                var ref;
                return !options.get("headingStaticText") && !((ref = options.get("headingRotatingText")) === null || ref === void 0 ? void 0 : ref.length);
            }
        },
        {
            name: "description",
            type: "richText",
            required: true,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.description
        },
        {
            name: "ctaText",
            type: "string",
            required: true,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.ctaText
        },
        {
            name: "ctaUrl",
            type: "string",
            required: true,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.ctaUrl
        },
        {
            name: "hasGoogleSSO",
            type: "boolean"
        },
        {
            name: "googleSSOText",
            type: "string",
            showIf: function(options) {
                return options.get("hasGoogleSSO");
            }
        },
        {
            name: "secondaryCtaText",
            type: "string",
            required: false,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.secondaryCtaText
        },
        {
            name: "secondaryCtaUrl",
            type: "string",
            required: false,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.secondaryCtaUrl
        },
        {
            name: "calloutText",
            type: "richText",
            required: false
        },
        {
            name: "animationDataUrl",
            friendlyName: "Animation URL",
            type: "cloudinaryMediaLibrary",
            helperText: "URL for either a Lottie JSON or an MP4 video",
            required: false
        },
        {
            name: "animationAssetsUrl",
            type: "string",
            showIf: function(options) {
                return !!options.get("animationDataUrl") && options.get("animationDataUrl").toLowerCase().endsWith(".json");
            },
            helperText: "Path to the folder that contains image assets for Lottie animations"
        },
        {
            name: "animationShouldLoop",
            type: "boolean",
            required: true,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.animationShouldLoop,
            showIf: function(options) {
                return !!options.get("animationDataUrl");
            }
        },
        {
            name: "animationSpeed",
            type: "number",
            showIf: function(options) {
                return !!options.get("animationDataUrl");
            }
        },
        {
            name: "imageUrl",
            type: "cloudinaryImage",
            showIf: function(options) {
                return !options.get("animationDataUrl");
            }
        },
        {
            name: "mediaAltText",
            type: "string",
            required: true
        },
        {
            name: "mediaLinkText",
            type: "string"
        },
        {
            name: "mediaLinkUrl",
            type: "string"
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier,
                colors/* COLOR_KEYS.earth */.US.earth, 
            ],
            required: true,
            defaultValue: SplitColorHero_fixtures_DEFAULT_VALUES.backgroundColor
        },
        {
            name: "isReversedOnMobile",
            friendlyName: "Reverse sections on mobile",
            type: "boolean"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/TableSection/TableSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 







var TableSection_obj, TableSection_obj1;
var styles = (0,labelStyles/* labelStyles */.B)("Table", {
    root: function() {
        var sectionSpacing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "40px";
        return (0,emotion_react_browser_esm/* css */.iv)({
            margin: "".concat(sectionSpacing, " 0")
        });
    },
    title: function() {
        var titleSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "medium", titleAlignment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "center";
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[titleSize].mobile]), (_obj = {
            maxWidth: "1170px",
            margin: "0 auto 1em",
            padding: "0 20px",
            textAlign: titleAlignment,
            color: Colors/* Colors.neutral800 */.w.neutral800
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[titleSize].tablet])), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography */.ZT[responsive/* HEADING_SIZE_MAP */.Ry[titleSize].desktop])), _obj)));
    },
    tableContainer: (0,emotion_react_browser_esm/* css */.iv)({
        overflowX: "auto",
        padding: "0 20px"
    }),
    table: function() {
        var scrollableOnMobile = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return [
            (0,emotion_react_browser_esm/* css */.iv)({
                width: "100%",
                maxWidth: "1170px",
                margin: "0 auto",
                borderCollapse: "collapse"
            }),
            scrollableOnMobile && (0,withModifier/* withModifier */.Q)("scrollable-on-mobile", (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
                width: "200%"
            }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
                width: "100%"
            }))), 
        ];
    },
    cell: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), (TableSection_obj = {
        minWidth: "80px",
        padding: "8px",
        boxSizing: "border-box",
        border: "1px solid ".concat(Colors/* Colors.neutral400 */.w.neutral400),
        verticalAlign: "middle",
        textAlign: "left",
        color: Colors/* Colors.neutral800 */.w.neutral800
    }, (0,_define_property/* default */.Z)(TableSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3 */.ZT.paragraph3), {
        padding: "12px"
    })), (0,_define_property/* default */.Z)(TableSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), {
        padding: "16px"
    })), TableSection_obj))),
    header: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold), (TableSection_obj1 = {
        backgroundColor: Colors/* Colors.neutral200 */.w.neutral200
    }, (0,_define_property/* default */.Z)(TableSection_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold)), (0,_define_property/* default */.Z)(TableSection_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1ShortSemibold */.ZT.paragraph1ShortSemibold)), TableSection_obj1)))
});
function TableSection(props) {
    var Title = props.titleElement || "h2";
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: styles.root(props.sectionSpacing)
    }, props.title && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Title, {
        css: styles.title(props.titleSize, props.titleAlignment)
    }, props.title), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: styles.tableContainer
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("table", {
        css: styles.table(props.scrollableOnMobile)
    }, props.headers && props.headers.length > 0 && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("thead", null, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("tr", null, props.headers.map(function(header, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("th", {
            css: [
                styles.cell,
                styles.header
            ],
            key: index
        }, header.text);
    }))), props.rows && props.rows.length > 0 && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("tbody", null, props.rows.map(function(row, rowIndex) {
        var ref;
        /*#__PURE__*/ return (0,emotion_react_browser_esm/* jsx */.tZ)("tr", {
            css: styles.row,
            key: rowIndex
        }, (ref = row.cells) === null || ref === void 0 ? void 0 : ref.map(function(cell, cellIndex) {
            return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("td", {
                colSpan: cell.columnSpan,
                css: styles.cell,
                key: cellIndex,
                rowSpan: cell.rowSpan
            }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
                html: cell.text
            }));
        }));
    })))));
}

;// CONCATENATED MODULE: ./src/components/sections/TableSection/fixtures.ts
var TableSection_fixtures_DEFAULT_VALUES = {
    title: "Example Table",
    headers: [
        {
            text: "Header 1"
        },
        {
            text: "Header 2"
        }
    ],
    rows: [
        {
            cells: [
                {
                    text: "<p>Row 1, cell 1</p>"
                },
                {
                    text: "<p>Row 1, cell 2</p>"
                }, 
            ]
        },
        {
            cells: [
                {
                    text: "<p>Row 2, cell 1</p>"
                },
                {
                    text: "<p>Row 2, cell 2</p>"
                }, 
            ]
        }, 
    ],
    sectionSpacing: "40px",
    titleElement: "h2",
    titleSize: "medium",
    titleAlignment: "center",
    scrollableOnMobile: false
};

;// CONCATENATED MODULE: ./src/components/sections/TableSection/TableSection.builder.tsx





/* harmony default export */ var TableSection_builder = (createBuilderModule(withTracking(TableSection, {
    as: "section",
    sectionName: events/* SectionName.TableSection */.jz.TableSection
}), {
    name: "TableSection",
    image: "https://cdn.zappy.app/05373ef2b4f09243f922a398b0fdc981.png",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "headers",
            type: "list",
            subFields: [
                {
                    name: "text",
                    type: "string"
                }
            ],
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.headers
        },
        {
            name: "rows",
            type: "list",
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.rows,
            subFields: [
                {
                    name: "cells",
                    type: "list",
                    subFields: [
                        {
                            name: "text",
                            type: "richText"
                        },
                        {
                            name: "rowSpan",
                            type: "number"
                        },
                        {
                            name: "columnSpan",
                            type: "number"
                        }, 
                    ]
                }, 
            ]
        },
        {
            name: "sectionSpacing",
            type: "string",
            enum: [
                "0",
                "20px",
                "40px",
                "60px",
                "80px"
            ],
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.sectionSpacing
        },
        {
            name: "titleTag",
            type: "string",
            enum: [
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6"
            ],
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.titleElement
        },
        {
            name: "titleSize",
            type: "string",
            enum: [
                "small",
                "medium",
                "large"
            ],
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.titleSize
        },
        {
            name: "titleAlignment",
            type: "string",
            enum: [
                "center",
                "left"
            ],
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.titleAlignment
        },
        {
            name: "scrollableOnMobile",
            type: "boolean",
            defaultValue: TableSection_fixtures_DEFAULT_VALUES.scrollableOnMobile,
            helperText: "Whether the table should be horizontally scrollable on mobile or " + "should be constrained to the width of the screen"
        }, 
    ]
}));

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/FloatingBox/FloatingBox.js
var FloatingBox = __webpack_require__(15504);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Tabs/TabsDropdown.js







const TabsDropdown_Styles = (0,labelStyles/* labelStyles */.B)('TabsDropdown', {
    root: emotion_react_browser_esm/* css */.iv `
    position: relative;
  `,
    summary: emotion_react_browser_esm/* css */.iv `
    // Hides default icon on details element
    &::-webkit-details-marker {
      display: none;
    }

    &::before {
      display: none;
    }
  `,
    menu: emotion_react_browser_esm/* css */.iv `
    padding: 10px;
    min-width: 250px;
  `,
});
const TabsDropdown = (props) => {
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const menuItems = props.items.map((item) => ((0,isolateComponent/* isolateComponent */.U)(MenuItem, { disabled: item.disabled, href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
            setIsOpen(false);
            props.onChooseItem(item, event);
        } }, item.text)));
    const [setClickOutsideNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: () => {
            setIsOpen(false);
        },
    });
    const containerHandlers = {
        onKeyUp: (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        },
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", Object.assign({ ref: setClickOutsideNode }, containerHandlers),
        (0,isolateComponent/* isolateComponent */.U)(IconButton, { color: "icon-primary", icon: "navMoreHoriz", label: "More items\u2026", ariaExpanded: isOpen, onClick: () => setIsOpen(!isOpen), size: {
                medium: 'xsmall',
                large: 'small',
            }[props.size], tooltipPosition: "west" }),
        isOpen && ((0,isolateComponent/* isolateComponent */.U)(FloatingBox/* FloatingBox */.f, { align: "right" },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TabsDropdown_Styles.menu },
                (0,isolateComponent/* isolateComponent */.U)(Menu, { ariaLabel: "" }, menuItems))))));
};
//# sourceMappingURL=TabsDropdown.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Tabs/Tabs.js






const indicatorTrackHeight = 3;
const Tabs_Styles = (0,labelStyles/* labelStyles */.B)('Tabs', {
    root: (props) => [
        emotion_react_browser_esm/* css */.iv `
      ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold}
      position: relative;
      display: grid;
      grid-template-columns: 1fr auto;
      column-gap: 20px;
      row-gap: 2px;
      align-items: center;
    `,
        props.size === 'medium' &&
            (0,withModifier/* withModifier */.Q)('medium', emotion_react_browser_esm/* css */.iv `
          height: 50px;
        `),
        props.size === 'large' &&
            (0,withModifier/* withModifier */.Q)('large', emotion_react_browser_esm/* css */.iv `
          height: 70px;
        `),
    ],
    primary: ({ count }) => [
        emotion_react_browser_esm/* css */.iv `
      display: grid;
      height: 100%;
      // Allow shrinking
      min-width: 0;
      max-width: 100%;
    `,
        (0,withModifier/* withModifier */.Q)(`count-${count}`, emotion_react_browser_esm/* css */.iv `
        grid-template-columns: repeat(${count}, minmax(auto, min-content));
      `),
    ],
    item: ({ isSelected }) => [
        emotion_react_browser_esm/* css */.iv `
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
      font-weight: 600;
      text-decoration: none;
      padding: 0 20px;

      &:not([disabled]):hover,
      &:not([disabled]):focus {
        color: ${Colors/* Colors.blue */.w.blue};
        outline: none;
      }

      &[disabled] {
        color: ${Colors/* Colors.neutral500 */.w.neutral500};
        cursor: not-allowed;
      }
    `,
        isSelected &&
            (0,withModifier/* withModifier */.Q)('selected', emotion_react_browser_esm/* css */.iv `
          color: ${Colors/* Colors.blue */.w.blue};
        `),
    ],
    itemText: emotion_react_browser_esm/* css */.iv `
    display: block;
    white-space: nowrap;
  `,
    indicatorTrack: (props) => [
        emotion_react_browser_esm/* css */.iv `
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      // This ends up being a non-integer, but it actually renders better
      // in Chrome (and still renders fine in other browsers) this way.
      border-radius: ${indicatorTrackHeight / 2}px;
      height: ${indicatorTrackHeight}px;
      overflow: hidden;
    `,
        props.shouldRenderTrack &&
            (0,withModifier/* withModifier */.Q)('visible', emotion_react_browser_esm/* css */.iv `
          background-color: ${Colors/* Colors.neutral300 */.w.neutral300};
        `),
    ],
    indicator: emotion_react_browser_esm/* css */.iv `
    position: absolute;
    height: inherit;
    border-radius: inherit;
    background-color: ${Colors/* Colors.blue */.w.blue};
    transition: all 250ms ease-in-out;
  `,
});
const TabsItem = (props) => {
    if (props.disabled) {
        return ((0,isolateComponent/* isolateComponent */.U)("button", { type: "button", "aria-label": props.ariaLabel, css: Tabs_Styles.item(props), disabled: true },
            (0,isolateComponent/* isolateComponent */.U)("span", { css: Tabs_Styles.itemText }, props.text)));
    }
    return ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { ariaLabel: props.ariaLabel, ariaCurrent: props.isSelected ? props.ariaCurrent : undefined, color: null, css: Tabs_Styles.item(props), href: props.href, onClick: props.onChoose, ref: props.forwardedRef },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: Tabs_Styles.itemText }, props.text)));
};
const Tabs = (originalProps) => {
    const props = Object.assign(Object.assign({}, originalProps), { size: originalProps.size || 'large' });
    const selectedItemRef = (0,react.useRef)(null);
    const [indicatorStyles, setIndicatorStyles] = (0,react.useState)({});
    const shouldRenderIndicator = !props.items.every((i) => i.isExtra);
    const primaryItems = props.items.filter((item) => !item.isExtra);
    const primaryLinks = primaryItems.map((item) => {
        const isSelected = props.isItemSelected(item, props.selectedItemHref);
        return ((0,isolateComponent/* isolateComponent */.U)(TabsItem, Object.assign({}, item, { ariaCurrent: props.ariaCurrent, forwardedRef: isSelected && shouldRenderIndicator ? selectedItemRef : null, isSelected: isSelected, key: item.href, onChoose: (event) => props.onChooseItem(item, event) })));
    });
    const secondaryItems = props.items.filter((item) => item.isExtra);
    const isSecondaryItemSelected = secondaryItems.some((item) => {
        return props.isItemSelected(item, props.selectedItemHref);
    });
    const secondaryMenu = secondaryItems.length > 0 && ((0,isolateComponent/* isolateComponent */.U)("div", { ref: isSecondaryItemSelected && shouldRenderIndicator
            ? selectedItemRef
            : null },
        (0,isolateComponent/* isolateComponent */.U)(TabsDropdown, { size: props.size, items: secondaryItems, onChooseItem: props.onChooseItem, selectedItemHref: props.selectedItemHref })));
    (0,react.useEffect)(() => {
        const requestId = requestAnimationFrame(() => {
            setIndicatorStyles(selectedItemRef.current
                ? {
                    left: selectedItemRef.current.offsetLeft,
                    width: selectedItemRef.current.offsetWidth,
                }
                : {});
        });
        return () => cancelAnimationFrame(requestId);
    }, [props.items, props.selectedItemHref]);
    return ((0,isolateComponent/* isolateComponent */.U)("nav", { "aria-label": props.ariaLabel, css: Tabs_Styles.root(props) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: Tabs_Styles.primary({ count: primaryLinks.length }), ref: props.forwardedRef }, primaryLinks),
        secondaryMenu,
        (0,isolateComponent/* isolateComponent */.U)("div", { css: Tabs_Styles.indicatorTrack(props) },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: Tabs_Styles.indicator, style: indicatorStyles }))));
};
Tabs.defaultProps = {
    ariaCurrent: 'page',
    isItemSelected: (item, selectedItemHref) => item.href === selectedItemHref,
    onChooseItem: () => { },
    shouldRenderTrack: true,
};
//# sourceMappingURL=Tabs.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/TabsSection/TabsSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 













var TabsSection_obj;
var TabsSection_Styles = (0,labelStyles/* labelStyles */.B)("TabsSection", {
    navContent: (0,emotion_react_browser_esm/* css */.iv)({
        overflowX: "auto"
    }),
    tabContent: (0,emotion_react_browser_esm/* css */.iv)((TabsSection_obj = {
        overflowX: "auto",
        paddingTop: "30px"
    }, (0,_define_property/* default */.Z)(TabsSection_obj, responsive/* mediaQueries.tablet */.w5.tablet, {
        paddingTop: "45px"
    }), (0,_define_property/* default */.Z)(TabsSection_obj, responsive/* mediaQueries.desktop */.w5.desktop, {
        paddingTop: "55px"
    }), TabsSection_obj))
});
function TabsSection(props) {
    var ref;
    var root = (0,react.useRef)(null);
    var ref1 = props.tabs.reduce(function(result, tab, index) {
        var id = tab.id || tab.heading.toLowerCase().replace(/\s/g, "-");
        var href = "#".concat(id);
        return {
            navItems: (0,_to_consumable_array/* default */.Z)(result.navItems).concat([
                {
                    href: href,
                    text: tab.heading
                }
            ]),
            content: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result.content), (0,_define_property/* default */.Z)({}, href, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(builder_react_es5/* BuilderBlocks */.Wp, {
                blocks: tab.content,
                dataPath: "component.options.tabs.".concat(index, ".content"),
                parentElementId: props.builderBlock.id
            })))
        };
    }, {
        navItems: [],
        content: {}
    }), navItems = ref1.navItems, content = ref1.content;
    var ref2 = (0,react.useState)((0,isBrowser/* isBrowser */.j)() && window.location.hash && Object.prototype.hasOwnProperty.call(content, window.location.hash) ? window.location.hash : navItems[0].href), selectedTabHref = ref2[0], setSelectedTabHref = ref2[1];
    (0,react.useLayoutEffect)(function() {
        if (window.location.hash && Object.prototype.hasOwnProperty.call(content, window.location.hash) && root.current) {
            root.current.scrollIntoView();
        }
    }, [
        content
    ]);
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var handleTabChange = function(tab, event) {
        event.preventDefault();
        setSelectedTabHref(tab.href);
        if (props.changeUrlOnTabChange) {
            window.location.hash = tab.href;
        }
        emitUserInteractionEvent({
            event_action: avro/* EventAction.click */.AO.click,
            interaction_name: avro/* InteractionName.tab_change */.AI.tab_change,
            interaction_raw_text: innerText(tab.text),
            option_selected: innerText(tab.text),
            custom_tracking_fields: {
                section_name: events/* SectionName.TabsSection */.jz.TabsSection
            }
        });
        trackEvent(events/* EventName.CALL_TO_ACTION */.B_.CALL_TO_ACTION, {
            path: window.location.pathname,
            from_path: document.referrer,
            cta_name: events/* CtaName.tabSelection */.XE.tabSelection,
            cta_raw_text: tab.text,
            cta_goal: events/* CtaGoal.getMoreInformation */.LK.getMoreInformation
        });
    };
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        ref: root
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Section, {
        heading: props.heading,
        layerName: (ref = props.builderBlock) === null || ref === void 0 ? void 0 : ref.layerName,
        sectionToTrack: events/* SectionName.TabsSection */.jz.TabsSection,
        subheading: props.subheading
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TabsSection_Styles.navContent
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Tabs, {
        items: navItems,
        onChooseItem: handleTabChange,
        selectedItemHref: selectedTabHref
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TabsSection_Styles.tabContent
    }, content[selectedTabHref])));
}

;// CONCATENATED MODULE: ./src/components/sections/TabsSection/TabsSection.builder.ts



/* harmony default export */ var TabsSection_builder = (createBuilderModule(TabsSection, {
    name: "TabsSection",
    image: "https://cdn.zappy.app/4f358d25a3f6a8c4560b262b80b3dd63.png",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Section Heading"
        },
        {
            name: "subheading",
            type: "string",
            defaultValue: "Section Subheading"
        },
        /**
     * Related forum thread implementing Tabs https://forum.builder.io/t/react-custom-component-containing-editable-subcomponents/25
     */ {
            name: "tabs",
            /**
       * @see Input.broadcast
       * Without / With: https://cdn.zappy.app/4f79ffebd8463d62e5aa82152fd5c8b5.png
       */ broadcast: true,
            type: "list",
            subFields: [
                {
                    name: "heading",
                    type: "string",
                    defaultValue: "Tab Heading"
                },
                {
                    name: "id",
                    type: "string"
                },
                {
                    name: "content",
                    type: "uiBlocks",
                    hideFromUI: true,
                    defaultValue: [
                        blockElement({
                            heading: "Default New Tab",
                            mediaSrc: "https://cdn.zappy.app/6db2607df31caecba4c910998dba31af.png"
                        }), 
                    ]
                }, 
            ],
            defaultValue: [
                {
                    heading: "Tab Heading 01",
                    content: []
                },
                {
                    heading: "Tab Heading 02",
                    content: []
                }, 
            ]
        },
        {
            name: "changeUrlOnTabChange",
            type: "boolean"
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/TestimonialSolo/TestimonialMapping.js
const remapDeprecatedColors = (color) => {
    const mapping = {
        lava10: 'cream',
        ocean10: 'acidWash',
        sun10: 'neutral200',
        white: 'neutral100',
    };
    return mapping[color] || color;
};
const TestimonialMapping_breakpoints = {
    tablet: 768,
    desktop: 1230,
};
//# sourceMappingURL=TestimonialMapping.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/TestimonialCarousel/TestimonialCarousel.js






const TestimonialCarousel_Styles = (0,labelStyles/* labelStyles */.B)('testimonialCarousel', {
    testimonialCarouselContainer: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${Colors/* Colors */.w[remapDeprecatedColors(backgroundColor)]};
    padding: 20px;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      padding: 40px 30px;
    }
  `,
    testimonialContainerWrapper: emotion_react_browser_esm/* css */.iv `
    width: 100%;
    display: flex;
    overflow-x: auto;
    gap: 40px;
    // Fits inside our 1230px max grid, plus about 100px of padding on each side of the carousel
    // so that it is centered and not quite as wide as a Hero, for example
    max-width: 1030px;
    &::-webkit-scrollbar {
      /* Hide scrollbar for Chrome, Safari and Opera */
      display: none;
    }
    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      gap: 60px;
    }
  `,
    testimonialContainer: emotion_react_browser_esm/* css */.iv `
    min-width: 100%;
    display: grid;
    align-items: flex-start;
    grid-template-columns: repeat(1,1fr);
    gap: 30px 0;
    margin-bottom: 30px;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      grid-template-columns: repeat(2,1fr);
      gap: 0 30px;
    }
    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      margin-bottom: 40px;
      gap: 0 100px;
    }
  }
  `,
    testimonial: emotion_react_browser_esm/* css */.iv `
    text-align: left;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      max-width: 339px;
    }
    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      max-width: 400px;
    }
  `,
    avatarContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 20px;
  `,
    quote: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin-bottom: 20px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.subHeader1 */.ZT.subHeader1}
    }
  `,
    author: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
  `,
});
const TestimonialCarousel = (props) => {
    const [activeTestimonialIndex, setActiveTestimonialIndex] = (0,react.useState)(0);
    const testimonialContainerRef = (0,react.useRef)(null);
    const [testimonialContainerWidth, setTestimonialContainerWidth] = (0,react.useState)(0);
    (0,react.useEffect)(() => {
        var _a;
        setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
    }, []);
    (0,react.useLayoutEffect)(() => {
        const onResize = debounce(() => {
            var _a;
            setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
        }, 100);
        window.addEventListener('resize', onResize, { capture: true });
        return () => {
            window.removeEventListener('resize', onResize, { capture: true });
        };
    });
    const paginator = ((0,isolateComponent/* isolateComponent */.U)(Paginator, { currentPageIndex: activeTestimonialIndex, onPaginate: ({ pageIndex: index }) => setActiveTestimonialIndex(index), pageUrls: Array.from({ length: props.testimonials.length }) }));
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialCarousel_Styles.testimonialCarouselContainer(props.backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialCarousel_Styles.testimonialContainerWrapper, ref: testimonialContainerRef }, testimonialContainerWidth && ((0,isolateComponent/* isolateComponent */.U)(ScrollSnap, { gap: 60, itemWidth: testimonialContainerWidth, onScroll: (index) => {
                setActiveTestimonialIndex(index);
            }, pageIndex: activeTestimonialIndex, scrollSnapAlign: "center" }, props.testimonials.map((testimonial, i) => ((0,isolateComponent/* isolateComponent */.U)("div", { key: i, css: TestimonialCarousel_Styles.testimonialContainer },
            (0,isolateComponent/* isolateComponent */.U)("div", null, testimonial.mediaElement),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialCarousel_Styles.testimonial },
                testimonial.hasAuthorAvatar && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialCarousel_Styles.avatarContainer },
                    (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: 40 }))),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialCarousel_Styles.quote }, testimonial.quote),
                (0,isolateComponent/* isolateComponent */.U)("p", { css: TestimonialCarousel_Styles.author },
                    testimonial.author,
                    ", ",
                    testimonial.company)))))))),
        paginator));
};
//# sourceMappingURL=TestimonialCarousel.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/TestimonialCarousel/fixtures.ts

var TestimonialCarousel_fixtures_DEFAULT_VALUES = {
    testimonials: new Array(3).fill({
        quote: "This is a default quote (Edit me)",
        author: "Name Surname",
        company: "Zapier",
        hasAuthorAvatar: true,
        avatarUrl: "https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png",
        mediaURL: "https://cdn.zappy.app/255f5477d911b5b66c44f8e1727df828.png"
    }),
    backgroundColor: colors/* COLOR_KEYS.cream */.US.cream
};

;// CONCATENATED MODULE: ./src/components/sections/TestimonialCarousel/TestimonialCarousel.tsx







function TestimonialCarousel_TestimonialCarousel(param) {
    var backgroundColor = param.backgroundColor, _testimonials = param.testimonials, testimonials = _testimonials === void 0 ? [] : _testimonials;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {
        backgroundColor: backgroundColor || TestimonialCarousel_fixtures_DEFAULT_VALUES.backgroundColor,
        testimonials: testimonials.map(function(testimonial) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testimonial), {
                quote: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
                    backgroundColor: backgroundColor,
                    html: testimonial.quote
                }),
                mediaElement: testimonial.mediaURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                    src: testimonial.mediaURL || "",
                    alt: testimonial.mediaAltText || ""
                }) || ((ref = testimonial.video) === null || ref === void 0 ? void 0 : ref.videoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, (0,src_object_spread/* default */.Z)({}, testimonial.video))
            });
        })
    });
}

;// CONCATENATED MODULE: ./src/components/sections/TestimonialCarousel/TestimonialCarousel.builder.ts







/* harmony default export */ var TestimonialCarousel_builder = (createBuilderModule(withTracking(TestimonialCarousel_TestimonialCarousel, {
    as: "section",
    sectionName: events/* SectionName.TestimonialCarousel */.jz.TestimonialCarousel
}), {
    name: "TestimonialCarousel",
    image: "https://pic.onlinewebfonts.com/svg/img_550787.png",
    inputs: [
        {
            name: "testimonials",
            type: "list",
            required: true,
            defaultValue: TestimonialCarousel_fixtures_DEFAULT_VALUES.testimonials,
            subFields: [
                {
                    name: "quote",
                    type: "richText",
                    required: true
                },
                {
                    name: "author",
                    type: "string",
                    required: true
                },
                {
                    name: "company",
                    type: "string",
                    required: true
                },
                {
                    name: "hasAuthorAvatar",
                    type: "boolean"
                },
                {
                    name: "avatarUrl",
                    type: "cloudinaryImage"
                },
                {
                    name: "mediaURL",
                    type: "cloudinaryImage"
                },
                {
                    name: "mediaAltText",
                    type: "string"
                },
                {
                    name: "video",
                    type: "object",
                    subFields: videoInputs
                }, 
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/TestimonialSolo/TestimonialSolo.js




const TestimonialSolo_Styles = (0,labelStyles/* labelStyles */.B)('TestimonialSolo', {
    root: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[remapDeprecatedColors(backgroundColor)]};
  `,
    content: emotion_react_browser_esm/* css */.iv `
    padding: 39px 19px;
    margin: 0 auto;
    text-align: center;
    max-width: 500px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      max-width: 770px;
      padding: 58px 0px;
    }
  `,
    avatarContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 20px;
  `,
    quote: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin-bottom: 20px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.subHeader1 */.ZT.subHeader1}
    }
  `,
    author: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold}
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold}
    }
  `,
    company: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1}
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    }
  `,
});
const TestimonialSolo = ({ backgroundColor, avatarUrl, hasAuthorAvatar = true, quote, author, company, }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialSolo_Styles.root(backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialSolo_Styles.content },
            hasAuthorAvatar && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialSolo_Styles.avatarContainer },
                (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { "data-testId": "Avatar", name: author, url: avatarUrl, size: 40 }))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TestimonialSolo_Styles.quote }, quote),
            (0,isolateComponent/* isolateComponent */.U)("p", { css: TestimonialSolo_Styles.author }, author),
            (0,isolateComponent/* isolateComponent */.U)("p", { css: TestimonialSolo_Styles.company }, company))));
};
//# sourceMappingURL=TestimonialSolo.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/TestimonialMultipleColumn/TestimonialMultipleColumn.js





const CommonStyles = (0,labelStyles/* labelStyles */.B)('TestimonialCommon', {
    quote: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1}
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin-bottom: 10px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      margin-bottom: 20px;
      ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    }

    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      margin-bottom: 20px;
      ${Typography/* Typography.paragraph1 */.ZT.paragraph1}
      color: ${Colors/* Colors.neutral700 */.w.neutral700};
    }
  `,
    author: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold}
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold}
    }
  `,
    company: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1 */.ZT.smallPrint1}
    color: ${Colors/* Colors.neutral700 */.w.neutral700};

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    }
  `,
});
const TwoColumnStyles = (0,labelStyles/* labelStyles */.B)('TestimonialTwoColumn', {
    outerBox: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[remapDeprecatedColors(backgroundColor)]};
    padding: 20px;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      padding: 72px 30px;
    }
    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      padding: 82px 0px;
    }
  `,
    grid: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-rows: auto;
    row-gap: 25px;
    max-width: 1170px;
    justify-content: center;
    margin: 0 auto;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      grid-template-columns: auto 1px auto;
      column-gap: 15px;
      @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
        column-gap: 115px;
      }
    }
  `,
    content: emotion_react_browser_esm/* css */.iv `
    margin: 0 auto;
    text-align: center;
    max-width: 336px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      max-width: 339px;
    }

    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      max-width: 370px;
    }
  `,
    avatarContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 10px;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      margin-bottom: 20px;
    }
  `,
    border: emotion_react_browser_esm/* css */.iv `
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      width: 1px;
      background-color: ${Colors/* Colors.neutral400 */.w.neutral400};
    }
  `,
});
const ThreeColumnStyles = (0,labelStyles/* labelStyles */.B)('TestimonialThreeColumn', {
    outerBox: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[remapDeprecatedColors(backgroundColor)]};
    padding: 20px;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      padding: 40px 0px;
    }
    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      padding: 107px 0px;
    }
  `,
    grid: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-rows: auto;
    row-gap: 40px;
    max-width: 1170px;
    justify-content: center;
    margin: 0 auto;
    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      row-gap: 50px;
    }
    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      grid-template-columns: auto auto auto;
      column-gap: 30px;
    }
  `,
    content: emotion_react_browser_esm/* css */.iv `
    margin: 0 auto;
    text-align: left;
    max-width: 336px;

    @media screen and (min-width: ${TestimonialMapping_breakpoints.tablet}px) {
      max-width: 462px;
    }

    @media screen and (min-width: ${TestimonialMapping_breakpoints.desktop}px) {
      max-width: 370px;
    }
  `,
    innerFlex: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 20px;
  `,
});
const renderContentForTwoColumn = (props, index) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.content },
        props.testimonials[index].hasAuthorAvatar && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.avatarContainer },
            (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { "data-testId": "Avatar", name: props.testimonials[index].author, url: props.testimonials[index].avatarUrl, size: 40 }))),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: CommonStyles.quote }, props.testimonials[index].quote),
        (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.author }, props.testimonials[index].author),
        (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.company }, props.testimonials[index].company)));
};
const renderTwoColumn = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.outerBox(props.backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.grid },
            renderContentForTwoColumn(props, 0),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.border }),
            renderContentForTwoColumn(props, 1))));
};
const renderThreeColumn = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: ThreeColumnStyles.outerBox(props.backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ThreeColumnStyles.grid }, props.testimonials
            .slice(0, props.numberOfColumns)
            .map((testimonial, index) => ((0,isolateComponent/* isolateComponent */.U)("div", { key: index, css: ThreeColumnStyles.content },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: CommonStyles.quote }, testimonial.quote),
            testimonial.hasAuthorAvatar ? ((0,isolateComponent/* isolateComponent */.U)("div", { css: ThreeColumnStyles.innerFlex },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnStyles.avatarContainer },
                    (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: 40 })),
                (0,isolateComponent/* isolateComponent */.U)("div", null,
                    (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.author }, testimonial.author),
                    (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.company }, testimonial.company)))) : ((0,isolateComponent/* isolateComponent */.U)("div", null,
                (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.author }, testimonial.author),
                (0,isolateComponent/* isolateComponent */.U)("p", { css: CommonStyles.company }, testimonial.company)))))))));
};
const TestimonialMultipleColumn = (props) => {
    if (props.testimonials.length === 1) {
        const testimonial = props.testimonials[0];
        return ((0,isolateComponent/* isolateComponent */.U)(TestimonialSolo, { backgroundColor: props.backgroundColor, avatarUrl: testimonial.avatarUrl, company: testimonial.company, quote: testimonial.quote, author: testimonial.author }));
    }
    const renderType = props.numberOfColumns === 2 ? renderTwoColumn : renderThreeColumn;
    return renderType(props);
};
//# sourceMappingURL=TestimonialMultipleColumn.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/TestimonialMultipleColumn/TestimonialMultipleColumn.tsx





function TestimonialMultipleColumn_TestimonialMultipleColumn(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialMultipleColumn, {
        backgroundColor: props.backgroundColor,
        numberOfColumns: props.numberOfColumns,
        testimonials: props.testimonials.map(function(testimonial) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, testimonial), {
                quote: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
                    backgroundColor: props.backgroundColor,
                    html: testimonial.quote
                })
            });
        })
    });
}

;// CONCATENATED MODULE: ./src/components/sections/TestimonialMultipleColumn/fixtures.ts

var TestimonialMultipleColumn_fixtures_DEFAULT_VALUES = {
    numberOfColumns: 2,
    testimonials: new Array(3).fill({
        quote: "This is a default quote (Edit me)",
        author: "Name Surname",
        company: "Zapier",
        hasAuthorAvatar: true,
        avatarUrl: "https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png"
    }),
    backgroundColor: colors/* COLOR_KEYS.cream */.US.cream
};

;// CONCATENATED MODULE: ./src/components/sections/TestimonialMultipleColumn/TestimonialMultipleColumn.builder.ts






/* harmony default export */ var TestimonialMultipleColumn_builder = (createBuilderModule(withTracking(TestimonialMultipleColumn_TestimonialMultipleColumn, {
    as: "section",
    sectionName: events/* SectionName.TestimonialMultipleColumn */.jz.TestimonialMultipleColumn
}), {
    name: "TestimonialMultipleColumn",
    image: "https://cdn.zappy.app/ec91521a8eb8a2bdc6baa02fa86d99f8.png",
    inputs: [
        {
            name: "numberOfColumns",
            type: "number",
            required: true,
            defaultValue: TestimonialMultipleColumn_fixtures_DEFAULT_VALUES.numberOfColumns
        },
        {
            name: "testimonials",
            type: "list",
            required: true,
            defaultValue: TestimonialMultipleColumn_fixtures_DEFAULT_VALUES.testimonials,
            subFields: [
                {
                    name: "quote",
                    type: "richText",
                    required: true
                },
                {
                    name: "author",
                    type: "string",
                    required: true
                },
                {
                    name: "company",
                    type: "string",
                    required: true
                },
                {
                    name: "hasAuthorAvatar",
                    type: "boolean"
                },
                {
                    name: "avatarUrl",
                    type: "cloudinaryImage"
                }, 
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            defaultValue: TestimonialMultipleColumn_fixtures_DEFAULT_VALUES.backgroundColor,
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/TestimonialSolo/TestimonialSolo.tsx





function TestimonialSolo_TestimonialSolo(_param) {
    var background = _param.background, quote = _param.quote, restProps = _objectWithoutProperties(_param, [
        "background",
        "quote"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSolo, (0,src_object_spread/* default */.Z)({
        backgroundColor: background,
        quote: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: background,
            html: quote
        })
    }, restProps));
}

;// CONCATENATED MODULE: ./src/components/sections/TestimonialSolo/TestimonialSolo.builder.tsx





/* harmony default export */ var TestimonialSolo_builder = (createBuilderModule(withTracking(TestimonialSolo_TestimonialSolo, {
    sectionName: events/* SectionName.TestimonialSolo */.jz.TestimonialSolo
}), {
    name: "TestimonialSolo",
    image: "https://cdn.zapier.com/storage/photos/6ec78ee3777a52da2ffc3bae90191973.png",
    inputs: [
        {
            name: "background",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.lava10 */.US.lava10,
                colors/* COLOR_KEYS.ocean10 */.US.ocean10,
                colors/* COLOR_KEYS.sun10 */.US.sun10,
                colors/* COLOR_KEYS.white */.US.white,
                // V5 Colors
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            defaultValue: "neutral100"
        },
        {
            name: "quote",
            type: "richText",
            defaultValue: "This is a default quote (Edit me)",
            required: true
        },
        {
            name: "author",
            type: "string",
            defaultValue: "Name Surname",
            required: true
        },
        {
            name: "company",
            type: "string",
            defaultValue: "Zapier",
            required: true
        },
        {
            name: "hasAuthorAvatar",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "avatarUrl",
            type: "cloudinaryImage",
            defaultValue: "https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/TestimonialsSection/fixtures.tsx

var TestimonialsSection_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.night */.US.night,
    ctaText: "Meet our customers",
    ctaUrl: "#",
    description: "<p>Success starts with a Zap. At least that’s how these folks started. Maybe we’ll share your tweet next.</p>",
    heading: "Automation does the business good",
    testimonials: new Array(4).fill({
        author: "Name, VP of marketing at Storycorp",
        logoAltText: "StoryCorps",
        logoUrl: "https://cdn.zappy.app/4829b5157622c5c9bf800050cb265573.png",
        quote: "<p>“We uses Zapier to enrich our CRM data and improve internal workflows”</p>",
        thumbnailAltText: "32% increase in leads triaged",
        thumbnailUrl: "https://cdn.zappy.app/a6614085a15dac866830d02221ab7900.png"
    })
};

;// CONCATENATED MODULE: ./src/components/sections/TestimonialsSection/TestimonialsSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 










var TestimonialsSection_obj, TestimonialsSection_obj1;
var TestimonialsSection_Styles = (0,labelStyles/* labelStyles */.B)("TestimonialsSection", {
    root: function(backgroundColor) {
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            padding: "64px 20px 40px",
            backgroundColor: Colors/* Colors */.w[backgroundColor]
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            padding: "64px 20px 64px"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "144px 20px 160px"
        }), _obj));
    },
    container: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        maxWidth: "1170px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "64px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        gridTemplateColumns: "280px 1fr",
        gap: "120px"
    })),
    content: (0,emotion_react_browser_esm/* css */.iv)((TestimonialsSection_obj = {
        textAlign: "center"
    }, (0,_define_property/* default */.Z)(TestimonialsSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        maxWidth: "320px",
        margin: "0 auto"
    }), (0,_define_property/* default */.Z)(TestimonialsSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        height: "fit-content",
        position: "sticky",
        top: "".concat(144 + universal_nav_constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5, "px"),
        textAlign: "left"
    }), TestimonialsSection_obj)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.neutral100 */.w.neutral100,
        marginBottom: "16px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        marginBottom: "32px"
    })))),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), (0,_define_property/* default */.Z)({
        color: Colors/* Colors.neutral100 */.w.neutral100,
        marginBottom: "16px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        marginBottom: "40px"
    }))),
    testimonials: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "30px"
    }, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        gridTemplateColumns: "1fr 1fr"
    })),
    testimonial: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        flexDirection: "column"
    }),
    testimonialThumbnail: (0,emotion_react_browser_esm/* css */.iv)((TestimonialsSection_obj1 = {
        height: "295px",
        width: "100%",
        display: "block",
        objectFit: "cover",
        borderRadius: "3px 3px 0 0"
    }, (0,_define_property/* default */.Z)(TestimonialsSection_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        height: "320px"
    }), (0,_define_property/* default */.Z)(TestimonialsSection_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        height: "345px"
    }), (0,_define_property/* default */.Z)(TestimonialsSection_obj1, responsive/* MEDIA_MIN_WIDTH.extraLarge */.l0.extraLarge, {
        height: "370px"
    }), TestimonialsSection_obj1)),
    testimonialBody: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        padding: "20px",
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        borderRadius: "0 0 3px 3px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        padding: "30px"
    })),
    testimonialLogo: (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
        margin: "-63px 0 20px"
    }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        margin: "-73px 0 20px"
    })),
    testimonialContent: (0,emotion_react_browser_esm/* css */.iv)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexGrow: 1
    }),
    testimonialQuote: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph1Short */.ZT.paragraph1Short), {
        minHeight: "100px",
        marginBottom: "20px"
    })),
    testimonialAuthor: (0,emotion_react_browser_esm/* css */.iv)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium))
});
function TestimonialsSection(param) {
    var backgroundColor = param.backgroundColor, ctaText = param.ctaText, ctaUrl = param.ctaUrl, heading = param.heading, description = param.description, testimonials = param.testimonials;
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TestimonialsSection_Styles.root(backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TestimonialsSection_Styles.container
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TestimonialsSection_Styles.content
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: TestimonialsSection_Styles.heading
    }, heading), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TestimonialsSection_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: backgroundColor,
        html: description
    })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
        color: "secondary",
        href: ctaUrl,
        isFullWidth: true,
        onClick: function() {
            return emitCTAClickEvent({
                text: ctaText,
                href: ctaUrl,
                section: events/* SectionName.TestimonialsSection */.jz.TestimonialsSection
            });
        }
    }, ctaText)), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: TestimonialsSection_Styles.testimonials
    }, testimonials.map(function(testimonial, index) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonial,
            key: "".concat(testimonial.author, "-").concat(index)
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
            alt: testimonial.thumbnailAltText,
            css: TestimonialsSection_Styles.testimonialThumbnail,
            "data-testid": "testimonial-thumbnail",
            loading: "lazy",
            src: testimonial.thumbnailUrl
        }), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonialBody
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonialLogo
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(Img/* Img */.E, {
            alt: testimonial.logoAltText,
            borderRadius: 3,
            height: 86,
            isBlock: true,
            objectFit: "cover",
            src: testimonial.logoUrl,
            width: 86
        })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonialContent
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonialQuote
        }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: backgroundColor,
            html: testimonial.quote
        })), /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
            css: TestimonialsSection_Styles.testimonialAuthor
        }, testimonial.author))));
    }))));
}

;// CONCATENATED MODULE: ./src/components/sections/TestimonialsSection/TestimonialsSection.builder.tsx






/* harmony default export */ var TestimonialsSection_builder = (createBuilderModule(withTracking(TestimonialsSection, {
    sectionName: events/* SectionName.TestimonialsSection */.jz.TestimonialsSection
}), {
    name: "TestimonialsSection",
    image: "https://cdn.zappy.app/b7d72c7ef4b259c9e887bbae3c105295.svg",
    inputs: [
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier, 
            ],
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.backgroundColor
        },
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "description",
            type: "richText",
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.description
        },
        {
            name: "ctaText",
            type: "string",
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.ctaText
        },
        {
            name: "ctaUrl",
            type: "string",
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.ctaUrl
        },
        {
            name: "testimonials",
            type: "list",
            subFields: [
                {
                    name: "quote",
                    type: "richText",
                    required: true
                },
                {
                    name: "author",
                    type: "string",
                    required: true
                },
                {
                    name: "logoUrl",
                    type: "cloudinaryImage",
                    required: true
                },
                {
                    name: "logoAltText",
                    type: "string",
                    required: true
                },
                {
                    name: "thumbnailUrl",
                    type: "cloudinaryImage",
                    required: true
                },
                {
                    name: "thumbnailAltText",
                    type: "string",
                    required: true
                }, 
            ],
            required: true,
            defaultValue: TestimonialsSection_fixtures_DEFAULT_VALUES.testimonials
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/TwoColumnRiver/TwoColumnRiver.js



const TwoColumnRiver_Styles = (0,labelStyles/* labelStyles */.B)('TwoColumnRiver', {
    root: (backgroundColor = 'neutral100') => emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors */.w[backgroundColor]};
    padding: 20px;

    @media screen and (min-width: 640px) {
      padding: 40px 30px;
    }

    @media screen and (min-width: 1024px) {
      padding: 60px 20px;
    }
  `,
    container: (isReversed) => emotion_react_browser_esm/* css */.iv `
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column-reverse;

    @media screen and (min-width: 1024px) {
      flex-direction: ${isReversed ? 'row-reverse' : 'row'};
    }
  `,
    content: emotion_react_browser_esm/* css */.iv `
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      padding-right: 30px;
    }
  `,
    labelContainer: emotion_react_browser_esm/* css */.iv `
    margin-bottom: 20px;
  `,
    media: (isReversed) => emotion_react_browser_esm/* css */.iv `
    margin-bottom: 20px;
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      margin: ${isReversed ? '0 40px 0 0' : '0 0 0 40px'};
    }
  `,
    heading: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.pageHeader9 */.ZT.pageHeader9}
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin-bottom: 20px;
    @media screen and (min-width: 640px) {
      ${Typography/* Typography.pageHeader7 */.ZT.pageHeader7}
    }

    @media screen and (min-width: 1024px) {
      ${Typography/* Typography.pageHeader5 */.ZT.pageHeader5}
    }
  `,
    description: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph1Short */.ZT.paragraph1Short}
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    margin-bottom: 20px;
  `,
    cta: emotion_react_browser_esm/* css */.iv `
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 640px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
    secondaryCta: emotion_react_browser_esm/* css */.iv `
    margin-top: 20px;
  `,
});
const TwoColumnRiver = ({ backgroundColor = 'neutral100', ctaColor = 'primary', ctaHref, ctaText, description, heading, isReversed = false, media, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaHref, secondaryCtaText, label, labelIcon, labelColor, }) => {
    const getCtaComponent = () => {
        const sharedProps = {
            children: ctaText,
            href: ctaHref,
            onClick: onCtaClick,
            onKeyDown: onCtaKeyDown,
        };
        return ctaColor === 'brand' ? ((0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({}, sharedProps))) : ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, Object.assign({}, sharedProps, { color: ctaColor })));
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.root(backgroundColor) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.container(isReversed) },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.content },
                label && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.labelContainer },
                    (0,isolateComponent/* isolateComponent */.U)(TagLabel, { color: labelColor }, labelIcon ? ((0,isolateComponent/* isolateComponent */.U)(Grid_Grid/* Grid */.r, { alignItems: "center", columns: "auto max-content", gap: 5 },
                        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: labelIcon, size: 20 }),
                        label)) : (label)))),
                (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                    (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: TwoColumnRiver_Styles.heading }, heading)),
                description && (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.description }, description),
                ctaText && (ctaHref || onCtaClick) && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.cta }, getCtaComponent())),
                secondaryCtaText && secondaryCtaHref && ((0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.secondaryCta },
                    (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" }, secondaryCtaText)))),
            media && (0,isolateComponent/* isolateComponent */.U)("div", { css: TwoColumnRiver_Styles.media(isReversed) }, media))));
};
//# sourceMappingURL=TwoColumnRiver.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/sections/TwoColumnRiverSection/TwoColumnRiverSection.tsx






function TwoColumnRiverSection(_param) {
    var children = _param.children, description = _param.description, rest = _objectWithoutProperties(_param, [
        "children",
        "description"
    ]);
    var emitCTAClickEvent = (0,avro/* useAvroTracking */.B2)().emitCTAClickEvent;
    var ctaHref = rest.ctaHref, ctaText = rest.ctaText;
    var handleCTAClick = function() {
        if (ctaText && ctaHref) emitCTAClickEvent({
            text: ctaText,
            section: events/* SectionName.TwoColumnRiverSection */.jz.TwoColumnRiverSection,
            href: ctaHref
        });
    };
    var handleSecondaryCTAClick = function() {
        if (ctaText && ctaHref) emitCTAClickEvent({
            text: ctaText,
            section: events/* SectionName.TwoColumnRiverSection */.jz.TwoColumnRiverSection,
            href: ctaHref,
            type: avro/* CTAType.cta_link */.g8.cta_link
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumnRiver, (0,src_object_spread/* default */.Z)({
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
            backgroundColor: rest.backgroundColor,
            html: description
        }),
        media: children,
        onCtaClick: handleCTAClick,
        onSecondaryCtaClick: handleSecondaryCTAClick
    }, rest));
}

;// CONCATENATED MODULE: ./src/components/sections/TwoColumnRiverSection/fixtures.ts

var TwoColumnRiverSection_fixtures_DEFAULT_VALUES = {
    backgroundColor: colors/* COLOR_KEYS.neutral100 */.US.neutral100,
    heading: "Two column river",
    description: "<p><strong>Availability:</strong> Zapier has globally distributed SRE and Security teams that are on-call 24/7. To ensure users have real-time service availability updates, Zapier maintains a Status page.</p><p><strong>Logging: </strong>Zapier maintains a comprehensive log of all user and Zap activities. Zap activities are extensively logged internally for troubleshooting and support, and presented in summary in Zap History to inform users directly.</p>",
    ctaText: "Click me",
    ctaHref: "#",
    ctaColor: "primary",
    secondaryCtaText: "Click me too",
    secondaryCtaHref: "##",
    isReversed: false
};

;// CONCATENATED MODULE: ./src/components/sections/TwoColumnRiverSection/TwoColumnRiverSection.builder.ts








/* harmony default export */ var TwoColumnRiverSection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(withTracking(TwoColumnRiverSection, {
    as: "section",
    sectionName: events/* SectionName.TwoColumnRiverSection */.jz.TwoColumnRiverSection
})), {
    name: "TwoColumnRiver",
    image: "https://cdn.zappy.app/a60710d9fda3a9c0c68712739f625913.png",
    inputs: [
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.blue10 */.US.blue10,
                colors/* COLOR_KEYS.cream */.US.cream,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100,
                colors/* COLOR_KEYS.neutral200 */.US.neutral200, 
            ],
            defaultValue: colors/* COLOR_KEYS.neutral100 */.US.neutral100
        },
        {
            name: "heading",
            type: "string",
            required: true,
            defaultValue: "Edit me"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: TwoColumnRiverSection_fixtures_DEFAULT_VALUES.description
        },
        {
            name: "ctaText",
            type: "string"
        },
        {
            name: "ctaHref",
            type: "string"
        },
        {
            name: "ctaColor",
            type: "string",
            enum: [
                "primary",
                "primary-alt",
                "secondary",
                "brand"
            ],
            showIf: function(options) {
                return options.get("ctaText") && options.get("ctaHref");
            }
        },
        {
            name: "secondaryCtaText",
            type: "string"
        },
        {
            name: "secondaryCtaHref",
            type: "string"
        },
        {
            name: "isReversed",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "label",
            type: "string"
        },
        {
            name: "labelIcon",
            type: "string",
            enum: Object.values(ICON_NAMES)
        },
        {
            name: "labelColor",
            type: "string",
            enum: [
                "info",
                "success",
                "error",
                "warning",
                "white",
                "gray",
                "peach",
                "neutral300",
                "bolt",
                "cream", 
            ]
        }, 
    ],
    defaultChildren: [
        imgElement({
            src: "https://cdn.zappy.app/a676a6fd95275034143d3250133031a3.jpg",
            alt: "Mountain view"
        }), 
    ]
}));

;// CONCATENATED MODULE: ./src/components/sections/VideoSection/fixtures.ts

var VideoSection_fixtures_DEFAULT_VALUES = {
    heading: "Example heading",
    backgroundColor: colors/* COLOR_KEYS.moss */.US.moss,
    wistiaId: "t1yil0mi2f"
};

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/WistiaVideo/WistiaVideo.context.tsx
var WistiaVideo_context = __webpack_require__(61073);
;// CONCATENATED MODULE: ./src/components/WistiaVideo/WistiaVideo.tsx




var WistiaVideo = function(param) {
    var wistiaId = param.wistiaId;
    var setIsWistiaOnThePage = (0,WistiaVideo_context/* useWistiaScript */.L)().setIsWistiaOnThePage;
    (0,react.useEffect)(function() {
        setIsWistiaOnThePage();
    }, [
        setIsWistiaOnThePage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://fast.wistia.com/embed/medias/".concat(wistiaId, ".jsonp")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "wistia_responsive_wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wistia_responsive_padding",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "wistia_embed wistia_async_".concat(wistiaId, " videoFoam=true"),
                        style: {
                            display: "inline-block",
                            height: "100%",
                            position: "relative",
                            width: "100%"
                        }
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/sections/VideoSection/VideoSection.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 








var VideoSection_obj, VideoSection_obj1, VideoSection_obj2;
var VideoSection_Styles = (0,labelStyles/* labelStyles */.B)("VideoSection", {
    root: function(backgroundColor) {
        return (0,emotion_react_browser_esm/* css */.iv)((0,_define_property/* default */.Z)({
            padding: "60px 20px",
            backgroundColor: Colors/* Colors */.w[backgroundColor],
            color: backgroundColor === colors/* COLOR_KEYS.neutral100 */.US.neutral100 ? Colors/* Colors.neutral800 */.w.neutral800 : Colors/* Colors.neutral100 */.w.neutral100
        }, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            padding: "60px 20px 80px"
        }));
    },
    container: (0,emotion_react_browser_esm/* css */.iv)({
        maxWidth: "1170px",
        margin: "0 auto"
    }),
    content: (0,emotion_react_browser_esm/* css */.iv)((VideoSection_obj = {
        maxWidth: "512px",
        margin: "0 auto 32px"
    }, (0,_define_property/* default */.Z)(VideoSection_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
        margin: "0 auto 40px"
    }), (0,_define_property/* default */.Z)(VideoSection_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
        maxWidth: "800px",
        margin: "0 auto 48px"
    }), VideoSection_obj)),
    heading: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader7 */.ZT.pageHeader7), (VideoSection_obj1 = {
        color: "inherit",
        textAlign: "center",
        marginBottom: "8px"
    }, (0,_define_property/* default */.Z)(VideoSection_obj1, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader5 */.ZT.pageHeader5), {
        marginBottom: "16px"
    })), (0,_define_property/* default */.Z)(VideoSection_obj1, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.pageHeader3 */.ZT.pageHeader3), {
        marginBottom: "20px"
    })), VideoSection_obj1))),
    description: (0,emotion_react_browser_esm/* css */.iv)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, Typography/* Typography.heading */.ZT.heading), (VideoSection_obj2 = {
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "inherit"
    }, (0,_define_property/* default */.Z)(VideoSection_obj2, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader5 */.ZT.subHeader5)), (0,_define_property/* default */.Z)(VideoSection_obj2, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, (0,src_object_spread/* default */.Z)({}, Typography/* Typography.subHeader3 */.ZT.subHeader3)), VideoSection_obj2)))
});
function VideoSection(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: VideoSection_Styles.root(props.backgroundColor)
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: VideoSection_Styles.container
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: VideoSection_Styles.content
    }, props.heading && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
        css: VideoSection_Styles.heading
    }, props.heading), props.description && /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: VideoSection_Styles.description
    }, /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(RichTextHtml/* RichTextHtml */.CW, {
        backgroundColor: props.backgroundColor,
        html: props.description
    }))), props.wistiaId ? /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)(WistiaVideo, {
        wistiaId: props.wistiaId
    }) : props.children));
}

;// CONCATENATED MODULE: ./src/components/sections/VideoSection/VideoSection.builder.ts






/* harmony default export */ var VideoSection_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(withTracking(VideoSection, {
    as: "section",
    sectionName: events/* SectionName.VideoSection */.jz.VideoSection
})), {
    name: "VideoSection",
    image: "https://cdn.zappy.app/e994545429dd171ac93ccd78217bbf37.png",
    inputs: [
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                colors/* COLOR_KEYS.moss */.US.moss,
                colors/* COLOR_KEYS.neutral800 */.US.neutral800,
                colors/* COLOR_KEYS.night */.US.night,
                colors/* COLOR_KEYS.zapier */.US.zapier,
                colors/* COLOR_KEYS.neutral100 */.US.neutral100, 
            ],
            required: true,
            defaultValue: VideoSection_fixtures_DEFAULT_VALUES.backgroundColor
        },
        {
            name: "heading",
            type: "string",
            defaultValue: VideoSection_fixtures_DEFAULT_VALUES.heading
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "wistiaId",
            type: "string"
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/Visibility/Visibility.tsx
/** @jsxRuntime classic */ /** @jsx jsx */ 



var Visibility_Styles = (0,labelStyles/* labelStyles */.B)("Visibility", {
    root: function() {
        var hideOnMobile = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, hideOnTablet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, hideOnDesktop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var _obj;
        return (0,emotion_react_browser_esm/* css */.iv)((_obj = {
            display: hideOnMobile ? "none" : "block"
        }, (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.small */.l0.small, {
            display: hideOnTablet ? "none" : "block"
        }), (0,_define_property/* default */.Z)(_obj, responsive/* MEDIA_MIN_WIDTH.large */.l0.large, {
            display: hideOnDesktop ? "none" : "block"
        }), _obj));
    }
});
function Visibility(props) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        css: Visibility_Styles.root(props.hideOnMobile, props.hideOnTablet, props.hideOnDesktop)
    }, props.children);
}

;// CONCATENATED MODULE: ./src/components/Visibility/Visibility.builder.tsx



/* harmony default export */ var Visibility_builder = (createBuilderModule((0,builder_react_es5/* withChildren */.u7)(Visibility), {
    name: "Visibility",
    image: "https://cdn.zappy.app/7f0a7450fe514e4284bf33f3a819acb0.svg",
    inputs: [
        {
            name: "hideOnMobile",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "hideOnTablet",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "hideOnDesktop",
            type: "boolean",
            defaultValue: false
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/components/WistiaVideo/WistiaVideo.builder.ts



/* harmony default export */ var WistiaVideo_builder = (createBuilderModule(WistiaVideo, {
    name: "WistiaVideo",
    image: "https://cdn.zappy.app/5a5ad454e9f91a5e598ed39722e5e9f8.png",
    inputs: [
        {
            name: "wistiaId",
            type: "string",
            defaultValue: HOW_ZAPIER_WORKS_VIDEO,
            helperText: "You can grab the Wistia id from the video URL when logged in. Related Wistia docs: https://wistia.com/support/embed-and-share/sharing-videos",
            required: true
        }, 
    ]
}));

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/YouTubeVideo/YouTubeVideo.js



const YouTubeVideo_Styles = (0,labelStyles/* labelStyles */.B)('YouTubeVideo', {
    root: emotion_react_browser_esm/* css */.iv `
    position: relative;
    width: 100%;
    height: 0;
  `,
    video: emotion_react_browser_esm/* css */.iv `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `,
});
const useYouTubeIframeAPI = (youTubeId, events) => {
    (0,react.useEffect)(() => {
        const loadScriptTag = (scriptSrc) => {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;
            document.body.append(script);
        };
        const loadYouTubeIframeApi = () => {
            const youTubeIframeAPIReady = new Promise((resolve) => {
                const scriptSrc = 'https://www.youtube.com/iframe_api';
                const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
                if (!existingScript) {
                    loadScriptTag(scriptSrc);
                }
                const previousIframeApiReady = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = () => {
                    if (previousIframeApiReady) {
                        previousIframeApiReady();
                    }
                    resolve(window.YT);
                };
            });
            return youTubeIframeAPIReady;
        };
        const loadIframe = () => {
            return loadYouTubeIframeApi()
                .then((youTubeIframeAPI) => new youTubeIframeAPI.Player(`youtube-video-${youTubeId}`, {
                events,
            }))
                .catch(() => { });
        };
        if (events && Object.keys(events).length) {
            loadIframe();
        }
    }, [events, youTubeId]);
};
const YouTubeVideo = (props) => {
    const [src, setSrc] = (0,react.useState)(`https://www.youtube.com/embed/${props.youTubeId}?rel=0&autoplay=${Number(props.autoplay)}&mute=${Number(props.mute)}`);
    (0,react.useEffect)(() => {
        var _a;
        if (props.events && ((_a = Object.keys(props.events)) === null || _a === void 0 ? void 0 : _a.length)) {
            setSrc((prevState) => `${prevState}&enablejsapi=1&origin=${window.location.origin}`);
        }
    }, [props.events]);
    useYouTubeIframeAPI(props.youTubeId, props.events);
    const style = {
        paddingBottom: `${props.aspectRatio ** -1 * 100}%`,
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: YouTubeVideo_Styles.root, style: style },
        (0,isolateComponent/* isolateComponent */.U)("iframe", { id: `youtube-video-${props.youTubeId}`, allow: props.allowFullscreen ? 'fullscreen' : undefined, css: YouTubeVideo_Styles.video, frameBorder: "0", src: src, title: props.title })));
};
YouTubeVideo.defaultProps = {
    aspectRatio: 16 / 9,
    autoplay: false,
    allowFullscreen: true,
    mute: false,
};
//# sourceMappingURL=YouTubeVideo.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ./src/components/YouTubeVideo/YouTubeVideo.tsx


var YouTubeVideo_YouTubeVideo = function(param) {
    var allowFullscreen = param.allowFullscreen, aspectRatio = param.aspectRatio, autoplay = param.autoplay, title = param.title, youtubeId = param.youtubeId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubeVideo, {
        allowFullscreen: allowFullscreen,
        aspectRatio: aspectRatio,
        autoplay: autoplay,
        title: title,
        youTubeId: youtubeId
    });
};

;// CONCATENATED MODULE: ./src/components/YouTubeVideo/YouTubeVideo.builder.ts


/* harmony default export */ var YouTubeVideo_builder = (createBuilderModule(YouTubeVideo_YouTubeVideo, {
    name: "youtubeVideo",
    image: "https://cdn.zappy.app/6743fdc6e7c496290dc316ef1c5f2b28.png",
    inputs: [
        {
            name: "youtubeId",
            type: "string",
            defaultValue: "QEmNOlXf-HY"
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Title for YouTube video"
        },
        {
            name: "allowFullscreen",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "aspectRatio",
            type: "number",
            defaultValue: 16 / 9
        },
        {
            name: "autoplay",
            type: "boolean",
            defaultValue: false
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/utils/getEnumKeyByEnumValue.ts
function getEnumKeyByEnumValue(myEnum, enumValues) {
    return Object.keys(myEnum).filter(function(x) {
        return enumValues.includes(myEnum[x]);
    });
}
/* harmony default export */ var utils_getEnumKeyByEnumValue = ((/* unused pure expression or super */ null && (getEnumKeyByEnumValue)));

;// CONCATENATED MODULE: ./src/components/sections/ZapCardSection/ZapCardSection.builder.ts






/* harmony default export */ var ZapCardSection_builder = (createBuilderModule(ZapCardSection_ZapCardSection, {
    name: "ZapCardSection",
    image: "https://cdn.zappy.app/4e1f43386cebbdb10a527efc33a74804.png",
    hideFromInsertMenu: false,
    inputs: [
        {
            name: "layout",
            type: "string",
            enum: [
                "card",
                "mega",
                "auto"
            ]
        },
        {
            name: "background",
            type: "string",
            enum: Object.keys(backgroundColors),
            defaultValue: colors/* COLOR_KEYS.transparent */.US.transparent
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "zapTemplateID",
                    type: "string"
                },
                {
                    name: "label",
                    type: "string",
                    helperText: "Label name."
                },
                {
                    name: "labelTooltip",
                    type: "string",
                    helperText: "Tooltip describing why the label was applied."
                },
                {
                    name: "href",
                    type: "string",
                    helperText: "URL to the shared Zap / template."
                },
                {
                    name: "title",
                    type: "string",
                    helperText: "Title of the Zap."
                },
                {
                    name: "services",
                    type: "list",
                    subFields: [
                        {
                            name: "name",
                            type: "string",
                            defaultValue: "Slack",
                            helperText: "Service name."
                        },
                        {
                            name: "src",
                            type: "cloudinaryImage",
                            defaultValue: "https://images.zapier.com/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.128x128.png",
                            helperText: "URL to the service icon."
                        }, 
                    ],
                    helperText: "Array of services used by the Zap. Used to display service icons."
                },
                {
                    name: "color",
                    type: "color",
                    helperText: "Color of the card."
                },
                {
                    name: "ctaName",
                    type: "string",
                    enum: getEnumKeyByEnumValue(events/* CtaName */.XE, [
                        events/* CtaName.tryThis */.XE.tryThis,
                        events/* CtaName.learnMore */.XE.learnMore, 
                    ]),
                    helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
                    required: true
                },
                {
                    name: "ctaGoal",
                    type: "string",
                    enum: getEnumKeyByEnumValue(events/* CtaGoal */.LK, [
                        events/* CtaGoal.getMoreInformation */.LK.getMoreInformation,
                        events/* CtaGoal.exploreIntegrations */.LK.exploreIntegrations,
                        events/* CtaGoal.createZap */.LK.createZap, 
                    ]),
                    helperText: "For data tracking: Collaborate with data team on which value should be tracked for this CTA.",
                    required: true
                }, 
            ]
        }, 
    ]
}));

;// CONCATENATED MODULE: ./src/builder/register-builder.ts



























































/**
 * Declare components as desired "Insert" menu sections in Builder Editor sidebar menu
 */ var menuSections = [
    {
        sectionTitle: "Sections",
        componentModules: [
            AccordionSection_builder,
            BlockGrid_builder,
            BlockSection_builder,
            CarouselSection_builder,
            ColumnGridSections_builder,
            CTASection_builder,
            EventAgendaSection_builder,
            Heading_builder,
            HeroSection_builder,
            JobBoard_builder,
            LogoBar_builder,
            OneColumnBlock_builder,
            SignUpCtaSection_builder,
            TableSection_builder,
            TabsSection_builder,
            TestimonialCarousel_builder,
            TestimonialMultipleColumn_builder,
            TestimonialSolo_builder,
            TwoColumnRiverSection_builder,
            ZapCardSection_builder, 
        ]
    },
    {
        sectionTitle: "Blocks",
        componentModules: [
            Article_builder,
            Block_builder,
            BlockGridItem_builder,
            Breadcrumbs_builder,
            Card_builder,
            HubSpotForm_builder,
            HubSpotFormV2_builder,
            HubSpotMeeting_builder,
            Img_builder,
            Margin_builder,
            Spacer_builder,
            SignUpForm_builder,
            Video_builder,
            WistiaVideo_builder,
            YouTubeVideo_builder, 
        ]
    },
    {
        sectionTitle: "Custom",
        componentModules: [
            AnimationsSection_builder,
            AppsSection_builder,
            CompactCTASection_builder,
            FAQSection_builder,
            FeaturesSection_builder,
            PlanComparisonSection_builder,
            PopularTemplatesSection_builder,
            ResourcesSection_builder,
            ScrollingTweetsSection_builder,
            SplitColorAccordionSection_builder,
            SplitColorHero_builder,
            TestimonialsSection_builder,
            VideoSection_builder, 
        ]
    },
    {
        sectionTitle: "Utilities",
        componentModules: [
            ABTest_builder,
            ABVariant_builder,
            Anchor_builder,
            Conditional_builder,
            CTAClickTracking_builder,
            HeadingLevel_builder,
            InViewTracking_builder,
            Visibility_builder, 
        ]
    }, 
];
menuSections.forEach(function(param) {
    var sectionTitle = param.sectionTitle, componentModules = param.componentModules;
    // Register components
    componentModules.forEach(function(param) {
        var Component = param.Component, config = param.config;
        builder_react_es5/* Builder.registerComponent */.Ib.registerComponent(Component, config);
    });
    // Add to "Insert" menu section
    index_esm/* Builder.register */.Ib.register("insertMenu", {
        name: sectionTitle,
        items: componentModules.filter(function(param) {
            var config = param.config;
            return !config.hideFromInsertMenu;
        }).map(function(param) {
            var config = param.config;
            return {
                name: config.name
            };
        })
    });
});
migrations.forEach(function(migrate) {
    return migrate();
});


/***/ }),

/***/ 75571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useABTestContext; },
/* harmony export */   "h": function() { return /* binding */ ABTest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96204);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82929);







var getStoredVariant = function(experimentName) {
    return {
        name: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .isBrowser */ .j)() && window.localStorage.getItem("pb_".concat(experimentName)) || "",
        isFallback: false
    };
};
var setStoredVariant = function(experimentName, variantName) {
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .isBrowser */ .j)()) window.localStorage["pb_".concat(experimentName)] = variantName;
};
function ABTest(param) {
    var _variants = param.variants, variants = _variants === void 0 ? [] : _variants, experimentName = param.experimentName, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(getStoredVariant(experimentName)), activeVariant = ref[0], setActiveVariant = ref[1];
    // Used to track whether variants have been added as children of ABTest
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), registration = ref1[0], setRegistration = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isPreviewMode = _builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing || _builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing;
        var haveChildrenRegistered = !!Object.keys(registration).length;
        if ((activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name) || !variants || isPreviewMode || !haveChildrenRegistered) return;
        var arePrecentagesCorrect = (variants === null || variants === void 0 ? void 0 : variants.reduce(function(acc, curr) {
            return acc + (curr === null || curr === void 0 ? void 0 : curr.percent);
        }, 0)) === 100;
        var isEveryVariantNamedAndRegistered = variants.every(function(variant) {
            var ref;
            return (variant === null || variant === void 0 ? void 0 : (ref = variant.name) === null || ref === void 0 ? void 0 : ref.trim()) !== "" && registration[variant === null || variant === void 0 ? void 0 : variant.name];
        });
        var shouldUseFallbackVariant = !experimentName || !arePrecentagesCorrect || !isEveryVariantNamedAndRegistered;
        // If there is a problem with how the test was set up, then we use the fallback variant.
        if (shouldUseFallbackVariant) {
            var control = variants.find(function(variant) {
                return variant.control && variant.name.trim() !== "" && registration[variant.name];
            });
            var firstNamedVariant = variants.find(function(variant) {
                return variant.name.trim() !== "" && registration[variant.name];
            });
            /**
       * If there is a control, then we use that,
       * otherwise we use the first named variant.
       * If there is no control and no variants have names, then god help us all.
       */ var fallbackVariantName = (control === null || control === void 0 ? void 0 : control.name) || (firstNamedVariant === null || firstNamedVariant === void 0 ? void 0 : firstNamedVariant.name) || "";
            setActiveVariant({
                name: fallbackVariantName,
                isFallback: true
            });
        } else {
            var randomizedVariant = getRandomizedVariant(variants);
            setStoredVariant(experimentName, randomizedVariant);
            setActiveVariant({
                name: randomizedVariant,
                isFallback: false
            });
        }
    }, [
        variants,
        experimentName,
        registration,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name
    ]);
    var registerVariant = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(variant) {
        setRegistration(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prevState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, variant, true));
        });
    }, []);
    var deregisterVariant = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(variant) {
        setRegistration(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prevState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, variant, false));
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ABTestContext.Provider, {
        value: {
            activeVariant: activeVariant,
            experimentName: experimentName,
            registerVariant: registerVariant,
            deregisterVariant: deregisterVariant
        },
        children: children
    });
}
var ABTestContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    activeVariant: {
        name: "",
        isFallback: false
    },
    experimentName: ""
});
var useABTestContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(ABTestContext);
};
var getRandomizedVariant = function(variants) {
    var random = Math.random() * 100;
    var variant = variants.reduce(function(acc, curr) {
        var min = acc.remaining - curr.percent;
        var max = acc.remaining;
        if (random >= min && random < max) return {
            remaining: min,
            variant: curr.name
        };
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, acc), {
            remaining: min
        });
    }, {
        remaining: 100,
        variant: ""
    }).variant;
    return variant;
};


/***/ }),

/***/ 79205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "InViewTracking": function() { return /* binding */ InViewTracking; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react.useRef)();

  var _React$useState = (0,react.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* harmony default export */ var react_intersection_observer_m = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map

// EXTERNAL MODULE: ../../node_modules/@zapier/toolbox-tracking/dist/index.js
var dist = __webpack_require__(24645);
// EXTERNAL MODULE: ./src/observability/tracking/events.ts
var events = __webpack_require__(65088);
// EXTERNAL MODULE: ./src/observability/tracking/avro.ts
var avro = __webpack_require__(90073);
;// CONCATENATED MODULE: ./src/components/InViewTracking/InViewTracking.tsx








function InViewTracking(param) {
    var children = param.children, layerName = param.layerName, sectionName = param.sectionName, tmp = param.as, WrapperElement = tmp === void 0 ? "div" : tmp, className = param.className;
    var trackEvent = (0,dist.useTrackingContext)().trackEvent;
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var ref = (0,_sliced_to_array/* default */.Z)(useInView(), 2), ref1 = ref[0], inView = ref[1];
    (0,react.useEffect)(function() {
        if (inView) {
            emitUserInteractionEvent({
                event_action: avro/* EventAction.in_view */.AO.in_view,
                interaction_name: avro/* InteractionName.component_scrolled_into_view */.AI.component_scrolled_into_view,
                option_selected: WrapperElement,
                custom_tracking_fields: (0,_object_spread/* default */.Z)({
                    section_name: sectionName
                }, layerName && {
                    custom_section_name: layerName
                })
            });
            trackEvent(events/* EventName.SCROLLED_INTO_VIEW */.B_.SCROLLED_INTO_VIEW, (0,_object_spread/* default */.Z)({
                component: sectionName
            }, layerName && {
                custom_section_name: layerName
            }));
        }
    }, [
        inView,
        trackEvent,
        sectionName,
        WrapperElement,
        emitUserInteractionEvent,
        layerName, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TrackingProvider, {
        metadata: {
            event_location: sectionName
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperElement, {
            className: className,
            ref: ref1,
            children: children
        })
    });
}


/***/ }),

/***/ 97598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Page; },
  "l": function() { return /* binding */ usePageContext; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Spinner/Spinner.js
var Spinner = __webpack_require__(22211);
;// CONCATENATED MODULE: ./src/components/FallbackPage.tsx


/**
 * Minimal "Loading" fallback page implementation
 * https://nextjs.org/docs/basic-features/data-fetching#fallback-pages
 */ function FallbackPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
            size: "large"
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/Meta/Meta.tsx




var Meta = function(param) {
    var articleStructuredData = param.articleStructuredData, description = param.description, openGraphImageUrl = param.openGraphImageUrl, _openToSearchEngines = param.openToSearchEngines, openToSearchEngines = _openToSearchEngines === void 0 ? false : _openToSearchEngines, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: title,
                        property: "og:title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: title,
                        name: "twitter:title"
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: description,
                        id: "meta-description",
                        name: "description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: description,
                        property: "og:description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: description,
                        name: "twitter:description"
                    })
                ]
            }),
            openGraphImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: openGraphImageUrl,
                        property: "og:image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: openGraphImageUrl,
                        name: "twitter:image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "summary_large_image",
                        name: "twitter:card"
                    })
                ]
            }),
            !openToSearchEngines && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "noindex, nofollow",
                name: "robots"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "width=device-width, initial-scale=1.0",
                name: "viewport"
            }),
            articleStructuredData && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify((0,_object_spread/* default */.Z)({
                        "@context": "https://schema.org",
                        "@type": "Article"
                    }, articleStructuredData.headline && {
                        headline: articleStructuredData.headline
                    }, articleStructuredData.author && {
                        author: {
                            "@type": "Person",
                            name: articleStructuredData.author
                        }
                    }, articleStructuredData.dateModified && {
                        dateModified: new Date(articleStructuredData.dateModified).toISOString()
                    }, articleStructuredData.datePublished && {
                        datePublished: new Date(articleStructuredData.datePublished).toISOString()
                    }, openGraphImageUrl && {
                        image: openGraphImageUrl
                    }))
                }
            }, "article-structured-data")
        ]
    });
};

// EXTERNAL MODULE: ./src/components/WistiaVideo/WistiaVideo.context.tsx
var WistiaVideo_context = __webpack_require__(61073);
;// CONCATENATED MODULE: ./src/components/WistiaVideo/WistiaControlScript.tsx



/**
 * In case you wonder why E-v1.js is important for Wistia.
 *
 * Feel free to read: https://wistia.com/support/developers/e-v1
 */ function WistiaControlScript() {
    var isWistiaOnThePage = (0,WistiaVideo_context/* useWistiaScript */.L)().isWistiaOnThePage;
    return isWistiaOnThePage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            defer: true,
            src: "https://fast.wistia.com/assets/external/E-v1.js"
        })
    }) : null;
}

// EXTERNAL MODULE: ./src/components/UniversalLayout/UniversalLayout.tsx + 92 modules
var UniversalLayout = __webpack_require__(37151);
// EXTERNAL MODULE: ./src/components/PageBuilderComponent.tsx + 3 modules
var PageBuilderComponent = __webpack_require__(23391);
// EXTERNAL MODULE: ./src/observability/tracking/TrackRouting.tsx
var TrackRouting = __webpack_require__(5772);
;// CONCATENATED MODULE: ./src/components/Page.tsx












var Survey = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5736), __webpack_require__.e(300)]).then(__webpack_require__.bind(__webpack_require__, 50300)).then(function(mod) {
        return mod.SurveyContainer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50300)
            ];
        }
    }
});
var PageContext = /*#__PURE__*/ (0,react.createContext)({});
var usePageContext = function() {
    return (0,react.useContext)(PageContext);
};
function Page(param) {
    var content = param.content;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(content === null || content === void 0 ? void 0 : content.data), pageData = ref[0], setPageData = ref[1];
    // https://nextjs.org/docs/basic-features/data-fetching#fallback-pages
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FallbackPage, {});
    }
    var ref1 = pageData || {}, alertBanner = ref1.alertBanner, articleStructuredData = ref1.articleStructuredData, description = ref1.description, openGraphImageUrl = ref1.openGraphImageUrl, openToSearchEngines = ref1.openToSearchEngines, showSurvey = ref1.showSurvey, title = ref1.title, universalFooter = ref1.universalFooter, universalLayout = ref1.universalLayout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContext.Provider, {
        value: {
            id: content.id,
            variations: content.variations
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UniversalLayout/* UniversalLayout */.p, {
            alertBanner: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, alertBanner), {
                body: (alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.parsedBody) || (alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.body)
            }),
            hideFooter: universalLayout === null || universalLayout === void 0 ? void 0 : universalLayout.hideFooter,
            hideHeader: universalLayout === null || universalLayout === void 0 ? void 0 : universalLayout.hideHeader,
            shouldRenderAlphabetNav: universalFooter === null || universalFooter === void 0 ? void 0 : universalFooter.shouldRenderAlphabetNav,
            shouldRenderSeoLinks: universalFooter === null || universalFooter === void 0 ? void 0 : universalFooter.shouldRenderSeoLinks,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackRouting/* TrackRouting */.S, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                    articleStructuredData: articleStructuredData,
                    description: description,
                    openGraphImageUrl: openGraphImageUrl,
                    openToSearchEngines: openToSearchEngines,
                    title: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaControlScript, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilderComponent/* PageBuilderComponent */.bG, {
                    content: content,
                    setPageData: setPageData
                }),
                showSurvey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {})
            ]
        })
    });
}


/***/ }),

/***/ 23391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bG": function() { return /* binding */ PageBuilderComponent; },
  "yM": function() { return /* binding */ useComponentContext; }
});

// UNUSED EXPORTS: ComponentContext, useAsyncData

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/hooks/useDeepCompareEffect.ts
var useDeepCompareEffect = __webpack_require__(52965);
// EXTERNAL MODULE: ./src/rest/zapier/session/data.ts + 1 modules
var data = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/rest/zapier/recommendations/user_profile/data.ts + 1 modules
var user_profile_data = __webpack_require__(56675);
// EXTERNAL MODULE: ./src/rest/zapier/accounts/data.ts + 2 modules
var accounts_data = __webpack_require__(59606);
;// CONCATENATED MODULE: ./src/rest/zapier/session/fixtures.ts


var STATIC_SESSION = {
    banner_message: "",
    current_account_id: 2074697,
    email: "flash.slothmore@zapier.com",
    first_name: "Flash",
    has_activated: true,
    has_active_zaps: true,
    has_signed_up: true,
    id: 10768828,
    identity: -2132949854,
    is_developer: true,
    is_expert: false,
    is_high_value: true,
    is_logged_in: true,
    is_staff: true,
    is_temporary: false,
    last_login: "2022-10-24T00:36:53+00:00",
    last_name: "Slothmore",
    organizations: [
        1
    ],
    photo_url: "https://cdn.zappy.app/bf7a4f6fe39b2b0f80ab567ecaa5ebc7.png",
    primary_organization: 1,
    signup: "2021-08-22T19:55:44+00:00",
    since_signup: "1 year, 2 months",
    timezone: "America/Los_Angeles",
    user_id: 10774996,
    username: "flash.slothmore@zapier.com",
    roles: [
        {
            account_id: 2074697,
            role: "member"
        },
        {
            account_id: 10766258,
            role: "owner"
        }, 
    ]
};
var STATIC_EXTENDED_SESSION = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, STATIC_SESSION), {
    current_account_role: "member"
});
var DEFAULT_SESSION = {
    banner_message: "",
    current_account_id: null,
    email: "",
    first_name: "",
    has_activated: false,
    has_active_zaps: false,
    has_signed_up: false,
    identity: null,
    is_developer: false,
    is_expert: false,
    is_high_value: false,
    is_logged_in: false,
    is_staff: false,
    is_temporary: false,
    last_login: "",
    last_name: "",
    organizations: [
        null
    ],
    photo_url: "",
    primary_organization: null,
    signup: "",
    since_signup: "",
    timezone: "",
    username: ""
};

;// CONCATENATED MODULE: ./src/rest/zapier/accounts/constants.ts



var DEFAULT_ACCOUNT = {
    companies_trial_auto_upgrade: false,
    companies_trial_end_date: null,
    companies_trial_start_date: null,
    company_account_end_date: null,
    company_address: null,
    company_initial_engagement: false,
    created_at: "",
    currency: "",
    first_known_upgrade_date: "",
    has_been_in_companies_trial: false,
    has_modern_pricing_plan: false,
    id: null,
    is_chat_eligible: false,
    is_company_account: false,
    is_in_experts_mvp: false,
    is_premier_chat_eligible: false,
    is_team_account: false,
    is_trialing_companies: false,
    is_trialing_teams: false,
    is_trialing: false,
    is_unlimited: false,
    last_plan_change_at: "",
    logo_url: "",
    name: "",
    offer_returning_trial_extension: false,
    owner: {
        id: null,
        name: "",
        email: ""
    },
    paying: false,
    pays_manually: false,
    period_end: "",
    period_start: "",
    plan_group_id: null,
    plan_info: {
        id: null,
        name: "",
        metered_task_pricing: false,
        interval: "",
        allow_companies: false,
        allow_teams: false,
        allow_import_export: false
    },
    surveys_submitted: {
        company_trial_onboarding: false,
        company_trial_exit: false
    },
    team_account_end_date: null,
    teams_trial_auto_upgrade: false,
    teams_trial_end_date: null,
    trial_auto_upgrade: false,
    trial_end_date: null
};
var STATIC_ACCOUNT = {
    companies_trial_auto_upgrade: false,
    companies_trial_end_date: null,
    companies_trial_start_date: null,
    company_account_end_date: null,
    company_address: null,
    company_initial_engagement: true,
    created_at: "2017-03-14T18:29:35Z",
    currency: "USD",
    first_known_upgrade_date: "2017-03-14 18:29:40+00:00",
    has_been_in_companies_trial: false,
    has_modern_pricing_plan: false,
    id: 2074697,
    is_chat_eligible: false,
    is_company_account: true,
    is_in_experts_mvp: false,
    is_premier_chat_eligible: true,
    is_team_account: true,
    is_trialing_companies: false,
    is_trialing_teams: false,
    is_trialing: false,
    is_unlimited: true,
    last_plan_change_at: "2021-01-20T23:27:52Z",
    logo_url: "https://cdn.zappy.app/ef609ad5f25ec5a10ffb86d64a927aa7.png",
    name: "Zapier",
    offer_returning_trial_extension: false,
    owner: {
        id: 8121946,
        name: "Chief Bogo",
        email: "chief.bogo@zootopia.org"
    },
    paying: true,
    pays_manually: false,
    period_end: "2022-11-30T23:27:49.124248Z",
    period_start: "2022-10-30T23:27:49.124248Z",
    plan_group_id: 53,
    plan_info: {
        id: 322,
        name: "Company",
        metered_task_pricing: true,
        interval: "month",
        allow_companies: true,
        allow_teams: true,
        allow_import_export: true
    },
    surveys_submitted: {
        company_trial_onboarding: false,
        company_trial_exit: false
    },
    team_account_end_date: null,
    teams_trial_auto_upgrade: true,
    teams_trial_end_date: null,
    trial_auto_upgrade: false,
    trial_end_date: null
};
var STATIC_ACCOUNTS = [
    STATIC_ACCOUNT,
    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, STATIC_ACCOUNT), {
        id: 9122541,
        paying: false,
        name: "Personal Account",
        logo_url: "https://cdn.zapier.com/zapier/images/account-default-image.svg",
        owner: {
            id: STATIC_SESSION.id,
            name: "".concat(STATIC_SESSION.first_name, " ").concat(STATIC_SESSION.last_name),
            email: STATIC_SESSION.email
        },
        plan_info: {
            id: 640,
            name: "Free",
            metered_task_pricing: false,
            interval: "month",
            allow_companies: false,
            allow_teams: false,
            allow_import_export: false
        }
    }), 
];

;// CONCATENATED MODULE: ./src/rest/zapier/recommendations/user_profile/constants.ts


var STATIC_USER_PROFILE = {
    role_id: 44,
    company_size_id: 3,
    organization_name: "Zapier",
    inferred_organization_name: "Zapier"
};
var STATIC_EXTENDED_USER_PROFILE = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, STATIC_USER_PROFILE), {
    role_name: "Engineering",
    company_size_display_range: "250-999"
});
var DEFAULT_EXTENDED_USER_PROFILE = {
    role_id: null,
    role_name: "",
    company_size_id: null,
    company_size_display_range: "",
    organization_name: "",
    inferred_organization_name: ""
};

// EXTERNAL MODULE: ./src/components/RichTextHtml/RichTextHtml.tsx
var RichTextHtml = __webpack_require__(8841);
;// CONCATENATED MODULE: ./src/components/PageBuilderComponent.tsx









var ComponentContext = /*#__PURE__*/ (0,react.createContext)({
    asyncData: {}
});
var useComponentContext = function() {
    return (0,react.useContext)(ComponentContext);
};
var PageBuilderComponent = function(param) {
    var content = param.content, setPageData = param.setPageData;
    var ref, ref1;
    var asyncData = useAsyncData(content.dataSets) || {};
    var bindAsyncDataToAlertBanner = function(data) {
        var ref, ref1;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.alertBanner) === null || ref === void 0 ? void 0 : ref.body)) return data;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            alertBanner: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.alertBanner), {
                parsedBody: (0,RichTextHtml/* bindAsyncDataToHTML */.cT)((data === null || data === void 0 ? void 0 : (ref1 = data.alertBanner) === null || ref1 === void 0 ? void 0 : ref1.body) || "", asyncData)
            })
        });
    };
    (0,useDeepCompareEffect/* useDeepCompareEffect */.KW)(function() {
        var ref, ref1;
        if (((ref = content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.alertBanner) === null || ref1 === void 0 ? void 0 : ref1.body) && content.dataSets) {
            setPageData(bindAsyncDataToAlertBanner);
        }
    }, [
        asyncData,
        (ref = content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.alertBanner) === null || ref1 === void 0 ? void 0 : ref1.body,
        setPageData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentContext.Provider, {
        value: {
            asyncData: asyncData,
            dataSets: content.dataSets
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
            contentLoaded: function(data) {
                if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
                    setPageData(bindAsyncDataToAlertBanner(data));
                }
            },
            content: content,
            data: asyncData,
            model: builder_react_es5/* Builder.previewingModel */.Ib.previewingModel || (content === null || content === void 0 ? void 0 : content.model)
        })
    });
};
var useAsyncData = function(dataSets) {
    var router = (0,next_router.useRouter)();
    var ref = (0,data/* useSession */.k)(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.user)), user = ref.data;
    var ref1 = (0,user_profile_data/* useUserProfile */.G)(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.userProfile)), userProfile = ref1.data;
    var ref2 = (0,accounts_data/* useCurrentAccount */.t)(!!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.currentAccount)), currentAccount = ref2.data;
    if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
        return {
            currentAccount: STATIC_ACCOUNT,
            user: STATIC_EXTENDED_SESSION,
            userProfile: STATIC_EXTENDED_USER_PROFILE,
            queryParameters: {
                demo_source: "example_demo_source",
                utm_campaign: "example_utm_campaign",
                utm_medium: "example_utm_medium",
                utm_source: "example_utm_source"
            }
        };
    }
    var _demo_source, _utm_campaign, _utm_medium, _utm_source;
    return {
        currentAccount: (0,_object_spread/* default */.Z)({}, DEFAULT_ACCOUNT, currentAccount),
        user: (0,_object_spread/* default */.Z)({}, DEFAULT_SESSION, user),
        userProfile: (0,_object_spread/* default */.Z)({}, DEFAULT_EXTENDED_USER_PROFILE, userProfile),
        queryParameters: {
            demo_source: (_demo_source = router.query.demo_source) !== null && _demo_source !== void 0 ? _demo_source : "",
            utm_campaign: (_utm_campaign = router.query.utm_campaign) !== null && _utm_campaign !== void 0 ? _utm_campaign : "",
            utm_medium: (_utm_medium = router.query.utm_medium) !== null && _utm_medium !== void 0 ? _utm_medium : "",
            utm_source: (_utm_source = router.query.utm_source) !== null && _utm_source !== void 0 ? _utm_source : ""
        }
    };
};


/***/ }),

/***/ 8841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ RichTextHtml; },
/* harmony export */   "cT": function() { return /* binding */ bindAsyncDataToHTML; },
/* harmony export */   "iY": function() { return /* binding */ DATA_BINDING_REGEX; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47925);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96204);
/* harmony import */ var _zapier_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70776);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76635);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var _PageBuilderComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23391);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n\n    &:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n\n  ul {\n    list-style: none;\n    margin-left: 32px;\n\n    li {\n      position: relative;\n\n      &:before {\n        content: '•';\n        font-weight: bold;\n        display: flex;\n        align-items: baseline;\n        position: absolute;\n        font-size: 16px;\n        margin-left: -1em;\n        height: 100%;\n      }\n\n      &:not(:last-child) {\n        margin: 21px 0;\n      }\n    }\n  }\n\n  ol {\n    list-style: none;\n    margin-left: 32px;\n\n    li {\n      counter-reset: list-1 list-2;\n      counter-increment: list-0;\n\n      &:not(:last-child) {\n        margin: 21px 0;\n      }\n\n      &:before {\n        content: counter(list-0, decimal) '. ';\n        margin-left: -1em;\n      }\n\n      &.ql-indent-1 {\n        counter-increment: list-1;\n        counter-reset: list-2;\n\n        &:before {\n          content: counter(list-1, lower-alpha) '. ';\n        }\n      }\n\n      &.ql-indent-2 {\n        counter-increment: list-2;\n        counter-reset: none;\n\n        &:before {\n          content: counter(list-2, lower-roman) '. ';\n        }\n      }\n    }\n  }\n\n  li.ql-indent-1 {\n    padding-left: 2em;\n  }\n\n  li.ql-indent-2 {\n    padding-left: 4em;\n  }\n\n  p:not(:first-of-type) {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








// regex to match all values between double curly braces with a limit of 100 characters (e.g. {{foo.bar}})
var DATA_BINDING_REGEX = /(\\?)(\{\{(.{0,100}?)\}\})/g;
var bindAsyncDataToHTML = function(html, asyncData) {
    return html === null || html === void 0 ? void 0 : html.replaceAll(DATA_BINDING_REGEX, function(_, escapeCharacter, expression, contents) {
        var ref;
        if (!!escapeCharacter || !asyncData) {
            return expression;
        }
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(contents.split("||").map(function(s) {
            return s.trim();
        }), 2), path = ref1[0], fallbackValue = ref1[1];
        if (!(_builder_io_react__WEBPACK_IMPORTED_MODULE_3__/* .Builder.isEditing */ .Ib.isEditing && path.endsWith("help"))) {
            return (0,lodash__WEBPACK_IMPORTED_MODULE_4__.get)(asyncData, path) || fallbackValue || "";
        }
        /**
       * If path is just 'help', show the entire asyncData object,
       * otherwise show the value at the path with .help removed from the end
       */ var value = path === "help" ? asyncData : (0,lodash__WEBPACK_IMPORTED_MODULE_4__.get)(asyncData, (ref = path.split(".")) === null || ref === void 0 ? void 0 : ref.slice(0, -1)) || fallbackValue || "";
        // HTML to show in the editor if 'help' is provided as the key
        return "<code>\n      <div>Available keys:</div>\n      ".concat(Object.keys(value || {}).map(function(key) {
            return "<li>".concat(key, "</li>");
        }).join(""), "\n      </code>");
    });
};
var RichTextHtml = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.forwardRef)(function(props, ref) {
    var _$ref = (0,_PageBuilderComponent__WEBPACK_IMPORTED_MODULE_7__/* .useComponentContext */ .yM)(), asyncData = _$ref.asyncData, dataSets = _$ref.dataSets;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RichText, {
        dangerouslySetInnerHTML: {
            __html: dataSets || _builder_io_react__WEBPACK_IMPORTED_MODULE_3__/* .Builder.isEditing */ .Ib.isEditing || _builder_io_react__WEBPACK_IMPORTED_MODULE_3__/* .Builder.isPreviewing */ .Ib.isPreviewing ? bindAsyncDataToHTML(props.html, asyncData) : props.html
        },
        backgroundColor: props.backgroundColor,
        ref: ref
    });
});
function getLinkColor(param) {
    var backgroundColor = param.backgroundColor;
    if (!_constants__WEBPACK_IMPORTED_MODULE_8__/* .LIGHT_BACKGROUND_COLORS.some */ .Z5.some(function(color) {
        return color === backgroundColor;
    })) {
        return "inherit";
    }
    return _zapier_design_system__WEBPACK_IMPORTED_MODULE_9__/* .Colors.blue */ .w.blue;
}
function getLinkHoverColor(param) {
    var backgroundColor = param.backgroundColor;
    if (!_constants__WEBPACK_IMPORTED_MODULE_8__/* .LIGHT_BACKGROUND_COLORS.some */ .Z5.some(function(color) {
        return color === backgroundColor;
    })) {
        return "inherit";
    }
    return _zapier_design_system__WEBPACK_IMPORTED_MODULE_9__/* .Colors.night */ .w.night;
}
var RichText = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), getLinkColor, getLinkHoverColor);


/***/ }),

/***/ 37151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ UniversalLayout_UniversalLayout; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/AnnualBillingUpsell.js
var AnnualBillingUpsell_namespaceObject = {};
__webpack_require__.r(AnnualBillingUpsell_namespaceObject);
__webpack_require__.d(AnnualBillingUpsell_namespaceObject, {
  "Component": function() { return Component; },
  "shouldRender": function() { return shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/BannerMessage.js
var BannerMessage_namespaceObject = {};
__webpack_require__.r(BannerMessage_namespaceObject);
__webpack_require__.d(BannerMessage_namespaceObject, {
  "Component": function() { return BannerMessage_Component; },
  "shouldRender": function() { return BannerMessage_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/CompaniesTrialEnded.js
var CompaniesTrialEnded_namespaceObject = {};
__webpack_require__.r(CompaniesTrialEnded_namespaceObject);
__webpack_require__.d(CompaniesTrialEnded_namespaceObject, {
  "Component": function() { return CompaniesTrialEnded_Component; },
  "shouldRender": function() { return CompaniesTrialEnded_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/CompaniesTrialing.js
var CompaniesTrialing_namespaceObject = {};
__webpack_require__.r(CompaniesTrialing_namespaceObject);
__webpack_require__.d(CompaniesTrialing_namespaceObject, {
  "Component": function() { return CompaniesTrialing_Component; },
  "shouldRender": function() { return CompaniesTrialing_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/ProfessionalTrialEnded.js
var ProfessionalTrialEnded_namespaceObject = {};
__webpack_require__.r(ProfessionalTrialEnded_namespaceObject);
__webpack_require__.d(ProfessionalTrialEnded_namespaceObject, {
  "Component": function() { return ProfessionalTrialEnded_Component; },
  "shouldRender": function() { return ProfessionalTrialEnded_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/ProfessionalTrialing.js
var ProfessionalTrialing_namespaceObject = {};
__webpack_require__.r(ProfessionalTrialing_namespaceObject);
__webpack_require__.d(ProfessionalTrialing_namespaceObject, {
  "Component": function() { return ProfessionalTrialing_Component; },
  "shouldRender": function() { return ProfessionalTrialing_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/RefreshRequired.js
var RefreshRequired_namespaceObject = {};
__webpack_require__.r(RefreshRequired_namespaceObject);
__webpack_require__.d(RefreshRequired_namespaceObject, {
  "Component": function() { return RefreshRequired_Component; },
  "shouldRender": function() { return RefreshRequired_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsDowngraded.js
var TeamsDowngraded_namespaceObject = {};
__webpack_require__.r(TeamsDowngraded_namespaceObject);
__webpack_require__.d(TeamsDowngraded_namespaceObject, {
  "Component": function() { return TeamsDowngraded_Component; },
  "shouldRender": function() { return TeamsDowngraded_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsTrialEnded.js
var TeamsTrialEnded_namespaceObject = {};
__webpack_require__.r(TeamsTrialEnded_namespaceObject);
__webpack_require__.d(TeamsTrialEnded_namespaceObject, {
  "Component": function() { return TeamsTrialEnded_Component; },
  "shouldRender": function() { return TeamsTrialEnded_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/OverdueInvoice.js
var OverdueInvoice_namespaceObject = {};
__webpack_require__.r(OverdueInvoice_namespaceObject);
__webpack_require__.d(OverdueInvoice_namespaceObject, {
  "Component": function() { return OverdueInvoice_Component; },
  "shouldRender": function() { return OverdueInvoice_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsTrialing.js
var TeamsTrialing_namespaceObject = {};
__webpack_require__.r(TeamsTrialing_namespaceObject);
__webpack_require__.d(TeamsTrialing_namespaceObject, {
  "Component": function() { return TeamsTrialing_Component; },
  "shouldRender": function() { return TeamsTrialing_shouldRender; }
});

// NAMESPACE OBJECT: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/UnlimitedAccount.js
var UnlimitedAccount_namespaceObject = {};
__webpack_require__.r(UnlimitedAccount_namespaceObject);
__webpack_require__.d(UnlimitedAccount_namespaceObject, {
  "Component": function() { return UnlimitedAccount_Component; },
  "shouldRender": function() { return UnlimitedAccount_shouldRender; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/withModifier.js
var withModifier = __webpack_require__(52676);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/isolateComponent.js + 1 modules
var isolateComponent = __webpack_require__(77293);
// EXTERNAL MODULE: ../../node_modules/@zapier/identity/dist/identity.esm.js
var identity_esm = __webpack_require__(38716);
// EXTERNAL MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/constants/index.js
var constants = __webpack_require__(84649);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Link/Link.js + 1 modules
var Link = __webpack_require__(36394);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(73356);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/isEmptyObject.js
const isEmptyObject = (value) => {
    return (value == null ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
//# sourceMappingURL=isEmptyObject.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/common-hooks/dist/index.js
var dist = __webpack_require__(22193);
// EXTERNAL MODULE: ../../node_modules/@zapier/responsive-utils/dist/index.js
var responsive_utils_dist = __webpack_require__(87865);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/constants/links.js
const dashboardLink = {
    href: '/app/dashboard',
    icon: 'navDashboard',
    text: 'Dashboard',
};
const zapsLink = {
    href: '/app/zaps',
    icon: 'miscBoltAlt',
    text: 'Zaps',
};
const myAppsLink = {
    href: '/app/connections',
    icon: 'navApps',
    text: 'My Apps',
};
const historyLink = {
    href: '/app/history/usage',
    icon: 'miscClock',
    text: 'Zap History',
};
const exploreLinkInternal = {
    href: '/explore',
    icon: 'navExplore',
    text: 'Explore',
};
const helpLink = {
    href: '/help',
    icon: 'navHelp',
    isExternal: true,
    text: 'Get Help',
};
const usageLink = {
    href: '/app/settings/billing',
    icon: 'miscWallet',
    text: 'Usage',
};
const transferLink = {
    href: '/app/transfers',
    icon: 'arrowConnect',
    text: 'Transfers',
};
const moveZapsLink = {
    href: '/app/move-zaps/',
    icon: 'arrowBigRight',
    text: 'Move Zaps',
};
const settingsLink = {
    href: '/app/settings/profile',
    icon: 'navCog',
    text: 'Settings',
};
const logOutLink = {
    href: '/logout',
    icon: 'arrowExit',
    text: 'Log Out',
};
const UniversalSidebarLinks = (sideNavData) => [
    dashboardLink,
    zapsLink,
    transferLink,
    ...sideNavData,
    myAppsLink,
    historyLink,
    exploreLinkInternal,
    helpLink,
];
const AccountsMenuLinks = [
    settingsLink,
    logOutLink,
];
const topNavFallbackData = {
    topBarMenu: [
        {
            text: 'Solutions',
            href: null,
            submenu: [
                {
                    text: 'By role',
                    href: null,
                    icon: 'personOne',
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/solutions/marketing',
                        },
                        {
                            text: 'Business owners',
                            href: '/solutions/business-owner',
                        },
                        {
                            text: 'IT',
                            href: '/solutions/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/solutions/sales',
                        },
                    ],
                },
                {
                    text: 'By workflow',
                    href: null,
                    icon: 'navBriefcase',
                    submenu: [
                        {
                            text: 'Lead management',
                            href: '/solutions/lead-management',
                        },
                        {
                            text: 'Customer communications',
                            href: '/solutions/customer-communication',
                        },
                        {
                            text: 'Internal processes',
                            href: '/solutions/internal-processes',
                        },
                        {
                            text: 'Data management',
                            href: '/solutions/data-management',
                        },
                    ],
                },
                {
                    text: 'By company size',
                    href: null,
                    icon: 'navExplore',
                    submenu: [
                        {
                            text: 'Startups',
                            href: '/solutions/startups',
                        },
                        {
                            text: 'Small & medium businesses',
                            href: '/solutions/smb',
                        },
                        {
                            text: 'Enterprise',
                            href: '/solutions/enterprise',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Contact Sales',
                    icon: 'actionCalendar',
                    href: '/l/contact-sales?demo_source=cs_nav_menu_solutions',
                },
                {
                    text: 'Explore app integrations',
                    icon: 'actionExplore',
                    href: '/apps',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Streamline team comms',
                    href: '/customer-stories/calendly',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/20cbb6de7db26e259a378a859c8ea53b.png',
                    description: "How automation saves Calendly's team 10+ hours a week",
                    altText: "Calendly's logo.",
                },
                {
                    type: 'article-stub',
                    text: 'Drive growth—at scale',
                    href: '/customer-stories/fellow',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/b11de6045680c6b971d4b7ebeda65d16.png',
                    description: 'How Fellow onboards wholesale customers 4x faster',
                    altText: 'Close-up of a person sitting at a desk in front of an open laptop and looking off to the side at a document. Natural light is streaming through the windows in the background.',
                },
            ],
        },
        {
            text: 'Resources & Support',
            href: null,
            submenu: [
                {
                    text: 'By role',
                    href: null,
                    icon: 'fileGuide',
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/resources/marketing',
                        },
                        {
                            text: 'Business owners',
                            href: '/resources/business-owner',
                        },
                        {
                            text: 'IT',
                            href: '/resources/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/resources/sales',
                        },
                    ],
                },
                {
                    text: 'Learn more',
                    href: null,
                    icon: 'miscLearn',
                    submenu: [
                        {
                            text: 'Blog',
                            href: '/blog/',
                        },
                        {
                            text: 'Zapier University',
                            href: '/university',
                        },
                        {
                            text: 'Events and webinars',
                            href: '/resources/events',
                        },
                        {
                            text: 'Customer stories',
                            href: '/customer-stories',
                        },
                        {
                            text: 'Zapier guides',
                            href: '/resources/guides',
                        },
                    ],
                },
                {
                    text: 'Get help',
                    href: null,
                    icon: 'navHelp',
                    submenu: [
                        {
                            text: 'Help Center',
                            href: '/help',
                        },
                        {
                            text: 'Community',
                            href: 'https://community.zapier.com/',
                        },
                        {
                            text: 'Hire an Expert',
                            href: '/experts',
                        },
                        {
                            text: 'Support Services',
                            href: '/l/support-services',
                        },
                        {
                            text: 'Contact Support',
                            href: '/get-help',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Contact Sales',
                    icon: 'actionCalendar',
                    href: '/l/contact-sales?demo_source=cs_nav_menu_resources',
                },
                {
                    text: 'Explore app integrations',
                    icon: 'actionExplore',
                    href: '/apps',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Zapier quick-start guide',
                    href: '/learn/zapier-quick-start-guide',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/8d754b5e8481fdd190dd7b1cf7738a8d.png',
                    description: 'Create your first Zap with ease',
                    altText: "A simplified user interface design representing a portion of Zapier's platform. There's a vertical menu of platform options. At the top is a dominant orange button with text inside that reads \"Create Zap.\" Beneath the button is a stack of menu icons to represent Zapier's dashboard and zaps.",
                },
                {
                    type: 'link-list',
                    text: 'Developer resources',
                    href: null,
                    links: [
                        {
                            text: 'Build an integration',
                            href: '/platform/how-to-build',
                        },
                        {
                            text: 'Documentation',
                            href: 'https://platform.zapier.com/docs/zapier-intro',
                        },
                        {
                            text: 'Embedded integrations',
                            href: '/partner/solutions',
                        },
                        {
                            text: 'Integration Partner Program',
                            href: '/platform/partner-program',
                        },
                    ],
                },
            ],
        },
        {
            text: 'Teams & Companies',
            href: '/teams-companies',
        },
        {
            text: 'Pricing',
            href: '/pricing',
        },
    ],
};
//# sourceMappingURL=links.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/getHostname.js
const getHostname = (location) => {
    var _a;
    const hostname = location ? location.hostname : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    return hostname || '';
};
//# sourceMappingURL=getHostname.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/getServerUrl.js

const DESIGN_SYSTEM_SERVER_URLS = {
    production: 'https://design-system-bff.zapier.com',
    staging: 'https://design-system-bff.zapier-staging.com',
    localhost: 'http://localhost:8000',
};
const getServerUrl = () => {
    const hostname = getHostname();
    if (hostname.endsWith('zapier.com')) {
        return DESIGN_SYSTEM_SERVER_URLS.production;
    }
    else if (hostname.endsWith('zapier-staging.com')) {
        return DESIGN_SYSTEM_SERVER_URLS.staging;
    }
    else if (hostname === 'localhost') {
        return DESIGN_SYSTEM_SERVER_URLS.localhost;
    }
    return DESIGN_SYSTEM_SERVER_URLS.staging;
};
//# sourceMappingURL=getServerUrl.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/hooks/useTopNav.js




const useTopNav = (zapidentity) => {
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const [topNav, setTopNav] = (0,react.useState)(topNavFallbackData);
    (0,react.useEffect)(() => {
        let apiSubscribed = true;
        async function getTopnavData() {
            const serverUrl = getServerUrl();
            const topnavUrl = `${serverUrl}/navigation-data/topbar`;
            const fetchData = {
                headers: { 'x-zapidentity-id': zapidentity.toString() },
            };
            try {
                setIsLoading(true);
                const response = await fetch(topnavUrl, fetchData);
                if (!response.ok) {
                    throw new Error('Response was not OK');
                }
                if (apiSubscribed) {
                    const json = await response.json();
                    const { data } = json;
                    if (!isEmptyObject(data))
                        setTopNav(data);
                }
            }
            catch (error) {
                if (apiSubscribed) {
                    setTopNav(topNavFallbackData);
                }
            }
            finally {
                if (apiSubscribed) {
                    setIsLoading(false);
                }
            }
        }
        getTopnavData();
        return () => {
            apiSubscribed = false;
        };
    }, [zapidentity]);
    return { isLoading, topNav };
};
//# sourceMappingURL=useTopNav.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/readCookie.js
var readCookie = __webpack_require__(59251);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/hooks/useUniversalNavContext.js








const defaultContext = {
    canForceSidebarOpen: false,
    canTopbarFitBackToAppButton: false,
    canTopbarFitLinks: false,
    currentAccountId: undefined,
    currentUrl: '',
    isLoadingLoggedIn: true,
    isLoadingTopNav: true,
    isLoggedIn: false,
    isOnAppPage: false,
    isMyZapsButtonHidden: false,
    isSearchFullWidth: true,
    isSidebarControlledByTopbar: false,
    isSidebarForcedOpen: false,
    isSidebarOpenedByTopbar: false,
    isSidebarRendered: false,
    onToggleSidebarVisibility: () => { },
    setIsSidebarForcedOpen: () => { },
    setIsSidebarOpenedByTopbar: () => { },
    setIsSidebarRendered: () => { },
    shouldRenderCallToAction: false,
    shouldRenderSearch: true,
    shouldRenderSidebar: false,
    shouldRenderAccessibleSidebar: false,
    shouldRenderTopbarLinks: false,
    shouldRenderTOS: false,
    shouldRenderUniversalNav: true,
    sidebarWidth: 0,
    topbarSize: 'medium',
    topNavData: {},
    useQuery: () => { },
    getFullyQualifiedURL: (path) => path || undefined,
};
const UniversalNavContext = (0,react.createContext)(defaultContext);
const useUniversalNavContext = () => (0,react.useContext)(UniversalNavContext);
const isAuthenticatedQuery = lib/* default */.ZP `
  query isAuthenticatedQuery {
    isAuthenticatedV2
  }
`;
const isCurrentUrlAnAuthPage = (currentUrl) => {
    return (currentUrl.includes('/login') ||
        currentUrl.includes('/sign-up') ||
        currentUrl.includes('/oauth/authorize'));
};
const isCurrentUrlAnAppPage = (currentUrl, mode) => {
    if (mode) {
        return mode === 'in-app' ? true : false;
    }
    return currentUrl.includes('/app/');
};
const isCurrentUrlAnOnboardingPage = (currentUrl) => {
    return currentUrl.includes('/app/onboarding');
};
const shouldRenderSidebarForRoute = ({ currentUrl, mode, }) => {
    return (isCurrentUrlAnAppPage(currentUrl, mode) &&
        !isCurrentUrlAnAuthPage(currentUrl) &&
        !isCurrentUrlAnOnboardingPage(currentUrl));
};
const shouldRenderTopbarLinksForRoute = ({ currentUrl, mode, }) => {
    return (!isCurrentUrlAnAppPage(currentUrl, mode) &&
        !isCurrentUrlAnAuthPage(currentUrl));
};
const getShouldRenderSidebar = ({ isLoggedIn, canTopbarFitLinks, currentUrl, isSidebarControlledByTopbar, isSidebarOpenedByTopbar, mode, }) => {
    if (isSidebarControlledByTopbar) {
        return isSidebarOpenedByTopbar;
    }
    if (mode && mode === 'navigation') {
        return canTopbarFitLinks === false ? true : false;
    }
    if (mode && mode === 'in-app' && isLoggedIn) {
        return true;
    }
    if (isLoggedIn && shouldRenderSidebarForRoute({ currentUrl, mode })) {
        return true;
    }
    if (!canTopbarFitLinks &&
        shouldRenderTopbarLinksForRoute({ currentUrl, mode })) {
        return true;
    }
    return false;
};
const getShouldRenderAccessibleSidebar = ({ isLoggedIn, canTopbarFitLinks, currentUrl, isSidebarControlledByTopbar, isSidebarOpenedByTopbar, mode, }) => {
    if (isSidebarControlledByTopbar) {
        return !isSidebarOpenedByTopbar;
    }
    if (mode && mode === 'navigation') {
        return canTopbarFitLinks === false ? true : false;
    }
    if (mode && mode === 'in-app' && isLoggedIn && canTopbarFitLinks) {
        return false;
    }
    if (isLoggedIn &&
        shouldRenderSidebarForRoute({ currentUrl, mode }) &&
        !canTopbarFitLinks) {
        return true;
    }
    if (!canTopbarFitLinks &&
        shouldRenderTopbarLinksForRoute({ currentUrl, mode })) {
        return true;
    }
    return false;
};
const getShouldRenderSearch = ({ currentUrl }) => {
    if (isCurrentUrlAnAuthPage(currentUrl) ||
        isCurrentUrlAnOnboardingPage(currentUrl)) {
        return false;
    }
    return true;
};
const getShouldRenderTopbarToggle = ({ isSidebarControlledByTopbar, isLoggedIn, currentUrl, mode, }) => {
    if (!isSidebarControlledByTopbar) {
        return false;
    }
    if (isLoggedIn) {
        return true;
    }
    return shouldRenderTopbarLinksForRoute({
        currentUrl,
        mode,
    });
};
const getSidebarWidth = ({ canForceSidebarOpen, isSidebarForcedOpen, isSidebarRendered, isSidebarControlledByTopbar, }) => {
    if (!isSidebarRendered || isSidebarControlledByTopbar) {
        return 0;
    }
    if (canForceSidebarOpen && isSidebarForcedOpen) {
        return constants/* UNIVERSAL_SIDEBAR_WIDTH */.Z;
    }
    return constants/* UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH */.Cq;
};
const UniversalNavProvider = (props) => {
    const zapid = (0,readCookie/* readCookie */.v)('zapidentity');
    const { isLoading: isLoadingTopNav, topNav } = useTopNav(zapid || '');
    const { currentUrl, useQuery, urlPathPrefix, mode, shouldRenderTOS, isMyZapsButtonHidden, } = props;
    const isOnAppPage = isCurrentUrlAnAppPage(currentUrl, mode);
    const { isSearchFullWidth, isSidebarControlledByTopbar, canForceSidebarOpen, canTopbarFitBackToAppButton, canTopbarFitLinks, topbarSize, } = (0,responsive_utils_dist/* useMediaProps */.Oh)({
        '(min-width: 0px)': {
            isSidebarControlledByTopbar: true,
            isSearchFullWidth: true,
            canForceSidebarOpen: false,
            canTopbarFitBackToAppButton: false,
            canTopbarFitLinks: false,
            topbarSize: 'small',
        },
        '(min-width: 450px)': {
            canTopbarFitBackToAppButton: isEmptyObject(topNav.callToAction),
            topbarSize: isEmptyObject(topNav.callToAction) ? 'medium' : 'small',
        },
        '(min-width: 650px)': {
            canTopbarFitBackToAppButton: true,
            topbarSize: 'medium',
        },
        '(min-width: 1040px)': {
            isSidebarControlledByTopbar: false,
            isSearchFullWidth: false,
            canTopbarFitLinks: true,
        },
        '(min-width: 1280px)': {
            canForceSidebarOpen: shouldRenderSidebarForRoute({ currentUrl, mode }),
        },
    });
    const shouldRenderTopbarLinks = canTopbarFitLinks &&
        shouldRenderTopbarLinksForRoute({
            currentUrl,
            mode,
        });
    const authResult = useQuery(isAuthenticatedQuery, {
        fetchPolicy: 'cache-and-network',
        ssr: false,
    });
    const isLoggedIn = !!authResult.data && authResult.data.isAuthenticatedV2;
    const [isSidebarOpenedByTopbar, setIsSidebarOpenedByTopbar] = (0,react.useState)(false);
    const [isSidebarForcedOpen, setIsSidebarForcedOpen] = (0,dist/* useLocalStorage */._)('UniversalNav:isSidebarForcedOpen');
    (0,react.useEffect)(() => {
        if (isSidebarForcedOpen === null || isSidebarForcedOpen === undefined) {
            setIsSidebarForcedOpen(true);
        }
    }, [isSidebarForcedOpen, setIsSidebarForcedOpen]);
    const [isSidebarRendered, setIsSidebarRendered] = (0,react.useState)(false);
    const shouldRenderSidebar = getShouldRenderSidebar({
        isLoggedIn,
        canTopbarFitLinks,
        currentUrl,
        isSidebarControlledByTopbar,
        isSidebarOpenedByTopbar,
        mode,
    });
    const shouldRenderAccessibleSidebar = getShouldRenderAccessibleSidebar({
        isLoggedIn,
        canTopbarFitLinks,
        currentUrl,
        isSidebarControlledByTopbar,
        isSidebarOpenedByTopbar,
        mode,
    });
    const shouldRenderSearch = getShouldRenderSearch({
        currentUrl,
    });
    const shouldRenderTopbarToggle = getShouldRenderTopbarToggle({
        isSidebarControlledByTopbar,
        isLoggedIn,
        currentUrl,
    });
    const onToggleSidebarVisibility = shouldRenderTopbarToggle
        ? () => {
            setIsSidebarOpenedByTopbar(!isSidebarOpenedByTopbar);
        }
        : undefined;
    const sidebarWidth = getSidebarWidth({
        canForceSidebarOpen,
        isSidebarForcedOpen,
        isSidebarRendered,
        isSidebarControlledByTopbar,
    });
    const memoizedFullyQualifiedUrl = (0,react.useCallback)((link) => {
        if (link && urlPathPrefix && link.startsWith('/'))
            return urlPathPrefix + link;
        return link || undefined;
    }, [urlPathPrefix]);
    const value = {
        currentAccountId: props.currentAccountId,
        isLoadingLoggedIn: authResult.loading,
        isLoadingTopNav,
        canTopbarFitBackToAppButton,
        canTopbarFitLinks,
        canForceSidebarOpen,
        currentUrl,
        isLoggedIn,
        isOnAppPage,
        isMyZapsButtonHidden,
        isSearchFullWidth,
        isSidebarControlledByTopbar,
        isSidebarOpenedByTopbar,
        isSidebarForcedOpen: canForceSidebarOpen && isSidebarRendered ? isSidebarForcedOpen : false,
        isSidebarRendered,
        mode,
        onToggleSidebarVisibility,
        setIsSidebarOpenedByTopbar,
        setIsSidebarForcedOpen,
        setIsSidebarRendered,
        shouldRenderCallToAction: !isCurrentUrlAnOnboardingPage(currentUrl),
        shouldRenderSearch,
        shouldRenderSidebar,
        shouldRenderAccessibleSidebar,
        shouldRenderTopbarLinks,
        shouldRenderTOS,
        shouldRenderUniversalNav: true,
        sidebarWidth,
        topbarSize,
        topNavData: topNav,
        useQuery,
        urlPathPrefix,
        getFullyQualifiedURL: memoizedFullyQualifiedUrl,
    };
    return (react.createElement(UniversalNavContext.Provider, { value: value }, props.children));
};
//# sourceMappingURL=useUniversalNavContext.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/AlphabeticAppNav/AlphabeticAppNav.js




const Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-columns: 100%;
    gap: 10px;
    justify-items: center;
    ${Typography/* Typography.smallPrint3 */.ZT.smallPrint3};
    text-align: center;

    @media screen and (min-width: 650px) {
      gap: 20px;
    }
  `,
    title: emotion_react_browser_esm/* css */.iv `
    color: ${Colors/* Colors.neutral800 */.w.neutral800};
    ${Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold};
  `,
    links: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  `,
    link: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3}
    // Increase hit size.
    display: block;
    padding: 0px;
    margin: 0px 10px;
    white-space: nowrap;
    flex: none;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors/* Colors.blue */.w.blue};
      outline: none;
    }

    @media screen and (max-width: 768px) {
      margin: 0px 6px;
    }
  `,
};
const letters = ['0–9', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];
const AlphabeticAppNav = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkItems = letters.map((letter) => {
        const href = `${props.baseUrl}/${letter.toLowerCase()}`
            .replace('//', '/')
            .replace('–', '-');
        return ((0,isolateComponent/* isolateComponent */.U)("li", { key: letter },
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { ariaLabel: `${letter} — Apps beginning with ${letter}`, color: null, css: Styles.link, href: getFullyQualifiedURL(href) }, letter)));
    });
    return ((0,isolateComponent/* isolateComponent */.U)("section", { css: Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("h2", { css: Styles.title }, props.title),
        (0,isolateComponent/* isolateComponent */.U)("ul", { css: Styles.links }, linkItems)));
};
AlphabeticAppNav.defaultProps = {
    baseUrl: '/find-apps/',
    title: 'Apps by Title',
};
//# sourceMappingURL=AlphabeticAppNav.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/VisuallyHidden/VisuallyHidden.js
var VisuallyHidden = __webpack_require__(18672);
// EXTERNAL MODULE: ../../node_modules/@zapier/style-encapsulation/esm/labelStyles.js
var labelStyles = __webpack_require__(39479);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ZapierLogo/ZapierLogo.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const ZapierLogo_Styles = (0,labelStyles/* labelStyles */.B)('ZapierLogo', {
    root: { display: 'block' },
});
const getLogo = (_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    switch (variant) {
        case 'wordmark-horizontal-inverse':
            return ((0,isolateComponent/* isolateComponent */.U)("svg", { css: ZapierLogo_Styles.root, width: props.width, height: props.height, "data-testid": "ZapierLogo", viewBox: "0 0 244 66", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M57.1877 45.2253L57.1534 45.1166L78.809 25.2914V15.7391H44.0663V25.2914H64.8181L64.8524 25.3829L43.4084 45.2253V54.7775H79.1579V45.2253H57.1877Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M100.487 14.8297C96.4797 14.8297 93.2136 15.434 90.6892 16.6429C88.3376 17.6963 86.3568 19.4321 85.0036 21.6249C83.7091 23.8321 82.8962 26.2883 82.6184 28.832L93.1602 30.3135C93.5415 28.0674 94.3042 26.4754 95.4482 25.5373C96.7486 24.5562 98.3511 24.0605 99.9783 24.136C102.118 24.136 103.67 24.7079 104.634 25.8519C105.59 26.9959 106.076 28.5803 106.076 30.6681V31.7091H95.9401C90.7807 31.7091 87.0742 32.8531 84.8206 35.1411C82.5669 37.429 81.442 40.4492 81.4458 44.2014C81.4458 48.0452 82.5707 50.9052 84.8206 52.7813C87.0704 54.6574 89.8999 55.5897 93.3089 55.5783C97.5379 55.5783 100.791 54.1235 103.067 51.214C104.412 49.426 105.372 47.3793 105.887 45.2024H106.27L107.723 54.7546H117.275V30.5651C117.275 25.5659 115.958 21.6936 113.323 18.948C110.688 16.2024 106.409 14.8297 100.487 14.8297ZM103.828 44.6475C102.312 45.9116 100.327 46.5408 97.8562 46.5408C95.8199 46.5408 94.4052 46.1843 93.6121 45.4712C93.2256 45.1338 92.9182 44.7155 92.7116 44.246C92.505 43.7764 92.4043 43.2671 92.4166 42.7543C92.3941 42.2706 92.4702 41.7874 92.6403 41.3341C92.8104 40.8808 93.071 40.4668 93.4062 40.1174C93.7687 39.7774 94.1964 39.5145 94.6633 39.3444C95.1303 39.1743 95.6269 39.1006 96.1231 39.1278H106.093V39.7856C106.113 40.7154 105.919 41.6374 105.527 42.4804C105.134 43.3234 104.553 44.0649 103.828 44.6475Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M175.035 15.7391H163.75V54.7833H175.035V15.7391Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M241.666 15.7391C238.478 15.7391 235.965 16.864 234.127 19.1139C232.808 20.7307 231.805 23.1197 231.118 26.2809H230.787L229.311 15.7391H219.673V54.7775H230.958V34.7578C230.958 32.2335 231.549 30.2982 232.731 28.9521C233.914 27.606 236.095 26.933 239.275 26.933H243.559V15.7391H241.666Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M208.474 17.0147C205.839 15.4474 202.516 14.6657 198.504 14.6695C192.189 14.6695 187.247 16.4675 183.678 20.0634C180.109 23.6593 178.324 28.6166 178.324 34.9352C178.233 38.7553 179.067 42.5407 180.755 45.9689C182.3 49.0238 184.706 51.5592 187.676 53.2618C190.666 54.9892 194.222 55.8548 198.344 55.8586C201.909 55.8586 204.887 55.3095 207.278 54.2113C209.526 53.225 211.483 51.6791 212.964 49.7211C214.373 47.7991 215.42 45.6359 216.053 43.3377L206.329 40.615C205.92 42.1094 205.132 43.4728 204.041 44.5732C202.943 45.6714 201.103 46.2206 198.521 46.2206C195.451 46.2206 193.163 45.3416 191.657 43.5837C190.565 42.3139 189.878 40.5006 189.575 38.1498H216.201C216.31 37.0515 216.367 36.1306 216.367 35.387V32.9561C216.432 29.6903 215.757 26.4522 214.394 23.4839C213.118 20.7799 211.054 18.5248 208.474 17.0147ZM198.178 23.9758C202.754 23.9758 205.349 26.2275 205.963 30.731H189.775C190.032 29.2284 190.655 27.8121 191.589 26.607C193.072 24.8491 195.268 23.972 198.178 23.9758Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M169.515 0.00366253C168.666 -0.0252113 167.82 0.116874 167.027 0.421484C166.234 0.726094 165.511 1.187 164.899 1.77682C164.297 2.3723 163.824 3.08658 163.512 3.87431C163.2 4.66204 163.055 5.50601 163.086 6.35275C163.056 7.20497 163.201 8.05433 163.514 8.84781C163.826 9.64129 164.299 10.3619 164.902 10.9646C165.505 11.5673 166.226 12.0392 167.02 12.3509C167.814 12.6626 168.663 12.8074 169.515 12.7762C170.362 12.8082 171.206 12.6635 171.994 12.3514C172.782 12.0392 173.496 11.5664 174.091 10.963C174.682 10.3534 175.142 9.63077 175.446 8.83849C175.75 8.04621 175.89 7.20067 175.859 6.35275C175.898 5.50985 175.761 4.66806 175.456 3.88115C175.151 3.09424 174.686 2.37951 174.09 1.78258C173.493 1.18565 172.779 0.719644 171.992 0.414327C171.206 0.109011 170.364 -0.0288946 169.521 0.00938803L169.515 0.00366253Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M146.201 14.6695C142.357 14.6695 139.268 15.8764 136.935 18.2902C135.207 20.0786 133.939 22.7479 133.131 26.2981H132.771L131.295 15.7563H121.657V66H132.942V45.3054H133.354C133.698 46.6852 134.181 48.0267 134.795 49.3093C135.75 51.3986 137.316 53.1496 139.286 54.3314C141.328 55.446 143.629 56.0005 145.955 55.9387C150.68 55.9387 154.277 54.0988 156.748 50.419C159.219 46.7392 160.455 41.6046 160.455 35.0153C160.455 28.6509 159.259 23.6689 156.869 20.0691C154.478 16.4694 150.922 14.6695 146.201 14.6695ZM147.345 42.9602C146.029 44.8668 143.97 45.8201 141.167 45.8201C140.012 45.8735 138.86 45.6507 137.808 45.1703C136.755 44.6898 135.832 43.9656 135.116 43.0574C133.655 41.2233 132.927 38.7122 132.931 35.5243V34.7807C132.931 31.5432 133.659 29.0646 135.116 27.3448C136.572 25.625 138.59 24.7747 141.167 24.7937C144.02 24.7937 146.092 25.6994 147.385 27.5107C148.678 29.322 149.324 31.8483 149.324 35.0896C149.332 38.4414 148.676 41.065 147.356 42.9602H147.345Z", fill: "#FFFDF9" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M39.0441 45.2253H0V54.789H39.0441V45.2253Z", fill: "#FF4F00" })));
        default:
            return ((0,isolateComponent/* isolateComponent */.U)("svg", { css: ZapierLogo_Styles.root, width: props.width, height: props.height, "data-testid": "ZapierLogo", viewBox: "0 0 244 66", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M57.1877 45.2253L57.1534 45.1166L78.809 25.2914V15.7391H44.0663V25.2914H64.8181L64.8524 25.3829L43.4084 45.2253V54.7775H79.1579V45.2253H57.1877Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M100.487 14.8297C96.4797 14.8297 93.2136 15.434 90.6892 16.6429C88.3376 17.6963 86.3568 19.4321 85.0036 21.6249C83.7091 23.8321 82.8962 26.2883 82.6184 28.832L93.1602 30.3135C93.5415 28.0674 94.3042 26.4754 95.4482 25.5373C96.7486 24.5562 98.3511 24.0605 99.9783 24.136C102.118 24.136 103.67 24.7079 104.634 25.8519C105.59 26.9959 106.076 28.5803 106.076 30.6681V31.7091H95.9401C90.7807 31.7091 87.0742 32.8531 84.8206 35.1411C82.5669 37.429 81.442 40.4492 81.4458 44.2014C81.4458 48.0452 82.5707 50.9052 84.8206 52.7813C87.0704 54.6574 89.8999 55.5897 93.3089 55.5783C97.5379 55.5783 100.791 54.1235 103.067 51.214C104.412 49.426 105.372 47.3793 105.887 45.2024H106.27L107.723 54.7546H117.275V30.5651C117.275 25.5659 115.958 21.6936 113.323 18.948C110.688 16.2024 106.409 14.8297 100.487 14.8297ZM103.828 44.6475C102.312 45.9116 100.327 46.5408 97.8562 46.5408C95.8199 46.5408 94.4052 46.1843 93.6121 45.4712C93.2256 45.1338 92.9182 44.7155 92.7116 44.246C92.505 43.7764 92.4043 43.2671 92.4166 42.7543C92.3941 42.2706 92.4702 41.7874 92.6403 41.3341C92.8104 40.8808 93.071 40.4668 93.4062 40.1174C93.7687 39.7774 94.1964 39.5145 94.6633 39.3444C95.1303 39.1743 95.6269 39.1006 96.1231 39.1278H106.093V39.7856C106.113 40.7154 105.919 41.6374 105.527 42.4804C105.134 43.3234 104.553 44.0649 103.828 44.6475Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M175.035 15.7391H163.75V54.7833H175.035V15.7391Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M241.666 15.7391C238.478 15.7391 235.965 16.864 234.127 19.1139C232.808 20.7307 231.805 23.1197 231.119 26.2809H230.787L229.311 15.7391H219.673V54.7775H230.959V34.7578C230.959 32.2335 231.55 30.2982 232.732 28.9521C233.914 27.606 236.095 26.933 239.275 26.933H243.559V15.7391H241.666Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M208.473 17.0147C205.839 15.4474 202.515 14.6657 198.504 14.6695C192.189 14.6695 187.247 16.4675 183.678 20.0634C180.108 23.6593 178.324 28.6166 178.324 34.9352C178.233 38.7553 179.067 42.5407 180.755 45.9689C182.3 49.0238 184.706 51.5592 187.676 53.2618C190.665 54.9892 194.221 55.8548 198.344 55.8586C201.909 55.8586 204.887 55.3095 207.278 54.2113C209.526 53.225 211.483 51.6791 212.964 49.7211C214.373 47.7991 215.42 45.6359 216.052 43.3377L206.329 40.615C205.919 42.1094 205.131 43.4728 204.041 44.5732C202.942 45.6714 201.102 46.2206 198.521 46.2206C195.451 46.2206 193.163 45.3416 191.657 43.5837C190.564 42.3139 189.878 40.5006 189.575 38.1498H216.201C216.31 37.0515 216.367 36.1306 216.367 35.387V32.9561C216.431 29.6903 215.757 26.4522 214.394 23.4839C213.118 20.7799 211.054 18.5248 208.473 17.0147ZM198.178 23.9758C202.754 23.9758 205.348 26.2275 205.962 30.731H189.775C190.032 29.2284 190.655 27.8121 191.588 26.607C193.072 24.8491 195.268 23.972 198.178 23.9758Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M169.515 0.00366253C168.666 -0.0252113 167.82 0.116874 167.027 0.421484C166.234 0.726094 165.511 1.187 164.899 1.77682C164.297 2.3723 163.824 3.08658 163.512 3.87431C163.2 4.66204 163.055 5.50601 163.086 6.35275C163.056 7.20497 163.201 8.05433 163.514 8.84781C163.826 9.64129 164.299 10.3619 164.902 10.9646C165.505 11.5673 166.226 12.0392 167.02 12.3509C167.814 12.6626 168.663 12.8074 169.515 12.7762C170.362 12.8082 171.206 12.6635 171.994 12.3514C172.782 12.0392 173.496 11.5664 174.091 10.963C174.682 10.3534 175.142 9.63077 175.446 8.83849C175.75 8.04621 175.89 7.20067 175.859 6.35275C175.898 5.50985 175.761 4.66806 175.456 3.88115C175.151 3.09424 174.686 2.37951 174.09 1.78258C173.493 1.18565 172.779 0.719644 171.992 0.414327C171.206 0.109011 170.364 -0.0288946 169.521 0.00938803L169.515 0.00366253Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M146.201 14.6695C142.357 14.6695 139.268 15.8764 136.935 18.2902C135.207 20.0786 133.939 22.7479 133.131 26.2981H132.771L131.295 15.7563H121.657V66H132.942V45.3054H133.354C133.698 46.6852 134.181 48.0267 134.795 49.3093C135.75 51.3986 137.316 53.1496 139.286 54.3314C141.328 55.446 143.629 56.0005 145.955 55.9387C150.68 55.9387 154.277 54.0988 156.748 50.419C159.219 46.7392 160.455 41.6046 160.455 35.0153C160.455 28.6509 159.259 23.6689 156.869 20.0691C154.478 16.4694 150.922 14.6695 146.201 14.6695ZM147.345 42.9602C146.029 44.8668 143.97 45.8201 141.167 45.8201C140.012 45.8735 138.86 45.6507 137.808 45.1703C136.755 44.6898 135.832 43.9656 135.116 43.0574C133.655 41.2233 132.927 38.7122 132.931 35.5243V34.7807C132.931 31.5432 133.659 29.0646 135.116 27.3448C136.572 25.625 138.59 24.7747 141.167 24.7937C144.02 24.7937 146.092 25.6994 147.385 27.5107C148.678 29.322 149.324 31.8483 149.324 35.0896C149.332 38.4414 148.676 41.065 147.356 42.9602H147.345Z", fill: "#201515" }),
                (0,isolateComponent/* isolateComponent */.U)("path", { d: "M39.0441 45.2253H0V54.789H39.0441V45.2253Z", fill: "#FF4F00" })));
    }
};
const defaultProps = {
    color: 'zapier',
    width: 279,
    height: 70,
    variant: 'wordmark-horizontal',
};
const ZapierLogo = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return getLogo(props);
};
//# sourceMappingURL=ZapierLogo.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/Branding/Branding.js



const Branding_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 5px;
    cursor: default;
    user-select: none;
  `,
    cell: emotion_react_browser_esm/* css */.iv `
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
};
const Branding = () => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: Branding_Styles.root, "data-testid": "branding" },
        (0,isolateComponent/* isolateComponent */.U)(VisuallyHidden/* VisuallyHidden */.T, null, "Zapier"),
        (0,isolateComponent/* isolateComponent */.U)("div", { "aria-hidden": true, css: Branding_Styles.cell },
            (0,isolateComponent/* isolateComponent */.U)(ZapierLogo, { width: 81, height: 22 }))));
};
//# sourceMappingURL=Branding.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/HelpfulLinks/HelpfulLinks.js




const CssVars = {
    flexDirection: '--UniversalFooter__HelpfulLinks-flex-direction',
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const HelpfulLinks_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    display: flex;
    flex-direction: var(${CssVars.flexDirection}, column);
    justify-content: var(${CssVars.justifyContent}, center);
    text-align: center;
    flex-wrap: wrap;
    column-gap: 12.5px;
    row-gap: 10px;
  `,
    link: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold};
    color: ${Colors/* Colors.neutral700 */.w.neutral700} !important;
    // For browsers that don't yet support Flexbox gap
    padding: 0 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors/* Colors.blue */.w.blue} !important;
      outline: none;
    }
  `,
};
const HelpfulLinks = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { links = [
        { text: 'Pricing', href: '/pricing' },
        { text: 'Help', href: '/help' },
        { text: 'Developer Platform', href: '/platform' },
        { text: 'Press', href: '/press' },
        { text: 'Jobs', href: '/jobs/' },
        {
            text: 'Zapier for Companies',
            href: '/teams-companies',
        },
        { text: 'Transfer', href: '/transfer' },
    ], } = props;
    const linkNodes = links.map((link) => {
        return ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: HelpfulLinks_Styles.link, href: getFullyQualifiedURL(link.href) }, link.text)));
    });
    return (0,isolateComponent/* isolateComponent */.U)("ul", { css: HelpfulLinks_Styles.root }, linkNodes);
};
//# sourceMappingURL=HelpfulLinks.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/SocialIcons/icons.js

const FacebookIcon = {
    color: '#3b5998',
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>`,
    href: 'http://www.facebook.com/ZapierApp?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
    title: 'Follow us on Facebook',
};
const LinkedInIcon = {
    color: '#0976b4',
    svg: `<svg viewBox="0 0 44 40" xmlns="http://www.w3.org/2000/svg"><path d="M44 40h-9.725V25.938c0-3.68-1.52-6.193-4.866-6.193-2.558 0-3.981 1.696-4.643 3.33-.249.586-.21 1.403-.21 2.22V40h-9.634s.124-24.909 0-27.173h9.634v4.265c.57-1.865 3.648-4.526 8.56-4.526C39.211 12.566 44 16.474 44 24.89V40zM5.18 9.428h-.063C2.013 9.428 0 7.351 0 4.718 0 2.034 2.072 0 5.239 0c3.164 0 5.11 2.029 5.171 4.71 0 2.633-2.007 4.718-5.23 4.718zm-4.07 3.399h8.576V40H1.11V12.827z" fill-rule="evenodd"/></svg>`,
    href: 'http://www.linkedin.com/company/zapier/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
    title: 'Follow us on LinkedIn',
};
const TwitterIcon = {
    color: '#00aced',
    svg: `<svg viewBox="0 0 48 40" xmlns="http://www.w3.org/2000/svg"><path d="M48 4.735a19.235 19.235 0 0 1-5.655 1.59A10.076 10.076 0 0 0 46.675.74a19.395 19.395 0 0 1-6.257 2.447C38.627 1.225 36.066 0 33.231 0c-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.3C15.456 11.974 8.2 7.96 3.34 1.842a10.281 10.281 0 0 0-1.33 5.083c0 3.502 1.738 6.593 4.38 8.405a9.668 9.668 0 0 1-4.462-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 0 1-2.595.356 9.523 9.523 0 0 1-1.854-.18c1.254 4.01 4.888 6.932 9.199 7.01-3.37 2.71-7.618 4.325-12.23 4.325-.795 0-1.58-.047-2.35-.139C4.359 38.327 9.537 40 15.096 40c18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308A20.211 20.211 0 0 0 48 4.735" fill-rule="evenodd"/></svg>`,
    href: 'https://twitter.com/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier#!/zapier',
    title: 'Follow @zapier on Twitter',
};
const YouTubeIcon = {
    color: '#e52d27',
    svg: `<svg viewBox="0 0 48 34" xmlns="http://www.w3.org/2000/svg"><path d="M19.044 23.27l-.002-13.582 12.97 6.814-12.968 6.768zM47.52 7.334s-.47-3.33-1.908-4.798C43.786.61 41.74.601 40.803.49 34.086 0 24.011 0 24.011 0h-.022S13.914 0 7.197.49c-.939.11-2.983.12-4.81 2.045C.948 4.003.48 7.334.48 7.334S0 11.247 0 15.158v3.668c0 3.912.48 7.823.48 7.823s.468 3.331 1.907 4.798c1.827 1.926 4.225 1.866 5.293 2.067C11.52 33.885 24 34 24 34s10.086-.015 16.803-.505c.938-.113 2.983-.122 4.809-2.048 1.438-1.467 1.908-4.798 1.908-4.798s.48-3.91.48-7.823v-3.668c0-3.911-.48-7.824-.48-7.824z" fill-rule="evenodd"/></svg>`,
    href: 'http://www.youtube.com/user/ZapierApp/videos?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
    title: 'See helpful Zapier videos on Youtube',
};
const RssIcon = {
    color: Colors/* Colors.zapier */.w.zapier,
    svg: `<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm512 123q2 28-17 48-18 21-47 21H889q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5T250 902q-25-2-41.5-20T192 839V704q0-29 21-47 17-17 43-17h5q160 13 306 80.5T826 902q114 113 181.5 259t80.5 306zm512 2q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5T1329 1476q-12-215-101-408.5t-231.5-336-336-231.5T252 398q-25-1-42.5-19.5T192 335V192q0-28 20-46 18-18 44-18h3q262 13 501.5 120T1186 542q187 186 294 425.5t120 501.5z"/></svg>`,
    href: '/blog/feeds/latest/',
    title: 'Subscribe to our blog',
};
//# sourceMappingURL=icons.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/SocialIcons/SocialIcons.js





const SocialIcons_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  `,
    cell: emotion_react_browser_esm/* css */.iv `
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
  `,
    title: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold};
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    white-space: nowrap;
  `,
    icons: emotion_react_browser_esm/* css */.iv `
    display: flex;
    width: min-content;
    margin: 0 auto;
  `,
    iconItem: emotion_react_browser_esm/* css */.iv `
    margin-right: 10px;
    &:last-of-type {
      margin-right: 0;
    }
  `,
    icon: (icon) => emotion_react_browser_esm/* css */.iv `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-color: ${Colors/* Colors.neutral500 */.w.neutral500};

    &:hover,
    &:focus {
      background-color: ${icon.color};
      outline: none;
    }
  `,
    iconSvg: emotion_react_browser_esm/* css */.iv `
    width: 16px;
    height: 16px;
    fill: ${Colors/* Colors.neutral100 */.w.neutral100};

    > svg {
      width: inherit;
      height: inherit;
    }
  `,
};
const SocialIcon = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { ariaLabel: props.title, title: props.title, color: null, css: SocialIcons_Styles.icon(props), "data-testid": props.title, href: getFullyQualifiedURL(props.href) },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: SocialIcons_Styles.iconSvg, dangerouslySetInnerHTML: { __html: props.svg } })));
};
const DefaultSocialIcons = [
    FacebookIcon,
    LinkedInIcon,
    RssIcon,
    TwitterIcon,
    YouTubeIcon,
];
const SocialIcons = (props) => {
    const { icons = DefaultSocialIcons } = props;
    const iconNodes = icons.map((icon) => {
        return ((0,isolateComponent/* isolateComponent */.U)("li", { key: icon.title, css: SocialIcons_Styles.iconItem },
            (0,isolateComponent/* isolateComponent */.U)(SocialIcon, Object.assign({}, icon))));
    });
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: SocialIcons_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: SocialIcons_Styles.cell },
            (0,isolateComponent/* isolateComponent */.U)("h2", { css: SocialIcons_Styles.title }, props.title)),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: SocialIcons_Styles.cell },
            (0,isolateComponent/* isolateComponent */.U)("ul", { css: SocialIcons_Styles.icons }, iconNodes))));
};
SocialIcons.defaultProps = {
    title: 'Follow us',
};
//# sourceMappingURL=SocialIcons.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/ZapierMeta/ZapierMeta.js




const ZapierMeta_CssVars = {
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const ZapierMeta_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold};
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: var(${ZapierMeta_CssVars.justifyContent}, center);
    row-gap: 10px;
  `,
    copyright: emotion_react_browser_esm/* css */.iv `
    margin-right: 10px;
  `,
    links: emotion_react_browser_esm/* css */.iv `
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    white-space: nowrap;
  `,
    linkItem: emotion_react_browser_esm/* css */.iv `
    border-left: 1px solid ${Colors/* Colors.neutral400 */.w.neutral400};
    &:first-of-type {
      border-left: none;
    }
  `,
    link: (isButton = false) => emotion_react_browser_esm/* css */.iv `
    // Increase hit area and separate.
    padding: ${isButton ? '0' : '5px'} 10px;
    color: ${Colors/* Colors.neutral700 */.w.neutral700} !important;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors/* Colors.blue */.w.blue} !important;
      outline: none;
    }
  `,
};
const ZapierMeta = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkNodes = props.links.map((link) => {
        const content = link.href ? ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: ZapierMeta_Styles.link(false), color: null, href: getFullyQualifiedURL(link.href) }, link.text)) : ((0,isolateComponent/* isolateComponent */.U)("button", { className: link.className, css: ZapierMeta_Styles.link(true), style: link.style, type: "button" }, link.text));
        return ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text, css: ZapierMeta_Styles.linkItem }, content));
    });
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: ZapierMeta_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("p", { css: ZapierMeta_Styles.copyright },
            "\u00A9 ",
            new Date().getFullYear(),
            " Zapier Inc."),
        (0,isolateComponent/* isolateComponent */.U)("ul", { css: ZapierMeta_Styles.links }, linkNodes)));
};
ZapierMeta.defaultProps = {
    links: [
        {
            text: 'Manage cookies',
            className: 'ot-sdk-show-settings',
            style: { display: 'none' },
        },
        { text: 'Legal', href: '/legal' },
        { text: 'Privacy', href: '/privacy' },
    ],
};
//# sourceMappingURL=ZapierMeta.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/LinksSection/LinksSection.js




const listGridGap = '1px';
const listGridStyles = emotion_react_browser_esm/* css */.iv `
  display: grid;
  grid-template-columns: 100%;
  row-gap: ${listGridGap};
`;
const linkStyles = emotion_react_browser_esm/* css */.iv `
  display: block;
  // Increase hit state
  padding: 3px 0;
  cursor: pointer;
  color: ${Colors/* Colors.neutral700 */.w.neutral700};
  text-decoration: none;
  &:hover,
  &:focus {
    color: ${Colors/* Colors.blue */.w.blue};
    outline: none;
  }
`;
const toggleStyles = emotion_react_browser_esm/* css */.iv `
  display: block;
  width: 100%;
  margin-bottom: ${listGridGap};
  ${linkStyles};
  text-decoration: underline;

  // Dynamically change content when the details
  // element is opened and closed.
  details:not([open]) &::before {
    content: 'Show more';
  }
  details[open] &::before {
    content: 'Show less';
  }
`;
const LinksSection_Styles = {
    root: emotion_react_browser_esm/* css */.iv ``,
    title: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3};
    font-weight: 700;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    margin-bottom: 10px;
  `,
    links: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3 */.ZT.paragraph3};
    ${listGridStyles};
    // Prevent users from accidentally selecting
    // text when interacting with details. I don't
    // see a need for them to be able to copy the
    // link text to their clipboards.
    user-select: none;
  `,
    linksList: emotion_react_browser_esm/* css */.iv `
    ${listGridStyles};
  `,
    link: emotion_react_browser_esm/* css */.iv `
    ${linkStyles};
  `,
    moreLinks: emotion_react_browser_esm/* css */.iv `
    position: relative;
  `,
    moreLinksInner: emotion_react_browser_esm/* css */.iv `
    ${listGridStyles};
  `,
    moreLinksToggle: emotion_react_browser_esm/* css */.iv `
    // Hides default icon on details element
    &::-webkit-details-marker {
      display: none;
    }
    ${toggleStyles};

    // When details is open, the faux toggle will render
    // (so that it renders at the bottom of the list),
    // and the summary will be hidden but render over top
    // of it so it's still clickable.
    details[open] > & {
      position: absolute;
      bottom: 0;
      opacity: 0;
    }
  `,
    moreLinksFauxToggle: emotion_react_browser_esm/* css */.iv `
    ${toggleStyles};
  `,
};
const LinksList = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkNodes = props.links.map((link) => {
        return ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: LinksSection_Styles.link, color: null, href: getFullyQualifiedURL(link.href) }, link.text)));
    });
    return (0,isolateComponent/* isolateComponent */.U)("ul", { css: LinksSection_Styles.linksList }, linkNodes);
};
const MoreLinks = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("details", { css: LinksSection_Styles.moreLinks, open: props.isExpanded },
        (0,isolateComponent/* isolateComponent */.U)("summary", { "aria-label": "Toggle more links", css: LinksSection_Styles.moreLinksToggle, onClick: props.onToggleExpanded }),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: LinksSection_Styles.moreLinksInner },
            (0,isolateComponent/* isolateComponent */.U)(LinksList, { links: props.links }),
            (0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": true, css: LinksSection_Styles.moreLinksFauxToggle }))));
};
const LinksSection = (props) => {
    const { initiallyShownCount, links } = props;
    const moreLinks = links.length > initiallyShownCount && ((0,isolateComponent/* isolateComponent */.U)(MoreLinks, { links: links.slice(initiallyShownCount), isExpanded: props.isExpanded, onToggleExpanded: props.onToggleExpanded }));
    return ((0,isolateComponent/* isolateComponent */.U)("section", { css: LinksSection_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("h2", { css: LinksSection_Styles.title }, props.title),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: LinksSection_Styles.links },
            (0,isolateComponent/* isolateComponent */.U)(LinksList, { links: links.slice(0, initiallyShownCount) }),
            moreLinks)));
};
LinksSection.defaultProps = {
    initiallyShownCount: 5,
};
//# sourceMappingURL=LinksSection.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/LinksSection/sections.js
const TopSearchesSection = {
    title: 'Top Searches',
    links: [
        {
            text: 'Slack Integrations',
            href: '/apps/slack/integrations',
        },
        {
            text: 'Salesforce Integrations',
            href: '/apps/salesforce/integrations',
        },
        {
            text: 'HubSpot CRM Integrations',
            href: '/apps/hubspot-crm/integrations',
        },
        {
            text: 'PayPal Integrations',
            href: '/apps/paypal/integrations',
        },
        {
            text: 'Asana Integrations',
            href: '/apps/asana/integrations',
        },
        {
            text: 'Stripe Integrations',
            href: '/apps/stripe/integrations',
        },
        {
            text: 'GitHub Integrations',
            href: '/apps/github/integrations',
        },
        {
            text: 'Trello Integrations',
            href: '/apps/trello/integrations',
        },
        {
            text: 'Todoist Integrations',
            href: '/apps/todoist/integrations',
        },
        {
            text: 'Xero Integrations',
            href: '/apps/xero/integrations',
        },
        {
            text: 'Zapier Integrations',
            href: '/apps/zapier/integrations',
        },
        {
            text: 'Facebook Groups Integrations',
            href: '/apps/facebook-groups/integrations',
        },
        {
            text: 'JIRA Integrations',
            href: '/apps/jira/integrations',
        },
        {
            text: 'Pipedrive Integrations',
            href: '/apps/pipedrive/integrations',
        },
        {
            text: 'Zendesk Integrations',
            href: '/apps/zendesk/integrations',
        },
        {
            text: 'Google Analytics Integrations',
            href: '/apps/google-analytics/integrations',
        },
        {
            text: 'HipChat Integrations',
            href: '/apps/hipchat/integrations',
        },
        {
            text: 'MailChimp Integrations',
            href: '/apps/mailchimp/integrations',
        },
        {
            text: 'Shopify Integrations',
            href: '/apps/shopify/integrations',
        },
        {
            text: 'Intercom Integrations',
            href: '/apps/intercom/integrations',
        },
        {
            text: 'GitLab Integrations',
            href: '/apps/gitlab/integrations',
        },
        {
            text: 'Magento 2.X Integrations',
            href: '/apps/magento-v2/integrations',
        },
        {
            text: 'Google Drive Integrations',
            href: '/apps/google-drive/integrations',
        },
        {
            text: 'WooCommerce Integrations',
            href: '/apps/woocommerce/integrations',
        },
        {
            text: 'Basecamp 3 Integrations',
            href: '/apps/basecamp3/integrations',
        },
    ],
};
const PopularAppsSection = {
    title: 'Popular Apps',
    links: [
        {
            text: 'Dropbox',
            href: '/apps/dropbox/integrations',
        },
        {
            text: 'Google Sheets',
            href: '/apps/google-sheets/integrations',
        },
        {
            text: 'DocuSign',
            href: '/apps/docusign/integrations',
        },
        {
            text: 'WordPress',
            href: '/apps/wordpress/integrations',
        },
        {
            text: 'Office 365',
            href: '/apps/office-365/integrations',
        },
        {
            text: 'QuickBooks Online',
            href: '/apps/quickbooks/integrations',
        },
        {
            text: 'Mixpanel',
            href: '/apps/mixpanel/integrations',
        },
        {
            text: 'RingCentral',
            href: '/apps/ringcentral/integrations',
        },
        {
            text: 'Zoho CRM',
            href: '/apps/zoho-crm/integrations',
        },
        {
            text: 'HubSpot',
            href: '/apps/hubspot/integrations',
        },
        {
            text: 'Microsoft Teams',
            href: '/apps/microsoft-teams/integrations',
        },
        {
            text: 'Eventbrite',
            href: '/apps/eventbrite/integrations',
        },
        {
            text: 'Box',
            href: '/apps/box/integrations',
        },
        {
            text: 'Evernote Business',
            href: '/apps/evernote-business/integrations',
        },
        {
            text: 'LinkedIn',
            href: '/apps/linkedin/integrations',
        },
        {
            text: 'Marketo',
            href: '/apps/marketo/integrations',
        },
        {
            text: 'SugarCRM',
            href: '/apps/sugarcrm/integrations',
        },
        {
            text: 'Twilio',
            href: '/apps/twilio/integrations',
        },
        {
            text: 'Infusionsoft',
            href: '/apps/infusionsoft/integrations',
        },
        {
            text: 'Google Forms',
            href: '/apps/google-forms/integrations',
        },
        {
            text: 'SurveyMonkey',
            href: '/apps/surveymonkey/integrations',
        },
        {
            text: 'Campaign Monitor',
            href: '/apps/campaign-monitor/integrations',
        },
        {
            text: 'Pardot',
            href: '/apps/pardot/integrations',
        },
        {
            text: 'Microsoft Dynamics CRM',
            href: '/apps/microsoft-dynamics/integrations',
        },
    ],
};
const TrendingAppsSection = {
    title: 'Trending Apps',
    links: [
        {
            text: 'Twitch',
            href: '/apps/twitch/integrations',
        },
        {
            text: 'Printful',
            href: '/apps/printful/integrations',
        },
        {
            text: 'Microsoft To-Do',
            href: '/apps/microsoft-todo/integrations',
        },
        {
            text: 'Microsoft Outlook',
            href: '/apps/microsoft-outlook/integrations',
        },
        {
            text: 'Medium',
            href: '/apps/medium/integrations',
        },
        {
            text: 'Unbounce',
            href: '/apps/unbounce/integrations',
        },
        {
            text: 'Freshdesk',
            href: '/apps/freshdesk/integrations',
        },
        {
            text: 'Airtable',
            href: '/apps/airtable/integrations',
        },
        {
            text: 'Expensify',
            href: '/apps/expensify/integrations',
        },
        {
            text: 'Insightly',
            href: '/apps/insightly/integrations',
        },
        {
            text: 'PagerDuty',
            href: '/apps/pagerduty/integrations',
        },
        {
            text: 'Podio',
            href: '/apps/podio/integrations',
        },
        {
            text: 'Wunderlist',
            href: '/apps/wunderlist/integrations',
        },
        {
            text: 'Square',
            href: '/apps/square/integrations',
        },
        {
            text: 'Datadog',
            href: '/apps/datadog/integrations',
        },
        {
            text: 'Toggl',
            href: '/apps/toggl/integrations',
        },
        {
            text: 'ClickFunnels',
            href: '/apps/clickfunnels/integrations',
        },
        {
            text: 'Rocket.Chat',
            href: '/apps/rocketchat/integrations',
        },
        {
            text: 'Firebase',
            href: '/apps/firebase/integrations',
        },
        {
            text: 'Cisco Spark',
            href: '/apps/cisco-spark/integrations',
        },
        {
            text: 'MINDBODY',
            href: '/apps/mindbody/integrations',
        },
        {
            text: 'Harvest',
            href: '/apps/harvest/integrations',
        },
        {
            text: 'Smartsheet',
            href: '/apps/smartsheet/integrations',
        },
        {
            text: 'Teamwork Desk',
            href: '/apps/teamwork-desk/integrations',
        },
        {
            text: 'Yammer',
            href: '/apps/yammer/integrations',
        },
        {
            text: 'Typeform',
            href: '/apps/typeform/integrations',
        },
        {
            text: 'Autotask',
            href: '/apps/autotask/integrations',
        },
        {
            text: 'Wrike',
            href: '/apps/wrike/integrations',
        },
        {
            text: 'Help Scout',
            href: '/apps/help-scout/integrations',
        },
        {
            text: 'Braintree',
            href: '/apps/braintree/integrations',
        },
    ],
};
const TopAppsByCategorySection = {
    title: 'Top Apps by Category',
    links: [
        {
            text: 'Project Management',
            href: '/apps/categories/project-management',
        },
        {
            text: 'Calendar',
            href: '/apps/categories/calendar',
        },
        {
            text: 'Email',
            href: '/apps/categories/email',
        },
        {
            text: 'CRM (Customer Relationship Management)',
            href: '/apps/categories/crm',
        },
        {
            text: 'Marketing Automation',
            href: '/apps/categories/marketing',
        },
        {
            text: 'Notes',
            href: '/apps/categories/notes',
        },
        {
            text: 'Accounting',
            href: '/apps/categories/accounting',
        },
        {
            text: 'Social Media Marketing',
            href: '/apps/categories/social-marketing',
        },
        {
            text: 'Online Courses',
            href: '/apps/categories/education',
        },
        {
            text: 'Contact Management',
            href: '/apps/categories/contacts',
        },
        {
            text: 'Forms & Surveys',
            href: '/apps/categories/forms',
        },
        {
            text: 'Scheduling & Booking',
            href: '/apps/categories/scheduling',
        },
        {
            text: 'Task Management',
            href: '/apps/categories/todo-lists',
        },
        {
            text: 'Databases',
            href: '/apps/categories/databases',
        },
        {
            text: 'Call Tracking',
            href: '/apps/categories/call-tracking',
        },
        {
            text: 'Documents',
            href: '/apps/categories/documents',
        },
        {
            text: 'Fax',
            href: '/apps/categories/fax',
        },
        {
            text: 'Files',
            href: '/apps/categories/files',
        },
        {
            text: 'Customer Support',
            href: '/apps/categories/customer-support',
        },
        {
            text: 'Team Collaboration',
            href: '/apps/categories/team-collaboration',
        },
        {
            text: 'Spreadsheets',
            href: '/apps/categories/spreadsheets',
        },
        {
            text: 'Website Builders',
            href: '/apps/categories/cms',
        },
        {
            text: 'Ecommerce',
            href: '/apps/categories/ecommerce',
        },
        {
            text: 'Event Management',
            href: '/apps/categories/event-management',
        },
    ],
};
const OurBestContentSection = {
    title: 'Our Best Content',
    links: [
        {
            text: 'Best Video Conferencing Apps',
            href: '/blog/best-video-conferencing-apps',
        },
        {
            text: 'Best Email Apps',
            href: '/blog/best-email-app/',
        },
        {
            text: 'Best CRM Apps',
            href: '/learn/crm/best-crm-app/',
        },
        {
            text: 'Best Note Taking Apps',
            href: '/blog/best-note-taking-apps/',
        },
        {
            text: 'Best Calendar Apps',
            href: '/blog/best-calendar-apps/',
        },
        {
            text: 'Best Meeting Scheduler Apps',
            href: '/blog/best-meeting-scheduler-apps/',
        },
        {
            text: 'Best Todo List Apps',
            href: '/blog/best-todo-list-apps/',
        },
        {
            text: 'Best Powerpoint Alternatives',
            href: '/blog/best-powerpoint-alternatives/',
        },
        {
            text: 'Best Spreadsheet & Excel Alternatives',
            href: '/blog/best-spreadsheet-excel-alternative/',
        },
        {
            text: 'Best Time Tracking Apps',
            href: '/blog/best-time-tracking-apps/',
        },
        {
            text: 'Best eCommerce Shopping Cart Software',
            href: '/blog/best-ecommerce-shopping-cart-software/',
        },
        {
            text: 'Best Survey Apps',
            href: '/learn/forms-surveys/best-survey-apps/',
        },
        {
            text: 'Best Online Form Builder Software',
            href: '/learn/forms-surveys/best-online-form-builder-software/',
        },
        {
            text: 'Best Digital Signature Apps',
            href: '/blog/best-digital-signature-apps/',
        },
        {
            text: 'Best Team Chat App',
            href: '/blog/best-team-chat-app/',
        },
        {
            text: 'Workato vs. Zapier',
            href: '/l/workato-vs-zapier/',
        },
    ],
};
//# sourceMappingURL=sections.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-footer/components/UniversalFooter/UniversalFooter.js










const mediaQueryMedium = '(min-width: 650px)';
const mediaQueryLarge = '(min-width: 980px)';
const mediaQueryTablet = '(max-width: 980px)';
const UniversalFooter_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    background-color: ${Colors/* Colors.neutral100 */.w.neutral100};
    padding: 30px;
    @media ${mediaQueryTablet} {
      padding: 20px;
    }
  `,
    simplifiedNav: emotion_react_browser_esm/* css */.iv `
    display: flex;
    justify-content: center;
    justify-items: center;
  `,
    grid: (props) => emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 100%;
    grid-template-areas:
      ${props.shouldRenderAlphabetNav ? '"alphabetNav"' : ''}
      ${props.shouldRenderSeoLinks ? '"seoLinks"' : ''}
      "helpfulLinks"
      "socialIcons"
      "branding"
      "zapierMeta";
    justify-items: center;
    align-items: center;
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;

    @media ${mediaQueryMedium} {
      grid-template-columns: max-content 1fr;
      grid-template-areas:
        ${props.shouldRenderAlphabetNav ? '"alphabetNav alphabetNav"' : ''}
        ${props.shouldRenderSeoLinks ? '"seoLinks seoLinks"' : ''}
        "helpfulLinks helpfulLinks"
        "socialIcons socialIcons"
        "branding zapierMeta";
    }

    @media ${mediaQueryLarge} {
      grid-template-columns: max-content 1fr;
      grid-template-areas:
        ${props.shouldRenderAlphabetNav ? '"alphabetNav alphabetNav"' : ''}
        ${props.shouldRenderSeoLinks ? '"seoLinks seoLinks"' : ''}
        "socialIcons helpfulLinks"
        "branding zapierMeta";
    }
  `,
    branding: emotion_react_browser_esm/* css */.iv `
    grid-area: branding;
    @media ${mediaQueryMedium} {
      justify-self: start;
    }
  `,
    helpfulLinks: emotion_react_browser_esm/* css */.iv `
    grid-area: helpfulLinks;
    width: 100%;
    display: flex;
    justify-content: center;
    @media ${mediaQueryMedium} {
      ${CssVars.flexDirection}: row;
    }
    @media ${mediaQueryLarge} {
      justify-content: flex-end;
      ${CssVars.justifyContent}: flex-end;
    }
  `,
    alphabetNav: emotion_react_browser_esm/* css */.iv `
    grid-area: alphabetNav;

    @media ${mediaQueryMedium} {
      max-width: none;
    }
  `,
    seoLinks: emotion_react_browser_esm/* css */.iv `
    grid-area: seoLinks;
    width: 100%;
  `,
    socialIcons: emotion_react_browser_esm/* css */.iv `
    grid-area: socialIcons;
    @media ${mediaQueryLarge} {
      justify-self: start;
    }
  `,
    zapierMeta: emotion_react_browser_esm/* css */.iv `
    grid-area: zapierMeta;
    @media ${mediaQueryMedium} {
      justify-self: end;
      ${ZapierMeta_CssVars.justifyContent}: flex-end;
    }
  `,
    linksSections: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-columns: 100%;
    text-align: center;
    column-gap: 10px;
    row-gap: 20px;
    @media (min-width: 420px) {
      text-align: left;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    }
  `,
};
const LinksSections = (props) => {
    const [areSectionsExpanded, setAreSectionsExpanded] = (0,react.useState)(false);
    const toggleAreSectionsExpanded = () => {
        setAreSectionsExpanded(!areSectionsExpanded);
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.linksSections }, props.sections.map((section) => ((0,isolateComponent/* isolateComponent */.U)(LinksSection, { key: section.title + areSectionsExpanded, title: section.title, links: section.links, isExpanded: areSectionsExpanded, onToggleExpanded: toggleAreSectionsExpanded })))));
};
const UniversalFooter = (props) => {
    const alphabetNav = props.shouldRenderAlphabetNav && ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.alphabetNav },
        (0,isolateComponent/* isolateComponent */.U)(AlphabeticAppNav, null)));
    const seoLinks = props.shouldRenderSeoLinks && ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.seoLinks },
        (0,isolateComponent/* isolateComponent */.U)(LinksSections, { sections: [
                TopSearchesSection,
                PopularAppsSection,
                TrendingAppsSection,
                TopAppsByCategorySection,
                OurBestContentSection,
            ] })));
    return ((0,isolateComponent/* isolateComponent */.U)("footer", { css: UniversalFooter_Styles.root, role: "contentinfo", "data-testid": "universalFooter" }, props.showSimplifiedFooter ? ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.simplifiedNav },
        (0,isolateComponent/* isolateComponent */.U)(ZapierMeta, { links: [
                { text: 'Legal', href: '/legal' },
                { text: 'Privacy', href: '/privacy' },
                {
                    text: 'Manage cookies',
                    className: 'ot-sdk-show-settings',
                    style: { display: 'none' },
                },
            ] }))) : ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.grid(props) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.helpfulLinks },
            (0,isolateComponent/* isolateComponent */.U)(HelpfulLinks, null)),
        alphabetNav,
        seoLinks,
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.socialIcons },
            (0,isolateComponent/* isolateComponent */.U)(SocialIcons, null)),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.branding },
            (0,isolateComponent/* isolateComponent */.U)(Branding, null)),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalFooter_Styles.zapierMeta },
            (0,isolateComponent/* isolateComponent */.U)(ZapierMeta, null))))));
};
//# sourceMappingURL=UniversalFooter.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Animation.js
var Animation = __webpack_require__(98628);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/Button.js
var Button = __webpack_require__(20110);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/TooltipWrapper/TooltipWrapper.js + 1 modules
var TooltipWrapper = __webpack_require__(87593);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(46688);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/MenuCollapseButton/MenuCollapseButton.js



const MenuCollapseButton_Styles = (0,labelStyles/* labelStyles */.B)('MenuCollapseButton', {
    root: emotion_react_browser_esm/* css */.iv `
    width: 44px;
    height: 44px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors/* Colors.neutral600 */.w.neutral600};
    transition: ${Animation/* Animation.transitionValue */.f.transitionValue};

    &:hover,
    &:focus {
      background-color: none;
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }
  `,
});
const MenuCollapseButton = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: props.label, position: "east", shouldCorrectPosition: false, showTooltipOnTouchDevices: false }, () => ((0,isolateComponent/* isolateComponent */.U)("button", { type: "button", "aria-expanded": props.ariaExpanded, "aria-label": props.ariaLabel || props.label, css: MenuCollapseButton_Styles.root, onClick: (event) => {
            if (props.onClick) {
                props.onClick(event);
            }
        } },
        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: props.icon, size: 24 })))));
};
MenuCollapseButton.defaultProps = {
    ariaExpanded: false,
    icon: 'navMenu',
    label: 'Menu',
};
/* harmony default export */ var MenuCollapseButton_MenuCollapseButton = (MenuCollapseButton);
//# sourceMappingURL=MenuCollapseButton.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useClickOutside.js
var useClickOutside = __webpack_require__(37168);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/SkipLink/SkipLink.js



const SkipLink_Styles = (0,labelStyles/* labelStyles */.B)('SkipLink', {
    root: {
        fontSize: 10,
        textTransform: 'uppercase',
        display: 'block',
        color: Colors/* Colors.gray80 */.w.gray80,
        opacity: 0,
        pointerEvents: 'none',
        textDecoration: 'none',
        '&:focus': {
            opacity: 1,
            outline: 'none',
        },
    },
});
const SkipLink = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { ariaLabel: "Skip to main content", css: SkipLink_Styles.root, href: props.href }, props.text));
};
SkipLink.defaultProps = {
    href: constants/* skipLinkHref */.fe,
    text: 'Skip to content',
};
/* harmony default export */ var SkipLink_SkipLink = (SkipLink);
//# sourceMappingURL=SkipLink.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/constants.js
const CARET_SIZE = 24;
const PRODUCT_LINKS = {
    appIntegrations: {
        text: 'App integrations',
        description: 'Explore 5,000+ app connections',
        href: '/apps',
    },
    earlyAccessProgram: {
        text: 'Zapier Early Access',
        href: '/early-access',
    },
    features: {
        text: 'Features',
        description: 'Build flexible workflows',
        href: '/features',
    },
    howItWorks: {
        text: 'How it works',
        description: 'Learn the basics',
        href: '/how-it-works',
    },
    security: {
        text: 'Security',
        description: 'Trusted by 2M+ businesses',
        href: '/security',
    },
    zapierTables: {
        text: 'Zapier Tables',
        href: '/tables',
        icon: 'navTable',
        description: 'No-code databases built for Zaps',
        tag: 'beta',
    },
    zapierTransfer: {
        text: 'Zapier Transfer',
        href: '/transfer',
        icon: 'arrowConnect',
        description: 'Move bulk data on demand',
        tag: 'beta',
    },
    zapierInterfaces: {
        text: 'Zapier Interfaces',
        href: '/interfaces',
        icon: 'navInterfaces',
        description: 'Custom pages to power your Zaps',
        tag: 'beta',
    },
};
const SIDEBAR_PRODUCT_MENU = {
    text: 'Product',
    href: null,
    submenu: [
        {
            text: PRODUCT_LINKS.howItWorks.text,
            href: PRODUCT_LINKS.howItWorks.href,
        },
        {
            text: PRODUCT_LINKS.security.text,
            href: PRODUCT_LINKS.security.href,
        },
        {
            text: PRODUCT_LINKS.features.text,
            href: PRODUCT_LINKS.features.href,
        },
        {
            text: PRODUCT_LINKS.appIntegrations.text,
            href: PRODUCT_LINKS.appIntegrations.href,
        },
        {
            text: PRODUCT_LINKS.earlyAccessProgram.text,
            href: PRODUCT_LINKS.earlyAccessProgram.href,
            submenu: [
                {
                    text: `${PRODUCT_LINKS.zapierTransfer.text} (beta)`,
                    href: PRODUCT_LINKS.zapierTransfer.href,
                },
                {
                    text: `${PRODUCT_LINKS.zapierTables.text} (beta)`,
                    href: PRODUCT_LINKS.zapierTables.href,
                },
                {
                    text: `${PRODUCT_LINKS.zapierInterfaces.text} (alpha)`,
                    href: PRODUCT_LINKS.zapierInterfaces.href,
                },
            ],
        },
    ],
};
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/events-toolkit-browser/dist/index.js
var events_toolkit_browser_dist = __webpack_require__(8736);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/avroEvents.js
var avroEvents_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

const UserInteractionEvent = 'web_analytics.tracking.user_interaction.UserInteractionEvent';
const emitUserInteractionEvent = async (_a) => {
    var { interaction_name = 'call_to_action' } = _a, eventDetails = avroEvents_rest(_a, ["interaction_name"]);
    return await (0,events_toolkit_browser_dist.emit)(Object.assign(Object.assign({}, eventDetails), { absolute_url: window.location.pathname, interaction_name, referrer: document.referrer, system_name: 'design_system' }), UserInteractionEvent);
};
//# sourceMappingURL=avroEvents.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/createUniqueCustomProperty.js
var createUniqueCustomProperty = __webpack_require__(38137);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenuFooter/MegaMenuFooter.js




const MegaMenuFooter_Styles = {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        gap: 30,
    }),
    link: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint1Medium */.ZT.smallPrint1Medium), { textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6, color: Colors/* Colors.neutral800 */.w.neutral800, '&:hover': {
            color: Colors/* Colors.zapier */.w.zapier,
            textDecoration: 'none',
        }, '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
            outlineOffset: '1px',
            textDecoration: 'none',
        } })),
};
const MegaMenuFooter = (props) => {
    const { links } = props;
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `MegaNavFooter: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("ul", { css: MegaMenuFooter_Styles.root }, links === null || links === void 0 ? void 0 : links.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: MegaMenuFooter_Styles.link, href: link.href || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
            link.icon && (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: link.icon, size: 14 }),
            link.text))))));
};
//# sourceMappingURL=MegaMenuFooter.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Heading/HeadingLevel.js
var HeadingLevel = __webpack_require__(78062);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Heading/Heading.js
var Heading = __webpack_require__(28067);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/ArrowLinkIcon.js



const ArrowLinkIcon_Styles = (0,labelStyles/* labelStyles */.B)('Arrow', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        opacity: 0,
        height: 16,
        marginLeft: 0,
        marginTop: 2,
        position: 'absolute',
        transition: `opacity 100ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}, margin 150ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}`,
    }),
});
const ArrowLinkIcon = () => ((0,isolateComponent/* isolateComponent */.U)("span", { css: ArrowLinkIcon_Styles.root, "data-tag": "arrow-icon-wrapper" },
    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: "arrowBigRight", size: 14 })));
//# sourceMappingURL=ArrowLinkIcon.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenuSubmenu/constants.js
const ICON_SIZE = 20;
const HEADING_GAP = 8;
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenuSubmenu/SubMenuHeading.js







const SubMenuHeading_Styles = (0,labelStyles/* labelStyles */.B)('SubMenuHeading', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        textDecoration: 'none',
        color: Colors/* Colors.inherit */.w.inherit,
        outline: 'none',
        '&:hover > p, &:focus > p': {
            textDecoration: 'underline',
        },
        '&:hover > p > span, &:focus > p > span': {
            marginLeft: 4,
            opacity: 1,
        },
    }),
    headingWrapper: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        gap: HEADING_GAP,
        alignItems: 'end',
        marginBottom: 10,
    }),
    headingText: (0,emotion_react_browser_esm/* css */.iv)(Object.assign({}, Typography/* Typography.subHeader5Bold */.ZT.subHeader5Bold)),
    description: (hasIcon) => (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({ paddingLeft: hasIcon ? `${ICON_SIZE + HEADING_GAP}px` : 0 }, Typography/* Typography.paragraph3 */.ZT.paragraph3), { color: Colors/* Colors.neutral700 */.w.neutral700, maxWidth: 202, position: 'relative', transition: `text-decoration 100ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}` })),
    icon: (0,emotion_react_browser_esm/* css */.iv)({
        color: Colors/* Colors.inherit */.w.inherit,
        fontSize: 20,
        lineHeight: '20px',
    }),
});
const SubMenuHeading = (props) => {
    const { link } = props;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType, isLink) => {
        if (isLink) {
            emitUserInteractionEvent({
                event_action: eventType,
                option_selected: `MegaMenuSubmenuLink: ${text}`,
            });
            if (eventType === 'click' && props.onCloseMenu)
                props.onCloseMenu();
        }
    };
    const LinkComponent = link.href ? Link/* Link */.r : 'span';
    return ((0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
        (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, null,
            (0,isolateComponent/* isolateComponent */.U)(LinkComponent, { css: SubMenuHeading_Styles.root, color: null, href: link.href ? getFullyQualifiedURL(link.href) : undefined, onClick: () => handleEvent(link.text, 'click', !!link.href), onMouseEnter: () => handleEvent(link.text, 'hover', !!link.href) },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: SubMenuHeading_Styles.headingWrapper },
                    link.icon && ((0,isolateComponent/* isolateComponent */.U)("span", { css: SubMenuHeading_Styles.icon, "data-testid": "heading-icon" },
                        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: link.icon, size: ICON_SIZE }))),
                    (0,isolateComponent/* isolateComponent */.U)("span", { css: SubMenuHeading_Styles.headingText }, link.text)),
                link.description && ((0,isolateComponent/* isolateComponent */.U)("p", { css: SubMenuHeading_Styles.description(!!link.icon), "data-testid": "heading-description" },
                    link.description,
                    (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null)))))));
};
//# sourceMappingURL=SubMenuHeading.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenuSubmenu/SubMenuList.js






const SubMenuList_Styles = (0,labelStyles/* labelStyles */.B)('SubMenuList', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
    }),
    item: Object.assign(Object.assign({ marginBottom: '10px' }, Typography/* Typography.paragraph3 */.ZT.paragraph3), { '&:last-child': {
            marginBottom: 0,
        }, '&:focus-within': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
        } }),
    link: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({ color: Colors/* Colors.neutral700 */.w.neutral700 }, Typography/* Typography.paragraph3 */.ZT.paragraph3), { position: 'relative', textDecoration: 'none', transition: `text-decoration 100ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}`, '&:hover': {
            textDecoration: 'underline',
        }, '&:hover > span': {
            marginLeft: 4,
            opacity: 1,
        }, '&:focus': {
            outline: 'none',
        } })),
});
const SubMenuList = (props) => {
    const { submenu } = props;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `MegaMenuSubmenuLink: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("ul", { css: SubMenuList_Styles.root }, submenu.map((link, index) => ((0,isolateComponent/* isolateComponent */.U)("li", { css: SubMenuList_Styles.item, key: `${link.text}-${index}` },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { css: SubMenuList_Styles.link, color: null, href: getFullyQualifiedURL(link.href) || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
            link.text,
            (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null)))))));
};
//# sourceMappingURL=SubMenuList.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenuSubmenu/MegaMenuSubmenu.js






const MegaMenuSubmenu_Styles = (0,labelStyles/* labelStyles */.B)('MegaMenuSubmenu', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        color: Colors/* Colors.earth */.w.earth,
        display: 'grid',
        gap: '4%',
        gridTemplateColumns: 'repeat(3, minmax(0px, max-content))',
        gridTemplateRows: 'auto',
        height: '100%',
    }),
    group: (0,emotion_react_browser_esm/* css */.iv)({
        color: Colors/* Colors.inherit */.w.inherit,
        '&:hover, &:focus, &:focus-within': {
            color: Colors/* Colors.zapier */.w.zapier,
        },
    }),
    listWrapper: (hasIcon) => (0,emotion_react_browser_esm/* css */.iv)({
        paddingLeft: hasIcon ? `${ICON_SIZE + HEADING_GAP}px` : 0,
    }),
});
const MegaMenuSubmenu = (props) => {
    const { links } = props;
    return ((0,isolateComponent/* isolateComponent */.U)("ul", { css: MegaMenuSubmenu_Styles.root }, links.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text, css: MegaMenuSubmenu_Styles.group },
        (0,isolateComponent/* isolateComponent */.U)("div", { role: link.submenu ? 'group' : 'presentation' },
            (0,isolateComponent/* isolateComponent */.U)(SubMenuHeading, { link: link, onCloseMenu: props.onCloseMenu }),
            link.submenu && ((0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenuSubmenu_Styles.listWrapper(!!link.icon) },
                (0,isolateComponent/* isolateComponent */.U)(SubMenuList, { submenu: link.submenu, onCloseMenu: props.onCloseMenu })))))))));
};
//# sourceMappingURL=MegaMenuSubmenu.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Img/Img.js + 15 modules
var Img = __webpack_require__(77509);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/Promo/ArticlePromo.js






const ArticlePromo_Styles = {
    root: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({ color: Colors/* Colors.neutral800 */.w.neutral800, display: 'flex', flexDirection: 'column', position: 'relative', maxWidth: 400 }, Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold), { '@media (hover: hover)': {
            '&:hover p': {
                textDecoration: 'underline',
            },
            '&:hover a': {
                textDecoration: 'none',
            },
            '&:hover p > span': {
                marginLeft: 4,
                opacity: 1,
            },
            '&:focus-within': {
                outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
            },
            '&:focus-within > a': {
                textDecoration: 'none',
            },
        } })),
    title: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'block',
        marginBottom: 20,
        textDecoration: 'none',
        color: Colors/* Colors.neutral800 */.w.neutral800,
        outline: 'none',
        borderBottom: 'none',
        '&:hover': {
            textDecoration: 'none',
            color: Colors/* Colors.neutral800 */.w.neutral800,
        },
        '&:focus': {
            textDecoration: 'none',
            color: Colors/* Colors.neutral800 */.w.neutral800,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            zIndex: 1,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    }),
    imageContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        alignItems: 'center',
        gap: 16,
    }),
    description: (0,emotion_react_browser_esm/* css */.iv)(Object.assign({ transition: `text-decoration 100ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}`, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, overflow: 'hidden' }, Typography/* Typography.smallPrint1 */.ZT.smallPrint1)),
};
const ArticlePromo = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `ArticlePromo: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("article", { css: ArticlePromo_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, null,
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: ArticlePromo_Styles.title, href: getFullyQualifiedURL(props.href) || undefined, onClick: () => handleEvent(props.text, 'click'), onMouseEnter: () => handleEvent(props.text, 'hover'), target: props.target }, props.text))),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: ArticlePromo_Styles.imageContainer },
            (0,isolateComponent/* isolateComponent */.U)(Img/* Img */.E, { alt: props.altText, borderRadius: 0, src: props.imageUrl, width: 100 }),
            (0,isolateComponent/* isolateComponent */.U)("p", { css: ArticlePromo_Styles.description },
                props.description,
                (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null)))));
};
//# sourceMappingURL=ArticlePromo.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Text/Text.js
var Text = __webpack_require__(55414);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/layout/Spacer/Spacer.js
var Spacer = __webpack_require__(53939);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/Promo/ListPromo.js






const ListPromo_Styles = {
    root: (0,emotion_react_browser_esm/* css */.iv)(Object.assign({ color: Colors/* Colors.neutral800 */.w.neutral800 }, Typography/* Typography.smallPrint1Bold */.ZT.smallPrint1Bold)),
    listItem: (0,emotion_react_browser_esm/* css */.iv)({
        marginBottom: 8,
        '&:last-of-type': {
            marginBottom: 0,
        },
    }),
    link: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), { color: Colors/* Colors.neutral800 */.w.neutral800, transition: `text-decoration 100ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}`, textDecoration: 'none', '&:hover': {
            textDecoration: 'underline',
            color: Colors/* Colors.neutral800 */.w.neutral800,
        }, '&:hover > span': {
            marginLeft: 4,
            opacity: 1,
        }, '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
            color: Colors/* Colors.neutral800 */.w.neutral800,
        } })),
};
const ListPromo = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `ListPromo: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("section", { css: ListPromo_Styles.root },
        props.text && ((0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
            (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, null,
                (0,isolateComponent/* isolateComponent */.U)(Text/* Text */.x, { type: "smallPrint1Bold" }, props.text)),
            (0,isolateComponent/* isolateComponent */.U)(Spacer/* Spacer */.L, { height: 20 }))),
        (0,isolateComponent/* isolateComponent */.U)("ul", null, props.links.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text, css: ListPromo_Styles.listItem },
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: ListPromo_Styles.link, href: getFullyQualifiedURL(link.href) || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
                link.text,
                (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null))))))));
};
//# sourceMappingURL=ListPromo.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/Promo/Promo.js






const Promo_Styles = {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
    }),
    divider: (0,emotion_react_browser_esm/* css */.iv)({
        backgroundColor: Colors/* Colors.neutral500 */.w.neutral500,
        height: 1,
        margin: '20px 0',
        '&:last-of-type': {
            display: 'none',
        },
    }),
};
const Promo = (props) => {
    const { promo } = props;
    return promo ? ((0,isolateComponent/* isolateComponent */.U)("div", { css: Promo_Styles.root, "data-testid": "promo" }, promo.map((item, index) => ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, { key: `${item.type}-${index}` },
        item.type === 'article-stub' ? ((0,isolateComponent/* isolateComponent */.U)(ArticlePromo, Object.assign({}, item, { onCloseMenu: props.onCloseMenu }))) : ((0,isolateComponent/* isolateComponent */.U)(ListPromo, Object.assign({}, item, { onCloseMenu: props.onCloseMenu }))),
        (0,isolateComponent/* isolateComponent */.U)("hr", { css: Promo_Styles.divider })))))) : null;
};
//# sourceMappingURL=Promo.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenu/StaticProductLeft.js







const StaticProductLeft_Styles = (0,labelStyles/* labelStyles */.B)('StaticProductLeft', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        columnGap: '30px',
    }),
    image: (0,emotion_react_browser_esm/* css */.iv)({
        width: 250,
        height: 230,
    }),
    textContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
        marginTop: 23,
    }),
    heading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), { display: 'flex', flexDirection: 'column', color: Colors/* Colors.earth */.w.earth, lineHeight: '24px' })),
    subheading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), { color: Colors/* Colors.neutral700 */.w.neutral700, display: 'block', marginTop: 8 })),
    divider: (0,emotion_react_browser_esm/* css */.iv)({
        margin: '16px 0',
        height: 1,
        backgroundColor: Colors/* Colors.neutral300 */.w.neutral300,
        width: 380,
    }),
    linksContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'grid',
        gridTemplateColumns: 'max-content max-content',
        gap: '9px 50px',
        '@media screen and (min-width: 1080px)': {
            gap: '9px 60px',
        },
    }),
    linkContainer: (0,emotion_react_browser_esm/* css */.iv)({
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'column',
        '&:hover [data-tag="link-heading"]': {
            color: Colors/* Colors.zapier */.w.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-description"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
        },
    }),
    linkHeading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold), { textDecoration: 'none', color: Colors/* Colors.earth */.w.earth, lineHeight: '30px' })),
    linkDescription: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint3 */.ZT.smallPrint3), { textDecoration: 'none', color: Colors/* Colors.neutral700 */.w.neutral700, lineHeight: '20px' })),
});
const zapLinks = [
    PRODUCT_LINKS.howItWorks,
    PRODUCT_LINKS.security,
    PRODUCT_LINKS.features,
    PRODUCT_LINKS.appIntegrations,
];
const StaticProductLeft = ({ onCloseMenu }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `Product tab Left: ${text}`,
        });
        if (eventType === 'click' && onCloseMenu)
            onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductLeft_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)(Img/* Img */.E, { alt: "A simplified user interface design representing a portion of Zapier's platform. There's a vertical menu of platform options. At the top is a dominant orange button with text inside that reads 'Create Zap.' Beneath the button is a stack of menu icons to represent dashboard, Zaps, and Transfers.", css: StaticProductLeft_Styles.image, src: "https://cdn.zapier.com/storage/photos/39bccc5dc95c6dd96978b7b5635467a8.png" }),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductLeft_Styles.textContainer },
            (0,isolateComponent/* isolateComponent */.U)("header", null,
                (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                    (0,isolateComponent/* isolateComponent */.U)(Heading/* Heading */.X, { css: StaticProductLeft_Styles.heading }, "Zapier Automation Platform")),
                (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductLeft_Styles.subheading }, "No-code automation across 5,000+ apps")),
            (0,isolateComponent/* isolateComponent */.U)("hr", { css: StaticProductLeft_Styles.divider }),
            (0,isolateComponent/* isolateComponent */.U)("ul", { css: StaticProductLeft_Styles.linksContainer }, zapLinks.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: StaticProductLeft_Styles.linkContainer, href: getFullyQualifiedURL(link.href), onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover') },
                    (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductLeft_Styles.linkHeading, "data-tag": "link-heading" }, link.text),
                    (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductLeft_Styles.linkDescription, "data-tag": "link-description" },
                        link.description,
                        (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null))))))))));
};
/* harmony default export */ var MegaMenu_StaticProductLeft = (StaticProductLeft);
//# sourceMappingURL=StaticProductLeft.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenu/StaticProductRight.js







const StaticProductRight_Styles = (0,labelStyles/* labelStyles */.B)('StaticProductRight', {
    root: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
        marginRight: 1,
        width: 250,
    }),
    header: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        '&:hover [data-tag="heading"]': {
            color: Colors/* Colors.zapier */.w.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="subheading"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: `1px solid ${Colors/* Colors.blueJeans */.w.blueJeans}`,
        },
    }),
    heading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.pageHeader9 */.ZT.pageHeader9), { color: Colors/* Colors.earth */.w.earth, lineHeight: '24px' })),
    subheading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), { color: Colors/* Colors.neutral700 */.w.neutral700, display: 'block', marginTop: 8 })),
    divider: (0,emotion_react_browser_esm/* css */.iv)({
        margin: '16px 0',
        height: 1,
        backgroundColor: Colors/* Colors.neutral300 */.w.neutral300,
    }),
    linkContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        columnGap: 10,
        marginBottom: 8,
        textDecoration: 'none',
        color: Colors/* Colors.earth */.w.earth,
        '&:hover [data-tag="link-heading"]': {
            color: Colors/* Colors.zapier */.w.zapier,
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-icon"]': {
            color: Colors/* Colors.zapier */.w.zapier,
        },
        '&:hover [data-tag="tag-label"]': {
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-description"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
            color: Colors/* Colors.neutral700 */.w.neutral700,
        },
        '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
        },
    }),
    linkIcon: (0,emotion_react_browser_esm/* css */.iv)({
        marginTop: 6,
    }),
    linkTextContainer: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        flexDirection: 'column',
    }),
    linkHeading: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.paragraph3Semibold */.ZT.paragraph3Semibold), { marginRight: 6, lineHeight: '30px' })),
    linkHeadingRow: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        alignItems: 'center',
    }),
    descriptionWrapper: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint3 */.ZT.smallPrint3), { lineHeight: '20px' })),
    linkDescription: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.smallPrint3 */.ZT.smallPrint3), { color: Colors/* Colors.neutral700 */.w.neutral700, lineHeight: '20px' })),
    tagLabel: (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({}, Typography/* Typography.base */.ZT.base), { fontSize: '10px', lineHeight: '14px', fontWeight: 600, padding: '2px 6px', borderRadius: 100, backgroundColor: Colors/* Colors.lavender */.w.lavender, textDecoration: 'none', textTransform: 'lowercase' })),
});
const earlyAccessLinks = [
    PRODUCT_LINKS.zapierTransfer,
    PRODUCT_LINKS.zapierTables,
    PRODUCT_LINKS.zapierInterfaces,
];
const StaticProductRight = ({ onCloseMenu }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `Product tab Right: ${text}`,
        });
        if (eventType === 'click' && onCloseMenu)
            onCloseMenu();
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductRight_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: StaticProductRight_Styles.header, href: getFullyQualifiedURL(PRODUCT_LINKS.earlyAccessProgram.href), onClick: () => handleEvent('Early Access Program heading', 'click'), onMouseEnter: () => handleEvent('Early Access Program heading', 'hover') },
            (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.heading, "data-tag": "heading" }, PRODUCT_LINKS.earlyAccessProgram.text),
            (0,isolateComponent/* isolateComponent */.U)("div", null,
                (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.subheading, "data-tag": "subheading" },
                    "Be the first to try new products",
                    (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null)))),
        (0,isolateComponent/* isolateComponent */.U)("hr", { css: StaticProductRight_Styles.divider }),
        (0,isolateComponent/* isolateComponent */.U)("ul", null, earlyAccessLinks.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: StaticProductRight_Styles.linkContainer, href: getFullyQualifiedURL(link.href), onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover') },
                (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.linkIcon, "data-tag": "link-icon" },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: link.icon, size: 15 })),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductRight_Styles.linkTextContainer },
                    (0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductRight_Styles.linkHeadingRow },
                        (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.linkHeading, "data-tag": "link-heading" }, link.text),
                        (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.tagLabel, "data-tag": "tag-label" }, link.tag)),
                    (0,isolateComponent/* isolateComponent */.U)("div", { css: StaticProductRight_Styles.descriptionWrapper },
                        (0,isolateComponent/* isolateComponent */.U)("span", { css: StaticProductRight_Styles.linkDescription, "data-tag": "link-description" }, link.description),
                        (0,isolateComponent/* isolateComponent */.U)(ArrowLinkIcon, null))))))))));
};
/* harmony default export */ var MegaMenu_StaticProductRight = (StaticProductRight);
//# sourceMappingURL=StaticProductRight.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/MegaMenu/MegaMenu.js









const Vars = (0,createUniqueCustomProperty/* createUniqueCustomProperties */.F)('MegaMenu', [
    'footerWidth',
    'gridTemplateAreas',
    'gridTemplateColumns',
    'leftBackgroundColor',
    'rightBackgroundColor',
]);
const MegaMenu_Styles = (0,labelStyles/* labelStyles */.B)('MegaMenu', {
    root: (isMenuOpen) => [
        emotion_react_browser_esm/* css */.iv `
      ${Vars.footerWidth}: 90%;
      ${Vars.gridTemplateAreas}: 'left-padding left-content right-content right-padding'
      'left-padding footer right-content right-padding';
      ${Vars.gridTemplateColumns}: minmax(20px, 1fr) minmax(613.33px, 780px) minmax(306.66px, 380px) minmax(20px, 1fr);
      ${Vars.leftBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      ${Vars.rightBackgroundColor}: ${Colors/* Colors.neutral200 */.w.neutral200};

      &[data-layout='stretch'] {
        ${Vars.footerWidth}: 100%;
        ${Vars.gridTemplateAreas}: 'left-padding left-content right-content right-padding'
        'lower-left footer footer footer';
        ${Vars.gridTemplateColumns}: minmax(20px, 1fr) minmax(613.33px, 810px) minmax(306.66px, 350px) minmax(20px, 1fr);
        ${Vars.leftBackgroundColor}: ${Colors/* Colors.neutral200 */.w.neutral200};
        ${Vars.rightBackgroundColor}: ${Colors/* Colors.neutral100 */.w.neutral100};
      }
    `,
        (0,emotion_react_browser_esm/* css */.iv)({
            backgroundColor: `var(${Vars.leftBackgroundColor})`,
            border: `1px solid ${Colors/* Colors.neutral400 */.w.neutral400}`,
            position: 'absolute',
            top: constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5,
            left: 0,
            right: 0,
            minHeight: '100%',
            width: '100%',
            display: `${isMenuOpen ? 'block' : 'none'}`,
        }),
    ],
    megaMenuWrapper: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'grid',
        gridTemplateColumns: `var(${Vars.gridTemplateColumns})`,
        gridTemplateRows: '1fr auto',
        gridTemplateAreas: `var(${Vars.gridTemplateAreas})`,
        minHeight: 410,
    }),
    submenu: (0,emotion_react_browser_esm/* css */.iv)({
        gridArea: 'left-content',
    }),
    submenuLinksContainer: (isStaticProductTab) => (0,emotion_react_browser_esm/* css */.iv)({
        padding: isStaticProductTab ? '30px 0 20px' : '30px 15px 20px 0',
    }),
    promotionsContainer: (isStaticProductTab) => (0,emotion_react_browser_esm/* css */.iv)({
        background: `var(${Vars.rightBackgroundColor})`,
        padding: isStaticProductTab ? '53px 0 40px 40px' : '40px 0 40px 40px',
        gridArea: 'right-content',
        display: 'flex',
        alignItems: isStaticProductTab ? 'center' : 'normal',
    }),
    footerContainer: (0,emotion_react_browser_esm/* css */.iv)({
        boxShadow: `inset 0 1px ${Colors/* Colors.neutral300 */.w.neutral300}`,
        gridArea: 'footer',
        width: `var(${Vars.footerWidth})`,
        padding: '20px 2px',
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
    }),
    lowerLeftPadding: {
        gridArea: 'lower-left',
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        boxShadow: `inset 0 1px ${Colors/* Colors.neutral300 */.w.neutral300}`,
    },
    rightColumn: (0,emotion_react_browser_esm/* css */.iv)({
        gridArea: 'right-padding',
        backgroundColor: `var(${Vars.rightBackgroundColor})`,
    }),
});
const MegaMenu = (props) => {
    const { bottomLinks, isStaticProductTab, links, promoArea } = props;
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.root(props.isMenuOpen), "data-layout": props.layout, id: props.id },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.megaMenuWrapper },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.submenu },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.submenuLinksContainer(isStaticProductTab) }, isStaticProductTab ? ((0,isolateComponent/* isolateComponent */.U)(MegaMenu_StaticProductLeft, { onCloseMenu: props.onCloseMenu })) : ((0,isolateComponent/* isolateComponent */.U)(MegaMenuSubmenu, { links: links, onCloseMenu: props.onCloseMenu })))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.promotionsContainer(isStaticProductTab) }, isStaticProductTab ? ((0,isolateComponent/* isolateComponent */.U)(MegaMenu_StaticProductRight, { onCloseMenu: props.onCloseMenu })) : ((0,isolateComponent/* isolateComponent */.U)(Promo, { promo: promoArea, onCloseMenu: props.onCloseMenu }))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.footerContainer },
                (0,isolateComponent/* isolateComponent */.U)(MegaMenuFooter, { links: bottomLinks, onCloseMenu: props.onCloseMenu })),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.lowerLeftPadding }),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: MegaMenu_Styles.rightColumn }))));
};
/* harmony default export */ var MegaMenu_MegaMenu = (MegaMenu);
//# sourceMappingURL=MegaMenu.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/UniversalTopbarLink.js









const UniversalTopbarLink_Styles = (0,labelStyles/* labelStyles */.B)('UniversalTopbarLink', {
    root: (isMenuOnly) => (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({ paddingRight: isMenuOnly ? `${CARET_SIZE + 18}px` : 18, display: 'flex', alignItems: 'center', color: Colors/* Colors.neutral700 */.w.neutral700 }, Typography/* Typography.paragraph3 */.ZT.paragraph3), { '&:hover, &:focus, &:focus-within': {
            fontWeight: 600,
        }, '&[data-position="actions-menu"]': {
            paddingRight: 0,
        } })),
    link: (isMenuOnly) => (0,emotion_react_browser_esm/* css */.iv)(Object.assign(Object.assign({ color: Colors/* Colors.inherit */.w.inherit, display: 'flex', flexDirection: 'column', alignItems: 'center', height: constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5, lineHeight: `${constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5}px` }, Typography/* Typography.base */.ZT.base), { cursor: 'pointer', textDecoration: 'none', position: 'relative', '&:visited': {
            color: 'inherit',
        }, '&:focus': {
            outline: 'none',
        }, '&:focus-within > span': {
            '&::before': {
                backgroundColor: Colors/* Colors.neutral300 */.w.neutral300,
            },
        }, '&::after': {
            content: 'attr(data-text)',
            height: 0,
            visibility: 'hidden',
            overflow: 'hidden',
            userSelect: 'none',
            pointerEvents: 'none',
            fontWeight: 600,
        }, '&::before': {
            content: '""',
            height: 6,
            width: 0,
            fontWeight: 600,
            position: 'absolute',
            color: Colors/* Colors.zapier */.w.zapier,
            borderBottom: '6px solid',
            bottom: 0,
            left: 0,
            zIndex: 10,
            transition: `width 200ms ${Animation/* Animation.transitionTimingFunction */.f.transitionTimingFunction}`,
        }, '&[data-selected="true"]': {
            '&::before': {
                width: isMenuOnly ? 'calc(100% + 17px)' : '100%',
            },
        } })),
    linkInner: (isMenuOnly) => (0,emotion_react_browser_esm/* css */.iv)({
        transformStyle: 'preserve-3d',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 20,
            right: isMenuOnly ? '-28px' : '-10px',
            bottom: 20,
            left: '-10px',
            transform: 'translateZ(-1px)',
            borderRadius: 4,
            height: 32,
        },
    }),
    caret: (isMenuOpen) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            transition: Animation/* Animation.transitionValue */.f.transitionValue,
            position: 'absolute',
            top: CARET_SIZE - 1,
            right: `-${CARET_SIZE}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: CARET_SIZE,
            width: CARET_SIZE,
        }),
        isMenuOpen &&
            (0,withModifier/* withModifier */.Q)('menu-open', {
                transform: 'rotate(-180deg)',
            }),
    ],
});
const UniversalTopbarLink = (props) => {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const sanitizedId = (_a = props.ariaControls) === null || _a === void 0 ? void 0 : _a.replace(/[^\w]/g, '');
    const isMenuOnly = props.href === null;
    const handleEvent = (eventType) => {
        let eventMessage = '';
        if (eventType === 'click') {
            eventMessage = `${props.isMenuOpen ? 'Closing' : 'Opening'} UniversalLayout DynamicTopBar: ${isMenuOnly ? props.children : props.href}`;
        }
        else {
            eventMessage = `UniversalLayout DynamicTopBar: ${isMenuOnly ? props.children : props.href}`;
        }
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: eventMessage,
        });
    };
    const LinkComponent = isMenuOnly ? 'button' : Link/* Link */.r;
    const link = ((0,isolateComponent/* isolateComponent */.U)(LinkComponent, { color: isMenuOnly ? undefined : null, css: UniversalTopbarLink_Styles.link(isMenuOnly), "data-text": props.children, "data-selected": isMenuOnly && props.isMenuOpen, href: isMenuOnly ? undefined : getFullyQualifiedURL(props.href) || undefined, onClick: () => {
            handleEvent('click');
            if (props.toggleMenu && !props.href)
                props.toggleMenu();
        }, onMouseEnter: () => handleEvent('hover'), "aria-controls": sanitizedId, "aria-expanded": isMenuOnly ? props.isMenuOpen : undefined },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: UniversalTopbarLink_Styles.linkInner(isMenuOnly) },
            props.children,
            isMenuOnly && ((0,isolateComponent/* isolateComponent */.U)("span", { css: UniversalTopbarLink_Styles.caret(props.isMenuOpen) },
                (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: "arrowSmallDown", size: 16 }))))));
    const submenu = props.submenu && ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        link,
        (0,isolateComponent/* isolateComponent */.U)(MegaMenu_MegaMenu, { bottomLinks: props.bottomLinks, id: sanitizedId || '', isMenuOpen: props.isMenuOpen || false, isStaticProductTab: props.isStaticProductTab || false, key: (props.isMenuOpen || 'false').toString(), layout: props.isStaticProductTab ? 'stretch' : undefined, links: props.submenu, onCloseMenu: props.onCloseMenu, promoArea: props.promoArea })));
    const WrapperElement = props.position === 'actions-menu' ? 'span' : 'li';
    return ((0,isolateComponent/* isolateComponent */.U)(WrapperElement, { css: UniversalTopbarLink_Styles.root(isMenuOnly), "data-position": props.position, "data-testid": "topbar-link", role: props.role }, submenu || link));
};
/* harmony default export */ var UniversalTopbar_UniversalTopbarLink = (UniversalTopbarLink);
//# sourceMappingURL=UniversalTopbarLink.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/BrandButton/BrandButton.js
var BrandButton = __webpack_require__(37510);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/AccountActions.js







const AccountActions_Styles = (0,labelStyles/* labelStyles */.B)('AccountActions', {
    signupButton: {
        minWidth: 100,
    },
});
const AccountActions = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const signupPreintentEvent = () => {
        emitUserInteractionEvent({
            interaction_name: 'universalnav-signup',
            event_action: 'click',
            option_selected: 'Sign up',
        });
    };
    return ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        props.shouldRenderSignIn && ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { ariaControls: undefined, role: "none", href: getFullyQualifiedURL(props.loginHref) || null, isSelected: props.selectedHref.includes(props.loginHref), position: "actions-menu" }, "Log in")),
        props.shouldRenderSignUp && ((0,isolateComponent/* isolateComponent */.U)("div", { css: AccountActions_Styles.signupButton },
            (0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, { href: props.signupHref, id: "universalnav-signup", isFullWidth: true, onClick: signupPreintentEvent }, "Sign up")))));
};
AccountActions.defaultProps = {
    loginHref: constants/* loginPath */.Qv,
    selectedHref: '',
    signupHref: constants/* signupPath */.au,
    size: 'medium',
};
/* harmony default export */ var UniversalTopbar_AccountActions = (AccountActions);
//# sourceMappingURL=AccountActions.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/downshift/dist/downshift.esm.js + 2 modules
var downshift_esm = __webpack_require__(57490);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/FloatingMenu/FloatingMenu.js
var FloatingMenu = __webpack_require__(35080);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Spinner/Spinner.js
var Spinner = __webpack_require__(22211);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/TextInput/TextInput.js
var TextInput = __webpack_require__(42126);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/utils/formatAriaAttrKeys.js
var formatAriaAttrKeys = __webpack_require__(95945);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Typeahead/TypeaheadInput.js
var TypeaheadInput_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const TypeaheadInput_Styles = (0,labelStyles/* labelStyles */.B)('TypeaheadInput', {
    clearSelectionButton: emotion_react_browser_esm/* css */.iv `
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    &:hover,
    &:focus {
      color: ${Colors/* Colors.neutral600 */.w.neutral600};
      transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
    }
  `,
});
const ClearSelectionButton = ({ clearSelection, }) => {
    return ((0,isolateComponent/* isolateComponent */.U)("button", { type: "button", css: TypeaheadInput_Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection" },
        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { canAcceptPointerEvents: false, name: "x", size: 20 })));
};
const InputIcon = (props) => {
    return props.renderIcon && props.selectedItem ? (props.renderIcon(props.selectedItem, props.getLabelForItem)) : ((0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: "magnifyingGlass", size: props.iconSize }));
};
const TypeaheadInput = (_a) => {
    var { size = 'small' } = _a, props = TypeaheadInput_rest(_a, ["size"]);
    const showClearSelectionButton = props.selectedItem && !props.isDisabled;
    return ((0,isolateComponent/* isolateComponent */.U)(TextInput/* TextInput */.o, Object.assign({}, (0,formatAriaAttrKeys/* camelCaseAriaAttrs */.j)(props.getInputProps({
        ariaLabelledBy: props.ariaLabelledBy,
        autoComplete: props.autoComplete,
        onFocus: props.onFocus,
    })), { ariaLabel: props.ariaLabel, autoComplete: "off", canClickIconAfter: showClearSelectionButton, disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored, placeholder: props.placeholder, renderIconAfter: ({ iconSize, isFocused, isHovered }) => showClearSelectionButton ? ((0,isolateComponent/* isolateComponent */.U)(ClearSelectionButton, { clearSelection: props.clearSelection, isFocused: isFocused, isHovered: isHovered })) : (props.iconEndName && (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: props.iconEndName, size: iconSize })), renderIconBefore: ({ iconSize }) => {
            if (props.isBusy) {
                return ((0,isolateComponent/* isolateComponent */.U)("span", { style: { width: iconSize } },
                    (0,isolateComponent/* isolateComponent */.U)(Spinner/* Spinner */.$, null)));
            }
            return (0,isolateComponent/* isolateComponent */.U)(InputIcon, Object.assign({}, props, { iconSize: iconSize }));
        }, size: size })));
};
//# sourceMappingURL=TypeaheadInput.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/Typeahead/Typeahead.js
var Typeahead_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, ' ').trim();
const defaultFilterItems = (inputValue, items, getLabelForItem, showEmptyList = false) => {
    if (showEmptyList || !inputValue) {
        return items;
    }
    const lowerCaseInput = inputValue.toLowerCase();
    return items.filter((item) => {
        return getLabelForItem(item)
            .toLowerCase()
            .includes(dedupeAndTrimWhitespace(lowerCaseInput));
    });
};
const Typeahead_Styles = (0,labelStyles/* labelStyles */.B)('Typeahead', {
    root: () => [
        {
            position: 'relative',
        },
    ],
});
class Typeahead extends react.Component {
    constructor() {
        super(...arguments);
        this.itemToString = (item) => {
            return item ? this.props.getLabelForItem(item) : '';
        };
        this.stateReducer = (state, changes) => {
            if (this.props.keepInputValueOnBlur &&
                (changes.type === downshift_esm/* default.stateChangeTypes.blurInput */.ZP.stateChangeTypes.blurInput ||
                    changes.type === downshift_esm/* default.stateChangeTypes.mouseUp */.ZP.stateChangeTypes.mouseUp)) {
                return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
            }
            return changes;
        };
    }
    render() {
        const { props } = this;
        return ((0,isolateComponent/* isolateComponent */.U)(downshift_esm/* default */.ZP, { id: props.id, initialSelectedItem: props.selectedItem || props.initialSelectedItem, inputId: props.inputId, inputValue: props.inputValue, itemToString: this.itemToString, labelId: props.labelId, onChange: props.onChange, onInputValueChange: props.onInputValueChange, selectedItem: props.selectedItem, stateReducer: this.stateReducer }, ({ clearSelection, getInputProps, getItemProps, getMenuProps, getRootProps, highlightedIndex, inputId, inputValue, isOpen, openMenu, selectedItem, }) => {
            if (props.setClearSelection) {
                props.setClearSelection(clearSelection);
            }
            const ariaLabelledBy = props.labelId || null;
            const _a = getRootProps({
                'aria-labelledby': ariaLabelledBy,
                refKey: 'innerRef',
            }), { innerRef } = _a, rootProps = Typeahead_rest(_a, ["innerRef"]);
            const filteredItems = props.filterItems(inputValue, props.items, props.getLabelForItem, props.showEmptyList || false);
            const showMenu = isOpen && filteredItems.length > 0;
            const isErrored = (props.showErrorOnNoResults &&
                inputValue &&
                filteredItems.length === 0) ||
                props.isErrored;
            return ((0,isolateComponent/* isolateComponent */.U)("div", Object.assign({}, rootProps, { css: Typeahead_Styles.root(), ref: innerRef }),
                (0,isolateComponent/* isolateComponent */.U)(TypeaheadInput, { ariaLabel: props.ariaLabel, ariaLabelledBy: ariaLabelledBy, autoComplete: props.autoComplete, clearSelection: clearSelection, disabledText: props.disabledText, getInputProps: getInputProps, getLabelForItem: props.getLabelForItem, iconEndName: props.iconEndName, inputValue: inputValue, isBusy: props.isBusy, isDisabled: props.isDisabled, isErrored: !!isErrored, onFocus: props.openOnFocus ? openMenu : undefined, placeholder: props.placeholder, renderIcon: props.renderIcon, selectedItem: selectedItem, size: props.size }),
                showMenu &&
                    props.renderFloatingMenu({
                        ariaLabel: props.menuAriaLabel,
                        getItemProps,
                        getKeyForItem: props.getKeyForItem,
                        getLabelForItem: props.getLabelForItem,
                        getMenuProps,
                        highlightedIndex,
                        items: filteredItems,
                        renderIcon: props.renderIcon,
                    })));
        }));
    }
}
Typeahead.defaultProps = {
    filterItems: defaultFilterItems,
    isDisabled: false,
    openOnFocus: false,
    renderFloatingMenu: (props) => ((0,isolateComponent/* isolateComponent */.U)(FloatingMenu/* FloatingMenu */.A, Object.assign({}, props))),
    showEmptyList: false,
    showErrorOnNoResults: false,
};
/* harmony default export */ var Typeahead_Typeahead = (Typeahead);
//# sourceMappingURL=Typeahead.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceTypeahead/useAppSearchData/publicAppSearchQuery.js

const publicAppSearchQuery = lib/* default */.ZP `
  query publicAppSearchQuery(
    $nameContains: String!
    $limit: Int!
    $excludeUpcoming: Boolean
    $includeIsAppAdmin: Boolean
    $includeIsAppCollaborator: Boolean
  ) {
    getAppsByNameContains(
      nameContains: $nameContains
      limit: $limit
      excludeUpcoming: $excludeUpcoming
      includingIsAppAdmin: $includeIsAppAdmin
      includingIsAppCollaborator: $includeIsAppCollaborator
    ) {
      edges {
        id
        canonicalId
        slug
        name
        currentImplementation {
          id
        }
        images {
          url_16x16
          url_32x32
          url_64x64
          url_128x128
        }
      }
    }
  }
`;
//# sourceMappingURL=publicAppSearchQuery.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceTypeahead/useAppSearchData/useAppSearchData.js
var useAppSearchData_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


const DEFAULT_LIMIT = 20;
const timeoutIds = new WeakMap();
const simpleDebounce = (fn, delay) => (...args) => {
    clearTimeout(timeoutIds.get(fn));
    const timeoutId = setTimeout(() => {
        fn(...args);
    }, delay);
    timeoutIds.set(fn, timeoutId);
};
const useAppSearchData_dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, ' ').trim();
const useAppSearchData = ({ limit, searchDebounceDelay, excludeUpcoming, useQuery, includeIsAppAdmin, includeIsAppCollaborator, }) => {
    var _a;
    const [searchQuery, setSearchQuery] = (0,react.useState)('');
    const variables = {
        limit: limit || DEFAULT_LIMIT,
        nameContains: useAppSearchData_dedupeAndTrimWhitespace(searchQuery),
        excludeUpcoming,
        includeIsAppAdmin,
        includeIsAppCollaborator,
    };
    const _b = useQuery(publicAppSearchQuery, {
        variables,
        skip: searchQuery.trim() === '',
    }), { data } = _b, graphqlQueryControls = useAppSearchData_rest(_b, ["data"]);
    const apps = ((_a = data === null || data === void 0 ? void 0 : data.getAppsByNameContains) === null || _a === void 0 ? void 0 : _a.edges) || [];
    return Object.assign(Object.assign({}, graphqlQueryControls), { onSearch: simpleDebounce((query) => {
            setSearchQuery(useAppSearchData_dedupeAndTrimWhitespace(query));
        }, searchDebounceDelay || 0), searchQuery: useAppSearchData_dedupeAndTrimWhitespace(searchQuery), apps });
};
//# sourceMappingURL=useAppSearchData.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceIcon/ServiceIcon.js
var ServiceIcon = __webpack_require__(64476);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/patterns/ServiceTypeahead/ServiceTypeahead.js







const ServiceTypeahead_Styles = (0,labelStyles/* labelStyles */.B)('ServiceTypeahead', {
    serviceIcon: emotion_react_browser_esm/* css */.iv `
    &[data-disabled] {
      opacity: 0.6;
    }
  `,
});
const emptyItem = {
    disabled: true,
    name: 'No search results found.',
};
const ServiceTypeahead_dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, ' ').trim();
const ServiceTypeahead = (props) => {
    const { ariaLabel, disabledText, initialSelectedItem, inputId, isDisabled, labelId, menuAriaLabel, onChange, onResultsUpdate, placeholder, slugFilter, excludeUpcoming, resultsLimit, setClearSelection, size, includeIsAppAdmin, includeIsAppCollaborator, } = props;
    const getIconUrlForItem = (item) => item.images.url_32x32;
    const getLabelForItem = (item) => item.name;
    const renderIcon = (item) => {
        if (!item || !item.images) {
            return null;
        }
        return ((0,isolateComponent/* isolateComponent */.U)("span", { css: ServiceTypeahead_Styles.serviceIcon, "data-disabled": isDisabled ? '' : undefined },
            (0,isolateComponent/* isolateComponent */.U)(ServiceIcon/* ServiceIcon */.A, { ariaHidden: true, serviceName: getLabelForItem(item), size: 30, src: getIconUrlForItem(item) })));
    };
    const { apps, loading, onSearch, searchQuery } = useAppSearchData({
        limit: resultsLimit,
        searchDebounceDelay: 300,
        excludeUpcoming,
        useQuery: props.useQuery,
        includeIsAppAdmin,
        includeIsAppCollaborator,
    });
    (0,react.useEffect)(() => {
        if (!loading && searchQuery.length && onResultsUpdate) {
            onResultsUpdate(ServiceTypeahead_dedupeAndTrimWhitespace(searchQuery), apps);
        }
    }, [apps, loading, onResultsUpdate, searchQuery]);
    const filteredApps = !slugFilter
        ? apps
        : apps.filter((app) => app.slug !== slugFilter);
    const hasZeroResults = loading === false && searchQuery.length > 0 && filteredApps.length === 0;
    const displayedApps = hasZeroResults ? [emptyItem] : filteredApps;
    return ((0,isolateComponent/* isolateComponent */.U)(Typeahead_Typeahead, { ariaLabel: ariaLabel, autoComplete: "off", disabledText: disabledText, getLabelForItem: getLabelForItem, id: props.id, initialSelectedItem: initialSelectedItem, inputId: inputId, isBusy: loading, isDisabled: isDisabled, items: loading || searchQuery === '' ? [] : displayedApps, labelId: labelId, menuAriaLabel: menuAriaLabel, onChange: onChange, onInputValueChange: (query) => onSearch(ServiceTypeahead_dedupeAndTrimWhitespace(query)), placeholder: placeholder, renderFloatingMenu: (menuProps) => props.renderFloatingMenu(Object.assign(Object.assign({}, menuProps), { visibleItems: resultsLimit })), renderIcon: renderIcon, setClearSelection: setClearSelection, showEmptyList: true, size: size }));
};
ServiceTypeahead.defaultProps = {
    excludeUpcoming: true,
    includeIsAppAdmin: true,
    includeIsAppCollaborator: true,
    onResultsUpdate: () => { },
    renderFloatingMenu: (props) => (0,isolateComponent/* isolateComponent */.U)(FloatingMenu/* FloatingMenu */.A, Object.assign({}, props)),
    resultsLimit: 4,
};
//# sourceMappingURL=ServiceTypeahead.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/SearchToggler.js



const SearchToggler_Styles = (0,labelStyles/* labelStyles */.B)('SearchToggler', {
    root: emotion_react_browser_esm/* css */.iv `
    width: 40px;
    height: 40px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors/* Colors.neutral600 */.w.neutral600};
    transition: ${Animation/* Animation.transitionValue */.f.transitionValue};

    &:hover,
    &:focus {
      background-color: transparent;
      color: ${Colors/* Colors.neutral800 */.w.neutral800};
    }
  `,
});
const SearchToggler = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: props.label, position: "south", shouldCorrectPosition: false, showTooltipOnTouchDevices: false }, () => ((0,isolateComponent/* isolateComponent */.U)("label", { "aria-hidden": props.ariaHidden, "aria-label": props.ariaLabel, css: SearchToggler_Styles.root, htmlFor: props.id },
        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: props.isSearching ? 'formX' : 'magnifyingGlass', size: 24 })))));
};
/* harmony default export */ var UniversalTopbar_SearchToggler = (SearchToggler);
//# sourceMappingURL=SearchToggler.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/SearchForm.js






const SearchForm_Styles = (0,labelStyles/* labelStyles */.B)('SearchForm', {
    root: ({ isSearching }) => [
        {
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: 10,
            width: isSearching ? '100%' : 'auto',
            maxWidth: 500,
        },
    ],
});
const SearchForm = (props) => {
    const { useQuery } = useUniversalNavContext();
    const [setClickOutsideNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: () => props.onClose(),
    });
    const onEscape = (e) => {
        if (e.key === 'Escape') {
            props.onClose();
        }
    };
    const { routeTo } = (0,dist/* useLink */.nB)();
    const handleChange = (app) => {
        const { location } = window;
        const isDevOrStaging = location.origin.includes('localhost') ||
            location.origin.includes('zapier-staging');
        const isZapier = location.origin.startsWith('https://zapier.com');
        if (app && app.slug) {
            const url = `/apps/${app.slug}/integrations`;
            emitUserInteractionEvent({
                interaction_name: 'universalNavServiceTypeahead',
                event_action: 'click',
                option_selected: app.slug,
            });
            if (routeTo) {
                routeTo(url);
            }
            else {
                if (isDevOrStaging || isZapier)
                    location.href = `${location.origin}${url}`;
                else
                    location.href = `https://zapier.com${url}`;
            }
        }
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: SearchForm_Styles.root(props), role: "form" },
        (0,isolateComponent/* isolateComponent */.U)("div", { onKeyUp: onEscape, ref: setClickOutsideNode },
            (0,isolateComponent/* isolateComponent */.U)(ServiceTypeahead, { ariaLabel: "Search Apps", excludeUpcoming: false, id: "universalNavServiceTypeahead", inputId: props.searchInputId, menuAriaLabel: "List of available apps", onChange: (app) => handleChange(app), placeholder: "Search by App", resultsLimit: 8, useQuery: useQuery })),
        (0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_SearchToggler, { ariaHidden: true, ariaLabel: "Close search", isSearching: true })));
};
/* harmony default export */ var UniversalTopbar_SearchForm = (SearchForm);
//# sourceMappingURL=SearchForm.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalTopbar/UniversalTopbar.js













const UniversalTopbar_Styles = (0,labelStyles/* labelStyles */.B)('UniversalTopbar', {
    root: [
        {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: `${Colors/* Colors.neutral100 */.w.neutral100}`,
            position: 'relative',
            borderBottom: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        },
    ],
    header: ({ hasSidebar }) => [
        (0,emotion_react_browser_esm/* css */.iv)({
            width: '100%',
            maxWidth: '1200px',
            height: constants/* UNIVERSAL_TOPBAR_CONDENSED_HEIGHT */.Eg,
            padding: '0 22px 0 10px',
            display: 'grid',
            gridTemplateColumns: 'max-content auto max-content',
            alignItems: 'stretch',
            gap: '5px',
            backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
            '@media (min-width: 450px)': {
                height: constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5,
                padding: '0 20px',
                gap: '0',
            },
        }),
        hasSidebar &&
            (0,withModifier/* withModifier */.Q)('has-sidebar', (0,emotion_react_browser_esm/* css */.iv)({
                maxWidth: 'none',
                paddingLeft: '10px',
            })),
    ],
    group: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        justifySelf: 'flex-end',
        gap: '5px',
        '@media (min-width: 450px)': {
            gap: '17px',
        },
    }),
    mainNavigationContent: [
        {
            display: 'flex',
            alignItems: 'stretch',
            marginLeft: 25,
        },
    ],
    searchForm: (props, { isSearching }) => [
        {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: Animation/* Animation.transitionValue */.f.transitionValue,
            opacity: 0,
            pointerEvents: 'none',
            transform: 'scaleX(0)',
        },
        isSearching &&
            (0,withModifier/* withModifier */.Q)('searching', {
                opacity: 1,
                pointerEvents: 'auto',
                transform: 'scaleX(1)',
            }),
        props.isSearchFullWidth &&
            (0,withModifier/* withModifier */.Q)('fullWidth', {
                backgroundColor: `${Colors/* Colors.neutral100 */.w.neutral100}`,
                padding: '0 10px',
            }),
    ],
    searchToggler: ({ isSearching }) => [
        {
            marginRight: -7,
            transition: Animation/* Animation.transitionValue */.f.transitionValue,
        },
        isSearching &&
            (0,withModifier/* withModifier */.Q)('hidden', {
                opacity: 0.2,
                pointerEvents: 'none',
            }),
    ],
    navLinksList: (props) => [
        Object.assign({ display: 'grid' }, (props.links && {
            gridTemplateColumns: `repeat(${props.links.length + 1}, max-content)`,
        })),
        props.isSearching &&
            (0,withModifier/* withModifier */.Q)('searching', {
                opacity: 0,
            }),
    ],
    logoLinksWrapper: {
        position: 'relative',
    },
    skipLink: {
        position: 'absolute',
        top: '100%',
        whiteSpace: 'nowrap',
    },
});
const staticProductTabBottomLinks = [
    {
        text: 'Contact Sales',
        icon: 'actionCalendar',
        href: '/l/contact-sales?demo_source=cs_nav_menu_product',
    },
    {
        text: 'Explore app integrations',
        icon: 'actionExplore',
        href: '/apps',
    },
];
const Links = (props) => {
    var _a;
    const [activeMenu, setActiveMenu] = (0,react.useState)('');
    const [activeElement, setActiveElement] = (0,react.useState)(null);
    const [setClickOutsideNav] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: () => setActiveMenu(''),
    });
    const toggleMegaMenu = (menuId) => {
        if (activeMenu === menuId) {
            if (activeElement instanceof HTMLElement)
                activeElement.focus();
            setActiveMenu('');
        }
        else {
            if (activeElement instanceof HTMLElement)
                setActiveElement(document.activeElement);
            setActiveMenu(menuId);
        }
    };
    const closeMenu = () => setActiveMenu('');
    const handleEscape = (e) => {
        if (e.key === 'Escape') {
            if (activeElement instanceof HTMLElement)
                activeElement.focus();
            setActiveMenu('');
        }
    };
    (0,react.useEffect)(() => {
        document.addEventListener('keydown', handleEscape, { capture: false });
        return () => {
            document.removeEventListener('keydown', handleEscape, { capture: false });
        };
    });
    const filteredBottomLinks = staticProductTabBottomLinks.filter((link) => {
        return props.hasCta ? link.text !== 'Contact Sales' : link;
    });
    const staticProductTab = ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { ariaControls: "Product", bottomLinks: filteredBottomLinks, href: null, isMenuOpen: activeMenu === 'Product', isStaticProductTab: true, key: "Product", isSelected: props.selectedHref === 'Product', onCloseMenu: closeMenu, position: "navigation", submenu: [], toggleMenu: () => toggleMegaMenu('Product') }, "Product"));
    const links = (_a = props.links) === null || _a === void 0 ? void 0 : _a.map((link) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { ariaControls: link.text, bottomLinks: link.bottomLinks, href: link.href, isMenuOpen: activeMenu === link.text, key: link.text, isSelected: props.selectedHref === link.href, isStaticProductTab: false, position: "navigation", promoArea: link.promoArea, submenu: link.submenu, toggleMenu: () => toggleMegaMenu(link.text), onCloseMenu: closeMenu }, link.text)));
    if (!links) {
        return null;
    }
    return ((0,isolateComponent/* isolateComponent */.U)("nav", { "aria-label": "Site Links", id: "site-nav", ref: setClickOutsideNav },
        (0,isolateComponent/* isolateComponent */.U)("ul", { css: UniversalTopbar_Styles.navLinksList(props) },
            staticProductTab,
            links)));
};
const UniversalTopbar = (props) => {
    var _a;
    const { currentUrl, getFullyQualifiedURL, shouldRenderCallToAction, topNavData, } = useUniversalNavContext();
    const hasCta = !isEmptyObject(topNavData.callToAction);
    const sidebar = props.renderSidebar && props.renderSidebar(props);
    const logoSize = {
        width: 105,
        height: 28,
    };
    const searchInputId = 'universal-nav-app-search';
    const [isSearching, setIsSearching] = (0,react.useState)(false);
    const onCloseSearch = () => {
        setIsSearching(false);
    };
    const searchForm = props.renderSearchForm({
        isSearching,
        searchInputId,
        onClose: onCloseSearch,
    });
    const [setClickOutsideNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: (event) => {
            if (props.onClickOutside)
                props.onClickOutside(event);
        },
    });
    const { links } = props;
    const callToActionUrl = getFullyQualifiedURL(`${(_a = topNavData.callToAction) === null || _a === void 0 ? void 0 : _a.href}?demo_source=cs_nav_header_${currentUrl}`) || '';
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.root, ref: (node) => setClickOutsideNode(node) },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.header({ hasSidebar: !!sidebar }), "data-testid": "universalTopbar", onClick: props.onClick },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.group },
                sidebar,
                props.shouldRenderLogo && ((0,isolateComponent/* isolateComponent */.U)("header", { css: UniversalTopbar_Styles.logoLinksWrapper },
                    (0,isolateComponent/* isolateComponent */.U)("a", { "aria-label": props.logoAriaLabel, href: getFullyQualifiedURL(props.logoHref), onClick: props.onLogoClick },
                        (0,isolateComponent/* isolateComponent */.U)(ZapierLogo, Object.assign({}, logoSize))),
                    (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.skipLink },
                        (0,isolateComponent/* isolateComponent */.U)(SkipLink_SkipLink, { href: props.skipLinkHref }))))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.mainNavigationContent },
                links && links.length > 0 && ((0,isolateComponent/* isolateComponent */.U)(Links, Object.assign({}, props, { hasCta: hasCta, isSearching: isSearching, links: links }))),
                !!searchForm && ((0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": "Search apps", css: UniversalTopbar_Styles.searchForm(props, { isSearching }), onBlur: () => {
                        setIsSearching(false);
                    }, onFocus: () => {
                        setIsSearching(true);
                        emitUserInteractionEvent({
                            interaction_name: searchInputId,
                            event_action: 'in_view',
                            option_selected: 'Universal Nav Search opened',
                        });
                    }, role: "form" }, searchForm))),
            (0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": "Manage your account and search apps", css: UniversalTopbar_Styles.group, role: "form" },
                !!searchForm && ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalTopbar_Styles.searchToggler({ isSearching }), "data-testid": "searchToggler" },
                    (0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_SearchToggler, { id: searchInputId, isSearching: false, label: "Search apps\u2026" }))),
                topNavData.callToAction &&
                    props.size !== 'small' &&
                    shouldRenderCallToAction && ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { href: callToActionUrl, isSelected: false, position: "actions-menu" }, topNavData.callToAction.text)),
                props.renderAccountMenu(props)))));
};
UniversalTopbar.defaultProps = {
    logoAriaLabel: 'Go to the Zapier Homepage',
    logoHref: '/',
    onLogoClick: () => { },
    renderAccountMenu: (props) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_AccountActions, { selectedHref: props.selectedHref, shouldRenderSignIn: props.size !== 'small', shouldRenderSignUp: true, size: props.size })),
    renderNotifications: () => null,
    renderSearchForm: (props) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_SearchForm, { isSearching: props.isSearching, onClose: props.onClose, searchInputId: props.searchInputId })),
    selectedHref: '',
    shouldRenderLogo: true,
    size: 'medium',
    skipLinkHref: constants/* skipLinkHref */.fe,
};
/* harmony default export */ var UniversalTopbar_UniversalTopbar = (UniversalTopbar);
//# sourceMappingURL=UniversalTopbar.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/TopbarLoadingState/TopbarLoadingState.js
var TopbarLoadingState_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};










const TopbarLoadingState_Styles = (0,labelStyles/* labelStyles */.B)('TopbarLoadingState', {
    root: [
        {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: `${Colors/* Colors.neutral100 */.w.neutral100}`,
            position: 'relative',
            borderBottom: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        },
    ],
    header: (0,emotion_react_browser_esm/* css */.iv)({
        width: '100%',
        maxWidth: '1200px',
        height: constants/* UNIVERSAL_TOPBAR_CONDENSED_HEIGHT */.Eg,
        padding: '0 10px 0 59px',
        display: 'grid',
        gridTemplateColumns: 'max-content auto max-content',
        alignItems: 'stretch',
        gap: '5px',
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
        '@media (min-width: 450px)': {
            height: constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5,
            padding: '0 20px 0 71px',
            gap: '0',
        },
        '@media (min-width: 1040px)': {
            paddingLeft: '20px',
        },
    }),
    group: (0,emotion_react_browser_esm/* css */.iv)({
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        justifySelf: 'flex-end',
        gap: '5px',
        '@media (min-width: 450px)': {
            gap: '17px',
        },
    }),
    mainNavigationContent: [
        {
            display: 'flex',
            alignItems: 'stretch',
            marginLeft: 25,
        },
    ],
    logoLinksWrapper: {
        position: 'relative',
    },
    skipLink: {
        position: 'absolute',
        top: '100%',
        whiteSpace: 'nowrap',
    },
});
const TopbarLoadingState = (_a) => {
    var _b;
    var { shouldRenderHiddenMenu = true } = _a, props = TopbarLoadingState_rest(_a, ["shouldRenderHiddenMenu"]);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const logoSize = {
        width: 105,
        height: 28,
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: TopbarLoadingState_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: TopbarLoadingState_Styles.header, "data-testid": "universalTopbar-loading-state" },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TopbarLoadingState_Styles.group }, props.shouldRenderLogo && ((0,isolateComponent/* isolateComponent */.U)("header", { css: TopbarLoadingState_Styles.logoLinksWrapper },
                (0,isolateComponent/* isolateComponent */.U)("a", { "aria-label": props.logoAriaLabel, href: getFullyQualifiedURL(props.logoHref), onClick: props.onLogoClick },
                    (0,isolateComponent/* isolateComponent */.U)(ZapierLogo, Object.assign({}, logoSize))),
                (0,isolateComponent/* isolateComponent */.U)("div", { css: TopbarLoadingState_Styles.skipLink },
                    (0,isolateComponent/* isolateComponent */.U)(SkipLink_SkipLink, { href: props.skipLinkHref }))))),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: TopbarLoadingState_Styles.mainNavigationContent }, shouldRenderHiddenMenu ? ((0,isolateComponent/* isolateComponent */.U)(VisuallyHidden/* VisuallyHidden */.T, null,
                (0,isolateComponent/* isolateComponent */.U)("nav", { "aria-label": "Site Links", id: "site-nav" },
                    (0,isolateComponent/* isolateComponent */.U)("ul", null,
                        (0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { ariaControls: "Product", bottomLinks: staticProductTabBottomLinks, href: null, isSelected: false, isStaticProductTab: true, key: "Product", submenu: [] }, "Product"), (_b = topNavFallbackData === null || topNavFallbackData === void 0 ? void 0 : topNavFallbackData.topBarMenu) === null || _b === void 0 ? void 0 :
                        _b.map((link) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbarLink, { href: link.href, key: link.text, isSelected: false, submenu: link.submenu }, link.text))))))) : ((0,isolateComponent/* isolateComponent */.U)(Spacer/* Spacer */.L, null))),
            (0,isolateComponent/* isolateComponent */.U)("div", { "aria-label": "Manage your account and search apps", css: TopbarLoadingState_Styles.group, role: "form" }, props.renderAccountMenu(props)))));
};
TopbarLoadingState.defaultProps = {
    logoAriaLabel: 'Go to the Zapier Homepage',
    logoHref: '/',
    onLogoClick: () => { },
    renderAccountMenu: (props) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_AccountActions, { selectedHref: props.selectedHref, shouldRenderSignIn: props.size !== 'small', shouldRenderSignUp: true, size: props.size })),
    renderNotifications: () => null,
    renderSearchForm: (props) => ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_SearchForm, { isSearching: props.isSearching, onClose: props.onClose, searchInputId: props.searchInputId })),
    selectedHref: '',
    shouldRenderLogo: true,
    size: 'medium',
    skipLinkHref: constants/* skipLinkHref */.fe,
};
/* harmony default export */ var TopbarLoadingState_TopbarLoadingState = (TopbarLoadingState);
//# sourceMappingURL=TopbarLoadingState.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(29476);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/hashString.js
const hashString = (str) => {
    let hash = 0;
    let i = 0;
    let chr = null;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return Math.abs(hash).toString(16);
};
//# sourceMappingURL=hashString.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/createUniqueClassName.js

const createUniqueClassName = (block, elementName) => {
    const hash = hashString('universal-nav' + block + elementName);
    return `${block}__${elementName}-${hash}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalNavLink/UniversalNavLink.js




const tooltipClassName = createUniqueClassName('UniversalNavLink', 'tooltip');
const tooltipSelector = `.${tooltipClassName}`;
const navIconClassName = createUniqueClassName('UniversalNavLink', 'navIcon');
const navIconSelector = `.${navIconClassName}`;
const externalIconClassName = createUniqueClassName('UniversalNavLink', 'externalIcon');
const externalIconSelector = `.${externalIconClassName}`;
const UniversalNavLink_Styles = (0,labelStyles/* labelStyles */.B)('UniversalNavLink', {
    root: (props, hasBeforeText) => [
        (0,withModifier/* withModifier */.Q)('', Object.assign(Object.assign(Object.assign({}, Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium), { color: Colors/* Colors.neutral800 */.w.neutral800, display: 'flex', position: 'relative', minHeight: 50, padding: 10, borderRadius: 3, whiteSpace: 'nowrap', width: '100%', transition: `${Animation/* Animation.transitionValue */.f.transitionValue}, font-weight 0s`, textDecoration: 'none', '&:hover, &:focus': {
                transition: 'none',
                color: Colors/* Colors.neutral800 */.w.neutral800,
                backgroundColor: Colors/* Colors.neutral200 */.w.neutral200,
                outline: 'none',
            }, [navIconSelector]: {
                color: Colors/* Colors.neutral600 */.w.neutral600,
            }, [`&:hover ${navIconSelector}, &:focus ${navIconSelector}`]: {
                transition: 'none',
                color: Colors/* Colors.neutral800 */.w.neutral800,
            } }), (props.isSidebar && Object.assign(Object.assign({}, Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium), { borderRadius: 15, color: Colors/* Colors.neutral700 */.w.neutral700, outline: 'solid 2px transparent', '&:hover, &:focus': {
                transition: 'none',
                backgroundColor: Colors/* Colors.cream */.w.cream,
                outline: `solid 2px transparent`,
            }, '&:focus': Object.assign(Object.assign({}, Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold), { outlineOffset: '-1px', outline: `solid 2px ${Colors/* Colors.brand */.w.brand}` }), [navIconSelector]: {
                color: Colors/* Colors.neutral800 */.w.neutral800,
            }, [`&:hover ${navIconSelector}, &:focus ${navIconSelector}`]: {
                transition: 'none',
            } })))),
        !hasBeforeText &&
            (0,withModifier/* withModifier */.Q)('textOnly', {
                paddingLeft: 15,
                paddingRight: 15,
            }),
        props.isSelected &&
            (0,withModifier/* withModifier */.Q)('selected', Object.assign(Object.assign(Object.assign({}, Typography/* Typography.paragraph3Bold */.ZT.paragraph3Bold), { color: Colors/* Colors.blue */.w.blue, backgroundColor: Colors/* Colors.blue10 */.w.blue10, [navIconSelector]: {
                    color: Colors/* Colors.blue */.w.blue,
                } }), (props.isSidebar && {
                color: Colors/* Colors.neutral800 */.w.neutral800,
                backgroundColor: Colors/* Colors.cream */.w.cream,
                [navIconSelector]: { color: Colors/* Colors.brand */.w.brand },
            }))),
        props.isCollapsed &&
            (0,withModifier/* withModifier */.Q)('collapsed', {
                width: 50,
            }),
        {
            [tooltipSelector]: {
                opacity: 0,
                pointerEvents: 'none',
                transition: 'opacity 0.1s ease-in-out',
                '@media (hover: none)': {
                    display: 'none',
                },
            },
            [`&:hover ${tooltipSelector}, &:focus ${tooltipSelector}`]: {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
        {
            [externalIconSelector]: {
                opacity: 0,
            },
            [`&:hover ${externalIconSelector}, &:focus ${externalIconSelector}`]: {
                opacity: 0.5,
            },
        },
    ],
    layout: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        gap: 20,
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
    },
    text: {
        '&[aria-hidden="true"]': {
            opacity: 0,
        },
    },
});
const UniversalNavLink = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const tooltip = props.isCollapsed && ((0,isolateComponent/* isolateComponent */.U)("span", { className: tooltipClassName },
        (0,isolateComponent/* isolateComponent */.U)(Tooltip/* Tooltip */.u, { position: "east" }, props.text)));
    const onClick = (e) => {
        e.currentTarget.blur();
        if (props.onClick) {
            props.onClick(e);
        }
    };
    const beforeText = props.renderBeforeText && props.renderBeforeText(props);
    return ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: UniversalNavLink_Styles.root(props, !!beforeText), href: getFullyQualifiedURL(props.href), onClick: onClick, role: props.role, target: props.target || '_self' },
        (0,isolateComponent/* isolateComponent */.U)("span", { css: UniversalNavLink_Styles.layout },
            beforeText,
            (0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": props.isCollapsed, css: UniversalNavLink_Styles.text }, props.text),
            props.isExternal && !props.isCollapsed && ((0,isolateComponent/* isolateComponent */.U)("span", { className: externalIconClassName },
                (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: "arrowOffsite", size: 18 })))),
        tooltip));
};
UniversalNavLink.defaultProps = {
    isCollapsed: false,
    isExternal: false,
    isSelected: false,
    renderBeforeText: (props) => props.icon && ((0,isolateComponent/* isolateComponent */.U)("span", { className: navIconClassName },
        (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: props.icon, size: 30 }))),
};
/* harmony default export */ var UniversalNavLink_UniversalNavLink = (UniversalNavLink);
//# sourceMappingURL=UniversalNavLink.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarError.js


const UniversalSidebarError_Styles = (0,labelStyles/* labelStyles */.B)('UniversalSidebarError', {
    toggle: Object.assign(Object.assign({}, Typography/* Typography.smallPrint1 */.ZT.smallPrint1), { color: Colors/* Colors.error */.w.error, cursor: 'pointer', padding: '3px 0', borderBottom: `1px solid transparent`, transition: Animation/* Animation.transitionValue */.f.transitionValue, '&:hover, &:focus': {
            borderBottomColor: Colors/* Colors.error */.w.error,
        } }),
    message: {
        color: Colors/* Colors.error */.w.error,
        marginTop: 10,
        padding: 10,
        border: `1px solid ${Colors/* Colors.gray20 */.w.gray20}`,
        borderRadius: 5,
        font: '14px/18px monospace',
    },
});
const UniversalSidebarError = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)("details", null,
        (0,isolateComponent/* isolateComponent */.U)("summary", { css: UniversalSidebarError_Styles.toggle }, "Oh no, something went wrong!"),
        (0,isolateComponent/* isolateComponent */.U)("pre", { css: UniversalSidebarError_Styles.message }, props.children)));
};
/* harmony default export */ var UniversalSidebar_UniversalSidebarError = (UniversalSidebarError);
//# sourceMappingURL=UniversalSidebarError.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarSubheaderButton.js


const UniversalSidebarSubheaderButton = (props) => {
    return ((0,isolateComponent/* isolateComponent */.U)(BrandButton/* BrandButton */.h, Object.assign({ ariaLabel: props.text, iconBefore: props.iconName, hasShadow: true, href: props.href, isFullWidth: true }, (props.isCollapsed && { color: 'brand-nav' }), { size: "medium" }), !props.isCollapsed && props.text));
};
/* harmony default export */ var UniversalSidebar_UniversalSidebarSubheaderButton = (UniversalSidebarSubheaderButton);
//# sourceMappingURL=UniversalSidebarSubheaderButton.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/date/dist/index.js
var date_dist = __webpack_require__(68516);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/ProgressBar/ProgressBar.js
var ProgressBar = __webpack_require__(52819);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarUsage/abbreviateNumber.js
const suffixes = ['', 'k', 'M', 'B', 'T', ''];
const isNumber = (value) => {
    return typeof value === 'number' && !Number.isNaN(value);
};
const abbreviateNumber = (value) => {
    if (!value || (value < 1 && value > -1)) {
        return isNumber(value) ? value.toString() : null;
    }
    const tier = Math.floor(Math.log(Math.abs(value)) / Math.log(1000));
    const suffix = suffixes[Math.min(tier, suffixes.length)];
    const adjusted = String(Math.abs(value) / Math.pow(1000, tier)).substring(0, 3);
    const noTrailingDec = adjusted.endsWith('.')
        ? adjusted.slice(0, -1)
        : adjusted;
    return `${value < 0 ? '-' : ''}${noTrailingDec}${suffix}`;
};
//# sourceMappingURL=abbreviateNumber.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarUsage/UsageBar.js



const UsageBar_Styles = (0,labelStyles/* labelStyles */.B)('UsageBar', {
    root: {
        display: 'block',
        paddingTop: '10px',
    },
    text: {
        display: 'grid',
        gap: 20,
        gridTemplateColumns: 'auto 1fr',
        marginBottom: 5,
    },
    label: Object.assign(Object.assign({}, Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold), { color: Colors/* Colors.neutral700 */.w.neutral700 }),
    amounts: Object.assign(Object.assign({}, Typography/* Typography.smallPrint1Medium */.ZT.smallPrint1Medium), { textAlign: 'right', color: Colors/* Colors.neutral700 */.w.neutral700 }),
});
const formatNumber = (number) => {
    const formatted = number > 9999 ? abbreviateNumber(number) : number.toLocaleString();
    return typeof formatted === 'string' ? formatted : 'Error';
};
const UsageBar = (props) => {
    const amount = props.max === Infinity
        ? 'Unlimited'
        : `${formatNumber(props.value)} / ${formatNumber(props.max)}`;
    return ((0,isolateComponent/* isolateComponent */.U)("figure", { css: UsageBar_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("p", { "aria-label": `Used ${props.value} of ${props.max} ${props.label}`, css: UsageBar_Styles.text },
            (0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": true, css: UsageBar_Styles.label }, props.label),
            (0,isolateComponent/* isolateComponent */.U)("span", { "aria-hidden": true, css: UsageBar_Styles.amounts }, amount)),
        props.max !== Infinity && ((0,isolateComponent/* isolateComponent */.U)(ProgressBar/* ProgressBar */.k, { max: props.max, value: props.value }))));
};
/* harmony default export */ var UniversalSidebarUsage_UsageBar = (UsageBar);
//# sourceMappingURL=UsageBar.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarUsage/UniversalSidebarUsage.js





const UniversalSidebarUsage_Styles = (0,labelStyles/* labelStyles */.B)('UniversalSidebarUsage', {
    root: {
        display: 'grid',
        gap: 10,
        whiteSpace: 'nowrap',
        padding: '0 10px 10px',
    },
    header: Object.assign(Object.assign({ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 20, alignItems: 'center' }, Typography/* Typography.base */.ZT.base), { fontSize: 16, fontWeight: 600, color: Colors/* Colors.gray80 */.w.gray80 }),
    planName: Object.assign(Object.assign({ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }, Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium), { color: Colors/* Colors.neutral700 */.w.neutral700 }),
    content: {
        margin: '0 5px',
    },
    usages: {
        display: 'grid',
        gap: 5,
        marginBottom: 5,
    },
    resetInfo: Object.assign(Object.assign({ display: 'grid', gap: 10 }, Typography/* Typography.smallPrint1Medium */.ZT.smallPrint1Medium), { gridTemplateRows: '1fr auto', paddingTop: '10px', color: Colors/* Colors.neutral700 */.w.neutral700 }),
    managePlanLink: {
        fontWeight: 600,
        textDecoration: 'underline',
        '&:hover, &:focus': {
            color: Colors/* Colors.blue */.w.blue,
            outline: 'none',
        },
    },
});
const Usages = (props) => {
    const hasUsedExtraTasks = props.isPlanMetered && props.numTasks > props.numFreeTasksMax;
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarUsage_Styles.usages },
        (0,isolateComponent/* isolateComponent */.U)(UniversalSidebarUsage_UsageBar, { label: props.isPlanMetered ? 'Included Tasks' : 'Tasks', max: props.isPlanMetered ? props.numFreeTasksMax : props.numTasksMax, value: props.isPlanMetered
                ? Math.min(props.numTasks, props.numFreeTasksMax)
                : props.numTasks }),
        hasUsedExtraTasks && ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebarUsage_UsageBar, { label: "Extra Tasks", max: props.numTasksMax - props.numFreeTasksMax, value: props.numTasks - props.numFreeTasksMax })),
        (0,isolateComponent/* isolateComponent */.U)(UniversalSidebarUsage_UsageBar, { label: "Zaps", max: props.numZapsMax, value: props.numZaps })));
};
const UniversalSidebarUsage = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const relativeDate = (0,date_dist/* formatTimeSpan */.lF)(Date.now(), props.resetDate, false);
    return ((0,isolateComponent/* isolateComponent */.U)("section", { css: UniversalSidebarUsage_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarUsage_Styles.header },
            (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { name: "miscWallet", size: 30 }),
            (0,isolateComponent/* isolateComponent */.U)("h3", { css: UniversalSidebarUsage_Styles.planName }, props.trialPlanName
                ? `${props.trialPlanName} plan (Trial)`
                : props.title)),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarUsage_Styles.content },
            (0,isolateComponent/* isolateComponent */.U)(Usages, Object.assign({}, props)),
            (0,isolateComponent/* isolateComponent */.U)("p", { css: UniversalSidebarUsage_Styles.resetInfo },
                (0,isolateComponent/* isolateComponent */.U)("span", null, props.trialPlanName && props.trialPlanEndDate
                    ? `Trial ends on ${(0,date_dist/* formatDateTime */.o0)(props.trialPlanEndDate, 'default')}`
                    : `Monthly usage resets in ${relativeDate}`),
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL(props.managePlanHref) }, "Manage Plan"))),
        props.children));
};
UniversalSidebarUsage.defaultProps = {
    isPlanMetered: false,
    numFreeTasksMax: 0,
    managePlanHref: '/app/settings/billing',
    title: 'Usage',
};
/* harmony default export */ var UniversalSidebarUsage_UniversalSidebarUsage = (UniversalSidebarUsage);
//# sourceMappingURL=UniversalSidebarUsage.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/utils/useSidebarData.js

const sidebarDataQuery = lib/* default */.ZP `
  query sidebarDataQuery($accountId: Int!) {
    isAuthenticatedV2
    account(id: $accountId) {
      id
      name
      plan {
        amount
        hasMeteredBilling
        name
        id
        tiers {
          numTasks
          pricePerTask
        }
      }
      usage {
        periodEnd
        tasks {
          limit
          total
        }
        zaps {
          limit
          on
        }
      }
      isTrialing
      trialEndDate
      isTrialingTeams
      teamTrialEndDate
      isTrialingCompanies
      companiesTrialEndDate
    }
  }
`;
const useSidebarData = ({ accountId, useQuery }) => {
    const variables = {
        accountId,
    };
    const result = useQuery(sidebarDataQuery, { ssr: false, variables });
    return result;
};
/* harmony default export */ var utils_useSidebarData = (useSidebarData);
//# sourceMappingURL=useSidebarData.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/url-utils/dist/index.js
var url_utils_dist = __webpack_require__(17712);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarSubmenu/UniversalSidebarSubmenu.js




const UniversalSidebarSubmenu_Styles = (0,labelStyles/* labelStyles */.B)('UniversalSidebarSubmenu', {
    summary: [
        emotion_react_browser_esm/* css */.iv `
      display: block;
      border-radius: 15px;
      color: ${Colors/* Colors.neutral700 */.w.neutral700};

      &:hover,
      &:focus {
        color: ${Colors/* Colors.neutral700 */.w.neutral700};
        background-color: ${Colors/* Colors.cream */.w.cream};
      }
      &:focus {
        outline: solid 2px ${Colors/* Colors.brand */.w.brand};
      }
      outline: solid 2px transparent;
      transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
    `,
        emotion_react_browser_esm/* css */.iv `
      /* Hides default icon on details element */
      &::-webkit-details-marker {
        display: none;
      }
      /* Hide default icon from IE. */
      &::before {
        display: none;
      }
    `,
    ],
    summaryInner: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium};
    line-height: 20px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
    align-items: center;
    min-height: 50px;
    padding: 10px 15px;
    white-space: nowrap;
    width: 100%;
    transition: ${Animation/* Animation.transitionValue */.f.transitionValue};
  `,
    caret: emotion_react_browser_esm/* css */.iv `
    transition: ${Animation/* Animation.transitionValue */.f.transitionValue};

    [open] & {
      transform: rotate(-180deg);
    }
  `,
    list: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-columns: 100%;
    gap: 5px;
    padding: 10px 0;
  `,
    link: emotion_react_browser_esm/* css */.iv `
    ${Typography/* Typography.paragraph3Medium */.ZT.paragraph3Medium};
    display: block;
    border-radius: 3px;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    line-height: 20px;
    padding: 10px 15px;
    text-decoration: none;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    outline: solid 2px transparent;
    transition: ${Animation/* Animation.transitionValue */.f.transitionValue};

    &:hover,
    &:focus {
      background-color: ${Colors/* Colors.cream */.w.cream};
      text-decoration: none;
    }
    &:hover {
      outline: solid 2px transparent;
    }
    &:focus {
      outline: solid 2px ${Colors/* Colors.brand */.w.brand};
    }
  `,
    linkInner: emotion_react_browser_esm/* css */.iv `
    transform: translateY(1px);
    padding-left: 16px;
  `,
    linkTitle: emotion_react_browser_esm/* css */.iv `
    display: block;
    text-decoration: none;
    outline: none;
  `,
    linkDescription: emotion_react_browser_esm/* css */.iv `
    display: block;
    color: ${Colors/* Colors.neutral700 */.w.neutral700};
    margin-top: 5px;
    font-size: 12px;
    line-height: 15px;
    text-decoration: none;
    outline: none;
  `,
});
const SubmenuLink = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { color: null, css: UniversalSidebarSubmenu_Styles.link, href: props.href ? getFullyQualifiedURL(props.href) : undefined },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarSubmenu_Styles.linkInner },
            (0,isolateComponent/* isolateComponent */.U)("p", { css: UniversalSidebarSubmenu_Styles.linkTitle }, props.text),
            props.description && ((0,isolateComponent/* isolateComponent */.U)("p", { css: UniversalSidebarSubmenu_Styles.linkDescription }, props.description)))));
};
const UniversalSidebarSubmenu = (props) => {
    const linkItems = props.links.map((link) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: link.text },
        (0,isolateComponent/* isolateComponent */.U)(SubmenuLink, Object.assign({}, link)),
        link.submenu && ((0,isolateComponent/* isolateComponent */.U)("ul", null, link.submenu.map((nestedLink) => ((0,isolateComponent/* isolateComponent */.U)("li", { key: nestedLink.text, style: { paddingLeft: '16px' } },
            (0,isolateComponent/* isolateComponent */.U)(SubmenuLink, Object.assign({}, nestedLink))))))))));
    return ((0,isolateComponent/* isolateComponent */.U)("details", null,
        (0,isolateComponent/* isolateComponent */.U)("summary", { css: UniversalSidebarSubmenu_Styles.summary },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarSubmenu_Styles.summaryInner },
                (0,isolateComponent/* isolateComponent */.U)("span", null, props.text),
                (0,isolateComponent/* isolateComponent */.U)("span", { css: UniversalSidebarSubmenu_Styles.caret },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { isBlock: true, name: "arrowSmallDown", size: 24 })))),
        (0,isolateComponent/* isolateComponent */.U)("ul", { css: UniversalSidebarSubmenu_Styles.list }, linkItems)));
};
/* harmony default export */ var UniversalSidebarSubmenu_UniversalSidebarSubmenu = (UniversalSidebarSubmenu);
//# sourceMappingURL=UniversalSidebarSubmenu.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/hooks/useSidebarLinkData.js



const useSidebarLinkData = () => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const [sideNavData, setSideNavData] = (0,react.useState)([]);
    (0,react.useEffect)(() => {
        let apiSubscribed = true;
        async function getSidebarUrlData() {
            const serverUrl = getServerUrl();
            const sidebarUrl = `${serverUrl}/navigation-data/sidebar`;
            let userId = '0';
            try {
                const sessionResult = await fetch(getFullyQualifiedURL('/api/v4/session/'));
                const session = await sessionResult.json();
                if (session.id) {
                    userId = session.id;
                }
            }
            catch (_a) {
            }
            try {
                const response = await fetch(sidebarUrl, {
                    headers: { 'x-customuser-id': userId },
                });
                if (!response.ok) {
                    throw new Error('Response was not OK');
                }
                if (apiSubscribed) {
                    const json = await response.json();
                    const { data } = json;
                    setSideNavData(data);
                }
            }
            catch (error) {
                if (apiSubscribed) {
                    setSideNavData([]);
                }
            }
        }
        getSidebarUrlData();
        return () => {
            apiSubscribed = false;
        };
    }, [getFullyQualifiedURL]);
    return { sideNavData };
};
//# sourceMappingURL=useSidebarLinkData.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebar.js







const GAP = 20;
const UniversalSidebar_Styles = (0,labelStyles/* labelStyles */.B)('UniversalSidebar', {
    root: (props) => [
        {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: Colors/* Colors.neutral100 */.w.neutral100,
            padding: '30px 10px 0 10px',
            width: '100%',
            transition: Animation/* Animation.transitionValue */.f.transitionValue,
            willChange: 'transform, width',
        },
        !props.isFullWidth &&
            (0,withModifier/* withModifier */.Q)('constrainedWidth', {
                width: constants/* UNIVERSAL_SIDEBAR_WIDTH */.Z,
                maxWidth: '100vw',
            }),
        !props.isFullWidth &&
            (0,withModifier/* withModifier */.Q)('bordered', {
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    width: 1,
                    backgroundColor: Colors/* Colors.gray20 */.w.gray20,
                },
            }),
        props.isShadowed &&
            (0,withModifier/* withModifier */.Q)('shadowed', {
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    bottom: 0,
                    width: 10,
                    pointerEvents: 'none',
                    background: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.10) 0%,
            rgba(0, 0, 0, 0.03) 50%,
            rgba(0, 0, 0, 0.00) 100%
          )`,
                },
            }),
        props.isCollapsed &&
            (0,withModifier/* withModifier */.Q)('collapsed', {
                width: constants/* UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH */.Cq,
                overflow: 'visible',
            }),
    ],
    header: {
        flex: 'none',
    },
    content: (props) => [
        {
            overflow: 'auto',
            paddingTop: GAP,
            paddingBottom: GAP,
            flexBasis: 'auto',
            flexShrink: 1,
            flexGrow: 0,
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': {
                display: 'none',
            },
        },
        props.isCollapsed &&
            (0,withModifier/* withModifier */.Q)('collapsed', {
                overflow: 'visible',
            }),
    ],
    links: (props) => [
        Object.assign({ alignContent: 'start', display: 'grid', gap: 10 }, (!props.isCollapsed && { padding: '0 2px' })),
    ],
    footer: {
        flex: 'none',
        borderTop: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        paddingTop: GAP,
        paddingBottom: GAP,
    },
});
const isLinkSelected = (href, selectedHref) => {
    return (0,url_utils_dist.normalizePathname)(href).endsWith((0,url_utils_dist.normalizePathname)(selectedHref));
};
const PropLink = ({ isCollapsed, isSelected, link, }) => {
    const iconOutlineList = [
        'miscBoltAlt',
        'miscClock',
        'navApps',
        'navDashboard',
        'navExplore',
        'navHelp',
    ];
    const icon = link.icon && iconOutlineList.includes(link.icon)
        ? isSelected
            ? `${link.icon}Fill`
            : link.icon
        : link.icon;
    const linkOrMenu = link.submenu && !link.href ? ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebarSubmenu_UniversalSidebarSubmenu, { links: link.submenu, text: link.text })) : ((0,isolateComponent/* isolateComponent */.U)(UniversalNavLink_UniversalNavLink, { href: link.href, icon: icon, isCollapsed: isCollapsed, isSelected: isSelected, isSidebar: true, text: link.text }));
    return (0,isolateComponent/* isolateComponent */.U)("li", null, linkOrMenu);
};
const UniversalSidebar_Links = (props) => {
    var _a;
    const links = (_a = props.links) === null || _a === void 0 ? void 0 : _a.map((link) => {
        const isSelected = isLinkSelected(link.href || '', props.selectedHref);
        return ((0,isolateComponent/* isolateComponent */.U)(PropLink, { isCollapsed: props.isCollapsed, isSelected: isSelected, key: link.text, link: link }));
    });
    return (0,isolateComponent/* isolateComponent */.U)("ul", { css: UniversalSidebar_Styles.links(props) }, links);
};
const UniversalSidebar = (props) => {
    const { sideNavData } = useSidebarLinkData();
    const mouseProps = {
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
    };
    const subheaderContent = props.renderSubheader && props.renderSubheader(props);
    const subheader = subheaderContent && ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebar_Styles.header }, subheaderContent));
    const footerContent = props.renderFooter();
    const footer = footerContent && ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebar_Styles.footer, role: "region" }, footerContent));
    const linksToRender = props.links || UniversalSidebarLinks(sideNavData);
    return ((0,isolateComponent/* isolateComponent */.U)("nav", Object.assign({ "aria-label": "Site Links", css: UniversalSidebar_Styles.root(props), "data-testid": "universalSidebar" }, mouseProps),
        subheader,
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebar_Styles.content(props) },
            (0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_Links, Object.assign({}, props, { links: linksToRender }))),
        footer));
};
UniversalSidebar.defaultProps = {
    isCollapsed: false,
    isFullWidth: true,
    logoHref: '/',
    logoAriaLabel: 'Go to homepage',
    renderFooter: () => null,
    selectedHref: '',
    skipLinkHref: constants/* skipLinkHref */.fe,
};
/* harmony default export */ var UniversalSidebar_UniversalSidebar = (UniversalSidebar);
//# sourceMappingURL=UniversalSidebar.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalSidebar/UniversalSidebarContainer.js
var UniversalSidebarContainer_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};











const infinitize = (number) => {
    return number === -1 ? Infinity : number;
};
const MaybeCta = (props) => {
    const isFree = props.planAmount === 0;
    const isNearTaskLimit = props.numTasks / props.numTasksMax >= 0.8;
    const isNearZapLimit = props.numZaps / props.numZapsMax >= 0.8;
    return isFree || isNearTaskLimit || isNearZapLimit ? ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "secondary", href: props.upgradeLink, isFullWidth: true, size: "small" }, "Upgrade plan")) : null;
};
const UniversalSidebarContainer_Styles = (0,labelStyles/* labelStyles */.B)('UniversalSidebarContainer', {
    footerWrapper: {
        overflow: 'hidden',
        padding: 10,
    },
    tOSWrapper: {
        whiteSpace: 'initial',
        background: Colors/* Colors.neutral200 */.w.neutral200,
        border: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        borderRadius: 10,
        padding: 15,
    },
    tOSHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    tOSHeading: {
        display: 'flex',
        alignItems: 'center',
    },
    tOSDismissalIconButton: {
        display: 'flex',
        alignItems: 'center',
        '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
        },
    },
    tOSDismissalButton: {
        color: `${Colors/* Colors.blue */.w.blue}`,
        textDecoration: 'underline',
        '&:focus': {
            outline: `1px solid ${Colors/* Colors.blue */.w.blue}`,
        },
    },
    divider: {
        border: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        marginTop: 10,
        marginBottom: 10,
    },
});
const MaybeTOS = () => {
    const LATEST_VERSION_OF_TERMS = 'design-system-tos-notification-2022-11-15';
    const hasUserDismissedLatestToS = localStorage.getItem('versionOfTermsDismissed') ===
        LATEST_VERSION_OF_TERMS || false;
    const handleDismiss = () => {
        localStorage.setItem('versionOfTermsDismissed', LATEST_VERSION_OF_TERMS);
    };
    const { getFullyQualifiedURL, shouldRenderTOS } = useUniversalNavContext();
    return shouldRenderTOS && hasUserDismissedLatestToS === false ? ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
        (0,isolateComponent/* isolateComponent */.U)("hr", { css: UniversalSidebarContainer_Styles.divider }),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarContainer_Styles.tOSWrapper },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarContainer_Styles.tOSHeader },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarContainer_Styles.tOSHeading },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { ariaHidden: true, color: "blueJeans", name: "alertInfoFill", size: 18 }),
                    (0,isolateComponent/* isolateComponent */.U)(HeadingLevel/* HeadingLevel */.y, null,
                        (0,isolateComponent/* isolateComponent */.U)(Text/* Text */.x, { margin: "0 0 0 5px", tag: Heading/* Heading */.X, type: "smallPrint1Semibold" }, "Updated Terms"))),
                (0,isolateComponent/* isolateComponent */.U)("button", { "aria-label": "Dismiss notification", css: UniversalSidebarContainer_Styles.tOSDismissalIconButton, onClick: handleDismiss, type: "button" },
                    (0,isolateComponent/* isolateComponent */.U)(Icon/* Icon */.J, { ariaHidden: true, color: "neutral800", name: "formX", size: 24 }))),
            (0,isolateComponent/* isolateComponent */.U)(Text/* Text */.x, { tag: "p", type: "smallPrint1" },
                "We updated the",
                ' ',
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL('/legal/terms-of-service') }, "Zapier Terms of Service"),
                ' ',
                "on November 15, 2022. For existing users, these updated terms will be effective beginning on December 15, 2022. By continuing to use Zapier, you agree to these updated terms.",
                ' ',
                (0,isolateComponent/* isolateComponent */.U)("button", { css: UniversalSidebarContainer_Styles.tOSDismissalButton, type: "button", onClick: handleDismiss }, "Dismiss"))))) : null;
};
const FooterWrapper = ({ children }) => ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalSidebarContainer_Styles.footerWrapper }, children));
const UniversalSidebarContainer = (_a) => {
    var { currentAccountId } = _a, props = UniversalSidebarContainer_rest(_a, ["currentAccountId"]);
    const { useQuery, getFullyQualifiedURL } = useUniversalNavContext();
    const result = utils_useSidebarData({ accountId: currentAccountId, useQuery });
    const { loading, data, error } = result;
    const renderedUsageLink = ((0,isolateComponent/* isolateComponent */.U)(UniversalNavLink_UniversalNavLink, { href: usageLink.href, icon: usageLink.icon, isCollapsed: props.isCollapsed, isSelected: isLinkSelected(usageLink.href || '', props.selectedHref), isSidebar: true, text: usageLink.text }));
    const renderFooter = () => {
        if (props.isCollapsed) {
            return renderedUsageLink;
        }
        if (error) {
            return ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                renderedUsageLink,
                (0,isolateComponent/* isolateComponent */.U)(FooterWrapper, null,
                    (0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_UniversalSidebarError, null, error.message),
                    (0,isolateComponent/* isolateComponent */.U)(MaybeTOS, null))));
        }
        if (loading || !(data === null || data === void 0 ? void 0 : data.account)) {
            return null;
        }
        const { plan, usage, isTrialing, trialEndDate, isTrialingTeams, teamTrialEndDate, isTrialingCompanies, companiesTrialEndDate, } = data.account;
        const tiers = plan.tiers;
        const freeTier = tiers && tiers.find((tier) => tier.pricePerTask === 0);
        const numFreeTasksMax = freeTier ? freeTier.numTasks : 0;
        const normalizedUsage = {
            isPlanMetered: plan.hasMeteredBilling,
            numTasks: usage.tasks.total,
            numFreeTasksMax,
            numTasksMax: infinitize(usage.tasks.limit),
            numZaps: usage.zaps.on,
            numZapsMax: infinitize(usage.zaps.limit),
        };
        const trialPlanName = isTrialingTeams
            ? 'Team'
            : isTrialingCompanies
                ? 'Company'
                : isTrialing
                    ? 'Professional'
                    : undefined;
        const trialPlanEndDate = isTrialingTeams
            ? teamTrialEndDate
            : isTrialingCompanies
                ? companiesTrialEndDate
                : trialEndDate;
        return ((0,isolateComponent/* isolateComponent */.U)(FooterWrapper, null,
            (0,isolateComponent/* isolateComponent */.U)(UniversalSidebarUsage_UniversalSidebarUsage, Object.assign({}, normalizedUsage, { resetDate: usage.periodEnd, title: `${plan.name} Plan`, trialPlanName: trialPlanName, trialPlanEndDate: trialPlanEndDate !== null && trialPlanEndDate !== void 0 ? trialPlanEndDate : undefined }),
                (0,isolateComponent/* isolateComponent */.U)(MaybeCta, Object.assign({}, normalizedUsage, { planAmount: plan.amount, upgradeLink: getFullyQualifiedURL('/app/pricing') })),
                (0,isolateComponent/* isolateComponent */.U)(MaybeTOS, null))));
    };
    return ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_UniversalSidebar, Object.assign({}, props, { logoAriaLabel: "Go to dashboard", logoHref: getFullyQualifiedURL('/app/dashboard'), renderFooter: renderFooter, renderSubheader: () => ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_UniversalSidebarSubheaderButton, { href: getFullyQualifiedURL('/webintent/create-zap?entry-point-method=make_a_zap_call_to_action'), iconName: "formAdd", isCollapsed: props.isCollapsed, text: "Create Zap" })) })));
};
/* harmony default export */ var UniversalSidebar_UniversalSidebarContainer = (UniversalSidebarContainer);
//# sourceMappingURL=UniversalSidebarContainer.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/AccountsMenu/utils/useAccountsMenuData.js

const accountsDataQuery = lib/* default */.ZP `
  query accountsDataQuery {
    accounts {
      id
      normalizedImageUrl
      normalizedName
    }
    currentUserV2 {
      id
      email
    }
  }
`;
const useAccountsMenuData = ({ useQuery }) => useQuery(accountsDataQuery, { ssr: false, fetchPolicy: 'network-only' });
/* harmony default export */ var utils_useAccountsMenuData = (useAccountsMenuData);
//# sourceMappingURL=useAccountsMenuData.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Avatar/Avatar.js
var Avatar = __webpack_require__(41273);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/FloatingBox/FloatingBox.js
var FloatingBox = __webpack_require__(15504);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/AccountsMenu/AccountsMenu.js






const detailsClassName = createUniqueClassName('AccountsMenu', 'details');
const AccountsMenu_Styles = (0,labelStyles/* labelStyles */.B)('AccountsMenu', {
    root: {
        position: 'relative',
    },
    accounts: {
        borderBottom: `1px solid ${Colors/* Colors.neutral300 */.w.neutral300}`,
        marginBottom: 10,
        paddingBottom: 10,
        overflow: 'auto',
        maxHeight: 'calc(60px * 3.5)',
    },
    summary: {
        position: 'relative',
        display: 'block',
        cursor: 'pointer',
        transition: Animation/* Animation.transitionValue */.f.transitionValue,
        '&::-webkit-details-marker': {
            display: 'none',
        },
    },
    menuContainer: {
        padding: 10,
        width: 300,
    },
    email: Object.assign(Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 10px' }, Typography/* Typography.smallPrint1Semibold */.ZT.smallPrint1Semibold), { color: Colors/* Colors.neutral600 */.w.neutral600, marginBottom: 10 }),
    emailText: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
});
const renderAccountSwitchMenu = (props, setIsMenuOpen) => {
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: AccountsMenu_Styles.accounts }, props.accounts.map((account) => {
        const isCurrentAccount = account.id === props.currentAccountId;
        return ((0,isolateComponent/* isolateComponent */.U)(UniversalNavLink_UniversalNavLink, { href: account.accountSwitcherUrl, isSelected: isCurrentAccount, key: account.id, onClick: (event) => {
                if (props.onAccountClick) {
                    props.onAccountClick(account, event);
                }
                setIsMenuOpen(false);
            }, renderBeforeText: () => ((0,isolateComponent/* isolateComponent */.U)("div", { css: AccountsMenu_Styles.avatar },
                (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { isBlock: true, isSelected: isCurrentAccount, name: account.name, shouldLazilyLoad: false, size: 40, url: account.imageUrl }))), role: "menuitem", text: account.name }));
    })));
};
const renderMenuLinks = (props, setIsMenuOpen) => {
    return props.menuLinks.map((menuLink) => ((0,isolateComponent/* isolateComponent */.U)(UniversalNavLink_UniversalNavLink, { href: menuLink.href, icon: menuLink.icon, key: menuLink.text, onClick: () => setIsMenuOpen(false), role: "menuitem", text: menuLink.text, target: menuLink.target })));
};
const fallbackAccount = {
    id: -1,
    name: '⋯',
    accountSwitcherUrl: '/',
};
const AccountsMenu = (props) => {
    const [isMenuOpen, setIsMenuOpen] = (0,react.useState)(false);
    const [setClickOutsideNode] = (0,useClickOutside/* useClickOutside */.O)({
        onClickOutside: () => setIsMenuOpen(false),
    });
    const currentAccount = props.accounts.find((account) => account.id === props.currentAccountId) ||
        fallbackAccount;
    const toggleMenu = (event) => {
        event.preventDefault();
        setIsMenuOpen(!isMenuOpen);
    };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: AccountsMenu_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("details", { className: detailsClassName, "data-testid": "accountsMenu", open: isMenuOpen, ref: (node) => setClickOutsideNode(node) },
            (0,isolateComponent/* isolateComponent */.U)("summary", { "aria-haspopup": "menu", "aria-label": props.menuLabel, css: AccountsMenu_Styles.summary, "data-testid": "accounts-menu-summary", onClick: toggleMenu, tabIndex: 0 },
                (0,isolateComponent/* isolateComponent */.U)(TooltipWrapper/* TooltipWrapper */.p, { content: currentAccount.name, isBlock: true, position: "west", shouldCorrectPosition: false, tooltipId: "tooltip-accounts-menu" }, ({ childProps }) => ((0,isolateComponent/* isolateComponent */.U)("div", Object.assign({}, (0,formatAriaAttrKeys/* kebabCaseAriaAttrs */.v)(childProps)),
                    (0,isolateComponent/* isolateComponent */.U)(Avatar/* Avatar */.q, { isBlock: true, isInteractive: true, isSelected: isMenuOpen, name: currentAccount.name, shouldLazilyLoad: false, size: props.size === 'small' ? 25 : 40, url: currentAccount.imageUrl }))))),
            (0,isolateComponent/* isolateComponent */.U)(FloatingBox/* FloatingBox */.f, { align: "right", hasWhiteBackground: props.hasWhiteBackground, position: "south", borderRadius: 10 },
                (0,isolateComponent/* isolateComponent */.U)("div", { css: AccountsMenu_Styles.menuContainer, role: "menu" },
                    (0,isolateComponent/* isolateComponent */.U)("div", { css: AccountsMenu_Styles.email },
                        (0,isolateComponent/* isolateComponent */.U)("span", { css: AccountsMenu_Styles.emailText }, props.email)),
                    props.accounts.length > 1 &&
                        renderAccountSwitchMenu(props, setIsMenuOpen),
                    renderMenuLinks(props, setIsMenuOpen))))));
};
AccountsMenu.defaultProps = {
    menuLabel: 'Accounts Settings',
    menuLinks: AccountsMenuLinks,
    size: 'medium',
};
/* harmony default export */ var AccountsMenu_AccountsMenu = (AccountsMenu);
//# sourceMappingURL=AccountsMenu.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/AccountsMenu/AccountsMenuContainer.js






const AccountsMenuContainer = (props) => {
    var _a;
    const { useQuery, getFullyQualifiedURL } = useUniversalNavContext();
    const result = utils_useAccountsMenuData({ useQuery });
    const { data } = result;
    const accounts = ((data === null || data === void 0 ? void 0 : data.accounts) || []).map((account) => ({
        id: account.id,
        name: account.normalizedName,
        imageUrl: account.normalizedImageUrl,
        accountSwitcherUrl: getFullyQualifiedURL((0,identity_esm/* buildAccountSwitcherUrl */.L5)(account.id)),
    }));
    const menuLinks = [
        ...AccountsMenuLinks.map((link) => (Object.assign(Object.assign({}, link), { href: getFullyQualifiedURL(link.href) || null }))),
    ];
    if (accounts.length > 1) {
        menuLinks.unshift(moveZapsLink);
    }
    const email = ((_a = data === null || data === void 0 ? void 0 : data.currentUserV2) === null || _a === void 0 ? void 0 : _a.email) || '';
    return ((0,isolateComponent/* isolateComponent */.U)(AccountsMenu_AccountsMenu, Object.assign({ accounts: accounts, email: email, menuLinks: menuLinks }, props)));
};
/* harmony default export */ var AccountsMenu_AccountsMenuContainer = (AccountsMenuContainer);
//# sourceMappingURL=AccountsMenuContainer.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/utils/findAccountsMenuRenderer.js





const renderAccountsMenuContainerConfig = {
    shouldRender: (renderProps) => {
        return renderProps.isLoggedIn;
    },
    makeRenderer: (renderProps) => (props) => {
        const backToAppButton = !renderProps.currentUrl.includes('/app/') &&
            renderProps.canTopbarFitBackToAppButton && (react.createElement(UniversalNavContext.Consumer, null, (context) => !renderProps.isMyZapsButtonHidden && (react.createElement(BrandButton/* BrandButton */.h, { href: context.getFullyQualifiedURL('/app/zaps'), id: "back-to-app" }, "My Zaps"))));
        return (react.createElement(react.Fragment, null,
            backToAppButton,
            react.createElement(AccountsMenu_AccountsMenuContainer, { currentAccountId: renderProps.currentAccountId, size: props.size })));
    },
};
const renderLoadingConfig = {
    shouldRender: (renderProps) => {
        return !renderProps.isLoggedIn && renderProps.isLoadingLoggedIn;
    },
    makeRenderer: () => () => {
        return (react.createElement("div", { "data-testid": "accounts-loader" },
            react.createElement(Spinner/* Spinner */.$, { color: "black" })));
    },
};
const renderSignUpOnlyConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/login');
    },
    makeRenderer: (renderProps) => (props) => {
        const isOnReauthenticate = renderProps.currentUrl.includes('/reauthenticate');
        return (react.createElement(UniversalTopbar_AccountActions, { selectedHref: renderProps.currentUrl, shouldRenderSignIn: false, shouldRenderSignUp: !isOnReauthenticate, signupHref: renderProps.signupHref, size: props.size }));
    },
};
const renderSignInOnlyConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/sign-up');
    },
    makeRenderer: (renderProps) => (props) => {
        return (react.createElement(UniversalTopbar_AccountActions, { loginHref: renderProps.loginHref, selectedHref: renderProps.currentUrl, shouldRenderSignIn: true, shouldRenderSignUp: false, size: props.size }));
    },
};
const renderOnboardingConfig = {
    shouldRender: (renderProps) => {
        return renderProps.currentUrl.includes('/onboarding');
    },
    makeRenderer: () => () => {
        return null;
    },
};
const configs = [
    renderSignUpOnlyConfig,
    renderSignInOnlyConfig,
    renderOnboardingConfig,
    renderAccountsMenuContainerConfig,
    renderLoadingConfig,
];
const findAccountsMenuRenderer = (renderProps) => {
    const foundConfig = configs.find((config) => {
        return config.shouldRender(renderProps);
    });
    return foundConfig && foundConfig.makeRenderer(renderProps);
};
/* harmony default export */ var utils_findAccountsMenuRenderer = (findAccountsMenuRenderer);
//# sourceMappingURL=findAccountsMenuRenderer.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/hooks/useUnscrollableBody.js

const hasBody = () => {
    return typeof document !== 'undefined' && !!document.body;
};
const useUnscrollableBody = ({ shouldAllowScroll, }) => {
    (0,react.useEffect)(() => {
        if (hasBody()) {
            document.body.style.overflow = shouldAllowScroll ? '' : 'hidden';
        }
        return () => {
            if (hasBody()) {
                document.body.style.overflow = '';
            }
        };
    }, [shouldAllowScroll]);
};
/* harmony default export */ var hooks_useUnscrollableBody = (useUnscrollableBody);
//# sourceMappingURL=useUnscrollableBody.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-nav/components/UniversalNav.js















const MY_ZAPS_TEXT = 'My Zaps';
const LOGIN_TEXT = 'Log in';
const SIGN_UP_TEXT = 'Sign up';
const slideAnimation = emotion_react_browser_esm/* keyframes */.F4 `
  0% { transform: translateX(-100%); }
  100% { transform: translateX(0); }
`;
const UniversalNav_Styles = (0,labelStyles/* labelStyles */.B)('UniversalNav', {
    root: ({ shouldHeaderStickToTop }) => [
        emotion_react_browser_esm/* css */.iv `
      position: sticky;
      z-index: ${constants/* UNIVERSAL_NAV_ZINDEX */.ii};
      top: -${constants/* UNIVERSAL_TOPBAR_CONDENSED_HEIGHT */.Eg}px;

      @media (min-width: 450px) {
        top: -${constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5}px;
      }
    `,
        shouldHeaderStickToTop &&
            (0,withModifier/* withModifier */.Q)('stuck-to-top', emotion_react_browser_esm/* css */.iv `
          top: 0;
        `),
    ],
    sidebarCtaButtons: emotion_react_browser_esm/* css */.iv `
    display: grid;
    grid-template-columns: 1fr fr;
    gap: 10px;
  `,
    forceMenuCollapseButton: emotion_react_browser_esm/* css */.iv `
    margin-left: 5px;
  `,
    sidebarWrapper: ({ isFixed, isFullWidth, }) => [
        emotion_react_browser_esm/* css */.iv `
      position: absolute;
      display: flex;
      align-items: stretch;
      // Push beneath UniversalTopbar border so the border is seen.
      margin-top: 1px;
      top: 100%;
      left: 0;
      height: 100vh;
      will-change: height;
      transition: height 300ms linear;
    `,
        isFixed &&
            !isFullWidth &&
            emotion_react_browser_esm/* css */.iv `
        position: fixed;
        top: 0;
        bottom: 0;
        height: auto;
      `,
        isFullWidth &&
            emotion_react_browser_esm/* css */.iv `
        // Pull above UniversalTopbar border so the border is hidden.
        margin-top: 0;
        width: 100%;
      `,
        !isFullWidth &&
            emotion_react_browser_esm/* css */.iv `
        animation: ${slideAnimation} ${Animation/* Animation.transitionDuration */.f.transitionDuration} ease-in-out;
      `,
    ],
});
const copyQueryString = (source, destination) => (0,url_utils_dist.addParamsToUrl)(destination, (0,url_utils_dist.extractParams)(source), true);
const Sidebar = (props) => {
    var _a;
    const { getFullyQualifiedURL, shouldRenderAccessibleSidebar, } = useUniversalNavContext();
    const [isCollapsed, setIsCollapsed] = (0,react.useState)(true);
    const isFullWidth = props.size === 'small';
    const isActuallyCollapsed = !isFullWidth &&
        !props.isSidebarForcedOpen &&
        !props.isSidebarControlledByTopbar &&
        isCollapsed;
    const sharedProps = {
        isCollapsed: isActuallyCollapsed,
        isFullWidth,
        isShadowed: !isFullWidth && !props.isSidebarForcedOpen && !isActuallyCollapsed,
        onClick: props.onClick,
        onMouseEnter: () => {
            if (window.matchMedia('(hover: hover)').matches) {
                setIsCollapsed(false);
            }
        },
        onMouseLeave: () => {
            if (window.matchMedia('(hover: hover)').matches) {
                setIsCollapsed(true);
            }
        },
        selectedHref: props.currentUrl,
        skipLinkHref: props.skipLinkHref,
    };
    const shouldRenderLoggedInSidebar = props.isLoggedIn &&
        props.currentAccountId &&
        (props.isOnAppPage || props.shouldRenderTopbarLinks);
    hooks_useUnscrollableBody({
        shouldAllowScroll: (!isFullWidth && !sharedProps.isShadowed) ||
            shouldRenderAccessibleSidebar,
    });
    const callToActionUrl = getFullyQualifiedURL(`${(_a = props.callToAction) === null || _a === void 0 ? void 0 : _a.href}?demo_source=cs_nav_header_${props.currentUrl}`) || '';
    const handleCallToActionClick = (text) => {
        emitUserInteractionEvent({
            event_action: 'click',
            option_selected: `UniversalDynamicTopbar: ${text}`,
        });
    };
    const ZAPS_URL = getFullyQualifiedURL('/app/zaps');
    const LOGIN_URL = getFullyQualifiedURL(props.loginHref);
    const SIGNUP_URL = getFullyQualifiedURL(props.signupHref);
    const sidebar = shouldRenderLoggedInSidebar ? ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_UniversalSidebarContainer, Object.assign({}, sharedProps, { currentAccountId: props.currentAccountId }))) : ((0,isolateComponent/* isolateComponent */.U)(UniversalSidebar_UniversalSidebar, Object.assign({}, sharedProps, { links: props.links, logoAriaLabel: "Go to Zapier homepage", logoHref: getFullyQualifiedURL('/'), renderFooter: () => {
            if (props.size === 'small' && !isActuallyCollapsed) {
                if (!props.isLoggedIn) {
                    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalNav_Styles.sidebarCtaButtons },
                        props.callToAction && ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "secondary", href: callToActionUrl, onClick: () => {
                                var _a;
                                return handleCallToActionClick(`${(_a = props.callToAction) === null || _a === void 0 ? void 0 : _a.text} to ${callToActionUrl}`);
                            }, size: "small" }, props.callToAction.text)),
                        (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "secondary", href: LOGIN_URL, size: "small", onClick: () => handleCallToActionClick(`${LOGIN_TEXT} ${LOGIN_URL}`) }, LOGIN_TEXT),
                        (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "primary", href: SIGNUP_URL, size: "small", onClick: () => handleCallToActionClick(`${SIGN_UP_TEXT} ${SIGNUP_URL}
                      )}`) }, SIGN_UP_TEXT)));
                }
                if (props.isLoggedIn && !props.isOnAppPage) {
                    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalNav_Styles.sidebarCtaButtons },
                        props.callToAction && ((0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "secondary", href: callToActionUrl, isFullWidth: true, size: "medium", onClick: () => {
                                var _a;
                                return handleCallToActionClick(`${(_a = props.callToAction) === null || _a === void 0 ? void 0 : _a.text} to ${callToActionUrl}`);
                            } }, props.callToAction.text)),
                        (0,isolateComponent/* isolateComponent */.U)(Button/* Button */.z, { color: "primary-alt", href: ZAPS_URL, isFullWidth: true, size: "medium", onClick: () => handleCallToActionClick(`${MY_ZAPS_TEXT} ${ZAPS_URL}`) }, MY_ZAPS_TEXT)));
                }
            }
            return null;
        } })));
    const style = { height: props.height };
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalNav_Styles.sidebarWrapper({
            isFixed: props.isFixed,
            isFullWidth,
        }), style: style }, sidebar));
};
const UniversalNav = (props) => {
    const { canTopbarFitBackToAppButton, canForceSidebarOpen, currentAccountId, currentUrl, isLoadingLoggedIn, isLoadingTopNav, isLoggedIn, isOnAppPage, isMyZapsButtonHidden, isSearchFullWidth, isSidebarForcedOpen, isSidebarControlledByTopbar, isSidebarOpenedByTopbar, mode, onToggleSidebarVisibility, setIsSidebarForcedOpen, setIsSidebarOpenedByTopbar, setIsSidebarRendered, shouldRenderCallToAction, shouldRenderSearch, shouldRenderSidebar, shouldRenderAccessibleSidebar, shouldRenderTopbarLinks, topbarSize, topNavData, } = useUniversalNavContext();
    const shouldHeaderStickToTop = shouldRenderTopbarLinksForRoute({
        currentUrl,
        mode,
    });
    (0,react.useEffect)(() => {
        setIsSidebarRendered(shouldRenderSidebar);
        return () => {
            setIsSidebarRendered(false);
        };
    }, [setIsSidebarRendered, shouldRenderSidebar]);
    const getLinksToRender = () => {
        if (isLoadingTopNav) {
            return [{ text: '', href: '' }];
        }
        return topNavData.topBarMenu;
    };
    const linksToRender = getLinksToRender();
    const loginHref = copyQueryString(currentUrl, constants/* loginPath */.Qv);
    const signupHref = copyQueryString(currentUrl, constants/* signupPath */.au);
    const renderAccountMenu = utils_findAccountsMenuRenderer({
        canTopbarFitBackToAppButton,
        currentAccountId,
        currentUrl,
        isMyZapsButtonHidden,
        isLoadingLoggedIn,
        isLoggedIn,
        loginHref,
        signupHref,
    });
    const renderSearchForm = shouldRenderSearch ? undefined : () => undefined;
    const [bottom, setBottom] = (0,react.useState)(Infinity);
    const navRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        const setNavBottom = () => {
            if (navRef.current) {
                setBottom(navRef.current.getBoundingClientRect().bottom);
            }
        };
        setNavBottom();
        document.addEventListener('scroll', setNavBottom, { capture: true });
        window.addEventListener('resize', setNavBottom, { capture: true });
        return () => {
            document.removeEventListener('scroll', setNavBottom, { capture: true });
            window.removeEventListener('resize', setNavBottom, { capture: true });
        };
    }, []);
    const closeSidebar = () => {
        setIsSidebarOpenedByTopbar(false);
    };
    const closeSidebarOnTriggerClick = (e) => {
        const target = e.target;
        const trigger = target.closest('a, button, label, [role="button"]');
        if (isSidebarOpenedByTopbar && !!trigger) {
            closeSidebar();
        }
    };
    const renderSidebar = (topbarProps) => {
        const buttonLabel = isSidebarForcedOpen ? 'Close Sidebar' : 'Open Sidebar';
        const buttonIcon = isSidebarForcedOpen ? 'formX' : 'navMenu';
        const toggleSidebarVisibilityButton = (() => {
            if (onToggleSidebarVisibility) {
                return ((0,isolateComponent/* isolateComponent */.U)(MenuCollapseButton_MenuCollapseButton, { ariaExpanded: isSidebarOpenedByTopbar, icon: isSidebarOpenedByTopbar ? 'formX' : 'navMenu', label: "Menu", onClick: onToggleSidebarVisibility }));
            }
            if (canForceSidebarOpen) {
                return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalNav_Styles.forceMenuCollapseButton },
                    (0,isolateComponent/* isolateComponent */.U)(MenuCollapseButton_MenuCollapseButton, { ariaExpanded: isSidebarForcedOpen, icon: buttonIcon, label: buttonLabel, onClick: () => setIsSidebarForcedOpen(!isSidebarForcedOpen) })));
            }
            return null;
        })();
        let sidebarLinksToRender = linksToRender || [];
        sidebarLinksToRender = [SIDEBAR_PRODUCT_MENU, ...sidebarLinksToRender];
        const sidebar = shouldRenderSidebar && ((0,isolateComponent/* isolateComponent */.U)(Sidebar, { callToAction: shouldRenderCallToAction ? topNavData.callToAction : undefined, currentAccountId: currentAccountId, currentUrl: currentUrl, height: `calc(100vh - ${Math.max(0, bottom)}px)`, isFixed: bottom <= 0, isLoggedIn: isLoggedIn, isOnAppPage: isOnAppPage, isSidebarControlledByTopbar: isSidebarControlledByTopbar, isSidebarForcedOpen: isSidebarForcedOpen, links: sidebarLinksToRender, loginHref: loginHref, onClick: closeSidebarOnTriggerClick, shouldRenderTopbarLinks: shouldRenderTopbarLinks, signupHref: signupHref, size: topbarProps.size, skipLinkHref: props.skipLinkHref }));
        const accessibleSidebar = shouldRenderAccessibleSidebar && ((0,isolateComponent/* isolateComponent */.U)(VisuallyHidden/* VisuallyHidden */.T, null,
            (0,isolateComponent/* isolateComponent */.U)("div", { "data-testid": "hidden-sidebar" },
                (0,isolateComponent/* isolateComponent */.U)(Sidebar, { currentAccountId: currentAccountId, currentUrl: currentUrl, height: `calc(100vh - ${Math.max(0, bottom)}px)`, isFixed: bottom <= 0, isLoggedIn: isLoggedIn, isOnAppPage: isOnAppPage, isSidebarControlledByTopbar: isSidebarControlledByTopbar, isSidebarForcedOpen: isSidebarForcedOpen, links: sidebarLinksToRender || [], loginHref: loginHref, onClick: closeSidebarOnTriggerClick, shouldRenderTopbarLinks: shouldRenderTopbarLinks, signupHref: signupHref, size: topbarProps.size, skipLinkHref: props.skipLinkHref }))));
        return ((toggleSidebarVisibilityButton || sidebar) && ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
            toggleSidebarVisibilityButton,
            sidebar,
            accessibleSidebar)));
    };
    const [hasMounted, setHasMounted] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        setHasMounted(true);
    }, []);
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalNav_Styles.root({ shouldHeaderStickToTop }), key: hasMounted ? 'has-mounted' : 'has-not-mounted', ref: navRef }, isLoadingTopNav ? ((0,isolateComponent/* isolateComponent */.U)(TopbarLoadingState_TopbarLoadingState, { isSearchFullWidth: isSearchFullWidth, links: shouldRenderTopbarLinks ? linksToRender : [], onClick: closeSidebarOnTriggerClick, onClickOutside: closeSidebar, renderAccountMenu: renderAccountMenu, renderSearchForm: renderSearchForm, renderSidebar: renderSidebar, selectedHref: currentUrl, size: topbarSize, skipLinkHref: props.skipLinkHref })) : ((0,isolateComponent/* isolateComponent */.U)(UniversalTopbar_UniversalTopbar, { isSearchFullWidth: isSearchFullWidth, links: shouldRenderTopbarLinks ? linksToRender : [], onClick: closeSidebarOnTriggerClick, onClickOutside: closeSidebar, renderAccountMenu: renderAccountMenu, renderSearchForm: renderSearchForm, renderSidebar: renderSidebar, selectedHref: currentUrl, size: topbarSize, skipLinkHref: props.skipLinkHref }))));
};
UniversalNav.defaultProps = {
    renderNotifications: () => null,
};
//# sourceMappingURL=UniversalNav.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/useAlertBanner/alertBannerNotificationsQuery.js

const alertBannerNotificationsQuery = lib/* default */.ZP `
  query alertBannerNotifications($accountId: Int!) {
    isAuthenticated: isAuthenticatedV2

    currentUser: currentUserV2 {
      id
      bannerMessage
      hasSeenNotifications {
        jobsCta
      }
    }

    currentAccount: account(id: $accountId) {
      # Core account data
      id
      currency
      currentUserRole
      firstKnownUpgradeDate
      isUnlimited
      periodEndDate
      hasOverdueInvoice
      # Basic trialing data
      isTrialing
      trialEndDate
      # Teams data
      isTeamAccount
      isTrialingTeams
      teamAccountEndDate
      teamsTrialAutoUpgrade
      teamTrialEndDate
      # Companies data
      isCompanyAccount
      isTrialingCompanies
      companiesTrialEndDate
      companiesTrialAutoUpgrade
      # Current plan data
      plan: planV2 {
        id
        name
        interval
        isInPlanGroup
        amount
        type
      }
      # Offers issued to this account for Sunset campaign
      campaignOffers: campaignOffers(campaignSlug: "notion-discount") {
        id
        acceptedAt
        expiry
      }
    }

    possiblePlans: pricingPageV3Plans(accountId: $accountId) {
      planType
      plans {
        id
        name
        interval
        amount
        type
      }
    }

    # @ref ul-1: Professional* components expects interval to be year,
    # so be cognizant of that if changing.
    nextPlan: nextPlanV2(accountId: $accountId, interval: year) {
      id
      name
      interval
      amount
      type
    }

    nextTeamPlan: nextPlanV2(accountId: $accountId, type: "Team") {
      id
      name
      interval
      amount
      type
    }

    nextCompanyPlan: nextPlanV2(
      accountId: $accountId
      type: "Company"
      interval: year
    ) {
      id
      name
      interval
      amount
      type
    }
  }
`;
//# sourceMappingURL=alertBannerNotificationsQuery.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Alert/Alert.js
var Alert = __webpack_require__(20271);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/AnnualBillingUpsell.js




const ANNUAL_UPDATE_DISMISSED_KEY = 'annualUpsellDismissedOn';
const calculateAnnualSavingsAmount = (data) => {
    var _a;
    const { currentAccount } = data;
    const currentPlan = currentAccount.plan;
    const alternatePlan = (_a = data.possiblePlans
        .find((possiblePlan) => {
        return possiblePlan.planType === currentPlan.type;
    })) === null || _a === void 0 ? void 0 : _a.plans.find((plan) => {
        return plan.name === currentPlan.name && plan.interval === 'year';
    });
    const currentMonthlyAmount = currentPlan.amount || 0;
    const alternateMonthlyAmount = ((alternatePlan === null || alternatePlan === void 0 ? void 0 : alternatePlan.amount) || currentMonthlyAmount) / 12;
    const difference = currentMonthlyAmount - alternateMonthlyAmount;
    return difference / currentMonthlyAmount;
};
const shouldRender = (data) => {
    const { currentAccount: { plan }, } = data;
    const isEligibleForAnnualUpsell = plan.interval !== 'year' && plan.isInPlanGroup;
    const hasDismissedAnnualUpsell = localStorage.getItem(ANNUAL_UPDATE_DISMISSED_KEY) !== null;
    if (hasDismissedAnnualUpsell || !isEligibleForAnnualUpsell) {
        return false;
    }
    return calculateAnnualSavingsAmount(data) > 0;
};
const Component = function AnnualBillingUpsell(props) {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const [annualUpsellDismissedOn, setAnnualUpsellDismissedOn] = (0,react.useState)(localStorage.getItem(ANNUAL_UPDATE_DISMISSED_KEY));
    (0,react.useEffect)(() => {
        if (annualUpsellDismissedOn !== null) {
            localStorage.setItem(ANNUAL_UPDATE_DISMISSED_KEY, annualUpsellDismissedOn);
        }
    }, [annualUpsellDismissedOn]);
    const { data } = props;
    const currentPlan = data.currentAccount.plan;
    const savingsAmount = calculateAnnualSavingsAmount(data);
    const savingsPercent = `${Math.floor(savingsAmount * 100)}%`;
    const upgradeUrl = encodeURI(`/app/checkout/change/${currentPlan.name.toLowerCase()}`);
    const onUpgrade = () => {
        props.trackEvent('clicked annual billing nudge');
    };
    const onDismiss = () => {
        setAnnualUpsellDismissedOn(new Date().toUTCString());
    };
    const title = ((0,isolateComponent/* isolateComponent */.U)("span", null,
        `Save ${savingsPercent} when you `,
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "switch to an annual subscription")));
    if (annualUpsellDismissedOn) {
        return null;
    }
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: title, type: "info", onDismiss: onDismiss }));
};
//# sourceMappingURL=AnnualBillingUpsell.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/BannerMessage.js



const BannerMessage_Styles = (0,labelStyles/* labelStyles */.B)('BannerMessage', {
    content: emotion_react_browser_esm/* css */.iv `
    display: inline-block;

    // Reset styles lifted from @zapier/style-encapsulation package.
    * {
      all: unset;
      box-sizing: border-box;
      -webkit-text-fill-color: currentColor;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    a {
      cursor: pointer;
      text-decoration: underline;
    }
  `,
});
const BannerMessage_shouldRender = (data) => {
    return !!data.currentUser.bannerMessage;
};
const BannerMessage_Component = function BannerMessage(props) {
    const content = ((0,isolateComponent/* isolateComponent */.U)("div", { css: BannerMessage_Styles.content, dangerouslySetInnerHTML: {
            __html: props.data.currentUser.bannerMessage,
        } }));
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { ariaLive: "polite", layout: props.layout, title: content, type: "info" }));
};
//# sourceMappingURL=BannerMessage.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/utils.js
const PRO_PLAN_NAME = 'Pro (2,000 Tasks)';
const PRO_PLAN_INTERVAL = 'year';
const buildUpgradeUrl = (opts) => {
    const currentPlanName = (opts.currentPlanName || '').toLowerCase();
    const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
    const url = currentPlanName && upgradePlanName
        ? `/app/checkout/upgrade/${currentPlanName}/${upgradePlanName}?interval=${opts.interval || 'month'}`
        : '/app/pricing';
    return encodeURI(url);
};
const getShouldRenderSunsetCopy = (campaignOffers = []) => {
    const hasSunsetOffer = campaignOffers.length &&
        campaignOffers.every((offer) => !offer.acceptedAt &&
            offer.expiry &&
            new Date(offer.expiry) >= new Date());
    return hasSunsetOffer;
};
const getProfessionalPlanData = (possiblePlans, currentAccount) => {
    var _a;
    const professionalPlan = (_a = possiblePlans
        .find((plan) => plan.planType === 'Professional')) === null || _a === void 0 ? void 0 : _a.plans.find((plan) => plan.name === PRO_PLAN_NAME && plan.interval === PRO_PLAN_INTERVAL);
    const professionalUpgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.name) || PRO_PLAN_NAME,
        interval: currentAccount.plan.interval,
    });
    const professionalPlanAmount = ((professionalPlan === null || professionalPlan === void 0 ? void 0 : professionalPlan.amount) || 0) / 12;
    return { professionalUpgradeUrl, professionalPlanAmount };
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/CompaniesTrialEnded.js





const CompaniesTrialEnded_shouldRender = (data) => {
    const { isCompanyAccount, companiesTrialEndDate } = data.currentAccount;
    if (!companiesTrialEndDate || isCompanyAccount)
        return false;
    const companiesTrialHasEnded = (0,date_dist/* parseDateTime */.wG)(companiesTrialEndDate) < new Date();
    return companiesTrialHasEnded && (0,date_dist/* daysFromNow */.Cp)(companiesTrialEndDate) <= 7;
};
const CompaniesTrialEnded_Component = function CompaniesTrialEnded(props) {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data } = props;
    const { currentAccount } = data;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.name,
        interval: currentAccount.plan.interval,
    });
    const onUpgrade = () => {
        props.trackEvent('company-trial-ended-upgrade-clicked', {
            profileId: data.currentUser.id,
        });
    };
    const onContactSupport = () => {
        props.trackEvent('company-trial-ended-support-extend-trial-clicked', {
            profileId: data.currentUser.id,
        });
    };
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: "Your Company trial has ended", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "Upgrade"),
        ' ',
        "to keep using our advanced administrative and security controls. Still have questions?",
        ' ',
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL('/app/get-help'), onClick: onContactSupport }, "Contact us"),
        ' '));
};
//# sourceMappingURL=CompaniesTrialEnded.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ../../node_modules/lodash/pick.js
var pick = __webpack_require__(13888);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/hooks/useCurrencies/useCurrencies.js

const defaultCurrency = {
  icon: "UnitedStates",
  id: "USD",
  multiplier: 1,
  name: "USD",
  symbol: "$",
  zeroDecimal: false
};
const currencyQuery = lib/* default */.ZP`
  query currencyQuery {
    currencies {
      id
      icon
      multiplier
      name
      symbol
      zeroDecimal
    }
  }
`;
function useCurrencies(props) {
  var _queryResults$data;

  const useQuery = props.useQuery; // @ts-ignore - graphql-proxy fails ts without this even though it does not reference this at all 😭

  const queryResults = useQuery(currencyQuery);
  return {
    currencies: (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$data = queryResults.data) === null || _queryResults$data === void 0 ? void 0 : _queryResults$data.currencies) || [],
    error: queryResults.error ? "There was an issue loading currencies. Please try again" : null,
    isLoading: queryResults.loading,
    onSelectCurrency: currency => queryResults.client.writeData({
      data: {
        selectedCurrency: currency
      }
    })
  };
}
//# sourceMappingURL=useCurrencies.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/utils/formatPriceToBeInCurrency/types.js
let RoundingStrategy;

(function (RoundingStrategy) {
  RoundingStrategy["up"] = "up";
  RoundingStrategy["down"] = "down";
  RoundingStrategy["default"] = "default";
})(RoundingStrategy || (RoundingStrategy = {}));
//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/utils/formatPriceToBeInCurrency/roundNumberByStrategy.js

const roundNumberByStrategy = (value, roundingStrategy) => {
  let round;

  switch (roundingStrategy) {
    case RoundingStrategy.up:
      round = Math.ceil;
      break;

    case RoundingStrategy.down:
      round = Math.floor;
      break;

    case RoundingStrategy["default"]:
    default:
      round = Math.round;
  }

  return round(value);
};
//# sourceMappingURL=roundNumberByStrategy.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/utils/formatPriceToBeInCurrency/formatPrice.js

/**
 * Round a number (up) to the first n digits
 * @example 12.34 => 12.34
 * @example 12345.67 => 12350
 * @example 1234567.89 => 1235000
 */

const relativeRound = (value, numberOfDigitsToKeep = 3) => {
  // Log will error out on 0 so just return 0 back
  if (!value) return 0; // Determine the level of rounding that is needed

  const tier = Math.floor(Math.log10(Math.abs(value))); // Keep the first n digits of the number

  const roundingLevel = tier - numberOfDigitsToKeep; // Divide the number by the rounding level to set up the round

  const adjusted = value / Math.pow(10, roundingLevel); // Always round up to be on the safe side and

  const rounded = Math[value < 0 ? "floor" : "ceil"](adjusted); // multiply by the rounding level to get the number back in the correct order
  // of magnitude

  return parseFloat((rounded * Math.pow(10, roundingLevel)).toPrecision(12));
};
/**
 * Formats a price in pennies to be a price in dollars.
 */


const formatPrice = (price, {
  roundingStrategy,
  maxDecimals = 2,
  minDecimals = 0,
  useRelativeRounding = false,
  isPriceGivenAsCents = true
} = {}) => {
  // round if we need to
  const rounded = useRelativeRounding ? relativeRound(price) : price; // Price is given in pennies so convert to dollars

  let priceInDollars = isPriceGivenAsCents ? rounded / 100 : rounded;

  if (roundingStrategy && maxDecimals <= 2) {
    priceInDollars = roundNumberByStrategy(priceInDollars, roundingStrategy);
  } // Only show decimals if we have pennies or we are forcing them


  const hasPennies = priceInDollars % 1 !== 0;
  const options = {
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: minDecimals === 0 && hasPennies ? 2 : minDecimals
  }; // format the price in the user's locale

  return priceInDollars.toLocaleString(undefined, options);
};
//# sourceMappingURL=formatPrice.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/utils/formatPriceToBeInCurrency/formatPriceWithCurrencySymbol.js


/**
 * Formats a price in pennies to be in dollars with the currency symbol.
 */
const formatPriceWithCurrencySymbol = (price, formattingOptions, symbol = "$") => price >= 0 ? `${symbol}${formatPrice(price, formattingOptions)}` : `–${symbol}${formatPrice(Math.abs(price), formattingOptions)}`;
//# sourceMappingURL=formatPriceWithCurrencySymbol.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/utils/formatPriceToBeInCurrency/formatPriceToBeInCurrency.js




/**
 * Applies currency multiplier and formats price.
 */
const formatPriceToBeInCurrency = (price, currency = defaultCurrency, includeSymbol = true, formattingOptions = {}) => {
  const adjusted = price * currency.multiplier;
  return includeSymbol ? formatPriceWithCurrencySymbol(adjusted, formattingOptions, currency.symbol) : formatPrice(adjusted, formattingOptions);
};
//# sourceMappingURL=formatPriceToBeInCurrency.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/currency/esm/components/Price/Price.js

var __jsx = react.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function getFormattedPrice(price, meta) {
  const {
    isLocalized,
    currency,
    roundingStrategy
  } = meta;

  const formattingOptions = _objectSpread(_objectSpread({}, pick_default()(meta, ["minDecimals", "maxDecimals"])), {}, {
    useRelativeRounding: false
  });
  /**
   * Zero-decimal currencies need their price rounded based on a given strategy
   * They also need to be treated as whole dollars and not cents (avoid division by 100)
   */


  if (currency.zeroDecimal) {
    formattingOptions.isPriceGivenAsCents = !isLocalized;
    formattingOptions.roundingStrategy = roundingStrategy !== null && roundingStrategy !== void 0 ? roundingStrategy : RoundingStrategy["default"];
  }

  return isLocalized ? formatPrice(price, formattingOptions) : formatPriceToBeInCurrency(price, currency, false, formattingOptions);
}
/**
 * Displays a price in a user-friendly format
 */


const Price = ({
  children,
  currency = defaultCurrency,
  maxDecimals = 2,
  minDecimals = 0,
  symbolFontSize = "inherit",
  isLocalized = false,
  roundingStrategy
}) => {
  const absPrice = Math.abs(children);
  const isNegative = children < 0;
  const price = getFormattedPrice(absPrice, {
    currency,
    isLocalized,
    maxDecimals,
    minDecimals,
    roundingStrategy
  });
  return __jsx("span", {
    style: {
      alignItems: "center",
      display: "inline-flex"
    }
  }, isNegative && __jsx("span", null, "-"), __jsx("span", {
    style: {
      fontSize: symbolFontSize
    }
  }, currency.symbol), __jsx("span", null, `${price} ${(currency === null || currency === void 0 ? void 0 : currency.symbol) === "$" ? currency.name : ""}`.trim()));
};
//# sourceMappingURL=Price.js.map

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/CompaniesTrialing.js





const CompaniesTrialing_shouldRender = (data) => {
    const { currentAccount } = data;
    return (currentAccount.isTrialingCompanies &&
        currentAccount.companiesTrialEndDate &&
        ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole));
};
const CompaniesTrialing_Component = function CompaniesTrialing(props) {
    var _a, _b, _c, _d;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data, currency } = props;
    const { currentAccount } = data;
    const { companiesTrialEndDate, companiesTrialAutoUpgrade: willAutoUpgrade, } = currentAccount;
    const trialDaysRemaining = (0,date_dist/* daysFromNow */.Cp)(companiesTrialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = `${trialDaysRemaining} ${daysText} left in your Company trial`;
    const nextPlanAmount = (((_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.amount) || 0) / 12;
    const formattedEndDate = (0,date_dist/* parseDateTime */.wG)(companiesTrialEndDate)
        .toLocaleString('en-US', { month: 'short', day: 'numeric' })
        .replace(/([a-z]+)/i, '$1.');
    const autoBillingLink = ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL('/app/settings/billing') }, "Edit trial payment settings"));
    const content = willAutoUpgrade ? ((0,isolateComponent/* isolateComponent */.U)("p", null,
        `You will be billed and charged `,
        (0,isolateComponent/* isolateComponent */.U)(Price, { currency: currency }, nextPlanAmount),
        "/month ",
        ' at the end of your trial. ',
        autoBillingLink)) : ((0,isolateComponent/* isolateComponent */.U)("p", null,
        `On ${formattedEndDate}, you’ll lose access to Company plan features and be downgraded to a ${(_d = (_c = (_b = data.currentAccount) === null || _b === void 0 ? void 0 : _b.plan) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : 'Free'} plan. `,
        autoBillingLink));
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: title, type: "info" }, content));
};
//# sourceMappingURL=CompaniesTrialing.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/ProfessionalTrialEnded.js






const ProfessionalTrialEnded_shouldRender = (data) => {
    const { currentAccount } = data;
    const { isTrialing, trialEndDate } = currentAccount;
    return (!isTrialing &&
        !!trialEndDate &&
        currentAccount.plan.amount === 0 &&
        (0,date_dist/* daysFromNow */.Cp)(trialEndDate) <= 14);
};
const ProfessionalTrialEnded_Component = function ProfessionalTrialEnded(props) {
    const { data, currency } = props;
    const { currentAccount } = data;
    const { professionalUpgradeUrl, professionalPlanAmount, } = getProfessionalPlanData(data.possiblePlans, currentAccount);
    const nextPlanAmount = professionalPlanAmount;
    const upgradeUrl = professionalUpgradeUrl;
    const pricingText = nextPlanAmount > 0 && ((0,isolateComponent/* isolateComponent */.U)("span", null,
        "for as low as ",
        (0,isolateComponent/* isolateComponent */.U)(Price, { currency: currency }, nextPlanAmount),
        "/month"));
    const onUpgrade = () => {
        props.trackEvent('Trial: clicked banner', {
            in_trial: false,
        });
    };
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: "Your Professional trial has ended", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
            (0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: upgradeUrl, onClick: onUpgrade }, "Upgrade"),
                "\u00A0",
                pricingText,
                " to keep using multi-step Zaps, filters, premium apps, and more"))));
};
//# sourceMappingURL=ProfessionalTrialEnded.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/ProfessionalTrialing.js







const ProfessionalTrialing_shouldRender = (data, isExcludedUrl = false) => {
    const { isTrialing, trialEndDate } = data.currentAccount;
    return !!isTrialing && !!trialEndDate && !isExcludedUrl;
};
const ProfessionalTrialing_Component = function ProfessionalTrialing(props) {
    const { data, currency } = props;
    const { currentAccount, possiblePlans } = data;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { trialEndDate } = currentAccount;
    const trialDaysRemaining = (0,date_dist/* daysFromNow */.Cp)(trialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const { professionalUpgradeUrl, professionalPlanAmount, } = getProfessionalPlanData(possiblePlans, currentAccount);
    const upgradeUrl = professionalUpgradeUrl;
    const nextPlanAmount = professionalPlanAmount;
    const onClickLink = () => {
        props.trackEvent('Trial: clicked banner');
    };
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: "Welcome to your Professional trial!", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)("p", null,
            `You have ${trialDaysRemaining} ${daysText} to try Zapier’s `,
            (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL('/help/account/billing-pricing/understand-your-zapier-premium-trial'), onClick: onClickLink }, "paid features"),
            ".",
            ' ',
            (0,isolateComponent/* isolateComponent */.U)(react.Fragment, null,
                (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: upgradeUrl, onClick: onClickLink }, "Upgrade"),
                ' ',
                "anytime",
                nextPlanAmount > 0 && ((0,isolateComponent/* isolateComponent */.U)("span", null,
                    ' ',
                    "for as low as ",
                    (0,isolateComponent/* isolateComponent */.U)(Price, { currency: currency }, nextPlanAmount),
                    "/month."))))));
};
//# sourceMappingURL=ProfessionalTrialing.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/RefreshRequired.js


const parsedTime = Date.now();
const RefreshRequired_shouldRender = () => {
    const hoursElapsed = (Date.now() - parsedTime) / 1000 / 60 / 60;
    return hoursElapsed > 24;
};
const RefreshRequired_Component = function RefreshRequired() {
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { ariaLive: "polite", layout: "banner", title: "A new version of Zapier is available", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)("p", null,
            (0,isolateComponent/* isolateComponent */.U)("button", { type: "button", css: { textDecoration: 'underline' }, onClick: () => window.location.reload() }, "Refresh now"),
            ' ',
            "to get the latest version")));
};
//# sourceMappingURL=RefreshRequired.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsDowngraded.js



const TeamsDowngraded_shouldRender = (data) => {
    const { isTeamAccount, teamAccountEndDate } = data.currentAccount;
    return (!isTeamAccount &&
        !!teamAccountEndDate &&
        (0,date_dist/* daysFromNow */.Cp)(teamAccountEndDate) <= 7);
};
const TeamsDowngraded_Component = function TeamsDowngraded(props) {
    const onUpgrade = () => {
        props.trackEvent('clicked teams downgraded banner');
    };
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: "You\u2019ve recently canceled your Team plan", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: "/app/checkout/upgrade-to-team", onClick: () => onUpgrade() }, "Upgrade"),
        "\u00A0to regain your access to unlimited users, shared app connections, premier support, and more"));
};
//# sourceMappingURL=TeamsDowngraded.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsTrialEnded.js





const TeamsTrialEnded_shouldRender = (data) => {
    const { isTeamAccount, teamTrialEndDate } = data.currentAccount;
    return (!isTeamAccount && !!teamTrialEndDate && (0,date_dist/* daysFromNow */.Cp)(teamTrialEndDate) <= 7);
};
const TeamsTrialEnded_Component = function TeamsTrialEnded(props) {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data } = props;
    const { currentAccount } = data;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_a = data.nextTeamPlan) === null || _a === void 0 ? void 0 : _a.name,
        interval: currentAccount.plan.interval,
    });
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: "Your Team trial has ended", type: "info" },
        (0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL(upgradeUrl) }, "Upgrade"),
        "\u00A0to keep your access to unlimited users, shared app connections, premier support, and more"));
};
//# sourceMappingURL=TeamsTrialEnded.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/writeCookie.js
var writeCookie = __webpack_require__(26791);
;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/OverdueInvoice.js




const OverdueInvoice_shouldRender = (data) => {
    const { currentAccount } = data;
    const hasDismissedBanner = (0,readCookie/* readCookie */.v)('dismissedOverdueInvoiceBanner');
    return (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.hasOverdueInvoice) && !(hasDismissedBanner === 'true');
};
const OverdueInvoice_Component = function OverdueInvoice(props) {
    const [isExcludedUrl, setIsExcludedUrl] = (0,react.useState)(false);
    const [isDismissed, setIsDismissed] = (0,react.useState)(false);
    const { data } = props;
    const { currentAccount } = data;
    const periodEndDate = data.currentAccount.periodEndDate;
    const hasBillingPrivs = ['owner', 'super_admin'].includes(currentAccount.currentUserRole);
    (0,react.useEffect)(() => {
        setIsExcludedUrl(window.location.pathname.includes('checkout/invoice/pay'));
    }, []);
    const expiryDate = () => {
        if (periodEndDate) {
            return periodEndDate;
        }
        const defaultExpiry = new Date();
        defaultExpiry.setDate(defaultExpiry.getDate() + 30);
        return defaultExpiry;
    };
    const onDismiss = () => {
        (0,writeCookie/* writeCookie */.w)('dismissedOverdueInvoiceBanner', 'true', {
            category: 'essential',
            expires: expiryDate(),
        });
        setIsDismissed(true);
    };
    if (isDismissed || isExcludedUrl) {
        return null;
    }
    const title = ((0,isolateComponent/* isolateComponent */.U)("span", null,
        "There was a problem with your last payment.",
        ' ',
        hasBillingPrivs ? ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: "/app/settings/billing" }, "Fix it now")) : ((0,isolateComponent/* isolateComponent */.U)(react.Fragment, null, "Please have an account owner update the payment information."))));
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { onDismiss: onDismiss, layout: props.layout, title: title, type: "error" }));
};
//# sourceMappingURL=OverdueInvoice.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/TeamsTrialing.js





const TeamsTrialing_shouldRender = (data) => {
    return data.currentAccount.isTrialingTeams;
};
const TeamsTrialing_Component = function TeamsTrialing(props) {
    var _a, _b, _c, _d, _e;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data, currency } = props;
    const { currentAccount } = data;
    const willAutoUpgrade = currentAccount.teamsTrialAutoUpgrade;
    const canToggleAutoUpgrade = ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole);
    const nextPlanAmount = (_b = (_a = data.nextTeamPlan) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : -1;
    const interval = currentAccount.plan.interval;
    const isYearly = interval === 'year';
    const monthlyAmount = isYearly ? nextPlanAmount / 12 : nextPlanAmount;
    const trialDaysRemaining = currentAccount.teamTrialEndDate
        ? (0,date_dist/* daysFromNow */.Cp)(currentAccount.teamTrialEndDate)
        : 0;
    const formattedEndDate = (0,date_dist/* parseDateTime */.wG)(currentAccount.teamTrialEndDate)
        .toLocaleString('en-US', { month: 'short', day: 'numeric' })
        .replace(/([a-z]+)/i, '$1.');
    const autoBillingLink = ((0,isolateComponent/* isolateComponent */.U)(Link/* Link */.r, { href: getFullyQualifiedURL('/app/settings/billing') }, "Edit trial payment settings"));
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = currentAccount.teamTrialEndDate
        ? `${trialDaysRemaining} ${daysText} left in your Team trial`
        : 'You are on a Team trial';
    const intervalText = isYearly ? ' (paid annually)' : '';
    const content = willAutoUpgrade ? ((0,isolateComponent/* isolateComponent */.U)("p", null,
        `You will be billed and charged `,
        monthlyAmount < 0 ? ('') : ((0,isolateComponent/* isolateComponent */.U)("span", null,
            (0,isolateComponent/* isolateComponent */.U)(Price, { currency: currency }, monthlyAmount),
            "/month",
            intervalText)),
        '. ',
        canToggleAutoUpgrade ? autoBillingLink : null)) : ((0,isolateComponent/* isolateComponent */.U)("p", null,
        (currentAccount.teamTrialEndDate
            ? `On ${formattedEndDate}, `
            : `At the end of your trial, `) +
            `you’ll lose access to Team plan features and be downgraded to a ${(_e = (_d = (_c = data.currentAccount) === null || _c === void 0 ? void 0 : _c.plan) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : 'Free'} plan. `,
        canToggleAutoUpgrade ? autoBillingLink : null));
    return ((0,isolateComponent/* isolateComponent */.U)(Alert/* Alert */.b, { layout: props.layout, title: title, type: "info" }, content));
};
//# sourceMappingURL=TeamsTrialing.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/banners/UnlimitedAccount.js
const UnlimitedAccount_shouldRender = (data) => {
    return data.currentAccount.isUnlimited;
};
const UnlimitedAccount_Component = function UnlimitedAccount() {
    return null;
};
//# sourceMappingURL=UnlimitedAccount.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/useAlertBanner/useAlertBanner.js















const possibleComponents = [
    RefreshRequired_namespaceObject,
    BannerMessage_namespaceObject,
    UnlimitedAccount_namespaceObject,
    CompaniesTrialing_namespaceObject,
    CompaniesTrialEnded_namespaceObject,
    TeamsTrialing_namespaceObject,
    TeamsTrialEnded_namespaceObject,
    OverdueInvoice_namespaceObject,
    TeamsDowngraded_namespaceObject,
    ProfessionalTrialing_namespaceObject,
    ProfessionalTrialEnded_namespaceObject,
    AnnualBillingUpsell_namespaceObject,
];
const useAlertBanner = (opts) => {
    var _a;
    const currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    const [lastRenderedTime, setLastRenderedTime] = (0,react.useState)(Date.now());
    const [isExcludedUrl, setIsExcludedUrl] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        setTimeout(() => {
            setLastRenderedTime(Date.now());
        }, 5 * 60 * 60 * 1000);
    }, [lastRenderedTime]);
    (0,react.useEffect)(() => {
        setIsExcludedUrl(window.location.pathname.includes('team-account-setup'));
    }, []);
    const result = opts.useQuery(alertBannerNotificationsQuery, {
        ssr: false,
        variables: {
            accountId: currentAccountId,
        },
    });
    const { data } = result;
    const Component = result.loading ||
        result.error ||
        !data ||
        !data.currentUser ||
        !data.currentAccount
        ? undefined
        : (_a = possibleComponents.find((component) => {
            return component.shouldRender(data, isExcludedUrl);
        })) === null || _a === void 0 ? void 0 : _a.Component;
    return {
        data,
        Component,
        isLoading: result.loading,
    };
};
//# sourceMappingURL=useAlertBanner.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/AlertBanner/AlertBanner.js



const AlertBanner = (props) => {
    const { Component, data } = useAlertBanner({ useQuery: props.useQuery });
    const { currencies, isLoading: isLoadingCurrencies } = useCurrencies({
        useQuery: props.useQuery,
    });
    if (!Component || isLoadingCurrencies) {
        return null;
    }
    return ((0,isolateComponent/* isolateComponent */.U)(Component, { data: data, currency: currencies === null || currencies === void 0 ? void 0 : currencies.find((c) => c.name === (data === null || data === void 0 ? void 0 : data.currentAccount.currency)), layout: "banner", trackEvent: props.trackEvent, useQuery: props.useQuery, useMutation: props.useMutation }));
};
//# sourceMappingURL=AlertBanner.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

;// CONCATENATED MODULE: ../../node_modules/@zapier/universal-layout/esm/universal-layout/components/UniversalLayout/UniversalLayout.js










const UniversalLayout_Styles = {
    root: emotion_react_browser_esm/* css */.iv `
    display: block;
  `,
    alertBanner: emotion_react_browser_esm/* css */.iv `
    &:empty {
      display: none;
    }
  `,
    grid: emotion_react_browser_esm/* css */.iv `
    min-height: 100vh;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'head'
      'main'
      'foot';
    gap: 0;
    transition: all ease-in-out 300ms;
  `,
    gridWithSidebar: (sidebarWidth) => emotion_react_browser_esm/* css */.iv `
    grid-template-columns: ${sidebarWidth}px 1fr;
    grid-template-areas:
      'head head'
      '.... main'
      '.... foot';
  `,
    head: (shouldHeaderStickToTop) => [
        emotion_react_browser_esm/* css */.iv `
      grid-area: head;
      // Stickiness is handled by UniversalNav but needs
      // to be reinforced here to work properly.
      position: sticky;
      z-index: ${constants/* UNIVERSAL_NAV_ZINDEX */.ii};
      top: -${constants/* UNIVERSAL_TOPBAR_CONDENSED_HEIGHT */.Eg}px;

      @media (min-width: 450px) {
        top: -${constants/* UNIVERSAL_TOPBAR_HEIGHT */.w5}px;
      }
    `,
        shouldHeaderStickToTop &&
            (0,withModifier/* withModifier */.Q)('stuck-to-top', emotion_react_browser_esm/* css */.iv `
          top: 0;
        `),
    ],
    main: emotion_react_browser_esm/* css */.iv `
    grid-area: main;
    position: relative;
  `,
    foot: emotion_react_browser_esm/* css */.iv `
    grid-area: foot;
  `,
};
const UniversalLayout_defaultProps = {
    mainContentId: 'mainContent',
    renderAlertBanner: (props) => ((0,isolateComponent/* isolateComponent */.U)(AlertBanner, { trackEvent: props.trackEvent, useMutation: props.useMutation, useQuery: props.useQuery })),
    renderNotifications: () => null,
    renderHeader: (props) => {
        return ((0,isolateComponent/* isolateComponent */.U)(UniversalNav, { renderNotifications: props.renderNotifications, skipLinkHref: `#${props.mainContentId}` }));
    },
    renderFooter: (props) => {
        return ((0,isolateComponent/* isolateComponent */.U)(UniversalFooter, { shouldRenderAlphabetNav: props.shouldRenderAlphabetNav, shouldRenderSeoLinks: props.shouldRenderSeoLinks, showSimplifiedFooter: props.showSimplifiedFooter }));
    },
};
const UniversalLayoutInner = (props) => {
    const { sidebarWidth } = useUniversalNavContext();
    const shouldHeaderStickToTop = shouldRenderTopbarLinksForRoute({
        currentUrl: props.currentUrl,
        mode: props.mode,
    });
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalLayout_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalLayout_Styles.alertBanner, "data-testid": "UniversalLayoutAlertBanner" }, props.renderAlertBanner(props)),
        (0,isolateComponent/* isolateComponent */.U)("div", { css: [
                UniversalLayout_Styles.grid,
                sidebarWidth && UniversalLayout_Styles.gridWithSidebar(sidebarWidth),
            ] },
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalLayout_Styles.head(shouldHeaderStickToTop) }, props.renderHeader(props)),
            (0,isolateComponent/* isolateComponent */.U)("main", { css: UniversalLayout_Styles.main, id: props.mainContentId }, props.children),
            (0,isolateComponent/* isolateComponent */.U)("div", { css: UniversalLayout_Styles.foot }, props.renderFooter(props)))));
};
const UniversalLayout = (_props) => {
    const props = Object.assign(Object.assign({}, UniversalLayout_defaultProps), _props);
    const currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    return ((0,isolateComponent/* isolateComponent */.U)(UniversalNavProvider, { currentAccountId: currentAccountId, currentUrl: props.currentUrl, isMyZapsButtonHidden: props.isMyZapsButtonHidden, urlPathPrefix: props.urlPathPrefix, useQuery: props.useQuery, mode: props.mode, shouldRenderTOS: props.shouldRenderTOS },
        (0,isolateComponent/* isolateComponent */.U)(UniversalLayoutInner, Object.assign({}, props))));
};
UniversalLayout.defaultProps = UniversalLayout_defaultProps;
//# sourceMappingURL=UniversalLayout.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(87274);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(22820);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js







function useMutation(mutation, options) {
    var client = (0,useApolloClient/* useApolloClient */.x)(options === null || options === void 0 ? void 0 : options.client);
    (0,parser/* verifyDocumentType */.Vp)(mutation, parser/* DocumentType.Mutation */.n_.Mutation);
    var _a = (0,react.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,mergeOptions/* mergeOptions */.J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new client_errors/* ApolloError */.cA({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,equality_esm/* equal */.D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted);
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,equality_esm/* equal */.D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib_es6/* __assign */.pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(40794);
// EXTERNAL MODULE: ./src/observability/tracking/avro.ts
var avro = __webpack_require__(90073);
// EXTERNAL MODULE: ./src/observability/tracking/useTrackEvent.ts + 1 modules
var useTrackEvent = __webpack_require__(22506);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/hooks/useOverflow.js
var useOverflow = __webpack_require__(60196);
;// CONCATENATED MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Alert/AlertDescription.js





const AlertDescription_Styles = (0,labelStyles/* labelStyles */.B)('AlertDescription', {
    root: emotion_react_browser_esm/* css */.iv `
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  `,
    content: (props, { isOpen }) => [
        emotion_react_browser_esm/* css */.iv `
      // All of the properties below this are necessary
      // for line clamping to work. Even though the properties
      // have 'webkit' in them, they work cross-browser.
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};
      overflow: hidden;

      > * {
        display: inline;
      }
    `,
        isOpen &&
            emotion_react_browser_esm/* css */.iv `
        label: -open;
        -webkit-line-clamp: initial;
      `,
    ],
    toggle: emotion_react_browser_esm/* css */.iv `
    cursor: pointer;
    textTransform: lowercase;
    color: ${Colors/* Colors.blue */.w.blue};

    &:hover, &:focus: {
      text-decoration: underline;
    },
  `,
});
const AlertDescription_defaultProps = {
    maxLines: 3,
};
const AlertDescription = (_props) => {
    const props = Object.assign(Object.assign({}, AlertDescription_defaultProps), _props);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [isOverflowing, setOverflowingNode] = (0,useOverflow/* useOverflow */.I)();
    const toggle = isOverflowing && ((0,isolateComponent/* isolateComponent */.U)("button", { css: AlertDescription_Styles.toggle, onClick: () => setIsOpen(!isOpen), type: "button" }, isOpen ? 'show less' : 'show more'));
    return ((0,isolateComponent/* isolateComponent */.U)("div", { css: AlertDescription_Styles.root },
        (0,isolateComponent/* isolateComponent */.U)("div", { css: AlertDescription_Styles.content(props, { isOpen }), ref: setOverflowingNode },
            (0,isolateComponent/* isolateComponent */.U)("div", null, props.children)),
        toggle));
};
//# sourceMappingURL=AlertDescription.js.map
// @zapier/design-system@5.32.5 (2004a9d50)

// EXTERNAL MODULE: ./src/components/RichTextHtml/RichTextHtml.tsx
var RichTextHtml = __webpack_require__(8841);
// EXTERNAL MODULE: ./src/constants/colors.ts
var colors = __webpack_require__(27423);
;// CONCATENATED MODULE: ./src/components/UniversalLayout/UniversalLayout.tsx












var alertBannerBackgroundColorMap = {
    error: colors/* COLOR_KEYS.error400 */.US.error400,
    info: colors/* COLOR_KEYS.blue */.US.blue,
    success: colors/* COLOR_KEYS.success400 */.US.success400,
    warning: colors/* COLOR_KEYS.warning400 */.US.warning400
};
var UniversalLayout_UniversalLayout = function(param) {
    var children = param.children, _hideFooter = param.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _hideHeader = param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, _shouldRenderAlphabetNav = param.shouldRenderAlphabetNav, shouldRenderAlphabetNav = _shouldRenderAlphabetNav === void 0 ? false : _shouldRenderAlphabetNav, _shouldRenderSeoLinks = param.shouldRenderSeoLinks, shouldRenderSeoLinks = _shouldRenderSeoLinks === void 0 ? false : _shouldRenderSeoLinks, alertBanner = param.alertBanner;
    var ref;
    var ref1 = (0,react.useState)(true), showAlertBanner = ref1[0], setShowAlertBanner = ref1[1];
    var richTextRef = (0,react.useRef)(null);
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var trackEvent = (0,useTrackEvent/* useTrackEvent */.K)();
    var currentUrl = ((ref = (0,router.useRouter)()) === null || ref === void 0 ? void 0 : ref.asPath) || "";
    var handleDismissAlertBanner = function() {
        var ref;
        setShowAlertBanner(false);
        emitUserInteractionEvent({
            event_action: avro/* EventAction.click */.AO.click,
            interaction_name: avro/* InteractionName.dismiss */.AI.dismiss,
            option_selected: "dismiss_button",
            custom_tracking_fields: {
                component: "UniversalLayout"
            },
            interaction_raw_text: ((alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.layout) === "mini" ? (ref = richTextRef.current) === null || ref === void 0 ? void 0 : ref.innerText.trim() : alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.title) || ""
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(identity_esm/* CurrentAccountIdProvider */.No, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniversalLayout, {
            currentUrl: currentUrl,
            renderAlertBanner: function() {
                return showAlertBanner && ((alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.layout) === "mini" ? !!(alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.body) : !!(alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.title) && !!(alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.type)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    layout: alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.layout,
                    miniBackgroundColor: alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.miniBackgroundColor,
                    title: alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.title,
                    type: alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.type
                }, (alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.dismissable) && {
                    onDismiss: handleDismissAlertBanner
                }), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertDescription, {
                        children: (alertBanner === null || alertBanner === void 0 ? void 0 : alertBanner.body) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextHtml/* RichTextHtml */.CW, {
                            backgroundColor: alertBanner.layout === "mini" ? alertBanner.miniBackgroundColor : alertBanner.type && alertBannerBackgroundColorMap[alertBanner.type],
                            html: alertBanner.body,
                            ref: richTextRef
                        })
                    })
                })) : null;
            },
            renderFooter: hideFooter ? function() {
                return null;
            } : undefined,
            renderHeader: hideHeader ? function() {
                return null;
            } : undefined,
            shouldRenderAlphabetNav: shouldRenderAlphabetNav,
            shouldRenderSeoLinks: shouldRenderSeoLinks,
            // @ts-ignore: as suggested by Alej (https://github.com/zapier/blog/pull/375#discussion_r545454080)
            trackEvent: trackEvent,
            useMutation: useMutation,
            useQuery: useQuery/* useQuery */.a,
            children: children
        })
    });
};


/***/ }),

/***/ 61073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ WistiaVideoProvider; },
/* harmony export */   "L": function() { return /* binding */ useWistiaScript; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


// Getting a conflict with Prettier here.
// eslint-disable-next-line no-spaced-func
var WistiaVideoContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isWistiaOnThePage: false,
    setIsWistiaOnThePage: function() {}
});
function WistiaVideoProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isWistiaOnThePage = ref[0], setIsWistiaOnThePage = ref[1];
    var updateWistiaState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setIsWistiaOnThePage(true);
    }, []);
    var value = {
        isWistiaOnThePage: isWistiaOnThePage,
        setIsWistiaOnThePage: updateWistiaState
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WistiaVideoContext.Provider, {
        value: value,
        children: children
    });
}
function useWistiaScript() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(WistiaVideoContext);
    if (context === undefined) {
        throw new Error("useWistiaScript must be used within a WistiaProvider");
    }
    return context;
}


/***/ }),

/***/ 28257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CD": function() { return /* binding */ transformZapCardSection; },
  "gs": function() { return /* binding */ useUnregisteredProps; }
});

// UNUSED EXPORTS: fetchZapTemplates

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(79381);
// EXTERNAL MODULE: ./src/utils/isBrowser.ts
var isBrowser = __webpack_require__(82929);
;// CONCATENATED MODULE: ./src/utils/getBaseURL.ts
var getBaseURL = function() {
    if (false) {}
    if (true) {
        return "https://".concat("pagebuilder-qoq9d834f.vercel.zapier-deployment.com");
    }
    return "https://zapier-staging.com" || 0;
};

;// CONCATENATED MODULE: ./src/rest/zapier/guidedRecipe/data.ts



var fetchGuidedRecipe = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
        var ref, ref1, response, responseJSON, services;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return fetch("".concat((0,isBrowser/* isBrowser */.j)() ? getBaseURL() : "https://zapier.com", "/api/v4/guided-recipes/").concat(id, "/"));
                case 3:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 7;
                        break;
                    }
                    console.error("Error fetching Guided Recipe with ID " + id);
                    return _ctx.abrupt("return", {
                        title: "",
                        service: [],
                        href: ""
                    });
                case 7:
                    _ctx.next = 9;
                    return response.json();
                case 9:
                    responseJSON = _ctx.sent;
                    services = (ref = responseJSON.services) === null || ref === void 0 ? void 0 : ref.map(function(service) {
                        var ref;
                        return {
                            name: service.name,
                            src: (ref = service.images) === null || ref === void 0 ? void 0 : ref.url_64x64
                        };
                    });
                    return _ctx.abrupt("return", {
                        title: responseJSON.title,
                        services: services,
                        href: "https://zapier.com".concat(responseJSON.guided_recipe_url),
                        color: "#".concat((ref1 = responseJSON.head_service) === null || ref1 === void 0 ? void 0 : ref1.primary_color)
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchGuidedRecipe(id) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/sections/ZapCardSection/ZapCardSection.transformer.ts







var fetchZapTemplates = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(items) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", Promise.all((items || []).map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                            var zapTemplate;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (item.zapTemplateID) {
                                            _ctx.next = 2;
                                            break;
                                        }
                                        return _ctx.abrupt("return", item);
                                    case 2:
                                        _ctx.next = 4;
                                        return fetchGuidedRecipe(item.zapTemplateID);
                                    case 4:
                                        zapTemplate = _ctx.sent;
                                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item, zapTemplate), {
                                            // Use the title/href from API if none was input by the Builder user.
                                            title: item.title || zapTemplate.title,
                                            href: item.href || zapTemplate.href,
                                            color: item.color || zapTemplate.color
                                        }));
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(item) {
                            return _ref.apply(this, arguments);
                        };
                    }())));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchZapTemplates(items) {
        return _ref.apply(this, arguments);
    };
}();
var useUnregisteredProps = function(props) {
    var data = (0,dist/* default */.ZP)("zap-templates/".concat(JSON.stringify(props.items || [])), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing)) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetchZapTemplates(props.items);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", props.items);
                case 10:
                    return _ctx.abrupt("return", props.items);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }))).data;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        items: data
    });
};
var transformZapCardSection = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var ref, ref1, ref2, zapTemplates;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return fetchZapTemplates((block === null || block === void 0 ? void 0 : (ref = block.component) === null || ref === void 0 ? void 0 : (ref1 = ref.options) === null || ref1 === void 0 ? void 0 : ref1.items) || []);
                case 3:
                    zapTemplates = _ctx.sent;
                    return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, block), {
                        component: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, block === null || block === void 0 ? void 0 : block.component), {
                            options: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, block === null || block === void 0 ? void 0 : (ref2 = block.component) === null || ref2 === void 0 ? void 0 : ref2.options), {
                                items: zapTemplates
                            })
                        })
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function transformZapCardSection(block) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 27423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H7": function() { return /* binding */ BACKGROUND_TO_FONT_COLORS; },
/* harmony export */   "US": function() { return /* binding */ COLOR_KEYS; },
/* harmony export */   "Z5": function() { return /* binding */ LIGHT_BACKGROUND_COLORS; },
/* harmony export */   "gh": function() { return /* binding */ BACKGROUND_COLOR_KEYS; },
/* harmony export */   "ji": function() { return /* binding */ COLOR_KEYS_LIST; },
/* harmony export */   "kg": function() { return /* binding */ SEMANTIC_COLORS; },
/* harmony export */   "kw": function() { return /* binding */ SEMANTIC_COLORS_LIST; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70776);




var COLOR_KEYS = Object.keys(_zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors */ .w).reduce(function(obj, key) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, obj), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, key));
}, {});
var SEMANTIC_COLORS;
(function(SEMANTIC_COLORS) {
    SEMANTIC_COLORS["danger"] = "danger";
    SEMANTIC_COLORS["primary"] = "primary";
    SEMANTIC_COLORS["primaryAlt"] = "primary-alt";
    SEMANTIC_COLORS["secondary"] = "secondary";
    SEMANTIC_COLORS["tertiary"] = "tertiary";
})(SEMANTIC_COLORS || (SEMANTIC_COLORS = {}));
var COLOR_KEYS_LIST = Object.values(COLOR_KEYS).sort();
var _obj;
var BACKGROUND_TO_FONT_COLORS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.acidWash, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.bolt, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.cream, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.earth, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral100 */ .w.neutral100), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.gray, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.lavender, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.moss, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral100 */ .w.neutral100), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.neutral100, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.neutral800, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral100 */ .w.neutral100), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.night, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral100 */ .w.neutral100), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.peach, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.sky, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.transparent, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral800 */ .w.neutral800), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, COLOR_KEYS.zapier, _zapier_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Colors.neutral100 */ .w.neutral100), _obj);
var LIGHT_BACKGROUND_COLORS = [
    COLOR_KEYS.acidWash,
    COLOR_KEYS.bolt,
    COLOR_KEYS.cream,
    COLOR_KEYS.neutral200,
    COLOR_KEYS.lavender,
    COLOR_KEYS.neutral100,
    COLOR_KEYS.peach,
    COLOR_KEYS.sky,
    COLOR_KEYS.transparent,
    // Deprecated
    COLOR_KEYS.white,
    COLOR_KEYS.gray5,
    COLOR_KEYS.gray10,
    COLOR_KEYS.ocean5,
    COLOR_KEYS.ocean10,
    COLOR_KEYS.sun5,
    COLOR_KEYS.sun10,
    COLOR_KEYS.lava5,
    COLOR_KEYS.lava10, 
];
var BACKGROUND_COLOR_KEYS = Object.keys(BACKGROUND_TO_FONT_COLORS).sort();
var FONT_COLORS = Object.values(BACKGROUND_TO_FONT_COLORS);
var SEMANTIC_COLORS_LIST = Object.values(SEMANTIC_COLORS).sort();


/***/ }),

/***/ 95964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ MEDIA_MAX_WIDTH; },
/* harmony export */   "Ry": function() { return /* binding */ HEADING_SIZE_MAP; },
/* harmony export */   "Ux": function() { return /* binding */ SUB_HEADING_SIZE_MAP; },
/* harmony export */   "d": function() { return /* binding */ MAX_WIDTH; },
/* harmony export */   "j$": function() { return /* binding */ BREAKPOINTS; },
/* harmony export */   "l0": function() { return /* binding */ MEDIA_MIN_WIDTH; },
/* harmony export */   "w5": function() { return /* binding */ mediaQueries; }
/* harmony export */ });
/* unused harmony exports MIN_WIDTH, mediaQueryValues */
var BREAKPOINTS = {
    extraSmall: 450,
    small: 640,
    medium: 768,
    large: 1024,
    extraLarge: 1280
};
var MIN_WIDTH = {
    extraSmall: "(min-width: ".concat(BREAKPOINTS.extraSmall, "px)"),
    small: "(min-width: ".concat(BREAKPOINTS.small, "px)"),
    medium: "(min-width: ".concat(BREAKPOINTS.medium, "px)"),
    large: "(min-width: ".concat(BREAKPOINTS.large, "px)"),
    extraLarge: "(min-width: ".concat(BREAKPOINTS.extraLarge, "px)")
};
var MAX_WIDTH = {
    extraSmall: "(max-width: ".concat(BREAKPOINTS.extraSmall, "px)"),
    small: "(max-width: ".concat(BREAKPOINTS.small, "px)"),
    medium: "(max-width: ".concat(BREAKPOINTS.medium, "px)"),
    large: "(max-width: ".concat(BREAKPOINTS.large, "px)"),
    extraLarge: "(max-width: ".concat(BREAKPOINTS.extraLarge, "px)")
};
var MEDIA_MAX_WIDTH = {
    extraSmall: "@media ".concat(MAX_WIDTH.extraSmall),
    small: "@media ".concat(MAX_WIDTH.small),
    medium: "@media ".concat(MAX_WIDTH.medium),
    large: "@media ".concat(MAX_WIDTH.large),
    extraLarge: "@media ".concat(MAX_WIDTH.extraLarge)
};
var MEDIA_MIN_WIDTH = {
    extraSmall: "@media ".concat(MIN_WIDTH.extraSmall),
    small: "@media ".concat(MIN_WIDTH.small),
    medium: "@media ".concat(MIN_WIDTH.medium),
    large: "@media ".concat(MIN_WIDTH.large),
    extraLarge: "@media ".concat(MIN_WIDTH.extraLarge)
};
var mediaQueryValues = {
    tablet: "(min-width: 768px)",
    desktop: "(min-width: 1230px)"
};
var mediaQueries = {
    tablet: "@media ".concat(mediaQueryValues.tablet),
    desktop: "@media ".concat(mediaQueryValues.desktop)
};
var HEADING_SIZE_MAP = {
    small: {
        mobile: "subHeader5Bold",
        tablet: "pageHeader9",
        desktop: "pageHeader7"
    },
    medium: {
        mobile: "pageHeader9",
        tablet: "pageHeader7",
        desktop: "pageHeader5"
    },
    large: {
        mobile: "pageHeader7",
        tablet: "pageHeader5",
        desktop: "pageHeader3"
    }
};
var SUB_HEADING_SIZE_MAP = {
    small: {
        mobile: "paragraph3",
        tablet: "paragraph3",
        desktop: "paragraph1"
    },
    medium: {
        mobile: "paragraph3",
        tablet: "paragraph1",
        desktop: "subHeader5"
    },
    large: {
        mobile: "paragraph1",
        tablet: "subHeader5",
        desktop: "subHeader3"
    }
};


/***/ }),

/***/ 52310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ PrefetchedDataContext; },
/* harmony export */   "n": function() { return /* binding */ usePrefetchedDataContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var PrefetchedDataContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    roles: [],
    companySizes: []
});
var usePrefetchedDataContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PrefetchedDataContext);
};


/***/ }),

/***/ 52965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KW": function() { return /* binding */ useDeepCompareEffect; }
/* harmony export */ });
/* unused harmony exports useDeepCompareMemoize, useDeepCompareEffectNoCheck */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/**
 * Taken from https://github.com/kentcdodds/use-deep-compare-effect/blob/main/src/index.ts
 * Replaced dequal dependencies with lodash/isEqual
 * LICENSE - https://github.com/kentcdodds/use-deep-compare-effect/blob/main/LICENSE
 */ 


function checkDeps(deps) {
    if (!deps || !deps.length) {
        throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
    }
    if (deps.every(function(dep) {
        return isPrimitive(dep) && typeof dep !== "undefined";
    })) {
        throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
    }
}
function isPrimitive(val) {
    return val == null || /^[sbn]/.test(typeof val === "undefined" ? "undefined" : _type_of(val));
}
/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a memoized version of the value as long as it remains deeply equal
 */ function useDeepCompareMemoize(value) {
    var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
    var signalRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(0);
    if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(value, ref.current)) {
        ref.current = value;
        signalRef.current += 1;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return ref.current;
    }, [
        signalRef.current
    ]);
}
function useDeepCompareEffect(callback, dependencies) {
    if (false) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(callback, useDeepCompareMemoize(dependencies));
}
function useDeepCompareEffectNoCheck(callback, dependencies) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useDeepCompareEffect)));


/***/ }),

/***/ 36287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useViewportSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95964);


var useViewportSize = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), viewportSize = ref[0], setViewportSize = ref[1];
    var getViewportSize = function() {
        var width;
        var height;
        if (window.innerWidth >= 0 && window.innerWidth < _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.extraSmall */ .j$.extraSmall) {
            width = "extraSmall";
        } else if (window.innerWidth >= _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.extraSmall */ .j$.extraSmall && window.innerWidth < _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.small */ .j$.small) {
            width = "small";
        } else if (window.innerWidth >= _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.small */ .j$.small && window.innerWidth < _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.large */ .j$.large) {
            width = "medium";
        } else if (window.innerWidth >= _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.large */ .j$.large && window.innerWidth < _constants__WEBPACK_IMPORTED_MODULE_1__/* .BREAKPOINTS.extraLarge */ .j$.extraLarge) {
            width = "large";
        } else {
            width = "extraLarge";
        }
        if (innerHeight < 600) {
            height = "short";
        } else {
            height = "normal";
        }
        setViewportSize(function(prevState) {
            if (width !== prevState.width || height !== prevState.height) return {
                width: width,
                height: height
            };
            return prevState;
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        getViewportSize();
        window.addEventListener("resize", getViewportSize);
        return function() {
            window.removeEventListener("resize", getViewportSize);
        };
    }, []);
    return viewportSize;
};


/***/ }),

/***/ 5772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TrackRouting; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TrackingProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45413);
/* harmony import */ var _useTrackEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22506);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65088);
/* harmony import */ var _avro__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90073);





function TrackRouting() {
    var trackEvent = (0,_useTrackEvent__WEBPACK_IMPORTED_MODULE_1__/* .useTrackEvent */ .K)();
    var emitPageViewEvent = (0,_avro__WEBPACK_IMPORTED_MODULE_2__/* .useAvroTracking */ .B2)().emitPageViewEvent;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_TrackingProvider__WEBPACK_IMPORTED_MODULE_3__/* .cleanHttpRefererFromStorage */ .iv)();
        var trackPageView = function() {
            // setTimeout for reasons of:
            // A) Give added time / tick for identity Cookie to be set (additional safety measure)
            // B) timneutkens does it in next-plugin-google-analytics for equivalent handler https://github.com/vercel/next.js/blob/5fff814ca1e7f78b50535a55d6f99bd842c4e049/packages/next-plugin-google-analytics/src/on-init-client.js
            setTimeout(function() {
                trackEvent(_events__WEBPACK_IMPORTED_MODULE_4__/* .EventName.NAVIGATE */ .B_.NAVIGATE, {});
                trackEvent(_events__WEBPACK_IMPORTED_MODULE_4__/* .EventName.PERFORMANCE_MOUNT */ .B_.PERFORMANCE_MOUNT, {
                    timeToMount: window.performance.now(),
                    timeToMountType: "page-ready"
                });
                // Avro page view
                emitPageViewEvent();
            }, 0);
        };
        trackPageView();
        return function() {
            (0,_TrackingProvider__WEBPACK_IMPORTED_MODULE_3__/* .cleanHttpRefererFromStorage */ .iv)();
        };
    }, [
        emitPageViewEvent,
        trackEvent
    ]);
    return null;
}


/***/ }),

/***/ 45413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ TrackingProvider; },
/* harmony export */   "iv": function() { return /* binding */ cleanHttpRefererFromStorage; }
/* harmony export */ });
/* unused harmony export setHttpRefererFromStorage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24645);
/* harmony import */ var _zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65088);






var httpRefererKey = "http_referer_blog";
(0,_zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3__.configureTracking)({
    // This has to be 'web' see following slack thread
    // https://zapier.slack.com/archives/C406QGE15/p1605895155293500
    service: "web",
    release: "".concat("b1783a46a1479ecdf1f3c222e877294040acba1e")
});
var addHttpRefererToNavigateEvent = function() {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (event.name === _events__WEBPACK_IMPORTED_MODULE_5__/* .EventName.NAVIGATE */ .B_.NAVIGATE) {
                            /**
     * We need this because Next.js uses client-side routing, and that causes `document.referrer` to be empty
     * whenever a route changes.
     *
     * This issue is not Next.js specific, it's a Single Page Application issue.
     */ event.apply({
                                http_referer: localStorage.getItem(httpRefererKey) || document.referrer
                            });
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
};
var trackingFunctions = (0,_zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3__.createEventTracker)([
    addHttpRefererToNavigateEvent
]);
function TrackingProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_zapier_toolbox_tracking__WEBPACK_IMPORTED_MODULE_3__.TrackingProvider, {
        trackingFunctions: trackingFunctions,
        children: children
    });
}
var cleanHttpRefererFromStorage = function() {
    return localStorage.removeItem(httpRefererKey);
};
var setHttpRefererFromStorage = function() {
    return localStorage.setItem(httpRefererKey, location.href);
};


/***/ }),

/***/ 90073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AI": function() { return /* binding */ InteractionName; },
/* harmony export */   "AO": function() { return /* binding */ EventAction; },
/* harmony export */   "B2": function() { return /* binding */ useAvroTracking; },
/* harmony export */   "g8": function() { return /* binding */ CTAType; }
/* harmony export */ });
/* unused harmony exports Event, emitPageViewEvent, emitUserInteractionEvent, emitSignupUserInteractionEvent, emitCTAClickEvent, emitAccordionToggleEvent */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _zapier_events_toolkit_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18862);
/* harmony import */ var _components_ABTest_ABTest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75571);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97598);
/* harmony import */ var _zapier_cookies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59251);







var Event;
(function(Event) {
    Event["UserInteraction"] = "web_analytics.tracking.user_interaction.UserInteractionEvent";
    Event["PageView"] = "web_analytics.tracking.page_view.PageViewEvent";
    Event["SignupUserInteractionEvent"] = "web_analytics.tracking.user_interaction.SignupUserInteractionEvent";
})(Event || (Event = {}));
var EventAction;
(function(EventAction) {
    EventAction["click"] = "click";
    EventAction["close"] = "close";
    EventAction["in_view"] = "in_view";
    EventAction["edit"] = "edit";
    EventAction["select"] = "select";
})(EventAction || (EventAction = {}));
var InteractionName;
(function(InteractionName) {
    InteractionName["call_to_action"] = "call_to_action";
    InteractionName["carousel_button_click"] = "carousel_button_click";
    InteractionName["component_scrolled_into_view"] = "component_scrolled_into_view";
    InteractionName["dismiss"] = "dismiss";
    InteractionName["navigation"] = "navigation";
    InteractionName["popup"] = "popup";
    InteractionName["radio_select"] = "radio_select";
    InteractionName["submit"] = "submit";
    InteractionName["tab_change"] = "tab_change";
    InteractionName["toggle"] = "toggle";
    InteractionName["video"] = "video";
})(InteractionName || (InteractionName = {}));
var CTAType;
(function(CTAType) {
    CTAType["block_grid_item_link"] = "block_grid_item_link";
    CTAType["cta_button"] = "cta_button";
    CTAType["cta_link"] = "cta_link";
    CTAType["secondary_cta_button"] = "secondary_cta_button";
    CTAType["zap_card_link"] = "zap_card_link";
})(CTAType || (CTAType = {}));
function emitPageViewEvent(eventDetails) {
    return (0,_zapier_events_toolkit_browser__WEBPACK_IMPORTED_MODULE_1__.emit)({
        system_name: "pagebuilder",
        experiment_flag: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.experiment_flag,
        experiment_name: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.experiment_name
    }, Event.PageView);
}
function emitUserInteractionEvent(eventDetails) {
    return (0,_zapier_events_toolkit_browser__WEBPACK_IMPORTED_MODULE_1__.emit)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventDetails), {
        system_name: "pagebuilder"
    }), Event.UserInteraction);
}
function emitSignupUserInteractionEvent(eventDetails) {
    return (0,_zapier_events_toolkit_browser__WEBPACK_IMPORTED_MODULE_1__.emit)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, eventDetails), {
        signup_location: window.location.href,
        system_name: "pagebuilder"
    }), Event.SignupUserInteractionEvent);
}
function emitCTAClickEvent(param) {
    var text = param.text, href = param.href, _type = param.type, type = _type === void 0 ? CTAType.cta_button : _type, section = param.section, experiment_name = param.experiment_name, experiment_flag = param.experiment_flag;
    return emitUserInteractionEvent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        experiment_flag: experiment_flag,
        experiment_name: experiment_name,
        event_action: EventAction.click,
        interaction_name: InteractionName.call_to_action,
        interaction_raw_text: text,
        destination_href: href,
        option_selected: type
    }, section && {
        custom_tracking_fields: {
            section_name: section
        }
    }));
}
function emitAccordionToggleEvent(param) {
    var section = param.section, title = param.title, option_selected = param.option_selected, experiment_name = param.experiment_name, experiment_flag = param.experiment_flag;
    return emitUserInteractionEvent({
        experiment_flag: experiment_flag,
        experiment_name: experiment_name,
        event_action: EventAction.click,
        interaction_name: InteractionName.toggle,
        interaction_raw_text: title,
        option_selected: option_selected,
        custom_tracking_fields: {
            section_name: section
        }
    });
}
function useAvroTracking() {
    var ref = (0,_components_ABTest_ABTest__WEBPACK_IMPORTED_MODULE_4__/* .useABTestContext */ .I)(), experimentName = ref.experimentName, activeVariant = ref.activeVariant;
    var ref1 = (0,_components_Page__WEBPACK_IMPORTED_MODULE_5__/* .usePageContext */ .l)(), id = ref1.id, variations = ref1.variations;
    // Must use a callback to get the experiment name or it will be stale inside of injectExperimentContext
    var getBuilderExperimentName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var ref;
        var builderABTestID = (0,_zapier_cookies__WEBPACK_IMPORTED_MODULE_6__/* .readCookie */ .v)("builder.tests.".concat(id));
        return builderABTestID ? (variations === null || variations === void 0 ? void 0 : (ref = variations[builderABTestID]) === null || ref === void 0 ? void 0 : ref.name) || "default" : "";
    }, [
        variations,
        id
    ]);
    var injectExperimentContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(callback) {
        return function(props) {
            // If the activeVariant is a fallback, then the ABTest was not set up correctly and we do not send tracking events.
            var isValidABTest = !!(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name) && !(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.isFallback);
            var experiment_flag = isValidABTest || !!getBuilderExperimentName();
            var experiment_name = getBuilderExperimentName() || "".concat(experimentName, "_").concat(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name);
            return callback((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props, experiment_flag && {
                experiment_name: experiment_name
            }), {
                experiment_flag: experiment_flag
            }));
        };
    }, [
        experimentName,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.isFallback,
        activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.name,
        getBuilderExperimentName, 
    ]);
    var emitUserInteractionEventCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(args) {
        return injectExperimentContext(emitUserInteractionEvent)(args);
    }, [
        injectExperimentContext
    ]);
    var emitCTAClickEventCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(args) {
        return injectExperimentContext(emitCTAClickEvent)(args);
    }, [
        injectExperimentContext
    ]);
    var emitAccordionToggleEventCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(args) {
        return injectExperimentContext(emitAccordionToggleEvent)(args);
    }, [
        injectExperimentContext
    ]);
    var emitPageViewEventCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return injectExperimentContext(emitPageViewEvent)();
    }, [
        injectExperimentContext
    ]);
    var emitSignupUserInteractionEventCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(args) {
        return injectExperimentContext(emitSignupUserInteractionEvent)(args);
    }, [
        injectExperimentContext
    ]);
    return {
        emitPageViewEvent: emitPageViewEventCallback,
        emitCTAClickEvent: emitCTAClickEventCallback,
        emitUserInteractionEvent: emitUserInteractionEventCallback,
        emitAccordionToggleEvent: emitAccordionToggleEventCallback,
        emitSignupUserInteractionEvent: emitSignupUserInteractionEventCallback
    };
}


/***/ }),

/***/ 65088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B_": function() { return /* binding */ EventName; },
/* harmony export */   "LK": function() { return /* binding */ CtaGoal; },
/* harmony export */   "XE": function() { return /* binding */ CtaName; },
/* harmony export */   "jz": function() { return /* binding */ SectionName; }
/* harmony export */ });
var SectionName;
(function(SectionName) {
    SectionName["AccordionSection"] = "AccordionSection";
    SectionName["AnimationsSection"] = "AnimationsSection";
    SectionName["AppsSection"] = "AppsSection";
    SectionName["BlockGrid"] = "BlockGrid";
    SectionName["BlockSection"] = "BlockSection";
    SectionName["Card"] = "Card";
    SectionName["CarouselSection"] = "CarouselSection";
    SectionName["ColumnsGridSection"] = "ColumnsGridSection";
    SectionName["CompactCTASection"] = "CompactCTASection";
    SectionName["CTASection"] = "CTASection";
    SectionName["CtaStandardSection"] = "CtaStandardSection";
    SectionName["EventAgendaSection"] = "EventAgendaSection";
    SectionName["FakeSection"] = "FakeSection";
    SectionName["FAQSection"] = "FAQSection";
    SectionName["FeaturesSection"] = "FeaturesSection";
    SectionName["HeroFeatures"] = "HeroFeatures";
    SectionName["HeroSection"] = "HeroSection";
    SectionName["HubSpotMeeting"] = "HubSpotMeeting";
    SectionName["JobBoard"] = "JobBoard";
    SectionName["LogoBar"] = "LogoBar";
    SectionName["OneColumnBlock"] = "OneColumnBlock";
    SectionName["PlanComparisonSection"] = "PlanComparisonSection";
    SectionName["PopularTemplatesSection"] = "PopularTemplatesSection";
    SectionName["ResourcesSection"] = "ResourcesSection";
    SectionName["ScrollingTweetsSection"] = "ScrollingTweetsSection";
    SectionName["SectionWithSubNav"] = "SectionWithSubNav";
    SectionName["SignUpSection"] = "SignUpSection";
    SectionName["SplitColorAccordionSection"] = "SplitColorAccordionSection";
    SectionName["SplitColorHero"] = "SplitColorHero";
    SectionName["SubscribeSection"] = "SubscribeSection";
    SectionName["TableSection"] = "TableSection";
    SectionName["TabsSection"] = "TabsSection";
    SectionName["TestimonialCarousel"] = "TestimonialCarousel";
    SectionName["TestimonialMultipleColumn"] = "TestimonialMultipleColumn";
    SectionName["TestimonialSolo"] = "TestimonialSolo";
    SectionName["TestimonialsSection"] = "TestimonialsSection";
    SectionName["TwoColumnRiverSection"] = "TwoColumnRiverSection";
    SectionName["VideoSection"] = "VideoSection";
    SectionName["ZapCardSection"] = "ZapCardSection";
})(SectionName || (SectionName = {}));
var CtaGoal;
(function(CtaGoal) {
    CtaGoal["browseTemplates"] = "browse_templates";
    CtaGoal["getMoreInformation"] = "get_more_information";
    CtaGoal["exploreIntegrations"] = "explore_integrations";
    CtaGoal["upgrade"] = "upgrade";
    CtaGoal["fakeCtaGoal"] = "fakeCtaGoal";
    CtaGoal["signup"] = "signup";
    CtaGoal["webinarRegistration"] = "webinarRegistration";
    CtaGoal["eventRegistration"] = "eventRegistration";
    CtaGoal["scheduleCall"] = "scheduleCall";
    CtaGoal["createZap"] = "createZap";
    CtaGoal["transfer"] = "transfer";
})(CtaGoal || (CtaGoal = {}));
var CtaName;
(function(CtaName) {
    CtaName["browseTemplates"] = "browse_templates";
    CtaName["exploreIntegrations"] = "explore_integrations";
    CtaName["features"] = "features";
    CtaName["tryThis"] = "try_this";
    CtaName["tabSelection"] = "tab_selection";
    CtaName["demo"] = "demo";
    CtaName["moreArticles"] = "get_more_articles";
    CtaName["readFullStory"] = "read_full_story";
    CtaName["betaOptIn"] = "beta_opt_in";
    CtaName["fakeCtaName"] = "fakeCtaName";
    CtaName["viewMore"] = "viewMore";
    CtaName["learnMore"] = "learnMore";
    CtaName["register"] = "register";
    CtaName["watchVideo"] = "watchVideo";
    CtaName["downloadContent"] = "downloadContent";
    CtaName["signup"] = "signup";
    CtaName["upgrade"] = "upgrade";
    CtaName["contactUs"] = "contactUs";
    CtaName["getStarted"] = "getStarted";
})(CtaName || (CtaName = {}));
var EventName;
(function(EventName) {
    EventName["NAVIGATE"] = "navigate";
    EventName["PERFORMANCE_MOUNT"] = "performance_mount";
    EventName[/**
   * We need PAGE_VIEW & NAVIAGETE_SSR for the time being so that we can
   * 1) track pages in the same way we have in the past and
   * 2) work towards moving to Avro events by end of 2021.
   */ "PAGE_VIEW"] = "schema:web_analytics.tracking.page_view.PageViewEvent";
    EventName["SCROLLED_INTO_VIEW"] = "component_scrolled_into_view";
    EventName["CALL_TO_ACTION"] = "call_to_action";
    EventName["FAQ_ACCORDION_OPEN"] = "faq_accordion_open";
    EventName["FAQ_ACCORDION_CLOSE"] = "faq_accordion_close";
    EventName["FAQ_SECTION_CLOSE"] = "faq_section_close";
    EventName["FAQ_SECTION_OPEN"] = "faq_section_open";
    EventName["HUBSPOT_FORM_SUBMITTED"] = "hubspot_form_submitted";
})(EventName || (EventName = {}));


/***/ }),

/***/ 22506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ useTrackEvent; }
});

// EXTERNAL MODULE: ../../node_modules/@zapier/toolbox-tracking/dist/index.js
var dist = __webpack_require__(24645);
;// CONCATENATED MODULE: ./src/utils/isDatadog.ts
/**
 * Determine if client side context within Datadog request (Synthetic Bots etc...)
 *
 * Useful to disable event tracking for Datadog bots.
 * See Datadog Identify Synthetic Bots documentation here:
 * https://docs.datadoghq.com/synthetics/guide/identify_synthetics_bots/?tab=singleandmultistepapitests#default-headers
 */ function isDatadog() {
    return  true && window.navigator.userAgent.includes("Datadog");
}

;// CONCATENATED MODULE: ./src/observability/tracking/useTrackEvent.ts


var noop = function() {
    return undefined;
};
/**
 * Wrap useTrackingContext and expose only the strongly typed trackEvent
 * All trackEvent usages should flow through this rather than using useTrackingContext() directly
 */ var useTrackEvent = function() {
    var trackEvent = (0,dist.useTrackingContext)().trackEvent;
    if (isDatadog()) {
        return noop;
    }
    return trackEvent;
};


/***/ }),

/***/ 73548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 6 modules
var globals = __webpack_require__(66064);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(42370);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,globals/* invariant */.kG)(context.client, 29);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ../../node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(92454);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/useCookieConsent.js
var useCookieConsent = __webpack_require__(7727);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../node_modules/@zapier/global-styles-provider/esm/components/GlobalStylesProvider/GlobalCss/V5Styles.js

const V5Styles = emotion_react_browser_esm/* css */.iv `
  :root {
    // Brand colors
    --zds-colors-zapier: #ff4f00;
    --zds-colors-earth: #31201f;
    --zds-colors-moss: #1a4a4c;
    --zds-colors-night: #2c3266;
    --zds-colors-lavender: #c1b7ff;
    --zds-colors-peach: #ffe7d1;
    --zds-colors-bolt: #fdff9f;
    --zds-colors-sky: #9ddef3;
    --zds-colors-cream: #fff3e6;

    /* Blues */
    --zds-colors-blue-jeans: #3d4592;
    --zds-colors-bluebell: #5e71c7;
    --zds-colors-periwinkle: #90a1ed;
    --zds-colors-lilac: #b2bce9;
    --zds-colors-hydrangea: #d2d8f3;
    --zds-colors-acid-wash: #f0f1fa;

    /* Error */
    --zds-colors-error-500: #b83519;
    --zds-colors-error-400: #ce482d;
    --zds-colors-error-300: #e87057;
    --zds-colors-error-200: #feb7a8;
    --zds-colors-error-100: #fadfd9;

    /* Warning */
    --zds-colors-warning-500: #dfb900;
    --zds-colors-warning-400: #ffd300;
    --zds-colors-warning-300: #f8df68;
    --zds-colors-warning-200: #fcec9f;
    --zds-colors-warning-100: #fff4bc;

    /* Success */
    --zds-colors-success-500: #086f3d;
    --zds-colors-success-400: #0f884e;
    --zds-colors-success-300: #36a770;
    --zds-colors-success-200: #ade2c8;
    --zds-colors-success-100: #def3e9;

    /* Neutrals */
    --zds-colors-neutral-800: #2d2e2e;
    --zds-colors-neutral-700: #403f3e;
    --zds-colors-neutral-600: #95928e;
    --zds-colors-neutral-500: #a8a5a0;
    --zds-colors-neutral-400: #d7d5d2;
    --zds-colors-neutral-300: #e8e7e4;
    --zds-colors-neutral-200: #f7f5f2;
    --zds-colors-neutral-100: #fffdf9;

    /* Typography */
    /* heading and base are the same for now, but will be different with Phase 2 */
    --zds-typography-base: 'Inter', sans-serif;
    --zds-typography-heading: 'Inter', sans-serif;
    --zds-typography-large-letter-spacing: -2px;
    --zds-typography-medium-letter-spacing: -1px;
    --zds-typography-small-letter-spacing: normal;
    --zds-typography-pageheader-weight: 500;
    --zds-typography-pageheader1-fontsize: 72px;
    --zds-typography-pageheader1-lineheight: 76px;
    --zds-typography-pageheader3-fontsize: 56px;
    --zds-typography-pageheader3-lineheight: 64px;
    --zds-typography-pageheader5-lineheight: 48px;
    --zds-typography-pageheader7-lineheight: 40px;
    --zds-typography-pageheader9-lineheight: 32px;
    --zds-typography-paragraph1short-lineheight: 24px;
    --zds-typography-paragraph3-lineheight: 24px;
  }
`;
//# sourceMappingURL=V5Styles.js.map
// @zapier/global-styles-provider@0.5.2 (87c17cb79)

;// CONCATENATED MODULE: ../../node_modules/@zapier/global-styles-provider/esm/components/GlobalStylesProvider/GlobalCss/PlatformStyles.js

const PlatformStyles = emotion_react_browser_esm/* css */.iv `
  @font-face {
    font-family: Degular Display;
    src: url('https://fonts.zapier.com/Degular/Degular_Display-Bold.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 700;
  }
  @font-face {
    font-family: Degular;
    src: url('https://fonts.zapier.com/Degular/DegularDisplay-Medium.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 500;
  }
  @font-face {
    font-family: Degular;
    src: url('https://fonts.zapier.com/Degular/DegularDisplay-Semibold.woff2')
      format('woff2');
    font-display: swap;
    font-weight: 600;
  }
  :root {
    // Brand colors
    --zds-colors-zapier: #ff4f00;
    --zds-colors-earth: #201515;
    --zds-colors-moss: #1f3121;
    --zds-colors-night: #2b2358;
    --zds-colors-lavender: #c1b7ff;
    --zds-colors-peach: #ffbf63;
    --zds-colors-bolt: #f6ffdb;
    --zds-colors-sky: #cde4e1;
    --zds-colors-cream: #fff3e6;

    /* Blues */
    --zds-colors-blue-jeans: #3d4592;
    --zds-colors-bluebell: #5e71c7;
    --zds-colors-periwinkle: #90a1ed;
    --zds-colors-lilac: #b2bce9;
    --zds-colors-hydrangea: #d2d8f3;
    --zds-colors-acid-wash: #f0f1fa;

    /* Error */
    --zds-colors-error-500: #b83519;
    --zds-colors-error-400: #ce482d;
    --zds-colors-error-300: #e87057;
    --zds-colors-error-200: #feb7a8;
    --zds-colors-error-100: #fadfd9;

    /* Warning */
    --zds-colors-warning-500: #dfb900;
    --zds-colors-warning-400: #ffd300;
    --zds-colors-warning-300: #f8df68;
    --zds-colors-warning-200: #fcec9f;
    --zds-colors-warning-100: #fff4bc;

    /* Success */
    --zds-colors-success-500: #086f3d;
    --zds-colors-success-400: #0f884e;
    --zds-colors-success-300: #36a770;
    --zds-colors-success-200: #ade2c8;
    --zds-colors-success-100: #def3e9;

    /* Neutrals */
    --zds-colors-neutral-800: #2d2e2e;
    --zds-colors-neutral-700: #403f3e;
    --zds-colors-neutral-600: #95928e;
    --zds-colors-neutral-500: #a8a5a0;
    --zds-colors-neutral-400: #d7d5d2;
    --zds-colors-neutral-300: #e8e7e4;
    --zds-colors-neutral-200: #f7f5f2;
    --zds-colors-neutral-100: #fffdf9;

    /* Typography */
    /* heading and base are the same for now, but will be different with Phase 2 */
    --zds-typography-base: 'Inter', sans-serif;
    --zds-typography-heading: 'Degular', sans-serif;
    --zds-typography-heading-display: 'Degular Display', sans-serif;
    --zds-typography-large-letter-spacing: 1px;
    --zds-typography-small-letter-spacing: normal;
    --zds-typography-pageheader-weight: 700;
    --zds-typography-semibold-weight: 600;
    --zds-typography-medium-weight: 500;
    --zds-typography-pageheader1-fontsize: 82px;
    --zds-typography-pageheader1-lineheight: 84px;
    --zds-typography-pageheader3-fontsize: 62px;
    --zds-typography-pageheader3-lineheight: 66px;
    --zds-typography-pageheader4-fontsize: 52px;
    --zds-typography-pageheader4-lineheight: 60px;
    --zds-typography-pageheader5-fontsize: 42px;
    --zds-typography-pageheader5-lineheight: 50px;
    --zds-typography-pageheader7-fontsize: 34px;
    --zds-typography-pageheader7-lineheight: 40px;
    --zds-typography-pageheader9-fontsize: 26px;
    --zds-typography-pageheader9-lineheight: 32px;
    --zds-typography-paragraph1short-lineheight: 24px;
    --zds-typography-paragraph3-lineheight: 24px;
  }
`;
//# sourceMappingURL=PlatformStyles.js.map
// @zapier/global-styles-provider@0.5.2 (87c17cb79)

;// CONCATENATED MODULE: ../../node_modules/@zapier/global-styles-provider/esm/components/GlobalStylesProvider/GlobalStylesProvider.js




const ThemeContext = (0,react.createContext)({
    isRebrand: false,
    isPlatform: false,
});
const useTheme = () => {
    const { isRebrand, isPlatform } = useContext(ThemeContext);
    return { isRebrand, isPlatform };
};
const REBRAND_COOKIE = '__tnp';
const PLATFORM_COOKIE = '__tzp';
const GlobalStylesProvider = ({ children, isPlatform, isRebrand, }) => {
    return (react.createElement(ThemeContext.Provider, { value: { isRebrand, isPlatform } },
        react.createElement(emotion_react_browser_esm/* Global */.xB, { styles: isPlatform ? PlatformStyles : V5Styles }),
        children));
};
//# sourceMappingURL=GlobalStylesProvider.js.map
// @zapier/global-styles-provider@0.5.2 (87c17cb79)

// EXTERNAL MODULE: ../../node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(96204);
// EXTERNAL MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js + 9 modules
var core_browser_esm = __webpack_require__(39503);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js + 1 modules
var Colors = __webpack_require__(70776);
;// CONCATENATED MODULE: ./src/components/GlobalStyles.tsx



var globalStyles = (0,core_browser_esm/* css */.iv)({
    body: {
        fontFamily: Typography/* Typography.base.fontFamily */.ZT.base.fontFamily,
        fontStyle: "normal",
        fontWeight: "normal",
        margin: 0,
        backgroundColor: Colors/* Colors.neutral100 */.w.neutral100
    },
    "*": {
        margin: 0,
        padding: 0
    }
});
function GlobalStyles() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(core_browser_esm/* Global */.xB, {
        styles: globalStyles
    });
}

// EXTERNAL MODULE: ./src/components/WistiaVideo/WistiaVideo.context.tsx
var WistiaVideo_context = __webpack_require__(61073);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
;// CONCATENATED MODULE: ../../node_modules/zen-observable-ts/module.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}



;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(45931);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new globals/* InvariantError */.ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new globals/* InvariantError */.ej(44);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,globals/* invariant */.kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,globals/* invariant */.kG)(fragments.length === 1, 45);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: (0,tslib_es6/* __spreadArray */.ev)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(fragmentName)) : (0,globals/* invariant */.kG)(fragment, 46);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return ((0,objects/* isNonNullObject */.s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new globals/* InvariantError */.ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new globals/* InvariantError */.ej(55);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,objects/* isNonNullObject */.s)(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (storeUtils_isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function storeUtils_isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js


function checkDocument(doc) {
    __DEV__ ? (0,globals/* invariant */.kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,globals/* invariant */.kG)(doc && doc.kind === 'Document', 47);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new globals/* InvariantError */.ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new globals/* InvariantError */.ej(48);
        }
        return definition;
    });
    __DEV__ ? (0,globals/* invariant */.kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,globals/* invariant */.kG)(operations.length <= 1, 49);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,globals/* invariant */.kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,globals/* invariant */.kG)(queryDef && queryDef.operation === 'query', 50);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,globals/* invariant */.kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,globals/* invariant */.kG)(doc.kind === 'Document', 51);
    __DEV__ ? (0,globals/* invariant */.kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,globals/* invariant */.kG)(doc.definitions.length <= 1, 52);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,globals/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,globals/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 53);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new globals/* InvariantError */.ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new globals/* InvariantError */.ej(54);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new globals/* InvariantError */.ej("illegal argument: ".concat(key)) : new globals/* InvariantError */.ej(27);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : Observable.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return Observable.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || Observable.of()
                    : rightLink.request(operation) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || Observable.of()
                    : rightLink.request(operation, forward) || Observable.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && globals/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || Observable.of();
                }) || Observable.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new globals/* InvariantError */.ej('request is not implemented') : new globals/* InvariantError */.ej(22);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(92277);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/visitor.mjs

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visitor_visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + (0,inspect/* default */.Z)(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */

function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,globals/* invariant */.kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,globals/* invariant */.kG)(evaledValue !== void 0, 40);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) { return hasDirectives(names, root, false); };
var hasAllDirectives = function (names, root) { return hasDirectives(names, root, true); };
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    visitor_visit(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return BREAK;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,globals/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,globals/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, 41);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,globals/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,globals/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', 42);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,globals/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,globals/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 43);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/serializeFetchParameter.js

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new globals/* InvariantError */.ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new globals/* InvariantError */.ej(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/selectURI.js
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/responseIterator.js

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/async.js
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/nodeStream.js

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/promise.js

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/reader.js

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/responseIterator.js





function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js


var mergeDeep_hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = objects/* isNonNullObject */.s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,objects/* isNonNullObject */.s)(source) && (0,objects/* isNonNullObject */.s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (mergeDeep_hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib_es6/* __spreadArray */.ev)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,objects/* isNonNullObject */.s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/incrementalResult.js



function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
function isApolloPayloadResult(value) {
    return (0,objects/* isNonNullObject */.s)(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new DeepMerger();
    if (isExecutionPatchIncrementalResult(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}
//# sourceMappingURL=incrementalResult.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js





var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c, _d, _e;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _f, value, done, chunk, bi, message, i, headers, contentType_1, body, result, next;
        var _g, _h;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _j.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _f = _j.sent(), value = _f.value, done = _f.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while (bi > -1) {
                        message = void 0;
                        _g = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _g[0], buffer = _g[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = parseHeaders(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 &&
                                contentType_1.toLowerCase().indexOf("application/json") === -1) {
                                throw new Error("Unsupported patch content type: application/json is required.");
                            }
                            body = message.slice(i);
                            try {
                                result = parseJsonBody(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result ||
                                    "payload" in result) {
                                    if (isApolloPayloadResult(result)) {
                                        next = {};
                                        if ("payload" in result) {
                                            next = (0,tslib_es6/* __assign */.pi)({}, result.payload);
                                        }
                                        if ("errors" in result) {
                                            next = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, next), { extensions: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ("extensions" in next ? next.extensions : null)), (_h = {}, _h[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG] = result.errors, _h)) });
                                        }
                                        (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, next);
                                    }
                                    else {
                                        (_c = observer.next) === null || _c === void 0 ? void 0 : _c.call(observer, result);
                                    }
                                }
                                else if (Object.keys(result).length === 1 &&
                                    "hasNext" in result &&
                                    !result.hasNext) {
                                    (_d = observer.complete) === null || _d === void 0 ? void 0 : _d.call(observer);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_e = observer.complete) === null || _e === void 0 ? void 0 : _e.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        throwServerError(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/checkFetcher.js

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new globals/* InvariantError */.ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new globals/* InvariantError */.ej(23);
    }
};
//# sourceMappingURL=checkFetcher.js.map
// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visitor_visit(ast, {
    leave: printDocASTReducer
  });
} // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,blockString/* printBlockString */.LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

function isMultiline(string) {
  return string.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray && maybeArray.some(isMultiline);
}

;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, __spreadArray([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
;
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/createSignalIfSupported.js
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/rewriteURIForGET.js

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/fromError.js

function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/createHttpLink.js















var backupFetch = (0,globals/* maybe */.wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            visitor_visit(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib_es6/* __assign */.pi)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        var definitionIsSubscription = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'subscription';
        };
        var isSubscription = definitionIsSubscription(getMainDefinition(operation.query));
        var hasDefer = hasDirectives(['defer'], operation.query);
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            if (isSubscription && hasDefer) {
                __DEV__ && globals/* invariant.warn */.kG.warn("Multipart-subscriptions do not support @defer");
            }
            if (isSubscription) {
                acceptHeader += 'boundary=graphql;subscriptionSpec=1.0,application/json';
            }
            else if (hasDefer) {
                acceptHeader += 'deferSpec=20220824,application/json';
            }
            options.headers.accept = acceptHeader;
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            var currentFetch = preferredFetch || (0,globals/* maybe */.wY)(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return readMultipartBody(response, observer);
                }
                else {
                    return readJsonBody(response, operation, observer);
                }
            })
                .catch(function (err) { return handleError(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/HttpLink.js



var HttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));

//# sourceMappingURL=HttpLink.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/execute.js

var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/version.js
var version = '3.7.14';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
;// CONCATENATED MODULE: ../../node_modules/@wry/trie/lib/trie.esm.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/object-canon.js





function shallowCopy(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        return (0,arrays/* isArray */.k)(value)
            ? value.slice(0)
            : (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        this.pool = new Trie(canUse/* canUseWeakMap */.mr);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,objects/* isNonNullObject */.s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/errorHandling.js


function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0,arrays/* isNonEmptyArray */.O)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
        ? result.errors.slice(0)
        : [];
    if (isExecutionPatchIncrementalResult(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js







var TYPENAME_FIELD = {
    kind: kinds/* Kind.FIELD */.h.FIELD,
    name: {
        kind: kinds/* Kind.NAME */.h.NAME,
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    var nameSet = new Set();
    var tests = [];
    directives.forEach(function (directive) {
        if (directive.name) {
            nameSet.add(directive.name);
        }
        else if (directive.test) {
            tests.push(directive.test);
        }
    });
    return function (directive) { return (nameSet.has(directive.name.value) ||
        tests.some(function (test) { return test(directive); })); };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, inUse = {
                variables: new Set,
                fragmentSpreads: new Set,
            });
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if ((0,arrays/* isArray */.k)(ancestor))
                continue;
            if (ancestor.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        __DEV__ && globals/* invariant.error */.kG.error("Could not find operation or fragment");
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var hasRemoveDirective = directives.some(function (directive) { return directive.remove; });
    var shouldRemoveField = function (nodeDirectives) { return (hasRemoveDirective &&
        nodeDirectives &&
        nodeDirectives.some(directiveMatcher)); };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = visitor_visit(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    return node;
                }
                if (operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) { return (selection.kind === kinds/* Kind.FIELD */.h.FIELD &&
                        selection.name.value === '__typename'); })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        return doc;
    }
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION &&
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    allFragmentNamesUsed.forEach(function (fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) { return !!(!allFragmentNamesUsed.has(fragmentName) ||
        getInUseByFragmentName(fragmentName).removed); };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty(visitor_visit(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) { return usedVariableNames_1.has(varDef.variable.name.value); }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return visitor_visit(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION) {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (storeUtils_isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (storeUtils_isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && globals/* invariant.warn */.kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === Kind.VARIABLE &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign(__assign({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = visitor_visit(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/makeUniqueId.js
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/iteration.js
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/subclassing.js


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUse/* canUseSymbol */.aS && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new Observable(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(Observable));

fixObservableSubclass(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep_toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (cloneDeep_toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js





var ObservableQuery_assign = Object.assign, ObservableQuery_hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = getOperationDefinition(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            core_networkStatus/* NetworkStatus.ready */.I.ready;
        var result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, lastResult), { loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,equality_esm/* equal */.D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        return (!this.last ||
            !(0,equality_esm/* equal */.D)(this.last.result, newResult) ||
            (variables && !(0,equality_esm/* equal */.D)(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,equality_esm/* equal */.D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            var queryDef = getQueryDefinition(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && globals/* invariant.warn */.kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !(0,equality_esm/* equal */.D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.refetch */.I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && globals/* invariant.error */.kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,equality_esm/* equal */.D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, core_networkStatus/* NetworkStatus.setVariables */.I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
            }
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager['fetchConcastWithInfo'](this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,globals/* invariant */.kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,globals/* invariant */.kG)(pollInterval, 13);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,core_networkStatus/* isNetworkRequestInFlight */.O)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, core_networkStatus/* NetworkStatus.poll */.I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : cloneDeep(newResult), variables: variables });
        if (!(0,arrays/* isNonEmptyArray */.O)(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserveAsConcast = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch ||
            newNetworkStatus === core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore ||
            newNetworkStatus === core_networkStatus/* NetworkStatus.poll */.I.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !(0,equality_esm/* equal */.D)(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
                }
            }
        }
        var variables = options.variables && (0,tslib_es6/* __assign */.pi)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast && fromLink) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            iterateObserversSafely(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: core_networkStatus/* NetworkStatus.error */.I.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(Observable));

fixObservableSubclass(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && globals/* invariant.error */.kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && globals/* invariant.debug */.kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
//# sourceMappingURL=ObservableQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
  return node.kind === Kind.OPERATION_DEFINITION || node.kind === Kind.FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
  return node.kind === kinds/* Kind.FIELD */.h.FIELD || node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD || node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT;
}
function isValueNode(node) {
  return node.kind === Kind.VARIABLE || node.kind === Kind.INT || node.kind === Kind.FLOAT || node.kind === Kind.STRING || node.kind === Kind.BOOLEAN || node.kind === Kind.NULL || node.kind === Kind.ENUM || node.kind === Kind.LIST || node.kind === Kind.OBJECT;
}
function isTypeNode(node) {
  return node.kind === Kind.NAMED_TYPE || node.kind === Kind.LIST_TYPE || node.kind === Kind.NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
  return node.kind === Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === Kind.DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_DEFINITION || node.kind === Kind.OBJECT_TYPE_DEFINITION || node.kind === Kind.INTERFACE_TYPE_DEFINITION || node.kind === Kind.UNION_TYPE_DEFINITION || node.kind === Kind.ENUM_TYPE_DEFINITION || node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_EXTENSION || node.kind === Kind.OBJECT_TYPE_EXTENSION || node.kind === Kind.INTERFACE_TYPE_EXTENSION || node.kind === Kind.UNION_TYPE_EXTENSION || node.kind === Kind.ENUM_TYPE_EXTENSION || node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

;// CONCATENATED MODULE: ../../node_modules/@wry/context/lib/slot.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());
//# sourceMappingURL=slot.js.map
;// CONCATENATED MODULE: ../../node_modules/@wry/context/lib/index.js


const { bind, noContext } = Slot;
// Like global.setTimeout, except the callback runs with captured context.

function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject) => {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (lib_isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            const invokeNext = (value) => invoke(boundNext, value);
            const invokeThrow = (error) => invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function lib_isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method) => {
            const fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var bundle_esm_a;
var bundle_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (bundle_esm_a = Array.from, bundle_esm_a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : bundle_esm_a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                bundle_esm_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new Trie(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function bundle_esm_wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js


var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: dep(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return removeClientSetsFromDocument(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        visitor_visit(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return BREAK;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) {
                            return [2];
                        }
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (storeUtils_isField(selection)) {
                            return [2, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,globals/* invariant */.kG)(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (!rootValue) {
                    return [2, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                argumentsObjectFromField(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === 'client'; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                visitor_visit(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === 'client') {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(spread.name.value)) : (0,globals/* invariant */.kG)(fragment, 12);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryInfo.js







;
var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,equality_esm/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,equality_esm/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0,equality_esm/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !(0,equality_esm/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    reobserveCacheFirst(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !(0,equality_esm/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,equality_esm/* equal */.D)(variables, lastWrite.variables) &&
            (0,equality_esm/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new DeepMerger();
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData = mergeIncrementalData(this.getDiff().result, result);
            result.data = mergedData;
        }
        else if ('hasNext' in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryManager.js














var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('QueryManager stopped while query was in flight') : new globals/* InvariantError */.ej(14));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? (0,globals/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,globals/* invariant */.kG)(mutation, 15);
                        __DEV__ ? (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 16);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new client_errors/* ApolloError */.cA({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6/* __assign */.pi)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        if (!('hasNext' in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof client_errors/* ApolloError */.cA ? err : new client_errors/* ApolloError */.cA({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!isExecutionPatchIncrementalResult(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if (isExecutionPatchIncrementalResult(result) && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.transform(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = mergeIncrementalData(diff.result, result);
                }
                if (typeof mergedData !== 'undefined') {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && getOperationName(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    var isFinalResult = !isExecutionPatchResult(result) ||
                        (isExecutionPatchIncrementalResult(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: diff.result });
                                if ('incremental' in result) {
                                    delete result.incremental;
                                }
                                if ('hasNext' in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = removeConnectionDirectiveFromDocument(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
                asQuery: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,globals/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,globals/* invariant */.kG)(options.query, 17);
        __DEV__ ? (0,globals/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,globals/* invariant */.kG)(options.query.kind === 'Document', 18);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.returnPartialData, 19);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.pollInterval, 20);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new globals/* InvariantError */.ej(21));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = makeUniqueId("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                var hasErrors = graphQLResultHasError(result);
                var hasProtocolErrors = (0,client_errors/* graphQLResultHasProtocolErrors */.ls)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) {
                        errors.graphQLErrors = result.errors;
                    }
                    if (hasProtocolErrors) {
                        errors.protocolErrors = result.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                    }
                    throw new client_errors/* ApolloError */.cA(errors);
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = canonicalStringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                Observable.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new client_errors/* ApolloError */.cA({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,client_errors/* isApolloError */.MS)(networkError)
                ? networkError
                : new client_errors/* ApolloError */.cA({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast;
    };
    QueryManager.prototype.fetchConcastWithInfo = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                sourcesWithInfo.sources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return sourcesWithInfo;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast, containsDataFromLink;
        if (this.transform(normalized.query).hasClientExports) {
            concast = new Concast(this.localState
                .addExportedVariables(normalized.query, normalized.variables, normalized.context)
                .then(fromVariables).then(function (sourcesWithInfo) { return sourcesWithInfo.sources; }));
            containsDataFromLink = true;
        }
        else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new Concast(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink,
        };
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !(0,equality_esm/* equal */.D)(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) { return Observable.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            if (errorPolicy === 'none' &&
                networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return { fromLink: false, sources: [resultsFromCache(diff, queryInfo.markReady())] };
                }
                if (returnPartialData || shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(diff), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(diff), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-only":
                return { fromLink: false, sources: [resultsFromCache(readCache(), queryInfo.markReady())] };
            case "network-only":
                if (shouldNotify) {
                    return { fromLink: true, sources: [resultsFromCache(readCache()), resultsFromLink()] };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "no-cache":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [
                            resultsFromCache(queryInfo.getDiff()),
                            resultsFromLink(),
                        ],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "standby":
                return { fromLink: false, sources: [] };
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink.empty();
        }
        if (!cache) {
            throw __DEV__ ? new globals/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new globals/* InvariantError */.ej(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && connectToDevTools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && globals/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/core/cache.js



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = bundle_esm_wrap(getFragmentQueryDocument);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/core/types/common.js

var MissingFieldError = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(23180);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/helpers.js

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}

function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,compact/* compact */.o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,objects/* isNonNullObject */.s)(result)) {
        return (0,arrays/* isArray */.k)(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if (storeUtils_isField(field) && shouldInclude(field, variables)) {
                    var key = resultKeyNameFromField(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,objects/* isNonNullObject */.s)(value) &&
        !isReference(value) &&
        !(0,arrays/* isArray */.k)(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = createFragmentMap(getFragmentDefinitions(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(isReference(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return isReference(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return makeReference(objOrIdOrRef);
            }
            if (isReference(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = makeReference(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,globals/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || makeReference(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if (isReference(obj)) {
                    found_1[obj.__ref] = true;
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? dep() : null;
        this.keyMaker = new Trie(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new Trie(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_esm/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,equality_esm/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/readFromStore.js









;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new ObjectCanon;
        this.executeSelectionSet = bundle_esm_wrap(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = bundle_esm_wrap(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(getQueryDefinition(query))), variables);
        var rootRef = makeReference(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: getMainDefinition(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6/* __assign */.pi)({ store: store, query: query, policies: policies, variables: variables, varString: canonicalStringify(variables), canonizeResults: canonizeResults }, extractFragmentContext(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new DeepMerger();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!shouldInclude(selection, variables))
                return;
            if (storeUtils_isField(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = resultKeyNameFromField(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,arrays/* isArray */.k)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = mergeDeepArray(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new DeepMerger();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if ((0,arrays/* isArray */.k)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                __DEV__ ? (0,globals/* invariant */.kG)(!isReference(value), "Missing selection set for object of type ".concat(getTypenameFromStoreObject(store, value), " returned for query field ").concat(field.name.value)) : (0,globals/* invariant */.kG)(!isReference(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                hasOwn.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,globals/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,globals/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && argumentsObjectFromField(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && hasOwn.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new DeepMerger;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,arrays/* isArray */.k)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,arrays/* isArray */.k)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,arrays/* isArray */.k)(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/policies.js







getStoreKeyName.setStringify(canonicalStringify);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? argumentsObjectFromField(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if ((0,arrays/* isArray */.k)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                (0,arrays/* isArray */.k)(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            (0,arrays/* isArray */.k)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,globals/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,globals/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && globals/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,arrays/* isArray */.k)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === fieldNameFromStoreName(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: isReference,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && globals/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,arrays/* isArray */.k)(existing) || (0,arrays/* isArray */.k)(incoming)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Cannot automatically merge arrays") : new globals/* InvariantError */.ej(4);
        }
        if ((0,objects/* isNonNullObject */.s)(existing) &&
            (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) &&
                storeValueIsStoreObject(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) &&
                isReference(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/writeToStore.js









;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = getOperationDefinition(query);
        var merger = makeProcessedFieldsMerger();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getDefaultValues(operationDefinition)), variables);
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: canonicalStringify(variables) }, extractFragmentContext(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!isReference(ref)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new globals/* InvariantError */.ej(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if (isReference(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = resultKeyNameFromField(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    (isReference(incomingValue) ||
                        storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && globals/* invariant.error */.kG.error("Missing field '".concat(resultKeyNameFromField(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = makeReference(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? cloneDeep(value) : value;
        }
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = getTypenameFromResult(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new Trie(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!shouldInclude(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = argumentsObjectFromField(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if (storeUtils_isField(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !isReference(incoming)) {
            var e_1 = (!(0,arrays/* isArray */.k)(incoming) &&
                (isReference(existing) || storeValueIsStoreObject(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return (0,arrays/* isArray */.k)(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = ((0,arrays/* isArray */.k)(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if (isReference(existing))
        return;
    if ((0,equality_esm/* equal */.D)(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0,arrays/* isArray */.k)(existing) &&
        !(0,arrays/* isArray */.k)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && globals/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = bundle_esm_wrap(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, canonicalStringify({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        canonicalStringify.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            forgetCache(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !(0,equality_esm/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map
// EXTERNAL MODULE: ../../node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(96279);
var browser_ponyfill_default = /*#__PURE__*/__webpack_require__.n(browser_ponyfill);
;// CONCATENATED MODULE: ./src/graphql/clients.ts


var NEXT_PUBLIC_ZAPIER_ORIGIN = "https://zapier-staging.com";
if (!NEXT_PUBLIC_ZAPIER_ORIGIN) {
    throw new Error("NEXT_PUBLIC_ZAPIER_ORIGIN not set");
}
var ZAPIER_GRAPHQL_URL = "".concat(NEXT_PUBLIC_ZAPIER_ORIGIN, "/api/graphql/v2");
var ZapierLink = new HttpLink({
    uri: ZAPIER_GRAPHQL_URL,
    credentials: "include",
    fetch: (browser_ponyfill_default())
});
var ZapierClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: ZapierLink,
    name: "pagebuilder"
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/display.js
/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var display = {
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
};
//# sourceMappingURL=display.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var CHROME_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var CHROME_EVAL_RE = /\((\S*)(?::(\d+))(?::(\d+))\)/;
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/utils.js

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
var ONE_KILO_BYTE = 1024;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
function utils_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
function shallowClone(object) {
    return utils_assign({}, object);
}
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
/**
 * Custom implementation of JSON.stringify that ignores value.toJSON.
 * We need to do that because some sites badly override toJSON on certain objects.
 * Note this still supposes that JSON.stringify is correct...
 */
function jsonStringify(value, replacer, space) {
    if (value === null || value === undefined) {
        return JSON.stringify(value);
    }
    var originalToJSON = [false, undefined];
    if (hasToJSON(value)) {
        // We need to add a flag and not rely on the truthiness of value.toJSON
        // because it can be set but undefined and that's actually significant.
        originalToJSON = [true, value.toJSON];
        delete value.toJSON;
    }
    var originalProtoToJSON = [false, undefined];
    var prototype;
    if (typeof value === 'object') {
        prototype = Object.getPrototypeOf(value);
        if (hasToJSON(prototype)) {
            originalProtoToJSON = [true, prototype.toJSON];
            delete prototype.toJSON;
        }
    }
    var result;
    try {
        result = JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        result = '<error: unable to serialize object>';
    }
    finally {
        if (originalToJSON[0]) {
            ;
            value.toJSON = originalToJSON[1];
        }
        if (originalProtoToJSON[0]) {
            ;
            prototype.toJSON = originalProtoToJSON[1];
        }
    }
    return result;
}
function hasToJSON(value) {
    return typeof value === 'object' && value !== null && Object.prototype.hasOwnProperty.call(value, 'toJSON');
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength)
        return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(emitter, event, listener, options) {
    return addEventListeners(emitter, [event], listener, options);
}
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = monitor(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    events.forEach(function (event) { return emitter.addEventListener(event, wrappedListener, options); });
    var stop = function () { return events.forEach(function (event) { return emitter.removeEventListener(event, wrappedListener, options); }); };
    return {
        stop: stop,
    };
}
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        addEventListener(window, eventName, callback, { once: true });
    }
}
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function requestIdleCallback(callback, opts) {
    // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
    // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
    // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
    // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
    // efficiently.
    if (window.requestIdleCallback) {
        var id_1 = window.requestIdleCallback(monitor(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(monitor(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
function removeDuplicates(array) {
    var deduplicated = [];
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    set.forEach(function (item) { return deduplicated.push(item); });
    return deduplicated;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/error.js



var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function formatUnknownError(stackTrace, errorObject, nonErrorPrefix, handlingStack) {
    if (!stackTrace || (stackTrace.message === undefined && !(errorObject instanceof Error))) {
        return {
            message: "".concat(nonErrorPrefix, " ").concat(jsonStringify(errorObject)),
            stack: 'No stack, consider using an instance of Error',
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
    };
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No internal monitoring should encapsulate the function, that is why we need to use callMonitored inside of it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            noop();
        }
    }
    callMonitored(function () {
        var stackTrace = computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable_Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new observable_Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/timeUtils.js

function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = Date.now() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return Math.round(correctedOrigin + relativeTime);
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(Date.now() - (getNavigationStart() + performance.now()));
}
function toServerDuration(duration) {
    if (!isNumber(duration)) {
        return duration;
    }
    return round(duration * 1e6, 0);
}
function timeStampNow() {
    return Date.now();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(getNavigationStart() + relativeTime);
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/configuration/experimentalFeatures.js
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */
var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures = new Set();
}
//# sourceMappingURL=experimentalFeatures.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/internalMonitoring/internalMonitoring.js







var monitoringConfiguration = { maxMessagesPerPage: 0, sentMessageCount: 0, telemetryEnabled: false };
var onInternalMonitoringMessageCollected;
function startInternalMonitoring(configuration) {
    var externalContextProvider;
    var telemetryContextProvider;
    var monitoringMessageObservable = new observable_Observable();
    var telemetryEventObservable = new observable_Observable();
    monitoringConfiguration.telemetryEnabled = performDraw(configuration.telemetrySampleRate);
    onInternalMonitoringMessageCollected = function (message) {
        monitoringMessageObservable.notify(withContext(message));
        if (isExperimentalFeatureEnabled('telemetry') && monitoringConfiguration.telemetryEnabled) {
            telemetryEventObservable.notify(toTelemetryEvent(message));
        }
    };
    utils_assign(monitoringConfiguration, {
        maxMessagesPerPage: configuration.maxInternalMonitoringMessagesPerPage,
        sentMessageCount: 0,
    });
    function withContext(message) {
        return combine({ date: timeStampNow() }, externalContextProvider !== undefined ? externalContextProvider() : {}, message);
    }
    function toTelemetryEvent(message) {
        return combine({
            type: 'telemetry',
            date: timeStampNow(),
            service: 'browser-sdk',
            version: "4.8.1",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: message, // https://github.com/microsoft/TypeScript/issues/48457
        }, telemetryContextProvider !== undefined ? telemetryContextProvider() : {});
    }
    return {
        setExternalContextProvider: function (provider) {
            externalContextProvider = provider;
        },
        monitoringMessageObservable: monitoringMessageObservable,
        setTelemetryContextProvider: function (provider) {
            telemetryContextProvider = provider;
        },
        telemetryEventObservable: telemetryEventObservable,
    };
}
function startFakeInternalMonitoring() {
    var messages = [];
    assign(monitoringConfiguration, {
        maxMessagesPerPage: Infinity,
        sentMessageCount: 0,
    });
    onInternalMonitoringMessageCollected = function (message) {
        messages.push(message);
    };
    return messages;
}
function resetInternalMonitoring() {
    onInternalMonitoringMessageCollected = undefined;
    monitoringConfiguration.debugMode = undefined;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onInternalMonitoringMessageCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        logErrorIfDebug(e);
        try {
            addMonitoringError(e);
        }
        catch (e) {
            logErrorIfDebug(e);
        }
    }
}
function addMonitoringMessage(message, context) {
    logMessageIfDebug(message, context);
    addToMonitoring(utils_assign({
        message: message,
        status: "debug" /* debug */,
    }, context));
}
function addMonitoringError(e) {
    addToMonitoring(utils_assign({
        status: "error" /* error */,
    }, formatError(e)));
}
function addToMonitoring(message) {
    if (onInternalMonitoringMessageCollected &&
        monitoringConfiguration.sentMessageCount < monitoringConfiguration.maxMessagesPerPage) {
        monitoringConfiguration.sentMessageCount += 1;
        onInternalMonitoringMessageCollected(message);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(stackTrace),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat(jsonStringify(e)),
    };
}
function setDebugMode(debugMode) {
    monitoringConfiguration.debugMode = debugMode;
}
function logErrorIfDebug(e) {
    if (monitoringConfiguration.debugMode) {
        display.error('[INTERNAL ERROR]', e);
    }
}
function logMessageIfDebug(message, context) {
    if (monitoringConfiguration.debugMode) {
        display.log('[MONITORING MESSAGE]', message, context);
    }
}
//# sourceMappingURL=internalMonitoring.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/boot/init.js



function makePublicApi(stub) {
    var publicApi = utils_assign({
        version: "4.8.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/contextManager.js
function createContextManager() {
    var context = {};
    return {
        get: function () { return context; },
        add: function (key, value) {
            context[key] = value;
        },
        remove: function (key) {
            delete context[key];
        },
        set: function (newContext) {
            context = newContext;
        },
    };
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js

function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(hostname) {
    var _a;
    if (hostname === void 0) { hostname = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge.getAllowedWebViewHosts().some(function (host) {
            var escapedHost = host.replace(/\./g, '\\.');
            var isDomainOrSubDomain = new RegExp("^(.+\\.)*".concat(escapedHost, "$"));
            return isDomainOrSubDomain.test(hostname);
        }));
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/browser/cookie.js


var COOKIE_ACCESS_DELAY = ONE_SECOND;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(generateUUID());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_SECOND, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/urlPolyfill.js

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js



var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
var INTAKE_SITE_US = 'datadoghq.com';
function createEndpointBuilder(initConfiguration, endpointType, tags, source) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US : _a, clientToken = initConfiguration.clientToken;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var host = "".concat(ENDPOINTS[endpointType], ".browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
    var baseUrl = "https://".concat(host, "/api/v2/").concat(INTAKE_TRACKS[endpointType]);
    var proxyUrl = initConfiguration.proxyUrl && normalizeUrl(initConfiguration.proxyUrl);
    return {
        build: function () {
            var parameters = "ddsource=".concat(source || 'browser') +
                "&ddtags=".concat(encodeURIComponent(["sdk_version:".concat("4.8.1")].concat(tags).join(','))) +
                "&dd-api-key=".concat(clientToken) +
                "&dd-evp-origin-version=".concat(encodeURIComponent("4.8.1")) +
                '&dd-evp-origin=browser' +
                "&dd-request-id=".concat(generateUUID());
            if (endpointType === 'rum') {
                parameters += "&batch_time=".concat(timeStampNow());
            }
            var endpointUrl = "".concat(baseUrl, "?").concat(parameters);
            return proxyUrl ? "".concat(proxyUrl, "?ddforward=").concat(encodeURIComponent(endpointUrl)) : endpointUrl;
        },
        buildIntakeUrl: function () {
            return proxyUrl ? "".concat(proxyUrl, "?ddforward") : baseUrl;
        },
    };
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js



function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeEndpoints = objectValues(endpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags);
    return utils_assign({
        isIntakeUrl: function (url) { return intakeEndpoints.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    var endpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
    if (initConfiguration.internalMonitoringApiKey) {
        return utils_assign(endpointBuilders, {
            internalMonitoringEndpointBuilder: createEndpointBuilder(utils_assign({}, initConfiguration, { clientToken: initConfiguration.internalMonitoringApiKey }), 'logs', tags, 'browser-agent-internal-monitoring'),
        });
    }
    return endpointBuilders;
}
function computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = utils_assign({}, initConfiguration, {
        site: INTAKE_SITE_US,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
        internalMonitoringEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags, 'browser-agent-internal-monitoring'),
    };
    intakeEndpoints.push.apply(intakeEndpoints, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); }));
    return utils_assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js






var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sampleRate !== undefined && !isPercentage(initConfiguration.sampleRate)) {
        display.error('Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
        display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    updateExperimentalFeatures(initConfiguration.enableExperimentalFeatures);
    return utils_assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sampleRate: (_a = initConfiguration.sampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * ONE_KILO_BYTE,
        eventRateLimiterThreshold: 3000,
        maxInternalMonitoringMessagesPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * ONE_SECOND,
        /**
         * Logs intake limit
         */
        maxBatchSize: 50,
        maxMessageSize: 256 * ONE_KILO_BYTE,
    }, computeTransportConfiguration(initConfiguration));
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/syntheticsContext.js

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function getSyntheticsContext() {
    var testId = window._DATADOG_SYNTHETICS_PUBLIC_ID || getCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
    var resultId = window._DATADOG_SYNTHETICS_RESULT_ID || getCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    if (typeof testId === 'string' && typeof resultId === 'string') {
        return {
            test_id: testId,
            result_id: resultId,
            injected: willSyntheticsInjectRum(),
        };
    }
}
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/configuration.js

function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.replaySampleRate !== undefined && !isPercentage(initConfiguration.replaySampleRate)) {
        display.error('Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display.error('Service need to be configured when tracing is enabled');
            return;
        }
    }
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    return utils_assign({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        replaySampleRate: (_a = initConfiguration.replaySampleRate) !== null && _a !== void 0 ? _a : 100,
        allowedTracingOrigins: (_b = initConfiguration.allowedTracingOrigins) !== null && _b !== void 0 ? _b : [],
        trackInteractions: !!initConfiguration.trackInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : DefaultPrivacyLevel.MASK_USER_INPUT,
    }, baseConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager();
    var user = {};
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var bufferApiCalls = new BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = timeStampNow(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = clocksNow(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    function clonedCommonContext() {
        return deepClone({
            context: globalContextManager.get(),
            user: user,
        });
    }
    function initRum(initConfiguration) {
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
            return;
        }
        if (canUseEventBridge()) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        else if (!canHandleSession(initConfiguration)) {
            return;
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new BoundedBuffer();
            startViewStrategy = function (options) {
                doStartRum(configuration, options);
            };
            beforeInitCalls.drain();
        }
        getInitConfigurationStrategy = function () { return deepClone(initConfiguration); };
        isAlreadyInitialized = true;
    }
    function doStartRum(configuration, initialViewOptions) {
        var startRumResults = startRumImpl(configuration, function () { return ({
            user: user,
            context: globalContextManager.get(),
            hasReplay: recorderApi.isRecording() ? true : undefined,
        }); }, recorderApi, initialViewOptions);
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, getInternalContextStrategy = startRumResults.getInternalContext);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = monitor(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = makePublicApi({
        init: monitor(initRum),
        addRumGlobalContext: monitor(globalContextManager.add),
        removeRumGlobalContext: monitor(globalContextManager.remove),
        getRumGlobalContext: monitor(globalContextManager.get),
        setRumGlobalContext: monitor(globalContextManager.set),
        getInternalContext: monitor(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: monitor(function () { return getInitConfigurationStrategy(); }),
        addAction: monitor(function (name, context) {
            addActionStrategy({
                name: name,
                context: deepClone(context),
                startClocks: clocksNow(),
                type: "custom" /* CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: deepClone(context),
                    startClocks: clocksNow(),
                });
            });
        },
        addTiming: monitor(function (name, time) {
            addTimingStrategy(name, time);
        }),
        setUser: monitor(function (newUser) {
            var sanitizedUser = sanitizeUser(newUser);
            if (sanitizedUser) {
                user = sanitizedUser;
            }
            else {
                display.error('Unsupported user:', newUser);
            }
        }),
        removeUser: monitor(function () {
            user = {};
        }),
        startView: startView,
        startSessionReplayRecording: monitor(recorderApi.start),
        stopSessionReplayRecording: monitor(recorderApi.stop),
    });
    return rumPublicApi;
    function sanitizeUser(newUser) {
        if (typeof newUser !== 'object' || !newUser) {
            return;
        }
        var result = deepClone(newUser);
        if ('id' in result) {
            result.id = String(result.id);
        }
        if ('name' in result) {
            result.name = String(result.name);
        }
        if ('email' in result) {
            result.email = String(result.email);
        }
        return result;
    }
    function canHandleSession(initConfiguration) {
        if (!areCookiesAuthorized(buildCookieOptions(initConfiguration))) {
            display.warn('Cookies are not authorized, we will not send any data.');
            return false;
        }
        if (isLocalFile()) {
            display.error('Execution is not allowed in the current context.');
            return false;
        }
        return true;
    }
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return utils_assign({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sampleRate: 100,
        });
    }
    function isLocalFile() {
        return window.location.protocol === 'file:';
    }
}
//# sourceMappingURL=rumPublicApi.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/transport/batch.js



// https://en.wikipedia.org/wiki/UTF-8
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
var Batch = /** @class */ (function () {
    function Batch(request, maxSize, bytesLimit, maxMessageSize, flushTimeout, beforeUnloadCallback) {
        if (beforeUnloadCallback === void 0) { beforeUnloadCallback = noop; }
        this.request = request;
        this.maxSize = maxSize;
        this.bytesLimit = bytesLimit;
        this.maxMessageSize = maxMessageSize;
        this.flushTimeout = flushTimeout;
        this.beforeUnloadCallback = beforeUnloadCallback;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesSize = 0;
        this.bufferMessageCount = 0;
        this.flushOnVisibilityHidden();
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (reason) {
        if (this.bufferMessageCount !== 0) {
            var messages = this.pushOnlyBuffer.concat(objectValues(this.upsertBuffer));
            this.request.send(messages.join('\n'), this.bufferBytesSize, reason);
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesSize = 0;
            this.bufferMessageCount = 0;
        }
    };
    Batch.prototype.sizeInBytes = function (candidate) {
        // Accurate byte size computations can degrade performances when there is a lot of events to process
        if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
            return candidate.length;
        }
        if (window.TextEncoder !== undefined) {
            return new TextEncoder().encode(candidate).length;
        }
        return new Blob([candidate]).size;
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesSize = _a.messageBytesSize;
        if (messageBytesSize >= this.maxMessageSize) {
            display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.maxMessageSize, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesSize)) {
            this.flush('willReachedBytesLimitWith');
        }
        this.push(processedMessage, messageBytesSize, key);
        if (this.isFull()) {
            this.flush('isFull');
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = jsonStringify(message);
        var messageBytesSize = this.sizeInBytes(processedMessage);
        return { processedMessage: processedMessage, messageBytesSize: messageBytesSize };
    };
    Batch.prototype.push = function (processedMessage, messageBytesSize, key) {
        if (this.bufferMessageCount > 0) {
            // \n separator at serialization
            this.bufferBytesSize += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesSize += messageBytesSize;
        this.bufferMessageCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesSize = this.sizeInBytes(removedMessage);
        this.bufferBytesSize -= messageBytesSize;
        this.bufferMessageCount -= 1;
        if (this.bufferMessageCount > 0) {
            this.bufferBytesSize -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesSize) {
        // byte of the separator at the end of the message
        return this.bufferBytesSize + messageBytesSize + 1 >= this.bytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessageCount === this.maxSize || this.bufferBytesSize >= this.bytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout(monitor(function () {
            _this.flush('flushPeriodically');
            _this.flushPeriodically();
        }), this.flushTimeout);
    };
    Batch.prototype.flushOnVisibilityHidden = function () {
        var _this = this;
        /**
         * With sendBeacon, requests are guaranteed to be successfully sent during document unload
         */
        // @ts-ignore this function is not always defined
        if (navigator.sendBeacon) {
            /**
             * beforeunload is called before visibilitychange
             * register first to be sure to be called before flush on beforeunload
             * caveat: unload can still be canceled by another listener
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, this.beforeUnloadCallback);
            /**
             * Only event that guarantee to fire on mobile devices when the page transitions to background state
             * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
             */
            addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
                if (document.visibilityState === 'hidden') {
                    _this.flush("visibilitychange" /* VISIBILITY_CHANGE */);
                }
            });
            /**
             * Safari does not support yet to send a request during:
             * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
             * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, function () { return _this.flush("beforeunload" /* BEFORE_UNLOAD */); });
        }
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js

var hasReportedXhrError = false;
/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(endpointBuilder, bytesLimit) {
        this.endpointBuilder = endpointBuilder;
        this.bytesLimit = bytesLimit;
    }
    HttpRequest.prototype.send = function (data, size, flushReason) {
        var url = this.endpointBuilder.build();
        var tryBeacon = !!navigator.sendBeacon && size < this.bytesLimit;
        if (tryBeacon) {
            try {
                var isQueued = navigator.sendBeacon(url, data);
                if (isQueued) {
                    return;
                }
            }
            catch (e) {
                reportBeaconError(e);
            }
        }
        var transportIntrospection = function (event) {
            var req = event === null || event === void 0 ? void 0 : event.currentTarget;
            if (req.status >= 200 && req.status < 300) {
                return;
            }
            if (!hasReportedXhrError) {
                hasReportedXhrError = true;
                addMonitoringMessage('XHR fallback failed', {
                    on_line: navigator.onLine,
                    size: size,
                    url: url,
                    try_beacon: tryBeacon,
                    flush_reason: flushReason,
                    event: {
                        is_trusted: event.isTrusted,
                        total: event.total,
                        loaded: event.loaded,
                    },
                    request: {
                        status: req.status,
                        ready_state: req.readyState,
                        response_text: req.responseText.slice(0, 512),
                    },
                });
            }
        };
        var request = new XMLHttpRequest();
        request.addEventListener('loadend', monitor(function (event) { return transportIntrospection(event); }));
        request.open('POST', url, true);
        request.send(data);
    };
    return HttpRequest;
}());

var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addMonitoringError(e);
    }
}
//# sourceMappingURL=httpRequest.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js

function startBatchWithReplica(configuration, endpoint, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    return {
        add: function (message) {
            primaryBatch.add(message);
            if (replicaBatch) {
                replicaBatch.add(message);
            }
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new observable_Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(monitor(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we are using the Zone __symbol__ API to get the original, unpatched
    // MutationObserver constructor.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        var symbol = browserWindow.Zone.__symbol__('MutationObserver');
        constructor = browserWindow[symbol];
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* IMAGE */,
        function (initiatorType, path) {
            return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* MEDIA */,
        function (initiatorType, path) {
            return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!isValidUrl(url)) {
        addMonitoringMessage("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* OTHER */;
    }
    var path = getPathName(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return toServerDuration(elapsed(startTime, responseEnd));
    }
    return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return utils_assign({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: toServerDuration(elapsed(start, end)),
        start: toServerDuration(elapsed(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= Date.now() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
function isCommentNode(node) {
    return node.nodeName === '#comment';
}
function isTextNode(node) {
    return node.nodeName === '#text';
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function supportPerformanceEntry() {
    // Safari 10 doesn't support PerformanceEntry
    return typeof PerformanceEntry === 'function';
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        setTimeout(monitor(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); }));
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = monitor(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            performance.addEventListener('resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    runOnReadyState('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = utils_assign(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = utils_assign(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback(utils_assign(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    runOnReadyState('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        setTimeout(monitor(sendFakeTiming));
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = Date.now();
    var timingSent = false;
    var removeEventListeners = addEventListeners(window, ["click" /* CLICK */, "mousedown" /* MOUSE_DOWN */, "keydown" /* KEY_DOWN */, "touchstart" /* TOUCH_START */, "pointerdown" /* POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: relativeNow(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        addEventListeners(window, ["pointerup" /* POINTER_UP */, "pointercancel" /* POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < Date.now() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (isNumber(timing[key])) {
            var numberKey = key;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/createEventRateLimiter.js

function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                setTimeout(function () {
                    eventCount = 0;
                }, ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: ErrorSource.AGENT,
                        startClocks: clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = deepClone(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = getType(originalValue);
        var newType = getType(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && field in object;
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/assembly.js



var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [
    // Fields with sensitive data
    'view.url',
    'view.referrer',
    'action.target.name',
    'error.message',
    'error.stack',
    'error.resource.url',
    'resource.url',
];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([
    // User-customizable field
    'context',
]);
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext) {
    var _a;
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var eventRateLimiters = (_a = {},
        _a["error" /* ERROR */] = createEventRateLimiter("error" /* ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _a["action" /* ACTION */] = createEventRateLimiter("action" /* ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _a);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        // allow to send events if the session was tracked when they start
        // except for views which are continuously updated
        // TODO: stop sending view updates when session is expired
        var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view" /* VIEW */ ? startTime : undefined);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: currentDrift(),
                    session: {
                        plan: session.hasReplayPlan ? 2 /* REPLAY */ : 1 /* LITE */,
                    },
                    browser_sdk_version: canUseEventBridge() ? "4.8.1" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: timeStampNow(),
                service: configuration.service,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SYNTHETICS */ : ciTestContext ? "ci_test" /* CI_TEST */ : "user" /* USER */,
                },
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
            };
            var actionId = actionContexts.findActionId(startTime);
            if (!isExperimentalFeatureEnabled('sub-apps')) {
                delete viewContext.service;
                delete viewContext.version;
            }
            else {
                rumContext.version = configuration.version;
            }
            var serverRumEvent = (needToAssembleWithAction(rawRumEvent) && actionId
                ? combine(rumContext, urlContext, viewContext, { action: { id: actionId } }, rawRumEvent)
                : combine(rumContext, urlContext, viewContext, rawRumEvent));
            serverRumEvent.context = combine(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!isEmptyObject(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (isEmptyObject(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, event.type === "view" /* VIEW */ ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) { return beforeSend(event, domainContext); });
        if (result === false && event.type !== "view" /* VIEW */) {
            return false;
        }
        if (result === false) {
            display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* ERROR */, "resource" /* RESOURCE */, "long_task" /* LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/foregroundContexts.js

// Arbitrary value to cap number of element mostly for backend & to save bandwidth
var MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
var MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
function trackFocus(onFocusChange) {
    return addEventListener(window, "focus" /* FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return addEventListener(window, "blur" /* BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var eventEndTime = (eventStartTime + duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = elapsed(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = elapsed(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: toServerDuration(startDuration),
            duration: toServerDuration(endDuration),
        });
    }
    return filteredForegroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/internalContext.js

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: utils_assign({}, viewContext.view, urlContext.view),
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());

//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/browserDetection.js
function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/session/sessionCookieStore.js





var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
var LOCK_RETRY_DELAY = 10;
var MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = generateUUID();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return isChromium();
}
function retryLater(operations, currentNumberOfRetries) {
    setTimeout(monitor(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }), LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String(Date.now() + SESSION_EXPIRATION_DELAY);
    setSession(session, options);
}
function setSession(session, options) {
    setCookie(SESSION_COOKIE_NAME, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
}
function toSessionString(session) {
    return objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function retrieveSession() {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return isEmptyObject(session);
}
function clearSession(options) {
    setCookie(SESSION_COOKIE_NAME, '', 0, options);
}
//# sourceMappingURL=sessionCookieStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js





var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new observable_Observable();
    var expireObservable = new observable_Observable();
    var watchSessionTimeoutId = setInterval(monitor(watchSession), COOKIE_ACCESS_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = generateUUID();
            cookieSession.created = String(Date.now());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || Date.now() - Number(session.created) < SESSION_TIME_OUT_DELAY) &&
            (session.expire === undefined || Date.now() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: throttle(monitor(expandOrRenewSession), COOKIE_ACCESS_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/contextHistory.js


var END_OF_TIMES = Infinity;
var CLEAR_OLD_CONTEXTS_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.entries = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    /**
     * Add a context to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ContextHistory.prototype.add = function (context, startTime) {
        var _this = this;
        var entry = {
            context: context,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest context that was active during `startTime`, or the currently active context
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.context;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active context, if any. This method assumes that entries
     * are not overlapping.
     */
    ContextHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all contexts that were active during `startTime`, or all currently active contexts if no
     * `startTime` is provided.
     */
    ContextHistory.prototype.findAll = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        return this.entries
            .filter(function (entry) { return entry.startTime <= startTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.context; });
    };
    /**
     * Remove all entries from this collection.
     */
    ContextHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = relativeNow() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ContextHistory;
}());

//# sourceMappingURL=contextHistory.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new ContextHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            view: {
                id: view.id,
                name: view.name,
            },
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js


function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                callMonitored(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                callMonitored(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        setTimeout(monitor(function () {
            after(thisObject, value);
        }), 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = noop;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new observable_Observable(function () {
        var stopInstrumentingStart = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: normalizeUrl(url.toString()),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = relativeNow();
    startContext.startClocks = clocksNow();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethodAndCallOriginal(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = monitor(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
        completeContext.status = _this.status;
        observable.notify(shallowClone(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new observable_Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = callMonitored(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    callMonitored(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = normalizeUrl((typeof input === 'object' && input.url) || input);
    var startClocks = clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'complete';
        context.duration = elapsed(context.startClocks.timeStamp, timeStampNow());
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
            observable.notify(context);
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
            observable.notify(context);
        }
    };
    responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the the
 * request did not reach the server, but we the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course it might not be the case every time, but it should limit having incomplete traces a
 * bit..
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = shallowClone(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !isAllowedUrl(configuration, context.url) || !sessionManager.findTrackedSession()) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    inject(makeTracingHeaders(context.traceId, context.spanId));
}
function isAllowedUrl(configuration, requestUrl) {
    var requestOrigin = getOrigin(requestUrl);
    for (var _i = 0, _a = configuration.allowedTracingOrigins; _i < _a.length; _i++) {
        var allowedOrigin = _a[_i];
        if (requestOrigin === allowedOrigin || (allowedOrigin instanceof RegExp && allowedOrigin.test(requestOrigin))) {
            return true;
        }
    }
    return false;
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
function makeTracingHeaders(traceId, spanId) {
    return {
        'x-datadog-origin': 'rum',
        'x-datadog-parent-id': spanId.toDecimalString(),
        'x-datadog-sampled': '1',
        'x-datadog-sampling-priority': '1',
        'x-datadog-trace-id': traceId.toDecimalString(),
    };
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = initXhrObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    type: "xhr" /* XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = initFetchObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    responseType: context.responseType,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    type: "fetch" /* FETCH */,
                    url: context.url,
                    response: context.response,
                    init: context.init,
                    input: context.input,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (_a) {
        var type = _a.type;
        switch (type) {
            case "error" /* ERROR */:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case "action" /* ACTION */:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case "long_task" /* LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case "resource" /* RESOURCE */:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/waitIdlePage.js

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the next idle page time
 *
 * Detection lifecycle:
 * ```
 *                           Wait idle page
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitIdlePage(lifeCycle, domMutationObservable, idlePageCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable);
    return doWaitIdlePage(pageActivityObservable, idlePageCallback, maxDuration);
}
function doWaitIdlePage(pageActivityObservable, idlePageCallback, maxDuration) {
    var idleTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration &&
        setTimeout(monitor(function () { return complete({ hadActivity: true, end: timeStampNow() }); }), maxDuration);
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        var lastChangeTime = timeStampNow();
        if (!isBusy) {
            idleTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        idlePageCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable) {
    var observable = new observable_Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(function () { return notifyPageActivity(pendingRequestsCount); }), lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (_a) {
                var entryType = _a.entryType;
                return entryType === 'resource';
            })) {
                notifyPageActivity(pendingRequestsCount);
            }
        }), lifeCycle.subscribe(5 /* REQUEST_STARTED */, function (startEvent) {
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            notifyPageActivity(++pendingRequestsCount);
        }), lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
            // If the request started before the tracking start, ignore it
            if (firstRequestIndex === undefined || request.requestIndex < firstRequestIndex) {
                return;
            }
            notifyPageActivity(--pendingRequestsCount);
        }));
        return function () { return subscriptions.forEach(function (s) { return s.unsubscribe(); }); };
    });
    function notifyPageActivity(pendingRequestsCount) {
        observable.notify({ isBusy: pendingRequestsCount > 0 });
    }
    return observable;
}
//# sourceMappingURL=waitIdlePage.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument && element.ownerDocument.querySelector("label[for=\"".concat(element.id.replace('"', '\\"'), "\"]"));
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/trackActions.js




// Maximum duration for automatic actions
var AUTO_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackActions(lifeCycle, domMutationObservable, _a) {
    var actionNameAttribute = _a.actionNameAttribute;
    var history = new ContextHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        history.reset();
    });
    var stopListener = listenEvents(function (event) {
        if (!isExperimentalFeatureEnabled('frustration-signals') && history.find()) {
            // Ignore any new action if another one is already occurring.
            return;
        }
        var name = getActionNameFromElement(event.target, actionNameAttribute);
        if (!name) {
            return;
        }
        var actionController = newAction(lifeCycle, domMutationObservable, "click" /* CLICK */, name, event, function (endTime) {
            historyEntry.close(getRelativeTime(endTime));
        }, function () {
            historyEntry.remove();
        });
        var historyEntry = history.add(actionController, actionController.startClocks.relative);
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            var _a;
            return isExperimentalFeatureEnabled('frustration-signals')
                ? history.findAll(startTime).map(function (controller) { return controller.id; })
                : (_a = history.find(startTime)) === null || _a === void 0 ? void 0 : _a.id;
        },
    };
    return {
        stop: function () {
            history.findAll().forEach(function (actionController) { return actionController.discard(); });
            stopListener();
        },
        actionContexts: actionContexts,
    };
}
function listenEvents(callback) {
    return addEventListener(window, "click" /* CLICK */, function (event) {
        if (event.target instanceof Element) {
            callback(event);
        }
    }, { capture: true });
}
function newAction(lifeCycle, domMutationObservable, type, name, event, onCompleteCallback, onDiscardCallback) {
    var id = generateUUID();
    var startClocks = clocksNow();
    var eventCountsSubscription = trackEventCounts(lifeCycle);
    var stopWaitingIdlePage = waitIdlePage(lifeCycle, domMutationObservable, function (idleEvent) {
        if (idleEvent.hadActivity && startClocks.timeStamp <= idleEvent.end) {
            complete(idleEvent.end);
        }
        else {
            discard();
        }
    }, AUTO_ACTION_MAX_DURATION).stop;
    var viewCreatedSubscription;
    if (!isExperimentalFeatureEnabled('frustration-signals')) {
        // New views trigger the discard of the current pending Action
        viewCreatedSubscription = lifeCycle.subscribe(2 /* VIEW_CREATED */, discard);
    }
    function complete(endTime) {
        cleanup();
        var eventCounts = eventCountsSubscription.eventCounts;
        lifeCycle.notify(1 /* AUTO_ACTION_COMPLETED */, {
            counts: {
                errorCount: eventCounts.errorCount,
                longTaskCount: eventCounts.longTaskCount,
                resourceCount: eventCounts.resourceCount,
            },
            duration: elapsed(startClocks.timeStamp, endTime),
            id: id,
            name: name,
            startClocks: startClocks,
            type: type,
            event: event,
        });
        onCompleteCallback(endTime);
    }
    function discard() {
        cleanup();
        onDiscardCallback();
    }
    function cleanup() {
        stopWaitingIdlePage();
        eventCountsSubscription.stop();
        if (viewCreatedSubscription) {
            viewCreatedSubscription.unsubscribe();
        }
    }
    return {
        discard: discard,
        id: id,
        startClocks: startClocks,
    };
}
//# sourceMappingURL=trackActions.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(1 /* AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    var actionContexts = { findActionId: noop };
    if (configuration.trackInteractions) {
        actionContexts = trackActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, utils_assign({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                error: {
                    count: action.counts.errorCount,
                },
                id: action.id,
                loading_time: toServerDuration(action.duration),
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = combine({
        action: {
            id: generateUUID(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/tracekit/tracekit.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return instrumentMethodAndCallOriginal(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = computeStackTrace(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return instrumentMethodAndCallOriginal(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = computeStackTrace(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js



function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, errorObject) {
        var _a = formatUnknownError(stackTrace, errorObject, 'Uncaught'), stack = _a.stack, message = _a.message, type = _a.type;
        errorObservable.notify({
            message: message,
            stack: stack,
            type: type,
            source: ErrorSource.SOURCE,
            startClocks: clocksNow(),
            originalError: errorObject,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js





var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return mergeObservables.apply(void 0, consoleObservables);
}
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new observable_Observable(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    if (api === ConsoleApiName.error) {
        var firstErrorParam = find(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return formatErrorMessage(computeStackTrace(param));
    }
    return jsonStringify(param, undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: consoleError.message,
            stack: consoleError.stack,
            source: ErrorSource.CONSOLE,
            handling: "handled" /* HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js




var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if (includes(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new observable_Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new observable_Observable(function () {
        var handleCspViolation = monitor(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = addEventListener(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\""), event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackReportError.js

function trackReportError(errorObservable) {
    var subscription = initReportObservable([RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: ErrorSource.REPORT,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/errorCollection.js



function startErrorCollection(lifeCycle, foregroundContexts) {
    var errorObservable = new observable_Observable();
    trackConsoleError(errorObservable);
    trackRuntimeError(errorObservable);
    trackReportError(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts);
}
function doStartErrorCollection(lifeCycle, foregroundContexts) {
    lifeCycle.subscribe(12 /* RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, utils_assign({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var rawError = computeRawError(error, handlingStack, startClocks);
            lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function computeRawError(error, handlingStack, startClocks) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return utils_assign({
        startClocks: startClocks,
        source: ErrorSource.CUSTOM,
        originalError: error,
        handling: "handled" /* HANDLED */,
    }, formatUnknownError(stackTrace, error, 'Provided', handlingStack));
}
function processError(error, foregroundContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            source_type: 'browser',
        },
        type: "error" /* ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground !== undefined) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/longTask/longTaskCollection.js

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || session.hasLitePlan) {
                break;
            }
            var startClocks = relativeToClocks(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: generateUUID(),
                    duration: toServerDuration(entry.duration),
                },
                type: "long_task" /* LONG_TASK */,
            };
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/matchRequestTiming.js

/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 * - Browsers generate a timing entry for OPTIONS request
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - if two following timings match (OPTIONS request), return the timing for the actual request
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    if (candidates.length === 2 && firstCanBeOptionRequest(candidates)) {
        return candidates[1];
    }
    return;
}
function firstCanBeOptionRequest(correspondingEntries) {
    return endTime(correspondingEntries[0]) <= correspondingEntries[1].startTime;
}
function endTime(timing) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return (timing.startTime + timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return timing.startTime >= start - errorMargin && endTime(timing) <= end + errorMargin;
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceCollection.js




function startResourceCollection(lifeCycle) {
    lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processRequest(request));
    });
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !isRequestKind(entry)) {
                lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry));
            }
        }
    });
}
function processRequest(request) {
    var type = request.type === "xhr" /* XHR */ ? "xhr" /* XHR */ : "fetch" /* FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            duration: toServerDuration(request.duration),
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var tracingInfo = computeEntryTracingInfo(entry);
    var startClocks = relativeToClocks(entry.startTime);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, entryMetrics);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: utils_assign({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request) {
    var hasBeenTraced = request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
        },
    };
}
function computeEntryTracingInfo(entry) {
    return entry.traceId ? { _dd: { trace_id: entry.traceId } } : undefined;
}
function toPerformanceEntryRepresentation(entry) {
    if (supportPerformanceEntry() && entry instanceof PerformanceEntry) {
        entry.toJSON();
    }
    return entry;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackFirstHidden.js

var trackFirstHiddenSingleton;
var stopListeners;
function trackFirstHidden(emitter) {
    if (emitter === void 0) { emitter = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (stopListeners = addEventListeners(emitter, ["pagehide" /* PAGE_HIDE */, "visibilitychange" /* VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
function resetFirstHidden() {
    if (stopListeners) {
        stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackInitialViewTimings.js


// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackInitialViewTimings(lifeCycle, callback) {
    var timings = {};
    function setTimings(newTimings) {
        utils_assign(timings, newTimings);
        callback(timings);
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    return {
        stop: function () {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = find(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, emitter, callback) {
    var firstHidden = trackFirstHidden();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = addEventListeners(emitter, ["pointerdown" /* POINTER_DOWN */, "keydown" /* KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = findLast(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = find(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
//# sourceMappingURL=trackInitialViewTimings.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewMetrics.js




function trackViewMetrics(lifeCycle, domMutationObservable, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {
        eventCounts: {
            errorCount: 0,
            longTaskCount: 0,
            resourceCount: 0,
            userActionCount: 0,
        },
    };
    var stopEventCountsTracking = trackEventCounts(lifeCycle, function (newEventCounts) {
        viewMetrics.eventCounts = newEventCounts;
        scheduleViewUpdate();
    }).stop;
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = noop;
    }
    return {
        stop: function () {
            stopEventCountsTracking();
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitIdlePage(lifeCycle, domMutationObservable, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback(round(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= ONE_SECOND ||
                entry.startTime - startTime >= 5 * ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent('layout-shift');
}
//# sourceMappingURL=trackViewMetrics.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViews.js



var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var _a = trackInitialView(initialViewOptions), stopInitialViewTracking = _a.stop, initialView = _a.initialView;
    var currentView = initialView;
    var stopViewLifeCycle = startViewLifeCycle().stop;
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function trackInitialView(options) {
        var initialView = newView(lifeCycle, domMutationObservable, location, "initial_load" /* INITIAL_LOAD */, clocksOrigin(), options);
        var stop = trackInitialViewTimings(lifeCycle, function (timings) {
            initialView.updateTimings(timings);
            initialView.scheduleUpdate();
        }).stop;
        return { initialView: initialView, stop: stop };
    }
    function trackViewChange(startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, location, "route_change" /* ROUTE_CHANGE */, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
            // do not trigger view update to avoid wrong data
            currentView.end();
            // Renew view on session renewal
            currentView = trackViewChange(undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* BEFORE_UNLOAD */, function () {
            currentView.end();
            currentView.triggerUpdate();
        });
        // Session keep alive
        var keepAliveInterval = window.setInterval(monitor(function () {
            currentView.triggerUpdate();
        }), SESSION_KEEP_ALIVE_INTERVAL);
        return {
            stop: function () {
                clearInterval(keepAliveInterval);
            },
        };
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView.triggerUpdate();
                currentView = trackViewChange();
                return;
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = timeStampNow(); }
            currentView.addTiming(name, time);
            currentView.scheduleUpdate();
        },
        startView: function (options, startClocks) {
            currentView.end(startClocks);
            currentView.triggerUpdate();
            currentView = trackViewChange(startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            stopInitialViewTracking();
            stopViewLifeCycle();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = clocksNow(); }
    // Setup initial values
    var id = generateUUID();
    var timings = {};
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = shallowClone(initialLocation);
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* VIEW_CREATED */, { id: id, name: name, startClocks: startClocks, service: service, version: version });
    // Update the view every time the measures are changing
    var _a = throttle(monitor(triggerViewUpdate), THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackViewMetrics(lifeCycle, domMutationObservable, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
        lifeCycle.notify(3 /* VIEW_UPDATED */, utils_assign({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: elapsed(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        scheduleUpdate: scheduleViewUpdate,
        end: function (clocks) {
            if (clocks === void 0) { clocks = clocksNow(); }
            endClocks = clocks;
            stopViewMetricsTracking();
            lifeCycle.notify(4 /* VIEW_ENDED */, { endClocks: endClocks });
        },
        triggerUpdate: function () {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function (newTimings) {
            timings = newTimings;
            if (newTimings.loadEvent !== undefined) {
                setLoadEvent(newTimings.loadEvent);
            }
        },
        addTiming: function (name, time) {
            var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/viewCollection.js


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, recorderApi));
    });
    return trackViews(location, lifeCycle, domMutationObservable, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, foregroundContexts, recorderApi) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* VIEW */,
        view: {
            action: {
                count: view.eventCounts.userActionCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            dom_complete: toServerDuration(view.timings.domComplete),
            dom_content_loaded: toServerDuration(view.timings.domContentLoaded),
            dom_interactive: toServerDuration(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: toServerDuration(view.timings.firstContentfulPaint),
            first_input_delay: toServerDuration(view.timings.firstInputDelay),
            first_input_time: toServerDuration(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: toServerDuration(view.timings.largestContentfulPaint),
            load_event: toServerDuration(view.timings.loadEvent),
            loading_time: discardNegativeDuration(toServerDuration(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: toServerDuration(view.duration),
            in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration),
        },
        session: {
            has_replay: replayStats ? true : undefined,
        },
    };
    if (!isEmptyObject(view.customTimings)) {
        viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return isNumber(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js


var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var oldSessionId = getCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getCookie(OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        persistSession(session, options);
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js






var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(options, productKey, computeSessionState) {
    tryOldCookiesMigration(options);
    var sessionStore = startSessionStore(options, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), relativeNow());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive(relativeNow());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
    var stop = addEventListeners(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = monitor(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var rumSessionManager_RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = startSessionManager(configuration.cookieOptions, rumSessionManager_RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                hasReplayPlan: session.trackingType === "1" /* TRACKED_REPLAY */,
                hasLitePlan: session.trackingType === "2" /* TRACKED_LITE */,
            };
        },
    };
}
/**
 * Start a tracked replay session stub
 * It needs to be a replay plan in order to get long tasks
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        hasReplayPlan: true,
        hasLitePlan: false,
    };
    return {
        findTrackedSession: function () { return session; },
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!performDraw(configuration.sampleRate)) {
        trackingType = "0" /* NOT_TRACKED */;
    }
    else if (!performDraw(configuration.replaySampleRate)) {
        trackingType = "2" /* TRACKED_LITE */;
    }
    else {
        trackingType = "1" /* TRACKED_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* NOT_TRACKED */ ||
        trackingType === "1" /* TRACKED_REPLAY */ ||
        trackingType === "2" /* TRACKED_LITE */);
}
function isTypeTracked(rumSessionType) {
    return rumSessionType === "2" /* TRACKED_LITE */ || rumSessionType === "1" /* TRACKED_REPLAY */;
}
//# sourceMappingURL=rumSessionManager.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable) {
    var batch = makeRumBatch(configuration, lifeCycle);
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event); });
}
function makeRumBatch(configuration, lifeCycle) {
    var primaryBatch = createRumBatch(configuration.rumEndpointBuilder, function () {
        return lifeCycle.notify(9 /* BEFORE_UNLOAD */);
    });
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder);
    }
    function createRumBatch(endpointBuilder, unloadCallback) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout, unloadCallback);
    }
    function withReplicaApplicationId(message) {
        return combine(message, { application: { id: replica.applicationId } });
    }
    return {
        add: function (message) {
            primaryBatch.add(message);
            if (replicaBatch) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = getEventBridge();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/domain/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new ContextHistory(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = relativeNow();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.view.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            view: {
                url: url,
                referrer: referrer,
            },
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(location) {
    var currentLocation = shallowClone(location);
    var observable = new observable_Observable(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = shallowClone(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = instrumentMethodAndCallOriginal(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = instrumentMethodAndCallOriginal(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = addEventListener(window, "popstate" /* POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return addEventListener(window, "hashchange" /* HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/boot/startRum.js



















function startRum(configuration, getCommonContext, recorderApi, initialViewOptions) {
    var lifeCycle = new LifeCycle();
    var internalMonitoring = startRumInternalMonitoring(configuration);
    internalMonitoring.setExternalContextProvider(function () {
        var _a;
        return combine({
            application_id: configuration.applicationId,
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
        }, viewContexts.findView(), { view: { name: null } });
    });
    internalMonitoring.setTelemetryContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.view.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    if (!canUseEventBridge()) {
        startRumBatch(configuration, lifeCycle, internalMonitoring.telemetryEventObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, getCommonContext), viewContexts = _a.viewContexts, foregroundContexts = _a.foregroundContexts, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    startLongTaskCollection(lifeCycle, session);
    startResourceCollection(lifeCycle);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = startErrorCollection(lifeCycle, foregroundContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        getInternalContext: internalContext.get,
    };
}
function startRumInternalMonitoring(configuration) {
    var _a;
    var internalMonitoring = startInternalMonitoring(configuration);
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return bridge_1.send('internal_log', message); });
        internalMonitoring.telemetryEventObservable.subscribe(function (message) { return bridge_1.send('internal_telemetry', message); });
    }
    else if (configuration.internalMonitoringEndpointBuilder) {
        var batch_1 = startBatchWithReplica(configuration, configuration.internalMonitoringEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.internalMonitoringEndpointBuilder);
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return batch_1.add(message); });
    }
    return internalMonitoring;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, getCommonContext) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = startForegroundContexts();
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts), addAction = _a.addAction, actionContexts = _a.actionContexts;
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext);
    return {
        viewContexts: viewContexts,
        foregroundContexts: foregroundContexts,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            foregroundContexts.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum-core/esm/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/types.js

var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: DefaultPrivacyLevel.ALLOW,
    MASK: DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/privacy.js

var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;

var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNodePrivacyLevel = node.parentNode
        ? getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel)
        : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElement(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return privacy_isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
function privacy_isTextNode(node) {
    return node.nodeType === node.TEXT_NODE;
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serializationUtils.js


var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current)) {
            return false;
        }
        current = current.parentNode;
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/utils.js
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function utils_forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/serialize.js





function serializeDocument(document, defaultPrivacyLevel) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        document: document,
        parentNodePrivacyLevel: defaultPrivacyLevel,
    });
}
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: 0 /* Document */,
        childNodes: serializeChildNodes(document, options),
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: 1 /* DocumentType */,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serialzing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, otpion selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: 2 /* Element */,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = getAttributesForPrivacyLevel(element, nodePrivacyLevel);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = utils_assign({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: 2 /* Element */,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Scripts
        (relAttribute === 'preload' && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (!textContent) {
        return;
    }
    return {
        type: 3 /* Text */,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: 4 /* CDATA */,
        textContent: '',
    };
}
function serializeChildNodes(node, options) {
    var result = [];
    utils_forEach(node.childNodes, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeAttribute(element, nodePrivacyLevel, attributeName) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && attributeName.indexOf('data-') === 0 && attributeName !== PRIVACY_ATTR_NAME) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
function getAttributesForPrivacyLevel(element, nodePrivacyLevel) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            delete safeAttrs.rel;
            delete safeAttrs.href;
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            safeAttrs.checked = CENSORED_STRING_MARK;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element
     */
    if (element.scrollLeft) {
        safeAttrs.rr_scrollLeft = Math.round(element.scrollLeft);
    }
    if (element.scrollTop) {
        safeAttrs.rr_scrollTop = Math.round(element.scrollTop);
    }
    return safeAttrs;
}
//# sourceMappingURL=serialize.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/types.js
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractions = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractions = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/mutationObserver.js








/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function startMutationObserver(controller, mutationCallback, defaultPrivacyLevel) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: noop };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, defaultPrivacyLevel);
    });
    var observer = new MutationObserver(monitor(mutationBatch.addMutations));
    observer.observe(document, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    controller.onFlush(mutationBatch.flush);
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
    };
}
/**
 * Controls how mutations are processed, allowing to flush pending mutations.
 */
var MutationController = /** @class */ (function () {
    function MutationController() {
    }
    MutationController.prototype.flush = function () {
        var _a;
        (_a = this.flushListener) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    MutationController.prototype.onFlush = function (listener) {
        this.flushListener = listener;
    };
    return MutationController;
}());

function processMutations(mutations, mutationCallback, defaultPrivacyLevel) {
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return document.contains(mutation.target) &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), defaultPrivacyLevel), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, defaultPrivacyLevel) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        utils_forEach(mutation.addedNodes, function (node) {
            addedAndMovedNodes.add(node);
        });
        utils_forEach(mutation.removedNodes, function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            document: document,
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
        });
        if (!serializedNode) {
            continue;
        }
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(node.parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, defaultPrivacyLevel) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(mutation.target.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, defaultPrivacyLevel) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn() {
    var visual = window.visualViewport;
    return (Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visual = window.visualViewport;
    var normalised = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visual) {
        // On old browsers, we cannot normalise, so fallback to clientX/Y
        return normalised;
    }
    else if (isVisualViewportFactoredIn()) {
        // Typically Mobile Devices
        normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
        normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
        normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
    }
    return normalised;
};
var getVisualViewport = function () {
    var visual = window.visualViewport;
    return {
        scale: visual.scale,
        offsetLeft: visual.offsetLeft,
        offsetTop: visual.offsetTop,
        pageLeft: visual.pageLeft,
        pageTop: visual.pageTop,
        height: visual.height,
        width: visual.width,
    };
};
// excludes the width of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowWidth() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.width * visual.scale;
    }
    return window.innerWidth || 0;
}
// excludes the height of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowHeight() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.height * visual.scale;
    }
    return window.innerHeight || 0;
}
function getScrollX() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageLeft - visual.offsetLeft;
    }
    if (window.scrollX !== undefined) {
        return window.scrollX;
    }
    return window.pageXOffset || 0;
}
function getScrollY() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageTop - visual.offsetTop;
    }
    if (window.scrollY !== undefined) {
        return window.scrollY;
    }
    return window.pageYOffset || 0;
}
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/observer.js
var observer_a;








var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
var SCROLL_OBSERVER_THRESHOLD = 100;
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initObservers(o) {
    var mutationHandler = initMutationObserver(o.mutationController, o.mutationCb, o.defaultPrivacyLevel);
    var mousemoveHandler = initMoveObserver(o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.defaultPrivacyLevel);
    var scrollHandler = initScrollObserver(o.scrollCb, o.defaultPrivacyLevel);
    var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
    var inputHandler = initInputObserver(o.inputCb, o.defaultPrivacyLevel);
    var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetRuleCb);
    var focusHandler = initFocusObserver(o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
    return function () {
        mutationHandler();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        focusHandler();
        visualViewportResizeHandler();
    };
}
function initMutationObserver(mutationController, cb, defaultPrivacyLevel) {
    return startMutationObserver(mutationController, cb, defaultPrivacyLevel).stop;
}
function initMoveObserver(cb) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (hasSerializedNode(target)) {
            var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: clientX,
                y: clientY,
            };
            if (window.visualViewport) {
                var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
                position.x = visualViewportX;
                position.y = visualViewportY;
            }
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }), MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return addEventListeners(document, ["mousemove" /* MOUSE_MOVE */, "touchmove" /* TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
var eventTypeToMouseInteraction = (observer_a = {},
    observer_a["mouseup" /* MOUSE_UP */] = MouseInteractions.MouseUp,
    observer_a["mousedown" /* MOUSE_DOWN */] = MouseInteractions.MouseDown,
    observer_a["click" /* CLICK */] = MouseInteractions.Click,
    observer_a["contextmenu" /* CONTEXT_MENU */] = MouseInteractions.ContextMenu,
    observer_a["dblclick" /* DBL_CLICK */] = MouseInteractions.DblClick,
    observer_a["focus" /* FOCUS */] = MouseInteractions.Focus,
    observer_a["blur" /* BLUR */] = MouseInteractions.Blur,
    observer_a["touchstart" /* TOUCH_START */] = MouseInteractions.TouchStart,
    observer_a["touchend" /* TOUCH_END */] = MouseInteractions.TouchEnd,
    observer_a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
            return;
        }
        var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
        var position = {
            id: getSerializedNodeId(target),
            type: eventTypeToMouseInteraction[event.type],
            x: clientX,
            y: clientY,
        };
        if (window.visualViewport) {
            var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
            position.x = visualViewportX;
            position.y = visualViewportY;
        }
        cb(position);
    };
    return addEventListeners(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
function initScrollObserver(cb, defaultPrivacyLevel) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        if (target === document) {
            cb({
                id: id,
                x: getScrollX(),
                y: getScrollY(),
            });
        }
        else {
            cb({
                id: id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }), SCROLL_OBSERVER_THRESHOLD).throttled;
    return addEventListener(document, "scroll" /* SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
function initViewportResizeObserver(cb) {
    var updateDimension = throttle(monitor(function () {
        var height = getWindowHeight();
        var width = getWindowWidth();
        cb({
            height: Number(height),
            width: Number(width),
        });
    }), 200).throttled;
    return addEventListener(window, "resize" /* RESIZE */, updateDimension, { capture: true, passive: true }).stop;
}
function initInputObserver(cb, defaultPrivacyLevel) {
    var lastInputStateMap = new WeakMap();
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            utils_forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb(utils_assign({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
    var stopEventListeners = addEventListeners(document, ["input" /* INPUT */, "change" /* CHANGE */], function (event) {
        if (event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement ||
            event.target instanceof HTMLSelectElement) {
            onElementChange(event.target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var instrumentationStoppers = [
        instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange),
        instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
    ];
    return function () {
        instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        stopEventListeners();
    };
}
function initStyleSheetObserver(cb) {
    var restoreInsertRule = instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'insertRule', {
        before: function (rule, index) {
            if (hasSerializedNode(this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(this.ownerNode),
                    adds: [{ rule: rule, index: index }],
                });
            }
        },
    }).stop;
    var restoreDeleteRule = instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'deleteRule', {
        before: function (index) {
            if (hasSerializedNode(this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(this.ownerNode),
                    removes: [{ index: index }],
                });
            }
        },
    }).stop;
    return function () {
        restoreInsertRule();
        restoreDeleteRule();
    };
}
function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* PLAY */ ? MediaInteractions.Play : MediaInteractions.Pause,
        });
    };
    return addEventListeners(document, ["play" /* PLAY */, "pause" /* PAUSE */], handler, { capture: true, passive: true }).stop;
}
function initFocusObserver(focusCb) {
    return addEventListeners(window, ["focus" /* FOCUS */, "blur" /* BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
function initVisualViewportResizeObserver(cb) {
    if (!window.visualViewport) {
        return noop;
    }
    var _a = throttle(monitor(function () {
        cb(getVisualViewport());
    }), VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListeners(window.visualViewport, ["resize" /* RESIZE */, "scroll" /* SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=observer.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/record.js







function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var mutationController = new MutationController();
    var takeFullSnapshot = function (timestamp) {
        if (timestamp === void 0) { timestamp = timeStampNow(); }
        mutationController.flush(); // process any pending mutation before taking a full snapshot
        emit({
            data: {
                height: getWindowHeight(),
                href: window.location.href,
                width: getWindowWidth(),
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, options.defaultPrivacyLevel),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var stopObservers = initObservers({
        mutationController: mutationController,
        defaultPrivacyLevel: options.defaultPrivacyLevel,
        inputCb: function (v) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, v)); },
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (d) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, d));
        },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: function (m) { return emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, m)); },
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetRuleCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: timeStampNow(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: timeStampNow(),
            });
        },
    });
    return {
        stop: stopObservers,
        takeFullSnapshot: takeFullSnapshot,
        flushMutations: function () { return mutationController.flush(); },
    };
}
function assembleIncrementalSnapshot(source, data) {
    return {
        data: utils_assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: timeStampNow(),
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/transport/send.js

var send_SEND_BEACON_BYTE_LENGTH_LIMIT = 60000;
function send(endpointBuilder, data, metadata, rawSegmentSize, flushReason) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    toFormEntries(metadata, function (key, value) { return formData.append(key, value); });
    formData.append('raw_segment_size', rawSegmentSize.toString());
    var request = new HttpRequest(endpointBuilder, send_SEND_BEACON_BYTE_LENGTH_LIMIT);
    request.send(formData, data.byteLength, flushReason);
}
function toFormEntries(input, onEntry, prefix) {
    if (prefix === void 0) { prefix = ''; }
    objectEntries(input).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value !== null) {
            toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
        }
        else {
            onEntry("".concat(prefix).concat(key), String(value));
        }
    });
}
//# sourceMappingURL=send.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalRawSize) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalRawSize;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.isFlushed = false;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = utils_assign({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === RecordType.FullSnapshot,
            index_in_view: getSegmentsCount(viewId),
        }, context);
        addSegment(viewId);
        addRecord(viewId);
        var listener = monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                addWroteData(viewId, data.additionalRawSize);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawSize);
                    worker.removeEventListener('message', listener);
                }
                else {
                    onWrote(data.compressedSize);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                worker.removeEventListener('message', listener);
                addMonitoringMessage("Segment did not receive a 'flush' response before being replaced.");
            }
        });
        worker.addEventListener('message', listener);
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.end = record.timestamp;
        this.metadata.records_count += 1;
        addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.isFlushed = true;
        this.flushReason = reason;
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var MAX_SEGMENT_DURATION = 30000;
var MAX_SEGMENT_SIZE = send_SEND_BEACON_BYTE_LENGTH_LIMIT;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as much records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment size reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, send, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, send, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, send, worker, emitter) {
    if (emitter === void 0) { emitter = window; }
    var state = {
        status: 0 /* WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribeBeforeUnload = lifeCycle.subscribe(9 /* BEFORE_UNLOAD */, function () {
        flushSegment('before_unload');
    }).unsubscribe;
    var unsubscribeVisibilityChange = addEventListener(emitter, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
        if (document.visibilityState === 'hidden') {
            flushSegment('visibility_hidden');
        }
    }, { capture: true }).stop;
    function flushSegment(nextSegmentCreationReason) {
        if (state.status === 1 /* SegmentPending */) {
            state.segment.flush(nextSegmentCreationReason || 'sdk_stopped');
            clearTimeout(state.expirationTimeoutId);
        }
        if (nextSegmentCreationReason) {
            state = {
                status: 0 /* WaitingForInitialRecord */,
                nextSegmentCreationReason: nextSegmentCreationReason,
            };
        }
        else {
            state = {
                status: 2 /* Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new Segment(worker, context, creationReason, initialRecord, function (compressedSegmentSize) {
            if (!segment.isFlushed && compressedSegmentSize > MAX_SEGMENT_SIZE) {
                flushSegment('max_size');
            }
        }, function (data, rawSegmentSize) {
            send(data, segment.metadata, rawSegmentSize, segment.flushReason);
        });
        state = {
            status: 1 /* SegmentPending */,
            segment: segment,
            expirationTimeoutId: setTimeout(monitor(function () {
                flushSegment('max_duration');
            }), MAX_SEGMENT_DURATION),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment();
            unsubscribeViewCreated();
            unsubscribeBeforeUnload();
            unsubscribeVisibilityChange();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.view.id,
        },
    };
}
function setMaxSegmentSize(newSize) {
    if (newSize === void 0) { newSize = SEND_BEACON_BYTE_LENGTH_LIMIT; }
    MAX_SEGMENT_SIZE = newSize;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/deflateWorker.js
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawSize = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalRawSize = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedSize: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalRawSize: additionalRawSize,
                    });
                    break;
                }
                case 'flush': {
                    var additionalRawSize = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalRawSize: additionalRawSize,
                        rawSize: rawSize,
                    });
                    deflate = new Deflate();
                    rawSize = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawSize += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/startDeflateWorker.js


var state = { status: 0 /* Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    switch (state.status) {
        case 0 /* Nil */:
            state = { status: 1 /* Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* Error */:
            callback();
            break;
        case 3 /* Initialized */:
            callback(state.worker);
            break;
    }
}
function resetDeflateWorkerState() {
    state = { status: 0 /* Nil */ };
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        worker_1.addEventListener('error', monitor(onError));
        worker_1.addEventListener('message', monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        }));
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* Loading */) {
        display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && includes(error.message, 'Content Security Policy'))) {
            display.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            addMonitoringError(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* Error */ };
    }
    else {
        addMonitoringError(error);
    }
}
//# sourceMappingURL=startDeflateWorker.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/boot/startRecording.js





function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker) {
    var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, viewContexts, function (data, metadata, rawSegmentSize, flushReason) {
        return send(configuration.sessionReplayEndpointBuilder, data, metadata, rawSegmentSize, flushReason);
    }, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        defaultPrivacyLevel: configuration.defaultPrivacyLevel,
    }), stopRecording = _b.stop, takeFullSnapshot = _b.takeFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: timeStampNow(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        takeFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/boot/recorderApi.js



function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = startDeflateWorker; }
    if (canUseEventBridge()) {
        return {
            start: noop,
            stop: noop,
            getReplayStats: function () { return undefined; },
            onRumStart: noop,
            isRecording: function () { return false; },
        };
    }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* SESSION_EXPIRED */, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.hasReplayPlan) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                runOnReadyState('interactive', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ../../node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map
// EXTERNAL MODULE: ./src/utils/isBrowser.ts
var isBrowser = __webpack_require__(82929);
// EXTERNAL MODULE: ./src/utils/environment.ts
var environment = __webpack_require__(19429);
;// CONCATENATED MODULE: ./src/observability/datadogRum.ts



function initializeDatadogRum() {
    // Don't initialize during SSR
    if (!(0,isBrowser/* isBrowser */.j)()) return;
    if ((0,environment/* isDevelopment */.y)()) {
        console.info("Datadog RUM not initialized: not in a production environment.");
        return;
    }
    var applicationId = "3b6e979a-2e36-499c-b678-5a1fe9f0c8ed";
    var clientToken = "pubbd5cae99877bb7e7fc964e729eafe306";
    if (!applicationId || !clientToken) {
        console.info("Datadog RUM not initialized: missing applicationId or clientToken.");
        return;
    }
    // See https://docs.datadoghq.com/real_user_monitoring/installation/?tab=us#initialization-parameters
    // for more information on what these individual parameters do.
    datadogRum.init({
        applicationId: applicationId,
        clientToken: clientToken,
        sampleRate: 10,
        service: "pagebuilder",
        env: "staging",
        version: "b1783a46a1479ecdf1f3c222e877294040acba1e",
        // Enables distributed tracing for any `*.zapier.com` or `*.zapier-staging.com` APIs.
        // See: https://docs.datadoghq.com/real_user_monitoring/connect_rum_and_traces/?tab=browserrum
        allowedTracingOrigins: [
            /https:\/\/(.*\.)?zapier(-staging)?\.com/
        ]
    });
}
var vitalsMapper = {
    // Length of time it takes for the page to start and finish hydrating (in ms)
    "Next.js-hydration": "nextJsHydration",
    // Length of time it takes for a page to start rendering after a route change (in ms)
    "Next.js-route-change-to-render": "nextJsRouteChangeToRender",
    // Length of time it takes for a page to finish render after a route change (in ms)
    "Next.js-render": "nextJsRender",
    // Web Vitals - https://web.dev/vitals/
    CLS: "cumulativeLayoutShift",
    FCP: "firstContentfulPaint",
    FID: "firstInputDelay",
    LCP: "largestContentfulPaint",
    TTFB: "timeToFirstByte"
};
// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
function nextJsReportWebVitals(metric) {
    var mappedName = vitalsMapper[metric.name] || metric.name;
    if (!(0,environment/* isProduction */.M)()) {
        console.info("Datadog RUM: would have tracked web vital ".concat(mappedName, " - ").concat(metric.value, "."));
        return;
    }
    datadogRum.addAction("Web Vital: ".concat(mappedName), (0,_define_property/* default */.Z)({}, mappedName, metric.value));
}
function startSessionReplay() {
    datadogRum.startSessionReplayRecording();
}
function stopSessionReplay() {
    datadogRum.stopSessionReplayRecording();
}

// EXTERNAL MODULE: ./src/observability/tracking/TrackingProvider.tsx
var TrackingProvider = __webpack_require__(45413);
;// CONCATENATED MODULE: ./src/pages/_app.tsx


__webpack_require__(15593);











builder_react_es5/* builder.init */.fl.init("3ec535cf03da45b799427676882d3593");
initializeDatadogRum();
// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
var reportWebVitals = nextJsReportWebVitals;
function App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    (0,react.useEffect)(function() {
        (0,smoothscroll.polyfill)();
    }, []);
    var cookieConsent = (0,useCookieConsent/* useCookieConsent */.Y)();
    (0,react.useEffect)(function() {
        if (cookieConsent.byName.analytics) {
            startSessionReplay();
        } else {
            stopSessionReplay();
        }
    }, [
        cookieConsent.byName.analytics
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStylesProvider, {
        isPlatform: true,
        isRebrand: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
            client: ZapierClient,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideo_context/* WistiaVideoProvider */.C, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrackingProvider/* TrackingProvider */.L8, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 59606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xe": function() { return /* binding */ useAccounts; },
  "t": function() { return /* binding */ useCurrentAccount; }
});

// UNUSED EXPORTS: fetchAccounts, fetchAllAccounts

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(79381);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@zapier/identity/dist/identity.esm.js
var identity_esm = __webpack_require__(38716);
// EXTERNAL MODULE: ./src/utils/environment.ts
var environment = __webpack_require__(19429);
// EXTERNAL MODULE: ./src/utils/zodParse.ts
var zodParse = __webpack_require__(93475);
;// CONCATENATED MODULE: ./src/rest/zapier/utils.ts
function getPaginatedRequestURL(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (options.url) {
        return options.url;
    }
    var params = new URLSearchParams();
    if (options.limit) {
        params.append("limit", String(options.limit));
    }
    if (options.offset) {
        params.append("limit", String(options.offset));
    }
    var queryString = params.toString();
    var _baseURL;
    return ((_baseURL = options.baseURL) !== null && _baseURL !== void 0 ? _baseURL : "") + path + (queryString ? "?".concat(queryString) : "");
}

// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./src/rest/zapier/accounts/types.ts

var Z_Account = lib.z.object({
    companies_trial_end_date: lib.z.string().nullable(),
    companies_trial_start_date: lib.z.string().nullable(),
    company_account_end_date: lib.z.string().nullable(),
    company_address: lib.z.string().nullable(),
    company_initial_engagement: lib.z.boolean().nullable(),
    currency: lib.z.string().nullable(),
    first_known_upgrade_date: lib.z.string().nullable(),
    has_been_in_companies_trial: lib.z.boolean().nullable(),
    has_modern_pricing_plan: lib.z.boolean().nullable(),
    id: lib.z.number(),
    is_chat_eligible: lib.z.boolean().nullable(),
    is_company_account: lib.z.boolean().nullable(),
    is_in_experts_mvp: lib.z.boolean().nullable(),
    is_premier_chat_eligible: lib.z.boolean().nullable(),
    is_team_account: lib.z.boolean().nullable(),
    is_trialing_companies: lib.z.boolean().nullable(),
    is_trialing_teams: lib.z.boolean().nullable(),
    is_trialing: lib.z.boolean().nullable(),
    is_unlimited: lib.z.boolean().nullable(),
    last_plan_change_at: lib.z.string().nullable(),
    logo_url: lib.z.string().url().or(lib.z["enum"]([
        ""
    ])).optional().nullable(),
    name: lib.z.string(),
    offer_returning_trial_extension: lib.z.boolean().nullable(),
    owner: lib.z.object({
        id: lib.z.number(),
        name: lib.z.string(),
        email: lib.z.string().email()
    }),
    paying: lib.z.boolean().nullable(),
    pays_manually: lib.z.boolean().nullable(),
    period_end: lib.z.string().nullable(),
    period_start: lib.z.string().nullable(),
    plan_group_id: lib.z.number().nullable(),
    plan_info: lib.z.object({
        id: lib.z.number(),
        name: lib.z.string(),
        metered_task_pricing: lib.z.boolean(),
        interval: lib.z.string(),
        allow_companies: lib.z.boolean().nullable(),
        allow_teams: lib.z.boolean().nullable(),
        allow_import_export: lib.z.boolean().nullable()
    }),
    surveys_submitted: lib.z.object({
        company_trial_onboarding: lib.z.boolean().nullable(),
        company_trial_exit: lib.z.boolean().nullable()
    }),
    team_account_end_date: lib.z.string().nullable(),
    teams_trial_end_date: lib.z.string().nullable(),
    trial_auto_upgrade: lib.z.boolean().nullable(),
    trial_end_date: lib.z.string().nullable(),
    teams_trial_auto_upgrade: lib.z.boolean().nullable(),
    companies_trial_auto_upgrade: lib.z.boolean().nullable(),
    created_at: lib.z.string()
});
var Z_AccountsResponse = lib.z.object({
    count: lib.z.number(),
    next: lib.z.string().nullable(),
    previous: lib.z.string().nullable(),
    results: lib.z.array(Z_Account)
});

;// CONCATENATED MODULE: ./src/rest/zapier/accounts/data.ts











function fetchAccounts() {
    return _fetchAccounts.apply(this, arguments);
}
function _fetchAccounts() {
    _fetchAccounts = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var options, response, data, ref, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return fetch(getPaginatedRequestURL("/api/v4/accounts/", options));
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json().catch(function(error) {
                        return !(0,environment/* isProduction */.M)() && console.error(error);
                    });
                case 6:
                    data = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 10;
                        break;
                    }
                    ;
                    throw new Error("Failed to fetch accounts: ".concat((ref = data === null || data === void 0 ? void 0 : data.detail) !== null && ref !== void 0 ? ref : "Unknown error", " (").concat(response.status, ")"));
                case 10:
                    (0,zodParse/* zodParse */.U)(Z_AccountsResponse, data, "AccountsResponse");
                    return _ctx.abrupt("return", data);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAccounts.apply(this, arguments);
}
function fetchAllAccounts(options) {
    return _fetchAllAccounts.apply(this, arguments);
}
function _fetchAllAccounts() {
    _fetchAllAccounts = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(options) {
        var previousResults, data, _results, results, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    previousResults = _args.length > 1 && _args[1] !== void 0 ? _args[1] : [];
                    _ctx.next = 3;
                    return fetchAccounts(options);
                case 3:
                    data = _ctx.sent;
                    ;
                    results = (0,_to_consumable_array/* default */.Z)(previousResults).concat((0,_to_consumable_array/* default */.Z)((_results = data.results) !== null && _results !== void 0 ? _results : []));
                    if (!data.next) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", fetchAllAccounts((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        url: data.next
                    }), results));
                case 8:
                    return _ctx.abrupt("return", results);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAllAccounts.apply(this, arguments);
}
function useAccounts() {
    var shouldFetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    var ref = (0,dist/* default */.ZP)("/api/v4/accounts/".concat(shouldFetch), function() {
        return shouldFetch && !!currentAccountId ? fetchAllAccounts() : null;
    }), data = ref.data, error = ref.error, isLoading = ref.isLoading;
    if (error) {
        !(0,environment/* isProduction */.M)() && console.error(error);
        (0,esm_exports/* captureException */.Tb)(error);
    }
    return {
        data: data !== null && data !== void 0 ? data : null,
        error: error,
        isLoading: isLoading
    };
}
function useCurrentAccount() {
    var shouldFetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    var ref = useAccounts(shouldFetch), data = ref.data, error = ref.error, isLoading = ref.isLoading;
    if (error) {
        !(0,environment/* isProduction */.M)() && console.error(error);
        (0,esm_exports/* captureException */.Tb)(error);
    }
    var ref1;
    return {
        data: (ref1 = data === null || data === void 0 ? void 0 : data.find(function(param) {
            var id = param.id;
            return id === currentAccountId;
        })) !== null && ref1 !== void 0 ? ref1 : null,
        error: error,
        isLoading: isLoading
    };
}


/***/ }),

/***/ 56675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ useUserProfile; }
});

// UNUSED EXPORTS: fetchUserProfile

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(79381);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@zapier/identity/dist/identity.esm.js
var identity_esm = __webpack_require__(38716);
// EXTERNAL MODULE: ./src/utils/environment.ts
var environment = __webpack_require__(19429);
// EXTERNAL MODULE: ./src/utils/zodParse.ts
var zodParse = __webpack_require__(93475);
// EXTERNAL MODULE: ./src/contexts/PrefetchedDataContext.ts
var PrefetchedDataContext = __webpack_require__(52310);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./src/rest/zapier/recommendations/user_profile/types.ts

var Z_UserProfile = lib.z.object({
    organization_name: lib.z.string().nullable(),
    role_id: lib.z.number().nullable(),
    company_size_id: lib.z.number().nullable(),
    inferred_organization_name: lib.z.string().nullable().optional()
});
var Z_UserProfileResponse = lib.z.object({
    objects: lib.z.array(Z_UserProfile)
});

;// CONCATENATED MODULE: ./src/rest/zapier/recommendations/user_profile/data.ts










function fetchUserProfile() {
    return _fetchUserProfile.apply(this, arguments);
}
function _fetchUserProfile() {
    _fetchUserProfile = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data, ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("/api/v3/recommendations/user_profile");
                case 2:
                    response = _ctx.sent;
                    _ctx.next = 5;
                    return response.json().catch(function(error) {
                        return !(0,environment/* isProduction */.M)() && console.error(error);
                    });
                case 5:
                    data = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    throw new Error("Failed to fetch user profile: ".concat((ref = data === null || data === void 0 ? void 0 : data.errors) !== null && ref !== void 0 ? ref : [
                        "unknown error"
                    ].join(", "), " (").concat(response.status, ")"));
                case 9:
                    (0,zodParse/* zodParse */.U)(Z_UserProfileResponse, data, "UserProfileResponse");
                    return _ctx.abrupt("return", data.objects[0]);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchUserProfile.apply(this, arguments);
}
function useUserProfile() {
    var shouldFetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref, ref1;
    var currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    var ref2 = (0,dist/* default */.ZP)("/api/v3/recommendations/user_profile/".concat(shouldFetch), function() {
        return shouldFetch && !!currentAccountId ? fetchUserProfile() : null;
    }), data = ref2.data, error = ref2.error, isLoading = ref2.isLoading;
    var ref3 = (0,PrefetchedDataContext/* usePrefetchedDataContext */.n)(), roles = ref3.roles, companySizes = ref3.companySizes;
    if (error) {
        !(0,environment/* isProduction */.M)() && console.error(error);
        (0,esm_exports/* captureException */.Tb)(error);
    }
    var ref4, ref5;
    return {
        data: data ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            role_name: (ref4 = (ref = roles.find(function(param) {
                var id = param.id;
                return id === data.role_id;
            })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref4 !== void 0 ? ref4 : null,
            company_size_display_range: (ref5 = (ref1 = companySizes.find(function(param) {
                var id = param.id;
                return id === data.company_size_id;
            })) === null || ref1 === void 0 ? void 0 : ref1.display_range) !== null && ref5 !== void 0 ? ref5 : null
        }) : null,
        error: error,
        isLoading: isLoading
    };
}


/***/ }),

/***/ 27560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ useSession; }
});

// UNUSED EXPORTS: fetchSession

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(79381);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@zapier/identity/dist/identity.esm.js
var identity_esm = __webpack_require__(38716);
// EXTERNAL MODULE: ./src/utils/environment.ts
var environment = __webpack_require__(19429);
// EXTERNAL MODULE: ./src/utils/zodParse.ts
var zodParse = __webpack_require__(93475);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./src/rest/zapier/session/types.ts

var Z_Session = lib.z.object({
    id: lib.z.number().optional(),
    user_id: lib.z.number().optional(),
    identity: lib.z.number().nullable(),
    is_logged_in: lib.z.boolean(),
    has_signed_up: lib.z.boolean(),
    email: lib.z.string().email().or(lib.z["enum"]([
        ""
    ])).optional(),
    first_name: lib.z.string().optional(),
    last_name: lib.z.string().optional(),
    username: lib.z.string().optional(),
    last_login: lib.z.string().optional(),
    timezone: lib.z.string().optional().nullable(),
    photo_url: lib.z.string().url().or(lib.z["enum"]([
        ""
    ])).optional().nullable(),
    signup: lib.z.string().optional(),
    since_signup: lib.z.string().optional(),
    has_activated: lib.z.boolean().optional(),
    is_staff: lib.z.boolean().optional(),
    is_developer: lib.z.boolean().optional(),
    is_expert: lib.z.boolean().optional(),
    is_high_value: lib.z.boolean().optional(),
    is_temporary: lib.z.boolean().optional(),
    banner_message: lib.z.string().optional(),
    organizations: lib.z.array(lib.z.number().nullable()).optional(),
    primary_organization: lib.z.number().optional().nullable(),
    has_active_zaps: lib.z.boolean().optional(),
    current_account_id: lib.z.number().nullable(),
    roles: lib.z.array(lib.z.object({
        account_id: lib.z.number(),
        role: lib.z["enum"]([
            "owner",
            "member",
            "admin",
            "super_admin"
        ])
    })).optional()
});

;// CONCATENATED MODULE: ./src/rest/zapier/session/data.ts









var fetchSession = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(options) {
        var ref, sessionResponse, session;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return fetch("".concat((ref = options === null || options === void 0 ? void 0 : options.baseURL) !== null && ref !== void 0 ? ref : "", "/api/v4/session/"), (options === null || options === void 0 ? void 0 : options.zapsession) ? {
                        headers: {
                            Cookie: "zapsession=".concat(options.zapsession, ";")
                        }
                    } : {});
                case 3:
                    sessionResponse = _ctx.sent;
                    if (sessionResponse.ok) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Request to fetch user session failed. Status: ".concat(sessionResponse.status, ". Message: ").concat(sessionResponse.statusText));
                case 6:
                    _ctx.next = 8;
                    return sessionResponse.json().catch(function(error) {
                        return !(0,environment/* isProduction */.M)() && console.error(error);
                    });
                case 8:
                    session = _ctx.sent;
                    (0,zodParse/* zodParse */.U)(Z_Session, session, "Session");
                    return _ctx.abrupt("return", session);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchSession(options) {
        return _ref.apply(this, arguments);
    };
}();
var useSession = function() {
    var shouldFetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref, ref1;
    var currentAccountId = (0,identity_esm/* useCurrentAccountId */.X8)();
    var ref2 = (0,dist/* default */.ZP)("/api/v4/session/".concat(shouldFetch), function() {
        return shouldFetch ? fetchSession() : null;
    }), data = ref2.data, error = ref2.error, isLoading = ref2.isLoading;
    if (error) {
        !(0,environment/* isProduction */.M)() && console.error(error);
        (0,esm_exports/* captureException */.Tb)(error);
    }
    var ref3;
    return {
        data: data ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            current_account_role: (ref3 = (ref1 = (ref = data.roles) === null || ref === void 0 ? void 0 : ref.find(function(role) {
                return role.account_id === currentAccountId;
            })) === null || ref1 === void 0 ? void 0 : ref1.role) !== null && ref3 !== void 0 ? ref3 : ""
        }) : null,
        error: error,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 19429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isProduction; },
/* harmony export */   "y": function() { return /* binding */ isDevelopment; }
/* harmony export */ });
var isProduction = function() {
    return "staging" === "production";
};
var isDevelopment = function() {
    return "staging" === "development";
};


/***/ }),

/***/ 82929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; }
/* harmony export */ });
var isBrowser = function() {
    return "object" !== "undefined";
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (isBrowser)));


/***/ }),

/***/ 93475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ zodParse; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92642);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19429);


var zodParse = function(ZodSchema, unparsedData, schemaName) {
    var result = ZodSchema.safeParse(unparsedData);
    if (!(0,_environment__WEBPACK_IMPORTED_MODULE_0__/* .isProduction */ .M)() && !result.success) {
        var error = result.error.toString();
        console.error(error);
        throw new Error(error);
    }
    if (!result.success) (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(new Error("Zod parsing error (".concat(schemaName, "): ").concat(result.error.toString())));
    return result.success ? result.data : unparsedData;
};


/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 34911:
/***/ (function(module, exports) {

"use strict";


// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var global = getGlobal();

module.exports = exports = global.fetch;

// Needed for TypeScript and Webpack.
if (global.fetch) {
	exports["default"] = global.fetch.bind(global);
}

exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

/***/ }),

/***/ 19928:
/***/ (function(module) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else {}
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 92808:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 31368:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 56642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(92808);
exports.encode = exports.stringify = __webpack_require__(31368);


/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 92454:
/***/ (function(module) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ 98621:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ 5163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 45982:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 90336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.emit = void 0;
const EventsToolkitSettings_1 = __webpack_require__(8438);
const EventsToolkitUtilities_1 = __webpack_require__(92225);
const _1 = __webpack_require__(18862);
const VisitorTracking_1 = __webpack_require__(8515);
const VisitorTracking_2 = __webpack_require__(8515);
const version_1 = __webpack_require__(64940);
const PREVIOUS_LOCATION_KEY = _1.visitorId + "-previous-location";
const NEXT_PAGE_VIEW_REFERRER_KEY = _1.visitorId + "-next-page-view-referrer";
const PageViewEvent = "web_analytics.tracking.page_view.PageViewEvent";
const UserInteractionEvent = "web_analytics.tracking.user_interaction.UserInteractionEvent";
function setPreviousLocation(locationHref) {
    // we use session storage here to ensure this goes away when a browser window/tab is closed
    // but that it's also persisted if a browser session is restored.
    typeof window !== 'undefined' && window.sessionStorage.setItem(PREVIOUS_LOCATION_KEY, locationHref);
}
function getPreviousLocation(queryStringObject) {
    // we use "referer" to record where folks came from when they arrive in an app.
    // we also use it to record their previous location as they navigate around within
    // an app.   To ensure this works properly for Single Page Apps, we keep track
    // of this in session storage.
    let referer = queryStringObject.referer;
    let referrer = queryStringObject.referrer;
    let from = queryStringObject.from;
    if (referer !== undefined) {
        return referer || 'undefined';
    }
    if (referrer !== undefined) {
        return referrer || 'undefined';
    }
    if (from !== undefined) {
        return from || 'undefined';
    }
    return ((typeof window !== 'undefined' && window.sessionStorage.getItem(PREVIOUS_LOCATION_KEY)) || document.referrer);
}
function removePreviousLocation() {
    return (typeof window !== 'undefined' && window.sessionStorage.removeItem(PREVIOUS_LOCATION_KEY));
}
function removeNextPageViewReferrer() {
    return (typeof window !== 'undefined' && window.sessionStorage.removeItem(NEXT_PAGE_VIEW_REFERRER_KEY));
}
function setNextPageViewReferrer(locationHref) {
    typeof window !== 'undefined' && window.sessionStorage.setItem(NEXT_PAGE_VIEW_REFERRER_KEY, locationHref);
}
function getNextPageViewReferrer() {
    return ((typeof window !== 'undefined' && window.sessionStorage.getItem(NEXT_PAGE_VIEW_REFERRER_KEY)) ||
        document.referrer);
}
function applyDataGovernanceDefaults(eventData, eventType) {
    let page_path = null;
    let screen_size = null;
    let iframe_flag = null;
    let popup_flag = null;
    let user_agent = null;
    let url_address = null;
    let query_string = null;
    let fully_qualified_domain_name = null;
    let utm_campaign = null;
    let utm_content = null;
    let utm_medium = null;
    let utm_source = null;
    let visitor_id = null;
    let session_id = null;
    let page_view_id = null;
    let referer = null;
    let events_library_version = version_1.LIB_VERSION;
    let event_action = null;
    let interaction_name = null;
    let interaction_raw_text = null;
    if (EventsToolkitUtilities_1.isBrowser()) {
        fully_qualified_domain_name = window.location.hostname;
        url_address = window.location.href;
        page_path = window.location.pathname;
        query_string = window.location.search;
        user_agent = window.navigator.userAgent;
        var queryStringObject = EventsToolkitUtilities_1.querystringToObj(query_string);
        utm_campaign = queryStringObject.utm_campaign;
        utm_content = queryStringObject.utm_content;
        utm_medium = queryStringObject.utm_medium;
        utm_source = queryStringObject.utm_source;
        const width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        screen_size = `${width}x${height}`;
        iframe_flag = EventsToolkitUtilities_1.isInIframe();
        popup_flag = EventsToolkitUtilities_1.isInPopup();
        visitor_id = _1.visitorId;
        session_id = VisitorTracking_1.getSessionId();
        page_view_id = VisitorTracking_2.getPageViewId();
        if (eventType == UserInteractionEvent) {
            event_action = eventData.event_action || null;
            interaction_name = eventData.interaction_name || null;
            interaction_raw_text = eventData.interaction_raw_text || null;
        }
        if (eventType == PageViewEvent) {
            // We'll save the current url_address value for the PageViewEvent
            // as the "next PageViewEvent referrer"   This value will be used as
            // the next PageViewEvent's referer value to ensure this is consistently
            // tracked for Single Page Applications.
            // As we move to different pages, we'll keep track of our history
            // so we can use this as the "referrer" in Single Page Applications.
            // We don't immediately make the "next PageViewEvent referrer value" the
            // "previous location" as that can cause issues for referrer tracking
            // on other events like the UserInteractionEvent.
            setPreviousLocation(getNextPageViewReferrer());
            referer = getPreviousLocation(queryStringObject);
            setNextPageViewReferrer(url_address);
        }
        else {
            referer = getPreviousLocation(queryStringObject);
        }
    }
    return Object.assign({ fully_qualified_domain_name,
        url_address,
        query_string,
        page_path,
        screen_size,
        iframe_flag,
        popup_flag,
        user_agent,
        utm_content,
        utm_medium,
        utm_source,
        utm_campaign,
        visitor_id,
        page_view_id,
        referer,
        session_id,
        events_library_version,
        interaction_name,
        interaction_raw_text,
        event_action }, eventData);
}
function writeToDataLayer(eventType, eventData) {
    if (EventsToolkitUtilities_1.isBrowser() && EventsToolkitSettings_1.settings.write_to_data_layer === "true") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "analyticsEvent",
            eventLabel: eventType,
            eventAction: eventData.event_action,
            interactionName: eventData.interaction_name,
            interactionRawText: eventData.interaction_raw_text,
            pagePath: eventData.page_path,
            visitorId: _1.visitorId,
        });
    }
}
if (typeof window !== 'undefined') {
    window.addEventListener("beforeunload", () => {
        removePreviousLocation();
        removeNextPageViewReferrer();
    });
}
function emit(eventData, eventType) {
    return __awaiter(this, void 0, void 0, function* () {
        var emitStatus = true;
        var eventRequestData = undefined;
        try {
            eventRequestData = applyDataGovernanceDefaults(eventData, eventType);
            var headers = {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            };
            const response = yield fetch(EventsToolkitSettings_1.settings.emit_api, {
                body: JSON.stringify({
                    properties: eventRequestData,
                    subject: eventType,
                }),
                credentials: "include",
                headers: headers,
                method: "POST",
            });
            if (response.status !== 200) {
                console.warn("Unable to emit event:", response);
                emitStatus = false;
            }
            else {
                writeToDataLayer(eventType, eventRequestData);
            }
        }
        catch (error) {
            console.warn("Unable to emit event:", error);
            emitStatus = false;
        }
        return [emitStatus, eventRequestData];
    });
}
exports.emit = emit;


/***/ }),

/***/ 8438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34406);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settings = void 0;
function getEventsToolkitEmitAPI() {
    if (true) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return "https://zapier-staging.com/api/v4/tracking/event/";
    }
    else {}
}
function getWriteToDataLayer() {
    if (true) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return "true";
    }
    else {}
}
exports.settings = {
    streaming_service: process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        ? process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        : "api",
    emit_api: getEventsToolkitEmitAPI(),
    domain: new URL(getEventsToolkitEmitAPI()).hostname,
    write_to_data_layer: getWriteToDataLayer(),
};


/***/ }),

/***/ 92225:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.querystringToObj = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
const isBrowser = () => typeof window !== "undefined";
exports.isBrowser = isBrowser;
const isInIframe = () => {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInIframe = isInIframe;
const isInPopup = () => {
    return exports.isBrowser() && !!window.opener;
};
exports.isInPopup = isInPopup;
const querystringToObj = (query) => {
    var _a, _b;
    let qs = (_b = query !== null && query !== void 0 ? query : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : "";
    if (qs.startsWith("?")) {
        qs = qs.substr(1);
    }
    qs = decodeURIComponent(qs);
    var chunks = qs.split("&"), obj = {};
    for (var c = 0; c < chunks.length; c++) {
        var split = chunks[c].split("=", 2);
        obj[split[0]] = split[1];
    }
    return obj;
};
exports.querystringToObj = querystringToObj;


/***/ }),

/***/ 8515:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPageViewId = exports.getSessionId = exports.getVisitorId = void 0;
const EventsToolkitSettings_1 = __webpack_require__(8438);
const EventsToolkitUtilities_1 = __webpack_require__(92225);
const sessionIdCookieName = "session_id";
const visitorIdCookieName = "visitor_id";
const pageViewIdSessionStorageName = "page_view_id";
function getCookie(name) {
    var _a;
    let matches = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.match(new RegExp("(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
// this routine is based on various approaches that have been posted and discussed
// at https://gist.github.com/jed/982883
// we prefer to do "inline" uuid generation here instead of including a separate library.
const getUuid = (a = "") => {
    var _a;
    return a
        ? /* eslint-disable no-bitwise */
            (Number(a) ^
                (((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint8Array(1))[0]) &
                    (15 >> (Number(a) / 4)))).toString(16)
        : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, getUuid);
};
function getVisitorId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var visitorId = getCookie(visitorIdCookieName);
        if (!visitorId) {
            visitorId = getUuid();
            document.cookie =
                visitorIdCookieName +
                    "=" +
                    visitorId +
                    ";domain=" +
                    EventsToolkitSettings_1.settings.domain +
                    ";path=/;max-age=5897232000";
        }
        return visitorId;
    }
    else {
        return undefined;
    }
}
exports.getVisitorId = getVisitorId;
function getSessionId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var sessionId = getCookie(sessionIdCookieName);
        if (!sessionId) {
            sessionId = getUuid();
        }
        // session id values should be regenerated after 60 minutes (3600 seconds) of inactivity
        document.cookie =
            sessionIdCookieName +
                "=" +
                sessionId +
                ";domain=" +
                EventsToolkitSettings_1.settings.domain +
                ";path=/;max-age=3600";
        return sessionId;
    }
    else {
        return undefined;
    }
}
exports.getSessionId = getSessionId;
function getPageViewId() {
    if (EventsToolkitUtilities_1.isBrowser()) {
        var pageViewIdSession = sessionStorage.getItem(pageViewIdSessionStorageName);
        var pageViewIdJson;
        var pageViewId;
        if (pageViewIdSession) {
            pageViewIdJson = JSON.parse(pageViewIdSession);
        }
        if (pageViewIdJson && pageViewIdJson.length == 2 && pageViewIdJson[0] == window.location.pathname) {
            pageViewId = pageViewIdJson[1];
        }
        else {
            pageViewId = getUuid();
            pageViewIdSession = JSON.stringify([location.pathname, pageViewId]);
            sessionStorage.setItem(pageViewIdSessionStorageName, pageViewIdSession);
        }
        return pageViewId;
    }
    else {
        return undefined;
    }
}
exports.getPageViewId = getPageViewId;


/***/ }),

/***/ 18862:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.emit = exports.visitorId = void 0;
const VisitorTracking_1 = __webpack_require__(8515);
exports.visitorId = VisitorTracking_1.getVisitorId();
var EventsToolkit_1 = __webpack_require__(90336);
Object.defineProperty(exports, "emit", ({ enumerable: true, get: function () { return EventsToolkit_1.emit; } }));


/***/ }),

/***/ 64940:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LIB_VERSION = void 0;
exports.LIB_VERSION = "1.1.8";


/***/ }),

/***/ 64368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 45832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ isApolloError; },
/* harmony export */   "YG": function() { return /* binding */ PROTOCOL_ERRORS_SYMBOL; },
/* harmony export */   "cA": function() { return /* binding */ ApolloError; },
/* harmony export */   "ls": function() { return /* binding */ graphQLResultHasProtocolErrors; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5163);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66064);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45931);



var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) {
        return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var errors = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError)
        errors.push(err.networkError);
    return errors
        .map(function (err) { return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(err) && err.message || 'Error message not found.'; })
        .join('\n');
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = 'ApolloError';
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43869);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 22820:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66064);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42370);



function useApolloClient(override) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 32);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 40794:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useQuery; }
});

// UNUSED EXPORTS: useInternalState

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 6 modules
var globals = __webpack_require__(66064);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && globals/* invariant.error */.kG.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = react.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUse/* canUseLayoutEffect */.JC) {
        react.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    react.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(42370);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(87274);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(22820);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(23180);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.I.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.I.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && globals/* invariant.warn */.kG.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.executeQuery = function (options) {
        var _this = this;
        var _a;
        if (options.query) {
            Object.assign(this, { query: options.query });
        }
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function (resolve) {
            var result;
            concast.subscribe({
                next: function (value) {
                    result = value;
                },
                error: function () {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function () {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,equality_esm/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,equality_esm/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.I.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return setTimeout(function () { return subscription.unsubscribe(); }); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0,equality_esm/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push((0,compact/* compact */.o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions/* mergeOptions */.J);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6/* __rest */._T)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            Promise.resolve().then(function () {
                if (error_1) {
                    _this.onError(error_1);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function (result) {
        return (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? new errors/* ApolloError */.cA({ graphQLErrors: result.errors })
            : result.error;
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6/* __rest */._T)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            queryResult.error = new errors/* ApolloError */.cA({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.I.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 87274:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* unused harmony exports operationName, parser */
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66064);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 33);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 34);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, 35);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 36);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, 37);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 43869:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66064);

var canUseWeakMap = typeof WeakMap === 'function' &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 23180:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66064);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45931);


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 58769:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5163);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9428);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 45931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 66064:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ej": function() { return /* reexport */ InvariantError; },
  "kG": function() { return /* reexport */ invariant; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: DEV, checkDEV, global

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/node_modules/ts-invariant/lib/invariant.js

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* harmony default export */ var lib_invariant = ((/* unused pure expression or super */ null && (invariant)));
//# sourceMappingURL=invariant.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/node_modules/ts-invariant/process/index.js
/* provided dependency */ var process = __webpack_require__(34406);
function process_maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  process_maybe(function() { return globalThis }) ||
  process_maybe(function() { return window }) ||
  process_maybe(function() { return self }) ||
  process_maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  process_maybe(function() { return process_maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !process_maybe(function() { return "production" }) &&
      !process_maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(8162);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? invariant("boolean" === typeof DEV, DEV) : invariant("boolean" === typeof DEV, 39);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 32222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 18770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 93520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 88660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 92277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46182);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    // $FlowFixMe(>=0.90.0)
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 46182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 85717:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(lines);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
} // @internal

function getBlockStringIndentation(lines) {
  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    if (commonIndent === null || indent < commonIndent) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  return commonIndent === null ? 0 : commonIndent;
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 95115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),

/***/ 8162:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; }
});

// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(88660);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/defineToStringTag.mjs
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function defineToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/source.mjs



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  this.locationOffset.line > 0 || (0,devAssert/* default */.Z)(0, 'line in locationOffset is 1-indexed and must be positive');
  this.locationOffset.column > 0 || (0,devAssert/* default */.Z)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported

defineToStringTag(Source);


/***/ }),

/***/ 82067:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createDateFormatter": function() { return /* binding */ createDateFormatter; }
/* harmony export */ });
const defaultPattern = '[YMDdAaHhms]+';
const identity = (x) => x;
const formatters = {
    YYYY: parts => parts.year,
    YY: parts => parts.year.slice(-2),
    MMMM: parts => parts.lmonth,
    MMM: parts => parts.lmonth.slice(0, 3),
    MM: parts => parts.month,
    DD: parts => parts.day,
    dddd: parts => parts.weekday,
    ddd: parts => parts.weekday.slice(0, 3),
    A: parts => parts.dayPeriod,
    a: parts => parts.dayPeriod.toLowerCase(),
    HH: parts => ('0' + (Number(parts.lhour) % 24)).slice(-2),
    hh: parts => parts.hour,
    mm: parts => parts.minute,
    ss: parts => parts.second
};
const createCustomPattern = (customFormatters) => Object.keys(customFormatters).reduce((pattern, key) => `|${key}`, '');
function formatDate(customFormatters, format, parts, date) {
    const customPattern = createCustomPattern(customFormatters);
    const patternRegexp = new RegExp(`${defaultPattern}${customPattern}`, 'g');
    const allFormatters = Object.assign({}, formatters, customFormatters);
    return format.replace(patternRegexp, (mask) => (allFormatters[mask] || identity)(parts, date));
}

const parsers = new Map();
const intlFormattersOptions = [
    {
        weekday: 'long',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    },
    {
        month: 'long',
        hour: '2-digit',
        hour12: false,
    },
];
const createIntlFormatterWith = (options) => intlFormattersOptions.map((intlFormatterOptions) => new Intl.DateTimeFormat(options.locale, Object.assign({}, intlFormatterOptions, { timeZone: options.timezone })));
const longTokensTransformer = (token) => (token.type !== 'literal' ? { type: `l${token.type}`, value: token.value } : token);
const datePartsReducer = (parts, token) => {
    parts[token.type] = token.value;
    return parts;
};
const tokenize = (intlFormatter, date) => intlFormatter.formatToParts(date).filter((token) => token.type !== 'literal');
const normalize = (parts) => {
    parts.dayPeriod = parts.dayPeriod || parts.dayperiod || '';
    delete parts.dayperiod;
    parts.lhour = ('0' + (Number(parts.lhour) % 24)).slice(-2);
    return parts;
};
const createParser = (options) => {
    const [intlFormatter, intlFormatterLong] = createIntlFormatterWith(options);
    return function parseDateImpl(date) {
        const tokens = tokenize(intlFormatter, date);
        const longTokens = tokenize(intlFormatterLong, date).map(longTokensTransformer);
        const allTokens = [...tokens, ...longTokens];
        const parts = allTokens.reduce(datePartsReducer, {});
        return normalize(parts);
    };
};
function parseDate(date, options = {}) {
    const key = `${options.locale}${options.timezone}`;
    let parser = parsers.get(key);
    if (!parser) {
        parser = createParser(options);
        parsers.set(key, parser);
    }
    return parser(date);
}

function createDateFormatter(customFormatters) {
    return function intlFormatDate(date, format, options) {
        const tokens = parseDate(date, options);
        const output = formatDate(customFormatters, format, tokens, date);
        return output;
    };
}

var index = createDateFormatter({});

/* harmony default export */ __webpack_exports__["default"] = (index);



/***/ }),

/***/ 79381:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useSWR; }
});

// UNUSED EXPORTS: SWRConfig, mutate, preload, unstable_serialize, useSWRConfig

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(43100);
;// CONCATENATED MODULE: ../../node_modules/swr/_internal/dist/index.mjs


// Global state used to deduplicate requests and store listeners
const SWRGlobalState = new WeakMap();

const EMPTY_CACHE = {};
const INITIAL_CACHE = {};
const noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const UNDEFINED = /*#__NOINLINE__*/ noop();
const OBJECT = Object;
const isUndefined = (v)=>v === UNDEFINED;
const isFunction = (v)=>typeof v == 'function';
const mergeObjects = (a, b)=>({
        ...a,
        ...b
    });
const STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const isWindowDefined = typeof window != STR_UNDEFINED;
const isDocumentDefined = typeof document != STR_UNDEFINED;
const hasRequestAnimationFrame = ()=>isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
const createCacheHelper = (cache, key)=>{
    const state = SWRGlobalState.get(cache);
    return [
        // Getter
        ()=>cache.get(key) || EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!isUndefined(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return cache.get(key) || EMPTY_CACHE;
        }
    ];
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const table = new WeakMap();
// counter of the key
let counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const stableHash = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            const keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let online = true;
const isOnline = ()=>online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
];
const isVisible = ()=>{
    const visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
const initFocus = (callback)=>{
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return ()=>{
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
const initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return ()=>{
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
const preset = {
    isOnline,
    isVisible
};
const defaultConfigOptions = {
    initFocus,
    initReconnect
};

const IS_REACT_LEGACY = !react.useId;
const IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
const rAF = (f)=>hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
const navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);

const dist_serialize = (key)=>{
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};

// Global timestamp.
let __timestamp = 0;
const getTimestamp = ()=>++__timestamp;

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;

var constants = {
  __proto__: null,
  FOCUS_EVENT: FOCUS_EVENT,
  RECONNECT_EVENT: RECONNECT_EVENT,
  MUTATE_EVENT: MUTATE_EVENT
};

async function internalMutate(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = mergeObjects({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if (isFunction(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for(let keyIt = it.next(); !keyIt.done; keyIt = it.next()){
            const key = keyIt.value;
            if (// Skip the special useSWRInfinite keys.
            !key.startsWith('$inf$') && keyFilter(cache.get(key)._k)) {
                matchedKeys.push(key);
            }
        }
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = dist_serialize(_k);
        if (!key) return;
        const [get, set] = createCacheHelper(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                if (revalidators && revalidators[0]) {
                    return revalidators[0](MUTATE_EVENT).then(()=>get().data);
                }
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) {
            // Revalidate and broadcast state.
            return startRevalidate();
        }
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = getTimestamp();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !isUndefined(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = isUndefined(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = isFunction(optimisticData) ? optimisticData(committedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if (isFunction(data)) {
            // `data` is a function, call it passing current cache value.
            try {
                data = data(committedData);
            } catch (err) {
                // If it throws an error synchronously, we shouldn't update the cache.
                error = err;
            }
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && isFunction(data.then)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if (isFunction(populateCache)) {
                    data = populateCache(data, committedData);
                }
                // Only update cached data if there's no error. Data can be `undefined` here.
                set({
                    data,
                    _c: UNDEFINED
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = getTimestamp();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: UNDEFINED
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}

const revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
const initCache = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        const opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = internalMutate.bind(UNDEFINED, provider);
        let unmount = noop;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) {
                for(let i = subs.length; i--;){
                    subs[i](value, prev);
                }
            }
        };
        const initProvider = ()=>{
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};

// error retry
const onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
const compare = (currentData, newData)=>stableHash(currentData) == stableHash(newData);
// Default cache provider
const [cache, mutate] = initCache(new Map());
// Default config
const defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare,
    isPaused: ()=>false,
    cache,
    mutate,
    fallback: {}
}, // use web preset by default
preset);

const mergeConfigs = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1 , fallback: f1  } = a;
        const { use: u2 , fallback: f2  } = b;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

const SWRConfigContext = (0,react.createContext)({});
const SWRConfig = (props)=>{
    const { value  } = props;
    const parentConfig = (0,react.useContext)(SWRConfigContext);
    const isFunctionalConfig = isFunction(value);
    const config = (0,react.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0,react.useMemo)(()=>isFunctionalConfig ? config : mergeConfigs(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // Use a lazy initialized state to create the cache on first access.
    const [cacheContext] = (0,react.useState)(()=>provider ? initCache(provider(extendedConfig.cache || cache), config) : UNDEFINED);
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

// @ts-expect-error
const enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
const use = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const setupDevTools = ()=>{
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react;
    }
};

const normalize = (args)=>{
    return isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};

const useSWRConfig = ()=>{
    return mergeObjects(defaultConfig, (0,react.useContext)(SWRConfigContext));
};

const preload = (key_, fetcher)=>{
    const key = dist_serialize(key_)[0];
    const [, , , PRELOAD] = SWRGlobalState.get(cache);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(key_);
    PRELOAD[key] = req;
    return req;
};
const middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const key = dist_serialize(key_)[0];
            const [, , , PRELOAD] = SWRGlobalState.get(cache);
            const req = PRELOAD[key];
            if (req) {
                delete PRELOAD[key];
                return req;
            }
            return fetcher_(...args);
        });
        return useSWRNext(key_, fetcher, config);
    };

const BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const withArgs = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = useSWRConfig();
        // Normalize arguments.
        const [key, fn, _config] = normalize(args);
        // Merge configurations.
        const config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use  } = config;
        const middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;){
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher || null, config);
    };
};

/**
 * An implementation of state with dependency-tracking.
 */ const useStateWithDeps = (state)=>{
    const rerender = useState({})[1];
    const unmountedRef = useRef(false);
    const stateRef = useRef(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = useRef({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = useCallback((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if (IS_REACT_LEGACY) {
                rerender({});
            } else {
                React.startTransition(()=>rerender({}));
            }
        }
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useIsomorphicLayoutEffect(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const subscribeCallback = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
const withMiddleware = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = normalize(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};

setupDevTools();



;// CONCATENATED MODULE: ../../node_modules/swr/core/dist/index.mjs





const WITH_DEDUPE = {
    dedupe: true
};
const useSWRHandler = (_key, fetcher, config)=>{
    const { cache , compare , suspense , fallbackData , revalidateOnMount , revalidateIfStale , refreshInterval , refreshWhenHidden , refreshWhenOffline , keepPreviousData  } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH] = SWRGlobalState.get(cache);
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    const [key, fnArg] = dist_serialize(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0,react.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0,react.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0,react.useRef)(key);
    const fetcherRef = (0,react.useRef)(fetcher);
    const configRef = (0,react.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = createCacheHelper(cache, key);
    const stateDependencies = (0,react.useRef)({}).current;
    const fallback = isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        let equal = true;
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(current[t], prev[t])) {
                    if (isUndefined(prev[t])) {
                        if (!compare(current[t], returnedData)) {
                            equal = false;
                        }
                    } else {
                        equal = false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    equal = false;
                }
            }
        }
        return equal;
    };
    const getSnapshot = (0,react.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!isUndefined(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!isUndefined(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = mergeObjects(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = getSelectedCache(getCache());
        const memorizedInitialSnapshot = getSelectedCache(getInitialCache());
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                return isEqual(newSnapshot, memorizedSnapshot) ? memorizedSnapshot : memorizedSnapshot = newSnapshot;
            },
            ()=>memorizedInitialSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0,shim.useSyncExternalStore)((0,react.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = isUndefined(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0,react.useRef)(data);
    const returnedData = keepPreviousData ? isUndefined(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !isUndefined(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return isUndefined(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = isUndefined(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = isUndefined(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0,react.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
            return false;
        }
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (IS_REACT_LEGACY) {
                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            }
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
            }
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if (isUndefined(getCache().data)) {
            initialState.isLoading = true;
        }
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && isUndefined(getCache().data)) {
                    setTimeout(()=>{
                        if (loading && callbackSafeguard()) {
                            getConfig().onLoadingSlow(key, config);
                        }
                    }, config.loadingTimeout);
                }
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    getTimestamp()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) {
                // If the request isn't interrupted, clean it up after the
                // deduplication interval.
                setTimeout(cleanupState, config.dedupingInterval);
            }
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Clear error.
            finalState.error = UNDEFINED;
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!isUndefined(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) {
                    getConfig().onSuccess(newData, key, config);
                }
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError  } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || isFunction(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) {
                            // If it's inactive, stop. It will auto-revalidate when
                            // refocusing or reconnecting.
                            // When retrying, deduplication is always enabled.
                            currentConfig.onErrorRetry(err, key, currentConfig, revalidate, {
                                retryCount: (opts.retryCount || 0) + 1,
                                dedupe: true
                            });
                        }
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0,react.useCallback)(// Use callback to make sure `keyRef.current` returns latest result every time
    (...args)=>{
        return internalMutate(cache, keyRef.current, ...args);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // The logic for updating refs.
    useIsomorphicLayoutEffect(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!isUndefined(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type)=>{
            if (type == constants.FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == constants.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == constants.MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        const unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation.
        if (shouldDoInitialRevalidation) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            } else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    useIsomorphicLayoutEffect(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = isFunction(refreshInterval) ? refreshInterval(data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0,react.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!IS_REACT_LEGACY && IS_SERVER) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const dist_SWRConfig = OBJECT.defineProperty(SWRConfig, 'defaultValue', {
    value: defaultConfig
});
const unstable_serialize = (key)=>serialize(key)[0];
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ mod; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPromise, ZodRecord, ZodSchema, ZodSet, ZodString, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, boolean, custom, date, default, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, literal, makeIssue, map, nan, nativeEnum, never, null, nullable, number, object, objectUtil, oboolean, onumber, optional, ostring, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, string, transformer, tuple, undefined, union, unknown, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be greater than ${issue.inclusive ? `or equal to ` : ``}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be greater than ${issue.inclusive ? `or equal to ` : ``}${new Date(issue.minimum)}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be less than ${issue.inclusive ? `or equal to ` : ``}${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be smaller than ${issue.inclusive ? `or equal to ` : ``}${new Date(issue.maximum)}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap,
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (typeof value.value !== "undefined" || pair.alwaysSet) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== undefined && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        return this._path.concat(this._key);
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        const error = new ZodError(ctx.common.issues);
        return { success: false, error };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this.superRefine = this._refinement;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.default = this.default.bind(this);
        this.describe = this.describe.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: [], parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    optional() {
        return ZodOptional.create(this);
    }
    nullable() {
        return ZodNullable.create(this);
    }
    nullish() {
        return this.optional().nullable();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this);
    }
    or(option) {
        return ZodUnion.create([this, option]);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming);
    }
    transform(transform) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(undefined),
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
// eslint-disable-next-line
const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
class ZodString extends ZodType {
    constructor() {
        super(...arguments);
        this._regex = (regex, validation, message) => this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */
        this.nonempty = (message) => this.min(1, errorUtil.errToObj(message));
        this.trim = () => new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this.min(len, message).max(len, message);
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int");
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBigInt.create = (params) => {
    return new ZodBigInt({
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all(ctx.data.map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = ctx.data.map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return this.min(len, message).max(len, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////
/////////////////////////////////////////
//////////                     //////////
//////////      ZodObject      //////////
//////////                     //////////
/////////////////////////////////////////
/////////////////////////////////////////
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second,
        };
    };
})(objectUtil || (objectUtil = {}));
const AugmentFactory = (def) => (augmentation) => {
    return new ZodObject({
        ...def,
        shape: () => ({
            ...def.shape(),
            ...augmentation,
        }),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return ZodArray.create(deepPartialify(schema.element));
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        this.augment = AugmentFactory(this._def);
        this.extend = AugmentFactory(this._def);
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        // const mergedShape = objectUtil.mergeShapes(
        //   this._def.shape(),
        //   merging._def.shape()
        // );
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).map((key) => {
            // only add to shape if key corresponds to an element of the current shape
            if (this.shape[key])
                shape[key] = this.shape[key];
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).map((key) => {
            if (util.objectKeys(mask).indexOf(key) === -1) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        if (mask) {
            util.objectKeys(this.shape).map((key) => {
                if (util.objectKeys(mask).indexOf(key) === -1) {
                    newShape[key] = this.shape[key];
                }
                else {
                    newShape[key] = this.shape[key].optional();
                }
            });
            return new ZodObject({
                ...this._def,
                shape: () => newShape,
            });
        }
        else {
            for (const key in this.shape) {
                const fieldSchema = this.shape[key];
                newShape[key] = fieldSchema.optional();
            }
        }
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required() {
        const newShape = {};
        for (const key in this.shape) {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while (newField instanceof ZodOptional) {
                newField = newField._def.innerType;
            }
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.options.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: this.validDiscriminatorValues,
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get validDiscriminatorValues() {
        return Array.from(this.options.keys());
    }
    get options() {
        return this._def.options;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, types, params) {
        // Get all the valid discriminator values
        const options = new Map();
        try {
            types.forEach((type) => {
                const discriminatorValue = type.shape[discriminator].value;
                options.set(discriminatorValue, type);
            });
        }
        catch (e) {
            throw new Error("The discriminator value could not be extracted from all the provided schemas");
        }
        // Assert that all the discriminator values are unique
        if (options.size !== types.length) {
            throw new Error("Some of the discriminator values are not unique");
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                type: "array",
            });
            status.dirty();
        }
        const items = ctx.data
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            return OK(async (...args) => {
                const error = new ZodError([]);
                const parsedArgs = await this._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await fn(...parsedArgs);
                const parsedReturns = await this._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            return OK((...args) => {
                const parsedArgs = this._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = fn(...parsedArgs.data);
                const parsedReturns = this._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data);
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                // if (base.status === "aborted") return INVALID;
                // if (base.status === "dirty") {
                //   return { status: "dirty", value: base.value };
                // }
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    // if (base.status === "aborted") return INVALID;
                    // if (base.status === "dirty") {
                    //   return { status: "dirty", value: base.value };
                    // }
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
const custom = (check, params = {}, fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            if (!check(data)) {
                const p = typeof params === "function" ? params(data) : params;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
// new approach that works for abstract classes
// but required TS 4.4+
// abstract class Class {
//   constructor(..._: any[]) {}
// }
// const instanceOfType = <T extends typeof Class>(
const instanceOfType = (cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params, true);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const NEVER = INVALID;

var mod = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getParsedType: getParsedType,
    ZodParsedType: ZodParsedType,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    get objectUtil () { return objectUtil; },
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(7298), __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);